webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularAnimate = __webpack_require__(96);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _angularCookies = __webpack_require__(98);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(100);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(102);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(104);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(105);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	var _uiSelect = __webpack_require__(107);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _app = __webpack_require__(109);
	
	var _navbar = __webpack_require__(110);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(113);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _main = __webpack_require__(115);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _portada = __webpack_require__(119);
	
	var _portada2 = _interopRequireDefault(_portada);
	
	var _pregunta = __webpack_require__(121);
	
	var _pregunta2 = _interopRequireDefault(_pregunta);
	
	var _formulario = __webpack_require__(125);
	
	var _formulario2 = _interopRequireDefault(_formulario);
	
	var _resultado = __webpack_require__(127);
	
	var _resultado2 = _interopRequireDefault(_resultado);
	
	var _mapa = __webpack_require__(626);
	
	var _mapa2 = _interopRequireDefault(_mapa);
	
	var _app2 = __webpack_require__(760);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(764);
	
	var _util2 = _interopRequireDefault(_util);
	
	__webpack_require__(766);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('acosoEnLineaApp', [_angularAnimate2.default, _angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _uiSelect2.default, _navbar2.default, _footer2.default, _main2.default, _app3.default, _util2.default, _resultado2.default, _pregunta2.default, _formulario2.default, _portada2.default, _mapa2.default]).config(_app.routeConfig);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['acosoEnLineaApp'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(108);
	module.exports = 'ui.select';


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	function isNil(value) {
	  return angular.isUndefined(value) || value === null;
	}
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  removeSelected: true,
	  resetSearchInput: true,
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false,
	  spinnerEnabled: false,
	  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	  backspaceReset: true
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	      return function link(scope, element, attrs, $select) {
	
	
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	
	        scope.$watch('$select.open', function(open) {
	          if (open) {
	            tElement.attr('role', 'listbox');
	            $select.refresh(attrs.refresh);
	          } else {
	            element.removeAttr('role');
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	  ctrl.refreshing = false;
	  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	      ctrl.open = true;
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	    else if (ctrl.open && !ctrl.searchEnabled) {
	      // Close the selection if we don't have search enabled, and we click on the select again
	      ctrl.close();
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items || [];
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined && data !== null ) {
	          var filteredItems = data.filter(function(i) {
	            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            }) : !angular.equals(i, selectedItems);
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	      $scope.$broadcast('uis:refresh');
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	          var refreshPromise = $scope.$eval(refreshAttr);
	          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	            ctrl.refreshing = true;
	            refreshPromise.finally(function() {
	              ctrl.refreshing = false;
	            });
	          }
	        }
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  var _isItemSelected = function (item) {
	    return (ctrl.selected && angular.isArray(ctrl.selected) &&
	        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
	  };
	
	  var disabledItems = [];
	
	  function _updateItemDisabled(item, isDisabled) {
	    var disabledItemIndex = disabledItems.indexOf(item);
	    if (isDisabled && disabledItemIndex === -1) {
	      disabledItems.push(item);
	    }
	
	    if (!isDisabled && disabledItemIndex > -1) {
	      disabledItems.splice(disabledItemIndex, 1);
	    }
	  }
	
	  function _isItemDisabled(item) {
	    return disabledItems.indexOf(item) > -1;
	  }
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var item = itemScope[ctrl.itemProperty];
	    var itemIndex = ctrl.items.indexOf(item);
	    var isDisabled = false;
	
	    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	      if (item.isTag) return false;
	
	      if (ctrl.multiple) {
	        isDisabled = _isItemSelected(item);
	      }
	
	      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	      }
	
	      _updateItemDisabled(item, isDisabled);
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (isNil(item) || !_isItemDisabled(item)) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !_isItemDisabled(item)) {
	        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	        ctrl.clickTriggeredSelect = false;
	        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	          ctrl.clickTriggeredSelect = true;
	
	        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              if (item === undefined) {
	                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              }
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if (_isItemSelected(item)) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	        _resetSearchInput();
	        $scope.$broadcast('uis:select', item);
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    ctrl.open = false;
	    _resetSearchInput();
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(null);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  // Set default function for locked choices - avoids unnecessary
	  // logic if functionality is not being used
	  ctrl.isLocked = function () {
	    return false;
	  };
	
	  $scope.$watch(function () {
	    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	  }, _initaliseLockedChoices);
	
	  function _initaliseLockedChoices(doInitalise) {
	    if(!doInitalise) return;
	
	    var lockedItems = [];
	
	    function _updateItemLocked(item, isLocked) {
	      var lockedItemIndex = lockedItems.indexOf(item);
	      if (isLocked && lockedItemIndex === -1) {
	        lockedItems.push(item);
	        }
	
	      if (!isLocked && lockedItemIndex > -1) {
	        lockedItems.splice(lockedItemIndex, 1);
	      }
	    }
	
	    function _isItemlocked(item) {
	      return lockedItems.indexOf(item) > -1;
	    }
	
	    ctrl.isLocked = function (itemScope, itemIndex) {
	      var isLocked = false,
	          item = ctrl.selected[itemIndex];
	
	      if(item) {
	        if (itemScope) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	          _updateItemLocked(item, isLocked);
	        } else {
	          isLocked = _isItemlocked(item);
	        }
	      }
	
	      return isLocked;
	    };
	  }
	
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.$element[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        }, angular.noop);
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	          var idx = ++ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	            ctrl.activeIndex = ++idx;
	          }
	        }
	        break;
	      case KEY.UP:
	        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > minActiveIndex) {
	          var idxmin = --ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	            ctrl.activeIndex = --idxmin;
	          }
	        }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        var oldsearch = ctrl.search;
	        angular.forEach(items, function (item) {
	          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	          if (newItem) {
	            ctrl.select(newItem, true);
	          }
	        });
	        ctrl.search = oldsearch || EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	
	  $scope.$watch('$select.activeIndex', function(activeIndex) {
	    if (activeIndex)
	      $element.find('input').attr(
	        'aria-activedescendant',
	        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	  });
	
	  $scope.$watch('$select.open', function(open) {
	    if (!open)
	      $element.find('input').removeAttr('aria-activedescendant');
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('backspaceReset', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var backspaceReset = scope.$eval(attrs.backspaceReset);
	          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	        });
	
	        attrs.$observe('limit', function() {
	          //Limit the number of selections allowed
	          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	        });
	
	        scope.$watch('removeSelected', function() {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        attrs.$observe('spinnerEnabled', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	        });
	
	        attrs.$observe('spinnerClass', function() {
	          var spinnerClass = attrs.spinnerClass;
	          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        var calculateDropdownPosAfterAnimation = function() {
	          // Delay positioning the dropdown until all choices have been added so its height is correct.
	          $timeout(function() {
	            if ($select.dropdownPosition === 'up') {
	              //Go UP
	              setDropdownPosUp();
	            } else {
	              //AUTO
	              element.removeClass(directionUpClassName);
	
	              var offset = uisOffset(element);
	              var offsetDropdown = uisOffset(dropdown);
	
	              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	              // Determine if the direction of the dropdown needs to be changed.
	              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                //Go UP
	                setDropdownPosUp(offset, offsetDropdown);
	              }else{
	                //Go DOWN
	                setDropdownPosDown(offset, offsetDropdown);
	              }
	            }
	
	            // Display the dropdown once it has been positioned.
	            dropdown[0].style.opacity = 1;
	          });
	        };
	
	        var opened = false;
	        
	        scope.calculateDropdownPos = function() {
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	            if (dropdown.length === 0) {
	              return;
	            }
	
	           // Hide the dropdown so there is no flicker until $timeout is done executing.
	           if ($select.search === '' && !opened) {
	              dropdown[0].style.opacity = 0;
	              opened = true;
	           }
	
	            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	              var needsCalculated = true;
	
	              $select.$animate.on('enter', dropdown, function (elem, phase) {
	                if (phase === 'close' && needsCalculated) {
	                  calculateDropdownPosAfterAnimation();
	                  needsCalculated = false;
	                }
	              });
	            } else {
	              calculateDropdownPosAfterAnimation();
	            }
	          } else {
	            if (dropdown === null || dropdown.length === 0) {
	              return;
	            }
	
	            // Reset the position of the dropdown.
	            dropdown[0].style.opacity = 0;
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	            element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        if($select.refreshItems){
	          $select.refreshItems();
	        }
	        if($select.sizeSearchInput){
	          $select.sizeSearchInput();
	        }
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        // if the choice is locked, don't remove it
	        if($select.isLocked(null, index)) return false;
	
	        var removedChoice = $select.selected[index];
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	        return true;
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if (isNil(ngModel.$viewValue)){
	            ngModel.$viewValue = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function(){
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                if($selectMultiple.removeChoice(curr)) {
	                  return prev;
	                } else {
	                  return curr;
	                }
	
	              } else {
	                // If nothing yet selected, select last item
	                return last;
	              }
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	      
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function() {
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	  return {
	    restrict: 'A',
	    require: 'uiSelect',
	    link: function (scope, element, attrs, $select) {
	      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	      scope.$watch('$select.open', function (isOpen, previousState) {
	        if (isOpen !== previousState) {
	          $timeout(function () {
	            $select.onOpenCloseCallback(scope, {
	              isOpen: isOpen
	            });
	          });
	        }
	      });
	    }
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups track by $group.name';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider', 'uiSelectConfig'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider, uiSelectConfig) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	
	  uiSelectConfig.theme = 'bootstrap';
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jquery = __webpack_require__(111);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var navbarHeigth = 60;
	var NavbarComponent = exports.NavbarComponent = function NavbarComponent() {
	  _classCallCheck(this, NavbarComponent);
	};
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(112),
	  controller: NavbarComponent
	}).directive('scrollTo', ['scrollTo', function (scrollTo) {
	  'ngInject';
	
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attr) {
	      var $el = (0, _jquery2.default)(element);
	      var handler = function handler() {
	        scrollTo(attr.scrollTo);
	      };
	      $el.bind('click', handler);
	      scope.$on('$destroy', function () {
	        $el.unbind('click', handler);
	      });
	    }
	  };
	}]).factory('scrollTo', function () {
	  'ngInject';
	
	  return function (scrollTo) {
	    var scrollTop = void 0;
	    if (scrollTo === 'top') {
	      scrollTop = 0;
	    } else {
	      scrollTop = (0, _jquery2.default)(scrollTo).offset().top - navbarHeigth;
	    }
	    (0, _jquery2.default)('html, body').animate({
	      scrollTop: scrollTop
	    }, 1000);
	  };
	}).name;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.4.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2019-05-01T21:04Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.4.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code, options ) {
			DOMEval( code, { nonce: options && options.nonce } );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.4
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2019-04-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) &&
	
					// Support: IE 8 only
					// Exclude object elements
					(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 && rdescend.test( selector ) ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = (elem.ownerDocument || elem).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( typeof elem.contentDocument !== "undefined" ) {
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									} );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		// Support: IE 9-11 only
		// Also use offsetWidth/offsetHeight for when box sizing is unreliable
		// We use getClientRects() to check for hidden/disconnected.
		// In those cases, the computed value can be trusted to be border-box
		if ( ( !support.boxSizingReliable() && isBorderBox ||
			val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url, options ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top navbar-top fixed-top\">\n  <div class=\"container-fluid\">\n    <div class=\"navbar-header\">\n      <a class=\"navbar-brand\" href=\"/\">\n        <img alt=\"DATA CUENTA LOGO\" class=\"icon icon-logo-isotipo\" src=\"assets/images/logo-datacuenta-isotipo.svg\">\n        <img alt=\"DATA CUENTA LOGO TEXTO\" class=\"icon icon-logo-text\" src=\"assets/images/logo-datacuenta-texto.svg\">\n      </a>\n    </div>\n\n    <ul class=\"nav navbar-nav\">\n      <li class=\"navbtn\">\n        <a href=\"/mapa\">\n          <img alt=\"LOGO MAPA\" class=\"icon icon-localizacion\" src=\"assets/images/localizacion.svg\">\n        </a>\n      </li>\n      \n      <li class=\"navbtn\">\n        <a href=\"/\">\n          <img alt=\"DATA CUENTA LOGO\" class=\"icon icon-bars\" src=\"assets/images/logo-bars-colors.svg\">\n          <img alt=\"TEDIC\" class=\"icon-tedic\" src=\"assets/images/logo-tedic-success.svg\">\n        </a>\n      </li>\n    </ul>\n\n\n\n  </div>\n</nav>\n"

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterComponent = undefined;
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterComponent = exports.FooterComponent = function FooterComponent() {
	  _classCallCheck(this, FooterComponent);
	};
	
	exports.default = _angular2.default.module('directives.footer', []).component('footer', {
	  template: __webpack_require__(114),
	  controller: FooterComponent
	}).name;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"footer container\">\n  <div>\n    <a>\n      <img class=\"logo-europa\" src=\"assets/images/logo-europe.png\" alt=\"Logo de la Unión Europea\">\n    </a>\n  </div>\n  <div>\n    <a href=\"https://www.equalrightstrust.org\" target=\"_top\">\n      <img class=\"logo-equalrightstrust\" src=\"assets/images/logo-equalrightstrust.png\" alt=\"Logo de Equal Rights Trust\">\n    </a>\n  </div>\n  <div>\n    <a href=\"http://tedic.org\" target=\"_top\">\n      <img class=\"logo-tedic\" src=\"assets/images/logo-tedic-success.svg\" alt=\"Logo de Tedic\">\n    </a>\n  </div>\n  <div>\n    <a href=\"/\" target=\"_top\">\n      <img class=\"logo-datacuenta\" src=\"assets/images/logo-datacuenta-isotipo.svg\" alt=\"Logo de DataCuenta\">\n    </a>\n  </div>\n  <div>\n    <a href=\"https://creativecommons.org/\" target=\"_top\">\n      <img class=\"logo-cc\" src=\"assets/images/logo-cc-circle-black.svg\" alt=\"Logo de Creative Commons\">\n    </a>\n  </div>\n  <div>\n    <a href=\"https://gitlab.com/tedicpy/data.cuenta\" target=\"_top\">\n      <img class=\"logo-gitlab\" src=\"assets/images/logo-gitlab.png\" alt=\"Logo de GitLab\">\n    </a>\n  </div>\n</div>\n"

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _main = __webpack_require__(116);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _angularUiRouter = __webpack_require__(104);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['scrollTo'];
	  function MainController(scrollTo) {
	    _classCallCheck(this, MainController);
	
	    this.scrollTo = scrollTo;
	  }
	
	  _createClass(MainController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.scrollTo('top');
	    }
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('acosoEnLineaApp.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	  template: __webpack_require__(118),
	  controller: MainController
	}).name;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    template: '<main></main>',
	    abstract: true
	  });
	  $stateProvider.state('main.portada', {
	    url: '',
	    template: '<portada></portada>'
	  });
	  $stateProvider.state('main.pregunta', {
	    url: 'preguntas',
	    template: '<pregunta></pregunta>'
	  });
	  $stateProvider.state('main.resultado', {
	    url: 'resultados',
	    template: '<resultado></resultado>',
	    params: {
	      general: true,
	      result: null
	    }
	  });
	  $stateProvider.state('main.politicaDePrivacidad', {
	    url: 'politicaDePrivacidad',
	    template: __webpack_require__(117)
	  });
	}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h1>Política de Privacidad</h1>\n  <p><a href=\"http://tedic.org\">TEDIC</a> es una ONG, domiciliada en la ciudad de Asunción – Paraguay. Su forma de contacto es <a href=\"mailto://hola@tedic.org\">hola@tedic.org</a>. Para\n    nosotras\n    la privacidad de tu información es un asunto importante, te aseguramos que los datos personales que nos proporcionas\n    serán tratados solo para el cumplimiento de la finalidad de la plataforma <a href=\"/\">Data.Cuenta</a>.</p>\n  <p>La información de la encuesta es anónima. Es decir, no almacenamos información de carácter personal como son nombre,\n    apellido, correo electrónico y cualquier otro tipo de información que identifique a una persona dentro de la encuesta\n    de\n    la plataforma <a href=\"/\">Data.Cuenta</a>.</p>\n  <p>Para fines estadísticos solo recogemos direcciones IP (una dirección de Protocolo de Internet, o dirección IP, es un\n    número identificador único de cada ordenador o dispositivo de red en Internet). Utilizamos su dirección IP para\n    determinar si accede a nuestros servicios desde dentro o desde fuera de la República de Paraguay.</p>\n  <p>Para evitar el completado automático y abuso de la plataforma se utiliza la tecnología <a href=\"https://www.google.com/recaptcha/intro/v3.html\">reCAPTCHA</a> de Google que tiene\n    sus\n    propios <a href=\"https://policies.google.com/terms?hl=es-419\">Términos y Condiciones</a> y <a href=\"https://policies.google.com/privacy?hl=es-419\">Política de Privacidad</a>.</p>\n</div>"

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = "<navbar></navbar>\n  <div ui-view=\"\"></div>\n<footer></footer>\n"

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(94);
	
	var portadaComponent = exports.portadaComponent = function () {
	  portadaComponent.$inject = ['$state', '$window', '$http'];
	  function portadaComponent($state, $window, $http) {
	    'ngInject';
	
	    _classCallCheck(this, portadaComponent);
	
	    this.$state = $state;
	    this.$window = $window;
	    this.$http = $http;
	    this.checkCaptcha = null;
	  }
	
	  _createClass(portadaComponent, [{
	    key: 'goTo',
	    value: function goTo(path) {
	      this.$state.go(path, {}, { reload: true });
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      grecaptcha.ready(function () {
	        grecaptcha.execute('6LcbcKoUAAAAANtBw_bQ0KNIe-W4ki5Fm-5xXogX', { action: 'homepage' }).then(function (token) {
	          _this.$http.post('/api/encuestas/captcha', {
	            token: token
	          }).then(function (response) {
	            _this.checkCaptcha = response.data;
	          });;
	        });
	      });
	    }
	  }, {
	    key: 'sentTokenCaptcha',
	    value: function sentTokenCaptcha(token) {
	      this.$http.post('/api/encuestas/captcha', {
	        token: token
	      });
	    }
	  }]);
	
	  return portadaComponent;
	}();
	
	exports.default = angular.module('acosoEnLineaApp.portada', []).component('portada', {
	  template: __webpack_require__(120),
	  controller: portadaComponent,
	  controllerAs: 'vm'
	}).name;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid portada\">\n  <!-- bloque-2 -->\n  <div id=\"bloque-2\" class=\"jumbotron\">\n    <div class=\"bg-1-top-right\">\n      <div class=\"bg-1-bottom-left\">\n        <h1 class=\"text-center\">\n          <img alt=\"DATA CUENTA LOGO\" class=\"icon-logo\" src=\"assets/images/logo-datacuenta-blanco.svg\">\n        </h1>\n        <h2>\n          <span>Test para darte cuenta de la</span>\n          <b>violencia digital</b>\n          <img alt=\"\" class=\"icon-line-main\" src=\"assets/images/line-main.svg\">\n        </h2>\n        <div class=\"separator visible-md-block visible-lg-block\" scroll-to=\"#bloque-3\">\n          <img alt=\"\" class=\"icon-down-chevron\" src=\"assets/images/down-chevron-white.svg\">\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- bloque-3 -->\n  <div id=\"bloque-3\" class=\"jumbotron\">\n    <p class=\"visible-xs-block visible-sm-block text-center\">\n      Esta es una plataforma<br>\n      interactiva que pretende<br>\n      visibilizar, medir y conocer<br>\n      las experiencias de<br>\n      violencia que han sido<br>\n      mediadas por la tecnología.\n    </p>\n    <div class=\"visible-md-block visible-lg-block row\">\n      <div class=\"col-md-4 col-md-offset-2\">\n        <p class=\"text\">\n          Esta es una plataforma<br>\n          interactiva que pretende<br>\n          visibilizar, medir y conocer<br>\n          las experiencias de<br>\n          violencia que han sido<br>\n          mediadas por la tecnología.\n        </p>\n      </div>\n      <div class=\"col-md-4\">\n        <div class=\"circle\">\n          <p>\n            Desde la selfie<br>\n            controladora de<br>\n            tus sueños hasta<br>\n            esos mensajitos<br>\n            indeseados de<br>\n            gente indeseable.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div class=\"separator visible-xs-block visible-sm-block\" scroll-to=\"#bloque-4\">\n      <img alt=\"\" class=\"icon-down-chevron\" src=\"assets/images/down-chevron-success.svg\">\n    </div>\n  </div>\n\n  <!-- bloque-4 -->\n  <div id=\"bloque-4\" class=\"jumbotron\">\n    <div class=\"bg-2\">\n      <div class=\"container-fluid visible-xs-block visible-sm-block\">\n        <div class=\"row\">\n          <div class=\"col-sm-12 col-md-4 col-md-offset-2\">\n            <div class=\"circle\">\n              <p>\n                Desde la selfie<br>\n                controladora de<br>\n                tus sueños hasta<br>\n                esos mensajitos<br>\n                indeseados de<br>\n                gente indeseable.\n              </p>\n            </div>\n          </div>\n          <div class=\"col-sm-12 col-md-4\">\n            <p class=\"text\">\n              Queremos saber<br>\n              qué te ha pasado, y<br>\n              <b>queremos brindarte<br>\n                consejos y soluciones<br>\n                para hacerle frente</b><br>\n              a las formas de violencia<br>\n              que muchas veces<br>\n              no reconocemos en<br>\n              nuestro cotidiano...\n            </p>\n          </div>\n        </div>\n      </div>\n      <div class=\"visible-md-block visible-lg-block\">\n        <p class=\"text\">\n          Queremos saber qué te ha pasado, y<br>\n          <b>queremos brindarte consejos<br>\n            y soluciones para hacerle frente</b><br>\n          a las formas de violencia que muchas veces<br>\n          no reconocemos en nuestro cotidiano...\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <!-- bloque-5-btn -->\n  <div id=\"bloque-5-btn\">\n    <div class=\"text-center\">\n      <div class=\"btn-group btn-group-lg btn-group-vertical btn-encuesta-container\">\n        <button type=\"button\" class=\"btn btn-encuesta\" ng-click=\"vm.goTo('main.pregunta')\">\n          Completar encuesta\n          <img class=\"message-tail-danger\" src=\"assets/images/message-tail-danger-bottom-right.svg\">\n        </button>\n        <!-- <button type=\"button\" class=\"btn btn-estadisticas\" ng-click=\"vm.goTo('main.resultado')\">\n          <img class=\"message-tail-success\" src=\"assets/images/message-tail-success.svg\">\n          VER ESTADÍSTICAS\n        </button> -->\n      </div>\n      <div class=\"text-center\">\n        <a class=\"btn-estadisticas\" ng-click=\"vm.goTo('main.resultado')\">\n          <img class=\"logo-bars-colors\" src=\"assets/images/logo-bars-colors.svg\">\n          Ver estadísticas\n        </a>\n      </div>\n      <div class=\"text-center btn-politica-de-privacidad-container\">\n        <a ng-click=\"vm.goTo('main.politicaDePrivacidad')\">\n          Leer Política de Privacidad\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(94);
	var _ = __webpack_require__(122);
	var $ = __webpack_require__(111);
	
	var preguntaComponent = exports.preguntaComponent = function () {
	  preguntaComponent.$inject = ['$scope', '$state', '$http', 'appConfig', '$timeout', '$window'];
	  function preguntaComponent($scope, $state, $http, appConfig, $timeout, $window) {
	    'ngInject';
	
	    _classCallCheck(this, preguntaComponent);
	
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$http = $http;
	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.index = 0;
	    this.preguntas = appConfig.preguntas;
	    this.result = {
	      cat1: 0,
	      cat2: 0,
	      cat3: 0
	    };
	    this.setClasses();
	    this.$window.localStorage.removeItem('respuestas');
	    this.$window.localStorage.removeItem('resultInd');
	    this.$window.localStorage.removeItem('encuestaId');
	    this.$window.localStorage.removeItem('encuestaTimestamp');
	  }
	
	  _createClass(preguntaComponent, [{
	    key: 'setClasses',
	    value: function setClasses() {
	      var backgroundColors = ['success', 'info', 'warning', 'danger'];
	      var lastBG = void 0;
	
	      this.preguntas.forEach(function (pregunta, index) {
	        pregunta.classes = [];
	        pregunta.classes.push('pregunta-' + pregunta.idPregunta);
	
	        if (index % 2 == 0) {
	          pregunta.classes.push('par');
	        } else {
	          pregunta.classes.push('impar');
	        }
	
	        pregunta.classes.push(getColor());
	      });
	
	      function getColor() {
	        var currentBG = _.sample(backgroundColors);
	        if (lastBG === currentBG) {
	          return getColor();
	        }
	        lastBG = currentBG;
	        return currentBG;
	      }
	    }
	  }, {
	    key: 'goNext',
	    value: function goNext(respuesta) {
	      var _this = this;
	
	      if (this.animatingBtn) {
	        return;
	      }
	      this.animateBtn(respuesta, function () {
	        _this.preguntas[_this.index].respuesta = respuesta;
	        if (_this.index < _this.preguntas.length - 1) {
	          _this.index++;
	        } else {
	          _this.calculoResultado();
	          _this.addEncuesta(function (result) {
	            _this.$window.localStorage.setItem('encuestaId', result.data._id);
	            _this.$window.localStorage.setItem('encuestaTimestamp', Date.now());
	            _this.$window.localStorage.setItem('resultInd', JSON.stringify(_this.result));
	            _this.$window.localStorage.setItem('respuestas', JSON.stringify(_this.preguntas));
	            _this.$state.go('main.resultado', {}, { reload: true });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'animateBtn',
	    value: function animateBtn(respuesta, cb) {
	      var _this2 = this;
	
	      var iconsToShow = 2;
	      var animationDuration = 1500;
	      this.iconSelected = this.getOneIcon(respuesta);
	      this.animatingBtn = true;
	      var $btn = void 0;
	      if (respuesta === 'SI') {
	        $btn = $('.btn-si');
	      } else if (respuesta === 'NO') {
	        $btn = $('.btn-no');
	      } else if (respuesta === 'NOSE') {
	        $btn = $('.btn-nose');
	      }
	
	      $btn.addClass('shake');
	      this.$timeout(function () {
	        $btn.removeClass('shake');
	        _this2.animatingBtn = false;
	        cb();
	      }, animationDuration);
	    }
	  }, {
	    key: 'getOneIcon',
	    value: function getOneIcon(respuesta) {
	      var newIcon = void 0;
	      if (respuesta === 'SI') {
	        newIcon = '#' + _.sample(['001-llanto', '002-triste', '004-enojado-1', '006-vomito', '009-enojado-3', '014-emoji-1']);
	      } else if (respuesta === 'NO') {
	        newIcon = '#' + _.sample(['007-enojado-2', '010-conmocionado', '012-conmocionado-1', '013-emoji', '002-triste']);
	      } else if (respuesta === 'NOSE') {
	        return '#012-conmocionado-1';
	      }
	      if (newIcon === this.iconSelected) {
	        return this.getOneIcon(respuesta);
	      }
	      return newIcon;
	    }
	  }, {
	    key: 'calculoResultado',
	    value: function calculoResultado() {
	      var tRespCat1 = 0;
	      var tRespCat2 = 0;
	      var tRespCat3 = 0;
	
	      var tRespSiCat1 = 0;
	      var tRespSiCat2 = 0;
	      var tRespSiCat3 = 0;
	      for (var i = 0; i < this.preguntas.length; i++) {
	        if (i == 0 || i == 1 || i == 4 || i == 5 || i == 6 || i == 7 || i == 8) {
	          if (this.preguntas[i].respuesta == 'SI') {
	            tRespSiCat1++;
	          }
	          if (this.preguntas[i].respuesta == 'SI' || this.preguntas[i].respuesta == 'NO') {
	            tRespCat1++;
	          }
	        }
	
	        if (i == 2 || i == 7) {
	          if (this.preguntas[i].respuesta == 'SI') {
	            tRespSiCat2++;
	          }
	          if (this.preguntas[i].respuesta == 'SI' || this.preguntas[i].respuesta == 'NO') {
	            tRespCat2++;
	          }
	        }
	
	        if (i == 3 || i == 4 || i == 5) {
	          if (this.preguntas[i].respuesta == 'SI') {
	            tRespSiCat3++;
	          }
	          if (this.preguntas[i].respuesta == 'SI' || this.preguntas[i].respuesta == 'NO') {
	            tRespCat3++;
	          }
	        }
	      }
	      this.result.tRespCat1 = tRespCat1;
	      this.result.tRespCat2 = tRespCat2;
	      this.result.tRespCat3 = tRespCat3;
	      this.result.tRespSiCat1 = tRespSiCat1;
	      this.result.tRespSiCat2 = tRespSiCat2;
	      this.result.tRespSiCat3 = tRespSiCat3;
	    }
	  }, {
	    key: 'addEncuesta',
	    value: function addEncuesta(cb) {
	      this.$http.post('/api/encuestas', {
	        preguntas: this.preguntas,
	        result: this.result
	      }).then(cb);
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return preguntaComponent;
	}();
	
	exports.default = angular.module('acosoEnLineaApp.pregunta', []).component('pregunta', {
	  template: __webpack_require__(124),
	  controller: preguntaComponent,
	  controllerAs: 'vm'
	}).name;

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pregunta-container\" ng-class=\"vm.preguntas[vm.index].classes\">\n  <div class=\"bg-preguntas\">\n    <div class=\"visible-xs visible-sm content\">\n      <div class=\"pregunta-id\">\n        <h2>{{vm.preguntas[vm.index].idPregunta}}</h2>\n      </div>\n      <div class=\"pregunta-text\">\n        <div class=\"bg-preg-text\">\n          <p>{{vm.preguntas[vm.index].descripcion}}</p>\n        </div>\n      </div>\n      <div ng-include=\"'pregunta-btns'\"></div>\n    </div>\n    \n    <div class=\"visible-md visible-lg content\">\n      <div class=\"row\">\n        <div class=\"col-md-4\">\n          <div class=\"pregunta-id\">\n            <h2>{{vm.preguntas[vm.index].idPregunta}}</h2>\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div class=\"pregunta-text\">\n            <div class=\"bg-preg-text\">\n              <p>{{vm.preguntas[vm.index].descripcion}}</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <div ng-include=\"'pregunta-btns'\"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n<script type=\"text/ng-template\" id=\"pregunta-btns\">\n  <div class=\"pregunta-btn-group text-center\">\n    <div class=\"btn-group btn-group-lg\">\n      <button ng-click=\"vm.goNext('NO')\" type=\"button\" class=\"btn btn-no\">\n        <img class=\"message-tail-bottom-left\" src=\"assets/images/message-tail-bottom-left.svg\">\n        <span class=\"text\">No</span>\n        <svg class=\"icon\">\n          <use xlink:href=\"{{vm.iconSelected}}\"></use>\n        </svg>\n      </button>\n      <button ng-click=\"vm.goNext('SI')\" type=\"button\" class=\"btn btn-si\">\n        <img class=\"message-tail-bottom-right\" src=\"assets/images/message-tail-bottom-right.svg\">\n        <span class=\"text\">Si</span>\n        <svg class=\"icon\">\n          <use xlink:href=\"{{vm.iconSelected}}\"></use>\n        </svg>\n      </button>\n    </div>\n    <div class=\"btn-group btn-group-lg\">\n      <button ng-click=\"vm.goNext('NOSE')\" type=\"button\" class=\"btn btn-default btn-nose\">\n        <span class=\"text\">No responder</span>\n        <svg class=\"icon\">\n          <use xlink:href=\"{{vm.iconSelected}}\"></use>\n        </svg>\n      </button>\n    </div>\n  </div>\n</script>\n\n\n<!-- SVG Sprite -->\n<svg width=\"0\" height=\"0\" class=\"hidden\">\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"001-llanto\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256S0 397.382 0 256 114.618 0 256 0s256 114.618 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M312.889 384c0 39.296-25.473 42.666-56.889 42.666-31.431 0-56.889-3.371-56.889-42.666 0-39.267 25.458-85.334 56.889-85.334 31.417 0 56.889 46.067 56.889 85.334m113.777-170.666a14.05 14.05 0 0 1-5.276-1.024c-74.367-29.739-104.846-74.525-106.112-76.43-4.367-6.528-2.603-15.36 3.94-19.726 6.527-4.353 15.33-2.603 19.697 3.897.27.399 27.449 39.623 93.028 65.849 7.296 2.915 10.85 11.192 7.936 18.489-2.219 5.56-7.58 8.945-13.213 8.945m-341.332 0a14.24 14.24 0 0 1-13.213-8.946c-2.915-7.297.626-15.574 7.921-18.49 65.593-26.225 92.772-65.45 93.042-65.848 4.38-6.485 13.212-8.206 19.726-3.84 6.485 4.38 8.249 13.155 3.911 19.669-1.266 1.906-31.759 46.691-106.112 76.43a14.068 14.068 0 0 1-5.275 1.025\"\n      fill=\"#664500\"></path>\n    <path d=\"M113.778 497.777l56.888-.653V227.57h-56.889v270.208zm227.556-270.222h56.889v270.222l-56.89-.653V227.555z\" fill=\"#5dadec\"></path>\n    <path d=\"M213.319 256c-2.134 0-4.309-.484-6.343-1.494-49.949-24.989-100.565-.27-101.062 0-7.04 3.528-15.559.654-19.087-6.371-3.512-7.026-.653-15.574 6.372-19.086 2.588-1.267 63.971-31.233 126.492 0 7.026 3.512 9.885 12.06 6.371 19.086-2.503 4.992-7.523 7.865-12.743 7.865m199.111 0c-2.134 0-4.309-.484-6.342-1.494-49.963-24.974-100.565-.27-101.063 0-7.026 3.513-15.559.669-19.086-6.371-3.513-7.026-.654-15.574 6.371-19.086 2.574-1.267 64.014-31.233 126.493 0 7.026 3.512 9.885 12.06 6.357 19.086-2.49 4.992-7.51 7.865-12.73 7.865\"\n      fill=\"#664500\"></path>\n    <path d=\"M512 483.555C512 499.256 397.382 512 256 512S0 499.257 0 483.555s114.618-28.445 256-28.445 256 12.744 256 28.445\" fill=\"#5dadec\"></path>\n    <path d=\"M298.666 384c0 23.566-19.1 28.445-42.666 28.445s-42.666-4.879-42.666-28.445 19.1-28.445 42.666-28.445 42.666 4.879 42.666 28.445\" fill=\"#e75a70\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"002-triste\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M199.111 234.666c0 27.506-15.915 49.778-35.555 49.778S128 262.172 128 234.666c0-27.491 15.915-49.777 35.555-49.777s35.556 22.286 35.556 49.777m201.139 0c0 27.506-15.915 49.778-35.555 49.778s-35.555-22.273-35.555-49.778c0-27.491 15.915-49.777 35.555-49.777s35.555 22.286 35.555 49.777m-66.241 161.835c-.172-.626-16.299-62.278-78.009-62.278-61.739 0-77.866 61.653-78.009 62.278-.754 3.029.611 6.13 3.285 7.738 2.674 1.592 6.159 1.222 8.476-.854.143-.1 14.422-12.274 66.248-12.274 51.044 0 65.664 11.805 66.219 12.274a7.116 7.116 0 0 0 4.892 1.949 7.178 7.178 0 0 0 3.499-.91c2.787-1.594 4.181-4.823 3.399-7.923\"\n      fill=\"#664500\"></path>\n    <path d=\"M142.222 426.666c0 39.282-31.828 71.112-71.11 71.112S0 465.948 0 426.666s56.889-142.222 71.111-142.222 71.111 102.941 71.111 142.222\" fill=\"#5dadec\"></path>\n    <path d=\"M426.666 184.889c-78.99 0-110.961-62.109-112.285-64.754-3.512-7.026-.653-15.559 6.372-19.086 6.997-3.499 15.53-.669 19.057 6.315 1.052 2.062 25.885 49.081 86.855 49.081 7.865 0 14.222 6.371 14.222 14.223.002 7.85-6.356 14.22-14.22 14.22m-341.333.001c-7.852 0-14.223-6.371-14.223-14.223 0-7.851 6.371-14.222 14.223-14.222 72.291 0 85.276-44.374 85.802-46.265 2.063-7.509 9.814-12.06 17.338-10.084 7.537 1.978 12.102 9.571 10.211 17.138-.698 2.76-18.006 67.656-113.351 67.656\"\n      fill=\"#664500\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"003-enojado\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#da2f47\"></path>\n    <path d=\"M362.454 424.946c-.64-2.546-16.611-62.279-106.454-62.279-89.856 0-105.828 59.734-106.454 62.28-.782 3.085.611 6.285 3.371 7.878 2.774 1.55 6.244 1.124 8.52-1.095.27-.27 27.79-26.396 94.563-26.396 66.759 0 94.294 26.126 94.549 26.396a7.179 7.179 0 0 0 5.006 2.047 7.178 7.178 0 0 0 3.499-.91c2.787-1.592 4.181-4.82 3.4-7.92M223.389 245.945c-46.294-46.294-120.69-46.834-123.833-46.834-7.851 0-14.207 6.358-14.207 14.208-.014 7.836 6.342 14.222 14.194 14.236.412 0 27.377.313 56.647 10.481-8.434 9.103-13.966 23.239-13.966 39.296 0 27.507 15.915 49.778 35.555 49.778s35.555-22.273 35.555-49.778c0-2.475-.27-4.835-.526-7.21.185 0 .355.1.526.1 3.641 0 7.281-1.394 10.055-4.168 5.56-5.56 5.56-14.548 0-20.109m189.056-46.834c-3.142 0-77.525.54-123.832 46.834a14.204 14.204 0 0 0 0 20.11 14.182 14.182 0 0 0 10.055 4.168c.185 0 .34-.1.512-.1-.227 2.375-.512 4.736-.512 7.21 0 27.507 15.915 49.778 35.555 49.778s35.555-22.272 35.555-49.777c0-16.058-5.533-30.194-13.967-39.296 29.269-10.17 56.235-10.482 56.662-10.482 7.836-.013 14.193-6.4 14.18-14.236-.014-7.851-6.358-14.209-14.208-14.209\"\n      fill=\"#292f33\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"004-enojado-1\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#da2f47\"></path>\n    <g fill=\"#292f33\">\n      <path d=\"M362.454 424.946c-.64-2.546-16.611-62.279-106.454-62.279-89.856 0-105.828 59.734-106.454 62.28-.782 3.085.611 6.285 3.371 7.878 2.774 1.55 6.244 1.124 8.52-1.095.27-.27 27.79-26.396 94.563-26.396 66.759 0 94.294 26.126 94.549 26.396a7.179 7.179 0 0 0 5.006 2.047 7.178 7.178 0 0 0 3.499-.91c2.787-1.592 4.181-4.82 3.4-7.92M223.389 217.5c-46.294-46.294-120.69-46.834-123.833-46.834-7.851 0-14.207 6.358-14.207 14.208-.014 7.836 6.342 14.222 14.194 14.236.412 0 27.377.313 56.647 10.481-8.434 9.103-13.966 23.239-13.966 39.296 0 27.507 15.915 49.778 35.555 49.778s35.555-22.273 35.555-49.778c0-2.475-.27-4.835-.526-7.21.185 0 .355.1.526.1 3.641 0 7.281-1.395 10.055-4.168 5.56-5.559 5.56-14.548 0-20.109m189.056-46.834c-3.142 0-77.525.54-123.832 46.834a14.204 14.204 0 0 0 0 20.11 14.182 14.182 0 0 0 10.055 4.168c.185 0 .34-.1.512-.1-.227 2.375-.512 4.736-.512 7.21 0 27.507 15.915 49.778 35.555 49.778s35.555-22.272 35.555-49.777c0-16.058-5.533-30.194-13.967-39.297 29.269-10.168 56.235-10.48 56.662-10.48 7.836-.015 14.193-6.4 14.18-14.237-.014-7.851-6.358-14.209-14.208-14.209\"></path>\n      <path d=\"M422.955 469.334H89.045c-17.679 0-32.156-14.464-32.156-32.156v-81.622c0-17.692 14.479-32.156 32.156-32.156h333.909c17.692 0 32.156 14.464 32.156 32.156v81.621c.001 17.692-14.463 32.157-32.155 32.157\"></path>\n    </g>\n    <path d=\"M122.468 402.66h12.842l2.161-15.403H124.63l-2.162 15.403zm-10.952-15.403h-11.62c-4.466 0-6.5-3.256-6.5-6.5 0-3.242 2.034-6.485 6.5-6.485h13.511l2.973-21.76c.682-4.863 2.702-6.485 6.755-6.485 3.242 0 6.229 2.148 6.229 5.405 0 2.02 0 1.082-.27 3.243l-2.717 19.599h12.985l2.973-21.76c.682-4.864 2.702-6.485 6.77-6.485 3.242 0 6.215 2.147 6.215 5.405 0 2.02 0 1.081-.27 3.242l-2.703 19.599h11.62c4.467 0 6.5 3.242 6.5 6.485 0 3.242-2.033 6.5-6.5 6.5h-13.51l-2.177 15.402h11.634c4.466 0 6.485 3.257 6.485 6.5s-2.02 6.485-6.485 6.485h-13.512l-2.972 21.76c-.683 4.88-2.716 6.485-6.77 6.485-3.243 0-6.215-2.147-6.215-5.39 0-2.033 0-1.095.27-3.256l2.702-19.599h-12.983l-2.973 21.76c-.669 4.88-2.702 6.485-6.755 6.485-3.242 0-6.229-2.147-6.229-5.39 0-2.033 0-1.095.27-3.256l2.717-19.599H95.83c-4.466 0-6.485-3.242-6.485-6.485 0-3.242 2.02-6.5 6.485-6.5h13.525l2.161-15.405zm152.037 35.698c0-4.338-2.574-8.106-7.04-8.106-4.467 0-7.027 3.769-7.027 8.106 0 4.324 2.56 7.979 7.026 7.979 4.465 0 7.04-3.655 7.04-7.979m-27.847 0c0-11.761 8.775-21.902 20.807-21.902 12.047 0 20.835 10.14 20.835 21.902 0 11.747-8.788 21.76-20.835 21.76-12.032 0-20.807-10.012-20.807-21.76m13.099-74.24c1.764-3.371 3.115-4.309 6.229-4.309 4.18 0 7.965 3.371 7.965 7.566 0 1.082 0 2.02-1.082 4.054l-45.426 85.035c-2.02 2.845-2.83 4.467-6.073 4.467-3.512 0-7.708-3.372-7.708-7.44 0-2.02.811-3.91 1.351-4.992l44.744-84.381zm-32.854 18.389c0-4.309-2.56-8.107-7.026-8.107-4.466 0-7.026 3.798-7.026 8.107 0 4.337 2.56 7.992 7.026 7.992 4.466.001 7.026-3.655 7.026-7.992m-27.847 0c0-11.762 8.788-21.903 20.82-21.903s20.822 10.14 20.822 21.903-8.789 21.773-20.821 21.773-20.822-10.01-20.822-21.773m111.56-12.686c0-5.675 4.182-9.188 9.728-9.188 5.405 0 9.727 3.641 9.727 9.188v52.053c0 5.546-4.323 9.201-9.727 9.201-5.546 0-9.727-3.512-9.727-9.2v-52.055zm-.825 79.772c0-5.817 4.737-10.553 10.553-10.553 5.817 0 10.553 4.737 10.553 10.553 0 5.817-4.737 10.553-10.553 10.553-5.816 0-10.553-4.736-10.553-10.553m76.288-76.629c-3.982 0-9.529 3.257-9.529 8.562 0 4.948 2.433 7.95 7.595 13.212l.725.74.91-.455c7.069-3.712 10.639-7.865 10.639-12.374 0-6.67-5.347-9.685-10.34-9.685m-9.543 38.557c-6.087 4.08-12.287 9.457-12.287 18.36 0 9.33 6.072 15.347 15.487 15.347 7.837 0 12.928-3.441 18.134-8.619l1.01-.981-21.334-24.789-1.01.682zm49.024 49.407c-2.645 0-4.309-.754-6.115-2.787l-10.297-11.235-1.024.952c-9.984 9.159-18.603 13.07-28.8 13.07-15.773 0-31.701-8.989-31.701-29.07 0-15.744 12.331-25.159 19.683-29.369l1.664-.967-1.351-1.394c-6.045-6.329-8.505-11.562-8.505-18.047 0-15.303 13.98-22.273 26.965-22.273 10.866 0 26.169 6.429 26.169 20.721 0 13.525-12.559 21.348-16.413 23.424l-1.635.881 16.513 19.073 6.328-7.623c3.513-4.223 5.547-6.001 9.188-6.001 2.915 0 6.03 2.618 6.03 7.439 0 3.626-3.584 8.32-7.098 12.459l-4.223 4.765 10.041 11.903c1.862 2.219 2.631 3.399 2.631 6.088 0 4.18-3.84 7.991-8.05 7.991\"\n      fill=\"#fff\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 511.757 511.757\" id=\"005-pensamiento\">\n    <path d=\"M28.323 227.555c0 125.681 101.887 227.555 227.555 227.555 125.68 0 227.555-101.874 227.555-227.555C483.433 101.887 381.56 0 255.879 0 130.21 0 28.323 101.887 28.323 227.555\" fill=\"#ffcc4d\"></path>\n    <g fill=\"#664500\">\n      <path d=\"M218.986 149.334c0 19.641-12.742 35.555-28.445 35.555s-28.445-15.915-28.445-35.555c0-19.626 12.743-35.555 28.445-35.555s28.445 15.927 28.445 35.555m150.67 14.221c0 19.641-12.729 35.555-28.445 35.555-15.701 0-28.445-15.915-28.445-35.555 0-19.626 12.743-35.555 28.445-35.555 15.716 0 28.445 15.929 28.445 35.555M137.421 90.069a13.047 13.047 0 0 1-5.561-5.66c-3.073-6.102-.569-13.184 5.589-15.829 60.672-26.026 109.497-.611 111.545.484 6.158 3.285 8.647 10.639 5.561 16.412-3.073 5.76-10.525 7.765-16.683 4.523-1.748-.91-40.277-20.367-89.287.668-3.654 1.55-7.779 1.208-11.164-.598m72.135 188.289c-1.934-1.807-3.356-4.168-3.925-6.913-1.407-6.67 2.816-12.885 9.458-13.853 65.309-9.642 105.984 27.435 107.705 29.014 5.12 4.75 5.617 12.473 1.166 17.28-4.438 4.779-12.16 4.808-17.266.085-1.479-1.309-33.735-29.98-86.5-22.201-3.939.584-7.835-.796-10.638-3.413\"></path>\n      <path d=\"M290.452 143.402a13.15 13.15 0 0 1-5.148-6.03c-2.66-6.286.327-13.198 6.641-15.417 62.307-21.845 109.297 6.826 111.275 8.064 5.902 3.697 7.879 11.192 4.422 16.753-3.44 5.547-11.036 7.04-16.938 3.385-1.706-1.038-38.799-23.053-89.132-5.405-3.752 1.31-7.848.684-11.12-1.35\"></path>\n    </g>\n    <path d=\"M245.581 499.655s17.992-5.845 20.324-19.229c2.46-13.81-8.875-16.597-8.875-16.597s14.805-2.959 16.669-19.57c1.749-15.645-12.26-19.385-12.26-19.385s13.795-5.689 14.45-21.888c.54-13.639-14.151-20.309-14.151-20.309s71.65-17.35 79.005-19.057c7.338-1.721 18.787-8.761 15.217-24.106-3.541-15.36-17.124-15.9-24.149-14.265-7.026 1.65-95.915 22.286-126.577 29.426-3.272.754-18.603 4.295-20.467 4.75-7.68 1.806-11.165-1.579-5.76-7.281 7.24-7.623 11.848-16.058 13.47-30.051 1.692-14.734-3.3-32.91-6.16-39.95-5.318-13.1-14.293-23.453-24.66-27.008-16.186-5.546-27.677 4.565-21.932 22.201 8.59 26.383 2.973 48-11.848 61.057-34.83 30.677-51.043 52.55-40.248 99.17 11.761 50.846 62.251 83.57 113.095 71.795 2.688-.6 44.857-9.703 44.857-9.703\"\n      fill=\"#f4900c\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 506.934 506.934\" id=\"006-vomito\">\n    <path d=\"M452.593 199.125c0 110-89.125 199.125-199.125 199.125S54.343 309.125 54.343 199.125 143.468 0 253.466 0c110.002 0 199.127 89.125 199.127 199.125\" fill=\"#fdcb58\"></path>\n    <path d=\"M401.063 224.89c-1.375-1-22.625-16.75-54.375-27.5.375-1.375.5-2.75.5-4.125 0-4.375-1.625-8.25-4.25-11.25 21.125-6.125 39-6.25 39.375-6.25 6.5 0 11.75-5.25 11.625-11.75 0-6.5-5.25-11.75-11.75-11.75-2.625 0-63.875.5-102 38.625-3.375 3.375-4.375 8.375-2.5 12.75 1.75 4.375 6.125 7.25 10.75 7.25 53.75 0 98 32.5 98.375 32.75a11.543 11.543 0 0 0 7 2.375c3.625 0 7.125-1.625 9.375-4.625 4.123-5.375 2.998-12.625-2.126-16.5m-174.457-34.119c-38.125-38.125-99.375-38.625-102-38.625-6.5 0-11.75 5.25-11.75 11.75s5.25 11.75 11.625 11.75c.375 0 18.25.125 39.375 6.25-2.625 3-4.25 7-4.25 11.25 0 1.5.25 2.875.5 4.125-31.875 10.75-53.125 26.5-54.375 27.5-5.125 3.875-6.25 11.25-2.375 16.375 2.25 3.125 5.875 4.625 9.375 4.625 2.5 0 4.875-.75 7-2.375.5-.375 44.375-32.75 98.375-32.75 4.75 0 9-2.875 10.875-7.25 2-4.25 1-9.25-2.375-12.625m26.863 138.83c-34.75 0-57.75 4-86.25 9.625-6.5 1.25-19.125 0-19.125-19.125 0-38.375 44-86.25 105.375-86.25s105.375 47.875 105.375 86.25c0 19.125-12.626 20.375-19.126 19.125-28.5-5.5-51.5-9.625-86.25-9.625\"\n      fill=\"#664500\"></path>\n    <g fill=\"#78b159\">\n      <path d=\"M323.768 471.845c0 13-10.5 23.375-23.375 23.375s-23.375-10.5-23.375-23.375c0-13 10.5-23.375 23.375-23.375s23.375 10.375 23.375 23.375\"></path>\n      <path d=\"M183.167 474.042V304.417c0-23.375 35.125-46.875 70.25-46.875s70.25 23.375 70.25 46.875v167.875l-140.5 1.75z\"></path>\n      <path d=\"M395.718 478.434c0 15.75-63.625 28.5-142.25 28.5s-142.25-12.75-142.25-28.5 63.625-28.5 142.25-28.5 142.25 12.875 142.25 28.5\"></path>\n    </g>\n    <path d=\"M241.817 298.625c0 9.75-7.875 17.625-17.625 17.625s-17.625-7.875-17.625-17.625S214.442 281 224.192 281s17.625 7.875 17.625 17.625m68.525 34.265c0 9.75-7.875 17.625-17.625 17.625s-17.625-7.875-17.625-17.625 7.875-17.625 17.625-17.625 17.625 8 17.625 17.625m-21.786 71.125c0 9.75-7.875 17.625-17.625 17.625s-17.625-7.875-17.625-17.625 7.875-17.625 17.625-17.625 17.625 8 17.625 17.625m-35.088 49.338c0 13.875-11.25 25.125-25.125 25.125s-25.125-11.25-25.125-25.125 11.25-25.125 25.125-25.125 25.125 11.25 25.125 25.125\"\n      fill=\"#5d9040\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"007-enojado-2\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M362.454 424.946c-.64-2.546-16.611-62.279-106.454-62.279-89.856 0-105.828 59.734-106.454 62.28-.782 3.085.611 6.285 3.371 7.878 2.774 1.55 6.244 1.124 8.52-1.095.27-.27 27.79-26.396 94.563-26.396 66.759 0 94.294 26.126 94.549 26.396a7.179 7.179 0 0 0 5.006 2.047 7.178 7.178 0 0 0 3.499-.91c2.787-1.592 4.181-4.82 3.4-7.92M223.389 245.945c-46.294-46.294-120.69-46.834-123.833-46.834-7.851 0-14.207 6.358-14.207 14.208-.014 7.836 6.342 14.222 14.194 14.236.412 0 27.377.313 56.647 10.481-8.434 9.103-13.966 23.239-13.966 39.296 0 27.507 15.915 49.778 35.555 49.778s35.555-22.273 35.555-49.778c0-2.475-.27-4.835-.526-7.21.185 0 .355.1.526.1 3.641 0 7.281-1.394 10.055-4.168 5.56-5.56 5.56-14.548 0-20.109m189.056-46.834c-3.142 0-77.525.54-123.832 46.834a14.204 14.204 0 0 0 0 20.11 14.182 14.182 0 0 0 10.055 4.168c.185 0 .34-.1.512-.1-.227 2.375-.512 4.736-.512 7.21 0 27.507 15.915 49.778 35.555 49.778s35.555-22.272 35.555-49.777c0-16.058-5.533-30.194-13.967-39.296 29.269-10.17 56.235-10.482 56.662-10.482 7.836-.013 14.193-6.4 14.18-14.236-.014-7.851-6.358-14.209-14.208-14.209\"\n      fill=\"#664500\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"008-llanto-1\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M199.111 241.778c0 27.506-15.915 49.777-35.555 49.777S128 269.284 128 241.777c0-27.49 15.915-49.777 35.555-49.777s35.556 22.286 35.556 49.778m201.139 0c0 27.506-15.915 49.777-35.555 49.777s-35.555-22.273-35.555-49.778c0-27.49 15.915-49.777 35.555-49.777s35.555 22.286 35.555 49.778M85.319 192c-2.959 0-5.959-.925-8.519-2.845-6.286-4.707-7.553-13.625-2.845-19.911 46.392-61.866 108.316-62.578 110.934-62.578 7.851 0 14.222 6.372 14.222 14.223 0 7.836-6.328 14.194-14.165 14.222-2.205.029-50.758 1.223-88.235 51.2A14.216 14.216 0 0 1 85.32 192m341.346 0c-4.337 0-8.605-1.963-11.392-5.689-37.546-50.076-86.201-51.186-88.263-51.2-7.822-.085-14.137-6.485-14.093-14.294.042-7.836 6.357-14.15 14.18-14.15 2.617 0 64.526.71 110.933 62.577 4.722 6.286 3.442 15.203-2.845 19.911a14.141 14.141 0 0 1-8.52 2.845m-92.657 211.612c-.172-.626-16.299-62.278-78.009-62.278-61.739 0-77.866 61.653-78.009 62.278-.754 3.03.611 6.13 3.285 7.738 2.674 1.592 6.159 1.222 8.476-.854.143-.1 14.422-12.274 66.248-12.274 51.044 0 65.664 11.805 66.219 12.274a7.116 7.116 0 0 0 4.892 1.949 7.178 7.178 0 0 0 3.499-.91c2.787-1.594 4.181-4.823 3.399-7.923\"\n      fill=\"#664500\"></path>\n    <path d=\"M227.555 440.889c0 39.281-31.829 71.111-71.111 71.111s-71.111-31.829-71.111-71.111 56.888-142.223 71.11-142.223 71.112 102.942 71.112 142.223\" fill=\"#5dadec\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"009-enojado-3\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256S0 397.382 0 256 114.618 0 256 0s256 114.618 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M284.445 184.889c-.782 0-1.55-.058-2.346-.199-7.751-1.294-12.985-8.619-11.691-16.37 5.588-33.621 36.55-97.209 113.578-97.209 7.865 0 14.223 6.372 14.223 14.223s-6.358 14.222-14.223 14.222c-72.462 0-85.035 70.458-85.532 73.458-1.153 6.94-7.183 11.875-14.009 11.875m-56.904 0c-6.812 0-12.829-4.906-14.009-11.848-.512-3.001-13.582-73.486-85.532-73.486-7.851 0-14.223-6.371-14.223-14.222S120.15 71.11 128 71.11c77.028 0 107.975 63.588 113.579 97.209 1.294 7.751-3.94 15.075-11.676 16.37-.797.144-1.594.2-2.362.2m-65.266 69.546c-33.209 0-55.04-14.18-56.378-15.075-6.542-4.353-8.306-13.184-3.953-19.726 4.352-6.543 13.183-8.32 19.726-3.94 1.407.91 37.006 23.267 85.305-.896 7.04-3.513 15.574-.654 19.086 6.37 3.513 7.027.669 15.56-6.357 19.073-21.246 10.625-40.774 14.194-57.429 14.194m187.464 0c-16.669 0-36.195-3.57-57.429-14.194-7.026-3.512-9.87-12.046-6.357-19.072 3.527-7.04 12.046-9.885 19.072-6.371 48.37 24.177 83.911 1.792 85.39.838 6.542-4.238 15.374-2.417 19.655 4.11 4.295 6.528 2.546 15.275-3.954 19.613-1.351.897-23.182 15.076-56.377 15.076M369.778 384c-4.338 0-8.605-1.963-11.393-5.689-.355-.484-39.566-51.2-102.4-51.2s-102.03 50.716-102.429 51.229c-4.736 6.229-13.667 7.481-19.911 2.774-6.257-4.721-7.524-13.596-2.816-19.869 1.92-2.546 47.815-62.578 125.155-62.578 77.326 0 123.235 60.033 125.155 62.578 4.721 6.286 3.441 15.204-2.845 19.911a14.13 14.13 0 0 1-8.516 2.844\"\n      fill=\"#664500\"></path>\n    <path d=\"M218.894 285.582c-6.443-2.773-13.924-.383-17.621 5.547L130.16 404.906a14.198 14.198 0 0 0-.384 14.421 14.215 14.215 0 0 0 12.446 7.34h42.666a14.223 14.223 0 0 0 13.795-10.78l28.445-113.778c1.692-6.77-1.791-13.796-8.235-16.526m162.946 119.323L310.728 291.13c-3.727-5.945-11.193-8.307-17.608-5.547-6.442 2.745-9.941 9.757-8.235 16.527l28.445 113.777a14.193 14.193 0 0 0 13.781 10.78h42.666a14.23 14.23 0 0 0 12.445-7.325 14.226 14.226 0 0 0-.383-14.435\"\n      fill=\"#f5f8fa\"></path>\n    <path d=\"M454.855 429.199c.043-.854.256-1.664.256-2.532 0-23.552-19.115-42.666-42.666-42.666-14.62 0-27.477 7.368-35.171 18.56-6.699-2.759-14.024-4.337-21.718-4.337-31.417 0-56.888 25.472-56.888 56.889S324.14 512 355.556 512c19.414 0 36.523-9.756 46.792-24.618C409.16 501.889 423.78 512 440.89 512c23.566 0 42.666-19.1 42.666-42.666-.001-18.648-12.032-34.334-28.701-40.136m-298.41-30.976c-7.709 0-15.019 1.565-21.717 4.338-7.694-11.193-20.566-18.56-35.172-18.56-23.552 0-42.666 19.115-42.666 42.666 0 .868.199 1.679.256 2.531-16.669 5.803-28.7 21.475-28.7 40.135 0 23.567 19.1 42.667 42.666 42.667 17.095 0 31.73-10.113 38.528-24.619 10.282 14.847 27.377 24.619 46.805 24.619 31.418 0 56.889-25.473 56.889-56.889s-25.473-56.888-56.889-56.888\"\n      fill=\"#e1e8ed\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"010-conmocionado\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M327.111 384c0 47.133-31.828 85.334-71.111 85.334S184.889 431.133 184.889 384c0-47.119 31.829-85.334 71.111-85.334s71.111 38.215 71.111 85.334M85.319 156.445c-2.959 0-5.959-.925-8.519-2.845-6.286-4.707-7.553-13.625-2.845-19.911C120.347 71.823 182.271 71.11 184.889 71.11c7.851 0 14.222 6.371 14.222 14.223 0 7.836-6.328 14.193-14.165 14.222-2.205.029-50.758 1.223-88.235 51.2a14.22 14.22 0 0 1-11.392 5.689m341.347.001c-4.337 0-8.605-1.963-11.392-5.689-37.546-50.076-86.201-51.186-88.263-51.2-7.822-.085-14.137-6.485-14.093-14.294.042-7.836 6.357-14.15 14.18-14.15 2.617 0 64.526.71 110.933 62.577 4.722 6.286 3.442 15.203-2.845 19.911a14.141 14.141 0 0 1-8.52 2.845m-228.779 64l25.5-25.5a14.204 14.204 0 0 0 0-20.11c-5.56-5.561-14.548-5.561-20.11 0l-25.5 25.5-25.5-25.5c-5.56-5.561-14.548-5.561-20.11 0-5.56 5.561-5.56 14.549 0 20.11l25.5 25.5-25.5 25.5c-5.56 5.561-5.56 14.549 0 20.11 2.774 2.774 6.414 4.168 10.055 4.168s7.282-1.394 10.055-4.168l25.5-25.5 25.5 25.5a14.182 14.182 0 0 0 10.055 4.168c3.642 0 7.282-1.394 10.055-4.168a14.204 14.204 0 0 0 0-20.11l-25.5-25.5zm156.445 0l25.5-25.5a14.204 14.204 0 0 0 0-20.11c-5.56-5.561-14.563-5.561-20.11 0l-25.5 25.5-25.5-25.5c-5.56-5.561-14.563-5.561-20.11 0-5.56 5.561-5.56 14.549 0 20.11l25.5 25.5-25.5 25.5c-5.56 5.561-5.56 14.549 0 20.11a14.182 14.182 0 0 0 10.055 4.168c3.642 0 7.282-1.394 10.055-4.168l25.5-25.5 25.5 25.5a14.182 14.182 0 0 0 10.055 4.168c3.642 0 7.282-1.394 10.055-4.168a14.204 14.204 0 0 0 0-20.11l-25.5-25.5z\"\n      fill=\"#664500\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"011-enfermo\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M435.2 244.623c-1.621-1.21-27.462-20.282-66.076-33.338.384-1.635.654-3.314.654-5.063 0-5.247-1.963-9.998-5.107-13.71 25.643-7.41 47.418-7.622 47.802-7.622 7.836-.029 14.193-6.4 14.18-14.251-.014-7.837-6.358-14.194-14.208-14.194-3.129 0-77.525.526-123.832 46.834a14.19 14.19 0 0 0-3.073 15.502 14.21 14.21 0 0 0 13.128 8.775c65.28 0 118.955 39.424 119.495 39.836a14.246 14.246 0 0 0 8.49 2.817 14.22 14.22 0 0 0 11.407-5.703c4.692-6.287 3.412-15.176-2.86-19.883m-211.811-41.344c-46.294-46.294-120.69-46.834-123.833-46.834-7.851 0-14.207 6.357-14.207 14.207-.014 7.837 6.342 14.223 14.194 14.237.37 0 22.158.227 47.786 7.622-3.129 3.713-5.106 8.463-5.106 13.71 0 1.749.27 3.428.668 5.063C104.264 224.34 78.423 243.41 76.8 244.62c-6.286 4.708-7.552 13.625-2.845 19.912 2.788 3.726 7.069 5.688 11.393 5.688 2.958 0 5.958-.925 8.518-2.845.527-.398 53.86-39.822 119.466-39.822 5.747 0 10.938-3.47 13.142-8.775a14.216 14.216 0 0 0-3.085-15.5m4.166 209.167c28.445-71.111 184.889-71.111 184.889-42.666.001 14.221-113.778-14.224-184.889 42.666\"\n      fill=\"#664500\"></path>\n    <path d=\"M261.774 256.469c38.087 38.059-56.519 220.786-74.666 238.933-14.934 14.934-59.734 14.934-74.667-14.933-14.933-29.866-59.733 0-74.666-14.934-29.866-29.866 14.934-44.8 0-74.666s-44.8-44.8-14.934-74.666 104.534-14.934 149.334-44.8 74.651-29.867 89.599-14.934\"\n      fill=\"#ccd6dd\"></path>\n    <path d=\"M246.358 282.595c-.228-.881-.754-1.607-1.124-2.417-.426-.94-.725-1.92-1.338-2.76-2.29-3.086-5.76-5.318-9.87-5.902h-.014a15.167 15.167 0 0 0-5.773.313c-1.28.327-2.404 1.024-3.541 1.664-.54.298-1.153.426-1.65.796a14.98 14.98 0 0 0-3.954 4.337C177.366 348.172 77.696 391.607 76.686 392.05c-7.566 3.257-11.065 12.032-7.822 19.612 2.432 5.66 7.936 9.045 13.725 9.045a14.78 14.78 0 0 0 5.874-1.209c3.186-1.365 57.685-25.187 105.613-67.028-29.411 54.4-74.382 85.276-75.007 85.689-6.841 4.593-8.675 13.852-4.096 20.707a14.93 14.93 0 0 0 12.43 6.641 14.89 14.89 0 0 0 8.262-2.517c3.883-2.589 95.318-64.698 111.019-174.549a14.937 14.937 0 0 0-.326-5.845\"\n      fill=\"#f5f8fa\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"012-conmocionado-1\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M199.111 234.666c0 27.506-15.915 49.778-35.555 49.778S128 262.172 128 234.666c0-27.491 15.915-49.777 35.555-49.777s35.556 22.286 35.556 49.777m201.139 0c0 27.506-15.915 49.778-35.555 49.778s-35.555-22.273-35.555-49.778c0-27.491 15.915-49.777 35.555-49.777s35.555 22.286 35.555 49.777m-44.695 135.112h-199.11c-7.851 0-14.223-6.358-14.223-14.223 0-7.865 6.372-14.223 14.223-14.223h199.111c7.865 0 14.223 6.358 14.223 14.223-.001 7.865-6.359 14.222-14.224 14.222\"\n      fill=\"#664500\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"013-emoji\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M362.454 396.501c-.64-2.546-16.611-62.278-106.454-62.278-89.856 0-105.828 59.733-106.454 62.278-.782 3.087.611 6.287 3.371 7.879 2.774 1.579 6.244 1.109 8.52-1.095.27-.27 27.79-26.396 94.563-26.396 66.759 0 94.294 26.126 94.549 26.396a7.179 7.179 0 0 0 5.006 2.047 7.178 7.178 0 0 0 3.499-.91c2.787-1.592 4.181-4.82 3.4-7.92m49.991-197.391c-4.337 0-8.605-1.962-11.392-5.688-34.574-46.138-92.63-12.033-95.075-10.568-6.755 4.054-15.488 1.849-19.513-4.864-4.054-6.741-1.862-15.474 4.864-19.512 28.416-17.053 92.644-35.229 132.48 17.877 4.721 6.287 3.441 15.204-2.845 19.912a14.144 14.144 0 0 1-8.519 2.843m-312.904 0c-2.959 0-5.959-.925-8.519-2.845-6.286-4.707-7.552-13.625-2.845-19.911 39.837-53.12 104.08-34.93 132.48-17.877 6.728 4.038 8.918 12.77 4.864 19.512-4.025 6.727-12.742 8.931-19.485 4.879-2.531-1.508-60.786-35.2-95.103 10.552a14.21 14.21 0 0 1-11.392 5.69m312.904 28.444c0-7.851-6.357-14.223-14.222-14.223h-99.555c-7.865 0-14.223 6.372-14.223 14.223s6.357 14.223 14.223 14.223h72.42C374.03 250.04 381.84 256 391.113 256c11.776 0 21.333-9.543 21.333-21.334 0-1.565-.199-3.086-.512-4.565.169-.853.511-1.65.511-2.546m-184.89 0c0-7.851-6.371-14.223-14.223-14.223h-99.554c-7.852 0-14.223 6.372-14.223 14.223s6.371 14.223 14.223 14.223h72.42C189.14 250.04 196.95 256 206.223 256c11.776 0 21.333-9.543 21.333-21.334 0-1.565-.198-3.086-.512-4.565.156-.853.511-1.65.511-2.546\"\n      fill=\"#664500\"></path>\n  </symbol>\n  <symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"014-emoji-1\">\n    <path d=\"M512 256c0 141.382-114.618 256-256 256C114.631 512 0 397.382 0 256 0 114.631 114.631 0 256 0c141.382 0 256 114.631 256 256\" fill=\"#ffcc4d\"></path>\n    <path d=\"M199.111 234.666c0 27.506-15.915 49.778-35.555 49.778S128 262.172 128 234.666c0-27.491 15.915-49.777 35.555-49.777s35.556 22.286 35.556 49.777m201.139 0c0 27.506-15.915 49.778-35.555 49.778s-35.555-22.273-35.555-49.778c0-27.491 15.915-49.777 35.555-49.777s35.555 22.286 35.555 49.777m-66.241 161.835c-.172-.626-16.299-62.278-78.009-62.278-61.725 0-77.853 61.653-78.009 62.278-.754 3.029.626 6.13 3.3 7.738 2.66 1.592 6.159 1.222 8.476-.854.143-.1 14.422-12.274 66.233-12.274 51.044 0 65.664 11.805 66.219 12.274a7.116 7.116 0 0 0 4.892 1.949 7.178 7.178 0 0 0 3.499-.91c2.787-1.594 4.181-4.823 3.399-7.923\"\n      fill=\"#664500\"></path>\n    <path d=\"M142.222 426.666c0 39.282-31.828 71.112-71.11 71.112S0 465.948 0 426.666s56.889-142.222 71.111-142.222 71.111 102.941 71.111 142.222\" fill=\"#5dadec\"></path>\n    <path d=\"M256 156.445c124.43 0 228.025 64.127 251.107 149.106 3.158-16.042 4.893-32.597 4.893-49.55C512 114.631 397.382 0 256 0 114.631 0 0 114.631 0 256c0 16.953 1.749 33.508 4.892 49.55C27.975 220.573 131.584 156.445 256 156.445\" fill=\"#bdddf4\"></path>\n    <path d=\"M426.666 170.666c-78.99 0-110.961-62.109-112.285-64.754-3.512-7.026-.653-15.573 6.372-19.086 6.997-3.499 15.53-.669 19.057 6.315 1.052 2.063 25.885 49.081 86.855 49.081 7.865 0 14.222 6.372 14.222 14.223s-6.356 14.221-14.22 14.221m-341.333 0c-7.852 0-14.223-6.371-14.223-14.222s6.371-14.223 14.223-14.223c72.291 0 85.276-44.374 85.802-46.265 2.063-7.509 9.814-12.06 17.338-10.084 7.537 1.978 12.102 9.572 10.211 17.138-.698 2.761-18.006 67.656-113.351 67.656\"\n      fill=\"#664500\"></path>\n  </symbol>\n</svg>"

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formularioComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var formularioComponent = exports.formularioComponent = function () {
	  formularioComponent.$inject = ['$window', '$http', 'appConfig', 'localidadesList'];
	  function formularioComponent($window, $http, appConfig, localidadesList) {
	    'ngInject';
	
	    _classCallCheck(this, formularioComponent);
	
	    this.$window = $window;
	    this.$http = $http;
	    this.appConfig = appConfig;
	
	    this.selected = {
	      genero: null,
	      localidad: null,
	      edad: null
	    };
	    this.validation = {
	      genero: null,
	      localidad: null,
	      edad: null
	    };
	    this.generosList = appConfig.generos;
	    this.localidadesList = localidadesList;
	    this.edadesList = _.range(appConfig.edades.desde, appConfig.edades.hasta);
	  }
	
	  _createClass(formularioComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.encuesta.genero) {
	        this.selected.genero = _.find(this.generosList, { value: this.encuesta.genero });
	        this.validation.genero = 'valid';
	      }
	      var _encuesta = this.encuesta,
	          departamento = _encuesta.departamento,
	          ciudad = _encuesta.ciudad;
	
	      if (this.encuesta && departamento && ciudad) {
	        this.selected.localidad = _.find(this.localidadesList, { departamento: departamento, ciudad: ciudad });
	        this.validation.localidad = 'valid';
	      }
	      if (this.encuesta && this.encuesta.edad) {
	        this.selected.edad = this.encuesta.edad;
	        this.validation.edad = 'valid';
	      }
	      this.setFinish();
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(input, value) {
	      var _this = this;
	
	      this.validation[input] = 'waiting';
	      this.$http.put('/api/encuestas/' + this.encuesta._id, { input: input, value: value }).then(function (result) {
	        _this.validation[input] = 'valid';
	        _this.setFinish();
	      });
	    }
	  }, {
	    key: 'setFinish',
	    value: function setFinish() {
	      if (this.validation.genero === 'valid' && this.validation.localidad === 'valid' && this.validation.edad === 'valid') {
	        this.validation.finish = true;
	      }
	    }
	  }]);
	
	  return formularioComponent;
	}();
	
	exports.default = _angular2.default.module('acosoEnLineaApp.formulario', []).component('formulario', {
	  template: __webpack_require__(126),
	  controller: formularioComponent,
	  controllerAs: 'vm',
	  bindings: {
	    encuesta: '='
	  }
	}).name;

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"text-center\">\n        <h2>La encuesta está por terminar</h2>\n        <h3 ng-class=\"vm.validation.finish ? 'text-success' : 'text-danger'\">\n          <span>{{vm.validation.finish ? 'Gracias!' : 'Dejános unos datos más'}}</span>\n        </h3>\n      </div>\n    </div>\n  </div>\n</div>\n\n<form class=\"form\">\n  <div class=\"row\">\n    <div class=\"genero\">\n    <div class=\"col-sm-4\">\n      <div class=\"form-group\" ng-class=\"{'has-success': vm.validation.genero === 'valid'}\">\n        <label class=\"control-label\">Género</label>\n        <ui-select ng-model=\"vm.selected.genero\" on-select=\"vm.selectOption('genero', $select.selected)\">\n          <ui-select-match>\n            <span ng-bind=\"$select.selected.label\"></span>\n          </ui-select-match>\n          <ui-select-choices repeat=\"item in vm.generosList | filter:$select.search\">\n            <span ng-bind-html=\"item.label | highlight:$select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    </div>\n    <div class=\"localidades\">\n    <div class=\"col-sm-4\">\n      <div class=\"form-group\" ng-class=\"{'has-success': vm.validation.localidad === 'valid'}\">\n        <label class=\"control-label\">Localidad</label>\n        <ui-select ng-model=\"vm.selected.localidad\" on-select=\"vm.selectOption('localidad', $select.selected)\">\n          <ui-select-match>\n            <span ng-bind=\"$select.selected.ciudad\"></span>\n          </ui-select-match>\n          <ui-select-choices repeat=\"item in vm.localidadesList | filter:$select.search\" group-by=\"'departamento'\">\n            <span ng-bind-html=\"item.ciudad | highlight:$select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n    </div>\n    <div class=\"edad\">\n    <div class=\"col-sm-4\">\n      <div class=\"form-group\" ng-class=\"{'has-success': vm.validation.edad === 'valid'}\">\n        <label class=\"control-label\">Edad</label>\n        <ui-select ng-model=\"vm.selected.edad\" on-select=\"vm.selectOption('edad', $select.selected)\">\n          <ui-select-match>\n            <span ng-bind=\"$select.selected\"></span>\n          </ui-select-match>\n          <ui-select-choices repeat=\"item in vm.edadesList | filter:$select.search\">\n            <span ng-bind-html=\"item | highlight:$select.search\"></span>\n          </ui-select-choices>\n        </ui-select>\n      </div>\n    </div>\n  </div>\n  </div>\n</form>\n\n<div class=\"container-fluid fin-encuesta fade\" ng-show=\"vm.validation.finish\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 text-center\">\n      <img class=\"like-heart\" src=\"assets/images/like-heart.svg\">\n      <h2>Fin de la encuesta</h2>\n      <div class=\"btn-group\">\n        <button type=\"button\" class=\"btn btn-ver-estadisticas\" scroll-to=\"#resultados\">\n          <img class=\"message-tail-warning\" src=\"assets/images/message-tail-warning-bottom-left.svg\">\n          Ver estadísticas\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div style=\"height: 500px;width: 100%;\" ng-hide=\"vm.validation.finish\"></div>\n"

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resultadoComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _echarts = __webpack_require__(128);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = __webpack_require__(111);
	
	var colorList = ['#00AC9B', '#FFE153', '#ED3F5F', '#007CB4'];
	
	var resultadoComponent = exports.resultadoComponent = function () {
	  resultadoComponent.$inject = ['$scope', '$stateParams', '$http', '$state', '$window', 'scrollTo', 'appConfig'];
	  function resultadoComponent($scope, $stateParams, $http, $state, $window, scrollTo, appConfig) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, resultadoComponent);
	
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$http = $http;
	    this.$state = $state;
	    this.$window = $window;
	    this.scrollTo = scrollTo;
	
	    this.general = this.$stateParams.general;
	    this.openAccordion = {};
	    this.encuesta = {};
	    this.showFormulario = false;
	
	    this.encuestaId = this.$window.localStorage.getItem('encuestaId');
	    this.preguntasRespuestas = this.$window.localStorage.getItem('respuestas');
	    this.encuestaTimestamp = parseInt(this.$window.localStorage.getItem('encuestaTimestamp'));
	
	    if (this.preguntasRespuestas) {
	      this.preguntasRespuestas = JSON.parse(this.preguntasRespuestas);
	    }
	    if (this.encuestaTimestamp) {
	      this.maxTime = this.encuestaTimestamp + appConfig.timeToShowForm;
	      this.dateNow = Date.now();
	      if (this.dateNow > this.maxTime) {
	        this.$window.localStorage.removeItem('encuestaTimestamp');
	        this.encuestaTimestamp = null;
	        this.showFormulario = false;
	      } else if (this.dateNow < this.encuestaTimestamp + 300) {
	        this.showFormulario = true;
	        this.encuesta = { _id: this.encuestaId };
	      } else {
	        this.$http.get('/api/encuestas/' + this.encuestaId).then(function (result) {
	          _this.showFormulario = true;
	          _this.encuesta = result.data;
	          _this.preguntasRespuestas = result.data.preguntas;
	        });
	      }
	    }
	  }
	
	  _createClass(resultadoComponent, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.chart = {
	        bar: _echarts2.default.init(document.getElementById('bar'))
	      };
	      this.resultIndiv = _angular2.default.fromJson(this.$window.localStorage.getItem('resultInd'));
	      if (this.general) {
	        this.getResultadoGeneral();
	      } else {
	        this.result = this.$stateParams.result;
	        this.$window.localStorage.setItem('resultInd', _angular2.default.toJson(this.result));
	        this.barChart();
	      }
	
	      $(this.$window).resize(function () {
	        if (_this2.chart.bar) {
	          _this2.chart.bar.resize();
	        }
	      });
	    }
	  }, {
	    key: 'barChart',
	    value: function barChart() {
	      var _this3 = this;
	
	      var option = {
	        xAxis: {
	          type: 'value',
	          show: false,
	          max: 100
	        },
	        grid: {
	          top: 40,
	          bottom: 40,
	          left: 30,
	          right: 40,
	          containLabel: true
	        },
	        yAxis: {
	          type: 'category',
	          data: ['Acoso', 'Discurso de odio', 'Vigilancia'],
	          axisLabel: {
	            fontSize: 20
	          },
	          axisLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          }
	        },
	        series: [{
	          data: [{
	            value: Math.round(this.result.tRespSiCat1 / this.result.tRespCat1 * 100),
	            itemStyle: { color: colorList[0] }
	          }, {
	            value: Math.round(this.result.tRespSiCat2 / this.result.tRespCat2 * 100),
	            itemStyle: { color: colorList[1] }
	          }, {
	            value: Math.round(this.result.tRespSiCat3 / this.result.tRespCat3 * 100),
	            itemStyle: { color: colorList[2] }
	          }],
	          type: 'bar',
	          label: {
	            normal: {
	              position: 'right',
	              show: true,
	              fontSize: 14,
	              distance: 3,
	              formatter: "{c}%"
	            }
	          }
	        }]
	      };
	
	      this.chart.bar.on('click', function (params) {
	        if (params.name) {
	          if (params.name === "Vigilancia") {
	            _this3.openAccordion = { vigilancia: true };
	            _this3.scrollTo('#vigilancia');
	          } else if (params.name === "Discurso de odio") {
	            _this3.openAccordion = { discurso_de_odio: true };
	            _this3.scrollTo('#discurso-de-odio');
	          } else if (params.name === "Acoso") {
	            _this3.openAccordion = { acoso: true };
	            _this3.scrollTo('#acoso');
	          }
	          _this3.$scope.$apply();
	        }
	      });
	
	      this.chart.bar.setOption(option);
	    }
	  }, {
	    key: 'goToResulGen',
	    value: function goToResulGen() {
	      this.$state.go('main.resultado', { general: true });
	      this.scrollTo('#resultados');
	    }
	  }, {
	    key: 'goToResulInd',
	    value: function goToResulInd() {
	      this.$state.go('main.resultado', { general: false, result: this.resultIndiv });
	      this.scrollTo('#resultados');
	    }
	  }, {
	    key: 'getResultadoGeneral',
	    value: function getResultadoGeneral() {
	      var _this4 = this;
	
	      this.$http.get('/api/resultados').then(function (response) {
	        _this4.result = response.data;
	        _this4.barChart();
	      });
	    }
	  }, {
	    key: 'getPreguntaClass',
	    value: function getPreguntaClass(preguntaId) {
	      var selectedClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'panel-info';
	
	      if (!this.preguntasRespuestas || !this.preguntasRespuestas[preguntaId - 1]) {
	        return 'panel-default';
	      }
	      var respuesta = this.preguntasRespuestas[preguntaId - 1].respuesta;
	      if (respuesta === 'SI') {
	        return selectedClass;
	      }
	      return 'panel-default';
	    }
	  }]);
	
	  return resultadoComponent;
	}();
	
	exports.default = _angular2.default.module('acosoEnLineaApp.resultado', []).component('resultado', {
	  template: __webpack_require__(619),
	  controller: resultadoComponent,
	  controllerAs: 'vm'
	}).run(['$templateCache', function ($templateCache) {
	  'ngInject';
	
	  $templateCache.put('accordion-vigilancia.html', __webpack_require__(620));
	  $templateCache.put('accordion-discurso-de-odio.html', __webpack_require__(621));
	  $templateCache.put('accordion-acoso.html', __webpack_require__(622));
	  $templateCache.put('accordion-plataformas.html', __webpack_require__(623));
	  $templateCache.put('accordion-organizaciones.html', __webpack_require__(624));
	  $templateCache.put('accordion-iniciativas-estatales.html', __webpack_require__(625));
	}]).name;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _echarts = __webpack_require__(129);
	
	(function () {
	  for (var key in _echarts) {
	    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _echarts[key];
	  }
	})();
	
	var _export = __webpack_require__(252);
	
	(function () {
	  for (var key in _export) {
	    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _export[key];
	  }
	})();
	
	__webpack_require__(248);
	
	__webpack_require__(277);
	
	__webpack_require__(304);
	
	__webpack_require__(310);
	
	__webpack_require__(320);
	
	__webpack_require__(324);
	
	__webpack_require__(334);
	
	__webpack_require__(358);
	
	__webpack_require__(367);
	
	__webpack_require__(377);
	
	__webpack_require__(398);
	
	__webpack_require__(402);
	
	__webpack_require__(406);
	
	__webpack_require__(423);
	
	__webpack_require__(429);
	
	__webpack_require__(435);
	
	__webpack_require__(441);
	
	__webpack_require__(445);
	
	__webpack_require__(454);
	
	__webpack_require__(458);
	
	__webpack_require__(461);
	
	__webpack_require__(484);
	
	__webpack_require__(490);
	
	__webpack_require__(496);
	
	__webpack_require__(497);
	
	__webpack_require__(498);
	
	__webpack_require__(508);
	
	__webpack_require__(469);
	
	__webpack_require__(513);
	
	__webpack_require__(526);
	
	__webpack_require__(407);
	
	__webpack_require__(462);
	
	__webpack_require__(529);
	
	__webpack_require__(540);
	
	__webpack_require__(544);
	
	__webpack_require__(545);
	
	__webpack_require__(558);
	
	__webpack_require__(573);
	
	__webpack_require__(579);
	
	__webpack_require__(582);
	
	__webpack_require__(585);
	
	__webpack_require__(594);
	
	__webpack_require__(606);
	
	__webpack_require__(610);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrender = __webpack_require__(131);
	
	var zrUtil = __webpack_require__(134);
	
	var colorTool = __webpack_require__(150);
	
	var env = __webpack_require__(133);
	
	var timsort = __webpack_require__(155);
	
	var Eventful = __webpack_require__(138);
	
	var GlobalModel = __webpack_require__(172);
	
	var ExtensionAPI = __webpack_require__(227);
	
	var CoordinateSystemManager = __webpack_require__(228);
	
	var OptionManager = __webpack_require__(229);
	
	var backwardCompat = __webpack_require__(230);
	
	var dataStack = __webpack_require__(232);
	
	var ComponentModel = __webpack_require__(215);
	
	var SeriesModel = __webpack_require__(233);
	
	var ComponentView = __webpack_require__(237);
	
	var ChartView = __webpack_require__(238);
	
	var graphic = __webpack_require__(180);
	
	var modelUtil = __webpack_require__(173);
	
	var _throttle = __webpack_require__(240);
	
	var throttle = _throttle.throttle;
	
	var seriesColor = __webpack_require__(241);
	
	var aria = __webpack_require__(242);
	
	var loadingDefault = __webpack_require__(244);
	
	var Scheduler = __webpack_require__(245);
	
	var lightTheme = __webpack_require__(246);
	
	var darkTheme = __webpack_require__(247);
	
	__webpack_require__(248);
	
	var mapDataStorage = __webpack_require__(249);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var assert = zrUtil.assert;
	var each = zrUtil.each;
	var isFunction = zrUtil.isFunction;
	var isObject = zrUtil.isObject;
	var parseClassType = ComponentModel.parseClassType;
	var version = '4.2.1';
	var dependencies = {
	  zrender: '4.0.6'
	};
	var TEST_FRAME_REMAIN_TIME = 1;
	var PRIORITY_PROCESSOR_FILTER = 1000;
	var PRIORITY_PROCESSOR_STATISTIC = 5000;
	var PRIORITY_VISUAL_LAYOUT = 1000;
	var PRIORITY_VISUAL_GLOBAL = 2000;
	var PRIORITY_VISUAL_CHART = 3000;
	var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
	// necessary?
	
	var PRIORITY_VISUAL_BRUSH = 5000;
	var PRIORITY = {
	  PROCESSOR: {
	    FILTER: PRIORITY_PROCESSOR_FILTER,
	    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	  },
	  VISUAL: {
	    LAYOUT: PRIORITY_VISUAL_LAYOUT,
	    GLOBAL: PRIORITY_VISUAL_GLOBAL,
	    CHART: PRIORITY_VISUAL_CHART,
	    COMPONENT: PRIORITY_VISUAL_COMPONENT,
	    BRUSH: PRIORITY_VISUAL_BRUSH
	  }
	}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	// where they must not be invoked nestedly, except the only case: invoke
	// dispatchAction with updateMethod "none" in main process.
	// This flag is used to carry out this rule.
	// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	var IN_MAIN_PROCESS = '__flagInMainProcess';
	var OPTION_UPDATED = '__optionUpdated';
	var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	
	function createRegisterEventWithLowercaseName(method) {
	  return function (eventName, handler, context) {
	    // Event name is all lowercase
	    eventName = eventName && eventName.toLowerCase();
	    Eventful.prototype[method].call(this, eventName, handler, context);
	  };
	}
	/**
	 * @module echarts~MessageCenter
	 */
	
	
	function MessageCenter() {
	  Eventful.call(this);
	}
	
	MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on');
	MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off');
	MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one');
	zrUtil.mixin(MessageCenter, Eventful);
	/**
	 * @module echarts~ECharts
	 */
	
	function ECharts(dom, theme, opts) {
	  opts = opts || {}; // Get theme by name
	
	  if (typeof theme === 'string') {
	    theme = themeStorage[theme];
	  }
	  /**
	   * @type {string}
	   */
	
	
	  this.id;
	  /**
	   * Group id
	   * @type {string}
	   */
	
	  this.group;
	  /**
	   * @type {HTMLElement}
	   * @private
	   */
	
	  this._dom = dom;
	  var defaultRenderer = 'canvas';
	
	  /**
	   * @type {module:zrender/ZRender}
	   * @private
	   */
	  var zr = this._zr = zrender.init(dom, {
	    renderer: opts.renderer || defaultRenderer,
	    devicePixelRatio: opts.devicePixelRatio,
	    width: opts.width,
	    height: opts.height
	  });
	  /**
	   * Expect 60 pfs.
	   * @type {Function}
	   * @private
	   */
	
	  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
	  var theme = zrUtil.clone(theme);
	  theme && backwardCompat(theme, true);
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._theme = theme;
	  /**
	   * @type {Array.<module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsMap = {};
	  /**
	   * @type {Array.<module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsMap = {};
	  /**
	   * @type {module:echarts/CoordinateSystem}
	   * @private
	   */
	
	  this._coordSysMgr = new CoordinateSystemManager();
	  /**
	   * @type {module:echarts/ExtensionAPI}
	   * @private
	   */
	
	  var api = this._api = createExtensionAPI(this); // Sort on demand
	
	  function prioritySortFunc(a, b) {
	    return a.__prio - b.__prio;
	  }
	
	  timsort(visualFuncs, prioritySortFunc);
	  timsort(dataProcessorFuncs, prioritySortFunc);
	  /**
	   * @type {module:echarts/stream/Scheduler}
	   */
	
	  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
	  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
	  /**
	   * @type {module:echarts~MessageCenter}
	   * @private
	   */
	
	  this._messageCenter = new MessageCenter(); // Init mouse events
	
	  this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure
	
	  this._pendingActions = [];
	  zr.animation.on('frame', this._onframe, this);
	  bindRenderedEvent(zr, this); // ECharts instance can be used as value.
	
	  zrUtil.setAsPrimitive(this);
	}
	
	var echartsProto = ECharts.prototype;
	
	echartsProto._onframe = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  var scheduler = this._scheduler; // Lazy update
	
	  if (this[OPTION_UPDATED]) {
	    var silent = this[OPTION_UPDATED].silent;
	    this[IN_MAIN_PROCESS] = true;
	    prepare(this);
	    updateMethods.update.call(this);
	    this[IN_MAIN_PROCESS] = false;
	    this[OPTION_UPDATED] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  } // Avoid do both lazy update and progress in one frame.
	  else if (scheduler.unfinished) {
	      // Stream progress.
	      var remainTime = TEST_FRAME_REMAIN_TIME;
	      var ecModel = this._model;
	      var api = this._api;
	      scheduler.unfinished = false;
	
	      do {
	        var startTime = +new Date();
	        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
	
	        scheduler.performDataProcessorTasks(ecModel);
	        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
	        // each frame is not a good user experience. So we follow the rule that
	        // the extent of the coordinate system is determin in the first frame (the
	        // frame is executed immedietely after task reset.
	        // this._coordSysMgr.update(ecModel, api);
	        // console.log('--- ec frame visual ---', remainTime);
	
	        scheduler.performVisualTasks(ecModel);
	        renderSeries(this, this._model, api, 'remain');
	        remainTime -= +new Date() - startTime;
	      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
	
	
	      if (!scheduler.unfinished) {
	        this._zr.flush();
	      } // Else, zr flushing be ensue within the same frame,
	      // because zr flushing is after onframe event.
	
	    }
	};
	/**
	 * @return {HTMLElement}
	 */
	
	
	echartsProto.getDom = function () {
	  return this._dom;
	};
	/**
	 * @return {module:zrender~ZRender}
	 */
	
	
	echartsProto.getZr = function () {
	  return this._zr;
	};
	/**
	 * Usage:
	 * chart.setOption(option, notMerge, lazyUpdate);
	 * chart.setOption(option, {
	 *     notMerge: ...,
	 *     lazyUpdate: ...,
	 *     silent: ...
	 * });
	 *
	 * @param {Object} option
	 * @param {Object|boolean} [opts] opts or notMerge.
	 * @param {boolean} [opts.notMerge=false]
	 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
	 */
	
	
	echartsProto.setOption = function (option, notMerge, lazyUpdate) {
	  var silent;
	
	  if (isObject(notMerge)) {
	    lazyUpdate = notMerge.lazyUpdate;
	    silent = notMerge.silent;
	    notMerge = notMerge.notMerge;
	  }
	
	  this[IN_MAIN_PROCESS] = true;
	
	  if (!this._model || notMerge) {
	    var optionManager = new OptionManager(this._api);
	    var theme = this._theme;
	    var ecModel = this._model = new GlobalModel(null, null, theme, optionManager);
	    ecModel.scheduler = this._scheduler;
	    ecModel.init(null, null, theme, optionManager);
	  }
	
	  this._model.setOption(option, optionPreprocessorFuncs);
	
	  if (lazyUpdate) {
	    this[OPTION_UPDATED] = {
	      silent: silent
	    };
	    this[IN_MAIN_PROCESS] = false;
	  } else {
	    prepare(this);
	    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
	    // fetched after `setOption`.
	
	    this._zr.flush();
	
	    this[OPTION_UPDATED] = false;
	    this[IN_MAIN_PROCESS] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @DEPRECATED
	 */
	
	
	echartsProto.setTheme = function () {
	  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	};
	/**
	 * @return {module:echarts/model/Global}
	 */
	
	
	echartsProto.getModel = function () {
	  return this._model;
	};
	/**
	 * @return {Object}
	 */
	
	
	echartsProto.getOption = function () {
	  return this._model && this._model.getOption();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getWidth = function () {
	  return this._zr.getWidth();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getHeight = function () {
	  return this._zr.getHeight();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getDevicePixelRatio = function () {
	  return this._zr.painter.dpr || window.devicePixelRatio || 1;
	};
	/**
	 * Get canvas which has all thing rendered
	 * @param {Object} opts
	 * @param {string} [opts.backgroundColor]
	 * @return {string}
	 */
	
	
	echartsProto.getRenderedCanvas = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  opts = opts || {};
	  opts.pixelRatio = opts.pixelRatio || 1;
	  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
	  var zr = this._zr; // var list = zr.storage.getDisplayList();
	  // Stop animations
	  // Never works before in init animation, so remove it.
	  // zrUtil.each(list, function (el) {
	  //     el.stopAnimation(true);
	  // });
	
	  return zr.painter.getRenderedCanvas(opts);
	};
	/**
	 * Get svg data url
	 * @return {string}
	 */
	
	
	echartsProto.getSvgDataUrl = function () {
	  if (!env.svgSupported) {
	    return;
	  }
	
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.pathToDataUrl();
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 * @param {string} [opts.excludeComponents]
	 */
	
	
	echartsProto.getDataURL = function (opts) {
	  opts = opts || {};
	  var excludeComponents = opts.excludeComponents;
	  var ecModel = this._model;
	  var excludesComponentViews = [];
	  var self = this;
	  each(excludeComponents, function (componentType) {
	    ecModel.eachComponent({
	      mainType: componentType
	    }, function (component) {
	      var view = self._componentsMap[component.__viewId];
	
	      if (!view.group.ignore) {
	        excludesComponentViews.push(view);
	        view.group.ignore = true;
	      }
	    });
	  });
	  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataUrl() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	  each(excludesComponentViews, function (view) {
	    view.group.ignore = false;
	  });
	  return url;
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 */
	
	
	echartsProto.getConnectedDataURL = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  var groupId = this.group;
	  var mathMin = Math.min;
	  var mathMax = Math.max;
	  var MAX_NUMBER = Infinity;
	
	  if (connectedGroups[groupId]) {
	    var left = MAX_NUMBER;
	    var top = MAX_NUMBER;
	    var right = -MAX_NUMBER;
	    var bottom = -MAX_NUMBER;
	    var canvasList = [];
	    var dpr = opts && opts.pixelRatio || 1;
	    zrUtil.each(instances, function (chart, id) {
	      if (chart.group === groupId) {
	        var canvas = chart.getRenderedCanvas(zrUtil.clone(opts));
	        var boundingRect = chart.getDom().getBoundingClientRect();
	        left = mathMin(boundingRect.left, left);
	        top = mathMin(boundingRect.top, top);
	        right = mathMax(boundingRect.right, right);
	        bottom = mathMax(boundingRect.bottom, bottom);
	        canvasList.push({
	          dom: canvas,
	          left: boundingRect.left,
	          top: boundingRect.top
	        });
	      }
	    });
	    left *= dpr;
	    top *= dpr;
	    right *= dpr;
	    bottom *= dpr;
	    var width = right - left;
	    var height = bottom - top;
	    var targetCanvas = zrUtil.createCanvas();
	    targetCanvas.width = width;
	    targetCanvas.height = height;
	    var zr = zrender.init(targetCanvas);
	    each(canvasList, function (item) {
	      var img = new graphic.Image({
	        style: {
	          x: item.left * dpr - left,
	          y: item.top * dpr - top,
	          image: item.dom
	        }
	      });
	      zr.add(img);
	    });
	    zr.refreshImmediately();
	    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	  } else {
	    return this.getDataURL(opts);
	  }
	};
	/**
	 * Convert from logical coordinate system to pixel coordinate system.
	 * See CoordinateSystem#convertToPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId, geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	
	echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
	/**
	 * Convert from pixel coordinate system to logical coordinate system.
	 * See CoordinateSystem#convertFromPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');
	
	function doConvertPixel(methodName, finder, value) {
	  var ecModel = this._model;
	
	  var coordSysList = this._coordSysMgr.getCoordinateSystems();
	
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	
	  for (var i = 0; i < coordSysList.length; i++) {
	    var coordSys = coordSysList[i];
	
	    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
	      return result;
	    }
	  }
	}
	/**
	 * Is the specified coordinate systems or components contain the given pixel point.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {boolean} result
	 */
	
	
	echartsProto.containPixel = function (finder, value) {
	  var ecModel = this._model;
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	  zrUtil.each(finder, function (models, key) {
	    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
	      var coordSys = model.coordinateSystem;
	
	      if (coordSys && coordSys.containPoint) {
	        result |= !!coordSys.containPoint(value);
	      } else if (key === 'seriesModels') {
	        var view = this._chartsMap[model.__viewId];
	
	        if (view && view.containPoint) {
	          result |= view.containPoint(value, model);
	        } else {}
	      } else {}
	    }, this);
	  }, this);
	  return !!result;
	};
	/**
	 * Get visual from series or data.
	 * @param {string|Object} finder
	 *        If string, e.g., 'series', means {seriesIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            dataIndex / dataIndexInside
	 *        }
	 *        If dataIndex is not specified, series visual will be fetched,
	 *        but not data item visual.
	 *        If all of seriesIndex, seriesId, seriesName are not specified,
	 *        visual will be fetched from first series.
	 * @param {string} visualType 'color', 'symbol', 'symbolSize'
	 */
	
	
	echartsProto.getVisual = function (finder, visualType) {
	  var ecModel = this._model;
	  finder = modelUtil.parseFinder(ecModel, finder, {
	    defaultMainType: 'series'
	  });
	  var seriesModel = finder.seriesModel;
	  var data = seriesModel.getData();
	  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
	  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
	};
	/**
	 * Get view of corresponding component model
	 * @param  {module:echarts/model/Component} componentModel
	 * @return {module:echarts/view/Component}
	 */
	
	
	echartsProto.getViewOfComponentModel = function (componentModel) {
	  return this._componentsMap[componentModel.__viewId];
	};
	/**
	 * Get view of corresponding series model
	 * @param  {module:echarts/model/Series} seriesModel
	 * @return {module:echarts/view/Chart}
	 */
	
	
	echartsProto.getViewOfSeriesModel = function (seriesModel) {
	  return this._chartsMap[seriesModel.__viewId];
	};
	
	var updateMethods = {
	  prepareAndUpdate: function (payload) {
	    prepare(this);
	    updateMethods.update.call(this, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  update: function (payload) {
	    // console.profile && console.profile('update');
	    var ecModel = this._model;
	    var api = this._api;
	    var zr = this._zr;
	    var coordSysMgr = this._coordSysMgr;
	    var scheduler = this._scheduler; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    scheduler.restoreData(ecModel, payload);
	    scheduler.performSeriesTasks(ecModel); // TODO
	    // Save total ecModel here for undo/redo (after restoring data and before processing data).
	    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	    // Create new coordinate system each update
	    // In LineView may save the old coordinate system and use it to get the orignal point
	
	    coordSysMgr.create(ecModel, api);
	    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
	    // stream modes after data processing, where the filtered data is used to
	    // deteming whether use progressive rendering.
	
	    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
	    // can be fetched when coord sys updating (consider the barGrid extent fix). But
	    // the drawback is the full coord info can not be fetched. Fortunately this full
	    // coord is not requied in stream mode updater currently.
	
	    coordSysMgr.update(ecModel, api);
	    clearColorPalette(ecModel);
	    scheduler.performVisualTasks(ecModel, payload);
	    render(this, ecModel, api, payload); // Set background
	
	    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8
	
	    if (!env.canvasSupported) {
	      var colorArr = colorTool.parse(backgroundColor);
	      backgroundColor = colorTool.stringify(colorArr, 'rgb');
	
	      if (colorArr[3] === 0) {
	        backgroundColor = 'transparent';
	      }
	    } else {
	      zr.setBackgroundColor(backgroundColor);
	    }
	
	    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateTransform: function (payload) {
	    var ecModel = this._model;
	    var ecIns = this;
	    var api = this._api; // update before setOption
	
	    if (!ecModel) {
	      return;
	    } // ChartView.markUpdateMethod(payload, 'updateTransform');
	
	
	    var componentDirtyList = [];
	    ecModel.eachComponent(function (componentType, componentModel) {
	      var componentView = ecIns.getViewOfComponentModel(componentModel);
	
	      if (componentView && componentView.__alive) {
	        if (componentView.updateTransform) {
	          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
	          result && result.update && componentDirtyList.push(componentView);
	        } else {
	          componentDirtyList.push(componentView);
	        }
	      }
	    });
	    var seriesDirtyMap = zrUtil.createHashMap();
	    ecModel.eachSeries(function (seriesModel) {
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.updateTransform) {
	        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
	        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
	      } else {
	        seriesDirtyMap.set(seriesModel.uid, 1);
	      }
	    });
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true,
	      dirtyMap: seriesDirtyMap
	    }); // Currently, not call render of components. Geo render cost a lot.
	    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
	
	
	    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateView: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ChartView.markUpdateMethod(payload, 'updateView');
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true
	    });
	
	    render(this, this._model, this._api, payload);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateVisual: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateVisual');
	    // clearColorPalette(ecModel);
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateLayout: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateLayout');
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  }
	};
	
	function prepare(ecIns) {
	  var ecModel = ecIns._model;
	  var scheduler = ecIns._scheduler;
	  scheduler.restorePipelines(ecModel);
	  scheduler.prepareStageTasks();
	  prepareView(ecIns, 'component', ecModel, scheduler);
	  prepareView(ecIns, 'chart', ecModel, scheduler);
	  scheduler.plan();
	}
	/**
	 * @private
	 */
	
	
	function updateDirectly(ecIns, method, payload, mainType, subType) {
	  var ecModel = ecIns._model; // broadcast
	
	  if (!mainType) {
	    // FIXME
	    // Chart will not be update directly here, except set dirty.
	    // But there is no such scenario now.
	    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
	    return;
	  }
	
	  var query = {};
	  query[mainType + 'Id'] = payload[mainType + 'Id'];
	  query[mainType + 'Index'] = payload[mainType + 'Index'];
	  query[mainType + 'Name'] = payload[mainType + 'Name'];
	  var condition = {
	    mainType: mainType,
	    query: query
	  };
	  subType && (condition.subType = subType); // subType may be '' by parseClassType;
	
	  var excludeSeriesId = payload.excludeSeriesId;
	
	  if (excludeSeriesId != null) {
	    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
	  } // If dispatchAction before setOption, do nothing.
	
	
	  ecModel && ecModel.eachComponent(condition, function (model) {
	    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
	      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	    }
	  }, ecIns);
	
	  function callView(view) {
	    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	  }
	}
	/**
	 * Resize the chart
	 * @param {Object} opts
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @param {boolean} [opts.silent=false]
	 */
	
	
	echartsProto.resize = function (opts) {
	  this._zr.resize(opts);
	
	  var ecModel = this._model; // Resize loading effect
	
	  this._loadingFX && this._loadingFX.resize();
	
	  if (!ecModel) {
	    return;
	  }
	
	  var optionChanged = ecModel.resetOption('media');
	  var silent = opts && opts.silent;
	  this[IN_MAIN_PROCESS] = true;
	  optionChanged && prepare(this);
	  updateMethods.update.call(this);
	  this[IN_MAIN_PROCESS] = false;
	  flushPendingActions.call(this, silent);
	  triggerUpdatedEvent.call(this, silent);
	};
	
	function updateStreamModes(ecIns, ecModel) {
	  var chartsMap = ecIns._chartsMap;
	  var scheduler = ecIns._scheduler;
	  ecModel.eachSeries(function (seriesModel) {
	    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
	  });
	}
	/**
	 * Show loading effect
	 * @param  {string} [name='default']
	 * @param  {Object} [cfg]
	 */
	
	
	echartsProto.showLoading = function (name, cfg) {
	  if (isObject(name)) {
	    cfg = name;
	    name = '';
	  }
	
	  name = name || 'default';
	  this.hideLoading();
	
	  if (!loadingEffects[name]) {
	    return;
	  }
	
	  var el = loadingEffects[name](this._api, cfg);
	  var zr = this._zr;
	  this._loadingFX = el;
	  zr.add(el);
	};
	/**
	 * Hide loading effect
	 */
	
	
	echartsProto.hideLoading = function () {
	  this._loadingFX && this._zr.remove(this._loadingFX);
	  this._loadingFX = null;
	};
	/**
	 * @param {Object} eventObj
	 * @return {Object}
	 */
	
	
	echartsProto.makeActionFromEvent = function (eventObj) {
	  var payload = zrUtil.extend({}, eventObj);
	  payload.type = eventActionMap[eventObj.type];
	  return payload;
	};
	/**
	 * @pubilc
	 * @param {Object} payload
	 * @param {string} [payload.type] Action type
	 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
	 * @param {boolean} [opt.silent=false] Whether trigger events.
	 * @param {boolean} [opt.flush=undefined]
	 *                  true: Flush immediately, and then pixel in canvas can be fetched
	 *                      immediately. Caution: it might affect performance.
	 *                  false: Not not flush.
	 *                  undefined: Auto decide whether perform flush.
	 */
	
	
	echartsProto.dispatchAction = function (payload, opt) {
	  if (!isObject(opt)) {
	    opt = {
	      silent: !!opt
	    };
	  }
	
	  if (!actions[payload.type]) {
	    return;
	  } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	  if (!this._model) {
	    return;
	  } // May dispatchAction in rendering procedure
	
	
	  if (this[IN_MAIN_PROCESS]) {
	    this._pendingActions.push(payload);
	
	    return;
	  }
	
	  doDispatchAction.call(this, payload, opt.silent);
	
	  if (opt.flush) {
	    this._zr.flush(true);
	  } else if (opt.flush !== false && env.browser.weChat) {
	    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
	    // hang when sliding page (on touch event), which cause that zr does not
	    // refresh util user interaction finished, which is not expected.
	    // But `dispatchAction` may be called too frequently when pan on touch
	    // screen, which impacts performance if do not throttle them.
	    this._throttledZrFlush();
	  }
	
	  flushPendingActions.call(this, opt.silent);
	  triggerUpdatedEvent.call(this, opt.silent);
	};
	
	function doDispatchAction(payload, silent) {
	  var payloadType = payload.type;
	  var escapeConnect = payload.escapeConnect;
	  var actionWrap = actions[payloadType];
	  var actionInfo = actionWrap.actionInfo;
	  var cptType = (actionInfo.update || 'update').split(':');
	  var updateMethod = cptType.pop();
	  cptType = cptType[0] != null && parseClassType(cptType[0]);
	  this[IN_MAIN_PROCESS] = true;
	  var payloads = [payload];
	  var batched = false; // Batch action
	
	  if (payload.batch) {
	    batched = true;
	    payloads = zrUtil.map(payload.batch, function (item) {
	      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
	      item.batch = null;
	      return item;
	    });
	  }
	
	  var eventObjBatch = [];
	  var eventObj;
	  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
	  each(payloads, function (batchItem) {
	    // Action can specify the event by return it.
	    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
	
	    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType
	
	    eventObj.type = actionInfo.event || eventObj.type;
	    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	    if (isHighDown) {
	      // method, payload, mainType, subType
	      updateDirectly(this, updateMethod, batchItem, 'series');
	    } else if (cptType) {
	      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
	    }
	  }, this);
	
	  if (updateMethod !== 'none' && !isHighDown && !cptType) {
	    // Still dirty
	    if (this[OPTION_UPDATED]) {
	      // FIXME Pass payload ?
	      prepare(this);
	      updateMethods.update.call(this, payload);
	      this[OPTION_UPDATED] = false;
	    } else {
	      updateMethods[updateMethod].call(this, payload);
	    }
	  } // Follow the rule of action batch
	
	
	  if (batched) {
	    eventObj = {
	      type: actionInfo.event || payloadType,
	      escapeConnect: escapeConnect,
	      batch: eventObjBatch
	    };
	  } else {
	    eventObj = eventObjBatch[0];
	  }
	
	  this[IN_MAIN_PROCESS] = false;
	  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
	}
	
	function flushPendingActions(silent) {
	  var pendingActions = this._pendingActions;
	
	  while (pendingActions.length) {
	    var payload = pendingActions.shift();
	    doDispatchAction.call(this, payload, silent);
	  }
	}
	
	function triggerUpdatedEvent(silent) {
	  !silent && this.trigger('updated');
	}
	/**
	 * Event `rendered` is triggered when zr
	 * rendered. It is useful for realtime
	 * snapshot (reflect animation).
	 *
	 * Event `finished` is triggered when:
	 * (1) zrender rendering finished.
	 * (2) initial animation finished.
	 * (3) progressive rendering finished.
	 * (4) no pending action.
	 * (5) no delayed setOption needs to be processed.
	 */
	
	
	function bindRenderedEvent(zr, ecIns) {
	  zr.on('rendered', function () {
	    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
	    // so it should only be triggered when rendering indeed happend
	    // in zrender. (Consider the case that dipatchAction is keep
	    // triggering when mouse move).
	
	    if ( // Although zr is dirty if initial animation is not finished
	    // and this checking is called on frame, we also check
	    // animation finished for robustness.
	    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
	      ecIns.trigger('finished');
	    }
	  });
	}
	/**
	 * @param {Object} params
	 * @param {number} params.seriesIndex
	 * @param {Array|TypedArray} params.data
	 */
	
	
	echartsProto.appendData = function (params) {
	  var seriesIndex = params.seriesIndex;
	  var ecModel = this.getModel();
	  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
	  // system, util some scenario require that. In the expected usage of
	  // `appendData`, the initial extent of coordinate system should better
	  // be fixed by axis `min`/`max` setting or initial data, otherwise if
	  // the extent changed while `appendData`, the location of the painted
	  // graphic elements have to be changed, which make the usage of
	  // `appendData` meaningless.
	
	  this._scheduler.unfinished = true;
	};
	/**
	 * Register event
	 * @method
	 */
	
	
	echartsProto.on = createRegisterEventWithLowercaseName('on');
	echartsProto.off = createRegisterEventWithLowercaseName('off');
	echartsProto.one = createRegisterEventWithLowercaseName('one');
	/**
	 * Prepare view instances of charts and components
	 * @param  {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	function prepareView(ecIns, type, ecModel, scheduler) {
	  var isComponent = type === 'component';
	  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
	  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
	  var zr = ecIns._zr;
	  var api = ecIns._api;
	
	  for (var i = 0; i < viewList.length; i++) {
	    viewList[i].__alive = false;
	  }
	
	  isComponent ? ecModel.eachComponent(function (componentType, model) {
	    componentType !== 'series' && doPrepare(model);
	  }) : ecModel.eachSeries(doPrepare);
	
	  function doPrepare(model) {
	    // Consider: id same and type changed.
	    var viewId = '_ec_' + model.id + '_' + model.type;
	    var view = viewMap[viewId];
	
	    if (!view) {
	      var classType = parseClassType(model.type);
	      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
	      view = new Clazz();
	      view.init(ecModel, api);
	      viewMap[viewId] = view;
	      viewList.push(view);
	      zr.add(view.group);
	    }
	
	    model.__viewId = view.__id = viewId;
	    view.__alive = true;
	    view.__model = model;
	    view.group.__ecComponentInfo = {
	      mainType: model.mainType,
	      index: model.componentIndex
	    };
	    !isComponent && scheduler.prepareView(view, model, ecModel, api);
	  }
	
	  for (var i = 0; i < viewList.length;) {
	    var view = viewList[i];
	
	    if (!view.__alive) {
	      !isComponent && view.renderTask.dispose();
	      zr.remove(view.group);
	      view.dispose(ecModel, api);
	      viewList.splice(i, 1);
	      delete viewMap[view.__id];
	      view.__id = view.group.__ecComponentInfo = null;
	    } else {
	      i++;
	    }
	  }
	} // /**
	//  * Encode visual infomation from data after data processing
	//  *
	//  * @param {module:echarts/model/Global} ecModel
	//  * @param {object} layout
	//  * @param {boolean} [layoutFilter] `true`: only layout,
	//  *                                 `false`: only not layout,
	//  *                                 `null`/`undefined`: all.
	//  * @param {string} taskBaseTag
	//  * @private
	//  */
	// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
	//     each(visualFuncs, function (visual, index) {
	//         var isLayout = visual.isLayout;
	//         if (layoutFilter == null
	//             || (layoutFilter === false && !isLayout)
	//             || (layoutFilter === true && isLayout)
	//         ) {
	//             visual.func(ecModel, api, payload);
	//         }
	//     });
	// }
	
	
	function clearColorPalette(ecModel) {
	  ecModel.clearColorPalette();
	  ecModel.eachSeries(function (seriesModel) {
	    seriesModel.clearColorPalette();
	  });
	}
	
	function render(ecIns, ecModel, api, payload) {
	  renderComponents(ecIns, ecModel, api, payload);
	  each(ecIns._chartsViews, function (chart) {
	    chart.__alive = false;
	  });
	  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts
	
	  each(ecIns._chartsViews, function (chart) {
	    if (!chart.__alive) {
	      chart.remove(ecModel, api);
	    }
	  });
	}
	
	function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
	  each(dirtyList || ecIns._componentsViews, function (componentView) {
	    var componentModel = componentView.__model;
	    componentView.render(componentModel, ecModel, api, payload);
	    updateZ(componentModel, componentView);
	  });
	}
	/**
	 * Render each chart and component
	 * @private
	 */
	
	
	function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
	  // Render all charts
	  var scheduler = ecIns._scheduler;
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    var chartView = ecIns._chartsMap[seriesModel.__viewId];
	    chartView.__alive = true;
	    var renderTask = chartView.renderTask;
	    scheduler.updatePayload(renderTask, payload);
	
	    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
	      renderTask.dirty();
	    }
	
	    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
	    chartView.group.silent = !!seriesModel.get('silent');
	    updateZ(seriesModel, chartView);
	    updateBlend(seriesModel, chartView);
	  });
	  scheduler.unfinished |= unfinished; // If use hover layer
	
	  updateHoverLayerStatus(ecIns._zr, ecModel); // Add aria
	
	  aria(ecIns._zr.dom, ecModel);
	}
	
	function performPostUpdateFuncs(ecModel, api) {
	  each(postUpdateFuncs, function (func) {
	    func(ecModel, api);
	  });
	}
	
	var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	/**
	 * @private
	 */
	
	echartsProto._initEvents = function () {
	  each(MOUSE_EVENT_NAMES, function (eveName) {
	    var handler = function (e) {
	      var ecModel = this.getModel();
	      var el = e.target;
	      var params;
	      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
	
	      if (isGlobalOut) {
	        params = {};
	      } else if (el && el.dataIndex != null) {
	        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
	        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
	      } // If element has custom eventData of components
	      else if (el && el.eventData) {
	          params = zrUtil.extend({}, el.eventData);
	        } // Contract: if params prepared in mouse event,
	      // these properties must be specified:
	      // {
	      //    componentType: string (component main type)
	      //    componentIndex: number
	      // }
	      // Otherwise event query can not work.
	
	
	      if (params) {
	        var componentType = params.componentType;
	        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
	        // markLine/markPoint/markArea, the componentType is
	        // 'markLine'/'markPoint'/'markArea', but we should better
	        // enable them to be queried by seriesIndex, since their
	        // option is set in each series.
	
	        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
	          componentType = 'series';
	          componentIndex = params.seriesIndex;
	        }
	
	        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
	        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
	        params.event = e;
	        params.type = eveName;
	        this._ecEventProcessor.eventInfo = {
	          targetEl: el,
	          packedEvent: params,
	          model: model,
	          view: view
	        };
	        this.trigger(eveName, params);
	      }
	    }; // Consider that some component (like tooltip, brush, ...)
	    // register zr event handler, but user event handler might
	    // do anything, such as call `setOption` or `dispatchAction`,
	    // which probably update any of the content and probably
	    // cause problem if it is called previous other inner handlers.
	
	
	    handler.zrEventfulCallAtLast = true;
	
	    this._zr.on(eveName, handler, this);
	  }, this);
	  each(eventActionMap, function (actionType, eventType) {
	    this._messageCenter.on(eventType, function (event) {
	      this.trigger(eventType, event);
	    }, this);
	  }, this);
	};
	/**
	 * @return {boolean}
	 */
	
	
	echartsProto.isDisposed = function () {
	  return this._disposed;
	};
	/**
	 * Clear
	 */
	
	
	echartsProto.clear = function () {
	  this.setOption({
	    series: []
	  }, true);
	};
	/**
	 * Dispose instance
	 */
	
	
	echartsProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._disposed = true;
	  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
	  var api = this._api;
	  var ecModel = this._model;
	  each(this._componentsViews, function (component) {
	    component.dispose(ecModel, api);
	  });
	  each(this._chartsViews, function (chart) {
	    chart.dispose(ecModel, api);
	  }); // Dispose after all views disposed
	
	  this._zr.dispose();
	
	  delete instances[this.id];
	};
	
	zrUtil.mixin(ECharts, Eventful);
	
	function updateHoverLayerStatus(zr, ecModel) {
	  var storage = zr.storage;
	  var elCount = 0;
	  storage.traverse(function (el) {
	    if (!el.isGroup) {
	      elCount++;
	    }
	  });
	
	  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
	    storage.traverse(function (el) {
	      if (!el.isGroup) {
	        // Don't switch back.
	        el.useHoverLayer = true;
	      }
	    });
	  }
	}
	/**
	 * Update chart progressive and blend.
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateBlend(seriesModel, chartView) {
	  var blendMode = seriesModel.get('blendMode') || null;
	  chartView.group.traverse(function (el) {
	    // FIXME marker and other components
	    if (!el.isGroup) {
	      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
	      if (el.style.blend !== blendMode) {
	        el.setStyle('blend', blendMode);
	      }
	    }
	
	    if (el.eachPendingDisplayable) {
	      el.eachPendingDisplayable(function (displayable) {
	        displayable.setStyle('blend', blendMode);
	      });
	    }
	  });
	}
	/**
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateZ(model, view) {
	  var z = model.get('z');
	  var zlevel = model.get('zlevel'); // Set z and zlevel
	
	  view.group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	    }
	  });
	}
	
	function createExtensionAPI(ecInstance) {
	  var coordSysMgr = ecInstance._coordSysMgr;
	  return zrUtil.extend(new ExtensionAPI(ecInstance), {
	    // Inject methods
	    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
	    getComponentByElement: function (el) {
	      while (el) {
	        var modelInfo = el.__ecComponentInfo;
	
	        if (modelInfo != null) {
	          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
	        }
	
	        el = el.parent;
	      }
	    }
	  });
	}
	/**
	 * @class
	 * Usage of query:
	 * `chart.on('click', query, handler);`
	 * The `query` can be:
	 * + The component type query string, only `mainType` or `mainType.subType`,
	 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
	 * + The component query object, like:
	 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
	 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
	 * + The data query object, like:
	 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
	 * + The other query object (cmponent customized query), like:
	 *   `{element: 'some'}` (only available in custom series).
	 *
	 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
	 * same as there is no such prop in the `query` object.
	 */
	
	
	function EventProcessor() {
	  // These info required: targetEl, packedEvent, model, view
	  this.eventInfo;
	}
	
	EventProcessor.prototype = {
	  constructor: EventProcessor,
	  normalizeQuery: function (query) {
	    var cptQuery = {};
	    var dataQuery = {};
	    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
	
	    if (zrUtil.isString(query)) {
	      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.
	
	      cptQuery.mainType = condCptType.main || null;
	      cptQuery.subType = condCptType.sub || null;
	    } // `query` is an object, convert to {mainType, index, name, id}.
	    else {
	        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
	        // can not be used in `compomentModel.filterForExposedEvent`.
	        var suffixes = ['Index', 'Name', 'Id'];
	        var dataKeys = {
	          name: 1,
	          dataIndex: 1,
	          dataType: 1
	        };
	        zrUtil.each(query, function (val, key) {
	          var reserved = false;
	
	          for (var i = 0; i < suffixes.length; i++) {
	            var propSuffix = suffixes[i];
	            var suffixPos = key.lastIndexOf(propSuffix);
	
	            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
	              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
	
	              if (mainType !== 'data') {
	                cptQuery.mainType = mainType;
	                cptQuery[propSuffix.toLowerCase()] = val;
	                reserved = true;
	              }
	            }
	          }
	
	          if (dataKeys.hasOwnProperty(key)) {
	            dataQuery[key] = val;
	            reserved = true;
	          }
	
	          if (!reserved) {
	            otherQuery[key] = val;
	          }
	        });
	      }
	
	    return {
	      cptQuery: cptQuery,
	      dataQuery: dataQuery,
	      otherQuery: otherQuery
	    };
	  },
	  filter: function (eventType, query, args) {
	    // They should be assigned before each trigger call.
	    var eventInfo = this.eventInfo;
	
	    if (!eventInfo) {
	      return true;
	    }
	
	    var targetEl = eventInfo.targetEl;
	    var packedEvent = eventInfo.packedEvent;
	    var model = eventInfo.model;
	    var view = eventInfo.view; // For event like 'globalout'.
	
	    if (!model || !view) {
	      return true;
	    }
	
	    var cptQuery = query.cptQuery;
	    var dataQuery = query.dataQuery;
	    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
	
	    function check(query, host, prop, propOnHost) {
	      return query[prop] == null || host[propOnHost || prop] === query[prop];
	    }
	  },
	  afterTrigger: function () {
	    // Make sure the eventInfo wont be used in next trigger.
	    this.eventInfo = null;
	  }
	};
	/**
	 * @type {Object} key: actionType.
	 * @inner
	 */
	
	var actions = {};
	/**
	 * Map eventType to actionType
	 * @type {Object}
	 */
	
	var eventActionMap = {};
	/**
	 * Data processor functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var dataProcessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var optionPreprocessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var postUpdateFuncs = [];
	/**
	 * Visual encoding functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 */
	
	var visualFuncs = [];
	/**
	 * Theme storage
	 * @type {Object.<key, Object>}
	 */
	
	var themeStorage = {};
	/**
	 * Loading effects
	 */
	
	var loadingEffects = {};
	var instances = {};
	var connectedGroups = {};
	var idBase = new Date() - 0;
	var groupIdBase = new Date() - 0;
	var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	
	function enableConnect(chart) {
	  var STATUS_PENDING = 0;
	  var STATUS_UPDATING = 1;
	  var STATUS_UPDATED = 2;
	  var STATUS_KEY = '__connectUpdateStatus';
	
	  function updateConnectedChartsStatus(charts, status) {
	    for (var i = 0; i < charts.length; i++) {
	      var otherChart = charts[i];
	      otherChart[STATUS_KEY] = status;
	    }
	  }
	
	  each(eventActionMap, function (actionType, eventType) {
	    chart._messageCenter.on(eventType, function (event) {
	      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
	        if (event && event.escapeConnect) {
	          return;
	        }
	
	        var action = chart.makeActionFromEvent(event);
	        var otherCharts = [];
	        each(instances, function (otherChart) {
	          if (otherChart !== chart && otherChart.group === chart.group) {
	            otherCharts.push(otherChart);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
	        each(otherCharts, function (otherChart) {
	          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
	            otherChart.dispatchAction(action);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
	      }
	    });
	  });
	}
	/**
	 * @param {HTMLElement} dom
	 * @param {Object} [theme]
	 * @param {Object} opts
	 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
	 * @param {string} [opts.renderer] Currently only 'canvas' is supported.
	 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
	 *                              Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
	 *                               Can be 'auto' (the same as null/undefined)
	 */
	
	
	function init(dom, theme, opts) {
	  var existInstance = getInstanceByDom(dom);
	
	  if (existInstance) {
	    return existInstance;
	  }
	
	  var chart = new ECharts(dom, theme, opts);
	  chart.id = 'ec_' + idBase++;
	  instances[chart.id] = chart;
	  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
	  enableConnect(chart);
	  return chart;
	}
	/**
	 * @return {string|Array.<module:echarts~ECharts>} groupId
	 */
	
	
	function connect(groupId) {
	  // Is array of charts
	  if (zrUtil.isArray(groupId)) {
	    var charts = groupId;
	    groupId = null; // If any chart has group
	
	    each(charts, function (chart) {
	      if (chart.group != null) {
	        groupId = chart.group;
	      }
	    });
	    groupId = groupId || 'g_' + groupIdBase++;
	    each(charts, function (chart) {
	      chart.group = groupId;
	    });
	  }
	
	  connectedGroups[groupId] = true;
	  return groupId;
	}
	/**
	 * @DEPRECATED
	 * @return {string} groupId
	 */
	
	
	function disConnect(groupId) {
	  connectedGroups[groupId] = false;
	}
	/**
	 * @return {string} groupId
	 */
	
	
	var disconnect = disConnect;
	/**
	 * Dispose a chart instance
	 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
	 */
	
	function dispose(chart) {
	  if (typeof chart === 'string') {
	    chart = instances[chart];
	  } else if (!(chart instanceof ECharts)) {
	    // Try to treat as dom
	    chart = getInstanceByDom(chart);
	  }
	
	  if (chart instanceof ECharts && !chart.isDisposed()) {
	    chart.dispose();
	  }
	}
	/**
	 * @param  {HTMLElement} dom
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceByDom(dom) {
	  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
	}
	/**
	 * @param {string} key
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceById(key) {
	  return instances[key];
	}
	/**
	 * Register theme
	 */
	
	
	function registerTheme(name, theme) {
	  themeStorage[name] = theme;
	}
	/**
	 * Register option preprocessor
	 * @param {Function} preprocessorFunc
	 */
	
	
	function registerPreprocessor(preprocessorFunc) {
	  optionPreprocessorFuncs.push(preprocessorFunc);
	}
	/**
	 * @param {number} [priority=1000]
	 * @param {Object|Function} processor
	 */
	
	
	function registerProcessor(priority, processor) {
	  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
	}
	/**
	 * Register postUpdater
	 * @param {Function} postUpdateFunc
	 */
	
	
	function registerPostUpdate(postUpdateFunc) {
	  postUpdateFuncs.push(postUpdateFunc);
	}
	/**
	 * Usage:
	 * registerAction('someAction', 'someEvent', function () { ... });
	 * registerAction('someAction', function () { ... });
	 * registerAction(
	 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
	 *     function () { ... }
	 * );
	 *
	 * @param {(string|Object)} actionInfo
	 * @param {string} actionInfo.type
	 * @param {string} [actionInfo.event]
	 * @param {string} [actionInfo.update]
	 * @param {string} [eventName]
	 * @param {Function} action
	 */
	
	
	function registerAction(actionInfo, eventName, action) {
	  if (typeof eventName === 'function') {
	    action = eventName;
	    eventName = '';
	  }
	
	  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	    event: eventName
	  }][0]; // Event name is all lowercase
	
	  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	  eventName = actionInfo.event; // Validate action type and event name.
	
	  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	  if (!actions[actionType]) {
	    actions[actionType] = {
	      action: action,
	      actionInfo: actionInfo
	    };
	  }
	
	  eventActionMap[eventName] = actionType;
	}
	/**
	 * @param {string} type
	 * @param {*} CoordinateSystem
	 */
	
	
	function registerCoordinateSystem(type, CoordinateSystem) {
	  CoordinateSystemManager.register(type, CoordinateSystem);
	}
	/**
	 * Get dimensions of specified coordinate system.
	 * @param {string} type
	 * @return {Array.<string|Object>}
	 */
	
	
	function getCoordinateSystemDimensions(type) {
	  var coordSysCreator = CoordinateSystemManager.get(type);
	
	  if (coordSysCreator) {
	    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	  }
	}
	/**
	 * Layout is a special stage of visual encoding
	 * Most visual encoding like color are common for different chart
	 * But each chart has it's own layout algorithm
	 *
	 * @param {number} [priority=1000]
	 * @param {Function} layoutTask
	 */
	
	
	function registerLayout(priority, layoutTask) {
	  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
	}
	/**
	 * @param {number} [priority=3000]
	 * @param {module:echarts/stream/Task} visualTask
	 */
	
	
	function registerVisual(priority, visualTask) {
	  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
	}
	/**
	 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
	 */
	
	
	function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
	  if (isFunction(priority) || isObject(priority)) {
	    fn = priority;
	    priority = defaultPriority;
	  }
	
	  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
	  stageHandler.__prio = priority;
	  stageHandler.__raw = fn;
	  targetList.push(stageHandler);
	  return stageHandler;
	}
	/**
	 * @param {string} name
	 */
	
	
	function registerLoading(name, loadingFx) {
	  loadingEffects[name] = loadingFx;
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentModel(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentModel;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentView(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentView;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentView.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendSeriesModel(opts
	/*, superClass*/
	) {
	  // var Clazz = SeriesModel;
	  // if (superClass) {
	  //     superClass = 'series.' + superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return SeriesModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendChartView(opts
	/*, superClass*/
	) {
	  // var Clazz = ChartView;
	  // if (superClass) {
	  //     superClass = superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ChartView.getClass(classType.main, true);
	  // }
	  return ChartView.extend(opts);
	}
	/**
	 * ZRender need a canvas context to do measureText.
	 * But in node environment canvas may be created by node-canvas.
	 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	 *
	 * Be careful of using it in the browser.
	 *
	 * @param {Function} creator
	 * @example
	 *     var Canvas = require('canvas');
	 *     var echarts = require('echarts');
	 *     echarts.setCanvasCreator(function () {
	 *         // Small size is enough.
	 *         return new Canvas(32, 32);
	 *     });
	 */
	
	
	function setCanvasCreator(creator) {
	  zrUtil.$override('createCanvas', creator);
	}
	/**
	 * @param {string} mapName
	 * @param {Array.<Object>|Object|string} geoJson
	 * @param {Object} [specialAreas]
	 *
	 * @example GeoJSON
	 *     $.get('USA.json', function (geoJson) {
	 *         echarts.registerMap('USA', geoJson);
	 *         // Or
	 *         echarts.registerMap('USA', {
	 *             geoJson: geoJson,
	 *             specialAreas: {}
	 *         })
	 *     });
	 *
	 *     $.get('airport.svg', function (svg) {
	 *         echarts.registerMap('airport', {
	 *             svg: svg
	 *         }
	 *     });
	 *
	 *     echarts.registerMap('eu', [
	 *         {svg: eu-topographic.svg},
	 *         {geoJSON: eu.json}
	 *     ])
	 */
	
	
	function registerMap(mapName, geoJson, specialAreas) {
	  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
	}
	/**
	 * @param {string} mapName
	 * @return {Object}
	 */
	
	
	function getMap(mapName) {
	  // For backward compatibility, only return the first one.
	  var records = mapDataStorage.retrieveMap(mapName);
	  return records && records[0] && {
	    geoJson: records[0].geoJSON,
	    specialAreas: records[0].specialAreas
	  };
	}
	
	registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
	registerPreprocessor(backwardCompat);
	registerProcessor(PRIORITY_PROCESSOR_STATISTIC, dataStack);
	registerLoading('default', loadingDefault); // Default actions
	
	registerAction({
	  type: 'highlight',
	  event: 'highlight',
	  update: 'highlight'
	}, zrUtil.noop);
	registerAction({
	  type: 'downplay',
	  event: 'downplay',
	  update: 'downplay'
	}, zrUtil.noop); // Default theme
	
	registerTheme('light', lightTheme);
	registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
	// be mounted on `echarts` is the extension `dataTool` is imported.
	
	var dataTool = {};
	exports.version = version;
	exports.dependencies = dependencies;
	exports.PRIORITY = PRIORITY;
	exports.init = init;
	exports.connect = connect;
	exports.disConnect = disConnect;
	exports.disconnect = disconnect;
	exports.dispose = dispose;
	exports.getInstanceByDom = getInstanceByDom;
	exports.getInstanceById = getInstanceById;
	exports.registerTheme = registerTheme;
	exports.registerPreprocessor = registerPreprocessor;
	exports.registerProcessor = registerProcessor;
	exports.registerPostUpdate = registerPostUpdate;
	exports.registerAction = registerAction;
	exports.registerCoordinateSystem = registerCoordinateSystem;
	exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	exports.registerLayout = registerLayout;
	exports.registerVisual = registerVisual;
	exports.registerLoading = registerLoading;
	exports.extendComponentModel = extendComponentModel;
	exports.extendComponentView = extendComponentView;
	exports.extendSeriesModel = extendSeriesModel;
	exports.extendChartView = extendChartView;
	exports.setCanvasCreator = setCanvasCreator;
	exports.registerMap = registerMap;
	exports.getMap = getMap;
	exports.dataTool = dataTool;
	var ___ec_export = __webpack_require__(252);
	(function () {
	    for (var key in ___ec_export) {
	        if (___ec_export.hasOwnProperty(key)) {
	            exports[key] = ___ec_export[key];
	        }
	    }
	})();

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) The code `if (__DEV__) ...` can be removed by build tool.
	// (2) If intend to use `__DEV__`, this module should be imported. Use a global
	// variable `__DEV__` may cause that miss the declaration (see #6535), or the
	// declaration is behind of the using position (for example in `Model.extent`,
	// And tools like rollup can not analysis the dependency if not import).
	var dev; // In browser
	
	if (typeof window !== 'undefined') {
	  dev = window.__DEV__;
	} // In node
	else if (typeof global !== 'undefined') {
	    dev = global.__DEV__;
	  }
	
	if (typeof dev === 'undefined') {
	  dev = true;
	}
	
	var __DEV__ = dev;
	exports.__DEV__ = __DEV__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(132);
	
	var env = __webpack_require__(133);
	
	var zrUtil = __webpack_require__(134);
	
	var Handler = __webpack_require__(135);
	
	var Storage = __webpack_require__(141);
	
	var Painter = __webpack_require__(156);
	
	var Animation = __webpack_require__(170);
	
	var HandlerProxy = __webpack_require__(171);
	
	/*!
	* ZRender, a high performance 2d drawing library.
	*
	* Copyright (c) 2013, Baidu Inc.
	* All rights reserved.
	*
	* LICENSE
	* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	*/
	var useVML = !env.canvasSupported;
	var painterCtors = {
	  canvas: Painter
	};
	var instances = {}; // ZRender实例map索引
	
	/**
	 * @type {string}
	 */
	
	var version = '4.0.7';
	/**
	 * Initializing a zrender instance
	 * @param {HTMLElement} dom
	 * @param {Object} [opts]
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @return {module:zrender/ZRender}
	 */
	
	function init(dom, opts) {
	  var zr = new ZRender(guid(), dom, opts);
	  instances[zr.id] = zr;
	  return zr;
	}
	/**
	 * Dispose zrender instance
	 * @param {module:zrender/ZRender} zr
	 */
	
	
	function dispose(zr) {
	  if (zr) {
	    zr.dispose();
	  } else {
	    for (var key in instances) {
	      if (instances.hasOwnProperty(key)) {
	        instances[key].dispose();
	      }
	    }
	
	    instances = {};
	  }
	
	  return this;
	}
	/**
	 * Get zrender instance by id
	 * @param {string} id zrender instance id
	 * @return {module:zrender/ZRender}
	 */
	
	
	function getInstance(id) {
	  return instances[id];
	}
	
	function registerPainter(name, Ctor) {
	  painterCtors[name] = Ctor;
	}
	
	function delInstance(id) {
	  delete instances[id];
	}
	/**
	 * @module zrender/ZRender
	 */
	
	/**
	 * @constructor
	 * @alias module:zrender/ZRender
	 * @param {string} id
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 */
	
	
	var ZRender = function (id, dom, opts) {
	  opts = opts || {};
	  /**
	   * @type {HTMLDomElement}
	   */
	
	  this.dom = dom;
	  /**
	   * @type {string}
	   */
	
	  this.id = id;
	  var self = this;
	  var storage = new Storage();
	  var rendererType = opts.renderer; // TODO WebGL
	
	  if (useVML) {
	    if (!painterCtors.vml) {
	      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
	    }
	
	    rendererType = 'vml';
	  } else if (!rendererType || !painterCtors[rendererType]) {
	    rendererType = 'canvas';
	  }
	
	  var painter = new painterCtors[rendererType](dom, storage, opts, id);
	  this.storage = storage;
	  this.painter = painter;
	  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot()) : null;
	  this.handler = new Handler(storage, painter, handerProxy, painter.root);
	  /**
	   * @type {module:zrender/animation/Animation}
	   */
	
	  this.animation = new Animation({
	    stage: {
	      update: zrUtil.bind(this.flush, this)
	    }
	  });
	  this.animation.start();
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
	  // FIXME 有点ugly
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	    el && el.removeSelfFromZr(self);
	  };
	
	  storage.addToStorage = function (el) {
	    oldAddToStorage.call(storage, el);
	    el.addSelfToZr(self);
	  };
	};
	
	ZRender.prototype = {
	  constructor: ZRender,
	
	  /**
	   * 获取实例唯一标识
	   * @return {string}
	   */
	  getId: function () {
	    return this.id;
	  },
	
	  /**
	   * 添加元素
	   * @param  {module:zrender/Element} el
	   */
	  add: function (el) {
	    this.storage.addRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * 删除元素
	   * @param  {module:zrender/Element} el
	   */
	  remove: function (el) {
	    this.storage.delRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Change configuration of layer
	   * @param {string} zLevel
	   * @param {Object} config
	   * @param {string} [config.clearColor=0] Clear color
	   * @param {string} [config.motionBlur=false] If enable motion blur
	   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
	  */
	  configLayer: function (zLevel, config) {
	    if (this.painter.configLayer) {
	      this.painter.configLayer(zLevel, config);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Set background color
	   * @param {string} backgroundColor
	   */
	  setBackgroundColor: function (backgroundColor) {
	    if (this.painter.setBackgroundColor) {
	      this.painter.setBackgroundColor(backgroundColor);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Repaint the canvas immediately
	   */
	  refreshImmediately: function () {
	    // var start = new Date();
	    // Clear needsRefresh ahead to avoid something wrong happens in refresh
	    // Or it will cause zrender refreshes again and again.
	    this._needsRefresh = false;
	    this.painter.refresh();
	    /**
	     * Avoid trigger zr.refresh in Element#beforeUpdate hook
	     */
	
	    this._needsRefresh = false; // var end = new Date();
	    // var log = document.getElementById('log');
	    // if (log) {
	    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
	    // }
	  },
	
	  /**
	   * Mark and repaint the canvas in the next frame of browser
	   */
	  refresh: function () {
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Perform all refresh
	   */
	  flush: function () {
	    var triggerRendered;
	
	    if (this._needsRefresh) {
	      triggerRendered = true;
	      this.refreshImmediately();
	    }
	
	    if (this._needsRefreshHover) {
	      triggerRendered = true;
	      this.refreshHoverImmediately();
	    }
	
	    triggerRendered && this.trigger('rendered');
	  },
	
	  /**
	   * Add element to hover layer
	   * @param  {module:zrender/Element} el
	   * @param {Object} style
	   */
	  addHover: function (el, style) {
	    if (this.painter.addHover) {
	      var elMirror = this.painter.addHover(el, style);
	      this.refreshHover();
	      return elMirror;
	    }
	  },
	
	  /**
	   * Add element from hover layer
	   * @param  {module:zrender/Element} el
	   */
	  removeHover: function (el) {
	    if (this.painter.removeHover) {
	      this.painter.removeHover(el);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Clear all hover elements in hover layer
	   * @param  {module:zrender/Element} el
	   */
	  clearHover: function () {
	    if (this.painter.clearHover) {
	      this.painter.clearHover();
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Refresh hover in next frame
	   */
	  refreshHover: function () {
	    this._needsRefreshHover = true;
	  },
	
	  /**
	   * Refresh hover immediately
	   */
	  refreshHoverImmediately: function () {
	    this._needsRefreshHover = false;
	    this.painter.refreshHover && this.painter.refreshHover();
	  },
	
	  /**
	   * Resize the canvas.
	   * Should be invoked when container size is changed
	   * @param {Object} [opts]
	   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	   */
	  resize: function (opts) {
	    opts = opts || {};
	    this.painter.resize(opts.width, opts.height);
	    this.handler.resize();
	  },
	
	  /**
	   * Stop and clear all animation immediately
	   */
	  clearAnimation: function () {
	    this.animation.clear();
	  },
	
	  /**
	   * Get container width
	   */
	  getWidth: function () {
	    return this.painter.getWidth();
	  },
	
	  /**
	   * Get container height
	   */
	  getHeight: function () {
	    return this.painter.getHeight();
	  },
	
	  /**
	   * Export the canvas as Base64 URL
	   * @param {string} type
	   * @param {string} [backgroundColor='#fff']
	   * @return {string} Base64 URL
	   */
	  // toDataURL: function(type, backgroundColor) {
	  //     return this.painter.getRenderedCanvas({
	  //         backgroundColor: backgroundColor
	  //     }).toDataURL(type);
	  // },
	
	  /**
	   * Converting a path to image.
	   * It has much better performance of drawing image rather than drawing a vector path.
	   * @param {module:zrender/graphic/Path} e
	   * @param {number} width
	   * @param {number} height
	   */
	  pathToImage: function (e, dpr) {
	    return this.painter.pathToImage(e, dpr);
	  },
	
	  /**
	   * Set default cursor
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    this.handler.setCursorStyle(cursorStyle);
	  },
	
	  /**
	   * Find hovered element
	   * @param {number} x
	   * @param {number} y
	   * @return {Object} {target, topTarget}
	   */
	  findHover: function (x, y) {
	    return this.handler.findHover(x, y);
	  },
	
	  /**
	   * Bind event
	   *
	   * @param {string} eventName Event name
	   * @param {Function} eventHandler Handler function
	   * @param {Object} [context] Context object
	   */
	  on: function (eventName, eventHandler, context) {
	    this.handler.on(eventName, eventHandler, context);
	  },
	
	  /**
	   * Unbind event
	   * @param {string} eventName Event name
	   * @param {Function} [eventHandler] Handler function
	   */
	  off: function (eventName, eventHandler) {
	    this.handler.off(eventName, eventHandler);
	  },
	
	  /**
	   * Trigger event manually
	   *
	   * @param {string} eventName Event name
	   * @param {event=} event Event object
	   */
	  trigger: function (eventName, event) {
	    this.handler.trigger(eventName, event);
	  },
	
	  /**
	   * Clear all objects and the canvas.
	   */
	  clear: function () {
	    this.storage.delRoot();
	    this.painter.clear();
	  },
	
	  /**
	   * Dispose self.
	   */
	  dispose: function () {
	    this.animation.stop();
	    this.clear();
	    this.storage.dispose();
	    this.painter.dispose();
	    this.handler.dispose();
	    this.animation = this.storage = this.painter = this.handler = null;
	    delInstance(this.id);
	  }
	};
	exports.version = version;
	exports.init = init;
	exports.dispose = dispose;
	exports.getInstance = getInstance;
	exports.registerPainter = registerPainter;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	/**
	 * zrender: 生成唯一id
	 *
	 * @author errorrik (errorrik@gmail.com)
	 */
	var idStart = 0x0907;
	
	function _default() {
	  return idStart++;
	}
	
	module.exports = _default;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	/**
	 * echarts设备环境识别
	 *
	 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
	 * @author firede[firede@firede.us]
	 * @desc thanks zepto.
	 */
	var env = {};
	
	if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
	  // In Weixin Application
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    wxa: true,
	    // Weixin Application
	    canvasSupported: true,
	    svgSupported: false,
	    touchEventsSupported: true,
	    domSupported: false
	  };
	} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
	  // In worker
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    worker: true,
	    canvasSupported: true,
	    domSupported: false
	  };
	} else if (typeof navigator === 'undefined') {
	  // In node
	  env = {
	    browser: {},
	    os: {},
	    node: true,
	    worker: false,
	    // Assume canvas is supported
	    canvasSupported: true,
	    svgSupported: true,
	    domSupported: false
	  };
	} else {
	  env = detect(navigator.userAgent);
	}
	
	var _default = env; // Zepto.js
	// (c) 2010-2013 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	
	function detect(ua) {
	  var os = {};
	  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
	  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
	  // var touchpad = webos && ua.match(/TouchPad/);
	  // var kindle = ua.match(/Kindle\/([\d.]+)/);
	  // var silk = ua.match(/Silk\/([\d._]+)/);
	  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
	  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
	  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
	  // var playbook = ua.match(/PlayBook/);
	  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
	
	  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
	  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
	
	  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
	  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
	
	  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
	  // - discern (more) between multiple browsers on android
	  // - decide if kindle fire in silk mode is android or not
	  // - Firefox on Android doesn't specify the Android version
	  // - possibly devide in os, device and browser hashes
	  // if (browser.webkit = !!webkit) browser.version = webkit[1];
	  // if (android) os.android = true, os.version = android[2];
	  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
	  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
	  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	  // if (webos) os.webos = true, os.version = webos[2];
	  // if (touchpad) os.touchpad = true;
	  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
	  // if (bb10) os.bb10 = true, os.version = bb10[2];
	  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
	  // if (playbook) browser.playbook = true;
	  // if (kindle) os.kindle = true, os.version = kindle[1];
	  // if (silk) browser.silk = true, browser.version = silk[1];
	  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
	  // if (chrome) browser.chrome = true, browser.version = chrome[1];
	
	  if (firefox) {
	    browser.firefox = true;
	    browser.version = firefox[1];
	  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
	  // if (webview) browser.webview = true;
	
	
	  if (ie) {
	    browser.ie = true;
	    browser.version = ie[1];
	  }
	
	  if (edge) {
	    browser.edge = true;
	    browser.version = edge[1];
	  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
	  // not be set on win phone. So we do not consider Win Phone.
	
	
	  if (weChat) {
	    browser.weChat = true;
	  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
	  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
	  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
	
	
	  return {
	    browser: browser,
	    os: os,
	    node: false,
	    // 原生canvas支持，改极端点了
	    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
	    canvasSupported: !!document.createElement('canvas').getContext,
	    svgSupported: typeof SVGRect !== 'undefined',
	    // works on most browsers
	    // IE10/11 does not support touch event, and MS Edge supports them but not by
	    // default, so we dont check navigator.maxTouchPoints for them here.
	    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
	    // <http://caniuse.com/#search=pointer%20event>.
	    pointerEventsSupported: 'onpointerdown' in window // Firefox supports pointer but not by default, only MS browsers are reliable on pointer
	    // events currently. So we dont use that on other browsers unless tested sufficiently.
	    // Although IE 10 supports pointer event, it use old style and is different from the
	    // standard. So we exclude that. (IE 10 is hardly used on touch device)
	    && (browser.edge || browser.ie && browser.version >= 11),
	    // passiveSupported: detectPassiveSupport()
	    domSupported: typeof document !== 'undefined'
	  };
	} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	// function detectPassiveSupport() {
	//     // Test via a getter in the options object to see if the passive property is accessed
	//     var supportsPassive = false;
	//     try {
	//         var opts = Object.defineProperty({}, 'passive', {
	//             get: function() {
	//                 supportsPassive = true;
	//             }
	//         });
	//         window.addEventListener('testPassive', function() {}, opts);
	//     } catch (e) {
	//     }
	//     return supportsPassive;
	// }
	
	
	module.exports = _default;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/**
	 * @module zrender/core/util
	 */
	// 用于处理merge时无法遍历Date等对象的问题
	var BUILTIN_OBJECT = {
	  '[object Function]': 1,
	  '[object RegExp]': 1,
	  '[object Date]': 1,
	  '[object Error]': 1,
	  '[object CanvasGradient]': 1,
	  '[object CanvasPattern]': 1,
	  // For node-canvas
	  '[object Image]': 1,
	  '[object Canvas]': 1
	};
	var TYPED_ARRAY = {
	  '[object Int8Array]': 1,
	  '[object Uint8Array]': 1,
	  '[object Uint8ClampedArray]': 1,
	  '[object Int16Array]': 1,
	  '[object Uint16Array]': 1,
	  '[object Int32Array]': 1,
	  '[object Uint32Array]': 1,
	  '[object Float32Array]': 1,
	  '[object Float64Array]': 1
	};
	var objToString = Object.prototype.toString;
	var arrayProto = Array.prototype;
	var nativeForEach = arrayProto.forEach;
	var nativeFilter = arrayProto.filter;
	var nativeSlice = arrayProto.slice;
	var nativeMap = arrayProto.map;
	var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  // Clear ctx instance for different environment
	  if (name === 'createCanvas') {
	    _ctx = null;
	  }
	
	  methods[name] = fn;
	}
	/**
	 * Those data types can be cloned:
	 *     Plain object, Array, TypedArray, number, string, null, undefined.
	 * Those data types will be assgined using the orginal data:
	 *     BUILTIN_OBJECT
	 * Instance of user defined class will be cloned to a plain object, without
	 * properties in prototype.
	 * Other data types is not supported (not sure what will happen).
	 *
	 * Caution: do not support clone Date, for performance consideration.
	 * (There might be a large number of date in `series.data`).
	 * So date should not be modified in and out of echarts.
	 *
	 * @param {*} source
	 * @return {*} new
	 */
	
	
	function clone(source) {
	  if (source == null || typeof source !== 'object') {
	    return source;
	  }
	
	  var result = source;
	  var typeStr = objToString.call(source);
	
	  if (typeStr === '[object Array]') {
	    if (!isPrimitive(source)) {
	      result = [];
	
	      for (var i = 0, len = source.length; i < len; i++) {
	        result[i] = clone(source[i]);
	      }
	    }
	  } else if (TYPED_ARRAY[typeStr]) {
	    if (!isPrimitive(source)) {
	      var Ctor = source.constructor;
	
	      if (source.constructor.from) {
	        result = Ctor.from(source);
	      } else {
	        result = new Ctor(source.length);
	
	        for (var i = 0, len = source.length; i < len; i++) {
	          result[i] = clone(source[i]);
	        }
	      }
	    }
	  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	    result = {};
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        result[key] = clone(source[key]);
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overwrite=false]
	 */
	
	
	function merge(target, source, overwrite) {
	  // We should escapse that source is string
	  // and enter for ... in ...
	  if (!isObject(source) || !isObject(target)) {
	    return overwrite ? clone(source) : target;
	  }
	
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var targetProp = target[key];
	      var sourceProp = source[key];
	
	      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
	        // 如果需要递归覆盖，就递归调用merge
	        merge(targetProp, sourceProp, overwrite);
	      } else if (overwrite || !(key in target)) {
	        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
	        // NOTE，在 target[key] 不存在的时候也是直接覆盖
	        target[key] = clone(source[key], true);
	      }
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {Array} targetAndSources The first item is target, and the rests are source.
	 * @param {boolean} [overwrite=false]
	 * @return {*} target
	 */
	
	
	function mergeAll(targetAndSources, overwrite) {
	  var result = targetAndSources[0];
	
	  for (var i = 1, len = targetAndSources.length; i < len; i++) {
	    result = merge(result, targetAndSources[i], overwrite);
	  }
	
	  return result;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @memberOf module:zrender/core/util
	 */
	
	
	function extend(target, source) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overlay=false]
	 * @memberOf module:zrender/core/util
	 */
	
	
	function defaults(target, source, overlay) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var createCanvas = function () {
	  return methods.createCanvas();
	};
	
	methods.createCanvas = function () {
	  return document.createElement('canvas');
	}; // FIXME
	
	
	var _ctx;
	
	function getContext() {
	  if (!_ctx) {
	    // Use util.createCanvas instead of createCanvas
	    // because createCanvas may be overwritten in different environment
	    _ctx = createCanvas().getContext('2d');
	  }
	
	  return _ctx;
	}
	/**
	 * 查询数组中元素的index
	 * @memberOf module:zrender/core/util
	 */
	
	
	function indexOf(array, value) {
	  if (array) {
	    if (array.indexOf) {
	      return array.indexOf(value);
	    }
	
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	}
	/**
	 * 构造类继承关系
	 *
	 * @memberOf module:zrender/core/util
	 * @param {Function} clazz 源类
	 * @param {Function} baseClazz 基类
	 */
	
	
	function inherits(clazz, baseClazz) {
	  var clazzPrototype = clazz.prototype;
	
	  function F() {}
	
	  F.prototype = baseClazz.prototype;
	  clazz.prototype = new F();
	
	  for (var prop in clazzPrototype) {
	    clazz.prototype[prop] = clazzPrototype[prop];
	  }
	
	  clazz.prototype.constructor = clazz;
	  clazz.superClass = baseClazz;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Object|Function} target
	 * @param {Object|Function} sorce
	 * @param {boolean} overlay
	 */
	
	
	function mixin(target, source, overlay) {
	  target = 'prototype' in target ? target.prototype : target;
	  source = 'prototype' in source ? source.prototype : source;
	  defaults(target, source, overlay);
	}
	/**
	 * Consider typed array.
	 * @param {Array|TypedArray} data
	 */
	
	
	function isArrayLike(data) {
	  if (!data) {
	    return;
	  }
	
	  if (typeof data === 'string') {
	    return false;
	  }
	
	  return typeof data.length === 'number';
	}
	/**
	 * 数组或对象遍历
	 * @memberOf module:zrender/core/util
	 * @param {Object|Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 */
	
	
	function each(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.forEach && obj.forEach === nativeForEach) {
	    obj.forEach(cb, context);
	  } else if (obj.length === +obj.length) {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      cb.call(context, obj[i], i, obj);
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        cb.call(context, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * 数组映射
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function map(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.map && obj.map === nativeMap) {
	    return obj.map(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      result.push(cb.call(context, obj[i], i, obj));
	    }
	
	    return result;
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {Object} [memo]
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function reduce(obj, cb, memo, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.reduce && obj.reduce === nativeReduce) {
	    return obj.reduce(cb, memo, context);
	  } else {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      memo = cb.call(context, memo, obj[i], i, obj);
	    }
	
	    return memo;
	  }
	}
	/**
	 * 数组过滤
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function filter(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.filter && obj.filter === nativeFilter) {
	    return obj.filter(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      if (cb.call(context, obj[i], i, obj)) {
	        result.push(obj[i]);
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * 数组项查找
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {*}
	 */
	
	
	function find(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  for (var i = 0, len = obj.length; i < len; i++) {
	    if (cb.call(context, obj[i], i, obj)) {
	      return obj[i];
	    }
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @param {*} context
	 * @return {Function}
	 */
	
	
	function bind(func, context) {
	  var args = nativeSlice.call(arguments, 2);
	  return function () {
	    return func.apply(context, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @return {Function}
	 */
	
	
	function curry(func) {
	  var args = nativeSlice.call(arguments, 1);
	  return function () {
	    return func.apply(this, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isArray(value) {
	  return objToString.call(value) === '[object Array]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isFunction(value) {
	  return typeof value === 'function';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isString(value) {
	  return objToString.call(value) === '[object String]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type === 'function' || !!value && type === 'object';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isBuiltInObject(value) {
	  return !!BUILTIN_OBJECT[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isTypedArray(value) {
	  return !!TYPED_ARRAY[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isDom(value) {
	  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
	}
	/**
	 * Whether is exactly NaN. Notice isNaN('a') returns true.
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function eqNaN(value) {
	  return value !== value;
	}
	/**
	 * If value1 is not null, then return value1, otherwise judget rest of values.
	 * Low performance.
	 * @memberOf module:zrender/core/util
	 * @return {*} Final value
	 */
	
	
	function retrieve(values) {
	  for (var i = 0, len = arguments.length; i < len; i++) {
	    if (arguments[i] != null) {
	      return arguments[i];
	    }
	  }
	}
	
	function retrieve2(value0, value1) {
	  return value0 != null ? value0 : value1;
	}
	
	function retrieve3(value0, value1, value2) {
	  return value0 != null ? value0 : value1 != null ? value1 : value2;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} arr
	 * @param {number} startIndex
	 * @param {number} endIndex
	 * @return {Array}
	 */
	
	
	function slice() {
	  return Function.call.apply(nativeSlice, arguments);
	}
	/**
	 * Normalize css liked array configuration
	 * e.g.
	 *  3 => [3, 3, 3, 3]
	 *  [4, 2] => [4, 2, 4, 2]
	 *  [4, 3, 2] => [4, 3, 2, 3]
	 * @param {number|Array.<number>} val
	 * @return {Array.<number>}
	 */
	
	
	function normalizeCssArray(val) {
	  if (typeof val === 'number') {
	    return [val, val, val, val];
	  }
	
	  var len = val.length;
	
	  if (len === 2) {
	    // vertical | horizontal
	    return [val[0], val[1], val[0], val[1]];
	  } else if (len === 3) {
	    // top | horizontal | bottom
	    return [val[0], val[1], val[2], val[1]];
	  }
	
	  return val;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {boolean} condition
	 * @param {string} message
	 */
	
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {string} str string to be trimed
	 * @return {string} trimed string
	 */
	
	
	function trim(str) {
	  if (str == null) {
	    return null;
	  } else if (typeof str.trim === 'function') {
	    return str.trim();
	  } else {
	    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	  }
	}
	
	var primitiveKey = '__ec_primitive__';
	/**
	 * Set an object as primitive to be ignored traversing children in clone or merge
	 */
	
	function setAsPrimitive(obj) {
	  obj[primitiveKey] = true;
	}
	
	function isPrimitive(obj) {
	  return obj[primitiveKey];
	}
	/**
	 * @constructor
	 * @param {Object} obj Only apply `ownProperty`.
	 */
	
	
	function HashMap(obj) {
	  var isArr = isArray(obj); // Key should not be set on this, otherwise
	  // methods get/set/... may be overrided.
	
	  this.data = {};
	  var thisMap = this;
	  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);
	
	  function visit(value, key) {
	    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
	  }
	}
	
	HashMap.prototype = {
	  constructor: HashMap,
	  // Do not provide `has` method to avoid defining what is `has`.
	  // (We usually treat `null` and `undefined` as the same, different
	  // from ES6 Map).
	  get: function (key) {
	    return this.data.hasOwnProperty(key) ? this.data[key] : null;
	  },
	  set: function (key, value) {
	    // Comparing with invocation chaining, `return value` is more commonly
	    // used in this case: `var someVal = map.set('a', genVal());`
	    return this.data[key] = value;
	  },
	  // Although util.each can be performed on this hashMap directly, user
	  // should not use the exposed keys, who are prefixed.
	  each: function (cb, context) {
	    context !== void 0 && (cb = bind(cb, context));
	
	    for (var key in this.data) {
	      this.data.hasOwnProperty(key) && cb(this.data[key], key);
	    }
	  },
	  // Do not use this method if performance sensitive.
	  removeKey: function (key) {
	    delete this.data[key];
	  }
	};
	
	function createHashMap(obj) {
	  return new HashMap(obj);
	}
	
	function concatArray(a, b) {
	  var newArray = new a.constructor(a.length + b.length);
	
	  for (var i = 0; i < a.length; i++) {
	    newArray[i] = a[i];
	  }
	
	  var offset = a.length;
	
	  for (i = 0; i < b.length; i++) {
	    newArray[i + offset] = b[i];
	  }
	
	  return newArray;
	}
	
	function noop() {}
	
	exports.$override = $override;
	exports.clone = clone;
	exports.merge = merge;
	exports.mergeAll = mergeAll;
	exports.extend = extend;
	exports.defaults = defaults;
	exports.createCanvas = createCanvas;
	exports.getContext = getContext;
	exports.indexOf = indexOf;
	exports.inherits = inherits;
	exports.mixin = mixin;
	exports.isArrayLike = isArrayLike;
	exports.each = each;
	exports.map = map;
	exports.reduce = reduce;
	exports.filter = filter;
	exports.find = find;
	exports.bind = bind;
	exports.curry = curry;
	exports.isArray = isArray;
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isBuiltInObject = isBuiltInObject;
	exports.isTypedArray = isTypedArray;
	exports.isDom = isDom;
	exports.eqNaN = eqNaN;
	exports.retrieve = retrieve;
	exports.retrieve2 = retrieve2;
	exports.retrieve3 = retrieve3;
	exports.slice = slice;
	exports.normalizeCssArray = normalizeCssArray;
	exports.assert = assert;
	exports.trim = trim;
	exports.setAsPrimitive = setAsPrimitive;
	exports.isPrimitive = isPrimitive;
	exports.createHashMap = createHashMap;
	exports.concatArray = concatArray;
	exports.noop = noop;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(134);
	
	var vec2 = __webpack_require__(136);
	
	var Draggable = __webpack_require__(137);
	
	var Eventful = __webpack_require__(138);
	
	var eventTool = __webpack_require__(139);
	
	var GestureMgr = __webpack_require__(140);
	
	var SILENT = 'silent';
	
	function makeEventPacket(eveType, targetInfo, event) {
	  return {
	    type: eveType,
	    event: event,
	    // target can only be an element that is not silent.
	    target: targetInfo.target,
	    // topTarget can be a silent element.
	    topTarget: targetInfo.topTarget,
	    cancelBubble: false,
	    offsetX: event.zrX,
	    offsetY: event.zrY,
	    gestureEvent: event.gestureEvent,
	    pinchX: event.pinchX,
	    pinchY: event.pinchY,
	    pinchScale: event.pinchScale,
	    wheelDelta: event.zrDelta,
	    zrByTouch: event.zrByTouch,
	    which: event.which,
	    stop: stopEvent
	  };
	}
	
	function stopEvent(event) {
	  eventTool.stop(this.event);
	}
	
	function EmptyProxy() {}
	
	EmptyProxy.prototype.dispose = function () {};
	
	var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	/**
	 * @alias module:zrender/Handler
	 * @constructor
	 * @extends module:zrender/mixin/Eventful
	 * @param {module:zrender/Storage} storage Storage instance.
	 * @param {module:zrender/Painter} painter Painter instance.
	 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
	 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
	 */
	
	var Handler = function (storage, painter, proxy, painterRoot) {
	  Eventful.call(this);
	  this.storage = storage;
	  this.painter = painter;
	  this.painterRoot = painterRoot;
	  proxy = proxy || new EmptyProxy();
	  /**
	   * Proxy of event. can be Dom, WebGLSurface, etc.
	   */
	
	  this.proxy = null;
	  /**
	   * {target, topTarget, x, y}
	   * @private
	   * @type {Object}
	   */
	
	  this._hovered = {};
	  /**
	   * @private
	   * @type {Date}
	   */
	
	  this._lastTouchMoment;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastX;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastY;
	  /**
	   * @private
	   * @type {module:zrender/core/GestureMgr}
	   */
	
	  this._gestureMgr;
	  Draggable.call(this);
	  this.setHandlerProxy(proxy);
	};
	
	Handler.prototype = {
	  constructor: Handler,
	  setHandlerProxy: function (proxy) {
	    if (this.proxy) {
	      this.proxy.dispose();
	    }
	
	    if (proxy) {
	      util.each(handlerNames, function (name) {
	        proxy.on && proxy.on(name, this[name], this);
	      }, this); // Attach handler
	
	      proxy.handler = this;
	    }
	
	    this.proxy = proxy;
	  },
	  mousemove: function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var lastHovered = this._hovered;
	    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
	    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
	    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
	    // See #6198.
	
	    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	      lastHoveredTarget = lastHovered.target;
	    }
	
	    var hovered = this._hovered = this.findHover(x, y);
	    var hoveredTarget = hovered.target;
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element
	
	    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(lastHovered, 'mouseout', event);
	    } // Mouse moving on one element
	
	
	    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element
	
	    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(hovered, 'mouseover', event);
	    }
	  },
	  mouseout: function (event) {
	    this.dispatchToElement(this._hovered, 'mouseout', event); // There might be some doms created by upper layer application
	    // at the same level of painter.getViewportRoot() (e.g., tooltip
	    // dom created by echarts), where 'globalout' event should not
	    // be triggered when mouse enters these doms. (But 'mouseout'
	    // should be triggered at the original hovered element as usual).
	
	    var element = event.toElement || event.relatedTarget;
	    var innerDom;
	
	    do {
	      element = element && element.parentNode;
	    } while (element && element.nodeType !== 9 && !(innerDom = element === this.painterRoot));
	
	    !innerDom && this.trigger('globalout', {
	      event: event
	    });
	  },
	
	  /**
	   * Resize
	   */
	  resize: function (event) {
	    this._hovered = {};
	  },
	
	  /**
	   * Dispatch event
	   * @param {string} eventName
	   * @param {event=} eventArgs
	   */
	  dispatch: function (eventName, eventArgs) {
	    var handler = this[eventName];
	    handler && handler.call(this, eventArgs);
	  },
	
	  /**
	   * Dispose
	   */
	  dispose: function () {
	    this.proxy.dispose();
	    this.storage = this.proxy = this.painter = null;
	  },
	
	  /**
	   * 设置默认的cursor style
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(cursorStyle);
	  },
	
	  /**
	   * 事件分发代理
	   *
	   * @private
	   * @param {Object} targetInfo {target, topTarget} 目标图形元素
	   * @param {string} eventName 事件名称
	   * @param {Object} event 事件对象
	   */
	  dispatchToElement: function (targetInfo, eventName, event) {
	    targetInfo = targetInfo || {};
	    var el = targetInfo.target;
	
	    if (el && el.silent) {
	      return;
	    }
	
	    var eventHandler = 'on' + eventName;
	    var eventPacket = makeEventPacket(eventName, targetInfo, event);
	
	    while (el) {
	      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
	      el.trigger(eventName, eventPacket);
	      el = el.parent;
	
	      if (eventPacket.cancelBubble) {
	        break;
	      }
	    }
	
	    if (!eventPacket.cancelBubble) {
	      // 冒泡到顶级 zrender 对象
	      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
	      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
	
	      this.painter && this.painter.eachOtherLayer(function (layer) {
	        if (typeof layer[eventHandler] === 'function') {
	          layer[eventHandler].call(layer, eventPacket);
	        }
	
	        if (layer.trigger) {
	          layer.trigger(eventName, eventPacket);
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {number} x
	   * @param {number} y
	   * @param {module:zrender/graphic/Displayable} exclude
	   * @return {model:zrender/Element}
	   * @method
	   */
	  findHover: function (x, y, exclude) {
	    var list = this.storage.getDisplayList();
	    var out = {
	      x: x,
	      y: y
	    };
	
	    for (var i = list.length - 1; i >= 0; i--) {
	      var hoverCheckResult;
	
	      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
	      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
	        !out.topTarget && (out.topTarget = list[i]);
	
	        if (hoverCheckResult !== SILENT) {
	          out.target = list[i];
	          break;
	        }
	      }
	    }
	
	    return out;
	  },
	  processGesture: function (event, stage) {
	    if (!this._gestureMgr) {
	      this._gestureMgr = new GestureMgr();
	    }
	
	    var gestureMgr = this._gestureMgr;
	    stage === 'start' && gestureMgr.clear();
	    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
	    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
	
	    if (gestureInfo) {
	      var type = gestureInfo.type;
	      event.gestureEvent = type;
	      this.dispatchToElement({
	        target: gestureInfo.target
	      }, type, gestureInfo.event);
	    }
	  }
	}; // Common handlers
	
	util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  Handler.prototype[name] = function (event) {
	    // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
	    var hovered = this.findHover(event.zrX, event.zrY);
	    var hoveredTarget = hovered.target;
	
	    if (name === 'mousedown') {
	      this._downEl = hoveredTarget;
	      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup
	
	      this._upEl = hoveredTarget;
	    } else if (name === 'mouseup') {
	      this._upEl = hoveredTarget;
	    } else if (name === 'click') {
	      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
	      // including the case that `mousedown` - `mousemove` - `mouseup`,
	      // which should be filtered, otherwise it will bring trouble to
	      // pan and zoom.
	      || !this._downPoint // Arbitrary value
	      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	        return;
	      }
	
	      this._downPoint = null;
	    }
	
	    this.dispatchToElement(hovered, name, event);
	  };
	});
	
	function isHover(displayable, x, y) {
	  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	    var el = displayable;
	    var isSilent;
	
	    while (el) {
	      // If clipped by ancestor.
	      // FIXME: If clipPath has neither stroke nor fill,
	      // el.clipPath.contain(x, y) will always return false.
	      if (el.clipPath && !el.clipPath.contain(x, y)) {
	        return false;
	      }
	
	      if (el.silent) {
	        isSilent = true;
	      }
	
	      el = el.parent;
	    }
	
	    return isSilent ? SILENT : true;
	  }
	
	  return false;
	}
	
	util.mixin(Handler, Eventful);
	util.mixin(Handler, Draggable);
	var _default = Handler;
	module.exports = _default;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个向量
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @return {Vector2}
	 */
	
	function create(x, y) {
	  var out = new ArrayCtor(2);
	
	  if (x == null) {
	    x = 0;
	  }
	
	  if (y == null) {
	    y = 0;
	  }
	
	  out[0] = x;
	  out[1] = y;
	  return out;
	}
	/**
	 * 复制向量数据
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function copy(out, v) {
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 克隆一个向量
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function clone(v) {
	  var out = new ArrayCtor(2);
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 设置向量的两个项
	 * @param {Vector2} out
	 * @param {number} a
	 * @param {number} b
	 * @return {Vector2} 结果
	 */
	
	
	function set(out, a, b) {
	  out[0] = a;
	  out[1] = b;
	  return out;
	}
	/**
	 * 向量相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function add(out, v1, v2) {
	  out[0] = v1[0] + v2[0];
	  out[1] = v1[1] + v2[1];
	  return out;
	}
	/**
	 * 向量缩放后相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} a
	 */
	
	
	function scaleAndAdd(out, v1, v2, a) {
	  out[0] = v1[0] + v2[0] * a;
	  out[1] = v1[1] + v2[1] * a;
	  return out;
	}
	/**
	 * 向量相减
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function sub(out, v1, v2) {
	  out[0] = v1[0] - v2[0];
	  out[1] = v1[1] - v2[1];
	  return out;
	}
	/**
	 * 向量长度
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	
	function len(v) {
	  return Math.sqrt(lenSquare(v));
	}
	
	var length = len; // jshint ignore:line
	
	/**
	 * 向量长度平方
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	function lenSquare(v) {
	  return v[0] * v[0] + v[1] * v[1];
	}
	
	var lengthSquare = lenSquare;
	/**
	 * 向量乘法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	function mul(out, v1, v2) {
	  out[0] = v1[0] * v2[0];
	  out[1] = v1[1] * v2[1];
	  return out;
	}
	/**
	 * 向量除法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function div(out, v1, v2) {
	  out[0] = v1[0] / v2[0];
	  out[1] = v1[1] / v2[1];
	  return out;
	}
	/**
	 * 向量点乘
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function dot(v1, v2) {
	  return v1[0] * v2[0] + v1[1] * v2[1];
	}
	/**
	 * 向量缩放
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {number} s
	 */
	
	
	function scale(out, v, s) {
	  out[0] = v[0] * s;
	  out[1] = v[1] * s;
	  return out;
	}
	/**
	 * 向量归一化
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	
	function normalize(out, v) {
	  var d = len(v);
	
	  if (d === 0) {
	    out[0] = 0;
	    out[1] = 0;
	  } else {
	    out[0] = v[0] / d;
	    out[1] = v[1] / d;
	  }
	
	  return out;
	}
	/**
	 * 计算向量间距离
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function distance(v1, v2) {
	  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	}
	
	var dist = distance;
	/**
	 * 向量距离平方
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	function distanceSquare(v1, v2) {
	  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	}
	
	var distSquare = distanceSquare;
	/**
	 * 求负向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	function negate(out, v) {
	  out[0] = -v[0];
	  out[1] = -v[1];
	  return out;
	}
	/**
	 * 插值两个点
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} t
	 */
	
	
	function lerp(out, v1, v2, t) {
	  out[0] = v1[0] + t * (v2[0] - v1[0]);
	  out[1] = v1[1] + t * (v2[1] - v1[1]);
	  return out;
	}
	/**
	 * 矩阵左乘向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {Vector2} m
	 */
	
	
	function applyTransform(out, v, m) {
	  var x = v[0];
	  var y = v[1];
	  out[0] = m[0] * x + m[2] * y + m[4];
	  out[1] = m[1] * x + m[3] * y + m[5];
	  return out;
	}
	/**
	 * 求两个向量最小值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function min(out, v1, v2) {
	  out[0] = Math.min(v1[0], v2[0]);
	  out[1] = Math.min(v1[1], v2[1]);
	  return out;
	}
	/**
	 * 求两个向量最大值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function max(out, v1, v2) {
	  out[0] = Math.max(v1[0], v2[0]);
	  out[1] = Math.max(v1[1], v2[1]);
	  return out;
	}
	
	exports.create = create;
	exports.copy = copy;
	exports.clone = clone;
	exports.set = set;
	exports.add = add;
	exports.scaleAndAdd = scaleAndAdd;
	exports.sub = sub;
	exports.len = len;
	exports.length = length;
	exports.lenSquare = lenSquare;
	exports.lengthSquare = lengthSquare;
	exports.mul = mul;
	exports.div = div;
	exports.dot = dot;
	exports.scale = scale;
	exports.normalize = normalize;
	exports.distance = distance;
	exports.dist = dist;
	exports.distanceSquare = distanceSquare;
	exports.distSquare = distSquare;
	exports.negate = negate;
	exports.lerp = lerp;
	exports.applyTransform = applyTransform;
	exports.min = min;
	exports.max = max;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	// TODO Draggable for group
	// FIXME Draggable on element which has parent rotation or scale
	function Draggable() {
	  this.on('mousedown', this._dragStart, this);
	  this.on('mousemove', this._drag, this);
	  this.on('mouseup', this._dragEnd, this);
	  this.on('globalout', this._dragEnd, this); // this._dropTarget = null;
	  // this._draggingTarget = null;
	  // this._x = 0;
	  // this._y = 0;
	}
	
	Draggable.prototype = {
	  constructor: Draggable,
	  _dragStart: function (e) {
	    var draggingTarget = e.target;
	
	    if (draggingTarget && draggingTarget.draggable) {
	      this._draggingTarget = draggingTarget;
	      draggingTarget.dragging = true;
	      this._x = e.offsetX;
	      this._y = e.offsetY;
	      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
	    }
	  },
	  _drag: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      var x = e.offsetX;
	      var y = e.offsetY;
	      var dx = x - this._x;
	      var dy = y - this._y;
	      this._x = x;
	      this._y = y;
	      draggingTarget.drift(dx, dy, e);
	      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
	      var dropTarget = this.findHover(x, y, draggingTarget).target;
	      var lastDropTarget = this._dropTarget;
	      this._dropTarget = dropTarget;
	
	      if (draggingTarget !== dropTarget) {
	        if (lastDropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
	        }
	
	        if (dropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
	        }
	      }
	    }
	  },
	  _dragEnd: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      draggingTarget.dragging = false;
	    }
	
	    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);
	
	    if (this._dropTarget) {
	      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
	    }
	
	    this._draggingTarget = null;
	    this._dropTarget = null;
	  }
	};
	
	function param(target, e) {
	  return {
	    target: target,
	    topTarget: e && e.topTarget
	  };
	}
	
	var _default = Draggable;
	module.exports = _default;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Event Mixin
	 * @module zrender/mixin/Eventful
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	var arrySlice = Array.prototype.slice;
	/**
	 * Event dispatcher.
	 *
	 * @alias module:zrender/mixin/Eventful
	 * @constructor
	 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
	 *        `eventProcessor.xxx` called.
	 * @param {Function} [eventProcessor.normalizeQuery]
	 *        param: {string|Object} Raw query.
	 *        return: {string|Object} Normalized query.
	 * @param {Function} [eventProcessor.filter] Event will be dispatched only
	 *        if it returns `true`.
	 *        param: {string} eventType
	 *        param: {string|Object} query
	 *        return: {boolean}
	 * @param {Function} [eventProcessor.afterTrigger] Call after all handlers called.
	 *        param: {string} eventType
	 */
	
	var Eventful = function (eventProcessor) {
	  this._$handlers = {};
	  this._$eventProcessor = eventProcessor;
	};
	
	Eventful.prototype = {
	  constructor: Eventful,
	
	  /**
	   * The handler can only be triggered once, then removed.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} context
	   */
	  one: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, true);
	  },
	
	  /**
	   * Bind a handler.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} [context]
	   */
	  on: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, false);
	  },
	
	  /**
	   * Whether any handler has bound.
	   *
	   * @param  {string}  event
	   * @return {boolean}
	   */
	  isSilent: function (event) {
	    var _h = this._$handlers;
	    return !_h[event] || !_h[event].length;
	  },
	
	  /**
	   * Unbind a event.
	   *
	   * @param {string} event The event name.
	   * @param {Function} [handler] The event handler.
	   */
	  off: function (event, handler) {
	    var _h = this._$handlers;
	
	    if (!event) {
	      this._$handlers = {};
	      return this;
	    }
	
	    if (handler) {
	      if (_h[event]) {
	        var newList = [];
	
	        for (var i = 0, l = _h[event].length; i < l; i++) {
	          if (_h[event][i].h !== handler) {
	            newList.push(_h[event][i]);
	          }
	        }
	
	        _h[event] = newList;
	      }
	
	      if (_h[event] && _h[event].length === 0) {
	        delete _h[event];
	      }
	    } else {
	      delete _h[event];
	    }
	
	    return this;
	  },
	
	  /**
	   * Dispatch a event.
	   *
	   * @param {string} type The event name.
	   */
	  trigger: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 3) {
	        args = arrySlice.call(args, 1);
	      }
	
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(hItem.ctx);
	            break;
	
	          case 2:
	            hItem.h.call(hItem.ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(hItem.ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(hItem.ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  },
	
	  /**
	   * Dispatch a event with context, which is specified at the last parameter.
	   *
	   * @param {string} type The event name.
	   */
	  triggerWithContext: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 4) {
	        args = arrySlice.call(args, 1, args.length - 1);
	      }
	
	      var ctx = args[args.length - 1];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(ctx);
	            break;
	
	          case 2:
	            hItem.h.call(ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  }
	};
	
	function normalizeQuery(host, query) {
	  var eventProcessor = host._$eventProcessor;
	
	  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
	    query = eventProcessor.normalizeQuery(query);
	  }
	
	  return query;
	}
	
	function on(eventful, event, query, handler, context, isOnce) {
	  var _h = eventful._$handlers;
	
	  if (typeof query === 'function') {
	    context = handler;
	    handler = query;
	    query = null;
	  }
	
	  if (!handler || !event) {
	    return eventful;
	  }
	
	  query = normalizeQuery(eventful, query);
	
	  if (!_h[event]) {
	    _h[event] = [];
	  }
	
	  for (var i = 0; i < _h[event].length; i++) {
	    if (_h[event][i].h === handler) {
	      return eventful;
	    }
	  }
	
	  var wrap = {
	    h: handler,
	    one: isOnce,
	    query: query,
	    ctx: context || eventful,
	    // FIXME
	    // Do not publish this feature util it is proved that it makes sense.
	    callAtLast: handler.zrEventfulCallAtLast
	  };
	  var lastIndex = _h[event].length - 1;
	  var lastWrap = _h[event][lastIndex];
	  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
	  return eventful;
	} // ----------------------
	// The events in zrender
	// ----------------------
	
	/**
	 * @event module:zrender/mixin/Eventful#onclick
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseout
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousemove
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousewheel
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousedown
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseup
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrag
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragstart
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragend
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragenter
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragleave
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrop
	 * @type {Function}
	 * @default null
	 */
	
	
	var _default = Eventful;
	module.exports = _default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var Eventful = __webpack_require__(138);
	
	exports.Dispatcher = Eventful;
	
	var env = __webpack_require__(133);
	
	/**
	 * 事件辅助类
	 * @module zrender/core/event
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
	var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	
	function getBoundingClientRect(el) {
	  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect
	  return el.getBoundingClientRect ? el.getBoundingClientRect() : {
	    left: 0,
	    top: 0
	  };
	} // `calculate` is optional, default false
	
	
	function clientToLocal(el, e, out, calculate) {
	  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
	  // to the padding edge of the target element. The only browser using this convention
	  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
	  // not support the properties.
	  // (see http://www.jacklmoore.com/notes/mouse-position/)
	  // In zr painter.dom, padding edge equals to border edge.
	  // FIXME
	  // When mousemove event triggered on ec tooltip, target is not zr painter.dom, and
	  // offsetX/Y is relative to e.target, where the calculation of zrX/Y via offsetX/Y
	  // is too complex. So css-transfrom dont support in this case temporarily.
	
	  if (calculate || !env.canvasSupported) {
	    defaultGetZrXY(el, e, out);
	  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
	  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
	  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
	  // zoom-factor, overflow / opacity layers, transforms ...)
	  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
	  // <https://bugs.jquery.com/ticket/8523#comment:14>
	  // BTW3, In ff, offsetX/offsetY is always 0.
	  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
	      out.zrX = e.layerX;
	      out.zrY = e.layerY;
	    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
	    else if (e.offsetX != null) {
	        out.zrX = e.offsetX;
	        out.zrY = e.offsetY;
	      } // For some other device, e.g., IOS safari.
	      else {
	          defaultGetZrXY(el, e, out);
	        }
	
	  return out;
	}
	
	function defaultGetZrXY(el, e, out) {
	  // This well-known method below does not support css transform.
	  var box = getBoundingClientRect(el);
	  out.zrX = e.clientX - box.left;
	  out.zrY = e.clientY - box.top;
	}
	/**
	 * 如果存在第三方嵌入的一些dom触发的事件，或touch事件，需要转换一下事件坐标.
	 * `calculate` is optional, default false.
	 */
	
	
	function normalizeEvent(el, e, calculate) {
	  e = e || window.event;
	
	  if (e.zrX != null) {
	    return e;
	  }
	
	  var eventType = e.type;
	  var isTouch = eventType && eventType.indexOf('touch') >= 0;
	
	  if (!isTouch) {
	    clientToLocal(el, e, e, calculate);
	    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	  } else {
	    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
	    touch && clientToLocal(el, touch, e, calculate);
	  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
	  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
	  // If e.which has been defined, if may be readonly,
	  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
	
	
	  var button = e.button;
	
	  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  } // [Caution]: `e.which` from browser is not always reliable. For example,
	  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
	  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
	  // `mousedown (pointerdown)` is the same as Chrome does.
	
	
	  return e;
	}
	/**
	 * @param {HTMLElement} el
	 * @param {string} name
	 * @param {Function} handler
	 */
	
	
	function addEventListener(el, name, handler) {
	  if (isDomLevel2) {
	    // Reproduct the console warning:
	    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
	    // Consider marking event handler as 'passive' to make the page more responsive.
	    // Just set console log level: verbose in chrome dev tool.
	    // then the warning log will be printed when addEventListener called.
	    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	    // We have not yet found a neat way to using passive. Because in zrender the dom event
	    // listener delegate all of the upper events of element. Some of those events need
	    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
	    // Before passive can be adopted, these issues should be considered:
	    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
	    // passive or not.
	    // (2) How to tread that some zrender event listener is passive, and some is not. If
	    // we use other way but not preventDefault of mousewheel and touchmove, browser
	    // compatibility should be handled.
	    // var opts = (env.passiveSupported && name === 'mousewheel')
	    //     ? {passive: true}
	    //     // By default, the third param of el.addEventListener is `capture: false`.
	    //     : void 0;
	    // el.addEventListener(name, handler /* , opts */);
	    el.addEventListener(name, handler);
	  } else {
	    el.attachEvent('on' + name, handler);
	  }
	}
	
	function removeEventListener(el, name, handler) {
	  if (isDomLevel2) {
	    el.removeEventListener(name, handler);
	  } else {
	    el.detachEvent('on' + name, handler);
	  }
	}
	/**
	 * preventDefault and stopPropagation.
	 * Notice: do not do that in zrender. Upper application
	 * do that if necessary.
	 *
	 * @memberOf module:zrender/core/event
	 * @method
	 * @param {Event} e : event对象
	 */
	
	
	var stop = isDomLevel2 ? function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  e.cancelBubble = true;
	} : function (e) {
	  e.returnValue = false;
	  e.cancelBubble = true;
	};
	/**
	 * This method only works for mouseup and mousedown. The functionality is restricted
	 * for fault tolerance, See the `e.which` compatibility above.
	 *
	 * @param {MouseEvent} e
	 * @return {boolean}
	 */
	
	function isMiddleOrRightButtonOnMouseUpDown(e) {
	  return e.which === 2 || e.which === 3;
	}
	/**
	 * To be removed.
	 * @deprecated
	 */
	
	
	function notLeftMouse(e) {
	  // If e.which is undefined, considered as left mouse event.
	  return e.which > 1;
	} // 做向上兼容
	
	
	exports.clientToLocal = clientToLocal;
	exports.normalizeEvent = normalizeEvent;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.stop = stop;
	exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
	exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var eventUtil = __webpack_require__(139);
	
	/**
	 * Only implements needed gestures for mobile.
	 */
	var GestureMgr = function () {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  this._track = [];
	};
	
	GestureMgr.prototype = {
	  constructor: GestureMgr,
	  recognize: function (event, target, root) {
	    this._doTrack(event, target, root);
	
	    return this._recognize(event);
	  },
	  clear: function () {
	    this._track.length = 0;
	    return this;
	  },
	  _doTrack: function (event, target, root) {
	    var touches = event.touches;
	
	    if (!touches) {
	      return;
	    }
	
	    var trackItem = {
	      points: [],
	      touches: [],
	      target: target,
	      event: event
	    };
	
	    for (var i = 0, len = touches.length; i < len; i++) {
	      var touch = touches[i];
	      var pos = eventUtil.clientToLocal(root, touch, {});
	      trackItem.points.push([pos.zrX, pos.zrY]);
	      trackItem.touches.push(touch);
	    }
	
	    this._track.push(trackItem);
	  },
	  _recognize: function (event) {
	    for (var eventName in recognizers) {
	      if (recognizers.hasOwnProperty(eventName)) {
	        var gestureInfo = recognizers[eventName](this._track, event);
	
	        if (gestureInfo) {
	          return gestureInfo;
	        }
	      }
	    }
	  }
	};
	
	function dist(pointPair) {
	  var dx = pointPair[1][0] - pointPair[0][0];
	  var dy = pointPair[1][1] - pointPair[0][1];
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function center(pointPair) {
	  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
	}
	
	var recognizers = {
	  pinch: function (track, event) {
	    var trackLen = track.length;
	
	    if (!trackLen) {
	      return;
	    }
	
	    var pinchEnd = (track[trackLen - 1] || {}).points;
	    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
	
	    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
	      var pinchScale = dist(pinchEnd) / dist(pinchPre);
	      !isFinite(pinchScale) && (pinchScale = 1);
	      event.pinchScale = pinchScale;
	      var pinchCenter = center(pinchEnd);
	      event.pinchX = pinchCenter[0];
	      event.pinchY = pinchCenter[1];
	      return {
	        type: 'pinch',
	        target: track[0].target,
	        event: event
	      };
	    }
	  } // Only pinch currently.
	
	};
	var _default = GestureMgr;
	module.exports = _default;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var Group = __webpack_require__(142);
	
	var timsort = __webpack_require__(155);
	
	// Use timsort because in most case elements are partially sorted
	// https://jsfiddle.net/pissang/jr4x7mdm/8/
	function shapeCompareFunc(a, b) {
	  if (a.zlevel === b.zlevel) {
	    if (a.z === b.z) {
	      // if (a.z2 === b.z2) {
	      //     // FIXME Slow has renderidx compare
	      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
	      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
	      //     return a.__renderidx - b.__renderidx;
	      // }
	      return a.z2 - b.z2;
	    }
	
	    return a.z - b.z;
	  }
	
	  return a.zlevel - b.zlevel;
	}
	/**
	 * 内容仓库 (M)
	 * @alias module:zrender/Storage
	 * @constructor
	 */
	
	
	var Storage = function () {
	  // jshint ignore:line
	  this._roots = [];
	  this._displayList = [];
	  this._displayListLen = 0;
	};
	
	Storage.prototype = {
	  constructor: Storage,
	
	  /**
	   * @param  {Function} cb
	   *
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._roots.length; i++) {
	      this._roots[i].traverse(cb, context);
	    }
	  },
	
	  /**
	   * 返回所有图形的绘制队列
	   * @param {boolean} [update=false] 是否在返回前更新该数组
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
	   *
	   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
	   * @return {Array.<module:zrender/graphic/Displayable>}
	   */
	  getDisplayList: function (update, includeIgnore) {
	    includeIgnore = includeIgnore || false;
	
	    if (update) {
	      this.updateDisplayList(includeIgnore);
	    }
	
	    return this._displayList;
	  },
	
	  /**
	   * 更新图形的绘制队列。
	   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
	   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
	   */
	  updateDisplayList: function (includeIgnore) {
	    this._displayListLen = 0;
	    var roots = this._roots;
	    var displayList = this._displayList;
	
	    for (var i = 0, len = roots.length; i < len; i++) {
	      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	    }
	
	    displayList.length = this._displayListLen;
	    env.canvasSupported && timsort(displayList, shapeCompareFunc);
	  },
	  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
	    if (el.ignore && !includeIgnore) {
	      return;
	    }
	
	    el.beforeUpdate();
	
	    if (el.__dirty) {
	      el.update();
	    }
	
	    el.afterUpdate();
	    var userSetClipPath = el.clipPath;
	
	    if (userSetClipPath) {
	      // FIXME 效率影响
	      if (clipPaths) {
	        clipPaths = clipPaths.slice();
	      } else {
	        clipPaths = [];
	      }
	
	      var currentClipPath = userSetClipPath;
	      var parentClipPath = el; // Recursively add clip path
	
	      while (currentClipPath) {
	        // clipPath 的变换是基于使用这个 clipPath 的元素
	        currentClipPath.parent = parentClipPath;
	        currentClipPath.updateTransform();
	        clipPaths.push(currentClipPath);
	        parentClipPath = currentClipPath;
	        currentClipPath = currentClipPath.clipPath;
	      }
	    }
	
	    if (el.isGroup) {
	      var children = el._children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i]; // Force to mark as dirty if group is dirty
	        // FIXME __dirtyPath ?
	
	        if (el.__dirty) {
	          child.__dirty = true;
	        }
	
	        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	      } // Mark group clean here
	
	
	      el.__dirty = false;
	    } else {
	      el.__clipPaths = clipPaths;
	      this._displayList[this._displayListLen++] = el;
	    }
	  },
	
	  /**
	   * 添加图形(Shape)或者组(Group)到根节点
	   * @param {module:zrender/Element} el
	   */
	  addRoot: function (el) {
	    if (el.__storage === this) {
	      return;
	    }
	
	    if (el instanceof Group) {
	      el.addChildrenToStorage(this);
	    }
	
	    this.addToStorage(el);
	
	    this._roots.push(el);
	  },
	
	  /**
	   * 删除指定的图形(Shape)或者组(Group)
	   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
	   */
	  delRoot: function (el) {
	    if (el == null) {
	      // 不指定el清空
	      for (var i = 0; i < this._roots.length; i++) {
	        var root = this._roots[i];
	
	        if (root instanceof Group) {
	          root.delChildrenFromStorage(this);
	        }
	      }
	
	      this._roots = [];
	      this._displayList = [];
	      this._displayListLen = 0;
	      return;
	    }
	
	    if (el instanceof Array) {
	      for (var i = 0, l = el.length; i < l; i++) {
	        this.delRoot(el[i]);
	      }
	
	      return;
	    }
	
	    var idx = util.indexOf(this._roots, el);
	
	    if (idx >= 0) {
	      this.delFromStorage(el);
	
	      this._roots.splice(idx, 1);
	
	      if (el instanceof Group) {
	        el.delChildrenFromStorage(this);
	      }
	    }
	  },
	  addToStorage: function (el) {
	    if (el) {
	      el.__storage = this;
	      el.dirty(false);
	    }
	
	    return this;
	  },
	  delFromStorage: function (el) {
	    if (el) {
	      el.__storage = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清空并且释放Storage
	   */
	  dispose: function () {
	    this._renderList = this._roots = null;
	  },
	  displayableSortFunc: shapeCompareFunc
	};
	var _default = Storage;
	module.exports = _default;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(134);
	
	var Element = __webpack_require__(143);
	
	var BoundingRect = __webpack_require__(154);
	
	/**
	 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
	 * @module zrender/graphic/Group
	 * @example
	 *     var Group = require('zrender/container/Group');
	 *     var Circle = require('zrender/graphic/shape/Circle');
	 *     var g = new Group();
	 *     g.position[0] = 100;
	 *     g.position[1] = 100;
	 *     g.add(new Circle({
	 *         style: {
	 *             x: 100,
	 *             y: 100,
	 *             r: 20,
	 *         }
	 *     }));
	 *     zr.add(g);
	 */
	
	/**
	 * @alias module:zrender/graphic/Group
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @extends module:zrender/mixin/Eventful
	 */
	var Group = function (opts) {
	  opts = opts || {};
	  Element.call(this, opts);
	
	  for (var key in opts) {
	    if (opts.hasOwnProperty(key)) {
	      this[key] = opts[key];
	    }
	  }
	
	  this._children = [];
	  this.__storage = null;
	  this.__dirty = true;
	};
	
	Group.prototype = {
	  constructor: Group,
	  isGroup: true,
	
	  /**
	   * @type {string}
	   */
	  type: 'group',
	
	  /**
	   * 所有子孙元素是否响应鼠标事件
	   * @name module:/zrender/container/Group#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * @return {Array.<module:zrender/Element>}
	   */
	  children: function () {
	    return this._children.slice();
	  },
	
	  /**
	   * 获取指定 index 的儿子节点
	   * @param  {number} idx
	   * @return {module:zrender/Element}
	   */
	  childAt: function (idx) {
	    return this._children[idx];
	  },
	
	  /**
	   * 获取指定名字的儿子节点
	   * @param  {string} name
	   * @return {module:zrender/Element}
	   */
	  childOfName: function (name) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].name === name) {
	        return children[i];
	      }
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  childCount: function () {
	    return this._children.length;
	  },
	
	  /**
	   * 添加子节点到最后
	   * @param {module:zrender/Element} child
	   */
	  add: function (child) {
	    if (child && child !== this && child.parent !== this) {
	      this._children.push(child);
	
	      this._doAdd(child);
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加子节点在 nextSibling 之前
	   * @param {module:zrender/Element} child
	   * @param {module:zrender/Element} nextSibling
	   */
	  addBefore: function (child, nextSibling) {
	    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
	      var children = this._children;
	      var idx = children.indexOf(nextSibling);
	
	      if (idx >= 0) {
	        children.splice(idx, 0, child);
	
	        this._doAdd(child);
	      }
	    }
	
	    return this;
	  },
	  _doAdd: function (child) {
	    if (child.parent) {
	      child.parent.remove(child);
	    }
	
	    child.parent = this;
	    var storage = this.__storage;
	    var zr = this.__zr;
	
	    if (storage && storage !== child.__storage) {
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	  },
	
	  /**
	   * 移除子节点
	   * @param {module:zrender/Element} child
	   */
	  remove: function (child) {
	    var zr = this.__zr;
	    var storage = this.__storage;
	    var children = this._children;
	    var idx = zrUtil.indexOf(children, child);
	
	    if (idx < 0) {
	      return this;
	    }
	
	    children.splice(idx, 1);
	    child.parent = null;
	
	    if (storage) {
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	    return this;
	  },
	
	  /**
	   * 移除所有子节点
	   */
	  removeAll: function () {
	    var children = this._children;
	    var storage = this.__storage;
	    var child;
	    var i;
	
	    for (i = 0; i < children.length; i++) {
	      child = children[i];
	
	      if (storage) {
	        storage.delFromStorage(child);
	
	        if (child instanceof Group) {
	          child.delChildrenFromStorage(storage);
	        }
	      }
	
	      child.parent = null;
	    }
	
	    children.length = 0;
	    return this;
	  },
	
	  /**
	   * 遍历所有子节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  eachChild: function (cb, context) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      cb.call(context, child, i);
	    }
	
	    return this;
	  },
	
	  /**
	   * 深度优先遍历所有子孙节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      cb.call(context, child);
	
	      if (child.type === 'group') {
	        child.traverse(cb, context);
	      }
	    }
	
	    return this;
	  },
	  addChildrenToStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	  },
	  delChildrenFromStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	  },
	  dirty: function () {
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh();
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function (includeChildren) {
	    // TODO Caching
	    var rect = null;
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var children = includeChildren || this._children;
	    var tmpMat = [];
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	
	      if (child.ignore || child.invisible) {
	        continue;
	      }
	
	      var childRect = child.getBoundingRect();
	      var transform = child.getLocalTransform(tmpMat); // TODO
	      // The boundingRect cacluated by transforming original
	      // rect may be bigger than the actual bundingRect when rotation
	      // is used. (Consider a circle rotated aginst its center, where
	      // the actual boundingRect should be the same as that not be
	      // rotated.) But we can not find better approach to calculate
	      // actual boundingRect yet, considering performance.
	
	      if (transform) {
	        tmpRect.copy(childRect);
	        tmpRect.applyTransform(transform);
	        rect = rect || tmpRect.clone();
	        rect.union(tmpRect);
	      } else {
	        rect = rect || childRect.clone();
	        rect.union(childRect);
	      }
	    }
	
	    return rect || tmpRect;
	  }
	};
	zrUtil.inherits(Group, Element);
	var _default = Group;
	module.exports = _default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(132);
	
	var Eventful = __webpack_require__(138);
	
	var Transformable = __webpack_require__(144);
	
	var Animatable = __webpack_require__(146);
	
	var zrUtil = __webpack_require__(134);
	
	/**
	 * @alias module:zrender/Element
	 * @constructor
	 * @extends {module:zrender/mixin/Animatable}
	 * @extends {module:zrender/mixin/Transformable}
	 * @extends {module:zrender/mixin/Eventful}
	 */
	var Element = function (opts) {
	  // jshint ignore:line
	  Transformable.call(this, opts);
	  Eventful.call(this, opts);
	  Animatable.call(this, opts);
	  /**
	   * 画布元素ID
	   * @type {string}
	   */
	
	  this.id = opts.id || guid();
	};
	
	Element.prototype = {
	  /**
	   * 元素类型
	   * Element type
	   * @type {string}
	   */
	  type: 'element',
	
	  /**
	   * 元素名字
	   * Element name
	   * @type {string}
	   */
	  name: '',
	
	  /**
	   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
	   * ZRender instance will be assigned when element is associated with zrender
	   * @name module:/zrender/Element#__zr
	   * @type {module:zrender/ZRender}
	   */
	  __zr: null,
	
	  /**
	   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
	   * If ignore drawing and events of the element object
	   * @name module:/zrender/Element#ignore
	   * @type {boolean}
	   * @default false
	   */
	  ignore: false,
	
	  /**
	   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
	   * 该路径会继承被裁减对象的变换
	   * @type {module:zrender/graphic/Path}
	   * @see http://www.w3.org/TR/2dcontext/#clipping-region
	   * @readOnly
	   */
	  clipPath: null,
	
	  /**
	   * 是否是 Group
	   * @type {boolean}
	   */
	  isGroup: false,
	
	  /**
	   * Drift element
	   * @param  {number} dx dx on the global space
	   * @param  {number} dy dy on the global space
	   */
	  drift: function (dx, dy) {
	    switch (this.draggable) {
	      case 'horizontal':
	        dy = 0;
	        break;
	
	      case 'vertical':
	        dx = 0;
	        break;
	    }
	
	    var m = this.transform;
	
	    if (!m) {
	      m = this.transform = [1, 0, 0, 1, 0, 0];
	    }
	
	    m[4] += dx;
	    m[5] += dy;
	    this.decomposeTransform();
	    this.dirty(false);
	  },
	
	  /**
	   * Hook before update
	   */
	  beforeUpdate: function () {},
	
	  /**
	   * Hook after update
	   */
	  afterUpdate: function () {},
	
	  /**
	   * Update each frame
	   */
	  update: function () {
	    this.updateTransform();
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {},
	
	  /**
	   * @protected
	   */
	  attrKV: function (key, value) {
	    if (key === 'position' || key === 'scale' || key === 'origin') {
	      // Copy the array
	      if (value) {
	        var target = this[key];
	
	        if (!target) {
	          target = this[key] = [];
	        }
	
	        target[0] = value[0];
	        target[1] = value[1];
	      }
	    } else {
	      this[key] = value;
	    }
	  },
	
	  /**
	   * Hide the element
	   */
	  hide: function () {
	    this.ignore = true;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * Show the element
	   */
	  show: function () {
	    this.ignore = false;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * @param {string|Object} key
	   * @param {*} value
	   */
	  attr: function (key, value) {
	    if (typeof key === 'string') {
	      this.attrKV(key, value);
	    } else if (zrUtil.isObject(key)) {
	      for (var name in key) {
	        if (key.hasOwnProperty(name)) {
	          this.attrKV(name, key[name]);
	        }
	      }
	    }
	
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * @param {module:zrender/graphic/Path} clipPath
	   */
	  setClipPath: function (clipPath) {
	    var zr = this.__zr;
	
	    if (zr) {
	      clipPath.addSelfToZr(zr);
	    } // Remove previous clip path
	
	
	    if (this.clipPath && this.clipPath !== clipPath) {
	      this.removeClipPath();
	    }
	
	    this.clipPath = clipPath;
	    clipPath.__zr = zr;
	    clipPath.__clipTarget = this;
	    this.dirty(false);
	  },
	
	  /**
	   */
	  removeClipPath: function () {
	    var clipPath = this.clipPath;
	
	    if (clipPath) {
	      if (clipPath.__zr) {
	        clipPath.removeSelfFromZr(clipPath.__zr);
	      }
	
	      clipPath.__zr = null;
	      clipPath.__clipTarget = null;
	      this.clipPath = null;
	      this.dirty(false);
	    }
	  },
	
	  /**
	   * Add self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  addSelfToZr: function (zr) {
	    this.__zr = zr; // 添加动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.addAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.addSelfToZr(zr);
	    }
	  },
	
	  /**
	   * Remove self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  removeSelfFromZr: function (zr) {
	    this.__zr = null; // 移除动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.removeAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.removeSelfFromZr(zr);
	    }
	  }
	};
	zrUtil.mixin(Element, Animatable);
	zrUtil.mixin(Element, Transformable);
	zrUtil.mixin(Element, Eventful);
	var _default = Element;
	module.exports = _default;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var matrix = __webpack_require__(145);
	
	var vector = __webpack_require__(136);
	
	/**
	 * 提供变换扩展
	 * @module zrender/mixin/Transformable
	 * @author pissang (https://www.github.com/pissang)
	 */
	var mIdentity = matrix.identity;
	var EPSILON = 5e-5;
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * @alias module:zrender/mixin/Transformable
	 * @constructor
	 */
	
	
	var Transformable = function (opts) {
	  opts = opts || {}; // If there are no given position, rotation, scale
	
	  if (!opts.position) {
	    /**
	     * 平移
	     * @type {Array.<number>}
	     * @default [0, 0]
	     */
	    this.position = [0, 0];
	  }
	
	  if (opts.rotation == null) {
	    /**
	     * 旋转
	     * @type {Array.<number>}
	     * @default 0
	     */
	    this.rotation = 0;
	  }
	
	  if (!opts.scale) {
	    /**
	     * 缩放
	     * @type {Array.<number>}
	     * @default [1, 1]
	     */
	    this.scale = [1, 1];
	  }
	  /**
	   * 旋转和缩放的原点
	   * @type {Array.<number>}
	   * @default null
	   */
	
	
	  this.origin = this.origin || null;
	};
	
	var transformableProto = Transformable.prototype;
	transformableProto.transform = null;
	/**
	 * 判断是否需要有坐标变换
	 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
	 */
	
	transformableProto.needLocalTransform = function () {
	  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
	};
	
	var scaleTmp = [];
	
	transformableProto.updateTransform = function () {
	  var parent = this.parent;
	  var parentHasTransform = parent && parent.transform;
	  var needLocalTransform = this.needLocalTransform();
	  var m = this.transform;
	
	  if (!(needLocalTransform || parentHasTransform)) {
	    m && mIdentity(m);
	    return;
	  }
	
	  m = m || matrix.create();
	
	  if (needLocalTransform) {
	    this.getLocalTransform(m);
	  } else {
	    mIdentity(m);
	  } // 应用父节点变换
	
	
	  if (parentHasTransform) {
	    if (needLocalTransform) {
	      matrix.mul(m, parent.transform, m);
	    } else {
	      matrix.copy(m, parent.transform);
	    }
	  } // 保存这个变换矩阵
	
	
	  this.transform = m;
	  var globalScaleRatio = this.globalScaleRatio;
	
	  if (globalScaleRatio != null && globalScaleRatio !== 1) {
	    this.getGlobalScale(scaleTmp);
	    var relX = scaleTmp[0] < 0 ? -1 : 1;
	    var relY = scaleTmp[1] < 0 ? -1 : 1;
	    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
	    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
	    m[0] *= sx;
	    m[1] *= sx;
	    m[2] *= sy;
	    m[3] *= sy;
	  }
	
	  this.invTransform = this.invTransform || matrix.create();
	  matrix.invert(this.invTransform, m);
	};
	
	transformableProto.getLocalTransform = function (m) {
	  return Transformable.getLocalTransform(this, m);
	};
	/**
	 * 将自己的transform应用到context上
	 * @param {CanvasRenderingContext2D} ctx
	 */
	
	
	transformableProto.setTransform = function (ctx) {
	  var m = this.transform;
	  var dpr = ctx.dpr || 1;
	
	  if (m) {
	    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	  } else {
	    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	  }
	};
	
	transformableProto.restoreTransform = function (ctx) {
	  var dpr = ctx.dpr || 1;
	  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};
	
	var tmpTransform = [];
	var originTransform = matrix.create();
	
	transformableProto.setLocalTransform = function (m) {
	  if (!m) {
	    // TODO return or set identity?
	    return;
	  }
	
	  var sx = m[0] * m[0] + m[1] * m[1];
	  var sy = m[2] * m[2] + m[3] * m[3];
	  var position = this.position;
	  var scale = this.scale;
	
	  if (isNotAroundZero(sx - 1)) {
	    sx = Math.sqrt(sx);
	  }
	
	  if (isNotAroundZero(sy - 1)) {
	    sy = Math.sqrt(sy);
	  }
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  position[0] = m[4];
	  position[1] = m[5];
	  scale[0] = sx;
	  scale[1] = sy;
	  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
	};
	/**
	 * 分解`transform`矩阵到`position`, `rotation`, `scale`
	 */
	
	
	transformableProto.decomposeTransform = function () {
	  if (!this.transform) {
	    return;
	  }
	
	  var parent = this.parent;
	  var m = this.transform;
	
	  if (parent && parent.transform) {
	    // Get local transform and decompose them to position, scale, rotation
	    matrix.mul(tmpTransform, parent.invTransform, m);
	    m = tmpTransform;
	  }
	
	  var origin = this.origin;
	
	  if (origin && (origin[0] || origin[1])) {
	    originTransform[4] = origin[0];
	    originTransform[5] = origin[1];
	    matrix.mul(tmpTransform, m, originTransform);
	    tmpTransform[4] -= origin[0];
	    tmpTransform[5] -= origin[1];
	    m = tmpTransform;
	  }
	
	  this.setLocalTransform(m);
	};
	/**
	 * Get global scale
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.getGlobalScale = function (out) {
	  var m = this.transform;
	  out = out || [];
	
	  if (!m) {
	    out[0] = 1;
	    out[1] = 1;
	    return out;
	  }
	
	  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	
	  if (m[0] < 0) {
	    out[0] = -out[0];
	  }
	
	  if (m[3] < 0) {
	    out[1] = -out[1];
	  }
	
	  return out;
	};
	/**
	 * 变换坐标位置到 shape 的局部坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToLocal = function (x, y) {
	  var v2 = [x, y];
	  var invTransform = this.invTransform;
	
	  if (invTransform) {
	    vector.applyTransform(v2, v2, invTransform);
	  }
	
	  return v2;
	};
	/**
	 * 变换局部坐标位置到全局坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToGlobal = function (x, y) {
	  var v2 = [x, y];
	  var transform = this.transform;
	
	  if (transform) {
	    vector.applyTransform(v2, v2, transform);
	  }
	
	  return v2;
	};
	/**
	 * @static
	 * @param {Object} target
	 * @param {Array.<number>} target.origin
	 * @param {number} target.rotation
	 * @param {Array.<number>} target.position
	 * @param {Array.<number>} [m]
	 */
	
	
	Transformable.getLocalTransform = function (target, m) {
	  m = m || [];
	  mIdentity(m);
	  var origin = target.origin;
	  var scale = target.scale || [1, 1];
	  var rotation = target.rotation || 0;
	  var position = target.position || [0, 0];
	
	  if (origin) {
	    // Translate to origin
	    m[4] -= origin[0];
	    m[5] -= origin[1];
	  }
	
	  matrix.scale(m, m, scale);
	
	  if (rotation) {
	    matrix.rotate(m, m, rotation);
	  }
	
	  if (origin) {
	    // Translate back from origin
	    m[4] += origin[0];
	    m[5] += origin[1];
	  }
	
	  m[4] += position[0];
	  m[5] += position[1];
	  return m;
	};
	
	var _default = Transformable;
	module.exports = _default;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/**
	 * 3x2矩阵操作类
	 * @exports zrender/tool/matrix
	 */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * Create a identity matrix.
	 * @return {Float32Array|Array.<number>}
	 */
	
	function create() {
	  var out = new ArrayCtor(6);
	  identity(out);
	  return out;
	}
	/**
	 * 设置矩阵为单位矩阵
	 * @param {Float32Array|Array.<number>} out
	 */
	
	
	function identity(out) {
	  out[0] = 1;
	  out[1] = 0;
	  out[2] = 0;
	  out[3] = 1;
	  out[4] = 0;
	  out[5] = 0;
	  return out;
	}
	/**
	 * 复制矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m
	 */
	
	
	function copy(out, m) {
	  out[0] = m[0];
	  out[1] = m[1];
	  out[2] = m[2];
	  out[3] = m[3];
	  out[4] = m[4];
	  out[5] = m[5];
	  return out;
	}
	/**
	 * 矩阵相乘
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m1
	 * @param {Float32Array|Array.<number>} m2
	 */
	
	
	function mul(out, m1, m2) {
	  // Consider matrix.mul(m, m2, m);
	  // where out is the same as m2.
	  // So use temp variable to escape error.
	  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	  out[0] = out0;
	  out[1] = out1;
	  out[2] = out2;
	  out[3] = out3;
	  out[4] = out4;
	  out[5] = out5;
	  return out;
	}
	/**
	 * 平移变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function translate(out, a, v) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  out[4] = a[4] + v[0];
	  out[5] = a[5] + v[1];
	  return out;
	}
	/**
	 * 旋转变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {number} rad
	 */
	
	
	function rotate(out, a, rad) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var st = Math.sin(rad);
	  var ct = Math.cos(rad);
	  out[0] = aa * ct + ab * st;
	  out[1] = -aa * st + ab * ct;
	  out[2] = ac * ct + ad * st;
	  out[3] = -ac * st + ct * ad;
	  out[4] = ct * atx + st * aty;
	  out[5] = ct * aty - st * atx;
	  return out;
	}
	/**
	 * 缩放变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function scale(out, a, v) {
	  var vx = v[0];
	  var vy = v[1];
	  out[0] = a[0] * vx;
	  out[1] = a[1] * vy;
	  out[2] = a[2] * vx;
	  out[3] = a[3] * vy;
	  out[4] = a[4] * vx;
	  out[5] = a[5] * vy;
	  return out;
	}
	/**
	 * 求逆矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function invert(out, a) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var det = aa * ad - ab * ac;
	
	  if (!det) {
	    return null;
	  }
	
	  det = 1.0 / det;
	  out[0] = ad * det;
	  out[1] = -ab * det;
	  out[2] = -ac * det;
	  out[3] = aa * det;
	  out[4] = (ac * aty - ad * atx) * det;
	  out[5] = (ab * atx - aa * aty) * det;
	  return out;
	}
	/**
	 * Clone a new matrix.
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function clone(a) {
	  var b = create();
	  copy(b, a);
	  return b;
	}
	
	exports.create = create;
	exports.identity = identity;
	exports.copy = copy;
	exports.mul = mul;
	exports.translate = translate;
	exports.rotate = rotate;
	exports.scale = scale;
	exports.invert = invert;
	exports.clone = clone;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var Animator = __webpack_require__(147);
	
	var log = __webpack_require__(152);
	
	var _util = __webpack_require__(134);
	
	var isString = _util.isString;
	var isFunction = _util.isFunction;
	var isObject = _util.isObject;
	var isArrayLike = _util.isArrayLike;
	var indexOf = _util.indexOf;
	
	/**
	 * @alias modue:zrender/mixin/Animatable
	 * @constructor
	 */
	var Animatable = function () {
	  /**
	   * @type {Array.<module:zrender/animation/Animator>}
	   * @readOnly
	   */
	  this.animators = [];
	};
	
	Animatable.prototype = {
	  constructor: Animatable,
	
	  /**
	   * 动画
	   *
	   * @param {string} path The path to fetch value from object, like 'a.b.c'.
	   * @param {boolean} [loop] Whether to loop animation.
	   * @return {module:zrender/animation/Animator}
	   * @example:
	   *     el.animate('style', false)
	   *         .when(1000, {x: 10} )
	   *         .done(function(){ // Animation done })
	   *         .start()
	   */
	  animate: function (path, loop) {
	    var target;
	    var animatingShape = false;
	    var el = this;
	    var zr = this.__zr;
	
	    if (path) {
	      var pathSplitted = path.split('.');
	      var prop = el; // If animating shape
	
	      animatingShape = pathSplitted[0] === 'shape';
	
	      for (var i = 0, l = pathSplitted.length; i < l; i++) {
	        if (!prop) {
	          continue;
	        }
	
	        prop = prop[pathSplitted[i]];
	      }
	
	      if (prop) {
	        target = prop;
	      }
	    } else {
	      target = el;
	    }
	
	    if (!target) {
	      log('Property "' + path + '" is not existed in element ' + el.id);
	      return;
	    }
	
	    var animators = el.animators;
	    var animator = new Animator(target, loop);
	    animator.during(function (target) {
	      el.dirty(animatingShape);
	    }).done(function () {
	      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
	      animators.splice(indexOf(animators, animator), 1);
	    });
	    animators.push(animator); // If animate after added to the zrender
	
	    if (zr) {
	      zr.animation.addAnimator(animator);
	    }
	
	    return animator;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stopAnimation: function (forwardToLast) {
	    var animators = this.animators;
	    var len = animators.length;
	
	    for (var i = 0; i < len; i++) {
	      animators[i].stop(forwardToLast);
	    }
	
	    animators.length = 0;
	    return this;
	  },
	
	  /**
	   * Caution: this method will stop previous animation.
	   * So do not use this method to one element twice before
	   * animation starts, unless you know what you are doing.
	   * @param {Object} target
	   * @param {number} [time=500] Time in ms
	   * @param {string} [easing='linear']
	   * @param {number} [delay=0]
	   * @param {Function} [callback]
	   * @param {Function} [forceAnimate] Prevent stop animation and callback
	   *        immediently when target values are the same as current values.
	   *
	   * @example
	   *  // Animate position
	   *  el.animateTo({
	   *      position: [10, 10]
	   *  }, function () { // done })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
	   *  el.animateTo({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100, 'cubicOut', function () { // done })
	   */
	  // TODO Return animation key
	  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate);
	  },
	
	  /**
	   * Animate from the target state to current state.
	   * The params and the return value are the same as `this.animateTo`.
	   */
	  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
	  }
	};
	
	function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
	  // animateTo(target, time, easing, callback);
	  if (isString(delay)) {
	    callback = easing;
	    easing = delay;
	    delay = 0;
	  } // animateTo(target, time, delay, callback);
	  else if (isFunction(easing)) {
	      callback = easing;
	      easing = 'linear';
	      delay = 0;
	    } // animateTo(target, time, callback);
	    else if (isFunction(delay)) {
	        callback = delay;
	        delay = 0;
	      } // animateTo(target, callback)
	      else if (isFunction(time)) {
	          callback = time;
	          time = 500;
	        } // animateTo(target)
	        else if (!time) {
	            time = 500;
	          } // Stop all previous animations
	
	
	  animatable.stopAnimation();
	  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
	  // if there is nothing to animate
	
	  var animators = animatable.animators.slice();
	  var count = animators.length;
	
	  function done() {
	    count--;
	
	    if (!count) {
	      callback && callback();
	    }
	  } // No animators. This should be checked before animators[i].start(),
	  // because 'done' may be executed immediately if no need to animate.
	
	
	  if (!count) {
	    callback && callback();
	  } // Start after all animators created
	  // Incase any animator is done immediately when all animation properties are not changed
	
	
	  for (var i = 0; i < animators.length; i++) {
	    animators[i].done(done).start(easing, forceAnimate);
	  }
	}
	/**
	 * @param {string} path=''
	 * @param {Object} source=animatable
	 * @param {Object} target
	 * @param {number} [time=500]
	 * @param {number} [delay=0]
	 * @param {boolean} [reverse] If `true`, animate
	 *        from the `target` to current state.
	 *
	 * @example
	 *  // Animate position
	 *  el._animateToShallow({
	 *      position: [10, 10]
	 *  })
	 *
	 *  // Animate shape, style and position in 100ms, delayed 100ms
	 *  el._animateToShallow({
	 *      shape: {
	 *          width: 500
	 *      },
	 *      style: {
	 *          fill: 'red'
	 *      }
	 *      position: [10, 10]
	 *  }, 100, 100)
	 */
	
	
	function animateToShallow(animatable, path, source, target, time, delay, reverse) {
	  var objShallow = {};
	  var propertyCount = 0;
	
	  for (var name in target) {
	    if (!target.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (source[name] != null) {
	      if (isObject(target[name]) && !isArrayLike(target[name])) {
	        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
	      } else {
	        if (reverse) {
	          objShallow[name] = source[name];
	          setAttrByPath(animatable, path, name, target[name]);
	        } else {
	          objShallow[name] = target[name];
	        }
	
	        propertyCount++;
	      }
	    } else if (target[name] != null && !reverse) {
	      setAttrByPath(animatable, path, name, target[name]);
	    }
	  }
	
	  if (propertyCount > 0) {
	    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
	  }
	}
	
	function setAttrByPath(el, path, name, value) {
	  // Attr directly if not has property
	  // FIXME, if some property not needed for element ?
	  if (!path) {
	    el.attr(name, value);
	  } else {
	    // Only support set shape or style
	    var props = {};
	    props[path] = {};
	    props[path][name] = value;
	    el.attr(props);
	  }
	}
	
	var _default = Animatable;
	module.exports = _default;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var Clip = __webpack_require__(148);
	
	var color = __webpack_require__(150);
	
	var _util = __webpack_require__(134);
	
	var isArrayLike = _util.isArrayLike;
	
	/**
	 * @module echarts/animation/Animator
	 */
	var arraySlice = Array.prototype.slice;
	
	function defaultGetter(target, key) {
	  return target[key];
	}
	
	function defaultSetter(target, key, value) {
	  target[key] = value;
	}
	/**
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} percent
	 * @return {number}
	 */
	
	
	function interpolateNumber(p0, p1, percent) {
	  return (p1 - p0) * percent + p0;
	}
	/**
	 * @param  {string} p0
	 * @param  {string} p1
	 * @param  {number} percent
	 * @return {string}
	 */
	
	
	function interpolateString(p0, p1, percent) {
	  return percent > 0.5 ? p1 : p0;
	}
	/**
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {number} percent
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function interpolateArray(p0, p1, percent, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = interpolateNumber(p0[i], p1[i], percent);
	    }
	  } else {
	    var len2 = len && p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	      }
	    }
	  }
	} // arr0 is source array, arr1 is target array.
	// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
	
	
	function fillArr(arr0, arr1, arrDim) {
	  var arr0Len = arr0.length;
	  var arr1Len = arr1.length;
	
	  if (arr0Len !== arr1Len) {
	    // FIXME Not work for TypedArray
	    var isPreviousLarger = arr0Len > arr1Len;
	
	    if (isPreviousLarger) {
	      // Cut the previous
	      arr0.length = arr1Len;
	    } else {
	      // Fill the previous
	      for (var i = arr0Len; i < arr1Len; i++) {
	        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	      }
	    }
	  } // Handling NaN value
	
	
	  var len2 = arr0[0] && arr0[0].length;
	
	  for (var i = 0; i < arr0.length; i++) {
	    if (arrDim === 1) {
	      if (isNaN(arr0[i])) {
	        arr0[i] = arr1[i];
	      }
	    } else {
	      for (var j = 0; j < len2; j++) {
	        if (isNaN(arr0[i][j])) {
	          arr0[i][j] = arr1[i][j];
	        }
	      }
	    }
	  }
	}
	/**
	 * @param  {Array} arr0
	 * @param  {Array} arr1
	 * @param  {number} arrDim
	 * @return {boolean}
	 */
	
	
	function isArraySame(arr0, arr1, arrDim) {
	  if (arr0 === arr1) {
	    return true;
	  }
	
	  var len = arr0.length;
	
	  if (len !== arr1.length) {
	    return false;
	  }
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      if (arr0[i] !== arr1[i]) {
	        return false;
	      }
	    }
	  } else {
	    var len2 = arr0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        if (arr0[i][j] !== arr1[i][j]) {
	          return false;
	        }
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * Catmull Rom interpolate array
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {Array} p2
	 * @param  {Array} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
	    }
	  } else {
	    var len2 = p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
	      }
	    }
	  }
	}
	/**
	 * Catmull Rom interpolate number
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @return {number}
	 */
	
	
	function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	
	function cloneValue(value) {
	  if (isArrayLike(value)) {
	    var len = value.length;
	
	    if (isArrayLike(value[0])) {
	      var ret = [];
	
	      for (var i = 0; i < len; i++) {
	        ret.push(arraySlice.call(value[i]));
	      }
	
	      return ret;
	    }
	
	    return arraySlice.call(value);
	  }
	
	  return value;
	}
	
	function rgba2String(rgba) {
	  rgba[0] = Math.floor(rgba[0]);
	  rgba[1] = Math.floor(rgba[1]);
	  rgba[2] = Math.floor(rgba[2]);
	  return 'rgba(' + rgba.join(',') + ')';
	}
	
	function getArrayDim(keyframes) {
	  var lastValue = keyframes[keyframes.length - 1].value;
	  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
	}
	
	function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
	  var getter = animator._getter;
	  var setter = animator._setter;
	  var useSpline = easing === 'spline';
	  var trackLen = keyframes.length;
	
	  if (!trackLen) {
	    return;
	  } // Guess data type
	
	
	  var firstVal = keyframes[0].value;
	  var isValueArray = isArrayLike(firstVal);
	  var isValueColor = false;
	  var isValueString = false; // For vertices morphing
	
	  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
	  var trackMaxTime; // Sort keyframe as ascending
	
	  keyframes.sort(function (a, b) {
	    return a.time - b.time;
	  });
	  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
	
	  var kfPercents = []; // Value of each keyframe
	
	  var kfValues = [];
	  var prevValue = keyframes[0].value;
	  var isAllValueEqual = true;
	
	  for (var i = 0; i < trackLen; i++) {
	    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
	
	    var value = keyframes[i].value; // Check if value is equal, deep check if value is array
	
	    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
	      isAllValueEqual = false;
	    }
	
	    prevValue = value; // Try converting a string to a color array
	
	    if (typeof value === 'string') {
	      var colorArray = color.parse(value);
	
	      if (colorArray) {
	        value = colorArray;
	        isValueColor = true;
	      } else {
	        isValueString = true;
	      }
	    }
	
	    kfValues.push(value);
	  }
	
	  if (!forceAnimate && isAllValueEqual) {
	    return;
	  }
	
	  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
	
	  for (var i = 0; i < trackLen - 1; i++) {
	    if (isValueArray) {
	      fillArr(kfValues[i], lastValue, arrDim);
	    } else {
	      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
	        kfValues[i] = lastValue;
	      }
	    }
	  }
	
	  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
	  // animation playback is sequency
	
	  var lastFrame = 0;
	  var lastFramePercent = 0;
	  var start;
	  var w;
	  var p0;
	  var p1;
	  var p2;
	  var p3;
	
	  if (isValueColor) {
	    var rgba = [0, 0, 0, 0];
	  }
	
	  var onframe = function (target, percent) {
	    // Find the range keyframes
	    // kf1-----kf2---------current--------kf3
	    // find kf2 and kf3 and do interpolation
	    var frame; // In the easing function like elasticOut, percent may less than 0
	
	    if (percent < 0) {
	      frame = 0;
	    } else if (percent < lastFramePercent) {
	      // Start from next key
	      // PENDING start from lastFrame ?
	      start = Math.min(lastFrame + 1, trackLen - 1);
	
	      for (frame = start; frame >= 0; frame--) {
	        if (kfPercents[frame] <= percent) {
	          break;
	        }
	      } // PENDING really need to do this ?
	
	
	      frame = Math.min(frame, trackLen - 2);
	    } else {
	      for (frame = lastFrame; frame < trackLen; frame++) {
	        if (kfPercents[frame] > percent) {
	          break;
	        }
	      }
	
	      frame = Math.min(frame - 1, trackLen - 2);
	    }
	
	    lastFrame = frame;
	    lastFramePercent = percent;
	    var range = kfPercents[frame + 1] - kfPercents[frame];
	
	    if (range === 0) {
	      return;
	    } else {
	      w = (percent - kfPercents[frame]) / range;
	    }
	
	    if (useSpline) {
	      p1 = kfValues[frame];
	      p0 = kfValues[frame === 0 ? frame : frame - 1];
	      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
	      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
	
	      if (isValueArray) {
	        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(p1, p2, w);
	        } else {
	          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
	        }
	
	        setter(target, propName, value);
	      }
	    } else {
	      if (isValueArray) {
	        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
	        } else {
	          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
	        }
	
	        setter(target, propName, value);
	      }
	    }
	  };
	
	  var clip = new Clip({
	    target: animator._target,
	    life: trackMaxTime,
	    loop: animator._loop,
	    delay: animator._delay,
	    onframe: onframe,
	    ondestroy: oneTrackDone
	  });
	
	  if (easing && easing !== 'spline') {
	    clip.easing = easing;
	  }
	
	  return clip;
	}
	/**
	 * @alias module:zrender/animation/Animator
	 * @constructor
	 * @param {Object} target
	 * @param {boolean} loop
	 * @param {Function} getter
	 * @param {Function} setter
	 */
	
	
	var Animator = function (target, loop, getter, setter) {
	  this._tracks = {};
	  this._target = target;
	  this._loop = loop || false;
	  this._getter = getter || defaultGetter;
	  this._setter = setter || defaultSetter;
	  this._clipCount = 0;
	  this._delay = 0;
	  this._doneList = [];
	  this._onframeList = [];
	  this._clipList = [];
	};
	
	Animator.prototype = {
	  /**
	   * 设置动画关键帧
	   * @param  {number} time 关键帧时间，单位是ms
	   * @param  {Object} props 关键帧的属性值，key-value表示
	   * @return {module:zrender/animation/Animator}
	   */
	  when: function (time
	  /* ms */
	  , props) {
	    var tracks = this._tracks;
	
	    for (var propName in props) {
	      if (!props.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      if (!tracks[propName]) {
	        tracks[propName] = []; // Invalid value
	
	        var value = this._getter(this._target, propName);
	
	        if (value == null) {
	          // zrLog('Invalid property ' + propName);
	          continue;
	        } // If time is 0
	        //  Then props is given initialize value
	        // Else
	        //  Initialize value from current prop value
	
	
	        if (time !== 0) {
	          tracks[propName].push({
	            time: 0,
	            value: cloneValue(value)
	          });
	        }
	      }
	
	      tracks[propName].push({
	        time: time,
	        value: props[propName]
	      });
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加动画每一帧的回调函数
	   * @param  {Function} callback
	   * @return {module:zrender/animation/Animator}
	   */
	  during: function (callback) {
	    this._onframeList.push(callback);
	
	    return this;
	  },
	  pause: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].pause();
	    }
	
	    this._paused = true;
	  },
	  resume: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].resume();
	    }
	
	    this._paused = false;
	  },
	  isPaused: function () {
	    return !!this._paused;
	  },
	  _doneCallback: function () {
	    // Clear all tracks
	    this._tracks = {}; // Clear all clips
	
	    this._clipList.length = 0;
	    var doneList = this._doneList;
	    var len = doneList.length;
	
	    for (var i = 0; i < len; i++) {
	      doneList[i].call(this);
	    }
	  },
	
	  /**
	   * 开始执行动画
	   * @param  {string|Function} [easing]
	   *         动画缓动函数，详见{@link module:zrender/animation/easing}
	   * @param  {boolean} forceAnimate
	   * @return {module:zrender/animation/Animator}
	   */
	  start: function (easing, forceAnimate) {
	    var self = this;
	    var clipCount = 0;
	
	    var oneTrackDone = function () {
	      clipCount--;
	
	      if (!clipCount) {
	        self._doneCallback();
	      }
	    };
	
	    var lastClip;
	
	    for (var propName in this._tracks) {
	      if (!this._tracks.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
	
	      if (clip) {
	        this._clipList.push(clip);
	
	        clipCount++; // If start after added to animation
	
	        if (this.animation) {
	          this.animation.addClip(clip);
	        }
	
	        lastClip = clip;
	      }
	    } // Add during callback on the last clip
	
	
	    if (lastClip) {
	      var oldOnFrame = lastClip.onframe;
	
	      lastClip.onframe = function (target, percent) {
	        oldOnFrame(target, percent);
	
	        for (var i = 0; i < self._onframeList.length; i++) {
	          self._onframeList[i](target, percent);
	        }
	      };
	    } // This optimization will help the case that in the upper application
	    // the view may be refreshed frequently, where animation will be
	    // called repeatly but nothing changed.
	
	
	    if (!clipCount) {
	      this._doneCallback();
	    }
	
	    return this;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stop: function (forwardToLast) {
	    var clipList = this._clipList;
	    var animation = this.animation;
	
	    for (var i = 0; i < clipList.length; i++) {
	      var clip = clipList[i];
	
	      if (forwardToLast) {
	        // Move to last frame before stop
	        clip.onframe(this._target, 1);
	      }
	
	      animation && animation.removeClip(clip);
	    }
	
	    clipList.length = 0;
	  },
	
	  /**
	   * 设置动画延迟开始的时间
	   * @param  {number} time 单位ms
	   * @return {module:zrender/animation/Animator}
	   */
	  delay: function (time) {
	    this._delay = time;
	    return this;
	  },
	
	  /**
	   * 添加动画结束的回调
	   * @param  {Function} cb
	   * @return {module:zrender/animation/Animator}
	   */
	  done: function (cb) {
	    if (cb) {
	      this._doneList.push(cb);
	    }
	
	    return this;
	  },
	
	  /**
	   * @return {Array.<module:zrender/animation/Clip>}
	   */
	  getClips: function () {
	    return this._clipList;
	  }
	};
	var _default = Animator;
	module.exports = _default;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var easingFuncs = __webpack_require__(149);
	
	/**
	 * 动画主控制器
	 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
	 * @config life(1000) 动画时长
	 * @config delay(0) 动画延迟时间
	 * @config loop(true)
	 * @config gap(0) 循环的间隔时间
	 * @config onframe
	 * @config easing(optional)
	 * @config ondestroy(optional)
	 * @config onrestart(optional)
	 *
	 * TODO pause
	 */
	function Clip(options) {
	  this._target = options.target; // 生命周期
	
	  this._life = options.life || 1000; // 延时
	
	  this._delay = options.delay || 0; // 开始时间
	  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
	
	  this._initialized = false; // 是否循环
	
	  this.loop = options.loop == null ? false : options.loop;
	  this.gap = options.gap || 0;
	  this.easing = options.easing || 'Linear';
	  this.onframe = options.onframe;
	  this.ondestroy = options.ondestroy;
	  this.onrestart = options.onrestart;
	  this._pausedTime = 0;
	  this._paused = false;
	}
	
	Clip.prototype = {
	  constructor: Clip,
	  step: function (globalTime, deltaTime) {
	    // Set startTime on first step, or _startTime may has milleseconds different between clips
	    // PENDING
	    if (!this._initialized) {
	      this._startTime = globalTime + this._delay;
	      this._initialized = true;
	    }
	
	    if (this._paused) {
	      this._pausedTime += deltaTime;
	      return;
	    }
	
	    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
	
	    if (percent < 0) {
	      return;
	    }
	
	    percent = Math.min(percent, 1);
	    var easing = this.easing;
	    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
	    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
	    this.fire('frame', schedule); // 结束
	
	    if (percent === 1) {
	      if (this.loop) {
	        this.restart(globalTime); // 重新开始周期
	        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
	
	        return 'restart';
	      } // 动画完成将这个控制器标识为待删除
	      // 在Animation.update中进行批量删除
	
	
	      this._needsRemove = true;
	      return 'destroy';
	    }
	
	    return null;
	  },
	  restart: function (globalTime) {
	    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
	    this._startTime = globalTime - remainder + this.gap;
	    this._pausedTime = 0;
	    this._needsRemove = false;
	  },
	  fire: function (eventType, arg) {
	    eventType = 'on' + eventType;
	
	    if (this[eventType]) {
	      this[eventType](this._target, arg);
	    }
	  },
	  pause: function () {
	    this._paused = true;
	  },
	  resume: function () {
	    this._paused = false;
	  }
	};
	var _default = Clip;
	module.exports = _default;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	/**
	 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
	 * @see http://sole.github.io/tween.js/examples/03_graphs.html
	 * @exports zrender/animation/easing
	 */
	var easing = {
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  linear: function (k) {
	    return k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticIn: function (k) {
	    return k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticOut: function (k) {
	    return k * (2 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k;
	    }
	
	    return -0.5 * (--k * (k - 2) - 1);
	  },
	  // 三次方的缓动（t^3）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicIn: function (k) {
	    return k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicOut: function (k) {
	    return --k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k + 2);
	  },
	  // 四次方的缓动（t^4）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticIn: function (k) {
	    return k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticOut: function (k) {
	    return 1 - --k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k;
	    }
	
	    return -0.5 * ((k -= 2) * k * k * k - 2);
	  },
	  // 五次方的缓动（t^5）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticIn: function (k) {
	    return k * k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticOut: function (k) {
	    return --k * k * k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k * k * k + 2);
	  },
	  // 正弦曲线的缓动（sin(t)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalIn: function (k) {
	    return 1 - Math.cos(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalOut: function (k) {
	    return Math.sin(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalInOut: function (k) {
	    return 0.5 * (1 - Math.cos(Math.PI * k));
	  },
	  // 指数曲线的缓动（2^t）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialIn: function (k) {
	    return k === 0 ? 0 : Math.pow(1024, k - 1);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialOut: function (k) {
	    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialInOut: function (k) {
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if ((k *= 2) < 1) {
	      return 0.5 * Math.pow(1024, k - 1);
	    }
	
	    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	  },
	  // 圆形曲线的缓动（sqrt(1-t^2)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularIn: function (k) {
	    return 1 - Math.sqrt(1 - k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularOut: function (k) {
	    return Math.sqrt(1 - --k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return -0.5 * (Math.sqrt(1 - k * k) - 1);
	    }
	
	    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	  },
	  // 创建类似于弹簧在停止前来回振荡的动画
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticIn: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticInOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    if ((k *= 2) < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	    }
	
	    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	  },
	  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backIn: function (k) {
	    var s = 1.70158;
	    return k * k * ((s + 1) * k - s);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backOut: function (k) {
	    var s = 1.70158;
	    return --k * k * ((s + 1) * k + s) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backInOut: function (k) {
	    var s = 1.70158 * 1.525;
	
	    if ((k *= 2) < 1) {
	      return 0.5 * (k * k * ((s + 1) * k - s));
	    }
	
	    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	  },
	  // 创建弹跳效果
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceIn: function (k) {
	    return 1 - easing.bounceOut(1 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceOut: function (k) {
	    if (k < 1 / 2.75) {
	      return 7.5625 * k * k;
	    } else if (k < 2 / 2.75) {
	      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
	    } else if (k < 2.5 / 2.75) {
	      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
	    } else {
	      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
	    }
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceInOut: function (k) {
	    if (k < 0.5) {
	      return easing.bounceIn(k * 2) * 0.5;
	    }
	
	    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	  }
	};
	var _default = easing;
	module.exports = _default;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(151);
	
	var kCSSColorTable = {
	  'transparent': [0, 0, 0, 0],
	  'aliceblue': [240, 248, 255, 1],
	  'antiquewhite': [250, 235, 215, 1],
	  'aqua': [0, 255, 255, 1],
	  'aquamarine': [127, 255, 212, 1],
	  'azure': [240, 255, 255, 1],
	  'beige': [245, 245, 220, 1],
	  'bisque': [255, 228, 196, 1],
	  'black': [0, 0, 0, 1],
	  'blanchedalmond': [255, 235, 205, 1],
	  'blue': [0, 0, 255, 1],
	  'blueviolet': [138, 43, 226, 1],
	  'brown': [165, 42, 42, 1],
	  'burlywood': [222, 184, 135, 1],
	  'cadetblue': [95, 158, 160, 1],
	  'chartreuse': [127, 255, 0, 1],
	  'chocolate': [210, 105, 30, 1],
	  'coral': [255, 127, 80, 1],
	  'cornflowerblue': [100, 149, 237, 1],
	  'cornsilk': [255, 248, 220, 1],
	  'crimson': [220, 20, 60, 1],
	  'cyan': [0, 255, 255, 1],
	  'darkblue': [0, 0, 139, 1],
	  'darkcyan': [0, 139, 139, 1],
	  'darkgoldenrod': [184, 134, 11, 1],
	  'darkgray': [169, 169, 169, 1],
	  'darkgreen': [0, 100, 0, 1],
	  'darkgrey': [169, 169, 169, 1],
	  'darkkhaki': [189, 183, 107, 1],
	  'darkmagenta': [139, 0, 139, 1],
	  'darkolivegreen': [85, 107, 47, 1],
	  'darkorange': [255, 140, 0, 1],
	  'darkorchid': [153, 50, 204, 1],
	  'darkred': [139, 0, 0, 1],
	  'darksalmon': [233, 150, 122, 1],
	  'darkseagreen': [143, 188, 143, 1],
	  'darkslateblue': [72, 61, 139, 1],
	  'darkslategray': [47, 79, 79, 1],
	  'darkslategrey': [47, 79, 79, 1],
	  'darkturquoise': [0, 206, 209, 1],
	  'darkviolet': [148, 0, 211, 1],
	  'deeppink': [255, 20, 147, 1],
	  'deepskyblue': [0, 191, 255, 1],
	  'dimgray': [105, 105, 105, 1],
	  'dimgrey': [105, 105, 105, 1],
	  'dodgerblue': [30, 144, 255, 1],
	  'firebrick': [178, 34, 34, 1],
	  'floralwhite': [255, 250, 240, 1],
	  'forestgreen': [34, 139, 34, 1],
	  'fuchsia': [255, 0, 255, 1],
	  'gainsboro': [220, 220, 220, 1],
	  'ghostwhite': [248, 248, 255, 1],
	  'gold': [255, 215, 0, 1],
	  'goldenrod': [218, 165, 32, 1],
	  'gray': [128, 128, 128, 1],
	  'green': [0, 128, 0, 1],
	  'greenyellow': [173, 255, 47, 1],
	  'grey': [128, 128, 128, 1],
	  'honeydew': [240, 255, 240, 1],
	  'hotpink': [255, 105, 180, 1],
	  'indianred': [205, 92, 92, 1],
	  'indigo': [75, 0, 130, 1],
	  'ivory': [255, 255, 240, 1],
	  'khaki': [240, 230, 140, 1],
	  'lavender': [230, 230, 250, 1],
	  'lavenderblush': [255, 240, 245, 1],
	  'lawngreen': [124, 252, 0, 1],
	  'lemonchiffon': [255, 250, 205, 1],
	  'lightblue': [173, 216, 230, 1],
	  'lightcoral': [240, 128, 128, 1],
	  'lightcyan': [224, 255, 255, 1],
	  'lightgoldenrodyellow': [250, 250, 210, 1],
	  'lightgray': [211, 211, 211, 1],
	  'lightgreen': [144, 238, 144, 1],
	  'lightgrey': [211, 211, 211, 1],
	  'lightpink': [255, 182, 193, 1],
	  'lightsalmon': [255, 160, 122, 1],
	  'lightseagreen': [32, 178, 170, 1],
	  'lightskyblue': [135, 206, 250, 1],
	  'lightslategray': [119, 136, 153, 1],
	  'lightslategrey': [119, 136, 153, 1],
	  'lightsteelblue': [176, 196, 222, 1],
	  'lightyellow': [255, 255, 224, 1],
	  'lime': [0, 255, 0, 1],
	  'limegreen': [50, 205, 50, 1],
	  'linen': [250, 240, 230, 1],
	  'magenta': [255, 0, 255, 1],
	  'maroon': [128, 0, 0, 1],
	  'mediumaquamarine': [102, 205, 170, 1],
	  'mediumblue': [0, 0, 205, 1],
	  'mediumorchid': [186, 85, 211, 1],
	  'mediumpurple': [147, 112, 219, 1],
	  'mediumseagreen': [60, 179, 113, 1],
	  'mediumslateblue': [123, 104, 238, 1],
	  'mediumspringgreen': [0, 250, 154, 1],
	  'mediumturquoise': [72, 209, 204, 1],
	  'mediumvioletred': [199, 21, 133, 1],
	  'midnightblue': [25, 25, 112, 1],
	  'mintcream': [245, 255, 250, 1],
	  'mistyrose': [255, 228, 225, 1],
	  'moccasin': [255, 228, 181, 1],
	  'navajowhite': [255, 222, 173, 1],
	  'navy': [0, 0, 128, 1],
	  'oldlace': [253, 245, 230, 1],
	  'olive': [128, 128, 0, 1],
	  'olivedrab': [107, 142, 35, 1],
	  'orange': [255, 165, 0, 1],
	  'orangered': [255, 69, 0, 1],
	  'orchid': [218, 112, 214, 1],
	  'palegoldenrod': [238, 232, 170, 1],
	  'palegreen': [152, 251, 152, 1],
	  'paleturquoise': [175, 238, 238, 1],
	  'palevioletred': [219, 112, 147, 1],
	  'papayawhip': [255, 239, 213, 1],
	  'peachpuff': [255, 218, 185, 1],
	  'peru': [205, 133, 63, 1],
	  'pink': [255, 192, 203, 1],
	  'plum': [221, 160, 221, 1],
	  'powderblue': [176, 224, 230, 1],
	  'purple': [128, 0, 128, 1],
	  'red': [255, 0, 0, 1],
	  'rosybrown': [188, 143, 143, 1],
	  'royalblue': [65, 105, 225, 1],
	  'saddlebrown': [139, 69, 19, 1],
	  'salmon': [250, 128, 114, 1],
	  'sandybrown': [244, 164, 96, 1],
	  'seagreen': [46, 139, 87, 1],
	  'seashell': [255, 245, 238, 1],
	  'sienna': [160, 82, 45, 1],
	  'silver': [192, 192, 192, 1],
	  'skyblue': [135, 206, 235, 1],
	  'slateblue': [106, 90, 205, 1],
	  'slategray': [112, 128, 144, 1],
	  'slategrey': [112, 128, 144, 1],
	  'snow': [255, 250, 250, 1],
	  'springgreen': [0, 255, 127, 1],
	  'steelblue': [70, 130, 180, 1],
	  'tan': [210, 180, 140, 1],
	  'teal': [0, 128, 128, 1],
	  'thistle': [216, 191, 216, 1],
	  'tomato': [255, 99, 71, 1],
	  'turquoise': [64, 224, 208, 1],
	  'violet': [238, 130, 238, 1],
	  'wheat': [245, 222, 179, 1],
	  'white': [255, 255, 255, 1],
	  'whitesmoke': [245, 245, 245, 1],
	  'yellow': [255, 255, 0, 1],
	  'yellowgreen': [154, 205, 50, 1]
	};
	
	function clampCssByte(i) {
	  // Clamp to integer 0 .. 255.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 255 ? 255 : i;
	}
	
	function clampCssAngle(i) {
	  // Clamp to integer 0 .. 360.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 360 ? 360 : i;
	}
	
	function clampCssFloat(f) {
	  // Clamp to float 0.0 .. 1.0.
	  return f < 0 ? 0 : f > 1 ? 1 : f;
	}
	
	function parseCssInt(str) {
	  // int or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssByte(parseFloat(str) / 100 * 255);
	  }
	
	  return clampCssByte(parseInt(str, 10));
	}
	
	function parseCssFloat(str) {
	  // float or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssFloat(parseFloat(str) / 100);
	  }
	
	  return clampCssFloat(parseFloat(str));
	}
	
	function cssHueToRgb(m1, m2, h) {
	  if (h < 0) {
	    h += 1;
	  } else if (h > 1) {
	    h -= 1;
	  }
	
	  if (h * 6 < 1) {
	    return m1 + (m2 - m1) * h * 6;
	  }
	
	  if (h * 2 < 1) {
	    return m2;
	  }
	
	  if (h * 3 < 2) {
	    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	  }
	
	  return m1;
	}
	
	function lerpNumber(a, b, p) {
	  return a + (b - a) * p;
	}
	
	function setRgba(out, r, g, b, a) {
	  out[0] = r;
	  out[1] = g;
	  out[2] = b;
	  out[3] = a;
	  return out;
	}
	
	function copyRgba(out, a) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  return out;
	}
	
	var colorCache = new LRU(20);
	var lastRemovedArr = null;
	
	function putToCache(colorStr, rgbaArr) {
	  // Reuse removed array
	  if (lastRemovedArr) {
	    copyRgba(lastRemovedArr, rgbaArr);
	  }
	
	  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
	}
	/**
	 * @param {string} colorStr
	 * @param {Array.<number>} out
	 * @return {Array.<number>}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function parse(colorStr, rgbaArr) {
	  if (!colorStr) {
	    return;
	  }
	
	  rgbaArr = rgbaArr || [];
	  var cached = colorCache.get(colorStr);
	
	  if (cached) {
	    return copyRgba(rgbaArr, cached);
	  } // colorStr may be not string
	
	
	  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.
	
	  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.
	
	  if (str in kCSSColorTable) {
	    copyRgba(rgbaArr, kCSSColorTable[str]);
	    putToCache(colorStr, rgbaArr);
	    return rgbaArr;
	  } // #abc and #abc123 syntax.
	
	
	  if (str.charAt(0) === '#') {
	    if (str.length === 4) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xfff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    } else if (str.length === 7) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xffffff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    }
	
	    return;
	  }
	
	  var op = str.indexOf('(');
	  var ep = str.indexOf(')');
	
	  if (op !== -1 && ep + 1 === str.length) {
	    var fname = str.substr(0, op);
	    var params = str.substr(op + 1, ep - (op + 1)).split(',');
	    var alpha = 1; // To allow case fallthrough.
	
	    switch (fname) {
	      case 'rgba':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        alpha = parseCssFloat(params.pop());
	      // jshint ignore:line
	      // Fall through.
	
	      case 'rgb':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsla':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        params[3] = parseCssFloat(params[3]);
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsl':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      default:
	        return;
	    }
	  }
	
	  setRgba(rgbaArr, 0, 0, 0, 1);
	  return;
	}
	/**
	 * @param {Array.<number>} hsla
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} rgba
	 */
	
	
	function hsla2rgba(hsla, rgba) {
	  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
	  // NOTE(deanm): According to the CSS spec s/l should only be
	  // percentages, but we don't bother and let float or percentage.
	
	  var s = parseCssFloat(hsla[1]);
	  var l = parseCssFloat(hsla[2]);
	  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	  var m1 = l * 2 - m2;
	  rgba = rgba || [];
	  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	
	  if (hsla.length === 4) {
	    rgba[3] = hsla[3];
	  }
	
	  return rgba;
	}
	/**
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} hsla
	 */
	
	
	function rgba2hsla(rgba) {
	  if (!rgba) {
	    return;
	  } // RGB from 0 to 255
	
	
	  var R = rgba[0] / 255;
	  var G = rgba[1] / 255;
	  var B = rgba[2] / 255;
	  var vMin = Math.min(R, G, B); // Min. value of RGB
	
	  var vMax = Math.max(R, G, B); // Max. value of RGB
	
	  var delta = vMax - vMin; // Delta RGB value
	
	  var L = (vMax + vMin) / 2;
	  var H;
	  var S; // HSL results from 0 to 1
	
	  if (delta === 0) {
	    H = 0;
	    S = 0;
	  } else {
	    if (L < 0.5) {
	      S = delta / (vMax + vMin);
	    } else {
	      S = delta / (2 - vMax - vMin);
	    }
	
	    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
	    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
	    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
	
	    if (R === vMax) {
	      H = deltaB - deltaG;
	    } else if (G === vMax) {
	      H = 1 / 3 + deltaR - deltaB;
	    } else if (B === vMax) {
	      H = 2 / 3 + deltaG - deltaR;
	    }
	
	    if (H < 0) {
	      H += 1;
	    }
	
	    if (H > 1) {
	      H -= 1;
	    }
	  }
	
	  var hsla = [H * 360, S, L];
	
	  if (rgba[3] != null) {
	    hsla.push(rgba[3]);
	  }
	
	  return hsla;
	}
	/**
	 * @param {string} color
	 * @param {number} level
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function lift(color, level) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    for (var i = 0; i < 3; i++) {
	      if (level < 0) {
	        colorArr[i] = colorArr[i] * (1 - level) | 0;
	      } else {
	        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
	      }
	
	      if (colorArr[i] > 255) {
	        colorArr[i] = 255;
	      } else if (color[i] < 0) {
	        colorArr[i] = 0;
	      }
	    }
	
	    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	  }
	}
	/**
	 * @param {string} color
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function toHex(color) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
	  }
	}
	/**
	 * Map value to color. Faster than lerp methods because color is represented by rgba array.
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<Array.<number>>} colors List of rgba color array
	 * @param {Array.<number>} [out] Mapped gba color array
	 * @return {Array.<number>} will be null/undefined if input illegal.
	 */
	
	
	function fastLerp(normalizedValue, colors, out) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  out = out || [];
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = colors[leftIndex];
	  var rightColor = colors[rightIndex];
	  var dv = value - leftIndex;
	  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	  return out;
	}
	/**
	 * @deprecated
	 */
	
	
	var fastMapToColor = fastLerp;
	/**
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<string>} colors Color list.
	 * @param {boolean=} fullOutput Default false.
	 * @return {(string|Object)} Result color. If fullOutput,
	 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
	 * @memberOf module:zrender/util/color
	 */
	
	function lerp(normalizedValue, colors, fullOutput) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = parse(colors[leftIndex]);
	  var rightColor = parse(colors[rightIndex]);
	  var dv = value - leftIndex;
	  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
	  return fullOutput ? {
	    color: color,
	    leftIndex: leftIndex,
	    rightIndex: rightIndex,
	    value: value
	  } : color;
	}
	/**
	 * @deprecated
	 */
	
	
	var mapToColor = lerp;
	/**
	 * @param {string} color
	 * @param {number=} h 0 ~ 360, ignore when null.
	 * @param {number=} s 0 ~ 1, ignore when null.
	 * @param {number=} l 0 ~ 1, ignore when null.
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	function modifyHSL(color, h, s, l) {
	  color = parse(color);
	
	  if (color) {
	    color = rgba2hsla(color);
	    h != null && (color[0] = clampCssAngle(h));
	    s != null && (color[1] = parseCssFloat(s));
	    l != null && (color[2] = parseCssFloat(l));
	    return stringify(hsla2rgba(color), 'rgba');
	  }
	}
	/**
	 * @param {string} color
	 * @param {number=} alpha 0 ~ 1
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	
	function modifyAlpha(color, alpha) {
	  color = parse(color);
	
	  if (color && alpha != null) {
	    color[3] = clampCssFloat(alpha);
	    return stringify(color, 'rgba');
	  }
	}
	/**
	 * @param {Array.<number>} arrColor like [12,33,44,0.4]
	 * @param {string} type 'rgba', 'hsva', ...
	 * @return {string} Result color. (If input illegal, return undefined).
	 */
	
	
	function stringify(arrColor, type) {
	  if (!arrColor || !arrColor.length) {
	    return;
	  }
	
	  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	
	  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	    colorStr += ',' + arrColor[3];
	  }
	
	  return type + '(' + colorStr + ')';
	}
	
	exports.parse = parse;
	exports.lift = lift;
	exports.toHex = toHex;
	exports.fastLerp = fastLerp;
	exports.fastMapToColor = fastMapToColor;
	exports.lerp = lerp;
	exports.mapToColor = mapToColor;
	exports.modifyHSL = modifyHSL;
	exports.modifyAlpha = modifyAlpha;
	exports.stringify = stringify;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	// Simple LRU cache use doubly linked list
	// @module zrender/core/LRU
	
	/**
	 * Simple double linked list. Compared with array, it has O(1) remove operation.
	 * @constructor
	 */
	var LinkedList = function () {
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	  this.head = null;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.tail = null;
	  this._len = 0;
	};
	
	var linkedListProto = LinkedList.prototype;
	/**
	 * Insert a new value at the tail
	 * @param  {} val
	 * @return {module:zrender/core/LRU~Entry}
	 */
	
	linkedListProto.insert = function (val) {
	  var entry = new Entry(val);
	  this.insertEntry(entry);
	  return entry;
	};
	/**
	 * Insert an entry at the tail
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.insertEntry = function (entry) {
	  if (!this.head) {
	    this.head = this.tail = entry;
	  } else {
	    this.tail.next = entry;
	    entry.prev = this.tail;
	    entry.next = null;
	    this.tail = entry;
	  }
	
	  this._len++;
	};
	/**
	 * Remove entry.
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.remove = function (entry) {
	  var prev = entry.prev;
	  var next = entry.next;
	
	  if (prev) {
	    prev.next = next;
	  } else {
	    // Is head
	    this.head = next;
	  }
	
	  if (next) {
	    next.prev = prev;
	  } else {
	    // Is tail
	    this.tail = prev;
	  }
	
	  entry.next = entry.prev = null;
	  this._len--;
	};
	/**
	 * @return {number}
	 */
	
	
	linkedListProto.len = function () {
	  return this._len;
	};
	/**
	 * Clear list
	 */
	
	
	linkedListProto.clear = function () {
	  this.head = this.tail = null;
	  this._len = 0;
	};
	/**
	 * @constructor
	 * @param {} val
	 */
	
	
	var Entry = function (val) {
	  /**
	   * @type {}
	   */
	  this.value = val;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.next;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.prev;
	};
	/**
	 * LRU Cache
	 * @constructor
	 * @alias module:zrender/core/LRU
	 */
	
	
	var LRU = function (maxSize) {
	  this._list = new LinkedList();
	  this._map = {};
	  this._maxSize = maxSize || 10;
	  this._lastRemovedEntry = null;
	};
	
	var LRUProto = LRU.prototype;
	/**
	 * @param  {string} key
	 * @param  {} value
	 * @return {} Removed value
	 */
	
	LRUProto.put = function (key, value) {
	  var list = this._list;
	  var map = this._map;
	  var removed = null;
	
	  if (map[key] == null) {
	    var len = list.len(); // Reuse last removed entry
	
	    var entry = this._lastRemovedEntry;
	
	    if (len >= this._maxSize && len > 0) {
	      // Remove the least recently used
	      var leastUsedEntry = list.head;
	      list.remove(leastUsedEntry);
	      delete map[leastUsedEntry.key];
	      removed = leastUsedEntry.value;
	      this._lastRemovedEntry = leastUsedEntry;
	    }
	
	    if (entry) {
	      entry.value = value;
	    } else {
	      entry = new Entry(value);
	    }
	
	    entry.key = key;
	    list.insertEntry(entry);
	    map[key] = entry;
	  }
	
	  return removed;
	};
	/**
	 * @param  {string} key
	 * @return {}
	 */
	
	
	LRUProto.get = function (key) {
	  var entry = this._map[key];
	  var list = this._list;
	
	  if (entry != null) {
	    // Put the latest used entry in the tail
	    if (entry !== list.tail) {
	      list.remove(entry);
	      list.insertEntry(entry);
	    }
	
	    return entry.value;
	  }
	};
	/**
	 * Clear the cache
	 */
	
	
	LRUProto.clear = function () {
	  this._list.clear();
	
	  this._map = {};
	};
	
	var _default = LRU;
	module.exports = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(153);
	
	var debugMode = _config.debugMode;
	
	var log = function () {};
	
	if (debugMode === 1) {
	  log = function () {
	    for (var k in arguments) {
	      throw new Error(arguments[k]);
	    }
	  };
	} else if (debugMode > 1) {
	  log = function () {
	    for (var k in arguments) {
	      console.log(arguments[k]);
	    }
	  };
	}
	
	var _default = log;
	module.exports = _default;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	var dpr = 1; // If in browser environment
	
	if (typeof window !== 'undefined') {
	  dpr = Math.max(window.devicePixelRatio || 1, 1);
	}
	/**
	 * config默认配置项
	 * @exports zrender/config
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	
	/**
	 * debug日志选项：catchBrushException为true下有效
	 * 0 : 不生成debug数据，发布用
	 * 1 : 异常抛出，调试用
	 * 2 : 控制台输出，调试用
	 */
	
	
	var debugMode = 0; // retina 屏幕优化
	
	var devicePixelRatio = dpr;
	exports.debugMode = debugMode;
	exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(136);
	
	var matrix = __webpack_require__(145);
	
	/**
	 * @module echarts/core/BoundingRect
	 */
	var v2ApplyTransform = vec2.applyTransform;
	var mathMin = Math.min;
	var mathMax = Math.max;
	/**
	 * @alias module:echarts/core/BoundingRect
	 */
	
	function BoundingRect(x, y, width, height) {
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	  /**
	   * @type {number}
	   */
	
	
	  this.x = x;
	  /**
	   * @type {number}
	   */
	
	  this.y = y;
	  /**
	   * @type {number}
	   */
	
	  this.width = width;
	  /**
	   * @type {number}
	   */
	
	  this.height = height;
	}
	
	BoundingRect.prototype = {
	  constructor: BoundingRect,
	
	  /**
	   * @param {module:echarts/core/BoundingRect} other
	   */
	  union: function (other) {
	    var x = mathMin(other.x, this.x);
	    var y = mathMin(other.y, this.y);
	    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	    this.x = x;
	    this.y = y;
	  },
	
	  /**
	   * @param {Array.<number>} m
	   * @methods
	   */
	  applyTransform: function () {
	    var lt = [];
	    var rb = [];
	    var lb = [];
	    var rt = [];
	    return function (m) {
	      // In case usage like this
	      // el.getBoundingRect().applyTransform(el.transform)
	      // And element has no transform
	      if (!m) {
	        return;
	      }
	
	      lt[0] = lb[0] = this.x;
	      lt[1] = rt[1] = this.y;
	      rb[0] = rt[0] = this.x + this.width;
	      rb[1] = lb[1] = this.y + this.height;
	      v2ApplyTransform(lt, lt, m);
	      v2ApplyTransform(rb, rb, m);
	      v2ApplyTransform(lb, lb, m);
	      v2ApplyTransform(rt, rt, m);
	      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
	      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
	      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
	      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
	      this.width = maxX - this.x;
	      this.height = maxY - this.y;
	    };
	  }(),
	
	  /**
	   * Calculate matrix of transforming from self to target rect
	   * @param  {module:zrender/core/BoundingRect} b
	   * @return {Array.<number>}
	   */
	  calculateTransform: function (b) {
	    var a = this;
	    var sx = b.width / a.width;
	    var sy = b.height / a.height;
	    var m = matrix.create(); // 矩阵右乘
	
	    matrix.translate(m, m, [-a.x, -a.y]);
	    matrix.scale(m, m, [sx, sy]);
	    matrix.translate(m, m, [b.x, b.y]);
	    return m;
	  },
	
	  /**
	   * @param {(module:echarts/core/BoundingRect|Object)} b
	   * @return {boolean}
	   */
	  intersect: function (b) {
	    if (!b) {
	      return false;
	    }
	
	    if (!(b instanceof BoundingRect)) {
	      // Normalize negative width/height.
	      b = BoundingRect.create(b);
	    }
	
	    var a = this;
	    var ax0 = a.x;
	    var ax1 = a.x + a.width;
	    var ay0 = a.y;
	    var ay1 = a.y + a.height;
	    var bx0 = b.x;
	    var bx1 = b.x + b.width;
	    var by0 = b.y;
	    var by1 = b.y + b.height;
	    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	  },
	  contain: function (x, y) {
	    var rect = this;
	    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
	  },
	
	  /**
	   * @return {module:echarts/core/BoundingRect}
	   */
	  clone: function () {
	    return new BoundingRect(this.x, this.y, this.width, this.height);
	  },
	
	  /**
	   * Copy from another rect
	   */
	  copy: function (other) {
	    this.x = other.x;
	    this.y = other.y;
	    this.width = other.width;
	    this.height = other.height;
	  },
	  plain: function () {
	    return {
	      x: this.x,
	      y: this.y,
	      width: this.width,
	      height: this.height
	    };
	  }
	};
	/**
	 * @param {Object|module:zrender/core/BoundingRect} rect
	 * @param {number} rect.x
	 * @param {number} rect.y
	 * @param {number} rect.width
	 * @param {number} rect.height
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	BoundingRect.create = function (rect) {
	  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	};
	
	var _default = BoundingRect;
	module.exports = _default;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	// https://github.com/mziccard/node-timsort
	var DEFAULT_MIN_MERGE = 32;
	var DEFAULT_MIN_GALLOPING = 7;
	var DEFAULT_TMP_STORAGE_LENGTH = 256;
	
	function minRunLength(n) {
	  var r = 0;
	
	  while (n >= DEFAULT_MIN_MERGE) {
	    r |= n & 1;
	    n >>= 1;
	  }
	
	  return n + r;
	}
	
	function makeAscendingRun(array, lo, hi, compare) {
	  var runHi = lo + 1;
	
	  if (runHi === hi) {
	    return 1;
	  }
	
	  if (compare(array[runHi++], array[lo]) < 0) {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	      runHi++;
	    }
	
	    reverseRun(array, lo, runHi);
	  } else {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	      runHi++;
	    }
	  }
	
	  return runHi - lo;
	}
	
	function reverseRun(array, lo, hi) {
	  hi--;
	
	  while (lo < hi) {
	    var t = array[lo];
	    array[lo++] = array[hi];
	    array[hi--] = t;
	  }
	}
	
	function binaryInsertionSort(array, lo, hi, start, compare) {
	  if (start === lo) {
	    start++;
	  }
	
	  for (; start < hi; start++) {
	    var pivot = array[start];
	    var left = lo;
	    var right = start;
	    var mid;
	
	    while (left < right) {
	      mid = left + right >>> 1;
	
	      if (compare(pivot, array[mid]) < 0) {
	        right = mid;
	      } else {
	        left = mid + 1;
	      }
	    }
	
	    var n = start - left;
	
	    switch (n) {
	      case 3:
	        array[left + 3] = array[left + 2];
	
	      case 2:
	        array[left + 2] = array[left + 1];
	
	      case 1:
	        array[left + 1] = array[left];
	        break;
	
	      default:
	        while (n > 0) {
	          array[left + n] = array[left + n - 1];
	          n--;
	        }
	
	    }
	
	    array[left] = pivot;
	  }
	}
	
	function gallopLeft(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) > 0) {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  } else {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) > 0) {
	      lastOffset = m + 1;
	    } else {
	      offset = m;
	    }
	  }
	
	  return offset;
	}
	
	function gallopRight(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) < 0) {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  } else {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) < 0) {
	      offset = m;
	    } else {
	      lastOffset = m + 1;
	    }
	  }
	
	  return offset;
	}
	
	function TimSort(array, compare) {
	  var minGallop = DEFAULT_MIN_GALLOPING;
	  var length = 0;
	  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
	  var stackLength = 0;
	  var runStart;
	  var runLength;
	  var stackSize = 0;
	  length = array.length;
	
	  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
	    tmpStorageLength = length >>> 1;
	  }
	
	  var tmp = [];
	  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
	  runStart = [];
	  runLength = [];
	
	  function pushRun(_runStart, _runLength) {
	    runStart[stackSize] = _runStart;
	    runLength[stackSize] = _runLength;
	    stackSize += 1;
	  }
	
	  function mergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
	        if (runLength[n - 1] < runLength[n + 1]) {
	          n--;
	        }
	      } else if (runLength[n] > runLength[n + 1]) {
	        break;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function forceMergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	        n--;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function mergeAt(i) {
	    var start1 = runStart[i];
	    var length1 = runLength[i];
	    var start2 = runStart[i + 1];
	    var length2 = runLength[i + 1];
	    runLength[i] = length1 + length2;
	
	    if (i === stackSize - 3) {
	      runStart[i + 1] = runStart[i + 2];
	      runLength[i + 1] = runLength[i + 2];
	    }
	
	    stackSize--;
	    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	    start1 += k;
	    length1 -= k;
	
	    if (length1 === 0) {
	      return;
	    }
	
	    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	
	    if (length2 === 0) {
	      return;
	    }
	
	    if (length1 <= length2) {
	      mergeLow(start1, length1, start2, length2);
	    } else {
	      mergeHigh(start1, length1, start2, length2);
	    }
	  }
	
	  function mergeLow(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length1; i++) {
	      tmp[i] = array[start1 + i];
	    }
	
	    var cursor1 = 0;
	    var cursor2 = start2;
	    var dest = start1;
	    array[dest++] = array[cursor2++];
	
	    if (--length2 === 0) {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	
	      return;
	    }
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	      return;
	    }
	
	    var _minGallop = minGallop;
	    var count1, count2, exit;
	
	    while (1) {
	      count1 = 0;
	      count2 = 0;
	      exit = false;
	
	      do {
	        if (compare(array[cursor2], tmp[cursor1]) < 0) {
	          array[dest++] = array[cursor2++];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest++] = tmp[cursor1++];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	
	        if (count1 !== 0) {
	          for (i = 0; i < count1; i++) {
	            array[dest + i] = tmp[cursor1 + i];
	          }
	
	          dest += count1;
	          cursor1 += count1;
	          length1 -= count1;
	
	          if (length1 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = array[cursor2++];
	
	        if (--length2 === 0) {
	          exit = true;
	          break;
	        }
	
	        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	
	        if (count2 !== 0) {
	          for (i = 0; i < count2; i++) {
	            array[dest + i] = array[cursor2 + i];
	          }
	
	          dest += count2;
	          cursor2 += count2;
	          length2 -= count2;
	
	          if (length2 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = tmp[cursor1++];
	
	        if (--length1 === 1) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	    minGallop < 1 && (minGallop = 1);
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	    } else if (length1 === 0) {
	      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
	    } else {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	    }
	  }
	
	  function mergeHigh(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length2; i++) {
	      tmp[i] = array[start2 + i];
	    }
	
	    var cursor1 = start1 + length1 - 1;
	    var cursor2 = length2 - 1;
	    var dest = start2 + length2 - 1;
	    var customCursor = 0;
	    var customDest = 0;
	    array[dest--] = array[cursor1--];
	
	    if (--length1 === 0) {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	
	      return;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	      return;
	    }
	
	    var _minGallop = minGallop;
	
	    while (true) {
	      var count1 = 0;
	      var count2 = 0;
	      var exit = false;
	
	      do {
	        if (compare(tmp[cursor2], array[cursor1]) < 0) {
	          array[dest--] = array[cursor1--];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest--] = tmp[cursor2--];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	
	        if (count1 !== 0) {
	          dest -= count1;
	          cursor1 -= count1;
	          length1 -= count1;
	          customDest = dest + 1;
	          customCursor = cursor1 + 1;
	
	          for (i = count1 - 1; i >= 0; i--) {
	            array[customDest + i] = array[customCursor + i];
	          }
	
	          if (length1 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = tmp[cursor2--];
	
	        if (--length2 === 1) {
	          exit = true;
	          break;
	        }
	
	        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	
	        if (count2 !== 0) {
	          dest -= count2;
	          cursor2 -= count2;
	          length2 -= count2;
	          customDest = dest + 1;
	          customCursor = cursor2 + 1;
	
	          for (i = 0; i < count2; i++) {
	            array[customDest + i] = tmp[customCursor + i];
	          }
	
	          if (length2 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = array[cursor1--];
	
	        if (--length1 === 0) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	
	    if (minGallop < 1) {
	      minGallop = 1;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	    } else if (length2 === 0) {
	      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
	    } else {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	    }
	  }
	
	  this.mergeRuns = mergeRuns;
	  this.forceMergeRuns = forceMergeRuns;
	  this.pushRun = pushRun;
	}
	
	function sort(array, compare, lo, hi) {
	  if (!lo) {
	    lo = 0;
	  }
	
	  if (!hi) {
	    hi = array.length;
	  }
	
	  var remaining = hi - lo;
	
	  if (remaining < 2) {
	    return;
	  }
	
	  var runLength = 0;
	
	  if (remaining < DEFAULT_MIN_MERGE) {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	    return;
	  }
	
	  var ts = new TimSort(array, compare);
	  var minRun = minRunLength(remaining);
	
	  do {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	
	    if (runLength < minRun) {
	      var force = remaining;
	
	      if (force > minRun) {
	        force = minRun;
	      }
	
	      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	      runLength = force;
	    }
	
	    ts.pushRun(lo, runLength);
	    ts.mergeRuns();
	    remaining -= runLength;
	    lo += runLength;
	  } while (remaining !== 0);
	
	  ts.forceMergeRuns();
	}
	
	module.exports = sort;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(153);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var util = __webpack_require__(134);
	
	var log = __webpack_require__(152);
	
	var BoundingRect = __webpack_require__(154);
	
	var timsort = __webpack_require__(155);
	
	var Layer = __webpack_require__(157);
	
	var requestAnimationFrame = __webpack_require__(162);
	
	var Image = __webpack_require__(163);
	
	var env = __webpack_require__(133);
	
	var HOVER_LAYER_ZLEVEL = 1e5;
	var CANVAS_ZLEVEL = 314159;
	var EL_AFTER_INCREMENTAL_INC = 0.01;
	var INCREMENTAL_INC = 0.001;
	
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function isLayerValid(layer) {
	  if (!layer) {
	    return false;
	  }
	
	  if (layer.__builtin__) {
	    return true;
	  }
	
	  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	var tmpRect = new BoundingRect(0, 0, 0, 0);
	var viewRect = new BoundingRect(0, 0, 0, 0);
	
	function isDisplayableCulled(el, width, height) {
	  tmpRect.copy(el.getBoundingRect());
	
	  if (el.transform) {
	    tmpRect.applyTransform(el.transform);
	  }
	
	  viewRect.width = width;
	  viewRect.height = height;
	  return !tmpRect.intersect(viewRect);
	}
	
	function isClipPathChanged(clipPaths, prevClipPaths) {
	  if (clipPaths === prevClipPaths) {
	    // Can both be null or undefined
	    return false;
	  }
	
	  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
	    return true;
	  }
	
	  for (var i = 0; i < clipPaths.length; i++) {
	    if (clipPaths[i] !== prevClipPaths[i]) {
	      return true;
	    }
	  }
	}
	
	function doClip(clipPaths, ctx) {
	  for (var i = 0; i < clipPaths.length; i++) {
	    var clipPath = clipPaths[i];
	    clipPath.setTransform(ctx);
	    ctx.beginPath();
	    clipPath.buildPath(ctx, clipPath.shape);
	    ctx.clip(); // Transform back
	
	    clipPath.restoreTransform(ctx);
	  }
	}
	
	function createRoot(width, height) {
	  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	  domRoot.style.cssText = ['position:relative', 'overflow:hidden', 'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
	  return domRoot;
	}
	/**
	 * @alias module:zrender/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var Painter = function (root, storage, opts) {
	  this.type = 'canvas'; // In node environment using node-canvas
	
	  var singleCanvas = !root.nodeName // In node ?
	  || root.nodeName.toUpperCase() === 'CANVAS';
	  this._opts = opts = util.extend({}, opts || {});
	  /**
	   * @type {number}
	   */
	
	  this.dpr = opts.devicePixelRatio || devicePixelRatio;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._singleCanvas = singleCanvas;
	  /**
	   * 绘图容器
	   * @type {HTMLElement}
	   */
	
	  this.root = root;
	  var rootStyle = root.style;
	
	  if (rootStyle) {
	    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
	    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
	    root.innerHTML = '';
	  }
	  /**
	   * @type {module:zrender/Storage}
	   */
	
	
	  this.storage = storage;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  var zlevelList = this._zlevelList = [];
	  /**
	   * @type {Object.<string, module:zrender/Layer>}
	   * @private
	   */
	
	  var layers = this._layers = {};
	  /**
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._layerConfig = {};
	  /**
	   * zrender will do compositing when root is a canvas and have multiple zlevels.
	   */
	
	  this._needsManuallyCompositing = false;
	
	  if (!singleCanvas) {
	    this._width = this._getSize(0);
	    this._height = this._getSize(1);
	    var domRoot = this._domRoot = createRoot(this._width, this._height);
	    root.appendChild(domRoot);
	  } else {
	    var width = root.width;
	    var height = root.height;
	
	    if (opts.width != null) {
	      width = opts.width;
	    }
	
	    if (opts.height != null) {
	      height = opts.height;
	    }
	
	    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly
	
	    root.width = width * this.dpr;
	    root.height = height * this.dpr;
	    this._width = width;
	    this._height = height; // Create layer if only one given canvas
	    // Device can be specified to create a high dpi image.
	
	    var mainLayer = new Layer(root, this, this.dpr);
	    mainLayer.__builtin__ = true;
	    mainLayer.initContext(); // FIXME Use canvas width and height
	    // mainLayer.resize(width, height);
	
	    layers[CANVAS_ZLEVEL] = mainLayer;
	    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.
	
	    zlevelList.push(CANVAS_ZLEVEL);
	    this._domRoot = root;
	  }
	  /**
	   * @type {module:zrender/Layer}
	   * @private
	   */
	
	
	  this._hoverlayer = null;
	  this._hoverElements = [];
	};
	
	Painter.prototype = {
	  constructor: Painter,
	  getType: function () {
	    return 'canvas';
	  },
	
	  /**
	   * If painter use a single canvas
	   * @return {boolean}
	   */
	  isSingleCanvas: function () {
	    return this._singleCanvas;
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._domRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   * @param {boolean} [paintAll=false] 强制绘制所有displayable
	   */
	  refresh: function (paintAll) {
	    var list = this.storage.getDisplayList(true);
	    var zlevelList = this._zlevelList;
	    this._redrawId = Math.random();
	
	    this._paintList(list, paintAll, this._redrawId); // Paint custum layers
	
	
	    for (var i = 0; i < zlevelList.length; i++) {
	      var z = zlevelList[i];
	      var layer = this._layers[z];
	
	      if (!layer.__builtin__ && layer.refresh) {
	        var clearColor = i === 0 ? this._backgroundColor : null;
	        layer.refresh(clearColor);
	      }
	    }
	
	    this.refreshHover();
	    return this;
	  },
	  addHover: function (el, hoverStyle) {
	    if (el.__hoverMir) {
	      return;
	    }
	
	    var elMirror = new el.constructor({
	      style: el.style,
	      shape: el.shape,
	      z: el.z,
	      z2: el.z2,
	      silent: el.silent
	    });
	    elMirror.__from = el;
	    el.__hoverMir = elMirror;
	    hoverStyle && elMirror.setStyle(hoverStyle);
	
	    this._hoverElements.push(elMirror);
	
	    return elMirror;
	  },
	  removeHover: function (el) {
	    var elMirror = el.__hoverMir;
	    var hoverElements = this._hoverElements;
	    var idx = util.indexOf(hoverElements, elMirror);
	
	    if (idx >= 0) {
	      hoverElements.splice(idx, 1);
	    }
	
	    el.__hoverMir = null;
	  },
	  clearHover: function (el) {
	    var hoverElements = this._hoverElements;
	
	    for (var i = 0; i < hoverElements.length; i++) {
	      var from = hoverElements[i].__from;
	
	      if (from) {
	        from.__hoverMir = null;
	      }
	    }
	
	    hoverElements.length = 0;
	  },
	  refreshHover: function () {
	    var hoverElements = this._hoverElements;
	    var len = hoverElements.length;
	    var hoverLayer = this._hoverlayer;
	    hoverLayer && hoverLayer.clear();
	
	    if (!len) {
	      return;
	    }
	
	    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
	    // FIXME?
	
	    if (!hoverLayer) {
	      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
	    }
	
	    var scope = {};
	    hoverLayer.ctx.save();
	
	    for (var i = 0; i < len;) {
	      var el = hoverElements[i];
	      var originalEl = el.__from; // Original el is removed
	      // PENDING
	
	      if (!(originalEl && originalEl.__zr)) {
	        hoverElements.splice(i, 1);
	        originalEl.__hoverMir = null;
	        len--;
	        continue;
	      }
	
	      i++; // Use transform
	      // FIXME style and shape ?
	
	      if (!originalEl.invisible) {
	        el.transform = originalEl.transform;
	        el.invTransform = originalEl.invTransform;
	        el.__clipPaths = originalEl.__clipPaths; // el.
	
	        this._doPaintEl(el, hoverLayer, true, scope);
	      }
	    }
	
	    hoverLayer.ctx.restore();
	  },
	  getHoverLayer: function () {
	    return this.getLayer(HOVER_LAYER_ZLEVEL);
	  },
	  _paintList: function (list, paintAll, redrawId) {
	    if (this._redrawId !== redrawId) {
	      return;
	    }
	
	    paintAll = paintAll || false;
	
	    this._updateLayerStatus(list);
	
	    var finished = this._doPaintList(list, paintAll);
	
	    if (this._needsManuallyCompositing) {
	      this._compositeManually();
	    }
	
	    if (!finished) {
	      var self = this;
	      requestAnimationFrame(function () {
	        self._paintList(list, paintAll, redrawId);
	      });
	    }
	  },
	  _compositeManually: function () {
	    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
	    var width = this._domRoot.width;
	    var height = this._domRoot.height;
	    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?
	
	    this.eachBuiltinLayer(function (layer) {
	      if (layer.virtual) {
	        ctx.drawImage(layer.dom, 0, 0, width, height);
	      }
	    });
	  },
	  _doPaintList: function (list, paintAll) {
	    var layerList = [];
	
	    for (var zi = 0; zi < this._zlevelList.length; zi++) {
	      var zlevel = this._zlevelList[zi];
	      var layer = this._layers[zlevel];
	
	      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
	        layerList.push(layer);
	      }
	    }
	
	    var finished = true;
	
	    for (var k = 0; k < layerList.length; k++) {
	      var layer = layerList[k];
	      var ctx = layer.ctx;
	      var scope = {};
	      ctx.save();
	      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
	      var useTimer = !paintAll && layer.incremental && Date.now;
	      var startTime = useTimer && Date.now();
	      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.
	
	      if (layer.__startIndex === layer.__endIndex) {
	        layer.clear(false, clearColor);
	      } else if (start === layer.__startIndex) {
	        var firstEl = list[start];
	
	        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
	          layer.clear(false, clearColor);
	        }
	      }
	
	      if (start === -1) {
	        console.error('For some unknown reason. drawIndex is -1');
	        start = layer.__startIndex;
	      }
	
	      for (var i = start; i < layer.__endIndex; i++) {
	        var el = list[i];
	
	        this._doPaintEl(el, layer, paintAll, scope);
	
	        el.__dirty = el.__dirtyText = false;
	
	        if (useTimer) {
	          // Date.now can be executed in 13,025,305 ops/second.
	          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
	          // The rest elements will be drawn in the next frame.
	
	          if (dTime > 15) {
	            break;
	          }
	        }
	      }
	
	      layer.__drawIndex = i;
	
	      if (layer.__drawIndex < layer.__endIndex) {
	        finished = false;
	      }
	
	      if (scope.prevElClipPaths) {
	        // Needs restore the state. If last drawn element is in the clipping area.
	        ctx.restore();
	      }
	
	      ctx.restore();
	    }
	
	    if (env.wxa) {
	      // Flush for weixin application
	      util.each(this._layers, function (layer) {
	        if (layer && layer.ctx && layer.ctx.draw) {
	          layer.ctx.draw();
	        }
	      });
	    }
	
	    return finished;
	  },
	  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
	    var ctx = currentLayer.ctx;
	    var m = el.transform;
	
	    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
	    !el.invisible // Ignore transparent element
	    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
	    // Draw a scale 0 element can cause all following draw wrong
	    // And setTransform with scale 0 will cause set back transform failed.
	    && !(m && !m[0] && !m[3]) // Ignore culled element
	    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
	      var clipPaths = el.__clipPaths; // Optimize when clipping on group with several elements
	
	      if (!scope.prevElClipPaths || isClipPathChanged(clipPaths, scope.prevElClipPaths)) {
	        // If has previous clipping state, restore from it
	        if (scope.prevElClipPaths) {
	          currentLayer.ctx.restore();
	          scope.prevElClipPaths = null; // Reset prevEl since context has been restored
	
	          scope.prevEl = null;
	        } // New clipping state
	
	
	        if (clipPaths) {
	          ctx.save();
	          doClip(clipPaths, ctx);
	          scope.prevElClipPaths = clipPaths;
	        }
	      }
	
	      el.beforeBrush && el.beforeBrush(ctx);
	      el.brush(ctx, scope.prevEl || null);
	      scope.prevEl = el;
	      el.afterBrush && el.afterBrush(ctx);
	    }
	  },
	
	  /**
	   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
	   * @param {number} zlevel
	   * @param {boolean} virtual Virtual layer will not be inserted into dom.
	   * @return {module:zrender/Layer}
	   */
	  getLayer: function (zlevel, virtual) {
	    if (this._singleCanvas && !this._needsManuallyCompositing) {
	      zlevel = CANVAS_ZLEVEL;
	    }
	
	    var layer = this._layers[zlevel];
	
	    if (!layer) {
	      // Create a new layer
	      layer = new Layer('zr_' + zlevel, this, this.dpr);
	      layer.zlevel = zlevel;
	      layer.__builtin__ = true;
	
	      if (this._layerConfig[zlevel]) {
	        util.merge(layer, this._layerConfig[zlevel], true);
	      }
	
	      if (virtual) {
	        layer.virtual = virtual;
	      }
	
	      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
	      // Or excanvas will get 0px clientWidth and clientHeight
	
	      layer.initContext();
	    }
	
	    return layer;
	  },
	  insertLayer: function (zlevel, layer) {
	    var layersMap = this._layers;
	    var zlevelList = this._zlevelList;
	    var len = zlevelList.length;
	    var prevLayer = null;
	    var i = -1;
	    var domRoot = this._domRoot;
	
	    if (layersMap[zlevel]) {
	      log('ZLevel ' + zlevel + ' has been used already');
	      return;
	    } // Check if is a valid layer
	
	
	    if (!isLayerValid(layer)) {
	      log('Layer of zlevel ' + zlevel + ' is not valid');
	      return;
	    }
	
	    if (len > 0 && zlevel > zlevelList[0]) {
	      for (i = 0; i < len - 1; i++) {
	        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
	          break;
	        }
	      }
	
	      prevLayer = layersMap[zlevelList[i]];
	    }
	
	    zlevelList.splice(i + 1, 0, zlevel);
	    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
	    // (It can be a WebGL layer and assigned to a ZImage element)
	    // But it still under management of zrender.
	
	    if (!layer.virtual) {
	      if (prevLayer) {
	        var prevDom = prevLayer.dom;
	
	        if (prevDom.nextSibling) {
	          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      } else {
	        if (domRoot.firstChild) {
	          domRoot.insertBefore(layer.dom, domRoot.firstChild);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      }
	    }
	  },
	  // Iterate each layer
	  eachLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      cb.call(context, this._layers[z], z);
	    }
	  },
	  // Iterate each buildin layer
	  eachBuiltinLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	  // Iterate each other layer except buildin layer
	  eachOtherLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (!layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	
	  /**
	   * 获取所有已创建的层
	   * @param {Array.<module:zrender/Layer>} [prevLayer]
	   */
	  getLayers: function () {
	    return this._layers;
	  },
	  _updateLayerStatus: function (list) {
	    this.eachBuiltinLayer(function (layer, z) {
	      layer.__dirty = layer.__used = false;
	    });
	
	    function updatePrevLayer(idx) {
	      if (prevLayer) {
	        if (prevLayer.__endIndex !== idx) {
	          prevLayer.__dirty = true;
	        }
	
	        prevLayer.__endIndex = idx;
	      }
	    }
	
	    if (this._singleCanvas) {
	      for (var i = 1; i < list.length; i++) {
	        var el = list[i];
	
	        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
	          this._needsManuallyCompositing = true;
	          break;
	        }
	      }
	    }
	
	    var prevLayer = null;
	    var incrementalLayerCount = 0;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	      var zlevel = el.zlevel;
	      var layer; // PENDING If change one incremental element style ?
	      // TODO Where there are non-incremental elements between incremental elements.
	
	      if (el.incremental) {
	        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
	        layer.incremental = true;
	        incrementalLayerCount = 1;
	      } else {
	        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
	      }
	
	      if (!layer.__builtin__) {
	        log('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
	      }
	
	      if (layer !== prevLayer) {
	        layer.__used = true;
	
	        if (layer.__startIndex !== i) {
	          layer.__dirty = true;
	        }
	
	        layer.__startIndex = i;
	
	        if (!layer.incremental) {
	          layer.__drawIndex = i;
	        } else {
	          // Mark layer draw index needs to update.
	          layer.__drawIndex = -1;
	        }
	
	        updatePrevLayer(i);
	        prevLayer = layer;
	      }
	
	      if (el.__dirty) {
	        layer.__dirty = true;
	
	        if (layer.incremental && layer.__drawIndex < 0) {
	          // Start draw from the first dirty element.
	          layer.__drawIndex = i;
	        }
	      }
	    }
	
	    updatePrevLayer(i);
	    this.eachBuiltinLayer(function (layer, z) {
	      // Used in last frame but not in this frame. Needs clear
	      if (!layer.__used && layer.getElementCount() > 0) {
	        layer.__dirty = true;
	        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
	      } // For incremental layer. In case start index changed and no elements are dirty.
	
	
	      if (layer.__dirty && layer.__drawIndex < 0) {
	        layer.__drawIndex = layer.__startIndex;
	      }
	    });
	  },
	
	  /**
	   * 清除hover层外所有内容
	   */
	  clear: function () {
	    this.eachBuiltinLayer(this._clearLayer);
	    return this;
	  },
	  _clearLayer: function (layer) {
	    layer.clear();
	  },
	  setBackgroundColor: function (backgroundColor) {
	    this._backgroundColor = backgroundColor;
	  },
	
	  /**
	   * 修改指定zlevel的绘制参数
	   *
	   * @param {string} zlevel
	   * @param {Object} config 配置对象
	   * @param {string} [config.clearColor=0] 每次清空画布的颜色
	   * @param {string} [config.motionBlur=false] 是否开启动态模糊
	   * @param {number} [config.lastFrameAlpha=0.7]
	   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   */
	  configLayer: function (zlevel, config) {
	    if (config) {
	      var layerConfig = this._layerConfig;
	
	      if (!layerConfig[zlevel]) {
	        layerConfig[zlevel] = config;
	      } else {
	        util.merge(layerConfig[zlevel], config, true);
	      }
	
	      for (var i = 0; i < this._zlevelList.length; i++) {
	        var _zlevel = this._zlevelList[i];
	
	        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
	          var layer = this._layers[_zlevel];
	          util.merge(layer, layerConfig[zlevel], true);
	        }
	      }
	    }
	  },
	
	  /**
	   * 删除指定层
	   * @param {number} zlevel 层所在的zlevel
	   */
	  delLayer: function (zlevel) {
	    var layers = this._layers;
	    var zlevelList = this._zlevelList;
	    var layer = layers[zlevel];
	
	    if (!layer) {
	      return;
	    }
	
	    layer.dom.parentNode.removeChild(layer.dom);
	    delete layers[zlevel];
	    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
	  },
	
	  /**
	   * 区域大小变化后重绘
	   */
	  resize: function (width, height) {
	    if (!this._domRoot.style) {
	      // Maybe in node or worker
	      if (width == null || height == null) {
	        return;
	      }
	
	      this._width = width;
	      this._height = height;
	      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
	    } else {
	      var domRoot = this._domRoot; // FIXME Why ?
	
	      domRoot.style.display = 'none'; // Save input w/h
	
	      var opts = this._opts;
	      width != null && (opts.width = width);
	      height != null && (opts.height = height);
	      width = this._getSize(0);
	      height = this._getSize(1);
	      domRoot.style.display = ''; // 优化没有实际改变的resize
	
	      if (this._width !== width || height !== this._height) {
	        domRoot.style.width = width + 'px';
	        domRoot.style.height = height + 'px';
	
	        for (var id in this._layers) {
	          if (this._layers.hasOwnProperty(id)) {
	            this._layers[id].resize(width, height);
	          }
	        }
	
	        util.each(this._progressiveLayers, function (layer) {
	          layer.resize(width, height);
	        });
	        this.refresh(true);
	      }
	
	      this._width = width;
	      this._height = height;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清除单独的一个层
	   * @param {number} zlevel
	   */
	  clearLayer: function (zlevel) {
	    var layer = this._layers[zlevel];
	
	    if (layer) {
	      layer.clear();
	    }
	  },
	
	  /**
	   * 释放
	   */
	  dispose: function () {
	    this.root.innerHTML = '';
	    this.root = this.storage = this._domRoot = this._layers = null;
	  },
	
	  /**
	   * Get canvas which has all thing rendered
	   * @param {Object} opts
	   * @param {string} [opts.backgroundColor]
	   * @param {number} [opts.pixelRatio]
	   */
	  getRenderedCanvas: function (opts) {
	    opts = opts || {};
	
	    if (this._singleCanvas && !this._compositeManually) {
	      return this._layers[CANVAS_ZLEVEL].dom;
	    }
	
	    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	    imageLayer.initContext();
	    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
	
	    if (opts.pixelRatio <= this.dpr) {
	      this.refresh();
	      var width = imageLayer.dom.width;
	      var height = imageLayer.dom.height;
	      var ctx = imageLayer.ctx;
	      this.eachLayer(function (layer) {
	        if (layer.__builtin__) {
	          ctx.drawImage(layer.dom, 0, 0, width, height);
	        } else if (layer.renderToCanvas) {
	          imageLayer.ctx.save();
	          layer.renderToCanvas(imageLayer.ctx);
	          imageLayer.ctx.restore();
	        }
	      });
	    } else {
	      // PENDING, echarts-gl and incremental rendering.
	      var scope = {};
	      var displayList = this.storage.getDisplayList(true);
	
	      for (var i = 0; i < displayList.length; i++) {
	        var el = displayList[i];
	
	        this._doPaintEl(el, imageLayer, true, scope);
	      }
	    }
	
	    return imageLayer.dom;
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  pathToImage: function (path, dpr) {
	    dpr = dpr || this.dpr;
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var rect = path.getBoundingRect();
	    var style = path.style;
	    var shadowBlurSize = style.shadowBlur * dpr;
	    var shadowOffsetX = style.shadowOffsetX * dpr;
	    var shadowOffsetY = style.shadowOffsetY * dpr;
	    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
	    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
	    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
	    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
	    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
	    var width = rect.width + leftMargin + rightMargin;
	    var height = rect.height + topMargin + bottomMargin;
	    canvas.width = width * dpr;
	    canvas.height = height * dpr;
	    ctx.scale(dpr, dpr);
	    ctx.clearRect(0, 0, width, height);
	    ctx.dpr = dpr;
	    var pathTransform = {
	      position: path.position,
	      rotation: path.rotation,
	      scale: path.scale
	    };
	    path.position = [leftMargin - rect.x, topMargin - rect.y];
	    path.rotation = 0;
	    path.scale = [1, 1];
	    path.updateTransform();
	
	    if (path) {
	      path.brush(ctx);
	    }
	
	    var ImageShape = Image;
	    var imgShape = new ImageShape({
	      style: {
	        x: 0,
	        y: 0,
	        image: canvas
	      }
	    });
	
	    if (pathTransform.position != null) {
	      imgShape.position = path.position = pathTransform.position;
	    }
	
	    if (pathTransform.rotation != null) {
	      imgShape.rotation = path.rotation = pathTransform.rotation;
	    }
	
	    if (pathTransform.scale != null) {
	      imgShape.scale = path.scale = pathTransform.scale;
	    }
	
	    return imgShape;
	  }
	};
	var _default = Painter;
	module.exports = _default;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(134);
	
	var _config = __webpack_require__(153);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var Style = __webpack_require__(158);
	
	var Pattern = __webpack_require__(161);
	
	/**
	 * @module zrender/Layer
	 * @author pissang(https://www.github.com/pissang)
	 */
	function returnFalse() {
	  return false;
	}
	/**
	 * 创建dom
	 *
	 * @inner
	 * @param {string} id dom id 待用
	 * @param {Painter} painter painter instance
	 * @param {number} number
	 */
	
	
	function createDom(id, painter, dpr) {
	  var newDom = util.createCanvas();
	  var width = painter.getWidth();
	  var height = painter.getHeight();
	  var newDomStyle = newDom.style;
	
	  if (newDomStyle) {
	    // In node or some other non-browser environment
	    newDomStyle.position = 'absolute';
	    newDomStyle.left = 0;
	    newDomStyle.top = 0;
	    newDomStyle.width = width + 'px';
	    newDomStyle.height = height + 'px';
	    newDom.setAttribute('data-zr-dom-id', id);
	  }
	
	  newDom.width = width * dpr;
	  newDom.height = height * dpr;
	  return newDom;
	}
	/**
	 * @alias module:zrender/Layer
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @param {string} id
	 * @param {module:zrender/Painter} painter
	 * @param {number} [dpr]
	 */
	
	
	var Layer = function (id, painter, dpr) {
	  var dom;
	  dpr = dpr || devicePixelRatio;
	
	  if (typeof id === 'string') {
	    dom = createDom(id, painter, dpr);
	  } // Not using isDom because in node it will return false
	  else if (util.isObject(id)) {
	      dom = id;
	      id = dom.id;
	    }
	
	  this.id = id;
	  this.dom = dom;
	  var domStyle = dom.style;
	
	  if (domStyle) {
	    // Not in node
	    dom.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	    domStyle['-webkit-user-select'] = 'none';
	    domStyle['user-select'] = 'none';
	    domStyle['-webkit-touch-callout'] = 'none';
	    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
	    domStyle['padding'] = 0;
	    domStyle['margin'] = 0;
	    domStyle['border-width'] = 0;
	  }
	
	  this.domBack = null;
	  this.ctxBack = null;
	  this.painter = painter;
	  this.config = null; // Configs
	
	  /**
	   * 每次清空画布的颜色
	   * @type {string}
	   * @default 0
	   */
	
	  this.clearColor = 0;
	  /**
	   * 是否开启动态模糊
	   * @type {boolean}
	   * @default false
	   */
	
	  this.motionBlur = false;
	  /**
	   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   * @type {number}
	   * @default 0.7
	   */
	
	  this.lastFrameAlpha = 0.7;
	  /**
	   * Layer dpr
	   * @type {number}
	   */
	
	  this.dpr = dpr;
	};
	
	Layer.prototype = {
	  constructor: Layer,
	  __dirty: true,
	  __used: false,
	  __drawIndex: 0,
	  __startIndex: 0,
	  __endIndex: 0,
	  incremental: false,
	  getElementCount: function () {
	    return this.__endIndex - this.__startIndex;
	  },
	  initContext: function () {
	    this.ctx = this.dom.getContext('2d');
	    this.ctx.dpr = this.dpr;
	  },
	  createBackBuffer: function () {
	    var dpr = this.dpr;
	    this.domBack = createDom('back-' + this.id, this.painter, dpr);
	    this.ctxBack = this.domBack.getContext('2d');
	
	    if (dpr !== 1) {
	      this.ctxBack.scale(dpr, dpr);
	    }
	  },
	
	  /**
	   * @param  {number} width
	   * @param  {number} height
	   */
	  resize: function (width, height) {
	    var dpr = this.dpr;
	    var dom = this.dom;
	    var domStyle = dom.style;
	    var domBack = this.domBack;
	
	    if (domStyle) {
	      domStyle.width = width + 'px';
	      domStyle.height = height + 'px';
	    }
	
	    dom.width = width * dpr;
	    dom.height = height * dpr;
	
	    if (domBack) {
	      domBack.width = width * dpr;
	      domBack.height = height * dpr;
	
	      if (dpr !== 1) {
	        this.ctxBack.scale(dpr, dpr);
	      }
	    }
	  },
	
	  /**
	   * 清空该层画布
	   * @param {boolean} [clearAll]=false Clear all with out motion blur
	   * @param {Color} [clearColor]
	   */
	  clear: function (clearAll, clearColor) {
	    var dom = this.dom;
	    var ctx = this.ctx;
	    var width = dom.width;
	    var height = dom.height;
	    var clearColor = clearColor || this.clearColor;
	    var haveMotionBLur = this.motionBlur && !clearAll;
	    var lastFrameAlpha = this.lastFrameAlpha;
	    var dpr = this.dpr;
	
	    if (haveMotionBLur) {
	      if (!this.domBack) {
	        this.createBackBuffer();
	      }
	
	      this.ctxBack.globalCompositeOperation = 'copy';
	      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	    }
	
	    ctx.clearRect(0, 0, width, height);
	
	    if (clearColor && clearColor !== 'transparent') {
	      var clearColorGradientOrPattern; // Gradient
	
	      if (clearColor.colorStops) {
	        // Cache canvas gradient
	        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        });
	        clearColor.__canvasGradient = clearColorGradientOrPattern;
	      } // Pattern
	      else if (clearColor.image) {
	          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
	        }
	
	      ctx.save();
	      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	      ctx.fillRect(0, 0, width, height);
	      ctx.restore();
	    }
	
	    if (haveMotionBLur) {
	      var domBack = this.domBack;
	      ctx.save();
	      ctx.globalAlpha = lastFrameAlpha;
	      ctx.drawImage(domBack, 0, 0, width, height);
	      ctx.restore();
	    }
	  }
	};
	var _default = Layer;
	module.exports = _default;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var fixShadow = __webpack_require__(159);
	
	var _constant = __webpack_require__(160);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
	// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
	
	var Style = function (opts) {
	  this.extendFrom(opts, false);
	};
	
	function createLinearGradient(ctx, obj, rect) {
	  var x = obj.x == null ? 0 : obj.x;
	  var x2 = obj.x2 == null ? 1 : obj.x2;
	  var y = obj.y == null ? 0 : obj.y;
	  var y2 = obj.y2 == null ? 0 : obj.y2;
	
	  if (!obj.global) {
	    x = x * rect.width + rect.x;
	    x2 = x2 * rect.width + rect.x;
	    y = y * rect.height + rect.y;
	    y2 = y2 * rect.height + rect.y;
	  } // Fix NaN when rect is Infinity
	
	
	  x = isNaN(x) ? 0 : x;
	  x2 = isNaN(x2) ? 1 : x2;
	  y = isNaN(y) ? 0 : y;
	  y2 = isNaN(y2) ? 0 : y2;
	  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	  return canvasGradient;
	}
	
	function createRadialGradient(ctx, obj, rect) {
	  var width = rect.width;
	  var height = rect.height;
	  var min = Math.min(width, height);
	  var x = obj.x == null ? 0.5 : obj.x;
	  var y = obj.y == null ? 0.5 : obj.y;
	  var r = obj.r == null ? 0.5 : obj.r;
	
	  if (!obj.global) {
	    x = x * width + rect.x;
	    y = y * height + rect.y;
	    r = r * min;
	  }
	
	  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	  return canvasGradient;
	}
	
	Style.prototype = {
	  constructor: Style,
	
	  /**
	   * @type {string}
	   */
	  fill: '#000',
	
	  /**
	   * @type {string}
	   */
	  stroke: null,
	
	  /**
	   * @type {number}
	   */
	  opacity: 1,
	
	  /**
	   * @type {number}
	   */
	  fillOpacity: null,
	
	  /**
	   * @type {number}
	   */
	  strokeOpacity: null,
	
	  /**
	   * @type {Array.<number>}
	   */
	  lineDash: null,
	
	  /**
	   * @type {number}
	   */
	  lineDashOffset: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetY: 0,
	
	  /**
	   * @type {number}
	   */
	  lineWidth: 1,
	
	  /**
	   * If stroke ignore scale
	   * @type {Boolean}
	   */
	  strokeNoScale: false,
	  // Bounding rect text configuration
	  // Not affected by element transform
	
	  /**
	   * @type {string}
	   */
	  text: null,
	
	  /**
	   * If `fontSize` or `fontFamily` exists, `font` will be reset by
	   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
	   * So do not visit it directly in upper application (like echarts),
	   * but use `contain/text#makeFont` instead.
	   * @type {string}
	   */
	  font: null,
	
	  /**
	   * The same as font. Use font please.
	   * @deprecated
	   * @type {string}
	   */
	  textFont: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontStyle: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontWeight: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * Should be 12 but not '12px'.
	   * @type {number}
	   */
	  fontSize: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontFamily: null,
	
	  /**
	   * Reserved for special functinality, like 'hr'.
	   * @type {string}
	   */
	  textTag: null,
	
	  /**
	   * @type {string}
	   */
	  textFill: '#000',
	
	  /**
	   * @type {string}
	   */
	  textStroke: null,
	
	  /**
	   * @type {number}
	   */
	  textWidth: null,
	
	  /**
	   * Only for textBackground.
	   * @type {number}
	   */
	  textHeight: null,
	
	  /**
	   * textStroke may be set as some color as a default
	   * value in upper applicaion, where the default value
	   * of textStrokeWidth should be 0 to make sure that
	   * user can choose to do not use text stroke.
	   * @type {number}
	   */
	  textStrokeWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textLineHeight: null,
	
	  /**
	   * 'inside', 'left', 'right', 'top', 'bottom'
	   * [x, y]
	   * Based on x, y of rect.
	   * @type {string|Array.<number>}
	   * @default 'inside'
	   */
	  textPosition: 'inside',
	
	  /**
	   * If not specified, use the boundingRect of a `displayable`.
	   * @type {Object}
	   */
	  textRect: null,
	
	  /**
	   * [x, y]
	   * @type {Array.<number>}
	   */
	  textOffset: null,
	
	  /**
	   * @type {string}
	   */
	  textAlign: null,
	
	  /**
	   * @type {string}
	   */
	  textVerticalAlign: null,
	
	  /**
	   * @type {number}
	   */
	  textDistance: 5,
	
	  /**
	   * @type {string}
	   */
	  textShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetY: 0,
	
	  /**
	   * @type {string}
	   */
	  textBoxShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetY: 0,
	
	  /**
	   * Whether transform text.
	   * Only useful in Path and Image element
	   * @type {boolean}
	   */
	  transformText: false,
	
	  /**
	   * Text rotate around position of Path or Image
	   * Only useful in Path and Image element and transformText is false.
	   */
	  textRotation: 0,
	
	  /**
	   * Text origin of text rotation, like [10, 40].
	   * Based on x, y of rect.
	   * Useful in label rotation of circular symbol.
	   * By default, this origin is textPosition.
	   * Can be 'center'.
	   * @type {string|Array.<number>}
	   */
	  textOrigin: null,
	
	  /**
	   * @type {string}
	   */
	  textBackgroundColor: null,
	
	  /**
	   * @type {string}
	   */
	  textBorderColor: null,
	
	  /**
	   * @type {number}
	   */
	  textBorderWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textBorderRadius: 0,
	
	  /**
	   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
	   * @type {number|Array.<number>}
	   */
	  textPadding: null,
	
	  /**
	   * Text styles for rich text.
	   * @type {Object}
	   */
	  rich: null,
	
	  /**
	   * {outerWidth, outerHeight, ellipsis, placeholder}
	   * @type {Object}
	   */
	  truncate: null,
	
	  /**
	   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	   * @type {string}
	   */
	  blend: null,
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  bind: function (ctx, el, prevEl) {
	    var style = this;
	    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
	    // Only apply cache if the last time cachced by this function.
	
	    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
	    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;
	
	    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	      var prop = STYLE_COMMON_PROPS[i];
	      var styleName = prop[0];
	
	      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
	        // FIXME Invalid property value will cause style leak from previous element.
	        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
	      }
	    }
	
	    if (notCheckCache || style.fill !== prevStyle.fill) {
	      ctx.fillStyle = style.fill;
	    }
	
	    if (notCheckCache || style.stroke !== prevStyle.stroke) {
	      ctx.strokeStyle = style.stroke;
	    }
	
	    if (notCheckCache || style.opacity !== prevStyle.opacity) {
	      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	    }
	
	    if (notCheckCache || style.blend !== prevStyle.blend) {
	      ctx.globalCompositeOperation = style.blend || 'source-over';
	    }
	
	    if (this.hasStroke()) {
	      var lineWidth = style.lineWidth;
	      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
	    }
	  },
	  hasFill: function () {
	    var fill = this.fill;
	    return fill != null && fill !== 'none';
	  },
	  hasStroke: function () {
	    var stroke = this.stroke;
	    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
	  },
	
	  /**
	   * Extend from other style
	   * @param {zrender/graphic/Style} otherStyle
	   * @param {boolean} overwrite true: overwrirte any way.
	   *                            false: overwrite only when !target.hasOwnProperty
	   *                            others: overwrite when property is not null/undefined.
	   */
	  extendFrom: function (otherStyle, overwrite) {
	    if (otherStyle) {
	      for (var name in otherStyle) {
	        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
	          this[name] = otherStyle[name];
	        }
	      }
	    }
	  },
	
	  /**
	   * Batch setting style with a given object
	   * @param {Object|string} obj
	   * @param {*} [obj]
	   */
	  set: function (obj, value) {
	    if (typeof obj === 'string') {
	      this[obj] = value;
	    } else {
	      this.extendFrom(obj, true);
	    }
	  },
	
	  /**
	   * Clone
	   * @return {zrender/graphic/Style} [description]
	   */
	  clone: function () {
	    var newStyle = new this.constructor();
	    newStyle.extendFrom(this, true);
	    return newStyle;
	  },
	  getGradient: function (ctx, obj, rect) {
	    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
	    var canvasGradient = method(ctx, obj, rect);
	    var colorStops = obj.colorStops;
	
	    for (var i = 0; i < colorStops.length; i++) {
	      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	    }
	
	    return canvasGradient;
	  }
	};
	var styleProto = Style.prototype;
	
	for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	  var prop = STYLE_COMMON_PROPS[i];
	
	  if (!(prop[0] in styleProto)) {
	    styleProto[prop[0]] = prop[1];
	  }
	} // Provide for others
	
	
	Style.getGradient = styleProto.getGradient;
	var _default = Style;
	module.exports = _default;

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	var SHADOW_PROPS = {
	  'shadowBlur': 1,
	  'shadowOffsetX': 1,
	  'shadowOffsetY': 1,
	  'textShadowBlur': 1,
	  'textShadowOffsetX': 1,
	  'textShadowOffsetY': 1,
	  'textBoxShadowBlur': 1,
	  'textBoxShadowOffsetX': 1,
	  'textBoxShadowOffsetY': 1
	};
	
	function _default(ctx, propName, value) {
	  if (SHADOW_PROPS.hasOwnProperty(propName)) {
	    return value *= ctx.dpr;
	  }
	
	  return value;
	}
	
	module.exports = _default;

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	var ContextCachedBy = {
	  NONE: 0,
	  STYLE_BIND: 1,
	  PLAIN_TEXT: 2
	}; // Avoid confused with 0/false.
	
	var WILL_BE_RESTORED = 9;
	exports.ContextCachedBy = ContextCachedBy;
	exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	var Pattern = function (image, repeat) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {image: ...}`, where this constructor will not be called.
	  this.image = image;
	  this.repeat = repeat; // Can be cloned
	
	  this.type = 'pattern';
	};
	
	Pattern.prototype.getCanvasPattern = function (ctx) {
	  return ctx.createPattern(this.image, this.repeat || 'repeat');
	};
	
	var _default = Pattern;
	module.exports = _default;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
	window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
	  setTimeout(func, 16);
	};
	
	module.exports = _default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(164);
	
	var BoundingRect = __webpack_require__(154);
	
	var zrUtil = __webpack_require__(134);
	
	var imageHelper = __webpack_require__(168);
	
	/**
	 * @alias zrender/graphic/Image
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	function ZImage(opts) {
	  Displayable.call(this, opts);
	}
	
	ZImage.prototype = {
	  constructor: ZImage,
	  type: 'image',
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var src = style.image; // Must bind each time
	
	    style.bind(ctx, this, prevEl);
	    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);
	
	    if (!image || !imageHelper.isImageReady(image)) {
	      return;
	    } // 图片已经加载完成
	    // if (image.nodeName.toUpperCase() == 'IMG') {
	    //     if (!image.complete) {
	    //         return;
	    //     }
	    // }
	    // Else is canvas
	
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var width = style.width;
	    var height = style.height;
	    var aspect = image.width / image.height;
	
	    if (width == null && height != null) {
	      // Keep image/height ratio
	      width = height * aspect;
	    } else if (height == null && width != null) {
	      height = width / aspect;
	    } else if (width == null && height == null) {
	      width = image.width;
	      height = image.height;
	    } // 设置transform
	
	
	    this.setTransform(ctx);
	
	    if (style.sWidth && style.sHeight) {
	      var sx = style.sx || 0;
	      var sy = style.sy || 0;
	      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	    } else if (style.sx && style.sy) {
	      var sx = style.sx;
	      var sy = style.sy;
	      var sWidth = width - sx;
	      var sHeight = height - sy;
	      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	    } else {
	      ctx.drawImage(image, x, y, width, height);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  getBoundingRect: function () {
	    var style = this.style;
	
	    if (!this._rect) {
	      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(ZImage, Displayable);
	var _default = ZImage;
	module.exports = _default;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(134);
	
	var Style = __webpack_require__(158);
	
	var Element = __webpack_require__(143);
	
	var RectText = __webpack_require__(165);
	
	/**
	 * 可绘制的图形基类
	 * Base class of all displayable graphic objects
	 * @module zrender/graphic/Displayable
	 */
	
	/**
	 * @alias module:zrender/graphic/Displayable
	 * @extends module:zrender/Element
	 * @extends module:zrender/graphic/mixin/RectText
	 */
	function Displayable(opts) {
	  opts = opts || {};
	  Element.call(this, opts); // Extend properties
	
	  for (var name in opts) {
	    if (opts.hasOwnProperty(name) && name !== 'style') {
	      this[name] = opts[name];
	    }
	  }
	  /**
	   * @type {module:zrender/graphic/Style}
	   */
	
	
	  this.style = new Style(opts.style, this);
	  this._rect = null; // Shapes for cascade clipping.
	
	  this.__clipPaths = []; // FIXME Stateful must be mixined after style is setted
	  // Stateful.call(this, opts);
	}
	
	Displayable.prototype = {
	  constructor: Displayable,
	  type: 'displayable',
	
	  /**
	   * Displayable 是否为脏，Painter 中会根据该标记判断是否需要是否需要重新绘制
	   * Dirty flag. From which painter will determine if this displayable object needs brush
	   * @name module:zrender/graphic/Displayable#__dirty
	   * @type {boolean}
	   */
	  __dirty: true,
	
	  /**
	   * 图形是否可见，为true时不绘制图形，但是仍能触发鼠标事件
	   * If ignore drawing of the displayable object. Mouse event will still be triggered
	   * @name module:/zrender/graphic/Displayable#invisible
	   * @type {boolean}
	   * @default false
	   */
	  invisible: false,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z: 0,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z2: 0,
	
	  /**
	   * z层level，决定绘画在哪层canvas中
	   * @name module:/zrender/graphic/Displayable#zlevel
	   * @type {number}
	   * @default 0
	   */
	  zlevel: 0,
	
	  /**
	   * 是否可拖拽
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  draggable: false,
	
	  /**
	   * 是否正在拖拽
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  dragging: false,
	
	  /**
	   * 是否相应鼠标事件
	   * @name module:/zrender/graphic/Displayable#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * If enable culling
	   * @type {boolean}
	   * @default false
	   */
	  culling: false,
	
	  /**
	   * Mouse cursor when hovered
	   * @name module:/zrender/graphic/Displayable#cursor
	   * @type {string}
	   */
	  cursor: 'pointer',
	
	  /**
	   * If hover area is bounding rect
	   * @name module:/zrender/graphic/Displayable#rectHover
	   * @type {string}
	   */
	  rectHover: false,
	
	  /**
	   * Render the element progressively when the value >= 0,
	   * usefull for large data.
	   * @type {boolean}
	   */
	  progressive: false,
	
	  /**
	   * @type {boolean}
	   */
	  incremental: false,
	
	  /**
	   * Scale ratio for global scale.
	   * @type {boolean}
	   */
	  globalScaleRatio: 1,
	  beforeBrush: function (ctx) {},
	  afterBrush: function (ctx) {},
	
	  /**
	   * 图形绘制方法
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  // Interface
	  brush: function (ctx, prevEl) {},
	
	  /**
	   * 获取最小包围盒
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // Interface
	  getBoundingRect: function () {},
	
	  /**
	   * 判断坐标 x, y 是否在图形上
	   * If displayable element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  contain: function (x, y) {
	    return this.rectContain(x, y);
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    cb.call(context, this);
	  },
	
	  /**
	   * 判断坐标 x, y 是否在图形的包围盒上
	   * If bounding rect of element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  rectContain: function (x, y) {
	    var coord = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    return rect.contain(coord[0], coord[1]);
	  },
	
	  /**
	   * 标记图形元素为脏，并且在下一帧重绘
	   * Mark displayable element dirty and refresh next frame
	   */
	  dirty: function () {
	    this.__dirty = this.__dirtyText = true;
	    this._rect = null;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * 图形是否会触发事件
	   * If displayable object binded any event
	   * @return {boolean}
	   */
	  // TODO, 通过 bind 绑定的事件
	  // isSilent: function () {
	  //     return !(
	  //         this.hoverable || this.draggable
	  //         || this.onmousemove || this.onmouseover || this.onmouseout
	  //         || this.onmousedown || this.onmouseup || this.onclick
	  //         || this.ondragenter || this.ondragover || this.ondragleave
	  //         || this.ondrop
	  //     );
	  // },
	
	  /**
	   * Alias for animate('style')
	   * @param {boolean} loop
	   */
	  animateStyle: function (loop) {
	    return this.animate('style', loop);
	  },
	  attrKV: function (key, value) {
	    if (key !== 'style') {
	      Element.prototype.attrKV.call(this, key, value);
	    } else {
	      this.style.set(value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setStyle: function (key, value) {
	    this.style.set(key, value);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * Use given style object
	   * @param  {Object} obj
	   */
	  useStyle: function (obj) {
	    this.style = new Style(obj, this);
	    this.dirty(false);
	    return this;
	  }
	};
	zrUtil.inherits(Displayable, Element);
	zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);
	
	var _default = Displayable;
	module.exports = _default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var textHelper = __webpack_require__(166);
	
	var BoundingRect = __webpack_require__(154);
	
	var _constant = __webpack_require__(160);
	
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	
	/**
	 * Mixin for drawing text in a element bounding rect
	 * @module zrender/mixin/RectText
	 */
	var tmpRect = new BoundingRect();
	
	var RectText = function () {};
	
	RectText.prototype = {
	  constructor: RectText,
	
	  /**
	   * Draw text in a rect with specified position.
	   * @param  {CanvasRenderingContext2D} ctx
	   * @param  {Object} rect Displayable rect
	   */
	  drawRectText: function (ctx, rect) {
	    var style = this.style;
	    rect = style.textRect || rect; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    } // FIXME
	    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
	    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
	    // text propably break the cache for its host elements.
	
	
	    ctx.save(); // Transform rect to view space
	
	    var transform = this.transform;
	
	    if (!style.transformText) {
	      if (transform) {
	        tmpRect.copy(rect);
	        tmpRect.applyTransform(transform);
	        rect = tmpRect;
	      }
	    } else {
	      this.setTransform(ctx);
	    } // transformText and textRotation can not be used at the same time.
	
	
	    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
	    ctx.restore();
	  }
	};
	var _default = RectText;
	module.exports = _default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(134);
	
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var each = _util.each;
	var normalizeCssArray = _util.normalizeCssArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	
	var textContain = __webpack_require__(167);
	
	var roundRectHelper = __webpack_require__(169);
	
	var imageHelper = __webpack_require__(168);
	
	var fixShadow = __webpack_require__(159);
	
	var _constant = __webpack_require__(160);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.
	
	var VALID_TEXT_ALIGN = {
	  left: 1,
	  right: 1,
	  center: 1
	};
	var VALID_TEXT_VERTICAL_ALIGN = {
	  top: 1,
	  bottom: 1,
	  middle: 1
	}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
	// the default value of shadowColor is `'transparent'`.
	
	var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
	/**
	 * @param {module:zrender/graphic/Style} style
	 * @return {module:zrender/graphic/Style} The input style.
	 */
	
	function normalizeTextStyle(style) {
	  normalizeStyle(style);
	  each(style.rich, normalizeStyle);
	  return style;
	}
	
	function normalizeStyle(style) {
	  if (style) {
	    style.font = textContain.makeFont(style);
	    var textAlign = style.textAlign;
	    textAlign === 'middle' && (textAlign = 'center');
	    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.
	
	    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
	    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
	    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
	    var textPadding = style.textPadding;
	
	    if (textPadding) {
	      style.textPadding = normalizeCssArray(style.textPadding);
	    }
	  }
	}
	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {string} text
	 * @param {module:zrender/graphic/Style} style
	 * @param {Object|boolean} [rect] {x, y, width, height}
	 *                  If set false, rect text is not used.
	 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
	 */
	
	
	function renderText(hostEl, ctx, text, style, rect, prevEl) {
	  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
	} // Avoid setting to ctx according to prevEl if possible for
	// performance in scenarios of large amount text.
	
	
	function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
	  'use strict';
	
	  var needDrawBg = needDrawBackground(style);
	  var prevStyle;
	  var checkCache = false;
	  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.
	
	  if (prevEl !== WILL_BE_RESTORED) {
	    if (prevEl) {
	      prevStyle = prevEl.style;
	      checkCache = !needDrawBg && cachedByMe && prevStyle;
	    } // Prevent from using cache in `Style::bind`, because of the case:
	    // ctx property is modified by other properties than `Style::bind`
	    // used, and Style::bind is called next.
	
	
	    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
	  } // Since this will be restored, prevent from using these props to check cache in the next
	  // entering of this method. But do not need to clear other cache like `Style::bind`.
	  else if (cachedByMe) {
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	    }
	
	  var styleFont = style.font || DEFAULT_FONT; // PENDING
	  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
	  // we can make font cache on ctx, which can cache for text el that are discontinuous.
	  // But layer save/restore needed to be considered.
	  // if (styleFont !== ctx.__fontCache) {
	  //     ctx.font = styleFont;
	  //     if (prevEl !== WILL_BE_RESTORED) {
	  //         ctx.__fontCache = styleFont;
	  //     }
	  // }
	
	  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
	    ctx.font = styleFont;
	  } // Use the final font from context-2d, because the final
	  // font might not be the style.font when it is illegal.
	  // But get `ctx.font` might be time consuming.
	
	
	  var computedFont = hostEl.__computedFont;
	
	  if (hostEl.__styleFont !== styleFont) {
	    hostEl.__styleFont = styleFont;
	    computedFont = hostEl.__computedFont = ctx.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var textLines = contentBlock.lines;
	  var lineHeight = contentBlock.lineHeight;
	  var boxPos = getBoxPosition(outerHeight, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign || 'left';
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY;
	
	  if (needDrawBg || textPadding) {
	    // Consider performance, do not call getTextWidth util necessary.
	    var textWidth = textContain.getWidth(text, computedFont);
	    var outerWidth = textWidth;
	    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
	    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	    if (textPadding) {
	      textX = getTextXForPadding(baseX, textAlign, textPadding);
	      textY += textPadding[0];
	    }
	  } // Always set textAlign and textBase line, because it is difficute to calculate
	  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
	  // font set happened.
	
	
	  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  ctx.textBaseline = 'middle'; // Set text opacity
	
	  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.
	
	  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
	    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
	    var styleProp = propItem[0];
	    var ctxProp = propItem[1];
	    var val = style[styleProp];
	
	    if (!checkCache || val !== prevStyle[styleProp]) {
	      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
	    }
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  var textStrokeWidth = style.textStrokeWidth;
	  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
	  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
	  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
	  var textStroke = getStroke(style.textStroke, textStrokeWidth);
	  var textFill = getFill(style.textFill);
	
	  if (textStroke) {
	    if (strokeWidthChanged) {
	      ctx.lineWidth = textStrokeWidth;
	    }
	
	    if (strokeChanged) {
	      ctx.strokeStyle = textStroke;
	    }
	  }
	
	  if (textFill) {
	    if (!checkCache || style.textFill !== prevStyle.textFill) {
	      ctx.fillStyle = textFill;
	    }
	  } // Optimize simply, in most cases only one line exists.
	
	
	  if (textLines.length === 1) {
	    // Fill after stroke so the outline will not cover the main part.
	    textStroke && ctx.strokeText(textLines[0], textX, textY);
	    textFill && ctx.fillText(textLines[0], textX, textY);
	  } else {
	    for (var i = 0; i < textLines.length; i++) {
	      // Fill after stroke so the outline will not cover the main part.
	      textStroke && ctx.strokeText(textLines[i], textX, textY);
	      textFill && ctx.fillText(textLines[i], textX, textY);
	      textY += lineHeight;
	    }
	  }
	}
	
	function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
	  // Do not do cache for rich text because of the complexity.
	  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
	  if (prevEl !== WILL_BE_RESTORED) {
	    ctx.__attrCachedBy = ContextCachedBy.NONE;
	  }
	
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
	  }
	
	  drawRichText(hostEl, ctx, contentBlock, style, rect);
	}
	
	function drawRichText(hostEl, ctx, contentBlock, style, rect) {
	  var contentWidth = contentBlock.width;
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var textPadding = style.textPadding;
	  var boxPos = getBoxPosition(outerHeight, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var xLeft = boxX;
	  var lineTop = boxY;
	
	  if (textPadding) {
	    xLeft += textPadding[3];
	    lineTop += textPadding[0];
	  }
	
	  var xRight = xLeft + contentWidth;
	  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	  for (var i = 0; i < contentBlock.lines.length; i++) {
	    var line = contentBlock.lines[i];
	    var tokens = line.tokens;
	    var tokenCount = tokens.length;
	    var lineHeight = line.lineHeight;
	    var usedWidth = line.width;
	    var leftIndex = 0;
	    var lineXLeft = xLeft;
	    var lineXRight = xRight;
	    var rightIndex = tokenCount - 1;
	    var token;
	
	    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
	      usedWidth -= token.width;
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
	      usedWidth -= token.width;
	      lineXRight -= token.width;
	      rightIndex--;
	    } // The other tokens are placed as textAlign 'center' if there is enough space.
	
	
	    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
	
	    while (leftIndex <= rightIndex) {
	      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
	
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    lineTop += lineHeight;
	  }
	}
	
	function applyTextRotation(ctx, style, rect, x, y) {
	  // textRotation only apply in RectText.
	  if (rect && style.textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = rect.width / 2 + rect.x;
	      y = rect.height / 2 + rect.y;
	    } else if (origin) {
	      x = origin[0] + rect.x;
	      y = origin[1] + rect.y;
	    }
	
	    ctx.translate(x, y); // Positive: anticlockwise
	
	    ctx.rotate(-style.textRotation);
	    ctx.translate(-x, -y);
	  }
	}
	
	function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
	  var tokenStyle = style.rich[token.styleName] || {};
	  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
	  // the bias of "Microsoft YaHei".
	
	  var textVerticalAlign = token.textVerticalAlign;
	  var y = lineTop + lineHeight / 2;
	
	  if (textVerticalAlign === 'top') {
	    y = lineTop + token.height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y = lineTop + lineHeight - token.height / 2;
	  }
	
	  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
	  var textPadding = token.textPadding;
	
	  if (textPadding) {
	    x = getTextXForPadding(x, textAlign, textPadding);
	    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
	  }
	
	  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
	  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
	  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
	  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle');
	  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
	  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
	  var textFill = getFill(tokenStyle.textFill || style.textFill);
	  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	    ctx.strokeText(token.text, x, y);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	    ctx.fillText(token.text, x, y);
	  }
	}
	
	function needDrawBackground(style) {
	  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
	} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
	// shape: {x, y, width, height}
	
	
	function drawBackground(hostEl, ctx, style, x, y, width, height) {
	  var textBackgroundColor = style.textBackgroundColor;
	  var textBorderWidth = style.textBorderWidth;
	  var textBorderColor = style.textBorderColor;
	  var isPlainBg = isString(textBackgroundColor);
	  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);
	
	  if (isPlainBg || textBorderWidth && textBorderColor) {
	    ctx.beginPath();
	    var textBorderRadius = style.textBorderRadius;
	
	    if (!textBorderRadius) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        r: textBorderRadius
	      });
	    }
	
	    ctx.closePath();
	  }
	
	  if (isPlainBg) {
	    setCtx(ctx, 'fillStyle', textBackgroundColor);
	
	    if (style.fillOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.fillOpacity * style.opacity;
	      ctx.fill();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.fill();
	    }
	  } else if (isObject(textBackgroundColor)) {
	    var image = textBackgroundColor.image;
	    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);
	
	    if (image && imageHelper.isImageReady(image)) {
	      ctx.drawImage(image, x, y, width, height);
	    }
	  }
	
	  if (textBorderWidth && textBorderColor) {
	    setCtx(ctx, 'lineWidth', textBorderWidth);
	    setCtx(ctx, 'strokeStyle', textBorderColor);
	
	    if (style.strokeOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.strokeOpacity * style.opacity;
	      ctx.stroke();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.stroke();
	    }
	  }
	}
	
	function onBgImageLoaded(image, textBackgroundColor) {
	  // Replace image, so that `contain/text.js#parseRichText`
	  // will get correct result in next tick.
	  textBackgroundColor.image = image;
	}
	
	function getBoxPosition(blockHeiht, style, rect) {
	  var baseX = style.x || 0;
	  var baseY = style.y || 0;
	  var textAlign = style.textAlign;
	  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
	
	  if (rect) {
	    var textPosition = style.textPosition;
	
	    if (textPosition instanceof Array) {
	      // Percent
	      baseX = rect.x + parsePercent(textPosition[0], rect.width);
	      baseY = rect.y + parsePercent(textPosition[1], rect.height);
	    } else {
	      var res = textContain.adjustTextPositionOnRect(textPosition, rect, style.textDistance);
	      baseX = res.x;
	      baseY = res.y; // Default align and baseline when has textPosition
	
	      textAlign = textAlign || res.textAlign;
	      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
	    } // textOffset is only support in RectText, otherwise
	    // we have to adjust boundingRect for textOffset.
	
	
	    var textOffset = style.textOffset;
	
	    if (textOffset) {
	      baseX += textOffset[0];
	      baseY += textOffset[1];
	    }
	  }
	
	  return {
	    baseX: baseX,
	    baseY: baseY,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	function setCtx(ctx, prop, value) {
	  ctx[prop] = fixShadow(ctx, prop, value);
	  return ctx[prop];
	}
	/**
	 * @param {string} [stroke] If specified, do not check style.textStroke.
	 * @param {string} [lineWidth] If specified, do not check style.textStroke.
	 * @param {number} style
	 */
	
	
	function getStroke(stroke, lineWidth) {
	  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
	  : stroke.image || stroke.colorStops ? '#000' : stroke;
	}
	
	function getFill(fill) {
	  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
	  : fill.image || fill.colorStops ? '#000' : fill;
	}
	
	function parsePercent(value, maxValue) {
	  if (typeof value === 'string') {
	    if (value.lastIndexOf('%') >= 0) {
	      return parseFloat(value) / 100 * maxValue;
	    }
	
	    return parseFloat(value);
	  }
	
	  return value;
	}
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	/**
	 * @param {string} text
	 * @param {module:zrender/Style} style
	 * @return {boolean}
	 */
	
	
	function needDrawText(text, style) {
	  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
	}
	
	exports.normalizeTextStyle = normalizeTextStyle;
	exports.renderText = renderText;
	exports.getStroke = getStroke;
	exports.getFill = getFill;
	exports.needDrawText = needDrawText;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(154);
	
	var imageHelper = __webpack_require__(168);
	
	var _util = __webpack_require__(134);
	
	var getContext = _util.getContext;
	var extend = _util.extend;
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var trim = _util.trim;
	var textWidthCache = {};
	var textWidthCacheCounter = 0;
	var TEXT_CACHE_MAX = 5000;
	var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {number} width
	 */
	
	
	function getWidth(text, font) {
	  font = font || DEFAULT_FONT;
	  var key = text + ':' + font;
	
	  if (textWidthCache[key]) {
	    return textWidthCache[key];
	  }
	
	  var textLines = (text + '').split('\n');
	  var width = 0;
	
	  for (var i = 0, l = textLines.length; i < l; i++) {
	    // textContain.measureText may be overrided in SVG or VML
	    width = Math.max(measureText(textLines[i], font).width, width);
	  }
	
	  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
	    textWidthCacheCounter = 0;
	    textWidthCache = {};
	  }
	
	  textWidthCacheCounter++;
	  textWidthCache[key] = width;
	  return width;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {string} [textAlign='left']
	 * @param {string} [textVerticalAlign='top']
	 * @param {Array.<number>} [textPadding]
	 * @param {Object} [rich]
	 * @param {Object} [truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	
	function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
	}
	
	function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
	  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
	  var outerWidth = getWidth(text, font);
	
	  if (textPadding) {
	    outerWidth += textPadding[1] + textPadding[3];
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
	  rect.lineHeight = contentBlock.lineHeight;
	  return rect;
	}
	
	function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  var contentBlock = parseRichText(text, {
	    rich: rich,
	    truncate: truncate,
	    font: font,
	    textAlign: textAlign,
	    textPadding: textPadding,
	    textLineHeight: textLineHeight
	  });
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  return new BoundingRect(x, y, outerWidth, outerHeight);
	}
	/**
	 * @public
	 * @param {number} x
	 * @param {number} width
	 * @param {string} [textAlign='left']
	 * @return {number} Adjusted x.
	 */
	
	
	function adjustTextX(x, width, textAlign) {
	  // FIXME Right to left language
	  if (textAlign === 'right') {
	    x -= width;
	  } else if (textAlign === 'center') {
	    x -= width / 2;
	  }
	
	  return x;
	}
	/**
	 * @public
	 * @param {number} y
	 * @param {number} height
	 * @param {string} [textVerticalAlign='top']
	 * @return {number} Adjusted y.
	 */
	
	
	function adjustTextY(y, height, textVerticalAlign) {
	  if (textVerticalAlign === 'middle') {
	    y -= height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y -= height;
	  }
	
	  return y;
	}
	/**
	 * @public
	 * @param {stirng} textPosition
	 * @param {Object} rect {x, y, width, height}
	 * @param {number} distance
	 * @return {Object} {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function adjustTextPositionOnRect(textPosition, rect, distance) {
	  var x = rect.x;
	  var y = rect.y;
	  var height = rect.height;
	  var width = rect.width;
	  var halfHeight = height / 2;
	  var textAlign = 'left';
	  var textVerticalAlign = 'top';
	
	  switch (textPosition) {
	    case 'left':
	      x -= distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'right':
	      x += distance + width;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'top':
	      x += width / 2;
	      y -= distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'bottom':
	      x += width / 2;
	      y += height + distance;
	      textAlign = 'center';
	      break;
	
	    case 'inside':
	      x += width / 2;
	      y += halfHeight;
	      textAlign = 'center';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideLeft':
	      x += distance;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideRight':
	      x += width - distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideTop':
	      x += width / 2;
	      y += distance;
	      textAlign = 'center';
	      break;
	
	    case 'insideBottom':
	      x += width / 2;
	      y += height - distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideTopLeft':
	      x += distance;
	      y += distance;
	      break;
	
	    case 'insideTopRight':
	      x += width - distance;
	      y += distance;
	      textAlign = 'right';
	      break;
	
	    case 'insideBottomLeft':
	      x += distance;
	      y += height - distance;
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideBottomRight':
	      x += width - distance;
	      y += height - distance;
	      textAlign = 'right';
	      textVerticalAlign = 'bottom';
	      break;
	  }
	
	  return {
	    x: x,
	    y: y,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	/**
	 * Show ellipsis if overflow.
	 *
	 * @public
	 * @param  {string} text
	 * @param  {string} containerWidth
	 * @param  {string} font
	 * @param  {number} [ellipsis='...']
	 * @param  {Object} [options]
	 * @param  {number} [options.maxIterations=3]
	 * @param  {number} [options.minChar=0] If truncate result are less
	 *                  then minChar, ellipsis will not show, which is
	 *                  better for user hint in some cases.
	 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
	 * @return {string}
	 */
	
	
	function truncateText(text, containerWidth, font, ellipsis, options) {
	  if (!containerWidth) {
	    return '';
	  }
	
	  var textLines = (text + '').split('\n');
	  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
	  // It is not appropriate that every line has '...' when truncate multiple lines.
	
	  for (var i = 0, len = textLines.length; i < len; i++) {
	    textLines[i] = truncateSingleLine(textLines[i], options);
	  }
	
	  return textLines.join('\n');
	}
	
	function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	  options = extend({}, options);
	  options.font = font;
	  var ellipsis = retrieve2(ellipsis, '...');
	  options.maxIterations = retrieve2(options.maxIterations, 2);
	  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
	  // Other languages?
	
	  options.cnCharWidth = getWidth('国', font); // FIXME
	  // Consider proportional font?
	
	  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
	  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
	  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
	
	  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
	
	  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	    contentWidth -= ascCharWidth;
	  }
	
	  var ellipsisWidth = getWidth(ellipsis, font);
	
	  if (ellipsisWidth > contentWidth) {
	    ellipsis = '';
	    ellipsisWidth = 0;
	  }
	
	  contentWidth = containerWidth - ellipsisWidth;
	  options.ellipsis = ellipsis;
	  options.ellipsisWidth = ellipsisWidth;
	  options.contentWidth = contentWidth;
	  options.containerWidth = containerWidth;
	  return options;
	}
	
	function truncateSingleLine(textLine, options) {
	  var containerWidth = options.containerWidth;
	  var font = options.font;
	  var contentWidth = options.contentWidth;
	
	  if (!containerWidth) {
	    return '';
	  }
	
	  var lineWidth = getWidth(textLine, font);
	
	  if (lineWidth <= containerWidth) {
	    return textLine;
	  }
	
	  for (var j = 0;; j++) {
	    if (lineWidth <= contentWidth || j >= options.maxIterations) {
	      textLine += options.ellipsis;
	      break;
	    }
	
	    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
	    textLine = textLine.substr(0, subLength);
	    lineWidth = getWidth(textLine, font);
	  }
	
	  if (textLine === '') {
	    textLine = options.placeholder;
	  }
	
	  return textLine;
	}
	
	function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	  var width = 0;
	  var i = 0;
	
	  for (var len = text.length; i < len && width < contentWidth; i++) {
	    var charCode = text.charCodeAt(i);
	    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
	  }
	
	  return i;
	}
	/**
	 * @public
	 * @param {string} font
	 * @return {number} line height
	 */
	
	
	function getLineHeight(font) {
	  // FIXME A rough approach.
	  return getWidth('国', font);
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {Object} width
	 */
	
	
	function measureText(text, font) {
	  return methods.measureText(text, font);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	methods.measureText = function (text, font) {
	  var ctx = getContext();
	  ctx.font = font || DEFAULT_FONT;
	  return ctx.measureText(text);
	};
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {Object} [truncate]
	 * @return {Object} block: {lineHeight, lines, height, outerHeight}
	 *  Notice: for performance, do not calculate outerWidth util needed.
	 */
	
	
	function parsePlainText(text, font, padding, textLineHeight, truncate) {
	  text != null && (text += '');
	  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
	  var lines = text ? text.split('\n') : [];
	  var height = lines.length * lineHeight;
	  var outerHeight = height;
	
	  if (padding) {
	    outerHeight += padding[0] + padding[2];
	  }
	
	  if (text && truncate) {
	    var truncOuterHeight = truncate.outerHeight;
	    var truncOuterWidth = truncate.outerWidth;
	
	    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
	      text = '';
	      lines = [];
	    } else if (truncOuterWidth != null) {
	      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
	        minChar: truncate.minChar,
	        placeholder: truncate.placeholder
	      }); // FIXME
	      // It is not appropriate that every line has '...' when truncate multiple lines.
	
	      for (var i = 0, len = lines.length; i < len; i++) {
	        lines[i] = truncateSingleLine(lines[i], options);
	      }
	    }
	  }
	
	  return {
	    lines: lines,
	    height: height,
	    outerHeight: outerHeight,
	    lineHeight: lineHeight
	  };
	}
	/**
	 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
	 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
	 *
	 * @public
	 * @param {string} text
	 * @param {Object} style
	 * @return {Object} block
	 * {
	 *      width,
	 *      height,
	 *      lines: [{
	 *          lineHeight,
	 *          width,
	 *          tokens: [[{
	 *              styleName,
	 *              text,
	 *              width,      // include textPadding
	 *              height,     // include textPadding
	 *              textWidth, // pure text width
	 *              textHeight, // pure text height
	 *              lineHeihgt,
	 *              font,
	 *              textAlign,
	 *              textVerticalAlign
	 *          }], [...], ...]
	 *      }, ...]
	 * }
	 * If styleName is undefined, it is plain text.
	 */
	
	
	function parseRichText(text, style) {
	  var contentBlock = {
	    lines: [],
	    width: 0,
	    height: 0
	  };
	  text != null && (text += '');
	
	  if (!text) {
	    return contentBlock;
	  }
	
	  var lastIndex = STYLE_REG.lastIndex = 0;
	  var result;
	
	  while ((result = STYLE_REG.exec(text)) != null) {
	    var matchedIndex = result.index;
	
	    if (matchedIndex > lastIndex) {
	      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
	    }
	
	    pushTokens(contentBlock, result[2], result[1]);
	    lastIndex = STYLE_REG.lastIndex;
	  }
	
	  if (lastIndex < text.length) {
	    pushTokens(contentBlock, text.substring(lastIndex, text.length));
	  }
	
	  var lines = contentBlock.lines;
	  var contentHeight = 0;
	  var contentWidth = 0; // For `textWidth: 100%`
	
	  var pendingList = [];
	  var stlPadding = style.textPadding;
	  var truncate = style.truncate;
	  var truncateWidth = truncate && truncate.outerWidth;
	  var truncateHeight = truncate && truncate.outerHeight;
	
	  if (stlPadding) {
	    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
	    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
	  } // Calculate layout info of tokens.
	
	
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i];
	    var lineHeight = 0;
	    var lineWidth = 0;
	
	    for (var j = 0; j < line.tokens.length; j++) {
	      var token = line.tokens[j];
	      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
	
	      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
	
	      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
	
	      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
	      // as box height of the block.
	      tokenStyle.textHeight, getLineHeight(font));
	      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	      token.height = tokenHeight;
	      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
	      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
	      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';
	
	      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
	        return {
	          lines: [],
	          width: 0,
	          height: 0
	        };
	      }
	
	      token.textWidth = getWidth(token.text, font);
	      var tokenWidth = tokenStyle.textWidth;
	      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
	      // line when box width is needed to be auto.
	
	      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
	        token.percentWidth = tokenWidth;
	        pendingList.push(token);
	        tokenWidth = 0; // Do not truncate in this case, because there is no user case
	        // and it is too complicated.
	      } else {
	        if (tokenWidthNotSpecified) {
	          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
	          // `getBoundingRect()` will not get correct result.
	
	          var textBackgroundColor = tokenStyle.textBackgroundColor;
	          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
	          // (1) If image is not loaded, it will be loaded at render phase and call
	          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
	          // image, and then the right size will be calculated here at the next tick.
	          // See `graphic/helper/text.js`.
	          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
	          // use `imageHelper.findExistImage` to find cached image.
	          // `imageHelper.findExistImage` will always be called here before
	          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
	          // which ensures that image will not be rendered before correct size calcualted.
	
	          if (bgImg) {
	            bgImg = imageHelper.findExistImage(bgImg);
	
	            if (imageHelper.isImageReady(bgImg)) {
	              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
	            }
	          }
	        }
	
	        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
	        tokenWidth += paddingW;
	        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
	
	        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
	          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
	            token.text = '';
	            token.textWidth = tokenWidth = 0;
	          } else {
	            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
	              minChar: truncate.minChar
	            });
	            token.textWidth = getWidth(token.text, font);
	            tokenWidth = token.textWidth + paddingW;
	          }
	        }
	      }
	
	      lineWidth += token.width = tokenWidth;
	      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	    }
	
	    line.width = lineWidth;
	    line.lineHeight = lineHeight;
	    contentHeight += lineHeight;
	    contentWidth = Math.max(contentWidth, lineWidth);
	  }
	
	  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
	  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);
	
	  if (stlPadding) {
	    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	  }
	
	  for (var i = 0; i < pendingList.length; i++) {
	    var token = pendingList[i];
	    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
	
	    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
	  }
	
	  return contentBlock;
	}
	
	function pushTokens(block, str, styleName) {
	  var isEmptyStr = str === '';
	  var strs = str.split('\n');
	  var lines = block.lines;
	
	  for (var i = 0; i < strs.length; i++) {
	    var text = strs[i];
	    var token = {
	      styleName: styleName,
	      text: text,
	      isLineHolder: !text && !isEmptyStr
	    }; // The first token should be appended to the last line.
	
	    if (!i) {
	      var tokens = (lines[lines.length - 1] || (lines[0] = {
	        tokens: []
	      })).tokens; // Consider cases:
	      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
	      // (which is a placeholder) should be replaced by new token.
	      // (2) A image backage, where token likes {a|}.
	      // (3) A redundant '' will affect textAlign in line.
	      // (4) tokens with the same tplName should not be merged, because
	      // they should be displayed in different box (with border and padding).
	
	      var tokensLen = tokens.length;
	      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
	      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
	      (text || !tokensLen || isEmptyStr) && tokens.push(token);
	    } // Other tokens always start a new line.
	    else {
	        // If there is '', insert it as a placeholder.
	        lines.push({
	          tokens: [token]
	        });
	      }
	  }
	}
	
	function makeFont(style) {
	  // FIXME in node-canvas fontWeight is before fontStyle
	  // Use `fontSize` `fontFamily` to check whether font properties are defined.
	  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
	  style.fontFamily || 'sans-serif'].join(' ');
	  return font && trim(font) || style.textFont || style.font;
	}
	
	exports.DEFAULT_FONT = DEFAULT_FONT;
	exports.$override = $override;
	exports.getWidth = getWidth;
	exports.getBoundingRect = getBoundingRect;
	exports.adjustTextX = adjustTextX;
	exports.adjustTextY = adjustTextY;
	exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
	exports.truncateText = truncateText;
	exports.getLineHeight = getLineHeight;
	exports.measureText = measureText;
	exports.parsePlainText = parsePlainText;
	exports.parseRichText = parseRichText;
	exports.makeFont = makeFont;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(151);
	
	var globalImageCache = new LRU(50);
	/**
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	function findExistImage(newImageOrSrc) {
	  if (typeof newImageOrSrc === 'string') {
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    return cachedImgObj && cachedImgObj.image;
	  } else {
	    return newImageOrSrc;
	  }
	}
	/**
	 * Caution: User should cache loaded images, but not just count on LRU.
	 * Consider if required images more than LRU size, will dead loop occur?
	 *
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
	 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
	 * @param {Function} [cb] params: (image, cbPayload)
	 * @param {Object} [cbPayload] Payload on cb calling.
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	
	function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
	  if (!newImageOrSrc) {
	    return image;
	  } else if (typeof newImageOrSrc === 'string') {
	    // Image should not be loaded repeatly.
	    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
	      return image;
	    } // Only when there is no existent image or existent image src
	    // is different, this method is responsible for load.
	
	
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    var pendingWrap = {
	      hostEl: hostEl,
	      cb: cb,
	      cbPayload: cbPayload
	    };
	
	    if (cachedImgObj) {
	      image = cachedImgObj.image;
	      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	    } else {
	      image = new Image();
	      image.onload = image.onerror = imageOnLoad;
	      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	        image: image,
	        pending: [pendingWrap]
	      });
	      image.src = image.__zrImageSrc = newImageOrSrc;
	    }
	
	    return image;
	  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
	  else {
	      return newImageOrSrc;
	    }
	}
	
	function imageOnLoad() {
	  var cachedImgObj = this.__cachedImgObj;
	  this.onload = this.onerror = this.__cachedImgObj = null;
	
	  for (var i = 0; i < cachedImgObj.pending.length; i++) {
	    var pendingWrap = cachedImgObj.pending[i];
	    var cb = pendingWrap.cb;
	    cb && cb(this, pendingWrap.cbPayload);
	    pendingWrap.hostEl.dirty();
	  }
	
	  cachedImgObj.pending.length = 0;
	}
	
	function isImageReady(image) {
	  return image && image.width && image.height;
	}
	
	exports.findExistImage = findExistImage;
	exports.createOrUpdateImage = createOrUpdateImage;
	exports.isImageReady = isImageReady;

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * @param {Object} ctx
	 * @param {Object} shape
	 * @param {number} shape.x
	 * @param {number} shape.y
	 * @param {number} shape.width
	 * @param {number} shape.height
	 * @param {number} shape.r
	 */
	function buildPath(ctx, shape) {
	  var x = shape.x;
	  var y = shape.y;
	  var width = shape.width;
	  var height = shape.height;
	  var r = shape.r;
	  var r1;
	  var r2;
	  var r3;
	  var r4; // Convert width and height to positive for better borderRadius
	
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	
	  if (typeof r === 'number') {
	    r1 = r2 = r3 = r4 = r;
	  } else if (r instanceof Array) {
	    if (r.length === 1) {
	      r1 = r2 = r3 = r4 = r[0];
	    } else if (r.length === 2) {
	      r1 = r3 = r[0];
	      r2 = r4 = r[1];
	    } else if (r.length === 3) {
	      r1 = r[0];
	      r2 = r4 = r[1];
	      r3 = r[2];
	    } else {
	      r1 = r[0];
	      r2 = r[1];
	      r3 = r[2];
	      r4 = r[3];
	    }
	  } else {
	    r1 = r2 = r3 = r4 = 0;
	  }
	
	  var total;
	
	  if (r1 + r2 > width) {
	    total = r1 + r2;
	    r1 *= width / total;
	    r2 *= width / total;
	  }
	
	  if (r3 + r4 > width) {
	    total = r3 + r4;
	    r3 *= width / total;
	    r4 *= width / total;
	  }
	
	  if (r2 + r3 > height) {
	    total = r2 + r3;
	    r2 *= height / total;
	    r3 *= height / total;
	  }
	
	  if (r1 + r4 > height) {
	    total = r1 + r4;
	    r1 *= height / total;
	    r4 *= height / total;
	  }
	
	  ctx.moveTo(x + r1, y);
	  ctx.lineTo(x + width - r2, y);
	  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
	  ctx.lineTo(x + width, y + height - r3);
	  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
	  ctx.lineTo(x + r4, y + height);
	  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
	  ctx.lineTo(x, y + r1);
	  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(134);
	
	var _event = __webpack_require__(139);
	
	var Dispatcher = _event.Dispatcher;
	
	var requestAnimationFrame = __webpack_require__(162);
	
	var Animator = __webpack_require__(147);
	
	/**
	 * 动画主类, 调度和管理所有动画控制器
	 *
	 * @module zrender/animation/Animation
	 * @author pissang(https://github.com/pissang)
	 */
	// TODO Additive animation
	// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
	// https://developer.apple.com/videos/wwdc2014/#236
	
	/**
	 * @typedef {Object} IZRenderStage
	 * @property {Function} update
	 */
	
	/**
	 * @alias module:zrender/animation/Animation
	 * @constructor
	 * @param {Object} [options]
	 * @param {Function} [options.onframe]
	 * @param {IZRenderStage} [options.stage]
	 * @example
	 *     var animation = new Animation();
	 *     var obj = {
	 *         x: 100,
	 *         y: 100
	 *     };
	 *     animation.animate(node.position)
	 *         .when(1000, {
	 *             x: 500,
	 *             y: 500
	 *         })
	 *         .when(2000, {
	 *             x: 100,
	 *             y: 100
	 *         })
	 *         .start('spline');
	 */
	var Animation = function (options) {
	  options = options || {};
	  this.stage = options.stage || {};
	
	  this.onframe = options.onframe || function () {}; // private properties
	
	
	  this._clips = [];
	  this._running = false;
	  this._time;
	  this._pausedTime;
	  this._pauseStart;
	  this._paused = false;
	  Dispatcher.call(this);
	};
	
	Animation.prototype = {
	  constructor: Animation,
	
	  /**
	   * 添加 clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  addClip: function (clip) {
	    this._clips.push(clip);
	  },
	
	  /**
	   * 添加 animator
	   * @param {module:zrender/animation/Animator} animator
	   */
	  addAnimator: function (animator) {
	    animator.animation = this;
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.addClip(clips[i]);
	    }
	  },
	
	  /**
	   * 删除动画片段
	   * @param {module:zrender/animation/Clip} clip
	   */
	  removeClip: function (clip) {
	    var idx = util.indexOf(this._clips, clip);
	
	    if (idx >= 0) {
	      this._clips.splice(idx, 1);
	    }
	  },
	
	  /**
	   * 删除动画片段
	   * @param {module:zrender/animation/Animator} animator
	   */
	  removeAnimator: function (animator) {
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.removeClip(clips[i]);
	    }
	
	    animator.animation = null;
	  },
	  _update: function () {
	    var time = new Date().getTime() - this._pausedTime;
	
	    var delta = time - this._time;
	    var clips = this._clips;
	    var len = clips.length;
	    var deferredEvents = [];
	    var deferredClips = [];
	
	    for (var i = 0; i < len; i++) {
	      var clip = clips[i];
	      var e = clip.step(time, delta); // Throw out the events need to be called after
	      // stage.update, like destroy
	
	      if (e) {
	        deferredEvents.push(e);
	        deferredClips.push(clip);
	      }
	    } // Remove the finished clip
	
	
	    for (var i = 0; i < len;) {
	      if (clips[i]._needsRemove) {
	        clips[i] = clips[len - 1];
	        clips.pop();
	        len--;
	      } else {
	        i++;
	      }
	    }
	
	    len = deferredEvents.length;
	
	    for (var i = 0; i < len; i++) {
	      deferredClips[i].fire(deferredEvents[i]);
	    }
	
	    this._time = time;
	    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
	    // depends on the sequence (e.g., echarts-stream and finish
	    // event judge)
	
	    this.trigger('frame', delta);
	
	    if (this.stage.update) {
	      this.stage.update();
	    }
	  },
	  _startLoop: function () {
	    var self = this;
	    this._running = true;
	
	    function step() {
	      if (self._running) {
	        requestAnimationFrame(step);
	        !self._paused && self._update();
	      }
	    }
	
	    requestAnimationFrame(step);
	  },
	
	  /**
	   * Start animation.
	   */
	  start: function () {
	    this._time = new Date().getTime();
	    this._pausedTime = 0;
	
	    this._startLoop();
	  },
	
	  /**
	   * Stop animation.
	   */
	  stop: function () {
	    this._running = false;
	  },
	
	  /**
	   * Pause animation.
	   */
	  pause: function () {
	    if (!this._paused) {
	      this._pauseStart = new Date().getTime();
	      this._paused = true;
	    }
	  },
	
	  /**
	   * Resume animation.
	   */
	  resume: function () {
	    if (this._paused) {
	      this._pausedTime += new Date().getTime() - this._pauseStart;
	      this._paused = false;
	    }
	  },
	
	  /**
	   * Clear animation.
	   */
	  clear: function () {
	    this._clips = [];
	  },
	
	  /**
	   * Whether animation finished.
	   */
	  isFinished: function () {
	    return !this._clips.length;
	  },
	
	  /**
	   * Creat animator for a target, whose props can be animated.
	   *
	   * @param  {Object} target
	   * @param  {Object} options
	   * @param  {boolean} [options.loop=false] Whether loop animation.
	   * @param  {Function} [options.getter=null] Get value from target.
	   * @param  {Function} [options.setter=null] Set value to target.
	   * @return {module:zrender/animation/Animation~Animator}
	   */
	  // TODO Gap
	  animate: function (target, options) {
	    options = options || {};
	    var animator = new Animator(target, options.loop, options.getter, options.setter);
	    this.addAnimator(animator);
	    return animator;
	  }
	};
	util.mixin(Animation, Dispatcher);
	var _default = Animation;
	module.exports = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var _event = __webpack_require__(139);
	
	var addEventListener = _event.addEventListener;
	var removeEventListener = _event.removeEventListener;
	var normalizeEvent = _event.normalizeEvent;
	
	var zrUtil = __webpack_require__(134);
	
	var Eventful = __webpack_require__(138);
	
	var env = __webpack_require__(133);
	
	var TOUCH_CLICK_DELAY = 300;
	var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
	var pointerEventNames = {
	  pointerdown: 1,
	  pointerup: 1,
	  pointermove: 1,
	  pointerout: 1
	};
	var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
	  var nm = name.replace('mouse', 'pointer');
	  return pointerEventNames[nm] ? nm : name;
	});
	
	function eventNameFix(name) {
	  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
	} // function onMSGestureChange(proxy, event) {
	//     if (event.translationX || event.translationY) {
	//         // mousemove is carried by MSGesture to reduce the sensitivity.
	//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
	//     }
	//     if (event.scale !== 1) {
	//         event.pinchX = event.offsetX;
	//         event.pinchY = event.offsetY;
	//         event.pinchScale = event.scale;
	//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
	//     }
	// }
	
	/**
	 * Prevent mouse event from being dispatched after Touch Events action
	 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
	 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
	 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
	 * Result: Blocking Mouse Events for 700ms.
	 */
	
	
	function setTouchTimer(instance) {
	  instance._touching = true;
	  clearTimeout(instance._touchTimer);
	  instance._touchTimer = setTimeout(function () {
	    instance._touching = false;
	  }, 700);
	}
	
	var domHandlers = {
	  /**
	   * Mouse move handler
	   * @inner
	   * @param {Event} event
	   */
	  mousemove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger('mousemove', event);
	  },
	
	  /**
	   * Mouse out handler
	   * @inner
	   * @param {Event} event
	   */
	  mouseout: function (event) {
	    event = normalizeEvent(this.dom, event);
	    var element = event.toElement || event.relatedTarget;
	
	    if (element !== this.dom) {
	      while (element && element.nodeType !== 9) {
	        // 忽略包含在root中的dom引起的mouseOut
	        if (element === this.dom) {
	          return;
	        }
	
	        element = element.parentNode;
	      }
	    }
	
	    this.trigger('mouseout', event);
	  },
	
	  /**
	   * Touch开始响应函数
	   * @inner
	   * @param {Event} event
	   */
	  touchstart: function (event) {
	    // Default mouse behaviour should not be disabled here.
	    // For example, page may needs to be slided.
	    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
	    // mouse event in upper applicatoin.
	
	    event.zrByTouch = true;
	    this._lastTouchMoment = new Date();
	    this.handler.processGesture(this, event, 'start'); // In touch device, trigger `mousemove`(`mouseover`) should
	    // be triggered, and must before `mousedown` triggered.
	
	    domHandlers.mousemove.call(this, event);
	    domHandlers.mousedown.call(this, event);
	    setTouchTimer(this);
	  },
	
	  /**
	   * Touch移动响应函数
	   * @inner
	   * @param {Event} event
	   */
	  touchmove: function (event) {
	    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
	    // mouse event in upper applicatoin.
	
	    event.zrByTouch = true;
	    this.handler.processGesture(this, event, 'change'); // Mouse move should always be triggered no matter whether
	    // there is gestrue event, because mouse move and pinch may
	    // be used at the same time.
	
	    domHandlers.mousemove.call(this, event);
	    setTouchTimer(this);
	  },
	
	  /**
	   * Touch结束响应函数
	   * @inner
	   * @param {Event} event
	   */
	  touchend: function (event) {
	    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
	    // mouse event in upper applicatoin.
	
	    event.zrByTouch = true;
	    this.handler.processGesture(this, event, 'end');
	    domHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
	    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
	    // we can conveniently implement "hover style" in both PC and touch device just
	    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
	    // to remove "hover style" on an element, without any additional code for
	    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
	    // style" will remain for user view)
	    // click event should always be triggered no matter whether
	    // there is gestrue event. System click can not be prevented.
	
	    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
	      domHandlers.click.call(this, event);
	    }
	
	    setTouchTimer(this);
	  },
	  pointerdown: function (event) {
	    domHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
	    //     this._msGesture.addPointer(event.pointerId);
	    // }
	  },
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      domHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    domHandlers.mouseup.call(this, event);
	  },
	  pointerout: function (event) {
	    // pointerout will be triggered when tap on touch screen
	    // (IE11+/Edge on MS Surface) after click event triggered,
	    // which is inconsistent with the mousout behavior we defined
	    // in touchend. So we unify them.
	    // (check domHandlers.touchend for detailed explanation)
	    if (!isPointerFromTouch(event)) {
	      domHandlers.mouseout.call(this, event);
	    }
	  }
	};
	
	function isPointerFromTouch(event) {
	  var pointerType = event.pointerType;
	  return pointerType === 'pen' || pointerType === 'touch';
	} // function useMSGuesture(handlerProxy, event) {
	//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
	// }
	// Common handlers
	
	
	zrUtil.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  domHandlers[name] = function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger(name, event);
	  };
	});
	/**
	 * 为控制类实例初始化dom 事件处理函数
	 *
	 * @inner
	 * @param {module:zrender/Handler} instance 控制类实例
	 */
	
	function initDomHandler(instance) {
	  zrUtil.each(touchHandlerNames, function (name) {
	    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
	  });
	  zrUtil.each(pointerHandlerNames, function (name) {
	    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
	  });
	  zrUtil.each(mouseHandlerNames, function (name) {
	    instance._handlers[name] = makeMouseHandler(domHandlers[name], instance);
	  });
	
	  function makeMouseHandler(fn, instance) {
	    return function () {
	      if (instance._touching) {
	        return;
	      }
	
	      return fn.apply(instance, arguments);
	    };
	  }
	}
	
	function HandlerDomProxy(dom) {
	  Eventful.call(this);
	  this.dom = dom;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._touching = false;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._touchTimer;
	  this._handlers = {};
	  initDomHandler(this);
	
	  if (env.pointerEventsSupported) {
	    // Only IE11+/Edge
	    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
	    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
	    // at the same time.
	    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
	    // screen, which do not occurs in pointer event.
	    // So we use pointer event to both detect touch gesture and mouse behavior.
	    mountHandlers(pointerHandlerNames, this); // FIXME
	    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
	    // which does not prevent defuault behavior occasionally (which may cause view port
	    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
	    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
	    // touch screen. And we only support click behavior on MS touch screen now.
	    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
	    // We dont support touch on IE on win7.
	    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
	    // if (typeof MSGesture === 'function') {
	    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
	    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
	    // }
	  } else {
	    if (env.touchEventsSupported) {
	      mountHandlers(touchHandlerNames, this); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
	      // addEventListener(root, 'mouseout', this._mouseoutHandler);
	    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
	    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
	    // mouse event can not be handle in those devices.
	    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
	    // mouseevent after touch event triggered, see `setTouchTimer`.
	
	
	    mountHandlers(mouseHandlerNames, this);
	  }
	
	  function mountHandlers(handlerNames, instance) {
	    zrUtil.each(handlerNames, function (name) {
	      addEventListener(dom, eventNameFix(name), instance._handlers[name]);
	    }, instance);
	  }
	}
	
	var handlerDomProxyProto = HandlerDomProxy.prototype;
	
	handlerDomProxyProto.dispose = function () {
	  var handlerNames = mouseHandlerNames.concat(touchHandlerNames);
	
	  for (var i = 0; i < handlerNames.length; i++) {
	    var name = handlerNames[i];
	    removeEventListener(this.dom, eventNameFix(name), this._handlers[name]);
	  }
	};
	
	handlerDomProxyProto.setCursor = function (cursorStyle) {
	  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
	};
	
	zrUtil.mixin(HandlerDomProxy, Eventful);
	var _default = HandlerDomProxy;
	module.exports = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var filter = _util.filter;
	var map = _util.map;
	var isArray = _util.isArray;
	var indexOf = _util.indexOf;
	var isObject = _util.isObject;
	var isString = _util.isString;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	var clone = _util.clone;
	var merge = _util.merge;
	var extend = _util.extend;
	var mixin = _util.mixin;
	
	var modelUtil = __webpack_require__(173);
	
	var Model = __webpack_require__(174);
	
	var ComponentModel = __webpack_require__(215);
	
	var globalDefault = __webpack_require__(221);
	
	var colorPaletteMixin = __webpack_require__(222);
	
	var _sourceHelper = __webpack_require__(223);
	
	var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts global model
	 *
	 * @module {echarts/model/Global}
	 */
	
	/**
	 * Caution: If the mechanism should be changed some day, these cases
	 * should be considered:
	 *
	 * (1) In `merge option` mode, if using the same option to call `setOption`
	 * many times, the result should be the same (try our best to ensure that).
	 * (2) In `merge option` mode, if a component has no id/name specified, it
	 * will be merged by index, and the result sequence of the components is
	 * consistent to the original sequence.
	 * (3) `reset` feature (in toolbox). Find detailed info in comments about
	 * `mergeOption` in module:echarts/model/OptionManager.
	 */
	var OPTION_INNER_KEY = '\0_ec_inner';
	/**
	 * @alias module:echarts/model/Global
	 *
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {Object} theme
	 */
	
	var GlobalModel = Model.extend({
	  init: function (option, parentModel, theme, optionManager) {
	    theme = theme || {};
	    this.option = null; // Mark as not initialized.
	
	    /**
	     * @type {module:echarts/model/Model}
	     * @private
	     */
	
	    this._theme = new Model(theme);
	    /**
	     * @type {module:echarts/model/OptionManager}
	     */
	
	    this._optionManager = optionManager;
	  },
	  setOption: function (option, optionPreprocessorFuncs) {
	    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');
	
	    this._optionManager.setOption(option, optionPreprocessorFuncs);
	
	    this.resetOption(null);
	  },
	
	  /**
	   * @param {string} type null/undefined: reset all.
	   *                      'recreate': force recreate all.
	   *                      'timeline': only reset timeline option
	   *                      'media': only reset media query option
	   * @return {boolean} Whether option changed.
	   */
	  resetOption: function (type) {
	    var optionChanged = false;
	    var optionManager = this._optionManager;
	
	    if (!type || type === 'recreate') {
	      var baseOption = optionManager.mountOption(type === 'recreate');
	
	      if (!this.option || type === 'recreate') {
	        initBase.call(this, baseOption);
	      } else {
	        this.restoreData();
	        this.mergeOption(baseOption);
	      }
	
	      optionChanged = true;
	    }
	
	    if (type === 'timeline' || type === 'media') {
	      this.restoreData();
	    }
	
	    if (!type || type === 'recreate' || type === 'timeline') {
	      var timelineOption = optionManager.getTimelineOption(this);
	      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
	    }
	
	    if (!type || type === 'recreate' || type === 'media') {
	      var mediaOptions = optionManager.getMediaOption(this, this._api);
	
	      if (mediaOptions.length) {
	        each(mediaOptions, function (mediaOption) {
	          this.mergeOption(mediaOption, optionChanged = true);
	        }, this);
	      }
	    }
	
	    return optionChanged;
	  },
	
	  /**
	   * @protected
	   */
	  mergeOption: function (newOption) {
	    var option = this.option;
	    var componentsMap = this._componentsMap;
	    var newCptTypes = [];
	    resetSourceDefaulter(this); // If no component class, merge directly.
	    // For example: color, animaiton options, etc.
	
	    each(newOption, function (componentOption, mainType) {
	      if (componentOption == null) {
	        return;
	      }
	
	      if (!ComponentModel.hasClass(mainType)) {
	        // globalSettingTask.dirty();
	        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
	      } else if (mainType) {
	        newCptTypes.push(mainType);
	      }
	    });
	    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	
	    function visitComponent(mainType, dependencies) {
	      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
	      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
	      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.
	
	      each(mapResult, function (item, index) {
	        var opt = item.option;
	
	        if (isObject(opt)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
	        }
	      });
	      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
	      option[mainType] = [];
	      componentsMap.set(mainType, []);
	      each(mapResult, function (resultItem, index) {
	        var componentModel = resultItem.exist;
	        var newCptOption = resultItem.option;
	        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
	        // see removeEdgeAndAdd in topologicalTravel and
	        // ComponentModel.getAllClassMainTypes.
	
	        if (!newCptOption) {
	          componentModel.mergeOption({}, this);
	          componentModel.optionUpdated({}, false);
	        } else {
	          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);
	
	          if (componentModel && componentModel instanceof ComponentModelClass) {
	            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
	
	            componentModel.mergeOption(newCptOption, this);
	            componentModel.optionUpdated(newCptOption, false);
	          } else {
	            // PENDING Global as parent ?
	            var extraOpt = extend({
	              dependentModels: dependentModels,
	              componentIndex: index
	            }, resultItem.keyInfo);
	            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
	            extend(componentModel, extraOpt);
	            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
	            // newCptOption has been used as componentModel.option
	            // and may be merged with theme and default, so pass null
	            // to avoid confusion.
	
	            componentModel.optionUpdated(null, true);
	          }
	        }
	
	        componentsMap.get(mainType)[index] = componentModel;
	        option[mainType][index] = componentModel.option;
	      }, this); // Backup series for filtering.
	
	      if (mainType === 'series') {
	        createSeriesIndices(this, componentsMap.get('series'));
	      }
	    }
	
	    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
	  },
	
	  /**
	   * Get option for output (cloned option and inner info removed)
	   * @public
	   * @return {Object}
	   */
	  getOption: function () {
	    var option = clone(this.option);
	    each(option, function (opts, mainType) {
	      if (ComponentModel.hasClass(mainType)) {
	        var opts = modelUtil.normalizeToArray(opts);
	
	        for (var i = opts.length - 1; i >= 0; i--) {
	          // Remove options with inner id.
	          if (modelUtil.isIdInner(opts[i])) {
	            opts.splice(i, 1);
	          }
	        }
	
	        option[mainType] = opts;
	      }
	    });
	    delete option[OPTION_INNER_KEY];
	    return option;
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getTheme: function () {
	    return this._theme;
	  },
	
	  /**
	   * @param {string} mainType
	   * @param {number} [idx=0]
	   * @return {module:echarts/model/Component}
	   */
	  getComponent: function (mainType, idx) {
	    var list = this._componentsMap.get(mainType);
	
	    if (list) {
	      return list[idx || 0];
	    }
	  },
	
	  /**
	   * If none of index and id and name used, return all components with mainType.
	   * @param {Object} condition
	   * @param {string} condition.mainType
	   * @param {string} [condition.subType] If ignore, only query by mainType
	   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  queryComponents: function (condition) {
	    var mainType = condition.mainType;
	
	    if (!mainType) {
	      return [];
	    }
	
	    var index = condition.index;
	    var id = condition.id;
	    var name = condition.name;
	
	    var cpts = this._componentsMap.get(mainType);
	
	    if (!cpts || !cpts.length) {
	      return [];
	    }
	
	    var result;
	
	    if (index != null) {
	      if (!isArray(index)) {
	        index = [index];
	      }
	
	      result = filter(map(index, function (idx) {
	        return cpts[idx];
	      }), function (val) {
	        return !!val;
	      });
	    } else if (id != null) {
	      var isIdArray = isArray(id);
	      result = filter(cpts, function (cpt) {
	        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
	      });
	    } else if (name != null) {
	      var isNameArray = isArray(name);
	      result = filter(cpts, function (cpt) {
	        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
	      });
	    } else {
	      // Return all components with mainType
	      result = cpts.slice();
	    }
	
	    return filterBySubType(result, condition);
	  },
	
	  /**
	   * The interface is different from queryComponents,
	   * which is convenient for inner usage.
	   *
	   * @usage
	   * var result = findComponents(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series'},
	   *     function (model, index) {...}
	   * );
	   * // result like [component0, componnet1, ...]
	   *
	   * @param {Object} condition
	   * @param {string} condition.mainType Mandatory.
	   * @param {string} [condition.subType] Optional.
	   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
	   *        where xxx is mainType.
	   *        If query attribute is null/undefined or has no index/id/name,
	   *        do not filtering by query conditions, which is convenient for
	   *        no-payload situations or when target of action is global.
	   * @param {Function} [condition.filter] parameter: component, return boolean.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  findComponents: function (condition) {
	    var query = condition.query;
	    var mainType = condition.mainType;
	    var queryCond = getQueryCond(query);
	    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
	    return doFilter(filterBySubType(result, condition));
	
	    function getQueryCond(q) {
	      var indexAttr = mainType + 'Index';
	      var idAttr = mainType + 'Id';
	      var nameAttr = mainType + 'Name';
	      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	        mainType: mainType,
	        // subType will be filtered finally.
	        index: q[indexAttr],
	        id: q[idAttr],
	        name: q[nameAttr]
	      } : null;
	    }
	
	    function doFilter(res) {
	      return condition.filter ? filter(res, condition.filter) : res;
	    }
	  },
	
	  /**
	   * @usage
	   * eachComponent('legend', function (legendModel, index) {
	   *     ...
	   * });
	   * eachComponent(function (componentType, model, index) {
	   *     // componentType does not include subType
	   *     // (componentType is 'xxx' but not 'xxx.aa')
	   * });
	   * eachComponent(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
	   *     function (model, index) {...}
	   * );
	   * eachComponent(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
	   *     function (model, index) {...}
	   * );
	   *
	   * @param {string|Object=} mainType When mainType is object, the definition
	   *                                  is the same as the method 'findComponents'.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachComponent: function (mainType, cb, context) {
	    var componentsMap = this._componentsMap;
	
	    if (typeof mainType === 'function') {
	      context = cb;
	      cb = mainType;
	      componentsMap.each(function (components, componentType) {
	        each(components, function (component, index) {
	          cb.call(context, componentType, component, index);
	        });
	      });
	    } else if (isString(mainType)) {
	      each(componentsMap.get(mainType), cb, context);
	    } else if (isObject(mainType)) {
	      var queryResult = this.findComponents(mainType);
	      each(queryResult, cb, context);
	    }
	  },
	
	  /**
	   * @param {string} name
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByName: function (name) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.name === name;
	    });
	  },
	
	  /**
	   * @param {number} seriesIndex
	   * @return {module:echarts/model/Series}
	   */
	  getSeriesByIndex: function (seriesIndex) {
	    return this._componentsMap.get('series')[seriesIndex];
	  },
	
	  /**
	   * Get series list before filtered by type.
	   * FIXME: rename to getRawSeriesByType?
	   *
	   * @param {string} subType
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByType: function (subType) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.subType === subType;
	    });
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeries: function () {
	    return this._componentsMap.get('series').slice();
	  },
	
	  /**
	   * @return {number}
	   */
	  getSeriesCount: function () {
	    return this._componentsMap.get('series').length;
	  },
	
	  /**
	   * After filtering, series may be different
	   * frome raw series.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      cb.call(context, series, rawSeriesIndex);
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeries: function (cb, context) {
	    each(this._componentsMap.get('series'), cb, context);
	  },
	
	  /**
	   * After filtering, series may be different.
	   * frome raw series.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeriesByType: function (subType, cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      if (series.subType === subType) {
	        cb.call(context, series, rawSeriesIndex);
	      }
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered of given type.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeriesByType: function (subType, cb, context) {
	    return each(this.getSeriesByType(subType), cb, context);
	  },
	
	  /**
	   * @param {module:echarts/model/Series} seriesModel
	   */
	  isSeriesFiltered: function (seriesModel) {
	    assertSeriesInitialized(this);
	    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getCurrentSeriesIndices: function () {
	    return (this._seriesIndices || []).slice();
	  },
	
	  /**
	   * @param {Function} cb
	   * @param {*} context
	   */
	  filterSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
	    createSeriesIndices(this, filteredSeries);
	  },
	  restoreData: function (payload) {
	    var componentsMap = this._componentsMap;
	    createSeriesIndices(this, componentsMap.get('series'));
	    var componentTypes = [];
	    componentsMap.each(function (components, componentType) {
	      componentTypes.push(componentType);
	    });
	    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
	      each(componentsMap.get(componentType), function (component) {
	        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
	      });
	    });
	  }
	});
	
	function isNotTargetSeries(seriesModel, payload) {
	  if (payload) {
	    var index = payload.seiresIndex;
	    var id = payload.seriesId;
	    var name = payload.seriesName;
	    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
	  }
	}
	/**
	 * @inner
	 */
	
	
	function mergeTheme(option, theme) {
	  // PENDING
	  // NOT use `colorLayer` in theme if option has `color`
	  var notMergeColorLayer = option.color && !option.colorLayer;
	  each(theme, function (themeItem, name) {
	    if (name === 'colorLayer' && notMergeColorLayer) {
	      return;
	    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
	
	
	    if (!ComponentModel.hasClass(name)) {
	      if (typeof themeItem === 'object') {
	        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
	      } else {
	        if (option[name] == null) {
	          option[name] = themeItem;
	        }
	      }
	    }
	  });
	}
	
	function initBase(baseOption) {
	  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
	  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
	
	  this.option = {};
	  this.option[OPTION_INNER_KEY] = 1;
	  /**
	   * Init with series: [], in case of calling findSeries method
	   * before series initialized.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @private
	   */
	
	  this._componentsMap = createHashMap({
	    series: []
	  });
	  /**
	   * Mapping between filtered series list and raw series list.
	   * key: filtered series indices, value: raw series indices.
	   * @type {Array.<nubmer>}
	   * @private
	   */
	
	  this._seriesIndices;
	  this._seriesIndicesMap;
	  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
	
	  merge(baseOption, globalDefault, false);
	  this.mergeOption(baseOption);
	}
	/**
	 * @inner
	 * @param {Array.<string>|string} types model types
	 * @return {Object} key: {string} type, value: {Array.<Object>} models
	 */
	
	
	function getComponentsByTypes(componentsMap, types) {
	  if (!isArray(types)) {
	    types = types ? [types] : [];
	  }
	
	  var ret = {};
	  each(types, function (type) {
	    ret[type] = (componentsMap.get(type) || []).slice();
	  });
	  return ret;
	}
	/**
	 * @inner
	 */
	
	
	function determineSubType(mainType, newCptOption, existComponent) {
	  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
	
	  return subType;
	}
	/**
	 * @inner
	 */
	
	
	function createSeriesIndices(ecModel, seriesModels) {
	  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
	    return series.componentIndex;
	  }) || []);
	}
	/**
	 * @inner
	 */
	
	
	function filterBySubType(components, condition) {
	  // Using hasOwnProperty for restrict. Consider
	  // subType is undefined in user payload.
	  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
	    return cpt.subType === condition.subType;
	  }) : components;
	}
	/**
	 * @inner
	 */
	
	
	function assertSeriesInitialized(ecModel) {}
	
	mixin(GlobalModel, colorPaletteMixin);
	var _default = GlobalModel;
	module.exports = _default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var isArray = zrUtil.isArray;
	/**
	 * Make the name displayable. But we should
	 * make sure it is not duplicated with user
	 * specified name, so use '\0';
	 */
	
	var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
	/**
	 * If value is not array, then translate it to array.
	 * @param  {*} value
	 * @return {Array} [value] or value
	 */
	
	function normalizeToArray(value) {
	  return value instanceof Array ? value : value == null ? [] : [value];
	}
	/**
	 * Sync default option between normal and emphasis like `position` and `show`
	 * In case some one will write code like
	 *     label: {
	 *          show: false,
	 *          position: 'outside',
	 *          fontSize: 18
	 *     },
	 *     emphasis: {
	 *          label: { show: true }
	 *     }
	 * @param {Object} opt
	 * @param {string} key
	 * @param {Array.<string>} subOpts
	 */
	
	
	function defaultEmphasis(opt, key, subOpts) {
	  // Caution: performance sensitive.
	  if (opt) {
	    opt[key] = opt[key] || {};
	    opt.emphasis = opt.emphasis || {};
	    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
	
	    for (var i = 0, len = subOpts.length; i < len; i++) {
	      var subOptName = subOpts[i];
	
	      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
	        opt.emphasis[key][subOptName] = opt[key][subOptName];
	      }
	    }
	  }
	}
	
	var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	//     // FIXME: deprecated, check and remove it.
	//     'textStyle'
	// ]);
	
	/**
	 * The method do not ensure performance.
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method retieves value from data.
	 * @param {string|number|Date|Array|Object} dataItem
	 * @return {number|string|Date|Array.<number|string|Date>}
	 */
	
	function getDataItemValue(dataItem) {
	  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
	}
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method determine if dataItem has extra option besides value
	 * @param {string|number|Date|Array|Object} dataItem
	 */
	
	
	function isDataItemOption(dataItem) {
	  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	}
	/**
	 * Mapping to exists for merge.
	 *
	 * @public
	 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
	 * @param {Object|Array.<Object>} newCptOptions
	 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          index of which is the same as exists.
	 */
	
	
	function mappingToExists(exists, newCptOptions) {
	  // Mapping by the order by original option (but not order of
	  // new option) in merge mode. Because we should ensure
	  // some specified index (like xAxisIndex) is consistent with
	  // original option, which is easy to understand, espatially in
	  // media query. And in most case, merge option is used to
	  // update partial option but not be expected to change order.
	  newCptOptions = (newCptOptions || []).slice();
	  var result = zrUtil.map(exists || [], function (obj, index) {
	    return {
	      exist: obj
	    };
	  }); // Mapping by id or name if specified.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    } // id has highest priority.
	
	
	    for (var i = 0; i < result.length; i++) {
	      if (!result[i].option // Consider name: two map to one.
	      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	
	    for (var i = 0; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Consider name: two map to one.
	      // Can not match when both ids exist but different.
	      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	  }); // Otherwise mapping by index.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    }
	
	    var i = 0;
	
	    for (; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Existing model that already has id should be able to
	      // mapped to (because after mapping performed model may
	      // be assigned with a id, whish should not affect next
	      // mapping), except those has inner id.
	      && !isIdInner(exist) // Caution:
	      // Do not overwrite id. But name can be overwritten,
	      // because axis use name as 'show label text'.
	      // 'exist' always has id and name and we dont
	      // need to check it.
	      && cptOption.id == null) {
	        result[i].option = cptOption;
	        break;
	      }
	    }
	
	    if (i >= result.length) {
	      result.push({
	        option: cptOption
	      });
	    }
	  });
	  return result;
	}
	/**
	 * Make id and name for mapping result (result of mappingToExists)
	 * into `keyInfo` field.
	 *
	 * @public
	 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          which order is the same as exists.
	 * @return {Array.<Object>} The input.
	 */
	
	
	function makeIdAndName(mapResult) {
	  // We use this id to hash component models and view instances
	  // in echarts. id can be specified by user, or auto generated.
	  // The id generation rule ensures new view instance are able
	  // to mapped to old instance when setOption are called in
	  // no-merge mode. So we generate model id by name and plus
	  // type in view id.
	  // name can be duplicated among components, which is convenient
	  // to specify multi components (like series) by one name.
	  // Ensure that each id is distinct.
	  var idMap = zrUtil.createHashMap();
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    existCpt && idMap.set(existCpt.id, item);
	  });
	  each(mapResult, function (item, index) {
	    var opt = item.option;
	    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	    opt && opt.id != null && idMap.set(opt.id, item);
	    !item.keyInfo && (item.keyInfo = {});
	  }); // Make name and id.
	
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    var opt = item.option;
	    var keyInfo = item.keyInfo;
	
	    if (!isObject(opt)) {
	      return;
	    } // name can be overwitten. Consider case: axis.name = '20km'.
	    // But id generated by name will not be changed, which affect
	    // only in that case: setOption with 'not merge mode' and view
	    // instance will be recreated, which can be accepted.
	
	
	    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
	    // because name may be used like in color pallet.
	    : DUMMY_COMPONENT_NAME_PREFIX + index;
	
	    if (existCpt) {
	      keyInfo.id = existCpt.id;
	    } else if (opt.id != null) {
	      keyInfo.id = opt.id + '';
	    } else {
	      // Consider this situatoin:
	      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	      // Series with the same name between optionA and optionB
	      // should be mapped.
	      var idNum = 0;
	
	      do {
	        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	      } while (idMap.get(keyInfo.id));
	    }
	
	    idMap.set(keyInfo.id, item);
	  });
	}
	
	function isNameSpecified(componentModel) {
	  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
	
	  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
	}
	/**
	 * @public
	 * @param {Object} cptOption
	 * @return {boolean}
	 */
	
	
	function isIdInner(cptOption) {
	  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
	}
	/**
	 * A helper for removing duplicate items between batchA and batchB,
	 * and in themselves, and categorize by series.
	 *
	 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
	 */
	
	
	function compressBatches(batchA, batchB) {
	  var mapA = {};
	  var mapB = {};
	  makeMap(batchA || [], mapA);
	  makeMap(batchB || [], mapB, mapA);
	  return [mapToArray(mapA), mapToArray(mapB)];
	
	  function makeMap(sourceBatch, map, otherMap) {
	    for (var i = 0, len = sourceBatch.length; i < len; i++) {
	      var seriesId = sourceBatch[i].seriesId;
	      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	      var otherDataIndices = otherMap && otherMap[seriesId];
	
	      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	        var dataIndex = dataIndices[j];
	
	        if (otherDataIndices && otherDataIndices[dataIndex]) {
	          otherDataIndices[dataIndex] = null;
	        } else {
	          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	        }
	      }
	    }
	  }
	
	  function mapToArray(map, isData) {
	    var result = [];
	
	    for (var i in map) {
	      if (map.hasOwnProperty(i) && map[i] != null) {
	        if (isData) {
	          result.push(+i);
	        } else {
	          var dataIndices = mapToArray(map[i], true);
	          dataIndices.length && result.push({
	            seriesId: i,
	            dataIndex: dataIndices
	          });
	        }
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	 *                         each of which can be Array or primary type.
	 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
	 */
	
	
	function queryDataIndex(data, payload) {
	  if (payload.dataIndexInside != null) {
	    return payload.dataIndexInside;
	  } else if (payload.dataIndex != null) {
	    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
	      return data.indexOfRawIndex(value);
	    }) : data.indexOfRawIndex(payload.dataIndex);
	  } else if (payload.name != null) {
	    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
	      return data.indexOfName(value);
	    }) : data.indexOfName(payload.name);
	  }
	}
	/**
	 * Enable property storage to any host object.
	 * Notice: Serialization is not supported.
	 *
	 * For example:
	 * var inner = zrUitl.makeInner();
	 *
	 * function some1(hostObj) {
	 *      inner(hostObj).someProperty = 1212;
	 *      ...
	 * }
	 * function some2() {
	 *      var fields = inner(this);
	 *      fields.someProperty1 = 1212;
	 *      fields.someProperty2 = 'xx';
	 *      ...
	 * }
	 *
	 * @return {Function}
	 */
	
	
	function makeInner() {
	  // Consider different scope by es module import.
	  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
	  return function (hostObj) {
	    return hostObj[key] || (hostObj[key] = {});
	  };
	}
	
	var innerUniqueIndex = 0;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex, seriesId, seriesName,
	 *            geoIndex, geoId, geoName,
	 *            bmapIndex, bmapId, bmapName,
	 *            xAxisIndex, xAxisId, xAxisName,
	 *            yAxisIndex, yAxisId, yAxisName,
	 *            gridIndex, gridId, gridName,
	 *            ... (can be extended)
	 *        }
	 *        Each properties can be number|string|Array.<number>|Array.<string>
	 *        For example, a finder could be
	 *        {
	 *            seriesIndex: 3,
	 *            geoId: ['aa', 'cc'],
	 *            gridName: ['xx', 'rr']
	 *        }
	 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
	 *        If nothing or null/undefined specified, return nothing.
	 * @param {Object} [opt]
	 * @param {string} [opt.defaultMainType]
	 * @param {Array.<string>} [opt.includeMainTypes]
	 * @return {Object} result like:
	 *        {
	 *            seriesModels: [seriesModel1, seriesModel2],
	 *            seriesModel: seriesModel1, // The first model
	 *            geoModels: [geoModel1, geoModel2],
	 *            geoModel: geoModel1, // The first model
	 *            ...
	 *        }
	 */
	
	function parseFinder(ecModel, finder, opt) {
	  if (zrUtil.isString(finder)) {
	    var obj = {};
	    obj[finder + 'Index'] = 0;
	    finder = obj;
	  }
	
	  var defaultMainType = opt && opt.defaultMainType;
	
	  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
	    finder[defaultMainType + 'Index'] = 0;
	  }
	
	  var result = {};
	  each(finder, function (value, key) {
	    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
	
	    if (key === 'dataIndex' || key === 'dataIndexInside') {
	      result[key] = value;
	      return;
	    }
	
	    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	    var mainType = parsedKey[1];
	    var queryType = (parsedKey[2] || '').toLowerCase();
	
	    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
	      return;
	    }
	
	    var queryParam = {
	      mainType: mainType
	    };
	
	    if (queryType !== 'index' || value !== 'all') {
	      queryParam[queryType] = value;
	    }
	
	    var models = ecModel.queryComponents(queryParam);
	    result[mainType + 'Models'] = models;
	    result[mainType + 'Model'] = models[0];
	  });
	  return result;
	}
	
	function has(obj, prop) {
	  return obj && obj.hasOwnProperty(prop);
	}
	
	function setAttribute(dom, key, value) {
	  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
	}
	
	function getAttribute(dom, key) {
	  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
	}
	
	function getTooltipRenderMode(renderModeOption) {
	  if (renderModeOption === 'auto') {
	    // Using html when `document` exists, use richText otherwise
	    return env.domSupported ? 'html' : 'richText';
	  } else {
	    return renderModeOption || 'html';
	  }
	}
	/**
	 * Group a list by key.
	 *
	 * @param {Array} array
	 * @param {Function} getKey
	 *        param {*} Array item
	 *        return {string} key
	 * @return {Object} Result
	 *        {Array}: keys,
	 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
	 */
	
	
	function groupData(array, getKey) {
	  var buckets = zrUtil.createHashMap();
	  var keys = [];
	  zrUtil.each(array, function (item) {
	    var key = getKey(item);
	    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
	  });
	  return {
	    keys: keys,
	    buckets: buckets
	  };
	}
	
	exports.normalizeToArray = normalizeToArray;
	exports.defaultEmphasis = defaultEmphasis;
	exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
	exports.getDataItemValue = getDataItemValue;
	exports.isDataItemOption = isDataItemOption;
	exports.mappingToExists = mappingToExists;
	exports.makeIdAndName = makeIdAndName;
	exports.isNameSpecified = isNameSpecified;
	exports.isIdInner = isIdInner;
	exports.compressBatches = compressBatches;
	exports.queryDataIndex = queryDataIndex;
	exports.makeInner = makeInner;
	exports.parseFinder = parseFinder;
	exports.setAttribute = setAttribute;
	exports.getAttribute = getAttribute;
	exports.getTooltipRenderMode = getTooltipRenderMode;
	exports.groupData = groupData;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	var _clazz = __webpack_require__(175);
	
	var enableClassExtend = _clazz.enableClassExtend;
	var enableClassCheck = _clazz.enableClassCheck;
	
	var lineStyleMixin = __webpack_require__(176);
	
	var areaStyleMixin = __webpack_require__(178);
	
	var textStyleMixin = __webpack_require__(179);
	
	var itemStyleMixin = __webpack_require__(214);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/model/Model
	 */
	var mixin = zrUtil.mixin;
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Model
	 * @constructor
	 * @param {Object} [option]
	 * @param {module:echarts/model/Model} [parentModel]
	 * @param {module:echarts/model/Global} [ecModel]
	 */
	
	function Model(option, parentModel, ecModel) {
	  /**
	   * @type {module:echarts/model/Model}
	   * @readOnly
	   */
	  this.parentModel = parentModel;
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @type {Object}
	   * @protected
	   */
	
	  this.option = option; // Simple optimization
	  // if (this.init) {
	  //     if (arguments.length <= 4) {
	  //         this.init(option, parentModel, ecModel, extraOpt);
	  //     }
	  //     else {
	  //         this.init.apply(this, arguments);
	  //     }
	  // }
	}
	
	Model.prototype = {
	  constructor: Model,
	
	  /**
	   * Model 的初始化函数
	   * @param {Object} option
	   */
	  init: null,
	
	  /**
	   * 从新的 Option merge
	   */
	  mergeOption: function (option) {
	    zrUtil.merge(this.option, option, true);
	  },
	
	  /**
	   * @param {string|Array.<string>} path
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  get: function (path, ignoreParent) {
	    if (path == null) {
	      return this.option;
	    }
	
	    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
	  },
	
	  /**
	   * @param {string} key
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  getShallow: function (key, ignoreParent) {
	    var option = this.option;
	    var val = option == null ? option : option[key];
	    var parentModel = !ignoreParent && getParent(this, key);
	
	    if (val == null && parentModel) {
	      val = parentModel.getShallow(key);
	    }
	
	    return val;
	  },
	
	  /**
	   * @param {string|Array.<string>} [path]
	   * @param {module:echarts/model/Model} [parentModel]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path, parentModel) {
	    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
	    var thisParentModel;
	    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
	    return new Model(obj, parentModel, this.ecModel);
	  },
	
	  /**
	   * If model has option
	   */
	  isEmpty: function () {
	    return this.option == null;
	  },
	  restoreData: function () {},
	  // Pending
	  clone: function () {
	    var Ctor = this.constructor;
	    return new Ctor(zrUtil.clone(this.option));
	  },
	  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
	  },
	  // If path is null/undefined, return null/undefined.
	  parsePath: function (path) {
	    if (typeof path === 'string') {
	      path = path.split('.');
	    }
	
	    return path;
	  },
	
	  /**
	   * @param {Function} getParentMethod
	   *        param {Array.<string>|string} path
	   *        return {module:echarts/model/Model}
	   */
	  customizeGetParent: function (getParentMethod) {
	    inner(this).getParent = getParentMethod;
	  },
	  isAnimationEnabled: function () {
	    if (!env.node) {
	      if (this.option.animation != null) {
	        return !!this.option.animation;
	      } else if (this.parentModel) {
	        return this.parentModel.isAnimationEnabled();
	      }
	    }
	  }
	};
	
	function doGet(obj, pathArr, parentModel) {
	  for (var i = 0; i < pathArr.length; i++) {
	    // Ignore empty
	    if (!pathArr[i]) {
	      continue;
	    } // obj could be number/string/... (like 0)
	
	
	    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  if (obj == null && parentModel) {
	    obj = parentModel.get(pathArr);
	  }
	
	  return obj;
	} // `path` can be null/undefined
	
	
	function getParent(model, path) {
	  var getParentMethod = inner(model).getParent;
	  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
	} // Enable Model.extend.
	
	
	enableClassExtend(Model);
	enableClassCheck(Model);
	mixin(Model, lineStyleMixin);
	mixin(Model, areaStyleMixin);
	mixin(Model, textStyleMixin);
	mixin(Model, itemStyleMixin);
	var _default = Model;
	module.exports = _default;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TYPE_DELIMITER = '.';
	var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	/**
	 * Notice, parseClassType('') should returns {main: '', sub: ''}
	 * @public
	 */
	
	function parseClassType(componentType) {
	  var ret = {
	    main: '',
	    sub: ''
	  };
	
	  if (componentType) {
	    componentType = componentType.split(TYPE_DELIMITER);
	    ret.main = componentType[0] || '';
	    ret.sub = componentType[1] || '';
	  }
	
	  return ret;
	}
	/**
	 * @public
	 */
	
	
	function checkClassType(componentType) {
	  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	}
	/**
	 * @public
	 */
	
	
	function enableClassExtend(RootClass, mandatoryMethods) {
	  RootClass.$constructor = RootClass;
	
	  RootClass.extend = function (proto) {
	    var superClass = this;
	
	    var ExtendedClass = function () {
	      if (!proto.$constructor) {
	        superClass.apply(this, arguments);
	      } else {
	        proto.$constructor.apply(this, arguments);
	      }
	    };
	
	    zrUtil.extend(ExtendedClass.prototype, proto);
	    ExtendedClass.extend = this.extend;
	    ExtendedClass.superCall = superCall;
	    ExtendedClass.superApply = superApply;
	    zrUtil.inherits(ExtendedClass, this);
	    ExtendedClass.superClass = superClass;
	    return ExtendedClass;
	  };
	}
	
	var classBase = 0;
	/**
	 * Can not use instanceof, consider different scope by
	 * cross domain or es module import in ec extensions.
	 * Mount a method "isInstance()" to Clz.
	 */
	
	function enableClassCheck(Clz) {
	  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
	  Clz.prototype[classAttr] = true;
	
	  Clz.isInstance = function (obj) {
	    return !!(obj && obj[classAttr]);
	  };
	} // superCall should have class info, which can not be fetch from 'this'.
	// Consider this case:
	// class A has method f,
	// class B inherits class A, overrides method f, f call superApply('f'),
	// class C inherits class B, do not overrides method f,
	// then when method of class C is called, dead loop occured.
	
	
	function superCall(context, methodName) {
	  var args = zrUtil.slice(arguments, 2);
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	
	function superApply(context, methodName, args) {
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	/**
	 * @param {Object} entity
	 * @param {Object} options
	 * @param {boolean} [options.registerWhenExtend]
	 * @public
	 */
	
	
	function enableClassManagement(entity, options) {
	  options = options || {};
	  /**
	   * Component model classes
	   * key: componentType,
	   * value:
	   *     componentClass, when componentType is 'xxx'
	   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
	   * @type {Object}
	   */
	
	  var storage = {};
	
	  entity.registerClass = function (Clazz, componentType) {
	    if (componentType) {
	      checkClassType(componentType);
	      componentType = parseClassType(componentType);
	
	      if (!componentType.sub) {
	        storage[componentType.main] = Clazz;
	      } else if (componentType.sub !== IS_CONTAINER) {
	        var container = makeContainer(componentType);
	        container[componentType.sub] = Clazz;
	      }
	    }
	
	    return Clazz;
	  };
	
	  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
	    var Clazz = storage[componentMainType];
	
	    if (Clazz && Clazz[IS_CONTAINER]) {
	      Clazz = subType ? Clazz[subType] : null;
	    }
	
	    if (throwWhenNotFound && !Clazz) {
	      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
	    }
	
	    return Clazz;
	  };
	
	  entity.getClassesByMainType = function (componentType) {
	    componentType = parseClassType(componentType);
	    var result = [];
	    var obj = storage[componentType.main];
	
	    if (obj && obj[IS_CONTAINER]) {
	      zrUtil.each(obj, function (o, type) {
	        type !== IS_CONTAINER && result.push(o);
	      });
	    } else {
	      result.push(obj);
	    }
	
	    return result;
	  };
	
	  entity.hasClass = function (componentType) {
	    // Just consider componentType.main.
	    componentType = parseClassType(componentType);
	    return !!storage[componentType.main];
	  };
	  /**
	   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
	   */
	
	
	  entity.getAllClassMainTypes = function () {
	    var types = [];
	    zrUtil.each(storage, function (obj, type) {
	      types.push(type);
	    });
	    return types;
	  };
	  /**
	   * If a main type is container and has sub types
	   * @param  {string}  mainType
	   * @return {boolean}
	   */
	
	
	  entity.hasSubTypes = function (componentType) {
	    componentType = parseClassType(componentType);
	    var obj = storage[componentType.main];
	    return obj && obj[IS_CONTAINER];
	  };
	
	  entity.parseClassType = parseClassType;
	
	  function makeContainer(componentType) {
	    var container = storage[componentType.main];
	
	    if (!container || !container[IS_CONTAINER]) {
	      container = storage[componentType.main] = {};
	      container[IS_CONTAINER] = true;
	    }
	
	    return container;
	  }
	
	  if (options.registerWhenExtend) {
	    var originalExtend = entity.extend;
	
	    if (originalExtend) {
	      entity.extend = function (proto) {
	        var ExtendedClass = originalExtend.call(this, proto);
	        return entity.registerClass(ExtendedClass, proto.type);
	      };
	    }
	  }
	
	  return entity;
	}
	/**
	 * @param {string|Array.<string>} properties
	 */
	
	
	function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
	  // if (!zrUtil.isArray(properties)) {
	  //     properties = properties != null ? [properties] : [];
	  // }
	  // zrUtil.each(properties, function (prop) {
	  //     var value = obj[prop];
	  //     Object.defineProperty
	  //         && Object.defineProperty(obj, prop, {
	  //             value: value, writable: false
	  //         });
	  //     zrUtil.isArray(obj[prop])
	  //         && Object.freeze
	  //         && Object.freeze(obj[prop]);
	  // });
	}
	
	exports.parseClassType = parseClassType;
	exports.enableClassExtend = enableClassExtend;
	exports.enableClassCheck = enableClassCheck;
	exports.enableClassManagement = enableClassManagement;
	exports.setReadOnly = setReadOnly;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getLineStyle: function (excludes) {
	    var style = getLineStyle(this, excludes);
	    var lineDash = this.getLineDash(style.lineWidth);
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getLineDash: function (lineWidth) {
	    if (lineWidth == null) {
	      lineWidth = 1;
	    }
	
	    var lineType = this.get('type');
	    var dotSize = Math.max(lineWidth, 2);
	    var dashSize = lineWidth * 4;
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
	  }
	};
	module.exports = _default;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Parse shadow style
	// TODO Only shallow path support
	function _default(properties) {
	  // Normalize
	  for (var i = 0; i < properties.length; i++) {
	    if (!properties[i][1]) {
	      properties[i][1] = properties[i][0];
	    }
	  }
	
	  return function (model, excludes, includes) {
	    var style = {};
	
	    for (var i = 0; i < properties.length; i++) {
	      var propName = properties[i][1];
	
	      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
	        continue;
	      }
	
	      var val = model.getShallow(propName);
	
	      if (val != null) {
	        style[properties[i][0]] = val;
	      }
	    }
	
	    return style;
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
	var _default = {
	  getAreaStyle: function (excludes, includes) {
	    return getAreaStyle(this, excludes, includes);
	  }
	};
	module.exports = _default;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(167);
	
	var graphicUtil = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PATH_COLOR = ['textStyle', 'color'];
	var _default = {
	  /**
	   * Get color property or get color from option.textStyle.color
	   * @param {boolean} [isEmphasis]
	   * @return {string}
	   */
	  getTextColor: function (isEmphasis) {
	    var ecModel = this.ecModel;
	    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	  },
	
	  /**
	   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	   * @return {string}
	   */
	  getFont: function () {
	    return graphicUtil.getFont({
	      fontStyle: this.getShallow('fontStyle'),
	      fontWeight: this.getShallow('fontWeight'),
	      fontSize: this.getShallow('fontSize'),
	      fontFamily: this.getShallow('fontFamily')
	    }, this.ecModel);
	  },
	  getTextRect: function (text) {
	    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
	  }
	};
	module.exports = _default;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var pathTool = __webpack_require__(181);
	
	var colorTool = __webpack_require__(150);
	
	var matrix = __webpack_require__(145);
	
	var vector = __webpack_require__(136);
	
	var Path = __webpack_require__(182);
	
	var Transformable = __webpack_require__(144);
	
	var ZImage = __webpack_require__(163);
	
	exports.Image = ZImage;
	
	var Group = __webpack_require__(142);
	
	exports.Group = Group;
	
	var Text = __webpack_require__(194);
	
	exports.Text = Text;
	
	var Circle = __webpack_require__(195);
	
	exports.Circle = Circle;
	
	var Sector = __webpack_require__(196);
	
	exports.Sector = Sector;
	
	var Ring = __webpack_require__(198);
	
	exports.Ring = Ring;
	
	var Polygon = __webpack_require__(199);
	
	exports.Polygon = Polygon;
	
	var Polyline = __webpack_require__(203);
	
	exports.Polyline = Polyline;
	
	var Rect = __webpack_require__(204);
	
	exports.Rect = Rect;
	
	var Line = __webpack_require__(206);
	
	exports.Line = Line;
	
	var BezierCurve = __webpack_require__(207);
	
	exports.BezierCurve = BezierCurve;
	
	var Arc = __webpack_require__(208);
	
	exports.Arc = Arc;
	
	var CompoundPath = __webpack_require__(209);
	
	exports.CompoundPath = CompoundPath;
	
	var LinearGradient = __webpack_require__(210);
	
	exports.LinearGradient = LinearGradient;
	
	var RadialGradient = __webpack_require__(212);
	
	exports.RadialGradient = RadialGradient;
	
	var BoundingRect = __webpack_require__(154);
	
	exports.BoundingRect = BoundingRect;
	
	var IncrementalDisplayable = __webpack_require__(213);
	
	exports.IncrementalDisplayable = IncrementalDisplayable;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var round = Math.round;
	var mathMax = Math.max;
	var mathMin = Math.min;
	var EMPTY_OBJ = {};
	var Z2_EMPHASIS_LIFT = 1;
	/**
	 * Extend shape with parameters
	 */
	
	function extendShape(opts) {
	  return Path.extend(opts);
	}
	/**
	 * Extend path
	 */
	
	
	function extendPath(pathData, opts) {
	  return pathTool.extendFromString(pathData, opts);
	}
	/**
	 * Create a path element from path data string
	 * @param {string} pathData
	 * @param {Object} opts
	 * @param {module:zrender/core/BoundingRect} rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makePath(pathData, opts, rect, layout) {
	  var path = pathTool.createFromString(pathData, opts);
	
	  if (rect) {
	    if (layout === 'center') {
	      rect = centerGraphic(rect, path.getBoundingRect());
	    }
	
	    resizePath(path, rect);
	  }
	
	  return path;
	}
	/**
	 * Create a image element from image url
	 * @param {string} imageUrl image url
	 * @param {Object} opts options
	 * @param {module:zrender/core/BoundingRect} rect constrain rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makeImage(imageUrl, rect, layout) {
	  var path = new ZImage({
	    style: {
	      image: imageUrl,
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    onload: function (img) {
	      if (layout === 'center') {
	        var boundingRect = {
	          width: img.width,
	          height: img.height
	        };
	        path.setStyle(centerGraphic(rect, boundingRect));
	      }
	    }
	  });
	  return path;
	}
	/**
	 * Get position of centered element in bounding box.
	 *
	 * @param  {Object} rect         element local bounding box
	 * @param  {Object} boundingRect constraint bounding box
	 * @return {Object} element position containing x, y, width, and height
	 */
	
	
	function centerGraphic(rect, boundingRect) {
	  // Set rect to center, keep width / height ratio.
	  var aspect = boundingRect.width / boundingRect.height;
	  var width = rect.height * aspect;
	  var height;
	
	  if (width <= rect.width) {
	    height = rect.height;
	  } else {
	    width = rect.width;
	    height = width / aspect;
	  }
	
	  var cx = rect.x + rect.width / 2;
	  var cy = rect.y + rect.height / 2;
	  return {
	    x: cx - width / 2,
	    y: cy - height / 2,
	    width: width,
	    height: height
	  };
	}
	
	var mergePath = pathTool.mergePath;
	/**
	 * Resize a path to fit the rect
	 * @param {module:zrender/graphic/Path} path
	 * @param {Object} rect
	 */
	
	function resizePath(path, rect) {
	  if (!path.applyTransform) {
	    return;
	  }
	
	  var pathRect = path.getBoundingRect();
	  var m = pathRect.calculateTransform(rect);
	  path.applyTransform(m);
	}
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x1]
	 * @param {number} [param.shape.y1]
	 * @param {number} [param.shape.x2]
	 * @param {number} [param.shape.y2]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeLine(param) {
	  var shape = param.shape;
	  var lineWidth = param.style.lineWidth;
	
	  if (round(shape.x1 * 2) === round(shape.x2 * 2)) {
	    shape.x1 = shape.x2 = subPixelOptimize(shape.x1, lineWidth, true);
	  }
	
	  if (round(shape.y1 * 2) === round(shape.y2 * 2)) {
	    shape.y1 = shape.y2 = subPixelOptimize(shape.y1, lineWidth, true);
	  }
	
	  return param;
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x]
	 * @param {number} [param.shape.y]
	 * @param {number} [param.shape.width]
	 * @param {number} [param.shape.height]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeRect(param) {
	  var shape = param.shape;
	  var lineWidth = param.style.lineWidth;
	  var originX = shape.x;
	  var originY = shape.y;
	  var originWidth = shape.width;
	  var originHeight = shape.height;
	  shape.x = subPixelOptimize(shape.x, lineWidth, true);
	  shape.y = subPixelOptimize(shape.y, lineWidth, true);
	  shape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - shape.x, originWidth === 0 ? 0 : 1);
	  shape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - shape.y, originHeight === 0 ? 0 : 1);
	  return param;
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	function hasFillOrStroke(fillOrStroke) {
	  return fillOrStroke != null && fillOrStroke !== 'none';
	} // Most lifted color are duplicated.
	
	
	var liftedColorMap = zrUtil.createHashMap();
	var liftedColorCount = 0;
	
	function liftColor(color) {
	  if (typeof color !== 'string') {
	    return color;
	  }
	
	  var liftedColor = liftedColorMap.get(color);
	
	  if (!liftedColor) {
	    liftedColor = colorTool.lift(color, -0.1);
	
	    if (liftedColorCount < 10000) {
	      liftedColorMap.set(color, liftedColor);
	      liftedColorCount++;
	    }
	  }
	
	  return liftedColor;
	}
	
	function cacheElementStl(el) {
	  if (!el.__hoverStlDirty) {
	    return;
	  }
	
	  el.__hoverStlDirty = false;
	  var hoverStyle = el.__hoverStl;
	
	  if (!hoverStyle) {
	    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
	    return;
	  }
	
	  var normalStyle = el.__cachedNormalStl = {};
	  el.__cachedNormalZ2 = el.z2;
	  var elStyle = el.style;
	
	  for (var name in hoverStyle) {
	    // See comment in `doSingleEnterHover`.
	    if (hoverStyle[name] != null) {
	      normalStyle[name] = elStyle[name];
	    }
	  } // Always cache fill and stroke to normalStyle for lifting color.
	
	
	  normalStyle.fill = elStyle.fill;
	  normalStyle.stroke = elStyle.stroke;
	}
	
	function doSingleEnterHover(el) {
	  var hoverStl = el.__hoverStl;
	
	  if (!hoverStl || el.__highlighted) {
	    return;
	  }
	
	  var useHoverLayer = el.useHoverLayer;
	  el.__highlighted = useHoverLayer ? 'layer' : 'plain';
	  var zr = el.__zr;
	
	  if (!zr && useHoverLayer) {
	    return;
	  }
	
	  var elTarget = el;
	  var targetStyle = el.style;
	
	  if (useHoverLayer) {
	    elTarget = zr.addHover(el);
	    targetStyle = elTarget.style;
	  }
	
	  rollbackDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    cacheElementStl(elTarget);
	  } // styles can be:
	  // {
	  //    label: {
	  //        show: false,
	  //        position: 'outside',
	  //        fontSize: 18
	  //    },
	  //    emphasis: {
	  //        label: {
	  //            show: true
	  //        }
	  //    }
	  // },
	  // where properties of `emphasis` may not appear in `normal`. We previously use
	  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
	  // But consider rich text and setOption in merge mode, it is impossible to cover
	  // all properties in merge. So we use merge mode when setting style here, where
	  // only properties that is not `null/undefined` can be set. The disadventage:
	  // null/undefined can not be used to remove style any more in `emphasis`.
	
	
	  targetStyle.extendFrom(hoverStl);
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
	  applyDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    el.dirty(false);
	    el.z2 += Z2_EMPHASIS_LIFT;
	  }
	}
	
	function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
	  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
	    targetStyle[prop] = liftColor(targetStyle[prop]);
	  }
	}
	
	function doSingleLeaveHover(el) {
	  var highlighted = el.__highlighted;
	
	  if (!highlighted) {
	    return;
	  }
	
	  el.__highlighted = false;
	
	  if (highlighted === 'layer') {
	    el.__zr && el.__zr.removeHover(el);
	  } else if (highlighted) {
	    var style = el.style;
	    var normalStl = el.__cachedNormalStl;
	
	    if (normalStl) {
	      rollbackDefaultTextStyle(style); // Consider null/undefined value, should use
	      // `setStyle` but not `extendFrom(stl, true)`.
	
	      el.setStyle(normalStl);
	      applyDefaultTextStyle(style);
	    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
	    // when `el` is on emphasis state. So here by comparing with 1, we try
	    // hard to make the bug case rare.
	
	
	    var normalZ2 = el.__cachedNormalZ2;
	
	    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
	      el.z2 = normalZ2;
	    }
	  }
	}
	
	function traverseCall(el, method) {
	  el.isGroup ? el.traverse(function (child) {
	    !child.isGroup && method(child);
	  }) : method(el);
	}
	/**
	 * Set hover style (namely "emphasis style") of element, based on the current
	 * style of the given `el`.
	 * This method should be called after all of the normal styles have been adopted
	 * to the `el`. See the reason on `setHoverStyle`.
	 *
	 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
	 * @param {Object|boolean} [hoverStl] The specified hover style.
	 *        If set as `false`, disable the hover style.
	 *        Similarly, The `el.hoverStyle` can alse be set
	 *        as `false` to disable the hover style.
	 *        Otherwise, use the default hover style if not provided.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.hoverSilentOnTouch=false] See `graphic.setAsHoverStyleTrigger`
	 */
	
	
	function setElementHoverStyle(el, hoverStl) {
	  // For performance consideration, it might be better to make the "hover style" only the
	  // difference properties from the "normal style", but not a entire copy of all styles.
	  hoverStl = el.__hoverStl = hoverStl !== false && (hoverStl || {});
	  el.__hoverStlDirty = true; // FIXME
	  // It is not completely right to save "normal"/"emphasis" flag on elements.
	  // It probably should be saved on `data` of series. Consider the cases:
	  // (1) A highlighted elements are moved out of the view port and re-enter
	  // again by dataZoom.
	  // (2) call `setOption` and replace elements totally when they are highlighted.
	
	  if (el.__highlighted) {
	    // Consider the case:
	    // The styles of a highlighted `el` is being updated. The new "emphasis style"
	    // should be adapted to the `el`. Notice here new "normal styles" should have
	    // been set outside and the cached "normal style" is out of date.
	    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
	    // of this method. In most cases, `z2` is not set and hover style should be able
	    // to rollback. Of course, that would bring bug, but only in a rare case, see
	    // `doSingleLeaveHover` for details.
	
	    doSingleLeaveHover(el);
	    doSingleEnterHover(el);
	  }
	}
	/**
	 * Emphasis (called by API) has higher priority than `mouseover`.
	 * When element has been called to be entered emphasis, mouse over
	 * should not trigger the highlight effect (for example, animation
	 * scale) again, and `mouseout` should not downplay the highlight
	 * effect. So the listener of `mouseover` and `mouseout` should
	 * check `isInEmphasis`.
	 *
	 * @param {module:zrender/Element} el
	 * @return {boolean}
	 */
	
	
	function isInEmphasis(el) {
	  return el && el.__isEmphasisEntered;
	}
	
	function onElementMouseOver(e) {
	  if (this.__hoverSilentOnTouch && e.zrByTouch) {
	    return;
	  } // Only if element is not in emphasis status
	
	
	  !this.__isEmphasisEntered && traverseCall(this, doSingleEnterHover);
	}
	
	function onElementMouseOut(e) {
	  if (this.__hoverSilentOnTouch && e.zrByTouch) {
	    return;
	  } // Only if element is not in emphasis status
	
	
	  !this.__isEmphasisEntered && traverseCall(this, doSingleLeaveHover);
	}
	
	function enterEmphasis() {
	  this.__isEmphasisEntered = true;
	  traverseCall(this, doSingleEnterHover);
	}
	
	function leaveEmphasis() {
	  this.__isEmphasisEntered = false;
	  traverseCall(this, doSingleLeaveHover);
	}
	/**
	 * Set hover style (namely "emphasis style") of element,
	 * based on the current style of the given `el`.
	 *
	 * (1)
	 * **CONSTRAINTS** for this method:
	 * <A> This method MUST be called after all of the normal styles having been adopted
	 * to the `el`.
	 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
	 * "normal style" having been set to the el.
	 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
	 * a default hover style).
	 *
	 * The reason: this method treat the current style of the `el` as the "normal style"
	 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
	 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
	 * logic, where the el should shift from the original emphasis style to the new
	 * "emphasis style" and should be able to "downplay" back to the new "normal style".
	 *
	 * Indeed, it is error-prone to make a interface has so many constraints, but I have
	 * not found a better solution yet to fit the backward compatibility, performance and
	 * the current programming style.
	 *
	 * (2)
	 * Call the method for a "root" element once. Do not call it for each descendants.
	 * If the descendants elemenets of a group has itself hover style different from the
	 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
	 * not call this method for them.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.hoverSilentOnTouch=false] See `graphic.setAsHoverStyleTrigger`.
	 */
	
	
	function setHoverStyle(el, hoverStyle, opt) {
	  el.isGroup ? el.traverse(function (child) {
	    // If element has sepcified hoverStyle, then use it instead of given hoverStyle
	    // Often used when item group has a label element and it's hoverStyle is different
	    !child.isGroup && setElementHoverStyle(child, child.hoverStyle || hoverStyle);
	  }) : setElementHoverStyle(el, el.hoverStyle || hoverStyle);
	  setAsHoverStyleTrigger(el, opt);
	}
	/**
	 * @param {Object|boolean} [opt] If `false`, means disable trigger.
	 * @param {boolean} [opt.hoverSilentOnTouch=false]
	 *        In touch device, mouseover event will be trigger on touchstart event
	 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	 *        conveniently use hoverStyle when tap on touch screen without additional
	 *        code for compatibility.
	 *        But if the chart/component has select feature, which usually also use
	 *        hoverStyle, there might be conflict between 'select-highlight' and
	 *        'hover-highlight' especially when roam is enabled (see geo for example).
	 *        In this case, hoverSilentOnTouch should be used to disable hover-highlight
	 *        on touch device.
	 */
	
	
	function setAsHoverStyleTrigger(el, opt) {
	  var disable = opt === false;
	  el.__hoverSilentOnTouch = opt != null && opt.hoverSilentOnTouch; // Simple optimize, since this method might be
	  // called for each elements of a group in some cases.
	
	  if (!disable || el.__hoverStyleTrigger) {
	    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.
	
	    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually
	
	    el[method]('emphasis', enterEmphasis)[method]('normal', leaveEmphasis);
	    el.__hoverStyleTrigger = !disable;
	  }
	}
	/**
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} normalStyle
	 * @param {Object} emphasisStyle
	 * @param {module:echarts/model/Model} normalModel
	 * @param {module:echarts/model/Model} emphasisModel
	 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
	 * @param {string|Function} [opt.defaultText]
	 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
	 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
	 * @param {module:echarts/model/Model} [opt.labelDataIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
	 * @param {module:echarts/model/Model} [opt.labelDimIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
	 * @param {Object} [normalSpecified]
	 * @param {Object} [emphasisSpecified]
	 */
	
	
	function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
	  opt = opt || EMPTY_OBJ;
	  var labelFetcher = opt.labelFetcher;
	  var labelDataIndex = opt.labelDataIndex;
	  var labelDimIndex = opt.labelDimIndex; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
	  // is not supported util someone requests.
	
	  var showNormal = normalModel.getShallow('show');
	  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
	  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
	  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
	
	  var baseText;
	
	  if (showNormal || showEmphasis) {
	    if (labelFetcher) {
	      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex);
	    }
	
	    if (baseText == null) {
	      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
	    }
	  }
	
	  var normalStyleText = showNormal ? baseText : null;
	  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
	
	  if (normalStyleText != null || emphasisStyleText != null) {
	    // Always set `textStyle` even if `normalStyle.text` is null, because default
	    // values have to be set on `normalStyle`.
	    // If we set default values on `emphasisStyle`, consider case:
	    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
	    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
	    // Then the 'red' will not work on emphasis.
	    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
	    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
	  }
	
	  normalStyle.text = normalStyleText;
	  emphasisStyle.text = emphasisStyleText;
	}
	/**
	 * Set basic textStyle properties.
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} textStyle
	 * @param {module:echarts/model/Model} model
	 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
	 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
	 * @param {boolean} [isEmphasis]
	 */
	
	
	function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
	  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
	  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	
	  return textStyle;
	}
	/**
	 * Set text option in the style.
	 * See more info in `setTextStyleCommon`.
	 * @deprecated
	 * @param {Object} textStyle
	 * @param {module:echarts/model/Model} labelModel
	 * @param {string|boolean} defaultColor Default text color.
	 *        If set as false, it will be processed as a emphasis style.
	 */
	
	
	function setText(textStyle, labelModel, defaultColor) {
	  var opt = {
	    isRectText: true
	  };
	  var isEmphasis;
	
	  if (defaultColor === false) {
	    isEmphasis = true;
	  } else {
	    // Support setting color as 'auto' to get visual color.
	    opt.autoColor = defaultColor;
	  }
	
	  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	}
	/**
	 * The uniform entry of set text style, that is, retrieve style definitions
	 * from `model` and set to `textStyle` object.
	 *
	 * Never in merge mode, but in overwrite mode, that is, all of the text style
	 * properties will be set. (Consider the states of normal and emphasis and
	 * default value can be adopted, merge would make the logic too complicated
	 * to manage.)
	 *
	 * The `textStyle` object can either be a plain object or an instance of
	 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
	 * After this mothod called, the `textStyle` object can then be used in
	 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
	 *
	 * Default value will be adopted and `insideRollbackOpt` will be created.
	 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
	 *
	 * opt: {
	 *      disableBox: boolean, Whether diable drawing box of block (outer most).
	 *      isRectText: boolean,
	 *      autoColor: string, specify a color when color is 'auto',
	 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
	 *              If autoColor specified, it is used as default textFill.
	 *      useInsideStyle:
	 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
	 *                  if `textFill` is not specified.
	 *              `false`: Do not use inside style.
	 *              `null/undefined`: use inside style if `isRectText` is true and
	 *                  `textFill` is not specified and textPosition contains `'inside'`.
	 *      forceRich: boolean
	 * }
	 */
	
	
	function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
	  // Consider there will be abnormal when merge hover style to normal style if given default value.
	  opt = opt || EMPTY_OBJ;
	
	  if (opt.isRectText) {
	    var textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	    // in bar series, and magric type should be considered.
	
	    textPosition === 'outside' && (textPosition = 'top');
	    textStyle.textPosition = textPosition;
	    textStyle.textOffset = textStyleModel.getShallow('offset');
	    var labelRotate = textStyleModel.getShallow('rotate');
	    labelRotate != null && (labelRotate *= Math.PI / 180);
	    textStyle.textRotation = labelRotate;
	    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
	  }
	
	  var ecModel = textStyleModel.ecModel;
	  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	  // {
	  //     data: [{
	  //         value: 12,
	  //         label: {
	  //             rich: {
	  //                 // no 'a' here but using parent 'a'.
	  //             }
	  //         }
	  //     }],
	  //     rich: {
	  //         a: { ... }
	  //     }
	  // }
	
	  var richItemNames = getRichItemNames(textStyleModel);
	  var richResult;
	
	  if (richItemNames) {
	    richResult = {};
	
	    for (var name in richItemNames) {
	      if (richItemNames.hasOwnProperty(name)) {
	        // Cascade is supported in rich.
	        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
	
	        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
	      }
	    }
	  }
	
	  textStyle.rich = richResult;
	  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
	
	  if (opt.forceRich && !opt.textStyle) {
	    opt.textStyle = {};
	  }
	
	  return textStyle;
	} // Consider case:
	// {
	//     data: [{
	//         value: 12,
	//         label: {
	//             rich: {
	//                 // no 'a' here but using parent 'a'.
	//             }
	//         }
	//     }],
	//     rich: {
	//         a: { ... }
	//     }
	// }
	
	
	function getRichItemNames(textStyleModel) {
	  // Use object to remove duplicated names.
	  var richItemNameMap;
	
	  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	    var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	    if (rich) {
	      richItemNameMap = richItemNameMap || {};
	
	      for (var name in rich) {
	        if (rich.hasOwnProperty(name)) {
	          richItemNameMap[name] = 1;
	        }
	      }
	    }
	
	    textStyleModel = textStyleModel.parentModel;
	  }
	
	  return richItemNameMap;
	}
	
	function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
	  // In merge mode, default value should not be given.
	  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
	  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
	  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
	  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth); // Save original textPosition, because style.textPosition will be repalced by
	  // real location (like [10, 30]) in zrender.
	
	  textStyle.insideRawTextPosition = textStyle.textPosition;
	
	  if (!isEmphasis) {
	    if (isBlock) {
	      textStyle.insideRollbackOpt = opt;
	      applyDefaultTextStyle(textStyle);
	    } // Set default finally.
	
	
	    if (textStyle.textFill == null) {
	      textStyle.textFill = opt.autoColor;
	    }
	  } // Do not use `getFont` here, because merge should be supported, where
	  // part of these properties may be changed in emphasis style, and the
	  // others should remain their original value got from normal style.
	
	
	  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
	  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
	  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
	  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
	  textStyle.textAlign = textStyleModel.getShallow('align');
	  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
	  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
	  textStyle.textWidth = textStyleModel.getShallow('width');
	  textStyle.textHeight = textStyleModel.getShallow('height');
	  textStyle.textTag = textStyleModel.getShallow('tag');
	
	  if (!isBlock || !opt.disableBox) {
	    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
	    textStyle.textPadding = textStyleModel.getShallow('padding');
	    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
	    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
	    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
	    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
	    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
	    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
	    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
	  }
	
	  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
	  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
	  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
	  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
	}
	
	function getAutoColor(color, opt) {
	  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
	}
	/**
	 * Give some default value to the input `textStyle` object, based on the current settings
	 * in this `textStyle` object.
	 *
	 * The Scenario:
	 * when text position is `inside` and `textFill` is not specified, we show
	 * text border by default for better view. But it should be considered that text position
	 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
	 * restore the style.
	 *
	 * Usage (& NOTICE):
	 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
	 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
	 * be called before the modification and `applyDefaultTextStyle` should be called after that.
	 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
	 * does, `rollbackDefaultTextStyle` is not needed to be called).
	 */
	
	
	function applyDefaultTextStyle(textStyle) {
	  var opt = textStyle.insideRollbackOpt; // Only `insideRollbackOpt` created (in `setTextStyleCommon`),
	  // applyDefaultTextStyle works.
	
	  if (!opt || textStyle.textFill != null) {
	    return;
	  }
	
	  var useInsideStyle = opt.useInsideStyle;
	  var textPosition = textStyle.insideRawTextPosition;
	  var insideRollback;
	  var autoColor = opt.autoColor;
	
	  if (useInsideStyle !== false && (useInsideStyle === true || opt.isRectText && textPosition // textPosition can be [10, 30]
	  && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0)) {
	    insideRollback = {
	      textFill: null,
	      textStroke: textStyle.textStroke,
	      textStrokeWidth: textStyle.textStrokeWidth
	    };
	    textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.
	
	    if (textStyle.textStroke == null) {
	      textStyle.textStroke = autoColor;
	      textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
	    }
	  } else if (autoColor != null) {
	    insideRollback = {
	      textFill: null
	    };
	    textStyle.textFill = autoColor;
	  } // Always set `insideRollback`, for clearing previous.
	
	
	  if (insideRollback) {
	    textStyle.insideRollback = insideRollback;
	  }
	}
	/**
	 * Consider the case: in a scatter,
	 * label: {
	 *     normal: {position: 'inside'},
	 *     emphasis: {position: 'top'}
	 * }
	 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
	 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
	 * should be retured to 'autoColor', but not keep '#fff'.
	 */
	
	
	function rollbackDefaultTextStyle(style) {
	  var insideRollback = style.insideRollback;
	
	  if (insideRollback) {
	    style.textFill = insideRollback.textFill;
	    style.textStroke = insideRollback.textStroke;
	    style.textStrokeWidth = insideRollback.textStrokeWidth;
	    style.insideRollback = null;
	  }
	}
	
	function getFont(opt, ecModel) {
	  // ecModel or default text style model.
	  var gTextStyleModel = ecModel || ecModel.getModel('textStyle');
	  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
	  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
	}
	
	function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
	  if (typeof dataIndex === 'function') {
	    cb = dataIndex;
	    dataIndex = null;
	  } // Do not check 'animation' property directly here. Consider this case:
	  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
	  // but its parent model (`seriesModel`) does.
	
	
	  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	
	  if (animationEnabled) {
	    var postfix = isUpdate ? 'Update' : '';
	    var duration = animatableModel.getShallow('animationDuration' + postfix);
	    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
	    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);
	
	    if (typeof animationDelay === 'function') {
	      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	    }
	
	    if (typeof duration === 'function') {
	      duration = duration(dataIndex);
	    }
	
	    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
	  } else {
	    el.stopAnimation();
	    el.attr(props);
	    cb && cb();
	  }
	}
	/**
	 * Update graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So if do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} [cb]
	 * @example
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	 *     // Or
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, function () { console.log('Animation done!'); });
	 */
	
	
	function updateProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Init graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So if do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} cb
	 */
	
	
	function initProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Get transform matrix of target (param target),
	 * in coordinate of its ancestor (param ancestor)
	 *
	 * @param {module:zrender/mixin/Transformable} target
	 * @param {module:zrender/mixin/Transformable} [ancestor]
	 */
	
	
	function getTransform(target, ancestor) {
	  var mat = matrix.identity([]);
	
	  while (target && target !== ancestor) {
	    matrix.mul(mat, target.getLocalTransform(), mat);
	    target = target.parent;
	  }
	
	  return mat;
	}
	/**
	 * Apply transform to an vertex.
	 * @param {Array.<number>} target [x, y]
	 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
	 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {Array.<number>} [x, y]
	 */
	
	
	function applyTransform(target, transform, invert) {
	  if (transform && !zrUtil.isArrayLike(transform)) {
	    transform = Transformable.getLocalTransform(transform);
	  }
	
	  if (invert) {
	    transform = matrix.invert([], transform);
	  }
	
	  return vector.applyTransform([], target, transform);
	}
	/**
	 * @param {string} direction 'left' 'right' 'top' 'bottom'
	 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
	 */
	
	
	function transformDirection(direction, transform, invert) {
	  // Pick a base, ensure that transform result will not be (0, 0).
	  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	  vertex = applyTransform(vertex, transform, invert);
	  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	}
	/**
	 * Apply group transition animation from g1 to g2.
	 * If no animatableModel, no animation.
	 */
	
	
	function groupTransition(g1, g2, animatableModel, cb) {
	  if (!g1 || !g2) {
	    return;
	  }
	
	  function getElMap(g) {
	    var elMap = {};
	    g.traverse(function (el) {
	      if (!el.isGroup && el.anid) {
	        elMap[el.anid] = el;
	      }
	    });
	    return elMap;
	  }
	
	  function getAnimatableProps(el) {
	    var obj = {
	      position: vector.clone(el.position),
	      rotation: el.rotation
	    };
	
	    if (el.shape) {
	      obj.shape = zrUtil.extend({}, el.shape);
	    }
	
	    return obj;
	  }
	
	  var elMap1 = getElMap(g1);
	  g2.traverse(function (el) {
	    if (!el.isGroup && el.anid) {
	      var oldEl = elMap1[el.anid];
	
	      if (oldEl) {
	        var newProp = getAnimatableProps(el);
	        el.attr(getAnimatableProps(oldEl));
	        updateProps(el, newProp, animatableModel, el.dataIndex);
	      } // else {
	      //     if (el.previousProps) {
	      //         graphic.updateProps
	      //     }
	      // }
	
	    }
	  });
	}
	/**
	 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
	 * @param {Object} rect {x, y, width, height}
	 * @return {Array.<Array.<number>>} A new clipped points.
	 */
	
	
	function clipPointsByRect(points, rect) {
	  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
	  // and when element have border.
	  return zrUtil.map(points, function (point) {
	    var x = point[0];
	    x = mathMax(x, rect.x);
	    x = mathMin(x, rect.x + rect.width);
	    var y = point[1];
	    y = mathMax(y, rect.y);
	    y = mathMin(y, rect.y + rect.height);
	    return [x, y];
	  });
	}
	/**
	 * @param {Object} targetRect {x, y, width, height}
	 * @param {Object} rect {x, y, width, height}
	 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
	 */
	
	
	function clipRectByRect(targetRect, rect) {
	  var x = mathMax(targetRect.x, rect.x);
	  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
	  var y = mathMax(targetRect.y, rect.y);
	  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
	  // should be painted. So return undefined.
	
	  if (x2 >= x && y2 >= y) {
	    return {
	      x: x,
	      y: y,
	      width: x2 - x,
	      height: y2 - y
	    };
	  }
	}
	/**
	 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
	 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
	 * @param {Object} [rect] {x, y, width, height}
	 * @return {module:zrender/Element} Icon path or image element.
	 */
	
	
	function createIcon(iconStr, opt, rect) {
	  opt = zrUtil.extend({
	    rectHover: true
	  }, opt);
	  var style = opt.style = {
	    strokeNoScale: true
	  };
	  rect = rect || {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  };
	
	  if (iconStr) {
	    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
	  }
	}
	
	exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
	exports.extendShape = extendShape;
	exports.extendPath = extendPath;
	exports.makePath = makePath;
	exports.makeImage = makeImage;
	exports.mergePath = mergePath;
	exports.resizePath = resizePath;
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;
	exports.setElementHoverStyle = setElementHoverStyle;
	exports.isInEmphasis = isInEmphasis;
	exports.setHoverStyle = setHoverStyle;
	exports.setAsHoverStyleTrigger = setAsHoverStyleTrigger;
	exports.setLabelStyle = setLabelStyle;
	exports.setTextStyle = setTextStyle;
	exports.setText = setText;
	exports.getFont = getFont;
	exports.updateProps = updateProps;
	exports.initProps = initProps;
	exports.getTransform = getTransform;
	exports.applyTransform = applyTransform;
	exports.transformDirection = transformDirection;
	exports.groupTransition = groupTransition;
	exports.clipPointsByRect = clipPointsByRect;
	exports.clipRectByRect = clipRectByRect;
	exports.createIcon = createIcon;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var PathProxy = __webpack_require__(183);
	
	var transformPath = __webpack_require__(193);
	
	// command chars
	// var cc = [
	//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
	//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
	// ];
	var mathSqrt = Math.sqrt;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	
	var vMag = function (v) {
	  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	};
	
	var vRatio = function (u, v) {
	  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	};
	
	var vAngle = function (u, v) {
	  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	};
	
	function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	  var psi = psiDeg * (PI / 180.0);
	  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
	  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
	  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	  if (lambda > 1) {
	    rx *= mathSqrt(lambda);
	    ry *= mathSqrt(lambda);
	  }
	
	  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
	  var cxp = f * rx * yp / ry;
	  var cyp = f * -ry * xp / rx;
	  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
	  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
	  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	  var dTheta = vAngle(u, v);
	
	  if (vRatio(u, v) <= -1) {
	    dTheta = PI;
	  }
	
	  if (vRatio(u, v) >= 1) {
	    dTheta = 0;
	  }
	
	  if (fs === 0 && dTheta > 0) {
	    dTheta = dTheta - 2 * PI;
	  }
	
	  if (fs === 1 && dTheta < 0) {
	    dTheta = dTheta + 2 * PI;
	  }
	
	  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	}
	
	var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
	// (1) delimiter can be comma or space, where continuous commas
	// or spaces should be seen as one comma.
	// (2) value can be like:
	// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
	// 'l-.5E1,54', '121-23-44-11' (no delimiter)
	
	var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;
	
	function createPathProxyFromString(data) {
	  if (!data) {
	    return new PathProxy();
	  } // var data = data.replace(/-/g, ' -')
	  //     .replace(/  /g, ' ')
	  //     .replace(/ /g, ',')
	  //     .replace(/,,/g, ',');
	  // var n;
	  // create pipes so that we can split the data
	  // for (n = 0; n < cc.length; n++) {
	  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	  // }
	  // data = data.replace(/-/g, ',-');
	  // create array
	  // var arr = cs.split('|');
	  // init context point
	
	
	  var cpx = 0;
	  var cpy = 0;
	  var subpathX = cpx;
	  var subpathY = cpy;
	  var prevCmd;
	  var path = new PathProxy();
	  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
	  // var cmdResult;
	  // while ((cmdResult = commandReg.exec(data)) != null) {
	  //     var cmdStr = cmdResult[1];
	  //     var cmdContent = cmdResult[2];
	
	  var cmdList = data.match(commandReg);
	
	  for (var l = 0; l < cmdList.length; l++) {
	    var cmdText = cmdList[l];
	    var cmdStr = cmdText.charAt(0);
	    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
	    // var p = cmdContent.split(valueSplitReg);
	    // var pLen = 0;
	    // for (var i = 0; i < p.length; i++) {
	    //     // '' and other invalid str => NaN
	    //     var val = parseFloat(p[i]);
	    //     !isNaN(val) && (p[pLen++] = val);
	    // }
	
	    var p = cmdText.match(numberReg) || [];
	    var pLen = p.length;
	
	    for (var i = 0; i < pLen; i++) {
	      p[i] = parseFloat(p[i]);
	    }
	
	    var off = 0;
	
	    while (off < pLen) {
	      var ctlPtx;
	      var ctlPty;
	      var rx;
	      var ry;
	      var psi;
	      var fa;
	      var fs;
	      var x1 = cpx;
	      var y1 = cpy; // convert l, H, h, V, and v to L
	
	      switch (cmdStr) {
	        case 'l':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'L':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'm':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'l';
	          break;
	
	        case 'M':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'L';
	          break;
	
	        case 'h':
	          cpx += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'H':
	          cpx = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'v':
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'V':
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'C':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	          cpx = p[off - 2];
	          cpy = p[off - 1];
	          break;
	
	        case 'c':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	          cpx += p[off - 2];
	          cpy += p[off - 1];
	          break;
	
	        case 'S':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 's':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = cpx + p[off++];
	          y1 = cpy + p[off++];
	          cpx += p[off++];
	          cpy += p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 'Q':
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'q':
	          x1 = p[off++] + cpx;
	          y1 = p[off++] + cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'T':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 't':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 'A':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	
	        case 'a':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	      }
	    }
	
	    if (cmdStr === 'z' || cmdStr === 'Z') {
	      cmd = CMD.Z;
	      path.addData(cmd); // z may be in the middle of the path.
	
	      cpx = subpathX;
	      cpy = subpathY;
	    }
	
	    prevCmd = cmd;
	  }
	
	  path.toStatic();
	  return path;
	} // TODO Optimize double memory cost problem
	
	
	function createPathOptions(str, opts) {
	  var pathProxy = createPathProxyFromString(str);
	  opts = opts || {};
	
	  opts.buildPath = function (path) {
	    if (path.setData) {
	      path.setData(pathProxy.data); // Svg and vml renderer don't have context
	
	      var ctx = path.getContext();
	
	      if (ctx) {
	        path.rebuildPath(ctx);
	      }
	    } else {
	      var ctx = path;
	      pathProxy.rebuildPath(ctx);
	    }
	  };
	
	  opts.applyTransform = function (m) {
	    transformPath(pathProxy, m);
	    this.dirty(true);
	  };
	
	  return opts;
	}
	/**
	 * Create a Path object from path string data
	 * http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {Object} opts Other options
	 */
	
	
	function createFromString(str, opts) {
	  return new Path(createPathOptions(str, opts));
	}
	/**
	 * Create a Path class from path string data
	 * @param  {string} str
	 * @param  {Object} opts Other options
	 */
	
	
	function extendFromString(str, opts) {
	  return Path.extend(createPathOptions(str, opts));
	}
	/**
	 * Merge multiple paths
	 */
	// TODO Apply transform
	// TODO stroke dash
	// TODO Optimize double memory cost problem
	
	
	function mergePath(pathEls, opts) {
	  var pathList = [];
	  var len = pathEls.length;
	
	  for (var i = 0; i < len; i++) {
	    var pathEl = pathEls[i];
	
	    if (!pathEl.path) {
	      pathEl.createPathProxy();
	    }
	
	    if (pathEl.__dirtyPath) {
	      pathEl.buildPath(pathEl.path, pathEl.shape, true);
	    }
	
	    pathList.push(pathEl.path);
	  }
	
	  var pathBundle = new Path(opts); // Need path proxy.
	
	  pathBundle.createPathProxy();
	
	  pathBundle.buildPath = function (path) {
	    path.appendPath(pathList); // Svg and vml renderer don't have context
	
	    var ctx = path.getContext();
	
	    if (ctx) {
	      path.rebuildPath(ctx);
	    }
	  };
	
	  return pathBundle;
	}
	
	exports.createFromString = createFromString;
	exports.extendFromString = extendFromString;
	exports.mergePath = mergePath;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(164);
	
	var zrUtil = __webpack_require__(134);
	
	var PathProxy = __webpack_require__(183);
	
	var pathContain = __webpack_require__(186);
	
	var Pattern = __webpack_require__(161);
	
	var getCanvasPattern = Pattern.prototype.getCanvasPattern;
	var abs = Math.abs;
	var pathProxyForDraw = new PathProxy(true);
	/**
	 * @alias module:zrender/graphic/Path
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	
	function Path(opts) {
	  Displayable.call(this, opts);
	  /**
	   * @type {module:zrender/core/PathProxy}
	   * @readOnly
	   */
	
	  this.path = null;
	}
	
	Path.prototype = {
	  constructor: Path,
	  type: 'path',
	  __dirtyPath: true,
	  strokeContainThreshold: 5,
	
	  /**
	   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
	   * @type {boolean}
	   */
	  subPixelOptimize: false,
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var path = this.path || pathProxyForDraw;
	    var hasStroke = style.hasStroke();
	    var hasFill = style.hasFill();
	    var fill = style.fill;
	    var stroke = style.stroke;
	    var hasFillGradient = hasFill && !!fill.colorStops;
	    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	    var hasFillPattern = hasFill && !!fill.image;
	    var hasStrokePattern = hasStroke && !!stroke.image;
	    style.bind(ctx, this, prevEl);
	    this.setTransform(ctx);
	
	    if (this.__dirty) {
	      var rect; // Update gradient because bounding rect may changed
	
	      if (hasFillGradient) {
	        rect = rect || this.getBoundingRect();
	        this._fillGradient = style.getGradient(ctx, fill, rect);
	      }
	
	      if (hasStrokeGradient) {
	        rect = rect || this.getBoundingRect();
	        this._strokeGradient = style.getGradient(ctx, stroke, rect);
	      }
	    } // Use the gradient or pattern
	
	
	    if (hasFillGradient) {
	      // PENDING If may have affect the state
	      ctx.fillStyle = this._fillGradient;
	    } else if (hasFillPattern) {
	      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
	    }
	
	    if (hasStrokeGradient) {
	      ctx.strokeStyle = this._strokeGradient;
	    } else if (hasStrokePattern) {
	      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
	    }
	
	    var lineDash = style.lineDash;
	    var lineDashOffset = style.lineDashOffset;
	    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
	
	    var scale = this.getGlobalScale();
	    path.setScale(scale[0], scale[1]); // Proxy context
	    // Rebuild path in following 2 cases
	    // 1. Path is dirty
	    // 2. Path needs javascript implemented lineDash stroking.
	    //    In this case, lineDash information will not be saved in PathProxy
	
	    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
	      path.beginPath(ctx); // Setting line dash before build path
	
	      if (lineDash && !ctxLineDash) {
	        path.setLineDash(lineDash);
	        path.setLineDashOffset(lineDashOffset);
	      }
	
	      this.buildPath(path, this.shape, false); // Clear path dirty flag
	
	      if (this.path) {
	        this.__dirtyPath = false;
	      }
	    } else {
	      // Replay path building
	      ctx.beginPath();
	      this.path.rebuildPath(ctx);
	    }
	
	    if (hasFill) {
	      if (style.fillOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.fillOpacity * style.opacity;
	        path.fill(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.fill(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      ctx.setLineDash(lineDash);
	      ctx.lineDashOffset = lineDashOffset;
	    }
	
	    if (hasStroke) {
	      if (style.strokeOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.strokeOpacity * style.opacity;
	        path.stroke(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.stroke(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      // PENDING
	      // Remove lineDash
	      ctx.setLineDash([]);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
	  // Like in circle
	  buildPath: function (ctx, shapeCfg, inBundle) {},
	  createPathProxy: function () {
	    this.path = new PathProxy();
	  },
	  getBoundingRect: function () {
	    var rect = this._rect;
	    var style = this.style;
	    var needsUpdateRect = !rect;
	
	    if (needsUpdateRect) {
	      var path = this.path;
	
	      if (!path) {
	        // Create path on demand.
	        path = this.path = new PathProxy();
	      }
	
	      if (this.__dirtyPath) {
	        path.beginPath();
	        this.buildPath(path, this.shape, false);
	      }
	
	      rect = path.getBoundingRect();
	    }
	
	    this._rect = rect;
	
	    if (style.hasStroke()) {
	      // Needs update rect with stroke lineWidth when
	      // 1. Element changes scale or lineWidth
	      // 2. Shape is changed
	      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
	
	      if (this.__dirty || needsUpdateRect) {
	        rectWithStroke.copy(rect); // FIXME Must after updateTransform
	
	        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
	
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
	
	        if (!style.hasFill()) {
	          w = Math.max(w, this.strokeContainThreshold || 4);
	        } // Consider line width
	        // Line scale can't be 0;
	
	
	        if (lineScale > 1e-10) {
	          rectWithStroke.width += w / lineScale;
	          rectWithStroke.height += w / lineScale;
	          rectWithStroke.x -= w / lineScale / 2;
	          rectWithStroke.y -= w / lineScale / 2;
	        }
	      } // Return rect with stroke
	
	
	      return rectWithStroke;
	    }
	
	    return rect;
	  },
	  contain: function (x, y) {
	    var localPos = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    var style = this.style;
	    x = localPos[0];
	    y = localPos[1];
	
	    if (rect.contain(x, y)) {
	      var pathData = this.path.data;
	
	      if (style.hasStroke()) {
	        var lineWidth = style.lineWidth;
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
	
	        if (lineScale > 1e-10) {
	          // Only add extra hover lineWidth when there are no fill
	          if (!style.hasFill()) {
	            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	          }
	
	          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
	            return true;
	          }
	        }
	      }
	
	      if (style.hasFill()) {
	        return pathContain.contain(pathData, x, y);
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param  {boolean} dirtyPath
	   */
	  dirty: function (dirtyPath) {
	    if (dirtyPath == null) {
	      dirtyPath = true;
	    } // Only mark dirty, not mark clean
	
	
	    if (dirtyPath) {
	      this.__dirtyPath = dirtyPath;
	      this._rect = null;
	    }
	
	    this.__dirty = this.__dirtyText = true;
	    this.__zr && this.__zr.refresh(); // Used as a clipping path
	
	    if (this.__clipTarget) {
	      this.__clipTarget.dirty();
	    }
	  },
	
	  /**
	   * Alias for animate('shape')
	   * @param {boolean} loop
	   */
	  animateShape: function (loop) {
	    return this.animate('shape', loop);
	  },
	  // Overwrite attrKV
	  attrKV: function (key, value) {
	    // FIXME
	    if (key === 'shape') {
	      this.setShape(value);
	      this.__dirtyPath = true;
	      this._rect = null;
	    } else {
	      Displayable.prototype.attrKV.call(this, key, value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setShape: function (key, value) {
	    var shape = this.shape; // Path from string may not have shape
	
	    if (shape) {
	      if (zrUtil.isObject(key)) {
	        for (var name in key) {
	          if (key.hasOwnProperty(name)) {
	            shape[name] = key[name];
	          }
	        }
	      } else {
	        shape[key] = value;
	      }
	
	      this.dirty(true);
	    }
	
	    return this;
	  },
	  getLineScale: function () {
	    var m = this.transform; // Get the line scale.
	    // Determinant of `m` means how much the area is enlarged by the
	    // transformation. So its square root can be used as a scale factor
	    // for width.
	
	    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
	  }
	};
	/**
	 * 扩展一个 Path element, 比如星形，圆等。
	 * Extend a path element
	 * @param {Object} props
	 * @param {string} props.type Path type
	 * @param {Function} props.init Initialize
	 * @param {Function} props.buildPath Overwrite buildPath method
	 * @param {Object} [props.style] Extended default style config
	 * @param {Object} [props.shape] Extended default shape config
	 */
	
	Path.extend = function (defaults) {
	  var Sub = function (opts) {
	    Path.call(this, opts);
	
	    if (defaults.style) {
	      // Extend default style
	      this.style.extendFrom(defaults.style, false);
	    } // Extend default shape
	
	
	    var defaultShape = defaults.shape;
	
	    if (defaultShape) {
	      this.shape = this.shape || {};
	      var thisShape = this.shape;
	
	      for (var name in defaultShape) {
	        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
	          thisShape[name] = defaultShape[name];
	        }
	      }
	    }
	
	    defaults.init && defaults.init.call(this, opts);
	  };
	
	  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象
	
	  for (var name in defaults) {
	    // Extending prototype values and methods
	    if (name !== 'style' && name !== 'shape') {
	      Sub.prototype[name] = defaults[name];
	    }
	  }
	
	  return Sub;
	};
	
	zrUtil.inherits(Path, Displayable);
	var _default = Path;
	module.exports = _default;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(184);
	
	var vec2 = __webpack_require__(136);
	
	var bbox = __webpack_require__(185);
	
	var BoundingRect = __webpack_require__(154);
	
	var _config = __webpack_require__(153);
	
	var dpr = _config.devicePixelRatio;
	
	/**
	 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
	 * 可以用于 isInsidePath 判断以及获取boundingRect
	 *
	 * @module zrender/core/PathProxy
	 * @author Yi Shen (http://www.github.com/pissang)
	 */
	// TODO getTotalLength, getPointAtLength
	var CMD = {
	  M: 1,
	  L: 2,
	  C: 3,
	  Q: 4,
	  A: 5,
	  Z: 6,
	  // Rect
	  R: 7
	}; // var CMD_MEM_SIZE = {
	//     M: 3,
	//     L: 3,
	//     C: 7,
	//     Q: 5,
	//     A: 9,
	//     R: 5,
	//     Z: 1
	// };
	
	var min = [];
	var max = [];
	var min2 = [];
	var max2 = [];
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathCos = Math.cos;
	var mathSin = Math.sin;
	var mathSqrt = Math.sqrt;
	var mathAbs = Math.abs;
	var hasTypedArray = typeof Float32Array !== 'undefined';
	/**
	 * @alias module:zrender/core/PathProxy
	 * @constructor
	 */
	
	var PathProxy = function (notSaveData) {
	  this._saveData = !(notSaveData || false);
	
	  if (this._saveData) {
	    /**
	     * Path data. Stored as flat array
	     * @type {Array.<Object>}
	     */
	    this.data = [];
	  }
	
	  this._ctx = null;
	};
	/**
	 * 快速计算Path包围盒（并不是最小包围盒）
	 * @return {Object}
	 */
	
	
	PathProxy.prototype = {
	  constructor: PathProxy,
	  _xi: 0,
	  _yi: 0,
	  _x0: 0,
	  _y0: 0,
	  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
	  _ux: 0,
	  _uy: 0,
	  _len: 0,
	  _lineDash: null,
	  _dashOffset: 0,
	  _dashIdx: 0,
	  _dashSum: 0,
	
	  /**
	   * @readOnly
	   */
	  setScale: function (sx, sy) {
	    this._ux = mathAbs(1 / dpr / sx) || 0;
	    this._uy = mathAbs(1 / dpr / sy) || 0;
	  },
	  getContext: function () {
	    return this._ctx;
	  },
	
	  /**
	   * @param  {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  beginPath: function (ctx) {
	    this._ctx = ctx;
	    ctx && ctx.beginPath();
	    ctx && (this.dpr = ctx.dpr); // Reset
	
	    if (this._saveData) {
	      this._len = 0;
	    }
	
	    if (this._lineDash) {
	      this._lineDash = null;
	      this._dashOffset = 0;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  moveTo: function (x, y) {
	    this.addData(CMD.M, x, y);
	    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
	    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
	    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
	    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
	
	    this._x0 = x;
	    this._y0 = y;
	    this._xi = x;
	    this._yi = y;
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  lineTo: function (x, y) {
	    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
	    || this._len < 5;
	    this.addData(CMD.L, x, y);
	
	    if (this._ctx && exceedUnit) {
	      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
	    }
	
	    if (exceedUnit) {
	      this._xi = x;
	      this._yi = y;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @param  {number} x3
	   * @param  {number} y3
	   * @return {module:zrender/core/PathProxy}
	   */
	  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
	    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	    }
	
	    this._xi = x3;
	    this._yi = y3;
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @return {module:zrender/core/PathProxy}
	   */
	  quadraticCurveTo: function (x1, y1, x2, y2) {
	    this.addData(CMD.Q, x1, y1, x2, y2);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	    }
	
	    this._xi = x2;
	    this._yi = y2;
	    return this;
	  },
	
	  /**
	   * @param  {number} cx
	   * @param  {number} cy
	   * @param  {number} r
	   * @param  {number} startAngle
	   * @param  {number} endAngle
	   * @param  {boolean} anticlockwise
	   * @return {module:zrender/core/PathProxy}
	   */
	  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
	    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	    this._xi = mathCos(endAngle) * r + cx;
	    this._yi = mathSin(endAngle) * r + cy;
	    return this;
	  },
	  // TODO
	  arcTo: function (x1, y1, x2, y2, radius) {
	    if (this._ctx) {
	      this._ctx.arcTo(x1, y1, x2, y2, radius);
	    }
	
	    return this;
	  },
	  // TODO
	  rect: function (x, y, w, h) {
	    this._ctx && this._ctx.rect(x, y, w, h);
	    this.addData(CMD.R, x, y, w, h);
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/PathProxy}
	   */
	  closePath: function () {
	    this.addData(CMD.Z);
	    var ctx = this._ctx;
	    var x0 = this._x0;
	    var y0 = this._y0;
	
	    if (ctx) {
	      this._needsDash() && this._dashedLineTo(x0, y0);
	      ctx.closePath();
	    }
	
	    this._xi = x0;
	    this._yi = y0;
	    return this;
	  },
	
	  /**
	   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
	   * stroke 同样
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  fill: function (ctx) {
	    ctx && ctx.fill();
	    this.toStatic();
	  },
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  stroke: function (ctx) {
	    ctx && ctx.stroke();
	    this.toStatic();
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDash: function (lineDash) {
	    if (lineDash instanceof Array) {
	      this._lineDash = lineDash;
	      this._dashIdx = 0;
	      var lineDashSum = 0;
	
	      for (var i = 0; i < lineDash.length; i++) {
	        lineDashSum += lineDash[i];
	      }
	
	      this._dashSum = lineDashSum;
	    }
	
	    return this;
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDashOffset: function (offset) {
	    this._dashOffset = offset;
	    return this;
	  },
	
	  /**
	   *
	   * @return {boolean}
	   */
	  len: function () {
	    return this._len;
	  },
	
	  /**
	   * 直接设置 Path 数据
	   */
	  setData: function (data) {
	    var len = data.length;
	
	    if (!(this.data && this.data.length === len) && hasTypedArray) {
	      this.data = new Float32Array(len);
	    }
	
	    for (var i = 0; i < len; i++) {
	      this.data[i] = data[i];
	    }
	
	    this._len = len;
	  },
	
	  /**
	   * 添加子路径
	   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
	   */
	  appendPath: function (path) {
	    if (!(path instanceof Array)) {
	      path = [path];
	    }
	
	    var len = path.length;
	    var appendSize = 0;
	    var offset = this._len;
	
	    for (var i = 0; i < len; i++) {
	      appendSize += path[i].len();
	    }
	
	    if (hasTypedArray && this.data instanceof Float32Array) {
	      this.data = new Float32Array(offset + appendSize);
	    }
	
	    for (var i = 0; i < len; i++) {
	      var appendPathData = path[i].data;
	
	      for (var k = 0; k < appendPathData.length; k++) {
	        this.data[offset++] = appendPathData[k];
	      }
	    }
	
	    this._len = offset;
	  },
	
	  /**
	   * 填充 Path 数据。
	   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
	   */
	  addData: function (cmd) {
	    if (!this._saveData) {
	      return;
	    }
	
	    var data = this.data;
	
	    if (this._len + arguments.length > data.length) {
	      // 因为之前的数组已经转换成静态的 Float32Array
	      // 所以不够用时需要扩展一个新的动态数组
	      this._expandData();
	
	      data = this.data;
	    }
	
	    for (var i = 0; i < arguments.length; i++) {
	      data[this._len++] = arguments[i];
	    }
	
	    this._prevCmd = cmd;
	  },
	  _expandData: function () {
	    // Only if data is Float32Array
	    if (!(this.data instanceof Array)) {
	      var newData = [];
	
	      for (var i = 0; i < this._len; i++) {
	        newData[i] = this.data[i];
	      }
	
	      this.data = newData;
	    }
	  },
	
	  /**
	   * If needs js implemented dashed line
	   * @return {boolean}
	   * @private
	   */
	  _needsDash: function () {
	    return this._lineDash;
	  },
	  _dashedLineTo: function (x1, y1) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var dx = x1 - x0;
	    var dy = y1 - y0;
	    var dist = mathSqrt(dx * dx + dy * dy);
	    var x = x0;
	    var y = y0;
	    var dash;
	    var nDash = lineDash.length;
	    var idx;
	    dx /= dist;
	    dy /= dist;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum;
	    x -= offset * dx;
	    y -= offset * dy;
	
	    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
	      idx = this._dashIdx;
	      dash = lineDash[idx];
	      x += dx * dash;
	      y += dy * dash;
	      this._dashIdx = (idx + 1) % nDash; // Skip positive offset
	
	      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
	        continue;
	      }
	
	      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
	    } // Offset for next lineTo
	
	
	    dx = x - x1;
	    dy = y - y1;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  // Not accurate dashed line to
	  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var t;
	    var dx;
	    var dy;
	    var cubicAt = curve.cubicAt;
	    var bezierLen = 0;
	    var idx = this._dashIdx;
	    var nDash = lineDash.length;
	    var x;
	    var y;
	    var tmpLen = 0;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum; // Bezier approx length
	
	    for (t = 0; t < 1; t += 0.1) {
	      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
	      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
	      bezierLen += mathSqrt(dx * dx + dy * dy);
	    } // Find idx after add offset
	
	
	    for (; idx < nDash; idx++) {
	      tmpLen += lineDash[idx];
	
	      if (tmpLen > offset) {
	        break;
	      }
	    }
	
	    t = (tmpLen - offset) / bezierLen;
	
	    while (t <= 1) {
	      x = cubicAt(x0, x1, x2, x3, t);
	      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
	      // Bad result if dash is long
	
	      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
	      t += lineDash[idx] / bezierLen;
	      idx = (idx + 1) % nDash;
	    } // Finish the last segment and calculate the new offset
	
	
	    idx % 2 !== 0 && ctx.lineTo(x3, y3);
	    dx = x3 - x;
	    dy = y3 - y;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  _dashedQuadraticTo: function (x1, y1, x2, y2) {
	    // Convert quadratic to cubic using degree elevation
	    var x3 = x2;
	    var y3 = y2;
	    x2 = (x2 + 2 * x1) / 3;
	    y2 = (y2 + 2 * y1) / 3;
	    x1 = (this._xi + 2 * x1) / 3;
	    y1 = (this._yi + 2 * y1) / 3;
	
	    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
	  },
	
	  /**
	   * 转成静态的 Float32Array 减少堆内存占用
	   * Convert dynamic array to static Float32Array
	   */
	  toStatic: function () {
	    var data = this.data;
	
	    if (data instanceof Array) {
	      data.length = this._len;
	
	      if (hasTypedArray) {
	        this.data = new Float32Array(data);
	      }
	    }
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	    var data = this.data;
	    var xi = 0;
	    var yi = 0;
	    var x0 = 0;
	    var y0 = 0;
	
	    for (var i = 0; i < data.length;) {
	      var cmd = data[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = data[i];
	        yi = data[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	          // 在 closePath 的时候使用
	          x0 = data[i++];
	          y0 = data[i++];
	          xi = x0;
	          yi = y0;
	          min2[0] = x0;
	          min2[1] = y0;
	          max2[0] = x0;
	          max2[1] = y0;
	          break;
	
	        case CMD.L:
	          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.C:
	          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.Q:
	          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.A:
	          // TODO Arc 判断的开销比较大
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++];
	          var endAngle = data[i++] + startAngle; // TODO Arc 旋转
	
	          i += 1;
	          var anticlockwise = 1 - data[i++];
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(startAngle) * rx + cx;
	            y0 = mathSin(startAngle) * ry + cy;
	          }
	
	          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = data[i++];
	          y0 = yi = data[i++];
	          var width = data[i++];
	          var height = data[i++]; // Use fromLine
	
	          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	          break;
	
	        case CMD.Z:
	          xi = x0;
	          yi = y0;
	          break;
	      } // Union
	
	
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * Rebuild path from current data
	   * Rebuild path will not consider javascript implemented line dash.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  rebuildPath: function (ctx) {
	    var d = this.data;
	    var x0, y0;
	    var xi, yi;
	    var x, y;
	    var ux = this._ux;
	    var uy = this._uy;
	    var len = this._len;
	
	    for (var i = 0; i < len;) {
	      var cmd = d[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = d[i];
	        yi = d[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          x0 = xi = d[i++];
	          y0 = yi = d[i++];
	          ctx.moveTo(xi, yi);
	          break;
	
	        case CMD.L:
	          x = d[i++];
	          y = d[i++]; // Not draw too small seg between
	
	          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
	            ctx.lineTo(x, y);
	            xi = x;
	            yi = y;
	          }
	
	          break;
	
	        case CMD.C:
	          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.Q:
	          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.A:
	          var cx = d[i++];
	          var cy = d[i++];
	          var rx = d[i++];
	          var ry = d[i++];
	          var theta = d[i++];
	          var dTheta = d[i++];
	          var psi = d[i++];
	          var fs = d[i++];
	          var r = rx > ry ? rx : ry;
	          var scaleX = rx > ry ? 1 : rx / ry;
	          var scaleY = rx > ry ? ry / rx : 1;
	          var isEllipse = Math.abs(rx - ry) > 1e-3;
	          var endAngle = theta + dTheta;
	
	          if (isEllipse) {
	            ctx.translate(cx, cy);
	            ctx.rotate(psi);
	            ctx.scale(scaleX, scaleY);
	            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
	            ctx.scale(1 / scaleX, 1 / scaleY);
	            ctx.rotate(-psi);
	            ctx.translate(-cx, -cy);
	          } else {
	            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
	          }
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(theta) * rx + cx;
	            y0 = mathSin(theta) * ry + cy;
	          }
	
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = d[i];
	          y0 = yi = d[i + 1];
	          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
	          break;
	
	        case CMD.Z:
	          ctx.closePath();
	          xi = x0;
	          yi = y0;
	      }
	    }
	  }
	};
	PathProxy.CMD = CMD;
	var _default = PathProxy;
	module.exports = _default;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(136);
	
	var v2Create = _vector.create;
	var v2DistSquare = _vector.distSquare;
	
	/**
	 * 曲线辅助模块
	 * @module zrender/core/curve
	 * @author pissang(https://www.github.com/pissang)
	 */
	var mathPow = Math.pow;
	var mathSqrt = Math.sqrt;
	var EPSILON = 1e-8;
	var EPSILON_NUMERIC = 1e-4;
	var THREE_SQRT = mathSqrt(3);
	var ONE_THIRD = 1 / 3; // 临时变量
	
	var _v0 = v2Create();
	
	var _v1 = v2Create();
	
	var _v2 = v2Create();
	
	function isAroundZero(val) {
	  return val > -EPSILON && val < EPSILON;
	}
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * 计算三次贝塞尔值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
	}
	/**
	 * 计算三次贝塞尔导数值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicDerivativeAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
	}
	/**
	 * 计算三次贝塞尔方程根，使用盛金公式
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} val
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function cubicRootAt(p0, p1, p2, p3, val, roots) {
	  // Evaluate roots of cubic functions
	  var a = p3 + 3 * (p1 - p2) - p0;
	  var b = 3 * (p2 - p1 * 2 + p0);
	  var c = 3 * (p1 - p0);
	  var d = p0 - val;
	  var A = b * b - 3 * a * c;
	  var B = b * c - 9 * a * d;
	  var C = c * c - 3 * b * d;
	  var n = 0;
	
	  if (isAroundZero(A) && isAroundZero(B)) {
	    if (isAroundZero(b)) {
	      roots[0] = 0;
	    } else {
	      var t1 = -c / b; //t1, t2, t3, b is not zero
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = B * B - 4 * A * C;
	
	    if (isAroundZero(disc)) {
	      var K = B / A;
	      var t1 = -b / a + K; // t1, a is not zero
	
	      var t2 = -K / 2; // t2, t3
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	      var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	
	      if (Y1 < 0) {
	        Y1 = -mathPow(-Y1, ONE_THIRD);
	      } else {
	        Y1 = mathPow(Y1, ONE_THIRD);
	      }
	
	      if (Y2 < 0) {
	        Y2 = -mathPow(-Y2, ONE_THIRD);
	      } else {
	        Y2 = mathPow(Y2, ONE_THIRD);
	      }
	
	      var t1 = (-b - (Y1 + Y2)) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else {
	      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	      var theta = Math.acos(T) / 3;
	      var ASqrt = mathSqrt(A);
	      var tmp = Math.cos(theta);
	      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	
	      if (t3 >= 0 && t3 <= 1) {
	        roots[n++] = t3;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算三次贝塞尔方程极限值的位置
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {Array.<number>} extrema
	 * @return {number} 有效数目
	 */
	
	
	function cubicExtrema(p0, p1, p2, p3, extrema) {
	  var b = 6 * p2 - 12 * p1 + 6 * p0;
	  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	  var c = 3 * p1 - 3 * p0;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      extrema[0] = -b / (2 * a);
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        extrema[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 细分三次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function cubicSubdivide(p0, p1, p2, p3, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p23 = (p3 - p2) * t + p2;
	  var p012 = (p12 - p01) * t + p01;
	  var p123 = (p23 - p12) * t + p12;
	  var p0123 = (p123 - p012) * t + p012; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012;
	  out[3] = p0123; // Seg1
	
	  out[4] = p0123;
	  out[5] = p123;
	  out[6] = p23;
	  out[7] = p3;
	}
	/**
	 * 投射点到三次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} [out] 投射点
	 * @return {number}
	 */
	
	
	function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  var prev;
	  var next;
	  var d1;
	  var d2;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	    d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    prev = t - interval;
	    next = t + interval; // t - interval
	
	    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	    d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = cubicAt(x0, x1, x2, x3, next);
	      _v2[1] = cubicAt(y0, y1, y2, y3, next);
	      d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = cubicAt(x0, x1, x2, x3, t);
	    out[1] = cubicAt(y0, y1, y2, y3, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	/**
	 * 计算二次方贝塞尔值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticAt(p0, p1, p2, t) {
	  var onet = 1 - t;
	  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	}
	/**
	 * 计算二次方贝塞尔导数值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticDerivativeAt(p0, p1, p2, t) {
	  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	}
	/**
	 * 计算二次方贝塞尔方程根
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function quadraticRootAt(p0, p1, p2, val, roots) {
	  var a = p0 - 2 * p1 + p2;
	  var b = 2 * (p1 - p0);
	  var c = p0 - val;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      var t1 = -b / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算二次贝塞尔方程极限值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @return {number}
	 */
	
	
	function quadraticExtremum(p0, p1, p2) {
	  var divider = p0 + p2 - 2 * p1;
	
	  if (divider === 0) {
	    // p1 is center of p0 and p2
	    return 0.5;
	  } else {
	    return (p0 - p1) / divider;
	  }
	}
	/**
	 * 细分二次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function quadraticSubdivide(p0, p1, p2, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p012 = (p12 - p01) * t + p01; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012; // Seg1
	
	  out[3] = p012;
	  out[4] = p12;
	  out[5] = p2;
	}
	/**
	 * 投射点到二次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} out 投射点
	 * @return {number}
	 */
	
	
	function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = quadraticAt(x0, x1, x2, _t);
	    _v1[1] = quadraticAt(y0, y1, y2, _t);
	    var d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    var prev = t - interval;
	    var next = t + interval; // t - interval
	
	    _v1[0] = quadraticAt(x0, x1, x2, prev);
	    _v1[1] = quadraticAt(y0, y1, y2, prev);
	    var d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = quadraticAt(x0, x1, x2, next);
	      _v2[1] = quadraticAt(y0, y1, y2, next);
	      var d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = quadraticAt(x0, x1, x2, t);
	    out[1] = quadraticAt(y0, y1, y2, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	
	exports.cubicAt = cubicAt;
	exports.cubicDerivativeAt = cubicDerivativeAt;
	exports.cubicRootAt = cubicRootAt;
	exports.cubicExtrema = cubicExtrema;
	exports.cubicSubdivide = cubicSubdivide;
	exports.cubicProjectPoint = cubicProjectPoint;
	exports.quadraticAt = quadraticAt;
	exports.quadraticDerivativeAt = quadraticDerivativeAt;
	exports.quadraticRootAt = quadraticRootAt;
	exports.quadraticExtremum = quadraticExtremum;
	exports.quadraticSubdivide = quadraticSubdivide;
	exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(136);
	
	var curve = __webpack_require__(184);
	
	/**
	 * @author Yi Shen(https://github.com/pissang)
	 */
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI2 = Math.PI * 2;
	var start = vec2.create();
	var end = vec2.create();
	var extremity = vec2.create();
	/**
	 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
	 * @module zrender/core/bbox
	 * @param {Array<Object>} points 顶点数组
	 * @param {number} min
	 * @param {number} max
	 */
	
	function fromPoints(points, min, max) {
	  if (points.length === 0) {
	    return;
	  }
	
	  var p = points[0];
	  var left = p[0];
	  var right = p[0];
	  var top = p[1];
	  var bottom = p[1];
	  var i;
	
	  for (i = 1; i < points.length; i++) {
	    p = points[i];
	    left = mathMin(left, p[0]);
	    right = mathMax(right, p[0]);
	    top = mathMin(top, p[1]);
	    bottom = mathMax(bottom, p[1]);
	  }
	
	  min[0] = left;
	  min[1] = top;
	  max[0] = right;
	  max[1] = bottom;
	}
	/**
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromLine(x0, y0, x1, y1, min, max) {
	  min[0] = mathMin(x0, x1);
	  min[1] = mathMin(y0, y1);
	  max[0] = mathMax(x0, x1);
	  max[1] = mathMax(y0, y1);
	}
	
	var xDim = [];
	var yDim = [];
	/**
	 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	  var cubicExtrema = curve.cubicExtrema;
	  var cubicAt = curve.cubicAt;
	  var i;
	  var n = cubicExtrema(x0, x1, x2, x3, xDim);
	  min[0] = Infinity;
	  min[1] = Infinity;
	  max[0] = -Infinity;
	  max[1] = -Infinity;
	
	  for (i = 0; i < n; i++) {
	    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
	    min[0] = mathMin(x, min[0]);
	    max[0] = mathMax(x, max[0]);
	  }
	
	  n = cubicExtrema(y0, y1, y2, y3, yDim);
	
	  for (i = 0; i < n; i++) {
	    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
	    min[1] = mathMin(y, min[1]);
	    max[1] = mathMax(y, max[1]);
	  }
	
	  min[0] = mathMin(x0, min[0]);
	  max[0] = mathMax(x0, max[0]);
	  min[0] = mathMin(x3, min[0]);
	  max[0] = mathMax(x3, max[0]);
	  min[1] = mathMin(y0, min[1]);
	  max[1] = mathMax(y0, max[1]);
	  min[1] = mathMin(y3, min[1]);
	  max[1] = mathMax(y3, max[1]);
	}
	/**
	 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	  var quadraticExtremum = curve.quadraticExtremum;
	  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero
	
	  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
	  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
	  var x = quadraticAt(x0, x1, x2, tx);
	  var y = quadraticAt(y0, y1, y2, ty);
	  min[0] = mathMin(x0, x2, x);
	  min[1] = mathMin(y0, y2, y);
	  max[0] = mathMax(x0, x2, x);
	  max[1] = mathMax(y0, y2, y);
	}
	/**
	 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
	 * @method
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x
	 * @param {number} y
	 * @param {number} rx
	 * @param {number} ry
	 * @param {number} startAngle
	 * @param {number} endAngle
	 * @param {number} anticlockwise
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
	  var vec2Min = vec2.min;
	  var vec2Max = vec2.max;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff % PI2 < 1e-4 && diff > 1e-4) {
	    // Is a circle
	    min[0] = x - rx;
	    min[1] = y - ry;
	    max[0] = x + rx;
	    max[1] = y + ry;
	    return;
	  }
	
	  start[0] = mathCos(startAngle) * rx + x;
	  start[1] = mathSin(startAngle) * ry + y;
	  end[0] = mathCos(endAngle) * rx + x;
	  end[1] = mathSin(endAngle) * ry + y;
	  vec2Min(min, start, end);
	  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]
	
	  startAngle = startAngle % PI2;
	
	  if (startAngle < 0) {
	    startAngle = startAngle + PI2;
	  }
	
	  endAngle = endAngle % PI2;
	
	  if (endAngle < 0) {
	    endAngle = endAngle + PI2;
	  }
	
	  if (startAngle > endAngle && !anticlockwise) {
	    endAngle += PI2;
	  } else if (startAngle < endAngle && anticlockwise) {
	    startAngle += PI2;
	  }
	
	  if (anticlockwise) {
	    var tmp = endAngle;
	    endAngle = startAngle;
	    startAngle = tmp;
	  } // var number = 0;
	  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
	
	
	  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	    if (angle > startAngle) {
	      extremity[0] = mathCos(angle) * rx + x;
	      extremity[1] = mathSin(angle) * ry + y;
	      vec2Min(min, extremity, min);
	      vec2Max(max, extremity, max);
	    }
	  }
	}
	
	exports.fromPoints = fromPoints;
	exports.fromLine = fromLine;
	exports.fromCubic = fromCubic;
	exports.fromQuadratic = fromQuadratic;
	exports.fromArc = fromArc;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(183);
	
	var line = __webpack_require__(187);
	
	var cubic = __webpack_require__(188);
	
	var quadratic = __webpack_require__(189);
	
	var arc = __webpack_require__(190);
	
	var _util = __webpack_require__(191);
	
	var normalizeRadian = _util.normalizeRadian;
	
	var curve = __webpack_require__(184);
	
	var windingLine = __webpack_require__(192);
	
	var CMD = PathProxy.CMD;
	var PI2 = Math.PI * 2;
	var EPSILON = 1e-4;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	} // 临时数组
	
	
	var roots = [-1, -1, -1];
	var extrema = [-1, -1];
	
	function swapExtrema() {
	  var tmp = extrema[0];
	  extrema[0] = extrema[1];
	  extrema[1] = tmp;
	}
	
	function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
	    return 0;
	  }
	
	  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var w = 0;
	    var nExtrema = -1;
	    var y0_;
	    var y1_;
	
	    for (var i = 0; i < nRoots; i++) {
	      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
	
	      var unit = t === 0 || t === 1 ? 0.5 : 1;
	      var x_ = curve.cubicAt(x0, x1, x2, x3, t);
	
	      if (x_ < x) {
	        // Quick reject
	        continue;
	      }
	
	      if (nExtrema < 0) {
	        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);
	
	        if (extrema[1] < extrema[0] && nExtrema > 1) {
	          swapExtrema();
	        }
	
	        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);
	
	        if (nExtrema > 1) {
	          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
	        }
	      }
	
	      if (nExtrema === 2) {
	        // 分成三段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else if (t < extrema[1]) {
	          w += y1_ < y0_ ? unit : -unit;
	        } else {
	          w += y3 < y1_ ? unit : -unit;
	        }
	      } else {
	        // 分成两段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else {
	          w += y3 < y0_ ? unit : -unit;
	        }
	      }
	    }
	
	    return w;
	  }
	}
	
	function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
	    return 0;
	  }
	
	  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var t = curve.quadraticExtremum(y0, y1, y2);
	
	    if (t >= 0 && t <= 1) {
	      var w = 0;
	      var y_ = curve.quadraticAt(y0, y1, y2, t);
	
	      for (var i = 0; i < nRoots; i++) {
	        // Remove one endpoint.
	        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
	        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);
	
	        if (x_ < x) {
	          // Quick reject
	          continue;
	        }
	
	        if (roots[i] < t) {
	          w += y_ < y0 ? unit : -unit;
	        } else {
	          w += y2 < y_ ? unit : -unit;
	        }
	      }
	
	      return w;
	    } else {
	      // Remove one endpoint.
	      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
	      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);
	
	      if (x_ < x) {
	        // Quick reject
	        return 0;
	      }
	
	      return y2 < y0 ? unit : -unit;
	    }
	  }
	} // TODO
	// Arc 旋转
	
	
	function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	  y -= cy;
	
	  if (y > r || y < -r) {
	    return 0;
	  }
	
	  var tmp = Math.sqrt(r * r - y * y);
	  roots[0] = -tmp;
	  roots[1] = tmp;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff < 1e-4) {
	    return 0;
	  }
	
	  if (diff % PI2 < 1e-4) {
	    // Is a circle
	    startAngle = 0;
	    endAngle = PI2;
	    var dir = anticlockwise ? 1 : -1;
	
	    if (x >= roots[0] + cx && x <= roots[1] + cx) {
	      return dir;
	    } else {
	      return 0;
	    }
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var w = 0;
	
	  for (var i = 0; i < 2; i++) {
	    var x_ = roots[i];
	
	    if (x_ + cx > x) {
	      var angle = Math.atan2(y, x_);
	      var dir = anticlockwise ? 1 : -1;
	
	      if (angle < 0) {
	        angle = PI2 + angle;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
	        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	          dir = -dir;
	        }
	
	        w += dir;
	      }
	    }
	  }
	
	  return w;
	}
	
	function containPath(data, lineWidth, isStroke, x, y) {
	  var w = 0;
	  var xi = 0;
	  var yi = 0;
	  var x0 = 0;
	  var y0 = 0;
	
	  for (var i = 0; i < data.length;) {
	    var cmd = data[i++]; // Begin a new subpath
	
	    if (cmd === CMD.M && i > 1) {
	      // Close previous subpath
	      if (!isStroke) {
	        w += windingLine(xi, yi, x0, y0, x, y);
	      } // 如果被任何一个 subpath 包含
	      // if (w !== 0) {
	      //     return true;
	      // }
	
	    }
	
	    if (i === 1) {
	      // 如果第一个命令是 L, C, Q
	      // 则 previous point 同绘制命令的第一个 point
	      //
	      // 第一个命令为 Arc 的情况下会在后面特殊处理
	      xi = data[i];
	      yi = data[i + 1];
	      x0 = xi;
	      y0 = yi;
	    }
	
	    switch (cmd) {
	      case CMD.M:
	        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	        // 在 closePath 的时候使用
	        x0 = data[i++];
	        y0 = data[i++];
	        xi = x0;
	        yi = y0;
	        break;
	
	      case CMD.L:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
	          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.C:
	        if (isStroke) {
	          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.Q:
	        if (isStroke) {
	          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.A:
	        // TODO Arc 判断的开销比较大
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++]; // TODO Arc 旋转
	
	        i += 1;
	        var anticlockwise = 1 - data[i++];
	        var x1 = Math.cos(theta) * rx + cx;
	        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	        if (i > 1) {
	          w += windingLine(xi, yi, x1, y1, x, y);
	        } else {
	          // 第一个命令起点还未定义
	          x0 = x1;
	          y0 = y1;
	        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	        var _x = (x - cx) * ry / rx + cx;
	
	        if (isStroke) {
	          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	            return true;
	          }
	        } else {
	          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	        }
	
	        xi = Math.cos(theta + dTheta) * rx + cx;
	        yi = Math.sin(theta + dTheta) * ry + cy;
	        break;
	
	      case CMD.R:
	        x0 = xi = data[i++];
	        y0 = yi = data[i++];
	        var width = data[i++];
	        var height = data[i++];
	        var x1 = x0 + width;
	        var y1 = y0 + height;
	
	        if (isStroke) {
	          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // FIXME Clockwise ?
	          w += windingLine(x1, y0, x1, y1, x, y);
	          w += windingLine(x0, y1, x0, y0, x, y);
	        }
	
	        break;
	
	      case CMD.Z:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // Close a subpath
	          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
	          // FIXME subpaths may overlap
	          // if (w !== 0) {
	          //     return true;
	          // }
	        }
	
	        xi = x0;
	        yi = y0;
	        break;
	    }
	  }
	
	  if (!isStroke && !isAroundEqual(yi, y0)) {
	    w += windingLine(xi, yi, x0, y0, x, y) || 0;
	  }
	
	  return w !== 0;
	}
	
	function contain(pathData, x, y) {
	  return containPath(pathData, 0, false, x, y);
	}
	
	function containStroke(pathData, lineWidth, x, y) {
	  return containPath(pathData, lineWidth, true, x, y);
	}
	
	exports.contain = contain;
	exports.containStroke = containStroke;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	/**
	 * 线段包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  var _a = 0;
	  var _b = x0; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
	    return false;
	  }
	
	  if (x0 !== x1) {
	    _a = (y0 - y1) / (x0 - x1);
	    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	  } else {
	    return Math.abs(x - x0) <= _l / 2;
	  }
	
	  var tmp = _a * x - y + _b;
	
	  var _s = tmp * tmp / (_a * _a + 1);
	
	  return _s <= _l / 2 * _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(184);
	
	/**
	 * 三次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  x3
	 * @param  {number}  y3
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
	    return false;
	  }
	
	  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var _curve = __webpack_require__(184);
	
	var quadraticProjectPoint = _curve.quadraticProjectPoint;
	
	/**
	 * 二次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
	    return false;
	  }
	
	  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(191);
	
	var normalizeRadian = _util.normalizeRadian;
	var PI2 = Math.PI * 2;
	/**
	 * 圆弧描边包含判断
	 * @param  {number}  cx
	 * @param  {number}  cy
	 * @param  {number}  r
	 * @param  {number}  startAngle
	 * @param  {number}  endAngle
	 * @param  {boolean}  anticlockwise
	 * @param  {number} lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {Boolean}
	 */
	
	function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  x -= cx;
	  y -= cy;
	  var d = Math.sqrt(x * x + y * y);
	
	  if (d - _l > r || d + _l < r) {
	    return false;
	  }
	
	  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
	    // Is a circle
	    return true;
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var angle = Math.atan2(y, x);
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	var PI2 = Math.PI * 2;
	
	function normalizeRadian(angle) {
	  angle %= PI2;
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle;
	}
	
	exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	function windingLine(x0, y0, x1, y1, x, y) {
	  if (y > y0 && y > y1 || y < y0 && y < y1) {
	    return 0;
	  } // Ignore horizontal line
	
	
	  if (y1 === y0) {
	    return 0;
	  }
	
	  var dir = y1 < y0 ? 1 : -1;
	  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
	
	  if (t === 1 || t === 0) {
	    dir = y1 < y0 ? 0.5 : -0.5;
	  }
	
	  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".
	
	  return x_ === x ? Infinity : x_ > x ? dir : 0;
	}
	
	module.exports = windingLine;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(183);
	
	var _vector = __webpack_require__(136);
	
	var v2ApplyTransform = _vector.applyTransform;
	var CMD = PathProxy.CMD;
	var points = [[], [], []];
	var mathSqrt = Math.sqrt;
	var mathAtan2 = Math.atan2;
	
	function _default(path, m) {
	  var data = path.data;
	  var cmd;
	  var nPoint;
	  var i;
	  var j;
	  var k;
	  var p;
	  var M = CMD.M;
	  var C = CMD.C;
	  var L = CMD.L;
	  var R = CMD.R;
	  var A = CMD.A;
	  var Q = CMD.Q;
	
	  for (i = 0, j = 0; i < data.length;) {
	    cmd = data[i++];
	    j = i;
	    nPoint = 0;
	
	    switch (cmd) {
	      case M:
	        nPoint = 1;
	        break;
	
	      case L:
	        nPoint = 1;
	        break;
	
	      case C:
	        nPoint = 3;
	        break;
	
	      case Q:
	        nPoint = 2;
	        break;
	
	      case A:
	        var x = m[4];
	        var y = m[5];
	        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
	        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
	        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx
	
	        data[i] *= sx;
	        data[i++] += x; // cy
	
	        data[i] *= sy;
	        data[i++] += y; // Scale rx and ry
	        // FIXME Assume psi is 0 here
	
	        data[i++] *= sx;
	        data[i++] *= sy; // Start angle
	
	        data[i++] += angle; // end angle
	
	        data[i++] += angle; // FIXME psi
	
	        i += 2;
	        j = i;
	        break;
	
	      case R:
	        // x0, y0
	        p[0] = data[i++];
	        p[1] = data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1]; // x1, y1
	
	        p[0] += data[i++];
	        p[1] += data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1];
	    }
	
	    for (k = 0; k < nPoint; k++) {
	      var p = points[k];
	      p[0] = data[i++];
	      p[1] = data[i++];
	      v2ApplyTransform(p, p, m); // Write back
	
	      data[j++] = p[0];
	      data[j++] = p[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(164);
	
	var zrUtil = __webpack_require__(134);
	
	var textContain = __webpack_require__(167);
	
	var textHelper = __webpack_require__(166);
	
	var _constant = __webpack_require__(160);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	
	/**
	 * @alias zrender/graphic/Text
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	var Text = function (opts) {
	  // jshint ignore:line
	  Displayable.call(this, opts);
	};
	
	Text.prototype = {
	  constructor: Text,
	  type: 'text',
	  brush: function (ctx, prevEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.
	
	    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
	    var text = style.text; // Convert to string
	
	    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
	    // is in textHelper.renderText, and performance of text render should
	    // be considered.
	    // style.bind(ctx, this, prevEl);
	
	    if (!textHelper.needDrawText(text, style)) {
	      // The current el.style is not applied
	      // and should not be used as cache.
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	      return;
	    }
	
	    this.setTransform(ctx);
	    textHelper.renderText(this, ctx, text, style, null, prevEl);
	    this.restoreTransform(ctx);
	  },
	  getBoundingRect: function () {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	
	    if (!this._rect) {
	      var text = style.text;
	      text != null ? text += '' : text = '';
	      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
	      rect.x += style.x || 0;
	      rect.y += style.y || 0;
	
	      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
	        var w = style.textStrokeWidth;
	        rect.x -= w / 2;
	        rect.y -= w / 2;
	        rect.width += w;
	        rect.height += w;
	      }
	
	      this._rect = rect;
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(Text, Displayable);
	var _default = Text;
	module.exports = _default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	/**
	 * 圆形
	 * @module zrender/shape/Circle
	 */
	var _default = Path.extend({
	  type: 'circle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    // Better stroking in ShapeBundle
	    // Always do it may have performence issue ( fill may be 2x more cost)
	    if (inBundle) {
	      ctx.moveTo(shape.cx + shape.r, shape.cy);
	    } // else {
	    //     if (ctx.allocate && !ctx.data.length) {
	    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
	    //     }
	    // }
	    // Better stroking in ShapeBundle
	    // ctx.moveTo(shape.cx + shape.r, shape.cy);
	
	
	    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var fixClipWithShadow = __webpack_require__(197);
	
	/**
	 * 扇形
	 * @module zrender/graphic/shape/Sector
	 */
	var _default = Path.extend({
	  type: 'sector',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
	    ctx.lineTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(133);
	
	// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
	// where exception "unexpected call to method or property access"
	// might be thrown when calling ctx.fill or ctx.stroke after a path
	// whose area size is zero is drawn and ctx.clip() is called and
	// shadowBlur is set. See #4572, #3112, #5777.
	// (e.g.,
	//  ctx.moveTo(10, 10);
	//  ctx.lineTo(20, 10);
	//  ctx.closePath();
	//  ctx.clip();
	//  ctx.shadowBlur = 10;
	//  ...
	//  ctx.fill();
	// )
	var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];
	
	function _default(orignalBrush) {
	  // version string can be: '11.0'
	  return env.browser.ie && env.browser.version >= 11 ? function () {
	    var clipPaths = this.__clipPaths;
	    var style = this.style;
	    var modified;
	
	    if (clipPaths) {
	      for (var i = 0; i < clipPaths.length; i++) {
	        var clipPath = clipPaths[i];
	        var shape = clipPath && clipPath.shape;
	        var type = clipPath && clipPath.type;
	
	        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
	          for (var j = 0; j < shadowTemp.length; j++) {
	            // It is save to put shadowTemp static, because shadowTemp
	            // will be all modified each item brush called.
	            shadowTemp[j][2] = style[shadowTemp[j][0]];
	            style[shadowTemp[j][0]] = shadowTemp[j][1];
	          }
	
	          modified = true;
	          break;
	        }
	      }
	    }
	
	    orignalBrush.apply(this, arguments);
	
	    if (modified) {
	      for (var j = 0; j < shadowTemp.length; j++) {
	        style[shadowTemp[j][0]] = shadowTemp[j][2];
	      }
	    }
	  } : orignalBrush;
	}
	
	module.exports = _default;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	/**
	 * 圆环
	 * @module zrender/graphic/shape/Ring
	 */
	var _default = Path.extend({
	  type: 'ring',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    r0: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var PI2 = Math.PI * 2;
	    ctx.moveTo(x + shape.r, y);
	    ctx.arc(x, y, shape.r, 0, PI2, false);
	    ctx.moveTo(x + shape.r0, y);
	    ctx.arc(x, y, shape.r0, 0, PI2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var polyHelper = __webpack_require__(200);
	
	/**
	 * 多边形
	 * @module zrender/shape/Polygon
	 */
	var _default = Path.extend({
	  type: 'polygon',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var smoothSpline = __webpack_require__(201);
	
	var smoothBezier = __webpack_require__(202);
	
	function buildPath(ctx, shape, closePath) {
	  var points = shape.points;
	  var smooth = shape.smooth;
	
	  if (points && points.length >= 2) {
	    if (smooth && smooth !== 'spline') {
	      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	      ctx.moveTo(points[0][0], points[0][1]);
	      var len = points.length;
	
	      for (var i = 0; i < (closePath ? len : len - 1); i++) {
	        var cp1 = controlPoints[i * 2];
	        var cp2 = controlPoints[i * 2 + 1];
	        var p = points[(i + 1) % len];
	        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	      }
	    } else {
	      if (smooth === 'spline') {
	        points = smoothSpline(points, closePath);
	      }
	
	      ctx.moveTo(points[0][0], points[0][1]);
	
	      for (var i = 1, l = points.length; i < l; i++) {
	        ctx.lineTo(points[i][0], points[i][1]);
	      }
	    }
	
	    closePath && ctx.closePath();
	  }
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(136);
	
	var v2Distance = _vector.distance;
	
	/**
	 * Catmull-Rom spline 插值折线
	 * @module zrender/shape/util/smoothSpline
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * @inner
	 */
	function interpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	/**
	 * @alias module:zrender/shape/util/smoothSpline
	 * @param {Array} points 线段顶点数组
	 * @param {boolean} isLoop
	 * @return {Array}
	 */
	
	
	function _default(points, isLoop) {
	  var len = points.length;
	  var ret = [];
	  var distance = 0;
	
	  for (var i = 1; i < len; i++) {
	    distance += v2Distance(points[i - 1], points[i]);
	  }
	
	  var segs = distance / 2;
	  segs = segs < len ? len : segs;
	
	  for (var i = 0; i < segs; i++) {
	    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
	    var idx = Math.floor(pos);
	    var w = pos - idx;
	    var p0;
	    var p1 = points[idx % len];
	    var p2;
	    var p3;
	
	    if (!isLoop) {
	      p0 = points[idx === 0 ? idx : idx - 1];
	      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
	      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
	    } else {
	      p0 = points[(idx - 1 + len) % len];
	      p2 = points[(idx + 1) % len];
	      p3 = points[(idx + 2) % len];
	    }
	
	    var w2 = w * w;
	    var w3 = w * w2;
	    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
	  }
	
	  return ret;
	}
	
	module.exports = _default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(136);
	
	var v2Min = _vector.min;
	var v2Max = _vector.max;
	var v2Scale = _vector.scale;
	var v2Distance = _vector.distance;
	var v2Add = _vector.add;
	var v2Clone = _vector.clone;
	var v2Sub = _vector.sub;
	
	/**
	 * 贝塞尔平滑曲线
	 * @module zrender/shape/util/smoothBezier
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * 贝塞尔平滑曲线
	 * @alias module:zrender/shape/util/smoothBezier
	 * @param {Array} points 线段顶点数组
	 * @param {number} smooth 平滑等级, 0-1
	 * @param {boolean} isLoop
	 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
	 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
	 *                           整个折线的包围盒做一个并集用来约束控制点。
	 * @param {Array} 计算出来的控制点数组
	 */
	function _default(points, smooth, isLoop, constraint) {
	  var cps = [];
	  var v = [];
	  var v1 = [];
	  var v2 = [];
	  var prevPoint;
	  var nextPoint;
	  var min;
	  var max;
	
	  if (constraint) {
	    min = [Infinity, Infinity];
	    max = [-Infinity, -Infinity];
	
	    for (var i = 0, len = points.length; i < len; i++) {
	      v2Min(min, min, points[i]);
	      v2Max(max, max, points[i]);
	    } // 与指定的包围盒做并集
	
	
	    v2Min(min, min, constraint[0]);
	    v2Max(max, max, constraint[1]);
	  }
	
	  for (var i = 0, len = points.length; i < len; i++) {
	    var point = points[i];
	
	    if (isLoop) {
	      prevPoint = points[i ? i - 1 : len - 1];
	      nextPoint = points[(i + 1) % len];
	    } else {
	      if (i === 0 || i === len - 1) {
	        cps.push(v2Clone(points[i]));
	        continue;
	      } else {
	        prevPoint = points[i - 1];
	        nextPoint = points[i + 1];
	      }
	    }
	
	    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
	
	    v2Scale(v, v, smooth);
	    var d0 = v2Distance(point, prevPoint);
	    var d1 = v2Distance(point, nextPoint);
	    var sum = d0 + d1;
	
	    if (sum !== 0) {
	      d0 /= sum;
	      d1 /= sum;
	    }
	
	    v2Scale(v1, v, -d0);
	    v2Scale(v2, v, d1);
	    var cp0 = v2Add([], point, v1);
	    var cp1 = v2Add([], point, v2);
	
	    if (constraint) {
	      v2Max(cp0, cp0, min);
	      v2Min(cp0, cp0, max);
	      v2Max(cp1, cp1, min);
	      v2Min(cp1, cp1, max);
	    }
	
	    cps.push(cp0);
	    cps.push(cp1);
	  }
	
	  if (isLoop) {
	    cps.push(cps.shift());
	  }
	
	  return cps;
	}
	
	module.exports = _default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var polyHelper = __webpack_require__(200);
	
	/**
	 * @module zrender/graphic/shape/Polyline
	 */
	var _default = Path.extend({
	  type: 'polyline',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, false);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var roundRectHelper = __webpack_require__(169);
	
	var _subPixelOptimize = __webpack_require__(205);
	
	var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;
	
	/**
	 * 矩形
	 * @module zrender/graphic/shape/Rect
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'rect',
	  shape: {
	    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
	    // r缩写为1         相当于 [1, 1, 1, 1]
	    // r缩写为[1]       相当于 [1, 1, 1, 1]
	    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
	    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
	    r: 0,
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
	      x = subPixelOptimizeOutputShape.x;
	      y = subPixelOptimizeOutputShape.y;
	      width = subPixelOptimizeOutputShape.width;
	      height = subPixelOptimizeOutputShape.height;
	      subPixelOptimizeOutputShape.r = shape.r;
	      shape = subPixelOptimizeOutputShape;
	    } else {
	      x = shape.x;
	      y = shape.y;
	      width = shape.width;
	      height = shape.height;
	    }
	
	    if (!shape.r) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, shape);
	    }
	
	    ctx.closePath();
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	/**
	 * Sub-pixel optimize for canvas rendering, prevent from blur
	 * when rendering a thin vertical/horizontal line.
	 */
	var round = Math.round;
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x1]
	 * @param {number} [inputShape.y1]
	 * @param {number} [inputShape.x2]
	 * @param {number} [inputShape.y2]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth]
	 */
	
	function subPixelOptimizeLine(outputShape, inputShape, style) {
	  var lineWidth = style && style.lineWidth;
	
	  if (!inputShape || !lineWidth) {
	    return;
	  }
	
	  var x1 = inputShape.x1;
	  var x2 = inputShape.x2;
	  var y1 = inputShape.y1;
	  var y2 = inputShape.y2;
	
	  if (round(x1 * 2) === round(x2 * 2)) {
	    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
	  } else {
	    outputShape.x1 = x1;
	    outputShape.x2 = x2;
	  }
	
	  if (round(y1 * 2) === round(y2 * 2)) {
	    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
	  } else {
	    outputShape.y1 = y1;
	    outputShape.y2 = y2;
	  }
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x]
	 * @param {number} [inputShape.y]
	 * @param {number} [inputShape.width]
	 * @param {number} [inputShape.height]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth]
	 */
	
	
	function subPixelOptimizeRect(outputShape, inputShape, style) {
	  var lineWidth = style && style.lineWidth;
	
	  if (!inputShape || !lineWidth) {
	    return;
	  }
	
	  var originX = inputShape.x;
	  var originY = inputShape.y;
	  var originWidth = inputShape.width;
	  var originHeight = inputShape.height;
	  outputShape.x = subPixelOptimize(originX, lineWidth, true);
	  outputShape.y = subPixelOptimize(originY, lineWidth, true);
	  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
	  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var _subPixelOptimize = __webpack_require__(205);
	
	var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;
	
	/**
	 * 直线
	 * @module zrender/graphic/shape/Line
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'line',
	  shape: {
	    // Start point
	    x1: 0,
	    y1: 0,
	    // End point
	    x2: 0,
	    y2: 0,
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1;
	    var y1;
	    var x2;
	    var y2;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
	      x1 = subPixelOptimizeOutputShape.x1;
	      y1 = subPixelOptimizeOutputShape.y1;
	      x2 = subPixelOptimizeOutputShape.x2;
	      y2 = subPixelOptimizeOutputShape.y2;
	    } else {
	      x1 = shape.x1;
	      y1 = shape.y1;
	      x2 = shape.x2;
	      y2 = shape.y2;
	    }
	
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (percent < 1) {
	      x2 = x1 * (1 - percent) + x2 * percent;
	      y2 = y1 * (1 - percent) + y2 * percent;
	    }
	
	    ctx.lineTo(x2, y2);
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} percent
	   * @return {Array.<number>}
	   */
	  pointAt: function (p) {
	    var shape = this.shape;
	    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	var vec2 = __webpack_require__(136);
	
	var _curve = __webpack_require__(184);
	
	var quadraticSubdivide = _curve.quadraticSubdivide;
	var cubicSubdivide = _curve.cubicSubdivide;
	var quadraticAt = _curve.quadraticAt;
	var cubicAt = _curve.cubicAt;
	var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
	var cubicDerivativeAt = _curve.cubicDerivativeAt;
	
	/**
	 * 贝塞尔曲线
	 * @module zrender/shape/BezierCurve
	 */
	var out = [];
	
	function someVectorAt(shape, t, isTangent) {
	  var cpx2 = shape.cpx2;
	  var cpy2 = shape.cpy2;
	
	  if (cpx2 === null || cpy2 === null) {
	    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
	  } else {
	    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
	  }
	}
	
	var _default = Path.extend({
	  type: 'bezier-curve',
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    // cpx2: 0,
	    // cpy2: 0
	    // Curve show percent, for animating
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var cpx1 = shape.cpx1;
	    var cpy1 = shape.cpy1;
	    var cpx2 = shape.cpx2;
	    var cpy2 = shape.cpy2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (cpx2 == null || cpy2 == null) {
	      if (percent < 1) {
	        quadraticSubdivide(x1, cpx1, x2, percent, out);
	        cpx1 = out[1];
	        x2 = out[2];
	        quadraticSubdivide(y1, cpy1, y2, percent, out);
	        cpy1 = out[1];
	        y2 = out[2];
	      }
	
	      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	    } else {
	      if (percent < 1) {
	        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	        cpx1 = out[1];
	        cpx2 = out[2];
	        x2 = out[3];
	        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	        cpy1 = out[1];
	        cpy2 = out[2];
	        y2 = out[3];
	      }
	
	      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	    }
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  pointAt: function (t) {
	    return someVectorAt(this.shape, t, false);
	  },
	
	  /**
	   * Get tangent at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  tangentAt: function (t) {
	    var p = someVectorAt(this.shape, t, true);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	/**
	 * 圆弧
	 * @module zrender/graphic/shape/Arc
	 */
	var _default = Path.extend({
	  type: 'arc',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	// CompoundPath to improve performance
	var _default = Path.extend({
	  type: 'compound',
	  shape: {
	    paths: null
	  },
	  _updatePathDirty: function () {
	    var dirtyPath = this.__dirtyPath;
	    var paths = this.shape.paths;
	
	    for (var i = 0; i < paths.length; i++) {
	      // Mark as dirty if any subpath is dirty
	      dirtyPath = dirtyPath || paths[i].__dirtyPath;
	    }
	
	    this.__dirtyPath = dirtyPath;
	    this.__dirty = this.__dirty || dirtyPath;
	  },
	  beforeBrush: function () {
	    this._updatePathDirty();
	
	    var paths = this.shape.paths || [];
	    var scale = this.getGlobalScale(); // Update path scale
	
	    for (var i = 0; i < paths.length; i++) {
	      if (!paths[i].path) {
	        paths[i].createPathProxy();
	      }
	
	      paths[i].path.setScale(scale[0], scale[1]);
	    }
	  },
	  buildPath: function (ctx, shape) {
	    var paths = shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].buildPath(ctx, paths[i].shape, true);
	    }
	  },
	  afterBrush: function () {
	    var paths = this.shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].__dirtyPath = false;
	    }
	  },
	  getBoundingRect: function () {
	    this._updatePathDirty();
	
	    return Path.prototype.getBoundingRect.call(this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(134);
	
	var Gradient = __webpack_require__(211);
	
	/**
	 * x, y, x2, y2 are all percent from 0 to 1
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @param {number} [x2=1]
	 * @param {number} [y2=0]
	 * @param {Array.<Object>} colorStops
	 * @param {boolean} [globalCoord=false]
	 */
	var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'linear', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0 : x;
	  this.y = y == null ? 0 : y;
	  this.x2 = x2 == null ? 1 : x2;
	  this.y2 = y2 == null ? 0 : y2; // Can be cloned
	
	  this.type = 'linear'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	LinearGradient.prototype = {
	  constructor: LinearGradient
	};
	zrUtil.inherits(LinearGradient, Gradient);
	var _default = LinearGradient;
	module.exports = _default;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	/**
	 * @param {Array.<Object>} colorStops
	 */
	var Gradient = function (colorStops) {
	  this.colorStops = colorStops || [];
	};
	
	Gradient.prototype = {
	  constructor: Gradient,
	  addColorStop: function (offset, color) {
	    this.colorStops.push({
	      offset: offset,
	      color: color
	    });
	  }
	};
	var _default = Gradient;
	module.exports = _default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(134);
	
	var Gradient = __webpack_require__(211);
	
	/**
	 * x, y, r are all percent from 0 to 1
	 * @param {number} [x=0.5]
	 * @param {number} [y=0.5]
	 * @param {number} [r=0.5]
	 * @param {Array.<Object>} [colorStops]
	 * @param {boolean} [globalCoord=false]
	 */
	var RadialGradient = function (x, y, r, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'radial', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0.5 : x;
	  this.y = y == null ? 0.5 : y;
	  this.r = r == null ? 0.5 : r; // Can be cloned
	
	  this.type = 'radial'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	RadialGradient.prototype = {
	  constructor: RadialGradient
	};
	zrUtil.inherits(RadialGradient, Gradient);
	var _default = RadialGradient;
	module.exports = _default;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(134);
	
	var inherits = _util.inherits;
	
	var Displayble = __webpack_require__(164);
	
	var BoundingRect = __webpack_require__(154);
	
	/**
	 * Displayable for incremental rendering. It will be rendered in a separate layer
	 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
	 * addDisplayables will render the added displayables incremetally.
	 *
	 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
	 */
	// TODO Style override ?
	function IncrementalDisplayble(opts) {
	  Displayble.call(this, opts);
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.notClear = true;
	}
	
	IncrementalDisplayble.prototype.incremental = true;
	
	IncrementalDisplayble.prototype.clearDisplaybles = function () {
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.dirty();
	  this.notClear = false;
	};
	
	IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
	  if (notPersistent) {
	    this._temporaryDisplayables.push(displayable);
	  } else {
	    this._displayables.push(displayable);
	  }
	
	  this.dirty();
	};
	
	IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
	  notPersistent = notPersistent || false;
	
	  for (var i = 0; i < displayables.length; i++) {
	    this.addDisplayable(displayables[i], notPersistent);
	  }
	};
	
	IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    cb && cb(this._displayables[i]);
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    cb && cb(this._temporaryDisplayables[i]);
	  }
	};
	
	IncrementalDisplayble.prototype.update = function () {
	  this.updateTransform();
	
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	};
	
	IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
	  // Render persistant displayables.
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._cursor = i; // Render temporary displayables.
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._temporaryDisplayables = [];
	  this.notClear = true;
	};
	
	var m = [];
	
	IncrementalDisplayble.prototype.getBoundingRect = function () {
	  if (!this._rect) {
	    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
	
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	      var childRect = displayable.getBoundingRect().clone();
	
	      if (displayable.needLocalTransform()) {
	        childRect.applyTransform(displayable.getLocalTransform(m));
	      }
	
	      rect.union(childRect);
	    }
	
	    this._rect = rect;
	  }
	
	  return this._rect;
	};
	
	IncrementalDisplayble.prototype.contain = function (x, y) {
	  var localPos = this.transformCoordToLocal(x, y);
	  var rect = this.getBoundingRect();
	
	  if (rect.contain(localPos[0], localPos[1])) {
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	
	      if (displayable.contain(x, y)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	inherits(IncrementalDisplayble, Displayble);
	var _default = IncrementalDisplayble;
	module.exports = _default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
	var _default = {
	  getItemStyle: function (excludes, includes) {
	    var style = getItemStyle(this, excludes, includes);
	    var lineDash = this.getBorderLineDash();
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getBorderLineDash: function () {
	    var lineType = this.get('borderType');
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
	  }
	};
	module.exports = _default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Model = __webpack_require__(174);
	
	var componentUtil = __webpack_require__(216);
	
	var _clazz = __webpack_require__(175);
	
	var enableClassManagement = _clazz.enableClassManagement;
	var parseClassType = _clazz.parseClassType;
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	var layout = __webpack_require__(217);
	
	var boxLayoutMixin = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Component model
	 *
	 * @module echarts/model/Component
	 */
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Component
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {module:echarts/model/Model} ecModel
	 */
	
	var ComponentModel = Model.extend({
	  type: 'component',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  id: '',
	
	  /**
	   * Because simplified concept is probably better, series.name (or component.name)
	   * has been having too many resposibilities:
	   * (1) Generating id (which requires name in option should not be modified).
	   * (2) As an index to mapping series when merging option or calling API (a name
	   * can refer to more then one components, which is convinient is some case).
	   * (3) Display.
	   * @readOnly
	   */
	  name: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  mainType: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  subType: '',
	
	  /**
	   * @readOnly
	   * @type {number}
	   */
	  componentIndex: 0,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	  ecModel: null,
	
	  /**
	   * key: componentType
	   * value:  Component model list, can not be null.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @readOnly
	   */
	  dependentModels: [],
	
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  uid: null,
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  $constructor: function (option, parentModel, ecModel, extraOpt) {
	    Model.call(this, option, parentModel, ecModel, extraOpt);
	    this.uid = componentUtil.getUID('ec_cpt_model');
	  },
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
	    var themeModel = ecModel.getTheme();
	    zrUtil.merge(option, themeModel.get(this.mainType));
	    zrUtil.merge(option, this.getDefaultOption());
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (option, extraOpt) {
	    zrUtil.merge(this.option, option, true);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(this.option, option, layoutMode);
	    }
	  },
	  // Hooker after init or mergeOption
	  optionUpdated: function (newCptOption, isInit) {},
	  getDefaultOption: function () {
	    var fields = inner(this);
	
	    if (!fields.defaultOption) {
	      var optList = [];
	      var Class = this.constructor;
	
	      while (Class) {
	        var opt = Class.prototype.defaultOption;
	        opt && optList.push(opt);
	        Class = Class.superClass;
	      }
	
	      var defaultOption = {};
	
	      for (var i = optList.length - 1; i >= 0; i--) {
	        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
	      }
	
	      fields.defaultOption = defaultOption;
	    }
	
	    return fields.defaultOption;
	  },
	  getReferringComponents: function (mainType) {
	    return this.ecModel.queryComponents({
	      mainType: mainType,
	      index: this.get(mainType + 'Index', true),
	      id: this.get(mainType + 'Id', true)
	    });
	  }
	}); // Reset ComponentModel.extend, add preConstruct.
	// clazzUtil.enableClassExtend(
	//     ComponentModel,
	//     function (option, parentModel, ecModel, extraOpt) {
	//         // Set dependentModels, componentIndex, name, id, mainType, subType.
	//         zrUtil.extend(this, extraOpt);
	//         this.uid = componentUtil.getUID('componentModel');
	//         // this.setReadOnly([
	//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
	//         //     'dependentModels', 'componentIndex'
	//         // ]);
	//     }
	// );
	// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	enableClassManagement(ComponentModel, {
	  registerWhenExtend: true
	});
	componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.
	
	componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);
	
	function getDependencies(componentType) {
	  var deps = [];
	  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
	    deps = deps.concat(Clazz.prototype.dependencies || []);
	  }); // Ensure main type.
	
	  deps = zrUtil.map(deps, function (type) {
	    return parseClassType(type).main;
	  }); // Hack dataset for convenience.
	
	  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
	    deps.unshift('dataset');
	  }
	
	  return deps;
	}
	
	zrUtil.mixin(ComponentModel, boxLayoutMixin);
	var _default = ComponentModel;
	module.exports = _default;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _clazz = __webpack_require__(175);
	
	var parseClassType = _clazz.parseClassType;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var base = 0;
	/**
	 * @public
	 * @param {string} type
	 * @return {string}
	 */
	
	function getUID(type) {
	  // Considering the case of crossing js context,
	  // use Math.random to make id as unique as possible.
	  return [type || '', base++, Math.random().toFixed(5)].join('_');
	}
	/**
	 * @inner
	 */
	
	
	function enableSubTypeDefaulter(entity) {
	  var subTypeDefaulters = {};
	
	  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
	    componentType = parseClassType(componentType);
	    subTypeDefaulters[componentType.main] = defaulter;
	  };
	
	  entity.determineSubType = function (componentType, option) {
	    var type = option.type;
	
	    if (!type) {
	      var componentTypeMain = parseClassType(componentType).main;
	
	      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	        type = subTypeDefaulters[componentTypeMain](option);
	      }
	    }
	
	    return type;
	  };
	
	  return entity;
	}
	/**
	 * Topological travel on Activity Network (Activity On Vertices).
	 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	 *
	 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	 *
	 * If there is circle dependencey, Error will be thrown.
	 *
	 */
	
	
	function enableTopologicalTravel(entity, dependencyGetter) {
	  /**
	   * @public
	   * @param {Array.<string>} targetNameList Target Component type list.
	   *                                           Can be ['aa', 'bb', 'aa.xx']
	   * @param {Array.<string>} fullNameList By which we can build dependency graph.
	   * @param {Function} callback Params: componentType, dependencies.
	   * @param {Object} context Scope of callback.
	   */
	  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	    if (!targetNameList.length) {
	      return;
	    }
	
	    var result = makeDepndencyGraph(fullNameList);
	    var graph = result.graph;
	    var stack = result.noEntryList;
	    var targetNameSet = {};
	    zrUtil.each(targetNameList, function (name) {
	      targetNameSet[name] = true;
	    });
	
	    while (stack.length) {
	      var currComponentType = stack.pop();
	      var currVertex = graph[currComponentType];
	      var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	      if (isInTargetNameSet) {
	        callback.call(context, currComponentType, currVertex.originalDeps.slice());
	        delete targetNameSet[currComponentType];
	      }
	
	      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	    }
	
	    zrUtil.each(targetNameSet, function () {
	      throw new Error('Circle dependency may exists');
	    });
	
	    function removeEdge(succComponentType) {
	      graph[succComponentType].entryCount--;
	
	      if (graph[succComponentType].entryCount === 0) {
	        stack.push(succComponentType);
	      }
	    } // Consider this case: legend depends on series, and we call
	    // chart.setOption({series: [...]}), where only series is in option.
	    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	    // not be called, but only sereis.mergeOption is called. Thus legend
	    // have no chance to update its local record about series (like which
	    // name of series is available in legend).
	
	
	    function removeEdgeAndAdd(succComponentType) {
	      targetNameSet[succComponentType] = true;
	      removeEdge(succComponentType);
	    }
	  };
	  /**
	   * DepndencyGraph: {Object}
	   * key: conponentType,
	   * value: {
	   *     successor: [conponentTypes...],
	   *     originalDeps: [conponentTypes...],
	   *     entryCount: {number}
	   * }
	   */
	
	
	  function makeDepndencyGraph(fullNameList) {
	    var graph = {};
	    var noEntryList = [];
	    zrUtil.each(fullNameList, function (name) {
	      var thisItem = createDependencyGraphItem(graph, name);
	      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	      thisItem.entryCount = availableDeps.length;
	
	      if (thisItem.entryCount === 0) {
	        noEntryList.push(name);
	      }
	
	      zrUtil.each(availableDeps, function (dependentName) {
	        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
	          thisItem.predecessor.push(dependentName);
	        }
	
	        var thatItem = createDependencyGraphItem(graph, dependentName);
	
	        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
	          thatItem.successor.push(name);
	        }
	      });
	    });
	    return {
	      graph: graph,
	      noEntryList: noEntryList
	    };
	  }
	
	  function createDependencyGraphItem(graph, name) {
	    if (!graph[name]) {
	      graph[name] = {
	        predecessor: [],
	        successor: []
	      };
	    }
	
	    return graph[name];
	  }
	
	  function getAvailableDependencies(originalDeps, fullNameList) {
	    var availableDeps = [];
	    zrUtil.each(originalDeps, function (dep) {
	      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	    });
	    return availableDeps;
	  }
	}
	
	exports.getUID = getUID;
	exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
	exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var BoundingRect = __webpack_require__(154);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var formatUtil = __webpack_require__(219);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Layout helpers for each component positioning
	var each = zrUtil.each;
	/**
	 * @public
	 */
	
	var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	/**
	 * @public
	 */
	
	var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	  var x = 0;
	  var y = 0;
	
	  if (maxWidth == null) {
	    maxWidth = Infinity;
	  }
	
	  if (maxHeight == null) {
	    maxHeight = Infinity;
	  }
	
	  var currentLineMaxSize = 0;
	  group.eachChild(function (child, idx) {
	    var position = child.position;
	    var rect = child.getBoundingRect();
	    var nextChild = group.childAt(idx + 1);
	    var nextChildRect = nextChild && nextChild.getBoundingRect();
	    var nextX;
	    var nextY;
	
	    if (orient === 'horizontal') {
	      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	      // FIXME compare before adding gap?
	
	      if (nextX > maxWidth || child.newline) {
	        x = 0;
	        nextX = moveX;
	        y += currentLineMaxSize + gap;
	        currentLineMaxSize = rect.height;
	      } else {
	        // FIXME: consider rect.y is not `0`?
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	      }
	    } else {
	      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	      if (nextY > maxHeight || child.newline) {
	        x += currentLineMaxSize + gap;
	        y = 0;
	        nextY = moveY;
	        currentLineMaxSize = rect.width;
	      } else {
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	      }
	    }
	
	    if (child.newline) {
	      return;
	    }
	
	    position[0] = x;
	    position[1] = y;
	    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	  });
	}
	/**
	 * VBox or HBox layouting
	 * @param {string} orient
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	
	var box = boxLayout;
	/**
	 * VBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var vbox = zrUtil.curry(boxLayout, 'vertical');
	/**
	 * HBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var hbox = zrUtil.curry(boxLayout, 'horizontal');
	/**
	 * If x or x2 is not specified or 'center' 'left' 'right',
	 * the width would be as long as possible.
	 * If y or y2 is not specified or 'middle' 'top' 'bottom',
	 * the height would be as long as possible.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.x]
	 * @param {number|string} [positionInfo.y]
	 * @param {number|string} [positionInfo.x2]
	 * @param {number|string} [positionInfo.y2]
	 * @param {Object} containerRect {width, height}
	 * @param {string|number} margin
	 * @return {Object} {width, height}
	 */
	
	function getAvailableSize(positionInfo, containerRect, margin) {
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var x = parsePercent(positionInfo.x, containerWidth);
	  var y = parsePercent(positionInfo.y, containerHeight);
	  var x2 = parsePercent(positionInfo.x2, containerWidth);
	  var y2 = parsePercent(positionInfo.y2, containerHeight);
	  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
	  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
	  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
	  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  return {
	    width: Math.max(x2 - x - margin[1] - margin[3], 0),
	    height: Math.max(y2 - y - margin[0] - margin[2], 0)
	  };
	}
	/**
	 * Parse position info.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width]
	 * @param {number|string} [positionInfo.height]
	 * @param {number|string} [positionInfo.aspect] Aspect is width / height
	 * @param {Object} containerRect
	 * @param {string|number} [margin]
	 *
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	
	function getLayoutRect(positionInfo, containerRect, margin) {
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var left = parsePercent(positionInfo.left, containerWidth);
	  var top = parsePercent(positionInfo.top, containerHeight);
	  var right = parsePercent(positionInfo.right, containerWidth);
	  var bottom = parsePercent(positionInfo.bottom, containerHeight);
	  var width = parsePercent(positionInfo.width, containerWidth);
	  var height = parsePercent(positionInfo.height, containerHeight);
	  var verticalMargin = margin[2] + margin[0];
	  var horizontalMargin = margin[1] + margin[3];
	  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	  if (isNaN(width)) {
	    width = containerWidth - right - horizontalMargin - left;
	  }
	
	  if (isNaN(height)) {
	    height = containerHeight - bottom - verticalMargin - top;
	  }
	
	  if (aspect != null) {
	    // If width and height are not given
	    // 1. Graph should not exceeds the container
	    // 2. Aspect must be keeped
	    // 3. Graph should take the space as more as possible
	    // FIXME
	    // Margin is not considered, because there is no case that both
	    // using margin and aspect so far.
	    if (isNaN(width) && isNaN(height)) {
	      if (aspect > containerWidth / containerHeight) {
	        width = containerWidth * 0.8;
	      } else {
	        height = containerHeight * 0.8;
	      }
	    } // Calculate width or height with given aspect
	
	
	    if (isNaN(width)) {
	      width = aspect * height;
	    }
	
	    if (isNaN(height)) {
	      height = width / aspect;
	    }
	  } // If left is not specified, calculate left from right and width
	
	
	  if (isNaN(left)) {
	    left = containerWidth - right - width - horizontalMargin;
	  }
	
	  if (isNaN(top)) {
	    top = containerHeight - bottom - height - verticalMargin;
	  } // Align left and top
	
	
	  switch (positionInfo.left || positionInfo.right) {
	    case 'center':
	      left = containerWidth / 2 - width / 2 - margin[3];
	      break;
	
	    case 'right':
	      left = containerWidth - width - horizontalMargin;
	      break;
	  }
	
	  switch (positionInfo.top || positionInfo.bottom) {
	    case 'middle':
	    case 'center':
	      top = containerHeight / 2 - height / 2 - margin[0];
	      break;
	
	    case 'bottom':
	      top = containerHeight - height - verticalMargin;
	      break;
	  } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	  left = left || 0;
	  top = top || 0;
	
	  if (isNaN(width)) {
	    // Width may be NaN if only one value is given except width
	    width = containerWidth - horizontalMargin - left - (right || 0);
	  }
	
	  if (isNaN(height)) {
	    // Height may be NaN if only one value is given except height
	    height = containerHeight - verticalMargin - top - (bottom || 0);
	  }
	
	  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	  rect.margin = margin;
	  return rect;
	}
	/**
	 * Position a zr element in viewport
	 *  Group position is specified by either
	 *  {left, top}, {right, bottom}
	 *  If all properties exists, right and bottom will be igonred.
	 *
	 * Logic:
	 *     1. Scale (against origin point in parent coord)
	 *     2. Rotate (against origin point in parent coord)
	 *     3. Traslate (with el.position by this method)
	 * So this method only fixes the last step 'Traslate', which does not affect
	 * scaling and rotating.
	 *
	 * If be called repeatly with the same input el, the same result will be gotten.
	 *
	 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
	 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
	 * @param {Object} containerRect
	 * @param {string|number} margin
	 * @param {Object} [opt]
	 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
	 * @param {Array.<number>} [opt.boundingMode='all']
	 *        Specify how to calculate boundingRect when locating.
	 *        'all': Position the boundingRect that is transformed and uioned
	 *               both itself and its descendants.
	 *               This mode simplies confine the elements in the bounding
	 *               of their container (e.g., using 'right: 0').
	 *        'raw': Position the boundingRect that is not transformed and only itself.
	 *               This mode is useful when you want a element can overflow its
	 *               container. (Consider a rotated circle needs to be located in a corner.)
	 *               In this mode positionInfo.width/height can only be number.
	 */
	
	
	function positionElement(el, positionInfo, containerRect, margin, opt) {
	  var h = !opt || !opt.hv || opt.hv[0];
	  var v = !opt || !opt.hv || opt.hv[1];
	  var boundingMode = opt && opt.boundingMode || 'all';
	
	  if (!h && !v) {
	    return;
	  }
	
	  var rect;
	
	  if (boundingMode === 'raw') {
	    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	  } else {
	    rect = el.getBoundingRect();
	
	    if (el.needLocalTransform()) {
	      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	      // which should not be modified.
	
	      rect = rect.clone();
	      rect.applyTransform(transform);
	    }
	  } // The real width and height can not be specified but calculated by the given el.
	
	
	  positionInfo = getLayoutRect(zrUtil.defaults({
	    width: rect.width,
	    height: rect.height
	  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	  // (see zrender/core/Transformable#getLocalTransform),
	  // we can just only modify el.position to get final result.
	
	  var elPos = el.position;
	  var dx = h ? positionInfo.x - rect.x : 0;
	  var dy = v ? positionInfo.y - rect.y : 0;
	  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
	}
	/**
	 * @param {Object} option Contains some of the properties in HV_NAMES.
	 * @param {number} hvIdx 0: horizontal; 1: vertical.
	 */
	
	
	function sizeCalculable(option, hvIdx) {
	  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	}
	/**
	 * Consider Case:
	 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
	 * through setOption or media query, using normal zrUtil.merge will cause
	 * {right: 0} does not take effect.
	 *
	 * @example
	 * ComponentModel.extend({
	 *     init: function () {
	 *         ...
	 *         var inputPositionParams = layout.getLayoutParams(option);
	 *         this.mergeOption(inputPositionParams);
	 *     },
	 *     mergeOption: function (newOption) {
	 *         newOption && zrUtil.merge(thisOption, newOption, true);
	 *         layout.mergeLayoutParam(thisOption, newOption);
	 *     }
	 * });
	 *
	 * @param {Object} targetOption
	 * @param {Object} newOption
	 * @param {Object|string} [opt]
	 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
	 *  that width (or height) should not be calculated by left and right (or top and bottom).
	 */
	
	
	function mergeLayoutParam(targetOption, newOption, opt) {
	  !zrUtil.isObject(opt) && (opt = {});
	  var ignoreSize = opt.ignoreSize;
	  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	  var hResult = merge(HV_NAMES[0], 0);
	  var vResult = merge(HV_NAMES[1], 1);
	  copy(HV_NAMES[0], targetOption, hResult);
	  copy(HV_NAMES[1], targetOption, vResult);
	
	  function merge(names, hvIdx) {
	    var newParams = {};
	    var newValueCount = 0;
	    var merged = {};
	    var mergedValueCount = 0;
	    var enoughParamNumber = 2;
	    each(names, function (name) {
	      merged[name] = targetOption[name];
	    });
	    each(names, function (name) {
	      // Consider case: newOption.width is null, which is
	      // set by user for removing width setting.
	      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	      hasValue(newParams, name) && newValueCount++;
	      hasValue(merged, name) && mergedValueCount++;
	    });
	
	    if (ignoreSize[hvIdx]) {
	      // Only one of left/right is premitted to exist.
	      if (hasValue(newOption, names[1])) {
	        merged[names[2]] = null;
	      } else if (hasValue(newOption, names[2])) {
	        merged[names[1]] = null;
	      }
	
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // or targetOption: {right: ...} and newOption: {width: ...},
	    // There is no conflict when merged only has params count
	    // little than enoughParamNumber.
	
	
	    if (mergedValueCount === enoughParamNumber || !newValueCount) {
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // Than we can make sure user only want those two, and ignore
	    // all origin params in targetOption.
	    else if (newValueCount >= enoughParamNumber) {
	        return newParams;
	      } else {
	        // Chose another param from targetOption by priority.
	        for (var i = 0; i < names.length; i++) {
	          var name = names[i];
	
	          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
	            newParams[name] = targetOption[name];
	            break;
	          }
	        }
	
	        return newParams;
	      }
	  }
	
	  function hasProp(obj, name) {
	    return obj.hasOwnProperty(name);
	  }
	
	  function hasValue(obj, name) {
	    return obj[name] != null && obj[name] !== 'auto';
	  }
	
	  function copy(names, target, source) {
	    each(names, function (name) {
	      target[name] = source[name];
	    });
	  }
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function getLayoutParams(source) {
	  return copyLayoutParams({}, source);
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function copyLayoutParams(target, source) {
	  source && target && each(LOCATION_PARAMS, function (name) {
	    source.hasOwnProperty(name) && (target[name] = source[name]);
	  });
	  return target;
	}
	
	exports.LOCATION_PARAMS = LOCATION_PARAMS;
	exports.HV_NAMES = HV_NAMES;
	exports.box = box;
	exports.vbox = vbox;
	exports.hbox = hbox;
	exports.getAvailableSize = getAvailableSize;
	exports.getLayoutRect = getLayoutRect;
	exports.positionElement = positionElement;
	exports.sizeCalculable = sizeCalculable;
	exports.mergeLayoutParam = mergeLayoutParam;
	exports.getLayoutParams = getLayoutParams;
	exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The method "quantile" was copied from "d3.js".
	* (See more details in the comment of the method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var RADIAN_EPSILON = 1e-4;
	
	function _trim(str) {
	  return str.replace(/^\s+/, '').replace(/\s+$/, '');
	}
	/**
	 * Linear mapping a value from domain to range
	 * @memberOf module:echarts/util/number
	 * @param  {(number|Array.<number>)} val
	 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
	 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
	 * @param  {boolean} clamp
	 * @return {(number|Array.<number>}
	 */
	
	
	function linearMap(val, domain, range, clamp) {
	  var subDomain = domain[1] - domain[0];
	  var subRange = range[1] - range[0];
	
	  if (subDomain === 0) {
	    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
	  } // Avoid accuracy problem in edge, such as
	  // 146.39 - 62.83 === 83.55999999999999.
	  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	  // It is a little verbose for efficiency considering this method
	  // is a hotspot.
	
	
	  if (clamp) {
	    if (subDomain > 0) {
	      if (val <= domain[0]) {
	        return range[0];
	      } else if (val >= domain[1]) {
	        return range[1];
	      }
	    } else {
	      if (val >= domain[0]) {
	        return range[0];
	      } else if (val <= domain[1]) {
	        return range[1];
	      }
	    }
	  } else {
	    if (val === domain[0]) {
	      return range[0];
	    }
	
	    if (val === domain[1]) {
	      return range[1];
	    }
	  }
	
	  return (val - domain[0]) / subDomain * subRange + range[0];
	}
	/**
	 * Convert a percent string to absolute number.
	 * Returns NaN if percent is not a valid string or number
	 * @memberOf module:echarts/util/number
	 * @param {string|number} percent
	 * @param {number} all
	 * @return {number}
	 */
	
	
	function parsePercent(percent, all) {
	  switch (percent) {
	    case 'center':
	    case 'middle':
	      percent = '50%';
	      break;
	
	    case 'left':
	    case 'top':
	      percent = '0%';
	      break;
	
	    case 'right':
	    case 'bottom':
	      percent = '100%';
	      break;
	  }
	
	  if (typeof percent === 'string') {
	    if (_trim(percent).match(/%$/)) {
	      return parseFloat(percent) / 100 * all;
	    }
	
	    return parseFloat(percent);
	  }
	
	  return percent == null ? NaN : +percent;
	}
	/**
	 * (1) Fix rounding error of float numbers.
	 * (2) Support return string to avoid scientific notation like '3.5e-7'.
	 *
	 * @param {number} x
	 * @param {number} [precision]
	 * @param {boolean} [returnStr]
	 * @return {number|string}
	 */
	
	
	function round(x, precision, returnStr) {
	  if (precision == null) {
	    precision = 10;
	  } // Avoid range error
	
	
	  precision = Math.min(Math.max(0, precision), 20);
	  x = (+x).toFixed(precision);
	  return returnStr ? x : +x;
	}
	
	function asc(arr) {
	  arr.sort(function (a, b) {
	    return a - b;
	  });
	  return arr;
	}
	/**
	 * Get precision
	 * @param {number} val
	 */
	
	
	function getPrecision(val) {
	  val = +val;
	
	  if (isNaN(val)) {
	    return 0;
	  } // It is much faster than methods converting number to string as follows
	  //      var tmp = val.toString();
	  //      return tmp.length - 1 - tmp.indexOf('.');
	  // especially when precision is low
	
	
	  var e = 1;
	  var count = 0;
	
	  while (Math.round(val * e) / e !== val) {
	    e *= 10;
	    count++;
	  }
	
	  return count;
	}
	/**
	 * @param {string|number} val
	 * @return {number}
	 */
	
	
	function getPrecisionSafe(val) {
	  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	  var eIndex = str.indexOf('e');
	
	  if (eIndex > 0) {
	    var precision = +str.slice(eIndex + 1);
	    return precision < 0 ? -precision : 0;
	  } else {
	    var dotIndex = str.indexOf('.');
	    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
	  }
	}
	/**
	 * Minimal dicernible data precisioin according to a single pixel.
	 *
	 * @param {Array.<number>} dataExtent
	 * @param {Array.<number>} pixelExtent
	 * @return {number} precision
	 */
	
	
	function getPixelPrecision(dataExtent, pixelExtent) {
	  var log = Math.log;
	  var LN10 = Math.LN10;
	  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	  return !isFinite(precision) ? 20 : precision;
	}
	/**
	 * Get a data of given precision, assuring the sum of percentages
	 * in valueList is 1.
	 * The largest remainer method is used.
	 * https://en.wikipedia.org/wiki/Largest_remainder_method
	 *
	 * @param {Array.<number>} valueList a list of all data
	 * @param {number} idx index of the data to be processed in valueList
	 * @param {number} precision integer number showing digits of precision
	 * @return {number} percent ranging from 0 to 100
	 */
	
	
	function getPercentWithPrecision(valueList, idx, precision) {
	  if (!valueList[idx]) {
	    return 0;
	  }
	
	  var sum = zrUtil.reduce(valueList, function (acc, val) {
	    return acc + (isNaN(val) ? 0 : val);
	  }, 0);
	
	  if (sum === 0) {
	    return 0;
	  }
	
	  var digits = Math.pow(10, precision);
	  var votesPerQuota = zrUtil.map(valueList, function (val) {
	    return (isNaN(val) ? 0 : val) / sum * digits * 100;
	  });
	  var targetSeats = digits * 100;
	  var seats = zrUtil.map(votesPerQuota, function (votes) {
	    // Assign automatic seats.
	    return Math.floor(votes);
	  });
	  var currentSum = zrUtil.reduce(seats, function (acc, val) {
	    return acc + val;
	  }, 0);
	  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
	    return votes - seats[idx];
	  }); // Has remainding votes.
	
	  while (currentSum < targetSeats) {
	    // Find next largest remainder.
	    var max = Number.NEGATIVE_INFINITY;
	    var maxId = null;
	
	    for (var i = 0, len = remainder.length; i < len; ++i) {
	      if (remainder[i] > max) {
	        max = remainder[i];
	        maxId = i;
	      }
	    } // Add a vote to max remainder.
	
	
	    ++seats[maxId];
	    remainder[maxId] = 0;
	    ++currentSum;
	  }
	
	  return seats[idx] / digits;
	} // Number.MAX_SAFE_INTEGER, ie do not support.
	
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	 * To 0 - 2 * PI, considering negative radian.
	 * @param {number} radian
	 * @return {number}
	 */
	
	function remRadian(radian) {
	  var pi2 = Math.PI * 2;
	  return (radian % pi2 + pi2) % pi2;
	}
	/**
	 * @param {type} radian
	 * @return {boolean}
	 */
	
	
	function isRadianAroundZero(val) {
	  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	}
	/* eslint-disable */
	
	
	var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	/* eslint-enable */
	
	/**
	 * @param {string|Date|number} value These values can be accepted:
	 *   + An instance of Date, represent a time in its own time zone.
	 *   + Or string in a subset of ISO 8601, only including:
	 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	 *     all of which will be treated as local time if time zone is not specified
	 *     (see <https://momentjs.com/>).
	 *   + Or other string format, including (all of which will be treated as loacal time):
	 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	 *   + a timestamp, which represent a time in UTC.
	 * @return {Date} date
	 */
	
	function parseDate(value) {
	  if (value instanceof Date) {
	    return value;
	  } else if (typeof value === 'string') {
	    // Different browsers parse date in different way, so we parse it manually.
	    // Some other issues:
	    // new Date('1970-01-01') is UTC,
	    // new Date('1970/01/01') and new Date('1970-1-01') is local.
	    // See issue #3623
	    var match = TIME_REG.exec(value);
	
	    if (!match) {
	      // return Invalid Date.
	      return new Date(NaN);
	    } // Use local time when no timezone offset specifed.
	
	
	    if (!match[8]) {
	      // match[n] can only be string or undefined.
	      // But take care of '12' + 1 => '121'.
	      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
	    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	    // For example, system timezone is set as "Time Zone: America/Toronto",
	    // then these code will get different result:
	    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	    // So we should not use `new Date`, but use `Date.UTC`.
	    else {
	        var hour = +match[4] || 0;
	
	        if (match[8].toUpperCase() !== 'Z') {
	          hour -= match[8].slice(0, 3);
	        }
	
	        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
	      }
	  } else if (value == null) {
	    return new Date(NaN);
	  }
	
	  return new Date(Math.round(value));
	}
	/**
	 * Quantity of a number. e.g. 0.1, 1, 10, 100
	 *
	 * @param  {number} val
	 * @return {number}
	 */
	
	
	function quantity(val) {
	  return Math.pow(10, quantityExponent(val));
	}
	
	function quantityExponent(val) {
	  return Math.floor(Math.log(val) / Math.LN10);
	}
	/**
	 * find a “nice” number approximately equal to x. Round the number if round = true,
	 * take ceiling if round = false. The primary observation is that the “nicest”
	 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	 *
	 * See "Nice Numbers for Graph Labels" of Graphic Gems.
	 *
	 * @param  {number} val Non-negative value.
	 * @param  {boolean} round
	 * @return {number}
	 */
	
	
	function nice(val, round) {
	  var exponent = quantityExponent(val);
	  var exp10 = Math.pow(10, exponent);
	  var f = val / exp10; // 1 <= f < 10
	
	  var nf;
	
	  if (round) {
	    if (f < 1.5) {
	      nf = 1;
	    } else if (f < 2.5) {
	      nf = 2;
	    } else if (f < 4) {
	      nf = 3;
	    } else if (f < 7) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  } else {
	    if (f < 1) {
	      nf = 1;
	    } else if (f < 2) {
	      nf = 2;
	    } else if (f < 3) {
	      nf = 3;
	    } else if (f < 5) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  }
	
	  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	  // 20 is the uppper bound of toFixed.
	
	  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	}
	/**
	 * This code was copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
	 * See the license statement at the head of this file.
	 * @param {Array.<number>} ascArr
	 */
	
	
	function quantile(ascArr, p) {
	  var H = (ascArr.length - 1) * p + 1;
	  var h = Math.floor(H);
	  var v = +ascArr[h - 1];
	  var e = H - h;
	  return e ? v + e * (ascArr[h] - v) : v;
	}
	/**
	 * Order intervals asc, and split them when overlap.
	 * expect(numberUtil.reformIntervals([
	 *     {interval: [18, 62], close: [1, 1]},
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [1, 1]},
	 *     {interval: [62, 150], close: [1, 1]},
	 *     {interval: [106, 150], close: [1, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ])).toEqual([
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [0, 1]},
	 *     {interval: [18, 62], close: [0, 1]},
	 *     {interval: [62, 150], close: [0, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ]);
	 * @param {Array.<Object>} list, where `close` mean open or close
	 *        of the interval, and Infinity can be used.
	 * @return {Array.<Object>} The origin list, which has been reformed.
	 */
	
	
	function reformIntervals(list) {
	  list.sort(function (a, b) {
	    return littleThan(a, b, 0) ? -1 : 1;
	  });
	  var curr = -Infinity;
	  var currClose = 1;
	
	  for (var i = 0; i < list.length;) {
	    var interval = list[i].interval;
	    var close = list[i].close;
	
	    for (var lg = 0; lg < 2; lg++) {
	      if (interval[lg] <= curr) {
	        interval[lg] = curr;
	        close[lg] = !lg ? 1 - currClose : 1;
	      }
	
	      curr = interval[lg];
	      currClose = close[lg];
	    }
	
	    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
	      list.splice(i, 1);
	    } else {
	      i++;
	    }
	  }
	
	  return list;
	
	  function littleThan(a, b, lg) {
	    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	  }
	}
	/**
	 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
	 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	 * subtraction forces infinities to NaN
	 *
	 * @param {*} v
	 * @return {boolean}
	 */
	
	
	function isNumeric(v) {
	  return v - parseFloat(v) >= 0;
	}
	
	exports.linearMap = linearMap;
	exports.parsePercent = parsePercent;
	exports.round = round;
	exports.asc = asc;
	exports.getPrecision = getPrecision;
	exports.getPrecisionSafe = getPrecisionSafe;
	exports.getPixelPrecision = getPixelPrecision;
	exports.getPercentWithPrecision = getPercentWithPrecision;
	exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
	exports.remRadian = remRadian;
	exports.isRadianAroundZero = isRadianAroundZero;
	exports.parseDate = parseDate;
	exports.quantity = quantity;
	exports.nice = nice;
	exports.quantile = quantile;
	exports.reformIntervals = reformIntervals;
	exports.isNumeric = isNumeric;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var textContain = __webpack_require__(167);
	
	var numberUtil = __webpack_require__(218);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Text from 'zrender/src/graphic/Text';
	
	/**
	 * 每三位默认加,格式化
	 * @param {string|number} x
	 * @return {string}
	 */
	function addCommas(x) {
	  if (isNaN(x)) {
	    return '-';
	  }
	
	  x = (x + '').split('.');
	  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
	}
	/**
	 * @param {string} str
	 * @param {boolean} [upperCaseFirst=false]
	 * @return {string} str
	 */
	
	
	function toCamelCase(str, upperCaseFirst) {
	  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	
	  if (upperCaseFirst && str) {
	    str = str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  return str;
	}
	
	var normalizeCssArray = zrUtil.normalizeCssArray;
	var replaceReg = /([&<>"'])/g;
	var replaceMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#39;'
	};
	
	function encodeHTML(source) {
	  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
	    return replaceMap[c];
	  });
	}
	
	var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	var wrapVar = function (varName, seriesIdx) {
	  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	};
	/**
	 * Template formatter
	 * @param {string} tpl
	 * @param {Array.<Object>|Object} paramsList
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTpl(tpl, paramsList, encode) {
	  if (!zrUtil.isArray(paramsList)) {
	    paramsList = [paramsList];
	  }
	
	  var seriesLen = paramsList.length;
	
	  if (!seriesLen) {
	    return '';
	  }
	
	  var $vars = paramsList[0].$vars || [];
	
	  for (var i = 0; i < $vars.length; i++) {
	    var alias = TPL_VAR_ALIAS[i];
	    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
	  }
	
	  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	    for (var k = 0; k < $vars.length; k++) {
	      var val = paramsList[seriesIdx][$vars[k]];
	      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	    }
	  }
	
	  return tpl;
	}
	/**
	 * simple Template formatter
	 *
	 * @param {string} tpl
	 * @param {Object} param
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTplSimple(tpl, param, encode) {
	  zrUtil.each(param, function (value, key) {
	    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	  });
	  return tpl;
	}
	/**
	 * @param {Object|string} [opt] If string, means color.
	 * @param {string} [opt.color]
	 * @param {string} [opt.extraCssText]
	 * @param {string} [opt.type='item'] 'item' or 'subItem'
	 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
	 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
	 * @return {string}
	 */
	
	
	function getTooltipMarker(opt, extraCssText) {
	  opt = zrUtil.isString(opt) ? {
	    color: opt,
	    extraCssText: extraCssText
	  } : opt || {};
	  var color = opt.color;
	  var type = opt.type;
	  var extraCssText = opt.extraCssText;
	  var renderMode = opt.renderMode || 'html';
	  var markerId = opt.markerId || 'X';
	
	  if (!color) {
	    return '';
	  }
	
	  if (renderMode === 'html') {
	    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
	  } else {
	    // Space for rich element marker
	    return {
	      renderMode: renderMode,
	      content: '{marker' + markerId + '|}  ',
	      style: {
	        color: color
	      }
	    };
	  }
	}
	
	function pad(str, len) {
	  str += '';
	  return '0000'.substr(0, len - str.length) + str;
	}
	/**
	 * ISO Date format
	 * @param {string} tpl
	 * @param {number} value
	 * @param {boolean} [isUTC=false] Default in local time.
	 *           see `module:echarts/scale/Time`
	 *           and `module:echarts/util/number#parseDate`.
	 * @inner
	 */
	
	
	function formatTime(tpl, value, isUTC) {
	  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	    tpl = 'MM-dd\nyyyy';
	  }
	
	  var date = numberUtil.parseDate(value);
	  var utc = isUTC ? 'UTC' : '';
	  var y = date['get' + utc + 'FullYear']();
	  var M = date['get' + utc + 'Month']() + 1;
	  var d = date['get' + utc + 'Date']();
	  var h = date['get' + utc + 'Hours']();
	  var m = date['get' + utc + 'Minutes']();
	  var s = date['get' + utc + 'Seconds']();
	  var S = date['get' + utc + 'Milliseconds']();
	  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
	  return tpl;
	}
	/**
	 * Capital first
	 * @param {string} str
	 * @return {string}
	 */
	
	
	function capitalFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	}
	
	var truncateText = textContain.truncateText;
	/**
	 * @public
	 * @param {Object} opt
	 * @param {string} opt.text
	 * @param {string} opt.font
	 * @param {string} [opt.textAlign='left']
	 * @param {string} [opt.textVerticalAlign='top']
	 * @param {Array.<number>} [opt.textPadding]
	 * @param {number} [opt.textLineHeight]
	 * @param {Object} [opt.rich]
	 * @param {Object} [opt.truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	function getTextBoundingRect(opt) {
	  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
	}
	/**
	 * @deprecated
	 * the `textLineHeight` was added later.
	 * For backward compatiblility, put it as the last parameter.
	 * But deprecated this interface. Please use `getTextBoundingRect` instead.
	 */
	
	
	function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
	  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
	}
	
	exports.addCommas = addCommas;
	exports.toCamelCase = toCamelCase;
	exports.normalizeCssArray = normalizeCssArray;
	exports.encodeHTML = encodeHTML;
	exports.formatTpl = formatTpl;
	exports.formatTplSimple = formatTplSimple;
	exports.getTooltipMarker = getTooltipMarker;
	exports.formatTime = formatTime;
	exports.capitalFirst = capitalFirst;
	exports.truncateText = truncateText;
	exports.getTextBoundingRect = getTextBoundingRect;
	exports.getTextRect = getTextRect;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  getBoxLayoutParams: function () {
	    return {
	      left: this.get('left'),
	      top: this.get('top'),
	      right: this.get('right'),
	      bottom: this.get('bottom'),
	      width: this.get('width'),
	      height: this.get('height')
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var platform = ''; // Navigator not exists in node
	
	if (typeof navigator !== 'undefined') {
	  platform = navigator.platform || '';
	}
	
	var _default = {
	  // backgroundColor: 'rgba(0,0,0,0)',
	  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
	  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
	  // Light colors:
	  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
	  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
	  // Dark colors:
	  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
	  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
	  // If xAxis and yAxis declared, grid is created by default.
	  // grid: {},
	  textStyle: {
	    // color: '#000',
	    // decoration: 'none',
	    // PENDING
	    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	    // fontFamily: 'Arial, Verdana, sans-serif',
	    fontSize: 12,
	    fontStyle: 'normal',
	    fontWeight: 'normal'
	  },
	  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	  // Default is source-over
	  blendMode: null,
	  animation: 'auto',
	  animationDuration: 1000,
	  animationDurationUpdate: 300,
	  animationEasing: 'exponentialOut',
	  animationEasingUpdate: 'cubicOut',
	  animationThreshold: 2000,
	  // Configuration for progressive/incremental rendering
	  progressiveThreshold: 3000,
	  progressive: 400,
	  // Threshold of if use single hover layer to optimize.
	  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	  // which is unexpected.
	  // see example <echarts/test/heatmap-large.html>.
	  hoverLayerThreshold: 3000,
	  // See: module:echarts/scale/Time
	  useUTC: false
	};
	module.exports = _default;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function getNearestColorPalette(colors, requestColorNum) {
	  var paletteNum = colors.length; // TODO colors must be in order
	
	  for (var i = 0; i < paletteNum; i++) {
	    if (colors[i].length > requestColorNum) {
	      return colors[i];
	    }
	  }
	
	  return colors[paletteNum - 1];
	}
	
	var _default = {
	  clearColorPalette: function () {
	    inner(this).colorIdx = 0;
	    inner(this).colorNameMap = {};
	  },
	
	  /**
	   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
	   *                 twise with the same parameters will get different result.
	   * @param {Object} [scope=this]
	   * @param {Object} [requestColorNum]
	   * @return {string} color string.
	   */
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    scope = scope || this;
	    var scopeFields = inner(scope);
	    var colorIdx = scopeFields.colorIdx || 0;
	    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	    if (colorNameMap.hasOwnProperty(name)) {
	      return colorNameMap[name];
	    }
	
	    var defaultColorPalette = normalizeToArray(this.get('color', true));
	    var layeredColorPalette = this.get('colorLayer', true);
	    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.
	
	    colorPalette = colorPalette || defaultColorPalette;
	
	    if (!colorPalette || !colorPalette.length) {
	      return;
	    }
	
	    var color = colorPalette[colorIdx];
	
	    if (name) {
	      colorNameMap[name] = color;
	    }
	
	    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
	    return color;
	  }
	};
	module.exports = _default;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	var getDataItemValue = _model.getDataItemValue;
	
	var _referHelper = __webpack_require__(224);
	
	var getCoordSysDefineBySeries = _referHelper.getCoordSysDefineBySeries;
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var map = _util.map;
	var isArray = _util.isArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	var isTypedArray = _util.isTypedArray;
	var isArrayLike = _util.isArrayLike;
	var extend = _util.extend;
	var assert = _util.assert;
	
	var Source = __webpack_require__(225);
	
	var _sourceType = __webpack_require__(226);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	/**
	 * @see {module:echarts/data/Source}
	 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
	 * @return {string} sourceFormat
	 */
	
	function detectSourceFormat(datasetModel) {
	  var data = datasetModel.option.source;
	  var sourceFormat = SOURCE_FORMAT_UNKNOWN;
	
	  if (isTypedArray(data)) {
	    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
	  } else if (isArray(data)) {
	    // FIXME Whether tolerate null in top level array?
	    if (data.length === 0) {
	      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	    }
	
	    for (var i = 0, len = data.length; i < len; i++) {
	      var item = data[i];
	
	      if (item == null) {
	        continue;
	      } else if (isArray(item)) {
	        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	        break;
	      } else if (isObject(item)) {
	        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
	        break;
	      }
	    }
	  } else if (isObject(data)) {
	    for (var key in data) {
	      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
	        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
	        break;
	      }
	    }
	  } else if (data != null) {
	    throw new Error('Invalid data');
	  }
	
	  inner(datasetModel).sourceFormat = sourceFormat;
	}
	/**
	 * [Scenarios]:
	 * (1) Provide source data directly:
	 *     series: {
	 *         encode: {...},
	 *         dimensions: [...]
	 *         seriesLayoutBy: 'row',
	 *         data: [[...]]
	 *     }
	 * (2) Refer to datasetModel.
	 *     series: [{
	 *         encode: {...}
	 *         // Ignore datasetIndex means `datasetIndex: 0`
	 *         // and the dimensions defination in dataset is used
	 *     }, {
	 *         encode: {...},
	 *         seriesLayoutBy: 'column',
	 *         datasetIndex: 1
	 *     }]
	 *
	 * Get data from series itself or datset.
	 * @return {module:echarts/data/Source} source
	 */
	
	
	function getSource(seriesModel) {
	  return inner(seriesModel).source;
	}
	/**
	 * MUST be called before mergeOption of all series.
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function resetSourceDefaulter(ecModel) {
	  // `datasetMap` is used to make default encode.
	  inner(ecModel).datasetMap = createHashMap();
	}
	/**
	 * [Caution]:
	 * MUST be called after series option merged and
	 * before "series.getInitailData()" called.
	 *
	 * [The rule of making default encode]:
	 * Category axis (if exists) alway map to the first dimension.
	 * Each other axis occupies a subsequent dimension.
	 *
	 * [Why make default encode]:
	 * Simplify the typing of encode in option, avoiding the case like that:
	 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
	 * where the "y" have to be manually typed as "1, 2, 3, ...".
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 */
	
	
	function prepareSource(seriesModel) {
	  var seriesOption = seriesModel.option;
	  var data = seriesOption.data;
	  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
	  var fromDataset = false;
	  var seriesLayoutBy = seriesOption.seriesLayoutBy;
	  var sourceHeader = seriesOption.sourceHeader;
	  var dimensionsDefine = seriesOption.dimensions;
	  var datasetModel = getDatasetModel(seriesModel);
	
	  if (datasetModel) {
	    var datasetOption = datasetModel.option;
	    data = datasetOption.source;
	    sourceFormat = inner(datasetModel).sourceFormat;
	    fromDataset = true; // These settings from series has higher priority.
	
	    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
	    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
	    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
	  }
	
	  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine); // Note: dataset option does not have `encode`.
	
	  var encodeDefine = seriesOption.encode;
	
	  if (!encodeDefine && datasetModel) {
	    encodeDefine = makeDefaultEncode(seriesModel, datasetModel, data, sourceFormat, seriesLayoutBy, completeResult);
	  }
	
	  inner(seriesModel).source = new Source({
	    data: data,
	    fromDataset: fromDataset,
	    seriesLayoutBy: seriesLayoutBy,
	    sourceFormat: sourceFormat,
	    dimensionsDefine: completeResult.dimensionsDefine,
	    startIndex: completeResult.startIndex,
	    dimensionsDetectCount: completeResult.dimensionsDetectCount,
	    encodeDefine: encodeDefine
	  });
	} // return {startIndex, dimensionsDefine, dimensionsCount}
	
	
	function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
	  if (!data) {
	    return {
	      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
	    };
	  }
	
	  var dimensionsDetectCount;
	  var startIndex;
	  var findPotentialName;
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    // Rule: Most of the first line are string: it is header.
	    // Caution: consider a line with 5 string and 1 number,
	    // it still can not be sure it is a head, because the
	    // 5 string may be 5 values of category columns.
	    if (sourceHeader === 'auto' || sourceHeader == null) {
	      arrayRowsTravelFirst(function (val) {
	        // '-' is regarded as null/undefined.
	        if (val != null && val !== '-') {
	          if (isString(val)) {
	            startIndex == null && (startIndex = 1);
	          } else {
	            startIndex = 0;
	          }
	        } // 10 is an experience number, avoid long loop.
	
	      }, seriesLayoutBy, data, 10);
	    } else {
	      startIndex = sourceHeader ? 1 : 0;
	    }
	
	    if (!dimensionsDefine && startIndex === 1) {
	      dimensionsDefine = [];
	      arrayRowsTravelFirst(function (val, index) {
	        dimensionsDefine[index] = val != null ? val : '';
	      }, seriesLayoutBy, data);
	    }
	
	    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = objectRowsCollectDimensions(data);
	      findPotentialName = true;
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = [];
	      findPotentialName = true;
	      each(data, function (colArr, key) {
	        dimensionsDefine.push(key);
	      });
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var value0 = getDataItemValue(data[0]);
	    dimensionsDetectCount = isArray(value0) && value0.length || 1;
	  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}
	
	  var potentialNameDimIndex;
	
	  if (findPotentialName) {
	    each(dimensionsDefine, function (dim, idx) {
	      if ((isObject(dim) ? dim.name : dim) === 'name') {
	        potentialNameDimIndex = idx;
	      }
	    });
	  }
	
	  return {
	    startIndex: startIndex,
	    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
	    dimensionsDetectCount: dimensionsDetectCount,
	    potentialNameDimIndex: potentialNameDimIndex // TODO: potentialIdDimIdx
	
	  };
	} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
	// which is reasonable. But dimension name is duplicated.
	// Returns undefined or an array contains only object without null/undefiend or string.
	
	
	function normalizeDimensionsDefine(dimensionsDefine) {
	  if (!dimensionsDefine) {
	    // The meaning of null/undefined is different from empty array.
	    return;
	  }
	
	  var nameMap = createHashMap();
	  return map(dimensionsDefine, function (item, index) {
	    item = extend({}, isObject(item) ? item : {
	      name: item
	    }); // User can set null in dimensions.
	    // We dont auto specify name, othewise a given name may
	    // cause it be refered unexpectedly.
	
	    if (item.name == null) {
	      return item;
	    } // Also consider number form like 2012.
	
	
	    item.name += ''; // User may also specify displayName.
	    // displayName will always exists except user not
	    // specified or dim name is not specified or detected.
	    // (A auto generated dim name will not be used as
	    // displayName).
	
	    if (item.displayName == null) {
	      item.displayName = item.name;
	    }
	
	    var exist = nameMap.get(item.name);
	
	    if (!exist) {
	      nameMap.set(item.name, {
	        count: 1
	      });
	    } else {
	      item.name += '-' + exist.count++;
	    }
	
	    return item;
	  });
	}
	
	function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
	  maxLoop == null && (maxLoop = Infinity);
	
	  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      cb(data[i] ? data[i][0] : null, i);
	    }
	  } else {
	    var value0 = data[0] || [];
	
	    for (var i = 0; i < value0.length && i < maxLoop; i++) {
	      cb(value0[i], i);
	    }
	  }
	}
	
	function objectRowsCollectDimensions(data) {
	  var firstIndex = 0;
	  var obj;
	
	  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line
	
	
	  if (obj) {
	    var dimensions = [];
	    each(obj, function (value, key) {
	      dimensions.push(key);
	    });
	    return dimensions;
	  }
	} // ??? TODO merge to completedimensions, where also has
	// default encode making logic. And the default rule
	// should depends on series? consider 'map'.
	
	
	function makeDefaultEncode(seriesModel, datasetModel, data, sourceFormat, seriesLayoutBy, completeResult) {
	  var coordSysDefine = getCoordSysDefineBySeries(seriesModel);
	  var encode = {}; // var encodeTooltip = [];
	  // var encodeLabel = [];
	
	  var encodeItemName = [];
	  var encodeSeriesName = [];
	  var seriesType = seriesModel.subType; // ??? TODO refactor: provide by series itself.
	  // Consider the case: 'map' series is based on geo coordSys,
	  // 'graph', 'heatmap' can be based on cartesian. But can not
	  // give default rule simply here.
	
	  var nSeriesMap = createHashMap(['pie', 'map', 'funnel']);
	  var cSeriesMap = createHashMap(['line', 'bar', 'pictorialBar', 'scatter', 'effectScatter', 'candlestick', 'boxplot']); // Usually in this case series will use the first data
	  // dimension as the "value" dimension, or other default
	  // processes respectively.
	
	  if (coordSysDefine && cSeriesMap.get(seriesType) != null) {
	    var ecModel = seriesModel.ecModel;
	    var datasetMap = inner(ecModel).datasetMap;
	    var key = datasetModel.uid + '_' + seriesLayoutBy;
	    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
	      categoryWayDim: 1,
	      valueWayDim: 0
	    }); // TODO
	    // Auto detect first time axis and do arrangement.
	
	    each(coordSysDefine.coordSysDims, function (coordDim) {
	      // In value way.
	      if (coordSysDefine.firstCategoryDimIndex == null) {
	        var dataDim = datasetRecord.valueWayDim++;
	        encode[coordDim] = dataDim; // ??? TODO give a better default series name rule?
	        // especially when encode x y specified.
	        // consider: when mutiple series share one dimension
	        // category axis, series name should better use
	        // the other dimsion name. On the other hand, use
	        // both dimensions name.
	
	        encodeSeriesName.push(dataDim); // encodeTooltip.push(dataDim);
	        // encodeLabel.push(dataDim);
	      } // In category way, category axis.
	      else if (coordSysDefine.categoryAxisMap.get(coordDim)) {
	          encode[coordDim] = 0;
	          encodeItemName.push(0);
	        } // In category way, non-category axis.
	        else {
	            var dataDim = datasetRecord.categoryWayDim++;
	            encode[coordDim] = dataDim; // encodeTooltip.push(dataDim);
	            // encodeLabel.push(dataDim);
	
	            encodeSeriesName.push(dataDim);
	          }
	    });
	  } // Do not make a complex rule! Hard to code maintain and not necessary.
	  // ??? TODO refactor: provide by series itself.
	  // [{name: ..., value: ...}, ...] like:
	  else if (nSeriesMap.get(seriesType) != null) {
	      // Find the first not ordinal. (5 is an experience value)
	      var firstNotOrdinal;
	
	      for (var i = 0; i < 5 && firstNotOrdinal == null; i++) {
	        if (!doGuessOrdinal(data, sourceFormat, seriesLayoutBy, completeResult.dimensionsDefine, completeResult.startIndex, i)) {
	          firstNotOrdinal = i;
	        }
	      }
	
	      if (firstNotOrdinal != null) {
	        encode.value = firstNotOrdinal;
	        var nameDimIndex = completeResult.potentialNameDimIndex || Math.max(firstNotOrdinal - 1, 0); // By default, label use itemName in charts.
	        // So we dont set encodeLabel here.
	
	        encodeSeriesName.push(nameDimIndex);
	        encodeItemName.push(nameDimIndex); // encodeTooltip.push(firstNotOrdinal);
	      }
	    } // encodeTooltip.length && (encode.tooltip = encodeTooltip);
	  // encodeLabel.length && (encode.label = encodeLabel);
	
	
	  encodeItemName.length && (encode.itemName = encodeItemName);
	  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
	  return encode;
	}
	/**
	 * If return null/undefined, indicate that should not use datasetModel.
	 */
	
	
	function getDatasetModel(seriesModel) {
	  var option = seriesModel.option; // Caution: consider the scenario:
	  // A dataset is declared and a series is not expected to use the dataset,
	  // and at the beginning `setOption({series: { noData })` (just prepare other
	  // option but no data), then `setOption({series: {data: [...]}); In this case,
	  // the user should set an empty array to avoid that dataset is used by default.
	
	  var thisData = option.data;
	
	  if (!thisData) {
	    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
	  }
	}
	/**
	 * The rule should not be complex, otherwise user might not
	 * be able to known where the data is wrong.
	 * The code is ugly, but how to make it neat?
	 *
	 * @param {module:echars/data/Source} source
	 * @param {number} dimIndex
	 * @return {boolean} Whether ordinal.
	 */
	
	
	function guessOrdinal(source, dimIndex) {
	  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
	} // dimIndex may be overflow source data.
	
	
	function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
	  var result; // Experience value.
	
	  var maxLoop = 5;
	
	  if (isTypedArray(data)) {
	    return false;
	  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
	  // always exists in source.
	
	
	  var dimName;
	
	  if (dimensionsDefine) {
	    dimName = dimensionsDefine[dimIndex];
	    dimName = isObject(dimName) ? dimName.name : dimName;
	  }
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	      var sample = data[dimIndex];
	
	      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
	        if ((result = detectValue(sample[startIndex + i])) != null) {
	          return result;
	        }
	      }
	    } else {
	      for (var i = 0; i < data.length && i < maxLoop; i++) {
	        var row = data[startIndex + i];
	
	        if (row && (result = detectValue(row[dimIndex])) != null) {
	          return result;
	        }
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimName) {
	      return;
	    }
	
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	
	      if (item && (result = detectValue(item[dimName])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimName) {
	      return;
	    }
	
	    var sample = data[dimName];
	
	    if (!sample || isTypedArray(sample)) {
	      return false;
	    }
	
	    for (var i = 0; i < sample.length && i < maxLoop; i++) {
	      if ((result = detectValue(sample[i])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	      var val = getDataItemValue(item);
	
	      if (!isArray(val)) {
	        return false;
	      }
	
	      if ((result = detectValue(val[dimIndex])) != null) {
	        return result;
	      }
	    }
	  }
	
	  function detectValue(val) {
	    // Consider usage convenience, '1', '2' will be treated as "number".
	    // `isFinit('')` get `true`.
	    if (val != null && isFinite(val) && val !== '') {
	      return false;
	    } else if (isString(val) && val !== '-') {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	exports.detectSourceFormat = detectSourceFormat;
	exports.getSource = getSource;
	exports.resetSourceDefaulter = resetSourceDefaulter;
	exports.prepareSource = prepareSource;
	exports.guessOrdinal = guessOrdinal;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var retrieve = _util.retrieve;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Helper for model references.
	 * There are many manners to refer axis/coordSys.
	 */
	// TODO
	// merge relevant logic to this file?
	// check: "modelHelper" of tooltip and "BrushTargetManager".
	
	/**
	 * @return {Object} For example:
	 * {
	 *     coordSysName: 'cartesian2d',
	 *     coordSysDims: ['x', 'y', ...],
	 *     axisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: yAxisModel
	 *     }),
	 *     categoryAxisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: undefined
	 *     }),
	 *     // It also indicate that whether there is category axis.
	 *     firstCategoryDimIndex: 1,
	 *     // To replace user specified encode.
	 * }
	 */
	function getCoordSysDefineBySeries(seriesModel) {
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var result = {
	    coordSysName: coordSysName,
	    coordSysDims: [],
	    axisMap: createHashMap(),
	    categoryAxisMap: createHashMap()
	  };
	  var fetch = fetchers[coordSysName];
	
	  if (fetch) {
	    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
	    return result;
	  }
	}
	
	var fetchers = {
	  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
	    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
	    result.coordSysDims = ['x', 'y'];
	    axisMap.set('x', xAxisModel);
	    axisMap.set('y', yAxisModel);
	
	    if (isCategory(xAxisModel)) {
	      categoryAxisMap.set('x', xAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(yAxisModel)) {
	      categoryAxisMap.set('y', yAxisModel);
	      result.firstCategoryDimIndex = 1;
	    }
	  },
	  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
	    result.coordSysDims = ['single'];
	    axisMap.set('single', singleAxisModel);
	
	    if (isCategory(singleAxisModel)) {
	      categoryAxisMap.set('single', singleAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	  },
	  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var polarModel = seriesModel.getReferringComponents('polar')[0];
	    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	    var angleAxisModel = polarModel.findAxisModel('angleAxis');
	    result.coordSysDims = ['radius', 'angle'];
	    axisMap.set('radius', radiusAxisModel);
	    axisMap.set('angle', angleAxisModel);
	
	    if (isCategory(radiusAxisModel)) {
	      categoryAxisMap.set('radius', radiusAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(angleAxisModel)) {
	      categoryAxisMap.set('angle', angleAxisModel);
	      result.firstCategoryDimIndex = 1;
	    }
	  },
	  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
	    result.coordSysDims = ['lng', 'lat'];
	  },
	  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var ecModel = seriesModel.ecModel;
	    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
	    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	      var axisDim = coordSysDims[index];
	      axisMap.set(axisDim, axisModel);
	
	      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
	        categoryAxisMap.set(axisDim, axisModel);
	        result.firstCategoryDimIndex = index;
	      }
	    });
	  }
	};
	
	function isCategory(axisModel) {
	  return axisModel.get('type') === 'category';
	}
	
	exports.getCoordSysDefineBySeries = getCoordSysDefineBySeries;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var isTypedArray = _util.isTypedArray;
	
	var _clazz = __webpack_require__(175);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	var _sourceType = __webpack_require__(226);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [sourceFormat]
	 *
	 * + "original":
	 * This format is only used in series.data, where
	 * itemStyle can be specified in data item.
	 *
	 * + "arrayRows":
	 * [
	 *     ['product', 'score', 'amount'],
	 *     ['Matcha Latte', 89.3, 95.8],
	 *     ['Milk Tea', 92.1, 89.4],
	 *     ['Cheese Cocoa', 94.4, 91.2],
	 *     ['Walnut Brownie', 85.4, 76.9]
	 * ]
	 *
	 * + "objectRows":
	 * [
	 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
	 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
	 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
	 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
	 * ]
	 *
	 * + "keyedColumns":
	 * {
	 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
	 *     'count': [823, 235, 1042, 988],
	 *     'score': [95.8, 81.4, 91.2, 76.9]
	 * }
	 *
	 * + "typedArray"
	 *
	 * + "unknown"
	 */
	
	/**
	 * @constructor
	 * @param {Object} fields
	 * @param {string} fields.sourceFormat
	 * @param {Array|Object} fields.fromDataset
	 * @param {Array|Object} [fields.data]
	 * @param {string} [seriesLayoutBy='column']
	 * @param {Array.<Object|string>} [dimensionsDefine]
	 * @param {Objet|HashMap} [encodeDefine]
	 * @param {number} [startIndex=0]
	 * @param {number} [dimensionsDetectCount]
	 */
	function Source(fields) {
	  /**
	   * @type {boolean}
	   */
	  this.fromDataset = fields.fromDataset;
	  /**
	   * Not null/undefined.
	   * @type {Array|Object}
	   */
	
	  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
	  /**
	   * See also "detectSourceFormat".
	   * Not null/undefined.
	   * @type {string}
	   */
	
	  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
	  /**
	   * 'row' or 'column'
	   * Not null/undefined.
	   * @type {string} seriesLayoutBy
	   */
	
	  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
	  /**
	   * dimensions definition in option.
	   * can be null/undefined.
	   * @type {Array.<Object|string>}
	   */
	
	  this.dimensionsDefine = fields.dimensionsDefine;
	  /**
	   * encode definition in option.
	   * can be null/undefined.
	   * @type {Objet|HashMap}
	   */
	
	  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
	  /**
	   * Not null/undefined, uint.
	   * @type {number}
	   */
	
	  this.startIndex = fields.startIndex || 0;
	  /**
	   * Can be null/undefined (when unknown), uint.
	   * @type {number}
	   */
	
	  this.dimensionsDetectCount = fields.dimensionsDetectCount;
	}
	/**
	 * Wrap original series data for some compatibility cases.
	 */
	
	
	Source.seriesDataToSource = function (data) {
	  return new Source({
	    data: data,
	    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
	    fromDataset: false
	  });
	};
	
	enableClassCheck(Source);
	var _default = Source;
	module.exports = _default;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Avoid typo.
	var SOURCE_FORMAT_ORIGINAL = 'original';
	var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
	var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
	var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
	var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME
	
	var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
	var SERIES_LAYOUT_BY_COLUMN = 'column';
	var SERIES_LAYOUT_BY_ROW = 'row';
	exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
	exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
	exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
	exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
	exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
	exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
	exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
	exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
	
	function ExtensionAPI(chartInstance) {
	  zrUtil.each(echartsAPIList, function (name) {
	    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
	  }, this);
	}
	
	var _default = ExtensionAPI;
	module.exports = _default;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordinateSystemCreators = {};
	
	function CoordinateSystemManager() {
	  this._coordinateSystems = [];
	}
	
	CoordinateSystemManager.prototype = {
	  constructor: CoordinateSystemManager,
	  create: function (ecModel, api) {
	    var coordinateSystems = [];
	    zrUtil.each(coordinateSystemCreators, function (creater, type) {
	      var list = creater.create(ecModel, api);
	      coordinateSystems = coordinateSystems.concat(list || []);
	    });
	    this._coordinateSystems = coordinateSystems;
	  },
	  update: function (ecModel, api) {
	    zrUtil.each(this._coordinateSystems, function (coordSys) {
	      coordSys.update && coordSys.update(ecModel, api);
	    });
	  },
	  getCoordinateSystems: function () {
	    return this._coordinateSystems.slice();
	  }
	};
	
	CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
	  coordinateSystemCreators[type] = coordinateSystemCreator;
	};
	
	CoordinateSystemManager.get = function (type) {
	  return coordinateSystemCreators[type];
	};
	
	var _default = CoordinateSystemManager;
	module.exports = _default;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	var ComponentModel = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts option manager
	 *
	 * @module {echarts/model/OptionManager}
	 */
	var each = zrUtil.each;
	var clone = zrUtil.clone;
	var map = zrUtil.map;
	var merge = zrUtil.merge;
	var QUERY_REG = /^(min|max)?(.+)$/;
	/**
	 * TERM EXPLANATIONS:
	 *
	 * [option]:
	 *
	 *     An object that contains definitions of components. For example:
	 *     var option = {
	 *         title: {...},
	 *         legend: {...},
	 *         visualMap: {...},
	 *         series: [
	 *             {data: [...]},
	 *             {data: [...]},
	 *             ...
	 *         ]
	 *     };
	 *
	 * [rawOption]:
	 *
	 *     An object input to echarts.setOption. 'rawOption' may be an
	 *     'option', or may be an object contains multi-options. For example:
	 *     var option = {
	 *         baseOption: {
	 *             title: {...},
	 *             legend: {...},
	 *             series: [
	 *                 {data: [...]},
	 *                 {data: [...]},
	 *                 ...
	 *             ]
	 *         },
	 *         timeline: {...},
	 *         options: [
	 *             {title: {...}, series: {data: [...]}},
	 *             {title: {...}, series: {data: [...]}},
	 *             ...
	 *         ],
	 *         media: [
	 *             {
	 *                 query: {maxWidth: 320},
	 *                 option: {series: {x: 20}, visualMap: {show: false}}
	 *             },
	 *             {
	 *                 query: {minWidth: 320, maxWidth: 720},
	 *                 option: {series: {x: 500}, visualMap: {show: true}}
	 *             },
	 *             {
	 *                 option: {series: {x: 1200}, visualMap: {show: true}}
	 *             }
	 *         ]
	 *     };
	 *
	 * @alias module:echarts/model/OptionManager
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	function OptionManager(api) {
	  /**
	   * @private
	   * @type {module:echarts/ExtensionAPI}
	   */
	  this._api = api;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._timelineOptions = [];
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	
	  this._mediaList = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._mediaDefault;
	  /**
	   * -1, means default.
	   * empty means no media.
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._currentMediaIndices = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._optionBackup;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._newBaseOption;
	} // timeline.notMerge is not supported in ec3. Firstly there is rearly
	// case that notMerge is needed. Secondly supporting 'notMerge' requires
	// rawOption cloned and backuped when timeline changed, which does no
	// good to performance. What's more, that both timeline and setOption
	// method supply 'notMerge' brings complex and some problems.
	// Consider this case:
	// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	
	
	OptionManager.prototype = {
	  constructor: OptionManager,
	
	  /**
	   * @public
	   * @param {Object} rawOption Raw option.
	   * @param {module:echarts/model/Global} ecModel
	   * @param {Array.<Function>} optionPreprocessorFuncs
	   * @return {Object} Init option
	   */
	  setOption: function (rawOption, optionPreprocessorFuncs) {
	    if (rawOption) {
	      // That set dat primitive is dangerous if user reuse the data when setOption again.
	      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
	        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
	      });
	    } // Caution: some series modify option data, if do not clone,
	    // it should ensure that the repeat modify correctly
	    // (create a new object when modify itself).
	
	
	    rawOption = clone(rawOption, true); // FIXME
	    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
	
	    var oldOptionBackup = this._optionBackup;
	    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
	    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	    if (oldOptionBackup) {
	      // Only baseOption can be merged.
	      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
	      // that is, if you `setOption` twice and both has timeline options, the latter
	      // timeline opitons will not be merged to the formers, but just substitude them.
	
	      if (newParsedOption.timelineOptions.length) {
	        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
	      }
	
	      if (newParsedOption.mediaList.length) {
	        oldOptionBackup.mediaList = newParsedOption.mediaList;
	      }
	
	      if (newParsedOption.mediaDefault) {
	        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
	      }
	    } else {
	      this._optionBackup = newParsedOption;
	    }
	  },
	
	  /**
	   * @param {boolean} isRecreate
	   * @return {Object}
	   */
	  mountOption: function (isRecreate) {
	    var optionBackup = this._optionBackup; // TODO
	    // 如果没有reset功能则不clone。
	
	    this._timelineOptions = map(optionBackup.timelineOptions, clone);
	    this._mediaList = map(optionBackup.mediaList, clone);
	    this._mediaDefault = clone(optionBackup.mediaDefault);
	    this._currentMediaIndices = [];
	    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	    // called, and is merged into every new option by inner method `mergeOption`
	    // each time `setOption` called, can be only used in `isRecreate`, because
	    // its reliability is under suspicion. In other cases option merge is
	    // performed by `model.mergeOption`.
	    ? optionBackup.baseOption : this._newBaseOption);
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Object}
	   */
	  getTimelineOption: function (ecModel) {
	    var option;
	    var timelineOptions = this._timelineOptions;
	
	    if (timelineOptions.length) {
	      // getTimelineOption can only be called after ecModel inited,
	      // so we can get currentIndex from timelineModel.
	      var timelineModel = ecModel.getComponent('timeline');
	
	      if (timelineModel) {
	        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
	      }
	    }
	
	    return option;
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Array.<Object>}
	   */
	  getMediaOption: function (ecModel) {
	    var ecWidth = this._api.getWidth();
	
	    var ecHeight = this._api.getHeight();
	
	    var mediaList = this._mediaList;
	    var mediaDefault = this._mediaDefault;
	    var indices = [];
	    var result = []; // No media defined.
	
	    if (!mediaList.length && !mediaDefault) {
	      return result;
	    } // Multi media may be applied, the latter defined media has higher priority.
	
	
	    for (var i = 0, len = mediaList.length; i < len; i++) {
	      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	        indices.push(i);
	      }
	    } // FIXME
	    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
	
	
	    if (!indices.length && mediaDefault) {
	      indices = [-1];
	    }
	
	    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	      result = map(indices, function (index) {
	        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	      });
	    } // Otherwise return nothing.
	
	
	    this._currentMediaIndices = indices;
	    return result;
	  }
	};
	
	function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
	  var timelineOptions = [];
	  var mediaList = [];
	  var mediaDefault;
	  var baseOption; // Compatible with ec2.
	
	  var timelineOpt = rawOption.timeline;
	
	  if (rawOption.baseOption) {
	    baseOption = rawOption.baseOption;
	  } // For timeline
	
	
	  if (timelineOpt || rawOption.options) {
	    baseOption = baseOption || {};
	    timelineOptions = (rawOption.options || []).slice();
	  } // For media query
	
	
	  if (rawOption.media) {
	    baseOption = baseOption || {};
	    var media = rawOption.media;
	    each(media, function (singleMedia) {
	      if (singleMedia && singleMedia.option) {
	        if (singleMedia.query) {
	          mediaList.push(singleMedia);
	        } else if (!mediaDefault) {
	          // Use the first media default.
	          mediaDefault = singleMedia;
	        }
	      }
	    });
	  } // For normal option
	
	
	  if (!baseOption) {
	    baseOption = rawOption;
	  } // Set timelineOpt to baseOption in ec3,
	  // which is convenient for merge option.
	
	
	  if (!baseOption.timeline) {
	    baseOption.timeline = timelineOpt;
	  } // Preprocess.
	
	
	  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
	    return media.option;
	  })), function (option) {
	    each(optionPreprocessorFuncs, function (preProcess) {
	      preProcess(option, isNew);
	    });
	  });
	  return {
	    baseOption: baseOption,
	    timelineOptions: timelineOptions,
	    mediaDefault: mediaDefault,
	    mediaList: mediaList
	  };
	}
	/**
	 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	 * Support: width, height, aspectRatio
	 * Can use max or min as prefix.
	 */
	
	
	function applyMediaQuery(query, ecWidth, ecHeight) {
	  var realMap = {
	    width: ecWidth,
	    height: ecHeight,
	    aspectratio: ecWidth / ecHeight // lowser case for convenientce.
	
	  };
	  var applicatable = true;
	  zrUtil.each(query, function (value, attr) {
	    var matched = attr.match(QUERY_REG);
	
	    if (!matched || !matched[1] || !matched[2]) {
	      return;
	    }
	
	    var operator = matched[1];
	    var realAttr = matched[2].toLowerCase();
	
	    if (!compare(realMap[realAttr], value, operator)) {
	      applicatable = false;
	    }
	  });
	  return applicatable;
	}
	
	function compare(real, expect, operator) {
	  if (operator === 'min') {
	    return real >= expect;
	  } else if (operator === 'max') {
	    return real <= expect;
	  } else {
	    // Equals
	    return real === expect;
	  }
	}
	
	function indicesEquals(indices1, indices2) {
	  // indices is always order by asc and has only finite number.
	  return indices1.join(',') === indices2.join(',');
	}
	/**
	 * Consider case:
	 * `chart.setOption(opt1);`
	 * Then user do some interaction like dataZoom, dataView changing.
	 * `chart.setOption(opt2);`
	 * Then user press 'reset button' in toolbox.
	 *
	 * After doing that all of the interaction effects should be reset, the
	 * chart should be the same as the result of invoke
	 * `chart.setOption(opt1); chart.setOption(opt2);`.
	 *
	 * Although it is not able ensure that
	 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
	 * `chart.setOption(merge(opt1, opt2));` exactly,
	 * this might be the only simple way to implement that feature.
	 *
	 * MEMO: We've considered some other approaches:
	 * 1. Each model handle its self restoration but not uniform treatment.
	 *     (Too complex in logic and error-prone)
	 * 2. Use a shadow ecModel. (Performace expensive)
	 */
	
	
	function mergeOption(oldOption, newOption) {
	  newOption = newOption || {};
	  each(newOption, function (newCptOpt, mainType) {
	    if (newCptOpt == null) {
	      return;
	    }
	
	    var oldCptOpt = oldOption[mainType];
	
	    if (!ComponentModel.hasClass(mainType)) {
	      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
	    } else {
	      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
	      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
	      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
	      oldOption[mainType] = map(mapResult, function (item) {
	        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
	      });
	    }
	  });
	}
	
	var _default = OptionManager;
	module.exports = _default;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var isArray = _util.isArray;
	var isObject = _util.isObject;
	
	var compatStyle = __webpack_require__(231);
	
	var _model = __webpack_require__(173);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Compatitable with 2.0
	function get(opt, path) {
	  path = path.split(',');
	  var obj = opt;
	
	  for (var i = 0; i < path.length; i++) {
	    obj = obj && obj[path[i]];
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  return obj;
	}
	
	function set(opt, path, val, overwrite) {
	  path = path.split(',');
	  var obj = opt;
	  var key;
	
	  for (var i = 0; i < path.length - 1; i++) {
	    key = path[i];
	
	    if (obj[key] == null) {
	      obj[key] = {};
	    }
	
	    obj = obj[key];
	  }
	
	  if (overwrite || obj[path[i]] == null) {
	    obj[path[i]] = val;
	  }
	}
	
	function compatLayoutProperties(option) {
	  each(LAYOUT_PROPERTIES, function (prop) {
	    if (prop[0] in option && !(prop[1] in option)) {
	      option[prop[1]] = option[prop[0]];
	    }
	  });
	}
	
	var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	
	function _default(option, isTheme) {
	  compatStyle(option, isTheme); // Make sure series array for model initialization.
	
	  option.series = normalizeToArray(option.series);
	  each(option.series, function (seriesOpt) {
	    if (!isObject(seriesOpt)) {
	      return;
	    }
	
	    var seriesType = seriesOpt.type;
	
	    if (seriesType === 'pie' || seriesType === 'gauge') {
	      if (seriesOpt.clockWise != null) {
	        seriesOpt.clockwise = seriesOpt.clockWise;
	      }
	    }
	
	    if (seriesType === 'gauge') {
	      var pointerColor = get(seriesOpt, 'pointer.color');
	      pointerColor != null && set(seriesOpt, 'itemStyle.normal.color', pointerColor);
	    }
	
	    compatLayoutProperties(seriesOpt);
	  }); // dataRange has changed to visualMap
	
	  if (option.dataRange) {
	    option.visualMap = option.dataRange;
	  }
	
	  each(COMPATITABLE_COMPONENTS, function (componentName) {
	    var options = option[componentName];
	
	    if (options) {
	      if (!isArray(options)) {
	        options = [options];
	      }
	
	      each(options, function (option) {
	        compatLayoutProperties(option);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	function compatEC2ItemStyle(opt) {
	  var itemStyleOpt = opt && opt.itemStyle;
	
	  if (!itemStyleOpt) {
	    return;
	  }
	
	  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	    var styleName = POSSIBLE_STYLES[i];
	    var normalItemStyleOpt = itemStyleOpt.normal;
	    var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].normal) {
	        opt[styleName].normal = normalItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	      }
	
	      normalItemStyleOpt[styleName] = null;
	    }
	
	    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].emphasis) {
	        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	      }
	
	      emphasisItemStyleOpt[styleName] = null;
	    }
	  }
	}
	
	function convertNormalEmphasis(opt, optType, useExtend) {
	  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
	    var normalOpt = opt[optType].normal;
	    var emphasisOpt = opt[optType].emphasis;
	
	    if (normalOpt) {
	      // Timeline controlStyle has other properties besides normal and emphasis
	      if (useExtend) {
	        opt[optType].normal = opt[optType].emphasis = null;
	        zrUtil.defaults(opt[optType], normalOpt);
	      } else {
	        opt[optType] = normalOpt;
	      }
	    }
	
	    if (emphasisOpt) {
	      opt.emphasis = opt.emphasis || {};
	      opt.emphasis[optType] = emphasisOpt;
	    }
	  }
	}
	
	function removeEC3NormalStatus(opt) {
	  convertNormalEmphasis(opt, 'itemStyle');
	  convertNormalEmphasis(opt, 'lineStyle');
	  convertNormalEmphasis(opt, 'areaStyle');
	  convertNormalEmphasis(opt, 'label');
	  convertNormalEmphasis(opt, 'labelLine'); // treemap
	
	  convertNormalEmphasis(opt, 'upperLabel'); // graph
	
	  convertNormalEmphasis(opt, 'edgeLabel');
	}
	
	function compatTextStyle(opt, propName) {
	  // Check whether is not object (string\null\undefined ...)
	  var labelOptSingle = isObject(opt) && opt[propName];
	  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;
	
	  if (textStyle) {
	    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
	      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];
	
	      if (textStyle.hasOwnProperty(propName)) {
	        labelOptSingle[propName] = textStyle[propName];
	      }
	    }
	  }
	}
	
	function compatEC3CommonStyles(opt) {
	  if (opt) {
	    removeEC3NormalStatus(opt);
	    compatTextStyle(opt, 'label');
	    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
	  }
	}
	
	function processSeries(seriesOpt) {
	  if (!isObject(seriesOpt)) {
	    return;
	  }
	
	  compatEC2ItemStyle(seriesOpt);
	  removeEC3NormalStatus(seriesOpt);
	  compatTextStyle(seriesOpt, 'label'); // treemap
	
	  compatTextStyle(seriesOpt, 'upperLabel'); // graph
	
	  compatTextStyle(seriesOpt, 'edgeLabel');
	
	  if (seriesOpt.emphasis) {
	    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
	
	    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
	
	    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
	  }
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint) {
	    compatEC2ItemStyle(markPoint);
	    compatEC3CommonStyles(markPoint);
	  }
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine) {
	    compatEC2ItemStyle(markLine);
	    compatEC3CommonStyles(markLine);
	  }
	
	  var markArea = seriesOpt.markArea;
	
	  if (markArea) {
	    compatEC3CommonStyles(markArea);
	  }
	
	  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
	  // then the backward compat based on option type will not be performed.
	
	  if (seriesOpt.type === 'graph') {
	    data = data || seriesOpt.nodes;
	    var edgeData = seriesOpt.links || seriesOpt.edges;
	
	    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
	      for (var i = 0; i < edgeData.length; i++) {
	        compatEC3CommonStyles(edgeData[i]);
	      }
	    }
	
	    zrUtil.each(seriesOpt.categories, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  }
	
	  if (data && !zrUtil.isTypedArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      compatEC3CommonStyles(data[i]);
	    }
	  } // mark point data
	
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint && markPoint.data) {
	    var mpData = markPoint.data;
	
	    for (var i = 0; i < mpData.length; i++) {
	      compatEC3CommonStyles(mpData[i]);
	    }
	  } // mark line data
	
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine && markLine.data) {
	    var mlData = markLine.data;
	
	    for (var i = 0; i < mlData.length; i++) {
	      if (zrUtil.isArray(mlData[i])) {
	        compatEC3CommonStyles(mlData[i][0]);
	        compatEC3CommonStyles(mlData[i][1]);
	      } else {
	        compatEC3CommonStyles(mlData[i]);
	      }
	    }
	  } // Series
	
	
	  if (seriesOpt.type === 'gauge') {
	    compatTextStyle(seriesOpt, 'axisLabel');
	    compatTextStyle(seriesOpt, 'title');
	    compatTextStyle(seriesOpt, 'detail');
	  } else if (seriesOpt.type === 'treemap') {
	    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
	    zrUtil.each(seriesOpt.levels, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  } else if (seriesOpt.type === 'tree') {
	    removeEC3NormalStatus(seriesOpt.leaves);
	  } // sunburst starts from ec4, so it does not need to compat levels.
	
	}
	
	function toArr(o) {
	  return zrUtil.isArray(o) ? o : o ? [o] : [];
	}
	
	function toObj(o) {
	  return (zrUtil.isArray(o) ? o[0] : o) || {};
	}
	
	function _default(option, isTheme) {
	  each(toArr(option.series), function (seriesOpt) {
	    isObject(seriesOpt) && processSeries(seriesOpt);
	  });
	  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	  each(axes, function (axisName) {
	    each(toArr(option[axisName]), function (axisOpt) {
	      if (axisOpt) {
	        compatTextStyle(axisOpt, 'axisLabel');
	        compatTextStyle(axisOpt.axisPointer, 'label');
	      }
	    });
	  });
	  each(toArr(option.parallel), function (parallelOpt) {
	    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	    compatTextStyle(parallelAxisDefault, 'axisLabel');
	    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	  });
	  each(toArr(option.calendar), function (calendarOpt) {
	    convertNormalEmphasis(calendarOpt, 'itemStyle');
	    compatTextStyle(calendarOpt, 'dayLabel');
	    compatTextStyle(calendarOpt, 'monthLabel');
	    compatTextStyle(calendarOpt, 'yearLabel');
	  }); // radar.name.textStyle
	
	  each(toArr(option.radar), function (radarOpt) {
	    compatTextStyle(radarOpt, 'name');
	  });
	  each(toArr(option.geo), function (geoOpt) {
	    if (isObject(geoOpt)) {
	      compatEC3CommonStyles(geoOpt);
	      each(toArr(geoOpt.regions), function (regionObj) {
	        compatEC3CommonStyles(regionObj);
	      });
	    }
	  });
	  each(toArr(option.timeline), function (timelineOpt) {
	    compatEC3CommonStyles(timelineOpt);
	    convertNormalEmphasis(timelineOpt, 'label');
	    convertNormalEmphasis(timelineOpt, 'itemStyle');
	    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
	    var data = timelineOpt.data;
	    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
	      if (zrUtil.isObject(item)) {
	        convertNormalEmphasis(item, 'label');
	        convertNormalEmphasis(item, 'itemStyle');
	      }
	    });
	  });
	  each(toArr(option.toolbox), function (toolboxOpt) {
	    convertNormalEmphasis(toolboxOpt, 'iconStyle');
	    each(toolboxOpt.feature, function (featureOpt) {
	      convertNormalEmphasis(featureOpt, 'iconStyle');
	    });
	  });
	  compatTextStyle(toObj(option.axisPointer), 'label');
	  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
	}
	
	module.exports = _default;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) [Caution]: the logic is correct based on the premises:
	//     data processing stage is blocked in stream.
	//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
	// (2) Only register once when import repeatly.
	//     Should be executed before after series filtered and before stack calculation.
	function _default(ecModel) {
	  var stackInfoMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
	
	    if (stack) {
	      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
	      var data = seriesModel.getData();
	      var stackInfo = {
	        // Used for calculate axis extent automatically.
	        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
	        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
	        stackedDimension: data.getCalculationInfo('stackedDimension'),
	        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
	        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
	        data: data,
	        seriesModel: seriesModel
	      }; // If stacked on axis that do not support data stack.
	
	      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
	        return;
	      }
	
	      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
	      stackInfoList.push(stackInfo);
	    }
	  });
	  stackInfoMap.each(calculateStack);
	}
	
	function calculateStack(stackInfoList) {
	  each(stackInfoList, function (targetStackInfo, idxInStack) {
	    var resultVal = [];
	    var resultNaN = [NaN, NaN];
	    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
	    var targetData = targetStackInfo.data;
	    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
	    // depending on legend selection.
	
	    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
	      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
	      // should also be NaN, to draw a appropriate belt area.
	
	      if (isNaN(sum)) {
	        return resultNaN;
	      }
	
	      var byValue;
	      var stackedDataRawIndex;
	
	      if (isStackedByIndex) {
	        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
	      } else {
	        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
	      } // If stackOver is NaN, chart view will render point on value start.
	
	
	      var stackedOver = NaN;
	
	      for (var j = idxInStack - 1; j >= 0; j--) {
	        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
	
	        if (!isStackedByIndex) {
	          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
	        }
	
	        if (stackedDataRawIndex >= 0) {
	          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
	
	          if (sum >= 0 && val > 0 || // Positive stack
	          sum <= 0 && val < 0 // Negative stack
	          ) {
	              sum += val;
	              stackedOver = val;
	              break;
	            }
	        }
	      }
	
	      resultVal[0] = sum;
	      resultVal[1] = stackedOver;
	      return resultVal;
	    });
	    targetData.hostModel.setData(newData); // Update for consequent calculation
	
	    targetStackInfo.data = newData;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var _format = __webpack_require__(219);
	
	var formatTime = _format.formatTime;
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	var getTooltipMarker = _format.getTooltipMarker;
	
	var modelUtil = __webpack_require__(173);
	
	var ComponentModel = __webpack_require__(215);
	
	var colorPaletteMixin = __webpack_require__(222);
	
	var dataFormatMixin = __webpack_require__(234);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var _task = __webpack_require__(236);
	
	var createTask = _task.createTask;
	
	var _sourceHelper = __webpack_require__(223);
	
	var prepareSource = _sourceHelper.prepareSource;
	var getSource = _sourceHelper.getSource;
	
	var _dataProvider = __webpack_require__(235);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var SeriesModel = ComponentModel.extend({
	  type: 'series.__base__',
	
	  /**
	   * @readOnly
	   */
	  seriesIndex: 0,
	  // coodinateSystem will be injected in the echarts/CoordinateSystem
	  coordinateSystem: null,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * Data provided for legend
	   * @type {Function}
	   */
	  // PENDING
	  legendDataProvider: null,
	
	  /**
	   * Access path of color for visual
	   */
	  visualColorAccessPath: 'itemStyle.color',
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  init: function (option, parentModel, ecModel, extraOpt) {
	    /**
	     * @type {number}
	     * @readOnly
	     */
	    this.seriesIndex = this.componentIndex;
	    this.dataTask = createTask({
	      count: dataTaskCount,
	      reset: dataTaskReset
	    });
	    this.dataTask.context = {
	      model: this
	    };
	    this.mergeDefaultAndTheme(option, ecModel);
	    prepareSource(this);
	    var data = this.getInitialData(option, ecModel);
	    wrapData(data, this);
	    this.dataTask.context.data = data;
	
	    /**
	     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
	     * @private
	     */
	    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
	    // dataBeforeProcessed by cloneShallow), cloneShallow will
	    // cause data.graph.data !== data when using
	    // module:echarts/data/Graph or module:echarts/data/Tree.
	    // See module:echarts/data/helper/linkList
	    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
	    // init or merge stage, because the data can be restored. So we do not `restoreData`
	    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
	    // Call `seriesModel.getRawData()` instead.
	    // this.restoreData();
	
	    autoSeriesName(this);
	  },
	
	  /**
	   * Util for merge default and theme to option
	   * @param  {Object} option
	   * @param  {module:echarts/model/Global} ecModel
	   */
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	    // But if name duplicate between series subType
	    // (for example: parallel) add component mainType,
	    // add suffix 'Series'.
	
	    var themeSubType = this.subType;
	
	    if (ComponentModel.hasClass(themeSubType)) {
	      themeSubType += 'Series';
	    }
	
	    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
	    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	    this.fillDataTextStyle(option.data);
	
	    if (layoutMode) {
	      mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (newSeriesOption, ecModel) {
	    // this.settingTask.dirty();
	    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
	    this.fillDataTextStyle(newSeriesOption.data);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	    }
	
	    prepareSource(this);
	    var data = this.getInitialData(newSeriesOption, ecModel);
	    wrapData(data, this);
	    this.dataTask.dirty();
	    this.dataTask.context.data = data;
	    inner(this).dataBeforeProcessed = data;
	    autoSeriesName(this);
	  },
	  fillDataTextStyle: function (data) {
	    // Default data label emphasis `show`
	    // FIXME Tree structure data ?
	    // FIXME Performance ?
	    if (data && !zrUtil.isTypedArray(data)) {
	      var props = ['show'];
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i] && data[i].label) {
	          modelUtil.defaultEmphasis(data[i], 'label', props);
	        }
	      }
	    }
	  },
	
	  /**
	   * Init a data structure from data related option in series
	   * Must be overwritten
	   */
	  getInitialData: function () {},
	
	  /**
	   * Append data to list
	   * @param {Object} params
	   * @param {Array|TypedArray} params.data
	   */
	  appendData: function (params) {
	    // FIXME ???
	    // (1) If data from dataset, forbidden append.
	    // (2) support append data of dataset.
	    var data = this.getRawData();
	    data.appendData(params.data);
	  },
	
	  /**
	   * Consider some method like `filter`, `map` need make new data,
	   * We should make sure that `seriesModel.getData()` get correct
	   * data in the stream procedure. So we fetch data from upstream
	   * each time `task.perform` called.
	   * @param {string} [dataType]
	   * @return {module:echarts/data/List}
	   */
	  getData: function (dataType) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var data = task.context.data;
	      return dataType == null ? data : data.getLinkedData(dataType);
	    } else {
	      // When series is not alive (that may happen when click toolbox
	      // restore or setOption with not merge mode), series data may
	      // be still need to judge animation or something when graphic
	      // elements want to know whether fade out.
	      return inner(this).data;
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/List} data
	   */
	  setData: function (data) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var context = task.context; // Consider case: filter, data sample.
	
	      if (context.data !== data && task.modifyOutputEnd) {
	        task.setOutputEnd(data.count());
	      }
	
	      context.outputData = data; // Caution: setData should update context.data,
	      // Because getData may be called multiply in a
	      // single stage and expect to get the data just
	      // set. (For example, AxisProxy, x y both call
	      // getData and setDate sequentially).
	      // So the context.data should be fetched from
	      // upstream each time when a stage starts to be
	      // performed.
	
	      if (task !== this.dataTask) {
	        context.data = data;
	      }
	    }
	
	    inner(this).data = data;
	  },
	
	  /**
	   * @see {module:echarts/data/helper/sourceHelper#getSource}
	   * @return {module:echarts/data/Source} source
	   */
	  getSource: function () {
	    return getSource(this);
	  },
	
	  /**
	   * Get data before processed
	   * @return {module:echarts/data/List}
	   */
	  getRawData: function () {
	    return inner(this).dataBeforeProcessed;
	  },
	
	  /**
	   * Get base axis if has coordinate system and has axis.
	   * By default use coordSys.getBaseAxis();
	   * Can be overrided for some chart.
	   * @return {type} description
	   */
	  getBaseAxis: function () {
	    var coordSys = this.coordinateSystem;
	    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	  },
	  // FIXME
	
	  /**
	   * Default tooltip formatter
	   *
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
	   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
	   *                                     string is used as DOM HTML content.
	   *                                     'richText' is used for rendering tooltip in rich text form, for those where
	   *                                     DOM operation is not supported.
	   * @return {Object} formatted tooltip with `html` and `markers`
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var series = this;
	    renderMode = renderMode || 'html';
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    var isRichText = renderMode === 'richText';
	    var markers = {};
	    var markerId = 0;
	
	    function formatArrayValue(value) {
	      // ??? TODO refactor these logic.
	      // check: category-no-encode-has-axis-data in dataset.html
	      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
	      }, 0);
	      var result = [];
	      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
	        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
	      }) // By default, all dims is used on tooltip.
	      : zrUtil.each(value, setEachItem);
	
	      function setEachItem(val, dim) {
	        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        var dimType = dimInfo.type;
	        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
	        var dimHead = getTooltipMarker({
	          color: color,
	          type: 'subItem',
	          renderMode: renderMode,
	          markerId: markName
	        });
	        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
	        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
	        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
	        valStr && result.push(valStr);
	
	        if (isRichText) {
	          markers[markName] = color;
	          ++markerId;
	        }
	      }
	
	      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
	      var content = newLine + result.join(newLine || ', ');
	      return {
	        renderMode: renderMode,
	        content: content,
	        style: markers
	      };
	    }
	
	    function formatSingleValue(val) {
	      // return encodeHTML(addCommas(val));
	      return {
	        renderMode: renderMode,
	        content: encodeHTML(addCommas(val)),
	        style: markers
	      };
	    }
	
	    var data = this.getData();
	    var tooltipDims = data.mapDimension('defaultedTooltip', true);
	    var tooltipDimLen = tooltipDims.length;
	    var value = this.getRawValue(dataIndex);
	    var isValueArr = zrUtil.isArray(value);
	    var color = data.getItemVisual(dataIndex, 'color');
	
	    if (zrUtil.isObject(color) && color.colorStops) {
	      color = (color.colorStops[0] || {}).color;
	    }
	
	    color = color || 'transparent'; // Complicated rule for pretty tooltip.
	
	    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
	    var content = formattedValue.content;
	    var markName = series.seriesIndex + 'at' + markerId;
	    var colorEl = getTooltipMarker({
	      color: color,
	      type: 'item',
	      renderMode: renderMode,
	      markerId: markName
	    });
	    markers[markName] = color;
	    ++markerId;
	    var name = data.getName(dataIndex);
	    var seriesName = this.name;
	
	    if (!modelUtil.isNameSpecified(this)) {
	      seriesName = '';
	    }
	
	    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
	    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
	    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
	    return {
	      html: html,
	      markers: markers
	    };
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var animationEnabled = this.getShallow('animation');
	
	    if (animationEnabled) {
	      if (this.getData().count() > this.getShallow('animationThreshold')) {
	        animationEnabled = false;
	      }
	    }
	
	    return animationEnabled;
	  },
	  restoreData: function () {
	    this.dataTask.dirty();
	  },
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    var ecModel = this.ecModel; // PENDING
	
	    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);
	
	    if (!color) {
	      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
	    }
	
	    return color;
	  },
	
	  /**
	   * Use `data.mapDimension(coordDim, true)` instead.
	   * @deprecated
	   */
	  coordDimToDataDim: function (coordDim) {
	    return this.getRawData().mapDimension(coordDim, true);
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressive: function () {
	    return this.get('progressive');
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressiveThreshold: function () {
	    return this.get('progressiveThreshold');
	  },
	
	  /**
	   * Get data indices for show tooltip content. See tooltip.
	   * @abstract
	   * @param {Array.<string>|string} dim
	   * @param {Array.<number>} value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis
	   * @return {Object} {dataIndices, nestestValue}.
	   */
	  getAxisTooltipData: null,
	
	  /**
	   * See tooltip.
	   * @abstract
	   * @param {number} dataIndex
	   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
	   */
	  getTooltipPosition: null,
	
	  /**
	   * @see {module:echarts/stream/Scheduler}
	   */
	  pipeTask: null,
	
	  /**
	   * Convinient for override in extended class.
	   * @protected
	   * @type {Function}
	   */
	  preventIncremental: null,
	
	  /**
	   * @public
	   * @readOnly
	   * @type {Object}
	   */
	  pipelineContext: null
	});
	zrUtil.mixin(SeriesModel, dataFormatMixin);
	zrUtil.mixin(SeriesModel, colorPaletteMixin);
	/**
	 * MUST be called after `prepareSource` called
	 * Here we need to make auto series, especially for auto legend. But we
	 * do not modify series.name in option to avoid side effects.
	 */
	
	function autoSeriesName(seriesModel) {
	  // User specified name has higher priority, otherwise it may cause
	  // series can not be queried unexpectedly.
	  var name = seriesModel.name;
	
	  if (!modelUtil.isNameSpecified(seriesModel)) {
	    seriesModel.name = getSeriesAutoName(seriesModel) || name;
	  }
	}
	
	function getSeriesAutoName(seriesModel) {
	  var data = seriesModel.getRawData();
	  var dataDims = data.mapDimension('seriesName', true);
	  var nameArr = [];
	  zrUtil.each(dataDims, function (dataDim) {
	    var dimInfo = data.getDimensionInfo(dataDim);
	    dimInfo.displayName && nameArr.push(dimInfo.displayName);
	  });
	  return nameArr.join(' ');
	}
	
	function dataTaskCount(context) {
	  return context.model.getRawData().count();
	}
	
	function dataTaskReset(context) {
	  var seriesModel = context.model;
	  seriesModel.setData(seriesModel.getRawData().cloneShallow());
	  return dataTaskProgress;
	}
	
	function dataTaskProgress(param, context) {
	  // Avoid repead cloneShallow when data just created in reset.
	  if (param.end > context.outputData.count()) {
	    context.model.getRawData().cloneShallow(context.outputData);
	  }
	} // TODO refactor
	
	
	function wrapData(data, seriesModel) {
	  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
	    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
	  });
	}
	
	function onDataSelfChange(seriesModel) {
	  var task = getCurrentTask(seriesModel);
	
	  if (task) {
	    // Consider case: filter, selectRange
	    task.setOutputEnd(this.count());
	  }
	}
	
	function getCurrentTask(seriesModel) {
	  var scheduler = (seriesModel.ecModel || {}).scheduler;
	  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
	
	  if (pipeline) {
	    // When pipline finished, the currrentTask keep the last
	    // task (renderTask).
	    var task = pipeline.currentTask;
	
	    if (task) {
	      var agentStubMap = task.agentStubMap;
	
	      if (agentStubMap) {
	        task = agentStubMap.get(seriesModel.uid);
	      }
	    }
	
	    return task;
	  }
	}
	
	var _default = SeriesModel;
	module.exports = _default;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(235);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	var _format = __webpack_require__(219);
	
	var getTooltipMarker = _format.getTooltipMarker;
	var formatTpl = _format.formatTpl;
	
	var _model = __webpack_require__(173);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly
	
	var _default = {
	  /**
	   * Get params for formatter
	   * @param {number} dataIndex
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex, dataType) {
	    var data = this.getData(dataType);
	    var rawValue = this.getRawValue(dataIndex, dataType);
	    var rawDataIndex = data.getRawIndex(dataIndex);
	    var name = data.getName(dataIndex);
	    var itemOpt = data.getRawDataItem(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	    var tooltipModel = this.ecModel.getComponent('tooltip');
	    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
	    var renderMode = getTooltipRenderMode(renderModeOption);
	    var mainType = this.mainType;
	    var isSeries = mainType === 'series';
	    return {
	      componentType: mainType,
	      componentSubType: this.subType,
	      componentIndex: this.componentIndex,
	      seriesType: isSeries ? this.subType : null,
	      seriesIndex: this.seriesIndex,
	      seriesId: isSeries ? this.id : null,
	      seriesName: isSeries ? this.name : null,
	      name: name,
	      dataIndex: rawDataIndex,
	      data: itemOpt,
	      dataType: dataType,
	      value: rawValue,
	      color: color,
	      marker: getTooltipMarker({
	        color: color,
	        renderMode: renderMode
	      }),
	      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	      $vars: ['seriesName', 'name', 'value']
	    };
	  },
	
	  /**
	   * Format label
	   * @param {number} dataIndex
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @param {string} [dataType]
	   * @param {number} [dimIndex]
	   * @param {string} [labelProp='label']
	   * @return {string} If not formatter, return null/undefined
	   */
	  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
	    status = status || 'normal';
	    var data = this.getData(dataType);
	    var itemModel = data.getItemModel(dataIndex);
	    var params = this.getDataParams(dataIndex, dataType);
	
	    if (dimIndex != null && params.value instanceof Array) {
	      params.value = params.value[dimIndex];
	    }
	
	    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
	      // Do not support '}' in dim name util have to.
	
	      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
	        var len = dim.length;
	
	        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
	          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
	        }
	
	        return retrieveRawValue(data, dataIndex, dim);
	      });
	    }
	  },
	
	  /**
	   * Get raw value in option
	   * @param {number} idx
	   * @param {string} [dataType]
	   * @return {Array|number|string}
	   */
	  getRawValue: function (idx, dataType) {
	    return retrieveRawValue(this.getData(dataType), idx);
	  },
	
	  /**
	   * Should be implemented.
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @return {string} tooltip string
	   */
	  formatTooltip: function () {// Empty function
	  }
	};
	module.exports = _default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(134);
	
	var isTypedArray = _util.isTypedArray;
	var extend = _util.extend;
	var assert = _util.assert;
	var each = _util.each;
	var isObject = _util.isObject;
	
	var _model = __webpack_require__(173);
	
	var getDataItemValue = _model.getDataItemValue;
	var isDataItemOption = _model.isDataItemOption;
	
	var _number = __webpack_require__(218);
	
	var parseDate = _number.parseDate;
	
	var Source = __webpack_require__(225);
	
	var _sourceType = __webpack_require__(226);
	
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO
	// ??? refactor? check the outer usage of data provider.
	// merge with defaultDimValueGetter?
	
	/**
	 * If normal array used, mutable chunk size is supported.
	 * If typed array used, chunk size must be fixed.
	 */
	function DefaultDataProvider(source, dimSize) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  this._source = source;
	  var data = this._data = source.data;
	  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?
	
	  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	    this._offset = 0;
	    this._dimSize = dimSize;
	    this._data = data;
	  }
	
	  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
	  extend(this, methods);
	}
	
	var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration
	
	providerProto.pure = false; // If data is persistent and will not be released after use.
	
	providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource
	
	providerProto.getSource = function () {
	  return this._source;
	};
	
	var providerMethods = {
	  'arrayRows_column': {
	    pure: true,
	    count: function () {
	      return Math.max(0, this._data.length - this._source.startIndex);
	    },
	    getItem: function (idx) {
	      return this._data[idx + this._source.startIndex];
	    },
	    appendData: appendDataSimply
	  },
	  'arrayRows_row': {
	    pure: true,
	    count: function () {
	      var row = this._data[0];
	      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
	    },
	    getItem: function (idx) {
	      idx += this._source.startIndex;
	      var item = [];
	      var data = this._data;
	
	      for (var i = 0; i < data.length; i++) {
	        var row = data[i];
	        item.push(row ? row[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function () {
	      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
	    }
	  },
	  'objectRows': {
	    pure: true,
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'keyedColumns': {
	    pure: true,
	    count: function () {
	      var dimName = this._source.dimensionsDefine[0].name;
	      var col = this._data[dimName];
	      return col ? col.length : 0;
	    },
	    getItem: function (idx) {
	      var item = [];
	      var dims = this._source.dimensionsDefine;
	
	      for (var i = 0; i < dims.length; i++) {
	        var col = this._data[dims[i].name];
	        item.push(col ? col[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function (newData) {
	      var data = this._data;
	      each(newData, function (newCol, key) {
	        var oldCol = data[key] || (data[key] = []);
	
	        for (var i = 0; i < (newCol || []).length; i++) {
	          oldCol.push(newCol[i]);
	        }
	      });
	    }
	  },
	  'original': {
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'typedArray': {
	    persistent: false,
	    pure: true,
	    count: function () {
	      return this._data ? this._data.length / this._dimSize : 0;
	    },
	    getItem: function (idx, out) {
	      idx = idx - this._offset;
	      out = out || [];
	      var offset = this._dimSize * idx;
	
	      for (var i = 0; i < this._dimSize; i++) {
	        out[i] = this._data[offset + i];
	      }
	
	      return out;
	    },
	    appendData: function (newData) {
	      this._data = newData;
	    },
	    // Clean self if data is already used.
	    clean: function () {
	      // PENDING
	      this._offset += this.count();
	      this._data = null;
	    }
	  }
	};
	
	function countSimply() {
	  return this._data.length;
	}
	
	function getItemSimply(idx) {
	  return this._data[idx];
	}
	
	function appendDataSimply(newData) {
	  for (var i = 0; i < newData.length; i++) {
	    this._data.push(newData[i]);
	  }
	}
	
	var rawValueGetters = {
	  arrayRows: getRawValueSimply,
	  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
	    return dimIndex != null ? dataItem[dimName] : dataItem;
	  },
	  keyedColumns: getRawValueSimply,
	  original: function (dataItem, dataIndex, dimIndex, dimName) {
	    // FIXME
	    // In some case (markpoint in geo (geo-map.html)), dataItem
	    // is {coord: [...]}
	    var value = getDataItemValue(dataItem);
	    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
	  },
	  typedArray: getRawValueSimply
	};
	
	function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
	  return dimIndex != null ? dataItem[dimIndex] : dataItem;
	}
	
	var defaultDimValueGetters = {
	  arrayRows: getDimValueSimply,
	  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
	    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
	  },
	  keyedColumns: getDimValueSimply,
	  original: function (dataItem, dimName, dataIndex, dimIndex) {
	    // Performance sensitive, do not use modelUtil.getDataItemValue.
	    // If dataItem is an plain object with no value field, the var `value`
	    // will be assigned with the object, but it will be tread correctly
	    // in the `convertDataValue`.
	    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }
	
	    if (!this._rawData.pure && isDataItemOption(dataItem)) {
	      this.hasItemOption = true;
	    }
	
	    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	    : value, this._dimensionInfos[dimName]);
	  },
	  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
	    return dataItem[dimIndex];
	  }
	};
	
	function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
	  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
	}
	/**
	 * This helper method convert value in data.
	 * @param {string|number|Date} value
	 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
	 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
	 */
	
	
	function converDataValue(value, dimInfo) {
	  // Performance sensitive.
	  var dimType = dimInfo && dimInfo.type;
	
	  if (dimType === 'ordinal') {
	    // If given value is a category string
	    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
	    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
	  }
	
	  if (dimType === 'time' // spead up when using timestamp
	  && typeof value !== 'number' && value != null && value !== '-') {
	    value = +parseDate(value);
	  } // dimType defaults 'number'.
	  // If dimType is not ordinal and value is null or undefined or NaN or '-',
	  // parse to NaN.
	
	
	  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
	  // If object, also parse to NaN
	  : +value;
	} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
	// Consider persistent.
	// Caution: why use raw value to display on label or tooltip?
	// A reason is to avoid format. For example time value we do not know
	// how to format is expected. More over, if stack is used, calculated
	// value may be 0.91000000001, which have brings trouble to display.
	// TODO: consider how to treat null/undefined/NaN when display?
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string|number} [dim] dimName or dimIndex
	 * @return {Array.<number>|string|number} can be null/undefined.
	 */
	
	
	function retrieveRawValue(data, dataIndex, dim) {
	  if (!data) {
	    return;
	  } // Consider data may be not persistent.
	
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (dataItem == null) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	  var dimName;
	  var dimIndex;
	  var dimInfo = data.getDimensionInfo(dim);
	
	  if (dimInfo) {
	    dimName = dimInfo.name;
	    dimIndex = dimInfo.index;
	  }
	
	  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
	}
	/**
	 * Compatible with some cases (in pie, map) like:
	 * data: [{name: 'xx', value: 5, selected: true}, ...]
	 * where only sourceFormat is 'original' and 'objectRows' supported.
	 *
	 * ??? TODO
	 * Supported detail options in data item when using 'arrayRows'.
	 *
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string} attr like 'selected'
	 */
	
	
	function retrieveRawAttr(data, dataIndex, attr) {
	  if (!data) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	
	  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
	    return;
	  }
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
	    dataItem = null;
	  }
	
	  if (dataItem) {
	    return dataItem[attr];
	  }
	}
	
	exports.DefaultDataProvider = DefaultDataProvider;
	exports.defaultDimValueGetters = defaultDimValueGetters;
	exports.retrieveRawValue = retrieveRawValue;
	exports.retrieveRawAttr = retrieveRawAttr;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var assert = _util.assert;
	var isArray = _util.isArray;
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} define
	 * @return See the return of `createTask`.
	 */
	function createTask(define) {
	  return new Task(define);
	}
	/**
	 * @constructor
	 * @param {Object} define
	 * @param {Function} define.reset Custom reset
	 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
	 * @param {Function} [define.count] count is used to determin data task.
	 * @param {Function} [define.onDirty] count is used to determin data task.
	 */
	
	
	function Task(define) {
	  define = define || {};
	  this._reset = define.reset;
	  this._plan = define.plan;
	  this._count = define.count;
	  this._onDirty = define.onDirty;
	  this._dirty = true; // Context must be specified implicitly, to
	  // avoid miss update context when model changed.
	
	  this.context;
	}
	
	var taskProto = Task.prototype;
	/**
	 * @param {Object} performArgs
	 * @param {number} [performArgs.step] Specified step.
	 * @param {number} [performArgs.skip] Skip customer perform call.
	 * @param {number} [performArgs.modBy] Sampling window size.
	 * @param {number} [performArgs.modDataCount] Sampling count.
	 */
	
	taskProto.perform = function (performArgs) {
	  var upTask = this._upstream;
	  var skip = performArgs && performArgs.skip; // TODO some refactor.
	  // Pull data. Must pull data each time, because context.data
	  // may be updated by Series.setData.
	
	  if (this._dirty && upTask) {
	    var context = this.context;
	    context.data = context.outputData = upTask.context.outputData;
	  }
	
	  if (this.__pipeline) {
	    this.__pipeline.currentTask = this;
	  }
	
	  var planResult;
	
	  if (this._plan && !skip) {
	    planResult = this._plan(this.context);
	  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
	  // elements uniformed distributed when progress, especially when moving or zooming.
	
	
	  var lastModBy = normalizeModBy(this._modBy);
	  var lastModDataCount = this._modDataCount || 0;
	  var modBy = normalizeModBy(performArgs && performArgs.modBy);
	  var modDataCount = performArgs && performArgs.modDataCount || 0;
	
	  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
	    planResult = 'reset';
	  }
	
	  function normalizeModBy(val) {
	    !(val >= 1) && (val = 1); // jshint ignore:line
	
	    return val;
	  }
	
	  var forceFirstProgress;
	
	  if (this._dirty || planResult === 'reset') {
	    this._dirty = false;
	    forceFirstProgress = reset(this, skip);
	  }
	
	  this._modBy = modBy;
	  this._modDataCount = modDataCount;
	  var step = performArgs && performArgs.step;
	
	  if (upTask) {
	    this._dueEnd = upTask._outputDueEnd;
	  } // DataTask or overallTask
	  else {
	      this._dueEnd = this._count ? this._count(this.context) : Infinity;
	    } // Note: Stubs, that its host overall task let it has progress, has progress.
	  // If no progress, pass index from upstream to downstream each time plan called.
	
	
	  if (this._progress) {
	    var start = this._dueIndex;
	    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
	
	    if (!skip && (forceFirstProgress || start < end)) {
	      var progress = this._progress;
	
	      if (isArray(progress)) {
	        for (var i = 0; i < progress.length; i++) {
	          doProgress(this, progress[i], start, end, modBy, modDataCount);
	        }
	      } else {
	        doProgress(this, progress, start, end, modBy, modDataCount);
	      }
	    }
	
	    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
	    // input data is the same, so use `dueIndex` as `outputDueEnd`.
	
	    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
	    this._outputDueEnd = outputDueEnd;
	  } else {
	    // (1) Some overall task has no progress.
	    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
	    // This should always be performed so it can be passed to downstream.
	    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
	  }
	
	  return this.unfinished();
	};
	
	var iterator = function () {
	  var end;
	  var current;
	  var modBy;
	  var modDataCount;
	  var winCount;
	  var it = {
	    reset: function (s, e, sStep, sCount) {
	      current = s;
	      end = e;
	      modBy = sStep;
	      modDataCount = sCount;
	      winCount = Math.ceil(modDataCount / modBy);
	      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
	    }
	  };
	  return it;
	
	  function sequentialNext() {
	    return current < end ? current++ : null;
	  }
	
	  function modNext() {
	    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
	    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
	    // Use normal linear rendering mode.
	    : current;
	    current++;
	    return result;
	  }
	}();
	
	taskProto.dirty = function () {
	  this._dirty = true;
	  this._onDirty && this._onDirty(this.context);
	};
	
	function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
	  iterator.reset(start, end, modBy, modDataCount);
	  taskIns._callingProgress = progress;
	
	  taskIns._callingProgress({
	    start: start,
	    end: end,
	    count: end - start,
	    next: iterator.next
	  }, taskIns.context);
	}
	
	function reset(taskIns, skip) {
	  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
	  taskIns._settedOutputEnd = null;
	  var progress;
	  var forceFirstProgress;
	
	  if (!skip && taskIns._reset) {
	    progress = taskIns._reset(taskIns.context);
	
	    if (progress && progress.progress) {
	      forceFirstProgress = progress.forceFirstProgress;
	      progress = progress.progress;
	    } // To simplify no progress checking, array must has item.
	
	
	    if (isArray(progress) && !progress.length) {
	      progress = null;
	    }
	  }
	
	  taskIns._progress = progress;
	  taskIns._modBy = taskIns._modDataCount = null;
	  var downstream = taskIns._downstream;
	  downstream && downstream.dirty();
	  return forceFirstProgress;
	}
	/**
	 * @return {boolean}
	 */
	
	
	taskProto.unfinished = function () {
	  return this._progress && this._dueIndex < this._dueEnd;
	};
	/**
	 * @param {Object} downTask The downstream task.
	 * @return {Object} The downstream task.
	 */
	
	
	taskProto.pipe = function (downTask) {
	  // If already downstream, do not dirty downTask.
	  if (this._downstream !== downTask || this._dirty) {
	    this._downstream = downTask;
	    downTask._upstream = this;
	    downTask.dirty();
	  }
	};
	
	taskProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._upstream && (this._upstream._downstream = null);
	  this._downstream && (this._downstream._upstream = null);
	  this._dirty = false;
	  this._disposed = true;
	};
	
	taskProto.getUpstream = function () {
	  return this._upstream;
	};
	
	taskProto.getDownstream = function () {
	  return this._downstream;
	};
	
	taskProto.setOutputEnd = function (end) {
	  // This only happend in dataTask, dataZoom, map, currently.
	  // where dataZoom do not set end each time, but only set
	  // when reset. So we should record the setted end, in case
	  // that the stub of dataZoom perform again and earse the
	  // setted end by upstream.
	  this._outputDueEnd = this._settedOutputEnd = end;
	}; ///////////////////////////////////////////////////////////
	// For stream debug (Should be commented out after used!)
	// Usage: printTask(this, 'begin');
	// Usage: printTask(this, null, {someExtraProp});
	// function printTask(task, prefix, extra) {
	//     window.ecTaskUID == null && (window.ecTaskUID = 0);
	//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
	//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
	//     var props = [];
	//     if (task.__pipeline) {
	//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
	//         props.push({text: 'idx', value: val});
	//     } else {
	//         var stubCount = 0;
	//         task.agentStubMap.each(() => stubCount++);
	//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
	//     }
	//     props.push({text: 'uid', value: task.uidDebug});
	//     if (task.__pipeline) {
	//         props.push({text: 'pid', value: task.__pipeline.id});
	//         task.agent && props.push(
	//             {text: 'stubFor', value: task.agent.uidDebug}
	//         );
	//     }
	//     props.push(
	//         {text: 'dirty', value: task._dirty},
	//         {text: 'dueIndex', value: task._dueIndex},
	//         {text: 'dueEnd', value: task._dueEnd},
	//         {text: 'outputDueEnd', value: task._outputDueEnd}
	//     );
	//     if (extra) {
	//         Object.keys(extra).forEach(key => {
	//             props.push({text: key, value: extra[key]});
	//         });
	//     }
	//     var args = ['color: blue'];
	//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
	//         args.push('color: black', 'color: red'),
	//         `${item.text}: %c${item.value}`
	//     )).join('%c, ');
	//     console.log.apply(console, [msg].concat(args));
	//     // console.log(this);
	// }
	
	
	exports.createTask = createTask;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Group = __webpack_require__(142);
	
	var componentUtil = __webpack_require__(216);
	
	var clazzUtil = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Component = function () {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewComponent');
	};
	
	Component.prototype = {
	  constructor: Component,
	  init: function (ecModel, api) {},
	  render: function (componentModel, ecModel, api, payload) {},
	  dispose: function () {},
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var componentProto = Component.prototype;
	
	componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
	}; // Enable Component.extend.
	
	
	clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Component, {
	  registerWhenExtend: true
	});
	var _default = Component;
	module.exports = _default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	
	var Group = __webpack_require__(142);
	
	var componentUtil = __webpack_require__(216);
	
	var clazzUtil = __webpack_require__(175);
	
	var modelUtil = __webpack_require__(173);
	
	var _task = __webpack_require__(236);
	
	var createTask = _task.createTask;
	
	var createRenderPlanner = __webpack_require__(239);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var renderPlanner = createRenderPlanner();
	
	function Chart() {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewChart');
	  this.renderTask = createTask({
	    plan: renderTaskPlan,
	    reset: renderTaskReset
	  });
	  this.renderTask.context = {
	    view: this
	  };
	}
	
	Chart.prototype = {
	  type: 'chart',
	
	  /**
	   * Init the chart.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {},
	
	  /**
	   * Render the chart.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  render: function (seriesModel, ecModel, api, payload) {},
	
	  /**
	   * Highlight series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  highlight: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
	  },
	
	  /**
	   * Downplay series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  downplay: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'normal');
	  },
	
	  /**
	   * Remove self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  remove: function (ecModel, api) {
	    this.group.removeAll();
	  },
	
	  /**
	   * Dispose self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  dispose: function () {},
	
	  /**
	   * Rendering preparation in progressive mode.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalPrepareRender: null,
	
	  /**
	   * Render in progressive mode.
	   * @param  {Object} params See taskParams in `stream/task.js`
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalRender: null,
	
	  /**
	   * Update transform directly.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   * @return {Object} {update: true}
	   */
	  updateTransform: null,
	
	  /**
	   * The view contains the given point.
	   * @interface
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  // containPoint: function () {}
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var chartProto = Chart.prototype;
	
	chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
	  this.render(seriesModel, ecModel, api, payload);
	};
	/**
	 * Set state of single element
	 * @param  {module:zrender/Element} el
	 * @param  {string} state
	 */
	
	
	function elSetState(el, state) {
	  if (el) {
	    el.trigger(state);
	
	    if (el.type === 'group') {
	      for (var i = 0; i < el.childCount(); i++) {
	        elSetState(el.childAt(i), state);
	      }
	    }
	  }
	}
	/**
	 * @param  {module:echarts/data/List} data
	 * @param  {Object} payload
	 * @param  {string} state 'normal'|'emphasis'
	 */
	
	
	function toggleHighlight(data, payload, state) {
	  var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	  if (dataIndex != null) {
	    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
	      elSetState(data.getItemGraphicEl(dataIdx), state);
	    });
	  } else {
	    data.eachItemGraphicEl(function (el) {
	      elSetState(el, state);
	    });
	  }
	} // Enable Chart.extend.
	
	
	clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Chart, {
	  registerWhenExtend: true
	});
	
	Chart.markUpdateMethod = function (payload, methodName) {
	  inner(payload).updateMethod = methodName;
	};
	
	function renderTaskPlan(context) {
	  return renderPlanner(context.model);
	}
	
	function renderTaskReset(context) {
	  var seriesModel = context.model;
	  var ecModel = context.ecModel;
	  var api = context.api;
	  var payload = context.payload; // ???! remove updateView updateVisual
	
	  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
	  var view = context.view;
	  var updateMethod = payload && inner(payload).updateMethod;
	  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
	  // is less than progressive threshold.
	  : 'render';
	
	  if (methodName !== 'render') {
	    view[methodName](seriesModel, ecModel, api, payload);
	  }
	
	  return progressMethodMap[methodName];
	}
	
	var progressMethodMap = {
	  incrementalPrepareRender: {
	    progress: function (params, context) {
	      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
	    }
	  },
	  render: {
	    // Put view.render in `progress` to support appendData. But in this case
	    // view.render should not be called in reset, otherwise it will be called
	    // twise. Use `forceFirstProgress` to make sure that view.render is called
	    // in any cases.
	    forceFirstProgress: true,
	    progress: function (params, context) {
	      context.view.render(context.model, context.ecModel, context.api, context.payload);
	    }
	  }
	};
	var _default = Chart;
	module.exports = _default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @return {string} If large mode changed, return string 'reset';
	 */
	function _default() {
	  var inner = makeInner();
	  return function (seriesModel) {
	    var fields = inner(seriesModel);
	    var pipelineContext = seriesModel.pipelineContext;
	    var originalLarge = fields.large;
	    var originalProgressive = fields.progressiveRender;
	    var large = fields.large = pipelineContext.large;
	    var progressive = fields.progressiveRender = pipelineContext.progressiveRender;
	    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ORIGIN_METHOD = '\0__throttleOriginMethod';
	var RATE = '\0__throttleRate';
	var THROTTLE_TYPE = '\0__throttleType';
	/**
	 * @public
	 * @param {(Function)} fn
	 * @param {number} [delay=0] Unit: ms.
	 * @param {boolean} [debounce=false]
	 *        true: If call interval less than `delay`, only the last call works.
	 *        false: If call interval less than `delay, call works on fixed rate.
	 * @return {(Function)} throttled fn.
	 */
	
	function throttle(fn, delay, debounce) {
	  var currCall;
	  var lastCall = 0;
	  var lastExec = 0;
	  var timer = null;
	  var diff;
	  var scope;
	  var args;
	  var debounceNextCall;
	  delay = delay || 0;
	
	  function exec() {
	    lastExec = new Date().getTime();
	    timer = null;
	    fn.apply(scope, args || []);
	  }
	
	  var cb = function () {
	    currCall = new Date().getTime();
	    scope = this;
	    args = arguments;
	    var thisDelay = debounceNextCall || delay;
	    var thisDebounce = debounceNextCall || debounce;
	    debounceNextCall = null;
	    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
	    // than a new call of `cb`, that is, preserving the command order. Consider
	    // calculating "scale rate" when roaming as an example. When a call of `cb`
	    // happens, either the `exec` is called dierectly, or the call is delayed.
	    // But the delayed call should never be later than next call of `cb`. Under
	    // this assurance, we can simply update view state each time `dispatchAction`
	    // triggered by user roaming, but not need to add extra code to avoid the
	    // state being "rolled-back".
	
	    if (thisDebounce) {
	      timer = setTimeout(exec, thisDelay);
	    } else {
	      if (diff >= 0) {
	        exec();
	      } else {
	        timer = setTimeout(exec, -diff);
	      }
	    }
	
	    lastCall = currCall;
	  };
	  /**
	   * Clear throttle.
	   * @public
	   */
	
	
	  cb.clear = function () {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  };
	  /**
	   * Enable debounce once.
	   */
	
	
	  cb.debounceNextCall = function (debounceDelay) {
	    debounceNextCall = debounceDelay;
	  };
	
	  return cb;
	}
	/**
	 * Create throttle method or update throttle rate.
	 *
	 * @example
	 * ComponentView.prototype.render = function () {
	 *     ...
	 *     throttle.createOrUpdate(
	 *         this,
	 *         '_dispatchAction',
	 *         this.model.get('throttle'),
	 *         'fixRate'
	 *     );
	 * };
	 * ComponentView.prototype.remove = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 * ComponentView.prototype.dispose = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 * @param {number} [rate]
	 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
	 * @return {Function} throttled function.
	 */
	
	
	function createOrUpdate(obj, fnAttr, rate, throttleType) {
	  var fn = obj[fnAttr];
	
	  if (!fn) {
	    return;
	  }
	
	  var originFn = fn[ORIGIN_METHOD] || fn;
	  var lastThrottleType = fn[THROTTLE_TYPE];
	  var lastRate = fn[RATE];
	
	  if (lastRate !== rate || lastThrottleType !== throttleType) {
	    if (rate == null || !throttleType) {
	      return obj[fnAttr] = originFn;
	    }
	
	    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	    fn[ORIGIN_METHOD] = originFn;
	    fn[THROTTLE_TYPE] = throttleType;
	    fn[RATE] = rate;
	  }
	
	  return fn;
	}
	/**
	 * Clear throttle. Example see throttle.createOrUpdate.
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 */
	
	
	function clear(obj, fnAttr) {
	  var fn = obj[fnAttr];
	
	  if (fn && fn[ORIGIN_METHOD]) {
	    obj[fnAttr] = fn[ORIGIN_METHOD];
	  }
	}
	
	exports.throttle = throttle;
	exports.createOrUpdate = createOrUpdate;
	exports.clear = clear;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Gradient = __webpack_require__(211);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  createOnAllSeries: true,
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.');
	    var color = seriesModel.get(colorAccessPath) // Set in itemStyle
	    || seriesModel.getColorFromPalette( // TODO series count changed.
	    seriesModel.name, null, ecModel.getSeriesCount()); // Default color
	    // FIXME Set color function or use the platte color
	
	    data.setVisual('color', color); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (typeof color === 'function' && !(color instanceof Gradient)) {
	        data.each(function (idx) {
	          data.setItemVisual(idx, 'color', color(seriesModel.getDataParams(idx)));
	        });
	      } // itemStyle in each data item
	
	
	      var dataEach = function (data, idx) {
	        var itemModel = data.getItemModel(idx);
	        var color = itemModel.get(colorAccessPath, true);
	
	        if (color != null) {
	          data.setItemVisual(idx, 'color', color);
	        }
	      };
	
	      return {
	        dataEach: data.hasItemOption ? dataEach : null
	      };
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var lang = __webpack_require__(243);
	
	var _dataProvider = __webpack_require__(235);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(dom, ecModel) {
	  var ariaModel = ecModel.getModel('aria');
	
	  if (!ariaModel.get('show')) {
	    return;
	  } else if (ariaModel.get('description')) {
	    dom.setAttribute('aria-label', ariaModel.get('description'));
	    return;
	  }
	
	  var seriesCnt = 0;
	  ecModel.eachSeries(function (seriesModel, idx) {
	    ++seriesCnt;
	  }, this);
	  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
	  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
	  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
	  var ariaLabel;
	
	  if (seriesCnt < 1) {
	    // No series, no aria label
	    return;
	  } else {
	    var title = getTitle();
	
	    if (title) {
	      ariaLabel = replace(getConfig('general.withTitle'), {
	        title: title
	      });
	    } else {
	      ariaLabel = getConfig('general.withoutTitle');
	    }
	
	    var seriesLabels = [];
	    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
	    ariaLabel += replace(getConfig(prefix), {
	      seriesCount: seriesCnt
	    });
	    ecModel.eachSeries(function (seriesModel, idx) {
	      if (idx < displaySeriesCnt) {
	        var seriesLabel;
	        var seriesName = seriesModel.get('name');
	        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
	        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
	        seriesLabel = replace(seriesLabel, {
	          seriesId: seriesModel.seriesIndex,
	          seriesName: seriesModel.get('name'),
	          seriesType: getSeriesTypeName(seriesModel.subType)
	        });
	        var data = seriesModel.getData();
	        window.data = data;
	
	        if (data.count() > maxDataCnt) {
	          // Show part of data
	          seriesLabel += replace(getConfig('data.partialData'), {
	            displayCnt: maxDataCnt
	          });
	        } else {
	          seriesLabel += getConfig('data.allData');
	        }
	
	        var dataLabels = [];
	
	        for (var i = 0; i < data.count(); i++) {
	          if (i < maxDataCnt) {
	            var name = data.getName(i);
	            var value = retrieveRawValue(data, i);
	            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
	              name: name,
	              value: value
	            }));
	          }
	        }
	
	        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
	        seriesLabels.push(seriesLabel);
	      }
	    });
	    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
	    dom.setAttribute('aria-label', ariaLabel);
	  }
	
	  function replace(str, keyValues) {
	    if (typeof str !== 'string') {
	      return str;
	    }
	
	    var result = str;
	    zrUtil.each(keyValues, function (value, key) {
	      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
	    });
	    return result;
	  }
	
	  function getConfig(path) {
	    var userConfig = ariaModel.get(path);
	
	    if (userConfig == null) {
	      var pathArr = path.split('.');
	      var result = lang.aria;
	
	      for (var i = 0; i < pathArr.length; ++i) {
	        result = result[pathArr[i]];
	      }
	
	      return result;
	    } else {
	      return userConfig;
	    }
	  }
	
	  function getTitle() {
	    var title = ecModel.getModel('title').option;
	
	    if (title && title.length) {
	      title = title[0];
	    }
	
	    return title && title.text;
	  }
	
	  function getSeriesTypeName(type) {
	    return lang.series.typeNames[type] || '自定义图';
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  toolbox: {
	    brush: {
	      title: {
	        rect: '矩形选择',
	        polygon: '圈选',
	        lineX: '横向选择',
	        lineY: '纵向选择',
	        keep: '保持选择',
	        clear: '清除选择'
	      }
	    },
	    dataView: {
	      title: '数据视图',
	      lang: ['数据视图', '关闭', '刷新']
	    },
	    dataZoom: {
	      title: {
	        zoom: '区域缩放',
	        back: '区域缩放还原'
	      }
	    },
	    magicType: {
	      title: {
	        line: '切换为折线图',
	        bar: '切换为柱状图',
	        stack: '切换为堆叠',
	        tiled: '切换为平铺'
	      }
	    },
	    restore: {
	      title: '还原'
	    },
	    saveAsImage: {
	      title: '保存为图片',
	      lang: ['右键另存为图片']
	    }
	  },
	  series: {
	    typeNames: {
	      pie: '饼图',
	      bar: '柱状图',
	      line: '折线图',
	      scatter: '散点图',
	      effectScatter: '涟漪散点图',
	      radar: '雷达图',
	      tree: '树图',
	      treemap: '矩形树图',
	      boxplot: '箱型图',
	      candlestick: 'K线图',
	      k: 'K线图',
	      heatmap: '热力图',
	      map: '地图',
	      parallel: '平行坐标图',
	      lines: '线图',
	      graph: '关系图',
	      sankey: '桑基图',
	      funnel: '漏斗图',
	      gauge: '仪表盘图',
	      pictorialBar: '象形柱图',
	      themeRiver: '主题河流图',
	      sunburst: '旭日图'
	    }
	  },
	  aria: {
	    general: {
	      withTitle: '这是一个关于“{title}”的图表。',
	      withoutTitle: '这是一个图表，'
	    },
	    series: {
	      single: {
	        prefix: '',
	        withName: '图表类型是{seriesType}，表示{seriesName}。',
	        withoutName: '图表类型是{seriesType}。'
	      },
	      multiple: {
	        prefix: '它由{seriesCount}个图表系列组成。',
	        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
	        withoutName: '第{seriesId}个系列是一个{seriesType}，',
	        separator: {
	          middle: '；',
	          end: '。'
	        }
	      }
	    },
	    data: {
	      allData: '其数据是——',
	      partialData: '其中，前{displayCnt}项是——',
	      withName: '{name}的数据是{value}',
	      withoutName: '{value}',
	      separator: {
	        middle: '，',
	        end: ''
	      }
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} [opts]
	 * @param {string} [opts.text]
	 * @param {string} [opts.color]
	 * @param {string} [opts.textColor]
	 * @return {module:zrender/Element}
	 */
	
	function _default(api, opts) {
	  opts = opts || {};
	  zrUtil.defaults(opts, {
	    text: 'loading',
	    color: '#c23531',
	    textColor: '#000',
	    maskColor: 'rgba(255, 255, 255, 0.8)',
	    zlevel: 0
	  });
	  var mask = new graphic.Rect({
	    style: {
	      fill: opts.maskColor
	    },
	    zlevel: opts.zlevel,
	    z: 10000
	  });
	  var arc = new graphic.Arc({
	    shape: {
	      startAngle: -PI / 2,
	      endAngle: -PI / 2 + 0.1,
	      r: 10
	    },
	    style: {
	      stroke: opts.color,
	      lineCap: 'round',
	      lineWidth: 5
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  var labelRect = new graphic.Rect({
	    style: {
	      fill: 'none',
	      text: opts.text,
	      textPosition: 'right',
	      textDistance: 10,
	      textFill: opts.textColor
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  arc.animateShape(true).when(1000, {
	    endAngle: PI * 3 / 2
	  }).start('circularInOut');
	  arc.animateShape(true).when(1000, {
	    startAngle: PI * 3 / 2
	  }).delay(300).start('circularInOut');
	  var group = new graphic.Group();
	  group.add(arc);
	  group.add(labelRect);
	  group.add(mask); // Inject resize
	
	  group.resize = function () {
	    var cx = api.getWidth() / 2;
	    var cy = api.getHeight() / 2;
	    arc.setShape({
	      cx: cx,
	      cy: cy
	    });
	    var r = arc.shape.r;
	    labelRect.setShape({
	      x: cx - r,
	      y: cy - r,
	      width: r * 2,
	      height: r * 2
	    });
	    mask.setShape({
	      x: 0,
	      y: 0,
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  };
	
	  group.resize();
	  return group;
	}
	
	module.exports = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var map = _util.map;
	var isFunction = _util.isFunction;
	var createHashMap = _util.createHashMap;
	var noop = _util.noop;
	
	var _task = __webpack_require__(236);
	
	var createTask = _task.createTask;
	
	var _component = __webpack_require__(216);
	
	var getUID = _component.getUID;
	
	var GlobalModel = __webpack_require__(172);
	
	var ExtensionAPI = __webpack_require__(227);
	
	var _model = __webpack_require__(173);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/stream/Scheduler
	 */
	
	/**
	 * @constructor
	 */
	function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
	  this.ecInstance = ecInstance;
	  this.api = api;
	  this.unfinished; // Fix current processors in case that in some rear cases that
	  // processors might be registered after echarts instance created.
	  // Register processors incrementally for a echarts instance is
	  // not supported by this stream architecture.
	
	  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
	  var visualHandlers = this._visualHandlers = visualHandlers.slice();
	  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
	  /**
	   * @private
	   * @type {
	   *     [handlerUID: string]: {
	   *         seriesTaskMap?: {
	   *             [seriesUID: string]: Task
	   *         },
	   *         overallTask?: Task
	   *     }
	   * }
	   */
	
	  this._stageTaskMap = createHashMap();
	}
	
	var proto = Scheduler.prototype;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} payload
	 */
	
	proto.restoreData = function (ecModel, payload) {
	  // TODO: Only restroe needed series and components, but not all components.
	  // Currently `restoreData` of all of the series and component will be called.
	  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
	  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
	  // and some components like coordinate system, axes, dataZoom, visualMap only
	  // need their target series refresh.
	  // (1) If we are implementing this feature some day, we should consider these cases:
	  // if a data processor depends on a component (e.g., dataZoomProcessor depends
	  // on the settings of `dataZoom`), it should be re-performed if the component
	  // is modified by `setOption`.
	  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
	  // it should be re-performed when the result array of `getTargetSeries` changed.
	  // We use `dependencies` to cover these issues.
	  // (3) How to update target series when coordinate system related components modified.
	  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
	  // and this case all of the tasks will be set as dirty.
	  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
	  // depends on all of the series.
	  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
	  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
	  // that the overall task is set as dirty and to be performed, otherwise it probably cause
	  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
	  // probably cause state chaos (consider `dataZoomProcessor`).
	
	  this._stageTaskMap.each(function (taskRecord) {
	    var overallTask = taskRecord.overallTask;
	    overallTask && overallTask.dirty();
	  });
	}; // If seriesModel provided, incremental threshold is check by series data.
	
	
	proto.getPerformArgs = function (task, isBlock) {
	  // For overall task
	  if (!task.__pipeline) {
	    return;
	  }
	
	  var pipeline = this._pipelineMap.get(task.__pipeline.id);
	
	  var pCtx = pipeline.context;
	  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
	  var step = incremental ? pipeline.step : null;
	  var modDataCount = pCtx && pCtx.modDataCount;
	  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
	  return {
	    step: step,
	    modBy: modBy,
	    modDataCount: modDataCount
	  };
	};
	
	proto.getPipeline = function (pipelineId) {
	  return this._pipelineMap.get(pipelineId);
	};
	/**
	 * Current, progressive rendering starts from visual and layout.
	 * Always detect render mode in the same stage, avoiding that incorrect
	 * detection caused by data filtering.
	 * Caution:
	 * `updateStreamModes` use `seriesModel.getData()`.
	 */
	
	
	proto.updateStreamModes = function (seriesModel, view) {
	  var pipeline = this._pipelineMap.get(seriesModel.uid);
	
	  var data = seriesModel.getData();
	  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
	  // animation frame. Note that some types of series do not provide
	  // `view.incrementalPrepareRender` but support `chart.appendData`. We
	  // use the term `incremental` but not `progressive` to describe the
	  // case that `chart.appendData`.
	
	  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
	  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
	  // see `test/candlestick-large3.html`
	
	  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
	  seriesModel.pipelineContext = pipeline.context = {
	    progressiveRender: progressiveRender,
	    modDataCount: modDataCount,
	    large: large
	  };
	};
	
	proto.restorePipelines = function (ecModel) {
	  var scheduler = this;
	  var pipelineMap = scheduler._pipelineMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var progressive = seriesModel.getProgressive();
	    var pipelineId = seriesModel.uid;
	    pipelineMap.set(pipelineId, {
	      id: pipelineId,
	      head: null,
	      tail: null,
	      threshold: seriesModel.getProgressiveThreshold(),
	      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
	      blockIndex: -1,
	      step: Math.round(progressive || 700),
	      count: 0
	    });
	    pipe(scheduler, seriesModel, seriesModel.dataTask);
	  });
	};
	
	proto.prepareStageTasks = function () {
	  var stageTaskMap = this._stageTaskMap;
	  var ecModel = this.ecInstance.getModel();
	  var api = this.api;
	  each(this._allHandlers, function (handler) {
	    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
	    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
	    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
	  }, this);
	};
	
	proto.prepareView = function (view, model, ecModel, api) {
	  var renderTask = view.renderTask;
	  var context = renderTask.context;
	  context.model = model;
	  context.ecModel = ecModel;
	  context.api = api;
	  renderTask.__block = !view.incrementalPrepareRender;
	  pipe(this, model, renderTask);
	};
	
	proto.performDataProcessorTasks = function (ecModel, payload) {
	  // If we do not use `block` here, it should be considered when to update modes.
	  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
	    block: true
	  });
	}; // opt
	// opt.visualType: 'visual' or 'layout'
	// opt.setDirty
	
	
	proto.performVisualTasks = function (ecModel, payload, opt) {
	  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
	};
	
	function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
	  opt = opt || {};
	  var unfinished;
	  each(stageHandlers, function (stageHandler, idx) {
	    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
	      return;
	    }
	
	    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
	
	    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
	    var overallTask = stageHandlerRecord.overallTask;
	
	    if (overallTask) {
	      var overallNeedDirty;
	      var agentStubMap = overallTask.agentStubMap;
	      agentStubMap.each(function (stub) {
	        if (needSetDirty(opt, stub)) {
	          stub.dirty();
	          overallNeedDirty = true;
	        }
	      });
	      overallNeedDirty && overallTask.dirty();
	      updatePayload(overallTask, payload);
	      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
	      // then execute the overall task. And stub will call seriesModel.setData,
	      // which ensures that in the overallTask seriesModel.getData() will not
	      // return incorrect data.
	
	      agentStubMap.each(function (stub) {
	        stub.perform(performArgs);
	      });
	      unfinished |= overallTask.perform(performArgs);
	    } else if (seriesTaskMap) {
	      seriesTaskMap.each(function (task, pipelineId) {
	        if (needSetDirty(opt, task)) {
	          task.dirty();
	        }
	
	        var performArgs = scheduler.getPerformArgs(task, opt.block);
	        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
	        updatePayload(task, payload);
	        unfinished |= task.perform(performArgs);
	      });
	    }
	  });
	
	  function needSetDirty(opt, task) {
	    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
	  }
	
	  scheduler.unfinished |= unfinished;
	}
	
	proto.performSeriesTasks = function (ecModel) {
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    // Progress to the end for dataInit and dataRestore.
	    unfinished |= seriesModel.dataTask.perform();
	  });
	  this.unfinished |= unfinished;
	};
	
	proto.plan = function () {
	  // Travel pipelines, check block.
	  this._pipelineMap.each(function (pipeline) {
	    var task = pipeline.tail;
	
	    do {
	      if (task.__block) {
	        pipeline.blockIndex = task.__idxInPipeline;
	        break;
	      }
	
	      task = task.getUpstream();
	    } while (task);
	  });
	};
	
	var updatePayload = proto.updatePayload = function (task, payload) {
	  payload !== 'remain' && (task.context.payload = payload);
	};
	
	function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
	  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
	  // it works but it may cause other irrelevant charts blocked.
	
	  if (stageHandler.createOnAllSeries) {
	    ecModel.eachRawSeries(create);
	  } else if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, create);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(create);
	  }
	
	  function create(seriesModel) {
	    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
	    // Reuse original task instance.
	
	    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
	      plan: seriesTaskPlan,
	      reset: seriesTaskReset,
	      count: seriesTaskCount
	    }));
	    task.context = {
	      model: seriesModel,
	      ecModel: ecModel,
	      api: api,
	      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
	      plan: stageHandler.plan,
	      reset: stageHandler.reset,
	      scheduler: scheduler
	    };
	    pipe(scheduler, seriesModel, task);
	  } // Clear unused series tasks.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  seriesTaskMap.each(function (task, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      task.dispose();
	      seriesTaskMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
	  || createTask({
	    reset: overallTaskReset
	  });
	  overallTask.context = {
	    ecModel: ecModel,
	    api: api,
	    overallReset: stageHandler.overallReset,
	    scheduler: scheduler
	  }; // Reuse orignal stubs.
	
	  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries;
	  var overallProgress = true;
	  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
	  // stub in each pipelines, it will set the overall task dirty when the pipeline
	  // progress. Moreover, to avoid call the overall task each frame (too frequent),
	  // we set the pipeline block.
	
	  if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, createStub);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(createStub);
	  } // Otherwise, (usually it is legancy case), the overall task will only be
	  // executed when upstream dirty. Otherwise the progressive rendering of all
	  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
	  // dirty info from upsteam.
	  else {
	      overallProgress = false;
	      each(ecModel.getSeries(), createStub);
	    }
	
	  function createStub(seriesModel) {
	    var pipelineId = seriesModel.uid;
	    var stub = agentStubMap.get(pipelineId);
	
	    if (!stub) {
	      stub = agentStubMap.set(pipelineId, createTask({
	        reset: stubReset,
	        onDirty: stubOnDirty
	      })); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	    }
	
	    stub.context = {
	      model: seriesModel,
	      overallProgress: overallProgress,
	      modifyOutputEnd: modifyOutputEnd
	    };
	    stub.agent = overallTask;
	    stub.__block = overallProgress;
	    pipe(scheduler, seriesModel, stub);
	  } // Clear unused stubs.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  agentStubMap.each(function (stub, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	      agentStubMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function overallTaskReset(context) {
	  context.overallReset(context.ecModel, context.api, context.payload);
	}
	
	function stubReset(context, upstreamContext) {
	  return context.overallProgress && stubProgress;
	}
	
	function stubProgress() {
	  this.agent.dirty();
	  this.getDownstream().dirty();
	}
	
	function stubOnDirty() {
	  this.agent && this.agent.dirty();
	}
	
	function seriesTaskPlan(context) {
	  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
	}
	
	function seriesTaskReset(context) {
	  if (context.useClearVisual) {
	    context.data.clearAllVisual();
	  }
	
	  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
	  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
	    return makeSeriesTaskProgress(idx);
	  }) : singleSeriesTaskProgress;
	}
	
	var singleSeriesTaskProgress = makeSeriesTaskProgress(0);
	
	function makeSeriesTaskProgress(resetDefineIdx) {
	  return function (params, context) {
	    var data = context.data;
	    var resetDefine = context.resetDefines[resetDefineIdx];
	
	    if (resetDefine && resetDefine.dataEach) {
	      for (var i = params.start; i < params.end; i++) {
	        resetDefine.dataEach(data, i);
	      }
	    } else if (resetDefine && resetDefine.progress) {
	      resetDefine.progress(params, data);
	    }
	  };
	}
	
	function seriesTaskCount(context) {
	  return context.data.count();
	}
	
	function pipe(scheduler, seriesModel, task) {
	  var pipelineId = seriesModel.uid;
	
	  var pipeline = scheduler._pipelineMap.get(pipelineId);
	
	  !pipeline.head && (pipeline.head = task);
	  pipeline.tail && pipeline.tail.pipe(task);
	  pipeline.tail = task;
	  task.__idxInPipeline = pipeline.count++;
	  task.__pipeline = pipeline;
	}
	
	Scheduler.wrapStageHandler = function (stageHandler, visualType) {
	  if (isFunction(stageHandler)) {
	    stageHandler = {
	      overallReset: stageHandler,
	      seriesType: detectSeriseType(stageHandler)
	    };
	  }
	
	  stageHandler.uid = getUID('stageHandler');
	  visualType && (stageHandler.visualType = visualType);
	  return stageHandler;
	};
	/**
	 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
	 * To ensure that they can work normally, they should work in block mode, that is,
	 * they should not be started util the previous tasks finished. So they cause the
	 * progressive rendering disabled. We try to detect the series type, to narrow down
	 * the block range to only the series type they concern, but not all series.
	 */
	
	
	function detectSeriseType(legacyFunc) {
	  seriesType = null;
	
	  try {
	    // Assume there is no async when calling `eachSeriesByType`.
	    legacyFunc(ecModelMock, apiMock);
	  } catch (e) {}
	
	  return seriesType;
	}
	
	var ecModelMock = {};
	var apiMock = {};
	var seriesType;
	mockMethods(ecModelMock, GlobalModel);
	mockMethods(apiMock, ExtensionAPI);
	
	ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
	  seriesType = type;
	};
	
	ecModelMock.eachComponent = function (cond) {
	  if (cond.mainType === 'series' && cond.subType) {
	    seriesType = cond.subType;
	  }
	};
	
	function mockMethods(target, Clz) {
	  /* eslint-disable */
	  for (var name in Clz.prototype) {
	    // Do not use hasOwnProperty
	    target[name] = noop;
	  }
	  /* eslint-enable */
	
	}
	
	var _default = Scheduler;
	module.exports = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
	var _default = {
	  color: colorAll,
	  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
	};
	module.exports = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var contrastColor = '#eee';
	
	var axisCommon = function () {
	  return {
	    axisLine: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisTick: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisLabel: {
	      textStyle: {
	        color: contrastColor
	      }
	    },
	    splitLine: {
	      lineStyle: {
	        type: 'dashed',
	        color: '#aaa'
	      }
	    },
	    splitArea: {
	      areaStyle: {
	        color: contrastColor
	      }
	    }
	  };
	};
	
	var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
	var theme = {
	  color: colorPalette,
	  backgroundColor: '#333',
	  tooltip: {
	    axisPointer: {
	      lineStyle: {
	        color: contrastColor
	      },
	      crossStyle: {
	        color: contrastColor
	      }
	    }
	  },
	  legend: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  textStyle: {
	    color: contrastColor
	  },
	  title: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  toolbox: {
	    iconStyle: {
	      normal: {
	        borderColor: contrastColor
	      }
	    }
	  },
	  dataZoom: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  visualMap: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  timeline: {
	    lineStyle: {
	      color: contrastColor
	    },
	    itemStyle: {
	      normal: {
	        color: colorPalette[1]
	      }
	    },
	    label: {
	      normal: {
	        textStyle: {
	          color: contrastColor
	        }
	      }
	    },
	    controlStyle: {
	      normal: {
	        color: contrastColor,
	        borderColor: contrastColor
	      }
	    }
	  },
	  timeAxis: axisCommon(),
	  logAxis: axisCommon(),
	  valueAxis: axisCommon(),
	  categoryAxis: axisCommon(),
	  line: {
	    symbol: 'circle'
	  },
	  graph: {
	    color: colorPalette
	  },
	  gauge: {
	    title: {
	      textStyle: {
	        color: contrastColor
	      }
	    }
	  },
	  candlestick: {
	    itemStyle: {
	      normal: {
	        color: '#FD1050',
	        color0: '#0CF49B',
	        borderColor: '#FD1050',
	        borderColor0: '#0CF49B'
	      }
	    }
	  }
	};
	theme.categoryAxis.splitLine.show = false;
	var _default = theme;
	module.exports = _default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentModel = __webpack_require__(215);
	
	var ComponentView = __webpack_require__(237);
	
	var _sourceHelper = __webpack_require__(223);
	
	var detectSourceFormat = _sourceHelper.detectSourceFormat;
	
	var _sourceType = __webpack_require__(226);
	
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * This module is imported by echarts directly.
	 *
	 * Notice:
	 * Always keep this file exists for backward compatibility.
	 * Because before 4.1.0, dataset is an optional component,
	 * some users may import this module manually.
	 */
	ComponentModel.extend({
	  type: 'dataset',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // 'row', 'column'
	    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
	    sourceHeader: null,
	    dimensions: null,
	    source: null
	  },
	  optionUpdated: function () {
	    detectSourceFormat(this);
	  }
	});
	ComponentView.extend({
	  type: 'dataset'
	});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var isString = _util.isString;
	var isArray = _util.isArray;
	var each = _util.each;
	var assert = _util.assert;
	
	var _parseSVG = __webpack_require__(250);
	
	var parseXML = _parseSVG.parseXML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var storage = createHashMap(); // For minimize the code size of common echarts package,
	// do not put too much logic in this module.
	
	var _default = {
	  // The format of record: see `echarts.registerMap`.
	  // Compatible with previous `echarts.registerMap`.
	  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
	    var records;
	
	    if (isArray(rawGeoJson)) {
	      records = rawGeoJson;
	    } else if (rawGeoJson.svg) {
	      records = [{
	        type: 'svg',
	        source: rawGeoJson.svg,
	        specialAreas: rawGeoJson.specialAreas
	      }];
	    } else {
	      // Backward compatibility.
	      if (rawGeoJson.geoJson && !rawGeoJson.features) {
	        rawSpecialAreas = rawGeoJson.specialAreas;
	        rawGeoJson = rawGeoJson.geoJson;
	      }
	
	      records = [{
	        type: 'geoJSON',
	        source: rawGeoJson,
	        specialAreas: rawSpecialAreas
	      }];
	    }
	
	    each(records, function (record) {
	      var type = record.type;
	      type === 'geoJson' && (type = record.type = 'geoJSON');
	      var parse = parsers[type];
	      parse(record);
	    });
	    return storage.set(mapName, records);
	  },
	  retrieveMap: function (mapName) {
	    return storage.get(mapName);
	  }
	};
	var parsers = {
	  geoJSON: function (record) {
	    var source = record.source;
	    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
	  },
	  // Only perform parse to XML object here, which might be time
	  // consiming for large SVG.
	  // Although convert XML to zrender element is also time consiming,
	  // if we do it here, the clone of zrender elements has to be
	  // required. So we do it once for each geo instance, util real
	  // performance issues call for optimizing it.
	  svg: function (record) {
	    record.svgXML = parseXML(record.source);
	  }
	};
	module.exports = _default;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var Group = __webpack_require__(142);
	
	var ZImage = __webpack_require__(163);
	
	var Text = __webpack_require__(194);
	
	var Circle = __webpack_require__(195);
	
	var Rect = __webpack_require__(204);
	
	var Ellipse = __webpack_require__(251);
	
	var Line = __webpack_require__(206);
	
	var Path = __webpack_require__(182);
	
	var Polygon = __webpack_require__(199);
	
	var Polyline = __webpack_require__(203);
	
	var LinearGradient = __webpack_require__(210);
	
	var Style = __webpack_require__(158);
	
	var matrix = __webpack_require__(145);
	
	var _path = __webpack_require__(181);
	
	var createFromString = _path.createFromString;
	
	var _util = __webpack_require__(134);
	
	var isString = _util.isString;
	var extend = _util.extend;
	var defaults = _util.defaults;
	var trim = _util.trim;
	var each = _util.each;
	// import RadialGradient from '../graphic/RadialGradient';
	// import Pattern from '../graphic/Pattern';
	// import * as vector from '../core/vector';
	// Most of the values can be separated by comma and/or white space.
	var DILIMITER_REG = /[\s,]+/;
	/**
	 * For big svg string, this method might be time consuming.
	 *
	 * @param {string} svg xml string
	 * @return {Object} xml root.
	 */
	
	function parseXML(svg) {
	  if (isString(svg)) {
	    var parser = new DOMParser();
	    svg = parser.parseFromString(svg, 'text/xml');
	  } // Document node. If using $.get, doc node may be input.
	
	
	  if (svg.nodeType === 9) {
	    svg = svg.firstChild;
	  } // nodeName of <!DOCTYPE svg> is also 'svg'.
	
	
	  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
	    svg = svg.nextSibling;
	  }
	
	  return svg;
	}
	
	function SVGParser() {
	  this._defs = {};
	  this._root = null;
	  this._isDefine = false;
	  this._isText = false;
	}
	
	SVGParser.prototype.parse = function (xml, opt) {
	  opt = opt || {};
	  var svg = parseXML(xml);
	
	  if (!svg) {
	    throw new Error('Illegal svg');
	  }
	
	  var root = new Group();
	  this._root = root; // parse view port
	
	  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
	  // TODO: Other percent value not supported yet.
	
	  var width = parseFloat(svg.getAttribute('width') || opt.width);
	  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.
	
	  isNaN(width) && (width = null);
	  isNaN(height) && (height = null); // Apply inline style on svg element.
	
	  parseAttributes(svg, root, null, true);
	  var child = svg.firstChild;
	
	  while (child) {
	    this._parseNode(child, root);
	
	    child = child.nextSibling;
	  }
	
	  var viewBoxRect;
	  var viewBoxTransform;
	
	  if (viewBox) {
	    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.
	
	    if (viewBoxArr.length >= 4) {
	      viewBoxRect = {
	        x: parseFloat(viewBoxArr[0] || 0),
	        y: parseFloat(viewBoxArr[1] || 0),
	        width: parseFloat(viewBoxArr[2]),
	        height: parseFloat(viewBoxArr[3])
	      };
	    }
	  }
	
	  if (viewBoxRect && width != null && height != null) {
	    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);
	
	    if (!opt.ignoreViewBox) {
	      // If set transform on the output group, it probably bring trouble when
	      // some users only intend to show the clipped content inside the viewBox,
	      // but not intend to transform the output group. So we keep the output
	      // group no transform. If the user intend to use the viewBox as a
	      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
	      // manually according to the viewBox info in the output of this method.
	      var elRoot = root;
	      root = new Group();
	      root.add(elRoot);
	      elRoot.scale = viewBoxTransform.scale.slice();
	      elRoot.position = viewBoxTransform.position.slice();
	    }
	  } // Some shapes might be overflow the viewport, which should be
	  // clipped despite whether the viewBox is used, as the SVG does.
	
	
	  if (!opt.ignoreRootClip && width != null && height != null) {
	    root.setClipPath(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      }
	    }));
	  } // Set width/height on group just for output the viewport size.
	
	
	  return {
	    root: root,
	    width: width,
	    height: height,
	    viewBoxRect: viewBoxRect,
	    viewBoxTransform: viewBoxTransform
	  };
	};
	
	SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
	  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
	  // support <style>...</style> in svg, where nodeName is 'style',
	  // CSS classes is defined globally wherever the style tags are declared.
	
	  if (nodeName === 'defs') {
	    // define flag
	    this._isDefine = true;
	  } else if (nodeName === 'text') {
	    this._isText = true;
	  }
	
	  var el;
	
	  if (this._isDefine) {
	    var parser = defineParsers[nodeName];
	
	    if (parser) {
	      var def = parser.call(this, xmlNode);
	      var id = xmlNode.getAttribute('id');
	
	      if (id) {
	        this._defs[id] = def;
	      }
	    }
	  } else {
	    var parser = nodeParsers[nodeName];
	
	    if (parser) {
	      el = parser.call(this, xmlNode, parentGroup);
	      parentGroup.add(el);
	    }
	  }
	
	  var child = xmlNode.firstChild;
	
	  while (child) {
	    if (child.nodeType === 1) {
	      this._parseNode(child, el);
	    } // Is text
	
	
	    if (child.nodeType === 3 && this._isText) {
	      this._parseText(child, el);
	    }
	
	    child = child.nextSibling;
	  } // Quit define
	
	
	  if (nodeName === 'defs') {
	    this._isDefine = false;
	  } else if (nodeName === 'text') {
	    this._isText = false;
	  }
	};
	
	SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
	  if (xmlNode.nodeType === 1) {
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX += parseFloat(dx);
	    this._textY += parseFloat(dy);
	  }
	
	  var text = new Text({
	    style: {
	      text: xmlNode.textContent,
	      transformText: true
	    },
	    position: [this._textX || 0, this._textY || 0]
	  });
	  inheritStyle(parentGroup, text);
	  parseAttributes(xmlNode, text, this._defs);
	  var fontSize = text.style.fontSize;
	
	  if (fontSize && fontSize < 9) {
	    // PENDING
	    text.style.fontSize = 9;
	    text.scale = text.scale || [1, 1];
	    text.scale[0] *= fontSize / 9;
	    text.scale[1] *= fontSize / 9;
	  }
	
	  var rect = text.getBoundingRect();
	  this._textX += rect.width;
	  parentGroup.add(text);
	  return text;
	};
	
	var nodeParsers = {
	  'g': function (xmlNode, parentGroup) {
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'rect': function (xmlNode, parentGroup) {
	    var rect = new Rect();
	    inheritStyle(parentGroup, rect);
	    parseAttributes(xmlNode, rect, this._defs);
	    rect.setShape({
	      x: parseFloat(xmlNode.getAttribute('x') || 0),
	      y: parseFloat(xmlNode.getAttribute('y') || 0),
	      width: parseFloat(xmlNode.getAttribute('width') || 0),
	      height: parseFloat(xmlNode.getAttribute('height') || 0)
	    }); // console.log(xmlNode.getAttribute('transform'));
	    // console.log(rect.transform);
	
	    return rect;
	  },
	  'circle': function (xmlNode, parentGroup) {
	    var circle = new Circle();
	    inheritStyle(parentGroup, circle);
	    parseAttributes(xmlNode, circle, this._defs);
	    circle.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      r: parseFloat(xmlNode.getAttribute('r') || 0)
	    });
	    return circle;
	  },
	  'line': function (xmlNode, parentGroup) {
	    var line = new Line();
	    inheritStyle(parentGroup, line);
	    parseAttributes(xmlNode, line, this._defs);
	    line.setShape({
	      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
	      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
	      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
	      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
	    });
	    return line;
	  },
	  'ellipse': function (xmlNode, parentGroup) {
	    var ellipse = new Ellipse();
	    inheritStyle(parentGroup, ellipse);
	    parseAttributes(xmlNode, ellipse, this._defs);
	    ellipse.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
	      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
	    });
	    return ellipse;
	  },
	  'polygon': function (xmlNode, parentGroup) {
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polygon = new Polygon({
	      shape: {
	        points: points || []
	      }
	    });
	    inheritStyle(parentGroup, polygon);
	    parseAttributes(xmlNode, polygon, this._defs);
	    return polygon;
	  },
	  'polyline': function (xmlNode, parentGroup) {
	    var path = new Path();
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polyline = new Polyline({
	      shape: {
	        points: points || []
	      }
	    });
	    return polyline;
	  },
	  'image': function (xmlNode, parentGroup) {
	    var img = new ZImage();
	    inheritStyle(parentGroup, img);
	    parseAttributes(xmlNode, img, this._defs);
	    img.setStyle({
	      image: xmlNode.getAttribute('xlink:href'),
	      x: xmlNode.getAttribute('x'),
	      y: xmlNode.getAttribute('y'),
	      width: xmlNode.getAttribute('width'),
	      height: xmlNode.getAttribute('height')
	    });
	    return img;
	  },
	  'text': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x') || 0;
	    var y = xmlNode.getAttribute('y') || 0;
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX = parseFloat(x) + parseFloat(dx);
	    this._textY = parseFloat(y) + parseFloat(dy);
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'tspan': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x');
	    var y = xmlNode.getAttribute('y');
	
	    if (x != null) {
	      // new offset x
	      this._textX = parseFloat(x);
	    }
	
	    if (y != null) {
	      // new offset y
	      this._textY = parseFloat(y);
	    }
	
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    this._textX += dx;
	    this._textY += dy;
	    return g;
	  },
	  'path': function (xmlNode, parentGroup) {
	    // TODO svg fill rule
	    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
	    // path.style.globalCompositeOperation = 'xor';
	    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.
	
	    var path = createFromString(d);
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    return path;
	  }
	};
	var defineParsers = {
	  'lineargradient': function (xmlNode) {
	    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
	    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
	    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
	    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
	    var gradient = new LinearGradient(x1, y1, x2, y2);
	
	    _parseGradientColorStops(xmlNode, gradient);
	
	    return gradient;
	  },
	  'radialgradient': function (xmlNode) {}
	};
	
	function _parseGradientColorStops(xmlNode, gradient) {
	  var stop = xmlNode.firstChild;
	
	  while (stop) {
	    if (stop.nodeType === 1) {
	      var offset = stop.getAttribute('offset');
	
	      if (offset.indexOf('%') > 0) {
	        // percentage
	        offset = parseInt(offset, 10) / 100;
	      } else if (offset) {
	        // number from 0 to 1
	        offset = parseFloat(offset);
	      } else {
	        offset = 0;
	      }
	
	      var stopColor = stop.getAttribute('stop-color') || '#000000';
	      gradient.addColorStop(offset, stopColor);
	    }
	
	    stop = stop.nextSibling;
	  }
	}
	
	function inheritStyle(parent, child) {
	  if (parent && parent.__inheritedStyle) {
	    if (!child.__inheritedStyle) {
	      child.__inheritedStyle = {};
	    }
	
	    defaults(child.__inheritedStyle, parent.__inheritedStyle);
	  }
	}
	
	function parsePoints(pointsString) {
	  var list = trim(pointsString).split(DILIMITER_REG);
	  var points = [];
	
	  for (var i = 0; i < list.length; i += 2) {
	    var x = parseFloat(list[i]);
	    var y = parseFloat(list[i + 1]);
	    points.push([x, y]);
	  }
	
	  return points;
	}
	
	var attributesMap = {
	  'fill': 'fill',
	  'stroke': 'stroke',
	  'stroke-width': 'lineWidth',
	  'opacity': 'opacity',
	  'fill-opacity': 'fillOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  'stroke-dasharray': 'lineDash',
	  'stroke-dashoffset': 'lineDashOffset',
	  'stroke-linecap': 'lineCap',
	  'stroke-linejoin': 'lineJoin',
	  'stroke-miterlimit': 'miterLimit',
	  'font-family': 'fontFamily',
	  'font-size': 'fontSize',
	  'font-style': 'fontStyle',
	  'font-weight': 'fontWeight',
	  'text-align': 'textAlign',
	  'alignment-baseline': 'textBaseline'
	};
	
	function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
	  var zrStyle = el.__inheritedStyle || {};
	  var isTextEl = el.type === 'text'; // TODO Shadow
	
	  if (xmlNode.nodeType === 1) {
	    parseTransformAttribute(xmlNode, el);
	    extend(zrStyle, parseStyleAttribute(xmlNode));
	
	    if (!onlyInlineStyle) {
	      for (var svgAttrName in attributesMap) {
	        if (attributesMap.hasOwnProperty(svgAttrName)) {
	          var attrValue = xmlNode.getAttribute(svgAttrName);
	
	          if (attrValue != null) {
	            zrStyle[attributesMap[svgAttrName]] = attrValue;
	          }
	        }
	      }
	    }
	  }
	
	  var elFillProp = isTextEl ? 'textFill' : 'fill';
	  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
	  el.style = el.style || new Style();
	  var elStyle = el.style;
	  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
	  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
	  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
	    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
	    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
	  });
	
	  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
	    zrStyle.textBaseline = 'alphabetic';
	  }
	
	  if (zrStyle.textBaseline === 'alphabetic') {
	    zrStyle.textBaseline = 'bottom';
	  }
	
	  if (zrStyle.textAlign === 'start') {
	    zrStyle.textAlign = 'left';
	  }
	
	  if (zrStyle.textAlign === 'end') {
	    zrStyle.textAlign = 'right';
	  }
	
	  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
	    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
	  });
	
	  if (zrStyle.lineDash) {
	    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
	  }
	
	  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
	    // enable stroke
	    el[elStrokeProp] = true;
	  }
	
	  el.__inheritedStyle = zrStyle;
	}
	
	var urlRegex = /url\(\s*#(.*?)\)/;
	
	function getPaint(str, defs) {
	  // if (str === 'none') {
	  //     return;
	  // }
	  var urlMatch = defs && str && str.match(urlRegex);
	
	  if (urlMatch) {
	    var url = trim(urlMatch[1]);
	    var def = defs[url];
	    return def;
	  }
	
	  return str;
	}
	
	var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
	
	function parseTransformAttribute(xmlNode, node) {
	  var transform = xmlNode.getAttribute('transform');
	
	  if (transform) {
	    transform = transform.replace(/,/g, ' ');
	    var m = null;
	    var transformOps = [];
	    transform.replace(transformRegex, function (str, type, value) {
	      transformOps.push(type, value);
	    });
	
	    for (var i = transformOps.length - 1; i > 0; i -= 2) {
	      var value = transformOps[i];
	      var type = transformOps[i - 1];
	      m = m || matrix.create();
	
	      switch (type) {
	        case 'translate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
	          break;
	
	        case 'scale':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
	          break;
	
	        case 'rotate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.rotate(m, m, parseFloat(value[0]));
	          break;
	
	        case 'skew':
	          value = trim(value).split(DILIMITER_REG);
	          console.warn('Skew transform is not supported yet');
	          break;
	
	        case 'matrix':
	          var value = trim(value).split(DILIMITER_REG);
	          m[0] = parseFloat(value[0]);
	          m[1] = parseFloat(value[1]);
	          m[2] = parseFloat(value[2]);
	          m[3] = parseFloat(value[3]);
	          m[4] = parseFloat(value[4]);
	          m[5] = parseFloat(value[5]);
	          break;
	      }
	    }
	
	    node.setLocalTransform(m);
	  }
	} // Value may contain space.
	
	
	var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
	
	function parseStyleAttribute(xmlNode) {
	  var style = xmlNode.getAttribute('style');
	  var result = {};
	
	  if (!style) {
	    return result;
	  }
	
	  var styleList = {};
	  styleRegex.lastIndex = 0;
	  var styleRegResult;
	
	  while ((styleRegResult = styleRegex.exec(style)) != null) {
	    styleList[styleRegResult[1]] = styleRegResult[2];
	  }
	
	  for (var svgAttrName in attributesMap) {
	    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
	      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
	    }
	  }
	
	  return result;
	}
	/**
	 * @param {Array.<number>} viewBoxRect
	 * @param {number} width
	 * @param {number} height
	 * @return {Object} {scale, position}
	 */
	
	
	function makeViewBoxTransform(viewBoxRect, width, height) {
	  var scaleX = width / viewBoxRect.width;
	  var scaleY = height / viewBoxRect.height;
	  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'
	
	  var viewBoxScale = [scale, scale];
	  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
	  return {
	    scale: viewBoxScale,
	    position: viewBoxPosition
	  };
	}
	/**
	 * @param {string|XMLElement} xml
	 * @param {Object} [opt]
	 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
	 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
	 * @param {boolean} [opt.ignoreViewBox]
	 * @param {boolean} [opt.ignoreRootClip]
	 * @return {Object} result:
	 * {
	 *     root: Group, The root of the the result tree of zrender shapes,
	 *     width: number, the viewport width of the SVG,
	 *     height: number, the viewport height of the SVG,
	 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
	 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
	 * }
	 */
	
	
	function parseSVG(xml, opt) {
	  var parser = new SVGParser();
	  return parser.parse(xml, opt);
	}
	
	exports.parseXML = parseXML;
	exports.makeViewBoxTransform = makeViewBoxTransform;
	exports.parseSVG = parseSVG;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(182);
	
	/**
	 * 椭圆形状
	 * @module zrender/graphic/shape/Ellipse
	 */
	var _default = Path.extend({
	  type: 'ellipse',
	  shape: {
	    cx: 0,
	    cy: 0,
	    rx: 0,
	    ry: 0
	  },
	  buildPath: function (ctx, shape) {
	    var k = 0.5522848;
	    var x = shape.cx;
	    var y = shape.cy;
	    var a = shape.rx;
	    var b = shape.ry;
	    var ox = a * k; // 水平控制点偏移量
	
	    var oy = b * k; // 垂直控制点偏移量
	    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线
	
	    ctx.moveTo(x - a, y);
	    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
	    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
	    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
	    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrender = __webpack_require__(131);
	
	exports.zrender = zrender;
	
	var matrix = __webpack_require__(145);
	
	exports.matrix = matrix;
	
	var vector = __webpack_require__(136);
	
	exports.vector = vector;
	
	var zrUtil = __webpack_require__(134);
	
	var colorTool = __webpack_require__(150);
	
	exports.color = colorTool;
	
	var graphicUtil = __webpack_require__(180);
	
	var numberUtil = __webpack_require__(218);
	
	exports.number = numberUtil;
	
	var formatUtil = __webpack_require__(219);
	
	exports.format = formatUtil;
	
	var _throttle = __webpack_require__(240);
	
	var throttle = _throttle.throttle;
	exports.throttle = _throttle.throttle;
	
	var ecHelper = __webpack_require__(253);
	
	exports.helper = ecHelper;
	
	var parseGeoJSON = __webpack_require__(272);
	
	exports.parseGeoJSON = parseGeoJSON;
	
	var _List = __webpack_require__(255);
	
	exports.List = _List;
	
	var _Model = __webpack_require__(174);
	
	exports.Model = _Model;
	
	var _Axis = __webpack_require__(275);
	
	exports.Axis = _Axis;
	
	var _env = __webpack_require__(133);
	
	exports.env = _env;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Do not mount those modules on 'src/echarts' for better tree shaking.
	 */
	var parseGeoJson = parseGeoJSON;
	var ecUtil = {};
	zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
	  ecUtil[name] = zrUtil[name];
	});
	var graphic = {};
	zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
	  graphic[name] = graphicUtil[name];
	});
	exports.parseGeoJson = parseGeoJson;
	exports.util = ecUtil;
	exports.graphic = graphic;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var createListFromArray = __webpack_require__(254);
	
	var axisHelper = __webpack_require__(261);
	
	var axisModelCommonMixin = __webpack_require__(270);
	
	var Model = __webpack_require__(174);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	exports.getLayoutRect = _layout.getLayoutRect;
	
	var _dataStackHelper = __webpack_require__(260);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	var _completeDimensions = __webpack_require__(259);
	
	exports.completeDimensions = _completeDimensions;
	
	var _createDimensions = __webpack_require__(258);
	
	exports.createDimensions = _createDimensions;
	
	var _symbol = __webpack_require__(271);
	
	exports.createSymbol = _symbol.createSymbol;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';
	
	/**
	 * Create a muti dimension List structure from seriesModel.
	 * @param  {module:echarts/model/Model} seriesModel
	 * @return {module:echarts/data/List} list
	 */
	function createList(seriesModel) {
	  return createListFromArray(seriesModel.getSource(), seriesModel);
	} // export function createGraph(seriesModel) {
	//     var nodes = seriesModel.get('data');
	//     var links = seriesModel.get('links');
	//     return createGraphFromNodeEdge(nodes, links, seriesModel);
	// }
	
	
	var dataStack = {
	  isDimensionStacked: isDimensionStacked,
	  enableDataStack: enableDataStack,
	  getStackedDimension: getStackedDimension
	};
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @see http://echarts.baidu.com/option.html#series-scatter.symbol
	 * @param {string} symbolDesc
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 */
	
	/**
	 * Create scale
	 * @param {Array.<number>} dataExtent
	 * @param {Object|module:echarts/Model} option
	 */
	function createScale(dataExtent, option) {
	  var axisModel = option;
	
	  if (!Model.isInstance(option)) {
	    axisModel = new Model(option);
	    zrUtil.mixin(axisModel, axisModelCommonMixin);
	  }
	
	  var scale = axisHelper.createScaleByModel(axisModel);
	  scale.setExtent(dataExtent[0], dataExtent[1]);
	  axisHelper.niceScaleExtent(scale, axisModel);
	  return scale;
	}
	/**
	 * Mixin common methods to axis model,
	 *
	 * Inlcude methods
	 * `getFormattedLabels() => Array.<string>`
	 * `getCategories() => Array.<string>`
	 * `getMin(origin: boolean) => number`
	 * `getMax(origin: boolean) => number`
	 * `getNeedCrossZero() => boolean`
	 * `setRange(start: number, end: number)`
	 * `resetRange()`
	 */
	
	
	function mixinAxisModelCommonMethods(Model) {
	  zrUtil.mixin(Model, axisModelCommonMixin);
	}
	
	exports.createList = createList;
	exports.dataStack = dataStack;
	exports.createScale = createScale;
	exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var List = __webpack_require__(255);
	
	var createDimensions = __webpack_require__(258);
	
	var _sourceType = __webpack_require__(226);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	
	var _dimensionHelper = __webpack_require__(257);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _model = __webpack_require__(173);
	
	var getDataItemValue = _model.getDataItemValue;
	
	var CoordinateSystem = __webpack_require__(228);
	
	var _referHelper = __webpack_require__(224);
	
	var getCoordSysDefineBySeries = _referHelper.getCoordSysDefineBySeries;
	
	var Source = __webpack_require__(225);
	
	var _dataStackHelper = __webpack_require__(260);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/Source|Array} source Or raw data.
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object} [opt]
	 * @param {string} [opt.generateCoord]
	 */
	function createListFromArray(source, seriesModel, opt) {
	  opt = opt || {};
	
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var registeredCoordSys = CoordinateSystem.get(coordSysName);
	  var coordSysDefine = getCoordSysDefineBySeries(seriesModel);
	  var coordSysDimDefs;
	
	  if (coordSysDefine) {
	    coordSysDimDefs = zrUtil.map(coordSysDefine.coordSysDims, function (dim) {
	      var dimInfo = {
	        name: dim
	      };
	      var axisModel = coordSysDefine.axisMap.get(dim);
	
	      if (axisModel) {
	        var axisType = axisModel.get('type');
	        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
	      }
	
	      return dimInfo;
	    });
	  }
	
	  if (!coordSysDimDefs) {
	    // Get dimensions from registered coordinate system
	    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	  }
	
	  var dimInfoList = createDimensions(source, {
	    coordDimensions: coordSysDimDefs,
	    generateCoord: opt.generateCoord
	  });
	  var firstCategoryDimIndex;
	  var hasNameEncode;
	  coordSysDefine && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
	    var coordDim = dimInfo.coordDim;
	    var categoryAxisModel = coordSysDefine.categoryAxisMap.get(coordDim);
	
	    if (categoryAxisModel) {
	      if (firstCategoryDimIndex == null) {
	        firstCategoryDimIndex = dimIndex;
	      }
	
	      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
	    }
	
	    if (dimInfo.otherDims.itemName != null) {
	      hasNameEncode = true;
	    }
	  });
	
	  if (!hasNameEncode && firstCategoryDimIndex != null) {
	    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
	  }
	
	  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
	  var list = new List(dimInfoList, seriesModel);
	  list.setCalculationInfo(stackCalculationInfo);
	  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	    // Use dataIndex as ordinal value in categoryAxis
	    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
	  } : null;
	  list.hasItemOption = false;
	  list.initData(source, null, dimValueGetter);
	  return list;
	}
	
	function isNeedCompleteOrdinalData(source) {
	  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var sampleItem = firstDataNotNull(source.data || []);
	    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
	  }
	}
	
	function firstDataNotNull(data) {
	  var i = 0;
	
	  while (i < data.length && data[i] == null) {
	    i++;
	  }
	
	  return data[i];
	}
	
	var _default = createListFromArray;
	module.exports = _default;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var Model = __webpack_require__(174);
	
	var DataDiffer = __webpack_require__(256);
	
	var Source = __webpack_require__(225);
	
	var _dataProvider = __webpack_require__(235);
	
	var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
	var DefaultDataProvider = _dataProvider.DefaultDataProvider;
	
	var _dimensionHelper = __webpack_require__(257);
	
	var summarizeDimensions = _dimensionHelper.summarizeDimensions;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
	
	/**
	 * List for data storage
	 * @module echarts/data/List
	 */
	var isObject = zrUtil.isObject;
	var UNDEFINED = 'undefined';
	var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
	// which will cause weird udpate animation.
	
	var ID_PREFIX = 'e\0\0';
	var dataCtors = {
	  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
	  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
	  // Ordinal data type can be string or int
	  'ordinal': Array,
	  'number': Array,
	  'time': Array
	}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
	// different from the Ctor of typed array.
	
	var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
	var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
	var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
	
	function getIndicesCtor(list) {
	  // The possible max value in this._indicies is always this._rawCount despite of filtering.
	  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
	}
	
	function cloneChunk(originalChunk) {
	  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
	
	  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
	}
	
	var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
	var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];
	
	function transferProperties(target, source) {
	  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
	    if (source.hasOwnProperty(propName)) {
	      target[propName] = source[propName];
	    }
	  });
	  target.__wrappedMethods = source.__wrappedMethods;
	  zrUtil.each(CLONE_PROPERTIES, function (propName) {
	    target[propName] = zrUtil.clone(source[propName]);
	  });
	  target._calculationInfo = zrUtil.extend(source._calculationInfo);
	}
	/**
	 * @constructor
	 * @alias module:echarts/data/List
	 *
	 * @param {Array.<string|Object>} dimensions
	 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	 *      Spetial fields: {
	 *          ordinalMeta: <module:echarts/data/OrdinalMeta>
	 *          createInvertedIndices: <boolean>
	 *      }
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	
	var List = function (dimensions, hostModel) {
	  dimensions = dimensions || ['x', 'y'];
	  var dimensionInfos = {};
	  var dimensionNames = [];
	  var invertedIndicesMap = {};
	
	  for (var i = 0; i < dimensions.length; i++) {
	    // Use the original dimensions[i], where other flag props may exists.
	    var dimensionInfo = dimensions[i];
	
	    if (zrUtil.isString(dimensionInfo)) {
	      dimensionInfo = {
	        name: dimensionInfo
	      };
	    }
	
	    var dimensionName = dimensionInfo.name;
	    dimensionInfo.type = dimensionInfo.type || 'float';
	
	    if (!dimensionInfo.coordDim) {
	      dimensionInfo.coordDim = dimensionName;
	      dimensionInfo.coordDimIndex = 0;
	    }
	
	    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	    dimensionNames.push(dimensionName);
	    dimensionInfos[dimensionName] = dimensionInfo;
	    dimensionInfo.index = i;
	
	    if (dimensionInfo.createInvertedIndices) {
	      invertedIndicesMap[dimensionName] = [];
	    }
	  }
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	
	
	  this.dimensions = dimensionNames;
	  /**
	   * Infomation of each data dimension, like data type.
	   * @type {Object}
	   */
	
	  this._dimensionInfos = dimensionInfos;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.dataType;
	  /**
	   * Indices stores the indices of data subset after filtered.
	   * This data subset will be used in chart.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	
	  this._indices = null;
	  this._count = 0;
	  this._rawCount = 0;
	  /**
	   * Data storage
	   * @type {Object.<key, Array.<TypedArray|Array>>}
	   * @private
	   */
	
	  this._storage = {};
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._nameList = [];
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._idList = [];
	  /**
	   * Models of data option is stored sparse for optimizing memory cost
	   * @type {Array.<module:echarts/model/Model>}
	   * @private
	   */
	
	  this._optionModels = [];
	  /**
	   * Global visual properties after visual coding
	   * @type {Object}
	   * @private
	   */
	
	  this._visual = {};
	  /**
	   * Globel layout properties.
	   * @type {Object}
	   * @private
	   */
	
	  this._layout = {};
	  /**
	   * Item visual properties after visual coding
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemVisuals = [];
	  /**
	   * Key: visual type, Value: boolean
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.hasItemVisual = {};
	  /**
	   * Item layout properties after layout
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemLayouts = [];
	  /**
	   * Graphic elemnents
	   * @type {Array.<module:zrender/Element>}
	   * @private
	   */
	
	  this._graphicEls = [];
	  /**
	   * Max size of each chunk.
	   * @type {number}
	   * @private
	   */
	
	  this._chunkSize = 1e5;
	  /**
	   * @type {number}
	   * @private
	   */
	
	  this._chunkCount = 0;
	  /**
	   * @type {Array.<Array|Object>}
	   * @private
	   */
	
	  this._rawData;
	  /**
	   * Raw extent will not be cloned, but only transfered.
	   * It will not be calculated util needed.
	   * key: dim,
	   * value: {end: number, extent: Array.<number>}
	   * @type {Object}
	   * @private
	   */
	
	  this._rawExtent = {};
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._extent = {};
	  /**
	   * key: dim
	   * value: extent
	   * @type {Object}
	   * @private
	   */
	
	  this._approximateExtent = {};
	  /**
	   * Cache summary info for fast visit. See "dimensionHelper".
	   * @type {Object}
	   * @private
	   */
	
	  this._dimensionsSummary = summarizeDimensions(this);
	  /**
	   * @type {Object.<Array|TypedArray>}
	   * @private
	   */
	
	  this._invertedIndicesMap = invertedIndicesMap;
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._calculationInfo = {};
	};
	
	var listProto = List.prototype;
	listProto.type = 'list';
	/**
	 * If each data item has it's own option
	 * @type {boolean}
	 */
	
	listProto.hasItemOption = true;
	/**
	 * Get dimension name
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 * @return {string} Concrete dim name.
	 */
	
	listProto.getDimension = function (dim) {
	  if (!isNaN(dim)) {
	    dim = this.dimensions[dim] || dim;
	  }
	
	  return dim;
	};
	/**
	 * Get type and calculation info of particular dimension
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 */
	
	
	listProto.getDimensionInfo = function (dim) {
	  // Do not clone, because there may be categories in dimInfo.
	  return this._dimensionInfos[this.getDimension(dim)];
	};
	/**
	 * @return {Array.<string>} concrete dimension name list on coord.
	 */
	
	
	listProto.getDimensionsOnCoord = function () {
	  return this._dimensionsSummary.dataDimsOnCoord.slice();
	};
	/**
	 * @param {string} coordDim
	 * @param {number} [idx] A coordDim may map to more than one data dim.
	 *        If idx is `true`, return a array of all mapped dims.
	 *        If idx is not specified, return the first dim not extra.
	 * @return {string|Array.<string>} concrete data dim.
	 *        If idx is number, and not found, return null/undefined.
	 *        If idx is `true`, and not found, return empty array (always return array).
	 */
	
	
	listProto.mapDimension = function (coordDim, idx) {
	  var dimensionsSummary = this._dimensionsSummary;
	
	  if (idx == null) {
	    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
	  }
	
	  var dims = dimensionsSummary.encode[coordDim];
	  return idx === true // always return array if idx is `true`
	  ? (dims || []).slice() : dims && dims[idx];
	};
	/**
	 * Initialize from data
	 * @param {Array.<Object|number|Array>} data source or data or data provider.
	 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
	 *        defualt label/tooltip.
	 *        A name can be specified in encode.itemName,
	 *        or dataItem.name (only for series option data),
	 *        or provided in nameList from outside.
	 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
	 */
	
	
	listProto.initData = function (data, nameList, dimValueGetter) {
	  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);
	
	  if (notProvider) {
	    data = new DefaultDataProvider(data, this.dimensions.length);
	  }
	
	  this._rawData = data; // Clear
	
	  this._storage = {};
	  this._indices = null;
	  this._nameList = nameList || [];
	  this._idList = [];
	  this._nameRepeatCount = {};
	
	  if (!dimValueGetter) {
	    this.hasItemOption = false;
	  }
	  /**
	   * @readOnly
	   */
	
	
	  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter
	
	  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
	  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.
	
	  this._rawExtent = {};
	
	  this._initDataFromProvider(0, data.count()); // If data has no item option.
	
	
	  if (data.pure) {
	    this.hasItemOption = false;
	  }
	};
	
	listProto.getProvider = function () {
	  return this._rawData;
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 */
	
	
	listProto.appendData = function (data) {
	  var rawData = this._rawData;
	  var start = this.count();
	  rawData.appendData(data);
	  var end = rawData.count();
	
	  if (!rawData.persistent) {
	    end += start;
	  }
	
	  this._initDataFromProvider(start, end);
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 * This method does not modify `rawData` (`dataProvider`), but only
	 * add values to storage.
	 *
	 * The final count will be increased by `Math.max(values.length, names.length)`.
	 *
	 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
	 *        [
	 *            [12, 33, 44],
	 *            [NaN, 43, 1],
	 *            ['-', 'asdf', 0]
	 *        ]
	 *        Each item is exaclty cooresponding to a dimension.
	 * @param {Array.<string>} [names]
	 */
	
	
	listProto.appendValues = function (values, names) {
	  var chunkSize = this._chunkSize;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var rawExtent = this._rawExtent;
	  var start = this.count();
	  var end = start + Math.max(values.length, names ? names.length : 0);
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var emptyDataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    var sourceIdx = idx - start;
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	
	      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);
	
	      storage[dim][chunkIndex][chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    }
	
	    if (names) {
	      this._nameList[idx] = names[sourceIdx];
	    }
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	listProto._initDataFromProvider = function (start, end) {
	  // Optimize.
	  if (start >= end) {
	    return;
	  }
	
	  var chunkSize = this._chunkSize;
	  var rawData = this._rawData;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var dimensionInfoMap = this._dimensionInfos;
	  var nameList = this._nameList;
	  var idList = this._idList;
	  var rawExtent = this._rawExtent;
	  var nameRepeatCount = this._nameRepeatCount = {};
	  var nameDimIdx;
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    var dimInfo = dimensionInfoMap[dim];
	
	    if (dimInfo.otherDims.itemName === 0) {
	      nameDimIdx = this._nameDimIdx = i;
	    }
	
	    if (dimInfo.otherDims.itemId === 0) {
	      this._idDimIdx = i;
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var dataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    // NOTICE: Try not to write things into dataItem
	    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
	    // [1, 2]
	    // 2
	    // Bar chart, line chart which uses category axis
	    // only gives the 'y' value. 'x' value is the indices of category
	    // Use a tempValue to normalize the value to be a (x, y) value
	
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero
	
	      var val = this._dimValueGetter(dataItem, dim, idx, k);
	
	      dimStorage[chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    } // ??? FIXME not check by pure but sourceFormat?
	    // TODO refactor these logic.
	
	
	    if (!rawData.pure) {
	      var name = nameList[idx];
	
	      if (dataItem && name == null) {
	        // If dataItem is {name: ...}, it has highest priority.
	        // That is appropriate for many common cases.
	        if (dataItem.name != null) {
	          // There is no other place to persistent dataItem.name,
	          // so save it to nameList.
	          nameList[idx] = name = dataItem.name;
	        } else if (nameDimIdx != null) {
	          var nameDim = dimensions[nameDimIdx];
	          var nameDimChunk = storage[nameDim][chunkIndex];
	
	          if (nameDimChunk) {
	            name = nameDimChunk[chunkOffset];
	            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;
	
	            if (ordinalMeta && ordinalMeta.categories.length) {
	              name = ordinalMeta.categories[name];
	            }
	          }
	        }
	      } // Try using the id in option
	      // id or name is used on dynamical data, mapping old and new items.
	
	
	      var id = dataItem == null ? null : dataItem.id;
	
	      if (id == null && name != null) {
	        // Use name as id and add counter to avoid same name
	        nameRepeatCount[name] = nameRepeatCount[name] || 0;
	        id = name;
	
	        if (nameRepeatCount[name] > 0) {
	          id += '__ec__' + nameRepeatCount[name];
	        }
	
	        nameRepeatCount[name]++;
	      }
	
	      id != null && (idList[idx] = id);
	    }
	  }
	
	  if (!rawData.persistent && rawData.clean) {
	    // Clean unused data if data source is typed array.
	    rawData.clean();
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
	  var DataCtor = dataCtors[dimInfo.type];
	  var lastChunkIndex = chunkCount - 1;
	  var dim = dimInfo.name;
	  var resizeChunkArray = storage[dim][lastChunkIndex];
	
	  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
	    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
	    // within the initial chunkSize.
	
	    for (var j = 0; j < resizeChunkArray.length; j++) {
	      newStore[j] = resizeChunkArray[j];
	    }
	
	    storage[dim][lastChunkIndex] = newStore;
	  } // Create new chunks.
	
	
	  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
	    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
	  }
	}
	
	function prepareInvertedIndex(list) {
	  var invertedIndicesMap = list._invertedIndicesMap;
	  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
	    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
	
	    var ordinalMeta = dimInfo.ordinalMeta;
	
	    if (ordinalMeta) {
	      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
	      // mapping to 0, we should set it as INDEX_NOT_FOUND.
	
	      for (var i = 0; i < invertedIndices.length; i++) {
	        invertedIndices[i] = INDEX_NOT_FOUND;
	      }
	
	      for (var i = 0; i < list._count; i++) {
	        // Only support the case that all values are distinct.
	        invertedIndices[list.get(dim, i)] = i;
	      }
	    }
	  });
	}
	
	function getRawValueFromStore(list, dimIndex, rawIndex) {
	  var val;
	
	  if (dimIndex != null) {
	    var chunkSize = list._chunkSize;
	    var chunkIndex = Math.floor(rawIndex / chunkSize);
	    var chunkOffset = rawIndex % chunkSize;
	    var dim = list.dimensions[dimIndex];
	    var chunk = list._storage[dim][chunkIndex];
	
	    if (chunk) {
	      val = chunk[chunkOffset];
	      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;
	
	      if (ordinalMeta && ordinalMeta.categories.length) {
	        val = ordinalMeta.categories[val];
	      }
	    }
	  }
	
	  return val;
	}
	/**
	 * @return {number}
	 */
	
	
	listProto.count = function () {
	  return this._count;
	};
	
	listProto.getIndices = function () {
	  var newIndices;
	  var indices = this._indices;
	
	  if (indices) {
	    var Ctor = indices.constructor;
	    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
	
	    if (Ctor === Array) {
	      newIndices = new Ctor(thisCount);
	
	      for (var i = 0; i < thisCount; i++) {
	        newIndices[i] = indices[i];
	      }
	    } else {
	      newIndices = new Ctor(indices.buffer, 0, thisCount);
	    }
	  } else {
	    var Ctor = getIndicesCtor(this);
	    var newIndices = new Ctor(this.count());
	
	    for (var i = 0; i < newIndices.length; i++) {
	      newIndices[i] = i;
	    }
	  }
	
	  return newIndices;
	};
	/**
	 * Get value. Return NaN if idx is out of range.
	 * @param {string} dim Dim must be concrete name.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.get = function (dim, idx
	/*, stack */
	) {
	  if (!(idx >= 0 && idx < this._count)) {
	    return NaN;
	  }
	
	  var storage = this._storage;
	
	  if (!storage[dim]) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  idx = this.getRawIndex(idx);
	  var chunkIndex = Math.floor(idx / this._chunkSize);
	  var chunkOffset = idx % this._chunkSize;
	  var chunkStore = storage[dim][chunkIndex];
	  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
	  // if (stack) {
	  //     var dimensionInfo = this._dimensionInfos[dim];
	  //     if (dimensionInfo && dimensionInfo.stackable) {
	  //         var stackedOn = this.stackedOn;
	  //         while (stackedOn) {
	  //             // Get no stacked data of stacked on
	  //             var stackedValue = stackedOn.get(dim, idx);
	  //             // Considering positive stack, negative stack and empty data
	  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
	  //                 || (value <= 0 && stackedValue < 0) // Negative stack
	  //             ) {
	  //                 value += stackedValue;
	  //             }
	  //             stackedOn = stackedOn.stackedOn;
	  //         }
	  //     }
	  // }
	
	  return value;
	};
	/**
	 * @param {string} dim concrete dim
	 * @param {number} rawIndex
	 * @return {number|string}
	 */
	
	
	listProto.getByRawIndex = function (dim, rawIdx) {
	  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
	    return NaN;
	  }
	
	  var dimStore = this._storage[dim];
	
	  if (!dimStore) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = dimStore[chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
	 * Hack a much simpler _getFast
	 * @private
	 */
	
	
	listProto._getFast = function (dim, rawIdx) {
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = this._storage[dim][chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * Get value for multi dimensions.
	 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getValues = function (dimensions, idx
	/*, stack */
	) {
	  var values = [];
	
	  if (!zrUtil.isArray(dimensions)) {
	    // stack = idx;
	    idx = dimensions;
	    dimensions = this.dimensions;
	  }
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    values.push(this.get(dimensions[i], idx
	    /*, stack */
	    ));
	  }
	
	  return values;
	};
	/**
	 * If value is NaN. Inlcuding '-'
	 * Only check the coord dimensions.
	 * @param {string} dim
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.hasValue = function (idx) {
	  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;
	  var dimensionInfos = this._dimensionInfos;
	
	  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
	    if ( // Ordinal type can be string or number
	    dimensionInfos[dataDimsOnCoord[i]].type !== 'ordinal' // FIXME check ordinal when using index?
	    && isNaN(this.get(dataDimsOnCoord[i], idx))) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Get extent of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 */
	
	
	listProto.getDataExtent = function (dim
	/*, stack */
	) {
	  // Make sure use concrete dim as cache name.
	  dim = this.getDimension(dim);
	  var dimData = this._storage[dim];
	  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));
	
	  if (!dimData) {
	    return initialExtent;
	  } // Make more strict checkings to ensure hitting cache.
	
	
	  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
	  // var cacheName = dim;
	  // Consider the most cases when using data zoom, `getDataExtent`
	  // happened before filtering. We cache raw extent, which is not
	  // necessary to be cleared and recalculated when restore data.
	
	  var useRaw = !this._indices; // && !stack;
	
	  var dimExtent;
	
	  if (useRaw) {
	    return this._rawExtent[dim].slice();
	  }
	
	  dimExtent = this._extent[dim];
	
	  if (dimExtent) {
	    return dimExtent.slice();
	  }
	
	  dimExtent = initialExtent;
	  var min = dimExtent[0];
	  var max = dimExtent[1];
	
	  for (var i = 0; i < currEnd; i++) {
	    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
	    var value = this._getFast(dim, this.getRawIndex(i));
	
	    value < min && (min = value);
	    value > max && (max = value);
	  }
	
	  dimExtent = [min, max];
	  this._extent[dim] = dimExtent;
	  return dimExtent;
	};
	/**
	 * Optimize for the scenario that data is filtered by a given extent.
	 * Consider that if data amount is more than hundreds of thousand,
	 * extent calculation will cost more than 10ms and the cache will
	 * be erased because of the filtering.
	 */
	
	
	listProto.getApproximateExtent = function (dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  return this._approximateExtent[dim] || this.getDataExtent(dim
	  /*, stack */
	  );
	};
	
	listProto.setApproximateExtent = function (extent, dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  this._approximateExtent[dim] = extent.slice();
	};
	/**
	 * @param {string} key
	 * @return {*}
	 */
	
	
	listProto.getCalculationInfo = function (key) {
	  return this._calculationInfo[key];
	};
	/**
	 * @param {string|Object} key or k-v object
	 * @param {*} [value]
	 */
	
	
	listProto.setCalculationInfo = function (key, value) {
	  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
	};
	/**
	 * Get sum of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getSum = function (dim
	/*, stack */
	) {
	  var dimData = this._storage[dim];
	  var sum = 0;
	
	  if (dimData) {
	    for (var i = 0, len = this.count(); i < len; i++) {
	      var value = this.get(dim, i
	      /*, stack */
	      );
	
	      if (!isNaN(value)) {
	        sum += value;
	      }
	    }
	  }
	
	  return sum;
	};
	/**
	 * Get median of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getMedian = function (dim
	/*, stack */
	) {
	  var dimDataArray = []; // map all data of one dimension
	
	  this.each(dim, function (val, idx) {
	    if (!isNaN(val)) {
	      dimDataArray.push(val);
	    }
	  }); // TODO
	  // Use quick select?
	  // immutability & sort
	
	  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
	    return a - b;
	  });
	  var len = this.count(); // calculate median
	
	  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
	}; // /**
	//  * Retreive the index with given value
	//  * @param {string} dim Concrete dimension.
	//  * @param {number} value
	//  * @return {number}
	//  */
	// Currently incorrect: should return dataIndex but not rawIndex.
	// Do not fix it until this method is to be used somewhere.
	// FIXME Precision of float value
	// listProto.indexOf = function (dim, value) {
	//     var storage = this._storage;
	//     var dimData = storage[dim];
	//     var chunkSize = this._chunkSize;
	//     if (dimData) {
	//         for (var i = 0, len = this.count(); i < len; i++) {
	//             var chunkIndex = Math.floor(i / chunkSize);
	//             var chunkOffset = i % chunkSize;
	//             if (dimData[chunkIndex][chunkOffset] === value) {
	//                 return i;
	//             }
	//         }
	//     }
	//     return -1;
	// };
	
	/**
	 * Only support the dimension which inverted index created.
	 * Do not support other cases until required.
	 * @param {string} concrete dim
	 * @param {number|string} value
	 * @return {number} rawIndex
	 */
	
	
	listProto.rawIndexOf = function (dim, value) {
	  var invertedIndices = dim && this._invertedIndicesMap[dim];
	  var rawIndex = invertedIndices[value];
	
	  if (rawIndex == null || isNaN(rawIndex)) {
	    return INDEX_NOT_FOUND;
	  }
	
	  return rawIndex;
	};
	/**
	 * Retreive the index with given name
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfName = function (name) {
	  for (var i = 0, len = this.count(); i < len; i++) {
	    if (this.getName(i) === name) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given raw data index
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfRawIndex = function (rawIndex) {
	  if (!this._indices) {
	    return rawIndex;
	  }
	
	  if (rawIndex >= this._rawCount || rawIndex < 0) {
	    return -1;
	  } // Indices are ascending
	
	
	  var indices = this._indices; // If rawIndex === dataIndex
	
	  var rawDataIndex = indices[rawIndex];
	
	  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
	    return rawIndex;
	  }
	
	  var left = 0;
	  var right = this._count - 1;
	
	  while (left <= right) {
	    var mid = (left + right) / 2 | 0;
	
	    if (indices[mid] < rawIndex) {
	      left = mid + 1;
	    } else if (indices[mid] > rawIndex) {
	      right = mid - 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index of nearest value
	 * @param {string} dim
	 * @param {number} value
	 * @param {number} [maxDistance=Infinity]
	 * @return {Array.<number>} Considere multiple points has the same value.
	 */
	
	
	listProto.indicesOfNearest = function (dim, value, maxDistance) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var nearestIndices = [];
	
	  if (!dimData) {
	    return nearestIndices;
	  }
	
	  if (maxDistance == null) {
	    maxDistance = Infinity;
	  }
	
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	
	  for (var i = 0, len = this.count(); i < len; i++) {
	    var diff = value - this.get(dim, i
	    /*, stack */
	    );
	    var dist = Math.abs(diff);
	
	    if (diff <= maxDistance && dist <= minDist) {
	      // For the case of two data are same on xAxis, which has sequence data.
	      // Show the nearest index
	      // https://github.com/ecomfe/echarts/issues/2869
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        nearestIndices.length = 0;
	      }
	
	      nearestIndices.push(i);
	    }
	  }
	
	  return nearestIndices;
	};
	/**
	 * Get raw data index
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawIndex = getRawIndexWithoutIndices;
	
	function getRawIndexWithoutIndices(idx) {
	  return idx;
	}
	
	function getRawIndexWithIndices(idx) {
	  if (idx < this._count && idx >= 0) {
	    return this._indices[idx];
	  }
	
	  return -1;
	}
	/**
	 * Get raw data item
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawDataItem = function (idx) {
	  if (!this._rawData.persistent) {
	    var val = [];
	
	    for (var i = 0; i < this.dimensions.length; i++) {
	      var dim = this.dimensions[i];
	      val.push(this.get(dim, idx));
	    }
	
	    return val;
	  } else {
	    return this._rawData.getItem(this.getRawIndex(idx));
	  }
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getName = function (idx) {
	  var rawIndex = this.getRawIndex(idx);
	  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getId = function (idx) {
	  return getId(this, this.getRawIndex(idx));
	};
	
	function getId(list, rawIndex) {
	  var id = list._idList[rawIndex];
	
	  if (id == null) {
	    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
	  }
	
	  if (id == null) {
	    // FIXME Check the usage in graph, should not use prefix.
	    id = ID_PREFIX + rawIndex;
	  }
	
	  return id;
	}
	
	function normalizeDimensions(dimensions) {
	  if (!zrUtil.isArray(dimensions)) {
	    dimensions = [dimensions];
	  }
	
	  return dimensions;
	}
	
	function validateDimensions(list, dims) {
	  for (var i = 0; i < dims.length; i++) {
	    // stroage may be empty when no data, so use
	    // dimensionInfos to check.
	    if (!list._dimensionInfos[dims[i]]) {
	      console.error('Unkown dimension ' + dims[i]);
	    }
	  }
	}
	/**
	 * Data iteration
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 *
	 * @example
	 *  list.each('x', function (x, idx) {});
	 *  list.each(['x', 'y'], function (x, y, idx) {});
	 *  list.each(function (idx) {})
	 */
	
	
	listProto.each = function (dims, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dims === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dims;
	    dims = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
	  var dimSize = dims.length;
	
	  for (var i = 0; i < this.count(); i++) {
	    // Simple optimization
	    switch (dimSize) {
	      case 0:
	        cb.call(context, i);
	        break;
	
	      case 1:
	        cb.call(context, this.get(dims[0], i), i);
	        break;
	
	      case 2:
	        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
	        break;
	
	      default:
	        var k = 0;
	        var value = [];
	
	        for (; k < dimSize; k++) {
	          value[k] = this.get(dims[k], i);
	        } // Index
	
	
	        value[k] = i;
	        cb.apply(context, value);
	    }
	  }
	};
	/**
	 * Data filter
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 */
	
	
	listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var count = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(count);
	  var value = [];
	  var dimSize = dimensions.length;
	  var offset = 0;
	  var dim0 = dimensions[0];
	
	  for (var i = 0; i < count; i++) {
	    var keep;
	    var rawIdx = this.getRawIndex(i); // Simple optimization
	
	    if (dimSize === 0) {
	      keep = cb.call(context, i);
	    } else if (dimSize === 1) {
	      var val = this._getFast(dim0, rawIdx);
	
	      keep = cb.call(context, val, i);
	    } else {
	      for (var k = 0; k < dimSize; k++) {
	        value[k] = this._getFast(dim0, rawIdx);
	      }
	
	      value[k] = i;
	      keep = cb.apply(context, value);
	    }
	
	    if (keep) {
	      newIndices[offset++] = rawIdx;
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < count) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Select data in range. (For optimization of filter)
	 * (Manually inline code, support 5 million data filtering in data zoom.)
	 */
	
	
	listProto.selectRange = function (range) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  var dimensions = [];
	
	  for (var dim in range) {
	    if (range.hasOwnProperty(dim)) {
	      dimensions.push(dim);
	    }
	  }
	
	  var dimSize = dimensions.length;
	
	  if (!dimSize) {
	    return;
	  }
	
	  var originalCount = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(originalCount);
	  var offset = 0;
	  var dim0 = dimensions[0];
	  var min = range[dim0][0];
	  var max = range[dim0][1];
	  var quickFinished = false;
	
	  if (!this._indices) {
	    // Extreme optimization for common case. About 2x faster in chrome.
	    var idx = 0;
	
	    if (dimSize === 1) {
	      var dimStorage = this._storage[dimensions[0]];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
	          // value indicates the line should be broken. But for the case like
	          // scatter plot, a data item with empty value will not be rendered,
	          // but the axis extent may be effected if some other dim of the data
	          // item has value. Fortunately it is not a significant negative effect.
	
	          if (val >= min && val <= max || isNaN(val)) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    } else if (dimSize === 2) {
	      var dimStorage = this._storage[dim0];
	      var dimStorage2 = this._storage[dimensions[1]];
	      var min2 = range[dimensions[1]][0];
	      var max2 = range[dimensions[1]][1];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var chunkStorage2 = dimStorage2[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i];
	          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.
	
	          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    }
	  }
	
	  if (!quickFinished) {
	    if (dimSize === 1) {
	      for (var i = 0; i < originalCount; i++) {
	        var rawIndex = this.getRawIndex(i);
	
	        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.
	
	
	        if (val >= min && val <= max || isNaN(val)) {
	          newIndices[offset++] = rawIndex;
	        }
	      }
	    } else {
	      for (var i = 0; i < originalCount; i++) {
	        var keep = true;
	        var rawIndex = this.getRawIndex(i);
	
	        for (var k = 0; k < dimSize; k++) {
	          var dimk = dimensions[k];
	
	          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.
	
	
	          if (val < range[dimk][0] || val > range[dimk][1]) {
	            keep = false;
	          }
	        }
	
	        if (keep) {
	          newIndices[offset++] = this.getRawIndex(i);
	        }
	      }
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < originalCount) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Data mapping to a plain array
	 * @param {string|Array.<string>} [dimensions]
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.mapArray = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  var result = [];
	  this.each(dimensions, function () {
	    result.push(cb && cb.apply(this, arguments));
	  }, context);
	  return result;
	}; // Data in excludeDimensions is copied, otherwise transfered.
	
	
	function cloneListForMapAndSample(original, excludeDimensions) {
	  var allDimensions = original.dimensions;
	  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	  transferProperties(list, original);
	  var storage = list._storage = {};
	  var originalStorage = original._storage; // Init storage
	
	  for (var i = 0; i < allDimensions.length; i++) {
	    var dim = allDimensions[i];
	
	    if (originalStorage[dim]) {
	      // Notice that we do not reset invertedIndicesMap here, becuase
	      // there is no scenario of mapping or sampling ordinal dimension.
	      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
	        storage[dim] = cloneDimStore(originalStorage[dim]);
	        list._rawExtent[dim] = getInitialExtent();
	        list._extent[dim] = null;
	      } else {
	        // Direct reference for other dimensions
	        storage[dim] = originalStorage[dim];
	      }
	    }
	  }
	
	  return list;
	}
	
	function cloneDimStore(originalDimStore) {
	  var newDimStore = new Array(originalDimStore.length);
	
	  for (var j = 0; j < originalDimStore.length; j++) {
	    newDimStore[j] = cloneChunk(originalDimStore[j]);
	  }
	
	  return newDimStore;
	}
	
	function getInitialExtent() {
	  return [Infinity, -Infinity];
	}
	/**
	 * Data mapping to a new List with given dimensions
	 * @param {string|Array.<string>} dimensions
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.map = function (dimensions, cb, context, contextCompat) {
	  'use strict'; // contextCompat just for compat echarts3
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
	  // So we can reference to the same value
	
	  list._indices = this._indices;
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  var storage = list._storage;
	  var tmpRetValue = [];
	  var chunkSize = this._chunkSize;
	  var dimSize = dimensions.length;
	  var dataCount = this.count();
	  var values = [];
	  var rawExtent = list._rawExtent;
	
	  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
	    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
	      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
	      /*, stack */
	      );
	    }
	
	    values[dimSize] = dataIndex;
	    var retValue = cb && cb.apply(context, values);
	
	    if (retValue != null) {
	      // a number or string (in oridinal dimension)?
	      if (typeof retValue !== 'object') {
	        tmpRetValue[0] = retValue;
	        retValue = tmpRetValue;
	      }
	
	      var rawIndex = this.getRawIndex(dataIndex);
	      var chunkIndex = Math.floor(rawIndex / chunkSize);
	      var chunkOffset = rawIndex % chunkSize;
	
	      for (var i = 0; i < retValue.length; i++) {
	        var dim = dimensions[i];
	        var val = retValue[i];
	        var rawExtentOnDim = rawExtent[dim];
	        var dimStore = storage[dim];
	
	        if (dimStore) {
	          dimStore[chunkIndex][chunkOffset] = val;
	        }
	
	        if (val < rawExtentOnDim[0]) {
	          rawExtentOnDim[0] = val;
	        }
	
	        if (val > rawExtentOnDim[1]) {
	          rawExtentOnDim[1] = val;
	        }
	      }
	    }
	  }
	
	  return list;
	};
	/**
	 * Large data down sampling on given dimension
	 * @param {string} dimension
	 * @param {number} rate
	 * @param {Function} sampleValue
	 * @param {Function} sampleIndex Sample index for name and id
	 */
	
	
	listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	  var list = cloneListForMapAndSample(this, [dimension]);
	  var targetStorage = list._storage;
	  var frameValues = [];
	  var frameSize = Math.floor(1 / rate);
	  var dimStore = targetStorage[dimension];
	  var len = this.count();
	  var chunkSize = this._chunkSize;
	  var rawExtentOnDim = list._rawExtent[dimension];
	  var newIndices = new (getIndicesCtor(this))(len);
	  var offset = 0;
	
	  for (var i = 0; i < len; i += frameSize) {
	    // Last frame
	    if (frameSize > len - i) {
	      frameSize = len - i;
	      frameValues.length = frameSize;
	    }
	
	    for (var k = 0; k < frameSize; k++) {
	      var dataIdx = this.getRawIndex(i + k);
	      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
	      var originalChunkOffset = dataIdx % chunkSize;
	      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
	    }
	
	    var value = sampleValue(frameValues);
	    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
	    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
	    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data
	
	    dimStore[sampleChunkIndex][sampleChunkOffset] = value;
	
	    if (value < rawExtentOnDim[0]) {
	      rawExtentOnDim[0] = value;
	    }
	
	    if (value > rawExtentOnDim[1]) {
	      rawExtentOnDim[1] = value;
	    }
	
	    newIndices[offset++] = sampleFrameIdx;
	  }
	
	  list._count = offset;
	  list._indices = newIndices;
	  list.getRawIndex = getRawIndexWithIndices;
	  return list;
	};
	/**
	 * Get model of one data item.
	 *
	 * @param {number} idx
	 */
	// FIXME Model proxy ?
	
	
	listProto.getItemModel = function (idx) {
	  var hostModel = this.hostModel;
	  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
	};
	/**
	 * Create a data differ
	 * @param {module:echarts/data/List} otherList
	 * @return {module:echarts/data/DataDiffer}
	 */
	
	
	listProto.diff = function (otherList) {
	  var thisList = this;
	  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
	    return getId(otherList, idx);
	  }, function (idx) {
	    return getId(thisList, idx);
	  });
	};
	/**
	 * Get visual property.
	 * @param {string} key
	 */
	
	
	listProto.getVisual = function (key) {
	  var visual = this._visual;
	  return visual && visual[key];
	};
	/**
	 * Set visual property
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setVisual('color', color);
	 *  setVisual({
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setVisual = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setVisual(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._visual = this._visual || {};
	  this._visual[key] = val;
	};
	/**
	 * Set layout property.
	 * @param {string|Object} key
	 * @param {*} [val]
	 */
	
	
	listProto.setLayout = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setLayout(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._layout[key] = val;
	};
	/**
	 * Get layout property.
	 * @param  {string} key.
	 * @return {*}
	 */
	
	
	listProto.getLayout = function (key) {
	  return this._layout[key];
	};
	/**
	 * Get layout of single data item
	 * @param {number} idx
	 */
	
	
	listProto.getItemLayout = function (idx) {
	  return this._itemLayouts[idx];
	};
	/**
	 * Set layout of single data item
	 * @param {number} idx
	 * @param {Object} layout
	 * @param {boolean=} [merge=false]
	 */
	
	
	listProto.setItemLayout = function (idx, layout, merge) {
	  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
	};
	/**
	 * Clear all layout of single data item
	 */
	
	
	listProto.clearItemLayouts = function () {
	  this._itemLayouts.length = 0;
	};
	/**
	 * Get visual property of single data item
	 * @param {number} idx
	 * @param {string} key
	 * @param {boolean} [ignoreParent=false]
	 */
	
	
	listProto.getItemVisual = function (idx, key, ignoreParent) {
	  var itemVisual = this._itemVisuals[idx];
	  var val = itemVisual && itemVisual[key];
	
	  if (val == null && !ignoreParent) {
	    // Use global visual property
	    return this.getVisual(key);
	  }
	
	  return val;
	};
	/**
	 * Set visual property of single data item
	 *
	 * @param {number} idx
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setItemVisual(0, 'color', color);
	 *  setItemVisual(0, {
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setItemVisual = function (idx, key, value) {
	  var itemVisual = this._itemVisuals[idx] || {};
	  var hasItemVisual = this.hasItemVisual;
	  this._itemVisuals[idx] = itemVisual;
	
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        itemVisual[name] = key[name];
	        hasItemVisual[name] = true;
	      }
	    }
	
	    return;
	  }
	
	  itemVisual[key] = value;
	  hasItemVisual[key] = true;
	};
	/**
	 * Clear itemVisuals and list visual.
	 */
	
	
	listProto.clearAllVisual = function () {
	  this._visual = {};
	  this._itemVisuals = [];
	  this.hasItemVisual = {};
	};
	
	var setItemDataAndSeriesIndex = function (child) {
	  child.seriesIndex = this.seriesIndex;
	  child.dataIndex = this.dataIndex;
	  child.dataType = this.dataType;
	};
	/**
	 * Set graphic element relative to data. It can be set as null
	 * @param {number} idx
	 * @param {module:zrender/Element} [el]
	 */
	
	
	listProto.setItemGraphicEl = function (idx, el) {
	  var hostModel = this.hostModel;
	
	  if (el) {
	    // Add data index and series index for indexing the data by element
	    // Useful in tooltip
	    el.dataIndex = idx;
	    el.dataType = this.dataType;
	    el.seriesIndex = hostModel && hostModel.seriesIndex;
	
	    if (el.type === 'group') {
	      el.traverse(setItemDataAndSeriesIndex, el);
	    }
	  }
	
	  this._graphicEls[idx] = el;
	};
	/**
	 * @param {number} idx
	 * @return {module:zrender/Element}
	 */
	
	
	listProto.getItemGraphicEl = function (idx) {
	  return this._graphicEls[idx];
	};
	/**
	 * @param {Function} cb
	 * @param {*} context
	 */
	
	
	listProto.eachItemGraphicEl = function (cb, context) {
	  zrUtil.each(this._graphicEls, function (el, idx) {
	    if (el) {
	      cb && cb.call(context, el, idx);
	    }
	  });
	};
	/**
	 * Shallow clone a new list except visual and layout properties, and graph elements.
	 * New list only change the indices.
	 */
	
	
	listProto.cloneShallow = function (list) {
	  if (!list) {
	    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
	    list = new List(dimensionInfoList, this.hostModel);
	  } // FIXME
	
	
	  list._storage = this._storage;
	  transferProperties(list, this); // Clone will not change the data extent and indices
	
	  if (this._indices) {
	    var Ctor = this._indices.constructor;
	    list._indices = new Ctor(this._indices);
	  } else {
	    list._indices = null;
	  }
	
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return list;
	};
	/**
	 * Wrap some method to add more feature
	 * @param {string} methodName
	 * @param {Function} injectFunction
	 */
	
	
	listProto.wrapMethod = function (methodName, injectFunction) {
	  var originalMethod = this[methodName];
	
	  if (typeof originalMethod !== 'function') {
	    return;
	  }
	
	  this.__wrappedMethods = this.__wrappedMethods || [];
	
	  this.__wrappedMethods.push(methodName);
	
	  this[methodName] = function () {
	    var res = originalMethod.apply(this, arguments);
	    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
	  };
	}; // Methods that create a new list based on this list should be listed here.
	// Notice that those method should `RETURN` the new list.
	
	
	listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.
	
	listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
	var _default = List;
	module.exports = _default;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function defaultKeyGetter(item) {
	  return item;
	}
	/**
	 * @param {Array} oldArr
	 * @param {Array} newArr
	 * @param {Function} oldKeyGetter
	 * @param {Function} newKeyGetter
	 * @param {Object} [context] Can be visited by this.context in callback.
	 */
	
	
	function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
	  this._old = oldArr;
	  this._new = newArr;
	  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
	  this.context = context;
	}
	
	DataDiffer.prototype = {
	  constructor: DataDiffer,
	
	  /**
	   * Callback function when add a data
	   */
	  add: function (func) {
	    this._add = func;
	    return this;
	  },
	
	  /**
	   * Callback function when update a data
	   */
	  update: function (func) {
	    this._update = func;
	    return this;
	  },
	
	  /**
	   * Callback function when remove a data
	   */
	  remove: function (func) {
	    this._remove = func;
	    return this;
	  },
	  execute: function () {
	    var oldArr = this._old;
	    var newArr = this._new;
	    var oldDataIndexMap = {};
	    var newDataIndexMap = {};
	    var oldDataKeyArr = [];
	    var newDataKeyArr = [];
	    var i;
	    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
	    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this); // Travel by inverted order to make sure order consistency
	    // when duplicate keys exists (consider newDataIndex.pop() below).
	    // For performance consideration, these code below do not look neat.
	
	    for (i = 0; i < oldArr.length; i++) {
	      var key = oldDataKeyArr[i];
	      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
	
	      if (idx != null) {
	        // Consider there is duplicate key (for example, use dataItem.name as key).
	        // We should make sure every item in newArr and oldArr can be visited.
	        var len = idx.length;
	
	        if (len) {
	          len === 1 && (newDataIndexMap[key] = null);
	          idx = idx.unshift();
	        } else {
	          newDataIndexMap[key] = null;
	        }
	
	        this._update && this._update(idx, i);
	      } else {
	        this._remove && this._remove(i);
	      }
	    }
	
	    for (var i = 0; i < newDataKeyArr.length; i++) {
	      var key = newDataKeyArr[i];
	
	      if (newDataIndexMap.hasOwnProperty(key)) {
	        var idx = newDataIndexMap[key];
	
	        if (idx == null) {
	          continue;
	        } // idx can never be empty array here. see 'set null' logic above.
	
	
	        if (!idx.length) {
	          this._add && this._add(idx);
	        } else {
	          for (var j = 0, len = idx.length; j < len; j++) {
	            this._add && this._add(idx[j]);
	          }
	        }
	      }
	    }
	  }
	};
	
	function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
	  for (var i = 0; i < arr.length; i++) {
	    // Add prefix to avoid conflict with Object.prototype.
	    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
	    var existence = map[key];
	
	    if (existence == null) {
	      keyArr.push(key);
	      map[key] = i;
	    } else {
	      if (!existence.length) {
	        map[key] = existence = [existence];
	      }
	
	      existence.push(i);
	    }
	  }
	}
	
	var _default = DataDiffer;
	module.exports = _default;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);
	
	function summarizeDimensions(data) {
	  var summary = {};
	  var encode = summary.encode = {};
	  var notExtraCoordDimMap = createHashMap();
	  var defaultedLabel = [];
	  var defaultedTooltip = [];
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	    var coordDim = dimItem.coordDim;
	
	    if (coordDim) {
	      var coordDimArr = encode[coordDim];
	
	      if (!encode.hasOwnProperty(coordDim)) {
	        coordDimArr = encode[coordDim] = [];
	      }
	
	      coordDimArr[dimItem.coordDimIndex] = dimName;
	
	      if (!dimItem.isExtraCoord) {
	        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
	        // because when dataset is used, it is hard to guess which dimension
	        // can be value dimension. If both show x, y on label is not look good,
	        // and conventionally y axis is focused more.
	
	        if (mayLabelDimType(dimItem.type)) {
	          defaultedLabel[0] = dimName;
	        }
	      }
	
	      if (dimItem.defaultTooltip) {
	        defaultedTooltip.push(dimName);
	      }
	    }
	
	    OTHER_DIMENSIONS.each(function (v, otherDim) {
	      var otherDimArr = encode[otherDim];
	
	      if (!encode.hasOwnProperty(otherDim)) {
	        otherDimArr = encode[otherDim] = [];
	      }
	
	      var dimIndex = dimItem.otherDims[otherDim];
	
	      if (dimIndex != null && dimIndex !== false) {
	        otherDimArr[dimIndex] = dimItem.name;
	      }
	    });
	  });
	  var dataDimsOnCoord = [];
	  var encodeFirstDimNotExtra = {};
	  notExtraCoordDimMap.each(function (v, coordDim) {
	    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
	    // But should fix the case that radar axes: simplify the logic
	    // of `completeDimension`, remove `extraPrefix`.
	
	    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
	    // dim canot on more than one coordDim.
	
	    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
	  });
	  summary.dataDimsOnCoord = dataDimsOnCoord;
	  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
	  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
	  // in this way. Use label.formatter instead. May be remove this approach someday.
	
	  if (encodeLabel && encodeLabel.length) {
	    defaultedLabel = encodeLabel.slice();
	  }
	
	  var encodeTooltip = encode.tooltip;
	
	  if (encodeTooltip && encodeTooltip.length) {
	    defaultedTooltip = encodeTooltip.slice();
	  } else if (!defaultedTooltip.length) {
	    defaultedTooltip = defaultedLabel.slice();
	  }
	
	  encode.defaultedLabel = defaultedLabel;
	  encode.defaultedTooltip = defaultedTooltip;
	  return summary;
	}
	
	function getDimensionTypeByAxis(axisType) {
	  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	}
	
	function mayLabelDimType(dimType) {
	  // In most cases, ordinal and time do not suitable for label.
	  // Ordinal info can be displayed on axis. Time is too long.
	  return !(dimType === 'ordinal' || dimType === 'time');
	} // function findTheLastDimMayLabel(data) {
	//     // Get last value dim
	//     var dimensions = data.dimensions.slice();
	//     var valueType;
	//     var valueDim;
	//     while (dimensions.length && (
	//         valueDim = dimensions.pop(),
	//         valueType = data.getDimensionInfo(valueDim).type,
	//         valueType === 'ordinal' || valueType === 'time'
	//     )) {} // jshint ignore:line
	//     return valueDim;
	// }
	
	
	exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
	exports.summarizeDimensions = summarizeDimensions;
	exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var completeDimensions = __webpack_require__(259);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Substitute `completeDimensions`.
	 * `completeDimensions` is to be deprecated.
	 */
	
	/**
	 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
	 * @param {Object|Array} [opt]
	 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
	 * @param {number} [opt.dimensionsCount]
	 * @param {string} [opt.generateCoord]
	 * @param {string} [opt.generateCoordCount]
	 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
	 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
	 * @return {Array.<Object>} dimensionsInfo
	 */
	function _default(source, opt) {
	  opt = opt || {};
	  return completeDimensions(opt.coordDimensions || [], source, {
	    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
	    encodeDef: opt.encodeDefine || source.encodeDefine,
	    dimCount: opt.dimensionsCount,
	    generateCoord: opt.generateCoord,
	    generateCoordCount: opt.generateCoordCount
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var isString = _util.isString;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var isObject = _util.isObject;
	var clone = _util.clone;
	
	var _model = __webpack_require__(173);
	
	var normalizeToArray = _model.normalizeToArray;
	
	var _sourceHelper = __webpack_require__(223);
	
	var guessOrdinal = _sourceHelper.guessOrdinal;
	
	var Source = __webpack_require__(225);
	
	var _dimensionHelper = __webpack_require__(257);
	
	var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @deprecated
	 * Use `echarts/data/helper/createDimensions` instead.
	 */
	
	/**
	 * @see {module:echarts/test/ut/spec/data/completeDimensions}
	 *
	 * Complete the dimensions array, by user defined `dimension` and `encode`,
	 * and guessing from the data structure.
	 * If no 'value' dimension specified, the first no-named dimension will be
	 * named as 'value'.
	 *
	 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
	 *      provides not only dim template, but also default order.
	 *      properties: 'name', 'type', 'displayName'.
	 *      `name` of each item provides default coord name.
	 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
	 *                                    provide dims count that the sysDim required.
	 *      [{ordinalMeta}] can be specified.
	 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
	 * @param {Object} [opt]
	 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
	 *      For example: ['asdf', {name, type}, ...].
	 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
	 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
	 *                 If not specified, extra dim names will be:
	 *                 'value', 'value0', 'value1', ...
	 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
	 *                 If `generateCoordCount` specified, the generated dim names will be:
	 *                 `generateCoord` + 0, `generateCoord` + 1, ...
	 *                 can be Infinity, indicate that use all of the remain columns.
	 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
	 * @param {number} [opt.encodeDefaulter] If not specified, auto find the next available data dim.
	 * @return {Array.<Object>} [{
	 *      name: string mandatory,
	 *      displayName: string, the origin name in dimsDef, see source helper.
	 *                 If displayName given, the tooltip will displayed vertically.
	 *      coordDim: string mandatory,
	 *      coordDimIndex: number mandatory,
	 *      type: string optional,
	 *      otherDims: { never null/undefined
	 *          tooltip: number optional,
	 *          label: number optional,
	 *          itemName: number optional,
	 *          seriesName: number optional,
	 *      },
	 *      isExtraCoord: boolean true if coord is generated
	 *          (not specified in encode and not series specified)
	 *      other props ...
	 * }]
	 */
	function completeDimensions(sysDims, source, opt) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  opt = opt || {};
	  sysDims = (sysDims || []).slice();
	  var dimsDef = (opt.dimsDef || []).slice();
	  var encodeDef = createHashMap(opt.encodeDef);
	  var dataDimNameMap = createHashMap();
	  var coordDimNameMap = createHashMap(); // var valueCandidate;
	
	  var result = [];
	  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.
	
	  for (var i = 0; i < dimCount; i++) {
	    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
	      name: dimsDef[i]
	    });
	    var userDimName = dimDefItem.name;
	    var resultItem = result[i] = {
	      otherDims: {}
	    }; // Name will be applied later for avoiding duplication.
	
	    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	      // Only if `series.dimensions` is defined in option
	      // displayName, will be set, and dimension will be diplayed vertically in
	      // tooltip by default.
	      resultItem.name = resultItem.displayName = userDimName;
	      dataDimNameMap.set(userDimName, i);
	    }
	
	    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
	  } // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
	
	
	  encodeDef.each(function (dataDims, coordDim) {
	    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
	    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
	    // this case.
	
	    if (dataDims.length === 1 && dataDims[0] < 0) {
	      encodeDef.set(coordDim, false);
	      return;
	    }
	
	    var validDataDims = encodeDef.set(coordDim, []);
	    each(dataDims, function (resultDimIdx, idx) {
	      // The input resultDimIdx can be dim name or index.
	      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
	
	      if (resultDimIdx != null && resultDimIdx < dimCount) {
	        validDataDims[idx] = resultDimIdx;
	        applyDim(result[resultDimIdx], coordDim, idx);
	      }
	    });
	  }); // Apply templetes and default order from `sysDims`.
	
	  var availDimIdx = 0;
	  each(sysDims, function (sysDimItem, sysDimIndex) {
	    var coordDim;
	    var sysDimItem;
	    var sysDimItemDimsDef;
	    var sysDimItemOtherDims;
	
	    if (isString(sysDimItem)) {
	      coordDim = sysDimItem;
	      sysDimItem = {};
	    } else {
	      coordDim = sysDimItem.name;
	      var ordinalMeta = sysDimItem.ordinalMeta;
	      sysDimItem.ordinalMeta = null;
	      sysDimItem = clone(sysDimItem);
	      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
	
	      sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemOtherDims = sysDimItem.otherDims;
	      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	    }
	
	    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.
	
	    if (dataDims === false) {
	      return;
	    }
	
	    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.
	
	    if (!dataDims.length) {
	      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
	          availDimIdx++;
	        }
	
	        availDimIdx < result.length && dataDims.push(availDimIdx++);
	      }
	    } // Apply templates.
	
	
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      var resultItem = result[resultDimIdx];
	      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	      if (resultItem.name == null && sysDimItemDimsDef) {
	        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
	        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
	          name: sysDimItemDimsDefItem
	        });
	        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
	        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
	      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
	
	
	      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	    });
	  });
	
	  function applyDim(resultItem, coordDim, coordDimIndex) {
	    if (OTHER_DIMENSIONS.get(coordDim) != null) {
	      resultItem.otherDims[coordDim] = coordDimIndex;
	    } else {
	      resultItem.coordDim = coordDim;
	      resultItem.coordDimIndex = coordDimIndex;
	      coordDimNameMap.set(coordDim, true);
	    }
	  } // Make sure the first extra dim is 'value'.
	
	
	  var generateCoord = opt.generateCoord;
	  var generateCoordCount = opt.generateCoordCount;
	  var fromZero = generateCoordCount != null;
	  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
	  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.
	
	  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	    var resultItem = result[resultDimIdx] = result[resultDimIdx] || {};
	    var coordDim = resultItem.coordDim;
	
	    if (coordDim == null) {
	      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
	      resultItem.coordDimIndex = 0;
	
	      if (!generateCoord || generateCoordCount <= 0) {
	        resultItem.isExtraCoord = true;
	      }
	
	      generateCoordCount--;
	    }
	
	    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
	
	    if (resultItem.type == null && guessOrdinal(source, resultDimIdx, resultItem.name)) {
	      resultItem.type = 'ordinal';
	    }
	  }
	
	  return result;
	} // ??? TODO
	// Originally detect dimCount by data[0]. Should we
	// optimize it to only by sysDims and dimensions and encode.
	// So only necessary dims will be initialized.
	// But
	// (1) custom series should be considered. where other dims
	// may be visited.
	// (2) sometimes user need to calcualte bubble size or use visualMap
	// on other dimensions besides coordSys needed.
	// So, dims that is not used by system, should be shared in storage?
	
	
	function getDimCount(source, sysDims, dimsDef, optDimCount) {
	  // Note that the result dimCount should not small than columns count
	  // of data, otherwise `dataDimNameMap` checking will be incorrect.
	  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
	  each(sysDims, function (sysDimItem) {
	    var sysDimItemDimsDef = sysDimItem.dimsDef;
	    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
	  });
	  return dimCount;
	}
	
	function genName(name, map, fromZero) {
	  if (fromZero || map.get(name) != null) {
	    var i = 0;
	
	    while (map.get(name + i) != null) {
	      i++;
	    }
	
	    name += i;
	  }
	
	  map.set(name, true);
	  return name;
	}
	
	var _default = completeDimensions;
	module.exports = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var isString = _util.isString;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Note that it is too complicated to support 3d stack by value
	 * (have to create two-dimension inverted index), so in 3d case
	 * we just support that stacked by index.
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
	 *        The input dimensionInfoList will be modified.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
	 * @param {boolean} [opt.byIndex=false]
	 * @return {Object} calculationInfo
	 * {
	 *     stackedDimension: string
	 *     stackedByDimension: string
	 *     isStackedByIndex: boolean
	 *     stackedOverDimension: string
	 *     stackResultDimension: string
	 * }
	 */
	function enableDataStack(seriesModel, dimensionInfoList, opt) {
	  opt = opt || {};
	  var byIndex = opt.byIndex;
	  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.
	
	  var mayStack = !!(seriesModel && seriesModel.get('stack'));
	  var stackedByDimInfo;
	  var stackedDimInfo;
	  var stackResultDimension;
	  var stackedOverDimension;
	  each(dimensionInfoList, function (dimensionInfo, index) {
	    if (isString(dimensionInfo)) {
	      dimensionInfoList[index] = dimensionInfo = {
	        name: dimensionInfo
	      };
	    }
	
	    if (mayStack && !dimensionInfo.isExtraCoord) {
	      // Find the first ordinal dimension as the stackedByDimInfo.
	      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
	        stackedByDimInfo = dimensionInfo;
	      } // Find the first stackable dimension as the stackedDimInfo.
	
	
	      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
	        stackedDimInfo = dimensionInfo;
	      }
	    }
	  });
	
	  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
	    // Compatible with previous design, value axis (time axis) only stack by index.
	    // It may make sense if the user provides elaborately constructed data.
	    byIndex = true;
	  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
	  // That put stack logic in List is for using conveniently in echarts extensions, but it
	  // might not be a good way.
	
	
	  if (stackedDimInfo) {
	    // Use a weird name that not duplicated with other names.
	    stackResultDimension = '__\0ecstackresult';
	    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.
	
	    if (stackedByDimInfo) {
	      stackedByDimInfo.createInvertedIndices = true;
	    }
	
	    var stackedDimCoordDim = stackedDimInfo.coordDim;
	    var stackedDimType = stackedDimInfo.type;
	    var stackedDimCoordIndex = 0;
	    each(dimensionInfoList, function (dimensionInfo) {
	      if (dimensionInfo.coordDim === stackedDimCoordDim) {
	        stackedDimCoordIndex++;
	      }
	    });
	    dimensionInfoList.push({
	      name: stackResultDimension,
	      coordDim: stackedDimCoordDim,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	    stackedDimCoordIndex++;
	    dimensionInfoList.push({
	      name: stackedOverDimension,
	      // This dimension contains stack base (generally, 0), so do not set it as
	      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
	      coordDim: stackedOverDimension,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	  }
	
	  return {
	    stackedDimension: stackedDimInfo && stackedDimInfo.name,
	    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
	    isStackedByIndex: byIndex,
	    stackedOverDimension: stackedOverDimension,
	    stackResultDimension: stackResultDimension
	  };
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} stackedDim
	 */
	
	
	function isDimensionStacked(data, stackedDim
	/*, stackedByDim*/
	) {
	  // Each single series only maps to one pair of axis. So we do not need to
	  // check stackByDim, whatever stacked by a dimension or stacked by index.
	  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
	  //     stackedByDim != null
	  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
	  //         : data.getCalculationInfo('isStackedByIndex')
	  // );
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} targetDim
	 * @param {string} [stackedByDim] If not input this parameter, check whether
	 *                                stacked by index.
	 * @return {string} dimension
	 */
	
	
	function getStackedDimension(data, targetDim) {
	  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
	}
	
	exports.enableDataStack = enableDataStack;
	exports.isDimensionStacked = isDimensionStacked;
	exports.getStackedDimension = getStackedDimension;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var OrdinalScale = __webpack_require__(262);
	
	var IntervalScale = __webpack_require__(265);
	
	var Scale = __webpack_require__(263);
	
	var numberUtil = __webpack_require__(218);
	
	var _barGrid = __webpack_require__(267);
	
	var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
	var makeColumnLayout = _barGrid.makeColumnLayout;
	var retrieveColumnLayout = _barGrid.retrieveColumnLayout;
	
	var BoundingRect = __webpack_require__(154);
	
	__webpack_require__(268);
	
	__webpack_require__(269);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Get axis scale extent before niced.
	 * Item of returned array can only be number (including Infinity and NaN).
	 */
	function getScaleExtent(scale, model) {
	  var scaleType = scale.type;
	  var min = model.getMin();
	  var max = model.getMax();
	  var fixMin = min != null;
	  var fixMax = max != null;
	  var originalExtent = scale.getExtent();
	  var axisDataLen;
	  var boundaryGap;
	  var span;
	
	  if (scaleType === 'ordinal') {
	    axisDataLen = model.getCategories().length;
	  } else {
	    boundaryGap = model.get('boundaryGap');
	
	    if (!zrUtil.isArray(boundaryGap)) {
	      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
	    }
	
	    if (typeof boundaryGap[0] === 'boolean') {
	      boundaryGap = [0, 0];
	    }
	
	    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
	    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
	    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
	  } // Notice: When min/max is not set (that is, when there are null/undefined,
	  // which is the most common case), these cases should be ensured:
	  // (1) For 'ordinal', show all axis.data.
	  // (2) For others:
	  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	  //      disabled).
	  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	  //      be the result that originalExtent enlarged by boundaryGap.
	  // (3) If no data, it should be ensured that `scale.setBlank` is set.
	  // FIXME
	  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
	  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
	  // that the results processed by boundaryGap are positive/negative?
	
	
	  if (min == null) {
	    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
	  }
	
	  if (max == null) {
	    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
	  }
	
	  if (min === 'dataMin') {
	    min = originalExtent[0];
	  } else if (typeof min === 'function') {
	    min = min({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  if (max === 'dataMax') {
	    max = originalExtent[1];
	  } else if (typeof max === 'function') {
	    max = max({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  (min == null || !isFinite(min)) && (min = NaN);
	  (max == null || !isFinite(max)) && (max = NaN);
	  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero
	
	  if (model.getNeedCrossZero()) {
	    // Axis is over zero and min is not set
	    if (min > 0 && max > 0 && !fixMin) {
	      min = 0;
	    } // Axis is under zero and max is not set
	
	
	    if (min < 0 && max < 0 && !fixMax) {
	      max = 0;
	    }
	  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
	  // is base axis
	  // FIXME
	  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
	  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
	  //     Should not depend on series type `bar`?
	  // (3) Fix that might overlap when using dataZoom.
	  // (4) Consider other chart types using `barGrid`?
	  // See #6728, #4862, `test/bar-overflow-time-plot.html`
	
	
	  var ecModel = model.ecModel;
	
	  if (ecModel && scaleType === 'time'
	  /*|| scaleType === 'interval' */
	  ) {
	    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
	    var isBaseAxisAndHasBarSeries;
	    zrUtil.each(barSeriesModels, function (seriesModel) {
	      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
	    });
	
	    if (isBaseAxisAndHasBarSeries) {
	      // Calculate placement of bars on axis
	      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
	
	      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
	      min = adjustedScale.min;
	      max = adjustedScale.max;
	    }
	  }
	
	  return [min, max];
	}
	
	function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
	  // Get Axis Length
	  var axisExtent = model.axis.getExtent();
	  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
	
	  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);
	
	  if (barsOnCurrentAxis === undefined) {
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  var minOverflow = Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    minOverflow = Math.min(item.offset, minOverflow);
	  });
	  var maxOverflow = -Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
	  });
	  minOverflow = Math.abs(minOverflow);
	  maxOverflow = Math.abs(maxOverflow);
	  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow
	
	  var oldRange = max - min;
	  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
	  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
	  max += overflowBuffer * (maxOverflow / totalOverFlow);
	  min -= overflowBuffer * (minOverflow / totalOverFlow);
	  return {
	    min: min,
	    max: max
	  };
	}
	
	function niceScaleExtent(scale, model) {
	  var extent = getScaleExtent(scale, model);
	  var fixMin = model.getMin() != null;
	  var fixMax = model.getMax() != null;
	  var splitNumber = model.get('splitNumber');
	
	  if (scale.type === 'log') {
	    scale.base = model.get('logBase');
	  }
	
	  var scaleType = scale.type;
	  scale.setExtent(extent[0], extent[1]);
	  scale.niceExtent({
	    splitNumber: splitNumber,
	    fixMin: fixMin,
	    fixMax: fixMax,
	    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
	    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
	  }); // If some one specified the min, max. And the default calculated interval
	  // is not good enough. He can specify the interval. It is often appeared
	  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	  // to be 60.
	  // FIXME
	
	  var interval = model.get('interval');
	
	  if (interval != null) {
	    scale.setInterval && scale.setInterval(interval);
	  }
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @param {string} [axisType] Default retrieve from model.type
	 * @return {module:echarts/scale/*}
	 */
	
	
	function createScaleByModel(model, axisType) {
	  axisType = axisType || model.get('type');
	
	  if (axisType) {
	    switch (axisType) {
	      // Buildin scale
	      case 'category':
	        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);
	
	      case 'value':
	        return new IntervalScale();
	      // Extended scale, like time and log
	
	      default:
	        return (Scale.getClass(axisType) || IntervalScale).create(model);
	    }
	  }
	}
	/**
	 * Check if the axis corss 0
	 */
	
	
	function ifAxisCrossZero(axis) {
	  var dataExtent = axis.scale.getExtent();
	  var min = dataExtent[0];
	  var max = dataExtent[1];
	  return !(min > 0 && max > 0 || min < 0 && max < 0);
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {Function} Label formatter function.
	 *         param: {number} tickValue,
	 *         param: {number} idx, the index in all ticks.
	 *                         If category axis, this param is not requied.
	 *         return: {string} label string.
	 */
	
	
	function makeLabelFormatter(axis) {
	  var labelFormatter = axis.getLabelModel().get('formatter');
	  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
	
	  if (typeof labelFormatter === 'string') {
	    labelFormatter = function (tpl) {
	      return function (val) {
	        // For category axis, get raw value; for numeric axis,
	        // get foramtted label like '1,333,444'.
	        val = axis.scale.getLabel(val);
	        return tpl.replace('{value}', val != null ? val : '');
	      };
	    }(labelFormatter); // Consider empty array
	
	
	    return labelFormatter;
	  } else if (typeof labelFormatter === 'function') {
	    return function (tickValue, idx) {
	      // The original intention of `idx` is "the index of the tick in all ticks".
	      // But the previous implementation of category axis do not consider the
	      // `axisLabel.interval`, which cause that, for example, the `interval` is
	      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
	      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
	      // the definition here for back compatibility.
	      if (categoryTickStart != null) {
	        idx = tickValue - categoryTickStart;
	      }
	
	      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
	    };
	  } else {
	    return function (tick) {
	      return axis.scale.getLabel(tick);
	    };
	  }
	}
	
	function getAxisRawValue(axis, value) {
	  // In category axis with data zoom, tick is not the original
	  // index of axis.data. So tick should not be exposed to user
	  // in category axis.
	  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
	 */
	
	
	function estimateLabelUnionRect(axis) {
	  var axisModel = axis.model;
	  var scale = axis.scale;
	
	  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
	    return;
	  }
	
	  var isCategory = axis.type === 'category';
	  var realNumberScaleTicks;
	  var tickCount;
	  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
	
	  if (isCategory) {
	    tickCount = scale.count();
	  } else {
	    realNumberScaleTicks = scale.getTicks();
	    tickCount = realNumberScaleTicks.length;
	  }
	
	  var axisLabelModel = axis.getLabelModel();
	  var labelFormatter = makeLabelFormatter(axis);
	  var rect;
	  var step = 1; // Simple optimization for large amount of labels
	
	  if (tickCount > 40) {
	    step = Math.ceil(tickCount / 40);
	  }
	
	  for (var i = 0; i < tickCount; i += step) {
	    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
	    var label = labelFormatter(tickValue);
	    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
	    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	    rect ? rect.union(singleRect) : rect = singleRect;
	  }
	
	  return rect;
	}
	
	function rotateTextRect(textRect, rotate) {
	  var rotateRadians = rotate * Math.PI / 180;
	  var boundingBox = textRect.plain();
	  var beforeWidth = boundingBox.width;
	  var beforeHeight = boundingBox.height;
	  var afterWidth = beforeWidth * Math.cos(rotateRadians) + beforeHeight * Math.sin(rotateRadians);
	  var afterHeight = beforeWidth * Math.sin(rotateRadians) + beforeHeight * Math.cos(rotateRadians);
	  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
	  return rotatedRect;
	}
	/**
	 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
	 * @return {number|String} Can be null|'auto'|number|function
	 */
	
	
	function getOptionCategoryInterval(model) {
	  var interval = model.get('interval');
	  return interval == null ? 'auto' : interval;
	}
	/**
	 * Set `categoryInterval` as 0 implicitly indicates that
	 * show all labels reguardless of overlap.
	 * @param {Object} axis axisModel.axis
	 * @return {boolean}
	 */
	
	
	function shouldShowAllLabels(axis) {
	  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
	}
	
	exports.getScaleExtent = getScaleExtent;
	exports.niceScaleExtent = niceScaleExtent;
	exports.createScaleByModel = createScaleByModel;
	exports.ifAxisCrossZero = ifAxisCrossZero;
	exports.makeLabelFormatter = makeLabelFormatter;
	exports.getAxisRawValue = getAxisRawValue;
	exports.estimateLabelUnionRect = estimateLabelUnionRect;
	exports.getOptionCategoryInterval = getOptionCategoryInterval;
	exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Scale = __webpack_require__(263);
	
	var OrdinalMeta = __webpack_require__(264);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Linear continuous scale
	 * @module echarts/coord/scale/Ordinal
	 *
	 * http://en.wikipedia.org/wiki/Level_of_measurement
	 */
	// FIXME only one data
	var scaleProto = Scale.prototype;
	var OrdinalScale = Scale.extend({
	  type: 'ordinal',
	
	  /**
	   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
	   */
	  init: function (ordinalMeta, extent) {
	    // Caution: Should not use instanceof, consider ec-extensions using
	    // import approach to get OrdinalMeta class.
	    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
	      ordinalMeta = new OrdinalMeta({
	        categories: ordinalMeta
	      });
	    }
	
	    this._ordinalMeta = ordinalMeta;
	    this._extent = extent || [0, ordinalMeta.categories.length - 1];
	  },
	  parse: function (val) {
	    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
	    : Math.round(val);
	  },
	  contain: function (rank) {
	    rank = this.parse(rank);
	    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
	  },
	
	  /**
	   * Normalize given rank or name to linear [0, 1]
	   * @param {number|string} [val]
	   * @return {number}
	   */
	  normalize: function (val) {
	    return scaleProto.normalize.call(this, this.parse(val));
	  },
	  scale: function (val) {
	    return Math.round(scaleProto.scale.call(this, val));
	  },
	
	  /**
	   * @return {Array}
	   */
	  getTicks: function () {
	    var ticks = [];
	    var extent = this._extent;
	    var rank = extent[0];
	
	    while (rank <= extent[1]) {
	      ticks.push(rank);
	      rank++;
	    }
	
	    return ticks;
	  },
	
	  /**
	   * Get item on rank n
	   * @param {number} n
	   * @return {string}
	   */
	  getLabel: function (n) {
	    if (!this.isBlank()) {
	      // Note that if no data, ordinalMeta.categories is an empty array.
	      return this._ordinalMeta.categories[n];
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  count: function () {
	    return this._extent[1] - this._extent[0] + 1;
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	  getOrdinalMeta: function () {
	    return this._ordinalMeta;
	  },
	  niceTicks: zrUtil.noop,
	  niceExtent: zrUtil.noop
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	OrdinalScale.create = function () {
	  return new OrdinalScale();
	};
	
	var _default = OrdinalScale;
	module.exports = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var clazzUtil = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * // Scale class management
	 * @module echarts/scale/Scale
	 */
	
	/**
	 * @param {Object} [setting]
	 */
	function Scale(setting) {
	  this._setting = setting || {};
	  /**
	   * Extent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._extent = [Infinity, -Infinity];
	  /**
	   * Step is calculated in adjustExtent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._interval = 0;
	  this.init && this.init.apply(this, arguments);
	}
	/**
	 * Parse input val to valid inner number.
	 * @param {*} val
	 * @return {number}
	 */
	
	
	Scale.prototype.parse = function (val) {
	  // Notice: This would be a trap here, If the implementation
	  // of this method depends on extent, and this method is used
	  // before extent set (like in dataZoom), it would be wrong.
	  // Nevertheless, parse does not depend on extent generally.
	  return val;
	};
	
	Scale.prototype.getSetting = function (name) {
	  return this._setting[name];
	};
	
	Scale.prototype.contain = function (val) {
	  var extent = this._extent;
	  return val >= extent[0] && val <= extent[1];
	};
	/**
	 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.normalize = function (val) {
	  var extent = this._extent;
	
	  if (extent[1] === extent[0]) {
	    return 0.5;
	  }
	
	  return (val - extent[0]) / (extent[1] - extent[0]);
	};
	/**
	 * Scale normalized value
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.scale = function (val) {
	  var extent = this._extent;
	  return val * (extent[1] - extent[0]) + extent[0];
	};
	/**
	 * Set extent from data
	 * @param {Array.<number>} other
	 */
	
	
	Scale.prototype.unionExtent = function (other) {
	  var extent = this._extent;
	  other[0] < extent[0] && (extent[0] = other[0]);
	  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	  // this.setExtent(extent[0], extent[1]);
	};
	/**
	 * Set extent from data
	 * @param {module:echarts/data/List} data
	 * @param {string} dim
	 */
	
	
	Scale.prototype.unionExtentFromData = function (data, dim) {
	  this.unionExtent(data.getApproximateExtent(dim));
	};
	/**
	 * Get extent
	 * @return {Array.<number>}
	 */
	
	
	Scale.prototype.getExtent = function () {
	  return this._extent.slice();
	};
	/**
	 * Set extent
	 * @param {number} start
	 * @param {number} end
	 */
	
	
	Scale.prototype.setExtent = function (start, end) {
	  var thisExtent = this._extent;
	
	  if (!isNaN(start)) {
	    thisExtent[0] = start;
	  }
	
	  if (!isNaN(end)) {
	    thisExtent[1] = end;
	  }
	};
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	
	
	Scale.prototype.isBlank = function () {
	  return this._isBlank;
	},
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	Scale.prototype.setBlank = function (isBlank) {
	  this._isBlank = isBlank;
	};
	/**
	 * @abstract
	 * @param {*} tick
	 * @return {string} label of the tick.
	 */
	
	Scale.prototype.getLabel = null;
	clazzUtil.enableClassExtend(Scale);
	clazzUtil.enableClassManagement(Scale, {
	  registerWhenExtend: true
	});
	var _default = Scale;
	module.exports = _default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var isObject = _util.isObject;
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor
	 * @param {Object} [opt]
	 * @param {Object} [opt.categories=[]]
	 * @param {Object} [opt.needCollect=false]
	 * @param {Object} [opt.deduplication=false]
	 */
	function OrdinalMeta(opt) {
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  this.categories = opt.categories || [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._needCollect = opt.needCollect;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._deduplication = opt.deduplication;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._map;
	}
	/**
	 * @param {module:echarts/model/Model} axisModel
	 * @return {module:echarts/data/OrdinalMeta}
	 */
	
	
	OrdinalMeta.createByAxisModel = function (axisModel) {
	  var option = axisModel.option;
	  var data = option.data;
	  var categories = data && map(data, getName);
	  return new OrdinalMeta({
	    categories: categories,
	    needCollect: !categories,
	    // deduplication is default in axis.
	    deduplication: option.dedplication !== false
	  });
	};
	
	var proto = OrdinalMeta.prototype;
	/**
	 * @param {string} category
	 * @return {number} ordinal
	 */
	
	proto.getOrdinal = function (category) {
	  return getOrCreateMap(this).get(category);
	};
	/**
	 * @param {*} category
	 * @return {number} The ordinal. If not found, return NaN.
	 */
	
	
	proto.parseAndCollect = function (category) {
	  var index;
	  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
	  // This feature is only supported when !needCollect, because we should
	  // consider a common case: a value is 2017, which is a number but is
	  // expected to be tread as a category. This case usually happen in dataset,
	  // where it happent to be no need of the index feature.
	
	  if (typeof category !== 'string' && !needCollect) {
	    return category;
	  } // Optimize for the scenario:
	  // category is ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // Notice, if a dataset dimension provide categroies, usually echarts
	  // should remove duplication except user tell echarts dont do that
	  // (set axis.deduplication = false), because echarts do not know whether
	  // the values in the category dimension has duplication (consider the
	  // parallel-aqi example)
	
	
	  if (needCollect && !this._deduplication) {
	    index = this.categories.length;
	    this.categories[index] = category;
	    return index;
	  }
	
	  var map = getOrCreateMap(this);
	  index = map.get(category);
	
	  if (index == null) {
	    if (needCollect) {
	      index = this.categories.length;
	      this.categories[index] = category;
	      map.set(category, index);
	    } else {
	      index = NaN;
	    }
	  }
	
	  return index;
	}; // Consider big data, do not create map until needed.
	
	
	function getOrCreateMap(ordinalMeta) {
	  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
	}
	
	function getName(obj) {
	  if (isObject(obj) && obj.value != null) {
	    return obj.value;
	  } else {
	    return obj + '';
	  }
	}
	
	var _default = OrdinalMeta;
	module.exports = _default;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(218);
	
	var formatUtil = __webpack_require__(219);
	
	var Scale = __webpack_require__(263);
	
	var helper = __webpack_require__(266);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Interval scale
	 * @module echarts/scale/Interval
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @alias module:echarts/coord/scale/Interval
	 * @constructor
	 */
	
	var IntervalScale = Scale.extend({
	  type: 'interval',
	  _interval: 0,
	  _intervalPrecision: 2,
	  setExtent: function (start, end) {
	    var thisExtent = this._extent; //start,end may be a Number like '25',so...
	
	    if (!isNaN(start)) {
	      thisExtent[0] = parseFloat(start);
	    }
	
	    if (!isNaN(end)) {
	      thisExtent[1] = parseFloat(end);
	    }
	  },
	  unionExtent: function (other) {
	    var extent = this._extent;
	    other[0] < extent[0] && (extent[0] = other[0]);
	    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
	  },
	
	  /**
	   * Get interval
	   */
	  getInterval: function () {
	    return this._interval;
	  },
	
	  /**
	   * Set interval
	   */
	  setInterval: function (interval) {
	    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
	    // We assume user wan't to set both interval, min, max to get a better result
	
	    this._niceExtent = this._extent.slice();
	    this._intervalPrecision = helper.getIntervalPrecision(interval);
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getTicks: function () {
	    return helper.intervalScaleGetTicks(this._interval, this._extent, this._niceExtent, this._intervalPrecision);
	  },
	
	  /**
	   * @param {number} data
	   * @param {Object} [opt]
	   * @param {number|string} [opt.precision] If 'auto', use nice presision.
	   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
	   * @return {string}
	   */
	  getLabel: function (data, opt) {
	    if (data == null) {
	      return '';
	    }
	
	    var precision = opt && opt.precision;
	
	    if (precision == null) {
	      precision = numberUtil.getPrecisionSafe(data) || 0;
	    } else if (precision === 'auto') {
	      // Should be more precise then tick.
	      precision = this._intervalPrecision;
	    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	    data = roundNumber(data, precision, true);
	    return formatUtil.addCommas(data);
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   *
	   * @param {number} [splitNumber = 5] Desired number of ticks
	   * @param {number} [minInterval]
	   * @param {number} [maxInterval]
	   */
	  niceTicks: function (splitNumber, minInterval, maxInterval) {
	    splitNumber = splitNumber || 5;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (!isFinite(span)) {
	      return;
	    } // User may set axis min 0 and data are all negative
	    // FIXME If it needs to reverse ?
	
	
	    if (span < 0) {
	      span = -span;
	      extent.reverse();
	    }
	
	    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	    this._intervalPrecision = result.intervalPrecision;
	    this._interval = result.interval;
	    this._niceExtent = result.niceTickExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @param {Object} opt
	   * @param {number} [opt.splitNumber = 5] Given approx tick number
	   * @param {boolean} [opt.fixMin=false]
	   * @param {boolean} [opt.fixMax=false]
	   * @param {boolean} [opt.minInterval]
	   * @param {boolean} [opt.maxInterval]
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      if (extent[0] !== 0) {
	        // Expand extent
	        var expandSize = extent[0]; // In the fowllowing case
	        //      Axis has been fixed max 100
	        //      Plus data are all 100 and axis extent are [100, 100].
	        // Extend to the both side will cause expanded max is larger than fixed max.
	        // So only expand to the smaller side.
	
	        if (!opt.fixMax) {
	          extent[1] += expandSize / 2;
	          extent[0] -= expandSize / 2;
	        } else {
	          extent[0] -= expandSize / 2;
	        }
	      } else {
	        extent[1] = 1;
	      }
	    }
	
	    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	    if (!isFinite(span)) {
	      extent[0] = 0;
	      extent[1] = 1;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	    }
	  }
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	IntervalScale.create = function () {
	  return new IntervalScale();
	};
	
	var _default = IntervalScale;
	module.exports = _default;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(218);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For testable.
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
	 *                                Should be extent[0] < extent[1].
	 * @param {number} splitNumber splitNumber should be >= 1.
	 * @param {number} [minInterval]
	 * @param {number} [maxInterval]
	 * @return {Object} {interval, intervalPrecision, niceTickExtent}
	 */
	
	function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	  var result = {};
	  var span = extent[1] - extent[0];
	  var interval = result.interval = numberUtil.nice(span / splitNumber, true);
	
	  if (minInterval != null && interval < minInterval) {
	    interval = result.interval = minInterval;
	  }
	
	  if (maxInterval != null && interval > maxInterval) {
	    interval = result.interval = maxInterval;
	  } // Tow more digital for tick.
	
	
	  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
	  fixExtent(niceTickExtent, extent);
	  return result;
	}
	/**
	 * @param {number} interval
	 * @return {number} interval precision
	 */
	
	
	function getIntervalPrecision(interval) {
	  // Tow more digital for tick.
	  return numberUtil.getPrecisionSafe(interval) + 2;
	}
	
	function clamp(niceTickExtent, idx, extent) {
	  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	function fixExtent(niceTickExtent, extent) {
	  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	  clamp(niceTickExtent, 0, extent);
	  clamp(niceTickExtent, 1, extent);
	
	  if (niceTickExtent[0] > niceTickExtent[1]) {
	    niceTickExtent[0] = niceTickExtent[1];
	  }
	}
	
	function intervalScaleGetTicks(interval, extent, niceTickExtent, intervalPrecision) {
	  var ticks = []; // If interval is 0, return [];
	
	  if (!interval) {
	    return ticks;
	  } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	  var safeLimit = 10000;
	
	  if (extent[0] < niceTickExtent[0]) {
	    ticks.push(extent[0]);
	  }
	
	  var tick = niceTickExtent[0];
	
	  while (tick <= niceTickExtent[1]) {
	    ticks.push(tick); // Avoid rounding error
	
	    tick = roundNumber(tick + interval, intervalPrecision);
	
	    if (tick === ticks[ticks.length - 1]) {
	      // Consider out of safe float point, e.g.,
	      // -3711126.9907707 + 2e-10 === -3711126.9907707
	      break;
	    }
	
	    if (ticks.length > safeLimit) {
	      return [];
	    }
	  } // Consider this case: the last item of ticks is smaller
	  // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	  if (extent[1] > (ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1])) {
	    ticks.push(extent[1]);
	  }
	
	  return ticks;
	}
	
	exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
	exports.getIntervalPrecision = getIntervalPrecision;
	exports.fixExtent = fixExtent;
	exports.intervalScaleGetTicks = intervalScaleGetTicks;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(260);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var createRenderPlanner = __webpack_require__(239);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var STACK_PREFIX = '__ec_stack_';
	var LARGE_BAR_MIN_WIDTH = 0.5;
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim + axis.index;
	}
	/**
	 * @param {Object} opt
	 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
	 * @param {number} opt.count Positive interger.
	 * @param {number} [opt.barWidth]
	 * @param {number} [opt.barMaxWidth]
	 * @param {number} [opt.barGap]
	 * @param {number} [opt.barCategoryGap]
	 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	 */
	
	
	function getLayoutOnAxis(opt) {
	  var params = [];
	  var baseAxis = opt.axis;
	  var axisKey = 'axis0';
	
	  if (baseAxis.type !== 'category') {
	    return;
	  }
	
	  var bandWidth = baseAxis.getBandWidth();
	
	  for (var i = 0; i < opt.count || 0; i++) {
	    params.push(zrUtil.defaults({
	      bandWidth: bandWidth,
	      axisKey: axisKey,
	      stackId: STACK_PREFIX + i
	    }, opt));
	  }
	
	  var widthAndOffsets = doCalBarWidthAndOffset(params);
	  var result = [];
	
	  for (var i = 0; i < opt.count; i++) {
	    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	    item.offsetCenter = item.offset + item.width / 2;
	    result.push(item);
	  }
	
	  return result;
	}
	
	function prepareLayoutBarSeries(seriesType, ecModel) {
	  var seriesModels = [];
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for cartesian2d only
	    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
	      seriesModels.push(seriesModel);
	    }
	  });
	  return seriesModels;
	}
	
	function makeColumnLayout(barSeries) {
	  var seriesInfoList = [];
	  zrUtil.each(barSeries, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	    seriesInfoList.push({
	      bandWidth: bandWidth,
	      barWidth: barWidth,
	      barMaxWidth: barMaxWidth,
	      barGap: barGap,
	      barCategoryGap: barCategoryGap,
	      axisKey: getAxisKey(baseAxis),
	      stackId: getSeriesStackId(seriesModel)
	    });
	  });
	  return doCalBarWidthAndOffset(seriesInfoList);
	}
	
	function doCalBarWidthAndOffset(seriesInfoList) {
	  // Columns info on each category axis. Key is cartesian name
	  var columnsMap = {};
	  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
	    var axisKey = seriesInfo.axisKey;
	    var bandWidth = seriesInfo.bandWidth;
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = seriesInfo.stackId;
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    }; // Caution: In a single coordinate system, these barGrid attributes
	    // will be shared by series. Consider that they have default values,
	    // only the attributes set on the last series will work.
	    // Do not change this fact unless there will be a break change.
	    // TODO
	
	    var barWidth = seriesInfo.barWidth;
	
	    if (barWidth && !stacks[stackId].width) {
	      // See #6312, do not restrict width.
	      stacks[stackId].width = barWidth;
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    var barMaxWidth = seriesInfo.barMaxWidth;
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    var barGap = seriesInfo.barGap;
	    barGap != null && (columnsOnAxis.gap = barGap);
	    var barCategoryGap = seriesInfo.barCategoryGap;
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	/**
	 * @param {Object} barWidthAndOffset The result of makeColumnLayout
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
	 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
	 */
	
	
	function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
	  if (barWidthAndOffset && axis) {
	    var result = barWidthAndOffset[getAxisKey(axis)];
	
	    if (result != null && seriesModel != null) {
	      result = result[getSeriesStackId(seriesModel)];
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function layout(seriesType, ecModel) {
	  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
	  var barWidthAndOffset = makeColumnLayout(seriesModels);
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  zrUtil.each(seriesModels, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.setLayout({
	      offset: columnOffset,
	      size: columnWidth
	    });
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var isValueAxisH = valueAxis.isHorizontal();
	    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	
	      if (isNaN(value)) {
	        continue;
	      }
	
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	
	      if (stacked) {
	        // Only ordinal axis can be stacked.
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (isValueAxisH) {
	        var coord = cartesian.dataToPoint([value, baseValue]);
	        x = baseCoord;
	        y = coord[1] + columnOffset;
	        width = coord[0] - valueAxisStart;
	        height = columnWidth;
	
	        if (Math.abs(width) < barMinHeight) {
	          width = (width < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        stacked && (lastStackCoords[stackId][baseValue][sign] += width);
	      } else {
	        var coord = cartesian.dataToPoint([baseValue, value]);
	        x = coord[0] + columnOffset;
	        y = baseCoord;
	        width = columnWidth;
	        height = coord[1] - valueAxisStart;
	
	        if (Math.abs(height) < barMinHeight) {
	          // Include zero to has a positive bar
	          height = (height <= 0 ? -1 : 1) * barMinHeight;
	        }
	
	        stacked && (lastStackCoords[stackId][baseValue][sign] += height);
	      }
	
	      data.setItemLayout(idx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, this);
	} // TODO: Do not support stack in large mode yet.
	
	
	var largeLayout = {
	  seriesType: 'bar',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var valueAxisHorizontal = valueAxis.isHorizontal();
	    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
	    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;
	
	    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
	      // jshint ignore:line
	      barWidth = LARGE_BAR_MIN_WIDTH;
	    }
	
	    return {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var largePoints = new LargeArr(params.count * 2);
	      var dataIndex;
	      var coord = [];
	      var valuePair = [];
	      var offset = 0;
	
	      while ((dataIndex = params.next()) != null) {
	        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
	        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
	        coord = cartesian.dataToPoint(valuePair, null, coord);
	        largePoints[offset++] = coord[0];
	        largePoints[offset++] = coord[1];
	      }
	
	      data.setLayout({
	        largePoints: largePoints,
	        barWidth: barWidth,
	        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
	        valueAxisHorizontal: valueAxisHorizontal
	      });
	    }
	  }
	};
	
	function isOnCartesian(seriesModel) {
	  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	}
	
	function isInLargeMode(seriesModel) {
	  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
	} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
	
	
	function getValueAxisStart(baseAxis, valueAxis, stacked) {
	  var extent = valueAxis.getGlobalExtent();
	  var min;
	  var max;
	
	  if (extent[0] > extent[1]) {
	    min = extent[1];
	    max = extent[0];
	  } else {
	    min = extent[0];
	    max = extent[1];
	  }
	
	  var valueStart = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  valueStart < min && (valueStart = min);
	  valueStart > max && (valueStart = max);
	  return valueStart;
	}
	
	exports.getLayoutOnAxis = getLayoutOnAxis;
	exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
	exports.makeColumnLayout = makeColumnLayout;
	exports.retrieveColumnLayout = retrieveColumnLayout;
	exports.layout = layout;
	exports.largeLayout = largeLayout;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var numberUtil = __webpack_require__(218);
	
	var formatUtil = __webpack_require__(219);
	
	var scaleHelper = __webpack_require__(266);
	
	var IntervalScale = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The "scaleLevels" was originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment on the definition of "scaleLevels" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	// [About UTC and local time zone]:
	// In most cases, `number.parseDate` will treat input data string as local time
	// (except time zone is specified in time string). And `format.formateTime` returns
	// local time by default. option.useUTC is false by default. This design have
	// concidered these common case:
	// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
	// in local time by default.
	// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
	// as its original time, without any time difference.
	var intervalScaleProto = IntervalScale.prototype;
	var mathCeil = Math.ceil;
	var mathFloor = Math.floor;
	var ONE_SECOND = 1000;
	var ONE_MINUTE = ONE_SECOND * 60;
	var ONE_HOUR = ONE_MINUTE * 60;
	var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？
	
	var bisect = function (a, x, lo, hi) {
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	
	    if (a[mid][1] < x) {
	      lo = mid + 1;
	    } else {
	      hi = mid;
	    }
	  }
	
	  return lo;
	};
	/**
	 * @alias module:echarts/coord/scale/Time
	 * @constructor
	 */
	
	
	var TimeScale = IntervalScale.extend({
	  type: 'time',
	
	  /**
	   * @override
	   */
	  getLabel: function (val) {
	    var stepLvl = this._stepLvl;
	    var date = new Date(val);
	    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
	  },
	
	  /**
	   * @override
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      // Expand extent
	      extent[0] -= ONE_DAY;
	      extent[1] += ONE_DAY;
	    } // If there are no data and extent are [Infinity, -Infinity]
	
	
	    if (extent[1] === -Infinity && extent[0] === Infinity) {
	      var d = new Date();
	      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	      extent[0] = extent[1] - ONE_DAY;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
	    }
	  },
	
	  /**
	   * @override
	   */
	  niceTicks: function (approxTickNum, minInterval, maxInterval) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	    var approxInterval = span / approxTickNum;
	
	    if (minInterval != null && approxInterval < minInterval) {
	      approxInterval = minInterval;
	    }
	
	    if (maxInterval != null && approxInterval > maxInterval) {
	      approxInterval = maxInterval;
	    }
	
	    var scaleLevelsLen = scaleLevels.length;
	    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
	    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
	    var interval = level[1]; // Same with interval scale if span is much larger than 1 year
	
	    if (level[0] === 'year') {
	      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
	      // var niceYearSpan = numberUtil.nice(yearSpan, false);
	
	      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
	      interval *= yearStep;
	    }
	
	    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
	    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
	    scaleHelper.fixExtent(niceExtent, extent);
	    this._stepLvl = level; // Interval will be used in getTicks
	
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	  parse: function (val) {
	    // val might be float.
	    return +numberUtil.parseDate(val);
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  TimeScale.prototype[methodName] = function (val) {
	    return intervalScaleProto[methodName].call(this, this.parse(val));
	  };
	});
	/**
	 * This implementation was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	var scaleLevels = [// Format              interval
	['hh:mm:ss', ONE_SECOND], // 1s
	['hh:mm:ss', ONE_SECOND * 5], // 5s
	['hh:mm:ss', ONE_SECOND * 10], // 10s
	['hh:mm:ss', ONE_SECOND * 15], // 15s
	['hh:mm:ss', ONE_SECOND * 30], // 30s
	['hh:mm\nMM-dd', ONE_MINUTE], // 1m
	['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
	['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
	['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
	['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
	['hh:mm\nMM-dd', ONE_HOUR], // 1h
	['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
	['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
	['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
	['MM-dd\nyyyy', ONE_DAY], // 1d
	['MM-dd\nyyyy', ONE_DAY * 2], // 2d
	['MM-dd\nyyyy', ONE_DAY * 3], // 3d
	['MM-dd\nyyyy', ONE_DAY * 4], // 4d
	['MM-dd\nyyyy', ONE_DAY * 5], // 5d
	['MM-dd\nyyyy', ONE_DAY * 6], // 6d
	['week', ONE_DAY * 7], // 7d
	['MM-dd\nyyyy', ONE_DAY * 10], // 10d
	['week', ONE_DAY * 14], // 2w
	['week', ONE_DAY * 21], // 3w
	['month', ONE_DAY * 31], // 1M
	['week', ONE_DAY * 42], // 6w
	['month', ONE_DAY * 62], // 2M
	['week', ONE_DAY * 70], // 10w
	['quarter', ONE_DAY * 95], // 3M
	['month', ONE_DAY * 31 * 4], // 4M
	['month', ONE_DAY * 31 * 5], // 5M
	['half-year', ONE_DAY * 380 / 2], // 6M
	['month', ONE_DAY * 31 * 8], // 8M
	['month', ONE_DAY * 31 * 10], // 10M
	['year', ONE_DAY * 380] // 1Y
	];
	/**
	 * @param {module:echarts/model/Model}
	 * @return {module:echarts/scale/Time}
	 */
	
	TimeScale.create = function (model) {
	  return new TimeScale({
	    useUTC: model.ecModel.get('useUTC')
	  });
	};
	
	var _default = TimeScale;
	module.exports = _default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Scale = __webpack_require__(263);
	
	var numberUtil = __webpack_require__(218);
	
	var IntervalScale = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Log scale
	 * @module echarts/scale/Log
	 */
	// Use some method of IntervalScale
	var scaleProto = Scale.prototype;
	var intervalScaleProto = IntervalScale.prototype;
	var getPrecisionSafe = numberUtil.getPrecisionSafe;
	var roundingErrorFix = numberUtil.round;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var mathPow = Math.pow;
	var mathLog = Math.log;
	var LogScale = Scale.extend({
	  type: 'log',
	  base: 10,
	  $constructor: function () {
	    Scale.apply(this, arguments);
	    this._originalScale = new IntervalScale();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getTicks: function () {
	    var originalScale = this._originalScale;
	    var extent = this._extent;
	    var originalExtent = originalScale.getExtent();
	    return zrUtil.map(intervalScaleProto.getTicks.call(this), function (val) {
	      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158
	
	      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	      return powVal;
	    }, this);
	  },
	
	  /**
	   * @param {number} val
	   * @return {string}
	   */
	  getLabel: intervalScaleProto.getLabel,
	
	  /**
	   * @param  {number} val
	   * @return {number}
	   */
	  scale: function (val) {
	    val = scaleProto.scale.call(this, val);
	    return mathPow(this.base, val);
	  },
	
	  /**
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var base = this.base;
	    start = mathLog(start) / mathLog(base);
	    end = mathLog(end) / mathLog(base);
	    intervalScaleProto.setExtent.call(this, start, end);
	  },
	
	  /**
	   * @return {number} end
	   */
	  getExtent: function () {
	    var base = this.base;
	    var extent = scaleProto.getExtent.call(this);
	    extent[0] = mathPow(base, extent[0]);
	    extent[1] = mathPow(base, extent[1]); // Fix #4158
	
	    var originalScale = this._originalScale;
	    var originalExtent = originalScale.getExtent();
	    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	    return extent;
	  },
	
	  /**
	   * @param  {Array.<number>} extent
	   */
	  unionExtent: function (extent) {
	    this._originalScale.unionExtent(extent);
	
	    var base = this.base;
	    extent[0] = mathLog(extent[0]) / mathLog(base);
	    extent[1] = mathLog(extent[1]) / mathLog(base);
	    scaleProto.unionExtent.call(this, extent);
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    // TODO
	    // filter value that <= 0
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   * @param  {number} [approxTickNum = 10] Given approx tick number
	   */
	  niceTicks: function (approxTickNum) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (span === Infinity || span <= 0) {
	      return;
	    }
	
	    var interval = numberUtil.quantity(span);
	    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	    if (err <= 0.5) {
	      interval *= 10;
	    } // Interval should be integer
	
	
	    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	      interval *= 10;
	    }
	
	    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @override
	   */
	  niceExtent: function (opt) {
	    intervalScaleProto.niceExtent.call(this, opt);
	    var originalScale = this._originalScale;
	    originalScale.__fixMin = opt.fixMin;
	    originalScale.__fixMax = opt.fixMax;
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  LogScale.prototype[methodName] = function (val) {
	    val = mathLog(val) / mathLog(this.base);
	    return scaleProto[methodName].call(this, val);
	  };
	});
	
	LogScale.create = function () {
	  return new LogScale();
	};
	
	function fixRoundingError(val, originalVal) {
	  return roundingErrorFix(val, getPrecisionSafe(originalVal));
	}
	
	var _default = LogScale;
	module.exports = _default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as axisHelper from './axisHelper';
	var _default = {
	  /**
	   * @param {boolean} origin
	   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
	   */
	  getMin: function (origin) {
	    var option = this.option;
	    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
	
	    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
	      min = this.axis.scale.parse(min);
	    }
	
	    return min;
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
	   */
	  getMax: function (origin) {
	    var option = this.option;
	    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
	
	    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
	      max = this.axis.scale.parse(max);
	    }
	
	    return max;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  getNeedCrossZero: function () {
	    var option = this.option;
	    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
	  },
	
	  /**
	   * Should be implemented by each axis model if necessary.
	   * @return {module:echarts/model/Component} coordinate system model
	   */
	  getCoordSysModel: zrUtil.noop,
	
	  /**
	   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
	   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
	   */
	  setRange: function (rangeStart, rangeEnd) {
	    this.option.rangeStart = rangeStart;
	    this.option.rangeEnd = rangeEnd;
	  },
	
	  /**
	   * Reset range
	   */
	  resetRange: function () {
	    // rangeStart and rangeEnd is readonly.
	    this.option.rangeStart = this.option.rangeEnd = null;
	  }
	};
	module.exports = _default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var BoundingRect = __webpack_require__(154);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Symbol factory
	
	/**
	 * Triangle shape
	 * @inner
	 */
	var Triangle = graphic.extendShape({
	  type: 'triangle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy + height);
	    path.lineTo(cx - width, cy + height);
	    path.closePath();
	  }
	});
	/**
	 * Diamond shape
	 * @inner
	 */
	
	var Diamond = graphic.extendShape({
	  type: 'diamond',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy);
	    path.lineTo(cx, cy + height);
	    path.lineTo(cx - width, cy);
	    path.closePath();
	  }
	});
	/**
	 * Pin shape
	 * @inner
	 */
	
	var Pin = graphic.extendShape({
	  type: 'pin',
	  shape: {
	    // x, y on the cusp
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var w = shape.width / 5 * 3; // Height must be larger than width
	
	    var h = Math.max(w, shape.height);
	    var r = w / 2; // Dist on y with tangent point and circle center
	
	    var dy = r * r / (h - r);
	    var cy = y - h + r + dy;
	    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	    var dx = Math.cos(angle) * r;
	    var tanX = Math.sin(angle);
	    var tanY = Math.cos(angle);
	    var cpLen = r * 0.6;
	    var cpLen2 = r * 0.7;
	    path.moveTo(x - dx, cy + dy);
	    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	    path.closePath();
	  }
	});
	/**
	 * Arrow shape
	 * @inner
	 */
	
	var Arrow = graphic.extendShape({
	  type: 'arrow',
	  shape: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var height = shape.height;
	    var width = shape.width;
	    var x = shape.x;
	    var y = shape.y;
	    var dx = width / 3 * 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(x + dx, y + height);
	    ctx.lineTo(x, y + height / 4 * 3);
	    ctx.lineTo(x - dx, y + height);
	    ctx.lineTo(x, y);
	    ctx.closePath();
	  }
	});
	/**
	 * Map of path contructors
	 * @type {Object.<string, module:zrender/graphic/Path>}
	 */
	
	var symbolCtors = {
	  line: graphic.Line,
	  rect: graphic.Rect,
	  roundRect: graphic.Rect,
	  square: graphic.Rect,
	  circle: graphic.Circle,
	  diamond: Diamond,
	  pin: Pin,
	  arrow: Arrow,
	  triangle: Triangle
	};
	var symbolShapeMakers = {
	  line: function (x, y, w, h, shape) {
	    // FIXME
	    shape.x1 = x;
	    shape.y1 = y + h / 2;
	    shape.x2 = x + w;
	    shape.y2 = y + h / 2;
	  },
	  rect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	  },
	  roundRect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	    shape.r = Math.min(w, h) / 4;
	  },
	  square: function (x, y, w, h, shape) {
	    var size = Math.min(w, h);
	    shape.x = x;
	    shape.y = y;
	    shape.width = size;
	    shape.height = size;
	  },
	  circle: function (x, y, w, h, shape) {
	    // Put circle in the center of square
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.r = Math.min(w, h) / 2;
	  },
	  diamond: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  pin: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  arrow: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  triangle: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  }
	};
	var symbolBuildProxies = {};
	zrUtil.each(symbolCtors, function (Ctor, name) {
	  symbolBuildProxies[name] = new Ctor();
	});
	var SymbolClz = graphic.extendShape({
	  type: 'symbol',
	  shape: {
	    symbolType: '',
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  beforeBrush: function () {
	    var style = this.style;
	    var shape = this.shape; // FIXME
	
	    if (shape.symbolType === 'pin' && style.textPosition === 'inside') {
	      style.textPosition = ['50%', '40%'];
	      style.textAlign = 'center';
	      style.textVerticalAlign = 'middle';
	    }
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    var symbolType = shape.symbolType;
	    var proxySymbol = symbolBuildProxies[symbolType];
	
	    if (shape.symbolType !== 'none') {
	      if (!proxySymbol) {
	        // Default rect
	        symbolType = 'rect';
	        proxySymbol = symbolBuildProxies[symbolType];
	      }
	
	      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	    }
	  }
	}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	function symbolPathSetColor(color, innerColor) {
	  if (this.type !== 'image') {
	    var symbolStyle = this.style;
	    var symbolShape = this.shape;
	
	    if (symbolShape && symbolShape.symbolType === 'line') {
	      symbolStyle.stroke = color;
	    } else if (this.__isEmptyBrush) {
	      symbolStyle.stroke = color;
	      symbolStyle.fill = innerColor || '#fff';
	    } else {
	      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
	      symbolStyle.fill && (symbolStyle.fill = color);
	      symbolStyle.stroke && (symbolStyle.stroke = color);
	    }
	
	    this.dirty(false);
	  }
	}
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolType
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
	 *                            for path and image only.
	 */
	
	
	function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
	  // TODO Support image object, DynamicImage.
	  var isEmpty = symbolType.indexOf('empty') === 0;
	
	  if (isEmpty) {
	    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	  }
	
	  var symbolPath;
	
	  if (symbolType.indexOf('image://') === 0) {
	    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else if (symbolType.indexOf('path://') === 0) {
	    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else {
	    symbolPath = new SymbolClz({
	      shape: {
	        symbolType: symbolType,
	        x: x,
	        y: y,
	        width: w,
	        height: h
	      }
	    });
	  }
	
	  symbolPath.__isEmptyBrush = isEmpty;
	  symbolPath.setColor = symbolPathSetColor;
	  symbolPath.setColor(color);
	  return symbolPath;
	}
	
	exports.createSymbol = createSymbol;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Region = __webpack_require__(273);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parse and decode geo json
	 * @module echarts/coord/geo/parseGeoJson
	 */
	function decode(json) {
	  if (!json.UTF8Encoding) {
	    return json;
	  }
	
	  var encodeScale = json.UTF8Scale;
	
	  if (encodeScale == null) {
	    encodeScale = 1024;
	  }
	
	  var features = json.features;
	
	  for (var f = 0; f < features.length; f++) {
	    var feature = features[f];
	    var geometry = feature.geometry;
	    var coordinates = geometry.coordinates;
	    var encodeOffsets = geometry.encodeOffsets;
	
	    for (var c = 0; c < coordinates.length; c++) {
	      var coordinate = coordinates[c];
	
	      if (geometry.type === 'Polygon') {
	        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (var c2 = 0; c2 < coordinate.length; c2++) {
	          var polygon = coordinate[c2];
	          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
	        }
	      }
	    }
	  } // Has been decoded
	
	
	  json.UTF8Encoding = false;
	  return json;
	}
	
	function decodePolygon(coordinate, encodeOffsets, encodeScale) {
	  var result = [];
	  var prevX = encodeOffsets[0];
	  var prevY = encodeOffsets[1];
	
	  for (var i = 0; i < coordinate.length; i += 2) {
	    var x = coordinate.charCodeAt(i) - 64;
	    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	    x = x >> 1 ^ -(x & 1);
	    y = y >> 1 ^ -(y & 1); // Delta deocding
	
	    x += prevX;
	    y += prevY;
	    prevX = x;
	    prevY = y; // Dequantize
	
	    result.push([x / encodeScale, y / encodeScale]);
	  }
	
	  return result;
	}
	/**
	 * @alias module:echarts/coord/geo/parseGeoJson
	 * @param {Object} geoJson
	 * @return {module:zrender/container/Group}
	 */
	
	
	function _default(geoJson) {
	  decode(geoJson);
	  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
	    // Output of mapshaper may have geometry null
	    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	  }), function (featureObj) {
	    var properties = featureObj.properties;
	    var geo = featureObj.geometry;
	    var coordinates = geo.coordinates;
	    var geometries = [];
	
	    if (geo.type === 'Polygon') {
	      geometries.push({
	        type: 'polygon',
	        // According to the GeoJSON specification.
	        // First must be exterior, and the rest are all interior(holes).
	        exterior: coordinates[0],
	        interiors: coordinates.slice(1)
	      });
	    }
	
	    if (geo.type === 'MultiPolygon') {
	      zrUtil.each(coordinates, function (item) {
	        if (item[0]) {
	          geometries.push({
	            type: 'polygon',
	            exterior: item[0],
	            interiors: item.slice(1)
	          });
	        }
	      });
	    }
	
	    var region = new Region(properties.name, geometries, properties.cp);
	    region.properties = properties;
	    return region;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(154);
	
	var bbox = __webpack_require__(185);
	
	var vec2 = __webpack_require__(136);
	
	var polygonContain = __webpack_require__(274);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/geo/Region
	 */
	
	/**
	 * @param {string|Region} name
	 * @param {Array} geometries
	 * @param {Array.<number>} cp
	 */
	function Region(name, geometries, cp) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.name = name;
	  /**
	   * @type {Array.<Array>}
	   * @readOnly
	   */
	
	  this.geometries = geometries;
	
	  if (!cp) {
	    var rect = this.getBoundingRect();
	    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  } else {
	    cp = [cp[0], cp[1]];
	  }
	  /**
	   * @type {Array.<number>}
	   */
	
	
	  this.center = cp;
	}
	
	Region.prototype = {
	  constructor: Region,
	  properties: null,
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    var rect = this._rect;
	
	    if (rect) {
	      return rect;
	    }
	
	    var MAX_NUMBER = Number.MAX_VALUE;
	    var min = [MAX_NUMBER, MAX_NUMBER];
	    var max = [-MAX_NUMBER, -MAX_NUMBER];
	    var min2 = [];
	    var max2 = [];
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      } // Doesn't consider hole
	
	
	      var exterior = geometries[i].exterior;
	      bbox.fromPoints(exterior, min2, max2);
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * @param {<Array.<number>} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var rect = this.getBoundingRect();
	    var geometries = this.geometries;
	
	    if (!rect.contain(coord[0], coord[1])) {
	      return false;
	    }
	
	    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      if (polygonContain.contain(exterior, coord[0], coord[1])) {
	        // Not in the region if point is in the hole.
	        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	          if (polygonContain.contain(interiors[k])) {
	            continue loopGeo;
	          }
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  },
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var aspect = rect.width / rect.height;
	
	    if (!width) {
	      width = aspect * height;
	    } else if (!height) {
	      height = width / aspect;
	    }
	
	    var target = new BoundingRect(x, y, width, height);
	    var transform = rect.calculateTransform(target);
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      for (var p = 0; p < exterior.length; p++) {
	        vec2.applyTransform(exterior[p], exterior[p], transform);
	      }
	
	      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
	        for (var p = 0; p < interiors[h].length; p++) {
	          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
	        }
	      }
	    }
	
	    rect = this._rect;
	    rect.copy(target); // Update center
	
	    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  },
	  cloneShallow: function (name) {
	    name == null && (name = this.name);
	    var newRegion = new Region(name, this.geometries, this.center);
	    newRegion._rect = this._rect;
	    newRegion.transformTo = null; // Simply avoid to be called.
	
	    return newRegion;
	  }
	};
	var _default = Region;
	module.exports = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var windingLine = __webpack_require__(192);
	
	var EPSILON = 1e-8;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	}
	
	function contain(points, x, y) {
	  var w = 0;
	  var p = points[0];
	
	  if (!p) {
	    return false;
	  }
	
	  for (var i = 1; i < points.length; i++) {
	    var p2 = points[i];
	    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	    p = p2;
	  } // Close polygon
	
	
	  var p0 = points[0];
	
	  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
	    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	  }
	
	  return w !== 0;
	}
	
	exports.contain = contain;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var map = _util.map;
	
	var _number = __webpack_require__(218);
	
	var linearMap = _number.linearMap;
	var getPixelPrecision = _number.getPixelPrecision;
	
	var _axisTickLabelBuilder = __webpack_require__(276);
	
	var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
	var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
	var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMALIZED_EXTENT = [0, 1];
	/**
	 * Base class of Axis.
	 * @constructor
	 */
	
	var Axis = function (dim, scale, extent) {
	  /**
	   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
	   * @type {string}
	   */
	  this.dim = dim;
	  /**
	   * Axis scale
	   * @type {module:echarts/coord/scale/*}
	   */
	
	  this.scale = scale;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  this._extent = extent || [0, 0];
	  /**
	   * @type {boolean}
	   */
	
	  this.inverse = false;
	  /**
	   * Usually true when axis has a ordinal scale
	   * @type {boolean}
	   */
	
	  this.onBand = false;
	};
	
	Axis.prototype = {
	  constructor: Axis,
	
	  /**
	   * If axis extent contain given coord
	   * @param {number} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var extent = this._extent;
	    var min = Math.min(extent[0], extent[1]);
	    var max = Math.max(extent[0], extent[1]);
	    return coord >= min && coord <= max;
	  },
	
	  /**
	   * If axis extent contain given data
	   * @param {number} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.contain(this.dataToCoord(data));
	  },
	
	  /**
	   * Get coord extent.
	   * @return {Array.<number>}
	   */
	  getExtent: function () {
	    return this._extent.slice();
	  },
	
	  /**
	   * Get precision used for formatting
	   * @param {Array.<number>} [dataExtent]
	   * @return {number}
	   */
	  getPixelPrecision: function (dataExtent) {
	    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	  },
	
	  /**
	   * Set coord extent
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var extent = this._extent;
	    extent[0] = start;
	    extent[1] = end;
	  },
	
	  /**
	   * Convert data to coord. Data is the rank if it has an ordinal scale
	   * @param {number} data
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  dataToCoord: function (data, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	    data = scale.normalize(data);
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
	  },
	
	  /**
	   * Convert coord to data. Data is the rank if it has an ordinal scale
	   * @param {number} coord
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  coordToData: function (coord, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
	    return this.scale.scale(t);
	  },
	
	  /**
	   * Convert pixel point to data in axis
	   * @param {Array.<number>} point
	   * @param  {boolean} clamp
	   * @return {number} data
	   */
	  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
	  },
	
	  /**
	   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
	   * `axis.getTicksCoords` considers `onBand`, which is used by
	   * `boundaryGap:true` of category axis and splitLine and splitArea.
	   * @param {Object} [opt]
	   * @param {number} [opt.tickModel=axis.model.getModel('axisTick')]
	   * @param {boolean} [opt.clamp] If `true`, the first and the last
	   *        tick must be at the axis end points. Otherwise, clip ticks
	   *        that outside the axis extent.
	   * @return {Array.<Object>} [{
	   *     coord: ...,
	   *     tickValue: ...
	   * }, ...]
	   */
	  getTicksCoords: function (opt) {
	    opt = opt || {};
	    var tickModel = opt.tickModel || this.getTickModel();
	    var result = createAxisTicks(this, tickModel);
	    var ticks = result.ticks;
	    var ticksCoords = map(ticks, function (tickValue) {
	      return {
	        coord: this.dataToCoord(tickValue),
	        tickValue: tickValue
	      };
	    }, this);
	    var alignWithLabel = tickModel.get('alignWithLabel');
	    fixOnBandTicksCoords(this, ticksCoords, result.tickCategoryInterval, alignWithLabel, opt.clamp);
	    return ticksCoords;
	  },
	
	  /**
	   * @return {Array.<Object>} [{
	   *     formattedLabel: string,
	   *     rawLabel: axis.scale.getLabel(tickValue)
	   *     tickValue: number
	   * }, ...]
	   */
	  getViewLabels: function () {
	    return createAxisLabels(this).labels;
	  },
	
	  /**
	   * @return {module:echarts/coord/model/Model}
	   */
	  getLabelModel: function () {
	    return this.model.getModel('axisLabel');
	  },
	
	  /**
	   * Notice here we only get the default tick model. For splitLine
	   * or splitArea, we should pass the splitLineModel or splitAreaModel
	   * manually when calling `getTicksCoords`.
	   * In GL, this method may be overrided to:
	   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
	   * @return {module:echarts/coord/model/Model}
	   */
	  getTickModel: function () {
	    return this.model.getModel('axisTick');
	  },
	
	  /**
	   * Get width of band
	   * @return {number}
	   */
	  getBandWidth: function () {
	    var axisExtent = this._extent;
	    var dataExtent = this.scale.getExtent();
	    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	    len === 0 && (len = 1);
	    var size = Math.abs(axisExtent[1] - axisExtent[0]);
	    return Math.abs(size) / len;
	  },
	
	  /**
	   * @abstract
	   * @return {boolean} Is horizontal
	   */
	  isHorizontal: null,
	
	  /**
	   * @abstract
	   * @return {number} Get axis rotate, by degree.
	   */
	  getRotate: null,
	
	  /**
	   * Only be called in category axis.
	   * Can be overrided, consider other axes like in 3D.
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    return calculateCategoryInterval(this);
	  }
	};
	
	function fixExtentWithBands(extent, nTick) {
	  var size = extent[1] - extent[0];
	  var len = nTick;
	  var margin = size / len / 2;
	  extent[0] += margin;
	  extent[1] -= margin;
	} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
	// |---1---|---2---|---3---|---4---|.
	// So the displayed ticks and splitLine/splitArea should between
	// each data item, otherwise cause misleading (e.g., split tow bars
	// of a single data item when there are two bar series).
	// Also consider if tickCategoryInterval > 0 and onBand, ticks and
	// splitLine/spliteArea should layout appropriately corresponding
	// to displayed labels. (So we should not use `getBandWidth` in this
	// case).
	
	
	function fixOnBandTicksCoords(axis, ticksCoords, tickCategoryInterval, alignWithLabel, clamp) {
	  var ticksLen = ticksCoords.length;
	
	  if (!axis.onBand || alignWithLabel || !ticksLen) {
	    return;
	  }
	
	  var axisExtent = axis.getExtent();
	  var last;
	
	  if (ticksLen === 1) {
	    ticksCoords[0].coord = axisExtent[0];
	    last = ticksCoords[1] = {
	      coord: axisExtent[0]
	    };
	  } else {
	    var shift = ticksCoords[1].coord - ticksCoords[0].coord;
	    each(ticksCoords, function (ticksItem) {
	      ticksItem.coord -= shift / 2;
	      var tickCategoryInterval = tickCategoryInterval || 0; // Avoid split a single data item when odd interval.
	
	      if (tickCategoryInterval % 2 > 0) {
	        ticksItem.coord -= shift / ((tickCategoryInterval + 1) * 2);
	      }
	    });
	    last = {
	      coord: ticksCoords[ticksLen - 1].coord + shift
	    };
	    ticksCoords.push(last);
	  }
	
	  var inverse = axisExtent[0] > axisExtent[1];
	
	  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
	    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
	  }
	
	  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
	    ticksCoords.unshift({
	      coord: axisExtent[0]
	    });
	  }
	
	  if (littleThan(axisExtent[1], last.coord)) {
	    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
	  }
	
	  if (clamp && littleThan(last.coord, axisExtent[1])) {
	    ticksCoords.push({
	      coord: axisExtent[1]
	    });
	  }
	
	  function littleThan(a, b) {
	    return inverse ? a > b : a < b;
	  }
	}
	
	var _default = Axis;
	module.exports = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var textContain = __webpack_require__(167);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	var _axisHelper = __webpack_require__(261);
	
	var makeLabelFormatter = _axisHelper.makeLabelFormatter;
	var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @return {Object} {
	 *     labels: [{
	 *         formattedLabel: string,
	 *         rawLabel: string,
	 *         tickValue: number
	 *     }, ...],
	 *     labelCategoryInterval: number
	 * }
	 */
	
	function createAxisLabels(axis) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
	}
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
	 * @return {Object} {
	 *     ticks: Array.<number>
	 *     tickCategoryInterval: number
	 * }
	 */
	
	
	function createAxisTicks(axis, tickModel) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
	    ticks: axis.scale.getTicks()
	  };
	}
	
	function makeCategoryLabels(axis) {
	  var labelModel = axis.getLabelModel();
	  var result = makeCategoryLabelsActually(axis, labelModel);
	  return !labelModel.get('show') || axis.scale.isBlank() ? {
	    labels: [],
	    labelCategoryInterval: result.labelCategoryInterval
	  } : result;
	}
	
	function makeCategoryLabelsActually(axis, labelModel) {
	  var labelsCache = getListCache(axis, 'labels');
	  var optionLabelInterval = getOptionCategoryInterval(labelModel);
	  var result = listCacheGet(labelsCache, optionLabelInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var labels;
	  var numericLabelInterval;
	
	  if (zrUtil.isFunction(optionLabelInterval)) {
	    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
	  } else {
	    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
	    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
	  } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(labelsCache, optionLabelInterval, {
	    labels: labels,
	    labelCategoryInterval: numericLabelInterval
	  });
	}
	
	function makeCategoryTicks(axis, tickModel) {
	  var ticksCache = getListCache(axis, 'ticks');
	  var optionTickInterval = getOptionCategoryInterval(tickModel);
	  var result = listCacheGet(ticksCache, optionTickInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var ticks;
	  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
	  // we should not return all ticks.
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    ticks = [];
	  }
	
	  if (zrUtil.isFunction(optionTickInterval)) {
	    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
	  } // Always use label interval by default despite label show. Consider this
	  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
	  // labels. `splitLine` and `axisTick` should be consistent in this case.
	  else if (optionTickInterval === 'auto') {
	      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
	      tickCategoryInterval = labelsResult.labelCategoryInterval;
	      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
	        return labelItem.tickValue;
	      });
	    } else {
	      tickCategoryInterval = optionTickInterval;
	      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
	    } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(ticksCache, optionTickInterval, {
	    ticks: ticks,
	    tickCategoryInterval: tickCategoryInterval
	  });
	}
	
	function makeRealNumberLabels(axis) {
	  var ticks = axis.scale.getTicks();
	  var labelFormatter = makeLabelFormatter(axis);
	  return {
	    labels: zrUtil.map(ticks, function (tickValue, idx) {
	      return {
	        formattedLabel: labelFormatter(tickValue, idx),
	        rawLabel: axis.scale.getLabel(tickValue),
	        tickValue: tickValue
	      };
	    })
	  };
	} // Large category data calculation is performence sensitive, and ticks and label
	// probably be fetched by multiple times. So we cache the result.
	// axis is created each time during a ec process, so we do not need to clear cache.
	
	
	function getListCache(axis, prop) {
	  // Because key can be funciton, and cache size always be small, we use array cache.
	  return inner(axis)[prop] || (inner(axis)[prop] = []);
	}
	
	function listCacheGet(cache, key) {
	  for (var i = 0; i < cache.length; i++) {
	    if (cache[i].key === key) {
	      return cache[i].value;
	    }
	  }
	}
	
	function listCacheSet(cache, key, value) {
	  cache.push({
	    key: key,
	    value: value
	  });
	  return value;
	}
	
	function makeAutoCategoryInterval(axis) {
	  var result = inner(axis).autoInterval;
	  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
	}
	/**
	 * Calculate interval for category axis ticks and labels.
	 * To get precise result, at least one of `getRotate` and `isHorizontal`
	 * should be implemented in axis.
	 */
	
	
	function calculateCategoryInterval(axis) {
	  var params = fetchAutoCategoryIntervalCalculationParams(axis);
	  var labelFormatter = makeLabelFormatter(axis);
	  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	  // avoid generating a long array by `getTicks`
	  // in large category data case.
	
	  var tickCount = ordinalScale.count();
	
	  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	    return 0;
	  }
	
	  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
	
	  if (tickCount > 40) {
	    step = Math.max(1, Math.floor(tickCount / 40));
	  }
	
	  var tickValue = ordinalExtent[0];
	  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	  var unitW = Math.abs(unitSpan * Math.cos(rotation));
	  var unitH = Math.abs(unitSpan * Math.sin(rotation));
	  var maxW = 0;
	  var maxH = 0; // Caution: Performance sensitive for large category data.
	  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    var width = 0;
	    var height = 0; // Not precise, do not consider align and vertical align
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number
	
	    width = rect.width * 1.3;
	    height = rect.height * 1.3; // Min size, void long loop.
	
	    maxW = Math.max(maxW, width, 7);
	    maxH = Math.max(maxH, height, 7);
	  }
	
	  var dw = maxW / unitW;
	  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	  isNaN(dw) && (dw = Infinity);
	  isNaN(dh) && (dh = Infinity);
	  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
	  var cache = inner(axis.model);
	  var lastAutoInterval = cache.lastAutoInterval;
	  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	  // otherwise the calculated interval might jitter when the zoom
	  // window size is close to the interval-changing size.
	
	  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	  // point is not the same when zooming in or zooming out.
	  && lastAutoInterval > interval) {
	    interval = lastAutoInterval;
	  } // Only update cache if cache not used, otherwise the
	  // changing of interval is too insensitive.
	  else {
	      cache.lastTickCount = tickCount;
	      cache.lastAutoInterval = interval;
	    }
	
	  return interval;
	}
	
	function fetchAutoCategoryIntervalCalculationParams(axis) {
	  var labelModel = axis.getLabelModel();
	  return {
	    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
	    labelRotate: labelModel.get('rotate') || 0,
	    font: labelModel.getFont()
	  };
	}
	
	function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
	  var labelFormatter = makeLabelFormatter(axis);
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent();
	  var labelModel = axis.getLabelModel();
	  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
	
	  var step = Math.max((categoryInterval || 0) + 1, 1);
	  var startTick = ordinalExtent[0];
	  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
	  // while zooming and moving while interval > 0. Otherwise the selection
	  // of displayable ticks and symbols probably keep changing.
	  // 3 is empirical value.
	
	  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
	    startTick = Math.round(Math.ceil(startTick / step) * step);
	  } // (1) Only add min max label here but leave overlap checking
	  // to render stage, which also ensure the returned list
	  // suitable for splitLine and splitArea rendering.
	  // (2) Scales except category always contain min max label so
	  // do not need to perform this process.
	
	
	  var showAllLabel = shouldShowAllLabels(axis);
	  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
	  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
	
	  if (includeMinLabel && startTick !== ordinalExtent[0]) {
	    addItem(ordinalExtent[0]);
	  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
	
	
	  var tickValue = startTick;
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    addItem(tickValue);
	  }
	
	  if (includeMaxLabel && tickValue !== ordinalExtent[1]) {
	    addItem(ordinalExtent[1]);
	  }
	
	  function addItem(tVal) {
	    result.push(onlyTick ? tVal : {
	      formattedLabel: labelFormatter(tVal),
	      rawLabel: ordinalScale.getLabel(tVal),
	      tickValue: tVal
	    });
	  }
	
	  return result;
	} // When interval is function, the result `false` means ignore the tick.
	// It is time consuming for large category data.
	
	
	function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
	  var ordinalScale = axis.scale;
	  var labelFormatter = makeLabelFormatter(axis);
	  var result = [];
	  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
	    var rawLabel = ordinalScale.getLabel(tickValue);
	
	    if (categoryInterval(tickValue, rawLabel)) {
	      result.push(onlyTick ? tickValue : {
	        formattedLabel: labelFormatter(tickValue),
	        rawLabel: rawLabel,
	        tickValue: tickValue
	      });
	    }
	  });
	  return result;
	}
	
	exports.createAxisLabels = createAxisLabels;
	exports.createAxisTicks = createAxisTicks;
	exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(278);
	
	__webpack_require__(279);
	
	var visualSymbol = __webpack_require__(286);
	
	var layoutPoints = __webpack_require__(287);
	
	var dataSample = __webpack_require__(288);
	
	__webpack_require__(289);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
	echarts.registerLayout(layoutPoints('line')); // Down sample after filter
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var createListFromArray = __webpack_require__(254);
	
	var SeriesModel = __webpack_require__(233);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.line',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // stack: null
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // If clip the overflow value
	    clipOverflow: true,
	    // cursor: null,
	    label: {
	      position: 'top'
	    },
	    // itemStyle: {
	    // },
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    // areaStyle: {
	    // origin of areaStyle. Valid values:
	    // `'auto'/null/undefined`: from axisLine to data
	    // `'start'`: from min to data
	    // `'end'`: from data to max
	    // origin: 'auto'
	    // },
	    // false, 'start', 'end', 'middle'
	    step: false,
	    // Disabled if step is true
	    smooth: false,
	    smoothMonotone: null,
	    symbol: 'emptyCircle',
	    symbolSize: 4,
	    symbolRotate: null,
	    showSymbol: true,
	    // `false`: follow the label interval strategy.
	    // `true`: show all symbols.
	    // `'auto'`: If possible, show all symbols, otherwise
	    //           follow the label interval strategy.
	    showAllSymbol: 'auto',
	    // Whether to connect break point.
	    connectNulls: false,
	    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
	    sampling: 'none',
	    animationEasing: 'linear',
	    // Disable progressive
	    progressive: 0,
	    hoverLayerThreshold: Infinity
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var SymbolDraw = __webpack_require__(280);
	
	var SymbolClz = __webpack_require__(281);
	
	var lineAnimationDiff = __webpack_require__(283);
	
	var graphic = __webpack_require__(180);
	
	var modelUtil = __webpack_require__(173);
	
	var _poly = __webpack_require__(285);
	
	var Polyline = _poly.Polyline;
	var Polygon = _poly.Polygon;
	
	var ChartView = __webpack_require__(238);
	
	var _number = __webpack_require__(218);
	
	var round = _number.round;
	
	var _helper = __webpack_require__(284);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME step not support polar
	function isPointsSame(points1, points2) {
	  if (points1.length !== points2.length) {
	    return;
	  }
	
	  for (var i = 0; i < points1.length; i++) {
	    var p1 = points1[i];
	    var p2 = points2[i];
	
	    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
	      return;
	    }
	  }
	
	  return true;
	}
	
	function getSmooth(smooth) {
	  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
	}
	
	function getAxisExtentWithGap(axis) {
	  var extent = axis.getGlobalExtent();
	
	  if (axis.onBand) {
	    // Remove extra 1px to avoid line miter in clipped edge
	    var halfBandWidth = axis.getBandWidth() / 2 - 1;
	    var dir = extent[1] > extent[0] ? 1 : -1;
	    extent[0] += dir * halfBandWidth;
	    extent[1] -= dir * halfBandWidth;
	  }
	
	  return extent;
	}
	/**
	 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {Object} dataCoordInfo
	 * @param {Array.<Array.<number>>} points
	 */
	
	
	function getStackedOnPoints(coordSys, data, dataCoordInfo) {
	  if (!dataCoordInfo.valueDim) {
	    return [];
	  }
	
	  var points = [];
	
	  for (var idx = 0, len = data.count(); idx < len; idx++) {
	    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
	  }
	
	  return points;
	}
	
	function createGridClipShape(cartesian, hasAnimation, forSymbol, seriesModel) {
	  var xExtent = getAxisExtentWithGap(cartesian.getAxis('x'));
	  var yExtent = getAxisExtentWithGap(cartesian.getAxis('y'));
	  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
	  var x = Math.min(xExtent[0], xExtent[1]);
	  var y = Math.min(yExtent[0], yExtent[1]);
	  var width = Math.max(xExtent[0], xExtent[1]) - x;
	  var height = Math.max(yExtent[0], yExtent[1]) - y; // Avoid float number rounding error for symbol on the edge of axis extent.
	  // See #7913 and `test/dataZoom-clip.html`.
	
	  if (forSymbol) {
	    x -= 0.5;
	    width += 0.5;
	    y -= 0.5;
	    height += 0.5;
	  } else {
	    var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand clip shape to avoid clipping when line value exceeds axis
	
	    var expandSize = seriesModel.get('clipOverflow') ? lineWidth / 2 : Math.max(width, height);
	
	    if (isHorizontal) {
	      y -= expandSize;
	      height += expandSize * 2;
	    } else {
	      x -= expandSize;
	      width += expandSize * 2;
	    }
	  }
	
	  var clipPath = new graphic.Rect({
	    shape: {
	      x: x,
	      y: y,
	      width: width,
	      height: height
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
	    graphic.initProps(clipPath, {
	      shape: {
	        width: width,
	        height: height
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createPolarClipShape(polar, hasAnimation, forSymbol, seriesModel) {
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis();
	  var radiusExtent = radiusAxis.getExtent().slice();
	  radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
	  var angleExtent = angleAxis.getExtent();
	  var RADIAN = Math.PI / 180; // Avoid float number rounding error for symbol on the edge of axis extent.
	
	  if (forSymbol) {
	    radiusExtent[0] -= 0.5;
	    radiusExtent[1] += 0.5;
	  }
	
	  var clipPath = new graphic.Sector({
	    shape: {
	      cx: round(polar.cx, 1),
	      cy: round(polar.cy, 1),
	      r0: round(radiusExtent[0], 1),
	      r: round(radiusExtent[1], 1),
	      startAngle: -angleExtent[0] * RADIAN,
	      endAngle: -angleExtent[1] * RADIAN,
	      clockwise: angleAxis.inverse
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape.endAngle = -angleExtent[0] * RADIAN;
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: -angleExtent[1] * RADIAN
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createClipShape(coordSys, hasAnimation, forSymbol, seriesModel) {
	  return coordSys.type === 'polar' ? createPolarClipShape(coordSys, hasAnimation, forSymbol, seriesModel) : createGridClipShape(coordSys, hasAnimation, forSymbol, seriesModel);
	}
	
	function turnPointsIntoStep(points, coordSys, stepTurnAt) {
	  var baseAxis = coordSys.getBaseAxis();
	  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	  var stepPoints = [];
	
	  for (var i = 0; i < points.length - 1; i++) {
	    var nextPt = points[i + 1];
	    var pt = points[i];
	    stepPoints.push(pt);
	    var stepPt = [];
	
	    switch (stepTurnAt) {
	      case 'end':
	        stepPt[baseIndex] = nextPt[baseIndex];
	        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	        break;
	
	      case 'middle':
	        // default is start
	        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	        var stepPt2 = [];
	        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	        stepPt[1 - baseIndex] = pt[1 - baseIndex];
	        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	        stepPoints.push(stepPt);
	        stepPoints.push(stepPt2);
	        break;
	
	      default:
	        stepPt[baseIndex] = pt[baseIndex];
	        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	    }
	  } // Last points
	
	
	  points[i] && stepPoints.push(points[i]);
	  return stepPoints;
	}
	
	function getVisualGradient(data, coordSys) {
	  var visualMetaList = data.getVisual('visualMeta');
	
	  if (!visualMetaList || !visualMetaList.length || !data.count()) {
	    // When data.count() is 0, gradient range can not be calculated.
	    return;
	  }
	
	  if (coordSys.type !== 'cartesian2d') {
	    return;
	  }
	
	  var coordDim;
	  var visualMeta;
	
	  for (var i = visualMetaList.length - 1; i >= 0; i--) {
	    var dimIndex = visualMetaList[i].dimension;
	    var dimName = data.dimensions[dimIndex];
	    var dimInfo = data.getDimensionInfo(dimName);
	    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
	
	    if (coordDim === 'x' || coordDim === 'y') {
	      visualMeta = visualMetaList[i];
	      break;
	    }
	  }
	
	  if (!visualMeta) {
	    return;
	  } // If the area to be rendered is bigger than area defined by LinearGradient,
	  // the canvas spec prescribes that the color of the first stop and the last
	  // stop should be used. But if two stops are added at offset 0, in effect
	  // browsers use the color of the second stop to render area outside
	  // LinearGradient. So we can only infinitesimally extend area defined in
	  // LinearGradient to render `outerColors`.
	
	
	  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.
	
	  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
	    return {
	      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	      color: stop.color
	    };
	  });
	  var stopLen = colorStops.length;
	  var outerColors = visualMeta.outerColors.slice();
	
	  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	    colorStops.reverse();
	    outerColors.reverse();
	  }
	
	  var tinyExtent = 10; // Arbitrary value: 10px
	
	  var minCoord = colorStops[0].coord - tinyExtent;
	  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
	  var coordSpan = maxCoord - minCoord;
	
	  if (coordSpan < 1e-3) {
	    return 'transparent';
	  }
	
	  zrUtil.each(colorStops, function (stop) {
	    stop.offset = (stop.coord - minCoord) / coordSpan;
	  });
	  colorStops.push({
	    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
	    color: outerColors[1] || 'transparent'
	  });
	  colorStops.unshift({
	    // notice colorStops.length have been changed.
	    offset: stopLen ? colorStops[0].offset : 0.5,
	    color: outerColors[0] || 'transparent'
	  }); // zrUtil.each(colorStops, function (colorStop) {
	  //     // Make sure each offset has rounded px to avoid not sharp edge
	  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
	  // });
	
	  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
	  gradient[coordDim] = minCoord;
	  gradient[coordDim + '2'] = maxCoord;
	  return gradient;
	}
	
	function getIsIgnoreFunc(seriesModel, data, coordSys) {
	  var showAllSymbol = seriesModel.get('showAllSymbol');
	  var isAuto = showAllSymbol === 'auto';
	
	  if (showAllSymbol && !isAuto) {
	    return;
	  }
	
	  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	  if (!categoryAxis) {
	    return;
	  } // Note that category label interval strategy might bring some weird effect
	  // in some scenario: users may wonder why some of the symbols are not
	  // displayed. So we show all symbols as possible as we can.
	
	
	  if (isAuto // Simplify the logic, do not determine label overlap here.
	  && canShowAllSymbolForCategory(categoryAxis, data)) {
	    return;
	  } // Otherwise follow the label interval strategy on category axis.
	
	
	  var categoryDataDim = data.mapDimension(categoryAxis.dim);
	  var labelMap = {};
	  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
	    labelMap[labelItem.tickValue] = 1;
	  });
	  return function (dataIndex) {
	    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
	  };
	}
	
	function canShowAllSymbolForCategory(categoryAxis, data) {
	  // In mose cases, line is monotonous on category axis, and the label size
	  // is close with each other. So we check the symbol size and some of the
	  // label size alone with the category axis to estimate whether all symbol
	  // can be shown without overlap.
	  var axisExtent = categoryAxis.getExtent();
	  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
	  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
	  // Sampling some points, max 5.
	
	  var dataLen = data.count();
	  var step = Math.max(1, Math.round(dataLen / 5));
	
	  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
	    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
	    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
	    * 1.5 > availSize) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	var _default = ChartView.extend({
	  type: 'line',
	  init: function () {
	    var lineGroup = new graphic.Group();
	    var symbolDraw = new SymbolDraw();
	    this.group.add(symbolDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineGroup = lineGroup;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var areaStyleModel = seriesModel.getModel('areaStyle');
	    var points = data.mapArray(data.getItemLayout);
	    var isCoordSysPolar = coordSys.type === 'polar';
	    var prevCoordSys = this._coordSys;
	    var symbolDraw = this._symbolDraw;
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var lineGroup = this._lineGroup;
	    var hasAnimation = seriesModel.get('animation');
	    var isAreaChart = !areaStyleModel.isEmpty();
	    var valueOrigin = areaStyleModel.get('origin');
	    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
	    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
	    var showSymbol = seriesModel.get('showSymbol');
	    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
	
	    var oldData = this._data;
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    }); // Remove previous created symbols if showSymbol changed to false
	
	    if (!showSymbol) {
	      symbolDraw.remove();
	    }
	
	    group.add(lineGroup); // FIXME step not support polar
	
	    var step = !isCoordSysPolar && seriesModel.get('step'); // Initialization animation or coordinate system changed
	
	    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: createClipShape(coordSys, false, true, seriesModel)
	      });
	
	      if (step) {
	        // TODO If stacked series is not step
	        points = turnPointsIntoStep(points, coordSys, step);
	        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	      }
	
	      polyline = this._newPolyline(points, coordSys, hasAnimation);
	
	      if (isAreaChart) {
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      }
	
	      lineGroup.setClipPath(createClipShape(coordSys, true, false, seriesModel));
	    } else {
	      if (isAreaChart && !polygon) {
	        // If areaStyle is added
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      } else if (polygon && !isAreaChart) {
	        // If areaStyle is removed
	        lineGroup.remove(polygon);
	        polygon = this._polygon = null;
	      } // Update clipPath
	
	
	      lineGroup.setClipPath(createClipShape(coordSys, false, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
	      // because points are not changed
	
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: createClipShape(coordSys, false, true, seriesModel)
	      }); // Stop symbol animation and sync with line points
	      // FIXME performance?
	
	      data.eachItemGraphicEl(function (el) {
	        el.stopAnimation(true);
	      }); // In the case data zoom triggerred refreshing frequently
	      // Data may not change if line has a category axis. So it should animate nothing
	
	      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	        if (hasAnimation) {
	          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
	        } else {
	          // Not do it in update with animation
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step);
	            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	          }
	
	          polyline.setShape({
	            points: points
	          });
	          polygon && polygon.setShape({
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          });
	        }
	      }
	    }
	
	    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
	    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
	    lineStyleModel.getLineStyle(), {
	      fill: 'none',
	      stroke: visualColor,
	      lineJoin: 'bevel'
	    }));
	    var smooth = seriesModel.get('smooth');
	    smooth = getSmooth(seriesModel.get('smooth'));
	    polyline.setShape({
	      smooth: smooth,
	      smoothMonotone: seriesModel.get('smoothMonotone'),
	      connectNulls: seriesModel.get('connectNulls')
	    });
	
	    if (polygon) {
	      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	      var stackedOnSmooth = 0;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: visualColor,
	        opacity: 0.7,
	        lineJoin: 'bevel'
	      }));
	
	      if (stackedOnSeries) {
	        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	      }
	
	      polygon.setShape({
	        smooth: smooth,
	        stackedOnSmooth: stackedOnSmooth,
	        smoothMonotone: seriesModel.get('smoothMonotone'),
	        connectNulls: seriesModel.get('connectNulls')
	      });
	    }
	
	    this._data = data; // Save the coordinate system for transition animation when data changed
	
	    this._coordSys = coordSys;
	    this._stackedOnPoints = stackedOnPoints;
	    this._points = points;
	    this._step = step;
	    this._valueOrigin = valueOrigin;
	  },
	  dispose: function () {},
	  highlight: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (!symbol) {
	        // Create a temporary symbol if it is not exists
	        var pt = data.getItemLayout(dataIndex);
	
	        if (!pt) {
	          // Null data
	          return;
	        }
	
	        symbol = new SymbolClz(data, dataIndex);
	        symbol.position = pt;
	        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
	        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
	        symbol.__temp = true;
	        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	        symbol.stopSymbolAnimation(true);
	        this.group.add(symbol);
	      }
	
	      symbol.highlight();
	    } else {
	      // Highlight whole series
	      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	  downplay: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (symbol) {
	        if (symbol.__temp) {
	          data.setItemGraphicEl(dataIndex, null);
	          this.group.remove(symbol);
	        } else {
	          symbol.downplay();
	        }
	      }
	    } else {
	      // FIXME
	      // can not downplay completely.
	      // Downplay whole series
	      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolyline: function (points) {
	    var polyline = this._polyline; // Remove previous created polyline
	
	    if (polyline) {
	      this._lineGroup.remove(polyline);
	    }
	
	    polyline = new Polyline({
	      shape: {
	        points: points
	      },
	      silent: true,
	      z2: 10
	    });
	
	    this._lineGroup.add(polyline);
	
	    this._polyline = polyline;
	    return polyline;
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} stackedOnPoints
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolygon: function (points, stackedOnPoints) {
	    var polygon = this._polygon; // Remove previous created polygon
	
	    if (polygon) {
	      this._lineGroup.remove(polygon);
	    }
	
	    polygon = new Polygon({
	      shape: {
	        points: points,
	        stackedOnPoints: stackedOnPoints
	      },
	      silent: true
	    });
	
	    this._lineGroup.add(polygon);
	
	    this._polygon = polygon;
	    return polygon;
	  },
	
	  /**
	   * @private
	   */
	  // FIXME Two value axis
	  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var seriesModel = data.hostModel;
	    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
	    var current = diff.current;
	    var stackedOnCurrent = diff.stackedOnCurrent;
	    var next = diff.next;
	    var stackedOnNext = diff.stackedOnNext;
	
	    if (step) {
	      // TODO If stacked series is not step
	      current = turnPointsIntoStep(diff.current, coordSys, step);
	      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
	      next = turnPointsIntoStep(diff.next, coordSys, step);
	      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
	    } // `diff.current` is subset of `current` (which should be ensured by
	    // turnPointsIntoStep), so points in `__points` can be updated when
	    // points in `current` are update during animation.
	
	
	    polyline.shape.__points = diff.current;
	    polyline.shape.points = current;
	    graphic.updateProps(polyline, {
	      shape: {
	        points: next
	      }
	    }, seriesModel);
	
	    if (polygon) {
	      polygon.setShape({
	        points: current,
	        stackedOnPoints: stackedOnCurrent
	      });
	      graphic.updateProps(polygon, {
	        shape: {
	          points: next,
	          stackedOnPoints: stackedOnNext
	        }
	      }, seriesModel);
	    }
	
	    var updatedDataInfo = [];
	    var diffStatus = diff.status;
	
	    for (var i = 0; i < diffStatus.length; i++) {
	      var cmd = diffStatus[i].cmd;
	
	      if (cmd === '=') {
	        var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	        if (el) {
	          updatedDataInfo.push({
	            el: el,
	            ptIdx: i // Index of points
	
	          });
	        }
	      }
	    }
	
	    if (polyline.animators && polyline.animators.length) {
	      polyline.animators[0].during(function () {
	        for (var i = 0; i < updatedDataInfo.length; i++) {
	          var el = updatedDataInfo[i].el;
	          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
	        }
	      });
	    }
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var oldData = this._data;
	
	    this._lineGroup.removeAll();
	
	    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    });
	    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var SymbolClz = __webpack_require__(281);
	
	var _util = __webpack_require__(134);
	
	var isObject = _util.isObject;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/SymbolDraw
	 */
	
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/SymbolDraw
	 * @param {module:zrender/graphic/Group} [symbolCtor]
	 */
	function SymbolDraw(symbolCtor) {
	  this.group = new graphic.Group();
	  this._symbolCtor = symbolCtor || SymbolClz;
	}
	
	var symbolDrawProto = SymbolDraw.prototype;
	
	function symbolNeedsDraw(data, point, idx, opt) {
	  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
	  // the symbol element shape. We use the same clip shape here as
	  // the line clip.
	  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
	}
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.updateData = function (data, opt) {
	  opt = normalizeUpdateOpt(opt);
	  var group = this.group;
	  var seriesModel = data.hostModel;
	  var oldData = this._data;
	  var SymbolCtor = this._symbolCtor;
	  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldData) {
	    group.removeAll();
	  }
	
	  data.diff(oldData).add(function (newIdx) {
	    var point = data.getItemLayout(newIdx);
	
	    if (symbolNeedsDraw(data, point, newIdx, opt)) {
	      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
	      symbolEl.attr('position', point);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx);
	    var point = data.getItemLayout(newIdx);
	
	    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new SymbolCtor(data, newIdx);
	      symbolEl.attr('position', point);
	    } else {
	      symbolEl.updateData(data, newIdx, seriesScope);
	      graphic.updateProps(symbolEl, {
	        position: point
	      }, seriesModel);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && el.fadeOut(function () {
	      group.remove(el);
	    });
	  }).execute();
	  this._data = data;
	};
	
	symbolDrawProto.isPersistent = function () {
	  return true;
	};
	
	symbolDrawProto.updateLayout = function () {
	  var data = this._data;
	
	  if (data) {
	    // Not use animation
	    data.eachItemGraphicEl(function (el, idx) {
	      var point = data.getItemLayout(idx);
	      el.attr('position', point);
	    });
	  }
	};
	
	symbolDrawProto.incrementalPrepareUpdate = function (data) {
	  this._seriesScope = makeSeriesScope(data);
	  this._data = null;
	  this.group.removeAll();
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
	  opt = normalizeUpdateOpt(opt);
	
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var point = data.getItemLayout(idx);
	
	    if (symbolNeedsDraw(data, point, idx, opt)) {
	      var el = new this._symbolCtor(data, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      el.attr('position', point);
	      this.group.add(el);
	      data.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function normalizeUpdateOpt(opt) {
	  if (opt != null && !isObject(opt)) {
	    opt = {
	      isIgnore: opt
	    };
	  }
	
	  return opt || {};
	}
	
	symbolDrawProto.remove = function (enableAnimation) {
	  var group = this.group;
	  var data = this._data; // Incremental model do not have this._data.
	
	  if (data && enableAnimation) {
	    data.eachItemGraphicEl(function (el) {
	      el.fadeOut(function () {
	        group.remove(el);
	      });
	    });
	  } else {
	    group.removeAll();
	  }
	};
	
	function makeSeriesScope(data) {
	  var seriesModel = data.hostModel;
	  return {
	    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
	    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
	    symbolRotate: seriesModel.get('symbolRotate'),
	    symbolOffset: seriesModel.get('symbolOffset'),
	    hoverAnimation: seriesModel.get('hoverAnimation'),
	    labelModel: seriesModel.getModel('label'),
	    hoverLabelModel: seriesModel.getModel('emphasis.label'),
	    cursorStyle: seriesModel.get('cursor')
	  };
	}
	
	var _default = SymbolDraw;
	module.exports = _default;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(180);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var _labelHelper = __webpack_require__(282);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/Symbol}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	function SymbolClz(data, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.updateData(data, idx, seriesScope);
	}
	
	var symbolProto = SymbolClz.prototype;
	/**
	 * @public
	 * @static
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {Array.<number>} [width, height]
	 */
	
	var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
	  var symbolSize = data.getItemVisual(idx, 'symbolSize');
	  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	};
	
	function getScale(symbolSize) {
	  return [symbolSize[0] / 2, symbolSize[1] / 2];
	}
	
	function driftSymbol(dx, dy) {
	  this.parent.drift(dx, dy);
	}
	
	symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
	  // Remove paths created before
	  this.removeAll();
	  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
	  //     symbolType, -0.5, -0.5, 1, 1, color
	  // );
	  // If width/height are set too small (e.g., set to 1) on ios10
	  // and macOS Sierra, a circle stroke become a rect, no matter what
	  // the scale is set. So we set width/height as 2. See #4150.
	
	  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
	  symbolPath.attr({
	    z2: 100,
	    culling: true,
	    scale: getScale(symbolSize)
	  }); // Rewrite drift method
	
	  symbolPath.drift = driftSymbol;
	  this._symbolType = symbolType;
	  this.add(symbolPath);
	};
	/**
	 * Stop animation
	 * @param {boolean} toLastFrame
	 */
	
	
	symbolProto.stopSymbolAnimation = function (toLastFrame) {
	  this.childAt(0).stopAnimation(toLastFrame);
	};
	/**
	 * FIXME:
	 * Caution: This method breaks the encapsulation of this module,
	 * but it indeed brings convenience. So do not use the method
	 * unless you detailedly know all the implements of `Symbol`,
	 * especially animation.
	 *
	 * Get symbol path element.
	 */
	
	
	symbolProto.getSymbolPath = function () {
	  return this.childAt(0);
	};
	/**
	 * Get scale(aka, current symbol size).
	 * Including the change caused by animation
	 */
	
	
	symbolProto.getScale = function () {
	  return this.childAt(0).scale;
	};
	/**
	 * Highlight symbol
	 */
	
	
	symbolProto.highlight = function () {
	  this.childAt(0).trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	symbolProto.downplay = function () {
	  this.childAt(0).trigger('normal');
	};
	/**
	 * @param {number} zlevel
	 * @param {number} z
	 */
	
	
	symbolProto.setZ = function (zlevel, z) {
	  var symbolPath = this.childAt(0);
	  symbolPath.zlevel = zlevel;
	  symbolPath.z = z;
	};
	
	symbolProto.setDraggable = function (draggable) {
	  var symbolPath = this.childAt(0);
	  symbolPath.draggable = draggable;
	  symbolPath.cursor = draggable ? 'move' : 'pointer';
	};
	/**
	 * Update symbol properties
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Object} [seriesScope]
	 * @param {Object} [seriesScope.itemStyle]
	 * @param {Object} [seriesScope.hoverItemStyle]
	 * @param {Object} [seriesScope.symbolRotate]
	 * @param {Object} [seriesScope.symbolOffset]
	 * @param {module:echarts/model/Model} [seriesScope.labelModel]
	 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
	 * @param {boolean} [seriesScope.hoverAnimation]
	 * @param {Object} [seriesScope.cursorStyle]
	 * @param {module:echarts/model/Model} [seriesScope.itemModel]
	 * @param {string} [seriesScope.symbolInnerColor]
	 * @param {Object} [seriesScope.fadeIn=false]
	 */
	
	
	symbolProto.updateData = function (data, idx, seriesScope) {
	  this.silent = false;
	  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	  var seriesModel = data.hostModel;
	  var symbolSize = getSymbolSize(data, idx);
	  var isInit = symbolType !== this._symbolType;
	
	  if (isInit) {
	    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
	
	    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
	  } else {
	    var symbolPath = this.childAt(0);
	    symbolPath.silent = false;
	    graphic.updateProps(symbolPath, {
	      scale: getScale(symbolSize)
	    }, seriesModel, idx);
	  }
	
	  this._updateCommon(data, idx, symbolSize, seriesScope);
	
	  if (isInit) {
	    var symbolPath = this.childAt(0);
	    var fadeIn = seriesScope && seriesScope.fadeIn;
	    var target = {
	      scale: symbolPath.scale.slice()
	    };
	    fadeIn && (target.style = {
	      opacity: symbolPath.style.opacity
	    });
	    symbolPath.scale = [0, 0];
	    fadeIn && (symbolPath.style.opacity = 0);
	    graphic.initProps(symbolPath, target, seriesModel, idx);
	  }
	
	  this._seriesModel = seriesModel;
	}; // Update common properties
	
	
	var normalStyleAccessPath = ['itemStyle'];
	var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
	var normalLabelAccessPath = ['label'];
	var emphasisLabelAccessPath = ['emphasis', 'label'];
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Array.<number>} symbolSize
	 * @param {Object} [seriesScope]
	 */
	
	symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
	  var symbolPath = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var color = data.getItemVisual(idx, 'color'); // Reset style
	
	  if (symbolPath.type !== 'image') {
	    symbolPath.useStyle({
	      strokeNoScale: true
	    });
	  }
	
	  var itemStyle = seriesScope && seriesScope.itemStyle;
	  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
	  var symbolRotate = seriesScope && seriesScope.symbolRotate;
	  var symbolOffset = seriesScope && seriesScope.symbolOffset;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
	  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
	  var cursorStyle = seriesScope && seriesScope.cursorStyle;
	
	  if (!seriesScope || data.hasItemOption) {
	    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
	    // Because symbol provide setColor individually to set fill and stroke
	
	    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
	    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	    symbolRotate = itemModel.getShallow('symbolRotate');
	    symbolOffset = itemModel.getShallow('symbolOffset');
	    labelModel = itemModel.getModel(normalLabelAccessPath);
	    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
	    hoverAnimation = itemModel.getShallow('hoverAnimation');
	    cursorStyle = itemModel.getShallow('cursor');
	  } else {
	    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
	  }
	
	  var elStyle = symbolPath.style;
	  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	
	  if (symbolOffset) {
	    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
	  }
	
	  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!
	
	  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
	  symbolPath.setStyle(itemStyle);
	  var opacity = data.getItemVisual(idx, 'opacity');
	
	  if (opacity != null) {
	    elStyle.opacity = opacity;
	  }
	
	  var liftZ = data.getItemVisual(idx, 'liftZ');
	  var z2Origin = symbolPath.__z2Origin;
	
	  if (liftZ != null) {
	    if (z2Origin == null) {
	      symbolPath.__z2Origin = symbolPath.z2;
	      symbolPath.z2 += liftZ;
	    }
	  } else if (z2Origin != null) {
	    symbolPath.z2 = z2Origin;
	    symbolPath.__z2Origin = null;
	  }
	
	  var useNameLabel = seriesScope && seriesScope.useNameLabel;
	  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: idx,
	    defaultText: getLabelDefaultText,
	    isRectText: true,
	    autoColor: color
	  }); // Do not execute util needed.
	
	  function getLabelDefaultText(idx, opt) {
	    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
	  }
	
	  symbolPath.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  symbolPath.hoverStyle = hoverItemStyle; // FIXME
	  // Do not use symbol.trigger('emphasis'), but use symbol.highlight() instead.
	
	  graphic.setHoverStyle(symbolPath);
	  symbolPath.__symbolOriginalScale = getScale(symbolSize);
	
	  if (hoverAnimation && seriesModel.isAnimationEnabled()) {
	    // Note: consider `off`, should use static function here.
	    symbolPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut).on('emphasis', onEmphasis).on('normal', onNormal);
	  }
	};
	
	function onMouseOver() {
	  // see comment in `graphic.isInEmphasis`
	  !graphic.isInEmphasis(this) && onEmphasis.call(this);
	}
	
	function onMouseOut() {
	  // see comment in `graphic.isInEmphasis`
	  !graphic.isInEmphasis(this) && onNormal.call(this);
	}
	
	function onEmphasis() {
	  // Do not support this hover animation util some scenario required.
	  // Animation can only be supported in hover layer when using `el.incremetal`.
	  if (this.incremental || this.useHoverLayer) {
	    return;
	  }
	
	  var scale = this.__symbolOriginalScale;
	  var ratio = scale[1] / scale[0];
	  this.animateTo({
	    scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
	  }, 400, 'elasticOut');
	}
	
	function onNormal() {
	  if (this.incremental || this.useHoverLayer) {
	    return;
	  }
	
	  this.animateTo({
	    scale: this.__symbolOriginalScale
	  }, 400, 'elasticOut');
	}
	/**
	 * @param {Function} cb
	 * @param {Object} [opt]
	 * @param {Object} [opt.keepLabel=true]
	 */
	
	
	symbolProto.fadeOut = function (cb, opt) {
	  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
	
	  this.silent = symbolPath.silent = true; // Not show text when animating
	
	  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
	  graphic.updateProps(symbolPath, {
	    style: {
	      opacity: 0
	    },
	    scale: [0, 0]
	  }, this._seriesModel, this.dataIndex, cb);
	};
	
	zrUtil.inherits(SymbolClz, graphic.Group);
	var _default = SymbolClz;
	module.exports = _default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(235);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {string} label string. Not null/undefined
	 */
	function getDefaultLabel(data, dataIndex) {
	  var labelDims = data.mapDimension('defaultedLabel', true);
	  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
	
	  if (len === 1) {
	    return retrieveRawValue(data, dataIndex, labelDims[0]);
	  } else if (len) {
	    var vals = [];
	
	    for (var i = 0; i < labelDims.length; i++) {
	      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
	      vals.push(val);
	    }
	
	    return vals.join(' ');
	  }
	}
	
	exports.getDefaultLabel = getDefaultLabel;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _helper = __webpack_require__(284);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var arrayDiff = require('zrender/src/core/arrayDiff');
	// 'zrender/src/core/arrayDiff' has been used before, but it did
	// not do well in performance when roam with fixed dataZoom window.
	// function convertToIntId(newIdList, oldIdList) {
	//     // Generate int id instead of string id.
	//     // Compare string maybe slow in score function of arrDiff
	//     // Assume id in idList are all unique
	//     var idIndicesMap = {};
	//     var idx = 0;
	//     for (var i = 0; i < newIdList.length; i++) {
	//         idIndicesMap[newIdList[i]] = idx;
	//         newIdList[i] = idx++;
	//     }
	//     for (var i = 0; i < oldIdList.length; i++) {
	//         var oldId = oldIdList[i];
	//         // Same with newIdList
	//         if (idIndicesMap[oldId]) {
	//             oldIdList[i] = idIndicesMap[oldId];
	//         }
	//         else {
	//             oldIdList[i] = idx++;
	//         }
	//     }
	// }
	function diffData(oldData, newData) {
	  var diffResult = [];
	  newData.diff(oldData).add(function (idx) {
	    diffResult.push({
	      cmd: '+',
	      idx: idx
	    });
	  }).update(function (newIdx, oldIdx) {
	    diffResult.push({
	      cmd: '=',
	      idx: oldIdx,
	      idx1: newIdx
	    });
	  }).remove(function (idx) {
	    diffResult.push({
	      cmd: '-',
	      idx: idx
	    });
	  }).execute();
	  return diffResult;
	}
	
	function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
	  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
	  // var oldIdList = oldData.mapArray(oldData.getId);
	  // convertToIntId(newIdList, oldIdList);
	  // // FIXME One data ?
	  // diff = arrayDiff(oldIdList, newIdList);
	
	  var currPoints = [];
	  var nextPoints = []; // Points for stacking base line
	
	  var currStackedPoints = [];
	  var nextStackedPoints = [];
	  var status = [];
	  var sortedIndices = [];
	  var rawIndices = [];
	  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
	  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
	
	  for (var i = 0; i < diff.length; i++) {
	    var diffItem = diff[i];
	    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
	    // Which is in case remvoing or add more than one data in the tail or head
	
	    switch (diffItem.cmd) {
	      case '=':
	        var currentPt = oldData.getItemLayout(diffItem.idx);
	        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
	
	        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
	          currentPt = nextPt.slice();
	        }
	
	        currPoints.push(currentPt);
	        nextPoints.push(nextPt);
	        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
	        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
	        rawIndices.push(newData.getRawIndex(diffItem.idx1));
	        break;
	
	      case '+':
	        var idx = diffItem.idx;
	        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
	        nextPoints.push(newData.getItemLayout(idx).slice());
	        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
	        nextStackedPoints.push(newStackedOnPoints[idx]);
	        rawIndices.push(newData.getRawIndex(idx));
	        break;
	
	      case '-':
	        var idx = diffItem.idx;
	        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
	        // FIXME FIXME FIXME
	
	        if (rawIndex !== idx) {
	          currPoints.push(oldData.getItemLayout(idx));
	          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
	          currStackedPoints.push(oldStackedOnPoints[idx]);
	          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
	          rawIndices.push(rawIndex);
	        } else {
	          pointAdded = false;
	        }
	
	    } // Original indices
	
	
	    if (pointAdded) {
	      status.push(diffItem);
	      sortedIndices.push(sortedIndices.length);
	    }
	  } // Diff result may be crossed if all items are changed
	  // Sort by data index
	
	
	  sortedIndices.sort(function (a, b) {
	    return rawIndices[a] - rawIndices[b];
	  });
	  var sortedCurrPoints = [];
	  var sortedNextPoints = [];
	  var sortedCurrStackedPoints = [];
	  var sortedNextStackedPoints = [];
	  var sortedStatus = [];
	
	  for (var i = 0; i < sortedIndices.length; i++) {
	    var idx = sortedIndices[i];
	    sortedCurrPoints[i] = currPoints[idx];
	    sortedNextPoints[i] = nextPoints[idx];
	    sortedCurrStackedPoints[i] = currStackedPoints[idx];
	    sortedNextStackedPoints[i] = nextStackedPoints[idx];
	    sortedStatus[i] = status[idx];
	  }
	
	  return {
	    current: sortedCurrPoints,
	    next: sortedNextPoints,
	    stackedOnCurrent: sortedCurrStackedPoints,
	    stackedOnNext: sortedNextStackedPoints,
	    status: sortedStatus
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataStackHelper = __webpack_require__(260);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var _util = __webpack_require__(134);
	
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
	 */
	function prepareDataCoordInfo(coordSys, data, valueOrigin) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = getValueStart(valueAxis, valueOrigin);
	  var baseAxisDim = baseAxis.dim;
	  var valueAxisDim = valueAxis.dim;
	  var valueDim = data.mapDimension(valueAxisDim);
	  var baseDim = data.mapDimension(baseAxisDim);
	  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	  var dims = map(coordSys.dimensions, function (coordDim) {
	    return data.mapDimension(coordDim);
	  });
	  var stacked;
	  var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	  if (stacked |= isDimensionStacked(data, dims[0]
	  /*, dims[1]*/
	  )) {
	    // jshint ignore:line
	    dims[0] = stackResultDim;
	  }
	
	  if (stacked |= isDimensionStacked(data, dims[1]
	  /*, dims[0]*/
	  )) {
	    // jshint ignore:line
	    dims[1] = stackResultDim;
	  }
	
	  return {
	    dataDimsForPoint: dims,
	    valueStart: valueStart,
	    valueAxisDim: valueAxisDim,
	    baseAxisDim: baseAxisDim,
	    stacked: !!stacked,
	    valueDim: valueDim,
	    baseDim: baseDim,
	    baseDataOffset: baseDataOffset,
	    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
	  };
	}
	
	function getValueStart(valueAxis, valueOrigin) {
	  var valueStart = 0;
	  var extent = valueAxis.scale.getExtent();
	
	  if (valueOrigin === 'start') {
	    valueStart = extent[0];
	  } else if (valueOrigin === 'end') {
	    valueStart = extent[1];
	  } // auto
	  else {
	      // Both positive
	      if (extent[0] > 0) {
	        valueStart = extent[0];
	      } // Both negative
	      else if (extent[1] < 0) {
	          valueStart = extent[1];
	        } // If is one positive, and one negative, onZero shall be true
	
	    }
	
	  return valueStart;
	}
	
	function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
	  var value = NaN;
	
	  if (dataCoordInfo.stacked) {
	    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
	  }
	
	  if (isNaN(value)) {
	    value = dataCoordInfo.valueStart;
	  }
	
	  var baseDataOffset = dataCoordInfo.baseDataOffset;
	  var stackedData = [];
	  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
	  stackedData[1 - baseDataOffset] = value;
	  return coordSys.dataToPoint(stackedData);
	}
	
	exports.prepareDataCoordInfo = prepareDataCoordInfo;
	exports.getStackedOnPoint = getStackedOnPoint;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(182);
	
	var vec2 = __webpack_require__(136);
	
	var fixClipWithShadow = __webpack_require__(197);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Poly path support NaN point
	var vec2Min = vec2.min;
	var vec2Max = vec2.max;
	var scaleAndAdd = vec2.scaleAndAdd;
	var v2Copy = vec2.copy; // Temporary variable
	
	var v = [];
	var cp0 = [];
	var cp1 = [];
	
	function isPointNull(p) {
	  return isNaN(p[0]) || isNaN(p[1]);
	}
	
	function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  // if (smoothMonotone == null) {
	  //     if (isMono(points, 'x')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
	  //     }
	  //     else if (isMono(points, 'y')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
	  //     }
	  //     else {
	  //         return drawNonMono.apply(this, arguments);
	  //     }
	  // }
	  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
	  //     return drawMono.apply(this, arguments);
	  // }
	  // else {
	  //     return drawNonMono.apply(this, arguments);
	  // }
	  if (smoothMonotone === 'none' || !smoothMonotone) {
	    return drawNonMono.apply(this, arguments);
	  } else {
	    return drawMono.apply(this, arguments);
	  }
	}
	/**
	 * Check if points is in monotone.
	 *
	 * @param {number[][]} points         Array of points which is in [x, y] form
	 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
	 *                                    dimension that is checking.
	 *                                    If is 'none', `drawNonMono` should be
	 *                                    called.
	 *                                    If is undefined, either being monotone
	 *                                    in 'x' or 'y' will call `drawMono`.
	 */
	// function isMono(points, smoothMonotone) {
	//     if (points.length <= 1) {
	//         return true;
	//     }
	//     var dim = smoothMonotone === 'x' ? 0 : 1;
	//     var last = points[0][dim];
	//     var lastDiff = 0;
	//     for (var i = 1; i < points.length; ++i) {
	//         var diff = points[i][dim] - last;
	//         if (!isNaN(diff) && !isNaN(lastDiff)
	//             && diff !== 0 && lastDiff !== 0
	//             && ((diff >= 0) !== (lastDiff >= 0))
	//         ) {
	//             return false;
	//         }
	//         if (!isNaN(diff) && diff !== 0) {
	//             lastDiff = diff;
	//             last = points[i][dim];
	//         }
	//     }
	//     return true;
	// }
	
	/**
	 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
	 * control points will be used. This should be used when points are monotone
	 * either in x or y dimension.
	 */
	
	
	function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	    } else {
	      if (smooth > 0) {
	        var prevP = points[prevIdx];
	        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both
	
	        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
	        v2Copy(cp0, prevP);
	        cp0[dim] = prevP[dim] + ctrlLen;
	        v2Copy(cp1, p);
	        cp1[dim] = p[dim] - ctrlLen;
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	/**
	 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
	 * situations. This should be used when points are non-monotone neither in x or
	 * y dimension.
	 */
	
	
	function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	      v2Copy(cp0, p);
	    } else {
	      if (smooth > 0) {
	        var nextIdx = idx + dir;
	        var nextP = points[nextIdx];
	
	        if (connectNulls) {
	          // Find next point not null
	          while (nextP && isPointNull(points[nextIdx])) {
	            nextIdx += dir;
	            nextP = points[nextIdx];
	          }
	        }
	
	        var ratioNextSeg = 0.5;
	        var prevP = points[prevIdx];
	        var nextP = points[nextIdx]; // Last point
	
	        if (!nextP || isPointNull(nextP)) {
	          v2Copy(cp1, p);
	        } else {
	          // If next data is null in not connect case
	          if (isPointNull(nextP) && !connectNulls) {
	            nextP = p;
	          }
	
	          vec2.sub(v, nextP, prevP);
	          var lenPrevSeg;
	          var lenNextSeg;
	
	          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
	            var dim = smoothMonotone === 'x' ? 0 : 1;
	            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
	            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
	          } else {
	            lenPrevSeg = vec2.dist(p, prevP);
	            lenNextSeg = vec2.dist(p, nextP);
	          } // Use ratio of seg length
	
	
	          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
	        } // Smooth constraint
	
	
	        vec2Min(cp0, cp0, smoothMax);
	        vec2Max(cp0, cp0, smoothMin);
	        vec2Min(cp1, cp1, smoothMax);
	        vec2Max(cp1, cp1, smoothMin);
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment
	
	        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	
	function getBoundingBox(points, smoothConstraint) {
	  var ptMin = [Infinity, Infinity];
	  var ptMax = [-Infinity, -Infinity];
	
	  if (smoothConstraint) {
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (pt[0] < ptMin[0]) {
	        ptMin[0] = pt[0];
	      }
	
	      if (pt[1] < ptMin[1]) {
	        ptMin[1] = pt[1];
	      }
	
	      if (pt[0] > ptMax[0]) {
	        ptMax[0] = pt[0];
	      }
	
	      if (pt[1] > ptMax[1]) {
	        ptMax[1] = pt[1];
	      }
	    }
	  }
	
	  return {
	    min: smoothConstraint ? ptMin : ptMax,
	    max: smoothConstraint ? ptMax : ptMin
	  };
	}
	
	var Polyline = Path.extend({
	  type: 'ec-polyline',
	  shape: {
	    points: [],
	    smooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  style: {
	    fill: null,
	    stroke: '#000'
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var i = 0;
	    var len = points.length;
	    var result = getBoundingBox(points, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	    }
	  }
	});
	var Polygon = Path.extend({
	  type: 'ec-polygon',
	  shape: {
	    points: [],
	    // Offset between stacked base points and points
	    stackedOnPoints: [],
	    smooth: 0,
	    stackedOnSmooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var stackedOnPoints = shape.stackedOnPoints;
	    var i = 0;
	    var len = points.length;
	    var smoothMonotone = shape.smoothMonotone;
	    var bbox = getBoundingBox(points, shape.smoothConstraint);
	    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
	      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	      i += k + 1;
	      ctx.closePath();
	    }
	  }
	});
	exports.Polyline = Polyline;
	exports.Polygon = Polygon;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, defaultSymbolType, legendSymbol) {
	  // Encoding visual for all series include which is filtered for legend drawing
	  return {
	    seriesType: seriesType,
	    // For legend.
	    performRawSeries: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var symbolType = seriesModel.get('symbol') || defaultSymbolType;
	      var symbolSize = seriesModel.get('symbolSize');
	      var keepAspect = seriesModel.get('symbolKeepAspect');
	      data.setVisual({
	        legendSymbol: legendSymbol || symbolType,
	        symbol: symbolType,
	        symbolSize: symbolSize,
	        symbolKeepAspect: keepAspect
	      }); // Only visible series has each data be visual encoded
	
	      if (ecModel.isSeriesFiltered(seriesModel)) {
	        return;
	      }
	
	      var hasCallback = typeof symbolSize === 'function';
	
	      function dataEach(data, idx) {
	        if (typeof symbolSize === 'function') {
	          var rawValue = seriesModel.getRawValue(idx); // FIXME
	
	          var params = seriesModel.getDataParams(idx);
	          data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
	        }
	
	        if (data.hasItemOption) {
	          var itemModel = data.getItemModel(idx);
	          var itemSymbolType = itemModel.getShallow('symbol', true);
	          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
	          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
	
	          if (itemSymbolType != null) {
	            data.setItemVisual(idx, 'symbol', itemSymbolType);
	          }
	
	          if (itemSymbolSize != null) {
	            // PENDING Transform symbolSize ?
	            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
	          }
	
	          if (itemSymbolKeepAspect != null) {
	            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
	          }
	        }
	      }
	
	      return {
	        dataEach: data.hasItemOption || hasCallback ? dataEach : null
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var map = _util.map;
	
	var createRenderPlanner = __webpack_require__(239);
	
	var _dataStackHelper = __webpack_require__(260);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    plan: createRenderPlanner(),
	    reset: function (seriesModel) {
	      var data = seriesModel.getData();
	      var coordSys = seriesModel.coordinateSystem;
	      var pipelineContext = seriesModel.pipelineContext;
	      var isLargeRender = pipelineContext.large;
	
	      if (!coordSys) {
	        return;
	      }
	
	      var dims = map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }).slice(0, 2);
	      var dimLen = dims.length;
	      var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	      if (isDimensionStacked(data, dims[0]
	      /*, dims[1]*/
	      )) {
	        dims[0] = stackResultDim;
	      }
	
	      if (isDimensionStacked(data, dims[1]
	      /*, dims[0]*/
	      )) {
	        dims[1] = stackResultDim;
	      }
	
	      function progress(params, data) {
	        var segCount = params.end - params.start;
	        var points = isLargeRender && new Float32Array(segCount * dimLen);
	
	        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
	          var point;
	
	          if (dimLen === 1) {
	            var x = data.get(dims[0], i);
	            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
	          } else {
	            var x = tmpIn[0] = data.get(dims[0], i);
	            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement
	
	            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
	          }
	
	          if (isLargeRender) {
	            points[offset++] = point ? point[0] : NaN;
	            points[offset++] = point ? point[1] : NaN;
	          } else {
	            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
	          }
	        }
	
	        isLargeRender && data.setLayout('symbolPoints', points);
	      }
	
	      return dimLen && {
	        progress: progress
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var samplers = {
	  average: function (frame) {
	    var sum = 0;
	    var count = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      if (!isNaN(frame[i])) {
	        sum += frame[i];
	        count++;
	      }
	    } // Return NaN if count is 0
	
	
	    return count === 0 ? NaN : sum / count;
	  },
	  sum: function (frame) {
	    var sum = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      // Ignore NaN
	      sum += frame[i] || 0;
	    }
	
	    return sum;
	  },
	  max: function (frame) {
	    var max = -Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] > max && (max = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(max) ? max : NaN;
	  },
	  min: function (frame) {
	    var min = Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] < min && (min = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(min) ? min : NaN;
	  },
	  // TODO
	  // Median
	  nearest: function (frame) {
	    return frame[0];
	  }
	};
	
	var indexSampler = function (frame, value) {
	  return Math.round(frame.length / 2);
	};
	
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    modifyOutputEnd: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var sampling = seriesModel.get('sampling');
	      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
	
	      if (coordSys.type === 'cartesian2d' && sampling) {
	        var baseAxis = coordSys.getBaseAxis();
	        var valueAxis = coordSys.getOtherAxis(baseAxis);
	        var extent = baseAxis.getExtent(); // Coordinste system has been resized
	
	        var size = extent[1] - extent[0];
	        var rate = Math.round(data.count() / size);
	
	        if (rate > 1) {
	          var sampler;
	
	          if (typeof sampling === 'string') {
	            sampler = samplers[sampling];
	          } else if (typeof sampling === 'function') {
	            sampler = sampling;
	          }
	
	          if (sampler) {
	            // Only support sample the first dim mapped from value axis.
	            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
	          }
	        }
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	__webpack_require__(290);
	
	__webpack_require__(298);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid view
	echarts.extendComponentView({
	  type: 'grid',
	  render: function (gridModel, ecModel) {
	    this.group.removeAll();
	
	    if (gridModel.get('show')) {
	      this.group.add(new graphic.Rect({
	        shape: gridModel.coordinateSystem.getRect(),
	        style: zrUtil.defaults({
	          fill: gridModel.get('backgroundColor')
	        }, gridModel.getItemStyle()),
	        silent: true,
	        z2: -1
	      }));
	    }
	  }
	});
	echarts.registerPreprocessor(function (option) {
	  // Only create grid when need
	  if (option.xAxis && option.yAxis && !option.grid) {
	    option.grid = {};
	  }
	});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(134);
	
	var isObject = _util.isObject;
	var each = _util.each;
	var map = _util.map;
	var indexOf = _util.indexOf;
	var retrieve = _util.retrieve;
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _axisHelper = __webpack_require__(261);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;
	
	var Cartesian2D = __webpack_require__(291);
	
	var Axis2D = __webpack_require__(293);
	
	var CoordinateSystem = __webpack_require__(228);
	
	var _dataStackHelper = __webpack_require__(260);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(294);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Grid is a region which contains at most 4 cartesian systems
	 *
	 * TODO Default cartesian
	 */
	// Depends on GridModel, AxisModel, which performs preprocess.
	
	/**
	 * Check if the axis is used in the specified grid
	 * @inner
	 */
	function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
	  return axisModel.getCoordSysModel() === gridModel;
	}
	
	function Grid(gridModel, ecModel, api) {
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
	   * @private
	   */
	  this._coordsMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
	   * @private
	   */
	
	  this._coordsList = [];
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesList = [];
	
	  this._initCartesian(gridModel, ecModel, api);
	
	  this.model = gridModel;
	}
	
	var gridProto = Grid.prototype;
	gridProto.type = 'grid';
	gridProto.axisPointerEnabled = true;
	
	gridProto.getRect = function () {
	  return this._rect;
	};
	
	gridProto.update = function (ecModel, api) {
	  var axesMap = this._axesMap;
	
	  this._updateScale(ecModel, this.model);
	
	  each(axesMap.x, function (xAxis) {
	    niceScaleExtent(xAxis.scale, xAxis.model);
	  });
	  each(axesMap.y, function (yAxis) {
	    niceScaleExtent(yAxis.scale, yAxis.model);
	  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
	
	  var onZeroRecords = {};
	  each(axesMap.x, function (xAxis) {
	    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
	  });
	  each(axesMap.y, function (yAxis) {
	    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
	  }); // Resize again if containLabel is enabled
	  // FIXME It may cause getting wrong grid size in data processing stage
	
	  this.resize(this.model, api);
	};
	
	function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
	  axis.getAxesOnZeroOf = function () {
	    // TODO: onZero of multiple axes.
	    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
	  }; // onZero can not be enabled in these two situations:
	  // 1. When any other axis is a category axis.
	  // 2. When no axis is cross 0 point.
	
	
	  var otherAxes = axesMap[otherAxisDim];
	  var otherAxisOnZeroOf;
	  var axisModel = axis.model;
	  var onZero = axisModel.get('axisLine.onZero');
	  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');
	
	  if (!onZero) {
	    return;
	  } // If target axis is specified.
	
	
	  if (onZeroAxisIndex != null) {
	    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
	      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
	    }
	  } else {
	    // Find the first available other axis.
	    for (var idx in otherAxes) {
	      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
	      // if both onZero, the two Y axes overlap.
	      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
	        otherAxisOnZeroOf = otherAxes[idx];
	        break;
	      }
	    }
	  }
	
	  if (otherAxisOnZeroOf) {
	    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
	  }
	
	  function getOnZeroRecordKey(axis) {
	    return axis.dim + '_' + axis.index;
	  }
	}
	
	function canOnZeroToAxis(axis) {
	  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
	}
	/**
	 * Resize the grid
	 * @param {module:echarts/coord/cartesian/GridModel} gridModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	gridProto.resize = function (gridModel, api, ignoreContainLabel) {
	  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	  this._rect = gridRect;
	  var axesList = this._axesList;
	  adjustAxes(); // Minus label size
	
	  if (!ignoreContainLabel && gridModel.get('containLabel')) {
	    each(axesList, function (axis) {
	      if (!axis.model.get('axisLabel.inside')) {
	        var labelUnionRect = estimateLabelUnionRect(axis);
	
	        if (labelUnionRect) {
	          var dim = axis.isHorizontal() ? 'height' : 'width';
	          var margin = axis.model.get('axisLabel.margin');
	          gridRect[dim] -= labelUnionRect[dim] + margin;
	
	          if (axis.position === 'top') {
	            gridRect.y += labelUnionRect.height + margin;
	          } else if (axis.position === 'left') {
	            gridRect.x += labelUnionRect.width + margin;
	          }
	        }
	      }
	    });
	    adjustAxes();
	  }
	
	  function adjustAxes() {
	    each(axesList, function (axis) {
	      var isHorizontal = axis.isHorizontal();
	      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(extent[idx], extent[1 - idx]);
	      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
	    });
	  }
	};
	/**
	 * @param {string} axisType
	 * @param {number} [axisIndex]
	 */
	
	
	gridProto.getAxis = function (axisType, axisIndex) {
	  var axesMapOnDim = this._axesMap[axisType];
	
	  if (axesMapOnDim != null) {
	    if (axisIndex == null) {
	      // Find first axis
	      for (var name in axesMapOnDim) {
	        if (axesMapOnDim.hasOwnProperty(name)) {
	          return axesMapOnDim[name];
	        }
	      }
	    }
	
	    return axesMapOnDim[axisIndex];
	  }
	};
	/**
	 * @return {Array.<module:echarts/coord/Axis>}
	 */
	
	
	gridProto.getAxes = function () {
	  return this._axesList.slice();
	};
	/**
	 * Usage:
	 *      grid.getCartesian(xAxisIndex, yAxisIndex);
	 *      grid.getCartesian(xAxisIndex);
	 *      grid.getCartesian(null, yAxisIndex);
	 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
	 *
	 * @param {number|Object} [xAxisIndex]
	 * @param {number} [yAxisIndex]
	 */
	
	
	gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
	  if (xAxisIndex != null && yAxisIndex != null) {
	    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	    return this._coordsMap[key];
	  }
	
	  if (isObject(xAxisIndex)) {
	    yAxisIndex = xAxisIndex.yAxisIndex;
	    xAxisIndex = xAxisIndex.xAxisIndex;
	  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
	
	
	  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	      return coordList[i];
	    }
	  }
	};
	
	gridProto.getCartesians = function () {
	  return this._coordsList.slice();
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertToPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertFromPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	};
	/**
	 * @inner
	 */
	
	
	gridProto._findConvertTarget = function (ecModel, finder) {
	  var seriesModel = finder.seriesModel;
	  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
	  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
	  var gridModel = finder.gridModel;
	  var coordsList = this._coordsList;
	  var cartesian;
	  var axis;
	
	  if (seriesModel) {
	    cartesian = seriesModel.coordinateSystem;
	    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	  } else if (xAxisModel && yAxisModel) {
	    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  } else if (xAxisModel) {
	    axis = this.getAxis('x', xAxisModel.componentIndex);
	  } else if (yAxisModel) {
	    axis = this.getAxis('y', yAxisModel.componentIndex);
	  } // Lowest priority.
	  else if (gridModel) {
	      var grid = gridModel.coordinateSystem;
	
	      if (grid === this) {
	        cartesian = this._coordsList[0];
	      }
	    }
	
	  return {
	    cartesian: cartesian,
	    axis: axis
	  };
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.containPoint = function (point) {
	  var coord = this._coordsList[0];
	
	  if (coord) {
	    return coord.containPoint(point);
	  }
	};
	/**
	 * Initialize cartesian coordinate systems
	 * @private
	 */
	
	
	gridProto._initCartesian = function (gridModel, ecModel, api) {
	  var axisPositionUsed = {
	    left: false,
	    right: false,
	    top: false,
	    bottom: false
	  };
	  var axesMap = {
	    x: {},
	    y: {}
	  };
	  var axesCount = {
	    x: 0,
	    y: 0
	  }; /// Create axis
	
	  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	  if (!axesCount.x || !axesCount.y) {
	    // Roll back when there no either x or y axis
	    this._axesMap = {};
	    this._axesList = [];
	    return;
	  }
	
	  this._axesMap = axesMap; /// Create cartesian2d
	
	  each(axesMap.x, function (xAxis, xAxisIndex) {
	    each(axesMap.y, function (yAxis, yAxisIndex) {
	      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	      var cartesian = new Cartesian2D(key);
	      cartesian.grid = this;
	      cartesian.model = gridModel;
	      this._coordsMap[key] = cartesian;
	
	      this._coordsList.push(cartesian);
	
	      cartesian.addAxis(xAxis);
	      cartesian.addAxis(yAxis);
	    }, this);
	  }, this);
	
	  function createAxisCreator(axisType) {
	    return function (axisModel, idx) {
	      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var axisPosition = axisModel.get('position');
	
	      if (axisType === 'x') {
	        // Fix position
	        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	          // Default bottom of X
	          axisPosition = 'bottom';
	
	          if (axisPositionUsed[axisPosition]) {
	            axisPosition = axisPosition === 'top' ? 'bottom' : 'top';
	          }
	        }
	      } else {
	        // Fix position
	        if (axisPosition !== 'left' && axisPosition !== 'right') {
	          // Default left of Y
	          axisPosition = 'left';
	
	          if (axisPositionUsed[axisPosition]) {
	            axisPosition = axisPosition === 'left' ? 'right' : 'left';
	          }
	        }
	      }
	
	      axisPositionUsed[axisPosition] = true;
	      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
	
	      axisModel.axis = axis; // Inject axisModel into axis
	
	      axis.model = axisModel; // Inject grid info axis
	
	      axis.grid = this; // Index of axis, can be used as key
	
	      axis.index = idx;
	
	      this._axesList.push(axis);
	
	      axesMap[axisType][idx] = axis;
	      axesCount[axisType]++;
	    };
	  }
	};
	/**
	 * Update cartesian properties from series
	 * @param  {module:echarts/model/Option} option
	 * @private
	 */
	
	
	gridProto._updateScale = function (ecModel, gridModel) {
	  // Reset scale
	  each(this._axesList, function (axis) {
	    axis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (isCartesian2D(seriesModel)) {
	      var axesModels = findAxesModels(seriesModel, ecModel);
	      var xAxisModel = axesModels[0];
	      var yAxisModel = axesModels[1];
	
	      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	      var data = seriesModel.getData();
	      var xAxis = cartesian.getAxis('x');
	      var yAxis = cartesian.getAxis('y');
	
	      if (data.type === 'list') {
	        unionExtent(data, xAxis, seriesModel);
	        unionExtent(data, yAxis, seriesModel);
	      }
	    }
	  }, this);
	
	  function unionExtent(data, axis, seriesModel) {
	    each(data.mapDimension(axis.dim, true), function (dim) {
	      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
	      // is [0.1, 0.5], the extent of the `stackResultDimension`
	      // is [7, 9], the final extent should not include [0.1, 0.5].
	      data, getStackedDimension(data, dim));
	    });
	  }
	};
	/**
	 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
	 * @return {Object} {baseAxes: [], otherAxes: []}
	 */
	
	
	gridProto.getTooltipAxes = function (dim) {
	  var baseAxes = [];
	  var otherAxes = [];
	  each(this.getCartesians(), function (cartesian) {
	    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	    var otherAxis = cartesian.getOtherAxis(baseAxis);
	    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	  });
	  return {
	    baseAxes: baseAxes,
	    otherAxes: otherAxes
	  };
	};
	/**
	 * @inner
	 */
	
	
	function updateAxisTransform(axis, coordBase) {
	  var axisExtent = axis.getExtent();
	  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	    return coord + coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	    return coord - coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	}
	
	var axesTypes = ['xAxis', 'yAxis'];
	/**
	 * @inner
	 */
	
	function findAxesModels(seriesModel, ecModel) {
	  return map(axesTypes, function (axisType) {
	    var axisModel = seriesModel.getReferringComponents(axisType)[0];
	    return axisModel;
	  });
	}
	/**
	 * @inner
	 */
	
	
	function isCartesian2D(seriesModel) {
	  return seriesModel.get('coordinateSystem') === 'cartesian2d';
	}
	
	Grid.create = function (ecModel, api) {
	  var grids = [];
	  ecModel.eachComponent('grid', function (gridModel, idx) {
	    var grid = new Grid(gridModel, ecModel, api);
	    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	    // should be performed in create stage.
	
	    grid.resize(gridModel, api, true);
	    gridModel.coordinateSystem = grid;
	    grids.push(grid);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (!isCartesian2D(seriesModel)) {
	      return;
	    }
	
	    var axesModels = findAxesModels(seriesModel, ecModel);
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var gridModel = xAxisModel.getCoordSysModel();
	    var grid = gridModel.coordinateSystem;
	    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  });
	  return grids;
	}; // For deciding which dimensions to use when creating list data
	
	
	Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
	CoordinateSystem.register('cartesian2d', Grid);
	var _default = Grid;
	module.exports = _default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Cartesian = __webpack_require__(292);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function Cartesian2D(name) {
	  Cartesian.call(this, name);
	}
	
	Cartesian2D.prototype = {
	  constructor: Cartesian2D,
	  type: 'cartesian2d',
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/cartesian/Axis2D}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	  },
	
	  /**
	   * If contain point
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var axisX = this.getAxis('x');
	    var axisY = this.getAxis('y');
	    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, reserved, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
	    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  clampData: function (data, out) {
	    var xScale = this.getAxis('x').scale;
	    var yScale = this.getAxis('y').scale;
	    var xAxisExtent = xScale.getExtent();
	    var yAxisExtent = yScale.getExtent();
	    var x = xScale.parse(data[0]);
	    var y = yScale.parse(data[1]);
	    out = out || [];
	    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
	    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
	    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
	    return out;
	  },
	
	  /**
	   * Get other axis
	   * @param {module:echarts/coord/cartesian/Axis2D} axis
	   */
	  getOtherAxis: function (axis) {
	    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	  }
	};
	zrUtil.inherits(Cartesian2D, Cartesian);
	var _default = Cartesian2D;
	module.exports = _default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Cartesian coordinate system
	 * @module  echarts/coord/Cartesian
	 *
	 */
	function dimAxisMapper(dim) {
	  return this._axes[dim];
	}
	/**
	 * @alias module:echarts/coord/Cartesian
	 * @constructor
	 */
	
	
	var Cartesian = function (name) {
	  this._axes = {};
	  this._dimList = [];
	  /**
	   * @type {string}
	   */
	
	  this.name = name || '';
	};
	
	Cartesian.prototype = {
	  constructor: Cartesian,
	  type: 'cartesian',
	
	  /**
	   * Get axis
	   * @param  {number|string} dim
	   * @return {module:echarts/coord/Cartesian~Axis}
	   */
	  getAxis: function (dim) {
	    return this._axes[dim];
	  },
	
	  /**
	   * Get axes list
	   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
	   */
	  getAxes: function () {
	    return zrUtil.map(this._dimList, dimAxisMapper, this);
	  },
	
	  /**
	   * Get axes list by given scale type
	   */
	  getAxesByScale: function (scaleType) {
	    scaleType = scaleType.toLowerCase();
	    return zrUtil.filter(this.getAxes(), function (axis) {
	      return axis.scale.type === scaleType;
	    });
	  },
	
	  /**
	   * Add axis
	   * @param {module:echarts/coord/Cartesian.Axis}
	   */
	  addAxis: function (axis) {
	    var dim = axis.dim;
	    this._axes[dim] = axis;
	
	    this._dimList.push(dim);
	  },
	
	  /**
	   * Convert data to coord in nd space
	   * @param {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  dataToCoord: function (val) {
	    return this._dataCoordConvert(val, 'dataToCoord');
	  },
	
	  /**
	   * Convert coord in nd space to data
	   * @param  {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  coordToData: function (val) {
	    return this._dataCoordConvert(val, 'coordToData');
	  },
	  _dataCoordConvert: function (input, method) {
	    var dimList = this._dimList;
	    var output = input instanceof Array ? [] : {};
	
	    for (var i = 0; i < dimList.length; i++) {
	      var dim = dimList[i];
	      var axis = this._axes[dim];
	      output[dim] = axis[method](input[dim]);
	    }
	
	    return output;
	  }
	};
	var _default = Cartesian;
	module.exports = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Axis = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var Axis2D = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   */
	
	  this.position = position || 'bottom';
	};
	
	Axis2D.prototype = {
	  constructor: Axis2D,
	
	  /**
	   * Index of axis, can be used as key
	   */
	  index: 0,
	
	  /**
	   * Implemented in <module:echarts/coord/cartesian/Grid>.
	   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
	   *         If not on zero of other axis, return null/undefined.
	   *         If no axes, return an empty array.
	   */
	  getAxesOnZeroOf: null,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/cartesian/AxisModel}
	   */
	  model: null,
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * Each item cooresponds to this.getExtent(), which
	   * means globalExtent[0] may greater than globalExtent[1],
	   * unless `asc` is input.
	   *
	   * @param {boolean} [asc]
	   * @return {Array.<number>}
	   */
	  getGlobalExtent: function (asc) {
	    var ret = this.getExtent();
	    ret[0] = this.toGlobalCoord(ret[0]);
	    ret[1] = this.toGlobalCoord(ret[1]);
	    asc && ret[0] > ret[1] && ret.reverse();
	    return ret;
	  },
	  getOtherAxis: function () {
	    this.grid.getOtherAxis();
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	  },
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var localCoord = axis.toLocalCoord(80);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toLocalCoord: null,
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var globalCoord = axis.toLocalCoord(40);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toGlobalCoord: null
	};
	zrUtil.inherits(Axis2D, Axis);
	var _default = Axis2D;
	module.exports = _default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(295);
	
	var ComponentModel = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid 是在有直角坐标系的时候必须要存在的
	// 所以这里也要被 Cartesian2D 依赖
	var _default = ComponentModel.extend({
	  type: 'grid',
	  dependencies: ['xAxis', 'yAxis'],
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Grid}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    show: false,
	    zlevel: 0,
	    z: 0,
	    left: '10%',
	    top: 60,
	    right: '10%',
	    bottom: 60,
	    // If grid size contain label
	    containLabel: false,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderWidth: 1,
	    borderColor: '#ccc'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ComponentModel = __webpack_require__(215);
	
	var axisModelCreator = __webpack_require__(296);
	
	var axisModelCommonMixin = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'cartesian2dAxis',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Axis2D}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  init: function () {
	    AxisModel.superApply(this, 'init', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function () {
	    AxisModel.superApply(this, 'mergeOption', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  restoreData: function () {
	    AxisModel.superApply(this, 'restoreData', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   * @return {module:echarts/model/Component}
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'grid',
	      index: this.option.gridIndex,
	      id: this.option.gridId
	    })[0];
	  }
	});
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	var extraOption = {
	  // gridIndex: 0,
	  // gridId: '',
	  // Offset is for multiple axis on the same position
	  offset: 0
	};
	axisModelCreator('x', AxisModel, getAxisType, extraOption);
	axisModelCreator('y', AxisModel, getAxisType, extraOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var axisDefault = __webpack_require__(297);
	
	var ComponentModel = __webpack_require__(215);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var OrdinalMeta = __webpack_require__(264);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME axisType is fixed ?
	var AXIS_TYPES = ['value', 'category', 'time', 'log'];
	/**
	 * Generate sub axis model class
	 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
	 * @param {module:echarts/model/Component} BaseAxisModelClass
	 * @param {Function} axisTypeDefaulter
	 * @param {Object} [extraDefaultOption]
	 */
	
	function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
	  zrUtil.each(AXIS_TYPES, function (axisType) {
	    BaseAxisModelClass.extend({
	      /**
	       * @readOnly
	       */
	      type: axisName + 'Axis.' + axisType,
	      mergeDefaultAndTheme: function (option, ecModel) {
	        var layoutMode = this.layoutMode;
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
	        zrUtil.merge(option, this.getDefaultOption());
	        option.type = axisTypeDefaulter(axisName, option);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      },
	
	      /**
	       * @override
	       */
	      optionUpdated: function () {
	        var thisOption = this.option;
	
	        if (thisOption.type === 'category') {
	          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
	        }
	      },
	
	      /**
	       * Should not be called before all of 'getInitailData' finished.
	       * Because categories are collected during initializing data.
	       */
	      getCategories: function (rawData) {
	        var option = this.option; // FIXME
	        // warning if called before all of 'getInitailData' finished.
	
	        if (option.type === 'category') {
	          if (rawData) {
	            return option.data;
	          }
	
	          return this.__ordinalMeta.categories;
	        }
	      },
	      getOrdinalMeta: function () {
	        return this.__ordinalMeta;
	      },
	      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
	    });
	  });
	  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
	}
	
	module.exports = _default;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var defaultOption = {
	  show: true,
	  zlevel: 0,
	  z: 0,
	  // Inverse the axis.
	  inverse: false,
	  // Axis name displayed.
	  name: '',
	  // 'start' | 'middle' | 'end'
	  nameLocation: 'end',
	  // By degree. By defualt auto rotate by nameLocation.
	  nameRotate: null,
	  nameTruncate: {
	    maxWidth: null,
	    ellipsis: '...',
	    placeholder: '.'
	  },
	  // Use global text style by default.
	  nameTextStyle: {},
	  // The gap between axisName and axisLine.
	  nameGap: 15,
	  // Default `false` to support tooltip.
	  silent: false,
	  // Default `false` to avoid legacy user event listener fail.
	  triggerEvent: false,
	  tooltip: {
	    show: false
	  },
	  axisPointer: {},
	  axisLine: {
	    show: true,
	    onZero: true,
	    onZeroAxisIndex: null,
	    lineStyle: {
	      color: '#333',
	      width: 1,
	      type: 'solid'
	    },
	    // The arrow at both ends the the axis.
	    symbol: ['none', 'none'],
	    symbolSize: [10, 15]
	  },
	  axisTick: {
	    show: true,
	    // Whether axisTick is inside the grid or outside the grid.
	    inside: false,
	    // The length of axisTick.
	    length: 5,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    // Whether axisLabel is inside the grid or outside the grid.
	    inside: false,
	    rotate: 0,
	    // true | false | null/undefined (auto)
	    showMinLabel: null,
	    // true | false | null/undefined (auto)
	    showMaxLabel: null,
	    margin: 8,
	    // formatter: null,
	    fontSize: 12
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      color: ['#ccc'],
	      width: 1,
	      type: 'solid'
	    }
	  },
	  splitArea: {
	    show: false,
	    areaStyle: {
	      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
	    }
	  }
	};
	var axisDefault = {};
	axisDefault.categoryAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For categoryAxis, boolean.
	  boundaryGap: true,
	  // Set false to faster category collection.
	  // Only usefull in the case like: category is
	  // ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // null means "auto":
	  // if axis.data provided, do not deduplication,
	  // else do deduplication.
	  deduplication: null,
	  // splitArea: {
	  // show: false
	  // },
	  splitLine: {
	    show: false
	  },
	  axisTick: {
	    // If tick is align with label when boundaryGap is true
	    alignWithLabel: false,
	    interval: 'auto'
	  },
	  axisLabel: {
	    interval: 'auto'
	  }
	}, defaultOption);
	axisDefault.valueAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
	  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
	  boundaryGap: [0, 0],
	  // TODO
	  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
	  // Min value of the axis. can be:
	  // + a number
	  // + 'dataMin': use the min value in data.
	  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
	  // min: null,
	  // Max value of the axis. can be:
	  // + a number
	  // + 'dataMax': use the max value in data.
	  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
	  // max: null,
	  // Readonly prop, specifies start value of the range when using data zoom.
	  // rangeStart: null
	  // Readonly prop, specifies end value of the range when using data zoom.
	  // rangeEnd: null
	  // Optional value can be:
	  // + `false`: always include value 0.
	  // + `true`: the extent do not consider value 0.
	  // scale: false,
	  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
	  splitNumber: 5 // Interval specifies the span of the ticks is mandatorily.
	  // interval: null
	  // Specify min interval when auto calculate tick interval.
	  // minInterval: null
	  // Specify max interval when auto calculate tick interval.
	  // maxInterval: null
	
	}, defaultOption);
	axisDefault.timeAxis = zrUtil.defaults({
	  scale: true,
	  min: 'dataMin',
	  max: 'dataMax'
	}, axisDefault.valueAxis);
	axisDefault.logAxis = zrUtil.defaults({
	  scale: true,
	  logBase: 10
	}, axisDefault.valueAxis);
	var _default = axisDefault;
	module.exports = _default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(295);
	
	__webpack_require__(299);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var AxisBuilder = __webpack_require__(300);
	
	var AxisView = __webpack_require__(301);
	
	var cartesianAxisHelper = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine']; // function getAlignWithLabel(model, axisModel) {
	//     var alignWithLabel = model.get('alignWithLabel');
	//     if (alignWithLabel === 'auto') {
	//         alignWithLabel = axisModel.get('axisTick.alignWithLabel');
	//     }
	//     return alignWithLabel;
	// }
	
	var CartesianAxisView = AxisView.extend({
	  type: 'cartesianAxis',
	  axisPointerClass: 'CartesianAxisPointer',
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var gridModel = axisModel.getCoordSysModel();
	    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel, gridModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    this._splitAreaColors = null;
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = []; // Simple optimization
	    // Batching the lines if color are the same
	
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      var tickValue = ticksCoords[i].tickValue;
	
	      this._axisGroup.add(new graphic.Line(graphic.subPixelOptimizeLine({
	        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: zrUtil.defaults({
	          stroke: lineColors[colorIndex]
	        }, lineStyle),
	        silent: true
	      })));
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitArea: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitAreaModel = axisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitAreaModel,
	      clamp: true
	    });
	
	    if (!ticksCoords.length) {
	      return;
	    } // For Making appropriate splitArea animation, the color and anid
	    // should be corresponding to previous one if possible.
	
	
	    var areaColorsLen = areaColors.length;
	    var lastSplitAreaColors = this._splitAreaColors;
	    var newSplitAreaColors = zrUtil.createHashMap();
	    var colorIndex = 0;
	
	    if (lastSplitAreaColors) {
	      for (var i = 0; i < ticksCoords.length; i++) {
	        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
	
	        if (cIndex != null) {
	          colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
	          break;
	        }
	      }
	    }
	
	    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
	    var areaStyle = areaStyleModel.getAreaStyle();
	    areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (axis.isHorizontal()) {
	        x = prev;
	        y = gridRect.y;
	        width = tickCoord - x;
	        height = gridRect.height;
	        prev = x + width;
	      } else {
	        x = gridRect.x;
	        y = prev;
	        width = gridRect.width;
	        height = tickCoord - y;
	        prev = y + height;
	      }
	
	      var tickValue = ticksCoords[i - 1].tickValue;
	      tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
	
	      this._axisGroup.add(new graphic.Rect({
	        anid: tickValue != null ? 'area_' + tickValue : null,
	        shape: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        style: zrUtil.defaults({
	          fill: areaColors[colorIndex]
	        }, areaStyle),
	        silent: true
	      }));
	
	      colorIndex = (colorIndex + 1) % areaColorsLen;
	    }
	
	    this._splitAreaColors = newSplitAreaColors;
	  }
	});
	CartesianAxisView.extend({
	  type: 'xAxis'
	});
	CartesianAxisView.extend({
	  type: 'yAxis'
	});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var retrieve = _util.retrieve;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var each = _util.each;
	
	var formatUtil = __webpack_require__(219);
	
	var graphic = __webpack_require__(180);
	
	var Model = __webpack_require__(174);
	
	var _number = __webpack_require__(218);
	
	var isRadianAroundZero = _number.isRadianAroundZero;
	var remRadian = _number.remRadian;
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var matrixUtil = __webpack_require__(145);
	
	var _vector = __webpack_require__(136);
	
	var v2ApplyTransform = _vector.applyTransform;
	
	var _axisHelper = __webpack_require__(261);
	
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	
	function makeAxisEventDataBase(axisModel) {
	  var eventData = {
	    componentType: axisModel.mainType,
	    componentIndex: axisModel.componentIndex
	  };
	  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	  return eventData;
	}
	/**
	 * A final axis is translated and rotated from a "standard axis".
	 * So opt.position and opt.rotation is required.
	 *
	 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	 * for example: (0, 0) ------------> (0, 50)
	 *
	 * nameDirection or tickDirection or labelDirection is 1 means tick
	 * or label is below the standard axis, whereas is -1 means above
	 * the standard axis. labelOffset means offset between label and axis,
	 * which is useful when 'onZero', where axisLabel is in the grid and
	 * label in outside grid.
	 *
	 * Tips: like always,
	 * positive rotation represents anticlockwise, and negative rotation
	 * represents clockwise.
	 * The direction of position coordinate is the same as the direction
	 * of screen coordinate.
	 *
	 * Do not need to consider axis 'inverse', which is auto processed by
	 * axis extent.
	 *
	 * @param {module:zrender/container/Group} group
	 * @param {Object} axisModel
	 * @param {Object} opt Standard axis parameters.
	 * @param {Array.<number>} opt.position [x, y]
	 * @param {number} opt.rotation by radian
	 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
	 * @param {number} [opt.tickDirection=1] 1 or -1
	 * @param {number} [opt.labelDirection=1] 1 or -1
	 * @param {number} [opt.labelOffset=0] Usefull when onZero.
	 * @param {string} [opt.axisLabelShow] default get from axisModel.
	 * @param {string} [opt.axisName] default get from axisModel.
	 * @param {number} [opt.axisNameAvailableWidth]
	 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
	 * @param {number} [opt.strokeContainThreshold] Default label interval when label
	 * @param {number} [opt.nameTruncateMaxWidth]
	 */
	
	
	var AxisBuilder = function (axisModel, opt) {
	  /**
	   * @readOnly
	   */
	  this.opt = opt;
	  /**
	   * @readOnly
	   */
	
	  this.axisModel = axisModel; // Default value
	
	  defaults(opt, {
	    labelOffset: 0,
	    nameDirection: 1,
	    tickDirection: 1,
	    labelDirection: 1,
	    silent: true
	  });
	  /**
	   * @readOnly
	   */
	
	  this.group = new graphic.Group(); // FIXME Not use a seperate text group?
	
	  var dumbGroup = new graphic.Group({
	    position: opt.position.slice(),
	    rotation: opt.rotation
	  }); // this.group.add(dumbGroup);
	  // this._dumbGroup = dumbGroup;
	
	  dumbGroup.updateTransform();
	  this._transform = dumbGroup.transform;
	  this._dumbGroup = dumbGroup;
	};
	
	AxisBuilder.prototype = {
	  constructor: AxisBuilder,
	  hasBuilder: function (name) {
	    return !!builders[name];
	  },
	  add: function (name) {
	    builders[name].call(this);
	  },
	  getGroup: function () {
	    return this.group;
	  }
	};
	var builders = {
	  /**
	   * @private
	   */
	  axisLine: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	
	    if (!axisModel.get('axisLine.show')) {
	      return;
	    }
	
	    var extent = this.axisModel.axis.getExtent();
	    var matrix = this._transform;
	    var pt1 = [extent[0], 0];
	    var pt2 = [extent[1], 0];
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    }
	
	    var lineStyle = extend({
	      lineCap: 'round'
	    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
	    this.group.add(new graphic.Line(graphic.subPixelOptimizeLine({
	      // Id for animation
	      anid: 'line',
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: lineStyle,
	      strokeContainThreshold: opt.strokeContainThreshold || 5,
	      silent: true,
	      z2: 1
	    })));
	    var arrows = axisModel.get('axisLine.symbol');
	    var arrowSize = axisModel.get('axisLine.symbolSize');
	    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;
	
	    if (typeof arrowOffset === 'number') {
	      arrowOffset = [arrowOffset, arrowOffset];
	    }
	
	    if (arrows != null) {
	      if (typeof arrows === 'string') {
	        // Use the same arrow for start and end point
	        arrows = [arrows, arrows];
	      }
	
	      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
	        // Use the same size for width and height
	        arrowSize = [arrowSize, arrowSize];
	      }
	
	      var symbolWidth = arrowSize[0];
	      var symbolHeight = arrowSize[1];
	      each([{
	        rotate: opt.rotation + Math.PI / 2,
	        offset: arrowOffset[0],
	        r: 0
	      }, {
	        rotate: opt.rotation - Math.PI / 2,
	        offset: arrowOffset[1],
	        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
	      }], function (point, index) {
	        if (arrows[index] !== 'none' && arrows[index] != null) {
	          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset
	
	          var r = point.r + point.offset;
	          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
	          symbol.attr({
	            rotation: point.rotate,
	            position: pos,
	            silent: true,
	            z2: 11
	          });
	          this.group.add(symbol);
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  axisTickLabel: function () {
	    var axisModel = this.axisModel;
	    var opt = this.opt;
	    var tickEls = buildAxisTick(this, axisModel, opt);
	    var labelEls = buildAxisLabel(this, axisModel, opt);
	    fixMinMaxLabelShow(axisModel, labelEls, tickEls);
	  },
	
	  /**
	   * @private
	   */
	  axisName: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	    var name = retrieve(opt.axisName, axisModel.get('name'));
	
	    if (!name) {
	      return;
	    }
	
	    var nameLocation = axisModel.get('nameLocation');
	    var nameDirection = opt.nameDirection;
	    var textStyleModel = axisModel.getModel('nameTextStyle');
	    var gap = axisModel.get('nameGap') || 0;
	    var extent = this.axisModel.axis.getExtent();
	    var gapSignal = extent[0] > extent[1] ? -1 : 1;
	    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
	    // Reuse labelOffset.
	    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	    var labelLayout;
	    var nameRotation = axisModel.get('nameRotate');
	
	    if (nameRotation != null) {
	      nameRotation = nameRotation * PI / 180; // To radian.
	    }
	
	    var axisNameAvailableWidth;
	
	    if (isNameLocationCenter(nameLocation)) {
	      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	      nameDirection);
	    } else {
	      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
	      axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	      if (axisNameAvailableWidth != null) {
	        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	      }
	    }
	
	    var textFont = textStyleModel.getFont();
	    var truncateOpt = axisModel.get('nameTruncate', true) || {};
	    var ellipsis = truncateOpt.ellipsis;
	    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
	    // truncate rich text? (consider performance)
	
	    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
	      minChar: 2,
	      placeholder: truncateOpt.placeholder
	    }) : name;
	    var tooltipOpt = axisModel.get('tooltip', true);
	    var mainType = axisModel.mainType;
	    var formatterParams = {
	      componentType: mainType,
	      name: name,
	      $vars: ['name']
	    };
	    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'name',
	      __fullText: name,
	      __truncatedText: truncatedText,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: isSilent(axisModel),
	      z2: 1,
	      tooltip: tooltipOpt && tooltipOpt.show ? extend({
	        content: name,
	        formatter: function () {
	          return name;
	        },
	        formatterParams: formatterParams
	      }, tooltipOpt) : null
	    });
	    graphic.setTextStyle(textEl.style, textStyleModel, {
	      text: truncatedText,
	      textFont: textFont,
	      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
	      textAlign: labelLayout.textAlign,
	      textVerticalAlign: labelLayout.textVerticalAlign
	    });
	
	    if (axisModel.get('triggerEvent')) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisName';
	      textEl.eventData.name = name;
	    } // FIXME
	
	
	    this._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    this.group.add(textEl);
	    textEl.decomposeTransform();
	  }
	};
	/**
	 * @public
	 * @static
	 * @param {Object} opt
	 * @param {number} axisRotation in radian
	 * @param {number} textRotation in radian
	 * @param {number} direction
	 * @return {Object} {
	 *  rotation, // according to axis
	 *  textAlign,
	 *  textVerticalAlign
	 * }
	 */
	
	var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	  var rotationDiff = remRadian(textRotation - axisRotation);
	  var textAlign;
	  var textVerticalAlign;
	
	  if (isRadianAroundZero(rotationDiff)) {
	    // Label is parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI)) {
	    // Label is inverse parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff > 0 && rotationDiff < PI) {
	      textAlign = direction > 0 ? 'right' : 'left';
	    } else {
	      textAlign = direction > 0 ? 'left' : 'right';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	};
	
	function endTextLayout(opt, textPosition, textRotate, extent) {
	  var rotationDiff = remRadian(textRotate - opt.rotation);
	  var textAlign;
	  var textVerticalAlign;
	  var inverse = extent[0] > extent[1];
	  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	  if (isRadianAroundZero(rotationDiff - PI / 2)) {
	    textVerticalAlign = onLeft ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
	    textVerticalAlign = onLeft ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
	      textAlign = onLeft ? 'left' : 'right';
	    } else {
	      textAlign = onLeft ? 'right' : 'left';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	function isSilent(axisModel) {
	  var tooltipOpt = axisModel.get('tooltip');
	  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	}
	
	function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	  if (shouldShowAllLabels(axisModel.axis)) {
	    return;
	  } // If min or max are user set, we need to check
	  // If the tick on min(max) are overlap on their neighbour tick
	  // If they are overlapped, we need to hide the min(max) tick label
	
	
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
	  // Have not consider onBand yet, where tick els is more than label els.
	
	  labelEls = labelEls || [];
	  tickEls = tickEls || [];
	  var firstLabel = labelEls[0];
	  var nextLabel = labelEls[1];
	  var lastLabel = labelEls[labelEls.length - 1];
	  var prevLabel = labelEls[labelEls.length - 2];
	  var firstTick = tickEls[0];
	  var nextTick = tickEls[1];
	  var lastTick = tickEls[tickEls.length - 1];
	  var prevTick = tickEls[tickEls.length - 2];
	
	  if (showMinLabel === false) {
	    ignoreEl(firstLabel);
	    ignoreEl(firstTick);
	  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	    if (showMinLabel) {
	      ignoreEl(nextLabel);
	      ignoreEl(nextTick);
	    } else {
	      ignoreEl(firstLabel);
	      ignoreEl(firstTick);
	    }
	  }
	
	  if (showMaxLabel === false) {
	    ignoreEl(lastLabel);
	    ignoreEl(lastTick);
	  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	    if (showMaxLabel) {
	      ignoreEl(prevLabel);
	      ignoreEl(prevTick);
	    } else {
	      ignoreEl(lastLabel);
	      ignoreEl(lastTick);
	    }
	  }
	}
	
	function ignoreEl(el) {
	  el && (el.ignore = true);
	}
	
	function isTwoLabelOverlapped(current, next, labelLayout) {
	  // current and next has the same rotation.
	  var firstRect = current && current.getBoundingRect().clone();
	  var nextRect = next && next.getBoundingRect().clone();
	
	  if (!firstRect || !nextRect) {
	    return;
	  } // When checking intersect of two rotated labels, we use mRotationBack
	  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	  var mRotationBack = matrixUtil.identity([]);
	  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
	  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
	  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
	  return firstRect.intersect(nextRect);
	}
	
	function isNameLocationCenter(nameLocation) {
	  return nameLocation === 'middle' || nameLocation === 'center';
	}
	
	function buildAxisTick(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	
	  if (!axisModel.get('axisTick.show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var tickModel = axisModel.getModel('axisTick');
	  var lineStyleModel = tickModel.getModel('lineStyle');
	  var tickLen = tickModel.get('length');
	  var ticksCoords = axis.getTicksCoords();
	  var pt1 = [];
	  var pt2 = [];
	  var matrix = axisBuilder._transform;
	  var tickEls = [];
	
	  for (var i = 0; i < ticksCoords.length; i++) {
	    var tickCoord = ticksCoords[i].coord;
	    pt1[0] = tickCoord;
	    pt1[1] = 0;
	    pt2[0] = tickCoord;
	    pt2[1] = opt.tickDirection * tickLen;
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    } // Tick line, Not use group transform to have better line draw
	
	
	    var tickEl = new graphic.Line(graphic.subPixelOptimizeLine({
	      // Id for animation
	      anid: 'tick_' + ticksCoords[i].tickValue,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: defaults(lineStyleModel.getLineStyle(), {
	        stroke: axisModel.get('axisLine.lineStyle.color')
	      }),
	      z2: 2,
	      silent: true
	    }));
	    axisBuilder.group.add(tickEl);
	    tickEls.push(tickEl);
	  }
	
	  return tickEls;
	}
	
	function buildAxisLabel(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));
	
	  if (!show || axis.scale.isBlank()) {
	    return;
	  }
	
	  var labelModel = axisModel.getModel('axisLabel');
	  var labelMargin = labelModel.get('margin');
	  var labels = axis.getViewLabels(); // Special label rotate.
	
	  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
	  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	  var rawCategoryData = axisModel.getCategories(true);
	  var labelEls = [];
	  var silent = isSilent(axisModel);
	  var triggerEvent = axisModel.get('triggerEvent');
	  each(labels, function (labelItem, index) {
	    var tickValue = labelItem.tickValue;
	    var formattedLabel = labelItem.formattedLabel;
	    var rawLabel = labelItem.rawLabel;
	    var itemLabelModel = labelModel;
	
	    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
	    }
	
	    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
	    var tickCoord = axis.dataToCoord(tickValue);
	    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'label_' + tickValue,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: silent,
	      z2: 10
	    });
	    graphic.setTextStyle(textEl.style, itemLabelModel, {
	      text: formattedLabel,
	      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      // (2) Compatible with previous version, which always use formatted label as
	      // input. But in interval scale the formatted label is like '223,445', which
	      // maked user repalce ','. So we modify it to return original val but remain
	      // it as 'string' to avoid error in replacing.
	      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
	    }); // Pack data for mouse event
	
	    if (triggerEvent) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisLabel';
	      textEl.eventData.value = rawLabel;
	    } // FIXME
	
	
	    axisBuilder._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    labelEls.push(textEl);
	    axisBuilder.group.add(textEl);
	    textEl.decomposeTransform();
	  });
	  return labelEls;
	}
	
	var _default = AxisBuilder;
	module.exports = _default;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var axisPointerModelHelper = __webpack_require__(302);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Base class of AxisView.
	 */
	var AxisView = echarts.extendComponentView({
	  type: 'axis',
	
	  /**
	   * @private
	   */
	  _axisPointer: null,
	
	  /**
	   * @protected
	   * @type {string}
	   */
	  axisPointerClass: null,
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    // FIXME
	    // This process should proformed after coordinate systems updated
	    // (axis scale updated), and should be performed each time update.
	    // So put it here temporarily, although it is not appropriate to
	    // put a model-writing procedure in `view`.
	    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
	    AxisView.superApply(this, 'render', arguments);
	    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
	  },
	
	  /**
	   * Action handler.
	   * @public
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/model/Global} ecModel
	   * @param {module:echarts/ExtensionAPI} api
	   * @param {Object} payload
	   */
	  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
	    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    var axisPointer = this._axisPointer;
	    axisPointer && axisPointer.remove(api);
	    AxisView.superApply(this, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    disposeAxisPointer(this, api);
	    AxisView.superApply(this, 'dispose', arguments);
	  }
	});
	
	function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
	  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);
	
	  if (!Clazz) {
	    return;
	  }
	
	  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
	  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
	}
	
	function disposeAxisPointer(axisView, ecModel, api) {
	  var axisPointer = axisView._axisPointer;
	  axisPointer && axisPointer.dispose(ecModel, api);
	  axisView._axisPointer = null;
	}
	
	var axisPointerClazz = [];
	
	AxisView.registerAxisPointerClass = function (type, clazz) {
	  axisPointerClazz[type] = clazz;
	};
	
	AxisView.getAxisPointerClass = function (type) {
	  return type && axisPointerClazz[type];
	};
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Model = __webpack_require__(174);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	// allAxesInfo should be updated when setOption performed.
	
	function collect(ecModel, api) {
	  var result = {
	    /**
	     * key: makeKey(axis.model)
	     * value: {
	     *      axis,
	     *      coordSys,
	     *      axisPointerModel,
	     *      triggerTooltip,
	     *      involveSeries,
	     *      snap,
	     *      seriesModels,
	     *      seriesDataCount
	     * }
	     */
	    axesInfo: {},
	    seriesInvolved: false,
	
	    /**
	     * key: makeKey(coordSys.model)
	     * value: Object: key makeKey(axis.model), value: axisInfo
	     */
	    coordSysAxesInfo: {},
	    coordSysMap: {}
	  };
	  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	  result.seriesInvolved && collectSeriesInfo(result, ecModel);
	  return result;
	}
	
	function collectAxesInfo(result, ecModel, api) {
	  var globalTooltipModel = ecModel.getComponent('tooltip');
	  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	  var linksOption = globalAxisPointerModel.get('link', true) || [];
	  var linkGroups = []; // Collect axes info.
	
	  each(api.getCoordinateSystems(), function (coordSys) {
	    // Some coordinate system do not support axes, like geo.
	    if (!coordSys.axisPointerEnabled) {
	      return;
	    }
	
	    var coordSysKey = makeKey(coordSys.model);
	    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
	    // for user. So we enable seting tooltip on coordSys model.
	
	    var coordSysModel = coordSys.model;
	    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	    // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	    // show but axisPointer will show as normal.
	    && baseTooltipModel.get('show')) {
	      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
	      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));
	
	      if (triggerAxis || cross) {
	        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	      }
	
	      if (cross) {
	        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	      }
	    } // fromTooltip: true | false | 'cross'
	    // triggerTooltip: true | false | null
	
	
	    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	      var axisPointerShow = axisPointerModel.get('show');
	
	      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	        return;
	      }
	
	      if (triggerTooltip == null) {
	        triggerTooltip = axisPointerModel.get('triggerTooltip');
	      }
	
	      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	      var snap = axisPointerModel.get('snap');
	      var key = makeKey(axis.model);
	      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	      var axisInfo = result.axesInfo[key] = {
	        key: key,
	        axis: axis,
	        coordSys: coordSys,
	        axisPointerModel: axisPointerModel,
	        triggerTooltip: triggerTooltip,
	        involveSeries: involveSeries,
	        snap: snap,
	        useHandle: isHandleTrigger(axisPointerModel),
	        seriesModels: []
	      };
	      axesInfoInCoordSys[key] = axisInfo;
	      result.seriesInvolved |= involveSeries;
	      var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	      if (groupIndex != null) {
	        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	          axesInfo: {}
	        });
	        linkGroup.axesInfo[key] = axisInfo;
	        linkGroup.mapper = linksOption[groupIndex].mapper;
	        axisInfo.linkGroup = linkGroup;
	      }
	    }
	  });
	}
	
	function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	  var volatileOption = {};
	  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
	    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
	  }); // category axis do not auto snap, otherwise some tick that do not
	  // has value can not be hovered. value/time/log axis default snap if
	  // triggered from tooltip and trigger tooltip.
	
	  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
	  // Only these properties can be overrided from tooltip to axisPointer.
	
	  if (tooltipAxisPointerModel.get('type') === 'cross') {
	    volatileOption.type = 'line';
	  }
	
	  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	  labelOption.show == null && (labelOption.show = false);
	
	  if (fromTooltip === 'cross') {
	    // When 'cross', both axes show labels.
	    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
	    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
	    // (cross style is dashed by default)
	
	    if (!triggerTooltip) {
	      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
	    }
	  }
	
	  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	}
	
	function collectSeriesInfo(result, ecModel) {
	  // Prepare data for axis trigger
	  ecModel.eachSeries(function (seriesModel) {
	    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
	    var seriesTooltipShow = seriesModel.get('tooltip.show', true);
	
	    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
	      return;
	    }
	
	    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	      var axis = axisInfo.axis;
	
	      if (coordSys.getAxis(axis.dim) === axis) {
	        axisInfo.seriesModels.push(seriesModel);
	        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	        axisInfo.seriesDataCount += seriesModel.getData().count();
	      }
	    });
	  }, this);
	}
	/**
	 * For example:
	 * {
	 *     axisPointer: {
	 *         links: [{
	 *             xAxisIndex: [2, 4],
	 *             yAxisIndex: 'all'
	 *         }, {
	 *             xAxisId: ['a5', 'a7'],
	 *             xAxisName: 'xxx'
	 *         }]
	 *     }
	 * }
	 */
	
	
	function getLinkGroupIndex(linksOption, axis) {
	  var axisModel = axis.model;
	  var dim = axis.dim;
	
	  for (var i = 0; i < linksOption.length; i++) {
	    var linkOption = linksOption[i] || {};
	
	    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	      return i;
	    }
	  }
	}
	
	function checkPropInLink(linkPropValue, axisPropValue) {
	  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	}
	
	function fixValue(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	
	  if (!axisInfo) {
	    return;
	  }
	
	  var axisPointerModel = axisInfo.axisPointerModel;
	  var scale = axisInfo.axis.scale;
	  var option = axisPointerModel.option;
	  var status = axisPointerModel.get('status');
	  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	  if (value != null) {
	    value = scale.parse(value);
	  }
	
	  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	  // and status should be initialized.
	
	  if (status == null) {
	    option.status = useHandle ? 'show' : 'hide';
	  }
	
	  var extent = scale.getExtent().slice();
	  extent[0] > extent[1] && extent.reverse();
	
	  if ( // Pick a value on axis when initializing.
	  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	  // where we should re-pick a value to keep `handle` displaying normally.
	  || value > extent[1]) {
	    // Make handle displayed on the end of the axis when init, which looks better.
	    value = extent[1];
	  }
	
	  if (value < extent[0]) {
	    value = extent[0];
	  }
	
	  option.value = value;
	
	  if (useHandle) {
	    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	  }
	}
	
	function getAxisInfo(axisModel) {
	  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	}
	
	function getAxisPointerModel(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	  return axisInfo && axisInfo.axisPointerModel;
	}
	
	function isHandleTrigger(axisPointerModel) {
	  return !!axisPointerModel.get('handle.show');
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @return {string} unique key
	 */
	
	
	function makeKey(model) {
	  return model.type + '||' + model.id;
	}
	
	exports.collect = collect;
	exports.fixValue = fixValue;
	exports.getAxisInfo = getAxisInfo;
	exports.getAxisPointerModel = getAxisPointerModel;
	exports.makeKey = makeKey;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Can only be called after coordinate system creation stage.
	 * (Can be called before coordinate system update stage).
	 *
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(gridModel, axisModel, opt) {
	  opt = opt || {};
	  var grid = gridModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
	  var rawAxisPosition = axis.position;
	  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
	  var axisDim = axis.dim;
	  var rect = grid.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var idx = {
	    left: 0,
	    right: 1,
	    top: 0,
	    bottom: 1,
	    onZero: 2
	  };
	  var axisOffset = axisModel.get('offset') || 0;
	  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	  if (otherAxisOnZeroOf) {
	    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
	    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	  } // Axis position
	
	
	  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	  var dirMap = {
	    top: -1,
	    bottom: 1,
	    left: -1,
	    right: 1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  } // Special label rotation
	
	
	  var labelRotate = axisModel.get('axisLabel.rotate');
	  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
	
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var _barGrid = __webpack_require__(267);
	
	var layout = _barGrid.layout;
	var largeLayout = _barGrid.largeLayout;
	
	__webpack_require__(290);
	
	__webpack_require__(305);
	
	__webpack_require__(307);
	
	__webpack_require__(289);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(layout, 'bar')); // Should after normal bar layout, otherwise it is blocked by normal bar layout.
	
	echarts.registerLayout(largeLayout);
	echarts.registerVisual({
	  seriesType: 'bar',
	  reset: function (seriesModel) {
	    // Visual coding for legend
	    seriesModel.getData().setVisual('legendSymbol', 'roundRect');
	  }
	});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = BaseBarSeries.extend({
	  type: 'series.bar',
	  dependencies: ['grid', 'polar'],
	  brushSelector: 'rect',
	
	  /**
	   * @override
	   */
	  getProgressive: function () {
	    // Do not support progressive in normal mode.
	    return this.get('large') ? this.get('progressive') : false;
	  },
	
	  /**
	   * @override
	   */
	  getProgressiveThreshold: function () {
	    // Do not support progressive in normal mode.
	    var progressiveThreshold = this.get('progressiveThreshold');
	    var largeThreshold = this.get('largeThreshold');
	
	    if (largeThreshold > progressiveThreshold) {
	      progressiveThreshold = largeThreshold;
	    }
	
	    return progressiveThreshold;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(233);
	
	var createListFromArray = __webpack_require__(254);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.__base_bar__',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	  getMarkerPosition: function (value) {
	    var coordSys = this.coordinateSystem;
	
	    if (coordSys) {
	      // PENDING if clamp ?
	      var pt = coordSys.dataToPoint(coordSys.clampData(value));
	      var data = this.getData();
	      var offset = data.getLayout('offset');
	      var size = data.getLayout('size');
	      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	      pt[offsetIndex] += offset + size / 2;
	      return pt;
	    }
	
	    return [NaN, NaN];
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    // stack: null
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // 最小高度改为0
	    barMinHeight: 0,
	    // 最小角度为0，仅对极坐标系下的柱状图有效
	    barMinAngle: 0,
	    // cursor: null,
	    large: false,
	    largeThreshold: 400,
	    progressive: 3e3,
	    progressiveChunkMode: 'mod',
	    // barMaxWidth: null,
	    // 默认自适应
	    // barWidth: null,
	    // 柱间距离，默认为柱形宽度的30%，可设固定值
	    // barGap: '30%',
	    // 类目间柱形距离，默认为类目间距的20%，可设固定值
	    // barCategoryGap: '20%',
	    // label: {
	    //      show: false
	    // },
	    itemStyle: {},
	    emphasis: {}
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var _helper = __webpack_require__(308);
	
	var setLabel = _helper.setLabel;
	
	var Model = __webpack_require__(174);
	
	var barItemStyle = __webpack_require__(309);
	
	var Path = __webpack_require__(182);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'barBorderWidth']; // FIXME
	// Just for compatible with ec2.
	
	zrUtil.extend(Model.prototype, barItemStyle);
	
	var _default = echarts.extendChartView({
	  type: 'bar',
	  render: function (seriesModel, ecModel, api) {
	    this._updateDrawMode(seriesModel);
	
	    var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
	    } else {}
	
	    return this.group;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    // Do not support progressive in normal mode.
	    this._incrementalRenderLarge(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coord = seriesModel.coordinateSystem;
	    var baseAxis = coord.getBaseAxis();
	    var isHorizontalOrRadial;
	
	    if (coord.type === 'cartesian2d') {
	      isHorizontalOrRadial = baseAxis.isHorizontal();
	    } else if (coord.type === 'polar') {
	      isHorizontalOrRadial = baseAxis.dim === 'angle';
	    }
	
	    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = data.getItemModel(dataIndex);
	      var layout = getLayout[coord.type](data, dataIndex, itemModel);
	      var el = elementCreator[coord.type](data, dataIndex, itemModel, layout, isHorizontalOrRadial, animationModel);
	      data.setItemGraphicEl(dataIndex, el);
	      group.add(el);
	      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).update(function (newIndex, oldIndex) {
	      var el = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemModel = data.getItemModel(newIndex);
	      var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	      if (el) {
	        graphic.updateProps(el, {
	          shape: layout
	        }, animationModel, newIndex);
	      } else {
	        el = elementCreator[coord.type](data, newIndex, itemModel, layout, isHorizontalOrRadial, animationModel, true);
	      }
	
	      data.setItemGraphicEl(newIndex, el); // Add back
	
	      group.add(el);
	      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).remove(function (dataIndex) {
	      var el = oldData.getItemGraphicEl(dataIndex);
	
	      if (coord.type === 'cartesian2d') {
	        el && removeRect(dataIndex, animationModel, el);
	      } else {
	        el && removeSector(dataIndex, animationModel, el);
	      }
	    }).execute();
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    createLarge(seriesModel, this.group);
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    createLarge(seriesModel, this.group, true);
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel) {
	    this._clear(ecModel);
	  },
	  _clear: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel && ecModel.get('animation') && data && !this._isLargeDraw) {
	      data.eachItemGraphicEl(function (el) {
	        if (el.type === 'sector') {
	          removeSector(el.dataIndex, ecModel, el);
	        } else {
	          removeRect(el.dataIndex, ecModel, el);
	        }
	      });
	    } else {
	      group.removeAll();
	    }
	
	    this._data = null;
	  }
	});
	
	var elementCreator = {
	  cartesian2d: function (data, dataIndex, itemModel, layout, isHorizontal, animationModel, isUpdate) {
	    var rect = new graphic.Rect({
	      shape: zrUtil.extend({}, layout)
	    }); // Animation
	
	    if (animationModel) {
	      var rectShape = rect.shape;
	      var animateProperty = isHorizontal ? 'height' : 'width';
	      var animateTarget = {};
	      rectShape[animateProperty] = 0;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return rect;
	  },
	  polar: function (data, dataIndex, itemModel, layout, isRadial, animationModel, isUpdate) {
	    // Keep the same logic with bar in catesion: use end value to control
	    // direction. Notice that if clockwise is true (by default), the sector
	    // will always draw clockwisely, no matter whether endAngle is greater
	    // or less than startAngle.
	    var clockwise = layout.startAngle < layout.endAngle;
	    var sector = new graphic.Sector({
	      shape: zrUtil.defaults({
	        clockwise: clockwise
	      }, layout)
	    }); // Animation
	
	    if (animationModel) {
	      var sectorShape = sector.shape;
	      var animateProperty = isRadial ? 'r' : 'endAngle';
	      var animateTarget = {};
	      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return sector;
	  }
	};
	
	function removeRect(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      width: 0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	function removeSector(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      r: el.shape.r0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	var getLayout = {
	  cartesian2d: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    var fixedLineWidth = getLineWidth(itemModel, layout); // fix layout with lineWidth
	
	    var signX = layout.width > 0 ? 1 : -1;
	    var signY = layout.height > 0 ? 1 : -1;
	    return {
	      x: layout.x + signX * fixedLineWidth / 2,
	      y: layout.y + signY * fixedLineWidth / 2,
	      width: layout.width - signX * fixedLineWidth,
	      height: layout.height - signY * fixedLineWidth
	    };
	  },
	  polar: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    return {
	      cx: layout.cx,
	      cy: layout.cy,
	      r0: layout.r0,
	      r: layout.r,
	      startAngle: layout.startAngle,
	      endAngle: layout.endAngle
	    };
	  }
	};
	
	function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
	  var color = data.getItemVisual(dataIndex, 'color');
	  var opacity = data.getItemVisual(dataIndex, 'opacity');
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getBarItemStyle();
	
	  if (!isPolar) {
	    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
	  }
	
	  el.useStyle(zrUtil.defaults({
	    fill: color,
	    opacity: opacity
	  }, itemStyleModel.getBarItemStyle()));
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && el.attr('cursor', cursorStyle);
	  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';
	
	  if (!isPolar) {
	    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
	  }
	
	  graphic.setHoverStyle(el, hoverStyle);
	} // In case width or height are too small.
	
	
	function getLineWidth(itemModel, rawLayout) {
	  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	  return Math.min(lineWidth, Math.abs(rawLayout.width), Math.abs(rawLayout.height));
	}
	
	var LargePath = Path.extend({
	  type: 'largeBar',
	  shape: {
	    points: []
	  },
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	    var startPoint = this.__startPoint;
	    var valueIdx = this.__valueIdx;
	
	    for (var i = 0; i < points.length; i += 2) {
	      startPoint[this.__valueIdx] = points[i + valueIdx];
	      ctx.moveTo(startPoint[0], startPoint[1]);
	      ctx.lineTo(points[i], points[i + 1]);
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  // TODO support polar
	  var data = seriesModel.getData();
	  var startPoint = [];
	  var valueIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
	  startPoint[1 - valueIdx] = data.getLayout('valueAxisStart');
	  var el = new LargePath({
	    shape: {
	      points: data.getLayout('largePoints')
	    },
	    incremental: !!incremental,
	    __startPoint: startPoint,
	    __valueIdx: valueIdx
	  });
	  group.add(el);
	  setLargeStyle(el, seriesModel, data);
	}
	
	function setLargeStyle(el, seriesModel, data) {
	  var borderColor = data.getVisual('borderColor') || data.getVisual('color');
	  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	module.exports = _default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var _labelHelper = __webpack_require__(282);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
	  var labelModel = itemModel.getModel('label');
	  var hoverLabelModel = itemModel.getModel('emphasis.label');
	  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: dataIndex,
	    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
	    isRectText: true,
	    autoColor: color
	  });
	  fixPosition(normalStyle);
	  fixPosition(hoverStyle);
	}
	
	function fixPosition(style, labelPositionOutside) {
	  if (style.textPosition === 'outside') {
	    style.textPosition = labelPositionOutside;
	  }
	}
	
	exports.setLabel = setLabel;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
	['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getBarItemStyle: function (excludes) {
	    var style = getBarItemStyle(this, excludes);
	
	    if (this.getBorderLineDash) {
	      var lineDash = this.getBorderLineDash();
	      lineDash && (style.lineDash = lineDash);
	    }
	
	    return style;
	  }
	};
	module.exports = _default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	__webpack_require__(311);
	
	__webpack_require__(314);
	
	var createDataSelectAction = __webpack_require__(315);
	
	var dataColor = __webpack_require__(316);
	
	var pieLayout = __webpack_require__(317);
	
	var dataFilter = __webpack_require__(319);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	createDataSelectAction('pie', [{
	  type: 'pieToggleSelect',
	  event: 'pieselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'pieSelect',
	  event: 'pieselected',
	  method: 'select'
	}, {
	  type: 'pieUnSelect',
	  event: 'pieunselected',
	  method: 'unSelect'
	}]);
	echarts.registerVisual(dataColor('pie'));
	echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
	echarts.registerProcessor(dataFilter('pie'));

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var createListSimply = __webpack_require__(312);
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	var _number = __webpack_require__(218);
	
	var getPercentWithPrecision = _number.getPercentWithPrecision;
	
	var dataSelectableMixin = __webpack_require__(313);
	
	var _dataProvider = __webpack_require__(235);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PieSeries = echarts.extendSeriesModel({
	  type: 'series.pie',
	  // Overwrite
	  init: function (option) {
	    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    };
	
	    this.updateSelectedMap(this._createSelectableList());
	
	    this._defaultLabelLine(option);
	  },
	  // Overwrite
	  mergeOption: function (newOption) {
	    PieSeries.superCall(this, 'mergeOption', newOption);
	    this.updateSelectedMap(this._createSelectableList());
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, ['value']);
	  },
	  _createSelectableList: function () {
	    var data = this.getRawData();
	    var valueDim = data.mapDimension('value');
	    var targetList = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      targetList.push({
	        name: data.getName(i),
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    return targetList;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?
	
	    var valueList = [];
	    data.each(data.mapDimension('value'), function (value) {
	      valueList.push(value);
	    });
	    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
	    params.$vars.push('percent');
	    return params;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    modelUtil.defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    // 选中时扇区偏移量
	    selectedOffset: 10,
	    // 高亮扇区偏移量
	    hoverOffset: 10,
	    // If use strategy to avoid label overlapping
	    avoidLabelOverlap: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	    // roseType: null,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // cursor: null,
	    label: {
	      // If rotate around circle
	      rotate: false,
	      show: true,
	      // 'outer', 'inside', 'center'
	      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	      // 默认使用全局文本样式，详见TEXTSTYLE
	      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	    },
	    // Enabled when label.normal.position is 'outer'
	    labelLine: {
	      show: true,
	      // 引导线两段中的第一段长度
	      length: 15,
	      // 引导线两段中的第二段长度
	      length2: 15,
	      smooth: false,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      borderWidth: 1
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationEasing: 'cubicOut'
	  }
	});
	zrUtil.mixin(PieSeries, dataSelectableMixin);
	var _default = PieSeries;
	module.exports = _default;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createDimensions = __webpack_require__(258);
	
	var List = __webpack_require__(255);
	
	var _util = __webpack_require__(134);
	
	var extend = _util.extend;
	var isArray = _util.isArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Usage]:
	 * (1)
	 * createListSimply(seriesModel, ['value']);
	 * (2)
	 * createListSimply(seriesModel, {
	 *     coordDimensions: ['value'],
	 *     dimensionsCount: 5
	 * });
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
	 *        The options in opt, see `echarts/data/helper/createDimensions`
	 * @param {Array.<string>} [nameList]
	 * @return {module:echarts/data/List}
	 */
	function _default(seriesModel, opt, nameList) {
	  opt = isArray(opt) && {
	    coordDimensions: opt
	  } || extend({}, opt);
	  var source = seriesModel.getSource();
	  var dimensionsInfo = createDimensions(source, opt);
	  var list = new List(dimensionsInfo, seriesModel);
	  list.initData(source, nameList);
	  return list;
	}
	
	module.exports = _default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Data selectable mixin for chart series.
	 * To eanble data select, option of series must have `selectedMode`.
	 * And each data item will use `selected` to toggle itself selected status
	 */
	var _default = {
	  /**
	   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
	   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
	   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
	   */
	  updateSelectedMap: function (targetList) {
	    this._targetList = zrUtil.isArray(targetList) ? targetList.slice() : [];
	    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
	      targetMap.set(target.name, target);
	      return targetMap;
	    }, zrUtil.createHashMap());
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  // PENGING If selectedMode is null ?
	  select: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      this._selectTargetMap.each(function (target) {
	        target.selected = false;
	      });
	    }
	
	    target && (target.selected = true);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  unSelect: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
	    // selectedMode !== 'single' && target && (target.selected = false);
	
	    target && (target.selected = false);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  toggleSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	
	    if (target != null) {
	      this[target.selected ? 'unSelect' : 'select'](name, id);
	      return target.selected;
	    }
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  isSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    return target && target.selected;
	  }
	};
	module.exports = _default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var ChartView = __webpack_require__(238);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	function updateDataSelected(uid, seriesModel, hasAnimation, api) {
	  var data = seriesModel.getData();
	  var dataIndex = this.dataIndex;
	  var name = data.getName(dataIndex);
	  var selectedOffset = seriesModel.get('selectedOffset');
	  api.dispatchAction({
	    type: 'pieToggleSelect',
	    from: uid,
	    name: name,
	    seriesId: seriesModel.id
	  });
	  data.each(function (idx) {
	    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
	  });
	}
	/**
	 * @param {module:zrender/graphic/Sector} el
	 * @param {Object} layout
	 * @param {boolean} isSelected
	 * @param {number} selectedOffset
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	
	
	function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var offset = isSelected ? selectedOffset : 0;
	  var position = [dx * offset, dy * offset];
	  hasAnimation // animateTo will stop revious animation like update transition
	  ? el.animate().when(200, {
	    position: position
	  }).start('bounceOut') : el.attr('position', position);
	}
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function PiePiece(data, idx) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: 2
	  });
	  var polyline = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(sector);
	  this.add(polyline);
	  this.add(text);
	  this.updateData(data, idx, true); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    polyline.ignore = polyline.hoverIgnore;
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    polyline.ignore = polyline.normalIgnore;
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var piePieceProto = PiePiece.prototype;
	
	piePieceProto.updateData = function (data, idx, firstCreate) {
	  var sector = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    var animationType = seriesModel.getShallow('animationType');
	
	    if (animationType === 'scale') {
	      sector.shape.r = layout.r0;
	      graphic.initProps(sector, {
	        shape: {
	          r: layout.r
	        }
	      }, seriesModel, idx);
	    } // Expansion
	    else {
	        sector.shape.endAngle = layout.startAngle;
	        graphic.updateProps(sector, {
	          shape: {
	            endAngle: layout.endAngle
	          }
	        }, seriesModel, idx);
	      }
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var visualColor = data.getItemVisual(idx, 'color');
	  sector.useStyle(zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: visualColor
	  }, itemModel.getModel('itemStyle').getItemStyle()));
	  sector.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected
	
	  toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(null, idx), seriesModel.get('selectedOffset'), seriesModel.get('animation'));
	
	  function onEmphasis() {
	    // Sector may has animation of updating data. Force to move to the last frame
	    // Or it may stopped on the wrong shape
	    sector.stopAnimation(true);
	    sector.animateTo({
	      shape: {
	        r: layout.r + seriesModel.get('hoverOffset')
	      }
	    }, 300, 'elasticOut');
	  }
	
	  function onNormal() {
	    sector.stopAnimation(true);
	    sector.animateTo({
	      shape: {
	        r: layout.r
	      }
	    }, 300, 'elasticOut');
	  }
	
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (itemModel.get('hoverAnimation') && seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	  }
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	piePieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	  var smooth = labelLineModel.get('smooth');
	
	  if (smooth && smooth === true) {
	    smooth = 0.4;
	  }
	
	  labelLine.setShape({
	    smooth: smooth
	  });
	};
	
	zrUtil.inherits(PiePiece, graphic.Group); // Pie view
	
	var PieView = ChartView.extend({
	  type: 'pie',
	  init: function () {
	    var sectorGroup = new graphic.Group();
	    this._sectorGroup = sectorGroup;
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    if (payload && payload.from === this.uid) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var hasAnimation = ecModel.get('animation');
	    var isFirstRender = !oldData;
	    var animationType = seriesModel.get('animationType');
	    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
	    var selectedMode = seriesModel.get('selectedMode');
	    data.diff(oldData).add(function (idx) {
	      var piePiece = new PiePiece(data, idx); // Default expansion animation
	
	      if (isFirstRender && animationType !== 'scale') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      selectedMode && piePiece.on('click', onSectorClick);
	      data.setItemGraphicEl(idx, piePiece);
	      group.add(piePiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      piePiece.off('click');
	      selectedMode && piePiece.on('click', onSectorClick);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	
	    if (hasAnimation && isFirstRender && data.count() > 0 // Default expansion animation
	    && animationType !== 'scale') {
	      var shape = data.getItemLayout(0);
	      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
	      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
	      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel));
	    } else {
	      // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel) {
	    var clipPath = new graphic.Sector({
	      shape: {
	        cx: cx,
	        cy: cy,
	        r0: 0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: startAngle,
	        clockwise: clockwise
	      }
	    });
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
	      }
	    }, seriesModel, cb);
	    return clipPath;
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var data = seriesModel.getData();
	    var itemLayout = data.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = PieView;
	module.exports = _default;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, actionInfos) {
	  zrUtil.each(actionInfos, function (actionInfo) {
	    actionInfo.update = 'updateView';
	    /**
	     * @payload
	     * @property {string} seriesName
	     * @property {string} name
	     */
	
	    echarts.registerAction(actionInfo, function (payload, ecModel) {
	      var selected = {};
	      ecModel.eachComponent({
	        mainType: 'series',
	        subType: seriesType,
	        query: payload
	      }, function (seriesModel) {
	        if (seriesModel[actionInfo.method]) {
	          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
	        }
	
	        var data = seriesModel.getData(); // Create selected map
	
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          selected[name] = seriesModel.isSelected(name) || false;
	        });
	      });
	      return {
	        name: payload.name,
	        selected: selected
	      };
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Pick color from palette for each data item.
	// Applicable for charts that require applying color palette
	// in data level (like pie, funnel, chord).
	function _default(seriesType) {
	  return {
	    getTargetSeries: function (ecModel) {
	      // Pie and funnel may use diferrent scope
	      var paletteScope = {};
	      var seiresModelMap = createHashMap();
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        seriesModel.__paletteScope = paletteScope;
	        seiresModelMap.set(seriesModel.uid, seriesModel);
	      });
	      return seiresModelMap;
	    },
	    reset: function (seriesModel, ecModel) {
	      var dataAll = seriesModel.getRawData();
	      var idxMap = {};
	      var data = seriesModel.getData();
	      data.each(function (idx) {
	        var rawIdx = data.getRawIndex(idx);
	        idxMap[rawIdx] = idx;
	      });
	      dataAll.each(function (rawIdx) {
	        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
	
	        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
	
	        if (!singleDataColor) {
	          // FIXME Performance
	          var itemModel = dataAll.getItemModel(rawIdx);
	          var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + '', seriesModel.__paletteScope, dataAll.count()); // Legend may use the visual info in data before processed
	
	          dataAll.setItemVisual(rawIdx, 'color', color); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'color', color);
	          }
	        } else {
	          // Set data all color for legend
	          dataAll.setItemVisual(rawIdx, 'color', singleDataColor);
	        }
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	var labelLayout = __webpack_require__(318);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var validDataCount = 0;
	    data.each(valueDim, function (value) {
	      !isNaN(value) && validDataCount++;
	    });
	    var sum = data.getSum(valueDim); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var clockwise = seriesModel.get('clockwise');
	    var roseType = seriesModel.get('roseType');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	    var extent = data.getDataExtent(valueDim);
	    extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var currentAngle = startAngle;
	    var dir = clockwise ? 1 : -1;
	    data.each(valueDim, function (value, idx) {
	      var angle;
	
	      if (isNaN(value)) {
	        data.setItemLayout(idx, {
	          angle: NaN,
	          startAngle: NaN,
	          endAngle: NaN,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: r0,
	          r: roseType ? NaN : r
	        });
	        return;
	      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	      if (roseType !== 'area') {
	        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	      } else {
	        angle = PI2 / validDataCount;
	      }
	
	      if (angle < minAngle) {
	        angle = minAngle;
	        restAngle -= minAngle;
	      } else {
	        valueSumLargerThanMinAngle += value;
	      }
	
	      var endAngle = currentAngle + dir * angle;
	      data.setItemLayout(idx, {
	        angle: angle,
	        startAngle: currentAngle,
	        endAngle: endAngle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: roseType ? linearMap(value, extent, [r0, r]) : r
	      });
	      currentAngle = endAngle;
	    }); // Some sector is constrained by minAngle
	    // Rest sectors needs recalculate angle
	
	    if (restAngle < PI2 && validDataCount) {
	      // Average the angle if rest angle is not enough after all angles is
	      // Constrained by minAngle
	      if (restAngle <= 1e-3) {
	        var angle = PI2 / validDataCount;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            layout.angle = angle;
	            layout.startAngle = startAngle + dir * idx * angle;
	            layout.endAngle = startAngle + dir * (idx + 1) * angle;
	          }
	        });
	      } else {
	        unitRadian = restAngle / valueSumLargerThanMinAngle;
	        currentAngle = startAngle;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
	            layout.startAngle = currentAngle;
	            layout.endAngle = currentAngle + dir * angle;
	            currentAngle += dir * angle;
	          }
	        });
	      }
	    }
	
	    labelLayout(seriesModel, r, width, height);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(167);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME emphasis label position is not same with normal label position
	function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight) {
	  list.sort(function (a, b) {
	    return a.y - b.y;
	  });
	
	  function shiftDown(start, end, delta, dir) {
	    for (var j = start; j < end; j++) {
	      list[j].y += delta;
	
	      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
	        shiftUp(j, delta / 2);
	        return;
	      }
	    }
	
	    shiftUp(end - 1, delta / 2);
	  }
	
	  function shiftUp(end, delta) {
	    for (var j = end; j >= 0; j--) {
	      list[j].y -= delta;
	
	      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
	        break;
	      }
	    }
	  }
	
	  function changeX(list, isDownList, cx, cy, r, dir) {
	    var lastDeltaX = dir > 0 ? isDownList // right-side
	    ? Number.MAX_VALUE // down
	    : 0 // up
	    : isDownList // left-side
	    ? Number.MAX_VALUE // down
	    : 0; // up
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      var deltaY = Math.abs(list[i].y - cy);
	      var length = list[i].len;
	      var length2 = list[i].len2;
	      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
	
	      if (isDownList && deltaX >= lastDeltaX) {
	        // right-down, left-down
	        deltaX = lastDeltaX - 10;
	      }
	
	      if (!isDownList && deltaX <= lastDeltaX) {
	        // right-up, left-up
	        deltaX = lastDeltaX + 10;
	      }
	
	      list[i].x = cx + deltaX * dir;
	      lastDeltaX = deltaX;
	    }
	  }
	
	  var lastY = 0;
	  var delta;
	  var len = list.length;
	  var upList = [];
	  var downList = [];
	
	  for (var i = 0; i < len; i++) {
	    delta = list[i].y - lastY;
	
	    if (delta < 0) {
	      shiftDown(i, len, -delta, dir);
	    }
	
	    lastY = list[i].y + list[i].height;
	  }
	
	  if (viewHeight - lastY < 0) {
	    shiftUp(len - 1, lastY - viewHeight);
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].y >= cy) {
	      downList.push(list[i]);
	    } else {
	      upList.push(list[i]);
	    }
	  }
	
	  changeX(upList, false, cx, cy, r, dir);
	  changeX(downList, true, cx, cy, r, dir);
	}
	
	function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight) {
	  var leftList = [];
	  var rightList = [];
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (isPositionCenter(labelLayoutList[i])) {
	      continue;
	    }
	
	    if (labelLayoutList[i].x < cx) {
	      leftList.push(labelLayoutList[i]);
	    } else {
	      rightList.push(labelLayoutList[i]);
	    }
	  }
	
	  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight);
	  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight);
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (isPositionCenter(labelLayoutList[i])) {
	      continue;
	    }
	
	    var linePoints = labelLayoutList[i].linePoints;
	
	    if (linePoints) {
	      var dist = linePoints[1][0] - linePoints[2][0];
	
	      if (labelLayoutList[i].x < cx) {
	        linePoints[2][0] = labelLayoutList[i].x + 3;
	      } else {
	        linePoints[2][0] = labelLayoutList[i].x - 3;
	      }
	
	      linePoints[1][1] = linePoints[2][1] = labelLayoutList[i].y;
	      linePoints[1][0] = linePoints[2][0] + dist;
	    }
	  }
	}
	
	function isPositionCenter(layout) {
	  // Not change x for center label
	  return layout.position === 'center';
	}
	
	function _default(seriesModel, r, viewWidth, viewHeight) {
	  var data = seriesModel.getData();
	  var labelLayoutList = [];
	  var cx;
	  var cy;
	  var hasLabelRotate = false;
	  data.each(function (idx) {
	    var layout = data.getItemLayout(idx);
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
	
	    var labelPosition = labelModel.get('position') || itemModel.get('emphasis.label.position');
	    var labelLineModel = itemModel.getModel('labelLine');
	    var labelLineLen = labelLineModel.get('length');
	    var labelLineLen2 = labelLineModel.get('length2');
	    var midAngle = (layout.startAngle + layout.endAngle) / 2;
	    var dx = Math.cos(midAngle);
	    var dy = Math.sin(midAngle);
	    var textX;
	    var textY;
	    var linePoints;
	    var textAlign;
	    cx = layout.cx;
	    cy = layout.cy;
	    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	    if (labelPosition === 'center') {
	      textX = layout.cx;
	      textY = layout.cy;
	      textAlign = 'center';
	    } else {
	      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
	      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
	      textX = x1 + dx * 3;
	      textY = y1 + dy * 3;
	
	      if (!isLabelInside) {
	        // For roseType
	        var x2 = x1 + dx * (labelLineLen + r - layout.r);
	        var y2 = y1 + dy * (labelLineLen + r - layout.r);
	        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
	        var y3 = y2;
	        textX = x3 + (dx < 0 ? -5 : 5);
	        textY = y3;
	        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	      }
	
	      textAlign = isLabelInside ? 'center' : dx > 0 ? 'left' : 'right';
	    }
	
	    var font = labelModel.getFont();
	    var labelRotate = labelModel.get('rotate') ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
	    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
	    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
	    hasLabelRotate = !!labelRotate;
	    layout.label = {
	      x: textX,
	      y: textY,
	      position: labelPosition,
	      height: textRect.height,
	      len: labelLineLen,
	      len2: labelLineLen2,
	      linePoints: linePoints,
	      textAlign: textAlign,
	      verticalAlign: 'middle',
	      rotation: labelRotate,
	      inside: isLabelInside
	    }; // Not layout the inside label
	
	    if (!isLabelInside) {
	      labelLayoutList.push(layout.label);
	    }
	  });
	
	  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    reset: function (seriesModel, ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (!legendModels || !legendModels.length) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      data.filterSelf(function (idx) {
	        var name = data.getName(idx); // If in any legend component the status is not selected.
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(name)) {
	            return false;
	          }
	        }
	
	        return true;
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(321);
	
	__webpack_require__(322);
	
	var visualSymbol = __webpack_require__(286);
	
	var layoutPoints = __webpack_require__(287);
	
	__webpack_require__(289);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as zrUtil from 'zrender/src/core/util';
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('scatter', 'circle'));
	echarts.registerLayout(layoutPoints('scatter')); // echarts.registerProcessor(function (ecModel, api) {
	//     ecModel.eachSeriesByType('scatter', function (seriesModel) {
	//         var data = seriesModel.getData();
	//         var coordSys = seriesModel.coordinateSystem;
	//         if (coordSys.type !== 'geo') {
	//             return;
	//         }
	//         var startPt = coordSys.pointToData([0, 0]);
	//         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
	//         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
	//             return data.mapDimension(dim);
	//         });
	//         var range = {};
	//         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
	//         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
	//         data.selectRange(range);
	//     });
	// });

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(254);
	
	var SeriesModel = __webpack_require__(233);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.scatter',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	  brushSelector: 'point',
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      // PENDING
	      return this.option.large ? 5e3 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      // PENDING
	      return this.option.large ? 1e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10,
	    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // cursor: null,
	    // label: {
	    // show: false
	    // distance: 5,
	    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
	    //           'inside'|'left'|'right'|'top'|'bottom'
	    // 默认使用全局文本样式，详见TEXTSTYLE
	    // },
	    itemStyle: {
	      opacity: 0.8 // color: 各异
	      // progressive: null
	
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var SymbolDraw = __webpack_require__(280);
	
	var LargeSymbolDraw = __webpack_require__(323);
	
	var pointsLayout = __webpack_require__(287);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendChartView({
	  type: 'scatter',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.updateData(data);
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.incrementalPrepareUpdate(data);
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
	    // PENDING
	
	    this.group.dirty();
	
	    if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) {
	      return {
	        update: true
	      };
	    } else {
	      var res = pointsLayout().reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._symbolDraw.updateLayout(data);
	    }
	  },
	  _updateSymbolDraw: function (data, seriesModel) {
	    var symbolDraw = this._symbolDraw;
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
	      symbolDraw && symbolDraw.remove();
	      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(symbolDraw.group);
	    return symbolDraw;
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(true);
	    this._symbolDraw = null;
	  },
	  dispose: function () {}
	});

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var IncrementalDisplayable = __webpack_require__(213);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	// TODO Batch by color
	var BOOST_SIZE_THRESHOLD = 4;
	var LargeSymbolPath = graphic.extendShape({
	  shape: {
	    points: null
	  },
	  symbolProxy: null,
	  buildPath: function (path, shape) {
	    var points = shape.points;
	    var size = shape.size;
	    var symbolProxy = this.symbolProxy;
	    var symbolProxyShape = symbolProxy.shape;
	    var ctx = path.getContext ? path.getContext() : path;
	    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
	
	    if (canBoost) {
	      return;
	    }
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      symbolProxyShape.x = x - size[0] / 2;
	      symbolProxyShape.y = y - size[1] / 2;
	      symbolProxyShape.width = size[0];
	      symbolProxyShape.height = size[1];
	      symbolProxy.buildPath(path, symbolProxyShape, true);
	    }
	  },
	  afterBrush: function (ctx) {
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var canBoost = size[0] < BOOST_SIZE_THRESHOLD;
	
	    if (!canBoost) {
	      return;
	    }
	
	    this.setTransform(ctx); // PENDING If style or other canvas status changed?
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      } // fillRect is faster than building a rect path and draw.
	      // And it support light globalCompositeOperation.
	
	
	      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
	    }
	
	    this.restoreTransform(ctx);
	  },
	  findDataIndex: function (x, y) {
	    // TODO ???
	    // Consider transform
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var w = Math.max(size[0], 4);
	    var h = Math.max(size[1], 4); // Not consider transform
	    // Treat each element as a rect
	    // top down traverse
	
	    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
	      var i = idx * 2;
	      var x0 = points[i] - w / 2;
	      var y0 = points[i + 1] - h / 2;
	
	      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
	        return idx;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeSymbolDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeSymbolProto = LargeSymbolDraw.prototype;
	
	largeSymbolProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	
	largeSymbolProto.updateData = function (data) {
	  this.group.removeAll();
	  var symbolEl = new LargeSymbolPath({
	    rectHover: true,
	    cursor: 'default'
	  });
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data);
	
	  this.group.add(symbolEl);
	  this._incremental = null;
	};
	
	largeSymbolProto.updateLayout = function (data) {
	  if (this._incremental) {
	    return;
	  }
	
	  var points = data.getLayout('symbolPoints');
	  this.group.eachChild(function (child) {
	    if (child.startIndex != null) {
	      var len = (child.endIndex - child.startIndex) * 2;
	      var byteOffset = child.startIndex * 4 * 2;
	      points = new Float32Array(points.buffer, byteOffset, len);
	    }
	
	    child.setShape('points', points);
	  });
	};
	
	largeSymbolProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
	  // PENDING Incremental data?
	
	
	  if (data.count() > 2e6) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	
	largeSymbolProto.incrementalUpdate = function (taskParams, data) {
	  var symbolEl;
	
	  if (this._incremental) {
	    symbolEl = new LargeSymbolPath();
	
	    this._incremental.addDisplayable(symbolEl, true);
	  } else {
	    symbolEl = new LargeSymbolPath({
	      rectHover: true,
	      cursor: 'default',
	      startIndex: taskParams.start,
	      endIndex: taskParams.end
	    });
	    symbolEl.incremental = true;
	    this.group.add(symbolEl);
	  }
	
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, !!this._incremental);
	};
	
	largeSymbolProto._setCommon = function (symbolEl, data, isIncremental) {
	  var hostModel = data.hostModel; // TODO
	  // if (data.hasItemVisual.symbolSize) {
	  //     // TODO typed array?
	  //     symbolEl.setShape('sizes', data.mapArray(
	  //         function (idx) {
	  //             var size = data.getItemVisual(idx, 'symbolSize');
	  //             return (size instanceof Array) ? size : [size, size];
	  //         }
	  //     ));
	  // }
	  // else {
	
	  var size = data.getVisual('symbolSize');
	  symbolEl.setShape('size', size instanceof Array ? size : [size, size]); // }
	  // Create symbolProxy to build path for each data
	
	  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	  symbolEl.setColor = symbolEl.symbolProxy.setColor;
	  var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
	  symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
	  hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    symbolEl.setColor(visualColor);
	  }
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    symbolEl.seriesIndex = hostModel.seriesIndex;
	    symbolEl.on('mousemove', function (e) {
	      symbolEl.dataIndex = null;
	      var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex >= 0) {
	        // Provide dataIndex for tooltip
	        symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
	      }
	    });
	  }
	};
	
	largeSymbolProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeSymbolProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeSymbolDraw;
	module.exports = _default;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(325);
	
	__webpack_require__(330);
	
	__webpack_require__(331);
	
	var dataColor = __webpack_require__(316);
	
	var visualSymbol = __webpack_require__(286);
	
	var radarLayout = __webpack_require__(332);
	
	var dataFilter = __webpack_require__(319);
	
	var backwardCompat = __webpack_require__(333);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Must use radar component
	echarts.registerVisual(dataColor('radar'));
	echarts.registerVisual(visualSymbol('radar', 'circle'));
	echarts.registerLayout(radarLayout);
	echarts.registerProcessor(dataFilter('radar'));
	echarts.registerPreprocessor(backwardCompat);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(326);
	
	__webpack_require__(328);
	
	__webpack_require__(329);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var IndicatorAxis = __webpack_require__(327);
	
	var IntervalScale = __webpack_require__(265);
	
	var numberUtil = __webpack_require__(218);
	
	var _axisHelper = __webpack_require__(261);
	
	var getScaleExtent = _axisHelper.getScaleExtent;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(228);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO clockwise
	function Radar(radarModel, ecModel, api) {
	  this._model = radarModel;
	  /**
	   * Radar dimensions
	   * @type {Array.<string>}
	   */
	
	  this.dimensions = [];
	  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	    var dim = 'indicator_' + idx;
	    var indicatorAxis = new IndicatorAxis(dim, new IntervalScale());
	    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	    indicatorAxis.model = indicatorModel;
	    indicatorModel.axis = indicatorAxis;
	    this.dimensions.push(dim);
	    return indicatorAxis;
	  }, this);
	  this.resize(radarModel, api);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cx;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cy;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r0;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.startAngle;
	}
	
	Radar.prototype.getIndicatorAxes = function () {
	  return this._indicatorAxes;
	};
	
	Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	};
	
	Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  var angle = indicatorAxis.angle;
	  var x = this.cx + coord * Math.cos(angle);
	  var y = this.cy - coord * Math.sin(angle);
	  return [x, y];
	};
	
	Radar.prototype.pointToData = function (pt) {
	  var dx = pt[0] - this.cx;
	  var dy = pt[1] - this.cy;
	  var radius = Math.sqrt(dx * dx + dy * dy);
	  dx /= radius;
	  dy /= radius;
	  var radian = Math.atan2(-dy, dx); // Find the closest angle
	  // FIXME index can calculated directly
	
	  var minRadianDiff = Infinity;
	  var closestAxis;
	  var closestAxisIdx = -1;
	
	  for (var i = 0; i < this._indicatorAxes.length; i++) {
	    var indicatorAxis = this._indicatorAxes[i];
	    var diff = Math.abs(radian - indicatorAxis.angle);
	
	    if (diff < minRadianDiff) {
	      closestAxis = indicatorAxis;
	      closestAxisIdx = i;
	      minRadianDiff = diff;
	    }
	  }
	
	  return [closestAxisIdx, +(closestAxis && closestAxis.coodToData(radius))];
	};
	
	Radar.prototype.resize = function (radarModel, api) {
	  var center = radarModel.get('center');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var viewSize = Math.min(viewWidth, viewHeight) / 2;
	  this.cx = numberUtil.parsePercent(center[0], viewWidth);
	  this.cy = numberUtil.parsePercent(center[1], viewHeight);
	  this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
	
	  var radius = radarModel.get('radius');
	
	  if (typeof radius === 'string' || typeof radius === 'number') {
	    radius = [0, radius];
	  }
	
	  this.r0 = numberUtil.parsePercent(radius[0], viewSize);
	  this.r = numberUtil.parsePercent(radius[1], viewSize);
	  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
	    indicatorAxis.setExtent(this.r0, this.r);
	    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	    indicatorAxis.angle = angle;
	  }, this);
	};
	
	Radar.prototype.update = function (ecModel, api) {
	  var indicatorAxes = this._indicatorAxes;
	  var radarModel = this._model;
	  zrUtil.each(indicatorAxes, function (indicatorAxis) {
	    indicatorAxis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	      return;
	    }
	
	    var data = radarSeries.getData();
	    zrUtil.each(indicatorAxes, function (indicatorAxis) {
	      indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
	    });
	  }, this);
	  var splitNumber = radarModel.get('splitNumber');
	
	  function increaseInterval(interval) {
	    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
	
	    var f = interval / exp10;
	
	    if (f === 2) {
	      f = 5;
	    } else {
	      // f is 2 or 5
	      f *= 2;
	    }
	
	    return f * exp10;
	  } // Force all the axis fixing the maxSplitNumber.
	
	
	  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
	    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    var axisModel = indicatorAxis.model;
	    var scale = indicatorAxis.scale;
	    var fixedMin = axisModel.getMin();
	    var fixedMax = axisModel.getMax();
	    var interval = scale.getInterval();
	
	    if (fixedMin != null && fixedMax != null) {
	      // User set min, max, divide to get new interval
	      scale.setExtent(+fixedMin, +fixedMax);
	      scale.setInterval((fixedMax - fixedMin) / splitNumber);
	    } else if (fixedMin != null) {
	      var max; // User set min, expand extent on the other side
	
	      do {
	        max = fixedMin + interval * splitNumber;
	        scale.setExtent(+fixedMin, max); // Interval must been set after extent
	        // FIXME
	
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
	    } else if (fixedMax != null) {
	      var min; // User set min, expand extent on the other side
	
	      do {
	        min = fixedMax - interval * splitNumber;
	        scale.setExtent(min, +fixedMax);
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
	    } else {
	      var nicedSplitNumber = scale.getTicks().length - 1;
	
	      if (nicedSplitNumber > splitNumber) {
	        interval = increaseInterval(interval);
	      } // PENDING
	
	
	      var center = Math.round((rawExtent[0] + rawExtent[1]) / 2 / interval) * interval;
	      var halfSplitNumber = Math.round(splitNumber / 2);
	      scale.setExtent(numberUtil.round(center - halfSplitNumber * interval), numberUtil.round(center + (splitNumber - halfSplitNumber) * interval));
	      scale.setInterval(interval);
	    }
	  });
	};
	/**
	 * Radar dimensions is based on the data
	 * @type {Array}
	 */
	
	
	Radar.dimensions = [];
	
	Radar.create = function (ecModel, api) {
	  var radarList = [];
	  ecModel.eachComponent('radar', function (radarModel) {
	    var radar = new Radar(radarModel, ecModel, api);
	    radarList.push(radar);
	    radarModel.coordinateSystem = radar;
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries) {
	    if (radarSeries.get('coordinateSystem') === 'radar') {
	      // Inject coordinate system
	      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	    }
	  });
	  return radarList;
	};
	
	CoordinateSystem.register('radar', Radar);
	var _default = Radar;
	module.exports = _default;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Axis = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function IndicatorAxis(dim, scale, radiusExtent) {
	  Axis.call(this, dim, scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'value';
	  this.angle = 0;
	  /**
	   * Indicator name
	   * @type {string}
	   */
	
	  this.name = '';
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.model;
	}
	
	zrUtil.inherits(IndicatorAxis, Axis);
	var _default = IndicatorAxis;
	module.exports = _default;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var axisDefault = __webpack_require__(297);
	
	var Model = __webpack_require__(174);
	
	var axisModelCommonMixin = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var valueAxisDefault = axisDefault.valueAxis;
	
	function defaultsShow(opt, show) {
	  return zrUtil.defaults({
	    show: show
	  }, opt);
	}
	
	var RadarModel = echarts.extendComponentModel({
	  type: 'radar',
	  optionUpdated: function () {
	    var boundaryGap = this.get('boundaryGap');
	    var splitNumber = this.get('splitNumber');
	    var scale = this.get('scale');
	    var axisLine = this.get('axisLine');
	    var axisTick = this.get('axisTick');
	    var axisLabel = this.get('axisLabel');
	    var nameTextStyle = this.get('name');
	    var showName = this.get('name.show');
	    var nameFormatter = this.get('name.formatter');
	    var nameGap = this.get('nameGap');
	    var triggerEvent = this.get('triggerEvent');
	    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
	      // PENDING
	      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	        indicatorOpt.min = 0;
	      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	        indicatorOpt.max = 0;
	      }
	
	      var iNameTextStyle = nameTextStyle;
	
	      if (indicatorOpt.color != null) {
	        iNameTextStyle = zrUtil.defaults({
	          color: indicatorOpt.color
	        }, nameTextStyle);
	      } // Use same configuration
	
	
	      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
	        boundaryGap: boundaryGap,
	        splitNumber: splitNumber,
	        scale: scale,
	        axisLine: axisLine,
	        axisTick: axisTick,
	        axisLabel: axisLabel,
	        // Competitable with 2 and use text
	        name: indicatorOpt.text,
	        nameLocation: 'end',
	        nameGap: nameGap,
	        // min: 0,
	        nameTextStyle: iNameTextStyle,
	        triggerEvent: triggerEvent
	      }, false);
	
	      if (!showName) {
	        indicatorOpt.name = '';
	      }
	
	      if (typeof nameFormatter === 'string') {
	        var indName = indicatorOpt.name;
	        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	      } else if (typeof nameFormatter === 'function') {
	        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
	      }
	
	      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.
	
	      model.mainType = 'radar';
	      model.componentIndex = this.componentIndex;
	      return model;
	    }, this);
	
	    this.getIndicatorModels = function () {
	      return indicatorModels;
	    };
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '75%',
	    startAngle: 90,
	    name: {
	      show: true // formatter: null
	      // textStyle: {}
	
	    },
	    boundaryGap: [0, 0],
	    splitNumber: 5,
	    nameGap: 15,
	    scale: false,
	    // Polygon or circle
	    shape: 'polygon',
	    axisLine: zrUtil.merge({
	      lineStyle: {
	        color: '#bbb'
	      }
	    }, valueAxisDefault.axisLine),
	    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	    // {text, min, max}
	    indicator: []
	  }
	});
	var _default = RadarModel;
	module.exports = _default;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var AxisBuilder = __webpack_require__(300);
	
	var graphic = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	
	var _default = echarts.extendComponentView({
	  type: 'radar',
	  render: function (radarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	
	    this._buildAxes(radarModel);
	
	    this._buildSplitLineAndArea(radarModel);
	  },
	  _buildAxes: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
	      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	        position: [radar.cx, radar.cy],
	        rotation: indicatorAxis.angle,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1
	      });
	      return axisBuilder;
	    });
	    zrUtil.each(axisBuilders, function (axisBuilder) {
	      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	      this.group.add(axisBuilder.getGroup());
	    }, this);
	  },
	  _buildSplitLineAndArea: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	
	    if (!indicatorAxes.length) {
	      return;
	    }
	
	    var shape = radarModel.get('shape');
	    var splitLineModel = radarModel.getModel('splitLine');
	    var splitAreaModel = radarModel.getModel('splitArea');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var showSplitLine = splitLineModel.get('show');
	    var showSplitArea = splitAreaModel.get('show');
	    var splitLineColors = lineStyleModel.get('color');
	    var splitAreaColors = areaStyleModel.get('color');
	    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	    var splitLines = [];
	    var splitAreas = [];
	
	    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	      var colorIndex = idx % areaOrLineColorList.length;
	      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	      return colorIndex;
	    }
	
	    if (shape === 'circle') {
	      var ticksRadius = indicatorAxes[0].getTicksCoords();
	      var cx = radar.cx;
	      var cy = radar.cy;
	
	      for (var i = 0; i < ticksRadius.length; i++) {
	        if (showSplitLine) {
	          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	          splitLines[colorIndex].push(new graphic.Circle({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r: ticksRadius[i].coord
	            }
	          }));
	        }
	
	        if (showSplitArea && i < ticksRadius.length - 1) {
	          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
	          splitAreas[colorIndex].push(new graphic.Ring({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r0: ticksRadius[i].coord,
	              r: ticksRadius[i + 1].coord
	            }
	          }));
	        }
	      }
	    } // Polyyon
	    else {
	        var realSplitNumber;
	        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
	          var ticksCoords = indicatorAxis.getTicksCoords();
	          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
	          return zrUtil.map(ticksCoords, function (tickCoord) {
	            return radar.coordToPoint(tickCoord.coord, idx);
	          });
	        });
	        var prevPoints = [];
	
	        for (var i = 0; i <= realSplitNumber; i++) {
	          var points = [];
	
	          for (var j = 0; j < indicatorAxes.length; j++) {
	            points.push(axesTicksPoints[j][i]);
	          } // Close
	
	
	          if (points[0]) {
	            points.push(points[0].slice());
	          } else {}
	
	          if (showSplitLine) {
	            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	            splitLines[colorIndex].push(new graphic.Polyline({
	              shape: {
	                points: points
	              }
	            }));
	          }
	
	          if (showSplitArea && prevPoints) {
	            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
	            splitAreas[colorIndex].push(new graphic.Polygon({
	              shape: {
	                points: points.concat(prevPoints)
	              }
	            }));
	          }
	
	          prevPoints = points.slice().reverse();
	        }
	      }
	
	    var lineStyle = lineStyleModel.getLineStyle();
	    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	    zrUtil.each(splitAreas, function (splitAreas, idx) {
	      this.group.add(graphic.mergePath(splitAreas, {
	        style: zrUtil.defaults({
	          stroke: 'none',
	          fill: splitAreaColors[idx % splitAreaColors.length]
	        }, areaStyle),
	        silent: true
	      }));
	    }, this);
	    zrUtil.each(splitLines, function (splitLines, idx) {
	      this.group.add(graphic.mergePath(splitLines, {
	        style: zrUtil.defaults({
	          fill: 'none',
	          stroke: splitLineColors[idx % splitLineColors.length]
	        }, lineStyle),
	        silent: true
	      }));
	    }, this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(233);
	
	var createListSimply = __webpack_require__(312);
	
	var zrUtil = __webpack_require__(134);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var RadarSeries = SeriesModel.extend({
	  type: 'series.radar',
	  dependencies: ['radar'],
	  // Overwrite
	  init: function (option) {
	    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      generateCoord: 'indicator_',
	      generateCoordCount: Infinity
	    });
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var coordSys = this.coordinateSystem;
	    var indicatorAxes = coordSys.getIndicatorAxes();
	    var name = this.getData().getName(dataIndex);
	    return encodeHTML(name === '' ? this.name : name) + '<br/>' + zrUtil.map(indicatorAxes, function (axis, idx) {
	      var val = data.get(data.mapDimension(axis.dim), dataIndex);
	      return encodeHTML(axis.name + ' : ' + val);
	    }).join('<br />');
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'radar',
	    legendHoverLink: true,
	    radarIndex: 0,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    label: {
	      position: 'top'
	    },
	    // areaStyle: {
	    // },
	    // itemStyle: {}
	    symbol: 'emptyCircle',
	    symbolSize: 4 // symbolRotate: null
	
	  }
	});
	var _default = RadarSeries;
	module.exports = _default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var graphic = __webpack_require__(180);
	
	var zrUtil = __webpack_require__(134);
	
	var symbolUtil = __webpack_require__(271);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	var _default = echarts.extendChartView({
	  type: 'radar',
	  render: function (seriesModel, ecModel, api) {
	    var polar = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	
	    function createSymbol(data, idx) {
	      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	      var color = data.getItemVisual(idx, 'color');
	
	      if (symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
	      symbolPath.attr({
	        style: {
	          strokeNoScale: true
	        },
	        z2: 100,
	        scale: [symbolSize[0] / 2, symbolSize[1] / 2]
	      });
	      return symbolPath;
	    }
	
	    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	      // Simply rerender all
	      symbolGroup.removeAll();
	
	      for (var i = 0; i < newPoints.length - 1; i++) {
	        var symbolPath = createSymbol(data, idx);
	
	        if (symbolPath) {
	          symbolPath.__dimIdx = i;
	
	          if (oldPoints[i]) {
	            symbolPath.attr('position', oldPoints[i]);
	            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	              position: newPoints[i]
	            }, seriesModel, idx);
	          } else {
	            symbolPath.attr('position', newPoints[i]);
	          }
	
	          symbolGroup.add(symbolPath);
	        }
	      }
	    }
	
	    function getInitialPoints(points) {
	      return zrUtil.map(points, function (pt) {
	        return [polar.cx, polar.cy];
	      });
	    }
	
	    data.diff(oldData).add(function (idx) {
	      var points = data.getItemLayout(idx);
	
	      if (!points) {
	        return;
	      }
	
	      var polygon = new graphic.Polygon();
	      var polyline = new graphic.Polyline();
	      var target = {
	        shape: {
	          points: points
	        }
	      };
	      polygon.shape.points = getInitialPoints(points);
	      polyline.shape.points = getInitialPoints(points);
	      graphic.initProps(polygon, target, seriesModel, idx);
	      graphic.initProps(polyline, target, seriesModel, idx);
	      var itemGroup = new graphic.Group();
	      var symbolGroup = new graphic.Group();
	      itemGroup.add(polyline);
	      itemGroup.add(polygon);
	      itemGroup.add(symbolGroup);
	      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	      data.setItemGraphicEl(idx, itemGroup);
	    }).update(function (newIdx, oldIdx) {
	      var itemGroup = oldData.getItemGraphicEl(oldIdx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var target = {
	        shape: {
	          points: data.getItemLayout(newIdx)
	        }
	      };
	
	      if (!target.shape.points) {
	        return;
	      }
	
	      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	      graphic.updateProps(polyline, target, seriesModel);
	      graphic.updateProps(polygon, target, seriesModel);
	      data.setItemGraphicEl(newIdx, itemGroup);
	    }).remove(function (idx) {
	      group.remove(oldData.getItemGraphicEl(idx));
	    }).execute();
	    data.eachItemGraphicEl(function (itemGroup, idx) {
	      var itemModel = data.getItemModel(idx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var color = data.getItemVisual(idx, 'color');
	      group.add(itemGroup);
	      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
	        fill: 'none',
	        stroke: color
	      }));
	      polyline.hoverStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	      var areaStyleModel = itemModel.getModel('areaStyle');
	      var hoverAreaStyleModel = itemModel.getModel('emphasis.areaStyle');
	      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
	      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
	      polygon.ignore = polygonIgnore;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: color,
	        opacity: 0.7
	      }));
	      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
	      var itemStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	      var itemHoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      symbolGroup.eachChild(function (symbolPath) {
	        symbolPath.setStyle(itemStyle);
	        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
	        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          labelDimIndex: symbolPath.__dimIdx,
	          defaultText: data.get(data.dimensions[symbolPath.__dimIdx], idx),
	          autoColor: color,
	          isRectText: true
	        });
	      });
	
	      function onEmphasis() {
	        polygon.attr('ignore', hoverPolygonIgnore);
	      }
	
	      function onNormal() {
	        polygon.attr('ignore', polygonIgnore);
	      }
	
	      itemGroup.off('mouseover').off('mouseout').off('normal').off('emphasis');
	      itemGroup.on('emphasis', onEmphasis).on('mouseover', onEmphasis).on('normal', onNormal).on('mouseout', onNormal);
	      graphic.setHoverStyle(itemGroup);
	    });
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('radar', function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    function pointsConverter(val, idx) {
	      points[idx] = points[idx] || [];
	      points[idx][i] = coordSys.dataToPoint(val, i);
	    }
	
	    var axes = coordSys.getIndicatorAxes();
	
	    for (var i = 0; i < axes.length; i++) {
	      data.each(data.mapDimension(axes[i].dim), pointsConverter);
	    }
	
	    data.each(function (idx) {
	      // Close polygon
	      points[idx][0] && points[idx].push(points[idx][0].slice());
	      data.setItemLayout(idx, points[idx]);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Backward compat for radar chart in 2
	function _default(option) {
	  var polarOptArr = option.polar;
	
	  if (polarOptArr) {
	    if (!zrUtil.isArray(polarOptArr)) {
	      polarOptArr = [polarOptArr];
	    }
	
	    var polarNotRadar = [];
	    zrUtil.each(polarOptArr, function (polarOpt, idx) {
	      if (polarOpt.indicator) {
	        if (polarOpt.type && !polarOpt.shape) {
	          polarOpt.shape = polarOpt.type;
	        }
	
	        option.radar = option.radar || [];
	
	        if (!zrUtil.isArray(option.radar)) {
	          option.radar = [option.radar];
	        }
	
	        option.radar.push(polarOpt);
	      } else {
	        polarNotRadar.push(polarOpt);
	      }
	    });
	    option.polar = polarNotRadar;
	  }
	
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	      seriesOpt.radarIndex = seriesOpt.polarIndex;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(335);
	
	__webpack_require__(343);
	
	__webpack_require__(349);
	
	__webpack_require__(351);
	
	var mapSymbolLayout = __webpack_require__(354);
	
	var mapVisual = __webpack_require__(355);
	
	var mapDataStatistic = __webpack_require__(356);
	
	var backwardCompat = __webpack_require__(357);
	
	var createDataSelectAction = __webpack_require__(315);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(mapSymbolLayout);
	echarts.registerVisual(mapVisual);
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	echarts.registerPreprocessor(backwardCompat);
	createDataSelectAction('map', [{
	  type: 'mapToggleSelect',
	  event: 'mapselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'mapSelect',
	  event: 'mapselected',
	  method: 'select'
	}, {
	  type: 'mapUnSelect',
	  event: 'mapunselected',
	  method: 'unSelect'
	}]);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var createListSimply = __webpack_require__(312);
	
	var SeriesModel = __webpack_require__(233);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var dataSelectableMixin = __webpack_require__(313);
	
	var _dataProvider = __webpack_require__(235);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var geoSourceManager = __webpack_require__(336);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MapSeries = SeriesModel.extend({
	  type: 'series.map',
	  dependencies: ['geo'],
	  layoutMode: 'box',
	
	  /**
	   * Only first map series of same mapType will drawMap
	   * @type {boolean}
	   */
	  needsDrawMap: false,
	
	  /**
	   * Group of all map series with same mapType
	   * @type {boolean}
	   */
	  seriesGroup: [],
	  getInitialData: function (option) {
	    var data = createListSimply(this, ['value']);
	    var valueDim = data.mapDimension('value');
	    var dataNameMap = zrUtil.createHashMap();
	    var selectTargetList = [];
	    var toAppendNames = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      var name = data.getName(i);
	      dataNameMap.set(name, true);
	      selectTargetList.push({
	        name: name,
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap);
	    zrUtil.each(geoSource.regions, function (region) {
	      var name = region.name;
	
	      if (!dataNameMap.get(name)) {
	        selectTargetList.push({
	          name: name
	        });
	        toAppendNames.push(name);
	      }
	    });
	    this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
	    // map and render) can not be performed without a "full data". For example,
	    // find `dataIndex` by name.
	
	    data.appendValues([], toAppendNames);
	    return data;
	  },
	
	  /**
	   * If no host geo model, return null, which means using a
	   * inner exclusive geo model.
	   */
	  getHostGeoModel: function () {
	    var geoIndex = this.option.geoIndex;
	    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
	  },
	  getMapType: function () {
	    return (this.getHostGeoModel() || this).option.map;
	  },
	  // _fillOption: function (option, mapName) {
	  // Shallow clone
	  // option = zrUtil.extend({}, option);
	  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
	  // return option;
	  // },
	  getRawValue: function (dataIndex) {
	    // Use value stored in data instead because it is calculated from multiple series
	    // FIXME Provide all value of multiple series ?
	    var data = this.getData();
	    return data.get(data.mapDimension('value'), dataIndex);
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (regionName) {
	    var data = this.getData();
	    return data.getItemModel(data.indexOfName(regionName));
	  },
	
	  /**
	   * Map tooltip formatter
	   *
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    // FIXME orignalData and data is a bit confusing
	    var data = this.getData();
	    var formattedValue = addCommas(this.getRawValue(dataIndex));
	    var name = data.getName(dataIndex);
	    var seriesGroup = this.seriesGroup;
	    var seriesNames = [];
	
	    for (var i = 0; i < seriesGroup.length; i++) {
	      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	      var valueDim = data.mapDimension('value');
	
	      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
	        seriesNames.push(encodeHTML(seriesGroup[i].name));
	      }
	    }
	
	    return seriesNames.join(', ') + '<br />' + encodeHTML(name + ' : ' + formattedValue);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var name = this.getData().getName(dataIndex);
	      var geo = this.coordinateSystem;
	      var region = geo.getRegion(name);
	      return region && geo.dataToPoint(region.center);
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 2,
	    coordinateSystem: 'geo',
	    // map should be explicitly specified since ec3.
	    map: '',
	    // If `geoIndex` is not specified, a exclusive geo will be
	    // created. Otherwise use the specified geo component, and
	    // `map` and `mapType` are ignored.
	    // geoIndex: 0,
	    // 'center' | 'left' | 'right' | 'x%' | {number}
	    left: 'center',
	    // 'center' | 'top' | 'bottom' | 'x%' | {number}
	    top: 'center',
	    // right
	    // bottom
	    // width:
	    // height
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    // 数值合并方式，默认加和，可选为：
	    // 'sum' | 'average' | 'max' | 'min'
	    // mapValueCalculation: 'sum',
	    // 地图数值计算结果小数精度
	    // mapValuePrecision: 0,
	    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
	    showLegendSymbol: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    dataRangeHoverLink: true,
	    // 是否开启缩放及漫游模式
	    // roam: false,
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ],
	    // higher priority than center and zoom
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    label: {
	      show: false,
	      color: '#000'
	    },
	    // scaleLimit: null,
	    itemStyle: {
	      borderWidth: 0.5,
	      borderColor: '#444',
	      areaColor: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        areaColor: 'rgba(255,215,0,0.8)'
	      }
	    }
	  }
	});
	zrUtil.mixin(MapSeries, dataSelectableMixin);
	var _default = MapSeries;
	module.exports = _default;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var mapDataStorage = __webpack_require__(249);
	
	var geoJSONLoader = __webpack_require__(337);
	
	var geoSVGLoader = __webpack_require__(342);
	
	var BoundingRect = __webpack_require__(154);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var loaders = {
	  geoJSON: geoJSONLoader,
	  svg: geoSVGLoader
	};
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} nameMap
	   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
	   */
	  load: function (mapName, nameMap) {
	    var regions = [];
	    var regionsMap = createHashMap();
	    var nameCoordMap = createHashMap();
	    var boundingRect;
	    var mapRecords = retrieveMap(mapName);
	    each(mapRecords, function (record) {
	      var singleSource = loaders[record.type].load(mapName, record);
	      each(singleSource.regions, function (region) {
	        var regionName = region.name; // Try use the alias in geoNameMap
	
	        if (nameMap && nameMap.hasOwnProperty(regionName)) {
	          region = region.cloneShallow(regionName = nameMap[regionName]);
	        }
	
	        regions.push(region);
	        regionsMap.set(regionName, region);
	        nameCoordMap.set(regionName, region.center);
	      });
	      var rect = singleSource.boundingRect;
	
	      if (rect) {
	        boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
	      }
	    });
	    return {
	      regions: regions,
	      regionsMap: regionsMap,
	      nameCoordMap: nameCoordMap,
	      // FIXME Always return new ?
	      boundingRect: boundingRect || new BoundingRect(0, 0, 0, 0)
	    };
	  },
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   * @return {Array.<module:zrender/Element>} Roots.
	   */
	  makeGraphic: makeInvoker('makeGraphic'),
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   */
	  removeGraphic: makeInvoker('removeGraphic')
	};
	
	function makeInvoker(methodName) {
	  return function (mapName, hostKey) {
	    var mapRecords = retrieveMap(mapName);
	    var results = [];
	    each(mapRecords, function (record) {
	      var method = loaders[record.type][methodName];
	      method && results.push(method(mapName, record, hostKey));
	    });
	    return results;
	  };
	}
	
	function mapNotExistsError(mapName) {}
	
	function retrieveMap(mapName) {
	  var mapRecords = mapDataStorage.retrieveMap(mapName) || [];
	  return mapRecords;
	}
	
	module.exports = _default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	
	var parseGeoJson = __webpack_require__(272);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	var fixNanhai = __webpack_require__(338);
	
	var fixTextCoord = __webpack_require__(339);
	
	var fixGeoCoord = __webpack_require__(340);
	
	var fixDiaoyuIsland = __webpack_require__(341);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Built-in GEO fixer.
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @return {Object} {regions, boundingRect}
	   */
	  load: function (mapName, mapRecord) {
	    var parsed = inner(mapRecord).parsed;
	
	    if (parsed) {
	      return parsed;
	    }
	
	    var specialAreas = mapRecord.specialAreas || {};
	    var geoJSON = mapRecord.geoJSON;
	    var regions; // https://jsperf.com/try-catch-performance-overhead
	
	    try {
	      regions = geoJSON ? parseGeoJson(geoJSON) : [];
	    } catch (e) {
	      throw new Error('Invalid geoJson format\n' + e.message);
	    }
	
	    each(regions, function (region) {
	      var regionName = region.name;
	      fixTextCoord(mapName, region);
	      fixGeoCoord(mapName, region);
	      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
	      // to look better
	
	      var specialArea = specialAreas[regionName];
	
	      if (specialArea) {
	        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	      }
	    });
	    fixNanhai(mapName, regions);
	    return inner(mapRecord).parsed = {
	      regions: regions,
	      boundingRect: getBoundingRect(regions)
	    };
	  }
	};
	
	function getBoundingRect(regions) {
	  var rect;
	
	  for (var i = 0; i < regions.length; i++) {
	    var regionRect = regions[i].getBoundingRect();
	    rect = rect || regionRect.clone();
	    rect.union(regionRect);
	  }
	
	  return rect;
	}
	
	module.exports = _default;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Region = __webpack_require__(273);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 南海诸岛
	var geoCoord = [126, 25];
	var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	for (var i = 0; i < points.length; i++) {
	  for (var k = 0; k < points[i].length; k++) {
	    points[i][k][0] /= 10.5;
	    points[i][k][1] /= -10.5 / 0.75;
	    points[i][k][0] += geoCoord[0];
	    points[i][k][1] += geoCoord[1];
	  }
	}
	
	function _default(mapType, regions) {
	  if (mapType === 'china') {
	    regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
	      return {
	        type: 'polygon',
	        exterior: exterior
	      };
	    }), geoCoord));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordsOffsetMap = {
	  '南海诸岛': [32, 80],
	  // 全国
	  '广东': [0, -10],
	  '香港': [10, 5],
	  '澳门': [-10, 10],
	  //'北京': [-10, 0],
	  '天津': [5, 5]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'china') {
	    var coordFix = coordsOffsetMap[region.name];
	
	    if (coordFix) {
	      var cp = region.center;
	      cp[0] += coordFix[0] / 10.5;
	      cp[1] += -coordFix[1] / (10.5 / 0.75);
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var geoCoordMap = {
	  'Russia': [100, 60],
	  'United States': [-99, 38],
	  'United States of America': [-99, 38]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'world') {
	    var geoCoord = geoCoordMap[region.name];
	
	    if (geoCoord) {
	      var cp = region.center;
	      cp[0] = geoCoord[0];
	      cp[1] = geoCoord[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 钓鱼岛
	// var Region = require('../Region');
	// var zrUtil = require('zrender/src/core/util');
	// var geoCoord = [126, 25];
	var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	
	function _default(mapType, region) {
	  if (mapType === 'china' && region.name === '台湾') {
	    region.geometries.push({
	      type: 'polygon',
	      exterior: points[0]
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _parseSVG = __webpack_require__(250);
	
	var parseSVG = _parseSVG.parseSVG;
	var makeViewBoxTransform = _parseSVG.makeViewBoxTransform;
	
	var Group = __webpack_require__(142);
	
	var Rect = __webpack_require__(204);
	
	var _util = __webpack_require__(134);
	
	var assert = _util.assert;
	var createHashMap = _util.createHashMap;
	
	var BoundingRect = __webpack_require__(154);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @return {Object} {root, boundingRect}
	   */
	  load: function (mapName, mapRecord) {
	    var originRoot = inner(mapRecord).originRoot;
	
	    if (originRoot) {
	      return {
	        root: originRoot,
	        boundingRect: inner(mapRecord).boundingRect
	      };
	    }
	
	    var graphic = buildGraphic(mapRecord);
	    inner(mapRecord).originRoot = graphic.root;
	    inner(mapRecord).boundingRect = graphic.boundingRect;
	    return graphic;
	  },
	  makeGraphic: function (mapName, mapRecord, hostKey) {
	    // For performance consideration (in large SVG), graphic only maked
	    // when necessary and reuse them according to hostKey.
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap || (field.rootMap = createHashMap());
	    var root = rootMap.get(hostKey);
	
	    if (root) {
	      return root;
	    }
	
	    var originRoot = field.originRoot;
	    var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
	    // assign it to a view, but not reproduce graphic elements.
	
	    if (!field.originRootHostKey) {
	      field.originRootHostKey = hostKey;
	      root = originRoot;
	    } else {
	      root = buildGraphic(mapRecord, boundingRect).root;
	    }
	
	    return rootMap.set(hostKey, root);
	  },
	  removeGraphic: function (mapName, mapRecord, hostKey) {
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap;
	    rootMap && rootMap.removeKey(hostKey);
	
	    if (hostKey === field.originRootHostKey) {
	      field.originRootHostKey = null;
	    }
	  }
	};
	
	function buildGraphic(mapRecord, boundingRect) {
	  var svgXML = mapRecord.svgXML;
	  var result;
	  var root;
	
	  try {
	    result = svgXML && parseSVG(svgXML, {
	      ignoreViewBox: true,
	      ignoreRootClip: true
	    }) || {};
	    root = result.root;
	    assert(root != null);
	  } catch (e) {
	    throw new Error('Invalid svg format\n' + e.message);
	  }
	
	  var svgWidth = result.width;
	  var svgHeight = result.height;
	  var viewBoxRect = result.viewBoxRect;
	
	  if (!boundingRect) {
	    boundingRect = svgWidth == null || svgHeight == null ? // If svg width / height not specified, calculate
	    // bounding rect as the width / height
	    root.getBoundingRect() : new BoundingRect(0, 0, 0, 0);
	
	    if (svgWidth != null) {
	      boundingRect.width = svgWidth;
	    }
	
	    if (svgHeight != null) {
	      boundingRect.height = svgHeight;
	    }
	  }
	
	  if (viewBoxRect) {
	    var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
	    var elRoot = root;
	    root = new Group();
	    root.add(elRoot);
	    elRoot.scale = viewBoxTransform.scale;
	    elRoot.position = viewBoxTransform.position;
	  }
	
	  root.setClipPath(new Rect({
	    shape: boundingRect.plain()
	  }));
	  return {
	    root: root,
	    boundingRect: boundingRect
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var MapDraw = __webpack_require__(344);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var HIGH_DOWN_PROP = '__seriesMapHighDown';
	var RECORD_VERSION_PROP = '__seriesMapCallKey';
	
	var _default = echarts.extendChartView({
	  type: 'map',
	  render: function (mapModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var group = this.group;
	    group.removeAll();
	
	    if (mapModel.getHostGeoModel()) {
	      return;
	    } // Not update map if it is an roam action from self
	
	
	    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	      if (mapModel.needsDrawMap) {
	        var mapDraw = this._mapDraw || new MapDraw(api, true);
	        group.add(mapDraw.group);
	        mapDraw.draw(mapModel, ecModel, api, this, payload);
	        this._mapDraw = mapDraw;
	      } else {
	        // Remove drawed map
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      }
	    } else {
	      var mapDraw = this._mapDraw;
	      mapDraw && group.add(mapDraw.group);
	    }
	
	    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	  },
	  remove: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	    this.group.removeAll();
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	  },
	  _renderSymbols: function (mapModel, ecModel, api) {
	    var originalData = mapModel.originalData;
	    var group = this.group;
	    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      var layout = originalData.getItemLayout(originalDataIndex);
	
	      if (!layout || !layout.point) {
	        // Not exists in map
	        return;
	      }
	
	      var point = layout.point;
	      var offset = layout.offset;
	      var circle = new graphic.Circle({
	        style: {
	          // Because the special of map draw.
	          // Which needs statistic of multiple series and draw on one map.
	          // And each series also need a symbol with legend color
	          //
	          // Layout and visual are put one the different data
	          fill: mapModel.getData().getVisual('color')
	        },
	        shape: {
	          cx: point[0] + offset * 9,
	          cy: point[1],
	          r: 3
	        },
	        silent: true,
	        // Do not overlap the first series, on which labels are displayed.
	        z2: 8 + (!offset ? graphic.Z2_EMPHASIS_LIFT + 1 : 0)
	      }); // Only the series that has the first value on the same region is in charge of rendering the label.
	      // But consider the case:
	      // series: [
	      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
	      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
	      // ]
	      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
	      // For backward compatibility, we follow the rule that render label `A` by the
	      // settings on series `X` but render label `C` by the settings on series `Y`.
	
	      if (!offset) {
	        var fullData = mapModel.mainSeries.getData();
	        var name = originalData.getName(originalDataIndex);
	        var fullIndex = fullData.indexOfName(name);
	        var itemModel = originalData.getItemModel(originalDataIndex);
	        var labelModel = itemModel.getModel('label');
	        var hoverLabelModel = itemModel.getModel('emphasis.label');
	        var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
	        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
	        // FIXME
	        // If this is not the `mainSeries`, the item model (like label formatter)
	        // set on original data item will never get. But it has been working
	        // like that from the begining, and this scenario is rarely encountered.
	        // So it won't be fixed until have to.
	
	        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'normal'), name);
	        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'emphasis'), normalText);
	        var highDownRecord = regionGroup[HIGH_DOWN_PROP];
	        var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.
	
	        if (!highDownRecord) {
	          highDownRecord = regionGroup[HIGH_DOWN_PROP] = {};
	          var onEmphasis = zrUtil.curry(onRegionHighDown, true);
	          var onNormal = zrUtil.curry(onRegionHighDown, false);
	          regionGroup.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	        } // Prevent removed regions effect current grapics.
	
	
	        regionGroup[RECORD_VERSION_PROP] = recordVersion;
	        zrUtil.extend(highDownRecord, {
	          recordVersion: recordVersion,
	          circle: circle,
	          labelModel: labelModel,
	          hoverLabelModel: hoverLabelModel,
	          emphasisText: emphasisText,
	          normalText: normalText
	        }); // FIXME
	        // Consider set option when emphasis.
	
	        enterRegionHighDown(highDownRecord, false);
	      }
	
	      group.add(circle);
	    });
	  }
	});
	
	function onRegionHighDown(toHighOrDown) {
	  var highDownRecord = this[HIGH_DOWN_PROP];
	
	  if (highDownRecord && highDownRecord.recordVersion === this[RECORD_VERSION_PROP]) {
	    enterRegionHighDown(highDownRecord, toHighOrDown);
	  }
	}
	
	function enterRegionHighDown(highDownRecord, toHighOrDown) {
	  var circle = highDownRecord.circle;
	  var labelModel = highDownRecord.labelModel;
	  var hoverLabelModel = highDownRecord.hoverLabelModel;
	  var emphasisText = highDownRecord.emphasisText;
	  var normalText = highDownRecord.normalText;
	
	  if (toHighOrDown) {
	    circle.style.extendFrom(graphic.setTextStyle({}, hoverLabelModel, {
	      text: hoverLabelModel.get('show') ? emphasisText : null
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }, true)); // Make label upper than others if overlaps.
	
	    circle.__mapOriginalZ2 = circle.z2;
	    circle.z2 += graphic.Z2_EMPHASIS_LIFT;
	  } else {
	    graphic.setTextStyle(circle.style, labelModel, {
	      text: labelModel.get('show') ? normalText : null,
	      textPosition: labelModel.getShallow('position') || 'bottom'
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }); // Trigger normalize style like padding.
	
	    circle.dirty(false);
	
	    if (circle.__mapOriginalZ2 != null) {
	      circle.z2 = circle.__mapOriginalZ2;
	      circle.__mapOriginalZ2 = null;
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var RoamController = __webpack_require__(345);
	
	var roamHelper = __webpack_require__(347);
	
	var _cursorHelper = __webpack_require__(348);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(180);
	
	var geoSourceManager = __webpack_require__(336);
	
	var _component = __webpack_require__(216);
	
	var getUID = _component.getUID;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getFixedItemStyle(model, scale) {
	  var itemStyle = model.getItemStyle();
	  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	  // they should both set areaColor and color to be null.
	
	  if (areaColor != null) {
	    itemStyle.fill = areaColor;
	  }
	
	  return itemStyle;
	}
	
	function updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
	  regionsGroup.off('click');
	  regionsGroup.off('mousedown');
	
	  if (mapOrGeoModel.get('selectedMode')) {
	    regionsGroup.on('mousedown', function () {
	      mapDraw._mouseDownFlag = true;
	    });
	    regionsGroup.on('click', function (e) {
	      if (!mapDraw._mouseDownFlag) {
	        return;
	      }
	
	      mapDraw._mouseDownFlag = false;
	      var el = e.target;
	
	      while (!el.__regions) {
	        el = el.parent;
	      }
	
	      if (!el) {
	        return;
	      }
	
	      var action = {
	        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
	        batch: zrUtil.map(el.__regions, function (region) {
	          return {
	            name: region.name,
	            from: fromView.uid
	          };
	        })
	      };
	      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
	      api.dispatchAction(action);
	      updateMapSelected(mapOrGeoModel, regionsGroup);
	    });
	  }
	}
	
	function updateMapSelected(mapOrGeoModel, regionsGroup) {
	  // FIXME
	  regionsGroup.eachChild(function (otherRegionEl) {
	    zrUtil.each(otherRegionEl.__regions, function (region) {
	      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
	    });
	  });
	}
	/**
	 * @alias module:echarts/component/helper/MapDraw
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {boolean} updateGroup
	 */
	
	
	function MapDraw(api, updateGroup) {
	  var group = new graphic.Group();
	  /**
	   * @type {string}
	   * @private
	   */
	
	  this.uid = getUID('ec_map_draw');
	  /**
	   * @type {module:echarts/component/helper/RoamController}
	   * @private
	   */
	
	  this._controller = new RoamController(api.getZr());
	  /**
	   * @type {Object} {target, zoom, zoomLimit}
	   * @private
	   */
	
	  this._controllerHost = {
	    target: updateGroup ? group : null
	  };
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = group;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._updateGroup = updateGroup;
	  /**
	   * This flag is used to make sure that only one among
	   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
	   * action may be triggered when `pan`, which is unexpected.
	   * @type {booelan}
	   */
	
	  this._mouseDownFlag;
	  /**
	   * @type {string}
	   */
	
	  this._mapName;
	  /**
	   * @type {boolean}
	   */
	
	  this._initialized;
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._regionsGroup = new graphic.Group());
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._backgroundGroup = new graphic.Group());
	}
	
	MapDraw.prototype = {
	  constructor: MapDraw,
	  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
	    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	    // will be assigned with map data. Other GEO model has no data.
	
	    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	    isGeo && ecModel.eachComponent({
	      mainType: 'series',
	      subType: 'map'
	    }, function (mapSeries) {
	      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	        data = mapSeries.getData();
	      }
	    });
	    var geo = mapOrGeoModel.coordinateSystem;
	
	    this._updateBackground(geo);
	
	    var regionsGroup = this._regionsGroup;
	    var group = this.group;
	    var scale = geo.scale;
	    var transform = {
	      position: geo.position,
	      scale: scale
	    }; // No animation when first draw or in action
	
	    if (!regionsGroup.childAt(0) || payload) {
	      group.attr(transform);
	    } else {
	      graphic.updateProps(group, transform, mapOrGeoModel);
	    }
	
	    regionsGroup.removeAll();
	    var itemStyleAccessPath = ['itemStyle'];
	    var hoverItemStyleAccessPath = ['emphasis', 'itemStyle'];
	    var labelAccessPath = ['label'];
	    var hoverLabelAccessPath = ['emphasis', 'label'];
	    var nameMap = zrUtil.createHashMap();
	    zrUtil.each(geo.regions, function (region) {
	      // Consider in GeoJson properties.name may be duplicated, for example,
	      // there is multiple region named "United Kindom" or "France" (so many
	      // colonies). And it is not appropriate to merge them in geo, which
	      // will make them share the same label and bring trouble in label
	      // location calculation.
	      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
	      var compoundPath = new graphic.CompoundPath({
	        shape: {
	          paths: []
	        }
	      });
	      regionGroup.add(compoundPath);
	      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
	      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
	      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
	      var itemStyle = getFixedItemStyle(itemStyleModel, scale);
	      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel, scale);
	      var labelModel = regionModel.getModel(labelAccessPath);
	      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
	      var dataIdx; // Use the itemStyle in data if has data
	
	      if (data) {
	        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
	        // But visual color of series is used in symbol drawing
	        //
	        // Visual color for each series is for the symbol draw
	
	        var visualColor = data.getItemVisual(dataIdx, 'color', true);
	
	        if (visualColor) {
	          itemStyle.fill = visualColor;
	        }
	      }
	
	      zrUtil.each(region.geometries, function (geometry) {
	        if (geometry.type !== 'polygon') {
	          return;
	        }
	
	        compoundPath.shape.paths.push(new graphic.Polygon({
	          shape: {
	            points: geometry.exterior
	          }
	        }));
	
	        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); i++) {
	          compoundPath.shape.paths.push(new graphic.Polygon({
	            shape: {
	              points: geometry.interiors[i]
	            }
	          }));
	        }
	      });
	      compoundPath.setStyle(itemStyle);
	      compoundPath.style.strokeNoScale = true;
	      compoundPath.culling = true; // Label
	
	      var showLabel = labelModel.get('show');
	      var hoverShowLabel = hoverLabelModel.get('show');
	      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : region.name;
	        var labelFetcher; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var textEl = new graphic.Text({
	          position: region.center.slice(),
	          // FIXME
	          // label rotation is not support yet in geo or regions of series-map
	          // that has no data. The rotation will be effected by this `scale`.
	          // So needed to change to RectText?
	          scale: [1 / scale[0], 1 / scale[1]],
	          z2: 10,
	          silent: true
	        });
	        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: region.name,
	          useInsideStyle: false
	        }, {
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        });
	        regionGroup.add(textEl);
	      } // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the rigionGroup
	
	
	      if (data) {
	        data.setItemGraphicEl(dataIdx, regionGroup);
	      } else {
	        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
	
	        compoundPath.eventData = {
	          componentType: 'geo',
	          componentIndex: mapOrGeoModel.componentIndex,
	          geoIndex: mapOrGeoModel.componentIndex,
	          name: region.name,
	          region: regionModel && regionModel.option || {}
	        };
	      }
	
	      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
	      groupRegions.push(region);
	      graphic.setHoverStyle(regionGroup, hoverItemStyle, {
	        hoverSilentOnTouch: !!mapOrGeoModel.get('selectedMode')
	      });
	      regionsGroup.add(regionGroup);
	    });
	
	    this._updateController(mapOrGeoModel, ecModel, api);
	
	    updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
	    updateMapSelected(mapOrGeoModel, regionsGroup);
	  },
	  remove: function () {
	    this._regionsGroup.removeAll();
	
	    this._backgroundGroup.removeAll();
	
	    this._controller.dispose();
	
	    this._mapName && geoSourceManager.removeGraphic(this._mapName, this.uid);
	    this._mapName = null;
	    this._controllerHost = {};
	  },
	  _updateBackground: function (geo) {
	    var mapName = geo.map;
	
	    if (this._mapName !== mapName) {
	      zrUtil.each(geoSourceManager.makeGraphic(mapName, this.uid), function (root) {
	        this._backgroundGroup.add(root);
	      }, this);
	    }
	
	    this._mapName = mapName;
	  },
	  _updateController: function (mapOrGeoModel, ecModel, api) {
	    var geo = mapOrGeoModel.coordinateSystem;
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	
	    controller.enable(mapOrGeoModel.get('roam') || false);
	    var mainType = mapOrGeoModel.mainType;
	
	    function makeActionBase() {
	      var action = {
	        type: 'geoRoam',
	        componentType: mainType
	      };
	      action[mainType + 'Id'] = mapOrGeoModel.id;
	      return action;
	    }
	
	    controller.off('pan').on('pan', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        dx: e.dx,
	        dy: e.dy
	      }));
	    }, this);
	    controller.off('zoom').on('zoom', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      }));
	
	      if (this._updateGroup) {
	        var scale = this.group.scale;
	
	        this._regionsGroup.traverse(function (el) {
	          if (el.type === 'text') {
	            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
	          }
	        });
	      }
	    }, this);
	    controller.setPointerChecker(function (e, x, y) {
	      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
	    });
	  }
	};
	var _default = MapDraw;
	module.exports = _default;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Eventful = __webpack_require__(138);
	
	var eventTool = __webpack_require__(139);
	
	var interactionMutex = __webpack_require__(346);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @alias module:echarts/component/helper/RoamController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	function RoamController(zr) {
	  /**
	   * @type {Function}
	   */
	  this.pointerChecker;
	  /**
	   * @type {module:zrender}
	   */
	
	  this._zr = zr;
	  /**
	   * @type {Object}
	   */
	
	  this._opt = {}; // Avoid two roamController bind the same handler
	
	  var bind = zrUtil.bind;
	  var mousedownHandler = bind(mousedown, this);
	  var mousemoveHandler = bind(mousemove, this);
	  var mouseupHandler = bind(mouseup, this);
	  var mousewheelHandler = bind(mousewheel, this);
	  var pinchHandler = bind(pinch, this);
	  Eventful.call(this);
	  /**
	   * @param {Function} pointerChecker
	   *                   input: x, y
	   *                   output: boolean
	   */
	
	  this.setPointerChecker = function (pointerChecker) {
	    this.pointerChecker = pointerChecker;
	  };
	  /**
	   * Notice: only enable needed types. For example, if 'zoom'
	   * is not needed, 'zoom' should not be enabled, otherwise
	   * default mousewheel behaviour (scroll page) will be disabled.
	   *
	   * @param  {boolean|string} [controlType=true] Specify the control type,
	   *                          which can be null/undefined or true/false
	   *                          or 'pan/move' or 'zoom'/'scale'
	   * @param {Object} [opt]
	   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
	   */
	
	
	  this.enable = function (controlType, opt) {
	    // Disable previous first
	    this.disable();
	    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      // By default, wheel do not trigger move.
	      moveOnMouseWheel: false,
	      preventDefaultMouseMove: true
	    });
	
	    if (controlType == null) {
	      controlType = true;
	    }
	
	    if (controlType === true || controlType === 'move' || controlType === 'pan') {
	      zr.on('mousedown', mousedownHandler);
	      zr.on('mousemove', mousemoveHandler);
	      zr.on('mouseup', mouseupHandler);
	    }
	
	    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	      zr.on('mousewheel', mousewheelHandler);
	      zr.on('pinch', pinchHandler);
	    }
	  };
	
	  this.disable = function () {
	    zr.off('mousedown', mousedownHandler);
	    zr.off('mousemove', mousemoveHandler);
	    zr.off('mouseup', mouseupHandler);
	    zr.off('mousewheel', mousewheelHandler);
	    zr.off('pinch', pinchHandler);
	  };
	
	  this.dispose = this.disable;
	
	  this.isDragging = function () {
	    return this._dragging;
	  };
	
	  this.isPinching = function () {
	    return this._pinching;
	  };
	}
	
	zrUtil.mixin(RoamController, Eventful);
	
	function mousedown(e) {
	  if (eventTool.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY; // Only check on mosedown, but not mousemove.
	  // Mouse can be out of target when mouse moving.
	
	  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	    this._x = x;
	    this._y = y;
	    this._dragging = true;
	  }
	}
	
	function mousemove(e) {
	  if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY;
	  var oldX = this._x;
	  var oldY = this._y;
	  var dx = x - oldX;
	  var dy = y - oldY;
	  this._x = x;
	  this._y = y;
	  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
	  trigger(this, 'pan', 'moveOnMouseMove', e, {
	    dx: dx,
	    dy: dy,
	    oldX: oldX,
	    oldY: oldY,
	    newX: x,
	    newY: y
	  });
	}
	
	function mouseup(e) {
	  if (!eventTool.isMiddleOrRightButtonOnMouseUpDown(e)) {
	    this._dragging = false;
	  }
	}
	
	function mousewheel(e) {
	  var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
	  var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
	  var wheelDelta = e.wheelDelta;
	  var absWheelDeltaDelta = Math.abs(wheelDelta);
	  var originX = e.offsetX;
	  var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
	
	  if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
	    return;
	  } // If both `shouldZoom` and `shouldMove` is true, trigger
	  // their event both, and the final behavior is determined
	  // by event listener themselves.
	
	
	  if (shouldZoom) {
	    // Convenience:
	    // Mac and VM Windows on Mac: scroll up: zoom out.
	    // Windows: scroll up: zoom in.
	    // FIXME: Should do more test in different environment.
	    // wheelDelta is too complicated in difference nvironment
	    // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
	    // although it has been normallized by zrender.
	    // wheelDelta of mouse wheel is bigger than touch pad.
	    var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
	    var scale = wheelDelta > 0 ? factor : 1 / factor;
	    checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
	      scale: scale,
	      originX: originX,
	      originY: originY
	    });
	  }
	
	  if (shouldMove) {
	    // FIXME: Should do more test in different environment.
	    var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
	
	    var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
	    checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
	      scrollDelta: scrollDelta,
	      originX: originX,
	      originY: originY
	    });
	  }
	}
	
	function pinch(e) {
	  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	  checkPointerAndTrigger(this, 'zoom', null, e, {
	    scale: scale,
	    originX: e.pinchX,
	    originY: e.pinchY
	  });
	}
	
	function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
	    // When mouse is out of roamController rect,
	    // default befavoius should not be be disabled, otherwise
	    // page sliding is disabled, contrary to expectation.
	    eventTool.stop(e.event);
	    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
	  }
	}
	
	function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  // Also provide behavior checker for event listener, for some case that
	  // multiple components share one listener.
	  contollerEvent.isAvailableBehavior = zrUtil.bind(isAvailableBehavior, null, behaviorToCheck, e);
	  controller.trigger(eventName, contollerEvent);
	} // settings: {
	//     zoomOnMouseWheel
	//     moveOnMouseMove
	//     moveOnMouseWheel
	// }
	// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	
	
	function isAvailableBehavior(behaviorToCheck, e, settings) {
	  var setting = settings[behaviorToCheck];
	  return !behaviorToCheck || setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
	}
	
	var _default = RoamController;
	module.exports = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ATTR = '\0_ec_interaction_mutex';
	
	function take(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  store[resourceKey] = userKey;
	}
	
	function release(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  var uKey = store[resourceKey];
	
	  if (uKey === userKey) {
	    store[resourceKey] = null;
	  }
	}
	
	function isTaken(zr, resourceKey) {
	  return !!getStore(zr)[resourceKey];
	}
	
	function getStore(zr) {
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	/**
	 * payload: {
	 *     type: 'takeGlobalCursor',
	 *     key: 'dataZoomSelect', or 'brush', or ...,
	 *         If no userKey, release global cursor.
	 * }
	 */
	
	
	echarts.registerAction({
	  type: 'takeGlobalCursor',
	  event: 'globalCursorTaken',
	  update: 'update'
	}, function () {});
	exports.take = take;
	exports.release = release;
	exports.isTaken = isTaken;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 */
	function updateViewOnPan(controllerHost, dx, dy) {
	  var target = controllerHost.target;
	  var pos = target.position;
	  pos[0] += dx;
	  pos[1] += dy;
	  target.dirty();
	}
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 * @param {number} controllerHost.zoom
	 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
	 */
	
	
	function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	  var target = controllerHost.target;
	  var zoomLimit = controllerHost.zoomLimit;
	  var pos = target.position;
	  var scale = target.scale;
	  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	  newZoom *= zoomDelta;
	
	  if (zoomLimit) {
	    var zoomMin = zoomLimit.min || 0;
	    var zoomMax = zoomLimit.max || Infinity;
	    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	  }
	
	  var zoomScale = newZoom / controllerHost.zoom;
	  controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
	  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
	  scale[0] *= zoomScale;
	  scale[1] *= zoomScale;
	  target.dirty();
	}
	
	exports.updateViewOnPan = updateViewOnPan;
	exports.updateViewOnZoom = updateViewOnZoom;

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var IRRELEVANT_EXCLUDES = {
	  'axisPointer': 1,
	  'tooltip': 1,
	  'brush': 1
	};
	/**
	 * Avoid that: mouse click on a elements that is over geo or graph,
	 * but roam is triggered.
	 */
	
	function onIrrelevantElement(e, api, targetCoordSysModel) {
	  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	  var coordSys = model && model.coordinateSystem;
	  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
	}
	
	exports.onIrrelevantElement = onIrrelevantElement;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var _roamHelper = __webpack_require__(350);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} [componentType=series]
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	echarts.registerAction({
	  type: 'geoRoam',
	  event: 'geoRoam',
	  update: 'updateTransform'
	}, function (payload, ecModel) {
	  var componentType = payload.componentType || 'series';
	  ecModel.eachComponent({
	    mainType: componentType,
	    query: payload
	  }, function (componentModel) {
	    var geo = componentModel.coordinateSystem;
	
	    if (geo.type !== 'geo') {
	      return;
	    }
	
	    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
	    componentModel.setCenter && componentModel.setCenter(res.center);
	    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	    // So the center and zoom must be in sync. Include the series not selected by legend
	
	    if (componentType === 'series') {
	      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
	        seriesModel.setCenter(res.center);
	        seriesModel.setZoom(res.zoom);
	      });
	    }
	  });
	});

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/coord/View} view
	 * @param {Object} payload
	 * @param {Object} [zoomLimit]
	 */
	function updateCenterAndZoom(view, payload, zoomLimit) {
	  var previousZoom = view.getZoom();
	  var center = view.getCenter();
	  var zoom = payload.zoom;
	  var point = view.dataToPoint(center);
	
	  if (payload.dx != null && payload.dy != null) {
	    point[0] -= payload.dx;
	    point[1] -= payload.dy;
	    var center = view.pointToData(point);
	    view.setCenter(center);
	  }
	
	  if (zoom != null) {
	    if (zoomLimit) {
	      var zoomMin = zoomLimit.min || 0;
	      var zoomMax = zoomLimit.max || Infinity;
	      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	    } // Zoom on given point(originX, originY)
	
	
	    view.scale[0] *= zoom;
	    view.scale[1] *= zoom;
	    var position = view.position;
	    var fixX = (payload.originX - position[0]) * (zoom - 1);
	    var fixY = (payload.originY - position[1]) * (zoom - 1);
	    position[0] -= fixX;
	    position[1] -= fixY;
	    view.updateTransform(); // Get the new center
	
	    var center = view.pointToData(point);
	    view.setCenter(center);
	    view.setZoom(zoom * previousZoom);
	  }
	
	  return {
	    center: view.getCenter(),
	    zoom: view.getZoom()
	  };
	}
	
	exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var Geo = __webpack_require__(352);
	
	var layout = __webpack_require__(217);
	
	var numberUtil = __webpack_require__(218);
	
	var geoSourceManager = __webpack_require__(336);
	
	var mapDataStorage = __webpack_require__(249);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Resize method bound to the geo
	 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizeGeo(geoModel, api) {
	  var boundingCoords = geoModel.get('boundingCoords');
	
	  if (boundingCoords != null) {
	    var leftTop = boundingCoords[0];
	    var rightBottom = boundingCoords[1];
	
	    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
	      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
	    }
	  }
	
	  var rect = this.getBoundingRect();
	  var boxLayoutOption;
	  var center = geoModel.get('layoutCenter');
	  var size = geoModel.get('layoutSize');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var aspect = rect.width / rect.height * this.aspectScale;
	  var useCenterAndSize = false;
	
	  if (center && size) {
	    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
	    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));
	
	    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	      useCenterAndSize = true;
	    } else {}
	  }
	
	  var viewRect;
	
	  if (useCenterAndSize) {
	    var viewRect = {};
	
	    if (aspect > 1) {
	      // Width is same with size
	      viewRect.width = size;
	      viewRect.height = size / aspect;
	    } else {
	      viewRect.height = size;
	      viewRect.width = size * aspect;
	    }
	
	    viewRect.y = center[1] - viewRect.height / 2;
	    viewRect.x = center[0] - viewRect.width / 2;
	  } else {
	    // Use left/top/width/height
	    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
	
	    boxLayoutOption.aspect = aspect;
	    viewRect = layout.getLayoutRect(boxLayoutOption, {
	      width: viewWidth,
	      height: viewHeight
	    });
	  }
	
	  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	  this.setCenter(geoModel.get('center'));
	  this.setZoom(geoModel.get('zoom'));
	}
	/**
	 * @param {module:echarts/coord/Geo} geo
	 * @param {module:echarts/model/Model} model
	 * @inner
	 */
	
	
	function setGeoCoords(geo, model) {
	  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
	    geo.addGeoCoord(name, geoCoord);
	  });
	}
	
	var geoCreator = {
	  // For deciding which dimensions to use when creating list data
	  dimensions: Geo.prototype.dimensions,
	  create: function (ecModel, api) {
	    var geoList = []; // FIXME Create each time may be slow
	
	    ecModel.eachComponent('geo', function (geoModel, idx) {
	      var name = geoModel.get('map');
	      var aspectScale = geoModel.get('aspectScale');
	      var invertLongitute = true;
	      var mapRecords = mapDataStorage.retrieveMap(name);
	
	      if (mapRecords && mapRecords[0] && mapRecords[0].type === 'svg') {
	        aspectScale == null && (aspectScale = 1);
	        invertLongitute = false;
	      } else {
	        aspectScale == null && (aspectScale = 0.75);
	      }
	
	      var geo = new Geo(name + idx, name, geoModel.get('nameMap'), invertLongitute);
	      geo.aspectScale = aspectScale;
	      geo.zoomLimit = geoModel.get('scaleLimit');
	      geoList.push(geo);
	      setGeoCoords(geo, geoModel);
	      geoModel.coordinateSystem = geo;
	      geo.model = geoModel; // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(geoModel, api);
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      var coordSys = seriesModel.get('coordinateSystem');
	
	      if (coordSys === 'geo') {
	        var geoIndex = seriesModel.get('geoIndex') || 0;
	        seriesModel.coordinateSystem = geoList[geoIndex];
	      }
	    }); // If has map series
	
	    var mapModelGroupBySeries = {};
	    ecModel.eachSeriesByType('map', function (seriesModel) {
	      if (!seriesModel.getHostGeoModel()) {
	        var mapType = seriesModel.getMapType();
	        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	        mapModelGroupBySeries[mapType].push(seriesModel);
	      }
	    });
	    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
	      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('nameMap');
	      });
	      var geo = new Geo(mapType, mapType, zrUtil.mergeAll(nameMapList));
	      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('scaleLimit');
	      }));
	      geoList.push(geo); // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.aspectScale = mapSeries[0].get('aspectScale');
	      geo.resize(mapSeries[0], api);
	      zrUtil.each(mapSeries, function (singleMapSeries) {
	        singleMapSeries.coordinateSystem = geo;
	        setGeoCoords(geo, singleMapSeries);
	      });
	    });
	    return geoList;
	  },
	
	  /**
	   * Fill given regions array
	   * @param  {Array.<Object>} originRegionArr
	   * @param  {string} mapName
	   * @param  {Object} [nameMap]
	   * @return {Array}
	   */
	  getFilledRegions: function (originRegionArr, mapName, nameMap) {
	    // Not use the original
	    var regionsArr = (originRegionArr || []).slice();
	    var dataNameMap = zrUtil.createHashMap();
	
	    for (var i = 0; i < regionsArr.length; i++) {
	      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	    }
	
	    var source = geoSourceManager.load(mapName, nameMap);
	    zrUtil.each(source.regions, function (region) {
	      var name = region.name;
	      !dataNameMap.get(name) && regionsArr.push({
	        name: name
	      });
	    });
	    return regionsArr;
	  }
	};
	echarts.registerCoordinateSystem('geo', geoCreator);
	var _default = geoCreator;
	module.exports = _default;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var BoundingRect = __webpack_require__(154);
	
	var View = __webpack_require__(353);
	
	var geoSourceManager = __webpack_require__(336);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Geo description]
	 * For backward compatibility, the orginal interface:
	 * `name, map, geoJson, specialAreas, nameMap` is kept.
	 *
	 * @param {string|Object} name
	 * @param {string} map Map type
	 *        Specify the positioned areas by left, top, width, height
	 * @param {Object.<string, string>} [nameMap]
	 *        Specify name alias
	 * @param {boolean} [invertLongitute=true]
	 */
	function Geo(name, map, nameMap, invertLongitute) {
	  View.call(this, name);
	  /**
	   * Map type
	   * @type {string}
	   */
	
	  this.map = map;
	  var source = geoSourceManager.load(map, nameMap);
	  this._nameCoordMap = source.nameCoordMap;
	  this._regionsMap = source.regionsMap;
	  this._invertLongitute = invertLongitute == null ? true : invertLongitute;
	  /**
	   * @readOnly
	   */
	
	  this.regions = source.regions;
	  /**
	   * @type {module:zrender/src/core/BoundingRect}
	   */
	
	  this._rect = source.boundingRect;
	}
	
	Geo.prototype = {
	  constructor: Geo,
	  type: 'geo',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['lng', 'lat'],
	
	  /**
	   * If contain given lng,lat coord
	   * @param {Array.<number>}
	   * @readOnly
	   */
	  containCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @override
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var invertLongitute = this._invertLongitute;
	    rect = rect.clone();
	
	    if (invertLongitute) {
	      // Longitute is inverted
	      rect.y = -rect.y - rect.height;
	    }
	
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransformable.decomposeTransform();
	
	    if (invertLongitute) {
	      var scale = rawTransformable.scale;
	      scale[1] = -scale[1];
	    }
	
	    rawTransformable.updateTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/coord/geo/Region}
	   */
	  getRegion: function (name) {
	    return this._regionsMap.get(name);
	  },
	  getRegionByCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return regions[i];
	      }
	    }
	  },
	
	  /**
	   * Add geoCoord for indexing by name
	   * @param {string} name
	   * @param {Array.<number>} geoCoord
	   */
	  addGeoCoord: function (name, geoCoord) {
	    this._nameCoordMap.set(name, geoCoord);
	  },
	
	  /**
	   * Get geoCoord by name
	   * @param {string} name
	   * @return {Array.<number>}
	   */
	  getGeoCoord: function (name) {
	    return this._nameCoordMap.get(name);
	  },
	
	  /**
	   * @override
	   */
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {string|Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    if (typeof data === 'string') {
	      // Map area name to geoCoord
	      data = this.getGeoCoord(data);
	    }
	
	    if (data) {
	      return View.prototype.dataToPoint.call(this, data, noRoam, out);
	    }
	  },
	
	  /**
	   * @override
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @override
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
	};
	zrUtil.mixin(Geo, View);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var geoModel = finder.geoModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
	  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = Geo;
	module.exports = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var vector = __webpack_require__(136);
	
	var matrix = __webpack_require__(145);
	
	var BoundingRect = __webpack_require__(154);
	
	var Transformable = __webpack_require__(144);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Simple view coordinate system
	 * Mapping given x, y to transformd view x, y
	 */
	var v2ApplyTransform = vector.applyTransform; // Dummy transform node
	
	function TransformDummy() {
	  Transformable.call(this);
	}
	
	zrUtil.mixin(TransformDummy, Transformable);
	
	function View(name) {
	  /**
	   * @type {string}
	   */
	  this.name = name;
	  /**
	   * @type {Object}
	   */
	
	  this.zoomLimit;
	  Transformable.call(this);
	  this._roamTransformable = new TransformDummy();
	  this._rawTransformable = new TransformDummy();
	  this._center;
	  this._zoom;
	}
	
	View.prototype = {
	  constructor: View,
	  type: 'view',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Set bounding rect
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  // PENDING to getRect
	  setBoundingRect: function (x, y, width, height) {
	    this._rect = new BoundingRect(x, y, width, height);
	    return this._rect;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // PENDING to getRect
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  setViewRect: function (x, y, width, height) {
	    this.transformTo(x, y, width, height);
	    this._viewRect = new BoundingRect(x, y, width, height);
	  },
	
	  /**
	   * Transformed to particular position and size
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var rawTransform = this._rawTransformable;
	    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransform.decomposeTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * Set center of view
	   * @param {Array.<number>} [centerCoord]
	   */
	  setCenter: function (centerCoord) {
	    if (!centerCoord) {
	      return;
	    }
	
	    this._center = centerCoord;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * @param {number} zoom
	   */
	  setZoom: function (zoom) {
	    zoom = zoom || 1;
	    var zoomLimit = this.zoomLimit;
	
	    if (zoomLimit) {
	      if (zoomLimit.max != null) {
	        zoom = Math.min(zoomLimit.max, zoom);
	      }
	
	      if (zoomLimit.min != null) {
	        zoom = Math.max(zoomLimit.min, zoom);
	      }
	    }
	
	    this._zoom = zoom;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * Get default center without roam
	   */
	  getDefaultCenter: function () {
	    // Rect before any transform
	    var rawRect = this.getBoundingRect();
	    var cx = rawRect.x + rawRect.width / 2;
	    var cy = rawRect.y + rawRect.height / 2;
	    return [cx, cy];
	  },
	  getCenter: function () {
	    return this._center || this.getDefaultCenter();
	  },
	  getZoom: function () {
	    return this._zoom || 1;
	  },
	
	  /**
	   * @return {Array.<number}
	   */
	  getRoamTransform: function () {
	    return this._roamTransformable.getLocalTransform();
	  },
	
	  /**
	   * Remove roam
	   */
	  _updateCenterAndZoom: function () {
	    // Must update after view transform updated
	    var rawTransformMatrix = this._rawTransformable.getLocalTransform();
	
	    var roamTransform = this._roamTransformable;
	    var defaultCenter = this.getDefaultCenter();
	    var center = this.getCenter();
	    var zoom = this.getZoom();
	    center = vector.applyTransform([], center, rawTransformMatrix);
	    defaultCenter = vector.applyTransform([], defaultCenter, rawTransformMatrix);
	    roamTransform.origin = center;
	    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
	    roamTransform.scale = [zoom, zoom];
	
	    this._updateTransform();
	  },
	
	  /**
	   * Update transform from roam and mapLocation
	   * @private
	   */
	  _updateTransform: function () {
	    var roamTransformable = this._roamTransformable;
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.parent = roamTransformable;
	    roamTransformable.updateTransform();
	    rawTransformable.updateTransform();
	    matrix.copy(this.transform || (this.transform = []), rawTransformable.transform || matrix.create());
	    this._rawTransform = rawTransformable.getLocalTransform();
	    this.invTransform = this.invTransform || [];
	    matrix.invert(this.invTransform, this.transform);
	    this.decomposeTransform();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRect: function () {
	    return this._viewRect;
	  },
	
	  /**
	   * Get view rect after roam transform
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRectAfterRoam: function () {
	    var rect = this.getBoundingRect().clone();
	    rect.applyTransform(this.transform);
	    return rect;
	  },
	
	  /**
	   * Convert a single (lon, lat) data item to (x, y) point.
	   * @param {Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    var transform = noRoam ? this._rawTransform : this.transform;
	    out = out || [];
	    return transform ? v2ApplyTransform(out, data, transform) : vector.copy(out, data);
	  },
	
	  /**
	   * Convert a (x, y) point to (lon, lat) data
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var invTransform = this.invTransform;
	    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	  },
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  containPoint: function (point) {
	    return this.getViewRectAfterRoam().contain(point[0], point[1]);
	  }
	  /**
	   * @return {number}
	   */
	  // getScalarScale: function () {
	  //     // Use determinant square root of transform to mutiply scalar
	  //     var m = this.transform;
	  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
	  //     return det;
	  // }
	
	};
	zrUtil.mixin(View, Transformable);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var seriesModel = finder.seriesModel;
	  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = View;
	module.exports = _default;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var processedMapType = {};
	  ecModel.eachSeriesByType('map', function (mapSeries) {
	    var mapType = mapSeries.getMapType();
	
	    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	      return;
	    }
	
	    var mapSymbolOffsets = {};
	    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
	      var geo = subMapSeries.coordinateSystem;
	      var data = subMapSeries.originalData;
	
	      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	        data.each(data.mapDimension('value'), function (value, idx) {
	          var name = data.getName(idx);
	          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	          // not be drawn. So here must validate if value is NaN.
	
	          if (!region || isNaN(value)) {
	            return;
	          }
	
	          var offset = mapSymbolOffsets[name] || 0;
	          var point = geo.dataToPoint(region.center);
	          mapSymbolOffsets[name] = offset + 1;
	          data.setItemLayout(idx, {
	            point: point,
	            offset: offset
	          });
	        });
	      }
	    }); // Show label of those region not has legendSymbol(which is offset 0)
	
	    var data = mapSeries.getData();
	    data.each(function (idx) {
	      var name = data.getName(idx);
	      var layout = data.getItemLayout(idx) || {};
	      layout.showLabel = !mapSymbolOffsets[name];
	      data.setItemLayout(idx, layout);
	    });
	    processedMapType[mapType] = true;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var colorList = seriesModel.get('color');
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var areaColor = itemStyleModel.get('areaColor');
	    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
	    seriesModel.getData().setVisual({
	      'areaColor': areaColor,
	      'color': color
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME 公用？
	
	/**
	 * @param {Array.<module:echarts/data/List>} datas
	 * @param {string} statisticType 'average' 'sum'
	 * @inner
	 */
	function dataStatistics(datas, statisticType) {
	  var dataNameMap = {};
	  zrUtil.each(datas, function (data) {
	    data.each(data.mapDimension('value'), function (value, idx) {
	      // Add prefix to avoid conflict with Object.prototype.
	      var mapKey = 'ec-' + data.getName(idx);
	      dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	      if (!isNaN(value)) {
	        dataNameMap[mapKey].push(value);
	      }
	    });
	  });
	  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
	    var mapKey = 'ec-' + datas[0].getName(idx);
	    var sum = 0;
	    var min = Infinity;
	    var max = -Infinity;
	    var len = dataNameMap[mapKey].length;
	
	    for (var i = 0; i < len; i++) {
	      min = Math.min(min, dataNameMap[mapKey][i]);
	      max = Math.max(max, dataNameMap[mapKey][i]);
	      sum += dataNameMap[mapKey][i];
	    }
	
	    var result;
	
	    if (statisticType === 'min') {
	      result = min;
	    } else if (statisticType === 'max') {
	      result = max;
	    } else if (statisticType === 'average') {
	      result = sum / len;
	    } else {
	      result = sum;
	    }
	
	    return len === 0 ? NaN : result;
	  });
	}
	
	function _default(ecModel) {
	  var seriesGroups = {};
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var hostGeoModel = seriesModel.getHostGeoModel();
	    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	  });
	  zrUtil.each(seriesGroups, function (seriesList, key) {
	    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
	      return seriesModel.getData();
	    }), seriesList[0].get('mapValueCalculation'));
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].originalData = seriesList[i].getData();
	    } // FIXME Put where?
	
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].seriesGroup = seriesList;
	      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	      seriesList[i].setData(data.cloneShallow());
	      seriesList[i].mainSeries = seriesList[0];
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  // Save geoCoord
	  var mapSeries = [];
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'map') {
	      mapSeries.push(seriesOpt);
	      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
	
	      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(359);
	
	__webpack_require__(362);
	
	__webpack_require__(364);
	
	var visualSymbol = __webpack_require__(286);
	
	var treeLayout = __webpack_require__(365);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('tree', 'circle'));
	echarts.registerLayout(treeLayout);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(233);
	
	var Tree = __webpack_require__(360);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Create data struct and define tree view's series model
	 * @author Deqing Li(annong035@gmail.com)
	 */
	var _default = SeriesModel.extend({
	  type: 'series.tree',
	  layoutInfo: null,
	  // can support the position parameters 'left', 'top','right','bottom', 'width',
	  // 'height' in the setOption() with 'merge' mode normal.
	  layoutMode: 'box',
	
	  /**
	   * Init a tree data structure from data in option series
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    //create an virtual root
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    var leaves = option.leaves || {};
	    var treeOption = {};
	    treeOption.leaves = leaves;
	    var tree = Tree.createTree(root, this, treeOption);
	    var treeDepth = 0;
	    tree.eachNode('preorder', function (node) {
	      if (node.depth > treeDepth) {
	        treeDepth = node.depth;
	      }
	    });
	    var expandAndCollapse = option.expandAndCollapse;
	    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	    tree.root.eachNode('preorder', function (node) {
	      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
	
	      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	    });
	    return tree.data;
	  },
	
	  /**
	   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
	   * @returns {string} orient
	   */
	  getOrient: function () {
	    var orient = this.get('orient');
	
	    if (orient === 'horizontal') {
	      orient = 'LR';
	    } else if (orient === 'vertical') {
	      orient = 'TB';
	    }
	
	    return orient;
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    var tree = this.getData().tree;
	    var realRoot = tree.root.children[0];
	    var node = tree.getNodeByDataIndex(dataIndex);
	    var value = node.getValue();
	    var name = node.name;
	
	    while (node && node !== realRoot) {
	      name = node.parentNode.name + '.' + name;
	      node = node.parentNode;
	    }
	
	    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // the position of the whole view
	    left: '12%',
	    top: '12%',
	    right: '12%',
	    bottom: '12%',
	    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	    layout: 'orthogonal',
	    roam: false,
	    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.4,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
	    // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
	    orient: 'LR',
	    symbol: 'emptyCircle',
	    symbolSize: 7,
	    expandAndCollapse: true,
	    initialTreeDepth: 2,
	    lineStyle: {
	      color: '#ccc',
	      width: 1.5,
	      curveness: 0.5
	    },
	    itemStyle: {
	      color: 'lightsteelblue',
	      borderColor: '#c23531',
	      borderWidth: 1.5
	    },
	    label: {
	      show: true,
	      color: '#555'
	    },
	    leaves: {
	      label: {
	        show: true
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 700,
	    animationDurationUpdate: 1000
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Model = __webpack_require__(174);
	
	var linkList = __webpack_require__(361);
	
	var List = __webpack_require__(255);
	
	var createDimensions = __webpack_require__(258);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Tree data structure
	 *
	 * @module echarts/data/Tree
	 */
	
	/**
	 * @constructor module:echarts/data/Tree~TreeNode
	 * @param {string} name
	 * @param {module:echarts/data/Tree} hostTree
	 */
	var TreeNode = function (name, hostTree) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * Depth of node
	   *
	   * @type {number}
	   * @readOnly
	   */
	
	  this.depth = 0;
	  /**
	   * Height of the subtree rooted at this node.
	   * @type {number}
	   * @readOnly
	   */
	
	  this.height = 0;
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	
	  this.parentNode = null;
	  /**
	   * Reference to list item.
	   * Do not persistent dataIndex outside,
	   * besause it may be changed by list.
	   * If dataIndex -1,
	   * this node is logical deleted (filtered) in list.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.dataIndex = -1;
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @readOnly
	   */
	
	  this.children = [];
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @pubilc
	   */
	
	  this.viewChildren = [];
	  /**
	   * @type {moduel:echarts/data/Tree}
	   * @readOnly
	   */
	
	  this.hostTree = hostTree;
	};
	
	TreeNode.prototype = {
	  constructor: TreeNode,
	
	  /**
	   * The node is removed.
	   * @return {boolean} is removed.
	   */
	  isRemoved: function () {
	    return this.dataIndex < 0;
	  },
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb If in preorder and return false,
	   *                      its subtree will not be visited.
	   * @param {Object} [context]
	   */
	  eachNode: function (options, cb, context) {
	    if (typeof options === 'function') {
	      context = cb;
	      cb = options;
	      options = null;
	    }
	
	    options = options || {};
	
	    if (zrUtil.isString(options)) {
	      options = {
	        order: options
	      };
	    }
	
	    var order = options.order || 'preorder';
	    var children = this[options.attr || 'children'];
	    var suppressVisitSub;
	    order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	      children[i].eachNode(options, cb, context);
	    }
	
	    order === 'postorder' && cb.call(context, this);
	  },
	
	  /**
	   * Update depth and height of this subtree.
	   *
	   * @param  {number} depth
	   */
	  updateDepthAndHeight: function (depth) {
	    var height = 0;
	    this.depth = depth;
	
	    for (var i = 0; i < this.children.length; i++) {
	      var child = this.children[i];
	      child.updateDepthAndHeight(depth + 1);
	
	      if (child.height > height) {
	        height = child.height;
	      }
	    }
	
	    this.height = height + 1;
	  },
	
	  /**
	   * @param  {string} id
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeById: function (id) {
	    if (this.getId() === id) {
	      return this;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].getNodeById(id);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~TreeNode} node
	   * @return {boolean}
	   */
	  contains: function (node) {
	    if (node === this) {
	      return true;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].contains(node);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {boolean} includeSelf Default false.
	   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
	   */
	  getAncestors: function (includeSelf) {
	    var ancestors = [];
	    var node = includeSelf ? this : this.parentNode;
	
	    while (node) {
	      ancestors.push(node);
	      node = node.parentNode;
	    }
	
	    ancestors.reverse();
	    return ancestors;
	  },
	
	  /**
	   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
	   * @return {number} Value.
	   */
	  getValue: function (dimension) {
	    var data = this.hostTree.data;
	    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	  },
	
	  /**
	   * @param {Object} layout
	   * @param {boolean=} [merge=false]
	   */
	  setLayout: function (layout, merge) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	  },
	
	  /**
	   * @return {Object} layout
	   */
	  getLayout: function () {
	    return this.hostTree.data.getItemLayout(this.dataIndex);
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var hostTree = this.hostTree;
	    var itemModel = hostTree.data.getItemModel(this.dataIndex);
	    var levelModel = this.getLevelModel();
	    var leavesModel;
	
	    if (!levelModel && (this.children.length === 0 || this.children.length !== 0 && this.isExpand === false)) {
	      leavesModel = this.getLeavesModel();
	    }
	
	    return itemModel.getModel(path, (levelModel || leavesModel || hostTree.hostModel).getModel(path));
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getLevelModel: function () {
	    return (this.hostTree.levelModels || [])[this.depth];
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getLeavesModel: function () {
	    return this.hostTree.leavesModel;
	  },
	
	  /**
	   * @example
	   *  setItemVisual('color', color);
	   *  setItemVisual({
	   *      'color': color
	   *  });
	   */
	  setVisual: function (key, value) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	  },
	
	  /**
	   * Get item visual
	   */
	  getVisual: function (key, ignoreParent) {
	    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
	  },
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getRawIndex: function () {
	    return this.hostTree.data.getRawIndex(this.dataIndex);
	  },
	
	  /**
	   * @public
	   * @return {string}
	   */
	  getId: function () {
	    return this.hostTree.data.getId(this.dataIndex);
	  },
	
	  /**
	   * if this is an ancestor of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is ancestor
	   */
	  isAncestorOf: function (node) {
	    var parent = node.parentNode;
	
	    while (parent) {
	      if (parent === this) {
	        return true;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    return false;
	  },
	
	  /**
	   * if this is an descendant of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is descendant
	   */
	  isDescendantOf: function (node) {
	    return node !== this && node.isAncestorOf(this);
	  }
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/Tree
	 * @param {module:echarts/model/Model} hostModel
	 * @param {Array.<Object>} levelOptions
	 * @param {Object} leavesOption
	 */
	
	function Tree(hostModel, levelOptions, leavesOption) {
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	  this.root;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * Index of each item is the same as the raw index of coresponding list item.
	   * @private
	   * @type {Array.<module:echarts/data/Tree~TreeNode}
	   */
	
	  this._nodes = [];
	  /**
	   * @private
	   * @readOnly
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @private
	   * @readOnly
	   * @type {Array.<module:echarts/model/Model}
	   */
	
	  this.levelModels = zrUtil.map(levelOptions || [], function (levelDefine) {
	    return new Model(levelDefine, hostModel, hostModel.ecModel);
	  });
	  this.leavesModel = new Model(leavesOption || {}, hostModel, hostModel.ecModel);
	}
	
	Tree.prototype = {
	  constructor: Tree,
	  type: 'tree',
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb
	   * @param {Object}   [context]
	   */
	  eachNode: function (options, cb, context) {
	    this.root.eachNode(options, cb, context);
	  },
	
	  /**
	   * @param {number} dataIndex
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByDataIndex: function (dataIndex) {
	    var rawIndex = this.data.getRawIndex(dataIndex);
	    return this._nodes[rawIndex];
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByName: function (name) {
	    return this.root.getNodeByName(name);
	  },
	
	  /**
	   * Update item available by list,
	   * when list has been performed options like 'filterSelf' or 'map'.
	   */
	  update: function () {
	    var data = this.data;
	    var nodes = this._nodes;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      nodes[i].dataIndex = -1;
	    }
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      nodes[data.getRawIndex(i)].dataIndex = i;
	    }
	  },
	
	  /**
	   * Clear all layouts
	   */
	  clearLayouts: function () {
	    this.data.clearItemLayouts();
	  }
	};
	/**
	 * data node format:
	 * {
	 *     name: ...
	 *     value: ...
	 *     children: [
	 *         {
	 *             name: ...
	 *             value: ...
	 *             children: ...
	 *         },
	 *         ...
	 *     ]
	 * }
	 *
	 * @static
	 * @param {Object} dataRoot Root node.
	 * @param {module:echarts/model/Model} hostModel
	 * @param {Object} treeOptions
	 * @param {Array.<Object>} treeOptions.levels
	 * @param {Array.<Object>} treeOptions.leaves
	 * @return module:echarts/data/Tree
	 */
	
	Tree.createTree = function (dataRoot, hostModel, treeOptions) {
	  var tree = new Tree(hostModel, treeOptions.levels, treeOptions.leaves);
	  var listData = [];
	  var dimMax = 1;
	  buildHierarchy(dataRoot);
	
	  function buildHierarchy(dataNode, parentNode) {
	    var value = dataNode.value;
	    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
	    listData.push(dataNode);
	    var node = new TreeNode(dataNode.name, tree);
	    parentNode ? addChild(node, parentNode) : tree.root = node;
	
	    tree._nodes.push(node);
	
	    var children = dataNode.children;
	
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        buildHierarchy(children[i], node);
	      }
	    }
	  }
	
	  tree.root.updateDepthAndHeight(0);
	  var dimensionsInfo = createDimensions(listData, {
	    coordDimensions: ['value'],
	    dimensionsCount: dimMax
	  });
	  var list = new List(dimensionsInfo, hostModel);
	  list.initData(listData);
	  linkList({
	    mainData: list,
	    struct: tree,
	    structAttr: 'tree'
	  });
	  tree.update();
	  return tree;
	};
	/**
	 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	 * so this function is not ready and not necessary to be public.
	 *
	 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
	 */
	
	
	function addChild(child, node) {
	  var children = node.children;
	
	  if (child.parentNode === node) {
	    return;
	  }
	
	  children.push(child);
	  child.parentNode = node;
	}
	
	var _default = Tree;
	module.exports = _default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Link lists and struct (graph or tree)
	 */
	var each = zrUtil.each;
	var DATAS = '\0__link_datas';
	var MAIN_DATA = '\0__link_mainData'; // Caution:
	// In most case, either list or its shallow clones (see list.cloneShallow)
	// is active in echarts process. So considering heap memory consumption,
	// we do not clone tree or graph, but share them among list and its shallow clones.
	// But in some rare case, we have to keep old list (like do animation in chart). So
	// please take care that both the old list and the new list share the same tree/graph.
	
	/**
	 * @param {Object} opt
	 * @param {module:echarts/data/List} opt.mainData
	 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
	 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
	 * @param {Object} [opt.datas] {dataType: data},
	 *                 like: {node: nodeList, edge: edgeList}.
	 *                 Should contain mainData.
	 * @param {Object} [opt.datasAttr] {dataType: attr},
	 *                 designation: struct[datasAttr[dataType]] = list;
	 */
	
	function linkList(opt) {
	  var mainData = opt.mainData;
	  var datas = opt.datas;
	
	  if (!datas) {
	    datas = {
	      main: mainData
	    };
	    opt.datasAttr = {
	      main: 'data'
	    };
	  }
	
	  opt.datas = opt.mainData = null;
	  linkAll(mainData, datas, opt); // Porxy data original methods.
	
	  each(datas, function (data) {
	    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
	    });
	  }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	  // another changable methods, which may bring about dead lock.
	
	  each(mainData.CHANGABLE_METHODS, function (methodName) {
	    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
	  }); // Make sure datas contains mainData.
	
	  zrUtil.assert(datas[mainData.dataType] === mainData);
	}
	
	function transferInjection(opt, res) {
	  if (isMainData(this)) {
	    // Transfer datas to new main data.
	    var datas = zrUtil.extend({}, this[DATAS]);
	    datas[this.dataType] = res;
	    linkAll(res, datas, opt);
	  } else {
	    // Modify the reference in main data to point newData.
	    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
	  }
	
	  return res;
	}
	
	function changeInjection(opt, res) {
	  opt.struct && opt.struct.update(this);
	  return res;
	}
	
	function cloneShallowInjection(opt, res) {
	  // cloneShallow, which brings about some fragilities, may be inappropriate
	  // to be exposed as an API. So for implementation simplicity we can make
	  // the restriction that cloneShallow of not-mainData should not be invoked
	  // outside, but only be invoked here.
	  each(res[DATAS], function (data, dataType) {
	    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	  });
	  return res;
	}
	/**
	 * Supplement method to List.
	 *
	 * @public
	 * @param {string} [dataType] If not specified, return mainData.
	 * @return {module:echarts/data/List}
	 */
	
	
	function getLinkedData(dataType) {
	  var mainData = this[MAIN_DATA];
	  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
	}
	
	function isMainData(data) {
	  return data[MAIN_DATA] === data;
	}
	
	function linkAll(mainData, datas, opt) {
	  mainData[DATAS] = {};
	  each(datas, function (data, dataType) {
	    linkSingle(data, dataType, mainData, opt);
	  });
	}
	
	function linkSingle(data, dataType, mainData, opt) {
	  mainData[DATAS][dataType] = data;
	  data[MAIN_DATA] = mainData;
	  data.dataType = dataType;
	
	  if (opt.struct) {
	    data[opt.structAttr] = opt.struct;
	    opt.struct[opt.datasAttr[dataType]] = data;
	  } // Supplement method.
	
	
	  data.getLinkedData = getLinkedData;
	}
	
	var _default = linkList;
	module.exports = _default;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var SymbolClz = __webpack_require__(281);
	
	var _layoutHelper = __webpack_require__(363);
	
	var radialCoordinate = _layoutHelper.radialCoordinate;
	
	var echarts = __webpack_require__(129);
	
	var bbox = __webpack_require__(185);
	
	var View = __webpack_require__(353);
	
	var roamHelper = __webpack_require__(347);
	
	var RoamController = __webpack_require__(345);
	
	var _cursorHelper = __webpack_require__(348);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file This file used to draw tree view.
	 * @author Deqing Li(annong035@gmail.com)
	 */
	var _default = echarts.extendChartView({
	  type: 'tree',
	
	  /**
	   * Init the chart
	   * @override
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup = new graphic.Group();
	    /**
	     * @private
	     * @type {module:echarts/componet/helper/RoamController}
	     */
	
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: this.group
	    };
	    this.group.add(this._mainGroup);
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var layoutInfo = seriesModel.layoutInfo;
	    var group = this._mainGroup;
	    var layout = seriesModel.get('layout');
	
	    if (layout === 'radial') {
	      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
	    } else {
	      group.attr('position', [layoutInfo.x, layoutInfo.y]);
	    }
	
	    this._updateViewCoordSys(seriesModel);
	
	    this._updateController(seriesModel, ecModel, api);
	
	    var oldData = this._data;
	    var seriesScope = {
	      expandAndCollapse: seriesModel.get('expandAndCollapse'),
	      layout: layout,
	      orient: seriesModel.getOrient(),
	      curvature: seriesModel.get('lineStyle.curveness'),
	      symbolRotate: seriesModel.get('symbolRotate'),
	      symbolOffset: seriesModel.get('symbolOffset'),
	      hoverAnimation: seriesModel.get('hoverAnimation'),
	      useNameLabel: true,
	      fadeIn: true
	    };
	    data.diff(oldData).add(function (newIdx) {
	      if (symbolNeedsDraw(data, newIdx)) {
	        // Create node and edge
	        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	      if (!symbolNeedsDraw(data, newIdx)) {
	        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	        return;
	      } // Update node and edge
	
	
	      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	    }).remove(function (oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
	      // node haven't been initialized with a symbol element,
	      // you can't found it's symbol element through index.
	      // so if we want to remove the symbol element we should insure
	      // that the symbol element is not null.
	
	      if (symbolEl) {
	        removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	      }
	    }).execute();
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	
	    this._updateNodeAndLinkScale(seriesModel);
	
	    if (seriesScope.expandAndCollapse === true) {
	      data.eachItemGraphicEl(function (el, dataIndex) {
	        el.off('click').on('click', function () {
	          api.dispatchAction({
	            type: 'treeExpandAndCollapse',
	            seriesId: seriesModel.id,
	            dataIndex: dataIndex
	          });
	        });
	      });
	    }
	
	    this._data = data;
	  },
	  _updateViewCoordSys: function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    data.each(function (idx) {
	      var layout = data.getItemLayout(idx);
	
	      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
	        points.push([+layout.x, +layout.y]);
	      }
	    });
	    var min = [];
	    var max = [];
	    bbox.fromPoints(points, min, max); // If width or height is 0
	
	    if (max[0] - min[0] === 0) {
	      max[0] += 1;
	      min[0] -= 1;
	    }
	
	    if (max[1] - min[1] === 0) {
	      max[1] += 1;
	      min[1] -= 1;
	    }
	
	    var viewCoordSys = seriesModel.coordinateSystem = new View();
	    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	    viewCoordSys.setCenter(seriesModel.get('center'));
	    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
	
	    this.group.attr({
	      position: viewCoordSys.position,
	      scale: viewCoordSys.scale
	    });
	    this._viewCoordSys = viewCoordSys;
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }, this).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale(seriesModel);
	    }, this);
	  },
	  _updateNodeAndLinkScale: function (seriesModel) {
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  remove: function () {
	    this._mainGroup.removeAll();
	
	    this._data = null;
	  }
	});
	
	function symbolNeedsDraw(data, dataIndex) {
	  var layout = data.getItemLayout(dataIndex);
	  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
	}
	
	function getTreeNodeStyle(node, itemModel, seriesScope) {
	  seriesScope.itemModel = itemModel;
	  seriesScope.itemStyle = itemModel.getModel('itemStyle').getItemStyle();
	  seriesScope.hoverItemStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  seriesScope.lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	  seriesScope.labelModel = itemModel.getModel('label');
	  seriesScope.hoverLabelModel = itemModel.getModel('emphasis.label');
	
	  if (node.isExpand === false && node.children.length !== 0) {
	    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
	  } else {
	    seriesScope.symbolInnerColor = '#fff';
	  }
	
	  return seriesScope;
	}
	
	function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var isInit = !symbolEl;
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var virtualRoot = data.tree.root;
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceLayout = source.getLayout();
	  var sourceOldLayout = sourceSymbolEl ? {
	    x: sourceSymbolEl.position[0],
	    y: sourceSymbolEl.position[1],
	    rawX: sourceSymbolEl.__radialOldRawX,
	    rawY: sourceSymbolEl.__radialOldRawY
	  } : sourceLayout;
	  var targetLayout = node.getLayout();
	
	  if (isInit) {
	    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
	    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
	  } else {
	    symbolEl.updateData(data, dataIndex, seriesScope);
	  }
	
	  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	  symbolEl.__radialRawX = targetLayout.rawX;
	  symbolEl.__radialRawY = targetLayout.rawY;
	  group.add(symbolEl);
	  data.setItemGraphicEl(dataIndex, symbolEl);
	  graphic.updateProps(symbolEl, {
	    position: [targetLayout.x, targetLayout.y]
	  }, seriesModel);
	  var symbolPath = symbolEl.getSymbolPath();
	
	  if (seriesScope.layout === 'radial') {
	    var realRoot = virtualRoot.children[0];
	    var rootLayout = realRoot.getLayout();
	    var length = realRoot.children.length;
	    var rad;
	    var isLeft;
	
	    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
	      var center = {};
	      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
	      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
	      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      isLeft = center.x < rootLayout.x;
	
	      if (isLeft) {
	        rad = rad - Math.PI;
	      }
	    } else {
	      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	        isLeft = targetLayout.x < rootLayout.x;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	      } else {
	        isLeft = targetLayout.x > rootLayout.x;
	
	        if (!isLeft) {
	          rad = rad - Math.PI;
	        }
	      }
	    }
	
	    var textPosition = isLeft ? 'left' : 'right';
	    symbolPath.setStyle({
	      textPosition: textPosition,
	      textRotation: -rad,
	      textOrigin: 'center',
	      verticalAlign: 'middle'
	    });
	  }
	
	  if (node.parentNode && node.parentNode !== virtualRoot) {
	    var edge = symbolEl.__edge;
	
	    if (!edge) {
	      edge = symbolEl.__edge = new graphic.BezierCurve({
	        shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
	        style: zrUtil.defaults({
	          opacity: 0,
	          strokeNoScale: true
	        }, seriesScope.lineStyle)
	      });
	    }
	
	    graphic.updateProps(edge, {
	      shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
	      style: {
	        opacity: 1
	      }
	    }, seriesModel);
	    group.add(edge);
	  }
	}
	
	function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var virtualRoot = data.tree.root;
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceLayout;
	
	  while (sourceLayout = source.getLayout(), sourceLayout == null) {
	    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	  }
	
	  graphic.updateProps(symbolEl, {
	    position: [sourceLayout.x + 1, sourceLayout.y + 1]
	  }, seriesModel, function () {
	    group.remove(symbolEl);
	    data.setItemGraphicEl(dataIndex, null);
	  });
	  symbolEl.fadeOut(null, {
	    keepLabel: true
	  });
	  var edge = symbolEl.__edge;
	
	  if (edge) {
	    graphic.updateProps(edge, {
	      shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
	      style: {
	        opacity: 0
	      }
	    }, seriesModel, function () {
	      group.remove(edge);
	    });
	  }
	}
	
	function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
	  var cpx1;
	  var cpy1;
	  var cpx2;
	  var cpy2;
	  var orient = seriesScope.orient;
	  var x1;
	  var x2;
	  var y1;
	  var y2;
	
	  if (seriesScope.layout === 'radial') {
	    x1 = sourceLayout.rawX;
	    y1 = sourceLayout.rawY;
	    x2 = targetLayout.rawX;
	    y2 = targetLayout.rawY;
	    var radialCoor1 = radialCoordinate(x1, y1);
	    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
	    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
	    var radialCoor4 = radialCoordinate(x2, y2);
	    return {
	      x1: radialCoor1.x,
	      y1: radialCoor1.y,
	      x2: radialCoor4.x,
	      y2: radialCoor4.y,
	      cpx1: radialCoor2.x,
	      cpy1: radialCoor2.y,
	      cpx2: radialCoor3.x,
	      cpy2: radialCoor3.y
	    };
	  } else {
	    x1 = sourceLayout.x;
	    y1 = sourceLayout.y;
	    x2 = targetLayout.x;
	    y2 = targetLayout.y;
	
	    if (orient === 'LR' || orient === 'RL') {
	      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
	      cpy1 = y1;
	      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
	      cpy2 = y2;
	    }
	
	    if (orient === 'TB' || orient === 'BT') {
	      cpx1 = x1;
	      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
	      cpx2 = x2;
	      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
	    }
	  }
	
	  return {
	    x1: x1,
	    y1: y1,
	    x2: x2,
	    y2: y2,
	    cpx1: cpx1,
	    cpy1: cpy1,
	    cpx2: cpx2,
	    cpy2: cpy2
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The tree layoutHelper implementation was originally copied from
	* "d3.js"(https://github.com/d3/d3-hierarchy) with
	* some modifications made for this project.
	* (see more details in the comment of the specific method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the licence of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	
	/**
	 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
	 *       the tree.
	 */
	
	/**
	 * Initialize all computational message for following algorithm.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
	 */
	function init(root) {
	  root.hierNode = {
	    defaultAncestor: null,
	    ancestor: root,
	    prelim: 0,
	    modifier: 0,
	    change: 0,
	    shift: 0,
	    i: 0,
	    thread: null
	  };
	  var nodes = [root];
	  var node;
	  var children;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    children = node.children;
	
	    if (node.isExpand && children.length) {
	      var n = children.length;
	
	      for (var i = n - 1; i >= 0; i--) {
	        var child = children[i];
	        child.hierNode = {
	          defaultAncestor: null,
	          ancestor: child,
	          prelim: 0,
	          modifier: 0,
	          change: 0,
	          shift: 0,
	          i: i,
	          thread: null
	        };
	        nodes.push(child);
	      }
	    }
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes a preliminary x coordinate for node. Before that, this function is
	 * applied recursively to the children of node, as well as the function
	 * apportion(). After spacing out the children by calling executeShifts(), the
	 * node is placed to the midpoint of its outermost children.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param {Function} separation
	 */
	
	
	function firstWalk(node, separation) {
	  var children = node.isExpand ? node.children : [];
	  var siblings = node.parentNode.children;
	  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	  if (children.length) {
	    executeShifts(node);
	    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	    if (subtreeW) {
	      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      node.hierNode.modifier = node.hierNode.prelim - midPoint;
	    } else {
	      node.hierNode.prelim = midPoint;
	    }
	  } else if (subtreeW) {
	    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	  }
	
	  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes all real x-coordinates by summing up the modifiers recursively.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function secondWalk(node) {
	  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	  node.setLayout({
	    x: nodeX
	  }, true);
	  node.hierNode.modifier += node.parentNode.hierNode.modifier;
	}
	
	function separation(cb) {
	  return arguments.length ? cb : defaultSeparation;
	}
	/**
	 * Transform the common coordinate to radial coordinate.
	 *
	 * @param  {number} x
	 * @param  {number} y
	 * @return {Object}
	 */
	
	
	function radialCoordinate(x, y) {
	  var radialCoor = {};
	  x -= Math.PI / 2;
	  radialCoor.x = y * Math.cos(x);
	  radialCoor.y = y * Math.sin(x);
	  return radialCoor;
	}
	/**
	 * Get the layout position of the whole view.
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	/**
	 * All other shifts, applied to the smaller subtrees between w- and w+, are
	 * performed by this function.
	 *
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function executeShifts(node) {
	  var children = node.children;
	  var n = children.length;
	  var shift = 0;
	  var change = 0;
	
	  while (--n >= 0) {
	    var child = children[n];
	    child.hierNode.prelim += shift;
	    child.hierNode.modifier += shift;
	    change += child.hierNode.change;
	    shift += child.hierNode.shift + change;
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * The core of the algorithm. Here, a new subtree is combined with the
	 * previous subtrees. Threads are used to traverse the inside and outside
	 * contours of the left and right subtree up to the highest common level.
	 * Whenever two nodes of the inside contours conflict, we compute the left
	 * one of the greatest uncommon ancestors using the function nextAncestor()
	 * and call moveSubtree() to shift the subtree and prepare the shifts of
	 * smaller subtrees. Finally, we add a new thread (if necessary).
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @param  {Function} separation
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function apportion(subtreeV, subtreeW, ancestor, separation) {
	  if (subtreeW) {
	    var nodeOutRight = subtreeV;
	    var nodeInRight = subtreeV;
	    var nodeOutLeft = nodeInRight.parentNode.children[0];
	    var nodeInLeft = subtreeW;
	    var sumOutRight = nodeOutRight.hierNode.modifier;
	    var sumInRight = nodeInRight.hierNode.modifier;
	    var sumOutLeft = nodeOutLeft.hierNode.modifier;
	    var sumInLeft = nodeInLeft.hierNode.modifier;
	
	    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	      nodeOutRight = nextRight(nodeOutRight);
	      nodeOutLeft = nextLeft(nodeOutLeft);
	      nodeOutRight.hierNode.ancestor = subtreeV;
	      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	      if (shift > 0) {
	        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	        sumInRight += shift;
	        sumOutRight += shift;
	      }
	
	      sumInLeft += nodeInLeft.hierNode.modifier;
	      sumInRight += nodeInRight.hierNode.modifier;
	      sumOutRight += nodeOutRight.hierNode.modifier;
	      sumOutLeft += nodeOutLeft.hierNode.modifier;
	    }
	
	    if (nodeInLeft && !nextRight(nodeOutRight)) {
	      nodeOutRight.hierNode.thread = nodeInLeft;
	      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	    }
	
	    if (nodeInRight && !nextLeft(nodeOutLeft)) {
	      nodeOutLeft.hierNode.thread = nodeInRight;
	      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	      ancestor = subtreeV;
	    }
	  }
	
	  return ancestor;
	}
	/**
	 * This function is used to traverse the right contour of a subtree.
	 * It returns the rightmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextRight(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	}
	/**
	 * This function is used to traverse the left contour of a subtree (or a subforest).
	 * It returns the leftmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextLeft(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	}
	/**
	 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	 * Otherwise, returns the specified ancestor.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextAncestor(nodeInLeft, node, ancestor) {
	  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Shifts the current subtree rooted at wr.
	 * This is done by increasing prelim(w+) and modifier(w+) by shift.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} wl
	 * @param  {module:echarts/data/Tree~TreeNode} wr
	 * @param  {number} shift [description]
	 */
	
	
	function moveSubtree(wl, wr, shift) {
	  var change = shift / (wr.hierNode.i - wl.hierNode.i);
	  wr.hierNode.change -= change;
	  wr.hierNode.shift += shift;
	  wr.hierNode.modifier += shift;
	  wr.hierNode.prelim += shift;
	  wl.hierNode.change += change;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	
	function defaultSeparation(node1, node2) {
	  return node1.parentNode === node2.parentNode ? 1 : 2;
	}
	
	exports.init = init;
	exports.firstWalk = firstWalk;
	exports.secondWalk = secondWalk;
	exports.separation = separation;
	exports.radialCoordinate = radialCoordinate;
	exports.getViewRect = getViewRect;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var _roamHelper = __webpack_require__(350);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Register the actions of the tree
	 * @author Deqing Li(annong035@gmail.com)
	 */
	echarts.registerAction({
	  type: 'treeExpandAndCollapse',
	  event: 'treeExpandAndCollapse',
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var dataIndex = payload.dataIndex;
	    var tree = seriesModel.getData().tree;
	    var node = tree.getNodeByDataIndex(dataIndex);
	    node.isExpand = !node.isExpand;
	  });
	});
	echarts.registerAction({
	  type: 'treeRoam',
	  event: 'treeRoam',
	  // Here we set 'none' instead of 'update', because roam action
	  // just need to update the transform matrix without having to recalculate
	  // the layout. So don't need to go through the whole update process, such
	  // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
	  update: 'none'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _traversalHelper = __webpack_require__(366);
	
	var eachAfter = _traversalHelper.eachAfter;
	var eachBefore = _traversalHelper.eachBefore;
	
	var _layoutHelper = __webpack_require__(363);
	
	var init = _layoutHelper.init;
	var firstWalk = _layoutHelper.firstWalk;
	var secondWalk = _layoutHelper.secondWalk;
	var sep = _layoutHelper.separation;
	var radialCoordinate = _layoutHelper.radialCoordinate;
	var getViewRect = _layoutHelper.getViewRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	function commonLayout(seriesModel, api) {
	  var layoutInfo = getViewRect(seriesModel, api);
	  seriesModel.layoutInfo = layoutInfo;
	  var layout = seriesModel.get('layout');
	  var width = 0;
	  var height = 0;
	  var separation = null;
	
	  if (layout === 'radial') {
	    width = 2 * Math.PI;
	    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	    separation = sep(function (node1, node2) {
	      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	    });
	  } else {
	    width = layoutInfo.width;
	    height = layoutInfo.height;
	    separation = sep();
	  }
	
	  var virtualRoot = seriesModel.getData().tree.root;
	  var realRoot = virtualRoot.children[0];
	
	  if (realRoot) {
	    init(virtualRoot);
	    eachAfter(realRoot, firstWalk, separation);
	    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	    eachBefore(realRoot, secondWalk);
	    var left = realRoot;
	    var right = realRoot;
	    var bottom = realRoot;
	    eachBefore(realRoot, function (node) {
	      var x = node.getLayout().x;
	
	      if (x < left.getLayout().x) {
	        left = node;
	      }
	
	      if (x > right.getLayout().x) {
	        right = node;
	      }
	
	      if (node.depth > bottom.depth) {
	        bottom = node;
	      }
	    });
	    var delta = left === right ? 1 : separation(left, right) / 2;
	    var tx = delta - left.getLayout().x;
	    var kx = 0;
	    var ky = 0;
	    var coorX = 0;
	    var coorY = 0;
	
	    if (layout === 'radial') {
	      kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	      ky = height / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorX = (node.getLayout().x + tx) * kx;
	        coorY = (node.depth - 1) * ky;
	        var finalCoor = radialCoordinate(coorX, coorY);
	        node.setLayout({
	          x: finalCoor.x,
	          y: finalCoor.y,
	          rawX: coorX,
	          rawY: coorY
	        }, true);
	      });
	    } else {
	      var orient = seriesModel.getOrient();
	
	      if (orient === 'RL' || orient === 'LR') {
	        ky = height / (right.getLayout().x + delta + tx);
	        kx = width / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorY = (node.getLayout().x + tx) * ky;
	          coorX = orient === 'LR' ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      } else if (orient === 'TB' || orient === 'BT') {
	        kx = width / (right.getLayout().x + delta + tx);
	        ky = height / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorX = (node.getLayout().x + tx) * kx;
	          coorY = orient === 'TB' ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      }
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Traverse the tree from bottom to top and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	function eachAfter(root, callback, separation) {
	  var nodes = [root];
	  var next = [];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    next.push(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = 0; i < children.length; i++) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	
	  while (node = next.pop()) {
	    // jshint ignore:line
	    callback(node, separation);
	  }
	}
	/**
	 * Traverse the tree from top to bottom and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	
	
	function eachBefore(root, callback) {
	  var nodes = [root];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    callback(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = children.length - 1; i >= 0; i--) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	}
	
	exports.eachAfter = eachAfter;
	exports.eachBefore = eachBefore;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(368);
	
	__webpack_require__(370);
	
	__webpack_require__(373);
	
	var treemapVisual = __webpack_require__(374);
	
	var treemapLayout = __webpack_require__(376);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(treemapVisual);
	echarts.registerLayout(treemapLayout);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var SeriesModel = __webpack_require__(233);
	
	var Tree = __webpack_require__(360);
	
	var Model = __webpack_require__(174);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var _treeHelper = __webpack_require__(369);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.treemap',
	  layoutMode: 'box',
	  dependencies: ['grid', 'polar'],
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  defaultOption: {
	    // Disable progressive rendering
	    progressive: 0,
	    hoverLayerThreshold: Infinity,
	    // center: ['50%', '50%'],          // not supported in ec3.
	    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	    left: 'center',
	    top: 'middle',
	    right: null,
	    bottom: null,
	    width: '80%',
	    height: '80%',
	    sort: true,
	    // Can be null or false or true
	    // (order by desc default, asc not supported yet (strange effect))
	    clipWindow: 'origin',
	    // Size of clipped window when zooming. 'origin' or 'fullscreen'
	    squareRatio: 0.5 * (1 + Math.sqrt(5)),
	    // golden ratio
	    leafDepth: null,
	    // Nodes on depth from root are regarded as leaves.
	    // Count from zero (zero represents only view root).
	    drillDownIcon: '▶',
	    // Use html character temporarily because it is complicated
	    // to align specialized icon. ▷▶❒❐▼✚
	    zoomToNodeRatio: 0.32 * 0.32,
	    // Be effective when using zoomToNode. Specify the proportion of the
	    // target node area in the view area.
	    roam: true,
	    // true, false, 'scale' or 'zoom', 'move'.
	    nodeClick: 'zoomToNode',
	    // Leaf node click behaviour: 'zoomToNode', 'link', false.
	    // If leafDepth is set and clicking a node which has children but
	    // be on left depth, the behaviour would be changing root. Otherwise
	    // use behavious defined above.
	    animation: true,
	    animationDurationUpdate: 900,
	    animationEasing: 'quinticInOut',
	    breadcrumb: {
	      show: true,
	      height: 22,
	      left: 'center',
	      top: 'bottom',
	      // right
	      // bottom
	      emptyItemWidth: 25,
	      // Width of empty node.
	      itemStyle: {
	        color: 'rgba(0,0,0,0.7)',
	        //'#5793f3',
	        borderColor: 'rgba(255,255,255,0.7)',
	        borderWidth: 1,
	        shadowColor: 'rgba(150,150,150,1)',
	        shadowBlur: 3,
	        shadowOffsetX: 0,
	        shadowOffsetY: 0,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      emphasis: {
	        textStyle: {}
	      }
	    },
	    label: {
	      show: true,
	      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	      distance: 0,
	      padding: 5,
	      position: 'inside',
	      // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true // align
	      // verticalAlign
	
	    },
	    upperLabel: {
	      // Label when node is parent.
	      show: false,
	      position: [0, '50%'],
	      height: 20,
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true,
	      // align: null,
	      verticalAlign: 'middle'
	    },
	    itemStyle: {
	      color: null,
	      // Can be 'none' if not necessary.
	      colorAlpha: null,
	      // Can be 'none' if not necessary.
	      colorSaturation: null,
	      // Can be 'none' if not necessary.
	      borderWidth: 0,
	      gapWidth: 0,
	      borderColor: '#fff',
	      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	      // border color is evaluated by color of current node and
	      // borderColorSaturation.
	
	    },
	    emphasis: {
	      upperLabel: {
	        show: true,
	        position: [0, '50%'],
	        color: '#fff',
	        ellipsis: true,
	        verticalAlign: 'middle'
	      }
	    },
	    visualDimension: 0,
	    // Can be 0, 1, 2, 3.
	    visualMin: null,
	    visualMax: null,
	    color: [],
	    // + treemapSeries.color should not be modified. Please only modified
	    // level[n].color (if necessary).
	    // + Specify color list of each level. level[0].color would be global
	    // color list if not specified. (see method `setDefault`).
	    // + But set as a empty array to forbid fetch color from global palette
	    // when using nodeModel.get('color'), otherwise nodes on deep level
	    // will always has color palette set and are not able to inherit color
	    // from parent node.
	    // + TreemapSeries.color can not be set as 'none', otherwise effect
	    // legend color fetching (see seriesColor.js).
	    colorAlpha: null,
	    // Array. Specify color alpha range of each level, like [0.2, 0.8]
	    colorSaturation: null,
	    // Array. Specify color saturation of each level, like [0.2, 0.5]
	    colorMappingBy: 'index',
	    // 'value' or 'index' or 'id'.
	    visibleMin: 10,
	    // If area less than this threshold (unit: pixel^2), node will not
	    // be rendered. Only works when sort is 'asc' or 'desc'.
	    childrenVisibleMin: null,
	    // If area of a node less than this threshold (unit: pixel^2),
	    // grandchildren will not show.
	    // Why grandchildren? If not grandchildren but children,
	    // some siblings show children and some not,
	    // the appearance may be mess and not consistent,
	    levels: [] // Each item: {
	    //     visibleMin, itemStyle, visualDimension, label
	    // }
	    // data: {
	    //      value: [],
	    //      children: [],
	    //      link: 'http://xxx.xxx.xxx',
	    //      target: 'blank' or 'self'
	    // }
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || [];
	    levels = option.levels = setDefault(levels, ecModel);
	    var treeOption = {};
	    treeOption.levels = levels; // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    return Tree.createTree(root, this, treeOption).data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   * @param {boolean} [mutipleSeries=false]
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
	    var name = data.getName(dataIndex);
	    return encodeHTML(name + ': ' + formattedValue);
	  },
	
	  /**
	   * Add tree path to tooltip param
	   *
	   * @override
	   * @param {number} dataIndex
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	
	  /**
	   * @public
	   * @param {Object} layoutInfo {
	   *                                x: containerGroup x
	   *                                y: containerGroup y
	   *                                width: containerGroup width
	   *                                height: containerGroup height
	   *                            }
	   */
	  setLayoutInfo: function (layoutInfo) {
	    /**
	     * @readOnly
	     * @type {Object}
	     */
	    this.layoutInfo = this.layoutInfo || {};
	    zrUtil.extend(this.layoutInfo, layoutInfo);
	  },
	
	  /**
	   * @param  {string} id
	   * @return {number} index
	   */
	  mapIdToIndex: function (id) {
	    // A feature is implemented:
	    // index is monotone increasing with the sequence of
	    // input id at the first time.
	    // This feature can make sure that each data item and its
	    // mapped color have the same index between data list and
	    // color list at the beginning, which is useful for user
	    // to adjust data-color mapping.
	
	    /**
	     * @private
	     * @type {Object}
	     */
	    var idIndexMap = this._idIndexMap;
	
	    if (!idIndexMap) {
	      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
	      /**
	       * @private
	       * @type {number}
	       */
	
	      this._idIndexMapCount = 0;
	    }
	
	    var index = idIndexMap.get(id);
	
	    if (index == null) {
	      idIndexMap.set(id, index = this._idIndexMapCount++);
	    }
	
	    return index;
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	/**
	 * set default to level configuration
	 */
	
	
	function setDefault(levels, ecModel) {
	  var globalColorList = ecModel.get('color');
	
	  if (!globalColorList) {
	    return;
	  }
	
	  levels = levels || [];
	  var hasColorDefine;
	  zrUtil.each(levels, function (levelDefine) {
	    var model = new Model(levelDefine);
	    var modelColor = model.get('color');
	
	    if (model.get('itemStyle.color') || modelColor && modelColor !== 'none') {
	      hasColorDefine = true;
	    }
	  });
	
	  if (!hasColorDefine) {
	    var level0 = levels[0] || (levels[0] = {});
	    level0.color = globalColorList.slice();
	  }
	
	  return levels;
	}
	
	module.exports = _default;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
	  if (payload && zrUtil.indexOf(validPayloadTypes, payload.type) >= 0) {
	    var root = seriesModel.getData().tree.root;
	    var targetNode = payload.targetNode;
	
	    if (typeof targetNode === 'string') {
	      targetNode = root.getNodeById(targetNode);
	    }
	
	    if (targetNode && root.contains(targetNode)) {
	      return {
	        node: targetNode
	      };
	    }
	
	    var targetNodeId = payload.targetNodeId;
	
	    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	      return {
	        node: targetNode
	      };
	    }
	  }
	} // Not includes the given node at the last item.
	
	
	function getPathToRoot(node) {
	  var path = [];
	
	  while (node) {
	    node = node.parentNode;
	    node && path.push(node);
	  }
	
	  return path.reverse();
	}
	
	function aboveViewRoot(viewRoot, node) {
	  var viewPath = getPathToRoot(viewRoot);
	  return zrUtil.indexOf(viewPath, node) >= 0;
	} // From root to the input node (the input node will be included).
	
	
	function wrapTreePathInfo(node, seriesModel) {
	  var treePathInfo = [];
	
	  while (node) {
	    var nodeDataIndex = node.dataIndex;
	    treePathInfo.push({
	      name: node.name,
	      dataIndex: nodeDataIndex,
	      value: seriesModel.getRawValue(nodeDataIndex)
	    });
	    node = node.parentNode;
	  }
	
	  treePathInfo.reverse();
	  return treePathInfo;
	}
	
	exports.retrieveTargetInfo = retrieveTargetInfo;
	exports.getPathToRoot = getPathToRoot;
	exports.aboveViewRoot = aboveViewRoot;
	exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var DataDiffer = __webpack_require__(256);
	
	var helper = __webpack_require__(369);
	
	var Breadcrumb = __webpack_require__(371);
	
	var RoamController = __webpack_require__(345);
	
	var BoundingRect = __webpack_require__(154);
	
	var matrix = __webpack_require__(145);
	
	var animationUtil = __webpack_require__(372);
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var Group = graphic.Group;
	var Rect = graphic.Rect;
	var each = zrUtil.each;
	var DRAG_THRESHOLD = 3;
	var PATH_LABEL_NOAMAL = ['label'];
	var PATH_LABEL_EMPHASIS = ['emphasis', 'label'];
	var PATH_UPPERLABEL_NORMAL = ['upperLabel'];
	var PATH_UPPERLABEL_EMPHASIS = ['emphasis', 'upperLabel'];
	var Z_BASE = 10; // Should bigger than every z.
	
	var Z_BG = 1;
	var Z_CONTENT = 2;
	var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	// so use `stroke` to indicate the stroke of the rect.
	['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	
	var getItemStyleNormal = function (model) {
	  // Normal style props should include emphasis style props.
	  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.
	
	  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	  return itemStyle;
	};
	
	var _default = echarts.extendChartView({
	  type: 'treemap',
	
	  /**
	   * @override
	   */
	  init: function (o, api) {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this._containerGroup;
	    /**
	     * @private
	     * @type {Object.<string, Array.<module:zrender/container/Group>>}
	     */
	
	    this._storage = createStorage();
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:echarts/chart/treemap/Breadcrumb}
	     */
	
	    this._breadcrumb;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/RoamController}
	     */
	
	    this._controller;
	    /**
	     * 'ready', 'animating'
	     * @private
	     */
	
	    this._state = 'ready';
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var models = ecModel.findComponents({
	      mainType: 'series',
	      subType: 'treemap',
	      query: payload
	    });
	
	    if (zrUtil.indexOf(models, seriesModel) < 0) {
	      return;
	    }
	
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var payloadType = payload && payload.type;
	    var layoutInfo = seriesModel.layoutInfo;
	    var isInit = !this._oldTree;
	    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	      direction: payload.direction
	    } : null;
	
	    var containerGroup = this._giveContainerGroup(layoutInfo);
	
	    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	    this._resetController(api);
	
	    this._renderBreadcrumb(seriesModel, api, targetInfo);
	  },
	
	  /**
	   * @private
	   */
	  _giveContainerGroup: function (layoutInfo) {
	    var containerGroup = this._containerGroup;
	
	    if (!containerGroup) {
	      // FIXME
	      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	      containerGroup = this._containerGroup = new Group();
	
	      this._initEvents(containerGroup);
	
	      this.group.add(containerGroup);
	    }
	
	    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
	    return containerGroup;
	  },
	
	  /**
	   * @private
	   */
	  _doRender: function (containerGroup, seriesModel, reRoot) {
	    var thisTree = seriesModel.getData().tree;
	    var oldTree = this._oldTree; // Clear last shape records.
	
	    var lastsForAnimation = createStorage();
	    var thisStorage = createStorage();
	    var oldStorage = this._storage;
	    var willInvisibleEls = [];
	    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
	    // the oldTree is actually losted, so we can not find all of the old graphic
	    // elements from tree. So we use this stragegy: make element storage, move
	    // from old storage to new storage, clear old storage.
	
	    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	    var willDeleteEls = clearStorage(oldStorage);
	    this._oldTree = thisTree;
	    this._storage = thisStorage;
	    return {
	      lastsForAnimation: lastsForAnimation,
	      willDeleteEls: willDeleteEls,
	      renderFinally: renderFinally
	    };
	
	    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	      // When 'render' is triggered by action,
	      // 'this' and 'old' may be the same tree,
	      // we use rawIndex in that case.
	      if (sameTree) {
	        oldViewChildren = thisViewChildren;
	        each(thisViewChildren, function (child, index) {
	          !child.isRemoved() && processNode(index, index);
	        });
	      } // Diff hierarchically (diff only in each subtree, but not whole).
	      // because, consistency of view is important.
	      else {
	          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	        }
	
	      function getKey(node) {
	        // Identify by name or raw index.
	        return node.getId();
	      }
	
	      function processNode(newIndex, oldIndex) {
	        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	      }
	    }
	
	    function clearStorage(storage) {
	      var willDeleteEls = createStorage();
	      storage && each(storage, function (store, storageName) {
	        var delEls = willDeleteEls[storageName];
	        each(store, function (el) {
	          el && (delEls.push(el), el.__tmWillDelete = 1);
	        });
	      });
	      return willDeleteEls;
	    }
	
	    function renderFinally() {
	      each(willDeleteEls, function (els) {
	        each(els, function (el) {
	          el.parent && el.parent.remove(el);
	        });
	      });
	      each(willInvisibleEls, function (el) {
	        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	        // just mark as invisible.
	
	        el.dirty();
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
	    if (!seriesModel.get('animation')) {
	      return;
	    }
	
	    var duration = seriesModel.get('animationDurationUpdate');
	    var easing = seriesModel.get('animationEasing');
	    var animationWrap = animationUtil.createWrap(); // Make delete animations.
	
	    each(renderResult.willDeleteEls, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        if (el.invisible) {
	          return;
	        }
	
	        var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	        var target;
	
	        if (reRoot && reRoot.direction === 'drillDown') {
	          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	          // Only `content` will enter this branch, because
	          // `background` and `nodeGroup` will not be deleted.
	          ? {
	            shape: {
	              x: 0,
	              y: 0,
	              width: parent.__tmNodeWidth,
	              height: parent.__tmNodeHeight
	            },
	            style: {
	              opacity: 0
	            } // Others.
	
	          } : {
	            style: {
	              opacity: 0
	            }
	          };
	        } else {
	          var targetX = 0;
	          var targetY = 0;
	
	          if (!parent.__tmWillDelete) {
	            // Let node animate to right-bottom corner, cooperating with fadeout,
	            // which is appropriate for user understanding.
	            // Divided by 2 for reRoot rolling up effect.
	            targetX = parent.__tmNodeWidth / 2;
	            targetY = parent.__tmNodeHeight / 2;
	          }
	
	          target = storageName === 'nodeGroup' ? {
	            position: [targetX, targetY],
	            style: {
	              opacity: 0
	            }
	          } : {
	            shape: {
	              x: targetX,
	              y: targetY,
	              width: 0,
	              height: 0
	            },
	            style: {
	              opacity: 0
	            }
	          };
	        }
	
	        target && animationWrap.add(el, target, duration, easing);
	      });
	    }); // Make other animations
	
	    each(this._storage, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        var last = renderResult.lastsForAnimation[storageName][rawIndex];
	        var target = {};
	
	        if (!last) {
	          return;
	        }
	
	        if (storageName === 'nodeGroup') {
	          if (last.old) {
	            target.position = el.position.slice();
	            el.attr('position', last.old);
	          }
	        } else {
	          if (last.old) {
	            target.shape = zrUtil.extend({}, el.shape);
	            el.setShape(last.old);
	          }
	
	          if (last.fadein) {
	            el.setStyle('opacity', 0);
	            target.style = {
	              opacity: 1
	            };
	          } // When animation is stopped for succedent animation starting,
	          // el.style.opacity might not be 1
	          else if (el.style.opacity !== 1) {
	              target.style = {
	                opacity: 1
	              };
	            }
	        }
	
	        animationWrap.add(el, target, duration, easing);
	      });
	    }, this);
	    this._state = 'animating';
	    animationWrap.done(bind(function () {
	      this._state = 'ready';
	      renderResult.renderFinally();
	    }, this)).start();
	  },
	
	  /**
	   * @private
	   */
	  _resetController: function (api) {
	    var controller = this._controller; // Init controller.
	
	    if (!controller) {
	      controller = this._controller = new RoamController(api.getZr());
	      controller.enable(this.seriesModel.get('roam'));
	      controller.on('pan', bind(this._onPan, this));
	      controller.on('zoom', bind(this._onZoom, this));
	    }
	
	    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	    controller.setPointerChecker(function (e, x, y) {
	      return rect.contain(x, y);
	    });
	  },
	
	  /**
	   * @private
	   */
	  _clearController: function () {
	    var controller = this._controller;
	
	    if (controller) {
	      controller.dispose();
	      controller = null;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (e) {
	    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      this.api.dispatchAction({
	        type: 'treemapMove',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rootLayout.x + e.dx,
	          y: rootLayout.y + e.dy,
	          width: rootLayout.width,
	          height: rootLayout.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (e) {
	    var mouseX = e.originX;
	    var mouseY = e.originY;
	
	    if (this._state !== 'animating') {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	      mouseX -= layoutInfo.x;
	      mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	      var m = matrix.create();
	      matrix.translate(m, m, [-mouseX, -mouseY]);
	      matrix.scale(m, m, [e.scale, e.scale]);
	      matrix.translate(m, m, [mouseX, mouseY]);
	      rect.applyTransform(m);
	      this.api.dispatchAction({
	        type: 'treemapRender',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _initEvents: function (containerGroup) {
	    containerGroup.on('click', function (e) {
	      if (this._state !== 'ready') {
	        return;
	      }
	
	      var nodeClick = this.seriesModel.get('nodeClick', true);
	
	      if (!nodeClick) {
	        return;
	      }
	
	      var targetInfo = this.findTarget(e.offsetX, e.offsetY);
	
	      if (!targetInfo) {
	        return;
	      }
	
	      var node = targetInfo.node;
	
	      if (node.getLayout().isLeafRoot) {
	        this._rootToNode(targetInfo);
	      } else {
	        if (nodeClick === 'zoomToNode') {
	          this._zoomToNode(targetInfo);
	        } else if (nodeClick === 'link') {
	          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	          var link = itemModel.get('link', true);
	          var linkTarget = itemModel.get('target', true) || 'blank';
	          link && window.open(link, linkTarget);
	        }
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
	    if (!targetInfo) {
	      targetInfo = seriesModel.get('leafDepth', true) != null ? {
	        node: seriesModel.getViewRoot() // FIXME
	        // better way?
	        // Find breadcrumb tail on center of containerGroup.
	
	      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	      if (!targetInfo) {
	        targetInfo = {
	          node: seriesModel.getData().tree.root
	        };
	      }
	    }
	
	    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));
	
	    function onSelect(node) {
	      if (this._state !== 'animating') {
	        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
	          node: node
	        }) : this._zoomToNode({
	          node: node
	        });
	      }
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearController();
	
	    this._containerGroup && this._containerGroup.removeAll();
	    this._storage = createStorage();
	    this._state = 'ready';
	    this._breadcrumb && this._breadcrumb.remove();
	  },
	  dispose: function () {
	    this._clearController();
	  },
	
	  /**
	   * @private
	   */
	  _zoomToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapZoomToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapRootToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @public
	   * @param {number} x Global coord x.
	   * @param {number} y Global coord y.
	   * @return {Object} info If not found, return undefined;
	   * @return {number} info.node Target node.
	   * @return {number} info.offsetX x refer to target node.
	   * @return {number} info.offsetY y refer to target node.
	   */
	  findTarget: function (x, y) {
	    var targetInfo;
	    var viewRoot = this.seriesModel.getViewRoot();
	    viewRoot.eachNode({
	      attr: 'viewChildren',
	      order: 'preorder'
	    }, function (node) {
	      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	      if (bgEl) {
	        var point = bgEl.transformCoordToLocal(x, y);
	        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
	
	        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	          targetInfo = {
	            node: node,
	            offsetX: point[0],
	            offsetY: point[1]
	          };
	        } else {
	          return false; // Suppress visit subtree.
	        }
	      }
	    }, this);
	    return targetInfo;
	  }
	});
	/**
	 * @inner
	 */
	
	
	function createStorage() {
	  return {
	    nodeGroup: [],
	    background: [],
	    content: []
	  };
	}
	/**
	 * @inner
	 * @return Return undefined means do not travel further.
	 */
	
	
	function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	  // Whether under viewRoot.
	  if (!thisNode) {
	    // Deleting nodes will be performed finally. This method just find
	    // element from old storage, or create new element, set them to new
	    // storage, and set styles.
	    return;
	  } // -------------------------------------------------------------------
	  // Start of closure variables available in "Procedures in renderNode".
	
	
	  var thisLayout = thisNode.getLayout();
	
	  if (!thisLayout || !thisLayout.isInView) {
	    return;
	  }
	
	  var thisWidth = thisLayout.width;
	  var thisHeight = thisLayout.height;
	  var borderWidth = thisLayout.borderWidth;
	  var thisInvisible = thisLayout.invisible;
	  var thisRawIndex = thisNode.getRawIndex();
	  var oldRawIndex = oldNode && oldNode.getRawIndex();
	  var thisViewChildren = thisNode.viewChildren;
	  var upperHeight = thisLayout.upperHeight;
	  var isParent = thisViewChildren && thisViewChildren.length;
	  var itemStyleNormalModel = thisNode.getModel('itemStyle');
	  var itemStyleEmphasisModel = thisNode.getModel('emphasis.itemStyle'); // End of closure ariables available in "Procedures in renderNode".
	  // -----------------------------------------------------------------
	  // Node group
	
	  var group = giveGraphic('nodeGroup', Group);
	
	  if (!group) {
	    return;
	  }
	
	  parentGroup.add(group); // x,y are not set when el is above view root.
	
	  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
	  group.__tmNodeWidth = thisWidth;
	  group.__tmNodeHeight = thisHeight;
	
	  if (thisLayout.isAboveViewRoot) {
	    return group;
	  } // Background
	
	
	  var bg = giveGraphic('background', Rect, depth, Z_BG);
	  bg && renderBackground(group, bg, isParent && thisLayout.upperHeight); // No children, render content.
	
	  if (!isParent) {
	    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
	    content && renderContent(group, content);
	  }
	
	  return group; // ----------------------------
	  // | Procedures in renderNode |
	  // ----------------------------
	
	  function renderBackground(group, bg, useUpperLabel) {
	    // For tooltip.
	    bg.dataIndex = thisNode.dataIndex;
	    bg.seriesIndex = seriesModel.seriesIndex;
	    bg.setShape({
	      x: 0,
	      y: 0,
	      width: thisWidth,
	      height: thisHeight
	    });
	    var visualBorderColor = thisNode.getVisual('borderColor', true);
	    var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
	    updateStyle(bg, function () {
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualBorderColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      emphasisStyle.fill = emphasisBorderColor;
	
	      if (useUpperLabel) {
	        var upperLabelWidth = thisWidth - 2 * borderWidth;
	        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
	          x: borderWidth,
	          y: 0,
	          width: upperLabelWidth,
	          height: upperHeight
	        });
	      } // For old bg.
	      else {
	          normalStyle.text = emphasisStyle.text = null;
	        }
	
	      bg.setStyle(normalStyle);
	      graphic.setHoverStyle(bg, emphasisStyle);
	    });
	    group.add(bg);
	  }
	
	  function renderContent(group, content) {
	    // For tooltip.
	    content.dataIndex = thisNode.dataIndex;
	    content.seriesIndex = seriesModel.seriesIndex;
	    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	    content.culling = true;
	    content.setShape({
	      x: borderWidth,
	      y: borderWidth,
	      width: contentWidth,
	      height: contentHeight
	    });
	    var visualColor = thisNode.getVisual('color', true);
	    updateStyle(content, function () {
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
	      content.setStyle(normalStyle);
	      graphic.setHoverStyle(content, emphasisStyle);
	    });
	    group.add(content);
	  }
	
	  function updateStyle(element, cb) {
	    if (!thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      cb();
	
	      if (!element.__tmWillVisible) {
	        element.invisible = false;
	      }
	    } else {
	      // Delay invisible setting utill animation finished,
	      // avoid element vanish suddenly before animation.
	      !element.invisible && willInvisibleEls.push(element);
	    }
	  }
	
	  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
	    var nodeModel = thisNode.getModel();
	    var text = zrUtil.retrieve(seriesModel.getFormattedLabel(thisNode.dataIndex, 'normal', null, null, upperLabelRect ? 'upperLabel' : 'label'), nodeModel.get('name'));
	
	    if (!upperLabelRect && thisLayout.isLeafRoot) {
	      var iconChar = seriesModel.get('drillDownIcon', true);
	      text = iconChar ? iconChar + ' ' + text : text;
	    }
	
	    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
	    var isShow = normalLabelModel.getShallow('show');
	    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
	      defaultText: isShow ? text : null,
	      autoColor: visualColor,
	      isRectText: true
	    });
	    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
	    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
	      outerWidth: width,
	      outerHeight: height,
	      minChar: 2
	    } : null;
	  }
	
	  function giveGraphic(storageName, Ctor, depth, z) {
	    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	    var lasts = lastsForAnimation[storageName];
	
	    if (element) {
	      // Remove from oldStorage
	      oldStorage[storageName][oldRawIndex] = null;
	      prepareAnimationWhenHasOld(lasts, element, storageName);
	    } // If invisible and no old element, do not create new element (for optimizing).
	    else if (!thisInvisible) {
	        element = new Ctor({
	          z: calculateZ(depth, z)
	        });
	        element.__tmDepth = depth;
	        element.__tmStorageName = storageName;
	        prepareAnimationWhenNoOld(lasts, element, storageName);
	      } // Set to thisStorage
	
	
	    return thisStorage[storageName][thisRawIndex] = element;
	  }
	
	  function prepareAnimationWhenHasOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
	  } // If a element is new, we need to find the animation start point carefully,
	  // otherwise it will looks strange when 'zoomToNode'.
	
	
	  function prepareAnimationWhenNoOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    var parentNode = thisNode.parentNode;
	
	    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	      var parentOldX = 0;
	      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	      // For convenience, get old bounding rect from background.
	
	      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	      if (!reRoot && parentOldBg && parentOldBg.old) {
	        parentOldX = parentOldBg.old.width;
	        parentOldY = parentOldBg.old.height;
	      } // When no parent old shape found, its parent is new too,
	      // so we can just use {x:0, y:0}.
	
	
	      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
	        x: parentOldX,
	        y: parentOldY,
	        width: 0,
	        height: 0
	      };
	    } // Fade in, user can be aware that these nodes are new.
	
	
	    lastCfg.fadein = storageName !== 'nodeGroup';
	  }
	} // We can not set all backgroud with the same z, Because the behaviour of
	// drill down and roll up differ background creation sequence from tree
	// hierarchy sequence, which cause that lowser background element overlap
	// upper ones. So we calculate z based on depth.
	// Moreover, we try to shrink down z interval to [0, 1] to avoid that
	// treemap with large z overlaps other components.
	
	
	function calculateZ(depth, zInLevel) {
	  var zb = depth * Z_BASE + zInLevel;
	  return (zb - 1) / zb;
	}
	
	module.exports = _default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var layout = __webpack_require__(217);
	
	var zrUtil = __webpack_require__(134);
	
	var _treeHelper = __webpack_require__(369);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TEXT_PADDING = 8;
	var ITEM_GAP = 8;
	var ARRAY_LENGTH = 5;
	
	function Breadcrumb(containerGroup) {
	  /**
	   * @private
	   * @type {module:zrender/container/Group}
	   */
	  this.group = new graphic.Group();
	  containerGroup.add(this.group);
	}
	
	Breadcrumb.prototype = {
	  constructor: Breadcrumb,
	  render: function (seriesModel, api, targetNode, onSelect) {
	    var model = seriesModel.getModel('breadcrumb');
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    if (!model.get('show') || !targetNode) {
	      return;
	    }
	
	    var normalStyleModel = model.getModel('itemStyle'); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');
	
	    var textStyleModel = normalStyleModel.getModel('textStyle');
	    var layoutParam = {
	      pos: {
	        left: model.get('left'),
	        right: model.get('right'),
	        top: model.get('top'),
	        bottom: model.get('bottom')
	      },
	      box: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      emptyItemWidth: model.get('emptyItemWidth'),
	      totalWidth: 0,
	      renderList: []
	    };
	
	    this._prepare(targetNode, layoutParam, textStyleModel);
	
	    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
	
	    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	  },
	
	  /**
	   * Prepare render list and total width
	   * @private
	   */
	  _prepare: function (targetNode, layoutParam, textStyleModel) {
	    for (var node = targetNode; node; node = node.parentNode) {
	      var text = node.getModel().get('name');
	      var textRect = textStyleModel.getTextRect(text);
	      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	      layoutParam.totalWidth += itemWidth + ITEM_GAP;
	      layoutParam.renderList.push({
	        node: node,
	        text: text,
	        width: itemWidth
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
	    // Start rendering.
	    var lastX = 0;
	    var emptyItemWidth = layoutParam.emptyItemWidth;
	    var height = seriesModel.get('breadcrumb.height');
	    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
	    var totalWidth = layoutParam.totalWidth;
	    var renderList = layoutParam.renderList;
	
	    for (var i = renderList.length - 1; i >= 0; i--) {
	      var item = renderList[i];
	      var itemNode = item.node;
	      var itemWidth = item.width;
	      var text = item.text; // Hdie text and shorten width if necessary.
	
	      if (totalWidth > availableSize.width) {
	        totalWidth -= itemWidth - emptyItemWidth;
	        itemWidth = emptyItemWidth;
	        text = null;
	      }
	
	      var el = new graphic.Polygon({
	        shape: {
	          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	        },
	        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
	          lineJoin: 'bevel',
	          text: text,
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        }),
	        z: 10,
	        onclick: zrUtil.curry(onSelect, itemNode)
	      });
	      this.group.add(el);
	      packEventData(el, seriesModel, itemNode);
	      lastX += itemWidth + ITEM_GAP;
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this.group.removeAll();
	  }
	};
	
	function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	  !head && points.push([x, y + itemHeight / 2]);
	  return points;
	} // Package custom mouse event.
	
	
	function packEventData(el, seriesModel, itemNode) {
	  el.eventData = {
	    componentType: 'series',
	    componentSubType: 'treemap',
	    componentIndex: seriesModel.componentIndex,
	    seriesIndex: seriesModel.componentIndex,
	    seriesName: seriesModel.name,
	    seriesType: 'treemap',
	    selfType: 'breadcrumb',
	    // Distinguish with click event on treemap node.
	    nodeData: {
	      dataIndex: itemNode && itemNode.dataIndex,
	      name: itemNode && itemNode.name
	    },
	    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	  };
	}
	
	var _default = Breadcrumb;
	module.exports = _default;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {number} [time=500] Time in ms
	 * @param {string} [easing='linear']
	 * @param {number} [delay=0]
	 * @param {Function} [callback]
	 *
	 * @example
	 *  // Animate position
	 *  animation
	 *      .createWrap()
	 *      .add(el1, {position: [10, 10]})
	 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	 *      .done(function () { // done })
	 *      .start('cubicOut');
	 */
	function createWrap() {
	  var storage = [];
	  var elExistsMap = {};
	  var doneCallback;
	  return {
	    /**
	     * Caution: a el can only be added once, otherwise 'done'
	     * might not be called. This method checks this (by el.id),
	     * suppresses adding and returns false when existing el found.
	     *
	     * @param {modele:zrender/Element} el
	     * @param {Object} target
	     * @param {number} [time=500]
	     * @param {number} [delay=0]
	     * @param {string} [easing='linear']
	     * @return {boolean} Whether adding succeeded.
	     *
	     * @example
	     *     add(el, target, time, delay, easing);
	     *     add(el, target, time, easing);
	     *     add(el, target, time);
	     *     add(el, target);
	     */
	    add: function (el, target, time, delay, easing) {
	      if (zrUtil.isString(delay)) {
	        easing = delay;
	        delay = 0;
	      }
	
	      if (elExistsMap[el.id]) {
	        return false;
	      }
	
	      elExistsMap[el.id] = 1;
	      storage.push({
	        el: el,
	        target: target,
	        time: time,
	        delay: delay,
	        easing: easing
	      });
	      return true;
	    },
	
	    /**
	     * Only execute when animation finished. Will not execute when any
	     * of 'stop' or 'stopAnimation' called.
	     *
	     * @param {Function} callback
	     */
	    done: function (callback) {
	      doneCallback = callback;
	      return this;
	    },
	
	    /**
	     * Will stop exist animation firstly.
	     */
	    start: function () {
	      var count = storage.length;
	
	      for (var i = 0, len = storage.length; i < len; i++) {
	        var item = storage[i];
	        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
	      }
	
	      return this;
	
	      function done() {
	        count--;
	
	        if (!count) {
	          storage.length = 0;
	          elExistsMap = {};
	          doneCallback && doneCallback();
	        }
	      }
	    }
	  };
	}
	
	exports.createWrap = createWrap;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var helper = __webpack_require__(369);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Treemap action
	 */
	var noop = function () {};
	
	var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	
	for (var i = 0; i < actionTypes.length; i++) {
	  echarts.registerAction({
	    type: actionTypes[i],
	    update: 'updateView'
	  }, noop);
	}
	
	echarts.registerAction({
	  type: 'treemapRootToNode',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(375);
	
	var zrColor = __webpack_require__(150);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var isArray = zrUtil.isArray;
	var ITEM_STYLE_NORMAL = 'itemStyle';
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    var tree = seriesModel.getData().tree;
	    var root = tree.root;
	    var seriesItemStyleModel = seriesModel.getModel(ITEM_STYLE_NORMAL);
	
	    if (root.isRemoved()) {
	      return;
	    }
	
	    var levelItemStyles = zrUtil.map(tree.levelModels, function (levelModel) {
	      return levelModel ? levelModel.get(ITEM_STYLE_NORMAL) : null;
	    });
	    travelTree(root, // Visual should calculate from tree root but not view root.
	    {}, levelItemStyles, seriesItemStyleModel, seriesModel.getViewRoot().getAncestors(), seriesModel);
	  }
	};
	
	function travelTree(node, designatedVisual, levelItemStyles, seriesItemStyleModel, viewRootAncestors, seriesModel) {
	  var nodeModel = node.getModel();
	  var nodeLayout = node.getLayout(); // Optimize
	
	  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	    return;
	  }
	
	  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
	  var levelItemStyle = levelItemStyles[node.depth];
	  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, levelItemStyle, seriesItemStyleModel); // calculate border color
	
	  var borderColor = nodeItemStyleModel.get('borderColor');
	  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	  var thisNodeColor;
	
	  if (borderColorSaturation != null) {
	    // For performance, do not always execute 'calculateColor'.
	    thisNodeColor = calculateColor(visuals, node);
	    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	  }
	
	  node.setVisual('borderColor', borderColor);
	  var viewChildren = node.viewChildren;
	
	  if (!viewChildren || !viewChildren.length) {
	    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.
	
	    node.setVisual('color', thisNodeColor);
	  } else {
	    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	    zrUtil.each(viewChildren, function (child, index) {
	      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
	        travelTree(child, childVisual, levelItemStyles, seriesItemStyleModel, viewRootAncestors, seriesModel);
	      }
	    });
	  }
	}
	
	function buildVisuals(nodeItemStyleModel, designatedVisual, levelItemStyle, seriesItemStyleModel) {
	  var visuals = zrUtil.extend({}, designatedVisual);
	  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	    var val = nodeItemStyleModel.get(visualName, true); // Ignore parent
	
	    val == null && levelItemStyle && (val = levelItemStyle[visualName]);
	    val == null && (val = designatedVisual[visualName]);
	    val == null && (val = seriesItemStyleModel.get(visualName));
	    val != null && (visuals[visualName] = val);
	  });
	  return visuals;
	}
	
	function calculateColor(visuals) {
	  var color = getValueVisualDefine(visuals, 'color');
	
	  if (color) {
	    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	    if (colorSaturation) {
	      color = zrColor.modifyHSL(color, null, null, colorSaturation);
	    }
	
	    if (colorAlpha) {
	      color = zrColor.modifyAlpha(color, colorAlpha);
	    }
	
	    return color;
	  }
	}
	
	function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	}
	
	function getValueVisualDefine(visuals, name) {
	  var value = visuals[name];
	
	  if (value != null && value !== 'none') {
	    return value;
	  }
	}
	
	function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	  if (!viewChildren || !viewChildren.length) {
	    return;
	  }
	
	  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	  if (!rangeVisual) {
	    return;
	  }
	
	  var visualMin = nodeModel.get('visualMin');
	  var visualMax = nodeModel.get('visualMax');
	  var dataExtent = nodeLayout.dataExtent.slice();
	  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	  var colorMappingBy = nodeModel.get('colorMappingBy');
	  var opt = {
	    type: rangeVisual.name,
	    dataExtent: dataExtent,
	    visual: rangeVisual.range
	  };
	
	  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	    opt.mappingMethod = 'category';
	    opt.loop = true; // categories is ordinal, so do not set opt.categories.
	  } else {
	    opt.mappingMethod = 'linear';
	  }
	
	  var mapping = new VisualMapping(opt);
	  mapping.__drColorMappingBy = colorMappingBy;
	  return mapping;
	} // Notice: If we dont have the attribute 'colorRange', but only use
	// attribute 'color' to represent both concepts of 'colorRange' and 'color',
	// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	// this problem will be encountered:
	// If a level-1 node dont have children, and its siblings has children,
	// and colorRange is set on level-1, then the node can not be colored.
	// So we separate 'colorRange' and 'color' to different attributes.
	
	
	function getRangeVisual(nodeModel, name) {
	  // 'colorRange', 'colorARange', 'colorSRange'.
	  // If not exsits on this node, fetch from levels and series.
	  var range = nodeModel.get(name);
	  return isArray(range) && range.length ? {
	    name: name,
	    range: range
	  } : null;
	}
	
	function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	  var childVisuals = zrUtil.extend({}, visuals);
	
	  if (mapping) {
	    var mappingType = mapping.type;
	    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
	    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	    childVisuals[mappingType] = mapping.mapValueToVisual(value);
	  }
	
	  return childVisuals;
	}
	
	module.exports = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var zrColor = __webpack_require__(150);
	
	var _number = __webpack_require__(218);
	
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	/**
	 * @param {Object} option
	 * @param {string} [option.type] See visualHandlers.
	 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
	 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
	 *                                              required when mappingMethod is 'linear'
	 * @param {Array.<Object>=} [option.pieceList] [
	 *                                             {value: someValue},
	 *                                             {interval: [min1, max1], visual: {...}},
	 *                                             {interval: [min2, max2]}
	 *                                             ],
	 *                                            required when mappingMethod is 'piecewise'.
	 *                                            Visual for only each piece can be specified.
	 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
	 *                                            required when mappingMethod is 'category'.
	 *                                            If no option.categories, categories is set
	 *                                            as [0, 1, 2, ...].
	 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
	 * @param {(Array|Object|*)} [option.visual]  Visual data.
	 *                                            when mappingMethod is 'category',
	 *                                            visual data can be array or object
	 *                                            (like: {cate1: '#222', none: '#fff'})
	 *                                            or primary types (which represents
	 *                                            defualt category visual), otherwise visual
	 *                                            can be array or primary (which will be
	 *                                            normalized to array).
	 *
	 */
	
	var VisualMapping = function (option) {
	  var mappingMethod = option.mappingMethod;
	  var visualType = option.type;
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	
	  var thisOption = this.option = zrUtil.clone(option);
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.type = visualType;
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.mappingMethod = mappingMethod;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._normalizeData = normalizers[mappingMethod];
	  var visualHandler = visualHandlers[visualType];
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.applyVisual = visualHandler.applyVisual;
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.getColorMapper = visualHandler.getColorMapper;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._doMap = visualHandler._doMap[mappingMethod];
	
	  if (mappingMethod === 'piecewise') {
	    normalizeVisualRange(thisOption);
	    preprocessForPiecewise(thisOption);
	  } else if (mappingMethod === 'category') {
	    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	    // which need no more preprocess except normalize visual.
	    : normalizeVisualRange(thisOption, true);
	  } else {
	    // mappingMethod === 'linear' or 'fixed'
	    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	    normalizeVisualRange(thisOption);
	  }
	};
	
	VisualMapping.prototype = {
	  constructor: VisualMapping,
	  mapValueToVisual: function (value) {
	    var normalized = this._normalizeData(value);
	
	    return this._doMap(normalized, value);
	  },
	  getNormalizer: function () {
	    return zrUtil.bind(this._normalizeData, this);
	  }
	};
	var visualHandlers = VisualMapping.visualHandlers = {
	  color: {
	    applyVisual: makeApplyVisual('color'),
	
	    /**
	     * Create a mapper function
	     * @return {Function}
	     */
	    getColorMapper: function () {
	      var thisOption = this.option;
	      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	        !isNormalized && (value = this._normalizeData(value));
	        return doMapCategory.call(this, value);
	      } : function (value, isNormalized, out) {
	        // If output rgb array
	        // which will be much faster and useful in pixel manipulation
	        var returnRGBArray = !!out;
	        !isNormalized && (value = this._normalizeData(value));
	        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
	        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
	      }, this);
	    },
	    _doMap: {
	      linear: function (normalized) {
	        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	      },
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  colorHue: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, value);
	  }),
	  colorSaturation: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, value);
	  }),
	  colorLightness: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, null, value);
	  }),
	  colorAlpha: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyAlpha(color, value);
	  }),
	  opacity: {
	    applyVisual: makeApplyVisual('opacity'),
	    _doMap: makeDoMap([0, 1])
	  },
	  liftZ: {
	    applyVisual: makeApplyVisual('liftZ'),
	    _doMap: {
	      linear: doMapFixed,
	      category: doMapFixed,
	      piecewise: doMapFixed,
	      fixed: doMapFixed
	    }
	  },
	  symbol: {
	    applyVisual: function (value, getter, setter) {
	      var symbolCfg = this.mapValueToVisual(value);
	
	      if (zrUtil.isString(symbolCfg)) {
	        setter('symbol', symbolCfg);
	      } else if (isObject(symbolCfg)) {
	        for (var name in symbolCfg) {
	          if (symbolCfg.hasOwnProperty(name)) {
	            setter(name, symbolCfg[name]);
	          }
	        }
	      }
	    },
	    _doMap: {
	      linear: doMapToArray,
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = doMapToArray.call(this, normalized);
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  symbolSize: {
	    applyVisual: makeApplyVisual('symbolSize'),
	    _doMap: makeDoMap([0, 1])
	  }
	};
	
	function preprocessForPiecewise(thisOption) {
	  var pieceList = thisOption.pieceList;
	  thisOption.hasSpecialVisual = false;
	  zrUtil.each(pieceList, function (piece, index) {
	    piece.originIndex = index; // piece.visual is "result visual value" but not
	    // a visual range, so it does not need to be normalized.
	
	    if (piece.visual != null) {
	      thisOption.hasSpecialVisual = true;
	    }
	  });
	}
	
	function preprocessForSpecifiedCategory(thisOption) {
	  // Hash categories.
	  var categories = thisOption.categories;
	  var visual = thisOption.visual;
	  var categoryMap = thisOption.categoryMap = {};
	  each(categories, function (cate, index) {
	    categoryMap[cate] = index;
	  }); // Process visual map input.
	
	  if (!zrUtil.isArray(visual)) {
	    var visualArr = [];
	
	    if (zrUtil.isObject(visual)) {
	      each(visual, function (v, cate) {
	        var index = categoryMap[cate];
	        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	      });
	    } else {
	      // Is primary type, represents default visual.
	      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	    }
	
	    visual = setVisualToOption(thisOption, visualArr);
	  } // Remove categories that has no visual,
	  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	  for (var i = categories.length - 1; i >= 0; i--) {
	    if (visual[i] == null) {
	      delete categoryMap[categories[i]];
	      categories.pop();
	    }
	  }
	}
	
	function normalizeVisualRange(thisOption, isCategory) {
	  var visual = thisOption.visual;
	  var visualArr = [];
	
	  if (zrUtil.isObject(visual)) {
	    each(visual, function (v) {
	      visualArr.push(v);
	    });
	  } else if (visual != null) {
	    visualArr.push(visual);
	  }
	
	  var doNotNeedPair = {
	    color: 1,
	    symbol: 1
	  };
	
	  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	    // Do not care visualArr.length === 0, which is illegal.
	    visualArr[1] = visualArr[0];
	  }
	
	  setVisualToOption(thisOption, visualArr);
	}
	
	function makePartialColorVisualHandler(applyValue) {
	  return {
	    applyVisual: function (value, getter, setter) {
	      value = this.mapValueToVisual(value); // Must not be array value
	
	      setter('color', applyValue(getter('color'), value));
	    },
	    _doMap: makeDoMap([0, 1])
	  };
	}
	
	function doMapToArray(normalized) {
	  var visual = this.option.visual;
	  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
	}
	
	function makeApplyVisual(visualType) {
	  return function (value, getter, setter) {
	    setter(visualType, this.mapValueToVisual(value));
	  };
	}
	
	function doMapCategory(normalized) {
	  var visual = this.option.visual;
	  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	}
	
	function doMapFixed() {
	  return this.option.visual[0];
	}
	
	function makeDoMap(sourceExtent) {
	  return {
	    linear: function (normalized) {
	      return linearMap(normalized, sourceExtent, this.option.visual, true);
	    },
	    category: doMapCategory,
	    piecewise: function (normalized, value) {
	      var result = getSpecifiedVisual.call(this, value);
	
	      if (result == null) {
	        result = linearMap(normalized, sourceExtent, this.option.visual, true);
	      }
	
	      return result;
	    },
	    fixed: doMapFixed
	  };
	}
	
	function getSpecifiedVisual(value) {
	  var thisOption = this.option;
	  var pieceList = thisOption.pieceList;
	
	  if (thisOption.hasSpecialVisual) {
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	    var piece = pieceList[pieceIndex];
	
	    if (piece && piece.visual) {
	      return piece.visual[this.type];
	    }
	  }
	}
	
	function setVisualToOption(thisOption, visualArr) {
	  thisOption.visual = visualArr;
	
	  if (thisOption.type === 'color') {
	    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
	      return zrColor.parse(item);
	    });
	  }
	
	  return visualArr;
	}
	/**
	 * Normalizers by mapping methods.
	 */
	
	
	var normalizers = {
	  linear: function (value) {
	    return linearMap(value, this.option.dataExtent, [0, 1], true);
	  },
	  piecewise: function (value) {
	    var pieceList = this.option.pieceList;
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	    if (pieceIndex != null) {
	      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	    }
	  },
	  category: function (value) {
	    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
	
	    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	  },
	  fixed: zrUtil.noop
	};
	/**
	 * List available visual types.
	 *
	 * @public
	 * @return {Array.<string>}
	 */
	
	VisualMapping.listVisualTypes = function () {
	  var visualTypes = [];
	  zrUtil.each(visualHandlers, function (handler, key) {
	    visualTypes.push(key);
	  });
	  return visualTypes;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.addVisualHandler = function (name, handler) {
	  visualHandlers[name] = handler;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.isValidType = function (visualType) {
	  return visualHandlers.hasOwnProperty(visualType);
	};
	/**
	 * Convinent method.
	 * Visual can be Object or Array or primary type.
	 *
	 * @public
	 */
	
	
	VisualMapping.eachVisual = function (visual, callback, context) {
	  if (zrUtil.isObject(visual)) {
	    zrUtil.each(visual, callback, context);
	  } else {
	    callback.call(context, visual);
	  }
	};
	
	VisualMapping.mapVisual = function (visual, callback, context) {
	  var isPrimary;
	  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
	  VisualMapping.eachVisual(visual, function (v, key) {
	    var newVal = callback.call(context, v, key);
	    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	  });
	  return newVisual;
	};
	/**
	 * @public
	 * @param {Object} obj
	 * @return {Object} new object containers visual values.
	 *                 If no visuals, return null.
	 */
	
	
	VisualMapping.retrieveVisuals = function (obj) {
	  var ret = {};
	  var hasVisual;
	  obj && each(visualHandlers, function (h, visualType) {
	    if (obj.hasOwnProperty(visualType)) {
	      ret[visualType] = obj[visualType];
	      hasVisual = true;
	    }
	  });
	  return hasVisual ? ret : null;
	};
	/**
	 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	 *
	 * @public
	 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	 * @return {Array.<string>} Sorted visual types.
	 */
	
	
	VisualMapping.prepareVisualTypes = function (visualTypes) {
	  if (isObject(visualTypes)) {
	    var types = [];
	    each(visualTypes, function (item, type) {
	      types.push(type);
	    });
	    visualTypes = types;
	  } else if (zrUtil.isArray(visualTypes)) {
	    visualTypes = visualTypes.slice();
	  } else {
	    return [];
	  }
	
	  visualTypes.sort(function (type1, type2) {
	    // color should be front of colorSaturation, colorAlpha, ...
	    // symbol and symbolSize do not matter.
	    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	  });
	  return visualTypes;
	};
	/**
	 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	 * Other visuals are only depends on themself.
	 *
	 * @public
	 * @param {string} visualType1
	 * @param {string} visualType2
	 * @return {boolean}
	 */
	
	
	VisualMapping.dependsOn = function (visualType1, visualType2) {
	  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	};
	/**
	 * @param {number} value
	 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
	 *                         Always from small to big.
	 * @param {boolean} [findClosestWhenOutside=false]
	 * @return {number} index
	 */
	
	
	VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	  var possibleI;
	  var abs = Infinity; // value has the higher priority.
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var pieceValue = pieceList[i].value;
	
	    if (pieceValue != null) {
	      if (pieceValue === value // FIXME
	      // It is supposed to compare value according to value type of dimension,
	      // but currently value type can exactly be string or number.
	      // Compromise for numeric-like string (like '12'), especially
	      // in the case that visualMap.categories is ['22', '33'].
	      || typeof pieceValue === 'string' && pieceValue === value + '') {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(pieceValue, i);
	    }
	  }
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var piece = pieceList[i];
	    var interval = piece.interval;
	    var close = piece.close;
	
	    if (interval) {
	      if (interval[0] === -Infinity) {
	        if (littleThan(close[1], value, interval[1])) {
	          return i;
	        }
	      } else if (interval[1] === Infinity) {
	        if (littleThan(close[0], interval[0], value)) {
	          return i;
	        }
	      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(interval[0], i);
	      findClosestWhenOutside && updatePossible(interval[1], i);
	    }
	  }
	
	  if (findClosestWhenOutside) {
	    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	  }
	
	  function updatePossible(val, index) {
	    var newAbs = Math.abs(val - value);
	
	    if (newAbs < abs) {
	      abs = newAbs;
	      possibleI = index;
	    }
	  }
	};
	
	function littleThan(close, a, b) {
	  return close ? a <= b : a < b;
	}
	
	var _default = VisualMapping;
	module.exports = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var BoundingRect = __webpack_require__(154);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;
	
	var layout = __webpack_require__(217);
	
	var helper = __webpack_require__(369);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The treemap layout implementation was originally copied from
	* "d3.js" with some modifications made for this project.
	* (See more details in the comment of the method "squarify" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var retrieveValue = zrUtil.retrieve;
	var each = zrUtil.each;
	var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
	var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
	var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
	var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
	/**
	 * @public
	 */
	
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    // Layout result in each node:
	    // {x, y, width, height, area, borderWidth}
	    var ecWidth = api.getWidth();
	    var ecHeight = api.getHeight();
	    var seriesOption = seriesModel.option;
	    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	    var size = seriesOption.size || []; // Compatible with ec2.
	
	    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	    var payloadType = payload && payload.type;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	    var viewRoot = seriesModel.getViewRoot();
	    var viewAbovePath = helper.getPathToRoot(viewRoot);
	
	    if (payloadType !== 'treemapMove') {
	      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	      var sort = seriesOption.sort;
	
	      if (sort && sort !== 'asc' && sort !== 'desc') {
	        sort = 'desc';
	      }
	
	      var options = {
	        squareRatio: seriesOption.squareRatio,
	        sort: sort,
	        leafDepth: seriesOption.leafDepth
	      }; // layout should be cleared because using updateView but not update.
	
	      viewRoot.hostTree.clearLayouts(); // TODO
	      // optimize: if out of view clip, do not layout.
	      // But take care that if do not render node out of view clip,
	      // how to calculate start po
	
	      var viewRootLayout = {
	        x: 0,
	        y: 0,
	        width: rootSize[0],
	        height: rootSize[1],
	        area: rootSize[0] * rootSize[1]
	      };
	      viewRoot.setLayout(viewRootLayout);
	      squarify(viewRoot, options, false, 0); // Supplement layout.
	
	      var viewRootLayout = viewRoot.getLayout();
	      each(viewAbovePath, function (node, index) {
	        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	        node.setLayout(zrUtil.extend({
	          dataExtent: [childValue, childValue],
	          borderWidth: 0,
	          upperHeight: 0
	        }, viewRootLayout));
	      });
	    }
	
	    var treeRoot = seriesModel.getData().tree.root;
	    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	    seriesModel.setLayoutInfo(layoutInfo); // FIXME
	    // 现在没有clip功能，暂时取ec高宽。
	
	    prunning(treeRoot, // Transform to base element coordinate system.
	    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	  }
	};
	/**
	 * Layout treemap with squarify algorithm.
	 * The original presentation of this algorithm
	 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
	 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
	 * The implementation of this algorithm was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @protected
	 * @param {module:echarts/data/Tree~TreeNode} node
	 * @param {Object} options
	 * @param {string} options.sort 'asc' or 'desc'
	 * @param {number} options.squareRatio
	 * @param {boolean} hideChildren
	 * @param {number} depth
	 */
	
	function squarify(node, options, hideChildren, depth) {
	  var width;
	  var height;
	
	  if (node.isRemoved()) {
	    return;
	  }
	
	  var thisLayout = node.getLayout();
	  width = thisLayout.width;
	  height = thisLayout.height; // Considering border and gap
	
	  var nodeModel = node.getModel();
	  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	  var upperLabelHeight = getUpperLabelHeight(nodeModel);
	  var upperHeight = Math.max(borderWidth, upperLabelHeight);
	  var layoutOffset = borderWidth - halfGapWidth;
	  var layoutOffsetUpper = upperHeight - halfGapWidth;
	  var nodeModel = node.getModel();
	  node.setLayout({
	    borderWidth: borderWidth,
	    upperHeight: upperHeight,
	    upperLabelHeight: upperLabelHeight
	  }, true);
	  width = mathMax(width - 2 * layoutOffset, 0);
	  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
	  var totalArea = width * height;
	  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	  if (!viewChildren.length) {
	    return;
	  }
	
	  var rect = {
	    x: layoutOffset,
	    y: layoutOffsetUpper,
	    width: width,
	    height: height
	  };
	  var rowFixedLength = mathMin(width, height);
	  var best = Infinity; // the best row score so far
	
	  var row = [];
	  row.area = 0;
	
	  for (var i = 0, len = viewChildren.length; i < len;) {
	    var child = viewChildren[i];
	    row.push(child);
	    row.area += child.getLayout().area;
	    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	    if (score <= best) {
	      i++;
	      best = score;
	    } // abort, and try a different orientation
	    else {
	        row.area -= row.pop().getLayout().area;
	        position(row, rowFixedLength, rect, halfGapWidth, false);
	        rowFixedLength = mathMin(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	  }
	
	  if (row.length) {
	    position(row, rowFixedLength, rect, halfGapWidth, true);
	  }
	
	  if (!hideChildren) {
	    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	      hideChildren = true;
	    }
	  }
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    squarify(viewChildren[i], options, hideChildren, depth + 1);
	  }
	}
	/**
	 * Set area to each child, and calculate data extent for visual coding.
	 */
	
	
	function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	  var viewChildren = node.children || [];
	  var orderBy = options.sort;
	  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	  if (hideChildren && !overLeafDepth) {
	    return node.viewChildren = [];
	  } // Sort children, order by desc.
	
	
	  viewChildren = zrUtil.filter(viewChildren, function (child) {
	    return !child.isRemoved();
	  });
	  sort(viewChildren, orderBy);
	  var info = statistic(nodeModel, viewChildren, orderBy);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  }
	
	  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  } // Set area to each child.
	
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	    viewChildren[i].setLayout({
	      area: area
	    });
	  }
	
	  if (overLeafDepth) {
	    viewChildren.length && node.setLayout({
	      isLeafRoot: true
	    }, true);
	    viewChildren.length = 0;
	  }
	
	  node.viewChildren = viewChildren;
	  node.setLayout({
	    dataExtent: info.dataExtent
	  }, true);
	  return viewChildren;
	}
	/**
	 * Consider 'visibleMin'. Modify viewChildren and get new sum.
	 */
	
	
	function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	  // visibleMin is not supported yet when no option.sort.
	  if (!orderBy) {
	    return sum;
	  }
	
	  var visibleMin = nodeModel.get('visibleMin');
	  var len = orderedChildren.length;
	  var deletePoint = len; // Always travel from little value to big value.
	
	  for (var i = len - 1; i >= 0; i--) {
	    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	    if (value / sum * totalArea < visibleMin) {
	      deletePoint = i;
	      sum -= value;
	    }
	  }
	
	  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	  return sum;
	}
	/**
	 * Sort
	 */
	
	
	function sort(viewChildren, orderBy) {
	  if (orderBy) {
	    viewChildren.sort(function (a, b) {
	      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	    });
	  }
	
	  return viewChildren;
	}
	/**
	 * Statistic
	 */
	
	
	function statistic(nodeModel, children, orderBy) {
	  // Calculate sum.
	  var sum = 0;
	
	  for (var i = 0, len = children.length; i < len; i++) {
	    sum += children[i].getValue();
	  } // Statistic data extent for latter visual coding.
	  // Notice: data extent should be calculate based on raw children
	  // but not filtered view children, otherwise visual mapping will not
	  // be stable when zoom (where children is filtered by visibleMin).
	
	
	  var dimension = nodeModel.get('visualDimension');
	  var dataExtent; // The same as area dimension.
	
	  if (!children || !children.length) {
	    dataExtent = [NaN, NaN];
	  } else if (dimension === 'value' && orderBy) {
	    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	    orderBy === 'asc' && dataExtent.reverse();
	  } // Other dimension.
	  else {
	      var dataExtent = [Infinity, -Infinity];
	      each(children, function (child) {
	        var value = child.getValue(dimension);
	        value < dataExtent[0] && (dataExtent[0] = value);
	        value > dataExtent[1] && (dataExtent[1] = value);
	      });
	    }
	
	  return {
	    sum: sum,
	    dataExtent: dataExtent
	  };
	}
	/**
	 * Computes the score for the specified row,
	 * as the worst aspect ratio.
	 */
	
	
	function worst(row, rowFixedLength, ratio) {
	  var areaMax = 0;
	  var areaMin = Infinity;
	
	  for (var i = 0, area, len = row.length; i < len; i++) {
	    area = row[i].getLayout().area;
	
	    if (area) {
	      area < areaMin && (areaMin = area);
	      area > areaMax && (areaMax = area);
	    }
	  }
	
	  var squareArea = row.area * row.area;
	  var f = rowFixedLength * rowFixedLength * ratio;
	  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	}
	/**
	 * Positions the specified row of nodes. Modifies `rect`.
	 */
	
	
	function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	  // When rowFixedLength === rect.width,
	  // it is horizontal subdivision,
	  // rowFixedLength is the width of the subdivision,
	  // rowOtherLength is the height of the subdivision,
	  // and nodes will be positioned from left to right.
	  // wh[idx0WhenH] means: when horizontal,
	  //      wh[idx0WhenH] => wh[0] => 'width'.
	  //      xy[idx1WhenH] => xy[1] => 'y'.
	  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	  var idx1WhenH = 1 - idx0WhenH;
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  var last = rect[xy[idx0WhenH]];
	  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	  }
	
	  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	    var node = row[i];
	    var nodeLayout = {};
	    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	    var modWH = i === rowLen - 1 || remain < step ? remain : step;
	    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
	    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
	    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
	    last += modWH;
	    node.setLayout(nodeLayout, true);
	  }
	
	  rect[xy[idx1WhenH]] += rowOtherLength;
	  rect[wh[idx1WhenH]] -= rowOtherLength;
	} // Return [containerWidth, containerHeight] as defualt.
	
	
	function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	  // If targetInfo.node exists, we zoom to the node,
	  // so estimate whold width and heigth by target node.
	  var currNode = (targetInfo || {}).node;
	  var defaultSize = [containerWidth, containerHeight];
	
	  if (!currNode || currNode === viewRoot) {
	    return defaultSize;
	  }
	
	  var parent;
	  var viewArea = containerWidth * containerHeight;
	  var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	  while (parent = currNode.parentNode) {
	    // jshint ignore:line
	    var sum = 0;
	    var siblings = parent.children;
	
	    for (var i = 0, len = siblings.length; i < len; i++) {
	      sum += siblings[i].getValue();
	    }
	
	    var currNodeValue = currNode.getValue();
	
	    if (currNodeValue === 0) {
	      return defaultSize;
	    }
	
	    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	    var parentModel = parent.getModel();
	    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
	    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	    currNode = parent;
	  }
	
	  area < viewArea && (area = viewArea);
	  var scale = Math.pow(area / viewArea, 0.5);
	  return [containerWidth * scale, containerHeight * scale];
	} // Root postion base on coord of containerGroup
	
	
	function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	  if (rootRect) {
	    return {
	      x: rootRect.x,
	      y: rootRect.y
	    };
	  }
	
	  var defaultPosition = {
	    x: 0,
	    y: 0
	  };
	
	  if (!targetInfo) {
	    return defaultPosition;
	  } // If targetInfo is fetched by 'retrieveTargetInfo',
	  // old tree and new tree are the same tree,
	  // so the node still exists and we can visit it.
	
	
	  var targetNode = targetInfo.node;
	  var layout = targetNode.getLayout();
	
	  if (!layout) {
	    return defaultPosition;
	  } // Transform coord from local to container.
	
	
	  var targetCenter = [layout.width / 2, layout.height / 2];
	  var node = targetNode;
	
	  while (node) {
	    var nodeLayout = node.getLayout();
	    targetCenter[0] += nodeLayout.x;
	    targetCenter[1] += nodeLayout.y;
	    node = node.parentNode;
	  }
	
	  return {
	    x: layoutInfo.width / 2 - targetCenter[0],
	    y: layoutInfo.height / 2 - targetCenter[1]
	  };
	} // Mark nodes visible for prunning when visual coding and rendering.
	// Prunning depends on layout and root position, so we have to do it after layout.
	
	
	function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	  var nodeLayout = node.getLayout();
	  var nodeInViewAbovePath = viewAbovePath[depth];
	  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	    return;
	  }
	
	  node.setLayout({
	    // isInView means: viewRoot sub tree + viewAbovePath
	    isInView: true,
	    // invisible only means: outside view clip so that the node can not
	    // see but still layout for animation preparation but not render.
	    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	    isAboveViewRoot: isAboveViewRoot
	  }, true); // Transform to child coordinate.
	
	  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	  each(node.viewChildren || [], function (child) {
	    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	  });
	}
	
	function getUpperLabelHeight(model) {
	  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	}
	
	module.exports = _default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(378);
	
	__webpack_require__(381);
	
	__webpack_require__(386);
	
	var categoryFilter = __webpack_require__(388);
	
	var visualSymbol = __webpack_require__(286);
	
	var categoryVisual = __webpack_require__(389);
	
	var edgeVisual = __webpack_require__(390);
	
	var simpleLayout = __webpack_require__(391);
	
	var circularLayout = __webpack_require__(393);
	
	var forceLayout = __webpack_require__(395);
	
	var createView = __webpack_require__(397);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor(categoryFilter);
	echarts.registerVisual(visualSymbol('graph', 'circle', null));
	echarts.registerVisual(categoryVisual);
	echarts.registerVisual(edgeVisual);
	echarts.registerLayout(simpleLayout);
	echarts.registerLayout(circularLayout);
	echarts.registerLayout(forceLayout); // Graph view coordinate system
	
	echarts.registerCoordinateSystem('graphView', {
	  create: createView
	});

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var List = __webpack_require__(255);
	
	var zrUtil = __webpack_require__(134);
	
	var _model = __webpack_require__(173);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var Model = __webpack_require__(174);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	var createGraphFromNodeEdge = __webpack_require__(379);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GraphSeries = echarts.extendSeriesModel({
	  type: 'series.graph',
	  init: function (option) {
	    GraphSeries.superApply(this, 'init', arguments); // Provide data for legend select
	
	    this.legendDataProvider = function () {
	      return this._categoriesData;
	    };
	
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeOption: function (option) {
	    GraphSeries.superApply(this, 'mergeOption', arguments);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeDefaultAndTheme: function (option) {
	    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
	    defaultEmphasis(option, ['edgeLabel'], ['show']);
	  },
	  getInitialData: function (option, ecModel) {
	    var edges = option.edges || option.links || [];
	    var nodes = option.data || option.nodes || [];
	    var self = this;
	
	    if (nodes && edges) {
	      return createGraphFromNodeEdge(nodes, edges, this, true, beforeLink).data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      // Overwrite nodeData.getItemModel to
	      nodeData.wrapMethod('getItemModel', function (model) {
	        var categoriesModels = self._categoriesModels;
	        var categoryIdx = model.getShallow('category');
	        var categoryModel = categoriesModels[categoryIdx];
	
	        if (categoryModel) {
	          categoryModel.parentModel = model.parentModel;
	          model.parentModel = categoryModel;
	        }
	
	        return model;
	      });
	      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
	
	      var fakeSeriesModel = new Model({
	        label: edgeLabelModel.option
	      }, edgeLabelModel.parentModel, ecModel);
	      var emphasisEdgeLabelModel = self.getModel('emphasis.edgeLabel');
	      var emphasisFakeSeriesModel = new Model({
	        emphasis: {
	          label: emphasisEdgeLabelModel.option
	        }
	      }, emphasisEdgeLabelModel.parentModel, ecModel);
	      edgeData.wrapMethod('getItemModel', function (model) {
	        model.customizeGetParent(edgeGetParent);
	        return model;
	      });
	
	      function edgeGetParent(path) {
	        path = this.parsePath(path);
	        return path && path[0] === 'label' ? fakeSeriesModel : path && path[0] === 'emphasis' && path[1] === 'label' ? emphasisFakeSeriesModel : this.parentModel;
	      }
	    }
	  },
	
	  /**
	   * @return {module:echarts/data/Graph}
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getCategoriesData: function () {
	    return this._categoriesData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    if (dataType === 'edge') {
	      var nodeData = this.getData();
	      var params = this.getDataParams(dataIndex, dataType);
	      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	      var sourceName = nodeData.getName(edge.node1.dataIndex);
	      var targetName = nodeData.getName(edge.node2.dataIndex);
	      var html = [];
	      sourceName != null && html.push(sourceName);
	      targetName != null && html.push(targetName);
	      html = encodeHTML(html.join(' > '));
	
	      if (params.value) {
	        html += ' : ' + encodeHTML(params.value);
	      }
	
	      return html;
	    } else {
	      // dataType === 'node' or empty
	      return GraphSeries.superApply(this, 'formatTooltip', arguments);
	    }
	  },
	  _updateCategoriesData: function () {
	    var categories = zrUtil.map(this.option.categories || [], function (category) {
	      // Data must has value
	      return category.value != null ? category : zrUtil.extend({
	        value: 0
	      }, category);
	    });
	    var categoriesData = new List(['value'], this);
	    categoriesData.initData(categories);
	    this._categoriesData = categoriesData;
	    this._categoriesModels = categoriesData.mapArray(function (idx) {
	      return categoriesData.getItemModel(idx, true);
	    });
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  isAnimationEnabled: function () {
	    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
	    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // Default option for all coordinate systems
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // geoIndex: 0,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    layout: null,
	    focusNodeAdjacency: false,
	    // Configuration of circular layout
	    circular: {
	      rotateLabel: false
	    },
	    // Configuration of force directed layout
	    force: {
	      initLayout: null,
	      // Node repulsion. Can be an array to represent range.
	      repulsion: [0, 50],
	      gravity: 0.1,
	      // Edge length. Can be an array to represent range.
	      edgeLength: 30,
	      layoutAnimation: true
	    },
	    left: 'center',
	    top: 'center',
	    // right: null,
	    // bottom: null,
	    // width: '80%',
	    // height: '80%',
	    symbol: 'circle',
	    symbolSize: 10,
	    edgeSymbol: ['none', 'none'],
	    edgeSymbolSize: 10,
	    edgeLabel: {
	      position: 'middle'
	    },
	    draggable: false,
	    roam: false,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.6,
	    // cursor: null,
	    // categories: [],
	    // data: []
	    // Or
	    // nodes: []
	    //
	    // links: []
	    // Or
	    // edges: []
	    label: {
	      show: false,
	      formatter: '{b}'
	    },
	    itemStyle: {},
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      curveness: 0,
	      opacity: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = GraphSeries;
	module.exports = _default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var List = __webpack_require__(255);
	
	var Graph = __webpack_require__(380);
	
	var linkList = __webpack_require__(361);
	
	var createDimensions = __webpack_require__(258);
	
	var CoordinateSystem = __webpack_require__(228);
	
	var createListFromArray = __webpack_require__(254);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(nodes, edges, seriesModel, directed, beforeLink) {
	  // ??? TODO
	  // support dataset?
	  var graph = new Graph(directed);
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
	    nodes[i].id, nodes[i].name, i), i);
	  }
	
	  var linkNameList = [];
	  var validEdges = [];
	  var linkCount = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    var link = edges[i];
	    var source = link.source;
	    var target = link.target; // addEdge may fail when source or target not exists
	
	    if (graph.addEdge(source, target, linkCount)) {
	      validEdges.push(link);
	      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
	      linkCount++;
	    }
	  }
	
	  var coordSys = seriesModel.get('coordinateSystem');
	  var nodeData;
	
	  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	    nodeData = createListFromArray(nodes, seriesModel);
	  } else {
	    var coordSysCtor = CoordinateSystem.get(coordSys);
	    var coordDimensions = coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
	    // `value` dimension, but graph need `value` dimension. It's better to
	    // uniform this behavior.
	
	    if (zrUtil.indexOf(coordDimensions, 'value') < 0) {
	      coordDimensions.concat(['value']);
	    }
	
	    var dimensionNames = createDimensions(nodes, {
	      coordDimensions: coordDimensions
	    });
	    nodeData = new List(dimensionNames, seriesModel);
	    nodeData.initData(nodes);
	  }
	
	  var edgeData = new List(['value'], seriesModel);
	  edgeData.initData(validEdges, linkNameList);
	  beforeLink && beforeLink(nodeData, edgeData);
	  linkList({
	    mainData: nodeData,
	    struct: graph,
	    structAttr: 'graph',
	    datas: {
	      node: nodeData,
	      edge: edgeData
	    },
	    datasAttr: {
	      node: 'data',
	      edge: 'edgeData'
	    }
	  }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	  graph.update();
	  return graph;
	}
	
	module.exports = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var _clazz = __webpack_require__(175);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Graph data structure
	 *
	 * @module echarts/data/Graph
	 * @author Yi Shen(https://www.github.com/pissang)
	 */
	// id may be function name of Object, add a prefix to avoid this problem.
	function generateNodeKey(id) {
	  return '_EC_' + id;
	}
	/**
	 * @alias module:echarts/data/Graph
	 * @constructor
	 * @param {boolean} directed
	 */
	
	
	var Graph = function (directed) {
	  /**
	   * 是否是有向图
	   * @type {boolean}
	   * @private
	   */
	  this._directed = directed || false;
	  /**
	   * @type {Array.<module:echarts/data/Graph.Node>}
	   * @readOnly
	   */
	
	  this.nodes = [];
	  /**
	   * @type {Array.<module:echarts/data/Graph.Edge>}
	   * @readOnly
	   */
	
	  this.edges = [];
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Node>}
	   * @private
	   */
	
	  this._nodesMap = {};
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Edge>}
	   * @private
	   */
	
	  this._edgesMap = {};
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.edgeData;
	};
	
	var graphProto = Graph.prototype;
	/**
	 * @type {string}
	 */
	
	graphProto.type = 'graph';
	/**
	 * If is directed graph
	 * @return {boolean}
	 */
	
	graphProto.isDirected = function () {
	  return this._directed;
	};
	/**
	 * Add a new node
	 * @param {string} id
	 * @param {number} [dataIndex]
	 */
	
	
	graphProto.addNode = function (id, dataIndex) {
	  id = id || '' + dataIndex;
	  var nodesMap = this._nodesMap;
	
	  if (nodesMap[generateNodeKey(id)]) {
	    return;
	  }
	
	  var node = new Node(id, dataIndex);
	  node.hostGraph = this;
	  this.nodes.push(node);
	  nodesMap[generateNodeKey(id)] = node;
	  return node;
	};
	/**
	 * Get node by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getNodeByIndex = function (dataIndex) {
	  var rawIdx = this.data.getRawIndex(dataIndex);
	  return this.nodes[rawIdx];
	};
	/**
	 * Get node by id
	 * @param  {string} id
	 * @return {module:echarts/data/Graph.Node}
	 */
	
	
	graphProto.getNodeById = function (id) {
	  return this._nodesMap[generateNodeKey(id)];
	};
	/**
	 * Add a new edge
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.addEdge = function (n1, n2, dataIndex) {
	  var nodesMap = this._nodesMap;
	  var edgesMap = this._edgesMap; // PNEDING
	
	  if (typeof n1 === 'number') {
	    n1 = this.nodes[n1];
	  }
	
	  if (typeof n2 === 'number') {
	    n2 = this.nodes[n2];
	  }
	
	  if (!Node.isInstance(n1)) {
	    n1 = nodesMap[generateNodeKey(n1)];
	  }
	
	  if (!Node.isInstance(n2)) {
	    n2 = nodesMap[generateNodeKey(n2)];
	  }
	
	  if (!n1 || !n2) {
	    return;
	  }
	
	  var key = n1.id + '-' + n2.id; // PENDING
	
	  if (edgesMap[key]) {
	    return;
	  }
	
	  var edge = new Edge(n1, n2, dataIndex);
	  edge.hostGraph = this;
	
	  if (this._directed) {
	    n1.outEdges.push(edge);
	    n2.inEdges.push(edge);
	  }
	
	  n1.edges.push(edge);
	
	  if (n1 !== n2) {
	    n2.edges.push(edge);
	  }
	
	  this.edges.push(edge);
	  edgesMap[key] = edge;
	  return edge;
	};
	/**
	 * Get edge by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getEdgeByIndex = function (dataIndex) {
	  var rawIdx = this.edgeData.getRawIndex(dataIndex);
	  return this.edges[rawIdx];
	};
	/**
	 * Get edge by two linked nodes
	 * @param  {module:echarts/data/Graph.Node|string} n1
	 * @param  {module:echarts/data/Graph.Node|string} n2
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.getEdge = function (n1, n2) {
	  if (Node.isInstance(n1)) {
	    n1 = n1.id;
	  }
	
	  if (Node.isInstance(n2)) {
	    n2 = n2.id;
	  }
	
	  var edgesMap = this._edgesMap;
	
	  if (this._directed) {
	    return edgesMap[n1 + '-' + n2];
	  } else {
	    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	  }
	};
	/**
	 * Iterate all nodes
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachNode = function (cb, context) {
	  var nodes = this.nodes;
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i].dataIndex >= 0) {
	      cb.call(context, nodes[i], i);
	    }
	  }
	};
	/**
	 * Iterate all edges
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachEdge = function (cb, context) {
	  var edges = this.edges;
	  var len = edges.length;
	
	  for (var i = 0; i < len; i++) {
	    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	      cb.call(context, edges[i], i);
	    }
	  }
	};
	/**
	 * Breadth first traverse
	 * @param {Function} cb
	 * @param {module:echarts/data/Graph.Node} startNode
	 * @param {string} [direction='none'] 'none'|'in'|'out'
	 * @param {*} [context]
	 */
	
	
	graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
	  if (!Node.isInstance(startNode)) {
	    startNode = this._nodesMap[generateNodeKey(startNode)];
	  }
	
	  if (!startNode) {
	    return;
	  }
	
	  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	  for (var i = 0; i < this.nodes.length; i++) {
	    this.nodes[i].__visited = false;
	  }
	
	  if (cb.call(context, startNode, null)) {
	    return;
	  }
	
	  var queue = [startNode];
	
	  while (queue.length) {
	    var currentNode = queue.shift();
	    var edges = currentNode[edgeType];
	
	    for (var i = 0; i < edges.length; i++) {
	      var e = edges[i];
	      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	      if (!otherNode.__visited) {
	        if (cb.call(context, otherNode, currentNode)) {
	          // Stop traversing
	          return;
	        }
	
	        queue.push(otherNode);
	        otherNode.__visited = true;
	      }
	    }
	  }
	}; // TODO
	// graphProto.depthFirstTraverse = function (
	//     cb, startNode, direction, context
	// ) {
	// };
	// Filter update
	
	
	graphProto.update = function () {
	  var data = this.data;
	  var edgeData = this.edgeData;
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    nodes[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    nodes[data.getRawIndex(i)].dataIndex = i;
	  }
	
	  edgeData.filterSelf(function (idx) {
	    var edge = edges[edgeData.getRawIndex(idx)];
	    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	  }); // Update edge
	
	  for (var i = 0, len = edges.length; i < len; i++) {
	    edges[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = edgeData.count(); i < len; i++) {
	    edges[edgeData.getRawIndex(i)].dataIndex = i;
	  }
	};
	/**
	 * @return {module:echarts/data/Graph}
	 */
	
	
	graphProto.clone = function () {
	  var graph = new Graph(this._directed);
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(nodes[i].id, nodes[i].dataIndex);
	  }
	
	  for (var i = 0; i < edges.length; i++) {
	    var e = edges[i];
	    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	  }
	
	  return graph;
	};
	/**
	 * @alias module:echarts/data/Graph.Node
	 */
	
	
	function Node(id, dataIndex) {
	  /**
	  * @type {string}
	  */
	  this.id = id == null ? '' : id;
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.inEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.outEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.edges = [];
	  /**
	   * @type {module:echarts/data/Graph}
	   */
	
	  this.hostGraph;
	  /**
	   * @type {number}
	   */
	
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	
	Node.prototype = {
	  constructor: Node,
	
	  /**
	   * @return {number}
	   */
	  degree: function () {
	    return this.edges.length;
	  },
	
	  /**
	   * @return {number}
	   */
	  inDegree: function () {
	    return this.inEdges.length;
	  },
	
	  /**
	  * @return {number}
	  */
	  outDegree: function () {
	    return this.outEdges.length;
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var graph = this.hostGraph;
	    var itemModel = graph.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  }
	};
	/**
	 * 图边
	 * @alias module:echarts/data/Graph.Edge
	 * @param {module:echarts/data/Graph.Node} n1
	 * @param {module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 */
	
	function Edge(n1, n2, dataIndex) {
	  /**
	   * 节点1，如果是有向图则为源节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	  this.node1 = n1;
	  /**
	   * 节点2，如果是有向图则为目标节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	
	  this.node2 = n2;
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	/**
	 * @param {string} [path]
	 * @return {module:echarts/model/Model}
	 */
	
	
	Edge.prototype.getModel = function (path) {
	  if (this.dataIndex < 0) {
	    return;
	  }
	
	  var graph = this.hostGraph;
	  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	  return itemModel.getModel(path);
	};
	
	var createGraphDataProxyMixin = function (hostName, dataName) {
	  return {
	    /**
	     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	     * @return {number}
	     */
	    getValue: function (dimension) {
	      var data = this[hostName][dataName];
	      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	    },
	
	    /**
	     * @param {Object|string} key
	     * @param {*} [value]
	     */
	    setVisual: function (key, value) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	    },
	
	    /**
	     * @param {string} key
	     * @return {boolean}
	     */
	    getVisual: function (key, ignoreParent) {
	      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
	    },
	
	    /**
	     * @param {Object} layout
	     * @return {boolean} [merge=false]
	     */
	    setLayout: function (layout, merge) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLayout: function () {
	      return this[hostName][dataName].getItemLayout(this.dataIndex);
	    },
	
	    /**
	     * @return {module:zrender/Element}
	     */
	    getGraphicEl: function () {
	      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	    },
	
	    /**
	     * @return {number}
	     */
	    getRawIndex: function () {
	      return this[hostName][dataName].getRawIndex(this.dataIndex);
	    }
	  };
	};
	
	zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
	zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	Graph.Node = Node;
	Graph.Edge = Edge;
	enableClassCheck(Node);
	enableClassCheck(Edge);
	var _default = Graph;
	module.exports = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var SymbolDraw = __webpack_require__(280);
	
	var LineDraw = __webpack_require__(382);
	
	var RoamController = __webpack_require__(345);
	
	var roamHelper = __webpack_require__(347);
	
	var _cursorHelper = __webpack_require__(348);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(180);
	
	var adjustEdge = __webpack_require__(385);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FOCUS_ADJACENCY = '__focusNodeAdjacency';
	var UNFOCUS_ADJACENCY = '__unfocusNodeAdjacency';
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      var opct = child.lineLabelOriginalOpacity;
	
	      if (opct == null || opacityRatio != null) {
	        opct = opacity;
	      }
	
	      child.setStyle('opacity', opct);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.highlight && el.highlight();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	var _default = echarts.extendChartView({
	  type: 'graph',
	  init: function (ecModel, api) {
	    var symbolDraw = new SymbolDraw();
	    var lineDraw = new LineDraw();
	    var group = this.group;
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: group
	    };
	    group.add(symbolDraw.group);
	    group.add(lineDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineDraw = lineDraw;
	    this._firstRender = true;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    this._model = seriesModel;
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	    var symbolDraw = this._symbolDraw;
	    var lineDraw = this._lineDraw;
	    var group = this.group;
	
	    if (coordSys.type === 'view') {
	      var groupNewProp = {
	        position: coordSys.position,
	        scale: coordSys.scale
	      };
	
	      if (this._firstRender) {
	        group.attr(groupNewProp);
	      } else {
	        graphic.updateProps(group, groupNewProp, seriesModel);
	      }
	    } // Fix edge contact point with node
	
	
	    adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
	    var data = seriesModel.getData();
	    symbolDraw.updateData(data);
	    var edgeData = seriesModel.getEdgeData();
	    lineDraw.updateData(edgeData);
	
	    this._updateNodeAndLinkScale();
	
	    this._updateController(seriesModel, ecModel, api);
	
	    clearTimeout(this._layoutTimeout);
	    var forceLayout = seriesModel.forceLayout;
	    var layoutAnimation = seriesModel.get('force.layoutAnimation');
	
	    if (forceLayout) {
	      this._startForceLayoutIteration(forceLayout, layoutAnimation);
	    }
	
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx); // Update draggable
	
	      el.off('drag').off('dragend');
	      var draggable = itemModel.get('draggable');
	
	      if (draggable) {
	        el.on('drag', function () {
	          if (forceLayout) {
	            forceLayout.warmUp();
	            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
	            forceLayout.setFixed(idx); // Write position back to layout
	
	            data.setItemLayout(idx, el.position);
	          }
	        }, this).on('dragend', function () {
	          if (forceLayout) {
	            forceLayout.setUnfixed(idx);
	          }
	        }, this);
	      }
	
	      el.setDraggable(draggable && forceLayout);
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            dataIndex: el.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          api.dispatchAction({
	            type: 'unfocusNodeAdjacency',
	            seriesId: seriesModel.id
	          });
	        });
	      }
	    }, this);
	    data.graph.eachEdge(function (edge) {
	      var el = edge.getGraphicEl();
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (edge.getModel().get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            edgeDataIndex: edge.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          api.dispatchAction({
	            type: 'unfocusNodeAdjacency',
	            seriesId: seriesModel.id
	          });
	        });
	      }
	    });
	    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
	    var cx = data.getLayout('cx');
	    var cy = data.getLayout('cy');
	    data.eachItemGraphicEl(function (el, idx) {
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = data.getItemLayout(idx);
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        symbolPath.setStyle({
	          textRotation: -rad,
	          textPosition: textPosition,
	          textOrigin: 'center'
	        });
	        symbolPath.hoverStyle && (symbolPath.hoverStyle.textPosition = textPosition);
	      } else {
	        symbolPath.setStyle({
	          textRotation: 0
	        });
	      }
	    });
	    this._firstRender = false;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = this._model.getData();
	
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var edgeDataIndex = payload.edgeDataIndex;
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	
	    if (!node && !edge) {
	      return;
	    }
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      zrUtil.each(node.edges, function (adjacentEdge) {
	        if (adjacentEdge.dataIndex < 0) {
	          return;
	        }
	
	        fadeInItem(adjacentEdge, lineOpacityPath);
	        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
	        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
	      });
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = this._model.getData().graph;
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  },
	  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
	    var self = this;
	
	    (function step() {
	      forceLayout.step(function (stopped) {
	        self.updateLayout(self._model);
	        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	      });
	    })();
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	
	    if (seriesModel.coordinateSystem.type !== 'view') {
	      controller.disable();
	      return;
	    }
	
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale();
	
	      adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
	
	      this._lineDraw.updateLayout();
	    }, this);
	  },
	  _updateNodeAndLinkScale: function () {
	    var seriesModel = this._model;
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  updateLayout: function (seriesModel) {
	    adjustEdge(seriesModel.getGraph(), this._getNodeGlobalScale(seriesModel));
	
	    this._symbolDraw.updateLayout();
	
	    this._lineDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove();
	    this._lineDraw && this._lineDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var LineGroup = __webpack_require__(383);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/LineDraw
	 */
	// import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';
	
	/**
	 * @alias module:echarts/component/marker/LineDraw
	 * @constructor
	 */
	function LineDraw(ctor) {
	  this._ctor = ctor || LineGroup;
	  this.group = new graphic.Group();
	}
	
	var lineDrawProto = LineDraw.prototype;
	
	lineDrawProto.isPersistent = function () {
	  return true;
	};
	/**
	 * @param {module:echarts/data/List} lineData
	 */
	
	
	lineDrawProto.updateData = function (lineData) {
	  var lineDraw = this;
	  var group = lineDraw.group;
	  var oldLineData = lineDraw._lineData;
	  lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldLineData) {
	    group.removeAll();
	  }
	
	  var seriesScope = makeSeriesScope(lineData);
	  lineData.diff(oldLineData).add(function (idx) {
	    doAdd(lineDraw, lineData, idx, seriesScope);
	  }).update(function (newIdx, oldIdx) {
	    doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
	  }).remove(function (idx) {
	    group.remove(oldLineData.getItemGraphicEl(idx));
	  }).execute();
	};
	
	function doAdd(lineDraw, lineData, idx, seriesScope) {
	  var itemLayout = lineData.getItemLayout(idx);
	
	  if (!lineNeedsDraw(itemLayout)) {
	    return;
	  }
	
	  var el = new lineDraw._ctor(lineData, idx, seriesScope);
	  lineData.setItemGraphicEl(idx, el);
	  lineDraw.group.add(el);
	}
	
	function doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
	  var itemEl = oldLineData.getItemGraphicEl(oldIdx);
	
	  if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
	    lineDraw.group.remove(itemEl);
	    return;
	  }
	
	  if (!itemEl) {
	    itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
	  } else {
	    itemEl.updateData(newLineData, newIdx, seriesScope);
	  }
	
	  newLineData.setItemGraphicEl(newIdx, itemEl);
	  lineDraw.group.add(itemEl);
	}
	
	lineDrawProto.updateLayout = function () {
	  var lineData = this._lineData; // Do not support update layout in incremental mode.
	
	  if (!lineData) {
	    return;
	  }
	
	  lineData.eachItemGraphicEl(function (el, idx) {
	    el.updateLayout(lineData, idx);
	  }, this);
	};
	
	lineDrawProto.incrementalPrepareUpdate = function (lineData) {
	  this._seriesScope = makeSeriesScope(lineData);
	  this._lineData = null;
	  this.group.removeAll();
	};
	
	lineDrawProto.incrementalUpdate = function (taskParams, lineData) {
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var itemLayout = lineData.getItemLayout(idx);
	
	    if (lineNeedsDraw(itemLayout)) {
	      var el = new this._ctor(lineData, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      this.group.add(el);
	      lineData.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function makeSeriesScope(lineData) {
	  var hostModel = lineData.hostModel;
	  return {
	    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
	    hoverLineStyle: hostModel.getModel('emphasis.lineStyle').getLineStyle(),
	    labelModel: hostModel.getModel('label'),
	    hoverLabelModel: hostModel.getModel('emphasis.label')
	  };
	}
	
	lineDrawProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	lineDrawProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	function isPointNaN(pt) {
	  return isNaN(pt[0]) || isNaN(pt[1]);
	}
	
	function lineNeedsDraw(pts) {
	  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	}
	
	var _default = LineDraw;
	module.exports = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var vector = __webpack_require__(136);
	
	var symbolUtil = __webpack_require__(271);
	
	var LinePath = __webpack_require__(384);
	
	var graphic = __webpack_require__(180);
	
	var _number = __webpack_require__(218);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	function makeSymbolTypeKey(symbolCategory) {
	  return '_' + symbolCategory + 'Type';
	}
	/**
	 * @inner
	 */
	
	
	function createSymbol(name, lineData, idx) {
	  var color = lineData.getItemVisual(idx, 'color');
	  var symbolType = lineData.getItemVisual(idx, name);
	  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	
	  if (!symbolType || symbolType === 'none') {
	    return;
	  }
	
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [symbolSize, symbolSize];
	  }
	
	  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color);
	  symbolPath.name = name;
	  return symbolPath;
	}
	
	function createLine(points) {
	  var line = new LinePath({
	    name: 'line'
	  });
	  setLinePoints(line.shape, points);
	  return line;
	}
	
	function setLinePoints(targetShape, points) {
	  var p1 = points[0];
	  var p2 = points[1];
	  var cp1 = points[2];
	  targetShape.x1 = p1[0];
	  targetShape.y1 = p1[1];
	  targetShape.x2 = p2[0];
	  targetShape.y2 = p2[1];
	  targetShape.percent = 1;
	
	  if (cp1) {
	    targetShape.cpx1 = cp1[0];
	    targetShape.cpy1 = cp1[1];
	  } else {
	    targetShape.cpx1 = NaN;
	    targetShape.cpy1 = NaN;
	  }
	}
	
	function updateSymbolAndLabelBeforeLineUpdate() {
	  var lineGroup = this;
	  var symbolFrom = lineGroup.childOfName('fromSymbol');
	  var symbolTo = lineGroup.childOfName('toSymbol');
	  var label = lineGroup.childOfName('label'); // Quick reject
	
	  if (!symbolFrom && !symbolTo && label.ignore) {
	    return;
	  }
	
	  var invScale = 1;
	  var parentNode = this.parent;
	
	  while (parentNode) {
	    if (parentNode.scale) {
	      invScale /= parentNode.scale[0];
	    }
	
	    parentNode = parentNode.parent;
	  }
	
	  var line = lineGroup.childOfName('line'); // If line not changed
	  // FIXME Parent scale changed
	
	  if (!this.__dirty && !line.__dirty) {
	    return;
	  }
	
	  var percent = line.shape.percent;
	  var fromPos = line.pointAt(0);
	  var toPos = line.pointAt(percent);
	  var d = vector.sub([], toPos, fromPos);
	  vector.normalize(d, d);
	
	  if (symbolFrom) {
	    symbolFrom.attr('position', fromPos);
	    var tangent = line.tangentAt(0);
	    symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (symbolTo) {
	    symbolTo.attr('position', toPos);
	    var tangent = line.tangentAt(1);
	    symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (!label.ignore) {
	    label.attr('position', toPos);
	    var textPosition;
	    var textAlign;
	    var textVerticalAlign;
	    var distance = 5 * invScale; // End
	
	    if (label.__position === 'end') {
	      textPosition = [d[0] * distance + toPos[0], d[1] * distance + toPos[1]];
	      textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	      textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	    } // Middle
	    else if (label.__position === 'middle') {
	        var halfPercent = percent / 2;
	        var tangent = line.tangentAt(halfPercent);
	        var n = [tangent[1], -tangent[0]];
	        var cp = line.pointAt(halfPercent);
	
	        if (n[1] > 0) {
	          n[0] = -n[0];
	          n[1] = -n[1];
	        }
	
	        textPosition = [cp[0] + n[0] * distance, cp[1] + n[1] * distance];
	        textAlign = 'center';
	        textVerticalAlign = 'bottom';
	        var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	        if (toPos[0] < fromPos[0]) {
	          rotation = Math.PI + rotation;
	        }
	
	        label.attr('rotation', rotation);
	      } // Start
	      else {
	          textPosition = [-d[0] * distance + fromPos[0], -d[1] * distance + fromPos[1]];
	          textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	          textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	        }
	
	    label.attr({
	      style: {
	        // Use the user specified text align and baseline first
	        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
	        textAlign: label.__textAlign || textAlign
	      },
	      position: textPosition,
	      scale: [invScale, invScale]
	    });
	  }
	}
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	
	
	function Line(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createLine(lineData, idx, seriesScope);
	}
	
	var lineProto = Line.prototype; // Update symbol position and rotation
	
	lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;
	
	lineProto._createLine = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var linePoints = lineData.getItemLayout(idx);
	  var line = createLine(linePoints);
	  line.shape.percent = 0;
	  graphic.initProps(line, {
	    shape: {
	      percent: 1
	    }
	  }, seriesModel, idx);
	  this.add(line);
	  var label = new graphic.Text({
	    name: 'label',
	    // FIXME
	    // Temporary solution for `focusNodeAdjacency`.
	    // line label do not use the opacity of lineStyle.
	    lineLabelOriginalOpacity: 1
	  });
	  this.add(label);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
	    // it will be updated after line#update.
	    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	    this.add(symbol);
	    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var linePoints = lineData.getItemLayout(idx);
	  var target = {
	    shape: {}
	  };
	  setLinePoints(target.shape, linePoints);
	  graphic.updateProps(line, target, seriesModel, idx);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbolType = lineData.getItemVisual(idx, symbolCategory);
	    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	    if (this[key] !== symbolType) {
	      this.remove(this.childOfName(symbolCategory));
	      var symbol = createSymbol(symbolCategory, lineData, idx);
	      this.add(symbol);
	    }
	
	    this[key] = symbolType;
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
	
	  if (!seriesScope || lineData.hasItemOption) {
	    var itemModel = lineData.getItemModel(idx);
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	    labelModel = itemModel.getModel('label');
	    hoverLabelModel = itemModel.getModel('emphasis.label');
	  }
	
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor,
	    opacity: visualOpacity
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle; // Update symbol
	
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = this.childOfName(symbolCategory);
	
	    if (symbol) {
	      symbol.setColor(visualColor);
	      symbol.setStyle({
	        opacity: visualOpacity
	      });
	    }
	  }, this);
	  var showLabel = labelModel.getShallow('show');
	  var hoverShowLabel = hoverLabelModel.getShallow('show');
	  var label = this.childOfName('label');
	  var defaultLabelColor;
	  var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
	
	  if (showLabel || hoverShowLabel) {
	    defaultLabelColor = visualColor || '#000';
	    baseText = seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType);
	
	    if (baseText == null) {
	      var rawVal = seriesModel.getRawValue(idx);
	      baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
	    }
	  }
	
	  var normalText = showLabel ? baseText : null;
	  var emphasisText = hoverShowLabel ? zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), baseText) : null;
	  var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
	  // values have to be set on `normalStyle`.
	
	  if (normalText != null || emphasisText != null) {
	    graphic.setTextStyle(label.style, labelModel, {
	      text: normalText
	    }, {
	      autoColor: defaultLabelColor
	    });
	    label.__textAlign = labelStyle.textAlign;
	    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
	
	    label.__position = labelModel.get('position') || 'middle';
	  }
	
	  if (emphasisText != null) {
	    // Only these properties supported in this emphasis style here.
	    label.hoverStyle = {
	      text: emphasisText,
	      textFill: hoverLabelModel.getTextColor(true),
	      // For merging hover style to normal style, do not use
	      // `hoverLabelModel.getFont()` here.
	      fontStyle: hoverLabelModel.getShallow('fontStyle'),
	      fontWeight: hoverLabelModel.getShallow('fontWeight'),
	      fontSize: hoverLabelModel.getShallow('fontSize'),
	      fontFamily: hoverLabelModel.getShallow('fontFamily')
	    };
	  } else {
	    label.hoverStyle = {
	      text: null
	    };
	  }
	
	  label.ignore = !showLabel && !hoverShowLabel;
	  graphic.setHoverStyle(this);
	};
	
	lineProto.highlight = function () {
	  this.trigger('emphasis');
	};
	
	lineProto.downplay = function () {
	  this.trigger('normal');
	};
	
	lineProto.updateLayout = function (lineData, idx) {
	  this.setLinePoints(lineData.getItemLayout(idx));
	};
	
	lineProto.setLinePoints = function (points) {
	  var linePath = this.childOfName('line');
	  setLinePoints(linePath.shape, points);
	  linePath.dirty();
	};
	
	zrUtil.inherits(Line, graphic.Group);
	var _default = Line;
	module.exports = _default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var vec2 = __webpack_require__(136);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Line path for bezier and straight line draw
	 */
	var straightLineProto = graphic.Line.prototype;
	var bezierCurveProto = graphic.BezierCurve.prototype;
	
	function isLine(shape) {
	  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	}
	
	var _default = graphic.extendShape({
	  type: 'ec-line',
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    percent: 1,
	    cpx1: null,
	    cpy1: null
	  },
	  buildPath: function (ctx, shape) {
	    (isLine(shape) ? straightLineProto : bezierCurveProto).buildPath(ctx, shape);
	  },
	  pointAt: function (t) {
	    return isLine(this.shape) ? straightLineProto.pointAt.call(this, t) : bezierCurveProto.pointAt.call(this, t);
	  },
	  tangentAt: function (t) {
	    var shape = this.shape;
	    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : bezierCurveProto.tangentAt.call(this, t);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var curveTool = __webpack_require__(184);
	
	var vec2 = __webpack_require__(136);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var v1 = [];
	var v2 = [];
	var v3 = [];
	var quadraticAt = curveTool.quadraticAt;
	var v2DistSquare = vec2.distSquare;
	var mathAbs = Math.abs;
	
	function intersectCurveCircle(curvePoints, center, radius) {
	  var p0 = curvePoints[0];
	  var p1 = curvePoints[1];
	  var p2 = curvePoints[2];
	  var d = Infinity;
	  var t;
	  var radiusSquare = radius * radius;
	  var interval = 0.1;
	
	  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
	    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
	    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);
	
	    if (diff < d) {
	      d = diff;
	      t = _t;
	    }
	  } // Assume the segment is monotone，Find root through Bisection method
	  // At most 32 iteration
	
	
	  for (var i = 0; i < 32; i++) {
	    // var prev = t - interval;
	    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
	    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
	    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
	    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
	    var diff = v2DistSquare(v2, center) - radiusSquare;
	
	    if (mathAbs(diff) < 1e-2) {
	      break;
	    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	    interval /= 2;
	
	    if (diff < 0) {
	      if (nextDiff >= 0) {
	        t = t + interval;
	      } else {
	        t = t - interval;
	      }
	    } else {
	      if (nextDiff >= 0) {
	        t = t - interval;
	      } else {
	        t = t + interval;
	      }
	    }
	  }
	
	  return t;
	} // Adjust edge to avoid
	
	
	function _default(graph, scale) {
	  var tmp0 = [];
	  var quadraticSubdivide = curveTool.quadraticSubdivide;
	  var pts = [[], [], []];
	  var pts2 = [[], []];
	  var v = [];
	  scale /= 2;
	
	  function getSymbolSize(node) {
	    var symbolSize = node.getVisual('symbolSize');
	
	    if (symbolSize instanceof Array) {
	      symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	    }
	
	    return symbolSize;
	  }
	
	  graph.eachEdge(function (edge, idx) {
	    var linePoints = edge.getLayout();
	    var fromSymbol = edge.getVisual('fromSymbol');
	    var toSymbol = edge.getVisual('toSymbol');
	
	    if (!linePoints.__original) {
	      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];
	
	      if (linePoints[2]) {
	        linePoints.__original.push(vec2.clone(linePoints[2]));
	      }
	    }
	
	    var originalPoints = linePoints.__original; // Quadratic curve
	
	    if (linePoints[2] != null) {
	      vec2.copy(pts[0], originalPoints[0]);
	      vec2.copy(pts[1], originalPoints[2]);
	      vec2.copy(pts[2], originalPoints[1]);
	
	      if (fromSymbol && fromSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node1);
	        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[0][0] = tmp0[3];
	        pts[1][0] = tmp0[4];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[0][1] = tmp0[3];
	        pts[1][1] = tmp0[4];
	      }
	
	      if (toSymbol && toSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node2);
	        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[1][0] = tmp0[1];
	        pts[2][0] = tmp0[2];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[1][1] = tmp0[1];
	        pts[2][1] = tmp0[2];
	      } // Copy back to layout
	
	
	      vec2.copy(linePoints[0], pts[0]);
	      vec2.copy(linePoints[1], pts[2]);
	      vec2.copy(linePoints[2], pts[1]);
	    } // Line
	    else {
	        vec2.copy(pts2[0], originalPoints[0]);
	        vec2.copy(pts2[1], originalPoints[1]);
	        vec2.sub(v, pts2[1], pts2[0]);
	        vec2.normalize(v, v);
	
	        if (fromSymbol && fromSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node1);
	          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	        }
	
	        if (toSymbol && toSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node2);
	          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	        }
	
	        vec2.copy(linePoints[0], pts2[0]);
	        vec2.copy(linePoints[1], pts2[1]);
	      }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var _roamHelper = __webpack_require__(350);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	__webpack_require__(387);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'graphRoam',
	  event: 'graphRoam',
	  update: 'none'
	};
	/**
	 * @payload
	 * @property {string} name Series name
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 * @property {number} [dataIndex]
	 */
	echarts.registerAction({
	  type: 'focusNodeAdjacency',
	  event: 'focusNodeAdjacency',
	  update: 'series:focusNodeAdjacency'
	}, function () {});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 */
	
	echarts.registerAction({
	  type: 'unfocusNodeAdjacency',
	  event: 'unfocusNodeAdjacency',
	  update: 'series:unfocusNodeAdjacency'
	}, function () {});

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var categoriesData = graphSeries.getCategoriesData();
	    var graph = graphSeries.getGraph();
	    var data = graph.data;
	    var categoryNames = categoriesData.mapArray(categoriesData.getName);
	    data.filterSelf(function (idx) {
	      var model = data.getItemModel(idx);
	      var category = model.getShallow('category');
	
	      if (category != null) {
	        if (typeof category === 'number') {
	          category = categoryNames[category];
	        } // If in any legend component the status is not selected.
	
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(category)) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    });
	  }, this);
	}
	
	module.exports = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var paletteScope = {};
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var categoriesData = seriesModel.getCategoriesData();
	    var data = seriesModel.getData();
	    var categoryNameIdxMap = {};
	    categoriesData.each(function (idx) {
	      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	      categoryNameIdxMap['ec-' + name] = idx;
	      var itemModel = categoriesData.getItemModel(idx);
	      var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(name, paletteScope);
	      categoriesData.setItemVisual(idx, 'color', color);
	    }); // Assign category color to visual
	
	    if (categoriesData.count()) {
	      data.each(function (idx) {
	        var model = data.getItemModel(idx);
	        var category = model.getShallow('category');
	
	        if (category != null) {
	          if (typeof category === 'string') {
	            category = categoryNameIdxMap['ec-' + category];
	          }
	
	          if (!data.getItemVisual(idx, 'color', true)) {
	            data.setItemVisual(idx, 'color', categoriesData.getItemVisual(category, 'color'));
	          }
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var edgeData = seriesModel.getEdgeData();
	    var symbolType = normalize(seriesModel.get('edgeSymbol'));
	    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
	    var colorQuery = 'lineStyle.color'.split('.');
	    var opacityQuery = 'lineStyle.opacity'.split('.');
	    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    edgeData.setVisual('color', seriesModel.get(colorQuery));
	    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
	    edgeData.each(function (idx) {
	      var itemModel = edgeData.getItemModel(idx);
	      var edge = graph.getEdgeByIndex(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	      var color = itemModel.get(colorQuery);
	      var opacity = itemModel.get(opacityQuery);
	
	      switch (color) {
	        case 'source':
	          color = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          color = edge.node2.getVisual('color');
	          break;
	      }
	
	      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	      edge.setVisual('color', color);
	      edge.setVisual('opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	
	var _simpleLayoutHelper = __webpack_require__(392);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var layout = seriesModel.get('layout');
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      var data = seriesModel.getData();
	      var dimensions = [];
	      each(coordSys.dimensions, function (coordDim) {
	        dimensions = dimensions.concat(data.mapDimension(coordDim, true));
	      });
	
	      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	        var value = [];
	        var hasValue = false;
	
	        for (var i = 0; i < dimensions.length; i++) {
	          var val = data.get(dimensions[i], dataIndex);
	
	          if (!isNaN(val)) {
	            hasValue = true;
	          }
	
	          value.push(val);
	        }
	
	        if (hasValue) {
	          data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
	        } else {
	          // Also {Array.<number>}, not undefined to avoid if...else... statement
	          data.setItemLayout(dataIndex, [NaN, NaN]);
	        }
	      }
	
	      simpleLayoutEdge(data.graph);
	    } else if (!layout || layout === 'none') {
	      simpleLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(136);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function simpleLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var graph = seriesModel.getGraph();
	  graph.eachNode(function (node) {
	    var model = node.getModel();
	    node.setLayout([+model.get('x'), +model.get('y')]);
	  });
	  simpleLayoutEdge(graph);
	}
	
	function simpleLayoutEdge(graph) {
	  graph.eachEdge(function (edge) {
	    var curveness = edge.getModel().get('lineStyle.curveness') || 0;
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var points = [p1, p2];
	
	    if (+curveness) {
	      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	    }
	
	    edge.setLayout(points);
	  });
	}
	
	exports.simpleLayout = simpleLayout;
	exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _circularLayoutHelper = __webpack_require__(394);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    if (seriesModel.get('layout') === 'circular') {
	      circularLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(136);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function circularLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var rect = coordSys.getBoundingRect();
	  var nodeData = seriesModel.getData();
	  var graph = nodeData.graph;
	  var angle = 0;
	  var sum = nodeData.getSum('value');
	  var unitAngle = Math.PI * 2 / (sum || nodeData.count());
	  var cx = rect.width / 2 + rect.x;
	  var cy = rect.height / 2 + rect.y;
	  var r = Math.min(rect.width, rect.height) / 2;
	  graph.eachNode(function (node) {
	    var value = node.getValue('value');
	    angle += unitAngle * (sum ? value : 1) / 2;
	    node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	    angle += unitAngle * (sum ? value : 1) / 2;
	  });
	  nodeData.setLayout({
	    cx: cx,
	    cy: cy
	  });
	  graph.eachEdge(function (edge) {
	    var curveness = edge.getModel().get('lineStyle.curveness') || 0;
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var cp1;
	    var x12 = (p1[0] + p2[0]) / 2;
	    var y12 = (p1[1] + p2[1]) / 2;
	
	    if (+curveness) {
	      curveness *= 3;
	      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	    }
	
	    edge.setLayout([p1, p2, cp1]);
	  });
	}
	
	exports.circularLayout = circularLayout;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _forceHelper = __webpack_require__(396);
	
	var forceLayout = _forceHelper.forceLayout;
	
	var _simpleLayoutHelper = __webpack_require__(392);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	
	var _circularLayoutHelper = __webpack_require__(394);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	var _number = __webpack_require__(218);
	
	var linearMap = _number.linearMap;
	
	var vec2 = __webpack_require__(136);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var coordSys = graphSeries.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      return;
	    }
	
	    if (graphSeries.get('layout') === 'force') {
	      var preservedPoints = graphSeries.preservedPoints || {};
	      var graph = graphSeries.getGraph();
	      var nodeData = graph.data;
	      var edgeData = graph.edgeData;
	      var forceModel = graphSeries.getModel('force');
	      var initLayout = forceModel.get('initLayout');
	
	      if (graphSeries.preservedPoints) {
	        nodeData.each(function (idx) {
	          var id = nodeData.getId(idx);
	          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
	        });
	      } else if (!initLayout || initLayout === 'none') {
	        simpleLayout(graphSeries);
	      } else if (initLayout === 'circular') {
	        circularLayout(graphSeries);
	      }
	
	      var nodeDataExtent = nodeData.getDataExtent('value');
	      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');
	
	      var repulsion = forceModel.get('repulsion');
	      var edgeLength = forceModel.get('edgeLength');
	
	      if (!zrUtil.isArray(repulsion)) {
	        repulsion = [repulsion, repulsion];
	      }
	
	      if (!zrUtil.isArray(edgeLength)) {
	        edgeLength = [edgeLength, edgeLength];
	      } // Larger value has smaller length
	
	
	      edgeLength = [edgeLength[1], edgeLength[0]];
	      var nodes = nodeData.mapArray('value', function (value, idx) {
	        var point = nodeData.getItemLayout(idx);
	        var rep = linearMap(value, nodeDataExtent, repulsion);
	
	        if (isNaN(rep)) {
	          rep = (repulsion[0] + repulsion[1]) / 2;
	        }
	
	        return {
	          w: rep,
	          rep: rep,
	          fixed: nodeData.getItemModel(idx).get('fixed'),
	          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	        };
	      });
	      var edges = edgeData.mapArray('value', function (value, idx) {
	        var edge = graph.getEdgeByIndex(idx);
	        var d = linearMap(value, edgeDataExtent, edgeLength);
	
	        if (isNaN(d)) {
	          d = (edgeLength[0] + edgeLength[1]) / 2;
	        }
	
	        return {
	          n1: nodes[edge.node1.dataIndex],
	          n2: nodes[edge.node2.dataIndex],
	          d: d,
	          curveness: edge.getModel().get('lineStyle.curveness') || 0
	        };
	      });
	      var coordSys = graphSeries.coordinateSystem;
	      var rect = coordSys.getBoundingRect();
	      var forceInstance = forceLayout(nodes, edges, {
	        rect: rect,
	        gravity: forceModel.get('gravity')
	      });
	      var oldStep = forceInstance.step;
	
	      forceInstance.step = function (cb) {
	        for (var i = 0, l = nodes.length; i < l; i++) {
	          if (nodes[i].fixed) {
	            // Write back to layout instance
	            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
	          }
	        }
	
	        oldStep(function (nodes, edges, stopped) {
	          for (var i = 0, l = nodes.length; i < l; i++) {
	            if (!nodes[i].fixed) {
	              graph.getNodeByIndex(i).setLayout(nodes[i].p);
	            }
	
	            preservedPoints[nodeData.getId(i)] = nodes[i].p;
	          }
	
	          for (var i = 0, l = edges.length; i < l; i++) {
	            var e = edges[i];
	            var edge = graph.getEdgeByIndex(i);
	            var p1 = e.n1.p;
	            var p2 = e.n2.p;
	            var points = edge.getLayout();
	            points = points ? points.slice() : [];
	            points[0] = points[0] || [];
	            points[1] = points[1] || [];
	            vec2.copy(points[0], p1);
	            vec2.copy(points[1], p2);
	
	            if (+e.curveness) {
	              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	            }
	
	            edge.setLayout(points);
	          } // Update layout
	
	
	          cb && cb(stopped);
	        });
	      };
	
	      graphSeries.forceLayout = forceInstance;
	      graphSeries.preservedPoints = preservedPoints; // Step to get the layout
	
	      forceInstance.step();
	    } else {
	      // Remove prev injected forceLayout instance
	      graphSeries.forceLayout = null;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(136);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* Some formulas were originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment of the method "step" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
	//     return e.n1 === n ? e.n2 : e.n1;
	// }
	
	function forceLayout(nodes, edges, opts) {
	  var rect = opts.rect;
	  var width = rect.width;
	  var height = rect.height;
	  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;
	
	  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
	  //     var e = edges[i];
	  //     var n1 = e.n1;
	  //     var n2 = e.n2;
	  //     n1.edges = n1.edges || [];
	  //     n2.edges = n2.edges || [];
	  //     n1.edges.push(e);
	  //     n2.edges.push(e);
	  // }
	  // Init position
	
	  for (var i = 0; i < nodes.length; i++) {
	    var n = nodes[i];
	
	    if (!n.p) {
	      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
	    }
	
	    n.pp = vec2.clone(n.p);
	    n.edges = null;
	  } // Formula in 'Graph Drawing by Force-directed Placement'
	  // var k = scale * Math.sqrt(width * height / nodes.length);
	  // var k2 = k * k;
	
	
	  var friction = 0.6;
	  return {
	    warmUp: function () {
	      friction = 0.5;
	    },
	    setFixed: function (idx) {
	      nodes[idx].fixed = true;
	    },
	    setUnfixed: function (idx) {
	      nodes[idx].fixed = false;
	    },
	
	    /**
	     * Some formulas were originally copied from "d3.js"
	     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
	     * with some modifications made for this project.
	     * See the license statement at the head of this file.
	     */
	    step: function (cb) {
	      var v12 = [];
	      var nLen = nodes.length;
	
	      for (var i = 0; i < edges.length; i++) {
	        var e = edges[i];
	        var n1 = e.n1;
	        var n2 = e.n2;
	        vec2.sub(v12, n2.p, n1.p);
	        var d = vec2.len(v12) - e.d;
	        var w = n2.w / (n1.w + n2.w);
	
	        if (isNaN(w)) {
	          w = 0;
	        }
	
	        vec2.normalize(v12, v12);
	        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
	        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
	      } // Gravity
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
	          // vec2.scale(v12, v12, 1 / d);
	          // var gravityFactor = gravity;
	
	          scaleAndAdd(n.p, n.p, v12, gravity * friction);
	        }
	      } // Repulsive
	      // PENDING
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n1 = nodes[i];
	
	        for (var j = i + 1; j < nLen; j++) {
	          var n2 = nodes[j];
	          vec2.sub(v12, n2.p, n1.p);
	          var d = vec2.len(v12);
	
	          if (d === 0) {
	            // Random repulse
	            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
	            d = 1;
	          }
	
	          var repFact = (n1.rep + n2.rep) / d / d;
	          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
	          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
	        }
	      }
	
	      var v = [];
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v, n.p, n.pp);
	          scaleAndAdd(n.p, n.p, v, friction);
	          vec2.copy(n.pp, n.p);
	        }
	      }
	
	      friction = friction * 0.992;
	      cb && cb(nodes, edges, friction < 0.01);
	    }
	  };
	}
	
	exports.forceLayout = forceLayout;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var View = __webpack_require__(353);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var bbox = __webpack_require__(185);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Where to create the simple view coordinate system
	function getViewRect(seriesModel, api, aspect) {
	  var option = seriesModel.getBoxLayoutParams();
	  option.aspect = aspect;
	  return getLayoutRect(option, {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(ecModel, api) {
	  var viewList = [];
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var coordSysType = seriesModel.get('coordinateSystem');
	
	    if (!coordSysType || coordSysType === 'view') {
	      var data = seriesModel.getData();
	      var positions = data.mapArray(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        return [+itemModel.get('x'), +itemModel.get('y')];
	      });
	      var min = [];
	      var max = [];
	      bbox.fromPoints(positions, min, max); // If width or height is 0
	
	      if (max[0] - min[0] === 0) {
	        max[0] += 1;
	        min[0] -= 1;
	      }
	
	      if (max[1] - min[1] === 0) {
	        max[1] += 1;
	        min[1] -= 1;
	      }
	
	      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	      if (isNaN(aspect)) {
	        min = [viewRect.x, viewRect.y];
	        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	      }
	
	      var bbWidth = max[0] - min[0];
	      var bbHeight = max[1] - min[1];
	      var viewWidth = viewRect.width;
	      var viewHeight = viewRect.height;
	      var viewCoordSys = seriesModel.coordinateSystem = new View();
	      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	      viewCoordSys.setCenter(seriesModel.get('center'));
	      viewCoordSys.setZoom(seriesModel.get('zoom'));
	      viewList.push(viewCoordSys);
	    }
	  });
	  return viewList;
	}
	
	module.exports = _default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(399);
	
	__webpack_require__(400);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(312);
	
	var SeriesModel = __webpack_require__(233);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GaugeSeries = SeriesModel.extend({
	  type: 'series.gauge',
	  getInitialData: function (option, ecModel) {
	    var dataOpt = option.data || [];
	
	    if (!zrUtil.isArray(dataOpt)) {
	      dataOpt = [dataOpt];
	    }
	
	    option.data = dataOpt;
	    return createListSimply(this, ['value']);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    legendHoverLink: true,
	    radius: '75%',
	    startAngle: 225,
	    endAngle: -45,
	    clockwise: true,
	    // 最小值
	    min: 0,
	    // 最大值
	    max: 100,
	    // 分割段数，默认为10
	    splitNumber: 10,
	    // 坐标轴线
	    axisLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      lineStyle: {
	        // 属性lineStyle控制线条样式
	        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
	        width: 30
	      }
	    },
	    // 分隔线
	    splitLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      // 属性length控制线长
	      length: 30,
	      // 属性lineStyle（详见lineStyle）控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // 坐标轴小标记
	    axisTick: {
	      // 属性show控制显示与否，默认不显示
	      show: true,
	      // 每份split细分多少段
	      splitNumber: 5,
	      // 属性length控制线长
	      length: 8,
	      // 属性lineStyle控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    axisLabel: {
	      show: true,
	      distance: 5,
	      // formatter: null,
	      color: 'auto'
	    },
	    pointer: {
	      show: true,
	      length: '80%',
	      width: 8
	    },
	    itemStyle: {
	      color: 'auto'
	    },
	    title: {
	      show: true,
	      // x, y，单位px
	      offsetCenter: [0, '-40%'],
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#333',
	      fontSize: 15
	    },
	    detail: {
	      show: true,
	      backgroundColor: 'rgba(0,0,0,0)',
	      borderWidth: 0,
	      borderColor: '#ccc',
	      width: 100,
	      height: null,
	      // self-adaption
	      padding: [5, 10],
	      // x, y，单位px
	      offsetCenter: [0, '40%'],
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: 'auto',
	      fontSize: 30
	    }
	  }
	});
	var _default = GaugeSeries;
	module.exports = _default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var PointerPath = __webpack_require__(401);
	
	var graphic = __webpack_require__(180);
	
	var ChartView = __webpack_require__(238);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	var round = _number.round;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function parsePosition(seriesModel, api) {
	  var center = seriesModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var size = Math.min(width, height);
	  var cx = parsePercent(center[0], api.getWidth());
	  var cy = parsePercent(center[1], api.getHeight());
	  var r = parsePercent(seriesModel.get('radius'), size / 2);
	  return {
	    cx: cx,
	    cy: cy,
	    r: r
	  };
	}
	
	function formatLabel(label, labelFormatter) {
	  if (labelFormatter) {
	    if (typeof labelFormatter === 'string') {
	      label = labelFormatter.replace('{value}', label != null ? label : '');
	    } else if (typeof labelFormatter === 'function') {
	      label = labelFormatter(label);
	    }
	  }
	
	  return label;
	}
	
	var PI2 = Math.PI * 2;
	var GaugeView = ChartView.extend({
	  type: 'gauge',
	  render: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	    var colorList = seriesModel.get('axisLine.lineStyle.color');
	    var posInfo = parsePosition(seriesModel, api);
	
	    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	  },
	  dispose: function () {},
	  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
	    var group = this.group;
	    var axisLineModel = seriesModel.getModel('axisLine');
	    var lineStyleModel = axisLineModel.getModel('lineStyle');
	    var clockwise = seriesModel.get('clockwise');
	    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	    var angleRangeSpan = (endAngle - startAngle) % PI2;
	    var prevEndAngle = startAngle;
	    var axisLineWidth = lineStyleModel.get('width');
	
	    for (var i = 0; i < colorList.length; i++) {
	      // Clamp
	      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	      var endAngle = startAngle + angleRangeSpan * percent;
	      var sector = new graphic.Sector({
	        shape: {
	          startAngle: prevEndAngle,
	          endAngle: endAngle,
	          cx: posInfo.cx,
	          cy: posInfo.cy,
	          clockwise: clockwise,
	          r0: posInfo.r - axisLineWidth,
	          r: posInfo.r
	        },
	        silent: true
	      });
	      sector.setStyle({
	        fill: colorList[i][1]
	      });
	      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	      // so the properties for stroking are useless
	      ['color', 'borderWidth', 'borderColor']));
	      group.add(sector);
	      prevEndAngle = endAngle;
	    }
	
	    var getColor = function (percent) {
	      // Less than 0
	      if (percent <= 0) {
	        return colorList[0][1];
	      }
	
	      for (var i = 0; i < colorList.length; i++) {
	        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	          return colorList[i][1];
	        }
	      } // More than 1
	
	
	      return colorList[i - 1][1];
	    };
	
	    if (!clockwise) {
	      var tmp = startAngle;
	      startAngle = endAngle;
	      endAngle = tmp;
	    }
	
	    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
	
	    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
	  },
	  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var cx = posInfo.cx;
	    var cy = posInfo.cy;
	    var r = posInfo.r;
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	    var splitLineModel = seriesModel.getModel('splitLine');
	    var tickModel = seriesModel.getModel('axisTick');
	    var labelModel = seriesModel.getModel('axisLabel');
	    var splitNumber = seriesModel.get('splitNumber');
	    var subSplitNumber = tickModel.get('splitNumber');
	    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
	    var tickLen = parsePercent(tickModel.get('length'), r);
	    var angle = startAngle;
	    var step = (endAngle - startAngle) / splitNumber;
	    var subStep = step / subSplitNumber;
	    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	
	    for (var i = 0; i <= splitNumber; i++) {
	      var unitX = Math.cos(angle);
	      var unitY = Math.sin(angle); // Split line
	
	      if (splitLineModel.get('show')) {
	        var splitLine = new graphic.Line({
	          shape: {
	            x1: unitX * r + cx,
	            y1: unitY * r + cy,
	            x2: unitX * (r - splitLineLen) + cx,
	            y2: unitY * (r - splitLineLen) + cy
	          },
	          style: splitLineStyle,
	          silent: true
	        });
	
	        if (splitLineStyle.stroke === 'auto') {
	          splitLine.setStyle({
	            stroke: getColor(i / splitNumber)
	          });
	        }
	
	        group.add(splitLine);
	      } // Label
	
	
	      if (labelModel.get('show')) {
	        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	        var distance = labelModel.get('distance');
	        var autoColor = getColor(i / splitNumber);
	        group.add(new graphic.Text({
	          style: graphic.setTextStyle({}, labelModel, {
	            text: label,
	            x: unitX * (r - splitLineLen - distance) + cx,
	            y: unitY * (r - splitLineLen - distance) + cy,
	            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
	            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	          }, {
	            autoColor: autoColor
	          }),
	          silent: true
	        }));
	      } // Axis tick
	
	
	      if (tickModel.get('show') && i !== splitNumber) {
	        for (var j = 0; j <= subSplitNumber; j++) {
	          var unitX = Math.cos(angle);
	          var unitY = Math.sin(angle);
	          var tickLine = new graphic.Line({
	            shape: {
	              x1: unitX * r + cx,
	              y1: unitY * r + cy,
	              x2: unitX * (r - tickLen) + cx,
	              y2: unitY * (r - tickLen) + cy
	            },
	            silent: true,
	            style: tickLineStyle
	          });
	
	          if (tickLineStyle.stroke === 'auto') {
	            tickLine.setStyle({
	              stroke: getColor((i + j / subSplitNumber) / splitNumber)
	            });
	          }
	
	          group.add(tickLine);
	          angle += subStep;
	        }
	
	        angle -= subStep;
	      } else {
	        angle += step;
	      }
	    }
	  },
	  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var oldData = this._data;
	
	    if (!seriesModel.get('pointer.show')) {
	      // Remove old element
	      oldData && oldData.eachItemGraphicEl(function (el) {
	        group.remove(el);
	      });
	      return;
	    }
	
	    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
	    var angleExtent = [startAngle, endAngle];
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    data.diff(oldData).add(function (idx) {
	      var pointer = new PointerPath({
	        shape: {
	          angle: startAngle
	        }
	      });
	      graphic.initProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(idx, pointer);
	    }).update(function (newIdx, oldIdx) {
	      var pointer = oldData.getItemGraphicEl(oldIdx);
	      graphic.updateProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(newIdx, pointer);
	    }).remove(function (idx) {
	      var pointer = oldData.getItemGraphicEl(idx);
	      group.remove(pointer);
	    }).execute();
	    data.eachItemGraphicEl(function (pointer, idx) {
	      var itemModel = data.getItemModel(idx);
	      var pointerModel = itemModel.getModel('pointer');
	      pointer.setShape({
	        x: posInfo.cx,
	        y: posInfo.cy,
	        width: parsePercent(pointerModel.get('width'), posInfo.r),
	        r: parsePercent(pointerModel.get('length'), posInfo.r)
	      });
	      pointer.useStyle(itemModel.getModel('itemStyle').getItemStyle());
	
	      if (pointer.style.fill === 'auto') {
	        pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
	      }
	
	      graphic.setHoverStyle(pointer, itemModel.getModel('emphasis.itemStyle').getItemStyle());
	    });
	    this._data = data;
	  },
	  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var titleModel = seriesModel.getModel('title');
	
	    if (titleModel.get('show')) {
	      var offsetCenter = titleModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var minVal = +seriesModel.get('min');
	      var maxVal = +seriesModel.get('max');
	      var value = seriesModel.getData().get(valueDim, 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, titleModel, {
	          x: x,
	          y: y,
	          // FIXME First data name ?
	          text: data.getName(0),
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  },
	  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var detailModel = seriesModel.getModel('detail');
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	
	    if (detailModel.get('show')) {
	      var offsetCenter = detailModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var width = parsePercent(detailModel.get('width'), posInfo.r);
	      var height = parsePercent(detailModel.get('height'), posInfo.r);
	      var data = seriesModel.getData();
	      var value = data.get(data.mapDimension('value'), 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, detailModel, {
	          x: x,
	          y: y,
	          text: formatLabel( // FIXME First data name ?
	          value, detailModel.get('formatter')),
	          textWidth: isNaN(width) ? null : width,
	          textHeight: isNaN(height) ? null : height,
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  }
	});
	var _default = GaugeView;
	module.exports = _default;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(182);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Path.extend({
	  type: 'echartsGaugePointer',
	  shape: {
	    angle: 0,
	    width: 10,
	    r: 10,
	    x: 0,
	    y: 0
	  },
	  buildPath: function (ctx, shape) {
	    var mathCos = Math.cos;
	    var mathSin = Math.sin;
	    var r = shape.r;
	    var width = shape.width;
	    var angle = shape.angle;
	    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	    angle = shape.angle - Math.PI / 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	    ctx.lineTo(x, y);
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(403);
	
	__webpack_require__(404);
	
	var dataColor = __webpack_require__(316);
	
	var funnelLayout = __webpack_require__(405);
	
	var dataFilter = __webpack_require__(319);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(dataColor('funnel'));
	echarts.registerLayout(funnelLayout);
	echarts.registerProcessor(dataFilter('funnel'));

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var createListSimply = __webpack_require__(312);
	
	var _model = __webpack_require__(173);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FunnelSeries = echarts.extendSeriesModel({
	  type: 'series.funnel',
	  init: function (option) {
	    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    }; // Extend labelLine emphasis
	
	
	    this._defaultLabelLine(option);
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, ['value']);
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
	    var valueDim = data.mapDimension('value');
	    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
	
	    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
	    params.$vars.push('percent');
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    legendHoverLink: true,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    // 默认取数据最小最大值
	    // min: 0,
	    // max: 100,
	    minSize: '0%',
	    maxSize: '100%',
	    sort: 'descending',
	    // 'ascending', 'descending'
	    gap: 0,
	    funnelAlign: 'center',
	    label: {
	      show: true,
	      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    labelLine: {
	      show: true,
	      length: 20,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      // color: 各异,
	      borderColor: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = FunnelSeries;
	module.exports = _default;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var zrUtil = __webpack_require__(134);
	
	var ChartView = __webpack_require__(238);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	function FunnelPiece(data, idx) {
	  graphic.Group.call(this);
	  var polygon = new graphic.Polygon();
	  var labelLine = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(polygon);
	  this.add(labelLine);
	  this.add(text);
	  this.updateData(data, idx, true); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    labelLine.ignore = labelLine.hoverIgnore;
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    labelLine.ignore = labelLine.normalIgnore;
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var funnelPieceProto = FunnelPiece.prototype;
	var opacityAccessPath = ['itemStyle', 'opacity'];
	
	funnelPieceProto.updateData = function (data, idx, firstCreate) {
	  var polygon = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var opacity = data.getItemModel(idx).get(opacityAccessPath);
	  opacity = opacity == null ? 1 : opacity; // Reset style
	
	  polygon.useStyle({});
	
	  if (firstCreate) {
	    polygon.setShape({
	      points: layout.points
	    });
	    polygon.setStyle({
	      opacity: 0
	    });
	    graphic.initProps(polygon, {
	      style: {
	        opacity: opacity
	      }
	    }, seriesModel, idx);
	  } else {
	    graphic.updateProps(polygon, {
	      style: {
	        opacity: opacity
	      },
	      shape: {
	        points: layout.points
	      }
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  polygon.setStyle(zrUtil.defaults({
	    lineJoin: 'round',
	    fill: visualColor
	  }, itemStyleModel.getItemStyle(['opacity'])));
	  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	funnelPieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || labelLayout.linePoints
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	};
	
	zrUtil.inherits(FunnelPiece, graphic.Group);
	var FunnelView = ChartView.extend({
	  type: 'funnel',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    data.diff(oldData).add(function (idx) {
	      var funnelPiece = new FunnelPiece(data, idx);
	      data.setItemGraphicEl(idx, funnelPiece);
	      group.add(funnelPiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	var _default = FunnelView;
	module.exports = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(217);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function getSortedIndices(data, sort) {
	  var valueDim = data.mapDimension('value');
	  var valueArr = data.mapArray(valueDim, function (val) {
	    return val;
	  });
	  var indices = [];
	  var isAscending = sort === 'ascending';
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    indices[i] = i;
	  } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	  if (typeof sort === 'function') {
	    indices.sort(sort);
	  } else if (sort !== 'none') {
	    indices.sort(function (a, b) {
	      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	    });
	  }
	
	  return indices;
	}
	
	function labelLayout(data) {
	  data.each(function (idx) {
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label');
	    var labelPosition = labelModel.get('position');
	    var labelLineModel = itemModel.getModel('labelLine');
	    var layout = data.getItemLayout(idx);
	    var points = layout.points;
	    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center';
	    var textAlign;
	    var textX;
	    var textY;
	    var linePoints;
	
	    if (isLabelInside) {
	      textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	      textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	      textAlign = 'center';
	      linePoints = [[textX, textY], [textX, textY]];
	    } else {
	      var x1;
	      var y1;
	      var x2;
	      var labelLineLen = labelLineModel.get('length');
	
	      if (labelPosition === 'left') {
	        // Left side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        x2 = x1 - labelLineLen;
	        textX = x2 - 5;
	        textAlign = 'right';
	      } else {
	        // Right side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        x2 = x1 + labelLineLen;
	        textX = x2 + 5;
	        textAlign = 'left';
	      }
	
	      var y2 = y1;
	      linePoints = [[x1, y1], [x2, y2]];
	      textY = y2;
	    }
	
	    layout.label = {
	      linePoints: linePoints,
	      x: textX,
	      y: textY,
	      verticalAlign: 'middle',
	      textAlign: textAlign,
	      inside: isLabelInside
	    };
	  });
	}
	
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('funnel', function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var sort = seriesModel.get('sort');
	    var viewRect = getViewRect(seriesModel, api);
	    var indices = getSortedIndices(data, sort);
	    var sizeExtent = [parsePercent(seriesModel.get('minSize'), viewRect.width), parsePercent(seriesModel.get('maxSize'), viewRect.width)];
	    var dataExtent = data.getDataExtent(valueDim);
	    var min = seriesModel.get('min');
	    var max = seriesModel.get('max');
	
	    if (min == null) {
	      min = Math.min(dataExtent[0], 0);
	    }
	
	    if (max == null) {
	      max = dataExtent[1];
	    }
	
	    var funnelAlign = seriesModel.get('funnelAlign');
	    var gap = seriesModel.get('gap');
	    var itemHeight = (viewRect.height - gap * (data.count() - 1)) / data.count();
	    var y = viewRect.y;
	
	    var getLinePoints = function (idx, offY) {
	      // End point index is data.count() and we assign it 0
	      var val = data.get(valueDim, idx) || 0;
	      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	      var x0;
	
	      switch (funnelAlign) {
	        case 'left':
	          x0 = viewRect.x;
	          break;
	
	        case 'center':
	          x0 = viewRect.x + (viewRect.width - itemWidth) / 2;
	          break;
	
	        case 'right':
	          x0 = viewRect.x + viewRect.width - itemWidth;
	          break;
	      }
	
	      return [[x0, offY], [x0 + itemWidth, offY]];
	    };
	
	    if (sort === 'ascending') {
	      // From bottom to top
	      itemHeight = -itemHeight;
	      gap = -gap;
	      y += viewRect.height;
	      indices = indices.reverse();
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	      var idx = indices[i];
	      var nextIdx = indices[i + 1];
	      var itemModel = data.getItemModel(idx);
	      var height = itemModel.get('itemStyle.height');
	
	      if (height == null) {
	        height = itemHeight;
	      } else {
	        height = parsePercent(height, viewRect.height);
	
	        if (sort === 'ascending') {
	          height = -height;
	        }
	      }
	
	      var start = getLinePoints(idx, y);
	      var end = getLinePoints(nextIdx, y + height);
	      y += height + gap;
	      data.setItemLayout(idx, {
	        points: start.concat(end.slice().reverse())
	      });
	    }
	
	    labelLayout(data);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(407);
	
	__webpack_require__(420);
	
	__webpack_require__(421);
	
	var parallelVisual = __webpack_require__(422);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(parallelVisual);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var throttleUtil = __webpack_require__(240);
	
	var parallelPreprocessor = __webpack_require__(408);
	
	__webpack_require__(409);
	
	__webpack_require__(413);
	
	__webpack_require__(415);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CLICK_THRESHOLD = 5; // > 4
	// Parallel view
	
	echarts.extendComponentView({
	  type: 'parallel',
	  render: function (parallelModel, ecModel, api) {
	    this._model = parallelModel;
	    this._api = api;
	
	    if (!this._handlers) {
	      this._handlers = {};
	      zrUtil.each(handlers, function (handler, eventName) {
	        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
	      }, this);
	    }
	
	    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._handlers, function (handler, eventName) {
	      api.getZr().off(eventName, handler);
	    });
	    this._handlers = null;
	  },
	
	  /**
	   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
	   */
	  _throttledDispatchExpand: function (opt) {
	    this._dispatchExpand(opt);
	  },
	  _dispatchExpand: function (opt) {
	    opt && this._api.dispatchAction(zrUtil.extend({
	      type: 'parallelAxisExpand'
	    }, opt));
	  }
	});
	var handlers = {
	  mousedown: function (e) {
	    if (checkTrigger(this, 'click')) {
	      this._mouseDownPoint = [e.offsetX, e.offsetY];
	    }
	  },
	  mouseup: function (e) {
	    var mouseDownPoint = this._mouseDownPoint;
	
	    if (checkTrigger(this, 'click') && mouseDownPoint) {
	      var point = [e.offsetX, e.offsetY];
	      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	      if (dist > CLICK_THRESHOLD) {
	        return;
	      }
	
	      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	      result.behavior !== 'none' && this._dispatchExpand({
	        axisExpandWindow: result.axisExpandWindow
	      });
	    }
	
	    this._mouseDownPoint = null;
	  },
	  mousemove: function (e) {
	    // Should do nothing when brushing.
	    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	      return;
	    }
	
	    var model = this._model;
	    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	    var behavior = result.behavior;
	    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
	    : {
	      axisExpandWindow: result.axisExpandWindow,
	      // Jumping uses animation, and sliding suppresses animation.
	      animation: behavior === 'jump' ? null : false
	    });
	  }
	};
	
	function checkTrigger(view, triggerOn) {
	  var model = view._model;
	  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	}
	
	echarts.registerPreprocessor(parallelPreprocessor);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  createParallelIfNeeded(option);
	  mergeAxisOptionFromParallel(option);
	}
	/**
	 * Create a parallel coordinate if not exists.
	 * @inner
	 */
	
	
	function createParallelIfNeeded(option) {
	  if (option.parallel) {
	    return;
	  }
	
	  var hasParallelSeries = false;
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'parallel') {
	      hasParallelSeries = true;
	    }
	  });
	
	  if (hasParallelSeries) {
	    option.parallel = [{}];
	  }
	}
	/**
	 * Merge aixs definition from parallel option (if exists) to axis option.
	 * @inner
	 */
	
	
	function mergeAxisOptionFromParallel(option) {
	  var axes = modelUtil.normalizeToArray(option.parallelAxis);
	  zrUtil.each(axes, function (axisOption) {
	    if (!zrUtil.isObject(axisOption)) {
	      return;
	    }
	
	    var parallelIndex = axisOption.parallelIndex || 0;
	    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];
	
	    if (parallelOption && parallelOption.parallelAxisDefault) {
	      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Parallel = __webpack_require__(410);
	
	var CoordinateSystem = __webpack_require__(228);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel coordinate system creater.
	 */
	function create(ecModel, api) {
	  var coordSysList = [];
	  ecModel.eachComponent('parallel', function (parallelModel, idx) {
	    var coordSys = new Parallel(parallelModel, ecModel, api);
	    coordSys.name = 'parallel_' + idx;
	    coordSys.resize(parallelModel, api);
	    parallelModel.coordinateSystem = coordSys;
	    coordSys.model = parallelModel;
	    coordSysList.push(coordSys);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'parallel') {
	      var parallelModel = ecModel.queryComponents({
	        mainType: 'parallel',
	        index: seriesModel.get('parallelIndex'),
	        id: seriesModel.get('parallelId')
	      })[0];
	      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	    }
	  });
	  return coordSysList;
	}
	
	CoordinateSystem.register('parallel', {
	  create: create
	});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var matrix = __webpack_require__(145);
	
	var layoutUtil = __webpack_require__(217);
	
	var axisHelper = __webpack_require__(261);
	
	var ParallelAxis = __webpack_require__(411);
	
	var graphic = __webpack_require__(180);
	
	var numberUtil = __webpack_require__(218);
	
	var sliderMove = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel Coordinates
	 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
	 */
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var round = numberUtil.round;
	var PI = Math.PI;
	
	function Parallel(parallelModel, ecModel, api) {
	  /**
	   * key: dimension
	   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
	   * @private
	   */
	  this._axesMap = zrUtil.createHashMap();
	  /**
	   * key: dimension
	   * value: {position: [], rotation, }
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._axesLayout = {};
	  /**
	   * Always follow axis order.
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = parallelModel.dimensions;
	  /**
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	  /**
	   * @type {module:echarts/coord/parallel/ParallelModel}
	   */
	
	  this._model = parallelModel;
	
	  this._init(parallelModel, ecModel, api);
	}
	
	Parallel.prototype = {
	  type: 'parallel',
	  constructor: Parallel,
	
	  /**
	   * Initialize cartesian coordinate systems
	   * @private
	   */
	  _init: function (parallelModel, ecModel, api) {
	    var dimensions = parallelModel.dimensions;
	    var parallelAxisIndex = parallelModel.parallelAxisIndex;
	    each(dimensions, function (dim, idx) {
	      var axisIndex = parallelAxisIndex[idx];
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Injection
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	      axis.coordinateSystem = axisModel.coordinateSystem = this;
	    }, this);
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    this._updateAxesFromSeries(this._model, ecModel);
	  },
	
	  /**
	   * @override
	   */
	  containPoint: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var axisBase = layoutInfo.axisBase;
	    var layoutBase = layoutInfo.layoutBase;
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var pAxis = point[1 - pixelDimIndex];
	    var pLayout = point[pixelDimIndex];
	    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	  },
	  getModel: function () {
	    return this._model;
	  },
	
	  /**
	   * Update properties from series
	   * @private
	   */
	  _updateAxesFromSeries: function (parallelModel, ecModel) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (!parallelModel.contains(seriesModel, ecModel)) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      each(this.dimensions, function (dim) {
	        var axis = this._axesMap.get(dim);
	
	        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
	        axisHelper.niceScaleExtent(axis.scale, axis.model);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * Resize the parallel coordinate system.
	   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
	   * @param {module:echarts/ExtensionAPI} api
	   */
	  resize: function (parallelModel, api) {
	    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._layoutAxes();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _makeLayoutInfo: function () {
	    var parallelModel = this._model;
	    var rect = this._rect;
	    var xy = ['x', 'y'];
	    var wh = ['width', 'height'];
	    var layout = parallelModel.get('layout');
	    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	    var layoutLength = rect[wh[pixelDimIndex]];
	    var layoutExtent = [0, layoutLength];
	    var axisCount = this.dimensions.length;
	    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
	    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	    // where collapsed axes should be overlapped.
	
	    var axisExpandWindow = parallelModel.get('axisExpandWindow');
	    var winSize;
	
	    if (!axisExpandWindow) {
	      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
	      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    } else {
	      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    }
	
	    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	    return {
	      layout: layout,
	      pixelDimIndex: pixelDimIndex,
	      layoutBase: rect[xy[pixelDimIndex]],
	      layoutLength: layoutLength,
	      axisBase: rect[xy[1 - pixelDimIndex]],
	      axisLength: rect[wh[1 - pixelDimIndex]],
	      axisExpandable: axisExpandable,
	      axisExpandWidth: axisExpandWidth,
	      axisCollapseWidth: axisCollapseWidth,
	      axisExpandWindow: axisExpandWindow,
	      axisCount: axisCount,
	      winInnerIndices: winInnerIndices,
	      axisExpandWindow0Pos: axisExpandWindow0Pos
	    };
	  },
	
	  /**
	   * @private
	   */
	  _layoutAxes: function () {
	    var rect = this._rect;
	    var axes = this._axesMap;
	    var dimensions = this.dimensions;
	
	    var layoutInfo = this._makeLayoutInfo();
	
	    var layout = layoutInfo.layout;
	    axes.each(function (axis) {
	      var axisExtent = [0, layoutInfo.axisLength];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	    });
	    each(dimensions, function (dim, idx) {
	      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	      var positionTable = {
	        horizontal: {
	          x: posInfo.position,
	          y: layoutInfo.axisLength
	        },
	        vertical: {
	          x: 0,
	          y: posInfo.position
	        }
	      };
	      var rotationTable = {
	        horizontal: PI / 2,
	        vertical: 0
	      };
	      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	      var rotation = rotationTable[layout];
	      var transform = matrix.create();
	      matrix.rotate(transform, transform, rotation);
	      matrix.translate(transform, transform, position); // TODO
	      // tick等排布信息。
	      // TODO
	      // 根据axis order 更新 dimensions顺序。
	
	      this._axesLayout[dim] = {
	        position: position,
	        rotation: rotation,
	        transform: transform,
	        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	        axisLabelShow: posInfo.axisLabelShow,
	        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	        tickDirection: 1,
	        labelDirection: 1
	      };
	    }, this);
	  },
	
	  /**
	   * Get axis by dim.
	   * @param {string} dim
	   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
	   */
	  getAxis: function (dim) {
	    return this._axesMap.get(dim);
	  },
	
	  /**
	   * Convert a dim value of a single item of series data to Point.
	   * @param {*} value
	   * @param {string} dim
	   * @return {Array}
	   */
	  dataToPoint: function (value, dim) {
	    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	  },
	
	  /**
	   * Travel data for one time, get activeState of each data item.
	   * @param {module:echarts/data/List} data
	   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
	   *                            {number} dataIndex
	   * @param {number} [start=0] the start dataIndex that travel from.
	   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
	   */
	  eachActiveState: function (data, callback, start, end) {
	    start == null && (start = 0);
	    end == null && (end = data.count());
	    var axesMap = this._axesMap;
	    var dimensions = this.dimensions;
	    var dataDimensions = [];
	    var axisModels = [];
	    zrUtil.each(dimensions, function (axisDim) {
	      dataDimensions.push(data.mapDimension(axisDim));
	      axisModels.push(axesMap.get(axisDim).model);
	    });
	    var hasActiveSet = this.hasAxisBrushed();
	
	    for (var dataIndex = start; dataIndex < end; dataIndex++) {
	      var activeState;
	
	      if (!hasActiveSet) {
	        activeState = 'normal';
	      } else {
	        activeState = 'active';
	        var values = data.getValues(dataDimensions, dataIndex);
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          var state = axisModels[j].getActiveState(values[j]);
	
	          if (state === 'inactive') {
	            activeState = 'inactive';
	            break;
	          }
	        }
	      }
	
	      callback(activeState, dataIndex);
	    }
	  },
	
	  /**
	   * Whether has any activeSet.
	   * @return {boolean}
	   */
	  hasAxisBrushed: function () {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = false;
	
	    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	        hasActiveSet = true;
	      }
	    }
	
	    return hasActiveSet;
	  },
	
	  /**
	   * Convert coords of each axis to Point.
	   *  Return point. For example: [10, 20]
	   * @param {Array.<number>} coords
	   * @param {string} dim
	   * @return {Array.<number>}
	   */
	  axisCoordToPoint: function (coord, dim) {
	    var axisLayout = this._axesLayout[dim];
	    return graphic.applyTransform([coord, 0], axisLayout.transform);
	  },
	
	  /**
	   * Get axis layout.
	   */
	  getAxisLayout: function (dim) {
	    return zrUtil.clone(this._axesLayout[dim]);
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	   */
	  getSlidedAxisExpandWindow: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	    if (!this.containPoint(point)) {
	      return {
	        behavior: 'none',
	        axisExpandWindow: axisExpandWindow
	      };
	    } // Conver the point from global to expand coordinates.
	
	
	    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	    // slided when mouse is the center area of the window.
	
	    var delta;
	    var behavior = 'slide';
	    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	    var useJump = triggerArea[0] != null;
	
	    if (axisCollapseWidth) {
	      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * triggerArea[2];
	      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * (1 - triggerArea[2]);
	      } else {
	        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	      }
	
	      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	      : behavior = 'none';
	    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	    else {
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var pos = extent[1] * pointCoord / winSize;
	        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
	        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
	        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
	      }
	
	    return {
	      axisExpandWindow: axisExpandWindow,
	      behavior: behavior
	    };
	  }
	};
	
	function restrict(len, extent) {
	  return mathMin(mathMax(len, extent[0]), extent[1]);
	}
	
	function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	  return {
	    position: step * axisIndex,
	    axisNameAvailableWidth: step,
	    axisLabelShow: true
	  };
	}
	
	function layoutAxisWithExpand(axisIndex, layoutInfo) {
	  var layoutLength = layoutInfo.layoutLength;
	  var axisExpandWidth = layoutInfo.axisExpandWidth;
	  var axisCount = layoutInfo.axisCount;
	  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	  var winInnerIndices = layoutInfo.winInnerIndices;
	  var position;
	  var axisNameAvailableWidth = axisCollapseWidth;
	  var axisLabelShow = false;
	  var nameTruncateMaxWidth;
	
	  if (axisIndex < winInnerIndices[0]) {
	    position = axisIndex * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  } else if (axisIndex <= winInnerIndices[1]) {
	    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	    axisNameAvailableWidth = axisExpandWidth;
	    axisLabelShow = true;
	  } else {
	    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  }
	
	  return {
	    position: position,
	    axisNameAvailableWidth: axisNameAvailableWidth,
	    axisLabelShow: axisLabelShow,
	    nameTruncateMaxWidth: nameTruncateMaxWidth
	  };
	}
	
	var _default = Parallel;
	module.exports = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Axis = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor module:echarts/coord/parallel/ParallelAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 */
	var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.axisIndex = axisIndex;
	};
	
	ParallelAxis.prototype = {
	  constructor: ParallelAxis,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/parallel/AxisModel}
	   */
	  model: null,
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	  }
	};
	zrUtil.inherits(ParallelAxis, Axis);
	var _default = ParallelAxis;
	module.exports = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Calculate slider move result.
	 * Usage:
	 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	 *
	 * @param {number} delta Move length.
	 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
	 *              handleEnds will be modified in this method.
	 * @param {Array.<number>} extent handleEnds is restricted by extent.
	 *              extent[0] should less or equals than extent[1].
	 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds,
	 *              where the input minSpan and maxSpan will not work.
	 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
	 *              If not set, handle0 and cross handle1. If set as a non-negative
	 *              number (including `0`), handles will push each other when reaching
	 *              the minSpan.
	 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
	 * @return {Array.<number>} The input handleEnds.
	 */
	function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	  // Normalize firstly.
	  handleEnds[0] = restrict(handleEnds[0], extent);
	  handleEnds[1] = restrict(handleEnds[1], extent);
	  delta = delta || 0;
	  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	  if (minSpan != null) {
	    minSpan = restrict(minSpan, [0, extentSpan]);
	  }
	
	  if (maxSpan != null) {
	    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	  }
	
	  if (handleIndex === 'all') {
	    minSpan = maxSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	    handleIndex = 0;
	  }
	
	  var originalDistSign = getSpanSign(handleEnds, handleIndex);
	  handleEnds[handleIndex] += delta; // Restrict in extent.
	
	  var extentMinSpan = minSpan || 0;
	  var realExtent = extent.slice();
	  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	    // If minSpan exists, 'cross' is forbinden.
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	  } // Shrink span.
	
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (maxSpan != null && currDistSign.span > maxSpan) {
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	  }
	
	  return handleEnds;
	}
	
	function getSpanSign(handleEnds, handleIndex) {
	  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	  // is at left of handleEnds[1] for non-cross case.
	
	  return {
	    span: Math.abs(dist),
	    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	  };
	}
	
	function restrict(value, extend) {
	  return Math.min(extend[1], Math.max(extend[0], value));
	}
	
	module.exports = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Component = __webpack_require__(215);
	
	__webpack_require__(414);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Component.extend({
	  type: 'parallel',
	  dependencies: ['parallelAxis'],
	
	  /**
	   * @type {module:echarts/coord/parallel/Parallel}
	   */
	  coordinateSystem: null,
	
	  /**
	   * Each item like: 'dim0', 'dim1', 'dim2', ...
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * Coresponding to dimensions.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	  parallelAxisIndex: null,
	  layoutMode: 'box',
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    layout: 'horizontal',
	    // 'horizontal' or 'vertical'
	    // FIXME
	    // naming?
	    axisExpandable: false,
	    axisExpandCenter: null,
	    axisExpandCount: 0,
	    axisExpandWidth: 50,
	    // FIXME '10%' ?
	    axisExpandRate: 17,
	    axisExpandDebounce: 50,
	    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	    // Do not doc to user until necessary.
	    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	    axisExpandTriggerOn: 'click',
	    // 'mousemove' or 'click'
	    parallelAxisDefault: null
	  },
	
	  /**
	   * @override
	   */
	  init: function () {
	    Component.prototype.init.apply(this, arguments);
	    this.mergeOption({});
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var thisOption = this.option;
	    newOption && zrUtil.merge(thisOption, newOption, true);
	
	    this._initDimensions();
	  },
	
	  /**
	   * Whether series or axis is in this coordinate system.
	   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
	   * @param {module:echarts/model/Global} ecModel
	   */
	  contains: function (model, ecModel) {
	    var parallelIndex = model.get('parallelIndex');
	    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	  },
	  setAxisExpand: function (opt) {
	    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	      if (opt.hasOwnProperty(name)) {
	        this.option[name] = opt[name];
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _initDimensions: function () {
	    var dimensions = this.dimensions = [];
	    var parallelAxisIndex = this.parallelAxisIndex = [];
	    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
	      // Can not use this.contains here, because
	      // initialization has not been completed yet.
	      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	    }, this);
	    zrUtil.each(axisModels, function (axisModel) {
	      dimensions.push('dim' + axisModel.get('dim'));
	      parallelAxisIndex.push(axisModel.componentIndex);
	    });
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ComponentModel = __webpack_require__(215);
	
	var makeStyleMapper = __webpack_require__(177);
	
	var axisModelCreator = __webpack_require__(296);
	
	var numberUtil = __webpack_require__(218);
	
	var axisModelCommonMixin = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'baseParallelAxis',
	
	  /**
	   * @type {module:echarts/coord/parallel/Axis}
	   */
	  axis: null,
	
	  /**
	   * @type {Array.<Array.<number>}
	   * @readOnly
	   */
	  activeIntervals: [],
	
	  /**
	   * @return {Object}
	   */
	  getAreaSelectStyle: function () {
	    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
	  },
	
	  /**
	   * The code of this feature is put on AxisModel but not ParallelAxis,
	   * because axisModel can be alive after echarts updating but instance of
	   * ParallelAxis having been disposed. this._activeInterval should be kept
	   * when action dispatched (i.e. legend click).
	   *
	   * @param {Array.<Array<number>>} intervals interval.length === 0
	   *                                          means set all active.
	   * @public
	   */
	  setActiveIntervals: function (intervals) {
	    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize
	
	    if (activeIntervals) {
	      for (var i = activeIntervals.length - 1; i >= 0; i--) {
	        numberUtil.asc(activeIntervals[i]);
	      }
	    }
	  },
	
	  /**
	   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
	   *                         value can not be input.
	   * @return {string} 'normal': no activeIntervals set,
	   *                  'active',
	   *                  'inactive'.
	   * @public
	   */
	  getActiveState: function (value) {
	    var activeIntervals = this.activeIntervals;
	
	    if (!activeIntervals.length) {
	      return 'normal';
	    }
	
	    if (value == null || isNaN(value)) {
	      return 'inactive';
	    } // Simple optimization
	
	
	    if (activeIntervals.length === 1) {
	      var interval = activeIntervals[0];
	
	      if (interval[0] <= value && value <= interval[1]) {
	        return 'active';
	      }
	    } else {
	      for (var i = 0, len = activeIntervals.length; i < len; i++) {
	        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	          return 'active';
	        }
	      }
	    }
	
	    return 'inactive';
	  }
	});
	var defaultOption = {
	  type: 'value',
	
	  /**
	   * @type {Array.<number>}
	   */
	  dim: null,
	  // 0, 1, 2, ...
	  // parallelIndex: null,
	  areaSelectStyle: {
	    width: 20,
	    borderWidth: 1,
	    borderColor: 'rgba(160,197,232)',
	    color: 'rgba(160,197,232)',
	    opacity: 0.3
	  },
	  realtime: true,
	  // Whether realtime update view when select.
	  z: 10
	};
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(409);
	
	__webpack_require__(416);
	
	__webpack_require__(417);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} parallelAxisId
	 * @property {Array.<Array.<number>>} intervals
	 */
	var actionInfo = {
	  type: 'axisAreaSelect',
	  event: 'axisAreaSelected' // update: 'updateVisual'
	
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallelAxis',
	    query: payload
	  }, function (parallelAxisModel) {
	    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	  });
	});
	/**
	 * @payload
	 */
	
	echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallel',
	    query: payload
	  }, function (parallelModel) {
	    parallelModel.setAxisExpand(payload);
	  });
	});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var AxisBuilder = __webpack_require__(300);
	
	var BrushController = __webpack_require__(418);
	
	var brushHelper = __webpack_require__(419);
	
	var graphic = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	var AxisView = echarts.extendComponentView({
	  type: 'parallelAxis',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    AxisView.superApply(this, 'init', arguments);
	    /**
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
	  },
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	      return;
	    }
	
	    this.axisModel = axisModel;
	    this.api = api;
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var coordSysModel = getCoordSysModel(axisModel, ecModel);
	    var coordSys = coordSysModel.coordinateSystem;
	    var areaSelectStyle = axisModel.getAreaSelectStyle();
	    var areaWidth = areaSelectStyle.width;
	    var dim = axisModel.axis.dim;
	    var axisLayout = coordSys.getAxisLayout(dim);
	    var builderOpt = zrUtil.extend({
	      strokeContainThreshold: areaWidth
	    }, axisLayout);
	    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	    zrUtil.each(elementList, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	    var animationModel = payload && payload.animation === false ? null : axisModel;
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
	  },
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: function (axisModel, ecModel, api, payload) {
	  //     this._brushController && this._brushController
	  //         .updateCovers(getCoverInfoList(axisModel));
	  // },
	  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	    // After filtering, axis may change, select area needs to be update.
	    var extent = axisModel.axis.getExtent();
	    var extentLen = extent[1] - extent[0];
	    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	    // width/height might be negative, which will be
	    // normalized in BoundingRect.
	
	    var rect = graphic.BoundingRect.create({
	      x: extent[0],
	      y: -areaWidth / 2,
	      width: extentLen,
	      height: areaWidth
	    });
	    rect.x -= extra;
	    rect.width += 2 * extra;
	
	    this._brushController.mount({
	      enableGlobalPan: true,
	      rotation: builderOpt.rotation,
	      position: builderOpt.position
	    }).setPanels([{
	      panelId: 'pl',
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
	    }]).enableBrush({
	      brushType: 'lineX',
	      brushStyle: areaSelectStyle,
	      removeOnClick: true
	    }).updateCovers(getCoverInfoList(axisModel));
	  },
	  _onBrush: function (coverInfoList, opt) {
	    // Do not cache these object, because the mey be changed.
	    var axisModel = this.axisModel;
	    var axis = axisModel.axis;
	    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
	      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	    }); // If realtime is true, action is not dispatched on drag end, because
	    // the drag end emits the same params with the last drag move event,
	    // and may have some delay when using touch pad.
	
	    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'axisAreaSelect',
	        parallelAxisId: axisModel.id,
	        intervals: intervals
	      });
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  }
	});
	
	function fromAxisAreaSelect(axisModel, ecModel, payload) {
	  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	    mainType: 'parallelAxis',
	    query: payload
	  })[0] === axisModel;
	}
	
	function getCoverInfoList(axisModel) {
	  var axis = axisModel.axis;
	  return zrUtil.map(axisModel.activeIntervals, function (interval) {
	    return {
	      brushType: 'lineX',
	      panelId: 'pl',
	      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	    };
	  });
	}
	
	function getCoordSysModel(axisModel, ecModel) {
	  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	}
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var Eventful = __webpack_require__(138);
	
	var graphic = __webpack_require__(180);
	
	var interactionMutex = __webpack_require__(346);
	
	var DataDiffer = __webpack_require__(256);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var map = zrUtil.map;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathPow = Math.pow;
	var COVER_Z = 10000;
	var UNSELECT_THRESHOLD = 6;
	var MIN_RESIZE_LINE_WIDTH = 6;
	var MUTEX_RESOURCE_KEY = 'globalPan';
	var DIRECTION_MAP = {
	  w: [0, 0],
	  e: [0, 1],
	  n: [1, 0],
	  s: [1, 1]
	};
	var CURSOR_MAP = {
	  w: 'ew',
	  e: 'ew',
	  n: 'ns',
	  s: 'ns',
	  ne: 'nesw',
	  sw: 'nesw',
	  nw: 'nwse',
	  se: 'nwse'
	};
	var DEFAULT_BRUSH_OPT = {
	  brushStyle: {
	    lineWidth: 2,
	    stroke: 'rgba(0,0,0,0.3)',
	    fill: 'rgba(0,0,0,0.1)'
	  },
	  transformable: true,
	  brushMode: 'single',
	  removeOnClick: false
	};
	var baseUID = 0;
	/**
	 * @alias module:echarts/component/helper/BrushController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 * @event module:echarts/component/helper/BrushController#brush
	 *        params:
	 *            areas: Array.<Array>, coord relates to container group,
	 *                                    If no container specified, to global.
	 *            opt {
	 *                isEnd: boolean,
	 *                removeOnClick: boolean
	 *            }
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	
	function BrushController(zr) {
	  Eventful.call(this);
	  /**
	   * @type {module:zrender/zrender~ZRender}
	   * @private
	   */
	
	  this._zr = zr;
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = new graphic.Group();
	  /**
	   * Only for drawing (after enabledBrush).
	   *     'line', 'rect', 'polygon' or false
	   *     If passing false/null/undefined, disable brush.
	   *     If passing 'auto', determined by panel.defaultBrushType
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * Only for drawing (after enabledBrush).
	   *
	   * @private
	   * @type {Object}
	   */
	
	  this._brushOption;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._panels;
	  /**
	   * @private
	   * @type {Array.<nubmer>}
	   */
	
	  this._track = [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._dragging;
	  /**
	   * @private
	   * @type {Array}
	   */
	
	  this._covers = [];
	  /**
	   * @private
	   * @type {moudule:zrender/container/Group}
	   */
	
	  this._creatingCover;
	  /**
	   * `true` means global panel
	   * @private
	   * @type {module:zrender/container/Group|boolean}
	   */
	
	  this._creatingPanel;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._enableGlobalPan;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this._uid = 'brushController_' + baseUID++;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._handlers = {};
	  each(mouseHandlers, function (handler, eventName) {
	    this._handlers[eventName] = zrUtil.bind(handler, this);
	  }, this);
	}
	
	BrushController.prototype = {
	  constructor: BrushController,
	
	  /**
	   * If set to null/undefined/false, select disabled.
	   * @param {Object} brushOption
	   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
	   *                          If passing false/null/undefined, disable brush.
	   *                          If passing 'auto', determined by panel.defaultBrushType.
	   *                              ('auto' can not be used in global panel)
	   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
	   * @param {boolean} [brushOption.transformable=true]
	   * @param {boolean} [brushOption.removeOnClick=false]
	   * @param {Object} [brushOption.brushStyle]
	   * @param {number} [brushOption.brushStyle.width]
	   * @param {number} [brushOption.brushStyle.lineWidth]
	   * @param {string} [brushOption.brushStyle.stroke]
	   * @param {string} [brushOption.brushStyle.fill]
	   * @param {number} [brushOption.z]
	   */
	  enableBrush: function (brushOption) {
	    this._brushType && doDisableBrush(this);
	    brushOption.brushType && doEnableBrush(this, brushOption);
	    return this;
	  },
	
	  /**
	   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
	   *        Each items: {
	   *            panelId, // mandatory.
	   *            clipPath, // mandatory. function.
	   *            isTargetByCursor, // mandatory. function.
	   *            defaultBrushType, // optional, only used when brushType is 'auto'.
	   *            getLinearBrushOtherExtent, // optional. function.
	   *        }
	   */
	  setPanels: function (panelOpts) {
	    if (panelOpts && panelOpts.length) {
	      var panels = this._panels = {};
	      zrUtil.each(panelOpts, function (panelOpts) {
	        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
	      });
	    } else {
	      this._panels = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param {Object} [opt]
	   * @return {boolean} [opt.enableGlobalPan=false]
	   */
	  mount: function (opt) {
	    opt = opt || {};
	    this._enableGlobalPan = opt.enableGlobalPan;
	    var thisGroup = this.group;
	
	    this._zr.add(thisGroup);
	
	    thisGroup.attr({
	      position: opt.position || [0, 0],
	      rotation: opt.rotation || 0,
	      scale: opt.scale || [1, 1]
	    });
	    this._transform = thisGroup.getLocalTransform();
	    return this;
	  },
	  eachCover: function (cb, context) {
	    each(this._covers, cb, context);
	  },
	
	  /**
	   * Update covers.
	   * @param {Array.<Object>} brushOptionList Like:
	   *        [
	   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
	   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
	   *            ...
	   *        ]
	   *        `brushType` is required in each cover info. (can not be 'auto')
	   *        `id` is not mandatory.
	   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
	   *        If brushOptionList is null/undefined, all covers removed.
	   */
	  updateCovers: function (brushOptionList) {
	    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
	      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	    });
	    var tmpIdPrefix = '\0-brush-index-';
	    var oldCovers = this._covers;
	    var newCovers = this._covers = [];
	    var controller = this;
	    var creatingCover = this._creatingCover;
	    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	    return this;
	
	    function getKey(brushOption, index) {
	      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	    }
	
	    function oldGetKey(cover, index) {
	      return getKey(cover.__brushOption, index);
	    }
	
	    function addOrUpdate(newIndex, oldIndex) {
	      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
	      // where updating cover when creating should be forbiden.
	
	      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	        newCovers[newIndex] = oldCovers[oldIndex];
	      } else {
	        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
	        updateCoverAfterCreation(controller, cover);
	      }
	    }
	
	    function remove(oldIndex) {
	      if (oldCovers[oldIndex] !== creatingCover) {
	        controller.group.remove(oldCovers[oldIndex]);
	      }
	    }
	  },
	  unmount: function () {
	    this.enableBrush(false); // container may 'removeAll' outside.
	
	    clearCovers(this);
	
	    this._zr.remove(this.group);
	
	    return this;
	  },
	  dispose: function () {
	    this.unmount();
	    this.off();
	  }
	};
	zrUtil.mixin(BrushController, Eventful);
	
	function doEnableBrush(controller, brushOption) {
	  var zr = controller._zr; // Consider roam, which takes globalPan too.
	
	  if (!controller._enableGlobalPan) {
	    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  }
	
	  each(controller._handlers, function (handler, eventName) {
	    zr.on(eventName, handler);
	  });
	  controller._brushType = brushOption.brushType;
	  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	}
	
	function doDisableBrush(controller) {
	  var zr = controller._zr;
	  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  each(controller._handlers, function (handler, eventName) {
	    zr.off(eventName, handler);
	  });
	  controller._brushType = controller._brushOption = null;
	}
	
	function createCover(controller, brushOption) {
	  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	  cover.__brushOption = brushOption;
	  updateZ(cover, brushOption);
	  controller.group.add(cover);
	  return cover;
	}
	
	function endCreating(controller, creatingCover) {
	  var coverRenderer = getCoverRenderer(creatingCover);
	
	  if (coverRenderer.endCreating) {
	    coverRenderer.endCreating(controller, creatingCover);
	    updateZ(creatingCover, creatingCover.__brushOption);
	  }
	
	  return creatingCover;
	}
	
	function updateCoverShape(controller, cover) {
	  var brushOption = cover.__brushOption;
	  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	}
	
	function updateZ(cover, brushOption) {
	  var z = brushOption.z;
	  z == null && (z = COVER_Z);
	  cover.traverse(function (el) {
	    el.z = z;
	    el.z2 = z; // Consider in given container.
	  });
	}
	
	function updateCoverAfterCreation(controller, cover) {
	  getCoverRenderer(cover).updateCommon(controller, cover);
	  updateCoverShape(controller, cover);
	}
	
	function getCoverRenderer(cover) {
	  return coverRenderers[cover.__brushOption.brushType];
	} // return target panel or `true` (means global panel)
	
	
	function getPanelByPoint(controller, e, localCursorPoint) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panel;
	  var transform = controller._transform;
	  each(panels, function (pn) {
	    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	  });
	  return panel;
	} // Return a panel or true
	
	
	function getPanelByCover(controller, cover) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	  // which is then treated as global panel.
	
	  return panelId != null ? panels[panelId] : true;
	}
	
	function clearCovers(controller) {
	  var covers = controller._covers;
	  var originalLength = covers.length;
	  each(covers, function (cover) {
	    controller.group.remove(cover);
	  }, controller);
	  covers.length = 0;
	  return !!originalLength;
	}
	
	function trigger(controller, opt) {
	  var areas = map(controller._covers, function (cover) {
	    var brushOption = cover.__brushOption;
	    var range = zrUtil.clone(brushOption.range);
	    return {
	      brushType: brushOption.brushType,
	      panelId: brushOption.panelId,
	      range: range
	    };
	  });
	  controller.trigger('brush', areas, {
	    isEnd: !!opt.isEnd,
	    removeOnClick: !!opt.removeOnClick
	  });
	}
	
	function shouldShowCover(controller) {
	  var track = controller._track;
	
	  if (!track.length) {
	    return false;
	  }
	
	  var p2 = track[track.length - 1];
	  var p1 = track[0];
	  var dx = p2[0] - p1[0];
	  var dy = p2[1] - p1[1];
	  var dist = mathPow(dx * dx + dy * dy, 0.5);
	  return dist > UNSELECT_THRESHOLD;
	}
	
	function getTrackEnds(track) {
	  var tail = track.length - 1;
	  tail < 0 && (tail = 0);
	  return [track[0], track[tail]];
	}
	
	function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
	  var cover = new graphic.Group();
	  cover.add(new graphic.Rect({
	    name: 'main',
	    style: makeStyle(brushOption),
	    silent: true,
	    draggable: true,
	    cursor: 'move',
	    drift: curry(doDrift, controller, cover, 'nswe'),
	    ondragend: curry(trigger, controller, {
	      isEnd: true
	    })
	  }));
	  each(edgeNames, function (name) {
	    cover.add(new graphic.Rect({
	      name: name,
	      style: {
	        opacity: 0
	      },
	      draggable: true,
	      silent: true,
	      invisible: true,
	      drift: curry(doDrift, controller, cover, name),
	      ondragend: curry(trigger, controller, {
	        isEnd: true
	      })
	    }));
	  });
	  return cover;
	}
	
	function updateBaseRect(controller, cover, localRange, brushOption) {
	  var lineWidth = brushOption.brushStyle.lineWidth || 0;
	  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
	  var x = localRange[0][0];
	  var y = localRange[1][0];
	  var xa = x - lineWidth / 2;
	  var ya = y - lineWidth / 2;
	  var x2 = localRange[0][1];
	  var y2 = localRange[1][1];
	  var x2a = x2 - handleSize + lineWidth / 2;
	  var y2a = y2 - handleSize + lineWidth / 2;
	  var width = x2 - x;
	  var height = y2 - y;
	  var widtha = width + lineWidth;
	  var heighta = height + lineWidth;
	  updateRectShape(controller, cover, 'main', x, y, width, height);
	
	  if (brushOption.transformable) {
	    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	  }
	}
	
	function updateCommon(controller, cover) {
	  var brushOption = cover.__brushOption;
	  var transformable = brushOption.transformable;
	  var mainEl = cover.childAt(0);
	  mainEl.useStyle(makeStyle(brushOption));
	  mainEl.attr({
	    silent: !transformable,
	    cursor: transformable ? 'move' : 'default'
	  });
	  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
	    var el = cover.childOfName(name);
	    var globalDir = getGlobalDirection(controller, name);
	    el && el.attr({
	      silent: !transformable,
	      invisible: !transformable,
	      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	    });
	  });
	}
	
	function updateRectShape(controller, cover, name, x, y, w, h) {
	  var el = cover.childOfName(name);
	  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	}
	
	function makeStyle(brushOption) {
	  return zrUtil.defaults({
	    strokeNoScale: true
	  }, brushOption.brushStyle);
	}
	
	function formatRectRange(x, y, x2, y2) {
	  var min = [mathMin(x, x2), mathMin(y, y2)];
	  var max = [mathMax(x, x2), mathMax(y, y2)];
	  return [[min[0], max[0]], // x range
	  [min[1], max[1]] // y range
	  ];
	}
	
	function getTransform(controller) {
	  return graphic.getTransform(controller.group);
	}
	
	function getGlobalDirection(controller, localDirection) {
	  if (localDirection.length > 1) {
	    localDirection = localDirection.split('');
	    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
	    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	    return globalDir.join('');
	  } else {
	    var map = {
	      w: 'left',
	      e: 'right',
	      n: 'top',
	      s: 'bottom'
	    };
	    var inverseMap = {
	      left: 'w',
	      right: 'e',
	      top: 'n',
	      bottom: 's'
	    };
	    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
	    return inverseMap[globalDir];
	  }
	}
	
	function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
	  var brushOption = cover.__brushOption;
	  var rectRange = toRectRange(brushOption.range);
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(name.split(''), function (namePart) {
	    var ind = DIRECTION_MAP[namePart];
	    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	  });
	  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function driftPolygon(controller, cover, dx, dy, e) {
	  var range = cover.__brushOption.range;
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(range, function (point) {
	    point[0] += localDelta[0];
	    point[1] += localDelta[1];
	  });
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function toLocalDelta(controller, dx, dy) {
	  var thisGroup = controller.group;
	  var localD = thisGroup.transformCoordToLocal(dx, dy);
	  var localZero = thisGroup.transformCoordToLocal(0, 0);
	  return [localD[0] - localZero[0], localD[1] - localZero[1]];
	}
	
	function clipByPanel(controller, cover, data) {
	  var panel = getPanelByCover(controller, cover);
	  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
	}
	
	function pointsToRect(points) {
	  var xmin = mathMin(points[0][0], points[1][0]);
	  var ymin = mathMin(points[0][1], points[1][1]);
	  var xmax = mathMax(points[0][0], points[1][0]);
	  var ymax = mathMax(points[0][1], points[1][1]);
	  return {
	    x: xmin,
	    y: ymin,
	    width: xmax - xmin,
	    height: ymax - ymin
	  };
	}
	
	function resetCursor(controller, e, localCursorPoint) {
	  // Check active
	  if (!controller._brushType) {
	    return;
	  }
	
	  var zr = controller._zr;
	  var covers = controller._covers;
	  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	  if (!controller._dragging) {
	    for (var i = 0; i < covers.length; i++) {
	      var brushOption = covers[i].__brushOption;
	
	      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	        // Use cursor style set on cover.
	        return;
	      }
	    }
	  }
	
	  currPanel && zr.setCursorStyle('crosshair');
	}
	
	function preventDefault(e) {
	  var rawE = e.event;
	  rawE.preventDefault && rawE.preventDefault();
	}
	
	function mainShapeContain(cover, x, y) {
	  return cover.childOfName('main').contain(x, y);
	}
	
	function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	  var creatingCover = controller._creatingCover;
	  var panel = controller._creatingPanel;
	  var thisBrushOption = controller._brushOption;
	  var eventParams;
	
	  controller._track.push(localCursorPoint.slice());
	
	  if (shouldShowCover(controller) || creatingCover) {
	    if (panel && !creatingCover) {
	      thisBrushOption.brushMode === 'single' && clearCovers(controller);
	      var brushOption = zrUtil.clone(thisBrushOption);
	      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	      brushOption.panelId = panel === true ? null : panel.panelId;
	      creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	      controller._covers.push(creatingCover);
	    }
	
	    if (creatingCover) {
	      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	      var coverBrushOption = creatingCover.__brushOption;
	      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	      if (isEnd) {
	        endCreating(controller, creatingCover);
	        coverRenderer.updateCommon(controller, creatingCover);
	      }
	
	      updateCoverShape(controller, creatingCover);
	      eventParams = {
	        isEnd: isEnd
	      };
	    }
	  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	    // But a single click do not clear covers, because user may have casual
	    // clicks (for example, click on other component and do not expect covers
	    // disappear).
	    // Only some cover removed, trigger action, but not every click trigger action.
	    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	      eventParams = {
	        isEnd: isEnd,
	        removeOnClick: true
	      };
	    }
	  }
	
	  return eventParams;
	}
	
	function determineBrushType(brushType, panel) {
	  if (brushType === 'auto') {
	    return panel.defaultBrushType;
	  }
	
	  return brushType;
	}
	
	var mouseHandlers = {
	  mousedown: function (e) {
	    if (this._dragging) {
	      // In case some browser do not support globalOut,
	      // and release mose out side the browser.
	      handleDragEnd.call(this, e);
	    } else if (!e.target || !e.target.draggable) {
	      preventDefault(e);
	      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	      this._creatingCover = null;
	      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	      if (panel) {
	        this._dragging = true;
	        this._track = [localCursorPoint.slice()];
	      }
	    }
	  },
	  mousemove: function (e) {
	    var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	    resetCursor(this, e, localCursorPoint);
	
	    if (this._dragging) {
	      preventDefault(e);
	      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	      eventParams && trigger(this, eventParams);
	    }
	  },
	  mouseup: handleDragEnd //,
	  // FIXME
	  // in tooltip, globalout should not be triggered.
	  // globalout: handleDragEnd
	
	};
	
	function handleDragEnd(e) {
	  if (this._dragging) {
	    preventDefault(e);
	    var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	    var eventParams = updateCoverByMouse(this, e, localCursorPoint, true);
	    this._dragging = false;
	    this._track = [];
	    this._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
	
	    eventParams && trigger(this, eventParams);
	  }
	}
	/**
	 * key: brushType
	 * @type {Object}
	 */
	
	
	var coverRenderers = {
	  lineX: getLineRenderer(0),
	  lineY: getLineRenderer(1),
	  rect: {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        return range;
	      }, function (range) {
	        return range;
	      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      updateBaseRect(controller, cover, localRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  },
	  polygon: {
	    createCover: function (controller, brushOption) {
	      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	      // border of the shape when drawing, which is a better experience for user.
	
	      cover.add(new graphic.Polyline({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true
	      }));
	      return cover;
	    },
	    getCreatingRange: function (localTrack) {
	      return localTrack;
	    },
	    endCreating: function (controller, cover) {
	      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	      cover.add(new graphic.Polygon({
	        name: 'main',
	        draggable: true,
	        drift: curry(driftPolygon, controller, cover),
	        ondragend: curry(trigger, controller, {
	          isEnd: true
	        })
	      }));
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      cover.childAt(0).setShape({
	        points: clipByPanel(controller, cover, localRange)
	      });
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  }
	};
	
	function getLineRenderer(xyIndex) {
	  return {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        var rectRange = [range, [0, 100]];
	        xyIndex && rectRange.reverse();
	        return rectRange;
	      }, function (rectRange) {
	        return rectRange[xyIndex];
	      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
	      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
	      return [min, max];
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      var otherExtent; // If brushWidth not specified, fit the panel.
	
	      var panel = getPanelByCover(controller, cover);
	
	      if (panel !== true && panel.getLinearBrushOtherExtent) {
	        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
	      } else {
	        var zr = controller._zr;
	        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	      }
	
	      var rectRange = [localRange, otherExtent];
	      xyIndex && rectRange.reverse();
	      updateBaseRect(controller, cover, rectRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  };
	}
	
	var _default = BrushController;
	module.exports = _default;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(154);
	
	var _cursorHelper = __webpack_require__(348);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphicUtil = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeRectPanelClipPath(rect) {
	  rect = normalizeRect(rect);
	  return function (localPoints, transform) {
	    return graphicUtil.clipPointsByRect(localPoints, rect);
	  };
	}
	
	function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	  rect = normalizeRect(rect);
	  return function (xyIndex) {
	    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	    var brushWidth = idx ? rect.width : rect.height;
	    var base = idx ? rect.x : rect.y;
	    return [base, base + (brushWidth || 0)];
	  };
	}
	
	function makeRectIsTargetByCursor(rect, api, targetModel) {
	  rect = normalizeRect(rect);
	  return function (e, localCursorPoint, transform) {
	    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	  };
	} // Consider width/height is negative.
	
	
	function normalizeRect(rect) {
	  return BoundingRect.create(rect);
	}
	
	exports.makeRectPanelClipPath = makeRectPanelClipPath;
	exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
	exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var SeriesModel = __webpack_require__(233);
	
	var createListFromArray = __webpack_require__(254);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.parallel',
	  dependencies: ['parallel'],
	  visualColorAccessPath: 'lineStyle.color',
	  getInitialData: function (option, ecModel) {
	    var source = this.getSource();
	    setEncodeAndDimensions(source, this);
	    return createListFromArray(source, this);
	  },
	
	  /**
	   * User can get data raw indices on 'axisAreaSelected' event received.
	   *
	   * @public
	   * @param {string} activeState 'active' or 'inactive' or 'normal'
	   * @return {Array.<number>} Raw indices
	   */
	  getRawIndicesByActiveState: function (activeState) {
	    var coordSys = this.coordinateSystem;
	    var data = this.getData();
	    var indices = [];
	    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	      if (activeState === theActiveState) {
	        indices.push(data.getRawIndex(dataIndex));
	      }
	    });
	    return indices;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'parallel',
	    parallelIndex: 0,
	    label: {
	      show: false
	    },
	    inactiveOpacity: 0.05,
	    activeOpacity: 1,
	    lineStyle: {
	      width: 1,
	      opacity: 0.45,
	      type: 'solid'
	    },
	    emphasis: {
	      label: {
	        show: false
	      }
	    },
	    progressive: 500,
	    smooth: false,
	    // true | false | number
	    animationEasing: 'linear'
	  }
	});
	
	function setEncodeAndDimensions(source, seriesModel) {
	  // The mapping of parallelAxis dimension to data dimension can
	  // be specified in parallelAxis.option.dim. For example, if
	  // parallelAxis.option.dim is 'dim3', it mapping to the third
	  // dimension of data. But `data.encode` has higher priority.
	  // Moreover, parallelModel.dimension should not be regarded as data
	  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	  if (source.encodeDefine) {
	    return;
	  }
	
	  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	
	  if (!parallelModel) {
	    return;
	  }
	
	  var encodeDefine = source.encodeDefine = createHashMap();
	  each(parallelModel.dimensions, function (axisDim) {
	    var dataDimIndex = convertDimNameToNumber(axisDim);
	    encodeDefine.set(axisDim, dataDimIndex);
	  });
	}
	
	function convertDimNameToNumber(dimName) {
	  return +dimName.replace('dim', '');
	}
	
	module.exports = _default;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var ChartView = __webpack_require__(238);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_SMOOTH = 0.3;
	var ParallelView = ChartView.extend({
	  type: 'parallel',
	  init: function () {
	    /**
	     * @type {module:zrender/container/Group}
	     * @private
	     */
	    this._dataGroup = new graphic.Group();
	    this.group.add(this._dataGroup);
	    /**
	     * @type {module:echarts/data/List}
	     */
	
	    this._data;
	    /**
	     * @type {boolean}
	     */
	
	    this._initialized;
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var dataGroup = this._dataGroup;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	    data.diff(oldData).add(add).update(update).remove(remove).execute();
	
	    function add(newDataIndex) {
	      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function update(newDataIndex, oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	      data.setItemGraphicEl(newDataIndex, line);
	      var animationModel = payload && payload.animation === false ? null : seriesModel;
	      graphic.updateProps(line, {
	        shape: {
	          points: points
	        }
	      }, animationModel, newDataIndex);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function remove(oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      dataGroup.remove(line);
	    } // First create
	
	
	    if (!this._initialized) {
	      this._initialized = true;
	      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	        // Callback will be invoked immediately if there is no animation
	        setTimeout(function () {
	          dataGroup.removeClipPath();
	        });
	      });
	      dataGroup.setClipPath(clipPath);
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._initialized = true;
	    this._data = null;
	
	    this._dataGroup.removeAll();
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	
	    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
	      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
	      line.incremental = true;
	      updateElCommon(line, data, dataIndex, seriesScope);
	    }
	  },
	  dispose: function () {},
	  // _renderForProgressive: function (seriesModel) {
	  //     var dataGroup = this._dataGroup;
	  //     var data = seriesModel.getData();
	  //     var oldData = this._data;
	  //     var coordSys = seriesModel.coordinateSystem;
	  //     var dimensions = coordSys.dimensions;
	  //     var option = seriesModel.option;
	  //     var progressive = option.progressive;
	  //     var smooth = option.smooth ? SMOOTH : null;
	  //     // In progressive animation is disabled, so use simple data diff,
	  //     // which effects performance less.
	  //     // (Typically performance for data with length 7000+ like:
	  //     // simpleDiff: 60ms, addEl: 184ms,
	  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
	  //     if (simpleDiff(oldData, data, dimensions)) {
	  //         dataGroup.removeAll();
	  //         data.each(function (dataIndex) {
	  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
	  //         });
	  //     }
	  //     updateElCommon(data, progressive, smooth);
	  //     // Consider switch between progressive and not.
	  //     data.__plProgressive = true;
	  //     this._data = data;
	  // },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._dataGroup && this._dataGroup.removeAll();
	    this._data = null;
	  }
	});
	
	function createGridClipShape(coordSys, seriesModel, cb) {
	  var parallelModel = coordSys.model;
	  var rect = coordSys.getRect();
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    }
	  });
	  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	  rectEl.setShape(dim, 0);
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width,
	      height: rect.height
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	function createLinePoints(data, dataIndex, dimensions, coordSys) {
	  var points = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimName = dimensions[i];
	    var value = data.get(data.mapDimension(dimName), dataIndex);
	
	    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	      points.push(coordSys.dataToPoint(value, dimName));
	    }
	  }
	
	  return points;
	}
	
	function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    },
	    silent: true,
	    z2: 10
	  });
	  dataGroup.add(line);
	  data.setItemGraphicEl(dataIndex, line);
	  return line;
	}
	
	function makeSeriesScope(seriesModel) {
	  var smooth = seriesModel.get('smooth', true);
	  smooth === true && (smooth = DEFAULT_SMOOTH);
	  return {
	    lineStyle: seriesModel.getModel('lineStyle').getLineStyle(),
	    smooth: smooth != null ? smooth : DEFAULT_SMOOTH
	  };
	}
	
	function updateElCommon(el, data, dataIndex, seriesScope) {
	  var lineStyle = seriesScope.lineStyle;
	
	  if (data.hasItemOption) {
	    var lineStyleModel = data.getItemModel(dataIndex).getModel('lineStyle');
	    lineStyle = lineStyleModel.getLineStyle();
	  }
	
	  el.useStyle(lineStyle);
	  var elStyle = el.style;
	  elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
	
	  elStyle.stroke = data.getItemVisual(dataIndex, 'color'); // lineStyle.opacity have been set to itemVisual in parallelVisual.
	
	  elStyle.opacity = data.getItemVisual(dataIndex, 'opacity');
	  seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
	} // function simpleDiff(oldData, newData, dimensions) {
	//     var oldLen;
	//     if (!oldData
	//         || !oldData.__plProgressive
	//         || (oldLen = oldData.count()) !== newData.count()
	//     ) {
	//         return true;
	//     }
	//     var dimLen = dimensions.length;
	//     for (var i = 0; i < oldLen; i++) {
	//         for (var j = 0; j < dimLen; j++) {
	//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	//                 return true;
	//             }
	//         }
	//     }
	//     return false;
	// }
	// FIXME
	// 公用方法?
	
	
	function isEmptyValue(val, axisType) {
	  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	}
	
	var _default = ParallelView;
	module.exports = _default;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
	var _default = {
	  seriesType: 'parallel',
	  reset: function (seriesModel, ecModel, api) {
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var globalColors = ecModel.get('color');
	    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
	    var inactiveOpacity = seriesModel.get('inactiveOpacity');
	    var activeOpacity = seriesModel.get('activeOpacity');
	    var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var opacityMap = {
	      normal: lineStyle.opacity,
	      active: activeOpacity,
	      inactive: inactiveOpacity
	    };
	    data.setVisual('color', color);
	
	    function progress(params, data) {
	      coordSys.eachActiveState(data, function (activeState, dataIndex) {
	        var opacity = opacityMap[activeState];
	
	        if (activeState === 'normal' && data.hasItemOption) {
	          var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
	          itemOpacity != null && (opacity = itemOpacity);
	        }
	
	        data.setItemVisual(dataIndex, 'opacity', opacity);
	      }, params.start, params.end);
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(424);
	
	__webpack_require__(425);
	
	__webpack_require__(426);
	
	var sankeyLayout = __webpack_require__(427);
	
	var sankeyVisual = __webpack_require__(428);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(sankeyLayout);
	echarts.registerVisual(sankeyVisual);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(233);
	
	var createGraphFromNodeEdge = __webpack_require__(379);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Get initial data and define sankey view's series model
	 * @author Deqing Li(annong035@gmail.com)
	 */
	var SankeySeries = SeriesModel.extend({
	  type: 'series.sankey',
	  layoutInfo: null,
	
	  /**
	   * Init a graph data structure from data in option series
	   *
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    var links = option.edges || option.links;
	    var nodes = option.data || option.nodes;
	
	    if (nodes && links) {
	      var graph = createGraphFromNodeEdge(nodes, links, this, true);
	      return graph.data;
	    }
	  },
	  setNodePosition: function (dataIndex, localPosition) {
	    var dataItem = this.option.data[dataIndex];
	    dataItem.localX = localPosition[0];
	    dataItem.localY = localPosition[1];
	  },
	
	  /**
	   * Return the graphic data structure
	   *
	   * @return {module:echarts/data/Graph} graphic data structure
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * Get edge data of graphic data structure
	   *
	   * @return {module:echarts/data/List} data structure of list
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    // dataType === 'node' or empty do not show tooltip by default
	    if (dataType === 'edge') {
	      var params = this.getDataParams(dataIndex, dataType);
	      var rawDataOpt = params.data;
	      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	
	      if (params.value) {
	        html += ' : ' + params.value;
	      }
	
	      return encodeHTML(html);
	    }
	
	    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	
	    if (option.focusNodeAdjacency === true) {
	      option.focusNodeAdjacency = 'allEdges';
	    }
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    layout: null,
	    // The position of the whole view
	    left: '5%',
	    top: '5%',
	    right: '20%',
	    bottom: '5%',
	    // Value can be 'vertical'
	    orient: 'horizontal',
	    // The dx of the node
	    nodeWidth: 20,
	    // The vertical distance between two nodes
	    nodeGap: 8,
	    // Control if the node can move or not
	    draggable: true,
	    // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
	    focusNodeAdjacency: false,
	    // The number of iterations to change the position of the node
	    layoutIterations: 32,
	    label: {
	      show: true,
	      position: 'right',
	      color: '#000',
	      fontSize: 12
	    },
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: '#333'
	    },
	    lineStyle: {
	      color: '#314656',
	      opacity: 0.2,
	      curveness: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        opacity: 0.6
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 1000
	  }
	});
	var _default = SankeySeries;
	module.exports = _default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file  The file used to draw sankey view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.highlight && el.highlight();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	var SankeyShape = graphic.extendShape({
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    cpx2: 0,
	    cpy2: 0,
	    extent: 0,
	    orient: ''
	  },
	  buildPath: function (ctx, shape) {
	    var extent = shape.extent;
	    var orient = shape.orient;
	
	    if (orient === 'vertical') {
	      ctx.moveTo(shape.x1, shape.y1);
	      ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	      ctx.lineTo(shape.x2 + extent, shape.y2);
	      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
	    } else {
	      ctx.moveTo(shape.x1, shape.y1);
	      ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	      ctx.lineTo(shape.x2, shape.y2 + extent);
	      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
	    }
	
	    ctx.closePath();
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'sankey',
	
	  /**
	   * @private
	   * @type {module:echarts/chart/sankey/SankeySeries}
	   */
	  _model: null,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _focusAdjacencyDisabled: false,
	  render: function (seriesModel, ecModel, api) {
	    var sankeyView = this;
	    var graph = seriesModel.getGraph();
	    var group = this.group;
	    var layoutInfo = seriesModel.layoutInfo; // view width
	
	    var width = layoutInfo.width; // view height
	
	    var height = layoutInfo.height;
	    var nodeData = seriesModel.getData();
	    var edgeData = seriesModel.getData('edge');
	    var orient = seriesModel.get('orient');
	    this._model = seriesModel;
	    group.removeAll();
	    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge
	
	    graph.eachEdge(function (edge) {
	      var curve = new SankeyShape();
	      curve.dataIndex = edge.dataIndex;
	      curve.seriesIndex = seriesModel.seriesIndex;
	      curve.dataType = 'edge';
	      var lineStyleModel = edge.getModel('lineStyle');
	      var curvature = lineStyleModel.get('curveness');
	      var n1Layout = edge.node1.getLayout();
	      var node1Model = edge.node1.getModel();
	      var dragX1 = node1Model.get('localX');
	      var dragY1 = node1Model.get('localY');
	      var n2Layout = edge.node2.getLayout();
	      var node2Model = edge.node2.getModel();
	      var dragX2 = node2Model.get('localX');
	      var dragY2 = node2Model.get('localY');
	      var edgeLayout = edge.getLayout();
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var cpx1;
	      var cpy1;
	      var cpx2;
	      var cpy2;
	      curve.shape.extent = Math.max(1, edgeLayout.dy);
	      curve.shape.orient = orient;
	
	      if (orient === 'vertical') {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
	        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
	        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
	        cpx1 = x1;
	        cpy1 = y1 * (1 - curvature) + y2 * curvature;
	        cpx2 = x2;
	        cpy2 = y1 * curvature + y2 * (1 - curvature);
	      } else {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
	        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
	        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
	        cpx1 = x1 * (1 - curvature) + x2 * curvature;
	        cpy1 = y1;
	        cpx2 = x1 * curvature + x2 * (1 - curvature);
	        cpy2 = y2;
	      }
	
	      curve.setShape({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      });
	      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	      switch (curve.style.fill) {
	        case 'source':
	          curve.style.fill = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          curve.style.fill = edge.node2.getVisual('color');
	          break;
	      }
	
	      graphic.setHoverStyle(curve, edge.getModel('emphasis.lineStyle').getItemStyle());
	      group.add(curve);
	      edgeData.setItemGraphicEl(edge.dataIndex, curve);
	    }); // Generate a rect for each node
	
	    graph.eachNode(function (node) {
	      var layout = node.getLayout();
	      var itemModel = node.getModel();
	      var dragX = itemModel.get('localX');
	      var dragY = itemModel.get('localY');
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var rect = new graphic.Rect({
	        shape: {
	          x: dragX != null ? dragX * width : layout.x,
	          y: dragY != null ? dragY * height : layout.y,
	          width: layout.dx,
	          height: layout.dy
	        },
	        style: itemModel.getModel('itemStyle').getItemStyle()
	      });
	      var hoverStyle = node.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: node.dataIndex,
	        defaultText: node.id,
	        isRectText: true
	      });
	      rect.setStyle('fill', node.getVisual('color'));
	      graphic.setHoverStyle(rect, hoverStyle);
	      group.add(rect);
	      nodeData.setItemGraphicEl(node.dataIndex, rect);
	      rect.dataType = 'node';
	    });
	    nodeData.eachItemGraphicEl(function (el, dataIndex) {
	      var itemModel = nodeData.getItemModel(dataIndex);
	
	      if (itemModel.get('draggable')) {
	        el.drift = function (dx, dy) {
	          sankeyView._focusAdjacencyDisabled = true;
	          this.shape.x += dx;
	          this.shape.y += dy;
	          this.dirty();
	          api.dispatchAction({
	            type: 'dragNode',
	            seriesId: seriesModel.id,
	            dataIndex: nodeData.getRawIndex(dataIndex),
	            localX: this.shape.x / width,
	            localY: this.shape.y / height
	          });
	        };
	
	        el.ondragend = function () {
	          sankeyView._focusAdjacencyDisabled = false;
	        };
	
	        el.draggable = true;
	        el.cursor = 'move';
	      }
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.off('mouseover').on('mouseover', function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              dataIndex: el.dataIndex
	            });
	          }
	        });
	        el.off('mouseout').on('mouseout', function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            api.dispatchAction({
	              type: 'unfocusNodeAdjacency',
	              seriesId: seriesModel.id
	            });
	          }
	        });
	      }
	    });
	    edgeData.eachItemGraphicEl(function (el, dataIndex) {
	      var edgeModel = edgeData.getItemModel(dataIndex);
	
	      if (edgeModel.get('focusNodeAdjacency')) {
	        el.off('mouseover').on('mouseover', function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              edgeDataIndex: el.dataIndex
	            });
	          }
	        });
	        el.off('mouseout').on('mouseout', function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            api.dispatchAction({
	              type: 'unfocusNodeAdjacency',
	              seriesId: seriesModel.id
	            });
	          }
	        });
	      }
	    });
	
	    if (!this._data && seriesModel.get('animation')) {
	      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
	        group.removeClipPath();
	      }));
	    }
	
	    this._data = seriesModel.getData();
	  },
	  dispose: function () {},
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = this._model.getData();
	
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var itemModel = data.getItemModel(dataIndex);
	    var edgeDataIndex = payload.edgeDataIndex;
	
	    if (dataIndex == null && edgeDataIndex == null) {
	      return;
	    }
	
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      var focusNodeAdj = itemModel.get('focusNodeAdjacency');
	
	      if (focusNodeAdj === 'outEdges') {
	        zrUtil.each(node.outEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, lineOpacityPath);
	          fadeInItem(edge.node2, nodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'inEdges') {
	        zrUtil.each(node.inEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, lineOpacityPath);
	          fadeInItem(edge.node1, nodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'allEdges') {
	        zrUtil.each(node.edges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, lineOpacityPath);
	          fadeInItem(edge.node1, nodeOpacityPath);
	          fadeInItem(edge.node2, nodeOpacityPath);
	        });
	      }
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = this._model.getGraph();
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  }
	}); // Add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(387);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file The interactive action of sankey view
	 * @author Deqing Li(annong035@gmail.com)
	 */
	echarts.registerAction({
	  type: 'dragNode',
	  event: 'dragNode',
	  // here can only use 'update' now, other value is not support in echarts.
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sankey',
	    query: payload
	  }, function (seriesModel) {
	    seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
	  });
	});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(217);
	
	var zrUtil = __webpack_require__(134);
	
	var _model = __webpack_require__(173);
	
	var groupData = _model.groupData;
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file The layout algorithm of sankey view
	 * @author Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var nodeWidth = seriesModel.get('nodeWidth');
	    var nodeGap = seriesModel.get('nodeGap');
	    var layoutInfo = getViewRect(seriesModel, api);
	    seriesModel.layoutInfo = layoutInfo;
	    var width = layoutInfo.width;
	    var height = layoutInfo.height;
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    var edges = graph.edges;
	    computeNodeValues(nodes);
	    var filteredNodes = zrUtil.filter(nodes, function (node) {
	      return node.getLayout().value === 0;
	    });
	    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	    var orient = seriesModel.get('orient');
	    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient);
	  });
	}
	/**
	 * Get the layout position of the whole view
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient) {
	  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient);
	  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
	  computeEdgeDepths(nodes, orient);
	}
	/**
	 * Compute the value of each node by summing the associated edge's value
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeNodeValues(nodes) {
	  zrUtil.each(nodes, function (node) {
	    var value1 = sum(node.outEdges, getEdgeValue);
	    var value2 = sum(node.inEdges, getEdgeValue);
	    var value = Math.max(value1, value2);
	    node.setLayout({
	      value: value
	    }, true);
	  });
	}
	/**
	 * Compute the x-position for each node.
	 *
	 * Here we use Kahn algorithm to detect cycle when we traverse
	 * the node to computer the initial x position.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param  {number} nodeWidth  the dx of the node
	 * @param  {number} width  the whole width of the area to draw the view
	 */
	
	
	function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient) {
	  // Used to mark whether the edge is deleted. if it is deleted,
	  // the value is 0, otherwise it is 1.
	  var remainEdges = []; // Storage each node's indegree.
	
	  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.
	
	  var zeroIndegrees = [];
	  var nextNode = [];
	  var x = 0;
	  var kx = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    remainEdges[i] = 1;
	  }
	
	  for (i = 0; i < nodes.length; i++) {
	    indegreeArr[i] = nodes[i].inEdges.length;
	
	    if (indegreeArr[i] === 0) {
	      zeroIndegrees.push(nodes[i]);
	    }
	  }
	
	  while (zeroIndegrees.length) {
	    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
	      var node = zeroIndegrees[idx];
	
	      if (orient === 'vertical') {
	        node.setLayout({
	          y: x
	        }, true);
	        node.setLayout({
	          dy: nodeWidth
	        }, true);
	      } else {
	        node.setLayout({
	          x: x
	        }, true);
	        node.setLayout({
	          dx: nodeWidth
	        }, true);
	      }
	
	      for (var oidx = 0; oidx < node.outEdges.length; oidx++) {
	        var edge = node.outEdges[oidx];
	        var indexEdge = edges.indexOf(edge);
	        remainEdges[indexEdge] = 0;
	        var targetNode = edge.node2;
	        var nodeIndex = nodes.indexOf(targetNode);
	
	        if (--indegreeArr[nodeIndex] === 0) {
	          nextNode.push(targetNode);
	        }
	      }
	    }
	
	    ++x;
	    zeroIndegrees = nextNode;
	    nextNode = [];
	  }
	
	  for (i = 0; i < remainEdges.length; i++) {}
	
	  moveSinksRight(nodes, x, orient);
	
	  if (orient === 'vertical') {
	    kx = (height - nodeWidth) / (x - 1);
	  } else {
	    kx = (width - nodeWidth) / (x - 1);
	  }
	
	  scaleNodeBreadths(nodes, kx, orient);
	}
	/**
	 * All the node without outEgdes are assigned maximum x-position and
	 *     be aligned in the last column.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} x  value (x-1) use to assign to node without outEdges
	 *     as x-position
	 */
	
	
	function moveSinksRight(nodes, x, orient) {
	  zrUtil.each(nodes, function (node) {
	    if (!node.outEdges.length) {
	      if (orient === 'vertical') {
	        node.setLayout({
	          y: x - 1
	        }, true);
	      } else {
	        node.setLayout({
	          x: x - 1
	        }, true);
	      }
	    }
	  });
	}
	/**
	 * Scale node x-position to the width
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} kx   multiple used to scale nodes
	 */
	
	
	function scaleNodeBreadths(nodes, kx, orient) {
	  zrUtil.each(nodes, function (node) {
	    if (orient === 'vertical') {
	      var nodeY = node.getLayout().y * kx;
	      node.setLayout({
	        y: nodeY
	      }, true);
	    } else {
	      var nodeX = node.getLayout().x * kx;
	      node.setLayout({
	        x: nodeX
	      }, true);
	    }
	  });
	}
	/**
	 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 *     in the same column.
	 * @param {number} iterations  the number of iterations for the algorithm
	 */
	
	
	function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
	  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
	  initializeNodeDepth(nodes, nodesByBreadth, edges, height, width, nodeGap, orient);
	  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	
	  for (var alpha = 1; iterations > 0; iterations--) {
	    // 0.99 is a experience parameter, ensure that each iterations of
	    // changes as small as possible.
	    alpha *= 0.99;
	    relaxRightToLeft(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	    relaxLeftToRight(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	  }
	}
	
	function prepareNodesByBreadth(nodes, orient) {
	  var nodesByBreadth = [];
	  var keyAttr = orient === 'vertical' ? 'y' : 'x';
	  var groupResult = groupData(nodes, function (node) {
	    return node.getLayout()[keyAttr];
	  });
	  groupResult.keys.sort(function (a, b) {
	    return a - b;
	  });
	  zrUtil.each(groupResult.keys, function (key) {
	    nodesByBreadth.push(groupResult.buckets.get(key));
	  });
	  return nodesByBreadth;
	}
	/**
	 * Compute the original y-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 */
	
	
	function initializeNodeDepth(nodes, nodesByBreadth, edges, height, width, nodeGap, orient) {
	  var kyArray = [];
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var n = nodes.length;
	    var sum = 0;
	    var ky = 0;
	    zrUtil.each(nodes, function (node) {
	      sum += node.getLayout().value;
	    });
	
	    if (orient === 'vertical') {
	      ky = (width - (n - 1) * nodeGap) / sum;
	    } else {
	      ky = (height - (n - 1) * nodeGap) / sum;
	    }
	
	    kyArray.push(ky);
	  });
	  kyArray.sort(function (a, b) {
	    return a - b;
	  });
	  var ky0 = kyArray[0];
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node, i) {
	      var nodeDy = node.getLayout().value * ky0;
	
	      if (orient === 'vertical') {
	        node.setLayout({
	          x: i
	        }, true);
	        node.setLayout({
	          dx: nodeDy
	        }, true);
	      } else {
	        node.setLayout({
	          y: i
	        }, true);
	        node.setLayout({
	          dy: nodeDy
	        }, true);
	      }
	    });
	  });
	  zrUtil.each(edges, function (edge) {
	    var edgeDy = +edge.getValue() * ky0;
	    edge.setLayout({
	      dy: edgeDy
	    }, true);
	  });
	}
	/**
	 * Resolve the collision of initialized depth (y-position)
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {number} nodeGap  the vertical distance between two nodes
	 * @param {number} height  the whole height of the area to draw the view
	 */
	
	
	function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var node;
	    var dy;
	    var y0 = 0;
	    var n = nodes.length;
	    var i;
	
	    if (orient === 'vertical') {
	      var nodeX;
	      nodes.sort(function (a, b) {
	        return a.getLayout().x - b.getLayout().x;
	      });
	
	      for (i = 0; i < n; i++) {
	        node = nodes[i];
	        dy = y0 - node.getLayout().x;
	
	        if (dy > 0) {
	          nodeX = node.getLayout().x + dy;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        }
	
	        y0 = node.getLayout().x + node.getLayout().dx + nodeGap;
	      } // If the bottommost node goes outside the bounds, push it back up
	
	
	      dy = y0 - nodeGap - width;
	
	      if (dy > 0) {
	        nodeX = node.getLayout().x - dy;
	        node.setLayout({
	          x: nodeX
	        }, true);
	        y0 = nodeX;
	
	        for (i = n - 2; i >= 0; --i) {
	          node = nodes[i];
	          dy = node.getLayout().x + node.getLayout().dx + nodeGap - y0;
	
	          if (dy > 0) {
	            nodeX = node.getLayout().x - dy;
	            node.setLayout({
	              x: nodeX
	            }, true);
	          }
	
	          y0 = node.getLayout().x;
	        }
	      }
	    } else {
	      var nodeY;
	      nodes.sort(function (a, b) {
	        return a.getLayout().y - b.getLayout().y;
	      });
	
	      for (i = 0; i < n; i++) {
	        node = nodes[i];
	        dy = y0 - node.getLayout().y;
	
	        if (dy > 0) {
	          nodeY = node.getLayout().y + dy;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	
	        y0 = node.getLayout().y + node.getLayout().dy + nodeGap;
	      } // If the bottommost node goes outside the bounds, push it back up
	
	
	      dy = y0 - nodeGap - height;
	
	      if (dy > 0) {
	        nodeY = node.getLayout().y - dy;
	        node.setLayout({
	          y: nodeY
	        }, true);
	        y0 = nodeY;
	
	        for (i = n - 2; i >= 0; --i) {
	          node = nodes[i];
	          dy = node.getLayout().y + node.getLayout().dy + nodeGap - y0;
	
	          if (dy > 0) {
	            nodeY = node.getLayout().y - dy;
	            node.setLayout({
	              y: nodeY
	            }, true);
	          }
	
	          y0 = node.getLayout().y;
	        }
	      }
	    }
	  });
	}
	/**
	 * Change the y-position of the nodes, except most the right side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxRightToLeft(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.outEdges.length) {
	        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue, orient);
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	
	function weightedTarget(edge, orient) {
	  return center(edge.node2, orient) * edge.getValue();
	}
	
	function weightedSource(edge, orient) {
	  return center(edge.node1, orient) * edge.getValue();
	}
	
	function center(node, orient) {
	  if (orient === 'vertical') {
	    return node.getLayout().x + node.getLayout().dx / 2;
	  }
	
	  return node.getLayout().y + node.getLayout().dy / 2;
	}
	
	function getEdgeValue(edge) {
	  return edge.getValue();
	}
	
	function sum(array, f, orient) {
	  var sum = 0;
	  var len = array.length;
	  var i = -1;
	
	  while (++i < len) {
	    var value = +f.call(array, array[i], orient);
	
	    if (!isNaN(value)) {
	      sum += value;
	    }
	  }
	
	  return sum;
	}
	/**
	 * Change the y-position of the nodes, except most the left side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxLeftToRight(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.inEdges.length) {
	        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue, orient);
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	/**
	 * Compute the depth(y-position) of each edge
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeEdgeDepths(nodes, orient) {
	  zrUtil.each(nodes, function (node) {
	    if (orient === 'vertical') {
	      node.outEdges.sort(function (a, b) {
	        return a.node2.getLayout().x - b.node2.getLayout().x;
	      });
	      node.inEdges.sort(function (a, b) {
	        return a.node1.getLayout().x - b.node1.getLayout().x;
	      });
	    } else {
	      node.outEdges.sort(function (a, b) {
	        return a.node2.getLayout().y - b.node2.getLayout().y;
	      });
	      node.inEdges.sort(function (a, b) {
	        return a.node1.getLayout().y - b.node1.getLayout().y;
	      });
	    }
	  });
	  zrUtil.each(nodes, function (node) {
	    var sy = 0;
	    var ty = 0;
	    zrUtil.each(node.outEdges, function (edge) {
	      edge.setLayout({
	        sy: sy
	      }, true);
	      sy += edge.getLayout().dy;
	    });
	    zrUtil.each(node.inEdges, function (edge) {
	      edge.setLayout({
	        ty: ty
	      }, true);
	      ty += edge.getLayout().dy;
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(375);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual encoding for sankey view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	
	    if (nodes.length) {
	      var minValue = Infinity;
	      var maxValue = -Infinity;
	      zrUtil.each(nodes, function (node) {
	        var nodeValue = node.getLayout().value;
	
	        if (nodeValue < minValue) {
	          minValue = nodeValue;
	        }
	
	        if (nodeValue > maxValue) {
	          maxValue = nodeValue;
	        }
	      });
	      zrUtil.each(nodes, function (node) {
	        var mapping = new VisualMapping({
	          type: 'color',
	          mappingMethod: 'linear',
	          dataExtent: [minValue, maxValue],
	          visual: seriesModel.get('color')
	        });
	        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	        node.setVisual('color', mapValueToColor); // If set itemStyle.normal.color
	
	        var itemModel = node.getModel();
	        var customColor = itemModel.get('itemStyle.color');
	
	        if (customColor != null) {
	          node.setVisual('color', customColor);
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(430);
	
	__webpack_require__(432);
	
	var boxplotVisual = __webpack_require__(433);
	
	var boxplotLayout = __webpack_require__(434);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(boxplotVisual);
	echarts.registerLayout(boxplotLayout);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var SeriesModel = __webpack_require__(233);
	
	var _whiskerBoxCommon = __webpack_require__(431);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BoxplotSeries = SeriesModel.extend({
	  type: 'series.boxplot',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	  // TODO
	  // box width represents group size, so dimension should have 'size'.
	
	  /**
	   * @see <https://en.wikipedia.org/wiki/Box_plot>
	   * The meanings of 'min' and 'max' depend on user,
	   * and echarts do not need to know it.
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'min',
	    defaultTooltip: true
	  }, {
	    name: 'Q1',
	    defaultTooltip: true
	  }, {
	    name: 'median',
	    defaultTooltip: true
	  }, {
	    name: 'Q3',
	    defaultTooltip: true
	  }, {
	    name: 'max',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    boxWidth: [7, 50],
	    // [min, max] can be percent of band width.
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2,
	        shadowBlur: 5,
	        shadowOffsetX: 2,
	        shadowOffsetY: 2,
	        shadowColor: 'rgba(0,0,0,0.4)'
	      }
	    },
	    animationEasing: 'elasticOut',
	    animationDuration: 800
	  }
	});
	zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
	var _default = BoxplotSeries;
	module.exports = _default;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(312);
	
	var zrUtil = __webpack_require__(134);
	
	var _dimensionHelper = __webpack_require__(257);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var seriesModelMixin = {
	  /**
	   * @private
	   * @type {string}
	   */
	  _baseAxisDim: null,
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // When both types of xAxis and yAxis are 'value', layout is
	    // needed to be specified by user. Otherwise, layout can be
	    // judged by which axis is category.
	    var ordinalMeta;
	    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var addOrdinal; // FIXME
	    // 考虑时间轴
	
	    if (xAxisType === 'category') {
	      option.layout = 'horizontal';
	      ordinalMeta = xAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else if (yAxisType === 'category') {
	      option.layout = 'vertical';
	      ordinalMeta = yAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else {
	      option.layout = option.layout || 'horizontal';
	    }
	
	    var coordDims = ['x', 'y'];
	    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	    var axisModels = [xAxisModel, yAxisModel];
	    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
	    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
	    var data = option.data; // ??? FIXME make a stage to perform data transfrom.
	    // MUST create a new data, consider setOption({}) again.
	
	    if (data && addOrdinal) {
	      var newOptionData = [];
	      zrUtil.each(data, function (item, index) {
	        var newItem;
	
	        if (item.value && zrUtil.isArray(item.value)) {
	          newItem = item.value.slice();
	          item.value.unshift(index);
	        } else if (zrUtil.isArray(item)) {
	          newItem = item.slice();
	          item.unshift(index);
	        } else {
	          newItem = item;
	        }
	
	        newOptionData.push(newItem);
	      });
	      option.data = newOptionData;
	    }
	
	    var defaultValueDimensions = this.defaultValueDimensions;
	    return createListSimply(this, {
	      coordDimensions: [{
	        name: baseAxisDim,
	        type: getDimensionTypeByAxis(baseAxisType),
	        ordinalMeta: ordinalMeta,
	        otherDims: {
	          tooltip: false,
	          itemName: 0
	        },
	        dimsDef: ['base']
	      }, {
	        name: otherAxisDim,
	        type: getDimensionTypeByAxis(otherAxisType),
	        dimsDef: defaultValueDimensions.slice()
	      }],
	      dimensionsCount: defaultValueDimensions.length + 1
	    });
	  },
	
	  /**
	   * If horizontal, base axis is x, otherwise y.
	   * @override
	   */
	  getBaseAxis: function () {
	    var dim = this._baseAxisDim;
	    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	  }
	};
	exports.seriesModelMixin = seriesModelMixin;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ChartView = __webpack_require__(238);
	
	var graphic = __webpack_require__(180);
	
	var Path = __webpack_require__(182);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Update common properties
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var BoxplotView = ChartView.extend({
	  type: 'boxplot',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var oldData = this._data; // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var itemLayout = data.getItemLayout(newIdx);
	        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
	        data.setItemGraphicEl(newIdx, symbolEl);
	        group.add(symbolEl);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(symbolEl);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (!symbolEl) {
	        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
	      } else {
	        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
	      }
	
	      group.add(symbolEl);
	      data.setItemGraphicEl(newIdx, symbolEl);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	    this._data = null;
	    data && data.eachItemGraphicEl(function (el) {
	      el && group.remove(el);
	    });
	  },
	  dispose: zrUtil.noop
	});
	var BoxPath = Path.extend({
	  type: 'boxplotBoxPath',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	    var i = 0;
	    ctx.moveTo(ends[i][0], ends[i][1]);
	    i++;
	
	    for (; i < 4; i++) {
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	
	    ctx.closePath();
	
	    for (; i < ends.length; i++) {
	      ctx.moveTo(ends[i][0], ends[i][1]);
	      i++;
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
	  var ends = itemLayout.ends;
	  var el = new BoxPath({
	    shape: {
	      points: isInit ? transInit(ends, constDim, itemLayout) : ends
	    }
	  });
	  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
	  return el;
	}
	
	function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
	  var seriesModel = data.hostModel;
	  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
	  updateMethod(el, {
	    shape: {
	      points: itemLayout.ends
	    }
	  }, seriesModel, dataIndex);
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var borderColor = data.getItemVisual(dataIndex, 'color'); // Exclude borderColor.
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
	  itemStyle.stroke = borderColor;
	  itemStyle.strokeNoScale = true;
	  el.useStyle(itemStyle);
	  el.z2 = 100;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, dim, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[dim] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var _default = BoxplotView;
	module.exports = _default;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var borderColorQuery = ['itemStyle', 'borderColor'];
	
	function _default(ecModel, api) {
	  var globalColors = ecModel.get('color');
	  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
	    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      // Use name 'color' but not 'borderColor' for legend usage and
	      // visual coding from other component like dataRange.
	      color: seriesModel.get(borderColorQuery) || defaulColor
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        data.setItemVisual(idx, {
	          color: itemModel.get(borderColorQuery, true)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(ecModel) {
	  var groupResult = groupSeriesByAxis(ecModel);
	  each(groupResult, function (groupItem) {
	    var seriesModels = groupItem.seriesModels;
	
	    if (!seriesModels.length) {
	      return;
	    }
	
	    calculateBase(groupItem);
	    each(seriesModels, function (seriesModel, idx) {
	      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	    });
	  });
	}
	/**
	 * Group series by axis.
	 */
	
	
	function groupSeriesByAxis(ecModel) {
	  var result = [];
	  var axisList = [];
	  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	    var baseAxis = seriesModel.getBaseAxis();
	    var idx = zrUtil.indexOf(axisList, baseAxis);
	
	    if (idx < 0) {
	      idx = axisList.length;
	      axisList[idx] = baseAxis;
	      result[idx] = {
	        axis: baseAxis,
	        seriesModels: []
	      };
	    }
	
	    result[idx].seriesModels.push(seriesModel);
	  });
	  return result;
	}
	/**
	 * Calculate offset and box width for each series.
	 */
	
	
	function calculateBase(groupItem) {
	  var extent;
	  var baseAxis = groupItem.axis;
	  var seriesModels = groupItem.seriesModels;
	  var seriesCount = seriesModels.length;
	  var boxWidthList = groupItem.boxWidthList = [];
	  var boxOffsetList = groupItem.boxOffsetList = [];
	  var boundList = [];
	  var bandWidth;
	
	  if (baseAxis.type === 'category') {
	    bandWidth = baseAxis.getBandWidth();
	  } else {
	    var maxDataCount = 0;
	    each(seriesModels, function (seriesModel) {
	      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
	    });
	    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
	  }
	
	  each(seriesModels, function (seriesModel) {
	    var boxWidthBound = seriesModel.get('boxWidth');
	
	    if (!zrUtil.isArray(boxWidthBound)) {
	      boxWidthBound = [boxWidthBound, boxWidthBound];
	    }
	
	    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
	  });
	  var availableWidth = bandWidth * 0.8 - 2;
	  var boxGap = availableWidth / seriesCount * 0.3;
	  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	  var base = boxWidth / 2 - availableWidth / 2;
	  each(seriesModels, function (seriesModel, idx) {
	    boxOffsetList.push(base);
	    base += boxGap + boxWidth;
	    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	  });
	}
	/**
	 * Calculate points location for each series.
	 */
	
	
	function layoutSingleSeries(seriesModel, offset, boxWidth) {
	  var coordSys = seriesModel.coordinateSystem;
	  var data = seriesModel.getData();
	  var halfWidth = boxWidth / 2;
	  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
	  var vDimIdx = 1 - cDimIdx;
	  var coordDims = ['x', 'y'];
	  var cDim = data.mapDimension(coordDims[cDimIdx]);
	  var vDims = data.mapDimension(coordDims[vDimIdx], true);
	
	  if (cDim == null || vDims.length < 5) {
	    return;
	  }
	
	  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	    var axisDimVal = data.get(cDim, dataIndex);
	    var median = getPoint(axisDimVal, vDims[2], dataIndex);
	    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
	    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
	    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
	    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
	    var ends = [];
	    addBodyEnd(ends, end2, 0);
	    addBodyEnd(ends, end4, 1);
	    ends.push(end1, end2, end5, end4);
	    layEndLine(ends, end1);
	    layEndLine(ends, end5);
	    layEndLine(ends, median);
	    data.setItemLayout(dataIndex, {
	      initBaseline: median[vDimIdx],
	      ends: ends
	    });
	  }
	
	  function getPoint(axisDimVal, dimIdx, dataIndex) {
	    var val = data.get(dimIdx, dataIndex);
	    var p = [];
	    p[cDimIdx] = axisDimVal;
	    p[vDimIdx] = val;
	    var point;
	
	    if (isNaN(axisDimVal) || isNaN(val)) {
	      point = [NaN, NaN];
	    } else {
	      point = coordSys.dataToPoint(p);
	      point[cDimIdx] += offset;
	    }
	
	    return point;
	  }
	
	  function addBodyEnd(ends, point, start) {
	    var point1 = point.slice();
	    var point2 = point.slice();
	    point1[cDimIdx] += halfWidth;
	    point2[cDimIdx] -= halfWidth;
	    start ? ends.push(point1, point2) : ends.push(point2, point1);
	  }
	
	  function layEndLine(ends, endCenter) {
	    var from = endCenter.slice();
	    var to = endCenter.slice();
	    from[cDimIdx] -= halfWidth;
	    to[cDimIdx] += halfWidth;
	    ends.push(from, to);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(436);
	
	__webpack_require__(437);
	
	var preprocessor = __webpack_require__(438);
	
	var candlestickVisual = __webpack_require__(439);
	
	var candlestickLayout = __webpack_require__(440);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(preprocessor);
	echarts.registerVisual(candlestickVisual);
	echarts.registerLayout(candlestickLayout);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var SeriesModel = __webpack_require__(233);
	
	var _whiskerBoxCommon = __webpack_require__(431);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CandlestickSeries = SeriesModel.extend({
	  type: 'series.candlestick',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	
	  /**
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'open',
	    defaultTooltip: true
	  }, {
	    name: 'close',
	    defaultTooltip: true
	  }, {
	    name: 'lowest',
	    defaultTooltip: true
	  }, {
	    name: 'highest',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    itemStyle: {
	      color: '#c23531',
	      // 阳线 positive
	      color0: '#314656',
	      // 阴线 negative     '#c23531', '#314656'
	      borderWidth: 1,
	      // FIXME
	      // ec2中使用的是lineStyle.color 和 lineStyle.color0
	      borderColor: '#c23531',
	      borderColor0: '#314656'
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2
	      }
	    },
	    barMaxWidth: null,
	    barMinWidth: null,
	    barWidth: null,
	    large: true,
	    largeThreshold: 600,
	    progressive: 3e3,
	    progressiveThreshold: 1e4,
	    progressiveChunkMode: 'mod',
	    animationUpdate: false,
	    animationEasing: 'linear',
	    animationDuration: 300
	  },
	
	  /**
	   * Get dimension for shadow in dataZoom
	   * @return {string} dimension name
	   */
	  getShadowDim: function () {
	    return 'open';
	  },
	  brushSelector: function (dataIndex, data, selectors) {
	    var itemLayout = data.getItemLayout(dataIndex);
	    return itemLayout && selectors.rect(itemLayout.brushRect);
	  }
	});
	zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
	var _default = CandlestickSeries;
	module.exports = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ChartView = __webpack_require__(238);
	
	var graphic = __webpack_require__(180);
	
	var Path = __webpack_require__(182);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var SKIP_PROPS = ['color', 'color0', 'borderColor', 'borderColor0'];
	var CandlestickView = ChartView.extend({
	  type: 'candlestick',
	  render: function (seriesModel, ecModel, api) {
	    this._updateDrawMode(seriesModel);
	
	    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var isSimpleBox = data.getLayout('isSimpleBox'); // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var el;
	        var itemLayout = data.getItemLayout(newIdx);
	        el = createNormalBox(itemLayout, newIdx, true);
	        graphic.initProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	        setBoxCommon(el, data, newIdx, isSimpleBox);
	        group.add(el);
	        data.setItemGraphicEl(newIdx, el);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (!el) {
	        el = createNormalBox(itemLayout, newIdx);
	      } else {
	        graphic.updateProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	      }
	
	      setBoxCommon(el, data, newIdx, isSimpleBox);
	      group.add(el);
	      data.setItemGraphicEl(newIdx, el);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel) {
	    this._clear();
	
	    createLarge(seriesModel, this.group);
	  },
	  _incrementalRenderNormal: function (params, seriesModel) {
	    var data = seriesModel.getData();
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var el;
	      var itemLayout = data.getItemLayout(dataIndex);
	      el = createNormalBox(itemLayout, dataIndex);
	      setBoxCommon(el, data, dataIndex, isSimpleBox);
	      el.incremental = true;
	      this.group.add(el);
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    createLarge(seriesModel, this.group, true);
	  },
	  remove: function (ecModel) {
	    this._clear();
	  },
	  _clear: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: zrUtil.noop
	});
	var NormalBoxPath = Path.extend({
	  type: 'normalCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	
	    if (this.__simpleBox) {
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[6][0], ends[6][1]);
	    } else {
	      ctx.moveTo(ends[0][0], ends[0][1]);
	      ctx.lineTo(ends[1][0], ends[1][1]);
	      ctx.lineTo(ends[2][0], ends[2][1]);
	      ctx.lineTo(ends[3][0], ends[3][1]);
	      ctx.closePath();
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[5][0], ends[5][1]);
	      ctx.moveTo(ends[6][0], ends[6][1]);
	      ctx.lineTo(ends[7][0], ends[7][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, dataIndex, isInit) {
	  var ends = itemLayout.ends;
	  return new NormalBoxPath({
	    shape: {
	      points: isInit ? transInit(ends, itemLayout) : ends
	    },
	    z2: 100
	  });
	}
	
	function setBoxCommon(el, data, dataIndex, isSimpleBox) {
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var color = data.getItemVisual(dataIndex, 'color');
	  var borderColor = data.getItemVisual(dataIndex, 'borderColor') || color; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = normalItemStyleModel.getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.strokeNoScale = true;
	  el.style.fill = color;
	  el.style.stroke = borderColor;
	  el.__simpleBox = isSimpleBox;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[1] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var LargeBoxPath = Path.extend({
	  type: 'largeCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	
	    for (var i = 0; i < points.length;) {
	      if (this.__sign === points[i++]) {
	        var x = points[i++];
	        ctx.moveTo(x, points[i++]);
	        ctx.lineTo(x, points[i++]);
	      } else {
	        i += 3;
	      }
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  var data = seriesModel.getData();
	  var largePoints = data.getLayout('largePoints');
	  var elP = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: 1
	  });
	  group.add(elP);
	  var elN = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: -1
	  });
	  group.add(elN);
	  setLargeStyle(1, elP, seriesModel, data);
	  setLargeStyle(-1, elN, seriesModel, data);
	
	  if (incremental) {
	    elP.incremental = true;
	    elN.incremental = true;
	  }
	}
	
	function setLargeStyle(sign, el, seriesModel, data) {
	  var suffix = sign > 0 ? 'P' : 'N';
	  var borderColor = data.getVisual('borderColor' + suffix) || data.getVisual('color' + suffix); // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor; // No different
	  // el.style.lineWidth = .5;
	}
	
	var _default = CandlestickView;
	module.exports = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  if (!option || !zrUtil.isArray(option.series)) {
	    return;
	  } // Translate 'k' to 'candlestick'.
	
	
	  zrUtil.each(option.series, function (seriesItem) {
	    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
	      seriesItem.type = 'candlestick';
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(239);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
	var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
	var positiveColorQuery = ['itemStyle', 'color'];
	var negativeColorQuery = ['itemStyle', 'color0'];
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  // For legend.
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var isLargeRender = seriesModel.pipelineContext.large;
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      colorP: getColor(1, seriesModel),
	      colorN: getColor(-1, seriesModel),
	      borderColorP: getBorderColor(1, seriesModel),
	      borderColorN: getBorderColor(-1, seriesModel)
	    }); // Only visible series has each data be visual encoded
	
	    if (ecModel.isSeriesFiltered(seriesModel)) {
	      return;
	    }
	
	    return !isLargeRender && {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var itemModel = data.getItemModel(dataIndex);
	        var sign = data.getItemLayout(dataIndex).sign;
	        data.setItemVisual(dataIndex, {
	          color: getColor(sign, itemModel),
	          borderColor: getBorderColor(sign, itemModel)
	        });
	      }
	    }
	
	    function getColor(sign, model) {
	      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
	    }
	
	    function getBorderColor(sign, model) {
	      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(180);
	
	var subPixelOptimize = _graphic.subPixelOptimize;
	
	var createRenderPlanner = __webpack_require__(239);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var _util = __webpack_require__(134);
	
	var retrieve2 = _util.retrieve2;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var candleWidth = calculateCandleWidth(seriesModel, data);
	    var cDimIdx = 0;
	    var vDimIdx = 1;
	    var coordDims = ['x', 'y'];
	    var cDim = data.mapDimension(coordDims[cDimIdx]);
	    var vDims = data.mapDimension(coordDims[vDimIdx], true);
	    var openDim = vDims[0];
	    var closeDim = vDims[1];
	    var lowestDim = vDims[2];
	    var highestDim = vDims[3];
	    data.setLayout({
	      candleWidth: candleWidth,
	      // The value is experimented visually.
	      isSimpleBox: candleWidth <= 1.3
	    });
	
	    if (cDim == null || vDims.length < 4) {
	      return;
	    }
	
	    return {
	      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
	    };
	
	    function normalProgress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	        var ocLow = Math.min(openVal, closeVal);
	        var ocHigh = Math.max(openVal, closeVal);
	        var ocLowPoint = getPoint(ocLow, axisDimVal);
	        var ocHighPoint = getPoint(ocHigh, axisDimVal);
	        var lowestPoint = getPoint(lowestVal, axisDimVal);
	        var highestPoint = getPoint(highestVal, axisDimVal);
	        var ends = [];
	        addBodyEnd(ends, ocHighPoint, 0);
	        addBodyEnd(ends, ocLowPoint, 1);
	        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
	        data.setItemLayout(dataIndex, {
	          sign: getSign(data, dataIndex, openVal, closeVal, closeDim),
	          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
	          // open point.
	          ends: ends,
	          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
	        });
	      }
	
	      function getPoint(val, axisDimVal) {
	        var p = [];
	        p[cDimIdx] = axisDimVal;
	        p[vDimIdx] = val;
	        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	      }
	
	      function addBodyEnd(ends, point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[cDimIdx] = subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
	        point2[cDimIdx] = subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
	        start ? ends.push(point1, point2) : ends.push(point2, point1);
	      }
	
	      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
	        var pmin = getPoint(lowestVal, axisDimVal);
	        var pmax = getPoint(highestVal, axisDimVal);
	        pmin[cDimIdx] -= candleWidth / 2;
	        pmax[cDimIdx] -= candleWidth / 2;
	        return {
	          x: pmin[0],
	          y: pmin[1],
	          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
	          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
	        };
	      }
	
	      function subPixelOptimizePoint(point) {
	        point[cDimIdx] = subPixelOptimize(point[cDimIdx], 1);
	        return point;
	      }
	    }
	
	    function largeProgress(params, data) {
	      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
	      var points = new LargeArr(params.count * 5);
	      var offset = 0;
	      var point;
	      var tmpIn = [];
	      var tmpOut = [];
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	
	        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
	          points[offset++] = NaN;
	          offset += 4;
	          continue;
	        }
	
	        points[offset++] = getSign(data, dataIndex, openVal, closeVal, closeDim);
	        tmpIn[cDimIdx] = axisDimVal;
	        tmpIn[vDimIdx] = lowestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[0] : NaN;
	        points[offset++] = point ? point[1] : NaN;
	        tmpIn[vDimIdx] = highestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[1] : NaN;
	      }
	
	      data.setLayout('largePoints', points);
	    }
	  }
	};
	
	function getSign(data, dataIndex, openVal, closeVal, closeDim) {
	  var sign;
	
	  if (openVal > closeVal) {
	    sign = -1;
	  } else if (openVal < closeVal) {
	    sign = 1;
	  } else {
	    sign = dataIndex > 0 // If close === open, compare with close of last record
	    ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
	    1;
	  }
	
	  return sign;
	}
	
	function calculateCandleWidth(seriesModel, data) {
	  var baseAxis = seriesModel.getBaseAxis();
	  var extent;
	  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	  var barWidth = seriesModel.get('barWidth');
	  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	}
	
	module.exports = _default;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(442);
	
	__webpack_require__(443);
	
	var visualSymbol = __webpack_require__(286);
	
	var layoutPoints = __webpack_require__(287);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('effectScatter', 'circle'));
	echarts.registerLayout(layoutPoints('effectScatter'));

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(254);
	
	var SeriesModel = __webpack_require__(233);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.effectScatter',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    effectType: 'ripple',
	    progressive: 0,
	    // When to show the effect, option: 'render'|'emphasis'
	    showEffectOn: 'render',
	    // Ripple effect config
	    rippleEffect: {
	      period: 4,
	      // Scale of ripple
	      scale: 2.5,
	      // Brush type can be fill or stroke
	      brushType: 'fill'
	    },
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    // large: false,
	    // Available when large is true
	    // largeThreshold: 2000,
	    // itemStyle: {
	    //     opacity: 1
	    // }
	
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var SymbolDraw = __webpack_require__(280);
	
	var EffectSymbol = __webpack_require__(444);
	
	var matrix = __webpack_require__(145);
	
	var pointsLayout = __webpack_require__(287);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'effectScatter',
	  init: function () {
	    this._symbolDraw = new SymbolDraw(EffectSymbol);
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var effectSymbolDraw = this._symbolDraw;
	    effectSymbolDraw.updateData(data);
	    this.group.add(effectSymbolDraw.group);
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    this.group.dirty();
	    var res = pointsLayout().reset(seriesModel);
	
	    if (res.progress) {
	      res.progress({
	        start: 0,
	        end: data.count()
	      }, data);
	    }
	
	    this._symbolDraw.updateLayout(data);
	  },
	  _updateGroupTransform: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.getRoamTransform) {
	      this.group.transform = matrix.clone(coordSys.getRoamTransform());
	      this.group.decomposeTransform();
	    }
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var _graphic = __webpack_require__(180);
	
	var Group = _graphic.Group;
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var SymbolClz = __webpack_require__(281);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Symbol with ripple effect
	 * @module echarts/chart/helper/EffectSymbol
	 */
	var EFFECT_RIPPLE_NUMBER = 3;
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	function updateRipplePath(rippleGroup, effectCfg) {
	  rippleGroup.eachChild(function (ripplePath) {
	    ripplePath.attr({
	      z: effectCfg.z,
	      zlevel: effectCfg.zlevel,
	      style: {
	        stroke: effectCfg.brushType === 'stroke' ? effectCfg.color : null,
	        fill: effectCfg.brushType === 'fill' ? effectCfg.color : null
	      }
	    });
	  });
	}
	/**
	 * @constructor
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function EffectSymbol(data, idx) {
	  Group.call(this);
	  var symbol = new SymbolClz(data, idx);
	  var rippleGroup = new Group();
	  this.add(symbol);
	  this.add(rippleGroup);
	
	  rippleGroup.beforeUpdate = function () {
	    this.attr(symbol.getScale());
	  };
	
	  this.updateData(data, idx);
	}
	
	var effectSymbolProto = EffectSymbol.prototype;
	
	effectSymbolProto.stopEffectAnimation = function () {
	  this.childAt(1).removeAll();
	};
	
	effectSymbolProto.startEffectAnimation = function (effectCfg) {
	  var symbolType = effectCfg.symbolType;
	  var color = effectCfg.color;
	  var rippleGroup = this.childAt(1);
	
	  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
	    // var ripplePath = createSymbol(
	    //     symbolType, -0.5, -0.5, 1, 1, color
	    // );
	    // If width/height are set too small (e.g., set to 1) on ios10
	    // and macOS Sierra, a circle stroke become a rect, no matter what
	    // the scale is set. So we set width/height as 2. See #4136.
	    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	    ripplePath.attr({
	      style: {
	        strokeNoScale: true
	      },
	      z2: 99,
	      silent: true,
	      scale: [0.5, 0.5]
	    });
	    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
	
	    ripplePath.animate('', true).when(effectCfg.period, {
	      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
	    }).delay(delay).start();
	    ripplePath.animateStyle(true).when(effectCfg.period, {
	      opacity: 0
	    }).delay(delay).start();
	    rippleGroup.add(ripplePath);
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Update effect symbol
	 */
	
	
	effectSymbolProto.updateEffectAnimation = function (effectCfg) {
	  var oldEffectCfg = this._effectCfg;
	  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];
	
	  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	    var propName = DIFFICULT_PROPS[i];
	
	    if (oldEffectCfg[propName] !== effectCfg[propName]) {
	      this.stopEffectAnimation();
	      this.startEffectAnimation(effectCfg);
	      return;
	    }
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Highlight symbol
	 */
	
	
	effectSymbolProto.highlight = function () {
	  this.trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	effectSymbolProto.downplay = function () {
	  this.trigger('normal');
	};
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	effectSymbolProto.updateData = function (data, idx) {
	  var seriesModel = data.hostModel;
	  this.childAt(0).updateData(data, idx);
	  var rippleGroup = this.childAt(1);
	  var itemModel = data.getItemModel(idx);
	  var symbolType = data.getItemVisual(idx, 'symbol');
	  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	  var color = data.getItemVisual(idx, 'color');
	  rippleGroup.attr('scale', symbolSize);
	  rippleGroup.traverse(function (ripplePath) {
	    ripplePath.attr({
	      fill: color
	    });
	  });
	  var symbolOffset = itemModel.getShallow('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = rippleGroup.position;
	    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  rippleGroup.rotation = (itemModel.getShallow('symbolRotate') || 0) * Math.PI / 180 || 0;
	  var effectCfg = {};
	  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
	  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
	  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
	  effectCfg.effectOffset = idx / data.count();
	  effectCfg.z = itemModel.getShallow('z') || 0;
	  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
	  effectCfg.symbolType = symbolType;
	  effectCfg.color = color;
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (effectCfg.showEffectOn === 'render') {
	    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	    this._effectCfg = effectCfg;
	  } else {
	    // Not keep old effect config
	    this._effectCfg = null;
	    this.stopEffectAnimation();
	    var symbol = this.childAt(0);
	
	    var onEmphasis = function () {
	      symbol.highlight();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.startEffectAnimation(effectCfg);
	      }
	    };
	
	    var onNormal = function () {
	      symbol.downplay();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.stopEffectAnimation();
	      }
	    };
	
	    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
	  }
	
	  this._effectCfg = effectCfg;
	};
	
	effectSymbolProto.fadeOut = function (cb) {
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  cb && cb();
	};
	
	zrUtil.inherits(EffectSymbol, Group);
	var _default = EffectSymbol;
	module.exports = _default;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(446);
	
	__webpack_require__(447);
	
	var linesLayout = __webpack_require__(452);
	
	var linesVisual = __webpack_require__(453);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(linesLayout);
	echarts.registerVisual(linesVisual);

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var SeriesModel = __webpack_require__(233);
	
	var List = __webpack_require__(255);
	
	var _util = __webpack_require__(134);
	
	var concatArray = _util.concatArray;
	var mergeAll = _util.mergeAll;
	var map = _util.map;
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	var CoordinateSystem = __webpack_require__(228);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint32Array, Float64Array, Float32Array */
	var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
	var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
	
	function compatEc2(seriesOpt) {
	  var data = seriesOpt.data;
	
	  if (data && data[0] && data[0][0] && data[0][0].coord) {
	    seriesOpt.data = map(data, function (itemOpt) {
	      var coords = [itemOpt[0].coord, itemOpt[1].coord];
	      var target = {
	        coords: coords
	      };
	
	      if (itemOpt[0].name) {
	        target.fromName = itemOpt[0].name;
	      }
	
	      if (itemOpt[1].name) {
	        target.toName = itemOpt[1].name;
	      }
	
	      return mergeAll([target, itemOpt[0], itemOpt[1]]);
	    });
	  }
	}
	
	var LinesSeries = SeriesModel.extend({
	  type: 'series.lines',
	  dependencies: ['grid', 'polar'],
	  visualColorAccessPath: 'lineStyle.color',
	  init: function (option) {
	    // The input data may be null/undefined.
	    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
	
	    compatEc2(option);
	
	    var result = this._processFlatCoordsArray(option.data);
	
	    this._flatCoords = result.flatCoords;
	    this._flatCoordsOffset = result.flatCoordsOffset;
	
	    if (result.flatCoords) {
	      option.data = new Float32Array(result.count);
	    }
	
	    LinesSeries.superApply(this, 'init', arguments);
	  },
	  mergeOption: function (option) {
	    // The input data may be null/undefined.
	    option.data = option.data || [];
	    compatEc2(option);
	
	    if (option.data) {
	      // Only update when have option data to merge.
	      var result = this._processFlatCoordsArray(option.data);
	
	      this._flatCoords = result.flatCoords;
	      this._flatCoordsOffset = result.flatCoordsOffset;
	
	      if (result.flatCoords) {
	        option.data = new Float32Array(result.count);
	      }
	    }
	
	    LinesSeries.superApply(this, 'mergeOption', arguments);
	  },
	  appendData: function (params) {
	    var result = this._processFlatCoordsArray(params.data);
	
	    if (result.flatCoords) {
	      if (!this._flatCoords) {
	        this._flatCoords = result.flatCoords;
	        this._flatCoordsOffset = result.flatCoordsOffset;
	      } else {
	        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
	        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
	      }
	
	      params.data = new Float32Array(result.count);
	    }
	
	    this.getRawData().appendData(params.data);
	  },
	  _getCoordsFromItemModel: function (idx) {
	    var itemModel = this.getData().getItemModel(idx);
	    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
	    return coords;
	  },
	  getLineCoordsCount: function (idx) {
	    if (this._flatCoordsOffset) {
	      return this._flatCoordsOffset[idx * 2 + 1];
	    } else {
	      return this._getCoordsFromItemModel(idx).length;
	    }
	  },
	  getLineCoords: function (idx, out) {
	    if (this._flatCoordsOffset) {
	      var offset = this._flatCoordsOffset[idx * 2];
	      var len = this._flatCoordsOffset[idx * 2 + 1];
	
	      for (var i = 0; i < len; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = this._flatCoords[offset + i * 2];
	        out[i][1] = this._flatCoords[offset + i * 2 + 1];
	      }
	
	      return len;
	    } else {
	      var coords = this._getCoordsFromItemModel(idx);
	
	      for (var i = 0; i < coords.length; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = coords[i][0];
	        out[i][1] = coords[i][1];
	      }
	
	      return coords.length;
	    }
	  },
	  _processFlatCoordsArray: function (data) {
	    var startOffset = 0;
	
	    if (this._flatCoords) {
	      startOffset = this._flatCoords.length;
	    } // Stored as a typed array. In format
	    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
	
	
	    if (typeof data[0] === 'number') {
	      var len = data.length; // Store offset and len of each segment
	
	      var coordsOffsetAndLenStorage = new Uint32Arr(len);
	      var coordsStorage = new Float64Arr(len);
	      var coordsCursor = 0;
	      var offsetCursor = 0;
	      var dataCount = 0;
	
	      for (var i = 0; i < len;) {
	        dataCount++;
	        var count = data[i++]; // Offset
	
	        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
	
	        coordsOffsetAndLenStorage[offsetCursor++] = count;
	
	        for (var k = 0; k < count; k++) {
	          var x = data[i++];
	          var y = data[i++];
	          coordsStorage[coordsCursor++] = x;
	          coordsStorage[coordsCursor++] = y;
	
	          if (i > len) {}
	        }
	      }
	
	      return {
	        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
	        flatCoords: coordsStorage,
	        count: dataCount
	      };
	    }
	
	    return {
	      flatCoordsOffset: null,
	      flatCoords: null,
	      count: data.length
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    var lineData = new List(['value'], this);
	    lineData.hasItemOption = false;
	    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	      // dataItem is simply coords
	      if (dataItem instanceof Array) {
	        return NaN;
	      } else {
	        lineData.hasItemOption = true;
	        var value = dataItem.value;
	
	        if (value != null) {
	          return value instanceof Array ? value[dimIndex] : value;
	        }
	      }
	    });
	    return lineData;
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var itemModel = data.getItemModel(dataIndex);
	    var name = itemModel.get('name');
	
	    if (name) {
	      return name;
	    }
	
	    var fromName = itemModel.get('fromName');
	    var toName = itemModel.get('toName');
	    var html = [];
	    fromName != null && html.push(fromName);
	    toName != null && html.push(toName);
	    return encodeHTML(html.join(' > '));
	  },
	  preventIncremental: function () {
	    return !!this.get('effect.show');
	  },
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      return this.option.large ? 1e4 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      return this.option.large ? 2e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'geo',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    xAxisIndex: 0,
	    yAxisIndex: 0,
	    symbol: ['none', 'none'],
	    symbolSize: [10, 10],
	    // Geo coordinate system
	    geoIndex: 0,
	    effect: {
	      show: false,
	      period: 4,
	      // Animation delay. support callback
	      // delay: 0,
	      // If move with constant speed px/sec
	      // period will be ignored if this property is > 0,
	      constantSpeed: 0,
	      symbol: 'circle',
	      symbolSize: 3,
	      loop: true,
	      // Length of trail, 0 - 1
	      trailLength: 0.2 // Same with lineStyle.color
	      // color
	
	    },
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // If lines are polyline
	    // polyline not support curveness, label, animation
	    polyline: false,
	    label: {
	      show: false,
	      position: 'end' // distance: 5,
	      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    lineStyle: {
	      opacity: 0.5
	    }
	  }
	});
	var _default = LinesSeries;
	module.exports = _default;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var LineDraw = __webpack_require__(382);
	
	var EffectLine = __webpack_require__(448);
	
	var Line = __webpack_require__(383);
	
	var Polyline = __webpack_require__(449);
	
	var EffectPolyline = __webpack_require__(450);
	
	var LargeLineDraw = __webpack_require__(451);
	
	var linesLayout = __webpack_require__(452);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'lines',
	  init: function () {},
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    var zlevel = seriesModel.get('zlevel');
	    var trailLength = seriesModel.get('effect.trailLength');
	    var zr = api.getZr(); // Avoid the drag cause ghost shadow
	    // FIXME Better way ?
	    // SVG doesn't support
	
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(zlevel).clear(true);
	    } // Config layer with motion blur
	
	
	    if (this._lastZlevel != null && !isSvg) {
	      zr.configLayer(this._lastZlevel, {
	        motionBlur: false
	      });
	    }
	
	    if (this._showEffect(seriesModel) && trailLength) {
	      if (!isSvg) {
	        zr.configLayer(zlevel, {
	          motionBlur: true,
	          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	        });
	      }
	    }
	
	    lineDraw.updateData(data);
	    this._lastZlevel = zlevel;
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    lineDraw.incrementalPrepareUpdate(data);
	
	    this._clearLayer(api);
	
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var pipelineContext = seriesModel.pipelineContext;
	
	    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
	      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
	      return {
	        update: true
	      };
	    } else {
	      // TODO Use same logic with ScatterView.
	      // Manually update layout
	      var res = linesLayout.reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._lineDraw.updateLayout();
	
	      this._clearLayer(api);
	    }
	  },
	  _updateLineDraw: function (data, seriesModel) {
	    var lineDraw = this._lineDraw;
	
	    var hasEffect = this._showEffect(seriesModel);
	
	    var isPolyline = !!seriesModel.get('polyline');
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
	      if (lineDraw) {
	        lineDraw.remove();
	      }
	
	      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
	      this._hasEffet = hasEffect;
	      this._isPolyline = isPolyline;
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(lineDraw.group);
	    return lineDraw;
	  },
	  _showEffect: function (seriesModel) {
	    return !!seriesModel.get('effect.show');
	  },
	  _clearLayer: function (api) {
	    // Not use motion when dragging or zooming
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg && this._lastZlevel != null) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  remove: function (ecModel, api) {
	    this._lineDraw && this._lineDraw.remove();
	    this._lineDraw = null; // Clear motion when lineDraw is removed
	
	    this._clearLayer(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var Line = __webpack_require__(383);
	
	var zrUtil = __webpack_require__(134);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var vec2 = __webpack_require__(136);
	
	var curveUtil = __webpack_require__(184);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	function EffectLine(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.add(this.createLine(lineData, idx, seriesScope));
	
	  this._updateEffectSymbol(lineData, idx);
	}
	
	var effectLineProto = EffectLine.prototype;
	
	effectLineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Line(lineData, idx, seriesScope);
	};
	
	effectLineProto._updateEffectSymbol = function (lineData, idx) {
	  var itemModel = lineData.getItemModel(idx);
	  var effectModel = itemModel.getModel('effect');
	  var size = effectModel.get('symbolSize');
	  var symbolType = effectModel.get('symbol');
	
	  if (!zrUtil.isArray(size)) {
	    size = [size, size];
	  }
	
	  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
	  var symbol = this.childAt(1);
	
	  if (this._symbolType !== symbolType) {
	    // Remove previous
	    this.remove(symbol);
	    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	    symbol.z2 = 100;
	    symbol.culling = true;
	    this.add(symbol);
	  } // Symbol may be removed if loop is false
	
	
	  if (!symbol) {
	    return;
	  } // Shadow color is same with color in default
	
	
	  symbol.setStyle('shadowColor', color);
	  symbol.setStyle(effectModel.getItemStyle(['color']));
	  symbol.attr('scale', size);
	  symbol.setColor(color);
	  symbol.attr('scale', size);
	  this._symbolType = symbolType;
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
	  var symbol = this.childAt(1);
	
	  if (!symbol) {
	    return;
	  }
	
	  var self = this;
	  var points = lineData.getItemLayout(idx);
	  var period = effectModel.get('period') * 1000;
	  var loop = effectModel.get('loop');
	  var constantSpeed = effectModel.get('constantSpeed');
	  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
	    return idx / lineData.count() * period / 3;
	  });
	  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating
	
	  symbol.ignore = true;
	  this.updateAnimationPoints(symbol, points);
	
	  if (constantSpeed > 0) {
	    period = this.getLineLength(symbol) / constantSpeed * 1000;
	  }
	
	  if (period !== this._period || loop !== this._loop) {
	    symbol.stopAnimation();
	    var delay = delayExpr;
	
	    if (isDelayFunc) {
	      delay = delayExpr(idx);
	    }
	
	    if (symbol.__t > 0) {
	      delay = -period * symbol.__t;
	    }
	
	    symbol.__t = 0;
	    var animator = symbol.animate('', loop).when(period, {
	      __t: 1
	    }).delay(delay).during(function () {
	      self.updateSymbolPosition(symbol);
	    });
	
	    if (!loop) {
	      animator.done(function () {
	        self.remove(symbol);
	      });
	    }
	
	    animator.start();
	  }
	
	  this._period = period;
	  this._loop = loop;
	};
	
	effectLineProto.getLineLength = function (symbol) {
	  // Not so accurate
	  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
	};
	
	effectLineProto.updateAnimationPoints = function (symbol, points) {
	  symbol.__p1 = points[0];
	  symbol.__p2 = points[1];
	  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	};
	
	effectLineProto.updateData = function (lineData, idx, seriesScope) {
	  this.childAt(0).updateData(lineData, idx, seriesScope);
	
	  this._updateEffectSymbol(lineData, idx);
	};
	
	effectLineProto.updateSymbolPosition = function (symbol) {
	  var p1 = symbol.__p1;
	  var p2 = symbol.__p2;
	  var cp1 = symbol.__cp1;
	  var t = symbol.__t;
	  var pos = symbol.position;
	  var quadraticAt = curveUtil.quadraticAt;
	  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
	  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
	  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
	
	  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
	  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  symbol.ignore = false;
	};
	
	effectLineProto.updateLayout = function (lineData, idx) {
	  this.childAt(0).updateLayout(lineData, idx);
	  var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	zrUtil.inherits(EffectLine, graphic.Group);
	var _default = EffectLine;
	module.exports = _default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function Polyline(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createPolyline(lineData, idx, seriesScope);
	}
	
	var polylineProto = Polyline.prototype;
	
	polylineProto._createPolyline = function (lineData, idx, seriesScope) {
	  // var seriesModel = lineData.hostModel;
	  var points = lineData.getItemLayout(idx);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    }
	  });
	  this.add(line);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childAt(0);
	  var target = {
	    shape: {
	      points: lineData.getItemLayout(idx)
	    }
	  };
	  graphic.updateProps(line, target, seriesModel, idx);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var line = this.childAt(0);
	  var itemModel = lineData.getItemModel(idx);
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	
	  if (!seriesScope || lineData.hasItemOption) {
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	  }
	
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle;
	  graphic.setHoverStyle(this);
	};
	
	polylineProto.updateLayout = function (lineData, idx) {
	  var polyline = this.childAt(0);
	  polyline.setShape('points', lineData.getItemLayout(idx));
	};
	
	zrUtil.inherits(Polyline, graphic.Group);
	var _default = Polyline;
	module.exports = _default;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Polyline = __webpack_require__(449);
	
	var zrUtil = __webpack_require__(134);
	
	var EffectLine = __webpack_require__(448);
	
	var vec2 = __webpack_require__(136);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:echarts/chart/helper/EffectLine}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function EffectPolyline(lineData, idx, seriesScope) {
	  EffectLine.call(this, lineData, idx, seriesScope);
	  this._lastFrame = 0;
	  this._lastFramePercent = 0;
	}
	
	var effectPolylineProto = EffectPolyline.prototype; // Overwrite
	
	effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Polyline(lineData, idx, seriesScope);
	}; // Overwrite
	
	
	effectPolylineProto.updateAnimationPoints = function (symbol, points) {
	  this._points = points;
	  var accLenArr = [0];
	  var len = 0;
	
	  for (var i = 1; i < points.length; i++) {
	    var p1 = points[i - 1];
	    var p2 = points[i];
	    len += vec2.dist(p1, p2);
	    accLenArr.push(len);
	  }
	
	  if (len === 0) {
	    return;
	  }
	
	  for (var i = 0; i < accLenArr.length; i++) {
	    accLenArr[i] /= len;
	  }
	
	  this._offsets = accLenArr;
	  this._length = len;
	}; // Overwrite
	
	
	effectPolylineProto.getLineLength = function (symbol) {
	  return this._length;
	}; // Overwrite
	
	
	effectPolylineProto.updateSymbolPosition = function (symbol) {
	  var t = symbol.__t;
	  var points = this._points;
	  var offsets = this._offsets;
	  var len = points.length;
	
	  if (!offsets) {
	    // Has length 0
	    return;
	  }
	
	  var lastFrame = this._lastFrame;
	  var frame;
	
	  if (t < this._lastFramePercent) {
	    // Start from the next frame
	    // PENDING start from lastFrame ?
	    var start = Math.min(lastFrame + 1, len - 1);
	
	    for (frame = start; frame >= 0; frame--) {
	      if (offsets[frame] <= t) {
	        break;
	      }
	    } // PENDING really need to do this ?
	
	
	    frame = Math.min(frame, len - 2);
	  } else {
	    for (var frame = lastFrame; frame < len; frame++) {
	      if (offsets[frame] > t) {
	        break;
	      }
	    }
	
	    frame = Math.min(frame - 1, len - 2);
	  }
	
	  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
	  var tx = points[frame + 1][0] - points[frame][0];
	  var ty = points[frame + 1][1] - points[frame][1];
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  this._lastFrame = frame;
	  this._lastFramePercent = t;
	  symbol.ignore = false;
	};
	
	zrUtil.inherits(EffectPolyline, EffectLine);
	var _default = EffectPolyline;
	module.exports = _default;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var IncrementalDisplayable = __webpack_require__(213);
	
	var lineContain = __webpack_require__(187);
	
	var quadraticContain = __webpack_require__(189);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Batch by color
	var LargeLineShape = graphic.extendShape({
	  shape: {
	    polyline: false,
	    curveness: 0,
	    segs: []
	  },
	  buildPath: function (path, shape) {
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          path.moveTo(segs[i++], segs[i++]);
	
	          for (var k = 1; k < count; k++) {
	            path.lineTo(segs[i++], segs[i++]);
	          }
	        }
	      }
	    } else {
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	        path.moveTo(x0, y0);
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	          path.quadraticCurveTo(x2, y2, x1, y1);
	        } else {
	          path.lineTo(x1, y1);
	        }
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          var x0 = segs[i++];
	          var y0 = segs[i++];
	
	          for (var k = 1; k < count; k++) {
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	
	            if (lineContain.containStroke(x0, y0, x1, y1)) {
	              return dataIndex;
	            }
	          }
	        }
	
	        dataIndex++;
	      }
	    } else {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	
	          if (quadraticContain.containStroke(x0, y0, x2, y2, x1, y1)) {
	            return dataIndex;
	          }
	        } else {
	          if (lineContain.containStroke(x0, y0, x1, y1)) {
	            return dataIndex;
	          }
	        }
	
	        dataIndex++;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeLineDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeLineProto = LargeLineDraw.prototype;
	
	largeLineProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	
	largeLineProto.updateData = function (data) {
	  this.group.removeAll();
	  var lineEl = new LargeLineShape({
	    rectHover: true,
	    cursor: 'default'
	  });
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data); // Add back
	
	
	  this.group.add(lineEl);
	  this._incremental = null;
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental();
	
	  if (data.count() > 5e5) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalUpdate = function (taskParams, data) {
	  var lineEl = new LargeLineShape();
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data, !!this._incremental);
	
	  if (!this._incremental) {
	    lineEl.rectHover = true;
	    lineEl.cursor = 'default';
	    lineEl.__startIndex = taskParams.start;
	    this.group.add(lineEl);
	  } else {
	    this._incremental.addDisplayable(lineEl, true);
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeLineProto._setCommon = function (lineEl, data, isIncremental) {
	  var hostModel = data.hostModel;
	  lineEl.setShape({
	    polyline: hostModel.get('polyline'),
	    curveness: hostModel.get('lineStyle.curveness')
	  });
	  lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
	  lineEl.style.strokeNoScale = true;
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    lineEl.setStyle('stroke', visualColor);
	  }
	
	  lineEl.setStyle('fill');
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    lineEl.seriesIndex = hostModel.seriesIndex;
	    lineEl.on('mousemove', function (e) {
	      lineEl.dataIndex = null;
	      var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex > 0) {
	        // Provide dataIndex for tooltip
	        lineEl.dataIndex = dataIndex + lineEl.__startIndex;
	      }
	    });
	  }
	};
	
	largeLineProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeLineDraw;
	module.exports = _default;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(239);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var _default = {
	  seriesType: 'lines',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var isPolyline = seriesModel.get('polyline');
	    var isLarge = seriesModel.pipelineContext.large;
	
	    function progress(params, lineData) {
	      var lineCoords = [];
	
	      if (isLarge) {
	        var points;
	        var segCount = params.end - params.start;
	
	        if (isPolyline) {
	          var totalCoordsCount = 0;
	
	          for (var i = params.start; i < params.end; i++) {
	            totalCoordsCount += seriesModel.getLineCoordsCount(i);
	          }
	
	          points = new Float32Array(segCount + totalCoordsCount * 2);
	        } else {
	          points = new Float32Array(segCount * 4);
	        }
	
	        var offset = 0;
	        var pt = [];
	
	        for (var i = params.start; i < params.end; i++) {
	          var len = seriesModel.getLineCoords(i, lineCoords);
	
	          if (isPolyline) {
	            points[offset++] = len;
	          }
	
	          for (var k = 0; k < len; k++) {
	            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
	            points[offset++] = pt[0];
	            points[offset++] = pt[1];
	          }
	        }
	
	        lineData.setLayout('linesPoints', points);
	      } else {
	        for (var i = params.start; i < params.end; i++) {
	          var itemModel = lineData.getItemModel(i);
	          var len = seriesModel.getLineCoords(i, lineCoords);
	          var pts = [];
	
	          if (isPolyline) {
	            for (var j = 0; j < len; j++) {
	              pts.push(coordSys.dataToPoint(lineCoords[j]));
	            }
	          } else {
	            pts[0] = coordSys.dataToPoint(lineCoords[0]);
	            pts[1] = coordSys.dataToPoint(lineCoords[1]);
	            var curveness = itemModel.get('lineStyle.curveness');
	
	            if (+curveness) {
	              pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	            }
	          }
	
	          lineData.setItemLayout(i, pts);
	        }
	      }
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	var opacityQuery = 'lineStyle.opacity'.split('.');
	var _default = {
	  seriesType: 'lines',
	  reset: function (seriesModel, ecModel, api) {
	    var symbolType = normalize(seriesModel.get('symbol'));
	    var symbolSize = normalize(seriesModel.get('symbolSize'));
	    var data = seriesModel.getData();
	    data.setVisual('fromSymbol', symbolType && symbolType[0]);
	    data.setVisual('toSymbol', symbolType && symbolType[1]);
	    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    data.setVisual('opacity', seriesModel.get(opacityQuery));
	
	    function dataEach(data, idx) {
	      var itemModel = data.getItemModel(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
	      var opacity = itemModel.get(opacityQuery);
	      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	      data.setItemVisual(idx, 'opacity', opacity);
	    }
	
	    return {
	      dataEach: data.hasItemOption ? dataEach : null
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(455);
	
	__webpack_require__(456);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(233);
	
	var createListFromArray = __webpack_require__(254);
	
	var CoordinateSystem = __webpack_require__(228);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.heatmap',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      generateCoord: 'value'
	    });
	  },
	  preventIncremental: function () {
	    var coordSysCreator = CoordinateSystem.get(this.get('coordinateSystem'));
	
	    if (coordSysCreator && coordSysCreator.dimensions) {
	      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
	    }
	  },
	  defaultOption: {
	    // Cartesian2D or geo
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Geo coordinate system
	    geoIndex: 0,
	    blurSize: 30,
	    pointSize: 20,
	    maxOpacity: 1,
	    minOpacity: 0
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var graphic = __webpack_require__(180);
	
	var HeatmapLayer = __webpack_require__(457);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  pieceList = zrUtil.map(pieceList, function (piece) {
	    return {
	      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	    };
	  });
	  var len = pieceList.length;
	  var lastIndex = 0;
	  return function (val) {
	    // Try to find in the location of the last found
	    for (var i = lastIndex; i < len; i++) {
	      var interval = pieceList[i].interval;
	
	      if (interval[0] <= val && val <= interval[1]) {
	        lastIndex = i;
	        break;
	      }
	    }
	
	    if (i === len) {
	      // Not found, back interation
	      for (var i = lastIndex - 1; i >= 0; i--) {
	        var interval = pieceList[i].interval;
	
	        if (interval[0] <= val && val <= interval[1]) {
	          lastIndex = i;
	          break;
	        }
	      }
	    }
	
	    return i >= 0 && i < len && selected[i];
	  };
	}
	
	function getIsInContinuousRange(dataExtent, range) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	  return function (val) {
	    return val >= range[0] && val <= range[1];
	  };
	}
	
	function isGeoCoordSys(coordSys) {
	  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
	
	  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	}
	
	var _default = echarts.extendChartView({
	  type: 'heatmap',
	  render: function (seriesModel, ecModel, api) {
	    var visualMapOfThisSeries;
	    ecModel.eachComponent('visualMap', function (visualMap) {
	      visualMap.eachTargetSeries(function (targetSeries) {
	        if (targetSeries === seriesModel) {
	          visualMapOfThisSeries = visualMap;
	        }
	      });
	    });
	    this.group.removeAll();
	    this._incrementalDisplayable = null;
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
	    } else if (isGeoCoordSys(coordSys)) {
	      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	    }
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys) {
	      this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
	    }
	  },
	  _renderOnCartesianAndCalendar: function (seriesModel, api, start, end, incremental) {
	    var coordSys = seriesModel.coordinateSystem;
	    var width;
	    var height;
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      width = xAxis.getBandWidth();
	      height = yAxis.getBandWidth();
	    }
	
	    var group = this.group;
	    var data = seriesModel.getData();
	    var itemStyleQuery = 'itemStyle';
	    var hoverItemStyleQuery = 'emphasis.itemStyle';
	    var labelQuery = 'label';
	    var hoverLabelQuery = 'emphasis.label';
	    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
	    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
	    var labelModel = seriesModel.getModel(labelQuery);
	    var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
	    var coordSysType = coordSys.type;
	    var dataDims = coordSysType === 'cartesian2d' ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];
	
	    for (var idx = start; idx < end; idx++) {
	      var rect;
	
	      if (coordSysType === 'cartesian2d') {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[2], idx))) {
	          continue;
	        }
	
	        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
	        rect = new graphic.Rect({
	          shape: {
	            x: point[0] - width / 2,
	            y: point[1] - height / 2,
	            width: width,
	            height: height
	          },
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      } else {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[1], idx))) {
	          continue;
	        }
	
	        rect = new graphic.Rect({
	          z2: 1,
	          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      }
	
	      var itemModel = data.getItemModel(idx); // Optimization for large datset
	
	      if (data.hasItemOption) {
	        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
	        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
	        labelModel = itemModel.getModel(labelQuery);
	        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
	      }
	
	      var rawValue = seriesModel.getRawValue(idx);
	      var defaultText = '-';
	
	      if (rawValue && rawValue[2] != null) {
	        defaultText = rawValue[2];
	      }
	
	      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: idx,
	        defaultText: defaultText,
	        isRectText: true
	      });
	      rect.setStyle(style);
	      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
	      rect.incremental = incremental; // PENDING
	
	      if (incremental) {
	        // Rect must use hover layer if it's incremental.
	        rect.useHoverLayer = true;
	      }
	
	      group.add(rect);
	      data.setItemGraphicEl(idx, rect);
	    }
	  },
	  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
	    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	    //     throw new Error('Data range must have color visuals');
	    // }
	
	    var data = seriesModel.getData();
	    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	    hmLayer.blurSize = seriesModel.get('blurSize');
	    hmLayer.pointSize = seriesModel.get('pointSize');
	    hmLayer.minOpacity = seriesModel.get('minOpacity');
	    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	    var rect = geo.getViewRect().clone();
	    var roamTransform = geo.getRoamTransform();
	    rect.applyTransform(roamTransform); // Clamp on viewport
	
	    var x = Math.max(rect.x, 0);
	    var y = Math.max(rect.y, 0);
	    var x2 = Math.min(rect.width + rect.x, api.getWidth());
	    var y2 = Math.min(rect.height + rect.y, api.getHeight());
	    var width = x2 - x;
	    var height = y2 - y;
	    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
	    var points = data.mapArray(dims, function (lng, lat, value) {
	      var pt = geo.dataToPoint([lng, lat]);
	      pt[0] -= x;
	      pt[1] -= y;
	      pt.push(value);
	      return pt;
	    });
	    var dataExtent = visualMapModel.getExtent();
	    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	      inRange: inRangeVisuals.color.getColorMapper(),
	      outOfRange: outOfRangeVisuals.color.getColorMapper()
	    }, isInRange);
	    var img = new graphic.Image({
	      style: {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        image: hmLayer.canvas
	      },
	      silent: true
	    });
	    this.group.add(img);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8ClampedArray */
	
	/**
	 * @file defines echarts Heatmap Chart
	 * @author Ovilia (me@zhangwenli.com)
	 * Inspired by https://github.com/mourner/simpleheat
	 *
	 * @module
	 */
	var GRADIENT_LEVELS = 256;
	/**
	 * Heatmap Chart
	 *
	 * @class
	 */
	
	function Heatmap() {
	  var canvas = zrUtil.createCanvas();
	  this.canvas = canvas;
	  this.blurSize = 30;
	  this.pointSize = 20;
	  this.maxOpacity = 1;
	  this.minOpacity = 0;
	  this._gradientPixels = {};
	}
	
	Heatmap.prototype = {
	  /**
	   * Renders Heatmap and returns the rendered canvas
	   * @param {Array} data array of data, each has x, y, value
	   * @param {number} width canvas width
	   * @param {number} height canvas height
	   */
	  update: function (data, width, height, normalize, colorFunc, isInRange) {
	    var brush = this._getBrush();
	
	    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');
	
	    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');
	
	    var r = this.pointSize + this.blurSize;
	    var canvas = this.canvas;
	    var ctx = canvas.getContext('2d');
	    var len = data.length;
	    canvas.width = width;
	    canvas.height = height;
	
	    for (var i = 0; i < len; ++i) {
	      var p = data[i];
	      var x = p[0];
	      var y = p[1];
	      var value = p[2]; // calculate alpha using value
	
	      var alpha = normalize(value); // draw with the circle brush with alpha
	
	      ctx.globalAlpha = alpha;
	      ctx.drawImage(brush, x - r, y - r);
	    }
	
	    if (!canvas.width || !canvas.height) {
	      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	      // 'CanvasRenderingContext2D': The source height is 0."
	      return canvas;
	    } // colorize the canvas using alpha value and set with gradient
	
	
	    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var pixels = imageData.data;
	    var offset = 0;
	    var pixelLen = pixels.length;
	    var minOpacity = this.minOpacity;
	    var maxOpacity = this.maxOpacity;
	    var diffOpacity = maxOpacity - minOpacity;
	
	    while (offset < pixelLen) {
	      var alpha = pixels[offset + 3] / 256;
	      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	      if (alpha > 0) {
	        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	        pixels[offset++] = gradient[gradientOffset];
	        pixels[offset++] = gradient[gradientOffset + 1];
	        pixels[offset++] = gradient[gradientOffset + 2];
	        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	      } else {
	        offset += 4;
	      }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	    return canvas;
	  },
	
	  /**
	   * get canvas of a black circle brush used for canvas to draw later
	   * @private
	   * @returns {Object} circle brush canvas
	   */
	  _getBrush: function () {
	    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size
	
	    var r = this.pointSize + this.blurSize;
	    var d = r * 2;
	    brushCanvas.width = d;
	    brushCanvas.height = d;
	    var ctx = brushCanvas.getContext('2d');
	    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	    // draw the distinct circle in an invisible place,
	    // and use shadowOffset to draw shadow in the center of the canvas
	
	    ctx.shadowOffsetX = d;
	    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	    // color in color map
	
	    ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	    ctx.beginPath();
	    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    return brushCanvas;
	  },
	
	  /**
	   * get gradient color map
	   * @private
	   */
	  _getGradient: function (data, colorFunc, state) {
	    var gradientPixels = this._gradientPixels;
	    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	    var color = [0, 0, 0, 0];
	    var off = 0;
	
	    for (var i = 0; i < 256; i++) {
	      colorFunc[state](i / 255, true, color);
	      pixelsSingleState[off++] = color[0];
	      pixelsSingleState[off++] = color[1];
	      pixelsSingleState[off++] = color[2];
	      pixelsSingleState[off++] = color[3];
	    }
	
	    return pixelsSingleState;
	  }
	};
	var _default = Heatmap;
	module.exports = _default;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	__webpack_require__(290);
	
	__webpack_require__(459);
	
	__webpack_require__(460);
	
	var _barGrid = __webpack_require__(267);
	
	var layout = _barGrid.layout;
	
	var visualSymbol = __webpack_require__(286);
	
	__webpack_require__(289);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(layout, 'pictorialBar'));
	echarts.registerVisual(visualSymbol('pictorialBar', 'roundRect'));

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PictorialBarSeries = BaseBarSeries.extend({
	  type: 'series.pictorialBar',
	  dependencies: ['grid'],
	  defaultOption: {
	    symbol: 'circle',
	    // Customized bar shape
	    symbolSize: null,
	    // Can be ['100%', '100%'], null means auto.
	    symbolRotate: null,
	    symbolPosition: null,
	    // 'start' or 'end' or 'center', null means auto.
	    symbolOffset: null,
	    symbolMargin: null,
	    // start margin and end margin. Can be a number or a percent string.
	    // Auto margin by defualt.
	    symbolRepeat: false,
	    // false/null/undefined, means no repeat.
	    // Can be true, means auto calculate repeat times and cut by data.
	    // Can be a number, specifies repeat times, and do not cut by data.
	    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
	    symbolRepeatDirection: 'end',
	    // 'end' means from 'start' to 'end'.
	    symbolClip: false,
	    symbolBoundingData: null,
	    // Can be 60 or -40 or [-40, 60]
	    symbolPatternSize: 400,
	    // 400 * 400 px
	    barGap: '-100%',
	    // In most case, overlap is needed.
	    // z can be set in data item, which is z2 actually.
	    // Disable progressive
	    progressive: 0,
	    hoverAnimation: false // Open only when needed.
	
	  },
	  getInitialData: function (option) {
	    // Disable stack.
	    option.stack = null;
	    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
	  }
	});
	var _default = PictorialBarSeries;
	module.exports = _default;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	var isNumeric = _number.isNumeric;
	
	var _helper = __webpack_require__(308);
	
	var setLabel = _helper.setLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal
	
	var LAYOUT_ATTRS = [{
	  xy: 'x',
	  wh: 'width',
	  index: 0,
	  posDesc: ['left', 'right']
	}, {
	  xy: 'y',
	  wh: 'height',
	  index: 1,
	  posDesc: ['top', 'bottom']
	}];
	var pathForLineWidth = new graphic.Circle();
	var BarView = echarts.extendChartView({
	  type: 'pictorialBar',
	  render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var isHorizontal = !!baseAxis.isHorizontal();
	    var coordSysRect = cartesian.grid.getRect();
	    var opt = {
	      ecSize: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      seriesModel: seriesModel,
	      coordSys: cartesian,
	      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	      isHorizontal: isHorizontal,
	      valueDim: LAYOUT_ATTRS[+isHorizontal],
	      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
	    };
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = getItemModel(data, dataIndex);
	      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	      var bar = createBar(data, opt, symbolMeta);
	      data.setItemGraphicEl(dataIndex, bar);
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).update(function (newIndex, oldIndex) {
	      var bar = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(bar);
	        return;
	      }
	
	      var itemModel = getItemModel(data, newIndex);
	      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	      var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	        group.remove(bar);
	        data.setItemGraphicEl(newIndex, null);
	        bar = null;
	      }
	
	      if (bar) {
	        updateBar(bar, opt, symbolMeta);
	      } else {
	        bar = createBar(data, opt, symbolMeta, true);
	      }
	
	      data.setItemGraphicEl(newIndex, bar);
	      bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).remove(function (dataIndex) {
	      var bar = oldData.getItemGraphicEl(dataIndex);
	      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	    }).execute();
	    this._data = data;
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (bar) {
	          removeBar(data, bar.dataIndex, ecModel, bar);
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	}); // Set or calculate default value about symbol, and calculate layout info.
	
	function getSymbolMeta(data, dataIndex, itemModel, opt) {
	  var layout = data.getItemLayout(dataIndex);
	  var symbolRepeat = itemModel.get('symbolRepeat');
	  var symbolClip = itemModel.get('symbolClip');
	  var symbolPosition = itemModel.get('symbolPosition') || 'start';
	  var symbolRotate = itemModel.get('symbolRotate');
	  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	  var isAnimationEnabled = itemModel.isAnimationEnabled();
	  var symbolMeta = {
	    dataIndex: dataIndex,
	    layout: layout,
	    itemModel: itemModel,
	    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	    color: data.getItemVisual(dataIndex, 'color'),
	    symbolClip: symbolClip,
	    symbolRepeat: symbolRepeat,
	    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	    symbolPatternSize: symbolPatternSize,
	    rotation: rotation,
	    animationModel: isAnimationEnabled ? itemModel : null,
	    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
	    z2: itemModel.getShallow('z', true) || 0
	  };
	  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	  var symbolSize = symbolMeta.symbolSize;
	  var symbolOffset = itemModel.get('symbolOffset');
	
	  if (zrUtil.isArray(symbolOffset)) {
	    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
	  }
	
	  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	  return symbolMeta;
	} // bar length can be negative.
	
	
	function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
	  var valueDim = opt.valueDim;
	  var symbolBoundingData = itemModel.get('symbolBoundingData');
	  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	  var boundingLength;
	
	  if (zrUtil.isArray(symbolBoundingData)) {
	    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	    boundingLength = symbolBoundingExtent[pxSignIdx];
	  } else if (symbolBoundingData != null) {
	    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	  } else if (symbolRepeat) {
	    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	  } else {
	    boundingLength = layout[valueDim.wh];
	  }
	
	  output.boundingLength = boundingLength;
	
	  if (symbolRepeat) {
	    output.repeatCutLength = layout[valueDim.wh];
	  }
	
	  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
	}
	
	function convertToCoordOnAxis(axis, value) {
	  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	} // Support ['100%', '100%']
	
	
	function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
	  var valueDim = opt.valueDim;
	  var categoryDim = opt.categoryDim;
	  var categorySize = Math.abs(layout[categoryDim.wh]);
	  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	
	  if (zrUtil.isArray(symbolSize)) {
	    symbolSize = symbolSize.slice();
	  } else {
	    if (symbolSize == null) {
	      symbolSize = '100%';
	    }
	
	    symbolSize = [symbolSize, symbolSize];
	  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	  // to complicated to calculate real percent value if considering scaled lineWidth.
	  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	  // which can be tolerated in pictorial chart.
	
	
	  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
	  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
	
	  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	}
	
	function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
	  // In symbols are drawn with scale, so do not need to care about the case that width
	  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	  // be calculated.
	  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	  if (valueLineWidth) {
	    pathForLineWidth.attr({
	      scale: symbolScale.slice(),
	      rotation: rotation
	    });
	    pathForLineWidth.updateTransform();
	    valueLineWidth /= pathForLineWidth.getLineScale();
	    valueLineWidth *= symbolScale[opt.valueDim.index];
	  }
	
	  output.valueLineWidth = valueLineWidth;
	}
	
	function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
	  var categoryDim = opt.categoryDim;
	  var valueDim = opt.valueDim;
	  var pxSign = output.pxSign;
	  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	  // want symbols to rotate on its center, which should not be translated
	  // when rotating.
	
	  if (symbolRepeat) {
	    var absBoundingLength = Math.abs(boundingLength);
	    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
	    var hasEndGap = false;
	
	    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	      hasEndGap = true;
	      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	    }
	
	    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
	    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	    // to ensure that all of the symbols will not be overflow the given area.
	
	    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
	    // boundingLength.
	
	    var repeatSpecified = isNumeric(symbolRepeat);
	    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	    // entirely in the given layout area.
	
	    var mDiff = absBoundingLength - repeatTimes * unitLength;
	    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
	    uLenWithMargin = unitLength + symbolMargin * 2;
	    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
	
	    if (!repeatSpecified && symbolRepeat !== 'fixed') {
	      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	    }
	
	    pathLen = repeatTimes * uLenWithMargin - endFix;
	    output.repeatTimes = repeatTimes;
	    output.symbolMargin = symbolMargin;
	  }
	
	  var sizeFix = pxSign * (pathLen / 2);
	  var pathPosition = output.pathPosition = [];
	  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	  if (symbolOffset) {
	    pathPosition[0] += symbolOffset[0];
	    pathPosition[1] += symbolOffset[1];
	  }
	
	  var bundlePosition = output.bundlePosition = [];
	  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	  bundlePosition[valueDim.index] = layout[valueDim.xy];
	  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
	  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	  clipShape[valueDim.xy] = 0;
	  clipShape[valueDim.wh] = layout[valueDim.wh];
	}
	
	function createPath(symbolMeta) {
	  var symbolPatternSize = symbolMeta.symbolPatternSize;
	  var path = createSymbol( // Consider texture img, make a big size.
	  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
	  path.attr({
	    culling: true
	  });
	  path.type !== 'image' && path.setStyle({
	    strokeNoScale: true
	  });
	  return path;
	}
	
	function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var symbolSize = symbolMeta.symbolSize;
	  var valueLineWidth = symbolMeta.valueLineWidth;
	  var pathPosition = symbolMeta.pathPosition;
	  var valueDim = opt.valueDim;
	  var repeatTimes = symbolMeta.repeatTimes || 0;
	  var index = 0;
	  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	  eachPath(bar, function (path) {
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	
	    if (index < repeatTimes) {
	      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	    } else {
	      updateAttr(path, null, {
	        scale: [0, 0]
	      }, symbolMeta, isUpdate, function () {
	        bundle.remove(path);
	      });
	    }
	
	    updateHoverAnimation(path, symbolMeta);
	    index++;
	  });
	
	  for (; index < repeatTimes; index++) {
	    var path = createPath(symbolMeta);
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	    bundle.add(path);
	    var target = makeTarget(index);
	    updateAttr(path, {
	      position: target.position,
	      scale: [0, 0]
	    }, {
	      scale: target.scale,
	      rotation: target.rotation
	    }, symbolMeta, isUpdate); // FIXME
	    // If all emphasis/normal through action.
	
	    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	    updateHoverAnimation(path, symbolMeta);
	  }
	
	  function makeTarget(index) {
	    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	    // Otherwise: i = index;
	
	    var pxSign = symbolMeta.pxSign;
	    var i = index;
	
	    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	      i = repeatTimes - 1 - index;
	    }
	
	    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	    return {
	      position: position,
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    };
	  }
	
	  function onMouseOver() {
	    eachPath(bar, function (path) {
	      path.trigger('emphasis');
	    });
	  }
	
	  function onMouseOut() {
	    eachPath(bar, function (path) {
	      path.trigger('normal');
	    });
	  }
	}
	
	function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var mainPath = bar.__pictorialMainPath;
	
	  if (!mainPath) {
	    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	    bundle.add(mainPath);
	    updateAttr(mainPath, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: [0, 0],
	      rotation: symbolMeta.rotation
	    }, {
	      scale: symbolMeta.symbolScale.slice()
	    }, symbolMeta, isUpdate);
	    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	  } else {
	    updateAttr(mainPath, null, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    }, symbolMeta, isUpdate);
	  }
	
	  updateHoverAnimation(mainPath, symbolMeta);
	
	  function onMouseOver() {
	    this.trigger('emphasis');
	  }
	
	  function onMouseOut() {
	    this.trigger('normal');
	  }
	} // bar rect is used for label.
	
	
	function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
	  var barRect = bar.__pictorialBarRect;
	
	  if (!barRect) {
	    barRect = bar.__pictorialBarRect = new graphic.Rect({
	      z2: 2,
	      shape: rectShape,
	      silent: true,
	      style: {
	        stroke: 'transparent',
	        fill: 'transparent',
	        lineWidth: 0
	      }
	    });
	    bar.add(barRect);
	  } else {
	    updateAttr(barRect, null, {
	      shape: rectShape
	    }, symbolMeta, isUpdate);
	  }
	}
	
	function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	  // If not clip, symbol will be remove and rebuilt.
	  if (symbolMeta.symbolClip) {
	    var clipPath = bar.__pictorialClipPath;
	    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
	    var valueDim = opt.valueDim;
	    var animationModel = symbolMeta.animationModel;
	    var dataIndex = symbolMeta.dataIndex;
	
	    if (clipPath) {
	      graphic.updateProps(clipPath, {
	        shape: clipShape
	      }, animationModel, dataIndex);
	    } else {
	      clipShape[valueDim.wh] = 0;
	      clipPath = new graphic.Rect({
	        shape: clipShape
	      });
	
	      bar.__pictorialBundle.setClipPath(clipPath);
	
	      bar.__pictorialClipPath = clipPath;
	      var target = {};
	      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	        shape: target
	      }, animationModel, dataIndex);
	    }
	  }
	}
	
	function getItemModel(data, dataIndex) {
	  var itemModel = data.getItemModel(dataIndex);
	  itemModel.getAnimationDelayParams = getAnimationDelayParams;
	  itemModel.isAnimationEnabled = isAnimationEnabled;
	  return itemModel;
	}
	
	function getAnimationDelayParams(path) {
	  // The order is the same as the z-order, see `symbolRepeatDiretion`.
	  return {
	    index: path.__pictorialAnimationIndex,
	    count: path.__pictorialRepeatTimes
	  };
	}
	
	function isAnimationEnabled() {
	  // `animation` prop can be set on itemModel in pictorial bar chart.
	  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	}
	
	function updateHoverAnimation(path, symbolMeta) {
	  path.off('emphasis').off('normal');
	  var scale = symbolMeta.symbolScale.slice();
	  symbolMeta.hoverAnimation && path.on('emphasis', function () {
	    this.animateTo({
	      scale: [scale[0] * 1.1, scale[1] * 1.1]
	    }, 400, 'elasticOut');
	  }).on('normal', function () {
	    this.animateTo({
	      scale: scale.slice()
	    }, 400, 'elasticOut');
	  });
	}
	
	function createBar(data, opt, symbolMeta, isUpdate) {
	  // bar is the main element for each data.
	  var bar = new graphic.Group(); // bundle is used for location and clip.
	
	  var bundle = new graphic.Group();
	  bar.add(bundle);
	  bar.__pictorialBundle = bundle;
	  bundle.attr('position', symbolMeta.bundlePosition.slice());
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	  bar.__pictorialSymbolMeta = symbolMeta;
	  return bar;
	}
	
	function updateBar(bar, opt, symbolMeta) {
	  var animationModel = symbolMeta.animationModel;
	  var dataIndex = symbolMeta.dataIndex;
	  var bundle = bar.__pictorialBundle;
	  graphic.updateProps(bundle, {
	    position: symbolMeta.bundlePosition.slice()
	  }, animationModel, dataIndex);
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, true);
	  createOrUpdateClip(bar, opt, symbolMeta, true);
	}
	
	function removeBar(data, dataIndex, animationModel, bar) {
	  // Not show text when animating
	  var labelRect = bar.__pictorialBarRect;
	  labelRect && (labelRect.style.text = null);
	  var pathes = [];
	  eachPath(bar, function (path) {
	    pathes.push(path);
	  });
	  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	  bar.__pictorialClipPath && (animationModel = null);
	  zrUtil.each(pathes, function (path) {
	    graphic.updateProps(path, {
	      scale: [0, 0]
	    }, animationModel, dataIndex, function () {
	      bar.parent && bar.parent.remove(bar);
	    });
	  });
	  data.setItemGraphicEl(dataIndex, null);
	}
	
	function getShapeStr(data, symbolMeta) {
	  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	}
	
	function eachPath(bar, cb, context) {
	  // Do not use Group#eachChild, because it do not support remove.
	  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
	    el !== bar.__pictorialBarRect && cb.call(context, el);
	  });
	}
	
	function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	  if (symbolMeta.symbolClip && !isUpdate) {
	    animationAttrs && el.attr(animationAttrs);
	  } else {
	    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	  }
	}
	
	function updateCommon(bar, opt, symbolMeta) {
	  var color = symbolMeta.color;
	  var dataIndex = symbolMeta.dataIndex;
	  var itemModel = symbolMeta.itemModel; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  eachPath(bar, function (path) {
	    // PENDING setColor should be before setStyle!!!
	    path.setColor(color);
	    path.setStyle(zrUtil.defaults({
	      fill: color,
	      opacity: symbolMeta.opacity
	    }, normalStyle));
	    graphic.setHoverStyle(path, hoverStyle);
	    cursorStyle && (path.cursor = cursorStyle);
	    path.z2 = symbolMeta.z2;
	  });
	  var barRectHoverStyle = {};
	  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	  var barRect = bar.__pictorialBarRect;
	  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
	  graphic.setHoverStyle(barRect, barRectHoverStyle);
	}
	
	function toIntTimes(times) {
	  var roundedTimes = Math.round(times); // Escapse accurate error
	
	  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	}
	
	var _default = BarView;
	module.exports = _default;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(462);
	
	__webpack_require__(479);
	
	__webpack_require__(480);
	
	var themeRiverLayout = __webpack_require__(482);
	
	var themeRiverVisual = __webpack_require__(483);
	
	var dataFilter = __webpack_require__(319);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(themeRiverLayout);
	echarts.registerVisual(themeRiverVisual);
	echarts.registerProcessor(dataFilter('themeRiver'));

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(463);
	
	__webpack_require__(466);
	
	__webpack_require__(468);
	
	__webpack_require__(469);
	
	__webpack_require__(478);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendComponentView({
	  type: 'single'
	});

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Single = __webpack_require__(464);
	
	var CoordinateSystem = __webpack_require__(228);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinate system creator.
	 */
	
	/**
	 * Create single coordinate system and inject it into seriesModel.
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Array.<module:echarts/coord/single/Single>}
	 */
	function create(ecModel, api) {
	  var singles = [];
	  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	    var single = new Single(axisModel, ecModel, api);
	    single.name = 'single_' + idx;
	    single.resize(axisModel, api);
	    axisModel.coordinateSystem = single;
	    singles.push(single);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	      var singleAxisModel = ecModel.queryComponents({
	        mainType: 'singleAxis',
	        index: seriesModel.get('singleAxisIndex'),
	        id: seriesModel.get('singleAxisId')
	      })[0];
	      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	    }
	  });
	  return singles;
	}
	
	CoordinateSystem.register('single', {
	  create: create,
	  dimensions: Single.prototype.dimensions
	});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SingleAxis = __webpack_require__(465);
	
	var axisHelper = __webpack_require__(261);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinates system.
	 */
	
	/**
	 * Create a single coordinates system.
	 *
	 * @param {module:echarts/coord/single/AxisModel} axisModel
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function Single(axisModel, ecModel, api) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.dimension = 'single';
	  /**
	   * Add it just for draw tooltip.
	   *
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = ['single'];
	  /**
	   * @private
	   * @type {module:echarts/coord/single/SingleAxis}.
	   */
	
	  this._axis = null;
	  /**
	   * @private
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	
	  this._init(axisModel, ecModel, api);
	  /**
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	
	
	  this.model = axisModel;
	}
	
	Single.prototype = {
	  type: 'singleAxis',
	  axisPointerEnabled: true,
	  constructor: Single,
	
	  /**
	   * Initialize single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @private
	   */
	  _init: function (axisModel, ecModel, api) {
	    var dim = this.dimension;
	    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	    var isCategory = axis.type === 'category';
	    axis.onBand = isCategory && axisModel.get('boundaryGap');
	    axis.inverse = axisModel.get('inverse');
	    axis.orient = axisModel.get('orient');
	    axisModel.axis = axis;
	    axis.model = axisModel;
	    axis.coordinateSystem = this;
	    this._axis = axis;
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.coordinateSystem === this) {
	        var data = seriesModel.getData();
	        each(data.mapDimension(this.dimension, true), function (dim) {
	          this._axis.scale.unionExtentFromData(data, dim);
	        }, this);
	        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
	      }
	    }, this);
	  },
	
	  /**
	   * Resize the single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  resize: function (axisModel, api) {
	    this._rect = getLayoutRect({
	      left: axisModel.get('left'),
	      top: axisModel.get('top'),
	      right: axisModel.get('right'),
	      bottom: axisModel.get('bottom'),
	      width: axisModel.get('width'),
	      height: axisModel.get('height')
	    }, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._adjustAxis();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _adjustAxis: function () {
	    var rect = this._rect;
	    var axis = this._axis;
	    var isHorizontal = axis.isHorizontal();
	    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	    var idx = axis.reverse ? 1 : 0;
	    axis.setExtent(extent[idx], extent[1 - idx]);
	
	    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	  },
	
	  /**
	   * @param  {module:echarts/coord/single/SingleAxis} axis
	   * @param  {number} coordBase
	   */
	  _updateAxisTransform: function (axis, coordBase) {
	    var axisExtent = axis.getExtent();
	    var extentSum = axisExtent[0] + axisExtent[1];
	    var isHorizontal = axis.isHorizontal();
	    axis.toGlobalCoord = isHorizontal ? function (coord) {
	      return coord + coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	    axis.toLocalCoord = isHorizontal ? function (coord) {
	      return coord - coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	  },
	
	  /**
	   * Get axis.
	   *
	   * @return {module:echarts/coord/single/SingleAxis}
	   */
	  getAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * Get axis, add it just for draw tooltip.
	   *
	   * @return {[type]} [description]
	   */
	  getBaseAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._axis];
	  },
	
	  /**
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function () {
	    return {
	      baseAxes: [this.getAxis()]
	    };
	  },
	
	  /**
	   * If contain point.
	   *
	   * @param  {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var rect = this.getRect();
	    var axis = this.getAxis();
	    var orient = axis.orient;
	
	    if (orient === 'horizontal') {
	      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	    } else {
	      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	    }
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var axis = this.getAxis();
	    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	  },
	
	  /**
	   * Convert the series data to concrete point.
	   *
	   * @param  {number|Array.<number>} val
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (val) {
	    var axis = this.getAxis();
	    var rect = this.getRect();
	    var pt = [];
	    var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	    if (val instanceof Array) {
	      val = val[0];
	    }
	
	    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	    return pt;
	  }
	};
	var _default = Single;
	module.exports = _default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Axis = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor  module:echarts/coord/single/SingleAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   * - 'category'
	   * - 'value'
	   * - 'time'
	   * - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   *  @type {string}
	   */
	
	  this.position = position || 'bottom';
	  /**
	   * Axis orient
	   *  - 'horizontal'
	   *  - 'vertical'
	   * @type {[type]}
	   */
	
	  this.orient = null;
	};
	
	SingleAxis.prototype = {
	  constructor: SingleAxis,
	
	  /**
	   * Axis model
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	  model: null,
	
	  /**
	   * Judge the orient of the axis.
	   * @return {boolean}
	   */
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordinateSystem.pointToData(point, clamp)[0];
	  },
	
	  /**
	   * Convert the local coord(processed by dataToCoord())
	   * to global coord(concrete pixel coord).
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toGlobalCoord: null,
	
	  /**
	   * Convert the global coord to local coord.
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toLocalCoord: null
	};
	zrUtil.inherits(SingleAxis, Axis);
	var _default = SingleAxis;
	module.exports = _default;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var AxisBuilder = __webpack_require__(300);
	
	var graphic = __webpack_require__(180);
	
	var singleAxisHelper = __webpack_require__(467);
	
	var AxisView = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttr = 'splitLine';
	var SingleAxisView = AxisView.extend({
	  type: 'singleAxis',
	  axisPointerClass: 'SingleAxisPointer',
	  render: function (axisModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	    var layout = singleAxisHelper.layout(axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    group.add(axisBuilder.getGroup());
	
	    if (axisModel.get(selfBuilderAttr + '.show')) {
	      this['_' + selfBuilderAttr](axisModel);
	    }
	
	    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  _splitLine: function (axisModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineWidth = lineStyleModel.get('width');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var gridRect = axisModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var splitLines = [];
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	
	    for (var i = 0; i < ticksCoords.length; ++i) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line(graphic.subPixelOptimizeLine({
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: {
	          lineWidth: lineWidth
	        },
	        silent: true
	      })));
	    }
	
	    for (var i = 0; i < splitLines.length; ++i) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: {
	          stroke: lineColors[i % lineColors.length],
	          lineDash: lineStyleModel.getLineDash(lineWidth),
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	  }
	});
	var _default = SingleAxisView;
	module.exports = _default;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(axisModel, opt) {
	  opt = opt || {};
	  var single = axisModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var axisPosition = axis.position;
	  var orient = axis.orient;
	  var rect = single.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var positionMap = {
	    horizontal: {
	      top: rectBound[2],
	      bottom: rectBound[3]
	    },
	    vertical: {
	      left: rectBound[0],
	      right: rectBound[1]
	    }
	  };
	  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	  var r = {
	    horizontal: 0,
	    vertical: 1
	  };
	  layout.rotation = Math.PI / 2 * r[orient];
	  var directionMap = {
	    top: -1,
	    bottom: 1,
	    right: 1,
	    left: -1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  }
	
	  var labelRotation = opt.rotate;
	  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
	  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ComponentModel = __webpack_require__(215);
	
	var axisModelCreator = __webpack_require__(296);
	
	var axisModelCommonMixin = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'singleAxis',
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/single/SingleAxis}
	   */
	  axis: null,
	
	  /**
	   * @type {module:echarts/coord/single/Single}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this;
	  }
	});
	var defaultOption = {
	  left: '5%',
	  top: '5%',
	  right: '5%',
	  bottom: '5%',
	  type: 'value',
	  position: 'bottom',
	  orient: 'horizontal',
	  axisLine: {
	    show: true,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    }
	  },
	  // Single coordinate system and single axis is the,
	  // which is used as the parent tooltip model.
	  // same model, so we set default tooltip show as true.
	  tooltip: {
	    show: true
	  },
	  axisTick: {
	    show: true,
	    length: 6,
	    lineStyle: {
	      width: 2
	    }
	  },
	  axisLabel: {
	    show: true,
	    interval: 'auto'
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      type: 'dashed',
	      opacity: 0.2
	    }
	  }
	};
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	axisModelCreator('single', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var axisPointerModelHelper = __webpack_require__(302);
	
	var axisTrigger = __webpack_require__(470);
	
	__webpack_require__(472);
	
	__webpack_require__(473);
	
	__webpack_require__(475);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// CartesianAxisPointer is not supposed to be required here. But consider
	// echarts.simple.js and online build tooltip, which only require gridSimple,
	// CartesianAxisPointer should be able to required somewhere.
	echarts.registerPreprocessor(function (option) {
	  // Always has a global axisPointerModel for default setting.
	  if (option) {
	    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	    // is not set, remain null/undefined, otherwise it will
	    // override existent link setting.
	
	    if (link && !zrUtil.isArray(link)) {
	      option.axisPointer.link = [link];
	    }
	  }
	}); // This process should proformed after coordinate systems created
	// and series data processed. So put it on statistic processing stage.
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	  // allAxesInfo should be updated when setOption performed.
	  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
	}); // Broadcast to all views.
	
	echarts.registerAction({
	  type: 'updateAxisPointer',
	  event: 'updateAxisPointer',
	  update: ':updateAxisPointer'
	}, axisTrigger);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	var modelHelper = __webpack_require__(302);
	
	var findPointFromSeries = __webpack_require__(471);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry;
	var inner = makeInner();
	/**
	 * Basic logic: check all axis, if they do not demand show/highlight,
	 * then hide/downplay them.
	 *
	 * @param {Object} coordSysAxesInfo
	 * @param {Object} payload
	 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
	 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
	 * @param {Object} [payload.dataIndex] finder, restrict target axes.
	 * @param {Object} [payload.axesInfo] finder, restrict target axes.
	 *        [{
	 *          axisDim: 'x'|'y'|'angle'|...,
	 *          axisIndex: ...,
	 *          value: ...
	 *        }, ...]
	 * @param {Function} [payload.dispatchAction]
	 * @param {Object} [payload.tooltipOption]
	 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
	 *        which can be specified in dispatchAction
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Object} content of event obj for echarts.connect.
	 */
	
	function _default(payload, ecModel, api) {
	  var currTrigger = payload.currTrigger;
	  var point = [payload.x, payload.y];
	  var finder = payload;
	  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	  // See #6121. But we are not able to reproduce it yet.
	
	  if (!coordSysAxesInfo) {
	    return;
	  }
	
	  if (illegalPoint(point)) {
	    // Used in the default behavior of `connection`: use the sample seriesIndex
	    // and dataIndex. And also used in the tooltipView trigger.
	    point = findPointFromSeries({
	      seriesIndex: finder.seriesIndex,
	      // Do not use dataIndexInside from other ec instance.
	      // FIXME: auto detect it?
	      dataIndex: finder.dataIndex
	    }, ecModel).point;
	  }
	
	  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	  // and dataIndex.
	
	  var inputAxesInfo = finder.axesInfo;
	  var axesInfo = coordSysAxesInfo.axesInfo;
	  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	  var outputFinder = {};
	  var showValueMap = {};
	  var dataByCoordSys = {
	    list: [],
	    map: {}
	  };
	  var updaters = {
	    showPointer: curry(showPointer, showValueMap),
	    showTooltip: curry(showTooltip, dataByCoordSys)
	  }; // Process for triggered axes.
	
	  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	    // If a point given, it must be contained by the coordinate system.
	    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	      var axis = axisInfo.axis;
	      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	        var val = inputAxisInfo && inputAxisInfo.value;
	
	        if (val == null && !isIllegalPoint) {
	          val = axis.pointToData(point);
	        }
	
	        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
	      }
	    });
	  }); // Process for linked axes.
	
	  var linkTriggers = {};
	  each(axesInfo, function (tarAxisInfo, tarKey) {
	    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	    if (linkGroup && !showValueMap[tarKey]) {
	      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	          var val = srcValItem.value;
	          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	          linkTriggers[tarAxisInfo.key] = val;
	        }
	      });
	    }
	  });
	  each(linkTriggers, function (val, tarKey) {
	    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
	  });
	  updateModelActually(showValueMap, axesInfo, outputFinder);
	  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	  dispatchHighDownActually(axesInfo, dispatchAction, api);
	  return outputFinder;
	}
	
	function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
	  var axis = axisInfo.axis;
	
	  if (axis.scale.isBlank() || !axis.containData(newValue)) {
	    return;
	  }
	
	  if (!axisInfo.involveSeries) {
	    updaters.showPointer(axisInfo, newValue);
	    return;
	  } // Heavy calculation. So put it after axis.containData checking.
	
	
	  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	  var payloadBatch = payloadInfo.payloadBatch;
	  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	  // By defualt use the first involved series data as a sample to connect.
	
	  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	    zrUtil.extend(outputFinder, payloadBatch[0]);
	  } // If no linkSource input, this process is for collecting link
	  // target, where snap should not be accepted.
	
	
	  if (!dontSnap && axisInfo.snap) {
	    if (axis.containData(snapToValue) && snapToValue != null) {
	      newValue = snapToValue;
	    }
	  }
	
	  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
	  // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	}
	
	function buildPayloadsBySeries(value, axisInfo) {
	  var axis = axisInfo.axis;
	  var dim = axis.dim;
	  var snapToValue = value;
	  var payloadBatch = [];
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	  each(axisInfo.seriesModels, function (series, idx) {
	    var dataDim = series.getData().mapDimension(dim, true);
	    var seriesNestestValue;
	    var dataIndices;
	
	    if (series.getAxisTooltipData) {
	      var result = series.getAxisTooltipData(dataDim, value, axis);
	      dataIndices = result.dataIndices;
	      seriesNestestValue = result.nestestValue;
	    } else {
	      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	      // when data length is not same.
	      // false,
	      axis.type === 'category' ? 0.5 : null);
	
	      if (!dataIndices.length) {
	        return;
	      }
	
	      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	    }
	
	    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	      return;
	    }
	
	    var diff = value - seriesNestestValue;
	    var dist = Math.abs(diff); // Consider category case
	
	    if (dist <= minDist) {
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        snapToValue = seriesNestestValue;
	        payloadBatch.length = 0;
	      }
	
	      each(dataIndices, function (dataIndex) {
	        payloadBatch.push({
	          seriesIndex: series.seriesIndex,
	          dataIndexInside: dataIndex,
	          dataIndex: series.getData().getRawIndex(dataIndex)
	        });
	      });
	    }
	  });
	  return {
	    payloadBatch: payloadBatch,
	    snapToValue: snapToValue
	  };
	}
	
	function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	  showValueMap[axisInfo.key] = {
	    value: value,
	    payloadBatch: payloadBatch
	  };
	}
	
	function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	  var payloadBatch = payloadInfo.payloadBatch;
	  var axis = axisInfo.axis;
	  var axisModel = axis.model;
	  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	  // whose length will be used to judge whether dispatch action.
	
	  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	    return;
	  }
	
	  var coordSysModel = axisInfo.coordSys.model;
	  var coordSysKey = modelHelper.makeKey(coordSysModel);
	  var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	  if (!coordSysItem) {
	    coordSysItem = dataByCoordSys.map[coordSysKey] = {
	      coordSysId: coordSysModel.id,
	      coordSysIndex: coordSysModel.componentIndex,
	      coordSysType: coordSysModel.type,
	      coordSysMainType: coordSysModel.mainType,
	      dataByAxis: []
	    };
	    dataByCoordSys.list.push(coordSysItem);
	  }
	
	  coordSysItem.dataByAxis.push({
	    axisDim: axis.dim,
	    axisIndex: axisModel.componentIndex,
	    axisType: axisModel.type,
	    axisId: axisModel.id,
	    value: value,
	    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	    // depends that all models have been updated. So it should not be performed
	    // here. Considering axisPointerModel used here is volatile, which is hard
	    // to be retrieve in TooltipView, we prepare parameters here.
	    valueLabelOpt: {
	      precision: axisPointerModel.get('label.precision'),
	      formatter: axisPointerModel.get('label.formatter')
	    },
	    seriesDataIndices: payloadBatch.slice()
	  });
	}
	
	function updateModelActually(showValueMap, axesInfo, outputFinder) {
	  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    var valItem = showValueMap[key];
	
	    if (valItem) {
	      !axisInfo.useHandle && (option.status = 'show');
	      option.value = valItem.value; // For label formatter param and highlight.
	
	      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	    } // When always show (e.g., handle used), remain
	    // original value and status.
	    else {
	        // If hide, value still need to be set, consider
	        // click legend to toggle axis blank.
	        !axisInfo.useHandle && (option.status = 'hide');
	      } // If status is 'hide', should be no info in payload.
	
	
	    option.status === 'show' && outputAxesInfo.push({
	      axisDim: axisInfo.axis.dim,
	      axisIndex: axisInfo.axis.model.componentIndex,
	      value: option.value
	    });
	  });
	}
	
	function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	  // Basic logic: If no showTip required, hideTip will be dispatched.
	  if (illegalPoint(point) || !dataByCoordSys.list.length) {
	    dispatchAction({
	      type: 'hideTip'
	    });
	    return;
	  } // In most case only one axis (or event one series is used). It is
	  // convinient to fetch payload.seriesIndex and payload.dataIndex
	  // dirtectly. So put the first seriesIndex and dataIndex of the first
	  // axis on the payload.
	
	
	  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	  dispatchAction({
	    type: 'showTip',
	    escapeConnect: true,
	    x: point[0],
	    y: point[1],
	    tooltipOption: payload.tooltipOption,
	    position: payload.position,
	    dataIndexInside: sampleItem.dataIndexInside,
	    dataIndex: sampleItem.dataIndex,
	    seriesIndex: sampleItem.seriesIndex,
	    dataByCoordSys: dataByCoordSys.list
	  });
	}
	
	function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	  // FIXME
	  // highlight status modification shoule be a stage of main process?
	  // (Consider confilct (e.g., legend and axisPointer) and setOption)
	  var zr = api.getZr();
	  var highDownKey = 'axisPointerLastHighlights';
	  var lastHighlights = inner(zr)[highDownKey] || {};
	  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	  // Build hash map and remove duplicate incidentally.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
	      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	      newHighlights[key] = batchItem;
	    });
	  }); // Diff.
	
	  var toHighlight = [];
	  var toDownplay = [];
	  zrUtil.each(lastHighlights, function (batchItem, key) {
	    !newHighlights[key] && toDownplay.push(batchItem);
	  });
	  zrUtil.each(newHighlights, function (batchItem, key) {
	    !lastHighlights[key] && toHighlight.push(batchItem);
	  });
	  toDownplay.length && api.dispatchAction({
	    type: 'downplay',
	    escapeConnect: true,
	    batch: toDownplay
	  });
	  toHighlight.length && api.dispatchAction({
	    type: 'highlight',
	    escapeConnect: true,
	    batch: toHighlight
	  });
	}
	
	function findInputAxisInfo(inputAxesInfo, axisInfo) {
	  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	    var inputAxisInfo = inputAxesInfo[i];
	
	    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	      return inputAxisInfo;
	    }
	  }
	}
	
	function makeMapperParam(axisInfo) {
	  var axisModel = axisInfo.axis.model;
	  var item = {};
	  var dim = item.axisDim = axisInfo.axis.dim;
	  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	  item.axisName = item[dim + 'AxisName'] = axisModel.name;
	  item.axisId = item[dim + 'AxisId'] = axisModel.id;
	  return item;
	}
	
	function illegalPoint(point) {
	  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	}
	
	module.exports = _default;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} {point: [x, y], el: ...} point Will not be null.
	 */
	function _default(finder, ecModel) {
	  var point = [];
	  var seriesIndex = finder.seriesIndex;
	  var seriesModel;
	
	  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	    return {
	      point: []
	    };
	  }
	
	  var data = seriesModel.getData();
	  var dataIndex = modelUtil.queryDataIndex(data, finder);
	
	  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
	    return {
	      point: []
	    };
	  }
	
	  var el = data.getItemGraphicEl(dataIndex);
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (seriesModel.getTooltipPosition) {
	    point = seriesModel.getTooltipPosition(dataIndex) || [];
	  } else if (coordSys && coordSys.dataToPoint) {
	    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	      return data.mapDimension(dim);
	    }), dataIndex, true)) || [];
	  } else if (el) {
	    // Use graphic bounding rect
	    var rect = el.getBoundingRect().clone();
	    rect.applyTransform(el.transform);
	    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	
	  return {
	    point: point,
	    el: el
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerModel = echarts.extendComponentModel({
	  type: 'axisPointer',
	  coordSysAxesInfo: null,
	  defaultOption: {
	    // 'auto' means that show when triggered by tooltip or handle.
	    show: 'auto',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: null,
	    // set default in AxisPonterView.js
	    zlevel: 0,
	    z: 50,
	    type: 'line',
	    // 'line' 'shadow' 'cross' 'none'.
	    // axispointer triggered by tootip determine snap automatically,
	    // see `modelHelper`.
	    snap: false,
	    triggerTooltip: true,
	    value: null,
	    status: null,
	    // Init value depends on whether handle is used.
	    // [group0, group1, ...]
	    // Each group can be: {
	    //      mapper: function () {},
	    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
	    //      xAxisId: ...,
	    //      yAxisName: ...,
	    //      angleAxisIndex: ...
	    // }
	    // mapper: can be ignored.
	    //      input: {axisInfo, value}
	    //      output: {axisInfo, value}
	    link: [],
	    // Do not set 'auto' here, otherwise global animation: false
	    // will not effect at this axispointer.
	    animation: null,
	    animationDurationUpdate: 200,
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      type: 'solid'
	    },
	    shadowStyle: {
	      color: 'rgba(150,150,150,0.3)'
	    },
	    label: {
	      show: true,
	      formatter: null,
	      // string | Function
	      precision: 'auto',
	      // Or a number like 0, 1, 2 ...
	      margin: 3,
	      color: '#fff',
	      padding: [5, 7, 5, 7],
	      backgroundColor: 'auto',
	      // default: axis line color
	      borderColor: null,
	      borderWidth: 0,
	      shadowBlur: 3,
	      shadowColor: '#aaa' // Considering applicability, common style should
	      // better not have shadowOffset.
	      // shadowOffsetX: 0,
	      // shadowOffsetY: 2
	
	    },
	    handle: {
	      show: false,
	
	      /* eslint-disable */
	      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	      // jshint ignore:line
	
	      /* eslint-enable */
	      size: 45,
	      // handle margin is from symbol center to axis, which is stable when circular move.
	      margin: 50,
	      // color: '#1b8bbd'
	      // color: '#2f4554'
	      color: '#333',
	      shadowBlur: 3,
	      shadowColor: '#aaa',
	      shadowOffsetX: 0,
	      shadowOffsetY: 2,
	      // For mobile performance
	      throttle: 40
	    }
	  }
	});
	var _default = AxisPointerModel;
	module.exports = _default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var globalListener = __webpack_require__(474);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerView = echarts.extendComponentView({
	  type: 'axisPointer',
	  render: function (globalAxisPointerModel, ecModel, api) {
	    var globalTooltipModel = ecModel.getComponent('tooltip');
	    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	    // AxisPointerView to be independent to Tooltip.
	
	    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	        dispatchAction({
	          type: 'updateAxisPointer',
	          currTrigger: currTrigger,
	          x: e && e.offsetX,
	          y: e && e.offsetY
	        });
	      }
	    });
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    globalListener.unregister(api.getZr(), 'axisPointer');
	    AxisPointerView.superApply(this._model, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    globalListener.unregister('axisPointer', api);
	    AxisPointerView.superApply(this._model, 'dispose', arguments);
	  }
	});
	var _default = AxisPointerView;
	module.exports = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var each = zrUtil.each;
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Function} handler
	 *      param: {string} currTrigger
	 *      param: {Array.<number>} point
	 */
	
	function register(key, api, handler) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  inner(zr).records || (inner(zr).records = {});
	  initGlobalListeners(zr, api);
	  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
	  record.handler = handler;
	}
	
	function initGlobalListeners(zr, api) {
	  if (inner(zr).initialized) {
	    return;
	  }
	
	  inner(zr).initialized = true;
	  useHandler('click', zrUtil.curry(doEnter, 'click'));
	  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	  useHandler('globalout', onLeave);
	
	  function useHandler(eventType, cb) {
	    zr.on(eventType, function (e) {
	      var dis = makeDispatchAction(api);
	      each(inner(zr).records, function (record) {
	        record && cb(record, e, dis.dispatchAction);
	      });
	      dispatchTooltipFinally(dis.pendings, api);
	    });
	  }
	}
	
	function dispatchTooltipFinally(pendings, api) {
	  var showLen = pendings.showTip.length;
	  var hideLen = pendings.hideTip.length;
	  var actuallyPayload;
	
	  if (showLen) {
	    actuallyPayload = pendings.showTip[showLen - 1];
	  } else if (hideLen) {
	    actuallyPayload = pendings.hideTip[hideLen - 1];
	  }
	
	  if (actuallyPayload) {
	    actuallyPayload.dispatchAction = null;
	    api.dispatchAction(actuallyPayload);
	  }
	}
	
	function onLeave(record, e, dispatchAction) {
	  record.handler('leave', null, dispatchAction);
	}
	
	function doEnter(currTrigger, record, e, dispatchAction) {
	  record.handler(currTrigger, e, dispatchAction);
	}
	
	function makeDispatchAction(api) {
	  var pendings = {
	    showTip: [],
	    hideTip: []
	  }; // FIXME
	  // better approach?
	  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	  // So we have to add "final stage" to merge those dispatched actions.
	
	  var dispatchAction = function (payload) {
	    var pendingList = pendings[payload.type];
	
	    if (pendingList) {
	      pendingList.push(payload);
	    } else {
	      payload.dispatchAction = dispatchAction;
	      api.dispatchAction(payload);
	    }
	  };
	
	  return {
	    dispatchAction: dispatchAction,
	    pendings: pendings
	  };
	}
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function unregister(key, api) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  var record = (inner(zr).records || {})[key];
	
	  if (record) {
	    inner(zr).records[key] = null;
	  }
	}
	
	exports.register = register;
	exports.unregister = unregister;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var BaseAxisPointer = __webpack_require__(476);
	
	var viewHelper = __webpack_require__(477);
	
	var cartesianAxisHelper = __webpack_require__(303);
	
	var AxisView = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CartesianAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisPointerType = axisPointerModel.get('type');
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisExtent = axis.getGlobalExtent(true);
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var dimIndex = axis.dim === 'x' ? 0 : 1;
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	    var tooltipOptions = [{
	      verticalAlign: 'middle'
	    }, {
	      align: 'center'
	    }];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: tooltipOptions[dimIndex]
	    };
	  }
	});
	
	function getCartesian(grid, axis) {
	  var opt = {};
	  opt[axis.dim + 'AxisIndex'] = axis.index;
	  return grid.getCartesian(opt);
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent, elStyle) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	    graphic.subPixelOptimizeLine({
	      shape: targetShape,
	      style: elStyle
	    });
	    return {
	      type: 'Line',
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent, elStyle) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	    };
	  }
	};
	
	function getAxisDimIndex(axis) {
	  return axis.dim === 'x' ? 0 : 1;
	}
	
	AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	var _default = CartesianAxisPointer;
	module.exports = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var clazzUtil = __webpack_require__(175);
	
	var graphic = __webpack_require__(180);
	
	var axisPointerModelHelper = __webpack_require__(302);
	
	var eventTool = __webpack_require__(139);
	
	var throttleUtil = __webpack_require__(240);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var clone = zrUtil.clone;
	var bind = zrUtil.bind;
	/**
	 * Base axis pointer class in 2D.
	 * Implemenents {module:echarts/component/axis/IAxisPointer}.
	 */
	
	function BaseAxisPointer() {}
	
	BaseAxisPointer.prototype = {
	  /**
	   * @private
	   */
	  _group: null,
	
	  /**
	   * @private
	   */
	  _lastGraphicKey: null,
	
	  /**
	   * @private
	   */
	  _handle: null,
	
	  /**
	   * @private
	   */
	  _dragging: false,
	
	  /**
	   * @private
	   */
	  _lastValue: null,
	
	  /**
	   * @private
	   */
	  _lastStatus: null,
	
	  /**
	   * @private
	   */
	  _payloadInfo: null,
	
	  /**
	   * In px, arbitrary value. Do not set too small,
	   * no animation is ok for most cases.
	   * @protected
	   */
	  animationThreshold: 15,
	
	  /**
	   * @implement
	   */
	  render: function (axisModel, axisPointerModel, api, forceRender) {
	    var value = axisPointerModel.get('value');
	    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	    // be replaced when user calling setOption in not merge mode.
	
	    this._axisModel = axisModel;
	    this._axisPointerModel = axisPointerModel;
	    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
	    // So it is power consuming if performing `render` each time,
	    // especially on mobile device.
	
	    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	      return;
	    }
	
	    this._lastValue = value;
	    this._lastStatus = status;
	    var group = this._group;
	    var handle = this._handle;
	
	    if (!status || status === 'hide') {
	      // Do not clear here, for animation better.
	      group && group.hide();
	      handle && handle.hide();
	      return;
	    }
	
	    group && group.show();
	    handle && handle.show(); // Otherwise status is 'show'
	
	    var elOption = {};
	    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	    var graphicKey = elOption.graphicKey;
	
	    if (graphicKey !== this._lastGraphicKey) {
	      this.clear(api);
	    }
	
	    this._lastGraphicKey = graphicKey;
	    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	    if (!group) {
	      group = this._group = new graphic.Group();
	      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	      api.getZr().add(group);
	    } else {
	      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
	      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
	      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	    }
	
	    updateMandatoryProps(group, axisPointerModel, true);
	
	    this._renderHandle(value);
	  },
	
	  /**
	   * @implement
	   */
	  remove: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @implement
	   */
	  dispose: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @protected
	   */
	  determineAnimation: function (axisModel, axisPointerModel) {
	    var animation = axisPointerModel.get('animation');
	    var axis = axisModel.axis;
	    var isCategoryAxis = axis.type === 'category';
	    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	    if (!useSnap && !isCategoryAxis) {
	      return false;
	    }
	
	    if (animation === 'auto' || animation == null) {
	      var animationThreshold = this.animationThreshold;
	
	      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	        return true;
	      } // It is important to auto animation when snap used. Consider if there is
	      // a dataZoom, animation will be disabled when too many points exist, while
	      // it will be enabled for better visual effect when little points exist.
	
	
	      if (useSnap) {
	        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
	        var axisExtent = axis.getExtent(); // Approximate band width
	
	        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	      }
	
	      return false;
	    }
	
	    return animation === true;
	  },
	
	  /**
	   * add {pointer, label, graphicKey} to elOption
	   * @protected
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
	  },
	
	  /**
	   * @protected
	   */
	  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
	    var pointerOption = elOption.pointer;
	
	    if (pointerOption) {
	      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
	      group.add(pointerEl);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
	    if (elOption.label) {
	      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
	      group.add(labelEl);
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updatePointerEl: function (group, elOption, updateProps) {
	    var pointerEl = inner(group).pointerEl;
	
	    if (pointerEl) {
	      pointerEl.setStyle(elOption.pointer.style);
	      updateProps(pointerEl, {
	        shape: elOption.pointer.shape
	      });
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
	    var labelEl = inner(group).labelEl;
	
	    if (labelEl) {
	      labelEl.setStyle(elOption.label.style);
	      updateProps(labelEl, {
	        // Consider text length change in vertical axis, animation should
	        // be used on shape, otherwise the effect will be weird.
	        shape: elOption.label.shape,
	        position: elOption.label.position
	      });
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderHandle: function (value) {
	    if (this._dragging || !this.updateHandleTransform) {
	      return;
	    }
	
	    var axisPointerModel = this._axisPointerModel;
	
	    var zr = this._api.getZr();
	
	    var handle = this._handle;
	    var handleModel = axisPointerModel.getModel('handle');
	    var status = axisPointerModel.get('status');
	
	    if (!handleModel.get('show') || !status || status === 'hide') {
	      handle && zr.remove(handle);
	      this._handle = null;
	      return;
	    }
	
	    var isInit;
	
	    if (!this._handle) {
	      isInit = true;
	      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
	        cursor: 'move',
	        draggable: true,
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
	        drift: bind(this._onHandleDragMove, this),
	        ondragend: bind(this._onHandleDragEnd, this)
	      });
	      zr.add(handle);
	    }
	
	    updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
	
	    var handleSize = handleModel.get('size');
	
	    if (!zrUtil.isArray(handleSize)) {
	      handleSize = [handleSize, handleSize];
	    }
	
	    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
	    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	    this._moveHandleToValue(value, isInit);
	  },
	
	  /**
	   * @private
	   */
	  _moveHandleToValue: function (value, isInit) {
	    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragMove: function (dx, dy) {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    this._dragging = true; // Persistent for throttle.
	
	    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	    this._payloadInfo = trans;
	    handle.stopAnimation();
	    handle.attr(getHandleTransProps(trans));
	    inner(handle).lastProp = null;
	
	    this._doDispatchAxisPointer();
	  },
	
	  /**
	   * Throttled method.
	   * @private
	   */
	  _doDispatchAxisPointer: function () {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var payloadInfo = this._payloadInfo;
	    var axisModel = this._axisModel;
	
	    this._api.dispatchAction({
	      type: 'updateAxisPointer',
	      x: payloadInfo.cursorPoint[0],
	      y: payloadInfo.cursorPoint[1],
	      tooltipOption: payloadInfo.tooltipOption,
	      axesInfo: [{
	        axisDim: axisModel.axis.dim,
	        axisIndex: axisModel.componentIndex
	      }]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragEnd: function (moveAnimation) {
	    this._dragging = false;
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	    // axisPointer. So move handle to align the exact value position when
	    // drag ended.
	
	
	    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	    // button, and will be hidden after finger left handle button.
	
	
	    this._api.dispatchAction({
	      type: 'hideTip'
	    });
	  },
	
	  /**
	   * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {number} value
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0}
	   */
	  getHandleTransform: null,
	
	  /**
	   * * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {Object} transform {position, rotation}
	   * @param {Array.<number>} delta [dx, dy]
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
	   */
	  updateHandleTransform: null,
	
	  /**
	   * @private
	   */
	  clear: function (api) {
	    this._lastValue = null;
	    this._lastStatus = null;
	    var zr = api.getZr();
	    var group = this._group;
	    var handle = this._handle;
	
	    if (zr && group) {
	      this._lastGraphicKey = null;
	      group && zr.remove(group);
	      handle && zr.remove(handle);
	      this._group = null;
	      this._handle = null;
	      this._payloadInfo = null;
	    }
	  },
	
	  /**
	   * @protected
	   */
	  doClear: function () {// Implemented by sub-class if necessary.
	  },
	
	  /**
	   * @protected
	   * @param {Array.<number>} xy
	   * @param {Array.<number>} wh
	   * @param {number} [xDimIndex=0] or 1
	   */
	  buildLabel: function (xy, wh, xDimIndex) {
	    xDimIndex = xDimIndex || 0;
	    return {
	      x: xy[xDimIndex],
	      y: xy[1 - xDimIndex],
	      width: wh[xDimIndex],
	      height: wh[1 - xDimIndex]
	    };
	  }
	};
	BaseAxisPointer.prototype.constructor = BaseAxisPointer;
	
	function updateProps(animationModel, moveAnimation, el, props) {
	  // Animation optimize.
	  if (!propsEqual(inner(el).lastProp, props)) {
	    inner(el).lastProp = props;
	    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	  }
	}
	
	function propsEqual(lastProps, newProps) {
	  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
	    var equals = true;
	    zrUtil.each(newProps, function (item, key) {
	      equals = equals && propsEqual(lastProps[key], item);
	    });
	    return !!equals;
	  } else {
	    return lastProps === newProps;
	  }
	}
	
	function updateLabelShowHide(labelEl, axisPointerModel) {
	  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
	}
	
	function getHandleTransProps(trans) {
	  return {
	    position: trans.position.slice(),
	    rotation: trans.rotation || 0
	  };
	}
	
	function updateMandatoryProps(group, axisPointerModel, silent) {
	  var z = axisPointerModel.get('z');
	  var zlevel = axisPointerModel.get('zlevel');
	  group && group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	      el.silent = silent;
	    }
	  });
	}
	
	clazzUtil.enableClassExtend(BaseAxisPointer);
	var _default = BaseAxisPointer;
	module.exports = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var textContain = __webpack_require__(167);
	
	var formatUtil = __webpack_require__(219);
	
	var matrix = __webpack_require__(145);
	
	var axisHelper = __webpack_require__(261);
	
	var AxisBuilder = __webpack_require__(300);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Model} axisPointerModel
	 */
	function buildElStyle(axisPointerModel) {
	  var axisPointerType = axisPointerModel.get('type');
	  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	  var style;
	
	  if (axisPointerType === 'line') {
	    style = styleModel.getLineStyle();
	    style.fill = null;
	  } else if (axisPointerType === 'shadow') {
	    style = styleModel.getAreaStyle();
	    style.stroke = null;
	  }
	
	  return style;
	}
	/**
	 * @param {Function} labelPos {align, verticalAlign, position}
	 */
	
	
	function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	  var value = axisPointerModel.get('value');
	  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	    precision: axisPointerModel.get('label.precision'),
	    formatter: axisPointerModel.get('label.formatter')
	  });
	  var labelModel = axisPointerModel.getModel('label');
	  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
	  var font = labelModel.getFont();
	  var textRect = textContain.getBoundingRect(text, font);
	  var position = labelPos.position;
	  var width = textRect.width + paddings[1] + paddings[3];
	  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	  var align = labelPos.align;
	  align === 'right' && (position[0] -= width);
	  align === 'center' && (position[0] -= width / 2);
	  var verticalAlign = labelPos.verticalAlign;
	  verticalAlign === 'bottom' && (position[1] -= height);
	  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	  confineInContainer(position, width, height, api);
	  var bgColor = labelModel.get('backgroundColor');
	
	  if (!bgColor || bgColor === 'auto') {
	    bgColor = axisModel.get('axisLine.lineStyle.color');
	  }
	
	  elOption.label = {
	    shape: {
	      x: 0,
	      y: 0,
	      width: width,
	      height: height,
	      r: labelModel.get('borderRadius')
	    },
	    position: position.slice(),
	    // TODO: rich
	    style: {
	      text: text,
	      textFont: font,
	      textFill: labelModel.getTextColor(),
	      textPosition: 'inside',
	      fill: bgColor,
	      stroke: labelModel.get('borderColor') || 'transparent',
	      lineWidth: labelModel.get('borderWidth') || 0,
	      shadowBlur: labelModel.get('shadowBlur'),
	      shadowColor: labelModel.get('shadowColor'),
	      shadowOffsetX: labelModel.get('shadowOffsetX'),
	      shadowOffsetY: labelModel.get('shadowOffsetY')
	    },
	    // Lable should be over axisPointer.
	    z2: 10
	  };
	} // Do not overflow ec container
	
	
	function confineInContainer(position, width, height, api) {
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  position[0] = Math.min(position[0] + width, viewWidth) - width;
	  position[1] = Math.min(position[1] + height, viewHeight) - height;
	  position[0] = Math.max(position[0], 0);
	  position[1] = Math.max(position[1], 0);
	}
	/**
	 * @param {number} value
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} opt
	 * @param {Array.<Object>} seriesDataIndices
	 * @param {number|string} opt.precision 'auto' or a number
	 * @param {string|Function} opt.formatter label formatter
	 */
	
	
	function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	  value = axis.scale.parse(value);
	  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
	  // helps to debounce when when moving label.
	  value, {
	    precision: opt.precision
	  });
	  var formatter = opt.formatter;
	
	  if (formatter) {
	    var params = {
	      value: axisHelper.getAxisRawValue(axis, value),
	      seriesData: []
	    };
	    zrUtil.each(seriesDataIndices, function (idxItem) {
	      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	      var dataIndex = idxItem.dataIndexInside;
	      var dataParams = series && series.getDataParams(dataIndex);
	      dataParams && params.seriesData.push(dataParams);
	    });
	
	    if (zrUtil.isString(formatter)) {
	      text = formatter.replace('{value}', text);
	    } else if (zrUtil.isFunction(formatter)) {
	      text = formatter(params);
	    }
	  }
	
	  return text;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @param {number} value
	 * @param {Object} layoutInfo {
	 *  rotation, position, labelOffset, labelDirection, labelMargin
	 * }
	 */
	
	
	function getTransformedPosition(axis, value, layoutInfo) {
	  var transform = matrix.create();
	  matrix.rotate(transform, transform, layoutInfo.rotation);
	  matrix.translate(transform, transform, layoutInfo.position);
	  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	}
	
	function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
	  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	    align: textLayout.textAlign,
	    verticalAlign: textLayout.textVerticalAlign
	  });
	}
	/**
	 * @param {Array.<number>} p1
	 * @param {Array.<number>} p2
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeLineShape(p1, p2, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x1: p1[xDimIndex],
	    y1: p1[1 - xDimIndex],
	    x2: p2[xDimIndex],
	    y2: p2[1 - xDimIndex]
	  };
	}
	/**
	 * @param {Array.<number>} xy
	 * @param {Array.<number>} wh
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeRectShape(xy, wh, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x: xy[xDimIndex],
	    y: xy[1 - xDimIndex],
	    width: wh[xDimIndex],
	    height: wh[1 - xDimIndex]
	  };
	}
	
	function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	  return {
	    cx: cx,
	    cy: cy,
	    r0: r0,
	    r: r,
	    startAngle: startAngle,
	    endAngle: endAngle,
	    clockwise: true
	  };
	}
	
	exports.buildElStyle = buildElStyle;
	exports.buildLabelElOption = buildLabelElOption;
	exports.getValueLabel = getValueLabel;
	exports.getTransformedPosition = getTransformedPosition;
	exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
	exports.makeLineShape = makeLineShape;
	exports.makeRectShape = makeRectShape;
	exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(180);
	
	var BaseAxisPointer = __webpack_require__(476);
	
	var viewHelper = __webpack_require__(477);
	
	var singleAxisHelper = __webpack_require__(467);
	
	var AxisView = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var XY = ['x', 'y'];
	var WH = ['width', 'height'];
	var SingleAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	    var pixelValue = coordSys.dataToPoint(value)[0];
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = singleAxisHelper.layout(axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = singleAxisHelper.layout(axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var dimIndex = getPointDimIndex(axis);
	    var axisExtent = getGlobalExtent(coordSys, dimIndex);
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: {
	        verticalAlign: 'middle'
	      }
	    };
	  }
	});
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent, elStyle) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	    graphic.subPixelOptimizeLine({
	      shape: targetShape,
	      style: elStyle
	    });
	    return {
	      type: 'Line',
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent, elStyle) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	    };
	  }
	};
	
	function getPointDimIndex(axis) {
	  return axis.isHorizontal() ? 0 : 1;
	}
	
	function getGlobalExtent(coordSys, dimIndex) {
	  var rect = coordSys.getRect();
	  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	}
	
	AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	var _default = SingleAxisPointer;
	module.exports = _default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(233);
	
	var createDimensions = __webpack_require__(258);
	
	var _dimensionHelper = __webpack_require__(257);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var List = __webpack_require__(255);
	
	var zrUtil = __webpack_require__(134);
	
	var _model = __webpack_require__(173);
	
	var groupData = _model.groupData;
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file  Define the themeRiver view's series model
	 * @author Deqing Li(annong035@gmail.com)
	 */
	var DATA_NAME_INDEX = 2;
	var ThemeRiverSeries = SeriesModel.extend({
	  type: 'series.themeRiver',
	  dependencies: ['singleAxis'],
	
	  /**
	   * @readOnly
	   * @type {module:zrender/core/util#HashMap}
	   */
	  nameMap: null,
	
	  /**
	   * @override
	   */
	  init: function (option) {
	    // eslint-disable-next-line
	    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
	    // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendDataProvider = function () {
	      return this.getRawData();
	    };
	  },
	
	  /**
	   * If there is no value of a certain point in the time for some event,set it value to 0.
	   *
	   * @param {Array} data  initial data in the option
	   * @return {Array}
	   */
	  fixData: function (data) {
	    var rawDataLength = data.length; // grouped data by name
	
	    var groupResult = groupData(data, function (item) {
	      return item[2];
	    });
	    var layData = [];
	    groupResult.buckets.each(function (items, key) {
	      layData.push({
	        name: key,
	        dataList: items
	      });
	    });
	    var layerNum = layData.length;
	    var largestLayer = -1;
	    var index = -1;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var len = layData[i].dataList.length;
	
	      if (len > largestLayer) {
	        largestLayer = len;
	        index = i;
	      }
	    }
	
	    for (var k = 0; k < layerNum; ++k) {
	      if (k === index) {
	        continue;
	      }
	
	      var name = layData[k].name;
	
	      for (var j = 0; j < largestLayer; ++j) {
	        var timeValue = layData[index].dataList[j][0];
	        var length = layData[k].dataList.length;
	        var keyIndex = -1;
	
	        for (var l = 0; l < length; ++l) {
	          var value = layData[k].dataList[l][0];
	
	          if (value === timeValue) {
	            keyIndex = l;
	            break;
	          }
	        }
	
	        if (keyIndex === -1) {
	          data[rawDataLength] = [];
	          data[rawDataLength][0] = timeValue;
	          data[rawDataLength][1] = 0;
	          data[rawDataLength][2] = name;
	          rawDataLength++;
	        }
	      }
	    }
	
	    return data;
	  },
	
	  /**
	   * @override
	   * @param  {Object} option  the initial option that user gived
	   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
	   * @return {module:echarts/data/List}
	   */
	  getInitialData: function (option, ecModel) {
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: this.get('singleAxisIndex'),
	      id: this.get('singleAxisId')
	    })[0];
	    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined
	
	    var filterData = zrUtil.filter(option.data, function (dataItem) {
	      return dataItem[2] !== undefined;
	    }); // ??? TODO design a stage to transfer data for themeRiver and lines?
	
	    var data = this.fixData(filterData || []);
	    var nameList = [];
	    var nameMap = this.nameMap = zrUtil.createHashMap();
	    var count = 0;
	
	    for (var i = 0; i < data.length; ++i) {
	      nameList.push(data[i][DATA_NAME_INDEX]);
	
	      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	        nameMap.set(data[i][DATA_NAME_INDEX], count);
	        count++;
	      }
	    }
	
	    var dimensionsInfo = createDimensions(data, {
	      coordDimensions: ['single'],
	      dimensionsDefine: [{
	        name: 'time',
	        type: getDimensionTypeByAxis(axisType)
	      }, {
	        name: 'value',
	        type: 'float'
	      }, {
	        name: 'name',
	        type: 'ordinal'
	      }],
	      encodeDefine: {
	        single: 0,
	        value: 1,
	        itemName: 2
	      }
	    });
	    var list = new List(dimensionsInfo, this);
	    list.initData(data);
	    return list;
	  },
	
	  /**
	   * The raw data is divided into multiple layers and each layer
	   *     has same name.
	   *
	   * @return {Array.<Array.<number>>}
	   */
	  getLayerSeries: function () {
	    var data = this.getData();
	    var lenCount = data.count();
	    var indexArr = [];
	
	    for (var i = 0; i < lenCount; ++i) {
	      indexArr[i] = i;
	    }
	
	    var timeDim = data.mapDimension('single'); // data group by name
	
	    var groupResult = groupData(indexArr, function (index) {
	      return data.get('name', index);
	    });
	    var layerSeries = [];
	    groupResult.buckets.each(function (items, key) {
	      items.sort(function (index1, index2) {
	        return data.get(timeDim, index1) - data.get(timeDim, index2);
	      });
	      layerSeries.push({
	        name: key,
	        indices: items
	      });
	    });
	    return layerSeries;
	  },
	
	  /**
	   * Get data indices for show tooltip content
	   *
	   * @param {Array.<string>|string} dim  single coordinate dimension
	   * @param {number} value axis value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
	   *     the themeRiver.
	   * @return {Object} {dataIndices, nestestValue}
	   */
	  getAxisTooltipData: function (dim, value, baseAxis) {
	    if (!zrUtil.isArray(dim)) {
	      dim = dim ? [dim] : [];
	    }
	
	    var data = this.getData();
	    var layerSeries = this.getLayerSeries();
	    var indices = [];
	    var layerNum = layerSeries.length;
	    var nestestValue;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var minDist = Number.MAX_VALUE;
	      var nearestIdx = -1;
	      var pointNum = layerSeries[i].indices.length;
	
	      for (var j = 0; j < pointNum; ++j) {
	        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	        var dist = Math.abs(theValue - value);
	
	        if (dist <= minDist) {
	          nestestValue = theValue;
	          minDist = dist;
	          nearestIdx = layerSeries[i].indices[j];
	        }
	      }
	
	      indices.push(nearestIdx);
	    }
	
	    return {
	      dataIndices: indices,
	      nestestValue: nestestValue
	    };
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex  index of data
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var htmlName = data.getName(dataIndex);
	    var htmlValue = data.get(data.mapDimension('value'), dataIndex);
	
	    if (isNaN(htmlValue) || htmlValue == null) {
	      htmlValue = '-';
	    }
	
	    return encodeHTML(htmlName + ' : ' + htmlValue);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'singleAxis',
	    // gap in axis's orthogonal orientation
	    boundaryGap: ['10%', '10%'],
	    // legendHoverLink: true,
	    singleAxisIndex: 0,
	    animationEasing: 'linear',
	    label: {
	      margin: 4,
	      show: true,
	      position: 'left',
	      color: '#000',
	      fontSize: 11
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = ThemeRiverSeries;
	module.exports = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var _poly = __webpack_require__(285);
	
	var Polygon = _poly.Polygon;
	
	var graphic = __webpack_require__(180);
	
	var _util = __webpack_require__(134);
	
	var bind = _util.bind;
	var extend = _util.extend;
	
	var DataDiffer = __webpack_require__(256);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file  The file used to draw themeRiver view
	 * @author  Deqing Li(annong035@gmail.com)
	 */
	var _default = echarts.extendChartView({
	  type: 'themeRiver',
	  init: function () {
	    this._layers = [];
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var layerSeries = seriesModel.getLayerSeries();
	    var layoutInfo = data.getLayout('layoutInfo');
	    var rect = layoutInfo.rect;
	    var boundaryGap = layoutInfo.boundaryGap;
	    group.attr('position', [0, rect.y + boundaryGap[0]]);
	
	    function keyGetter(item) {
	      return item.name;
	    }
	
	    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
	    var newLayersGroups = {};
	    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	    function process(status, idx, oldIdx) {
	      var oldLayersGroups = this._layers;
	
	      if (status === 'remove') {
	        group.remove(oldLayersGroups[idx]);
	        return;
	      }
	
	      var points0 = [];
	      var points1 = [];
	      var color;
	      var indices = layerSeries[idx].indices;
	
	      for (var j = 0; j < indices.length; j++) {
	        var layout = data.getItemLayout(indices[j]);
	        var x = layout.x;
	        var y0 = layout.y0;
	        var y = layout.y;
	        points0.push([x, y0]);
	        points1.push([x, y0 + y]);
	        color = data.getItemVisual(indices[j], 'color');
	      }
	
	      var polygon;
	      var text;
	      var textLayout = data.getItemLayout(indices[0]);
	      var itemModel = data.getItemModel(indices[j - 1]);
	      var labelModel = itemModel.getModel('label');
	      var margin = labelModel.get('margin');
	
	      if (status === 'add') {
	        var layerGroup = newLayersGroups[idx] = new graphic.Group();
	        polygon = new Polygon({
	          shape: {
	            points: points0,
	            stackedOnPoints: points1,
	            smooth: 0.4,
	            stackedOnSmooth: 0.4,
	            smoothConstraint: false
	          },
	          z2: 0
	        });
	        text = new graphic.Text({
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        });
	        layerGroup.add(polygon);
	        layerGroup.add(text);
	        group.add(layerGroup);
	        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
	          polygon.removeClipPath();
	        }));
	      } else {
	        var layerGroup = oldLayersGroups[oldIdx];
	        polygon = layerGroup.childAt(0);
	        text = layerGroup.childAt(1);
	        group.add(layerGroup);
	        newLayersGroups[idx] = layerGroup;
	        graphic.updateProps(polygon, {
	          shape: {
	            points: points0,
	            stackedOnPoints: points1
	          }
	        }, seriesModel);
	        graphic.updateProps(text, {
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        }, seriesModel);
	      }
	
	      var hoverItemStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      graphic.setTextStyle(text.style, labelModel, {
	        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
	        textVerticalAlign: 'middle'
	      });
	      polygon.setStyle(extend({
	        fill: color
	      }, itemStyleModel.getItemStyle(['color'])));
	      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
	    }
	
	    this._layersSeries = layerSeries;
	    this._layers = newLayersGroups;
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(481)))

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var numberUtil = __webpack_require__(218);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file  Using layout algorithm transform the raw data to layout information.
	 * @author Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var single = seriesModel.coordinateSystem;
	    var layoutInfo = {}; // use the axis boundingRect for view
	
	    var rect = single.getRect();
	    layoutInfo.rect = rect;
	    var boundaryGap = seriesModel.get('boundaryGap');
	    var axis = single.getAxis();
	    layoutInfo.boundaryGap = boundaryGap;
	
	    if (axis.orient === 'horizontal') {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
	      var height = rect.height - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, height);
	    } else {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
	      var width = rect.width - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, width);
	    }
	
	    data.setLayout('layoutInfo', layoutInfo);
	  });
	}
	/**
	 * The layout information about themeriver
	 *
	 * @param {module:echarts/data/List} data  data in the series
	 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
	 * @param {number} height  value used to compute every series height
	 */
	
	
	function themeRiverLayout(data, seriesModel, height) {
	  if (!data.count()) {
	    return;
	  }
	
	  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	  var timeDim = data.mapDimension('single');
	  var valueDim = data.mapDimension('value');
	  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
	    return zrUtil.map(singleLayer.indices, function (idx) {
	      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
	      pt[1] = data.get(valueDim, idx);
	      return pt;
	    });
	  });
	  var base = computeBaseline(layerPoints);
	  var baseLine = base.y0;
	  var ky = height / base.max; // set layout information for each item.
	
	  var n = layerSeries.length;
	  var m = layerSeries[0].indices.length;
	  var baseY0;
	
	  for (var j = 0; j < m; ++j) {
	    baseY0 = baseLine[j] * ky;
	    data.setItemLayout(layerSeries[0].indices[j], {
	      layerIndex: 0,
	      x: layerPoints[0][j][0],
	      y0: baseY0,
	      y: layerPoints[0][j][1] * ky
	    });
	
	    for (var i = 1; i < n; ++i) {
	      baseY0 += layerPoints[i - 1][j][1] * ky;
	      data.setItemLayout(layerSeries[i].indices[j], {
	        layerIndex: i,
	        x: layerPoints[i][j][0],
	        y0: baseY0,
	        y: layerPoints[i][j][1] * ky
	      });
	    }
	  }
	}
	/**
	 * Compute the baseLine of the rawdata
	 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	 *
	 * @param  {Array.<Array>} data  the points in each layer
	 * @return {Object}
	 */
	
	
	function computeBaseline(data) {
	  var layerNum = data.length;
	  var pointNum = data[0].length;
	  var sums = [];
	  var y0 = [];
	  var max = 0;
	  var temp;
	  var base = {};
	
	  for (var i = 0; i < pointNum; ++i) {
	    for (var j = 0, temp = 0; j < layerNum; ++j) {
	      temp += data[j][i][1];
	    }
	
	    if (temp > max) {
	      max = temp;
	    }
	
	    sums.push(temp);
	  }
	
	  for (var k = 0; k < pointNum; ++k) {
	    y0[k] = (max - sums[k]) / 2;
	  }
	
	  max = 0;
	
	  for (var l = 0; l < pointNum; ++l) {
	    var sum = sums[l] + y0[l];
	
	    if (sum > max) {
	      max = sum;
	    }
	  }
	
	  base.y0 = y0;
	  base.max = max;
	  return base;
	}
	
	module.exports = _default;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual encoding for themeRiver view
	 * @author Deqing Li(annong035@gmail.com)
	 */
	function _default(ecModel) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var rawData = seriesModel.getRawData();
	    var colorList = seriesModel.get('color');
	    var idxMap = createHashMap();
	    data.each(function (idx) {
	      idxMap.set(data.getRawIndex(idx), idx);
	    });
	    rawData.each(function (rawIndex) {
	      var name = rawData.getName(rawIndex);
	      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
	      rawData.setItemVisual(rawIndex, 'color', color);
	      var idx = idxMap.get(rawIndex);
	
	      if (idx != null) {
	        data.setItemVisual(idx, 'color', color);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	__webpack_require__(485);
	
	__webpack_require__(486);
	
	__webpack_require__(488);
	
	var dataColor = __webpack_require__(316);
	
	var sunburstLayout = __webpack_require__(489);
	
	var dataFilter = __webpack_require__(319);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(zrUtil.curry(dataColor, 'sunburst'));
	echarts.registerLayout(zrUtil.curry(sunburstLayout, 'sunburst'));
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'sunburst'));

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var SeriesModel = __webpack_require__(233);
	
	var Tree = __webpack_require__(360);
	
	var _treeHelper = __webpack_require__(369);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.sunburst',
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || []; // levels = option.levels = setDefault(levels, ecModel);
	
	    var treeOption = {};
	    treeOption.levels = levels; // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    return Tree.createTree(root, this, treeOption).data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /*
	   * @override
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // Policy of highlighting pieces when hover on one
	    // Valid values: 'none' (for not downplay others), 'descendant',
	    // 'ancestor', 'self'
	    highlightPolicy: 'descendant',
	    // 'rootToNode', 'link', or false
	    nodeClick: 'rootToNode',
	    renderLabelForZeroData: false,
	    label: {
	      // could be: 'radial', 'tangential', or 'none'
	      rotate: 'radial',
	      show: true,
	      opacity: 1,
	      // 'left' is for inner side of inside, and 'right' is for outter
	      // side for inside
	      align: 'center',
	      position: 'inside',
	      distance: 5,
	      silent: true,
	      emphasis: {}
	    },
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: 'white',
	      borderType: 'solid',
	      shadowBlur: 0,
	      shadowColor: 'rgba(0, 0, 0, 0.2)',
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1,
	      emphasis: {},
	      highlight: {
	        opacity: 1
	      },
	      downplay: {
	        opacity: 0.9
	      }
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationDuration: 1000,
	    animationDurationUpdate: 500,
	    animationEasing: 'cubicOut',
	    data: [],
	    levels: [],
	
	    /**
	     * Sort order.
	     *
	     * Valid values: 'desc', 'asc', null, or callback function.
	     * 'desc' and 'asc' for descend and ascendant order;
	     * null for not sorting;
	     * example of callback function:
	     * function(nodeA, nodeB) {
	     *     return nodeA.getValue() - nodeB.getValue();
	     * }
	     */
	    sort: 'desc'
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	
	module.exports = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ChartView = __webpack_require__(238);
	
	var SunburstPiece = __webpack_require__(487);
	
	var DataDiffer = __webpack_require__(256);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	var SunburstView = ChartView.extend({
	  type: 'sunburst',
	  init: function () {},
	  render: function (seriesModel, ecModel, api, payload) {
	    var that = this;
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var data = seriesModel.getData();
	    var virtualRoot = data.tree.root;
	    var newRoot = seriesModel.getViewRoot();
	    var group = this.group;
	    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
	    var newChildren = [];
	    newRoot.eachNode(function (node) {
	      newChildren.push(node);
	    });
	    var oldChildren = this._oldChildren || [];
	    dualTravel(newChildren, oldChildren);
	    renderRollUp(virtualRoot, newRoot);
	
	    if (payload && payload.highlight && payload.highlight.piece) {
	      var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	      payload.highlight.piece.onEmphasis(highlightPolicy);
	    } else if (payload && payload.unhighlight) {
	      var piece = this.virtualPiece;
	
	      if (!piece && virtualRoot.children.length) {
	        piece = virtualRoot.children[0].piece;
	      }
	
	      if (piece) {
	        piece.onNormal();
	      }
	    }
	
	    this._initEvents();
	
	    this._oldChildren = newChildren;
	
	    function dualTravel(newChildren, oldChildren) {
	      if (newChildren.length === 0 && oldChildren.length === 0) {
	        return;
	      }
	
	      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	
	      function getKey(node) {
	        return node.getId();
	      }
	
	      function processNode(newId, oldId) {
	        var newNode = newId == null ? null : newChildren[newId];
	        var oldNode = oldId == null ? null : oldChildren[oldId];
	        doRenderNode(newNode, oldNode);
	      }
	    }
	
	    function doRenderNode(newNode, oldNode) {
	      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
	        // Not render data with value 0
	        newNode = null;
	      }
	
	      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
	        if (oldNode && oldNode.piece) {
	          if (newNode) {
	            // Update
	            oldNode.piece.updateData(false, newNode, 'normal', seriesModel, ecModel); // For tooltip
	
	            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
	          } else {
	            // Remove
	            removeNode(oldNode);
	          }
	        } else if (newNode) {
	          // Add
	          var piece = new SunburstPiece(newNode, seriesModel, ecModel);
	          group.add(piece); // For tooltip
	
	          data.setItemGraphicEl(newNode.dataIndex, piece);
	        }
	      }
	    }
	
	    function removeNode(node) {
	      if (!node) {
	        return;
	      }
	
	      if (node.piece) {
	        group.remove(node.piece);
	        node.piece = null;
	      }
	    }
	
	    function renderRollUp(virtualRoot, viewRoot) {
	      if (viewRoot.depth > 0) {
	        // Render
	        if (that.virtualPiece) {
	          // Update
	          that.virtualPiece.updateData(false, virtualRoot, 'normal', seriesModel, ecModel);
	        } else {
	          // Add
	          that.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel);
	          group.add(that.virtualPiece);
	        }
	
	        if (viewRoot.piece._onclickEvent) {
	          viewRoot.piece.off('click', viewRoot.piece._onclickEvent);
	        }
	
	        var event = function (e) {
	          that._rootToNode(viewRoot.parentNode);
	        };
	
	        viewRoot.piece._onclickEvent = event;
	        that.virtualPiece.on('click', event);
	      } else if (that.virtualPiece) {
	        // Remove
	        group.remove(that.virtualPiece);
	        that.virtualPiece = null;
	      }
	    }
	  },
	  dispose: function () {},
	
	  /**
	   * @private
	   */
	  _initEvents: function () {
	    var that = this;
	
	    var event = function (e) {
	      var targetFound = false;
	      var viewRoot = that.seriesModel.getViewRoot();
	      viewRoot.eachNode(function (node) {
	        if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
	          var nodeClick = node.getModel().get('nodeClick');
	
	          if (nodeClick === 'rootToNode') {
	            that._rootToNode(node);
	          } else if (nodeClick === 'link') {
	            var itemModel = node.getModel();
	            var link = itemModel.get('link');
	
	            if (link) {
	              var linkTarget = itemModel.get('target', true) || '_blank';
	              window.open(link, linkTarget);
	            }
	          }
	
	          targetFound = true;
	        }
	      });
	    };
	
	    if (this.group._onclickEvent) {
	      this.group.off('click', this.group._onclickEvent);
	    }
	
	    this.group.on('click', event);
	    this.group._onclickEvent = event;
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (node) {
	    if (node !== this.seriesModel.getViewRoot()) {
	      this.api.dispatchAction({
	        type: ROOT_TO_NODE_ACTION,
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        targetNode: node
	      });
	    }
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var treeRoot = seriesModel.getData();
	    var itemLayout = treeRoot.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = SunburstView;
	module.exports = _default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NodeHighlightPolicy = {
	  NONE: 'none',
	  // not downplay others
	  DESCENDANT: 'descendant',
	  ANCESTOR: 'ancestor',
	  SELF: 'self'
	};
	var DEFAULT_SECTOR_Z = 2;
	var DEFAULT_TEXT_Z = 4;
	/**
	 * Sunburstce of Sunburst including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	function SunburstPiece(node, seriesModel, ecModel) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: DEFAULT_SECTOR_Z
	  });
	  sector.seriesIndex = seriesModel.seriesIndex;
	  var text = new graphic.Text({
	    z2: DEFAULT_TEXT_Z,
	    silent: node.getModel('label').get('silent')
	  });
	  this.add(sector);
	  this.add(text);
	  this.updateData(true, node, 'normal', seriesModel, ecModel); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var SunburstPieceProto = SunburstPiece.prototype;
	
	SunburstPieceProto.updateData = function (firstCreate, node, state, seriesModel, ecModel) {
	  this.node = node;
	  node.piece = this;
	  seriesModel = seriesModel || this._seriesModel;
	  ecModel = ecModel || this._ecModel;
	  var sector = this.childAt(0);
	  sector.dataIndex = node.dataIndex;
	  var itemModel = node.getModel();
	  var layout = node.getLayout(); // if (!layout) {
	  //     console.log(node.getLayout());
	  // }
	
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var visualColor = getNodeColor(node, seriesModel, ecModel);
	  fillDefaultColor(node, seriesModel, visualColor);
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle();
	  var style;
	
	  if (state === 'normal') {
	    style = normalStyle;
	  } else {
	    var stateStyle = itemModel.getModel(state + '.itemStyle').getItemStyle();
	    style = zrUtil.merge(stateStyle, normalStyle);
	  }
	
	  style = zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: style.fill || visualColor
	  }, style);
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    sector.shape.r = layout.r0;
	    graphic.updateProps(sector, {
	      shape: {
	        r: layout.r
	      }
	    }, seriesModel, node.dataIndex);
	    sector.useStyle(style);
	  } else if (typeof style.fill === 'object' && style.fill.type || typeof sector.style.fill === 'object' && sector.style.fill.type) {
	    // Disable animation for gradient since no interpolation method
	    // is supported for gradient
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel);
	    sector.useStyle(style);
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape,
	      style: style
	    }, seriesModel);
	  }
	
	  this._updateLabel(seriesModel, visualColor, state);
	
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle);
	
	  if (firstCreate) {
	    var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	
	    this._initEvents(sector, node, seriesModel, highlightPolicy);
	  }
	
	  this._seriesModel = seriesModel || this._seriesModel;
	  this._ecModel = ecModel || this._ecModel;
	};
	
	SunburstPieceProto.onEmphasis = function (highlightPolicy) {
	  var that = this;
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      if (that.node === n) {
	        n.piece.updateData(false, n, 'emphasis');
	      } else if (isNodeHighlighted(n, that.node, highlightPolicy)) {
	        n.piece.childAt(0).trigger('highlight');
	      } else if (highlightPolicy !== NodeHighlightPolicy.NONE) {
	        n.piece.childAt(0).trigger('downplay');
	      }
	    }
	  });
	};
	
	SunburstPieceProto.onNormal = function () {
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      n.piece.updateData(false, n, 'normal');
	    }
	  });
	};
	
	SunburstPieceProto.onHighlight = function () {
	  this.updateData(false, this.node, 'highlight');
	};
	
	SunburstPieceProto.onDownplay = function () {
	  this.updateData(false, this.node, 'downplay');
	};
	
	SunburstPieceProto._updateLabel = function (seriesModel, visualColor, state) {
	  var itemModel = this.node.getModel();
	  var normalModel = itemModel.getModel('label');
	  var labelModel = state === 'normal' || state === 'emphasis' ? normalModel : itemModel.getModel(state + '.label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var text = zrUtil.retrieve(seriesModel.getFormattedLabel(this.node.dataIndex, 'normal', null, null, 'label'), this.node.name);
	
	  if (getLabelAttr('show') === false) {
	    text = '';
	  }
	
	  var layout = this.node.getLayout();
	  var labelMinAngle = labelModel.get('minAngle');
	
	  if (labelMinAngle == null) {
	    labelMinAngle = normalModel.get('minAngle');
	  }
	
	  labelMinAngle = labelMinAngle / 180 * Math.PI;
	  var angle = layout.endAngle - layout.startAngle;
	
	  if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) {
	    // Not displaying text when angle is too small
	    text = '';
	  }
	
	  var label = this.childAt(1);
	  graphic.setLabelStyle(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
	    defaultText: labelModel.getShallow('show') ? text : null,
	    autoColor: visualColor,
	    useInsideStyle: true
	  });
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var r;
	  var labelPosition = getLabelAttr('position');
	  var labelPadding = getLabelAttr('distance') || 0;
	  var textAlign = getLabelAttr('align');
	
	  if (labelPosition === 'outside') {
	    r = layout.r + labelPadding;
	    textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
	  } else {
	    if (!textAlign || textAlign === 'center') {
	      r = (layout.r + layout.r0) / 2;
	      textAlign = 'center';
	    } else if (textAlign === 'left') {
	      r = layout.r0 + labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'right';
	      }
	    } else if (textAlign === 'right') {
	      r = layout.r - labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'left';
	      }
	    }
	  }
	
	  label.attr('style', {
	    text: text,
	    textAlign: textAlign,
	    textVerticalAlign: getLabelAttr('verticalAlign') || 'middle',
	    opacity: getLabelAttr('opacity')
	  });
	  var textX = r * dx + layout.cx;
	  var textY = r * dy + layout.cy;
	  label.attr('position', [textX, textY]);
	  var rotateType = getLabelAttr('rotate');
	  var rotate = 0;
	
	  if (rotateType === 'radial') {
	    rotate = -midAngle;
	
	    if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (rotateType === 'tangential') {
	    rotate = Math.PI / 2 - midAngle;
	
	    if (rotate > Math.PI / 2) {
	      rotate -= Math.PI;
	    } else if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (typeof rotateType === 'number') {
	    rotate = rotateType * Math.PI / 180;
	  }
	
	  label.attr('rotation', rotate);
	
	  function getLabelAttr(name) {
	    var stateAttr = labelModel.get(name);
	
	    if (stateAttr == null) {
	      return normalModel.get(name);
	    } else {
	      return stateAttr;
	    }
	  }
	};
	
	SunburstPieceProto._initEvents = function (sector, node, seriesModel, highlightPolicy) {
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  var that = this;
	
	  var onEmphasis = function () {
	    that.onEmphasis(highlightPolicy);
	  };
	
	  var onNormal = function () {
	    that.onNormal();
	  };
	
	  var onDownplay = function () {
	    that.onDownplay();
	  };
	
	  var onHighlight = function () {
	    that.onHighlight();
	  };
	
	  if (seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal).on('downplay', onDownplay).on('highlight', onHighlight);
	  }
	};
	
	zrUtil.inherits(SunburstPiece, graphic.Group);
	var _default = SunburstPiece;
	/**
	 * Get node color
	 *
	 * @param {TreeNode} node the node to get color
	 * @param {module:echarts/model/Series} seriesModel series
	 * @param {module:echarts/model/Global} ecModel echarts defaults
	 */
	
	function getNodeColor(node, seriesModel, ecModel) {
	  // Color from visualMap
	  var visualColor = node.getVisual('color');
	  var visualMetaList = node.getVisual('visualMeta');
	
	  if (!visualMetaList || visualMetaList.length === 0) {
	    // Use first-generation color if has no visualMap
	    visualColor = null;
	  } // Self color or level color
	
	
	  var color = node.getModel('itemStyle').get('color');
	
	  if (color) {
	    return color;
	  } else if (visualColor) {
	    // Color mapping
	    return visualColor;
	  } else if (node.depth === 0) {
	    // Virtual root node
	    return ecModel.option.color[0];
	  } else {
	    // First-generation color
	    var length = ecModel.option.color.length;
	    color = ecModel.option.color[getRootId(node) % length];
	  }
	
	  return color;
	}
	/**
	 * Get index of root in sorted order
	 *
	 * @param {TreeNode} node current node
	 * @return {number} index in root
	 */
	
	
	function getRootId(node) {
	  var ancestor = node;
	
	  while (ancestor.depth > 1) {
	    ancestor = ancestor.parentNode;
	  }
	
	  var virtualRoot = node.getAncestors()[0];
	  return zrUtil.indexOf(virtualRoot.children, ancestor);
	}
	
	function isNodeHighlighted(node, activeNode, policy) {
	  if (policy === NodeHighlightPolicy.NONE) {
	    return false;
	  } else if (policy === NodeHighlightPolicy.SELF) {
	    return node === activeNode;
	  } else if (policy === NodeHighlightPolicy.ANCESTOR) {
	    return node === activeNode || node.isAncestorOf(activeNode);
	  } else {
	    return node === activeNode || node.isDescendantOf(activeNode);
	  }
	} // Fix tooltip callback function params.color incorrect when pick a default color
	
	
	function fillDefaultColor(node, seriesModel, color) {
	  var data = seriesModel.getData();
	  data.setItemVisual(node.dataIndex, 'color', color);
	}
	
	module.exports = _default;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var helper = __webpack_require__(369);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Sunburst action
	 */
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	echarts.registerAction({
	  type: ROOT_TO_NODE_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});
	var HIGHLIGHT_ACTION = 'sunburstHighlight';
	echarts.registerAction({
	  type: HIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleHighlight);
	
	  function handleHighlight(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);
	
	    if (targetInfo) {
	      payload.highlight = targetInfo.node;
	    }
	  }
	});
	var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
	echarts.registerAction({
	  type: UNHIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleUnhighlight);
	
	  function handleUnhighlight(model, index) {
	    payload.unhighlight = true;
	  }
	});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var virtualRoot = seriesModel.getData().tree.root;
	    var treeRoot = seriesModel.getViewRoot();
	    var rootDepth = treeRoot.depth;
	    var sort = seriesModel.get('sort');
	
	    if (sort != null) {
	      initChildren(treeRoot, sort);
	    }
	
	    var validDataCount = 0;
	    zrUtil.each(treeRoot.children, function (child) {
	      !isNaN(child.getValue()) && validDataCount++;
	    });
	    var sum = treeRoot.getValue(); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var renderRollupNode = treeRoot.depth > 0;
	    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
	    var rPerLevel = (r - r0) / (levels || 1);
	    var clockwise = seriesModel.get('clockwise');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var dir = clockwise ? 1 : -1;
	    /**
	     * Render a tree
	     * @return increased angle
	     */
	
	    var renderNode = function (node, startAngle) {
	      if (!node) {
	        return;
	      }
	
	      var endAngle = startAngle; // Render self
	
	      if (node !== virtualRoot) {
	        // Tree node is virtual, so it doesn't need to be drawn
	        var value = node.getValue();
	        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	
	        if (angle < minAngle) {
	          angle = minAngle;
	          restAngle -= minAngle;
	        } else {
	          valueSumLargerThanMinAngle += value;
	        }
	
	        endAngle = startAngle + dir * angle;
	        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
	        var rStart = r0 + rPerLevel * depth;
	        var rEnd = r0 + rPerLevel * (depth + 1);
	        var itemModel = node.getModel();
	
	        if (itemModel.get('r0') != null) {
	          rStart = parsePercent(itemModel.get('r0'), size / 2);
	        }
	
	        if (itemModel.get('r') != null) {
	          rEnd = parsePercent(itemModel.get('r'), size / 2);
	        }
	
	        node.setLayout({
	          angle: angle,
	          startAngle: startAngle,
	          endAngle: endAngle,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: rStart,
	          r: rEnd
	        });
	      } // Render children
	
	
	      if (node.children && node.children.length) {
	        // currentAngle = startAngle;
	        var siblingAngle = 0;
	        zrUtil.each(node.children, function (node) {
	          siblingAngle += renderNode(node, startAngle + siblingAngle);
	        });
	      }
	
	      return endAngle - startAngle;
	    }; // Virtual root node for roll up
	
	
	    if (renderRollupNode) {
	      var rStart = r0;
	      var rEnd = r0 + rPerLevel;
	      var angle = Math.PI * 2;
	      virtualRoot.setLayout({
	        angle: angle,
	        startAngle: startAngle,
	        endAngle: startAngle + angle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: rStart,
	        r: rEnd
	      });
	    }
	
	    renderNode(treeRoot, startAngle);
	  });
	}
	/**
	 * Init node children by order and update visual
	 *
	 * @param {TreeNode} node  root node
	 * @param {boolean}  isAsc if is in ascendant order
	 */
	
	
	function initChildren(node, isAsc) {
	  var children = node.children || [];
	  node.children = sort(children, isAsc); // Init children recursively
	
	  if (children.length) {
	    zrUtil.each(node.children, function (child) {
	      initChildren(child, isAsc);
	    });
	  }
	}
	/**
	 * Sort children nodes
	 *
	 * @param {TreeNode[]}               children children of node to be sorted
	 * @param {string | function | null} sort sort method
	 *                                   See SunburstSeries.js for details.
	 */
	
	
	function sort(children, sortOrder) {
	  if (typeof sortOrder === 'function') {
	    return children.sort(sortOrder);
	  } else {
	    var isAsc = sortOrder === 'asc';
	    return children.sort(function (a, b) {
	      var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
	      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var graphicUtil = __webpack_require__(180);
	
	var _labelHelper = __webpack_require__(282);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	var createListFromArray = __webpack_require__(254);
	
	var _barGrid = __webpack_require__(267);
	
	var getLayoutOnAxis = _barGrid.getLayoutOnAxis;
	
	var DataDiffer = __webpack_require__(256);
	
	var SeriesModel = __webpack_require__(233);
	
	var ChartView = __webpack_require__(238);
	
	var prepareCartesian2d = __webpack_require__(491);
	
	var prepareGeo = __webpack_require__(492);
	
	var prepareSingleAxis = __webpack_require__(493);
	
	var preparePolar = __webpack_require__(494);
	
	var prepareCalendar = __webpack_require__(495);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ITEM_STYLE_NORMAL_PATH = ['itemStyle'];
	var ITEM_STYLE_EMPHASIS_PATH = ['emphasis', 'itemStyle'];
	var LABEL_NORMAL = ['label'];
	var LABEL_EMPHASIS = ['emphasis', 'label']; // Use prefix to avoid index to be the same as el.name,
	// which will cause weird udpate animation.
	
	var GROUP_DIFF_PREFIX = 'e\0\0';
	/**
	 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	 * of each coordinate systems are not required by each coordinate systems directly, but
	 * required by the module `custom`.
	 *
	 * prepareInfoForCustomSeries {Function}: optional
	 *     @return {Object} {coordSys: {...}, api: {
	 *         coord: function (data, clamp) {}, // return point in global.
	 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	 *     }}
	 */
	
	var prepareCustoms = {
	  cartesian2d: prepareCartesian2d,
	  geo: prepareGeo,
	  singleAxis: prepareSingleAxis,
	  polar: preparePolar,
	  calendar: prepareCalendar
	}; // ------
	// Model
	// ------
	
	SeriesModel.extend({
	  type: 'series.custom',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    // Can be set as 'none'
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    useTransform: true // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // label: {}
	    // itemStyle: {}
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	
	  /**
	   * @override
	   */
	  getDataParams: function (dataIndex, dataType, el) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    el && (params.info = el.info);
	    return params;
	  }
	}); // -----
	// View
	// -----
	
	ChartView.extend({
	  type: 'custom',
	
	  /**
	   * @private
	   * @type {module:echarts/data/List}
	   */
	  _data: null,
	
	  /**
	   * @override
	   */
	  render: function (customSeries, ecModel, api, payload) {
	    var oldData = this._data;
	    var data = customSeries.getData();
	    var group = this.group;
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
	    // used in the scenario that data amount is not large but graphic elements
	    // is complicated, where merge mode is probably necessary for optimization.
	    // For example, reuse graphic elements and only update the transform when
	    // roam or data zoom according to `actionType`.
	
	    data.diff(oldData).add(function (newIdx) {
	      createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  incrementalPrepareRender: function (customSeries, ecModel, api) {
	    this.group.removeAll();
	    this._data = null;
	  },
	  incrementalRender: function (params, customSeries, ecModel, api, payload) {
	    var data = customSeries.getData();
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	
	    function setIncrementalAndHoverLayer(el) {
	      if (!el.isGroup) {
	        el.incremental = true;
	        el.useHoverLayer = true;
	      }
	    }
	
	    for (var idx = params.start; idx < params.end; idx++) {
	      var el = createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
	      el.traverse(setIncrementalAndHoverLayer);
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: zrUtil.noop,
	
	  /**
	   * @override
	   */
	  filterForExposedEvent: function (eventType, query, targetEl, packedEvent) {
	    var elementName = query.element;
	
	    if (elementName == null || targetEl.name === elementName) {
	      return true;
	    } // Enable to give a name on a group made by `renderItem`, and listen
	    // events that triggerd by its descendents.
	
	
	    while ((targetEl = targetEl.parent) && targetEl !== this.group) {
	      if (targetEl.name === elementName) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	});
	
	function createEl(elOption) {
	  var graphicType = elOption.type;
	  var el;
	
	  if (graphicType === 'path') {
	    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
	
	    var pathRect = shape.width != null && shape.height != null ? {
	      x: shape.x || 0,
	      y: shape.y || 0,
	      width: shape.width,
	      height: shape.height
	    } : null;
	    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.
	
	    el = graphicUtil.makePath(pathData, null, pathRect, shape.layout || 'center');
	    el.__customPathData = pathData;
	  } else if (graphicType === 'image') {
	    el = new graphicUtil.Image({});
	    el.__customImagePath = elOption.style.image;
	  } else if (graphicType === 'text') {
	    el = new graphicUtil.Text({});
	    el.__customText = elOption.style.text;
	  } else {
	    var Clz = graphicUtil[graphicType.charAt(0).toUpperCase() + graphicType.slice(1)];
	    el = new Clz();
	  }
	
	  el.__customGraphicType = graphicType;
	  el.name = elOption.name;
	  return el;
	}
	
	function updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
	  var transitionProps = {};
	  var elOptionStyle = elOption.style || {};
	  elOption.shape && (transitionProps.shape = zrUtil.clone(elOption.shape));
	  elOption.position && (transitionProps.position = elOption.position.slice());
	  elOption.scale && (transitionProps.scale = elOption.scale.slice());
	  elOption.origin && (transitionProps.origin = elOption.origin.slice());
	  elOption.rotation && (transitionProps.rotation = elOption.rotation);
	
	  if (el.type === 'image' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    });
	  }
	
	  if (el.type === 'text' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    }); // Compatible with previous: both support
	    // textFill and fill, textStroke and stroke in 'text' element.
	
	    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	  }
	
	  if (el.type !== 'group') {
	    el.useStyle(elOptionStyle); // Init animation.
	
	    if (isInit) {
	      el.style.opacity = 0;
	      var targetOpacity = elOptionStyle.opacity;
	      targetOpacity == null && (targetOpacity = 1);
	      graphicUtil.initProps(el, {
	        style: {
	          opacity: targetOpacity
	        }
	      }, animatableModel, dataIndex);
	    }
	  }
	
	  if (isInit) {
	    el.attr(transitionProps);
	  } else {
	    graphicUtil.updateProps(el, transitionProps, animatableModel, dataIndex);
	  } // Merge by default.
	  // z2 must not be null/undefined, otherwise sort error may occur.
	
	
	  elOption.hasOwnProperty('z2') && el.attr('z2', elOption.z2 || 0);
	  elOption.hasOwnProperty('silent') && el.attr('silent', elOption.silent);
	  elOption.hasOwnProperty('invisible') && el.attr('invisible', elOption.invisible);
	  elOption.hasOwnProperty('ignore') && el.attr('ignore', elOption.ignore); // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	  // Update them only when user specified, otherwise, remain.
	
	  elOption.hasOwnProperty('info') && el.attr('info', elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
	  // logic is ensured by `graphicUtil.setElementHoverStyle`.
	
	  var styleEmphasis = elOption.styleEmphasis;
	  var disableStyleEmphasis = styleEmphasis === false;
	
	  if (!( // Try to escapse setting hover style for performance.
	  el.__cusHasEmphStl && styleEmphasis == null || !el.__cusHasEmphStl && disableStyleEmphasis)) {
	    // Should not use graphicUtil.setHoverStyle, since the styleEmphasis
	    // should not be share by group and its descendants.
	    graphicUtil.setElementHoverStyle(el, styleEmphasis);
	    el.__cusHasEmphStl = !disableStyleEmphasis;
	  }
	
	  isRoot && graphicUtil.setAsHoverStyleTrigger(el, !disableStyleEmphasis);
	}
	
	function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
	  if (elOptionStyle[prop] != null && !isInit) {
	    targetStyle[prop] = elOptionStyle[prop];
	    elOptionStyle[prop] = oldElStyle[prop];
	  }
	}
	
	function makeRenderItem(customSeries, data, ecModel, api) {
	  var renderItem = customSeries.get('renderItem');
	  var coordSys = customSeries.coordinateSystem;
	  var prepareResult = {};
	
	  if (coordSys) {
	    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
	  }
	
	  var userAPI = zrUtil.defaults({
	    getWidth: api.getWidth,
	    getHeight: api.getHeight,
	    getZr: api.getZr,
	    getDevicePixelRatio: api.getDevicePixelRatio,
	    value: value,
	    style: style,
	    styleEmphasis: styleEmphasis,
	    visual: visual,
	    barLayout: barLayout,
	    currentSeriesIndices: currentSeriesIndices,
	    font: font
	  }, prepareResult.api || {});
	  var userParams = {
	    // The life cycle of context: current round of rendering.
	    // The global life cycle is probably not necessary, because
	    // user can store global status by themselves.
	    context: {},
	    seriesId: customSeries.id,
	    seriesName: customSeries.name,
	    seriesIndex: customSeries.seriesIndex,
	    coordSys: prepareResult.coordSys,
	    dataInsideLength: data.count(),
	    encode: wrapEncodeDef(customSeries.getData())
	  }; // Do not support call `api` asynchronously without dataIndexInside input.
	
	  var currDataIndexInside;
	  var currDirty = true;
	  var currItemModel;
	  var currLabelNormalModel;
	  var currLabelEmphasisModel;
	  var currVisualColor;
	  return function (dataIndexInside, payload) {
	    currDataIndexInside = dataIndexInside;
	    currDirty = true;
	    return renderItem && renderItem(zrUtil.defaults({
	      dataIndexInside: dataIndexInside,
	      dataIndex: data.getRawIndex(dataIndexInside),
	      // Can be used for optimization when zoom or roam.
	      actionType: payload ? payload.type : null
	    }, userParams), userAPI);
	  }; // Do not update cache until api called.
	
	  function updateCache(dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	    if (currDirty) {
	      currItemModel = data.getItemModel(dataIndexInside);
	      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
	      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
	      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
	      currDirty = false;
	    }
	  }
	  /**
	   * @public
	   * @param {number|string} dim
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   * @return {number|string} value
	   */
	
	
	  function value(dim, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.get(data.getDimension(dim || 0), dataIndexInside);
	  }
	  /**
	   * By default, `visual` is applied to style (to support visualMap).
	   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	   * it can be implemented as:
	   * `api.style({stroke: api.visual('color'), fill: null})`;
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function style(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
	    currVisualColor != null && (itemStyle.fill = currVisualColor);
	    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
	    opacity != null && (itemStyle.opacity = opacity);
	    graphicUtil.setTextStyle(itemStyle, currLabelNormalModel, null, {
	      autoColor: currVisualColor,
	      isRectText: true
	    });
	    itemStyle.text = currLabelNormalModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && zrUtil.extend(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function styleEmphasis(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
	    graphicUtil.setTextStyle(itemStyle, currLabelEmphasisModel, null, {
	      isRectText: true
	    }, true);
	    itemStyle.text = currLabelEmphasisModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && zrUtil.extend(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {string} visualType
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function visual(visualType, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.getItemVisual(dataIndexInside, visualType);
	  }
	  /**
	   * @public
	   * @param {number} opt.count Positive interger.
	   * @param {number} [opt.barWidth]
	   * @param {number} [opt.barMaxWidth]
	   * @param {number} [opt.barGap]
	   * @param {number} [opt.barCategoryGap]
	   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
	   */
	
	
	  function barLayout(opt) {
	    if (coordSys.getBaseAxis) {
	      var baseAxis = coordSys.getBaseAxis();
	      return getLayoutOnAxis(zrUtil.defaults({
	        axis: baseAxis
	      }, opt), api);
	    }
	  }
	  /**
	   * @public
	   * @return {Array.<number>}
	   */
	
	
	  function currentSeriesIndices() {
	    return ecModel.getCurrentSeriesIndices();
	  }
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {string} [opt.fontStyle]
	   * @param {number} [opt.fontWeight]
	   * @param {number} [opt.fontSize]
	   * @param {string} [opt.fontFamily]
	   * @return {string} font string
	   */
	
	
	  function font(opt) {
	    return graphicUtil.getFont(opt, ecModel);
	  }
	}
	
	function wrapEncodeDef(data) {
	  var encodeDef = {};
	  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
	    var dimInfo = data.getDimensionInfo(dimName);
	
	    if (!dimInfo.isExtraCoord) {
	      var coordDim = dimInfo.coordDim;
	      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
	    }
	  });
	  return encodeDef;
	}
	
	function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
	  el && data.setItemGraphicEl(dataIndex, el);
	  return el;
	}
	
	function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
	  // [Rule]
	  // By default, follow merge mode.
	  //     (It probably brings benifit for performance in some cases of large data, where
	  //     user program can be optimized to that only updated props needed to be re-calculated,
	  //     or according to `actionType` some calculation can be skipped.)
	  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
	  //     (It seems that violate the "merge" principle, but most of users probably intuitively
	  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
	  //     most cases.)
	  var simplyRemove = !elOption; // `null`/`undefined`/`false`
	
	  elOption = elOption || {};
	  var elOptionType = elOption.type;
	  var elOptionShape = elOption.shape;
	  var elOptionStyle = elOption.style;
	
	  if (el && (simplyRemove // || elOption.$merge === false
	  // If `elOptionType` is `null`, follow the merge principle.
	  || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== el.__customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
	  || elOptionType === 'text' && hasOwn(elOptionShape, 'text') && elOptionStyle.text !== el.__customText)) {
	    group.remove(el);
	    el = null;
	  } // `elOption.type` is undefined when `renderItem` returns nothing.
	
	
	  if (simplyRemove) {
	    return;
	  }
	
	  var isInit = !el;
	  !el && (el = createEl(elOption));
	  updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);
	
	  if (elOptionType === 'group') {
	    mergeChildren(el, dataIndex, elOption, animatableModel, data);
	  } // Always add whatever already added to ensure sequence.
	
	
	  group.add(el);
	  return el;
	} // Usage:
	// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
	//     the existing children will not be removed, and enables the feature that
	//     update some of the props of some of the children simply by construct
	//     the returned children of `renderItem` like:
	//     `var children = group.children = []; children[3] = {opacity: 0.5};`
	// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
	//     by child.name. But that might be lower performance.
	// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
	//     replaced totally.
	// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
	//
	// For implementation simpleness, do not provide a direct way to remove sinlge
	// child (otherwise the total indicies of the children array have to be modified).
	// User can remove a single child by set its `ignore` as `true` or replace
	// it by another element, where its `$merge` can be set as `true` if necessary.
	
	
	function mergeChildren(el, dataIndex, elOption, animatableModel, data) {
	  var newChildren = elOption.children;
	  var newLen = newChildren ? newChildren.length : 0;
	  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
	
	  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
	  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
	
	  if (!newLen && !byName && !notMerge) {
	    return;
	  }
	
	  if (byName) {
	    diffGroupChildren({
	      oldChildren: el.children() || [],
	      newChildren: newChildren || [],
	      dataIndex: dataIndex,
	      animatableModel: animatableModel,
	      group: el,
	      data: data
	    });
	    return;
	  }
	
	  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
	  // might be better performance.
	
	  var index = 0;
	
	  for (; index < newLen; index++) {
	    newChildren[index] && doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
	  }
	}
	
	function diffGroupChildren(context) {
	  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	}
	
	function getKey(item, idx) {
	  var name = item && item.name;
	  return name != null ? name : GROUP_DIFF_PREFIX + idx;
	}
	
	function processAddUpdate(newIndex, oldIndex) {
	  var context = this.context;
	  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
	}
	
	function processRemove(oldIndex) {
	  var context = this.context;
	  var child = context.oldChildren[oldIndex];
	  child && context.group.remove(child);
	}
	
	function getPathData(shape) {
	  // "d" follows the SVG convention.
	  return shape && (shape.pathData || shape.d);
	}
	
	function hasOwnPathData(shape) {
	  return shape && (shape.hasOwnProperty('pathData') || shape.hasOwnProperty('d'));
	}
	
	function hasOwn(host, prop) {
	  return host && host.hasOwnProperty(prop);
	}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
	    var axis = this.getAxis(dim);
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.grid.getRect();
	  return {
	    coordSys: {
	      // The name exposed to user is always 'cartesian2d' but not 'grid'.
	      type: 'cartesian2d',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map([0, 1], function (dimIdx) {
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var p1 = [];
	    var p2 = [];
	    p1[dimIdx] = val - halfSize;
	    p2[dimIdx] = val + halfSize;
	    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getBoundingRect();
	  return {
	    coordSys: {
	      type: 'geo',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      zoom: coordSys.getZoom()
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" and noRoam param,
	        // Compatible with this usage:
	        // echarts.util.map(item.points, api.coord)
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  var axis = this.getAxis();
	  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  return {
	    coordSys: {
	      type: 'singleAxis',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (val) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(val);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
	    var axis = this['get' + dim + 'Axis']();
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var method = 'dataTo' + dim;
	    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
	
	    if (dim === 'Angle') {
	      result = result * Math.PI / 180;
	    }
	
	    return result;
	  }, this);
	}
	
	function _default(coordSys) {
	  var radiusAxis = coordSys.getRadiusAxis();
	  var angleAxis = coordSys.getAngleAxis();
	  var radius = radiusAxis.getExtent();
	  radius[0] > radius[1] && radius.reverse();
	  return {
	    coordSys: {
	      type: 'polar',
	      cx: coordSys.cx,
	      cy: coordSys.cy,
	      r: radius[1],
	      r0: radius[0]
	    },
	    api: {
	      coord: zrUtil.bind(function (data) {
	        var radius = radiusAxis.dataToRadius(data[0]);
	        var angle = angleAxis.dataToAngle(data[1]);
	        var coord = coordSys.coordToPoint([radius, angle]);
	        coord.push(radius, angle * Math.PI / 180);
	        return coord;
	      }),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  var rangeInfo = coordSys.getRangeInfo();
	  return {
	    coordSys: {
	      type: 'calendar',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      cellWidth: coordSys.getCellWidth(),
	      cellHeight: coordSys.getCellHeight(),
	      rangeInfo: {
	        start: rangeInfo.start,
	        end: rangeInfo.end,
	        weeks: rangeInfo.weeks,
	        dayCount: rangeInfo.allDay
	      }
	    },
	    api: {
	      coord: function (data, clamp) {
	        return coordSys.dataToPoint(data, clamp);
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	var graphicUtil = __webpack_require__(180);
	
	var layoutUtil = __webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// -------------
	// Preprocessor
	// -------------
	echarts.registerPreprocessor(function (option) {
	  var graphicOption = option.graphic; // Convert
	  // {graphic: [{left: 10, type: 'circle'}, ...]}
	  // or
	  // {graphic: {left: 10, type: 'circle'}}
	  // to
	  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	  if (zrUtil.isArray(graphicOption)) {
	    if (!graphicOption[0] || !graphicOption[0].elements) {
	      option.graphic = [{
	        elements: graphicOption
	      }];
	    } else {
	      // Only one graphic instance can be instantiated. (We dont
	      // want that too many views are created in echarts._viewMap)
	      option.graphic = [option.graphic[0]];
	    }
	  } else if (graphicOption && !graphicOption.elements) {
	    option.graphic = [{
	      elements: [graphicOption]
	    }];
	  }
	}); // ------
	// Model
	// ------
	
	var GraphicModel = echarts.extendComponentModel({
	  type: 'graphic',
	  defaultOption: {
	    // Extra properties for each elements:
	    //
	    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
	    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
	    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
	    //      This mechanism is useful when you want to position a group/element
	    //      against the right side or the center of this container.
	    //
	    // width/height: (can only be pixel value, default 0)
	    //      Only be used to specify contianer(group) size, if needed. And
	    //      can not be percentage value (like '33%'). See the reason in the
	    //      layout algorithm below.
	    //
	    // bounding: (enum: 'all' (default) | 'raw')
	    //      Specify how to calculate boundingRect when locating.
	    //      'all': Get uioned and transformed boundingRect
	    //          from both itself and its descendants.
	    //          This mode simplies confining a group of elements in the bounding
	    //          of their ancester container (e.g., using 'right: 0').
	    //      'raw': Only use the boundingRect of itself and before transformed.
	    //          This mode is similar to css behavior, which is useful when you
	    //          want an element to be able to overflow its container. (Consider
	    //          a rotated circle needs to be located in a corner.)
	    // info: custom info. enables user to mount some info on elements and use them
	    //      in event handlers. Update them only when user specified, otherwise, remain.
	    // Note: elements is always behind its ancestors in this elements array.
	    elements: [],
	    parentId: null
	  },
	
	  /**
	   * Save el options for the sake of the performance (only update modified graphics).
	   * The order is the same as those in option. (ancesters -> descendants)
	   *
	   * @private
	   * @type {Array.<Object>}
	   */
	  _elOptionsToUpdate: null,
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    // Prevent default merge to elements
	    var elements = this.option.elements;
	    this.option.elements = null;
	    GraphicModel.superApply(this, 'mergeOption', arguments);
	    this.option.elements = elements;
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    var newList = (isInit ? thisOption : newOption).elements;
	    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	    var flattenedList = [];
	
	    this._flatten(newList, flattenedList);
	
	    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
	    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate
	
	    var elOptionsToUpdate = this._elOptionsToUpdate = [];
	    zrUtil.each(mappingResult, function (resultItem, index) {
	      var newElOption = resultItem.option;
	
	      if (!newElOption) {
	        return;
	      }
	
	      elOptionsToUpdate.push(newElOption);
	      setKeyInfoToNewElOption(resultItem, newElOption);
	      mergeNewElOptionToExist(existList, index, newElOption);
	      setLayoutInfoToExist(existList[index], newElOption);
	    }, this); // Clean
	
	    for (var i = existList.length - 1; i >= 0; i--) {
	      if (existList[i] == null) {
	        existList.splice(i, 1);
	      } else {
	        // $action should be volatile, otherwise option gotten from
	        // `getOption` will contain unexpected $action.
	        delete existList[i].$action;
	      }
	    }
	  },
	
	  /**
	   * Convert
	   * [{
	   *  type: 'group',
	   *  id: 'xx',
	   *  children: [{type: 'circle'}, {type: 'polygon'}]
	   * }]
	   * to
	   * [
	   *  {type: 'group', id: 'xx'},
	   *  {type: 'circle', parentId: 'xx'},
	   *  {type: 'polygon', parentId: 'xx'}
	   * ]
	   *
	   * @private
	   * @param {Array.<Object>} optionList option list
	   * @param {Array.<Object>} result result of flatten
	   * @param {Object} parentOption parent option
	   */
	  _flatten: function (optionList, result, parentOption) {
	    zrUtil.each(optionList, function (option) {
	      if (!option) {
	        return;
	      }
	
	      if (parentOption) {
	        option.parentOption = parentOption;
	      }
	
	      result.push(option);
	      var children = option.children;
	
	      if (option.type === 'group' && children) {
	        this._flatten(children, result, option);
	      } // Deleting for JSON output, and for not affecting group creation.
	
	
	      delete option.children;
	    }, this);
	  },
	  // FIXME
	  // Pass to view using payload? setOption has a payload?
	  useElOptionsToUpdate: function () {
	    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	    this._elOptionsToUpdate = null;
	    return els;
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendComponentView({
	  type: 'graphic',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this._elMap = zrUtil.createHashMap();
	    /**
	     * @private
	     * @type {module:echarts/graphic/GraphicModel}
	     */
	
	    this._lastGraphicModel;
	  },
	
	  /**
	   * @override
	   */
	  render: function (graphicModel, ecModel, api) {
	    // Having leveraged between use cases and algorithm complexity, a very
	    // simple layout mechanism is used:
	    // The size(width/height) can be determined by itself or its parent (not
	    // implemented yet), but can not by its children. (Top-down travel)
	    // The location(x/y) can be determined by the bounding rect of itself
	    // (can including its descendants or not) and the size of its parent.
	    // (Bottom-up travel)
	    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	    // view will be reused.
	    if (graphicModel !== this._lastGraphicModel) {
	      this._clear();
	    }
	
	    this._lastGraphicModel = graphicModel;
	
	    this._updateElements(graphicModel);
	
	    this._relocate(graphicModel, api);
	  },
	
	  /**
	   * Update graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   */
	  _updateElements: function (graphicModel) {
	    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	    if (!elOptionsToUpdate) {
	      return;
	    }
	
	    var elMap = this._elMap;
	    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
	
	    zrUtil.each(elOptionsToUpdate, function (elOption) {
	      var $action = elOption.$action;
	      var id = elOption.id;
	      var existEl = elMap.get(id);
	      var parentId = elOption.parentId;
	      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	      var elOptionStyle = elOption.style;
	
	      if (elOption.type === 'text' && elOptionStyle) {
	        // In top/bottom mode, textVerticalAlign should not be used, which cause
	        // inaccurately locating.
	        if (elOption.hv && elOption.hv[1]) {
	          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
	        } // Compatible with previous setting: both support fill and textFill,
	        // stroke and textStroke.
	
	
	        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	      } // Remove unnecessary props to avoid potential problems.
	
	
	      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	      if (!$action || $action === 'merge') {
	        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'replace') {
	        removeEl(existEl, elMap);
	        createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'remove') {
	        removeEl(existEl, elMap);
	      }
	
	      var el = elMap.get(id);
	
	      if (el) {
	        el.__ecGraphicWidth = elOption.width;
	        el.__ecGraphicHeight = elOption.height;
	        setEventData(el, graphicModel, elOption);
	      }
	    });
	  },
	
	  /**
	   * Locate graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _relocate: function (graphicModel, api) {
	    var elOptions = graphicModel.option.elements;
	    var rootGroup = this.group;
	    var elMap = this._elMap; // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	    for (var i = elOptions.length - 1; i >= 0; i--) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var containerInfo = parentEl === rootGroup ? {
	        width: api.getWidth(),
	        height: api.getHeight()
	      } : {
	        // Like 'position:absolut' in css, default 0.
	        width: parentEl.__ecGraphicWidth || 0,
	        height: parentEl.__ecGraphicHeight || 0
	      };
	      layoutUtil.positionElement(el, elOption, containerInfo, null, {
	        hv: elOption.hv,
	        boundingMode: elOption.bounding
	      });
	    }
	  },
	
	  /**
	   * Clear all elements.
	   *
	   * @private
	   */
	  _clear: function () {
	    var elMap = this._elMap;
	    elMap.each(function (el) {
	      removeEl(el, elMap);
	    });
	    this._elMap = zrUtil.createHashMap();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clear();
	  }
	});
	
	function createEl(id, targetElParent, elOption, elMap) {
	  var graphicType = elOption.type;
	  var Clz = graphicUtil[graphicType.charAt(0).toUpperCase() + graphicType.slice(1)];
	  var el = new Clz(elOption);
	  targetElParent.add(el);
	  elMap.set(id, el);
	  el.__ecGraphicId = id;
	}
	
	function removeEl(existEl, elMap) {
	  var existElParent = existEl && existEl.parent;
	
	  if (existElParent) {
	    existEl.type === 'group' && existEl.traverse(function (el) {
	      removeEl(el, elMap);
	    });
	    elMap.removeKey(existEl.__ecGraphicId);
	    existElParent.remove(existEl);
	  }
	} // Remove unnecessary props to avoid potential problems.
	
	
	function getCleanedElOption(elOption) {
	  elOption = zrUtil.extend({}, elOption);
	  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
	    delete elOption[name];
	  });
	  return elOption;
	}
	
	function isSetLoc(obj, props) {
	  var isSet;
	  zrUtil.each(props, function (prop) {
	    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	  });
	  return isSet;
	}
	
	function setKeyInfoToNewElOption(resultItem, newElOption) {
	  var existElOption = resultItem.exist; // Set id and type after id assigned.
	
	  newElOption.id = resultItem.keyInfo.id;
	  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	  if (newElOption.parentId == null) {
	    var newElParentOption = newElOption.parentOption;
	
	    if (newElParentOption) {
	      newElOption.parentId = newElParentOption.id;
	    } else if (existElOption) {
	      newElOption.parentId = existElOption.parentId;
	    }
	  } // Clear
	
	
	  newElOption.parentOption = null;
	}
	
	function mergeNewElOptionToExist(existList, index, newElOption) {
	  // Update existing options, for `getOption` feature.
	  var newElOptCopy = zrUtil.extend({}, newElOption);
	  var existElOption = existList[index];
	  var $action = newElOption.$action || 'merge';
	
	  if ($action === 'merge') {
	    if (existElOption) {
	      // We can ensure that newElOptCopy and existElOption are not
	      // the same object, so `merge` will not change newElOptCopy.
	      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
	        ignoreSize: true
	      }); // Will be used in render.
	
	      layoutUtil.copyLayoutParams(newElOption, existElOption);
	    } else {
	      existList[index] = newElOptCopy;
	    }
	  } else if ($action === 'replace') {
	    existList[index] = newElOptCopy;
	  } else if ($action === 'remove') {
	    // null will be cleaned later.
	    existElOption && (existList[index] = null);
	  }
	}
	
	function setLayoutInfoToExist(existItem, newElOption) {
	  if (!existItem) {
	    return;
	  }
	
	  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
	  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
	  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	  if (existItem.type === 'group') {
	    existItem.width == null && (existItem.width = newElOption.width = 0);
	    existItem.height == null && (existItem.height = newElOption.height = 0);
	  }
	}
	
	function setEventData(el, graphicModel, elOption) {
	  var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.
	
	  if (!el.silent && !el.ignore && !eventData) {
	    eventData = el.eventData = {
	      componentType: 'graphic',
	      componentIndex: graphicModel.componentIndex,
	      name: el.name
	    };
	  } // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	
	
	  if (eventData) {
	    eventData.info = el.info;
	  }
	}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(289);
	
	__webpack_require__(475);
	
	__webpack_require__(469);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(499);
	
	__webpack_require__(505);
	
	__webpack_require__(506);
	
	__webpack_require__(507);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(500);
	
	__webpack_require__(501);
	
	__webpack_require__(502);
	
	var legendFilter = __webpack_require__(504);
	
	var Component = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Do not contain scrollable legend, for sake of file size.
	// Series Filter
	echarts.registerProcessor(legendFilter);
	Component.registerSubTypeDefaulter('legend', function () {
	  // Default 'plain' when no type specified.
	  return 'plain';
	});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var Model = __webpack_require__(174);
	
	var _model = __webpack_require__(173);
	
	var isNameSpecified = _model.isNameSpecified;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var LegendModel = echarts.extendComponentModel({
	  type: 'legend.plain',
	  dependencies: ['series'],
	  layoutMode: {
	    type: 'box',
	    // legend.width/height are maxWidth/maxHeight actually,
	    // whereas realy width/height is calculated by its content.
	    // (Setting {left: 10, right: 10} does not make sense).
	    // So consider the case:
	    // `setOption({legend: {left: 10});`
	    // then `setOption({legend: {right: 10});`
	    // The previous `left` should be cleared by setting `ignoreSize`.
	    ignoreSize: true
	  },
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    option.selected = option.selected || {};
	  },
	  mergeOption: function (option) {
	    LegendModel.superCall(this, 'mergeOption', option);
	  },
	  optionUpdated: function () {
	    this._updateData(this.ecModel);
	
	    var legendData = this._data; // If selectedMode is single, try to select one
	
	    if (legendData[0] && this.get('selectedMode') === 'single') {
	      var hasSelected = false; // If has any selected in option.selected
	
	      for (var i = 0; i < legendData.length; i++) {
	        var name = legendData[i].get('name');
	
	        if (this.isSelected(name)) {
	          // Force to unselect others
	          this.select(name);
	          hasSelected = true;
	          break;
	        }
	      } // Try select the first if selectedMode is single
	
	
	      !hasSelected && this.select(legendData[0].get('name'));
	    }
	  },
	  _updateData: function (ecModel) {
	    var potentialData = [];
	    var availableNames = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      var seriesName = seriesModel.name;
	      availableNames.push(seriesName);
	      var isPotential;
	
	      if (seriesModel.legendDataProvider) {
	        var data = seriesModel.legendDataProvider();
	        var names = data.mapArray(data.getName);
	
	        if (!ecModel.isSeriesFiltered(seriesModel)) {
	          availableNames = availableNames.concat(names);
	        }
	
	        if (names.length) {
	          potentialData = potentialData.concat(names);
	        } else {
	          isPotential = true;
	        }
	      } else {
	        isPotential = true;
	      }
	
	      if (isPotential && isNameSpecified(seriesModel)) {
	        potentialData.push(seriesModel.name);
	      }
	    });
	    /**
	     * @type {Array.<string>}
	     * @private
	     */
	
	    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
	    // which is convinient for user preparing option.
	
	    var rawData = this.get('data') || potentialData;
	    var legendData = zrUtil.map(rawData, function (dataItem) {
	      // Can be string or number
	      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
	        dataItem = {
	          name: dataItem
	        };
	      }
	
	      return new Model(dataItem, this, this.ecModel);
	    }, this);
	    /**
	     * @type {Array.<module:echarts/model/Model>}
	     * @private
	     */
	
	    this._data = legendData;
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Model>}
	   */
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @param {string} name
	   */
	  select: function (name) {
	    var selected = this.option.selected;
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      var data = this._data;
	      zrUtil.each(data, function (dataItem) {
	        selected[dataItem.get('name')] = false;
	      });
	    }
	
	    selected[name] = true;
	  },
	
	  /**
	   * @param {string} name
	   */
	  unSelect: function (name) {
	    if (this.get('selectedMode') !== 'single') {
	      this.option.selected[name] = false;
	    }
	  },
	
	  /**
	   * @param {string} name
	   */
	  toggleSelected: function (name) {
	    var selected = this.option.selected; // Default is true
	
	    if (!selected.hasOwnProperty(name)) {
	      selected[name] = true;
	    }
	
	    this[selected[name] ? 'unSelect' : 'select'](name);
	  },
	
	  /**
	   * @param {string} name
	   */
	  isSelected: function (name) {
	    var selected = this.option.selected;
	    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 4,
	    show: true,
	    // 布局方式，默认为水平布局，可选为：
	    // 'horizontal' | 'vertical'
	    orient: 'horizontal',
	    left: 'center',
	    // right: 'center',
	    top: 0,
	    // bottom: null,
	    // 水平对齐
	    // 'auto' | 'left' | 'right'
	    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
	    align: 'auto',
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 图例边框颜色
	    borderColor: '#ccc',
	    borderRadius: 0,
	    // 图例边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 图例内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 各个item之间的间隔，单位px，默认为10，
	    // 横向布局时为水平间隔，纵向布局时为纵向间隔
	    itemGap: 10,
	    // 图例图形宽度
	    itemWidth: 25,
	    // 图例图形高度
	    itemHeight: 14,
	    // 图例关闭时候的颜色
	    inactiveColor: '#ccc',
	    textStyle: {
	      // 图例文字颜色
	      color: '#333'
	    },
	    // formatter: '',
	    // 选择模式，默认开启图例开关
	    selectedMode: true,
	    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
	    // selected: null,
	    // 图例内容（详见legend.data，数组中每一项代表一个item
	    // data: [],
	    // Tooltip 相关配置
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = LegendModel;
	module.exports = _default;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function legendSelectActionHandler(methodName, payload, ecModel) {
	  var selectedMap = {};
	  var isToggleSelect = methodName === 'toggleSelected';
	  var isSelected; // Update all legend components
	
	  ecModel.eachComponent('legend', function (legendModel) {
	    if (isToggleSelect && isSelected != null) {
	      // Force other legend has same selected status
	      // Or the first is toggled to true and other are toggled to false
	      // In the case one legend has some item unSelected in option. And if other legend
	      // doesn't has the item, they will assume it is selected.
	      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	    } else {
	      legendModel[methodName](payload.name);
	      isSelected = legendModel.isSelected(payload.name);
	    }
	
	    var legendData = legendModel.getData();
	    zrUtil.each(legendData, function (model) {
	      var name = model.get('name'); // Wrap element
	
	      if (name === '\n' || name === '') {
	        return;
	      }
	
	      var isItemSelected = legendModel.isSelected(name);
	
	      if (selectedMap.hasOwnProperty(name)) {
	        // Unselected if any legend is unselected
	        selectedMap[name] = selectedMap[name] && isItemSelected;
	      } else {
	        selectedMap[name] = isItemSelected;
	      }
	    });
	  }); // Return the event explicitly
	
	  return {
	    name: payload.name,
	    selected: selectedMap
	  };
	}
	/**
	 * @event legendToggleSelect
	 * @type {Object}
	 * @property {string} type 'legendToggleSelect'
	 * @property {string} [from]
	 * @property {string} name Series name or data item name
	 */
	
	
	echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
	/**
	 * @event legendSelect
	 * @type {Object}
	 * @property {string} type 'legendSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
	/**
	 * @event legendUnSelect
	 * @type {Object}
	 * @property {string} type 'legendUnSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(180);
	
	var _listComponent = __webpack_require__(503);
	
	var makeBackground = _listComponent.makeBackground;
	
	var layoutUtil = __webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var Group = graphic.Group;
	
	var _default = echarts.extendComponentView({
	  type: 'legend.plain',
	  newlineDisabled: false,
	
	  /**
	   * @override
	   */
	  init: function () {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this.group.add(this._contentGroup = new Group());
	    /**
	     * @private
	     * @type {module:zrender/Element}
	     */
	
	    this._backgroundEl;
	    /**
	     * If first rendering, `contentGroup.position` is [0, 0], which
	     * does not make sense and may cause unexepcted animation if adopted.
	     * @private
	     * @type {boolean}
	     */
	
	    this._isFirstRender = true;
	  },
	
	  /**
	   * @protected
	   */
	  getContentGroup: function () {
	    return this._contentGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (legendModel, ecModel, api) {
	    var isFirstRender = this._isFirstRender;
	    this._isFirstRender = false;
	    this.resetInner();
	
	    if (!legendModel.get('show', true)) {
	      return;
	    }
	
	    var itemAlign = legendModel.get('align');
	
	    if (!itemAlign || itemAlign === 'auto') {
	      itemAlign = legendModel.get('left') === 'right' && legendModel.get('orient') === 'vertical' ? 'right' : 'left';
	    }
	
	    this.renderInner(itemAlign, legendModel, ecModel, api); // Perform layout.
	
	    var positionInfo = legendModel.getBoxLayoutParams();
	    var viewportSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var padding = legendModel.get('padding');
	    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
	    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender); // Place mainGroup, based on the calculated `mainRect`.
	
	    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
	      width: mainRect.width,
	      height: mainRect.height
	    }, positionInfo), viewportSize, padding);
	    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.
	
	    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	  },
	
	  /**
	   * @protected
	   */
	  resetInner: function () {
	    this.getContentGroup().removeAll();
	    this._backgroundEl && this.group.remove(this._backgroundEl);
	  },
	
	  /**
	   * @protected
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api) {
	    var contentGroup = this.getContentGroup();
	    var legendDrawnMap = zrUtil.createHashMap();
	    var selectMode = legendModel.get('selectedMode');
	    var excludeSeriesId = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
	    });
	    each(legendModel.getData(), function (itemModel, dataIndex) {
	      var name = itemModel.get('name'); // Use empty string or \n as a newline string
	
	      if (!this.newlineDisabled && (name === '' || name === '\n')) {
	        contentGroup.add(new Group({
	          newline: true
	        }));
	        return;
	      } // Representitive series.
	
	
	      var seriesModel = ecModel.getSeriesByName(name)[0];
	
	      if (legendDrawnMap.get(name)) {
	        // Have been drawed
	        return;
	      } // Series legend
	
	
	      if (seriesModel) {
	        var data = seriesModel.getData();
	        var color = data.getVisual('color'); // If color is a callback function
	
	        if (typeof color === 'function') {
	          // Use the first data
	          color = color(seriesModel.getDataParams(0));
	        } // Using rect symbol defaultly
	
	
	        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
	        var symbolType = data.getVisual('symbol');
	
	        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode);
	
	        itemGroup.on('click', curry(dispatchSelectAction, name, api)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
	        legendDrawnMap.set(name, true);
	      } else {
	        // Data legend of pie, funnel
	        ecModel.eachRawSeries(function (seriesModel) {
	          // In case multiple series has same data name
	          if (legendDrawnMap.get(name)) {
	            return;
	          }
	
	          if (seriesModel.legendDataProvider) {
	            var data = seriesModel.legendDataProvider();
	            var idx = data.indexOfName(name);
	
	            if (idx < 0) {
	              return;
	            }
	
	            var color = data.getItemVisual(idx, 'color');
	            var legendSymbolType = 'roundRect';
	
	            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, selectMode); // FIXME: consider different series has items with the same name.
	
	
	            itemGroup.on('click', curry(dispatchSelectAction, name, api)) // Should not specify the series name, consider legend controls
	            // more than one pie series.
	            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
	            legendDrawnMap.set(name, true);
	          }
	        }, this);
	      }
	    }, this);
	  },
	  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode) {
	    var itemWidth = legendModel.get('itemWidth');
	    var itemHeight = legendModel.get('itemHeight');
	    var inactiveColor = legendModel.get('inactiveColor');
	    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
	    var isSelected = legendModel.isSelected(name);
	    var itemGroup = new Group();
	    var textStyleModel = itemModel.getModel('textStyle');
	    var itemIcon = itemModel.get('icon');
	    var tooltipModel = itemModel.getModel('tooltip');
	    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
	
	    legendSymbolType = itemIcon || legendSymbolType;
	    itemGroup.add(createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	    symbolKeepAspect == null ? true : symbolKeepAspect)); // Compose symbols
	    // PENDING
	
	    if (!itemIcon && symbolType // At least show one symbol, can't be all none
	    && (symbolType !== legendSymbolType || symbolType === 'none')) {
	      var size = itemHeight * 0.8;
	
	      if (symbolType === 'none') {
	        symbolType = 'circle';
	      } // Put symbol in the center
	
	
	      itemGroup.add(createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	      symbolKeepAspect == null ? true : symbolKeepAspect));
	    }
	
	    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	    var textAlign = itemAlign;
	    var formatter = legendModel.get('formatter');
	    var content = name;
	
	    if (typeof formatter === 'string' && formatter) {
	      content = formatter.replace('{name}', name != null ? name : '');
	    } else if (typeof formatter === 'function') {
	      content = formatter(name);
	    }
	
	    itemGroup.add(new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: content,
	        x: textX,
	        y: itemHeight / 2,
	        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
	        textAlign: textAlign,
	        textVerticalAlign: 'middle'
	      })
	    })); // Add a invisible rect to increase the area of mouse hover
	
	    var hitRect = new graphic.Rect({
	      shape: itemGroup.getBoundingRect(),
	      invisible: true,
	      tooltip: tooltipModel.get('show') ? zrUtil.extend({
	        content: name,
	        // Defaul formatter
	        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
	          return name;
	        },
	        formatterParams: {
	          componentType: 'legend',
	          legendIndex: legendModel.componentIndex,
	          name: name,
	          $vars: ['name']
	        }
	      }, tooltipModel.option) : null
	    });
	    itemGroup.add(hitRect);
	    itemGroup.eachChild(function (child) {
	      child.silent = true;
	    });
	    hitRect.silent = !selectMode;
	    this.getContentGroup().add(itemGroup);
	    graphic.setHoverStyle(itemGroup);
	    itemGroup.__legendDataIndex = dataIndex;
	    return itemGroup;
	  },
	
	  /**
	   * @protected
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize) {
	    var contentGroup = this.getContentGroup(); // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	    var contentRect = contentGroup.getBoundingRect();
	    contentGroup.attr('position', [-contentRect.x, -contentRect.y]);
	    return this.group.getBoundingRect();
	  },
	
	  /**
	   * @protected
	   */
	  remove: function () {
	    this.getContentGroup().removeAll();
	    this._isFirstRender = true;
	  }
	});
	
	function dispatchSelectAction(name, api) {
	  api.dispatchAction({
	    type: 'legendToggleSelect',
	    name: name
	  });
	}
	
	function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'highlight',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'downplay',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	var layoutBox = _layout.box;
	var positionElement = _layout.positionElement;
	
	var formatUtil = __webpack_require__(219);
	
	var graphic = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Layout list like component.
	 * It will box layout each items in group of component and then position the whole group in the viewport
	 * @param {module:zrender/group/Group} group
	 * @param {module:echarts/model/Component} componentModel
	 * @param {module:echarts/ExtensionAPI}
	 */
	function layout(group, componentModel, api) {
	  var boxLayoutParams = componentModel.getBoxLayoutParams();
	  var padding = componentModel.get('padding');
	  var viewportSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	  positionElement(group, boxLayoutParams, viewportSize, padding);
	}
	
	function makeBackground(rect, componentModel) {
	  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
	  var style = componentModel.getItemStyle(['color', 'opacity']);
	  style.fill = componentModel.get('backgroundColor');
	  var rect = new graphic.Rect({
	    shape: {
	      x: rect.x - padding[3],
	      y: rect.y - padding[0],
	      width: rect.width + padding[1] + padding[3],
	      height: rect.height + padding[0] + padding[2],
	      r: componentModel.get('borderRadius')
	    },
	    style: style,
	    silent: true,
	    z2: -1
	  }); // FIXME
	  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	  // and background rect when setting like `left: 0`, `top: 0`.
	  // graphic.subPixelOptimizeRect(rect);
	
	  return rect;
	}
	
	exports.layout = layout;
	exports.makeBackground = makeBackground;

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (legendModels && legendModels.length) {
	    ecModel.filterSeries(function (series) {
	      // If in any legend component the status is not selected.
	      // Because in legend series is assumed selected when it is not in the legend data.
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(series.name)) {
	          return false;
	        }
	      }
	
	      return true;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var LegendModel = __webpack_require__(500);
	
	var _layout = __webpack_require__(217);
	
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var getLayoutParams = _layout.getLayoutParams;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ScrollableLegendModel = LegendModel.extend({
	  type: 'legend.scroll',
	
	  /**
	   * @param {number} scrollDataIndex
	   */
	  setScrollDataIndex: function (scrollDataIndex) {
	    this.option.scrollDataIndex = scrollDataIndex;
	  },
	  defaultOption: {
	    scrollDataIndex: 0,
	    pageButtonItemGap: 5,
	    pageButtonGap: null,
	    pageButtonPosition: 'end',
	    // 'start' or 'end'
	    pageFormatter: '{current}/{total}',
	    // If null/undefined, do not show page.
	    pageIcons: {
	      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	    },
	    pageIconColor: '#2f4554',
	    pageIconInactiveColor: '#aaa',
	    pageIconSize: 15,
	    // Can be [10, 3], which represents [width, height]
	    pageTextStyle: {
	      color: '#333'
	    },
	    animationDurationUpdate: 800
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
	    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
	    mergeAndNormalizeLayoutParams(this, this.option, option);
	  },
	  getOrient: function () {
	    return this.get('orient') === 'vertical' ? {
	      index: 1,
	      name: 'vertical'
	    } : {
	      index: 0,
	      name: 'horizontal'
	    };
	  }
	}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
	
	function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
	  var orient = legendModel.getOrient();
	  var ignoreSize = [1, 1];
	  ignoreSize[orient.index] = 0;
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = ScrollableLegendModel;
	module.exports = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var layoutUtil = __webpack_require__(217);
	
	var LegendView = __webpack_require__(502);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Separate legend and scrollable legend to reduce package size.
	 */
	var Group = graphic.Group;
	var WH = ['width', 'height'];
	var XY = ['x', 'y'];
	var ScrollableLegendView = LegendView.extend({
	  type: 'legend.scroll',
	  newlineDisabled: true,
	  init: function () {
	    ScrollableLegendView.superCall(this, 'init');
	    /**
	     * @private
	     * @type {number} For `scroll`.
	     */
	
	    this._currentIndex = 0;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._containerGroup = new Group());
	
	    this._containerGroup.add(this.getContentGroup());
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	
	    this.group.add(this._controllerGroup = new Group());
	    /**
	     *
	     * @private
	     */
	
	    this._showController;
	  },
	
	  /**
	   * @override
	   */
	  resetInner: function () {
	    ScrollableLegendView.superCall(this, 'resetInner');
	
	    this._controllerGroup.removeAll();
	
	    this._containerGroup.removeClipPath();
	
	    this._containerGroup.__rectSize = null;
	  },
	
	  /**
	   * @override
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api) {
	    var me = this; // Render content items.
	
	    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api);
	    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
	    // e.g., '3/12345' should not overlap with the control arrow button.
	
	    var pageIconSize = legendModel.get('pageIconSize', true);
	
	    if (!zrUtil.isArray(pageIconSize)) {
	      pageIconSize = [pageIconSize, pageIconSize];
	    }
	
	    createPageButton('pagePrev', 0);
	    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	    controllerGroup.add(new graphic.Text({
	      name: 'pageText',
	      style: {
	        textFill: pageTextStyleModel.getTextColor(),
	        font: pageTextStyleModel.getFont(),
	        textVerticalAlign: 'middle',
	        textAlign: 'center'
	      },
	      silent: true
	    }));
	    createPageButton('pageNext', 1);
	
	    function createPageButton(name, iconIdx) {
	      var pageDataIndexName = name + 'DataIndex';
	      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	        // Buttons will be created in each render, so we do not need
	        // to worry about avoiding using legendModel kept in scope.
	        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
	      }, {
	        x: -pageIconSize[0] / 2,
	        y: -pageIconSize[1] / 2,
	        width: pageIconSize[0],
	        height: pageIconSize[1]
	      });
	      icon.name = name;
	      controllerGroup.add(icon);
	    }
	  },
	
	  /**
	   * @override
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender) {
	    var contentGroup = this.getContentGroup();
	    var containerGroup = this._containerGroup;
	    var controllerGroup = this._controllerGroup;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var yx = XY[1 - orientIdx]; // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	    layoutUtil.box( // Buttons in controller are layout always horizontally.
	    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	    var contentRect = contentGroup.getBoundingRect();
	    var controllerRect = controllerGroup.getBoundingRect();
	    var showController = this._showController = contentRect[wh] > maxSize[wh];
	    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	    // If first rendering, `contentGroup.position` is [0, 0], which
	    // does not make sense and may cause unexepcted animation if adopted.
	
	    if (!isFirstRender) {
	      contentPos[orientIdx] = contentGroup.position[orientIdx];
	    } // Layout container group based on 0.
	
	
	    var containerPos = [0, 0];
	    var controllerPos = [-controllerRect.x, -controllerRect.y];
	    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	    if (showController) {
	      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	      if (pageButtonPosition === 'end') {
	        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	      } // controller is on the left / top.
	      else {
	          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	        }
	    } // Always align controller to content as 'middle'.
	
	
	    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	    contentGroup.attr('position', contentPos);
	    containerGroup.attr('position', containerPos);
	    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
	    // mainRect should not be calculated by `this.group.getBoundingRect()`
	    // for sake of the overflow.
	
	    var mainRect = this.group.getBoundingRect();
	    var mainRect = {
	      x: 0,
	      y: 0
	    }; // Consider content may be overflow (should be clipped).
	
	    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	    containerGroup.__rectSize = maxSize[wh];
	
	    if (showController) {
	      var clipShape = {
	        x: 0,
	        y: 0
	      };
	      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	      clipShape[hw] = mainRect[hw];
	      containerGroup.setClipPath(new graphic.Rect({
	        shape: clipShape
	      })); // Consider content may be larger than container, container rect
	      // can not be obtained from `containerGroup.getBoundingRect()`.
	
	      containerGroup.__rectSize = clipShape[wh];
	    } else {
	      // Do not remove or ignore controller. Keep them set as place holders.
	      controllerGroup.eachChild(function (child) {
	        child.attr({
	          invisible: true,
	          silent: true
	        });
	      });
	    } // Content translate animation.
	
	
	    var pageInfo = this._getPageInfo(legendModel);
	
	    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
	      position: pageInfo.contentPosition
	    }, // When switch from "show controller" to "not show controller", view should be
	    // updated immediately without animation, otherwise causes weird efffect.
	    showController ? legendModel : false);
	
	    this._updatePageInfoView(legendModel, pageInfo);
	
	    return mainRect;
	  },
	  _pageGo: function (to, legendModel, api) {
	    var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	    scrollDataIndex != null && api.dispatchAction({
	      type: 'legendScroll',
	      scrollDataIndex: scrollDataIndex,
	      legendId: legendModel.id
	    });
	  },
	  _updatePageInfoView: function (legendModel, pageInfo) {
	    var controllerGroup = this._controllerGroup;
	    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
	      var canJump = pageInfo[name + 'DataIndex'] != null;
	      var icon = controllerGroup.childOfName(name);
	
	      if (icon) {
	        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	        icon.cursor = canJump ? 'pointer' : 'default';
	      }
	    });
	    var pageText = controllerGroup.childOfName('pageText');
	    var pageFormatter = legendModel.get('pageFormatter');
	    var pageIndex = pageInfo.pageIndex;
	    var current = pageIndex != null ? pageIndex + 1 : 0;
	    var total = pageInfo.pageCount;
	    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
	      current: current,
	      total: total
	    }));
	  },
	
	  /**
	   * @param {module:echarts/model/Model} legendModel
	   * @return {Object} {
	   *  contentPosition: Array.<number>, null when data item not found.
	   *  pageIndex: number, null when data item not found.
	   *  pageCount: number, always be a number, can be 0.
	   *  pagePrevDataIndex: number, null when no next page.
	   *  pageNextDataIndex: number, null when no previous page.
	   * }
	   */
	  _getPageInfo: function (legendModel) {
	    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
	    var contentGroup = this.getContentGroup();
	    var containerRectSize = this._containerGroup.__rectSize;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	
	    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
	
	    var children = contentGroup.children();
	    var targetItem = children[targetItemIndex];
	    var itemCount = children.length;
	    var pCount = !itemCount ? 0 : 1;
	    var result = {
	      contentPosition: contentGroup.position.slice(),
	      pageCount: pCount,
	      pageIndex: pCount - 1,
	      pagePrevDataIndex: null,
	      pageNextDataIndex: null
	    };
	
	    if (!targetItem) {
	      return result;
	    }
	
	    var targetItemInfo = getItemInfo(targetItem);
	    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
	    // (1) Always align based on the left/top most item.
	    // (2) It is user-friendly that the last item shown in the
	    // current window is shown at the begining of next window.
	    // Otherwise if half of the last item is cut by the window,
	    // it will have no chance to display entirely.
	    // (3) Consider that item size probably be different, we
	    // have calculate pageIndex by size rather than item index,
	    // and we can not get page index directly by division.
	    // (4) The window is to narrow to contain more than
	    // one item, we should make sure that the page can be fliped.
	
	    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // Half of the last item is out of the window.
	      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
	      // can be started at the current item or the last item.
	      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
	        if (winEndItemInfo.i > winStartItemInfo.i) {
	          winStartItemInfo = winEndItemInfo;
	        } else {
	          // e.g., when page size is smaller than item size.
	          winStartItemInfo = currItemInfo;
	        }
	
	        if (winStartItemInfo) {
	          if (result.pageNextDataIndex == null) {
	            result.pageNextDataIndex = winStartItemInfo.i;
	          }
	
	          ++result.pageCount;
	        }
	      }
	
	      winEndItemInfo = currItemInfo;
	    }
	
	    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // If the the end item does not intersect with the window started
	      // from the current item, a page can be settled.
	      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
	      winStartItemInfo.i < winEndItemInfo.i) {
	        winEndItemInfo = winStartItemInfo;
	
	        if (result.pagePrevDataIndex == null) {
	          result.pagePrevDataIndex = winStartItemInfo.i;
	        }
	
	        ++result.pageCount;
	        ++result.pageIndex;
	      }
	
	      winStartItemInfo = currItemInfo;
	    }
	
	    return result;
	
	    function getItemInfo(el) {
	      if (el) {
	        var itemRect = el.getBoundingRect();
	        var start = itemRect[xy] + el.position[orientIdx];
	        return {
	          s: start,
	          e: start + itemRect[wh],
	          i: el.__legendDataIndex
	        };
	      }
	    }
	
	    function intersect(itemInfo, winStart) {
	      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
	    }
	  },
	  _findTargetItemIndex: function (targetDataIndex) {
	    var index;
	    var contentGroup = this.getContentGroup();
	
	    if (this._showController) {
	      contentGroup.eachChild(function (child, idx) {
	        if (child.__legendDataIndex === targetDataIndex) {
	          index = idx;
	        }
	      });
	    } else {
	      index = 0;
	    }
	
	    return index;
	  }
	});
	var _default = ScrollableLegendView;
	module.exports = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @event legendScroll
	 * @type {Object}
	 * @property {string} type 'legendScroll'
	 * @property {string} scrollDataIndex
	 */
	echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	  var scrollDataIndex = payload.scrollDataIndex;
	  scrollDataIndex != null && ecModel.eachComponent({
	    mainType: 'legend',
	    subType: 'scroll',
	    query: payload
	  }, function (legendModel) {
	    legendModel.setScrollDataIndex(scrollDataIndex);
	  });
	});

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(469);
	
	__webpack_require__(509);
	
	__webpack_require__(510);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Better way to pack data in graphic element
	
	/**
	 * @action
	 * @property {string} type
	 * @property {number} seriesIndex
	 * @property {number} dataIndex
	 * @property {number} [x]
	 * @property {number} [y]
	 */
	echarts.registerAction({
	  type: 'showTip',
	  event: 'showTip',
	  update: 'tooltip:manuallyShowTip'
	}, // noop
	function () {});
	echarts.registerAction({
	  type: 'hideTip',
	  event: 'hideTip',
	  update: 'tooltip:manuallyHideTip'
	}, // noop
	function () {});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'tooltip',
	  dependencies: ['axisPointer'],
	  defaultOption: {
	    zlevel: 0,
	    z: 60,
	    show: true,
	    // tooltip主体内容
	    showContent: true,
	    // 'trigger' only works on coordinate system.
	    // 'item' | 'axis' | 'none'
	    trigger: 'item',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: 'mousemove|click',
	    alwaysShowContent: false,
	    displayMode: 'single',
	    // 'single' | 'multipleByCoordSys'
	    renderMode: 'auto',
	    // 'auto' | 'html' | 'richText'
	    // 'auto': use html by default, and use non-html if `document` is not defined
	    // 'html': use html for tooltip
	    // 'richText': use canvas, svg, and etc. for tooltip
	    // 位置 {Array} | {Function}
	    // position: null
	    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
	    // align: null,
	    // verticalAlign: null,
	    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
	    confine: false,
	    // 内容格式器：{string}（Template） ¦ {Function}
	    // formatter: null
	    showDelay: 0,
	    // 隐藏延迟，单位ms
	    hideDelay: 100,
	    // 动画变换时间，单位s
	    transitionDuration: 0.4,
	    enterable: false,
	    // 提示背景颜色，默认为透明度为0.7的黑色
	    backgroundColor: 'rgba(50,50,50,0.7)',
	    // 提示边框颜色
	    borderColor: '#333',
	    // 提示边框圆角，单位px，默认为4
	    borderRadius: 4,
	    // 提示边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 提示内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // Extra css text
	    extraCssText: '',
	    // 坐标轴指示器，坐标轴触发有效
	    axisPointer: {
	      // 默认为直线
	      // 可选为：'line' | 'shadow' | 'cross'
	      type: 'line',
	      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
	      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
	      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
	      // 极坐标系会默认选择 angle 轴
	      axis: 'auto',
	      animation: 'auto',
	      animationDurationUpdate: 200,
	      animationEasingUpdate: 'exponentialOut',
	      crossStyle: {
	        color: '#999',
	        width: 1,
	        type: 'dashed',
	        // TODO formatter
	        textStyle: {} // lineStyle and shadowStyle should not be specified here,
	        // otherwise it will always override those styles on option.axisPointer.
	
	      }
	    },
	    textStyle: {
	      color: '#fff',
	      fontSize: 14
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var TooltipContent = __webpack_require__(511);
	
	var TooltipRichContent = __webpack_require__(512);
	
	var formatUtil = __webpack_require__(219);
	
	var numberUtil = __webpack_require__(218);
	
	var graphic = __webpack_require__(180);
	
	var findPointFromSeries = __webpack_require__(471);
	
	var layoutUtil = __webpack_require__(217);
	
	var Model = __webpack_require__(174);
	
	var globalListener = __webpack_require__(474);
	
	var axisHelper = __webpack_require__(261);
	
	var axisPointerViewHelper = __webpack_require__(477);
	
	var _model = __webpack_require__(173);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var parsePercent = numberUtil.parsePercent;
	var proxyRect = new graphic.Rect({
	  shape: {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  }
	});
	
	var _default = echarts.extendComponentView({
	  type: 'tooltip',
	  init: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    var tooltipModel = ecModel.getComponent('tooltip');
	    var renderMode = tooltipModel.get('renderMode');
	    this._renderMode = getTooltipRenderMode(renderMode);
	    var tooltipContent;
	
	    if (this._renderMode === 'html') {
	      tooltipContent = new TooltipContent(api.getDom(), api);
	      this._newLine = '<br/>';
	    } else {
	      tooltipContent = new TooltipRichContent(api);
	      this._newLine = '\n';
	    }
	
	    this._tooltipContent = tooltipContent;
	  },
	  render: function (tooltipModel, ecModel, api) {
	    if (env.node) {
	      return;
	    } // Reset
	
	
	    this.group.removeAll();
	    /**
	     * @private
	     * @type {module:echarts/component/tooltip/TooltipModel}
	     */
	
	    this._tooltipModel = tooltipModel;
	    /**
	     * @private
	     * @type {module:echarts/model/Global}
	     */
	
	    this._ecModel = ecModel;
	    /**
	     * @private
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this._api = api;
	    /**
	     * Should be cleaned when render.
	     * @private
	     * @type {Array.<Array.<Object>>}
	     */
	
	    this._lastDataByCoordSys = null;
	    /**
	     * @private
	     * @type {boolean}
	     */
	
	    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    var tooltipContent = this._tooltipContent;
	    tooltipContent.update();
	    tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	    this._initGlobalListener();
	
	    this._keepShow();
	  },
	  _initGlobalListener: function () {
	    var tooltipModel = this._tooltipModel;
	    var triggerOn = tooltipModel.get('triggerOn');
	    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none') {
	        if (triggerOn.indexOf(currTrigger) >= 0) {
	          this._tryShow(e, dispatchAction);
	        } else if (currTrigger === 'leave') {
	          this._hide(dispatchAction);
	        }
	      }
	    }, this));
	  },
	  _keepShow: function () {
	    var tooltipModel = this._tooltipModel;
	    var ecModel = this._ecModel;
	    var api = this._api; // Try to keep the tooltip show when refreshing
	
	    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	    // self.manuallyShowTip({x, y}) might cause tooltip hide,
	    // which is not expected.
	    && tooltipModel.get('triggerOn') !== 'none') {
	      var self = this;
	      clearTimeout(this._refreshUpdateTimeout);
	      this._refreshUpdateTimeout = setTimeout(function () {
	        // Show tip next tick after other charts are rendered
	        // In case highlight action has wrong result
	        // FIXME
	        self.manuallyShowTip(tooltipModel, ecModel, api, {
	          x: self._lastX,
	          y: self._lastY
	        });
	      });
	    }
	  },
	
	  /**
	   * Show tip manually by
	   * dispatchAction({
	   *     type: 'showTip',
	   *     x: 10,
	   *     y: 10
	   * });
	   * Or
	   * dispatchAction({
	   *      type: 'showTip',
	   *      seriesIndex: 0,
	   *      dataIndex or dataIndexInside or name
	   * });
	   *
	   *  TODO Batch
	   */
	  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
	    if (payload.from === this.uid || env.node) {
	      return;
	    }
	
	    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket
	
	    this._ticket = ''; // When triggered from axisPointer.
	
	    var dataByCoordSys = payload.dataByCoordSys;
	
	    if (payload.tooltip && payload.x != null && payload.y != null) {
	      var el = proxyRect;
	      el.position = [payload.x, payload.y];
	      el.update();
	      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        target: el
	      }, dispatchAction);
	    } else if (dataByCoordSys) {
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        event: {},
	        dataByCoordSys: payload.dataByCoordSys,
	        tooltipOption: payload.tooltipOption
	      }, dispatchAction);
	    } else if (payload.seriesIndex != null) {
	      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	        return;
	      }
	
	      var pointInfo = findPointFromSeries(payload, ecModel);
	      var cx = pointInfo.point[0];
	      var cy = pointInfo.point[1];
	
	      if (cx != null && cy != null) {
	        this._tryShow({
	          offsetX: cx,
	          offsetY: cy,
	          position: payload.position,
	          target: pointInfo.el,
	          event: {}
	        }, dispatchAction);
	      }
	    } else if (payload.x != null && payload.y != null) {
	      // FIXME
	      // should wrap dispatchAction like `axisPointer/globalListener` ?
	      api.dispatchAction({
	        type: 'updateAxisPointer',
	        x: payload.x,
	        y: payload.y
	      });
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        target: api.getZr().findHover(payload.x, payload.y).target,
	        event: {}
	      }, dispatchAction);
	    }
	  },
	  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
	    var tooltipContent = this._tooltipContent;
	
	    if (!this._alwaysShowContent && this._tooltipModel) {
	      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	    }
	
	    this._lastX = this._lastY = null;
	
	    if (payload.from !== this.uid) {
	      this._hide(makeDispatchAction(payload, api));
	    }
	  },
	  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	  // and tooltip.
	  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
	    var seriesIndex = payload.seriesIndex;
	    var dataIndex = payload.dataIndex;
	    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	      return;
	    }
	
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	    if (!seriesModel) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);
	
	    if (tooltipModel.get('trigger') !== 'axis') {
	      return;
	    }
	
	    api.dispatchAction({
	      type: 'updateAxisPointer',
	      seriesIndex: seriesIndex,
	      dataIndex: dataIndex,
	      position: payload.position
	    });
	    return true;
	  },
	  _tryShow: function (e, dispatchAction) {
	    var el = e.target;
	    var tooltipModel = this._tooltipModel;
	
	    if (!tooltipModel) {
	      return;
	    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	    this._lastX = e.offsetX;
	    this._lastY = e.offsetY;
	    var dataByCoordSys = e.dataByCoordSys;
	
	    if (dataByCoordSys && dataByCoordSys.length) {
	      this._showAxisTooltip(dataByCoordSys, e);
	    } // Always show item tooltip if mouse is on the element with dataIndex
	    else if (el && el.dataIndex != null) {
	        this._lastDataByCoordSys = null;
	
	        this._showSeriesItemTooltip(e, el, dispatchAction);
	      } // Tooltip provided directly. Like legend.
	      else if (el && el.tooltip) {
	          this._lastDataByCoordSys = null;
	
	          this._showComponentItemTooltip(e, el, dispatchAction);
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	  },
	  _showOrMove: function (tooltipModel, cb) {
	    // showDelay is used in this case: tooltip.enterable is set
	    // as true. User intent to move mouse into tooltip and click
	    // something. `showDelay` makes it easyer to enter the content
	    // but tooltip do not move immediately.
	    var delay = tooltipModel.get('showDelay');
	    cb = zrUtil.bind(cb, this);
	    clearTimeout(this._showTimout);
	    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	  },
	  _showAxisTooltip: function (dataByCoordSys, e) {
	    var ecModel = this._ecModel;
	    var globalTooltipModel = this._tooltipModel;
	    var point = [e.offsetX, e.offsetY];
	    var singleDefaultHTML = [];
	    var singleParamsList = [];
	    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
	    var renderMode = this._renderMode;
	    var newLine = this._newLine;
	    var markers = {};
	    each(dataByCoordSys, function (itemCoordSys) {
	      // var coordParamList = [];
	      // var coordDefaultHTML = [];
	      // var coordTooltipModel = buildTooltipModel([
	      //     e.tooltipOption,
	      //     itemCoordSys.tooltipOption,
	      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
	      //     globalTooltipModel
	      // ]);
	      // var displayMode = coordTooltipModel.get('displayMode');
	      // var paramsList = displayMode === 'single' ? singleParamsList : [];
	      each(itemCoordSys.dataByAxis, function (item) {
	        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
	        var axisValue = item.value;
	        var seriesDefaultHTML = [];
	
	        if (!axisModel || axisValue == null) {
	          return;
	        }
	
	        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
	        zrUtil.each(item.seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams.axisDim = item.axisDim;
	          dataParams.axisIndex = item.axisIndex;
	          dataParams.axisType = item.axisType;
	          dataParams.axisId = item.axisId;
	          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
	          dataParams.axisValueLabel = valueLabel;
	
	          if (dataParams) {
	            singleParamsList.push(dataParams);
	            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
	            var html;
	
	            if (zrUtil.isObject(seriesTooltip)) {
	              html = seriesTooltip.html;
	              var newMarkers = seriesTooltip.markers;
	              zrUtil.merge(markers, newMarkers);
	            } else {
	              html = seriesTooltip;
	            }
	
	            seriesDefaultHTML.push(html);
	          }
	        }); // Default tooltip content
	        // FIXME
	        // (1) shold be the first data which has name?
	        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
	
	        var firstLine = valueLabel;
	
	        if (renderMode !== 'html') {
	          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
	        } else {
	          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
	        }
	      });
	    }, this); // In most case, the second axis is shown upper than the first one.
	
	    singleDefaultHTML.reverse();
	    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
	    var positionExpr = e.position;
	
	    this._showOrMove(singleTooltipModel, function () {
	      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
	        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
	      } else {
	        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
	      }
	    }); // Do not trigger events here, because this branch only be entered
	    // from dispatchAction.
	
	  },
	  _showSeriesItemTooltip: function (e, el, dispatchAction) {
	    var ecModel = this._ecModel; // Use dataModel in element if possible
	    // Used when mouseover on a element like markPoint or edge
	    // In which case, the data is not main data in series.
	
	    var seriesIndex = el.seriesIndex;
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	    var dataModel = el.dataModel || seriesModel;
	    var dataIndex = el.dataIndex;
	    var dataType = el.dataType;
	    var data = dataModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
	    var tooltipTrigger = tooltipModel.get('trigger');
	
	    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	      return;
	    }
	
	    var params = dataModel.getDataParams(dataIndex, dataType);
	    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
	    var defaultHtml;
	    var markers;
	
	    if (zrUtil.isObject(seriesTooltip)) {
	      defaultHtml = seriesTooltip.html;
	      markers = seriesTooltip.markers;
	    } else {
	      defaultHtml = seriesTooltip;
	      markers = null;
	    }
	
	    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	    this._showOrMove(tooltipModel, function () {
	      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
	    }); // FIXME
	    // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	    dispatchAction({
	      type: 'showTip',
	      dataIndexInside: dataIndex,
	      dataIndex: data.getRawIndex(dataIndex),
	      seriesIndex: seriesIndex,
	      from: this.uid
	    });
	  },
	  _showComponentItemTooltip: function (e, el, dispatchAction) {
	    var tooltipOpt = el.tooltip;
	
	    if (typeof tooltipOpt === 'string') {
	      var content = tooltipOpt;
	      tooltipOpt = {
	        content: content,
	        // Fixed formatter
	        formatter: content
	      };
	    }
	
	    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
	    var defaultHtml = subTooltipModel.get('content');
	    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
	    // only works on cooridinate system. In fact, we have not found case
	    // that requires setting `trigger` nothing on component yet.
	
	    this._showOrMove(subTooltipModel, function () {
	      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
	    }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	    dispatchAction({
	      type: 'showTip',
	      from: this.uid
	    });
	  },
	  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
	    // Reset ticket
	    this._ticket = '';
	
	    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	      return;
	    }
	
	    var tooltipContent = this._tooltipContent;
	    var formatter = tooltipModel.get('formatter');
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var html = defaultHtml;
	
	    if (formatter && typeof formatter === 'string') {
	      html = formatUtil.formatTpl(formatter, params, true);
	    } else if (typeof formatter === 'function') {
	      var callback = bind(function (cbTicket, html) {
	        if (cbTicket === this._ticket) {
	          tooltipContent.setContent(html, markers, tooltipModel);
	
	          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	        }
	      }, this);
	      this._ticket = asyncTicket;
	      html = formatter(params, asyncTicket, callback);
	    }
	
	    tooltipContent.setContent(html, markers, tooltipModel);
	    tooltipContent.show(tooltipModel);
	
	    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	  },
	
	  /**
	   * @param  {string|Function|Array.<number>|Object} positionExpr
	   * @param  {number} x Mouse x
	   * @param  {number} y Mouse y
	   * @param  {boolean} confine Whether confine tooltip content in view rect.
	   * @param  {Object|<Array.<Object>} params
	   * @param  {module:zrender/Element} el target element
	   * @param  {module:echarts/ExtensionAPI} api
	   * @return {Array.<number>}
	   */
	  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
	    var viewWidth = this._api.getWidth();
	
	    var viewHeight = this._api.getHeight();
	
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var contentSize = content.getSize();
	    var align = tooltipModel.get('align');
	    var vAlign = tooltipModel.get('verticalAlign');
	    var rect = el && el.getBoundingRect().clone();
	    el && rect.applyTransform(el.transform);
	
	    if (typeof positionExpr === 'function') {
	      // Callback of position can be an array or a string specify the position
	      positionExpr = positionExpr([x, y], params, content.el, rect, {
	        viewSize: [viewWidth, viewHeight],
	        contentSize: contentSize.slice()
	      });
	    }
	
	    if (zrUtil.isArray(positionExpr)) {
	      x = parsePercent(positionExpr[0], viewWidth);
	      y = parsePercent(positionExpr[1], viewHeight);
	    } else if (zrUtil.isObject(positionExpr)) {
	      positionExpr.width = contentSize[0];
	      positionExpr.height = contentSize[1];
	      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
	        width: viewWidth,
	        height: viewHeight
	      });
	      x = layoutRect.x;
	      y = layoutRect.y;
	      align = null; // When positionExpr is left/top/right/bottom,
	      // align and verticalAlign will not work.
	
	      vAlign = null;
	    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	    else if (typeof positionExpr === 'string' && el) {
	        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
	        x = pos[0];
	        y = pos[1];
	      } else {
	        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	        x = pos[0];
	        y = pos[1];
	      }
	
	    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	    if (tooltipModel.get('confine')) {
	      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
	      x = pos[0];
	      y = pos[1];
	    }
	
	    content.moveTo(x, y);
	  },
	  // FIXME
	  // Should we remove this but leave this to user?
	  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
	    var lastCoordSys = this._lastDataByCoordSys;
	    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
	      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
	      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	        var thisItem = thisDataByAxis[indexAxis] || {};
	        var lastIndices = lastItem.seriesDataIndices || [];
	        var newIndices = thisItem.seriesDataIndices || [];
	        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	          var newIdxItem = newIndices[j];
	          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	        });
	      });
	    });
	    this._lastDataByCoordSys = dataByCoordSys;
	    return !!contentNotChanged;
	  },
	  _hide: function (dispatchAction) {
	    // Do not directly hideLater here, because this behavior may be prevented
	    // in dispatchAction when showTip is dispatched.
	    // FIXME
	    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	    this._lastDataByCoordSys = null;
	    dispatchAction({
	      type: 'hideTip',
	      from: this.uid
	    });
	  },
	  dispose: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    this._tooltipContent.hide();
	
	    globalListener.unregister('itemTooltip', api);
	  }
	});
	/**
	 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
	 * From top to bottom. (the last one should be globalTooltipModel);
	 */
	
	
	function buildTooltipModel(modelCascade) {
	  var resultModel = modelCascade.pop();
	
	  while (modelCascade.length) {
	    var tooltipOpt = modelCascade.pop();
	
	    if (tooltipOpt) {
	      if (Model.isInstance(tooltipOpt)) {
	        tooltipOpt = tooltipOpt.get('tooltip', true);
	      } // In each data item tooltip can be simply write:
	      // {
	      //  value: 10,
	      //  tooltip: 'Something you need to know'
	      // }
	
	
	      if (typeof tooltipOpt === 'string') {
	        tooltipOpt = {
	          formatter: tooltipOpt
	        };
	      }
	
	      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
	    }
	  }
	
	  return resultModel;
	}
	
	function makeDispatchAction(payload, api) {
	  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	}
	
	function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	
	  if (gapH != null) {
	    if (x + width + gapH > viewWidth) {
	      x -= width + gapH;
	    } else {
	      x += gapH;
	    }
	  }
	
	  if (gapV != null) {
	    if (y + height + gapV > viewHeight) {
	      y -= height + gapV;
	    } else {
	      y += gapV;
	    }
	  }
	
	  return [x, y];
	}
	
	function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	  x = Math.min(x + width, viewWidth) - width;
	  y = Math.min(y + height, viewHeight) - height;
	  x = Math.max(x, 0);
	  y = Math.max(y, 0);
	  return [x, y];
	}
	
	function calcTooltipPosition(position, rect, contentSize) {
	  var domWidth = contentSize[0];
	  var domHeight = contentSize[1];
	  var gap = 5;
	  var x = 0;
	  var y = 0;
	  var rectWidth = rect.width;
	  var rectHeight = rect.height;
	
	  switch (position) {
	    case 'inside':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'top':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y - domHeight - gap;
	      break;
	
	    case 'bottom':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight + gap;
	      break;
	
	    case 'left':
	      x = rect.x - domWidth - gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'right':
	      x = rect.x + rectWidth + gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	  }
	
	  return [x, y];
	}
	
	function isCenterAlign(align) {
	  return align === 'center' || align === 'middle';
	}
	
	module.exports = _default;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var zrColor = __webpack_require__(150);
	
	var eventUtil = __webpack_require__(139);
	
	var env = __webpack_require__(133);
	
	var formatUtil = __webpack_require__(219);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var toCamelCase = formatUtil.toCamelCase;
	var vendors = ['', '-webkit-', '-moz-', '-o-'];
	var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
	/**
	 * @param {number} duration
	 * @return {string}
	 * @inner
	 */
	
	function assembleTransition(duration) {
	  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
	  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
	  return zrUtil.map(vendors, function (vendorPrefix) {
	    return vendorPrefix + 'transition:' + transitionText;
	  }).join(';');
	}
	/**
	 * @param {Object} textStyle
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleFont(textStyleModel) {
	  var cssText = [];
	  var fontSize = textStyleModel.get('fontSize');
	  var color = textStyleModel.getTextColor();
	  color && cssText.push('color:' + color);
	  cssText.push('font:' + textStyleModel.getFont());
	  fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
	  each(['decoration', 'align'], function (name) {
	    var val = textStyleModel.get(name);
	    val && cssText.push('text-' + name + ':' + val);
	  });
	  return cssText.join(';');
	}
	/**
	 * @param {Object} tooltipModel
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleCssText(tooltipModel) {
	  var cssText = [];
	  var transitionDuration = tooltipModel.get('transitionDuration');
	  var backgroundColor = tooltipModel.get('backgroundColor');
	  var textStyleModel = tooltipModel.getModel('textStyle');
	  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.
	
	  transitionDuration && cssText.push(assembleTransition(transitionDuration));
	
	  if (backgroundColor) {
	    if (env.canvasSupported) {
	      cssText.push('background-Color:' + backgroundColor);
	    } else {
	      // for ie
	      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
	      cssText.push('filter:alpha(opacity=70)');
	    }
	  } // Border style
	
	
	  each(['width', 'color', 'radius'], function (name) {
	    var borderName = 'border-' + name;
	    var camelCase = toCamelCase(borderName);
	    var val = tooltipModel.get(camelCase);
	    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	  }); // Text style
	
	  cssText.push(assembleFont(textStyleModel)); // Padding
	
	  if (padding != null) {
	    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
	  }
	
	  return cssText.join(';') + ';';
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipContent
	 * @constructor
	 */
	
	
	function TooltipContent(container, api) {
	  if (env.wxa) {
	    return null;
	  }
	
	  var el = document.createElement('div');
	  var zr = this._zr = api.getZr();
	  this.el = el;
	  this._x = api.getWidth() / 2;
	  this._y = api.getHeight() / 2;
	  container.appendChild(el);
	  this._container = container;
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	  var self = this;
	
	  el.onmouseenter = function () {
	    // clear the timeout in hideLater and keep showing tooltip
	    if (self._enterable) {
	      clearTimeout(self._hideTimeout);
	      self._show = true;
	    }
	
	    self._inContent = true;
	  };
	
	  el.onmousemove = function (e) {
	    e = e || window.event;
	
	    if (!self._enterable) {
	      // Try trigger zrender event to avoid mouse
	      // in and out shape too frequently
	      var handler = zr.handler;
	      eventUtil.normalizeEvent(container, e, true);
	      handler.dispatch('mousemove', e);
	    }
	  };
	
	  el.onmouseleave = function () {
	    if (self._enterable) {
	      if (self._show) {
	        self.hideLater(self._hideDelay);
	      }
	    }
	
	    self._inContent = false;
	  };
	}
	
	TooltipContent.prototype = {
	  constructor: TooltipContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function () {
	    // FIXME
	    // Move this logic to ec main?
	    var container = this._container;
	    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
	    var domStyle = container.style;
	
	    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
	      domStyle.position = 'relative';
	    } // Hide the tooltip
	    // PENDING
	    // this.hide();
	
	  },
	  show: function (tooltipModel) {
	    clearTimeout(this._hideTimeout);
	    var el = this.el;
	    el.style.cssText = gCssText + assembleCssText(tooltipModel) // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
	    + ';left:' + this._x + 'px;top:' + this._y + 'px;' + (tooltipModel.get('extraCssText') || '');
	    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occsionally move over the tooltip, a mouseout event will be
	    // triggered by canvas, and cuase some unexpectable result like dragging
	    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
	    // it. Although it is not suppored by IE8~IE10, fortunately it is a rare
	    // scenario.
	
	    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
	    this._show = true;
	  },
	  setContent: function (content) {
	    this.el.innerHTML = content == null ? '' : content;
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var el = this.el;
	    return [el.clientWidth, el.clientHeight];
	  },
	  moveTo: function (x, y) {
	    // xy should be based on canvas root. But tooltipContent is
	    // the sibling of canvas root. So padding of ec container
	    // should be considered here.
	    var zr = this._zr;
	    var viewportRootOffset;
	
	    if (zr && zr.painter && (viewportRootOffset = zr.painter.getViewportRootOffset())) {
	      x += viewportRootOffset.offsetLeft;
	      y += viewportRootOffset.offsetTop;
	    }
	
	    var style = this.el.style;
	    style.left = x + 'px';
	    style.top = y + 'px';
	    this._x = x;
	    this._y = y;
	  },
	  hide: function () {
	    this.el.style.display = 'none';
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  getOuterSize: function () {
	    var width = this.el.clientWidth;
	    var height = this.el.clientHeight; // Consider browser compatibility.
	    // IE8 does not support getComputedStyle.
	
	    if (document.defaultView && document.defaultView.getComputedStyle) {
	      var stl = document.defaultView.getComputedStyle(this.el);
	
	      if (stl) {
	        width += parseInt(stl.paddingLeft, 10) + parseInt(stl.paddingRight, 10) + parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
	        height += parseInt(stl.paddingTop, 10) + parseInt(stl.paddingBottom, 10) + parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
	      }
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	};
	var _default = TooltipContent;
	module.exports = _default;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Text = __webpack_require__(194);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Group from 'zrender/src/container/Group';
	
	/**
	 * @alias module:echarts/component/tooltip/TooltipRichContent
	 * @constructor
	 */
	function TooltipRichContent(api) {
	  this._zr = api.getZr();
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	}
	
	TooltipRichContent.prototype = {
	  constructor: TooltipRichContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function () {// noop
	  },
	  show: function (tooltipModel) {
	    if (this._hideTimeout) {
	      clearTimeout(this._hideTimeout);
	    }
	
	    this.el.attr('show', true);
	    this._show = true;
	  },
	
	  /**
	   * Set tooltip content
	   *
	   * @param {string} content rich text string of content
	   * @param {Object} markerRich rich text style
	   * @param {Object} tooltipModel tooltip model
	   */
	  setContent: function (content, markerRich, tooltipModel) {
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	
	    var markers = {};
	    var text = content;
	    var prefix = '{marker';
	    var suffix = '|}';
	    var startId = text.indexOf(prefix);
	
	    while (startId >= 0) {
	      var endId = text.indexOf(suffix);
	      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);
	
	      if (name.indexOf('sub') > -1) {
	        markers['marker' + name] = {
	          textWidth: 4,
	          textHeight: 4,
	          textBorderRadius: 2,
	          textBackgroundColor: markerRich[name],
	          // TODO: textOffset is not implemented for rich text
	          textOffset: [3, 0]
	        };
	      } else {
	        markers['marker' + name] = {
	          textWidth: 10,
	          textHeight: 10,
	          textBorderRadius: 5,
	          textBackgroundColor: markerRich[name]
	        };
	      }
	
	      text = text.substr(endId + 1);
	      startId = text.indexOf('{marker');
	    }
	
	    this.el = new Text({
	      style: {
	        rich: markers,
	        text: content,
	        textLineHeight: 20,
	        textBackgroundColor: tooltipModel.get('backgroundColor'),
	        textBorderRadius: tooltipModel.get('borderRadius'),
	        textFill: tooltipModel.get('textStyle.color'),
	        textPadding: tooltipModel.get('padding')
	      },
	      z: tooltipModel.get('z')
	    });
	
	    this._zr.add(this.el);
	
	    var self = this;
	    this.el.on('mouseover', function () {
	      // clear the timeout in hideLater and keep showing tooltip
	      if (self._enterable) {
	        clearTimeout(self._hideTimeout);
	        self._show = true;
	      }
	
	      self._inContent = true;
	    });
	    this.el.on('mouseout', function () {
	      if (self._enterable) {
	        if (self._show) {
	          self.hideLater(self._hideDelay);
	        }
	      }
	
	      self._inContent = false;
	    });
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var bounding = this.el.getBoundingRect();
	    return [bounding.width, bounding.height];
	  },
	  moveTo: function (x, y) {
	    if (this.el) {
	      this.el.attr('position', [x, y]);
	    }
	  },
	  hide: function () {
	    this.el.hide();
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  getOuterSize: function () {
	    return this.getSize();
	  }
	};
	var _default = TooltipRichContent;
	module.exports = _default;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var barPolar = __webpack_require__(514);
	
	__webpack_require__(515);
	
	__webpack_require__(521);
	
	__webpack_require__(523);
	
	__webpack_require__(469);
	
	__webpack_require__(525);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// For reducing size of echarts.min, barLayoutPolar is required by polar.
	echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view
	
	echarts.extendComponentView({
	  type: 'polar'
	});

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(260);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutPolar(seriesType, ecModel, api) {
	  // FIXME
	  // Revert becuase it brings bar progressive bug.
	  // The complete fix will be added in the next version.
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var lastStackCoords = {};
	  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	  }));
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for polar only
	    if (seriesModel.coordinateSystem.type !== 'polar') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = polar.getOtherAxis(baseAxis);
	    var cx = seriesModel.coordinateSystem.cx;
	    var cy = seriesModel.coordinateSystem.cy;
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var barMinAngle = seriesModel.get('barMinAngle') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var valueAxisStart = valueAxis.getExtent()[0];
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	
	      if (isNaN(value)) {
	        continue;
	      }
	
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	      // Only ordinal axis can be stacked.
	
	      if (stacked) {
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var r0;
	      var r;
	      var startAngle;
	      var endAngle; // radial sector
	
	      if (valueAxis.dim === 'radius') {
	        var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
	        var angle = baseAxis.dataToAngle(baseValue);
	
	        if (Math.abs(radiusSpan) < barMinHeight) {
	          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        r0 = baseCoord;
	        r = baseCoord + radiusSpan;
	        startAngle = angle - columnOffset;
	        endAngle = startAngle - columnWidth;
	        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
	      } // tangential sector
	      else {
	          // angleAxis must be clamped.
	          var angleSpan = valueAxis.dataToAngle(value, true) - valueAxisStart;
	          var radius = baseAxis.dataToRadius(baseValue);
	
	          if (Math.abs(angleSpan) < barMinAngle) {
	            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
	          }
	
	          r0 = radius + columnOffset;
	          r = r0 + columnWidth;
	          startAngle = baseCoord;
	          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
	          // add a round to differentiate it from origin
	          // var extent = angleAxis.getExtent();
	          // var stackCoord = angle;
	          // if (stackCoord === extent[0] && value > 0) {
	          //     stackCoord = extent[1];
	          // }
	          // else if (stackCoord === extent[1] && value < 0) {
	          //     stackCoord = extent[0];
	          // }
	
	          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
	        }
	
	      data.setItemLayout(idx, {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        // Consider that positive angle is anti-clockwise,
	        // while positive radian of sector is clockwise
	        startAngle: -startAngle * Math.PI / 180,
	        endAngle: -endAngle * Math.PI / 180
	      });
	    }
	  }, this);
	}
	/**
	 * Calculate bar width and offset for radial bar charts
	 */
	
	
	function calRadialBar(barSeries, api) {
	  // Columns info on each category axis. Key is polar name
	  var columnsMap = {};
	  zrUtil.each(barSeries, function (seriesModel, idx) {
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var columnsOnAxis = columnsMap[getAxisKey(baseAxis)] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[getAxisKey(baseAxis)] = columnsOnAxis;
	    var stackId = getSeriesStackId(seriesModel);
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    };
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	
	    if (barWidth && !stacks[stackId].width) {
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      stacks[stackId].width = barWidth;
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    barGap != null && (columnsOnAxis.gap = barGap);
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	
	var _default = barLayoutPolar;
	module.exports = _default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var Polar = __webpack_require__(516);
	
	var _number = __webpack_require__(218);
	
	var parsePercent = _number.parsePercent;
	
	var _axisHelper = __webpack_require__(261);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(228);
	
	var _dataStackHelper = __webpack_require__(260);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(519);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Axis scale
	
	/**
	 * Resize method bound to the polar
	 * @param {module:echarts/coord/polar/PolarModel} polarModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizePolar(polar, polarModel, api) {
	  var center = polarModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  polar.cx = parsePercent(center[0], width);
	  polar.cy = parsePercent(center[1], height);
	  var radiusAxis = polar.getRadiusAxis();
	  var size = Math.min(width, height) / 2;
	  var radius = parsePercent(polarModel.get('radius'), size);
	  radiusAxis.inverse ? radiusAxis.setExtent(radius, 0) : radiusAxis.setExtent(0, radius);
	}
	/**
	 * Update polar
	 */
	
	
	function updatePolarScale(ecModel, api) {
	  var polar = this;
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	  angleAxis.scale.setExtent(Infinity, -Infinity);
	  radiusAxis.scale.setExtent(Infinity, -Infinity);
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.coordinateSystem === polar) {
	      var data = seriesModel.getData();
	      zrUtil.each(data.mapDimension('radius', true), function (dim) {
	        radiusAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	      zrUtil.each(data.mapDimension('angle', true), function (dim) {
	        angleAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	    }
	  });
	  niceScaleExtent(angleAxis.scale, angleAxis.model);
	  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	  if (angleAxis.type === 'category' && !angleAxis.onBand) {
	    var extent = angleAxis.getExtent();
	    var diff = 360 / angleAxis.scale.count();
	    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	    angleAxis.setExtent(extent[0], extent[1]);
	  }
	}
	/**
	 * Set common axis properties
	 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	 * @param {module:echarts/coord/polar/AxisModel}
	 * @inner
	 */
	
	
	function setAxis(axis, axisModel) {
	  axis.type = axisModel.get('type');
	  axis.scale = createScaleByModel(axisModel);
	  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	  axis.inverse = axisModel.get('inverse');
	
	  if (axisModel.mainType === 'angleAxis') {
	    axis.inverse ^= axisModel.get('clockwise');
	    var startAngle = axisModel.get('startAngle');
	    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	  } // Inject axis instance
	
	
	  axisModel.axis = axis;
	  axis.model = axisModel;
	}
	
	var polarCreator = {
	  dimensions: Polar.prototype.dimensions,
	  create: function (ecModel, api) {
	    var polarList = [];
	    ecModel.eachComponent('polar', function (polarModel, idx) {
	      var polar = new Polar(idx); // Inject resize and update method
	
	      polar.update = updatePolarScale;
	      var radiusAxis = polar.getRadiusAxis();
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	      var angleAxisModel = polarModel.findAxisModel('angleAxis');
	      setAxis(radiusAxis, radiusAxisModel);
	      setAxis(angleAxis, angleAxisModel);
	      resizePolar(polar, polarModel, api);
	      polarList.push(polar);
	      polarModel.coordinateSystem = polar;
	      polar.model = polarModel;
	    }); // Inject coordinateSystem to series
	
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.get('coordinateSystem') === 'polar') {
	        var polarModel = ecModel.queryComponents({
	          mainType: 'polar',
	          index: seriesModel.get('polarIndex'),
	          id: seriesModel.get('polarId')
	        })[0];
	        seriesModel.coordinateSystem = polarModel.coordinateSystem;
	      }
	    });
	    return polarList;
	  }
	};
	CoordinateSystem.register('polar', polarCreator);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var RadiusAxis = __webpack_require__(517);
	
	var AngleAxis = __webpack_require__(518);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/polar/Polar
	 */
	
	/**
	 * @alias {module:echarts/coord/polar/Polar}
	 * @constructor
	 * @param {string} name
	 */
	var Polar = function (name) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * x of polar center
	   * @type {number}
	   */
	
	  this.cx = 0;
	  /**
	   * y of polar center
	   * @type {number}
	   */
	
	  this.cy = 0;
	  /**
	   * @type {module:echarts/coord/polar/RadiusAxis}
	   * @private
	   */
	
	  this._radiusAxis = new RadiusAxis();
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis}
	   * @private
	   */
	
	  this._angleAxis = new AngleAxis();
	  this._radiusAxis.polar = this._angleAxis.polar = this;
	};
	
	Polar.prototype = {
	  type: 'polar',
	  axisPointerEnabled: true,
	  constructor: Polar,
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['radius', 'angle'],
	
	  /**
	   * @type {module:echarts/coord/PolarModel}
	   */
	  model: null,
	
	  /**
	   * If contain coord
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var coord = this.pointToCoord(point);
	    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	  },
	
	  /**
	   * @param {string} dim
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxis: function (dim) {
	    return this['_' + dim + 'Axis'];
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._radiusAxis, this._angleAxis];
	  },
	
	  /**
	   * Get axes by type of scale
	   * @param {string} scaleType
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxesByScale: function (scaleType) {
	    var axes = [];
	    var angleAxis = this._angleAxis;
	    var radiusAxis = this._radiusAxis;
	    angleAxis.scale.type === scaleType && axes.push(angleAxis);
	    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	    return axes;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/AngleAxis}
	   */
	  getAngleAxis: function () {
	    return this._angleAxis;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/RadiusAxis}
	   */
	  getRadiusAxis: function () {
	    return this._radiusAxis;
	  },
	
	  /**
	   * @param {module:echarts/coord/polar/Axis}
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getOtherAxis: function (axis) {
	    var angleAxis = this._angleAxis;
	    return axis === angleAxis ? this._radiusAxis : angleAxis;
	  },
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	  },
	
	  /**
	   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function (dim) {
	    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	    return {
	      baseAxes: [baseAxis],
	      otherAxes: [this.getOtherAxis(baseAxis)]
	    };
	  },
	
	  /**
	   * Convert a single data item to (x, y) point.
	   * Parameter data is an array which the first element is radius and the second is angle
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	  },
	
	  /**
	   * Convert a (x, y) point to data
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var coord = this.pointToCoord(point);
	    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	  },
	
	  /**
	   * Convert a (x, y) point to (radius, angle) coord
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToCoord: function (point) {
	    var dx = point[0] - this.cx;
	    var dy = point[1] - this.cy;
	    var angleAxis = this.getAngleAxis();
	    var extent = angleAxis.getExtent();
	    var minAngle = Math.min(extent[0], extent[1]);
	    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	    // FIXME
	
	    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	    var radius = Math.sqrt(dx * dx + dy * dy);
	    dx /= radius;
	    dy /= radius;
	    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	    var dir = radian < minAngle ? 1 : -1;
	
	    while (radian < minAngle || radian > maxAngle) {
	      radian += dir * 360;
	    }
	
	    return [radius, radian];
	  },
	
	  /**
	   * Convert a (radius, angle) coord to (x, y) point
	   * @param {Array.<number>} coord
	   * @return {Array.<number>}
	   */
	  coordToPoint: function (coord) {
	    var radius = coord[0];
	    var radian = coord[1] / 180 * Math.PI;
	    var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	    var y = -Math.sin(radian) * radius + this.cy;
	    return [x, y];
	  }
	};
	var _default = Polar;
	module.exports = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Axis = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function RadiusAxis(scale, radiusExtent) {
	  Axis.call(this, 'radius', scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	RadiusAxis.prototype = {
	  constructor: RadiusAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToRadius: Axis.prototype.dataToCoord,
	  radiusToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(RadiusAxis, Axis);
	var _default = RadiusAxis;
	module.exports = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var textContain = __webpack_require__(167);
	
	var Axis = __webpack_require__(275);
	
	var _model = __webpack_require__(173);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function AngleAxis(scale, angleExtent) {
	  angleExtent = angleExtent || [0, 360];
	  Axis.call(this, 'angle', scale, angleExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	AngleAxis.prototype = {
	  constructor: AngleAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToAngle: Axis.prototype.dataToCoord,
	  angleToData: Axis.prototype.coordToData,
	
	  /**
	   * Only be called in category axis.
	   * Angle axis uses text height to decide interval
	   *
	   * @override
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    var axis = this;
	    var labelModel = axis.getLabelModel();
	    var ordinalScale = axis.scale;
	    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	    // avoid generating a long array by `getTicks`
	    // in large category data case.
	
	    var tickCount = ordinalScale.count();
	
	    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	      return 0;
	    }
	
	    var tickValue = ordinalExtent[0];
	    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(tickValue, labelModel.getFont(), 'center', 'top');
	    var maxH = Math.max(rect.height, 7);
	    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	    isNaN(dh) && (dh = Infinity);
	    var interval = Math.max(0, Math.floor(dh));
	    var cache = inner(axis.model);
	    var lastAutoInterval = cache.lastAutoInterval;
	    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	    // otherwise the calculated interval might jitter when the zoom
	    // window size is close to the interval-changing size.
	
	    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	    // point is not the same when zooming in or zooming out.
	    && lastAutoInterval > interval) {
	      interval = lastAutoInterval;
	    } // Only update cache if cache not used, otherwise the
	    // changing of interval is too insensitive.
	    else {
	        cache.lastTickCount = tickCount;
	        cache.lastAutoInterval = interval;
	      }
	
	    return interval;
	  }
	};
	zrUtil.inherits(AngleAxis, Axis);
	var _default = AngleAxis;
	module.exports = _default;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(520);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'polar',
	  dependencies: ['polarAxis', 'angleAxis'],
	
	  /**
	   * @type {module:echarts/coord/polar/Polar}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @param {string} axisType
	   * @return {module:echarts/coord/polar/AxisModel}
	   */
	  findAxisModel: function (axisType) {
	    var foundAxisModel;
	    var ecModel = this.ecModel;
	    ecModel.eachComponent(axisType, function (axisModel) {
	      if (axisModel.getCoordSysModel() === this) {
	        foundAxisModel = axisModel;
	      }
	    }, this);
	    return foundAxisModel;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '80%'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ComponentModel = __webpack_require__(215);
	
	var axisModelCreator = __webpack_require__(296);
	
	var axisModelCommonMixin = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisModel = ComponentModel.extend({
	  type: 'polarAxis',
	
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'polar',
	      index: this.option.polarIndex,
	      id: this.option.polarId
	    })[0];
	  }
	});
	zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
	var polarAxisDefaultExtendedOption = {
	  angle: {
	    // polarIndex: 0,
	    // polarId: '',
	    startAngle: 90,
	    clockwise: true,
	    splitNumber: 12,
	    axisLabel: {
	      rotate: false
	    }
	  },
	  radius: {
	    // polarIndex: 0,
	    // polarId: '',
	    splitNumber: 5
	  }
	};
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
	axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(515);
	
	__webpack_require__(522);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var Model = __webpack_require__(174);
	
	var AxisView = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisLabel', 'axisTick', 'splitLine', 'splitArea'];
	
	function getAxisLineShape(polar, rExtent, angle) {
	  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	  var start = polar.coordToPoint([rExtent[0], angle]);
	  var end = polar.coordToPoint([rExtent[1], angle]);
	  return {
	    x1: start[0],
	    y1: start[1],
	    x2: end[0],
	    y2: end[1]
	  };
	}
	
	function getRadiusIdx(polar) {
	  var radiusAxis = polar.getRadiusAxis();
	  return radiusAxis.inverse ? 0 : 1;
	} // Remove the last tick which will overlap the first tick
	
	
	function fixAngleOverlap(list) {
	  var firstItem = list[0];
	  var lastItem = list[list.length - 1];
	
	  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
	    list.pop();
	  }
	}
	
	var _default = AxisView.extend({
	  type: 'angleAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (angleAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!angleAxisModel.get('show')) {
	      return;
	    }
	
	    var angleAxis = angleAxisModel.axis;
	    var polar = angleAxis.polar;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var ticksAngles = angleAxis.getTicksCoords();
	    var labels = zrUtil.map(angleAxis.getViewLabels(), function (labelItem) {
	      var labelItem = zrUtil.clone(labelItem);
	      labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
	      return labelItem;
	    });
	    fixAngleOverlap(labels);
	    fixAngleOverlap(ticksAngles);
	    zrUtil.each(elementList, function (name) {
	      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	        this['_' + name](angleAxisModel, polar, ticksAngles, radiusExtent, labels);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _axisLine: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle');
	    var circle = new graphic.Circle({
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: radiusExtent[getRadiusIdx(polar)]
	      },
	      style: lineStyleModel.getLineStyle(),
	      z2: 1,
	      silent: true
	    });
	    circle.style.fill = null;
	    this.group.add(circle);
	  },
	
	  /**
	   * @private
	   */
	  _axisTick: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = zrUtil.map(ticksAngles, function (tickAngleItem) {
	      return new graphic.Line({
	        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
	      });
	    });
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      })
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _axisLabel: function (angleAxisModel, polar, ticksAngles, radiusExtent, labels) {
	    var rawCategoryData = angleAxisModel.getCategories(true);
	    var commonLabelModel = angleAxisModel.getModel('axisLabel');
	    var labelMargin = commonLabelModel.get('margin'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	    zrUtil.each(labels, function (labelItem, idx) {
	      var labelModel = commonLabelModel;
	      var tickValue = labelItem.tickValue;
	      var r = radiusExtent[getRadiusIdx(polar)];
	      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
	      var cx = polar.cx;
	      var cy = polar.cy;
	      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	      if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	        labelModel = new Model(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
	      }
	
	      var textEl = new graphic.Text({
	        silent: true
	      });
	      this.group.add(textEl);
	      graphic.setTextStyle(textEl.style, labelModel, {
	        x: p[0],
	        y: p[1],
	        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
	        text: labelItem.formattedLabel,
	        textAlign: labelTextAlign,
	        textVerticalAlign: labelTextVerticalAlign
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    var splitLineModel = angleAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length]
	        }, lineStyleModel.getLineStyle()),
	        silent: true,
	        z: angleAxisModel.get('z')
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (angleAxisModel, polar, ticksAngles, radiusExtent) {
	    if (!ticksAngles.length) {
	      return;
	    }
	
	    var splitAreaModel = angleAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var RADIAN = Math.PI / 180;
	    var prevAngle = -ticksAngles[0].coord * RADIAN;
	    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	    var clockwise = angleAxisModel.get('clockwise');
	
	    for (var i = 1; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: r0,
	          r: r1,
	          startAngle: prevAngle,
	          endAngle: -ticksAngles[i].coord * RADIAN,
	          clockwise: clockwise
	        },
	        silent: true
	      }));
	      prevAngle = -ticksAngles[i].coord * RADIAN;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(515);
	
	__webpack_require__(524);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var AxisBuilder = __webpack_require__(300);
	
	var AxisView = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitLine', 'splitArea'];
	
	var _default = AxisView.extend({
	  type: 'radiusAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (radiusAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!radiusAxisModel.get('show')) {
	      return;
	    }
	
	    var radiusAxis = radiusAxisModel.axis;
	    var polar = radiusAxis.polar;
	    var angleAxis = polar.getAngleAxis();
	    var ticksCoords = radiusAxis.getTicksCoords();
	    var axisAngle = angleAxis.getExtent()[0];
	    var radiusExtent = radiusAxis.getExtent();
	    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    this.group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
	        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitLineModel = radiusAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: ticksCoords[i].coord
	        },
	        silent: true
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length],
	          fill: null
	        }, lineStyleModel.getLineStyle()),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    if (!ticksCoords.length) {
	      return;
	    }
	
	    var splitAreaModel = radiusAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var prevRadius = ticksCoords[0].coord;
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: prevRadius,
	          r: ticksCoords[i].coord,
	          startAngle: 0,
	          endAngle: Math.PI * 2
	        },
	        silent: true
	      }));
	      prevRadius = ticksCoords[i].coord;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	/**
	 * @inner
	 */
	
	
	function layoutAxis(polar, radiusAxisModel, axisAngle) {
	  return {
	    position: [polar.cx, polar.cy],
	    rotation: axisAngle / 180 * Math.PI,
	    labelDirection: -1,
	    tickDirection: -1,
	    nameDirection: 1,
	    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	    // Over splitLine and splitArea
	    z2: 1
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var formatUtil = __webpack_require__(219);
	
	var BaseAxisPointer = __webpack_require__(476);
	
	var graphic = __webpack_require__(180);
	
	var viewHelper = __webpack_require__(477);
	
	var matrix = __webpack_require__(145);
	
	var AxisBuilder = __webpack_require__(300);
	
	var AxisView = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	
	    if (axis.dim === 'angle') {
	      this.animationThreshold = Math.PI / 18;
	    }
	
	    var polar = axis.polar;
	    var otherAxis = polar.getOtherAxis(axis);
	    var otherExtent = otherAxis.getExtent();
	    var coordValue;
	    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var labelMargin = axisPointerModel.get('label.margin');
	    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	  } // Do not support handle, utill any user requires it.
	
	});
	
	function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	  var axis = axisModel.axis;
	  var coord = axis.dataToCoord(value);
	  var axisAngle = polar.getAngleAxis().getExtent()[0];
	  axisAngle = axisAngle / 180 * Math.PI;
	  var radiusExtent = polar.getRadiusAxis().getExtent();
	  var position;
	  var align;
	  var verticalAlign;
	
	  if (axis.dim === 'radius') {
	    var transform = matrix.create();
	    matrix.rotate(transform, transform, axisAngle);
	    matrix.translate(transform, transform, [polar.cx, polar.cy]);
	    position = graphic.applyTransform([coord, -labelMargin], transform);
	    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
	    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	    align = labelLayout.textAlign;
	    verticalAlign = labelLayout.textVerticalAlign;
	  } else {
	    // angle axis
	    var r = radiusExtent[1];
	    position = polar.coordToPoint([r + labelMargin, coord]);
	    var cx = polar.cx;
	    var cy = polar.cy;
	    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	  }
	
	  return {
	    position: position,
	    align: align,
	    verticalAlign: verticalAlign
	  };
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, polar, coordValue, otherExtent, elStyle) {
	    return axis.dim === 'angle' ? {
	      type: 'Line',
	      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	    } : {
	      type: 'Circle',
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: coordValue
	      }
	    };
	  },
	  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var radian = Math.PI / 180;
	    return axis.dim === 'angle' ? {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	    } : {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	    };
	  }
	};
	AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	var _default = PolarAxisPointer;
	module.exports = _default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	__webpack_require__(527);
	
	__webpack_require__(351);
	
	__webpack_require__(528);
	
	__webpack_require__(349);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeAction(method, actionInfo) {
	  actionInfo.update = 'updateView';
	  echarts.registerAction(actionInfo, function (payload, ecModel) {
	    var selected = {};
	    ecModel.eachComponent({
	      mainType: 'geo',
	      query: payload
	    }, function (geoModel) {
	      geoModel[method](payload.name);
	      var geo = geoModel.coordinateSystem;
	      zrUtil.each(geo.regions, function (region) {
	        selected[region.name] = geoModel.isSelected(region.name) || false;
	      });
	    });
	    return {
	      selected: selected,
	      name: payload.name
	    };
	  });
	}
	
	makeAction('toggleSelected', {
	  type: 'geoToggleSelect',
	  event: 'geoselectchanged'
	});
	makeAction('select', {
	  type: 'geoSelect',
	  event: 'geoselected'
	});
	makeAction('unSelect', {
	  type: 'geoUnSelect',
	  event: 'geounselected'
	});

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var modelUtil = __webpack_require__(173);
	
	var ComponentModel = __webpack_require__(215);
	
	var Model = __webpack_require__(174);
	
	var selectableMixin = __webpack_require__(313);
	
	var geoCreator = __webpack_require__(351);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GeoModel = ComponentModel.extend({
	  type: 'geo',
	
	  /**
	   * @type {module:echarts/coord/geo/Geo}
	   */
	  coordinateSystem: null,
	  layoutMode: 'box',
	  init: function (option) {
	    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	    var self = this;
	    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
	    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
	      if (regionOpt.name) {
	        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
	      }
	
	      return optionModelMap;
	    }, zrUtil.createHashMap());
	    this.updateSelectedMap(option.regions);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    show: true,
	    left: 'center',
	    top: 'center',
	    // width:,
	    // height:,
	    // right
	    // bottom
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    // If svg used, aspectScale is 1 by default.
	    // aspectScale: 0.75,
	    aspectScale: null,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    silent: false,
	    // Map type
	    map: '',
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ]
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    // selectedMode: false
	    label: {
	      show: false,
	      color: '#000'
	    },
	    itemStyle: {
	      // color: 各异,
	      borderWidth: 0.5,
	      borderColor: '#444',
	      color: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        color: 'rgba(255,215,0,0.8)'
	      }
	    },
	    regions: []
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (name) {
	    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	  },
	
	  /**
	   * Format label
	   * @param {string} name Region name
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @return {string}
	   */
	  getFormattedLabel: function (name, status) {
	    var regionModel = this.getRegionModel(name);
	    var formatter = regionModel.get('label.' + status + '.formatter');
	    var params = {
	      name: name
	    };
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatter.replace('{a}', name != null ? name : '');
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  }
	});
	zrUtil.mixin(GeoModel, selectableMixin);
	var _default = GeoModel;
	module.exports = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MapDraw = __webpack_require__(344);
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'geo',
	  init: function (ecModel, api) {
	    var mapDraw = new MapDraw(api, true);
	    this._mapDraw = mapDraw;
	    this.group.add(mapDraw.group);
	  },
	  render: function (geoModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var mapDraw = this._mapDraw;
	
	    if (geoModel.get('show')) {
	      mapDraw.draw(geoModel, ecModel, api, this, payload);
	    } else {
	      this._mapDraw.group.removeAll();
	    }
	
	    this.group.silent = geoModel.get('silent');
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var preprocessor = __webpack_require__(530);
	
	__webpack_require__(531);
	
	__webpack_require__(535);
	
	__webpack_require__(536);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Brush component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	
	function _default(option, isNew) {
	  var brushComponents = option && option.brush;
	
	  if (!zrUtil.isArray(brushComponents)) {
	    brushComponents = brushComponents ? [brushComponents] : [];
	  }
	
	  if (!brushComponents.length) {
	    return;
	  }
	
	  var brushComponentSpecifiedBtns = [];
	  zrUtil.each(brushComponents, function (brushOpt) {
	    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	    if (tbs instanceof Array) {
	      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	    }
	  });
	  var toolbox = option && option.toolbox;
	
	  if (zrUtil.isArray(toolbox)) {
	    toolbox = toolbox[0];
	  }
	
	  if (!toolbox) {
	    toolbox = {
	      feature: {}
	    };
	    option.toolbox = [toolbox];
	  }
	
	  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	  removeDuplicate(brushTypes);
	
	  if (isNew && !brushTypes.length) {
	    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	  }
	}
	
	function removeDuplicate(arr) {
	  var map = {};
	  zrUtil.each(arr, function (val) {
	    map[val] = 1;
	  });
	  arr.length = 0;
	  zrUtil.each(map, function (flag, val) {
	    arr.push(val);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var BoundingRect = __webpack_require__(154);
	
	var visualSolution = __webpack_require__(532);
	
	var selector = __webpack_require__(533);
	
	var throttleUtil = __webpack_require__(240);
	
	var BrushTargetManager = __webpack_require__(534);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var STATE_LIST = ['inBrush', 'outOfBrush'];
	var DISPATCH_METHOD = '__ecBrushSelect';
	var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
	/**
	 * Layout for visual, the priority higher than other layout, and before brush visual.
	 */
	
	echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	      brushType: false
	    });
	    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	  });
	});
	/**
	 * Register the visual encoding if this modules required.
	 */
	
	echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  var brushSelected = [];
	  var throttleType;
	  var throttleDelay;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel, brushIndex) {
	    var thisBrushSelected = {
	      brushId: brushModel.id,
	      brushIndex: brushIndex,
	      brushName: brushModel.name,
	      areas: zrUtil.clone(brushModel.areas),
	      selected: []
	    }; // Every brush component exists in event params, convenient
	    // for user to find by index.
	
	    brushSelected.push(thisBrushSelected);
	    var brushOption = brushModel.option;
	    var brushLink = brushOption.brushLink;
	    var linkedSeriesMap = [];
	    var selectedDataIndexForLink = [];
	    var rangeInfoBySeries = [];
	    var hasBrushExists = 0;
	
	    if (!brushIndex) {
	      // Only the first throttle setting works.
	      throttleType = brushOption.throttleType;
	      throttleDelay = brushOption.throttleDelay;
	    } // Add boundingRect and selectors to range.
	
	
	    var areas = zrUtil.map(brushModel.areas, function (area) {
	      return bindSelector(zrUtil.defaults({
	        boundingRect: boundingRectBuilders[area.brushType](area)
	      }, area));
	    });
	    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	      mappingOption.mappingMethod = 'fixed';
	    });
	    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
	      linkedSeriesMap[seriesIndex] = 1;
	    });
	
	    function linkOthers(seriesIndex) {
	      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
	    } // If no supported brush or no brush on the series,
	    // all visuals should be in original state.
	
	
	    function brushed(rangeInfoList) {
	      return !!rangeInfoList.length;
	    }
	    /**
	     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	     *
	     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	     *   !brushed┘                                                                  └nothing.
	     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	     */
	    // Step A
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	    });
	
	    function stepAParallel(seriesModel, seriesIndex) {
	      var coordSys = seriesModel.coordinateSystem;
	      hasBrushExists |= coordSys.hasAxisBrushed();
	      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	      });
	    }
	
	    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	
	      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
	        return;
	      }
	
	      zrUtil.each(areas, function (area) {
	        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
	        hasBrushExists |= brushed(rangeInfoList);
	      });
	
	      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	        var data = seriesModel.getData();
	        data.each(function (dataIndex) {
	          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
	            selectedDataIndexForLink[dataIndex] = 1;
	          }
	        });
	      }
	    } // Step B
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var seriesBrushSelected = {
	        seriesId: seriesModel.id,
	        seriesIndex: seriesIndex,
	        seriesName: seriesModel.name,
	        dataIndex: []
	      }; // Every series exists in event params, convenient
	      // for user to find series by seriesIndex.
	
	      thisBrushSelected.selected.push(seriesBrushSelected);
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	      var rangeInfoList = rangeInfoBySeries[seriesIndex];
	      var data = seriesModel.getData();
	      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      } : function (dataIndex) {
	        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      }; // If no supported brush or no brush, all visuals are in original state.
	
	      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
	    });
	  });
	  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	});
	
	function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	  // This event will not be triggered when `setOpion`, otherwise dead lock may
	  // triggered when do `setOption` in event listener, which we do not find
	  // satisfactory way to solve yet. Some considered resolutions:
	  // (a) Diff with prevoius selected data ant only trigger event when changed.
	  // But store previous data and diff precisely (i.e., not only by dataIndex, but
	  // also detect value changes in selected data) might bring complexity or fragility.
	  // (b) Use spectial param like `silent` to suppress event triggering.
	  // But such kind of volatile param may be weird in `setOption`.
	  if (!payload) {
	    return;
	  }
	
	  var zr = api.getZr();
	
	  if (zr[DISPATCH_FLAG]) {
	    return;
	  }
	
	  if (!zr[DISPATCH_METHOD]) {
	    zr[DISPATCH_METHOD] = doDispatch;
	  }
	
	  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	  fn(api, brushSelected);
	}
	
	function doDispatch(api, brushSelected) {
	  if (!api.isDisposed()) {
	    var zr = api.getZr();
	    zr[DISPATCH_FLAG] = true;
	    api.dispatchAction({
	      type: 'brushSelect',
	      batch: brushSelected
	    });
	    zr[DISPATCH_FLAG] = false;
	  }
	}
	
	function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
	  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	    var area = rangeInfoList[i];
	
	    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
	      return true;
	    }
	  }
	}
	
	function getSelectorsByBrushType(seriesModel) {
	  var brushSelector = seriesModel.brushSelector;
	
	  if (zrUtil.isString(brushSelector)) {
	    var sels = [];
	    zrUtil.each(selector, function (selectorsByElementType, brushType) {
	      sels[brushType] = function (dataIndex, data, selectors, area) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
	      };
	    });
	    return sels;
	  } else if (zrUtil.isFunction(brushSelector)) {
	    var bSelector = {};
	    zrUtil.each(selector, function (sel, brushType) {
	      bSelector[brushType] = brushSelector;
	    });
	    return bSelector;
	  }
	
	  return brushSelector;
	}
	
	function brushModelNotControll(brushModel, seriesIndex) {
	  var seriesIndices = brushModel.option.seriesIndex;
	  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	}
	
	function bindSelector(area) {
	  var selectors = area.selectors = {};
	  zrUtil.each(selector[area.brushType], function (selFn, elType) {
	    // Do not use function binding or curry for performance.
	    selectors[elType] = function (itemLayout) {
	      return selFn(itemLayout, selectors, area);
	    };
	  });
	  return area;
	}
	
	var boundingRectBuilders = {
	  lineX: zrUtil.noop,
	  lineY: zrUtil.noop,
	  rect: function (area) {
	    return getBoundingRectFromMinMax(area.range);
	  },
	  polygon: function (area) {
	    var minMax;
	    var range = area.range;
	
	    for (var i = 0, len = range.length; i < len; i++) {
	      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	      var rg = range[i];
	      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	    }
	
	    return minMax && getBoundingRectFromMinMax(minMax);
	  }
	};
	
	function getBoundingRectFromMinMax(minMax) {
	  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var VisualMapping = __webpack_require__(375);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual solution, for consistent option specification.
	 */
	var each = zrUtil.each;
	
	function hasKeys(obj) {
	  if (obj) {
	    for (var name in obj) {
	      if (obj.hasOwnProperty(name)) {
	        return true;
	      }
	    }
	  }
	}
	/**
	 * @param {Object} option
	 * @param {Array.<string>} stateList
	 * @param {Function} [supplementVisualOption]
	 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
	 */
	
	
	function createVisualMappings(option, stateList, supplementVisualOption) {
	  var visualMappings = {};
	  each(stateList, function (state) {
	    var mappings = visualMappings[state] = createMappings();
	    each(option[state], function (visualData, visualType) {
	      if (!VisualMapping.isValidType(visualType)) {
	        return;
	      }
	
	      var mappingOption = {
	        type: visualType,
	        visual: visualData
	      };
	      supplementVisualOption && supplementVisualOption(mappingOption, state);
	      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	      // is not supported, such as rendering using gradient color.
	
	      if (visualType === 'opacity') {
	        mappingOption = zrUtil.clone(mappingOption);
	        mappingOption.type = 'colorAlpha';
	        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	      }
	    });
	  });
	  return visualMappings;
	
	  function createMappings() {
	    var Creater = function () {}; // Make sure hidden fields will not be visited by
	    // object iteration (with hasOwnProperty checking).
	
	
	    Creater.prototype.__hidden = Creater.prototype;
	    var obj = new Creater();
	    return obj;
	  }
	}
	/**
	 * @param {Object} thisOption
	 * @param {Object} newOption
	 * @param {Array.<string>} keys
	 */
	
	
	function replaceVisualOption(thisOption, newOption, keys) {
	  // Visual attributes merge is not supported, otherwise it
	  // brings overcomplicated merge logic. See #2853. So if
	  // newOption has anyone of these keys, all of these keys
	  // will be reset. Otherwise, all keys remain.
	  var has;
	  zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      has = true;
	    }
	  });
	  has && zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      thisOption[key] = zrUtil.clone(newOption[key]);
	    } else {
	      delete thisOption[key];
	    }
	  });
	}
	/**
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {module:echarts/data/List} list
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {object} [scope] Scope for getValueState
	 * @param {string} [dimension] Concrete dimension, if used.
	 */
	// ???! handle brush?
	
	
	function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	  var dataIndex;
	
	  function getVisual(key) {
	    return data.getItemVisual(dataIndex, key);
	  }
	
	  function setVisual(key, value) {
	    data.setItemVisual(dataIndex, key, value);
	  }
	
	  if (dimension == null) {
	    data.each(eachItem);
	  } else {
	    data.each([dimension], eachItem);
	  }
	
	  function eachItem(valueOrIndex, index) {
	    dataIndex = dimension == null ? valueOrIndex : index;
	    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	    if (rawDataItem && rawDataItem.visualMap === false) {
	      return;
	    }
	
	    var valueState = getValueState.call(scope, valueOrIndex);
	    var mappings = visualMappings[valueState];
	    var visualTypes = visualTypesMap[valueState];
	
	    for (var i = 0, len = visualTypes.length; i < len; i++) {
	      var type = visualTypes[i];
	      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {number} [dim] dimension or dimension index.
	 */
	
	
	function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	
	  function progress(params, data) {
	    if (dim != null) {
	      dim = data.getDimension(dim);
	    }
	
	    function getVisual(key) {
	      return data.getItemVisual(dataIndex, key);
	    }
	
	    function setVisual(key, value) {
	      data.setItemVisual(dataIndex, key, value);
	    }
	
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	      if (rawDataItem && rawDataItem.visualMap === false) {
	        continue;
	      }
	
	      var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
	      var valueState = getValueState(value);
	      var mappings = visualMappings[valueState];
	      var visualTypes = visualTypesMap[valueState];
	
	      for (var i = 0, len = visualTypes.length; i < len; i++) {
	        var type = visualTypes[i];
	        mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
	      }
	    }
	  }
	
	  return {
	    progress: progress
	  };
	}
	
	exports.createVisualMappings = createVisualMappings;
	exports.replaceVisualOption = replaceVisualOption;
	exports.applyVisual = applyVisual;
	exports.incrementalApplyVisual = incrementalApplyVisual;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var polygonContain = __webpack_require__(274);
	
	var BoundingRect = __webpack_require__(154);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Key of the first level is brushType: `line`, `rect`, `polygon`.
	// Key of the second level is chart element type: `point`, `rect`.
	// See moudule:echarts/component/helper/BrushController
	// function param:
	//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
	//      {Object} selectors {point: selector, rect: selector, ...}
	//      {Object} area {range: [[], [], ..], boudingRect}
	// function return:
	//      {boolean} Whether in the given brush.
	var selector = {
	  lineX: getLineSelectors(0),
	  lineY: getLineSelectors(1),
	  rect: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.intersect(itemLayout);
	    }
	  },
	  polygon: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      var points = area.range;
	
	      if (!itemLayout || points.length <= 1) {
	        return false;
	      }
	
	      var x = itemLayout.x;
	      var y = itemLayout.y;
	      var width = itemLayout.width;
	      var height = itemLayout.height;
	      var p = points[0];
	
	      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || lineIntersectPolygon(x, y, x + width, y, points) || lineIntersectPolygon(x, y, x, y + height, points) || lineIntersectPolygon(x + width, y, x + width, y + height, points) || lineIntersectPolygon(x, y + height, x + width, y + height, points)) {
	        return true;
	      }
	    }
	  }
	};
	
	function getLineSelectors(xyIndex) {
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  return {
	    point: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var p = itemLayout[xyIndex];
	        return inLineRange(p, range);
	      }
	    },
	    rect: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	      }
	    }
	  };
	}
	
	function inLineRange(p, range) {
	  return range[0] <= p && p <= range[1];
	}
	
	function lineIntersectPolygon(lx, ly, l2x, l2y, points) {
	  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	    var p = points[i];
	
	    if (lineIntersect(lx, ly, l2x, l2y, p[0], p[1], p2[0], p2[1])) {
	      return true;
	    }
	
	    p2 = p;
	  }
	} // Code from <http://blog.csdn.net/rickliuxiao/article/details/6259322> with some fix.
	// See <https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection>
	
	
	function lineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	  var delta = determinant(a2x - a1x, b1x - b2x, a2y - a1y, b1y - b2y);
	
	  if (nearZero(delta)) {
	    // parallel
	    return false;
	  }
	
	  var namenda = determinant(b1x - a1x, b1x - b2x, b1y - a1y, b1y - b2y) / delta;
	
	  if (namenda < 0 || namenda > 1) {
	    return false;
	  }
	
	  var miu = determinant(a2x - a1x, b1x - a1x, a2y - a1y, b1y - a1y) / delta;
	
	  if (miu < 0 || miu > 1) {
	    return false;
	  }
	
	  return true;
	}
	
	function nearZero(val) {
	  return val <= 1e-6 && val >= -1e-6;
	}
	
	function determinant(v1, v2, v3, v4) {
	  return v1 * v4 - v2 * v3;
	}
	
	var _default = selector;
	module.exports = _default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var modelUtil = __webpack_require__(173);
	
	var brushHelper = __webpack_require__(419);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var indexOf = zrUtil.indexOf;
	var curry = zrUtil.curry;
	var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
	// how to genarialize to more coordinate systems.
	
	var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	/**
	 * [option in constructor]:
	 * {
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 * }
	 *
	 *
	 * [targetInfo]:
	 *
	 * There can be multiple axes in a single targetInfo. Consider the case
	 * of `grid` component, a targetInfo represents a grid which contains one or more
	 * cartesian and one or more axes. And consider the case of parallel system,
	 * which has multiple axes in a coordinate system.
	 * Can be {
	 *     panelId: ...,
	 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
	 *     coordSyses: all cartesians.
	 *     gridModel: <grid component>
	 *     xAxes: correspond to coordSyses on index
	 *     yAxes: correspond to coordSyses on index
	 * }
	 * or {
	 *     panelId: ...,
	 *     coordSys: <geo coord sys>
	 *     coordSyses: [<geo coord sys>]
	 *     geoModel: <geo component>
	 * }
	 *
	 *
	 * [panelOpt]:
	 *
	 * Make from targetInfo. Input to BrushController.
	 * {
	 *     panelId: ...,
	 *     rect: ...
	 * }
	 *
	 *
	 * [area]:
	 *
	 * Generated by BrushController or user input.
	 * {
	 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
	 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 *     range: pixel range.
	 *     coordRange: representitive coord range (the first one of coordRanges).
	 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
	 * }
	 */
	
	/**
	 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
	 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} [opt]
	 * @param {Array.<string>} [opt.include] include coordinate system types.
	 */
	
	function BrushTargetManager(option, ecModel, opt) {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  var targetInfoList = this._targetInfoList = [];
	  var info = {};
	  var foundCpts = parseFinder(ecModel, option);
	  each(targetInfoBuilders, function (builder, type) {
	    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	      builder(foundCpts, targetInfoList, info);
	    }
	  });
	}
	
	var proto = BrushTargetManager.prototype;
	
	proto.setOutputRanges = function (areas, ecModel) {
	  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	    if (!area.coordRange) {
	      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	      // rebuild range by coordRange accrately, which may bring trouble when
	      // brushing only one item. So we use __rangeOffset to rebuilding range
	      // by coordRange. And this it only used in brush component so it is no
	      // need to be adapted to coordRanges.
	
	      var result = coordConvert[area.brushType](0, coordSys, coordRange);
	      area.__rangeOffset = {
	        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	        xyMinMax: result.xyMinMax
	      };
	    }
	  });
	};
	
	proto.matchOutputRanges = function (areas, ecModel, cb) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	
	    if (targetInfo && targetInfo !== true) {
	      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
	        var result = coordConvert[area.brushType](1, coordSys, area.range);
	        cb(area, result.values, coordSys, ecModel);
	      });
	    }
	  }, this);
	};
	
	proto.setInputRanges = function (areas, ecModel) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	    area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	    if (targetInfo && targetInfo !== true) {
	      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
	      // not keep its original value, for the sake of the dataZoom scenario,
	      // where area.coordRange remains unchanged but area.range may be changed.
	      // (2) Only support converting one coordRange to pixel range in brush
	      // component. So do not consider `coordRanges`.
	      // (3) About __rangeOffset, see comment above.
	
	      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	      var rangeOffset = area.__rangeOffset;
	      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	    }
	  }, this);
	};
	
	proto.makePanelOpts = function (api, getDefaultBrushType) {
	  return zrUtil.map(this._targetInfoList, function (targetInfo) {
	    var rect = targetInfo.getPanelRect();
	    return {
	      panelId: targetInfo.panelId,
	      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
	    };
	  });
	};
	
	proto.controlSeries = function (area, seriesModel, ecModel) {
	  // Check whether area is bound in coord, and series do not belong to that coord.
	  // If do not do this check, some brush (like lineX) will controll all axes.
	  var targetInfo = this.findTargetInfo(area, ecModel);
	  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	};
	/**
	 * If return Object, a coord found.
	 * If reutrn true, global found.
	 * Otherwise nothing found.
	 *
	 * @param {Object} area
	 * @param {Array} targetInfoList
	 * @return {Object|boolean}
	 */
	
	
	proto.findTargetInfo = function (area, ecModel) {
	  var targetInfoList = this._targetInfoList;
	  var foundCpts = parseFinder(ecModel, area);
	
	  for (var i = 0; i < targetInfoList.length; i++) {
	    var targetInfo = targetInfoList[i];
	    var areaPanelId = area.panelId;
	
	    if (areaPanelId) {
	      if (targetInfo.panelId === areaPanelId) {
	        return targetInfo;
	      }
	    } else {
	      for (var i = 0; i < targetInfoMatchers.length; i++) {
	        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
	          return targetInfo;
	        }
	      }
	    }
	  }
	
	  return true;
	};
	
	function formatMinMax(minMax) {
	  minMax[0] > minMax[1] && minMax.reverse();
	  return minMax;
	}
	
	function parseFinder(ecModel, option) {
	  return modelUtil.parseFinder(ecModel, option, {
	    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	  });
	}
	
	var targetInfoBuilders = {
	  grid: function (foundCpts, targetInfoList) {
	    var xAxisModels = foundCpts.xAxisModels;
	    var yAxisModels = foundCpts.yAxisModels;
	    var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	    var gridModelMap = zrUtil.createHashMap();
	    var xAxesHas = {};
	    var yAxesHas = {};
	
	    if (!xAxisModels && !yAxisModels && !gridModels) {
	      return;
	    }
	
	    each(xAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	    });
	    each(yAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      yAxesHas[gridModel.id] = true;
	    });
	    each(gridModels, function (gridModel) {
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	      yAxesHas[gridModel.id] = true;
	    });
	    gridModelMap.each(function (gridModel) {
	      var grid = gridModel.coordinateSystem;
	      var cartesians = [];
	      each(grid.getCartesians(), function (cartesian, index) {
	        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	          cartesians.push(cartesian);
	        }
	      });
	      targetInfoList.push({
	        panelId: 'grid--' + gridModel.id,
	        gridModel: gridModel,
	        coordSysModel: gridModel,
	        // Use the first one as the representitive coordSys.
	        coordSys: cartesians[0],
	        coordSyses: cartesians,
	        getPanelRect: panelRectBuilder.grid,
	        xAxisDeclared: xAxesHas[gridModel.id],
	        yAxisDeclared: yAxesHas[gridModel.id]
	      });
	    });
	  },
	  geo: function (foundCpts, targetInfoList) {
	    each(foundCpts.geoModels, function (geoModel) {
	      var coordSys = geoModel.coordinateSystem;
	      targetInfoList.push({
	        panelId: 'geo--' + geoModel.id,
	        geoModel: geoModel,
	        coordSysModel: geoModel,
	        coordSys: coordSys,
	        coordSyses: [coordSys],
	        getPanelRect: panelRectBuilder.geo
	      });
	    });
	  }
	};
	var targetInfoMatchers = [// grid
	function (foundCpts, targetInfo) {
	  var xAxisModel = foundCpts.xAxisModel;
	  var yAxisModel = foundCpts.yAxisModel;
	  var gridModel = foundCpts.gridModel;
	  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	  return gridModel && gridModel === targetInfo.gridModel;
	}, // geo
	function (foundCpts, targetInfo) {
	  var geoModel = foundCpts.geoModel;
	  return geoModel && geoModel === targetInfo.geoModel;
	}];
	var panelRectBuilder = {
	  grid: function () {
	    // grid is not Transformable.
	    return this.coordSys.grid.getRect().clone();
	  },
	  geo: function () {
	    var coordSys = this.coordSys;
	    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	    rect.applyTransform(graphic.getTransform(coordSys));
	    return rect;
	  }
	};
	var coordConvert = {
	  lineX: curry(axisConvert, 0),
	  lineY: curry(axisConvert, 1),
	  rect: function (to, coordSys, rangeOrCoordRange) {
	    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
	    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
	    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	    return {
	      values: values,
	      xyMinMax: values
	    };
	  },
	  polygon: function (to, coordSys, rangeOrCoordRange) {
	    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	    var values = zrUtil.map(rangeOrCoordRange, function (item) {
	      var p = coordSys[COORD_CONVERTS[to]](item);
	      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	      return p;
	    });
	    return {
	      values: values,
	      xyMinMax: xyMinMax
	    };
	  }
	};
	
	function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
	    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	  }));
	  var xyMinMax = [];
	  xyMinMax[axisNameIndex] = values;
	  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	  return {
	    values: values,
	    xyMinMax: xyMinMax
	  };
	}
	
	var diffProcessor = {
	  lineX: curry(axisDiffProcessor, 0),
	  lineY: curry(axisDiffProcessor, 1),
	  rect: function (values, refer, scales) {
	    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	  },
	  polygon: function (values, refer, scales) {
	    return zrUtil.map(values, function (item, idx) {
	      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	    });
	  }
	};
	
	function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	} // We have to process scale caused by dataZoom manually,
	// although it might be not accurate.
	
	
	function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	  var sizeCurr = getSize(xyMinMaxCurr);
	  var sizeOrigin = getSize(xyMinMaxOrigin);
	  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	  isNaN(scales[0]) && (scales[0] = 1);
	  isNaN(scales[1]) && (scales[1] = 1);
	  return scales;
	}
	
	function getSize(xyMinMax) {
	  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	}
	
	var _default = BrushTargetManager;
	module.exports = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var visualSolution = __webpack_require__(532);
	
	var Model = __webpack_require__(174);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
	var BrushModel = echarts.extendComponentModel({
	  type: 'brush',
	  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // inBrush: null,
	    // outOfBrush: null,
	    toolbox: null,
	    // Default value see preprocessor.
	    brushLink: null,
	    // Series indices array, broadcast using dataIndex.
	    // or 'all', which means all series. 'none' or null means no series.
	    seriesIndex: 'all',
	    // seriesIndex array, specify series controlled by this brush component.
	    geoIndex: null,
	    //
	    xAxisIndex: null,
	    yAxisIndex: null,
	    brushType: 'rect',
	    // Default brushType, see BrushController.
	    brushMode: 'single',
	    // Default brushMode, 'single' or 'multiple'
	    transformable: true,
	    // Default transformable.
	    brushStyle: {
	      // Default brushStyle
	      borderWidth: 1,
	      color: 'rgba(120,140,180,0.3)',
	      borderColor: 'rgba(120,140,180,0.8)'
	    },
	    throttleType: 'fixRate',
	    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
	    // If null, no throttle. Valid only in the first brush component
	    throttleDelay: 0,
	    // Unit: ms, 0 means every event will be triggered.
	    // FIXME
	    // 试验效果
	    removeOnClick: true,
	    z: 10000
	  },
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  areas: [],
	
	  /**
	   * Current activated brush type.
	   * If null, brush is inactived.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {string}
	   */
	  brushType: null,
	
	  /**
	   * Current brush opt.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {Object}
	   */
	  brushOption: {},
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  coordInfoList: [],
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	    thisOption.outOfBrush = thisOption.outOfBrush || {
	      color: DEFAULT_OUT_OF_BRUSH_COLOR
	    };
	
	    if (!inBrush.hasOwnProperty('liftZ')) {
	      // Bigger than the highlight z lift, otherwise it will
	      // be effected by the highlight z when brush.
	      inBrush.liftZ = 5;
	    }
	  },
	
	  /**
	   * If ranges is null/undefined, range state remain.
	   *
	   * @param {Array.<Object>} [ranges]
	   */
	  setAreas: function (areas) {
	    // If ranges is null/undefined, range state remain.
	    // This helps user to dispatchAction({type: 'brush'}) with no areas
	    // set but just want to get the current brush select info from a `brush` event.
	    if (!areas) {
	      return;
	    }
	
	    this.areas = zrUtil.map(areas, function (area) {
	      return generateBrushOption(this.option, area);
	    }, this);
	  },
	
	  /**
	   * see module:echarts/component/helper/BrushController
	   * @param {Object} brushOption
	   */
	  setBrushOption: function (brushOption) {
	    this.brushOption = generateBrushOption(this.option, brushOption);
	    this.brushType = this.brushOption.brushType;
	  }
	});
	
	function generateBrushOption(option, brushOption) {
	  return zrUtil.merge({
	    brushType: option.brushType,
	    brushMode: option.brushMode,
	    transformable: option.transformable,
	    brushStyle: new Model(option.brushStyle).getItemStyle(),
	    removeOnClick: option.removeOnClick,
	    z: option.z
	  }, brushOption, true);
	}
	
	var _default = BrushModel;
	module.exports = _default;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var BrushController = __webpack_require__(418);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'brush',
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/brush/BrushModel}
	     */
	
	    this.model;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  },
	
	  /**
	   * @override
	   */
	  render: function (brushModel) {
	    this.model = brushModel;
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateTransform: updateController,
	
	  /**
	   * @override
	   */
	  updateView: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateLayout: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: updateController,
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  },
	
	  /**
	   * @private
	   */
	  _onBrush: function (areas, opt) {
	    var modelId = this.model.id;
	    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	    // emits the same params with the last drag move event, and
	    // may have some delay when using touch pad, which makes
	    // animation not smooth (when using debounce).
	
	    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
	      type: 'brush',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	  }
	});
	
	function updateController(brushModel, ecModel, api, payload) {
	  // Do not update controller when drawing.
	  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	}
	
	module.exports = _default;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * payload: {
	 *      brushIndex: number, or,
	 *      brushId: string, or,
	 *      brushName: string,
	 *      globalRanges: Array
	 * }
	 */
	echarts.registerAction({
	  type: 'brush',
	  event: 'brush'
	  /*, update: 'updateView' */
	
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush',
	    query: payload
	  }, function (brushModel) {
	    brushModel.setAreas(payload.areas);
	  });
	});
	/**
	 * payload: {
	 *      brushComponents: [
	 *          {
	 *              brushId,
	 *              brushIndex,
	 *              brushName,
	 *              series: [
	 *                  {
	 *                      seriesId,
	 *                      seriesIndex,
	 *                      seriesName,
	 *                      rawIndices: [21, 34, ...]
	 *                  },
	 *                  ...
	 *              ]
	 *          },
	 *          ...
	 *      ]
	 * }
	 */
	
	echarts.registerAction({
	  type: 'brushSelect',
	  event: 'brushSelected',
	  update: 'none'
	}, function () {});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var featureManager = __webpack_require__(539);
	
	var lang = __webpack_require__(243);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var brushLang = lang.toolbox.brush;
	
	function Brush(model, ecModel, api) {
	  this.model = model;
	  this.ecModel = ecModel;
	  this.api = api;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushMode;
	}
	
	Brush.defaultOption = {
	  show: true,
	  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
	  icon: {
	    /* eslint-disable */
	    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	    // jshint ignore:line
	    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	    // jshint ignore:line
	    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	    // jshint ignore:line
	    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	    // jshint ignore:line
	    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	    // jshint ignore:line
	    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	  title: zrUtil.clone(brushLang.title)
	};
	var proto = Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {
	
	/* eslint-disable */
	
	proto.render =
	/* eslint-enable */
	proto.updateView = function (featureModel, ecModel, api) {
	  var brushType;
	  var brushMode;
	  var isBrushed;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    brushType = brushModel.brushType;
	    brushMode = brushModel.brushOption.brushMode || 'single';
	    isBrushed |= brushModel.areas.length;
	  });
	  this._brushType = brushType;
	  this._brushMode = brushMode;
	  zrUtil.each(featureModel.get('type', true), function (type) {
	    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	  });
	};
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon', true);
	  var icons = {};
	  zrUtil.each(model.get('type', true), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	proto.onclick = function (ecModel, api, type) {
	  var brushType = this._brushType;
	  var brushMode = this._brushMode;
	
	  if (type === 'clear') {
	    // Trigger parallel action firstly
	    api.dispatchAction({
	      type: 'axisAreaSelect',
	      intervals: []
	    });
	    api.dispatchAction({
	      type: 'brush',
	      command: 'clear',
	      // Clear all areas of all brush components.
	      areas: []
	    });
	  } else {
	    api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'brush',
	      brushOption: {
	        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	      }
	    });
	  }
	};
	
	featureManager.register('brush', Brush);
	var _default = Brush;
	module.exports = _default;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var features = {};
	
	function register(name, ctor) {
	  features[name] = ctor;
	}
	
	function get(name) {
	  return features[name];
	}
	
	exports.register = register;
	exports.get = get;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	__webpack_require__(543);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var layout = __webpack_require__(217);
	
	var numberUtil = __webpack_require__(218);
	
	var CoordinateSystem = __webpack_require__(228);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (24*60*60*1000)
	var PROXIMATE_ONE_DAY = 86400000;
	/**
	 * Calendar
	 *
	 * @constructor
	 *
	 * @param {Object} calendarModel calendarModel
	 * @param {Object} ecModel       ecModel
	 * @param {Object} api           api
	 */
	
	function Calendar(calendarModel, ecModel, api) {
	  this._model = calendarModel;
	}
	
	Calendar.prototype = {
	  constructor: Calendar,
	  type: 'calendar',
	  dimensions: ['time', 'value'],
	  // Required in createListFromData
	  getDimensionsInfo: function () {
	    return [{
	      name: 'time',
	      type: 'time'
	    }, 'value'];
	  },
	  getRangeInfo: function () {
	    return this._rangeInfo;
	  },
	  getModel: function () {
	    return this._model;
	  },
	  getRect: function () {
	    return this._rect;
	  },
	  getCellWidth: function () {
	    return this._sw;
	  },
	  getCellHeight: function () {
	    return this._sh;
	  },
	  getOrient: function () {
	    return this._orient;
	  },
	
	  /**
	   * getFirstDayOfWeek
	   *
	   * @example
	   *     0 : start at Sunday
	   *     1 : start at Monday
	   *
	   * @return {number}
	   */
	  getFirstDayOfWeek: function () {
	    return this._firstDayOfWeek;
	  },
	
	  /**
	   * get date info
	   *
	   * @param  {string|number} date date
	   * @return {Object}
	   * {
	   *      y: string, local full year, eg., '1940',
	   *      m: string, local month, from '01' ot '12',
	   *      d: string, local date, from '01' to '31' (if exists),
	   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
	   *      time: timestamp,
	   *      formatedDate: string, yyyy-MM-dd,
	   *      date: original date object.
	   * }
	   */
	  getDateInfo: function (date) {
	    date = numberUtil.parseDate(date);
	    var y = date.getFullYear();
	    var m = date.getMonth() + 1;
	    m = m < 10 ? '0' + m : m;
	    var d = date.getDate();
	    d = d < 10 ? '0' + d : d;
	    var day = date.getDay();
	    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	    return {
	      y: y,
	      m: m,
	      d: d,
	      day: day,
	      time: date.getTime(),
	      formatedDate: y + '-' + m + '-' + d,
	      date: date
	    };
	  },
	  getNextNDay: function (date, n) {
	    n = n || 0;
	
	    if (n === 0) {
	      return this.getDateInfo(date);
	    }
	
	    date = new Date(this.getDateInfo(date).time);
	    date.setDate(date.getDate() + n);
	    return this.getDateInfo(date);
	  },
	  update: function (ecModel, api) {
	    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	    this._orient = this._model.get('orient');
	    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
	    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	    var weeks = this._rangeInfo.weeks || 1;
	    var whNames = ['width', 'height'];
	
	    var cellSize = this._model.get('cellSize').slice();
	
	    var layoutParams = this._model.getBoxLayoutParams();
	
	    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	    zrUtil.each([0, 1], function (idx) {
	      if (cellSizeSpecified(cellSize, idx)) {
	        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	      }
	    });
	    var whGlobal = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
	    zrUtil.each([0, 1], function (idx) {
	      if (!cellSizeSpecified(cellSize, idx)) {
	        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	      }
	    });
	
	    function cellSizeSpecified(cellSize, idx) {
	      return cellSize[idx] != null && cellSize[idx] !== 'auto';
	    }
	
	    this._sw = cellSize[0];
	    this._sh = cellSize[1];
	  },
	
	  /**
	   * Convert a time data(time, value) item to (x, y) point.
	   *
	   * @override
	   * @param  {Array|number} data data
	   * @param  {boolean} [clamp=true] out of range
	   * @return {Array} point
	   */
	  dataToPoint: function (data, clamp) {
	    zrUtil.isArray(data) && (data = data[0]);
	    clamp == null && (clamp = true);
	    var dayInfo = this.getDateInfo(data);
	    var range = this._rangeInfo;
	    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
	      return [NaN, NaN];
	    }
	
	    var week = dayInfo.day;
	
	    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	    if (this._orient === 'vertical') {
	      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	    }
	
	    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	  },
	
	  /**
	   * Convert a (x, y) point to time data
	   *
	   * @override
	   * @param  {string} point point
	   * @return {string}       data
	   */
	  pointToData: function (point) {
	    var date = this.pointToDate(point);
	    return date && date.time;
	  },
	
	  /**
	   * Convert a time date item to (x, y) four point.
	   *
	   * @param  {Array} data  date[0] is date
	   * @param  {boolean} [clamp=true]  out of range
	   * @return {Object}       point
	   */
	  dataToRect: function (data, clamp) {
	    var point = this.dataToPoint(data, clamp);
	    return {
	      contentShape: {
	        x: point[0] - (this._sw - this._lineWidth) / 2,
	        y: point[1] - (this._sh - this._lineWidth) / 2,
	        width: this._sw - this._lineWidth,
	        height: this._sh - this._lineWidth
	      },
	      center: point,
	      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	    };
	  },
	
	  /**
	   * Convert a (x, y) point to time date
	   *
	   * @param  {Array} point point
	   * @return {Object}       date
	   */
	  pointToDate: function (point) {
	    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	    var range = this._rangeInfo.range;
	
	    if (this._orient === 'vertical') {
	      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	    }
	
	    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * initRange
	   *
	   * @private
	   * @return {Array} [start, end]
	   */
	  _initRangeOption: function () {
	    var range = this._model.get('range');
	
	    var rg = range;
	
	    if (zrUtil.isArray(rg) && rg.length === 1) {
	      rg = rg[0];
	    }
	
	    if (/^\d{4}$/.test(rg)) {
	      range = [rg + '-01-01', rg + '-12-31'];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
	      var start = this.getDateInfo(rg);
	      var firstDay = start.date;
	      firstDay.setMonth(firstDay.getMonth() + 1);
	      var end = this.getNextNDay(firstDay, -1);
	      range = [start.formatedDate, end.formatedDate];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
	      range = [rg, rg];
	    }
	
	    var tmp = this._getRangeInfo(range);
	
	    if (tmp.start.time > tmp.end.time) {
	      range.reverse();
	    }
	
	    return range;
	  },
	
	  /**
	   * range info
	   *
	   * @private
	   * @param  {Array} range range ['2017-01-01', '2017-07-08']
	   *  If range[0] > range[1], they will not be reversed.
	   * @return {Object}       obj
	   */
	  _getRangeInfo: function (range) {
	    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	    var reversed;
	
	    if (range[0].time > range[1].time) {
	      reversed = true;
	      range.reverse();
	    }
	
	    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case:
	    // Firstly set system timezone as "Time Zone: America/Toronto",
	    // ```
	    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	    // var second = new Date(1478412000000);
	    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	    // ```
	    // will get wrong result because of DST. So we should fix it.
	
	    var date = new Date(range[0].time);
	    var startDateNum = date.getDate();
	    var endDateNum = range[1].date.getDate();
	    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	    if (date.getDate() !== endDateNum) {
	      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
	
	      while (date.getDate() !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
	        allDay -= sign;
	        date.setDate(startDateNum + allDay - 1);
	      }
	    }
	
	    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
	    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	    reversed && range.reverse();
	    return {
	      range: [range[0].formatedDate, range[1].formatedDate],
	      start: range[0],
	      end: range[1],
	      allDay: allDay,
	      weeks: weeks,
	      // From 0.
	      nthWeek: nthWeek,
	      fweek: range[0].day,
	      lweek: range[1].day
	    };
	  },
	
	  /**
	   * get date by nthWeeks and week day in range
	   *
	   * @private
	   * @param  {number} nthWeek the week
	   * @param  {number} day   the week day
	   * @param  {Array} range [d1, d2]
	   * @return {Object}
	   */
	  _getDateByWeeksAndDay: function (nthWeek, day, range) {
	    var rangeInfo = this._getRangeInfo(range);
	
	    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	      return false;
	    }
	
	    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	    var date = new Date(rangeInfo.start.time);
	    date.setDate(rangeInfo.start.d + nthDay);
	    return this.getDateInfo(date);
	  }
	};
	Calendar.dimensions = Calendar.prototype.dimensions;
	Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;
	
	Calendar.create = function (ecModel, api) {
	  var calendarList = [];
	  ecModel.eachComponent('calendar', function (calendarModel) {
	    var calendar = new Calendar(calendarModel, ecModel, api);
	    calendarList.push(calendar);
	    calendarModel.coordinateSystem = calendar;
	  });
	  ecModel.eachSeries(function (calendarSeries) {
	    if (calendarSeries.get('coordinateSystem') === 'calendar') {
	      // Inject coordinate system
	      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	    }
	  });
	  return calendarList;
	};
	
	function doConvert(methodName, ecModel, finder, value) {
	  var calendarModel = finder.calendarModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	CoordinateSystem.register('calendar', Calendar);
	var _default = Calendar;
	module.exports = _default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ComponentModel = __webpack_require__(215);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutParams = _layout.getLayoutParams;
	var sizeCalculable = _layout.sizeCalculable;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CalendarModel = ComponentModel.extend({
	  type: 'calendar',
	
	  /**
	   * @type {module:echarts/coord/calendar/Calendar}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    left: 80,
	    top: 60,
	    cellSize: 20,
	    // horizontal vertical
	    orient: 'horizontal',
	    // month separate line style
	    splitLine: {
	      show: true,
	      lineStyle: {
	        color: '#000',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    // rect style  temporarily unused emphasis
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1,
	      borderColor: '#ccc'
	    },
	    // week text style
	    dayLabel: {
	      show: true,
	      // a week first day
	      firstDay: 0,
	      // start end
	      position: 'start',
	      margin: '50%',
	      // 50% of cellSize
	      nameMap: 'en',
	      color: '#000'
	    },
	    // month text style
	    monthLabel: {
	      show: true,
	      // start end
	      position: 'start',
	      margin: 5,
	      // center or left
	      align: 'center',
	      // cn en []
	      nameMap: 'en',
	      formatter: null,
	      color: '#000'
	    },
	    // year text style
	    yearLabel: {
	      show: true,
	      // top bottom left right
	      position: null,
	      margin: 30,
	      formatter: null,
	      color: '#ccc',
	      fontFamily: 'sans-serif',
	      fontWeight: 'bolder',
	      fontSize: 20
	    }
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    CalendarModel.superApply(this, 'init', arguments);
	    mergeAndNormalizeLayoutParams(option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    CalendarModel.superApply(this, 'mergeOption', arguments);
	    mergeAndNormalizeLayoutParams(this.option, option);
	  }
	});
	
	function mergeAndNormalizeLayoutParams(target, raw) {
	  // Normalize cellSize
	  var cellSize = target.cellSize;
	
	  if (!zrUtil.isArray(cellSize)) {
	    cellSize = target.cellSize = [cellSize, cellSize];
	  } else if (cellSize.length === 1) {
	    cellSize[1] = cellSize[0];
	  }
	
	  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
	    // If user have set `width` or both `left` and `right`, cellSize
	    // will be automatically set to 'auto', otherwise the default
	    // setting of cellSize will make `width` setting not work.
	    if (sizeCalculable(raw, hvIdx)) {
	      cellSize[hvIdx] = 'auto';
	    }
	
	    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
	  });
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = CalendarModel;
	module.exports = _default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var formatUtil = __webpack_require__(219);
	
	var numberUtil = __webpack_require__(218);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MONTH_TEXT = {
	  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var WEEK_TEXT = {
	  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  CN: ['日', '一', '二', '三', '四', '五', '六']
	};
	
	var _default = echarts.extendComponentView({
	  type: 'calendar',
	
	  /**
	   * top/left line points
	   *  @private
	   */
	  _tlpoints: null,
	
	  /**
	   * bottom/right line points
	   *  @private
	   */
	  _blpoints: null,
	
	  /**
	   * first day of month
	   *  @private
	   */
	  _firstDayOfMonth: null,
	
	  /**
	   * first day point of month
	   *  @private
	   */
	  _firstDayPoints: null,
	  render: function (calendarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	    var coordSys = calendarModel.coordinateSystem; // range info
	
	    var rangeData = coordSys.getRangeInfo();
	    var orient = coordSys.getOrient();
	
	    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	    this._renderLines(calendarModel, rangeData, orient, group);
	
	    this._renderYearText(calendarModel, rangeData, orient, group);
	
	    this._renderMonthText(calendarModel, orient, group);
	
	    this._renderWeekText(calendarModel, rangeData, orient, group);
	  },
	  // render day rect
	  _renderDayRect: function (calendarModel, rangeData, group) {
	    var coordSys = calendarModel.coordinateSystem;
	    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
	    var sw = coordSys.getCellWidth();
	    var sh = coordSys.getCellHeight();
	
	    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	      var point = coordSys.dataToRect([i], false).tl; // every rect
	
	      var rect = new graphic.Rect({
	        shape: {
	          x: point[0],
	          y: point[1],
	          width: sw,
	          height: sh
	        },
	        cursor: 'default',
	        style: itemRectStyleModel
	      });
	      group.add(rect);
	    }
	  },
	  // render separate line
	  _renderLines: function (calendarModel, rangeData, orient, group) {
	    var self = this;
	    var coordSys = calendarModel.coordinateSystem;
	    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
	    var show = calendarModel.get('splitLine.show');
	    var lineWidth = lineStyleModel.lineWidth;
	    this._tlpoints = [];
	    this._blpoints = [];
	    this._firstDayOfMonth = [];
	    this._firstDayPoints = [];
	    var firstDay = rangeData.start;
	
	    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	      addPoints(firstDay.formatedDate);
	
	      if (i === 0) {
	        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	      }
	
	      var date = firstDay.date;
	      date.setMonth(date.getMonth() + 1);
	      firstDay = coordSys.getDateInfo(date);
	    }
	
	    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	    function addPoints(date) {
	      self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	      self._tlpoints.push(points[0]);
	
	      self._blpoints.push(points[points.length - 1]);
	
	      show && self._drawSplitline(points, lineStyleModel, group);
	    } // render top/left line
	
	
	    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	  },
	  // get points at both ends
	  _getEdgesPoints: function (points, lineWidth, orient) {
	    var rs = [points[0].slice(), points[points.length - 1].slice()];
	    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	    rs[0][idx] = rs[0][idx] - lineWidth / 2;
	    rs[1][idx] = rs[1][idx] + lineWidth / 2;
	    return rs;
	  },
	  // render split line
	  _drawSplitline: function (points, lineStyleModel, group) {
	    var poyline = new graphic.Polyline({
	      z2: 20,
	      shape: {
	        points: points
	      },
	      style: lineStyleModel
	    });
	    group.add(poyline);
	  },
	  // render month line of one week points
	  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
	    var coordSys = calendarModel.coordinateSystem;
	    date = coordSys.getDateInfo(date);
	    var points = [];
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(date.time, i);
	      var point = coordSys.dataToRect([tmpD.time], false);
	      points[2 * tmpD.day] = point.tl;
	      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	    }
	
	    return points;
	  },
	  _formatterLabel: function (formatter, params) {
	    if (typeof formatter === 'string' && formatter) {
	      return formatUtil.formatTplSimple(formatter, params);
	    }
	
	    if (typeof formatter === 'function') {
	      return formatter(params);
	    }
	
	    return params.nameMap;
	  },
	  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
	    point = point.slice();
	    var aligns = ['center', 'bottom'];
	
	    if (position === 'bottom') {
	      point[1] += margin;
	      aligns = ['center', 'top'];
	    } else if (position === 'left') {
	      point[0] -= margin;
	    } else if (position === 'right') {
	      point[0] += margin;
	      aligns = ['center', 'top'];
	    } else {
	      // top
	      point[1] -= margin;
	    }
	
	    var rotate = 0;
	
	    if (position === 'left' || position === 'right') {
	      rotate = Math.PI / 2;
	    }
	
	    return {
	      rotation: rotate,
	      position: point,
	      style: {
	        textAlign: aligns[0],
	        textVerticalAlign: aligns[1]
	      }
	    };
	  },
	  // render year
	  _renderYearText: function (calendarModel, rangeData, orient, group) {
	    var yearLabel = calendarModel.getModel('yearLabel');
	
	    if (!yearLabel.get('show')) {
	      return;
	    }
	
	    var margin = yearLabel.get('margin');
	    var pos = yearLabel.get('position');
	
	    if (!pos) {
	      pos = orient !== 'horizontal' ? 'top' : 'left';
	    }
	
	    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	    var xc = (points[0][0] + points[1][0]) / 2;
	    var yc = (points[0][1] + points[1][1]) / 2;
	    var idx = orient === 'horizontal' ? 0 : 1;
	    var posPoints = {
	      top: [xc, points[idx][1]],
	      bottom: [xc, points[1 - idx][1]],
	      left: [points[1 - idx][0], yc],
	      right: [points[idx][0], yc]
	    };
	    var name = rangeData.start.y;
	
	    if (+rangeData.end.y > +rangeData.start.y) {
	      name = name + '-' + rangeData.end.y;
	    }
	
	    var formatter = yearLabel.get('formatter');
	    var params = {
	      start: rangeData.start.y,
	      end: rangeData.end.y,
	      nameMap: name
	    };
	
	    var content = this._formatterLabel(formatter, params);
	
	    var yearText = new graphic.Text({
	      z2: 30
	    });
	    graphic.setTextStyle(yearText.style, yearLabel, {
	      text: content
	    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	    group.add(yearText);
	  },
	  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
	    var align = 'left';
	    var vAlign = 'top';
	    var x = point[0];
	    var y = point[1];
	
	    if (orient === 'horizontal') {
	      y = y + margin;
	
	      if (isCenter) {
	        align = 'center';
	      }
	
	      if (position === 'start') {
	        vAlign = 'bottom';
	      }
	    } else {
	      x = x + margin;
	
	      if (isCenter) {
	        vAlign = 'middle';
	      }
	
	      if (position === 'start') {
	        align = 'right';
	      }
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render month and year text
	  _renderMonthText: function (calendarModel, orient, group) {
	    var monthLabel = calendarModel.getModel('monthLabel');
	
	    if (!monthLabel.get('show')) {
	      return;
	    }
	
	    var nameMap = monthLabel.get('nameMap');
	    var margin = monthLabel.get('margin');
	    var pos = monthLabel.get('position');
	    var align = monthLabel.get('align');
	    var termPoints = [this._tlpoints, this._blpoints];
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var idx = pos === 'start' ? 0 : 1;
	    var axis = orient === 'horizontal' ? 0 : 1;
	    margin = pos === 'start' ? -margin : margin;
	    var isCenter = align === 'center';
	
	    for (var i = 0; i < termPoints[idx].length - 1; i++) {
	      var tmp = termPoints[idx][i].slice();
	      var firstDay = this._firstDayOfMonth[i];
	
	      if (isCenter) {
	        var firstDayPoints = this._firstDayPoints[i];
	        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	      }
	
	      var formatter = monthLabel.get('formatter');
	      var name = nameMap[+firstDay.m - 1];
	      var params = {
	        yyyy: firstDay.y,
	        yy: (firstDay.y + '').slice(2),
	        MM: firstDay.m,
	        M: +firstDay.m,
	        nameMap: name
	      };
	
	      var content = this._formatterLabel(formatter, params);
	
	      var monthText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
	        text: content
	      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
	      group.add(monthText);
	    }
	  },
	  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
	    var align = 'center';
	    var vAlign = 'middle';
	    var x = point[0];
	    var y = point[1];
	    var isStart = position === 'start';
	
	    if (orient === 'horizontal') {
	      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	      align = isStart ? 'right' : 'left';
	    } else {
	      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	      vAlign = isStart ? 'bottom' : 'top';
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render weeks
	  _renderWeekText: function (calendarModel, rangeData, orient, group) {
	    var dayLabel = calendarModel.getModel('dayLabel');
	
	    if (!dayLabel.get('show')) {
	      return;
	    }
	
	    var coordSys = calendarModel.coordinateSystem;
	    var pos = dayLabel.get('position');
	    var nameMap = dayLabel.get('nameMap');
	    var margin = dayLabel.get('margin');
	    var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);
	
	    if (pos === 'start') {
	      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	      margin = -margin;
	    }
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(start, i);
	      var point = coordSys.dataToRect([tmpD.time], false).center;
	      var day = i;
	      day = Math.abs((i + firstDayOfWeek) % 7);
	      var weekText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
	        text: nameMap[day]
	      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
	      group.add(weekText);
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var graphic = __webpack_require__(180);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Model
	echarts.extendComponentModel({
	  type: 'title',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 6,
	    show: true,
	    text: '',
	    // 超链接跳转
	    // link: null,
	    // 仅支持self | blank
	    target: 'blank',
	    subtext: '',
	    // 超链接跳转
	    // sublink: null,
	    // 仅支持self | blank
	    subtarget: 'blank',
	    // 'center' ¦ 'left' ¦ 'right'
	    // ¦ {number}（x坐标，单位px）
	    left: 0,
	    // 'top' ¦ 'bottom' ¦ 'center'
	    // ¦ {number}（y坐标，单位px）
	    top: 0,
	    // 水平对齐
	    // 'auto' | 'left' | 'right' | 'center'
	    // 默认根据 left 的位置判断是左对齐还是右对齐
	    // textAlign: null
	    //
	    // 垂直对齐
	    // 'auto' | 'top' | 'bottom' | 'middle'
	    // 默认根据 top 位置判断是上对齐还是下对齐
	    // textBaseline: null
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 标题边框颜色
	    borderColor: '#ccc',
	    // 标题边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 标题内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 主副标题纵向间隔，单位px，默认为10，
	    itemGap: 10,
	    textStyle: {
	      fontSize: 18,
	      fontWeight: 'bolder',
	      color: '#333'
	    },
	    subtextStyle: {
	      color: '#aaa'
	    }
	  }
	}); // View
	
	echarts.extendComponentView({
	  type: 'title',
	  render: function (titleModel, ecModel, api) {
	    this.group.removeAll();
	
	    if (!titleModel.get('show')) {
	      return;
	    }
	
	    var group = this.group;
	    var textStyleModel = titleModel.getModel('textStyle');
	    var subtextStyleModel = titleModel.getModel('subtextStyle');
	    var textAlign = titleModel.get('textAlign');
	    var textBaseline = titleModel.get('textBaseline');
	    var textEl = new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: titleModel.get('text'),
	        textFill: textStyleModel.getTextColor()
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var textRect = textEl.getBoundingRect();
	    var subText = titleModel.get('subtext');
	    var subTextEl = new graphic.Text({
	      style: graphic.setTextStyle({}, subtextStyleModel, {
	        text: subText,
	        textFill: subtextStyleModel.getTextColor(),
	        y: textRect.height + titleModel.get('itemGap'),
	        textVerticalAlign: 'top'
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var link = titleModel.get('link');
	    var sublink = titleModel.get('sublink');
	    var triggerEvent = titleModel.get('triggerEvent', true);
	    textEl.silent = !link && !triggerEvent;
	    subTextEl.silent = !sublink && !triggerEvent;
	
	    if (link) {
	      textEl.on('click', function () {
	        window.open(link, '_' + titleModel.get('target'));
	      });
	    }
	
	    if (sublink) {
	      subTextEl.on('click', function () {
	        window.open(sublink, '_' + titleModel.get('subtarget'));
	      });
	    }
	
	    textEl.eventData = subTextEl.eventData = triggerEvent ? {
	      componentType: 'title',
	      componentIndex: titleModel.componentIndex
	    } : null;
	    group.add(textEl);
	    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	    var groupRect = group.getBoundingRect();
	    var layoutOption = titleModel.getBoxLayoutParams();
	    layoutOption.width = groupRect.width;
	    layoutOption.height = groupRect.height;
	    var layoutRect = getLayoutRect(layoutOption, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }, titleModel.get('padding')); // Adjust text align based on position
	
	    if (!textAlign) {
	      // Align left if title is on the left. center and right is same
	      textAlign = titleModel.get('left') || titleModel.get('right');
	
	      if (textAlign === 'middle') {
	        textAlign = 'center';
	      } // Adjust layout by text align
	
	
	      if (textAlign === 'right') {
	        layoutRect.x += layoutRect.width;
	      } else if (textAlign === 'center') {
	        layoutRect.x += layoutRect.width / 2;
	      }
	    }
	
	    if (!textBaseline) {
	      textBaseline = titleModel.get('top') || titleModel.get('bottom');
	
	      if (textBaseline === 'center') {
	        textBaseline = 'middle';
	      }
	
	      if (textBaseline === 'bottom') {
	        layoutRect.y += layoutRect.height;
	      } else if (textBaseline === 'middle') {
	        layoutRect.y += layoutRect.height / 2;
	      }
	
	      textBaseline = textBaseline || 'top';
	    }
	
	    group.attr('position', [layoutRect.x, layoutRect.y]);
	    var alignStyle = {
	      textAlign: textAlign,
	      textVerticalAlign: textBaseline
	    };
	    textEl.setStyle(alignStyle);
	    subTextEl.setStyle(alignStyle); // Render background
	    // Get groupRect again because textAlign has been changed
	
	    groupRect = group.getBoundingRect();
	    var padding = layoutRect.margin;
	    var style = titleModel.getItemStyle(['color', 'opacity']);
	    style.fill = titleModel.get('backgroundColor');
	    var rect = new graphic.Rect({
	      shape: {
	        x: groupRect.x - padding[3],
	        y: groupRect.y - padding[0],
	        width: groupRect.width + padding[1] + padding[3],
	        height: groupRect.height + padding[0] + padding[2],
	        r: titleModel.get('borderRadius')
	      },
	      style: style,
	      silent: true
	    });
	    graphic.subPixelOptimizeRect(rect);
	    group.add(rect);
	  }
	});

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(546);
	
	__webpack_require__(547);
	
	__webpack_require__(550);
	
	__webpack_require__(551);
	
	__webpack_require__(552);
	
	__webpack_require__(553);
	
	__webpack_require__(554);
	
	__webpack_require__(556);
	
	__webpack_require__(557);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('dataZoom', function () {
	  // Default 'slider' when no type specified.
	  return 'slider';
	});

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var modelUtil = __webpack_require__(173);
	
	var helper = __webpack_require__(548);
	
	var AxisProxy = __webpack_require__(549);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var eachAxisDim = helper.eachAxisDim;
	var DataZoomModel = echarts.extendComponentModel({
	  type: 'dataZoom',
	  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 4,
	    // Higher than normal component (z: 2).
	    orient: null,
	    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
	    xAxisIndex: null,
	    // Default the first horizontal category axis.
	    yAxisIndex: null,
	    // Default the first vertical category axis.
	    filterMode: 'filter',
	    // Possible values: 'filter' or 'empty' or 'weakFilter'.
	    // 'filter': data items which are out of window will be removed. This option is
	    //          applicable when filtering outliers. For each data item, it will be
	    //          filtered if one of the relevant dimensions is out of the window.
	    // 'weakFilter': data items which are out of window will be removed. This option
	    //          is applicable when filtering outliers. For each data item, it will be
	    //          filtered only if all  of the relevant dimensions are out of the same
	    //          side of the window.
	    // 'empty': data items which are out of window will be set to empty.
	    //          This option is applicable when user should not neglect
	    //          that there are some data items out of window.
	    // 'none': Do not filter.
	    // Taking line chart as an example, line will be broken in
	    // the filtered points when filterModel is set to 'empty', but
	    // be connected when set to 'filter'.
	    throttle: null,
	    // Dispatch action by the fixed rate, avoid frequency.
	    // default 100. Do not throttle when use null/undefined.
	    // If animation === true and animationDurationUpdate > 0,
	    // default value is 100, otherwise 20.
	    start: 0,
	    // Start percent. 0 ~ 100
	    end: 100,
	    // End percent. 0 ~ 100
	    startValue: null,
	    // Start value. If startValue specified, start is ignored.
	    endValue: null,
	    // End value. If endValue specified, end is ignored.
	    minSpan: null,
	    // 0 ~ 100
	    maxSpan: null,
	    // 0 ~ 100
	    minValueSpan: null,
	    // The range of dataZoom can not be smaller than that.
	    maxValueSpan: null,
	    // The range of dataZoom can not be larger than that.
	    rangeMode: null // Array, can be 'value' or 'percent'.
	
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * key like x_0, y_1
	     * @private
	     * @type {Object}
	     */
	    this._dataIntervalByAxis = {};
	    /**
	     * @private
	     */
	
	    this._dataInfo = {};
	    /**
	     * key like x_0, y_1
	     * @private
	     */
	
	    this._axisProxies = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * @private
	     */
	
	    this._autoThrottle = true;
	    /**
	     * 'percent' or 'value'
	     * @private
	     */
	
	    this._rangePropMode = ['percent', 'percent'];
	    var rawOption = retrieveRaw(option);
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.doInit(rawOption);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var rawOption = retrieveRaw(newOption); //FIX #2591
	
	    zrUtil.merge(this.option, newOption, true);
	    this.doInit(rawOption);
	  },
	
	  /**
	   * @protected
	   */
	  doInit: function (rawOption) {
	    var thisOption = this.option; // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    this._setDefaultThrottle(rawOption);
	
	    updateRangeUse(this, rawOption);
	    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	      // start/end has higher priority over startValue/endValue if they
	      // both set, but we should make chart.setOption({endValue: 1000})
	      // effective, rather than chart.setOption({endValue: 1000, end: null}).
	      if (this._rangePropMode[index] === 'value') {
	        thisOption[names[0]] = null;
	      } // Otherwise do nothing and use the merge result.
	
	    }, this);
	    this.textStyleModel = this.getModel('textStyle');
	
	    this._resetTarget();
	
	    this._giveAxisProxies();
	  },
	
	  /**
	   * @private
	   */
	  _giveAxisProxies: function () {
	    var axisProxies = this._axisProxies;
	    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
	      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
	
	      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
	      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
	      // dispose __dzAxisProxy
	
	      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetTarget: function () {
	    var thisOption = this.option;
	
	    var autoMode = this._judgeAutoMode();
	
	    eachAxisDim(function (dimNames) {
	      var axisIndexName = dimNames.axisIndex;
	      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
	    }, this);
	
	    if (autoMode === 'axisIndex') {
	      this._autoSetAxisIndex();
	    } else if (autoMode === 'orient') {
	      this._autoSetOrient();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _judgeAutoMode: function () {
	    // Auto set only works for setOption at the first time.
	    // The following is user's reponsibility. So using merged
	    // option is OK.
	    var thisOption = this.option;
	    var hasIndexSpecified = false;
	    eachAxisDim(function (dimNames) {
	      // When user set axisIndex as a empty array, we think that user specify axisIndex
	      // but do not want use auto mode. Because empty array may be encountered when
	      // some error occured.
	      if (thisOption[dimNames.axisIndex] != null) {
	        hasIndexSpecified = true;
	      }
	    }, this);
	    var orient = thisOption.orient;
	
	    if (orient == null && hasIndexSpecified) {
	      return 'orient';
	    } else if (!hasIndexSpecified) {
	      if (orient == null) {
	        thisOption.orient = 'horizontal';
	      }
	
	      return 'axisIndex';
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetAxisIndex: function () {
	    var autoAxisIndex = true;
	    var orient = this.get('orient', true);
	    var thisOption = this.option;
	    var dependentModels = this.dependentModels;
	
	    if (autoAxisIndex) {
	      // Find axis that parallel to dataZoom as default.
	      var dimName = orient === 'vertical' ? 'y' : 'x';
	
	      if (dependentModels[dimName + 'Axis'].length) {
	        thisOption[dimName + 'AxisIndex'] = [0];
	        autoAxisIndex = false;
	      } else {
	        each(dependentModels.singleAxis, function (singleAxisModel) {
	          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
	            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
	            autoAxisIndex = false;
	          }
	        });
	      }
	    }
	
	    if (autoAxisIndex) {
	      // Find the first category axis as default. (consider polar)
	      eachAxisDim(function (dimNames) {
	        if (!autoAxisIndex) {
	          return;
	        }
	
	        var axisIndices = [];
	        var axisModels = this.dependentModels[dimNames.axis];
	
	        if (axisModels.length && !axisIndices.length) {
	          for (var i = 0, len = axisModels.length; i < len; i++) {
	            if (axisModels[i].get('type') === 'category') {
	              axisIndices.push(i);
	            }
	          }
	        }
	
	        thisOption[dimNames.axisIndex] = axisIndices;
	
	        if (axisIndices.length) {
	          autoAxisIndex = false;
	        }
	      }, this);
	    }
	
	    if (autoAxisIndex) {
	      // FIXME
	      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
	      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
	      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
	      // dataZoom component auto adopts series that reference to
	      // both xAxis and yAxis which type is 'value'.
	      this.ecModel.eachSeries(function (seriesModel) {
	        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
	          eachAxisDim(function (dimNames) {
	            var axisIndices = thisOption[dimNames.axisIndex];
	            var axisIndex = seriesModel.get(dimNames.axisIndex);
	            var axisId = seriesModel.get(dimNames.axisId);
	            var axisModel = seriesModel.ecModel.queryComponents({
	              mainType: dimNames.axis,
	              index: axisIndex,
	              id: axisId
	            })[0];
	            axisIndex = axisModel.componentIndex;
	
	            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
	              axisIndices.push(axisIndex);
	            }
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetOrient: function () {
	    var dim; // Find the first axis
	
	    this.eachTargetAxis(function (dimNames) {
	      !dim && (dim = dimNames.name);
	    }, this);
	    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
	  },
	
	  /**
	   * @private
	   */
	  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
	    // FIXME
	    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
	    // 例如series.type === scatter时。
	    var is = true;
	    eachAxisDim(function (dimNames) {
	      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
	      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
	
	      if (!axisModel || axisModel.get('type') !== axisType) {
	        is = false;
	      }
	    }, this);
	    return is;
	  },
	
	  /**
	   * @private
	   */
	  _setDefaultThrottle: function (rawOption) {
	    // When first time user set throttle, auto throttle ends.
	    if (rawOption.hasOwnProperty('throttle')) {
	      this._autoThrottle = false;
	    }
	
	    if (this._autoThrottle) {
	      var globalOption = this.ecModel.option;
	      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	    }
	  },
	
	  /**
	   * @public
	   */
	  getFirstTargetAxisModel: function () {
	    var firstAxisModel;
	    eachAxisDim(function (dimNames) {
	      if (firstAxisModel == null) {
	        var indices = this.get(dimNames.axisIndex);
	
	        if (indices.length) {
	          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
	        }
	      }
	    }, this);
	    return firstAxisModel;
	  },
	
	  /**
	   * @public
	   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	   */
	  eachTargetAxis: function (callback, context) {
	    var ecModel = this.ecModel;
	    eachAxisDim(function (dimNames) {
	      each(this.get(dimNames.axisIndex), function (axisIndex) {
	        callback.call(context, dimNames, axisIndex, this, ecModel);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
	   */
	  getAxisProxy: function (dimName, axisIndex) {
	    return this._axisProxies[dimName + '_' + axisIndex];
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/model/Model} If not found, return null/undefined.
	   */
	  getAxisModel: function (dimName, axisIndex) {
	    var axisProxy = this.getAxisProxy(dimName, axisIndex);
	    return axisProxy && axisProxy.getAxisModel();
	  },
	
	  /**
	   * If not specified, set to undefined.
	   *
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   * @param {boolean} [ignoreUpdateRangeUsg=false]
	   */
	  setRawRange: function (opt, ignoreUpdateRangeUsg) {
	    var option = this.option;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	      // If only one of 'start' and 'startValue' is not null/undefined, the other
	      // should be cleared, which enable clear the option.
	      // If both of them are not set, keep option with the original value, which
	      // enable use only set start but not set end when calling `dispatchAction`.
	      // The same as 'end' and 'endValue'.
	      if (opt[names[0]] != null || opt[names[1]] != null) {
	        option[names[0]] = opt[names[0]];
	        option[names[1]] = opt[names[1]];
	      }
	    }, this);
	    !ignoreUpdateRangeUsg && updateRangeUse(this, opt);
	  },
	
	  /**
	   * @public
	   * @return {Array.<number>} [startPercent, endPercent]
	   */
	  getPercentRange: function () {
	    var axisProxy = this.findRepresentativeAxisProxy();
	
	    if (axisProxy) {
	      return axisProxy.getDataPercentWindow();
	    }
	  },
	
	  /**
	   * @public
	   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	   *
	   * @param {string} [axisDimName]
	   * @param {number} [axisIndex]
	   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
	   */
	  getValueRange: function (axisDimName, axisIndex) {
	    if (axisDimName == null && axisIndex == null) {
	      var axisProxy = this.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        return axisProxy.getDataValueWindow();
	      }
	    } else {
	      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
	    }
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
	   *      corresponding to the axisModel
	   * @return {module:echarts/component/dataZoom/AxisProxy}
	   */
	  findRepresentativeAxisProxy: function (axisModel) {
	    if (axisModel) {
	      return axisModel.__dzAxisProxy;
	    } // Find the first hosted axisProxy
	
	
	    var axisProxies = this._axisProxies;
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    } // If no hosted axis find not hosted axisProxy.
	    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
	    // and the option.start or option.end settings are different. The percentRange
	    // should follow axisProxy.
	    // (We encounter this problem in toolbox data zoom.)
	
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    }
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getRangePropMode: function () {
	    return this._rangePropMode.slice();
	  }
	});
	
	function retrieveRaw(option) {
	  var ret = {};
	  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	    option.hasOwnProperty(name) && (ret[name] = option[name]);
	  });
	  return ret;
	}
	
	function updateRangeUse(dataZoomModel, rawOption) {
	  var rangePropMode = dataZoomModel._rangePropMode;
	  var rangeModeInOption = dataZoomModel.get('rangeMode');
	  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	    var percentSpecified = rawOption[names[0]] != null;
	    var valueSpecified = rawOption[names[1]] != null;
	
	    if (percentSpecified && !valueSpecified) {
	      rangePropMode[index] = 'percent';
	    } else if (!percentSpecified && valueSpecified) {
	      rangePropMode[index] = 'value';
	    } else if (rangeModeInOption) {
	      rangePropMode[index] = rangeModeInOption[index];
	    } else if (percentSpecified) {
	      // percentSpecified && valueSpecified
	      rangePropMode[index] = 'percent';
	    } // else remain its original setting.
	
	  });
	}
	
	var _default = DataZoomModel;
	module.exports = _default;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var formatUtil = __webpack_require__(219);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.
	
	var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	/**
	 * @param {string} coordType
	 * @return {boolean}
	 */
	
	function isCoordSupported(coordType) {
	  return zrUtil.indexOf(COORDS, coordType) >= 0;
	}
	/**
	 * Create "each" method to iterate names.
	 *
	 * @pubilc
	 * @param  {Array.<string>} names
	 * @param  {Array.<string>=} attrs
	 * @return {Function}
	 */
	
	
	function createNameEach(names, attrs) {
	  names = names.slice();
	  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
	  attrs = (attrs || []).slice();
	  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
	  return function (callback, context) {
	    zrUtil.each(names, function (name, index) {
	      var nameObj = {
	        name: name,
	        capital: capitalNames[index]
	      };
	
	      for (var j = 0; j < attrs.length; j++) {
	        nameObj[attrs[j]] = name + capitalAttrs[j];
	      }
	
	      callback.call(context, nameObj);
	    });
	  };
	}
	/**
	 * Iterate each dimension name.
	 *
	 * @public
	 * @param {Function} callback The parameter is like:
	 *                            {
	 *                                name: 'angle',
	 *                                capital: 'Angle',
	 *                                axis: 'angleAxis',
	 *                                axisIndex: 'angleAixs',
	 *                                index: 'angleIndex'
	 *                            }
	 * @param {Object} context
	 */
	
	
	var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
	/**
	 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
	 * dataZoomModels and 'links' make up one or more graphics.
	 * This function finds the graphic where the source dataZoomModel is in.
	 *
	 * @public
	 * @param {Function} forEachNode Node iterator.
	 * @param {Function} forEachEdgeType edgeType iterator
	 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
	 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
	 */
	
	function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
	  return function (sourceNode) {
	    var result = {
	      nodes: [],
	      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
	
	    };
	    forEachEdgeType(function (edgeType) {
	      result.records[edgeType.name] = {};
	    });
	
	    if (!sourceNode) {
	      return result;
	    }
	
	    absorb(sourceNode, result);
	    var existsLink;
	
	    do {
	      existsLink = false;
	      forEachNode(processSingleNode);
	    } while (existsLink);
	
	    function processSingleNode(node) {
	      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
	        absorb(node, result);
	        existsLink = true;
	      }
	    }
	
	    return result;
	  };
	
	  function isNodeAbsorded(node, result) {
	    return zrUtil.indexOf(result.nodes, node) >= 0;
	  }
	
	  function isLinked(node, result) {
	    var hasLink = false;
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] && (hasLink = true);
	      });
	    });
	    return hasLink;
	  }
	
	  function absorb(node, result) {
	    result.nodes.push(node);
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] = true;
	      });
	    });
	  }
	}
	
	exports.isCoordSupported = isCoordSupported;
	exports.createNameEach = createNameEach;
	exports.eachAxisDim = eachAxisDim;
	exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var numberUtil = __webpack_require__(218);
	
	var helper = __webpack_require__(548);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	/**
	 * Operate single axis.
	 * One axis can only operated by one axis operator.
	 * Different dataZoomModels may be defined to operate the same axis.
	 * (i.e. 'inside' data zoom and 'slider' data zoom components)
	 * So dataZoomModels share one axisProxy in that case.
	 *
	 * @class
	 */
	
	var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this._dimName = dimName;
	  /**
	   * @private
	   */
	
	  this._axisIndex = axisIndex;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._valueWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._percentWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._dataExtent;
	  /**
	   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
	   * @private
	   * @type {Object}
	   */
	
	  this._minMaxSpan;
	  /**
	   * @readOnly
	   * @type {module: echarts/model/Global}
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @private
	   * @type {module: echarts/component/dataZoom/DataZoomModel}
	   */
	
	  this._dataZoomModel = dataZoomModel; // /**
	  //  * @readOnly
	  //  * @private
	  //  */
	  // this.hasSeriesStacked;
	};
	
	AxisProxy.prototype = {
	  constructor: AxisProxy,
	
	  /**
	   * Whether the axisProxy is hosted by dataZoomModel.
	   *
	   * @public
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   * @return {boolean}
	   */
	  hostedBy: function (dataZoomModel) {
	    return this._dataZoomModel === dataZoomModel;
	  },
	
	  /**
	   * @return {Array.<number>} Value can only be NaN or finite value.
	   */
	  getDataValueWindow: function () {
	    return this._valueWindow.slice();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getDataPercentWindow: function () {
	    return this._percentWindow.slice();
	  },
	
	  /**
	   * @public
	   * @param {number} axisIndex
	   * @return {Array} seriesModels
	   */
	  getTargetSeriesModels: function () {
	    var seriesModels = [];
	    var ecModel = this.ecModel;
	    ecModel.eachSeries(function (seriesModel) {
	      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
	        var dimName = this._dimName;
	        var axisModel = ecModel.queryComponents({
	          mainType: dimName + 'Axis',
	          index: seriesModel.get(dimName + 'AxisIndex'),
	          id: seriesModel.get(dimName + 'AxisId')
	        })[0];
	
	        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
	          seriesModels.push(seriesModel);
	        }
	      }
	    }, this);
	    return seriesModels;
	  },
	  getAxisModel: function () {
	    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	  },
	  getOtherAxisModel: function () {
	    var axisDim = this._dimName;
	    var ecModel = this.ecModel;
	    var axisModel = this.getAxisModel();
	    var isCartesian = axisDim === 'x' || axisDim === 'y';
	    var otherAxisDim;
	    var coordSysIndexName;
	
	    if (isCartesian) {
	      coordSysIndexName = 'gridIndex';
	      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
	    } else {
	      coordSysIndexName = 'polarIndex';
	      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
	    }
	
	    var foundOtherAxisModel;
	    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
	      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
	        foundOtherAxisModel = otherAxisModel;
	      }
	    });
	    return foundOtherAxisModel;
	  },
	  getMinMaxSpan: function () {
	    return zrUtil.clone(this._minMaxSpan);
	  },
	
	  /**
	   * Only calculate by given range and this._dataExtent, do not change anything.
	   *
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  calculateDataWindow: function (opt) {
	    var dataExtent = this._dataExtent;
	    var axisModel = this.getAxisModel();
	    var scale = axisModel.axis.scale;
	
	    var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	    var percentExtent = [0, 100];
	    var percentWindow = [opt.start, opt.end];
	    var valueWindow = [];
	    each(['startValue', 'endValue'], function (prop) {
	      valueWindow.push(opt[prop] != null ? scale.parse(opt[prop]) : null);
	    }); // Normalize bound.
	
	    each([0, 1], function (idx) {
	      var boundValue = valueWindow[idx];
	      var boundPercent = percentWindow[idx]; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	      // on `valueProp` ('startValue', 'endValue'). The former one is suitable
	      // for cases that a dataZoom component controls multiple axes with different
	      // unit or extent, and the latter one is suitable for accurate zoom by pixel
	      // (e.g., in dataZoomSelect). `valueProp` can be calculated from `percentProp`,
	      // but it is awkward that `percentProp` can not be obtained from `valueProp`
	      // accurately (because all of values that are overflow the `dataExtent` will
	      // be calculated to percent '100%'). So we have to use
	      // `dataZoom.getRangePropMode()` to mark which prop is used.
	      // `rangePropMode` is updated only when setOption or dispatchAction, otherwise
	      // it remains its original value.
	
	      if (rangePropMode[idx] === 'percent') {
	        if (boundPercent == null) {
	          boundPercent = percentExtent[idx];
	        } // Use scale.parse to math round for category or time axis.
	
	
	        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent, true));
	      } else {
	        // Calculating `percent` from `value` may be not accurate, because
	        // This calculation can not be inversed, because all of values that
	        // are overflow the `dataExtent` will be calculated to percent '100%'
	        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent, true);
	      } // valueWindow[idx] = round(boundValue);
	      // percentWindow[idx] = round(boundPercent);
	
	
	      valueWindow[idx] = boundValue;
	      percentWindow[idx] = boundPercent;
	    });
	    return {
	      valueWindow: asc(valueWindow),
	      percentWindow: asc(percentWindow)
	    };
	  },
	
	  /**
	   * Notice: reset should not be called before series.restoreData() called,
	   * so it is recommanded to be called in "process stage" but not "model init
	   * stage".
	   *
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  reset: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
	
	    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
	    // each(targetSeries, function (series) {
	    // var data = series.getData();
	    // var dataDim = data.mapDimension(this._dimName);
	    // var stackedDimension = data.getCalculationInfo('stackedDimension');
	    // if (stackedDimension && stackedDimension === dataDim) {
	    // this.hasSeriesStacked = true;
	    // }
	    // }, this);
	
	    var dataWindow = this.calculateDataWindow(dataZoomModel.option);
	    this._valueWindow = dataWindow.valueWindow;
	    this._percentWindow = dataWindow.percentWindow;
	    setMinMaxSpan(this); // Update axis setting then.
	
	    setAxisModel(this);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  restore: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    this._valueWindow = this._percentWindow = null;
	    setAxisModel(this, true);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  filterData: function (dataZoomModel, api) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var axisDim = this._dimName;
	    var seriesModels = this.getTargetSeriesModels();
	    var filterMode = dataZoomModel.get('filterMode');
	    var valueWindow = this._valueWindow;
	
	    if (filterMode === 'none') {
	      return;
	    } // FIXME
	    // Toolbox may has dataZoom injected. And if there are stacked bar chart
	    // with NaN data, NaN will be filtered and stack will be wrong.
	    // So we need to force the mode to be set empty.
	    // In fect, it is not a big deal that do not support filterMode-'filter'
	    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	    // selection" some day, which might need "adapt to data extent on the
	    // otherAxis", which is disabled by filterMode-'empty'.
	    // But currently, stack has been fixed to based on value but not index,
	    // so this is not an issue any more.
	    // var otherAxisModel = this.getOtherAxisModel();
	    // if (dataZoomModel.get('$fromToolbox')
	    //     && otherAxisModel
	    //     && otherAxisModel.hasSeriesStacked
	    // ) {
	    //     filterMode = 'empty';
	    // }
	    // TODO
	    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
	
	
	    each(seriesModels, function (seriesModel) {
	      var seriesData = seriesModel.getData();
	      var dataDims = seriesData.mapDimension(axisDim, true);
	
	      if (!dataDims.length) {
	        return;
	      }
	
	      if (filterMode === 'weakFilter') {
	        seriesData.filterSelf(function (dataIndex) {
	          var leftOut;
	          var rightOut;
	          var hasValue;
	
	          for (var i = 0; i < dataDims.length; i++) {
	            var value = seriesData.get(dataDims[i], dataIndex);
	            var thisHasValue = !isNaN(value);
	            var thisLeftOut = value < valueWindow[0];
	            var thisRightOut = value > valueWindow[1];
	
	            if (thisHasValue && !thisLeftOut && !thisRightOut) {
	              return true;
	            }
	
	            thisHasValue && (hasValue = true);
	            thisLeftOut && (leftOut = true);
	            thisRightOut && (rightOut = true);
	          } // If both left out and right out, do not filter.
	
	
	          return hasValue && leftOut && rightOut;
	        });
	      } else {
	        each(dataDims, function (dim) {
	          if (filterMode === 'empty') {
	            seriesModel.setData(seriesData.map(dim, function (value) {
	              return !isInWindow(value) ? NaN : value;
	            }));
	          } else {
	            var range = {};
	            range[dim] = valueWindow; // console.time('select');
	
	            seriesData.selectRange(range); // console.timeEnd('select');
	          }
	        });
	      }
	
	      each(dataDims, function (dim) {
	        seriesData.setApproximateExtent(valueWindow, dim);
	      });
	    });
	
	    function isInWindow(value) {
	      return value >= valueWindow[0] && value <= valueWindow[1];
	    }
	  }
	};
	
	function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	  var dataExtent = [Infinity, -Infinity];
	  each(seriesModels, function (seriesModel) {
	    var seriesData = seriesModel.getData();
	
	    if (seriesData) {
	      each(seriesData.mapDimension(axisDim, true), function (dim) {
	        var seriesExtent = seriesData.getApproximateExtent(dim);
	        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	      });
	    }
	  });
	
	  if (dataExtent[1] < dataExtent[0]) {
	    dataExtent = [NaN, NaN];
	  } // It is important to get "consistent" extent when more then one axes is
	  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	  // when zooming. But it is difficult to know what is "consistent", considering
	  // axes have different type or even different meanings (For example, two
	  // time axes are used to compare data of the same date in different years).
	  // So basically dataZoom just obtains extent by series.data (in category axis
	  // extent can be obtained from axis.data).
	  // Nevertheless, user can set min/max/scale on axes to make extent of axes
	  // consistent.
	
	
	  fixExtentByAxis(axisProxy, dataExtent);
	  return dataExtent;
	}
	
	function fixExtentByAxis(axisProxy, dataExtent) {
	  var axisModel = axisProxy.getAxisModel();
	  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
	  // by axis.data by default.
	
	  var isCategoryAxis = axisModel.get('type') === 'category';
	  var axisDataLen = isCategoryAxis && axisModel.getCategories().length;
	
	  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
	    dataExtent[0] = min;
	  } else if (isCategoryAxis) {
	    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
	  }
	
	  var max = axisModel.getMax(true);
	
	  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
	    dataExtent[1] = max;
	  } else if (isCategoryAxis) {
	    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
	  }
	
	  if (!axisModel.get('scale', true)) {
	    dataExtent[0] > 0 && (dataExtent[0] = 0);
	    dataExtent[1] < 0 && (dataExtent[1] = 0);
	  } // For value axis, if min/max/scale are not set, we just use the extent obtained
	  // by series data, which may be a little different from the extent calculated by
	  // `axisHelper.getScaleExtent`. But the different just affects the experience a
	  // little when zooming. So it will not be fixed until some users require it strongly.
	
	
	  return dataExtent;
	}
	
	function setAxisModel(axisProxy, isRestore) {
	  var axisModel = axisProxy.getAxisModel();
	  var percentWindow = axisProxy._percentWindow;
	  var valueWindow = axisProxy._valueWindow;
	
	  if (!percentWindow) {
	    return;
	  } // [0, 500]: arbitrary value, guess axis extent.
	
	
	  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
	  precision = Math.min(precision, 20); // isRestore or isFull
	
	  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
	  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
	}
	
	function setMinMaxSpan(axisProxy) {
	  var minMaxSpan = axisProxy._minMaxSpan = {};
	  var dataZoomModel = axisProxy._dataZoomModel;
	  each(['min', 'max'], function (minMax) {
	    minMaxSpan[minMax + 'Span'] = dataZoomModel.get(minMax + 'Span'); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	
	    if (valueSpan != null) {
	      minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	      valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan);
	
	      if (valueSpan != null) {
	        var dataExtent = axisProxy._dataExtent;
	        minMaxSpan[minMax + 'Span'] = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	      }
	    }
	  });
	}
	
	var _default = AxisProxy;
	module.exports = _default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(237);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'dataZoom',
	  render: function (dataZoomModel, ecModel, api, payload) {
	    this.dataZoomModel = dataZoomModel;
	    this.ecModel = ecModel;
	    this.api = api;
	  },
	
	  /**
	   * Find the first target coordinate system.
	   *
	   * @protected
	   * @return {Object} {
	   *                   grid: [
	   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	   *                       ...
	   *                   ],  // cartesians must not be null/undefined.
	   *                   polar: [
	   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
	   *                       ...
	   *                   ],  // polars must not be null/undefined.
	   *                   singleAxis: [
	   *                       {model: coord0, axisModels: [], coordIndex: 0}
	   *                   ]
	   */
	  getTargetCoordInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var ecModel = this.ecModel;
	    var coordSysLists = {};
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
	
	      if (axisModel) {
	        var coordModel = axisModel.getCoordSysModel();
	        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
	      }
	    }, this);
	
	    function save(coordModel, axisModel, store, coordIndex) {
	      var item;
	
	      for (var i = 0; i < store.length; i++) {
	        if (store[i].model === coordModel) {
	          item = store[i];
	          break;
	        }
	      }
	
	      if (!item) {
	        store.push(item = {
	          model: coordModel,
	          axisModels: [],
	          coordIndex: coordIndex
	        });
	      }
	
	      item.axisModels.push(axisModel);
	    }
	
	    return coordSysLists;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(547);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderZoomModel = DataZoomModel.extend({
	  type: 'dataZoom.slider',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    // ph => placeholder. Using placehoder here because
	    // deault value can only be drived in view stage.
	    right: 'ph',
	    // Default align to grid rect.
	    top: 'ph',
	    // Default align to grid rect.
	    width: 'ph',
	    // Default align to grid rect.
	    height: 'ph',
	    // Default align to grid rect.
	    left: null,
	    // Default align to grid rect.
	    bottom: null,
	    // Default align to grid rect.
	    backgroundColor: 'rgba(47,69,84,0)',
	    // Background of slider zoom component.
	    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
	    // highest priority, remain for compatibility of
	    // previous version, but not recommended any more.
	    dataBackground: {
	      lineStyle: {
	        color: '#2f4554',
	        width: 0.5,
	        opacity: 0.3
	      },
	      areaStyle: {
	        color: 'rgba(47,69,84,0.3)',
	        opacity: 0.3
	      }
	    },
	    borderColor: '#ddd',
	    // border color of the box. For compatibility,
	    // if dataBackgroundColor is set, borderColor
	    // is ignored.
	    fillerColor: 'rgba(167,183,204,0.4)',
	    // Color of selected area.
	    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
	    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
	
	    /* eslint-disable */
	    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
	
	    /* eslint-enable */
	    // Percent of the slider height
	    handleSize: '100%',
	    handleStyle: {
	      color: '#a7b7cc'
	    },
	    labelPrecision: null,
	    labelFormatter: null,
	    showDetail: true,
	    showDataShadow: 'auto',
	    // Default auto decision.
	    realtime: true,
	    zoomLock: false,
	    // Whether disable zoom.
	    textStyle: {
	      color: '#333'
	    }
	  }
	});
	var _default = SliderZoomModel;
	module.exports = _default;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var eventTool = __webpack_require__(139);
	
	var graphic = __webpack_require__(180);
	
	var throttle = __webpack_require__(240);
	
	var DataZoomView = __webpack_require__(550);
	
	var numberUtil = __webpack_require__(218);
	
	var layout = __webpack_require__(217);
	
	var sliderMove = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Rect = graphic.Rect;
	var linearMap = numberUtil.linearMap;
	var asc = numberUtil.asc;
	var bind = zrUtil.bind;
	var each = zrUtil.each; // Constants
	
	var DEFAULT_LOCATION_EDGE_GAP = 7;
	var DEFAULT_FRAME_BORDER_WIDTH = 1;
	var DEFAULT_FILLER_SIZE = 30;
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var LABEL_GAP = 5;
	var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	var SliderZoomView = DataZoomView.extend({
	  type: 'dataZoom.slider',
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {Object}
	     */
	    this._displayables = {};
	    /**
	     * @private
	     * @type {string}
	     */
	
	    this._orient;
	    /**
	     * [0, 100]
	     * @private
	     */
	
	    this._range;
	    /**
	     * [coord of the first handle, coord of the second handle]
	     * @private
	     */
	
	    this._handleEnds;
	    /**
	     * [length, thick]
	     * @private
	     * @type {Array.<number>}
	     */
	
	    this._size;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleWidth;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleHeight;
	    /**
	     * @private
	     */
	
	    this._location;
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._dataShadowInfo;
	    this.api = api;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    SliderZoomView.superApply(this, 'render', arguments);
	    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
	    this._orient = dataZoomModel.get('orient');
	
	    if (this.dataZoomModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    } // Notice: this._resetInterval() should not be executed when payload.type
	    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	      this._buildView();
	    }
	
	    this._updateView();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    SliderZoomView.superApply(this, 'remove', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    SliderZoomView.superApply(this, 'dispose', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	  _buildView: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    this._resetLocation();
	
	    this._resetInterval();
	
	    var barGroup = this._displayables.barGroup = new graphic.Group();
	
	    this._renderBackground();
	
	    this._renderHandle();
	
	    this._renderDataShadow();
	
	    thisGroup.add(barGroup);
	
	    this._positionGroup();
	  },
	
	  /**
	   * @private
	   */
	  _resetLocation: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var api = this.api; // If some of x/y/width/height are not specified,
	    // auto-adapt according to target grid.
	
	    var coordRect = this._findCoordRect();
	
	    var ecSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }; // Default align by coordinate system rect.
	
	    var positionInfo = this._orient === HORIZONTAL ? {
	      // Why using 'right', because right should be used in vertical,
	      // and it is better to be consistent for dealing with position param merge.
	      right: ecSize.width - coordRect.x - coordRect.width,
	      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
	      width: coordRect.width,
	      height: DEFAULT_FILLER_SIZE
	    } : {
	      // vertical
	      right: DEFAULT_LOCATION_EDGE_GAP,
	      top: coordRect.y,
	      width: DEFAULT_FILLER_SIZE,
	      height: coordRect.height
	    }; // Do not write back to option and replace value 'ph', because
	    // the 'ph' value should be recalculated when resize.
	
	    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
	      if (layoutParams[name] === 'ph') {
	        layoutParams[name] = positionInfo[name];
	      }
	    });
	    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
	    this._location = {
	      x: layoutRect.x,
	      y: layoutRect.y
	    };
	    this._size = [layoutRect.width, layoutRect.height];
	    this._orient === VERTICAL && this._size.reverse();
	  },
	
	  /**
	   * @private
	   */
	  _positionGroup: function () {
	    var thisGroup = this.group;
	    var location = this._location;
	    var orient = this._orient; // Just use the first axis to determine mapping.
	
	    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	    var inverse = targetAxisModel && targetAxisModel.get('inverse');
	    var barGroup = this._displayables.barGroup;
	    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	    barGroup.attr(orient === HORIZONTAL && !inverse ? {
	      scale: otherAxisInverse ? [1, 1] : [1, -1]
	    } : orient === HORIZONTAL && inverse ? {
	      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
	    } : orient === VERTICAL && !inverse ? {
	      scale: otherAxisInverse ? [1, -1] : [1, 1],
	      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
	
	    } : {
	      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
	      rotation: Math.PI / 2
	    }); // Position barGroup
	
	    var rect = thisGroup.getBoundingRect([barGroup]);
	    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
	  },
	
	  /**
	   * @private
	   */
	  _getViewExtent: function () {
	    return [0, this._size[0]];
	  },
	  _renderBackground: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var size = this._size;
	    var barGroup = this._displayables.barGroup;
	    barGroup.add(new Rect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: dataZoomModel.get('backgroundColor')
	      },
	      z2: -40
	    })); // Click panel, over shadow, below handles.
	
	    barGroup.add(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: 'transparent'
	      },
	      z2: 0,
	      onclick: zrUtil.bind(this._onClickPanelClick, this)
	    }));
	  },
	  _renderDataShadow: function () {
	    var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	    if (!info) {
	      return;
	    }
	
	    var size = this._size;
	    var seriesModel = info.series;
	    var data = seriesModel.getRawData();
	    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
	    : info.otherDim;
	
	    if (otherDim == null) {
	      return;
	    }
	
	    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
	
	    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
	    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
	    var otherShadowExtent = [0, size[1]];
	    var thisShadowExtent = [0, size[0]];
	    var areaPoints = [[size[0], 0], [0, 0]];
	    var linePoints = [];
	    var step = thisShadowExtent[1] / (data.count() - 1);
	    var thisCoord = 0; // Optimize for large data shadow
	
	    var stride = Math.round(data.count() / size[0]);
	    var lastIsEmpty;
	    data.each([otherDim], function (value, index) {
	      if (stride > 0 && index % stride) {
	        thisCoord += step;
	        return;
	      } // FIXME
	      // Should consider axis.min/axis.max when drawing dataShadow.
	      // FIXME
	      // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
	
	      if (isEmpty && !lastIsEmpty && index) {
	        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
	        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
	      } else if (!isEmpty && lastIsEmpty) {
	        areaPoints.push([thisCoord, 0]);
	        linePoints.push([thisCoord, 0]);
	      }
	
	      areaPoints.push([thisCoord, otherCoord]);
	      linePoints.push([thisCoord, otherCoord]);
	      thisCoord += step;
	      lastIsEmpty = isEmpty;
	    });
	    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	    this._displayables.barGroup.add(new graphic.Polygon({
	      shape: {
	        points: areaPoints
	      },
	      style: zrUtil.defaults({
	        fill: dataZoomModel.get('dataBackgroundColor')
	      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
	      silent: true,
	      z2: -20
	    }));
	
	    this._displayables.barGroup.add(new graphic.Polyline({
	      shape: {
	        points: linePoints
	      },
	      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
	      silent: true,
	      z2: -19
	    }));
	  },
	  _prepareDataShadowInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var showDataShadow = dataZoomModel.get('showDataShadow');
	
	    if (showDataShadow === false) {
	      return;
	    } // Find a representative series.
	
	
	    var result;
	    var ecModel = this.ecModel;
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
	      zrUtil.each(seriesModels, function (seriesModel) {
	        if (result) {
	          return;
	        }
	
	        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	          return;
	        }
	
	        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
	        var otherDim = getOtherDim(dimNames.name);
	        var otherAxisInverse;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (otherDim != null && coordSys.getOtherAxis) {
	          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	        }
	
	        otherDim = seriesModel.getData().mapDimension(otherDim);
	        result = {
	          thisAxis: thisAxis,
	          series: seriesModel,
	          thisDim: dimNames.name,
	          otherDim: otherDim,
	          otherAxisInverse: otherAxisInverse
	        };
	      }, this);
	    }, this);
	    return result;
	  },
	  _renderHandle: function () {
	    var displaybles = this._displayables;
	    var handles = displaybles.handles = [];
	    var handleLabels = displaybles.handleLabels = [];
	    var barGroup = this._displayables.barGroup;
	    var size = this._size;
	    var dataZoomModel = this.dataZoomModel;
	    barGroup.add(displaybles.filler = new Rect({
	      draggable: true,
	      cursor: getCursor(this._orient),
	      drift: bind(this._onDragMove, this, 'all'),
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragstart: bind(this._showDataInfo, this, true),
	      ondragend: bind(this._onDragEnd, this),
	      onmouseover: bind(this._showDataInfo, this, true),
	      onmouseout: bind(this._showDataInfo, this, false),
	      style: {
	        fill: dataZoomModel.get('fillerColor'),
	        textPosition: 'inside'
	      }
	    })); // Frame border.
	
	    barGroup.add(new Rect(graphic.subPixelOptimizeRect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	        fill: 'rgba(0,0,0,0)'
	      }
	    })));
	    each([0, 1], function (handleIndex) {
	      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
	        cursor: getCursor(this._orient),
	        draggable: true,
	        drift: bind(this._onDragMove, this, handleIndex),
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        ondragend: bind(this._onDragEnd, this),
	        onmouseover: bind(this._showDataInfo, this, true),
	        onmouseout: bind(this._showDataInfo, this, false)
	      }, {
	        x: -1,
	        y: 0,
	        width: 2,
	        height: 2
	      });
	      var bRect = path.getBoundingRect();
	      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
	      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version
	
	      if (handleColor != null) {
	        path.style.fill = handleColor;
	      }
	
	      barGroup.add(handles[handleIndex] = path);
	      var textStyleModel = dataZoomModel.textStyleModel;
	      this.group.add(handleLabels[handleIndex] = new graphic.Text({
	        silent: true,
	        invisible: true,
	        style: {
	          x: 0,
	          y: 0,
	          text: '',
	          textVerticalAlign: 'middle',
	          textAlign: 'center',
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        },
	        z2: 10
	      }));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var range = this._range = this.dataZoomModel.getPercentRange();
	
	    var viewExtent = this._getViewExtent();
	
	    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} delta
	   * @return {boolean} changed
	   */
	  _updateInterval: function (handleIndex, delta) {
	    var dataZoomModel = this.dataZoomModel;
	    var handleEnds = this._handleEnds;
	
	    var viewExtend = this._getViewExtent();
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    var percentExtent = [0, 100];
	    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	    var lastRange = this._range;
	    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (nonRealtime) {
	    var displaybles = this._displayables;
	    var handleEnds = this._handleEnds;
	    var handleInterval = asc(handleEnds.slice());
	    var size = this._size;
	    each([0, 1], function (handleIndex) {
	      // Handles
	      var handle = displaybles.handles[handleIndex];
	      var handleHeight = this._handleHeight;
	      handle.attr({
	        scale: [handleHeight / 2, handleHeight / 2],
	        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
	      });
	    }, this); // Filler
	
	    displaybles.filler.setShape({
	      x: handleInterval[0],
	      y: 0,
	      width: handleInterval[1] - handleInterval[0],
	      height: size[1]
	    });
	
	    this._updateDataInfo(nonRealtime);
	  },
	
	  /**
	   * @private
	   */
	  _updateDataInfo: function (nonRealtime) {
	    var dataZoomModel = this.dataZoomModel;
	    var displaybles = this._displayables;
	    var handleLabels = displaybles.handleLabels;
	    var orient = this._orient;
	    var labelTexts = ['', '']; // FIXME
	    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	    if (dataZoomModel.get('showDetail')) {
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        var axis = axisProxy.getAxisModel().axis;
	        var range = this._range;
	        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	        ? axisProxy.calculateDataWindow({
	          start: range[0],
	          end: range[1]
	        }).valueWindow : axisProxy.getDataValueWindow();
	        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	      }
	    }
	
	    var orderedHandleEnds = asc(this._handleEnds.slice());
	    setLabel.call(this, 0);
	    setLabel.call(this, 1);
	
	    function setLabel(handleIndex) {
	      // Label
	      // Text should not transform by barGroup.
	      // Ignore handlers transform
	      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
	      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	      var offset = this._handleWidth / 2 + LABEL_GAP;
	      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	        textAlign: orient === HORIZONTAL ? direction : 'center',
	        text: labelTexts[handleIndex]
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _formatLabel: function (value, axis) {
	    var dataZoomModel = this.dataZoomModel;
	    var labelFormatter = dataZoomModel.get('labelFormatter');
	    var labelPrecision = dataZoomModel.get('labelPrecision');
	
	    if (labelPrecision == null || labelPrecision === 'auto') {
	      labelPrecision = axis.getPixelPrecision();
	    }
	
	    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
	    : value.toFixed(Math.min(labelPrecision, 20));
	    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	  },
	
	  /**
	   * @private
	   * @param {boolean} showOrHide true: show, false: hide
	   */
	  _showDataInfo: function (showOrHide) {
	    // Always show when drgging.
	    showOrHide = this._dragging || showOrHide;
	    var handleLabels = this._displayables.handleLabels;
	    handleLabels[0].attr('invisible', !showOrHide);
	    handleLabels[1].attr('invisible', !showOrHide);
	  },
	  _onDragMove: function (handleIndex, dx, dy) {
	    this._dragging = true; // Transform dx, dy to bar coordination.
	
	    var barTransform = this._displayables.barGroup.getLocalTransform();
	
	    var vertex = graphic.applyTransform([dx, dy], barTransform, true);
	
	    var changed = this._updateInterval(handleIndex, vertex[0]);
	
	    var realtime = this.dataZoomModel.get('realtime');
	
	    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
	    // which cause bad visual effect when progressive enabled.
	
	
	    changed && realtime && this._dispatchZoomAction();
	  },
	  _onDragEnd: function () {
	    this._dragging = false;
	
	    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
	    // drag end will cause the whole view rerender, which is unnecessary.
	
	
	    var realtime = this.dataZoomModel.get('realtime');
	    !realtime && this._dispatchZoomAction();
	  },
	  _onClickPanelClick: function (e) {
	    var size = this._size;
	
	    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	      return;
	    }
	
	    var handleEnds = this._handleEnds;
	    var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	    var changed = this._updateInterval('all', localPoint[0] - center);
	
	    this._updateView();
	
	    changed && this._dispatchZoomAction();
	  },
	
	  /**
	   * This action will be throttled.
	   * @private
	   */
	  _dispatchZoomAction: function () {
	    var range = this._range;
	    this.api.dispatchAction({
	      type: 'dataZoom',
	      from: this.uid,
	      dataZoomId: this.dataZoomModel.id,
	      start: range[0],
	      end: range[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _findCoordRect: function () {
	    // Find the grid coresponding to the first axis referred by dataZoom.
	    var rect;
	    each(this.getTargetCoordInfo(), function (coordInfoList) {
	      if (!rect && coordInfoList.length) {
	        var coordSys = coordInfoList[0].model.coordinateSystem;
	        rect = coordSys.getRect && coordSys.getRect();
	      }
	    });
	
	    if (!rect) {
	      var width = this.api.getWidth();
	      var height = this.api.getHeight();
	      rect = {
	        x: width * 0.2,
	        y: height * 0.2,
	        width: width * 0.6,
	        height: height * 0.6
	      };
	    }
	
	    return rect;
	  }
	});
	
	function getOtherDim(thisDim) {
	  // FIXME
	  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	  var map = {
	    x: 'y',
	    y: 'x',
	    radius: 'angle',
	    angle: 'radius'
	  };
	  return map[thisDim];
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = SliderZoomView;
	module.exports = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(547);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    disabled: false,
	    // Whether disable this inside zoom.
	    zoomLock: false,
	    // Whether disable zoom but only pan.
	    zoomOnMouseWheel: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseMove: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseWheel: false,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    preventDefaultMouseMove: true
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var DataZoomView = __webpack_require__(550);
	
	var sliderMove = __webpack_require__(412);
	
	var roams = __webpack_require__(555);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var InsideZoomView = DataZoomView.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * 'throttle' is used in this.dispatchAction, so we save range
	     * to avoid missing some 'pan' info.
	     * @private
	     * @type {Array.<number>}
	     */
	    this._range;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    InsideZoomView.superApply(this, 'render', arguments); // Hance the `throttle` util ensures to preserve command order,
	    // here simply updating range all the time will not cause missing
	    // any of the the roam change.
	
	    this._range = dataZoomModel.getPercentRange(); // Reset controllers.
	
	    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
	      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
	        return roams.generateCoordId(coordInfo.model);
	      });
	      zrUtil.each(coordInfoList, function (coordInfo) {
	        var coordModel = coordInfo.model;
	        var getRange = {};
	        zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	          getRange[eventName] = bind(roamHandlers[eventName], this, coordInfo, coordSysName);
	        }, this);
	        roams.register(api, {
	          coordId: roams.generateCoordId(coordModel),
	          allCoordIds: allCoordIds,
	          containsPoint: function (e, x, y) {
	            return coordModel.coordinateSystem.containPoint([x, y]);
	          },
	          dataZoomId: dataZoomModel.id,
	          dataZoomModel: dataZoomModel,
	          getRange: getRange
	        });
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    roams.unregister(this.api, this.dataZoomModel.id);
	    InsideZoomView.superApply(this, 'dispose', arguments);
	    this._range = null;
	  }
	});
	var roamHandlers = {
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  zoom: function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName](null, [e.originX, e.originY], axisModel, controller, coordInfo);
	    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	    var scale = Math.max(1 / e.scale, 0);
	    range[0] = (range[0] - percentPoint) * scale + percentPoint;
	    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  },
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  pan: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	  }),
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  scrollMove: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
	  })
	};
	
	function makeMover(getPercentDelta) {
	  return function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
	    sliderMove(percentDelta, range, [0, 100], 'all');
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  };
	}
	
	var getDirectionInfo = {
	  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.dim === 'x') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // axis.dim === 'y'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var polar = coordInfo.model.coordinateSystem;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var angleExtent = polar.getAngleAxis().getExtent();
	    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	    newPoint = polar.pointToCoord(newPoint);
	
	    if (axisModel.mainType === 'radiusAxis') {
	      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	      ret.pixelStart = radiusExtent[0];
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'angleAxis'
	      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	      ret.pixelLength = angleExtent[1] - angleExtent[0];
	      ret.pixelStart = angleExtent[0];
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    var ret = {};
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.orient === 'horizontal') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'vertical'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  }
	};
	var _default = InsideZoomView;
	module.exports = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var RoamController = __webpack_require__(345);
	
	var throttleUtil = __webpack_require__(240);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Only create one roam controller for each coordinate system.
	// one roam controller might be refered by two inside data zoom
	// components (for example, one for x and one for y). When user
	// pan or zoom, only dispatch one action for those data zoom
	// components.
	var ATTR = '\0_ec_dataZoom_roams';
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} dataZoomInfo
	 * @param {string} dataZoomInfo.coordId
	 * @param {Function} dataZoomInfo.containsPoint
	 * @param {Array.<string>} dataZoomInfo.allCoordIds
	 * @param {string} dataZoomInfo.dataZoomId
	 * @param {Object} dataZoomInfo.getRange
	 * @param {Function} dataZoomInfo.getRange.pan
	 * @param {Function} dataZoomInfo.getRange.zoom
	 * @param {Function} dataZoomInfo.getRange.scrollMove
	 * @param {boolean} dataZoomInfo.dataZoomModel
	 */
	
	function register(api, dataZoomInfo) {
	  var store = giveStore(api);
	  var theDataZoomId = dataZoomInfo.dataZoomId;
	  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
	  // Avoid memory leak, dispose all not-used-registered.
	
	  zrUtil.each(store, function (record, coordId) {
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
	      delete dataZoomInfos[theDataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	  var record = store[theCoordId]; // Create if needed.
	
	  if (!record) {
	    record = store[theCoordId] = {
	      coordId: theCoordId,
	      dataZoomInfos: {},
	      count: 0
	    };
	    record.controller = createController(api, record);
	    record.dispatchAction = zrUtil.curry(dispatchAction, api);
	  } // Update reference of dataZoom.
	
	
	  !record.dataZoomInfos[theDataZoomId] && record.count++;
	  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
	  var controllerParams = mergeControllerParams(record.dataZoomInfos);
	  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
	
	  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
	
	  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.dataZoomModel.get('throttle', true), 'fixRate');
	}
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {string} dataZoomId
	 */
	
	
	function unregister(api, dataZoomId) {
	  var store = giveStore(api);
	  zrUtil.each(store, function (record) {
	    record.controller.dispose();
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[dataZoomId]) {
	      delete dataZoomInfos[dataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	}
	/**
	 * @public
	 */
	
	
	function generateCoordId(coordModel) {
	  return coordModel.type + '\0_' + coordModel.id;
	}
	/**
	 * Key: coordId, value: {dataZoomInfos: [], count, controller}
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(api) {
	  // Mount store on zrender instance, so that we do not
	  // need to worry about dispose.
	  var zr = api.getZr();
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	
	function createController(api, newRecord) {
	  var controller = new RoamController(api.getZr());
	  zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	    controller.on(eventName, function (event) {
	      var batch = [];
	      zrUtil.each(newRecord.dataZoomInfos, function (info) {
	        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
	        // moveOnMouseWheel, ...) enabled.
	        if (!event.isAvailableBehavior(info.dataZoomModel.option)) {
	          return;
	        }
	
	        var method = (info.getRange || {})[eventName];
	        var range = method && method(newRecord.controller, event);
	        !info.dataZoomModel.get('disabled', true) && range && batch.push({
	          dataZoomId: info.dataZoomId,
	          start: range[0],
	          end: range[1]
	        });
	      });
	      batch.length && newRecord.dispatchAction(batch);
	    });
	  });
	  return controller;
	}
	
	function cleanStore(store) {
	  zrUtil.each(store, function (record, coordId) {
	    if (!record.count) {
	      record.controller.dispose();
	      delete store[coordId];
	    }
	  });
	}
	/**
	 * This action will be throttled.
	 */
	
	
	function dispatchAction(api, batch) {
	  api.dispatchAction({
	    type: 'dataZoom',
	    batch: batch
	  });
	}
	/**
	 * Merge roamController settings when multiple dataZooms share one roamController.
	 */
	
	
	function mergeControllerParams(dataZoomInfos) {
	  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
	  // as string, it is probably revert to reserved word by compress tool. See #7411.
	
	  var prefix = 'type_';
	  var typePriority = {
	    'type_true': 2,
	    'type_move': 1,
	    'type_false': 0,
	    'type_undefined': -1
	  };
	  var preventDefaultMouseMove = true;
	  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
	    var dataZoomModel = dataZoomInfo.dataZoomModel;
	    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
	
	    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
	      controlType = oneType;
	    } // Prevent default move event by default. If one false, do not prevent. Otherwise
	    // users may be confused why it does not work when multiple insideZooms exist.
	
	
	    preventDefaultMouseMove &= dataZoomModel.get('preventDefaultMouseMove', true);
	  });
	  return {
	    controlType: controlType,
	    opt: {
	      // RoamController will enable all of these functionalities,
	      // and the final behavior is determined by its event listener
	      // provided by each inside zoom.
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      moveOnMouseWheel: true,
	      preventDefaultMouseMove: !!preventDefaultMouseMove
	    }
	  };
	}
	
	exports.register = register;
	exports.unregister = unregister;
	exports.generateCoordId = generateCoordId;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var _util = __webpack_require__(134);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor({
	  // `dataZoomProcessor` will only be performed in needed series. Consider if
	  // there is a line series and a pie series, it is better not to update the
	  // line series if only pie series is needed to be updated.
	  getTargetSeries: function (ecModel) {
	    var seriesModelMap = createHashMap();
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
	        each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
	          seriesModelMap.set(seriesModel.uid, seriesModel);
	        });
	      });
	    });
	    return seriesModelMap;
	  },
	  modifyOutputEnd: true,
	  // Consider appendData, where filter should be performed. Because data process is
	  // in block mode currently, it is not need to worry about that the overallProgress
	  // execute every frame.
	  overallReset: function (ecModel, api) {
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // We calculate window and reset axis here but not in model
	      // init stage and not after action dispatch handler, because
	      // reset should be called after seriesData.restoreData.
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
	      }); // Caution: data zoom filtering is order sensitive when using
	      // percent range and no min/max/scale set on axis.
	      // For example, we have dataZoom definition:
	      // [
	      //      {xAxisIndex: 0, start: 30, end: 70},
	      //      {yAxisIndex: 0, start: 20, end: 80}
	      // ]
	      // In this case, [20, 80] of y-dataZoom should be based on data
	      // that have filtered by x-dataZoom using range of [30, 70],
	      // but should not be based on full raw data. Thus sliding
	      // x-dataZoom will change both ranges of xAxis and yAxis,
	      // while sliding y-dataZoom will only change the range of yAxis.
	      // So we should filter x-axis after reset x-axis immediately,
	      // and then reset y-axis and filter y-axis.
	
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
	      });
	    });
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // Fullfill all of the range props so that user
	      // is able to get them from chart.getOption().
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	      var percentRange = axisProxy.getDataPercentWindow();
	      var valueRange = axisProxy.getDataValueWindow();
	      dataZoomModel.setRawRange({
	        start: percentRange[0],
	        end: percentRange[1],
	        startValue: valueRange[0],
	        endValue: valueRange[1]
	      }, true);
	    });
	  }
	});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var helper = __webpack_require__(548);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction('dataZoom', function (payload, ecModel) {
	  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
	    return model.get(dimNames.axisIndex);
	  });
	  var effectedModels = [];
	  ecModel.eachComponent({
	    mainType: 'dataZoom',
	    query: payload
	  }, function (model, index) {
	    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
	  });
	  zrUtil.each(effectedModels, function (dataZoomModel, index) {
	    dataZoomModel.setRawRange({
	      start: payload.start,
	      end: payload.end,
	      startValue: payload.startValue,
	      endValue: payload.endValue
	    });
	  });
	});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(559);
	
	__webpack_require__(570);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var preprocessor = __webpack_require__(560);
	
	__webpack_require__(561);
	
	__webpack_require__(562);
	
	__webpack_require__(563);
	
	__webpack_require__(566);
	
	__webpack_require__(569);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(option) {
	  var visualMap = option && option.visualMap;
	
	  if (!zrUtil.isArray(visualMap)) {
	    visualMap = visualMap ? [visualMap] : [];
	  }
	
	  each(visualMap, function (opt) {
	    if (!opt) {
	      return;
	    } // rename splitList to pieces
	
	
	    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
	      opt.pieces = opt.splitList;
	      delete opt.splitList;
	    }
	
	    var pieces = opt.pieces;
	
	    if (pieces && zrUtil.isArray(pieces)) {
	      each(pieces, function (piece) {
	        if (zrUtil.isObject(piece)) {
	          if (has(piece, 'start') && !has(piece, 'min')) {
	            piece.min = piece.start;
	          }
	
	          if (has(piece, 'end') && !has(piece, 'max')) {
	            piece.max = piece.end;
	          }
	        }
	      });
	    }
	  });
	}
	
	function has(obj, name) {
	  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	}
	
	module.exports = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('visualMap', function (option) {
	  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var visualSolution = __webpack_require__(532);
	
	var VisualMapping = __webpack_require__(375);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var VISUAL_PRIORITY = echarts.PRIORITY.VISUAL.COMPONENT;
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var resetDefines = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      var pipelineContext = seriesModel.pipelineContext;
	
	      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
	        return;
	      }
	
	      resetDefines.push(visualSolution.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, zrUtil.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
	    });
	    return resetDefines;
	  }
	}); // Only support color.
	
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var visualMetaList = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      if (visualMapModel.isTargetSeries(seriesModel)) {
	        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	          stops: [],
	          outerColors: []
	        };
	        var concreteDim = visualMapModel.getDataDimension(data);
	        var dimInfo = data.getDimensionInfo(concreteDim);
	
	        if (dimInfo != null) {
	          // visualMeta.dimension should be dimension index, but not concrete dimension.
	          visualMeta.dimension = dimInfo.index;
	          visualMetaList.push(visualMeta);
	        }
	      }
	    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	    seriesModel.getData().setVisual('visualMeta', visualMetaList);
	  }
	}); // FIXME
	// performance and export for heatmap?
	// value can be Infinity or -Infinity
	
	function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	  var mappings = visualMapModel.targetVisuals[valueState];
	  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	  var resultVisual = {
	    color: seriesModel.getData().getVisual('color') // default color.
	
	  };
	
	  for (var i = 0, len = visualTypes.length; i < len; i++) {
	    var type = visualTypes[i];
	    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	    mapping && mapping.applyVisual(value, getVisual, setVisual);
	  }
	
	  return resultVisual.color;
	
	  function getVisual(key) {
	    return resultVisual[key];
	  }
	
	  function setVisual(key, value) {
	    resultVisual[key] = value;
	  }
	}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var VisualMapModel = __webpack_require__(564);
	
	var numberUtil = __webpack_require__(218);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Constant
	var DEFAULT_BAR_BOUND = [20, 140];
	var ContinuousModel = VisualMapModel.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    align: 'auto',
	    // 'auto', 'left', 'right', 'top', 'bottom'
	    calculable: false,
	    // This prop effect default component type determine,
	    // See echarts/component/visualMap/typeDefaulter.
	    range: null,
	    // selected range. In default case `range` is [min, max]
	    // and can auto change along with modification of min max,
	    // util use specifid a range.
	    realtime: true,
	    // Whether realtime update.
	    itemHeight: null,
	    // The length of the range control edge.
	    itemWidth: null,
	    // The length of the other side.
	    hoverLink: true,
	    // Enable hover highlight.
	    hoverLinkDataSize: null,
	    // The size of hovered data.
	    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
	    // If not specified, follow the value of `realtime`.
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    ContinuousModel.superApply(this, 'optionUpdated', arguments);
	    this.resetExtent();
	    this.resetVisual(function (mappingOption) {
	      mappingOption.mappingMethod = 'linear';
	      mappingOption.dataExtent = this.getExtent();
	    });
	
	    this._resetRange();
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  resetItemSize: function () {
	    ContinuousModel.superApply(this, 'resetItemSize', arguments);
	    var itemSize = this.itemSize;
	    this._orient === 'horizontal' && itemSize.reverse();
	    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	  },
	
	  /**
	   * @private
	   */
	  _resetRange: function () {
	    var dataExtent = this.getExtent();
	    var range = this.option.range;
	
	    if (!range || range.auto) {
	      // `range` should always be array (so we dont use other
	      // value like 'auto') for user-friend. (consider getOption).
	      dataExtent.auto = 1;
	      this.option.range = dataExtent;
	    } else if (zrUtil.isArray(range)) {
	      if (range[0] > range[1]) {
	        range.reverse();
	      }
	
	      range[0] = Math.max(range[0], dataExtent[0]);
	      range[1] = Math.min(range[1], dataExtent[1]);
	    }
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	    zrUtil.each(this.stateList, function (state) {
	      var symbolSize = this.option.controller[state].symbolSize;
	
	      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	        symbolSize[0] = 0; // For good looking.
	      }
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.range = selected.slice();
	
	    this._resetRange();
	  },
	
	  /**
	   * @public
	   */
	  getSelected: function () {
	    var dataExtent = this.getExtent();
	    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp
	
	    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	    return dataInterval;
	  },
	
	  /**
	   * @override
	   */
	  getValueState: function (value) {
	    var range = this.option.range;
	    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	    // range[1] is processed likewise.
	
	    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	  },
	
	  /**
	   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (range) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @implement
	   */
	  getVisualMeta: function (getColorVisual) {
	    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	    var stops = [];
	
	    function setStop(value, valueState) {
	      stops.push({
	        value: value,
	        color: getColorVisual(value, valueState)
	      });
	    } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	    var iIdx = 0;
	    var oIdx = 0;
	    var iLen = iVals.length;
	    var oLen = oVals.length;
	
	    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	      if (oVals[oIdx] < iVals[iIdx]) {
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	      // If range is full, value beyond min, max will be clamped.
	      // make a singularity
	      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	      setStop(iVals[iIdx], 'inRange');
	    }
	
	    for (var first = 1; oIdx < oLen; oIdx++) {
	      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	        // make a singularity
	        if (first) {
	          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	          first = 0;
	        }
	
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    var stopsLen = stops.length;
	    return {
	      stops: stops,
	      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	    };
	  }
	});
	
	function getColorStopValues(visualMapModel, valueState, dataExtent) {
	  if (dataExtent[0] === dataExtent[1]) {
	    return dataExtent.slice();
	  } // When using colorHue mapping, it is not linear color any more.
	  // Moreover, canvas gradient seems not to be accurate linear.
	  // FIXME
	  // Should be arbitrary value 100? or based on pixel size?
	
	
	  var count = 200;
	  var step = (dataExtent[1] - dataExtent[0]) / count;
	  var value = dataExtent[0];
	  var stopValues = [];
	
	  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	    stopValues.push(value);
	    value += step;
	  }
	
	  stopValues.push(dataExtent[1]);
	  return stopValues;
	}
	
	var _default = ContinuousModel;
	module.exports = _default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var visualDefault = __webpack_require__(565);
	
	var VisualMapping = __webpack_require__(375);
	
	var visualSolution = __webpack_require__(532);
	
	var modelUtil = __webpack_require__(173);
	
	var numberUtil = __webpack_require__(218);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mapVisual = VisualMapping.mapVisual;
	var eachVisual = VisualMapping.eachVisual;
	var isArray = zrUtil.isArray;
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	var linearMap = numberUtil.linearMap;
	var noop = zrUtil.noop;
	var VisualMapModel = echarts.extendComponentModel({
	  type: 'visualMap',
	  dependencies: ['series'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  stateList: ['inRange', 'outOfRange'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],
	
	  /**
	   * [lowerBound, upperBound]
	   *
	   * @readOnly
	   * @type {Array.<number>}
	   */
	  dataBound: [-Infinity, Infinity],
	
	  /**
	   * @readOnly
	   * @type {string|Object}
	   */
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    zlevel: 0,
	    z: 4,
	    seriesIndex: 'all',
	    // 'all' or null/undefined: all series.
	    // A number or an array of number: the specified series.
	    // set min: 0, max: 200, only for campatible with ec2.
	    // In fact min max should not have default value.
	    min: 0,
	    // min value, must specified if pieces is not specified.
	    max: 200,
	    // max value, must specified if pieces is not specified.
	    dimension: null,
	    inRange: null,
	    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    outOfRange: null,
	    // 'color', 'colorHue', 'colorSaturation',
	    // 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    left: 0,
	    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
	    right: null,
	    // The same as left.
	    top: null,
	    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
	    bottom: 0,
	    // The same as top.
	    itemWidth: null,
	    itemHeight: null,
	    inverse: false,
	    orient: 'vertical',
	    // 'horizontal' ¦ 'vertical'
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderColor: '#ccc',
	    // 值域边框颜色
	    contentColor: '#5793f3',
	    inactiveColor: '#aaa',
	    borderWidth: 0,
	    // 值域边框线宽，单位px，默认为0（无边框）
	    padding: 5,
	    // 值域内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    textGap: 10,
	    //
	    precision: 0,
	    // 小数精度，默认为0，无小数点
	    color: null,
	    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
	    formatter: null,
	    text: null,
	    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
	    textStyle: {
	      color: '#333' // 值域文字颜色
	
	    }
	  },
	
	  /**
	   * @protected
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {Array.<number>}
	     */
	    this._dataExtent;
	    /**
	     * @readOnly
	     */
	
	    this.targetVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.controllerVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * [width, height]
	     * @readOnly
	     * @type {Array.<number>}
	     */
	
	    this.itemSize;
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	
	  /**
	   * @protected
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option; // FIXME
	    // necessary?
	    // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	    this.textStyleModel = this.getModel('textStyle');
	    this.resetItemSize();
	    this.completeVisualOption();
	  },
	
	  /**
	   * @protected
	   */
	  resetVisual: function (supplementVisualOption) {
	    var stateList = this.stateList;
	    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
	    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
	  },
	
	  /**
	   * @protected
	   * @return {Array.<number>} An array of series indices.
	   */
	  getTargetSeriesIndices: function () {
	    var optionSeriesIndex = this.option.seriesIndex;
	    var seriesIndices = [];
	
	    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	      this.ecModel.eachSeries(function (seriesModel, index) {
	        seriesIndices.push(index);
	      });
	    } else {
	      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
	    }
	
	    return seriesIndices;
	  },
	
	  /**
	   * @public
	   */
	  eachTargetSeries: function (callback, context) {
	    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
	      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
	    }, this);
	  },
	
	  /**
	   * @pubilc
	   */
	  isTargetSeries: function (seriesModel) {
	    var is = false;
	    this.eachTargetSeries(function (model) {
	      model === seriesModel && (is = true);
	    });
	    return is;
	  },
	
	  /**
	   * @example
	   * this.formatValueText(someVal); // format single numeric value to text.
	   * this.formatValueText(someVal, true); // format single category value to text.
	   * this.formatValueText([min, max]); // format numeric min-max to text.
	   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	   *
	   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
	   * @param {boolean} [isCategory=false] Only available when value is number.
	   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
	   * @return {string}
	   * @protected
	   */
	  formatValueText: function (value, isCategory, edgeSymbols) {
	    var option = this.option;
	    var precision = option.precision;
	    var dataBound = this.dataBound;
	    var formatter = option.formatter;
	    var isMinMax;
	    var textValue;
	    edgeSymbols = edgeSymbols || ['<', '>'];
	
	    if (zrUtil.isArray(value)) {
	      value = value.slice();
	      isMinMax = true;
	    }
	
	    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	    if (zrUtil.isString(formatter)) {
	      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	    } else if (zrUtil.isFunction(formatter)) {
	      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	    }
	
	    if (isMinMax) {
	      if (value[0] === dataBound[0]) {
	        return edgeSymbols[0] + ' ' + textValue[1];
	      } else if (value[1] === dataBound[1]) {
	        return edgeSymbols[1] + ' ' + textValue[0];
	      } else {
	        return textValue[0] + ' - ' + textValue[1];
	      }
	    } else {
	      // Format single value (includes category case).
	      return textValue;
	    }
	
	    function toFixed(val) {
	      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetExtent: function () {
	    var thisOption = this.option; // Can not calculate data extent by data here.
	    // Because series and data may be modified in processing stage.
	    // So we do not support the feature "auto min/max".
	
	    var extent = asc([thisOption.min, thisOption.max]);
	    this._dataExtent = extent;
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/data/List} list
	   * @return {string} Concrete dimention. If return null/undefined,
	   *                  no dimension used.
	   */
	  getDataDimension: function (list) {
	    var optDim = this.option.dimension;
	    var listDimensions = list.dimensions;
	
	    if (optDim == null && !listDimensions.length) {
	      return;
	    }
	
	    if (optDim != null) {
	      return list.getDimension(optDim);
	    }
	
	    var dimNames = list.dimensions;
	
	    for (var i = dimNames.length - 1; i >= 0; i--) {
	      var dimName = dimNames[i];
	      var dimInfo = list.getDimensionInfo(dimName);
	
	      if (!dimInfo.isCalculationCoord) {
	        return dimName;
	      }
	    }
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getExtent: function () {
	    return this._dataExtent.slice();
	  },
	
	  /**
	   * @protected
	   */
	  completeVisualOption: function () {
	    var ecModel = this.ecModel;
	    var thisOption = this.option;
	    var base = {
	      inRange: thisOption.inRange,
	      outOfRange: thisOption.outOfRange
	    };
	    var target = thisOption.target || (thisOption.target = {});
	    var controller = thisOption.controller || (thisOption.controller = {});
	    zrUtil.merge(target, base); // Do not override
	
	    zrUtil.merge(controller, base); // Do not override
	
	    var isCategory = this.isCategory();
	    completeSingle.call(this, target);
	    completeSingle.call(this, controller);
	    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	    completeController.call(this, controller);
	
	    function completeSingle(base) {
	      // Compatible with ec2 dataRange.color.
	      // The mapping order of dataRange.color is: [high value, ..., low value]
	      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	      // Notice: ec2 has no inverse.
	      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	      // So adding color only when no inRange defined.
	      && !base.inRange) {
	        base.inRange = {
	          color: thisOption.color.slice().reverse()
	        };
	      } // Compatible with previous logic, always give a defautl color, otherwise
	      // simple config with no inRange and outOfRange will not work.
	      // Originally we use visualMap.color as the default color, but setOption at
	      // the second time the default color will be erased. So we change to use
	      // constant DEFAULT_COLOR.
	      // If user do not want the defualt color, set inRange: {color: null}.
	
	
	      base.inRange = base.inRange || {
	        color: ecModel.get('gradientColor')
	      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
	
	      each(this.stateList, function (state) {
	        var visualType = base[state];
	
	        if (zrUtil.isString(visualType)) {
	          var defa = visualDefault.get(visualType, 'active', isCategory);
	
	          if (defa) {
	            base[state] = {};
	            base[state][visualType] = defa;
	          } else {
	            // Mark as not specified.
	            delete base[state];
	          }
	        }
	      }, this);
	    }
	
	    function completeInactive(base, stateExist, stateAbsent) {
	      var optExist = base[stateExist];
	      var optAbsent = base[stateAbsent];
	
	      if (optExist && !optAbsent) {
	        optAbsent = base[stateAbsent] = {};
	        each(optExist, function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	          if (defa != null) {
	            optAbsent[visualType] = defa; // Compatibable with ec2:
	            // Only inactive color to rgba(0,0,0,0) can not
	            // make label transparent, so use opacity also.
	
	            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	              optAbsent.opacity = [0, 0];
	            }
	          }
	        });
	      }
	    }
	
	    function completeController(controller) {
	      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	      var inactiveColor = this.get('inactiveColor');
	      each(this.stateList, function (state) {
	        var itemSize = this.itemSize;
	        var visuals = controller[state]; // Set inactive color for controller if no other color
	        // attr (like colorAlpha) specified.
	
	        if (!visuals) {
	          visuals = controller[state] = {
	            color: isCategory ? inactiveColor : [inactiveColor]
	          };
	        } // Consistent symbol and symbolSize if not specified.
	
	
	        if (visuals.symbol == null) {
	          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
	        }
	
	        if (visuals.symbolSize == null) {
	          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	        } // Filter square and none.
	
	
	        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
	          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
	        }); // Normalize symbolSize
	
	        var symbolSize = visuals.symbolSize;
	
	        if (symbolSize != null) {
	          var max = -Infinity; // symbolSize can be object when categories defined.
	
	          eachVisual(symbolSize, function (value) {
	            value > max && (max = value);
	          });
	          visuals.symbolSize = mapVisual(symbolSize, function (value) {
	            return linearMap(value, [0, max], [0, itemSize[0]], true);
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetItemSize: function () {
	    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	  },
	
	  /**
	   * @public
	   */
	  isCategory: function () {
	    return !!this.option.categories;
	  },
	
	  /**
	   * @public
	   * @abstract
	   */
	  setSelected: noop,
	
	  /**
	   * @public
	   * @abstract
	   * @param {*|module:echarts/data/List} valueOrData
	   * @param {number} dataIndex
	   * @return {string} state See this.stateList
	   */
	  getValueState: noop,
	
	  /**
	   * FIXME
	   * Do not publish to thirt-part-dev temporarily
	   * util the interface is stable. (Should it return
	   * a function but not visual meta?)
	   *
	   * @pubilc
	   * @abstract
	   * @param {Function} getColorVisual
	   *        params: value, valueState
	   *        return: color
	   * @return {Object} visualMeta
	   *        should includes {stops, outerColors}
	   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	   */
	  getVisualMeta: noop
	});
	var _default = VisualMapModel;
	module.exports = _default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual mapping.
	 */
	var visualDefault = {
	  /**
	   * @public
	   */
	  get: function (visualType, key, isCategory) {
	    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
	    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
	  }
	};
	var defaultOption = {
	  color: {
	    active: ['#006edd', '#e0ffff'],
	    inactive: ['rgba(0,0,0,0)']
	  },
	  colorHue: {
	    active: [0, 360],
	    inactive: [0, 0]
	  },
	  colorSaturation: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  colorLightness: {
	    active: [0.9, 0.5],
	    inactive: [0, 0]
	  },
	  colorAlpha: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  opacity: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  symbol: {
	    active: ['circle', 'roundRect', 'diamond'],
	    inactive: ['none']
	  },
	  symbolSize: {
	    active: [10, 50],
	    inactive: [0, 0]
	  }
	};
	var _default = visualDefault;
	module.exports = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var LinearGradient = __webpack_require__(210);
	
	var eventTool = __webpack_require__(139);
	
	var VisualMapView = __webpack_require__(567);
	
	var graphic = __webpack_require__(180);
	
	var numberUtil = __webpack_require__(218);
	
	var sliderMove = __webpack_require__(412);
	
	var helper = __webpack_require__(568);
	
	var modelUtil = __webpack_require__(173);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var linearMap = numberUtil.linearMap;
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max; // Arbitrary value
	
	var HOVER_LINK_SIZE = 12;
	var HOVER_LINK_OUT = 6; // Notice:
	// Any "interval" should be by the order of [low, high].
	// "handle0" (handleIndex === 0) maps to
	// low data value: this._dataInterval[0] and has low coord.
	// "handle1" (handleIndex === 1) maps to
	// high data value: this._dataInterval[1] and has high coord.
	// The logic of transform is implemented in this._createBarGroup.
	
	var ContinuousView = VisualMapView.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @override
	   */
	  init: function () {
	    ContinuousView.superApply(this, 'init', arguments);
	    /**
	     * @private
	     */
	
	    this._shapes = {};
	    /**
	     * @private
	     */
	
	    this._dataInterval = [];
	    /**
	     * @private
	     */
	
	    this._handleEnds = [];
	    /**
	     * @private
	     */
	
	    this._orient;
	    /**
	     * @private
	     */
	
	    this._useHandle;
	    /**
	     * @private
	     */
	
	    this._hoverLinkDataIndices = [];
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._hovering;
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function (visualMapModel, ecModel, api, payload) {
	    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	      this._buildView();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _buildView: function () {
	    this.group.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var thisGroup = this.group;
	    this._orient = visualMapModel.get('orient');
	    this._useHandle = visualMapModel.get('calculable');
	
	    this._resetInterval();
	
	    this._renderBar(thisGroup);
	
	    var dataRangeText = visualMapModel.get('text');
	
	    this._renderEndsText(thisGroup, dataRangeText, 0);
	
	    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	    this._updateView(true); // After updating view, inner shapes is built completely,
	    // and then background can be rendered.
	
	
	    this.renderBackground(thisGroup); // Real update view
	
	    this._updateView();
	
	    this._enableHoverLinkToSeries();
	
	    this._enableHoverLinkFromSeries();
	
	    this.positionGroup(thisGroup);
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, dataRangeText, endsIndex) {
	    if (!dataRangeText) {
	      return;
	    } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	    var text = dataRangeText[1 - endsIndex];
	    text = text != null ? text + '' : '';
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var itemSize = visualMapModel.itemSize;
	    var barGroup = this._shapes.barGroup;
	
	    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	    var orient = this._orient;
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    this.group.add(new graphic.Text({
	      style: {
	        x: position[0],
	        y: position[1],
	        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
	        textAlign: orient === 'horizontal' ? align : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderBar: function (targetGroup) {
	    var visualMapModel = this.visualMapModel;
	    var shapes = this._shapes;
	    var itemSize = visualMapModel.itemSize;
	    var orient = this._orient;
	    var useHandle = this._useHandle;
	    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);
	
	    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
	
	
	    barGroup.add(shapes.outOfRange = createPolygon());
	    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
	    var textRect = visualMapModel.textStyleModel.getTextRect('国');
	    var textSize = mathMax(textRect.width, textRect.height); // Handle
	
	    if (useHandle) {
	      shapes.handleThumbs = [];
	      shapes.handleLabels = [];
	      shapes.handleLabelPoints = [];
	
	      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
	
	      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
	    }
	
	    this._createIndicator(barGroup, itemSize, textSize, orient);
	
	    targetGroup.add(barGroup);
	  },
	
	  /**
	   * @private
	   */
	  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
	    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
	    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
	    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
	    handleThumb.position[0] = itemSize[0];
	    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	    // transform (orient/inverse). So label is built separately but not
	    // use zrender/graphic/helper/RectText, and is located based on view
	    // group (according to handleLabelPoint) but not barGroup.
	
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var handleLabel = new graphic.Text({
	      draggable: true,
	      drift: onDrift,
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragend: onDragEnd,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(handleLabel);
	    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
	    var shapes = this._shapes;
	    shapes.handleThumbs[handleIndex] = handleThumb;
	    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	    shapes.handleLabels[handleIndex] = handleLabel;
	  },
	
	  /**
	   * @private
	   */
	  _createIndicator: function (barGroup, itemSize, textSize, orient) {
	    var indicator = createPolygon([[0, 0]], 'move');
	    indicator.position[0] = itemSize[0];
	    indicator.attr({
	      invisible: true,
	      silent: true
	    });
	    barGroup.add(indicator);
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var indicatorLabel = new graphic.Text({
	      silent: true,
	      invisible: true,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(indicatorLabel);
	    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
	    var shapes = this._shapes;
	    shapes.indicator = indicator;
	    shapes.indicatorLabel = indicatorLabel;
	    shapes.indicatorLabelPoint = indicatorLabelPoint;
	  },
	
	  /**
	   * @private
	   */
	  _dragHandle: function (handleIndex, isEnd, dx, dy) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    this._dragging = !isEnd;
	
	    if (!isEnd) {
	      // Transform dx, dy to bar coordination.
	      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);
	
	      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
	      // before dispatch action.
	
	
	      this._updateView();
	    } // dragEnd do not dispatch action when realtime.
	
	
	    if (isEnd === !this.visualMapModel.get('realtime')) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'selectDataRange',
	        from: this.uid,
	        visualMapId: this.visualMapModel.id,
	        selected: this._dataInterval.slice()
	      });
	    }
	
	    if (isEnd) {
	      !this._hovering && this._clearHoverLinkToSeries();
	    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var visualMapModel = this.visualMapModel;
	    var dataInterval = this._dataInterval = visualMapModel.getSelected();
	    var dataExtent = visualMapModel.getExtent();
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} dx
	   * @param {number} dy
	   */
	  _updateInterval: function (handleIndex, delta) {
	    delta = delta || 0;
	    var visualMapModel = this.visualMapModel;
	    var handleEnds = this._handleEnds;
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
	    0);
	    var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (forSketch) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var shapes = this._shapes;
	    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	    shapes.inRange.setStyle({
	      fill: visualInRange.barColor,
	      opacity: visualInRange.opacity
	    }).setShape('points', visualInRange.barPoints);
	    shapes.outOfRange.setStyle({
	      fill: visualOutOfRange.barColor,
	      opacity: visualOutOfRange.opacity
	    }).setShape('points', visualOutOfRange.barPoints);
	
	    this._updateHandle(inRangeHandleEnds, visualInRange);
	  },
	
	  /**
	   * @private
	   */
	  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
	    var opts = {
	      forceState: forceState,
	      convertOpacityToAlpha: true
	    };
	
	    var colorStops = this._makeColorGradient(dataInterval, opts);
	
	    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	    var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	    return {
	      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	      barPoints: barPoints,
	      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	    };
	  },
	
	  /**
	   * @private
	   */
	  _makeColorGradient: function (dataInterval, opts) {
	    // Considering colorHue, which is not linear, so we have to sample
	    // to calculate gradient color stops, but not only caculate head
	    // and tail.
	    var sampleNumber = 100; // Arbitrary value.
	
	    var colorStops = [];
	    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[0], 'color', opts),
	      offset: 0
	    });
	
	    for (var i = 1; i < sampleNumber; i++) {
	      var currValue = dataInterval[0] + step * i;
	
	      if (currValue > dataInterval[1]) {
	        break;
	      }
	
	      colorStops.push({
	        color: this.getControllerVisual(currValue, 'color', opts),
	        offset: i / sampleNumber
	      });
	    }
	
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[1], 'color', opts),
	      offset: 1
	    });
	    return colorStops;
	  },
	
	  /**
	   * @private
	   */
	  _createBarPoints: function (handleEnds, symbolSizes) {
	    var itemSize = this.visualMapModel.itemSize;
	    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	  },
	
	  /**
	   * @private
	   */
	  _createBarGroup: function (itemAlign) {
	    var orient = this._orient;
	    var inverse = this.visualMapModel.get('inverse');
	    return new graphic.Group(orient === 'horizontal' && !inverse ? {
	      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
	      rotation: Math.PI / 2
	    } : orient === 'horizontal' && inverse ? {
	      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
	      rotation: -Math.PI / 2
	    } : orient === 'vertical' && !inverse ? {
	      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
	    } : {
	      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _updateHandle: function (handleEnds, visualInRange) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    var shapes = this._shapes;
	    var visualMapModel = this.visualMapModel;
	    var handleThumbs = shapes.handleThumbs;
	    var handleLabels = shapes.handleLabels;
	    each([0, 1], function (handleIndex) {
	      var handleThumb = handleThumbs[handleIndex];
	      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
	
	      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	        textVerticalAlign: 'middle',
	        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   * @param {number} cursorValue
	   * @param {number} textValue
	   * @param {string} [rangeSymbol]
	   * @param {number} [halfHoverLinkSize]
	   */
	  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var itemSize = visualMapModel.itemSize;
	    var sizeExtent = [0, itemSize[1]];
	    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
	    var shapes = this._shapes;
	    var indicator = shapes.indicator;
	
	    if (!indicator) {
	      return;
	    }
	
	    indicator.position[1] = pos;
	    indicator.attr('invisible', false);
	    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
	    var opts = {
	      convertOpacityToAlpha: true
	    };
	    var color = this.getControllerVisual(cursorValue, 'color', opts);
	    indicator.setStyle('fill', color); // Update handle label position.
	
	    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
	    var indicatorLabel = shapes.indicatorLabel;
	    indicatorLabel.attr('invisible', false);
	
	    var align = this._applyTransform('left', shapes.barGroup);
	
	    var orient = this._orient;
	    indicatorLabel.setStyle({
	      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
	      textAlign: orient === 'horizontal' ? 'center' : align,
	      x: textPoint[0],
	      y: textPoint[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkToSeries: function () {
	    var self = this;
	
	    this._shapes.barGroup.on('mousemove', function (e) {
	      self._hovering = true;
	
	      if (!self._dragging) {
	        var itemSize = self.visualMapModel.itemSize;
	
	        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
	        // below or upper than sizeExtent.
	
	
	        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);
	
	        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	      }
	    }).on('mouseout', function () {
	      // When mouse is out of handle, hoverLink still need
	      // to be displayed when realtime is set as false.
	      self._hovering = false;
	      !self._dragging && self._clearHoverLinkToSeries();
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkFromSeries: function () {
	    var zr = this.api.getZr();
	
	    if (this.visualMapModel.option.hoverLink) {
	      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	      zr.on('mouseout', this._hideIndicator, this);
	    } else {
	      this._clearHoverLinkFromSeries();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
	    var visualMapModel = this.visualMapModel;
	    var itemSize = visualMapModel.itemSize;
	
	    if (!visualMapModel.option.hoverLink) {
	      return;
	    }
	
	    var sizeExtent = [0, itemSize[1]];
	    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
	    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
	    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	    // where china and india has very large population.
	
	    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	    // otherwise labels overlap, especially when dragging.
	
	    if (hoverOnBar) {
	      if (valueRange[0] === -Infinity) {
	        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	      } else if (valueRange[1] === Infinity) {
	        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	      } else {
	        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	      }
	    } // When realtime is set as false, handles, which are in barGroup,
	    // also trigger hoverLink, which help user to realize where they
	    // focus on when dragging. (see test/heatmap-large.html)
	    // When realtime is set as true, highlight will not show when hover
	    // handle, because the label on handle, which displays a exact value
	    // but not range, might mislead users.
	
	
	    var oldBatch = this._hoverLinkDataIndices;
	    var newBatch = [];
	
	    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	    }
	
	    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);
	
	    this._dispatchHighDown('downplay', helper.convertDataIndex(resultBatches[0]));
	
	    this._dispatchHighDown('highlight', helper.convertDataIndex(resultBatches[1]));
	  },
	
	  /**
	   * @private
	   */
	  _hoverLinkFromSeriesMouseOver: function (e) {
	    var el = e.target;
	    var visualMapModel = this.visualMapModel;
	
	    if (!el || el.dataIndex == null) {
	      return;
	    }
	
	    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
	
	    if (!visualMapModel.isTargetSeries(dataModel)) {
	      return;
	    }
	
	    var data = dataModel.getData(el.dataType);
	    var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);
	
	    if (!isNaN(value)) {
	      this._showIndicator(value, value);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _hideIndicator: function () {
	    var shapes = this._shapes;
	    shapes.indicator && shapes.indicator.attr('invisible', true);
	    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkToSeries: function () {
	    this._hideIndicator();
	
	    var indices = this._hoverLinkDataIndices;
	
	    this._dispatchHighDown('downplay', helper.convertDataIndex(indices));
	
	    indices.length = 0;
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkFromSeries: function () {
	    this._hideIndicator();
	
	    var zr = this.api.getZr();
	    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	    zr.off('mouseout', this._hideIndicator);
	  },
	
	  /**
	   * @private
	   */
	  _applyTransform: function (vertex, element, inverse, global) {
	    var transform = graphic.getTransform(element, global ? null : this.group);
	    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
	  },
	
	  /**
	   * @private
	   */
	  _dispatchHighDown: function (type, batch) {
	    batch && batch.length && this.api.dispatchAction({
	      type: type,
	      batch: batch
	    });
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  }
	});
	
	function createPolygon(points, cursor, onDrift, onDragEnd) {
	  return new graphic.Polygon({
	    shape: {
	      points: points
	    },
	    draggable: !!onDrift,
	    cursor: cursor,
	    drift: onDrift,
	    onmousemove: function (e) {
	      // Fot mobile devicem, prevent screen slider on the button.
	      eventTool.stop(e.event);
	    },
	    ondragend: onDragEnd
	  });
	}
	
	function createHandlePoints(handleIndex, textSize) {
	  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
	}
	
	function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
	  return isRange ? [// indicate range
	  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
	  [0, 0], [5, -5], [5, 5]];
	}
	
	function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	  if (hoverLinkDataSize) {
	    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	  }
	
	  return halfHoverLinkSize;
	}
	
	function useHoverLinkOnHandle(visualMapModel) {
	  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = ContinuousView;
	module.exports = _default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var graphic = __webpack_require__(180);
	
	var formatUtil = __webpack_require__(219);
	
	var layout = __webpack_require__(217);
	
	var VisualMapping = __webpack_require__(375);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'visualMap',
	
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	  autoPositionValues: {
	    left: 1,
	    right: 1,
	    top: 1,
	    bottom: 1
	  },
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/visualMap/visualMapModel}
	     */
	
	    this.visualMapModel;
	  },
	
	  /**
	   * @protected
	   */
	  render: function (visualMapModel, ecModel, api, payload) {
	    this.visualMapModel = visualMapModel;
	
	    if (visualMapModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    }
	
	    this.doRender.apply(this, arguments);
	  },
	
	  /**
	   * @protected
	   */
	  renderBackground: function (group) {
	    var visualMapModel = this.visualMapModel;
	    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
	    var rect = group.getBoundingRect();
	    group.add(new graphic.Rect({
	      z2: -1,
	      // Lay background rect on the lowest layer.
	      silent: true,
	      shape: {
	        x: rect.x - padding[3],
	        y: rect.y - padding[0],
	        width: rect.width + padding[3] + padding[1],
	        height: rect.height + padding[0] + padding[2]
	      },
	      style: {
	        fill: visualMapModel.get('backgroundColor'),
	        stroke: visualMapModel.get('borderColor'),
	        lineWidth: visualMapModel.get('borderWidth')
	      }
	    }));
	  },
	
	  /**
	   * @protected
	   * @param {number} targetValue can be Infinity or -Infinity
	   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	   * @param {Object} [opts]
	   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
	   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
	   * @return {*} Visual value.
	   */
	  getControllerVisual: function (targetValue, visualCluster, opts) {
	    opts = opts || {};
	    var forceState = opts.forceState;
	    var visualMapModel = this.visualMapModel;
	    var visualObj = {}; // Default values.
	
	    if (visualCluster === 'symbol') {
	      visualObj.symbol = visualMapModel.get('itemSymbol');
	    }
	
	    if (visualCluster === 'color') {
	      var defaultColor = visualMapModel.get('contentColor');
	      visualObj.color = defaultColor;
	    }
	
	    function getter(key) {
	      return visualObj[key];
	    }
	
	    function setter(key, value) {
	      visualObj[key] = value;
	    }
	
	    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	    zrUtil.each(visualTypes, function (type) {
	      var visualMapping = mappings[type];
	
	      if (opts.convertOpacityToAlpha && type === 'opacity') {
	        type = 'colorAlpha';
	        visualMapping = mappings.__alphaForOpacity;
	      }
	
	      if (VisualMapping.dependsOn(type, visualCluster)) {
	        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	      }
	    });
	    return visualObj[visualCluster];
	  },
	
	  /**
	   * @protected
	   */
	  positionGroup: function (group) {
	    var model = this.visualMapModel;
	    var api = this.api;
	    layout.positionElement(group, model.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  },
	
	  /**
	   * @protected
	   * @abstract
	   */
	  doRender: zrUtil.noop
	});
	
	module.exports = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var _layout = __webpack_require__(217);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Array.<number>} itemSize always [short, long]
	 * @return {string} 'left' or 'right' or 'top' or 'bottom'
	 */
	function getItemAlign(visualMapModel, api, itemSize) {
	  var modelOption = visualMapModel.option;
	  var itemAlign = modelOption.align;
	
	  if (itemAlign != null && itemAlign !== 'auto') {
	    return itemAlign;
	  } // Auto decision align.
	
	
	  var ecSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	  var reals = paramsSet[realIndex];
	  var fakeValue = [0, null, 10];
	  var layoutInput = {};
	
	  for (var i = 0; i < 3; i++) {
	    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	  }
	
	  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	}
	/**
	 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	 * dataIndexInside means filtered index.
	 */
	
	
	function convertDataIndex(batch) {
	  zrUtil.each(batch || [], function (batchItem) {
	    if (batch.dataIndex != null) {
	      batch.dataIndexInside = batch.dataIndex;
	      batch.dataIndex = null;
	    }
	  });
	  return batch;
	}
	
	exports.getItemAlign = getItemAlign;
	exports.convertDataIndex = convertDataIndex;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'selectDataRange',
	  event: 'dataRangeSelected',
	  // FIXME use updateView appears wrong
	  update: 'update'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'visualMap',
	    query: payload
	  }, function (model) {
	    model.setSelected(payload.selected);
	  });
	});

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var preprocessor = __webpack_require__(560);
	
	__webpack_require__(561);
	
	__webpack_require__(562);
	
	__webpack_require__(571);
	
	__webpack_require__(572);
	
	__webpack_require__(569);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(134);
	
	var VisualMapModel = __webpack_require__(564);
	
	var VisualMapping = __webpack_require__(375);
	
	var visualDefault = __webpack_require__(565);
	
	var _number = __webpack_require__(218);
	
	var reformIntervals = _number.reformIntervals;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseModel = VisualMapModel.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * Order Rule:
	   *
	   * option.categories / option.pieces / option.text / option.selected:
	   *     If !option.inverse,
	   *     Order when vertical: ['top', ..., 'bottom'].
	   *     Order when horizontal: ['left', ..., 'right'].
	   *     If option.inverse, the meaning of
	   *     the order should be reversed.
	   *
	   * this._pieceList:
	   *     The order is always [low, ..., high].
	   *
	   * Mapping from location to low-high:
	   *     If !option.inverse
	   *     When vertical, top is high.
	   *     When horizontal, right is high.
	   *     If option.inverse, reverse.
	   */
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    selected: null,
	    // Object. If not specified, means selected.
	    // When pieces and splitNumber: {'0': true, '5': true}
	    // When categories: {'cate1': false, 'cate3': true}
	    // When selected === false, means all unselected.
	    minOpen: false,
	    // Whether include values that smaller than `min`.
	    maxOpen: false,
	    // Whether include values that bigger than `max`.
	    align: 'auto',
	    // 'auto', 'left', 'right'
	    itemWidth: 20,
	    // When put the controller vertically, it is the length of
	    // horizontal side of each item. Otherwise, vertical side.
	    itemHeight: 14,
	    // When put the controller vertically, it is the length of
	    // vertical side of each item. Otherwise, horizontal side.
	    itemSymbol: 'roundRect',
	    pieceList: null,
	    // Each item is Object, with some of those attrs:
	    // {min, max, lt, gt, lte, gte, value,
	    // color, colorSaturation, colorAlpha, opacity,
	    // symbol, symbolSize}, which customize the range or visual
	    // coding of the certain piece. Besides, see "Order Rule".
	    categories: null,
	    // category names, like: ['some1', 'some2', 'some3'].
	    // Attr min/max are ignored when categories set. See "Order Rule"
	    splitNumber: 5,
	    // If set to 5, auto split five pieces equally.
	    // If set to 0 and component type not set, component type will be
	    // determined as "continuous". (It is less reasonable but for ec2
	    // compatibility, see echarts/component/visualMap/typeDefaulter)
	    selectedMode: 'multiple',
	    // Can be 'multiple' or 'single'.
	    itemGap: 10,
	    // The gap between two items, in px.
	    hoverLink: true,
	    // Enable hover highlight.
	    showLabel: null // By default, when text is used, label will hide (the logic
	    // is remained for compatibility reason)
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
	    /**
	     * The order is always [low, ..., high].
	     * [{text: string, interval: Array.<number>}, ...]
	     * @private
	     * @type {Array.<Object>}
	     */
	
	    this._pieceList = [];
	    this.resetExtent();
	    /**
	     * 'pieces', 'categories', 'splitNumber'
	     * @type {string}
	     */
	
	    var mode = this._mode = this._determineMode();
	
	    resetMethods[this._mode].call(this);
	
	    this._resetSelected(newOption, isInit);
	
	    var categories = this.option.categories;
	    this.resetVisual(function (mappingOption, state) {
	      if (mode === 'categories') {
	        mappingOption.mappingMethod = 'category';
	        mappingOption.categories = zrUtil.clone(categories);
	      } else {
	        mappingOption.dataExtent = this.getExtent();
	        mappingOption.mappingMethod = 'piecewise';
	        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
	          var piece = zrUtil.clone(piece);
	
	          if (state !== 'inRange') {
	            // FIXME
	            // outOfRange do not support special visual in pieces.
	            piece.visual = null;
	          }
	
	          return piece;
	        });
	      }
	    });
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    // Consider this case:
	    // visualMap: {
	    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	    // }
	    // where no inRange/outOfRange set but only pieces. So we should make
	    // default inRange/outOfRange for this case, otherwise visuals that only
	    // appear in `pieces` will not be taken into account in visual encoding.
	    var option = this.option;
	    var visualTypesInPieces = {};
	    var visualTypes = VisualMapping.listVisualTypes();
	    var isCategory = this.isCategory();
	    zrUtil.each(option.pieces, function (piece) {
	      zrUtil.each(visualTypes, function (visualType) {
	        if (piece.hasOwnProperty(visualType)) {
	          visualTypesInPieces[visualType] = 1;
	        }
	      });
	    });
	    zrUtil.each(visualTypesInPieces, function (v, visualType) {
	      var exists = 0;
	      zrUtil.each(this.stateList, function (state) {
	        exists |= has(option, state, visualType) || has(option.target, state, visualType);
	      }, this);
	      !exists && zrUtil.each(this.stateList, function (state) {
	        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	      });
	    }, this);
	
	    function has(obj, state, visualType) {
	      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
	      );
	    }
	
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	  },
	  _resetSelected: function (newOption, isInit) {
	    var thisOption = this.option;
	    var pieceList = this._pieceList; // Selected do not merge but all override.
	
	    var selected = (isInit ? thisOption : newOption).selected || {};
	    thisOption.selected = selected; // Consider 'not specified' means true.
	
	    zrUtil.each(pieceList, function (piece, index) {
	      var key = this.getSelectedMapKey(piece);
	
	      if (!selected.hasOwnProperty(key)) {
	        selected[key] = true;
	      }
	    }, this);
	
	    if (thisOption.selectedMode === 'single') {
	      // Ensure there is only one selected.
	      var hasSel = false;
	      zrUtil.each(pieceList, function (piece, index) {
	        var key = this.getSelectedMapKey(piece);
	
	        if (selected[key]) {
	          hasSel ? selected[key] = false : hasSel = true;
	        }
	      }, this);
	    } // thisOption.selectedMode === 'multiple', default: all selected.
	
	  },
	
	  /**
	   * @public
	   */
	  getSelectedMapKey: function (piece) {
	    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	  },
	
	  /**
	   * @public
	   */
	  getPieceList: function () {
	    return this._pieceList;
	  },
	
	  /**
	   * @private
	   * @return {string}
	   */
	  _determineMode: function () {
	    var option = this.option;
	    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.selected = zrUtil.clone(selected);
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getValueState: function (value) {
	    var index = VisualMapping.findPieceIndex(value, this._pieceList);
	    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	  },
	
	  /**
	   * @public
	   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (pieceIndex) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        // Should always base on model pieceList, because it is order sensitive.
	        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
	        pIdx === pieceIndex && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @private
	   * @param {Object} piece piece.value or piece.interval is required.
	   * @return {number} Can be Infinity or -Infinity
	   */
	  getRepresentValue: function (piece) {
	    var representValue;
	
	    if (this.isCategory()) {
	      representValue = piece.value;
	    } else {
	      if (piece.value != null) {
	        representValue = piece.value;
	      } else {
	        var pieceInterval = piece.interval || [];
	        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	      }
	    }
	
	    return representValue;
	  },
	  getVisualMeta: function (getColorVisual) {
	    // Do not support category. (category axis is ordinal, numerical)
	    if (this.isCategory()) {
	      return;
	    }
	
	    var stops = [];
	    var outerColors = [];
	    var visualMapModel = this;
	
	    function setStop(interval, valueState) {
	      var representValue = visualMapModel.getRepresentValue({
	        interval: interval
	      });
	
	      if (!valueState) {
	        valueState = visualMapModel.getValueState(representValue);
	      }
	
	      var color = getColorVisual(representValue, valueState);
	
	      if (interval[0] === -Infinity) {
	        outerColors[0] = color;
	      } else if (interval[1] === Infinity) {
	        outerColors[1] = color;
	      } else {
	        stops.push({
	          value: interval[0],
	          color: color
	        }, {
	          value: interval[1],
	          color: color
	        });
	      }
	    } // Suplement
	
	
	    var pieceList = this._pieceList.slice();
	
	    if (!pieceList.length) {
	      pieceList.push({
	        interval: [-Infinity, Infinity]
	      });
	    } else {
	      var edge = pieceList[0].interval[0];
	      edge !== -Infinity && pieceList.unshift({
	        interval: [-Infinity, edge]
	      });
	      edge = pieceList[pieceList.length - 1].interval[1];
	      edge !== Infinity && pieceList.push({
	        interval: [edge, Infinity]
	      });
	    }
	
	    var curr = -Infinity;
	    zrUtil.each(pieceList, function (piece) {
	      var interval = piece.interval;
	
	      if (interval) {
	        // Fulfill gap.
	        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	        setStop(interval.slice());
	        curr = interval[1];
	      }
	    }, this);
	    return {
	      stops: stops,
	      outerColors: outerColors
	    };
	  }
	});
	/**
	 * Key is this._mode
	 * @type {Object}
	 * @this {module:echarts/component/viusalMap/PiecewiseMode}
	 */
	
	var resetMethods = {
	  splitNumber: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    var precision = Math.min(thisOption.precision, 20);
	    var dataExtent = this.getExtent();
	    var splitNumber = thisOption.splitNumber;
	    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	    thisOption.splitNumber = splitNumber;
	    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	      precision++;
	    }
	
	    thisOption.precision = precision;
	    splitStep = +splitStep.toFixed(precision);
	    var index = 0;
	
	    if (thisOption.minOpen) {
	      pieceList.push({
	        index: index++,
	        interval: [-Infinity, dataExtent[0]],
	        close: [0, 0]
	      });
	    }
	
	    for (var curr = dataExtent[0], len = index + splitNumber; index < len; curr += splitStep) {
	      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	      pieceList.push({
	        index: index++,
	        interval: [curr, max],
	        close: [1, 1]
	      });
	    }
	
	    if (thisOption.maxOpen) {
	      pieceList.push({
	        index: index++,
	        interval: [dataExtent[1], Infinity],
	        close: [0, 0]
	      });
	    }
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      piece.text = this.formatValueText(piece.interval);
	    }, this);
	  },
	  categories: function () {
	    var thisOption = this.option;
	    zrUtil.each(thisOption.categories, function (cate) {
	      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	      // 是否改一致。
	      this._pieceList.push({
	        text: this.formatValueText(cate, true),
	        value: cate
	      });
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, this._pieceList);
	  },
	  pieces: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
	      if (!zrUtil.isObject(pieceListItem)) {
	        pieceListItem = {
	          value: pieceListItem
	        };
	      }
	
	      var item = {
	        text: '',
	        index: index
	      };
	
	      if (pieceListItem.label != null) {
	        item.text = pieceListItem.label;
	      }
	
	      if (pieceListItem.hasOwnProperty('value')) {
	        var value = item.value = pieceListItem.value;
	        item.interval = [value, value];
	        item.close = [1, 1];
	      } else {
	        // `min` `max` is legacy option.
	        // `lt` `gt` `lte` `gte` is recommanded.
	        var interval = item.interval = [];
	        var close = item.close = [0, 0];
	        var closeList = [1, 0, 1];
	        var infinityList = [-Infinity, Infinity];
	        var useMinMax = [];
	
	        for (var lg = 0; lg < 2; lg++) {
	          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	          for (var i = 0; i < 3 && interval[lg] == null; i++) {
	            interval[lg] = pieceListItem[names[i]];
	            close[lg] = closeList[i];
	            useMinMax[lg] = i === 2;
	          }
	
	          interval[lg] == null && (interval[lg] = infinityList[lg]);
	        }
	
	        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
	        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
	
	        if (interval[0] === interval[1] && close[0] && close[1]) {
	          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	          // we use value to lift the priority when min === max
	          item.value = interval[0];
	        }
	      }
	
	      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	      pieceList.push(item);
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, pieceList); // Only pieces
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      var close = piece.close;
	      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	    }, this);
	  }
	};
	
	function normalizeReverse(thisOption, pieceList) {
	  var inverse = thisOption.inverse;
	
	  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	    pieceList.reverse();
	  }
	}
	
	var _default = PiecewiseModel;
	module.exports = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var VisualMapView = __webpack_require__(567);
	
	var graphic = __webpack_require__(180);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var layout = __webpack_require__(217);
	
	var helper = __webpack_require__(568);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseVisualMapView = VisualMapView.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var textStyleModel = visualMapModel.textStyleModel;
	    var textFont = textStyleModel.getFont();
	    var textFill = textStyleModel.getTextColor();
	
	    var itemAlign = this._getItemAlign();
	
	    var itemSize = visualMapModel.itemSize;
	
	    var viewData = this._getViewData();
	
	    var endsText = viewData.endsText;
	    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
	    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	    zrUtil.each(viewData.viewPieceList, renderItem, this);
	    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	    this.renderBackground(thisGroup);
	    this.positionGroup(thisGroup);
	
	    function renderItem(item) {
	      var piece = item.piece;
	      var itemGroup = new graphic.Group();
	      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);
	
	      this._enableHoverLink(itemGroup, item.indexInModelPieceList);
	
	      var representValue = visualMapModel.getRepresentValue(piece);
	
	      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	      if (showLabel) {
	        var visualState = this.visualMapModel.getValueState(representValue);
	        itemGroup.add(new graphic.Text({
	          style: {
	            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	            y: itemSize[1] / 2,
	            text: piece.text,
	            textVerticalAlign: 'middle',
	            textAlign: itemAlign,
	            textFont: textFont,
	            textFill: textFill,
	            opacity: visualState === 'outOfRange' ? 0.5 : 1
	          }
	        }));
	      }
	
	      thisGroup.add(itemGroup);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLink: function (itemGroup, pieceIndex) {
	    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));
	
	    function onHoverLink(method) {
	      var visualMapModel = this.visualMapModel;
	      visualMapModel.option.hoverLink && this.api.dispatchAction({
	        type: method,
	        batch: helper.convertDataIndex(visualMapModel.findTargetDataIndices(pieceIndex))
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _getItemAlign: function () {
	    var visualMapModel = this.visualMapModel;
	    var modelOption = visualMapModel.option;
	
	    if (modelOption.orient === 'vertical') {
	      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	    } else {
	      // horizontal, most case left unless specifying right.
	      var align = modelOption.align;
	
	      if (!align || align === 'auto') {
	        align = 'left';
	      }
	
	      return align;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
	    if (!text) {
	      return;
	    }
	
	    var itemGroup = new graphic.Group();
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    itemGroup.add(new graphic.Text({
	      style: {
	        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	        y: itemSize[1] / 2,
	        textVerticalAlign: 'middle',
	        textAlign: showLabel ? itemAlign : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	    group.add(itemGroup);
	  },
	
	  /**
	   * @private
	   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	   */
	  _getViewData: function () {
	    var visualMapModel = this.visualMapModel;
	    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
	      return {
	        piece: piece,
	        indexInModelPieceList: index
	      };
	    });
	    var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	    var orient = visualMapModel.get('orient');
	    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	    if (orient === 'horizontal' ? inverse : !inverse) {
	      viewPieceList.reverse();
	    } // Origin order of endsText is [high, low]
	    else if (endsText) {
	        endsText = endsText.slice().reverse();
	      }
	
	    return {
	      viewPieceList: viewPieceList,
	      endsText: endsText
	    };
	  },
	
	  /**
	   * @private
	   */
	  _createItemSymbol: function (group, representValue, shapeParam) {
	    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
	  },
	
	  /**
	   * @private
	   */
	  _onItemClick: function (piece) {
	    var visualMapModel = this.visualMapModel;
	    var option = visualMapModel.option;
	    var selected = zrUtil.clone(option.selected);
	    var newKey = visualMapModel.getSelectedMapKey(piece);
	
	    if (option.selectedMode === 'single') {
	      selected[newKey] = true;
	      zrUtil.each(selected, function (o, key) {
	        selected[key] = key === newKey;
	      });
	    } else {
	      selected[newKey] = !selected[newKey];
	    }
	
	    this.api.dispatchAction({
	      type: 'selectDataRange',
	      from: this.uid,
	      visualMapId: this.visualMapModel.id,
	      selected: selected
	    });
	  }
	});
	var _default = PiecewiseVisualMapView;
	module.exports = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(574);
	
	__webpack_require__(576);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// HINT Markpoint can't be used too much
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markPoint component is enabled
	  opt.markPoint = opt.markPoint || {};
	});

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(575);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markPoint',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: 'pin',
	    symbolSize: 50,
	    //symbolRotate: 0,
	    //symbolOffset: [0, 0]
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'inside'
	    },
	    itemStyle: {
	      borderWidth: 2
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(130);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var env = __webpack_require__(133);
	
	var modelUtil = __webpack_require__(173);
	
	var formatUtil = __webpack_require__(219);
	
	var dataFormatMixin = __webpack_require__(234);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var addCommas = formatUtil.addCommas;
	var encodeHTML = formatUtil.encodeHTML;
	
	function fillLabel(opt) {
	  modelUtil.defaultEmphasis(opt, 'label', ['show']);
	}
	
	var MarkerModel = echarts.extendComponentModel({
	  type: 'marker',
	  dependencies: ['series', 'grid', 'polar', 'geo'],
	
	  /**
	   * @overrite
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.mergeOption(option, ecModel, extraOpt.createdBySelf, true);
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var hostSeries = this.__hostSeries;
	    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	  },
	  mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
	    var MarkerModel = this.constructor;
	    var modelPropName = this.mainType + 'Model';
	
	    if (!createdBySelf) {
	      ecModel.eachSeries(function (seriesModel) {
	        var markerOpt = seriesModel.get(this.mainType, true);
	        var markerModel = seriesModel[modelPropName];
	
	        if (!markerOpt || !markerOpt.data) {
	          seriesModel[modelPropName] = null;
	          return;
	        }
	
	        if (!markerModel) {
	          if (isInit) {
	            // Default label emphasis `position` and `show`
	            fillLabel(markerOpt);
	          }
	
	          zrUtil.each(markerOpt.data, function (item) {
	            // FIXME Overwrite fillLabel method ?
	            if (item instanceof Array) {
	              fillLabel(item[0]);
	              fillLabel(item[1]);
	            } else {
	              fillLabel(item);
	            }
	          });
	          markerModel = new MarkerModel(markerOpt, this, ecModel);
	          zrUtil.extend(markerModel, {
	            mainType: this.mainType,
	            // Use the same series index and name
	            seriesIndex: seriesModel.seriesIndex,
	            name: seriesModel.name,
	            createdBySelf: true
	          });
	          markerModel.__hostSeries = seriesModel;
	        } else {
	          markerModel.mergeOption(markerOpt, ecModel, true);
	        }
	
	        seriesModel[modelPropName] = markerModel;
	      }, this);
	    }
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
	    var name = data.getName(dataIndex);
	    var html = encodeHTML(this.name);
	
	    if (value != null || name) {
	      html += '<br />';
	    }
	
	    if (name) {
	      html += encodeHTML(name);
	
	      if (value != null) {
	        html += ' : ';
	      }
	    }
	
	    if (value != null) {
	      html += encodeHTML(formattedValue);
	    }
	
	    return html;
	  },
	  getData: function () {
	    return this._data;
	  },
	  setData: function (data) {
	    this._data = data;
	  }
	});
	zrUtil.mixin(MarkerModel, dataFormatMixin);
	var _default = MarkerModel;
	module.exports = _default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var SymbolDraw = __webpack_require__(280);
	
	var numberUtil = __webpack_require__(218);
	
	var List = __webpack_require__(255);
	
	var markerHelper = __webpack_require__(577);
	
	var MarkerView = __webpack_require__(578);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function updateMarkerLayout(mpData, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  mpData.each(function (idx) {
	    var itemModel = mpData.getItemModel(idx);
	    var point;
	    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	    if (!isNaN(xPx) && !isNaN(yPx)) {
	      point = [xPx, yPx];
	    } // Chart like bar may have there own marker positioning logic
	    else if (seriesModel.getMarkerPosition) {
	        // Use the getMarkerPoisition
	        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	      } else if (coordSys) {
	        var x = mpData.get(coordSys.dimensions[0], idx);
	        var y = mpData.get(coordSys.dimensions[1], idx);
	        point = coordSys.dataToPoint([x, y]);
	      } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	
	    mpData.setItemLayout(idx, point);
	  });
	}
	
	var _default = MarkerView.extend({
	  type: 'markPoint',
	  // updateLayout: function (markPointModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mpModel = seriesModel.markPointModel;
	  //         if (mpModel) {
	  //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markPointModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mpModel = seriesModel.markPointModel;
	
	      if (mpModel) {
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mpModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var symbolDrawMap = this.markerGroupMap;
	    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME
	
	    mpModel.setData(mpData);
	    updateMarkerLayout(mpModel.getData(), seriesModel, api);
	    mpData.each(function (idx) {
	      var itemModel = mpData.getItemModel(idx);
	      var symbolSize = itemModel.getShallow('symbolSize');
	
	      if (typeof symbolSize === 'function') {
	        // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	        symbolSize = symbolSize(mpModel.getRawValue(idx), mpModel.getDataParams(idx));
	      }
	
	      mpData.setItemVisual(idx, {
	        symbolSize: symbolSize,
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color'),
	        symbol: itemModel.getShallow('symbol')
	      });
	    }); // TODO Text are wrong
	
	    symbolDraw.updateData(mpData);
	    this.group.add(symbolDraw.group); // Set host model for tooltip
	    // FIXME
	
	    mpData.eachItemGraphicEl(function (el) {
	      el.traverse(function (child) {
	        child.dataModel = mpModel;
	      });
	    });
	    symbolDraw.__keep = true;
	    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} [coordSys]
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mpModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var mpData = new List(coordDimsInfos, mpModel);
	  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));
	
	  if (coordSys) {
	    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
	  }
	
	  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  });
	  return mpData;
	}
	
	module.exports = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var numberUtil = __webpack_require__(218);
	
	var _dataStackHelper = __webpack_require__(260);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var indexOf = zrUtil.indexOf;
	
	function hasXOrY(item) {
	  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	}
	
	function hasXAndY(item) {
	  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	} // Make it simple, do not visit all stacked value to count precision.
	// function getPrecision(data, valueAxisDim, dataIndex) {
	//     var precision = -1;
	//     var stackedDim = data.mapDimension(valueAxisDim);
	//     do {
	//         precision = Math.max(
	//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
	//             precision
	//         );
	//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	//         if (stackedOnSeries) {
	//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
	//             data = stackedOnSeries.getData();
	//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
	//             stackedDim = data.getCalculationInfo('stackedDimension');
	//         }
	//         else {
	//             data = null;
	//         }
	//     } while (data);
	//     return precision;
	// }
	
	
	function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	  var coordArr = [];
	  var stacked = isDimensionStacked(data, targetDataDim
	  /*, otherDataDim*/
	  );
	  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
	  var value = numCalculate(data, calcDataDim, mlType);
	  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
	  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
	  coordArr[targetCoordIndex] = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
	
	  var precision = numberUtil.getPrecision(data.get(targetDataDim, dataIndex));
	  precision = Math.min(precision, 20);
	
	  if (precision >= 0) {
	    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	  }
	
	  return coordArr;
	}
	
	var curry = zrUtil.curry; // TODO Specified percent
	
	var markerTypeCalculator = {
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  min: curry(markerTypeCalculatorWithExtent, 'min'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  max: curry(markerTypeCalculatorWithExtent, 'max'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  average: curry(markerTypeCalculatorWithExtent, 'average')
	};
	/**
	 * Transform markPoint data item to format used in List by do the following
	 * 1. Calculate statistic like `max`, `min`, `average`
	 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	 * @param  {module:echarts/model/Series} seriesModel
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {Object}
	 */
	
	function dataTransform(seriesModel, item) {
	  var data = seriesModel.getData();
	  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
	  // 2. If `coord` is not a data array. Which uses `xAxis`,
	  // `yAxis` to specify the coord on each dimension
	  // parseFloat first because item.x and item.y can be percent string like '20%'
	
	  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
	    var dims = coordSys.dimensions;
	    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
	    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	    item = zrUtil.clone(item);
	
	    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	      item.coord = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex); // Force to use the value of calculated value.
	
	      item.value = item.coord[targetCoordIndex];
	    } else {
	      // FIXME Only has one of xAxis and yAxis.
	      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average
	
	      for (var i = 0; i < 2; i++) {
	        if (markerTypeCalculator[coord[i]]) {
	          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
	        }
	      }
	
	      item.coord = coord;
	    }
	  }
	
	  return item;
	}
	
	function getAxisInfo(item, data, coordSys, seriesModel) {
	  var ret = {};
	
	  if (item.valueIndex != null || item.valueDim != null) {
	    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
	    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	  } else {
	    ret.baseAxis = seriesModel.getBaseAxis();
	    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
	  }
	
	  return ret;
	}
	
	function dataDimToCoordDim(seriesModel, dataDim) {
	  var data = seriesModel.getData();
	  var dimensions = data.dimensions;
	  dataDim = data.getDimension(dataDim);
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimItem = data.getDimensionInfo(dimensions[i]);
	
	    if (dimItem.name === dataDim) {
	      return dimItem.coordDim;
	    }
	  }
	}
	/**
	 * Filter data which is out of coordinateSystem range
	 * [dataFilter description]
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {boolean}
	 */
	
	
	function dataFilter(coordSys, item) {
	  // Alwalys return true if there is no coordSys
	  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	}
	
	function dimValueGetter(item, dimName, dataIndex, dimIndex) {
	  // x, y, radius, angle
	  if (dimIndex < 2) {
	    return item.coord && item.coord[dimIndex];
	  }
	
	  return item.value;
	}
	
	function numCalculate(data, valueDataDim, type) {
	  if (type === 'average') {
	    var sum = 0;
	    var count = 0;
	    data.each(valueDataDim, function (val, idx) {
	      if (!isNaN(val)) {
	        sum += val;
	        count++;
	      }
	    });
	    return sum / count;
	  } else if (type === 'median') {
	    return data.getMedian(valueDataDim);
	  } else {
	    // max & min
	    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
	  }
	}
	
	exports.dataTransform = dataTransform;
	exports.getAxisInfo = getAxisInfo;
	exports.dataFilter = dataFilter;
	exports.dimValueGetter = dimValueGetter;
	exports.numCalculate = numCalculate;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'marker',
	  init: function () {
	    /**
	     * Markline grouped by series
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this.markerGroupMap = zrUtil.createHashMap();
	  },
	  render: function (markerModel, ecModel, api) {
	    var markerGroupMap = this.markerGroupMap;
	    markerGroupMap.each(function (item) {
	      item.__keep = false;
	    });
	    var markerModelKey = this.type + 'Model';
	    ecModel.eachSeries(function (seriesModel) {
	      var markerModel = seriesModel[markerModelKey];
	      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
	    }, this);
	    markerGroupMap.each(function (item) {
	      !item.__keep && this.group.remove(item.group);
	    }, this);
	  },
	  renderSeries: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(580);
	
	__webpack_require__(581);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markLine component is enabled
	  opt.markLine = opt.markLine || {};
	});

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(575);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markLine',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: ['circle', 'arrow'],
	    symbolSize: [8, 16],
	    //symbolRotate: 0,
	    precision: 2,
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'end'
	    },
	    lineStyle: {
	      type: 'dashed'
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        width: 3
	      }
	    },
	    animationEasing: 'linear'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var List = __webpack_require__(255);
	
	var numberUtil = __webpack_require__(218);
	
	var markerHelper = __webpack_require__(577);
	
	var LineDraw = __webpack_require__(382);
	
	var MarkerView = __webpack_require__(578);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'
	
	  var mlType = item.type;
	
	  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
	  // data: [{
	  //   yAxis: 10
	  // }]
	  || item.xAxis != null || item.yAxis != null)) {
	    var valueAxis;
	    var valueDataDim;
	    var value;
	
	    if (item.yAxis != null || item.xAxis != null) {
	      valueDataDim = item.yAxis != null ? 'y' : 'x';
	      valueAxis = coordSys.getAxis(valueDataDim);
	      value = zrUtil.retrieve(item.yAxis, item.xAxis);
	    } else {
	      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
	      valueDataDim = axisInfo.valueDataDim;
	      valueAxis = axisInfo.valueAxis;
	      value = markerHelper.numCalculate(data, valueDataDim, mlType);
	    }
	
	    var valueIndex = valueDataDim === 'x' ? 0 : 1;
	    var baseIndex = 1 - valueIndex;
	    var mlFrom = zrUtil.clone(item);
	    var mlTo = {};
	    mlFrom.type = null;
	    mlFrom.coord = [];
	    mlTo.coord = [];
	    mlFrom.coord[baseIndex] = -Infinity;
	    mlTo.coord[baseIndex] = Infinity;
	    var precision = mlModel.get('precision');
	
	    if (precision >= 0 && typeof value === 'number') {
	      value = +value.toFixed(Math.min(precision, 20));
	    }
	
	    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	    item = [mlFrom, mlTo, {
	      // Extra option for tooltip and label
	      type: mlType,
	      valueIndex: item.valueIndex,
	      // Force to use the value of calculated value.
	      value: value
	    }];
	  }
	
	  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type
	
	  item[2].type = item[2].type || ''; // Merge from option and to option into line option
	
	  zrUtil.merge(item[2], item[0]);
	  zrUtil.merge(item[2], item[1]);
	  return item;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markLine has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  var dimName = coordSys.dimensions[dimIndex];
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	}
	
	function markLineFilter(coordSys, item) {
	  if (coordSys.type === 'cartesian2d') {
	    var fromCoord = item[0].coord;
	    var toCoord = item[1].coord; // In case
	    // {
	    //  markLine: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
	}
	
	function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	    } else {
	      var dims = coordSys.dimensions;
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y]);
	    } // Expand line to the edge of grid if value on one axis is Inifnity
	    // In case
	    //  markLine: {
	    //    data: [{
	    //      yAxis: 2
	    //      // or
	    //      type: 'average'
	    //    }]
	    //  }
	
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var dims = coordSys.dimensions;
	
	      if (isInifinity(data.get(dims[0], idx))) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	      } else if (isInifinity(data.get(dims[1], idx))) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  data.setItemLayout(idx, point);
	}
	
	var _default = MarkerView.extend({
	  type: 'markLine',
	  // updateLayout: function (markLineModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mlModel = seriesModel.markLineModel;
	  //         if (mlModel) {
	  //             var mlData = mlModel.getData();
	  //             var fromData = mlModel.__from;
	  //             var toData = mlModel.__to;
	  //             // Update visual and layout of from symbol and to symbol
	  //             fromData.each(function (idx) {
	  //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	  //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	  //             });
	  //             // Update layout of line
	  //             mlData.each(function (idx) {
	  //                 mlData.setItemLayout(idx, [
	  //                     fromData.getItemLayout(idx),
	  //                     toData.getItemLayout(idx)
	  //                 ]);
	  //             });
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout();
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markLineModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mlModel = seriesModel.markLineModel;
	
	      if (mlModel) {
	        var mlData = mlModel.getData();
	        var fromData = mlModel.__from;
	        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
	
	        fromData.each(function (idx) {
	          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	        }); // Update layout of line
	
	        mlData.each(function (idx) {
	          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	        });
	        this.markerGroupMap.get(seriesModel.id).updateLayout();
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mlModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var lineDrawMap = this.markerGroupMap;
	    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	    this.group.add(lineDraw.group);
	    var mlData = createList(coordSys, seriesModel, mlModel);
	    var fromData = mlData.from;
	    var toData = mlData.to;
	    var lineData = mlData.line;
	    mlModel.__from = fromData;
	    mlModel.__to = toData; // Line data for tooltip and formatter
	
	    mlModel.setData(lineData);
	    var symbolType = mlModel.get('symbol');
	    var symbolSize = mlModel.get('symbolSize');
	
	    if (!zrUtil.isArray(symbolType)) {
	      symbolType = [symbolType, symbolType];
	    }
	
	    if (typeof symbolSize === 'number') {
	      symbolSize = [symbolSize, symbolSize];
	    } // Update visual and layout of from symbol and to symbol
	
	
	    mlData.from.each(function (idx) {
	      updateDataVisualAndLayout(fromData, idx, true);
	      updateDataVisualAndLayout(toData, idx, false);
	    }); // Update visual and layout of line
	
	    lineData.each(function (idx) {
	      var lineColor = lineData.getItemModel(idx).get('lineStyle.color');
	      lineData.setItemVisual(idx, {
	        color: lineColor || fromData.getItemVisual(idx, 'color')
	      });
	      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	      lineData.setItemVisual(idx, {
	        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
	        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
	        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
	        'toSymbol': toData.getItemVisual(idx, 'symbol')
	      });
	    });
	    lineDraw.updateData(lineData); // Set host model for tooltip
	    // FIXME
	
	    mlData.line.eachItemGraphicEl(function (el, idx) {
	      el.traverse(function (child) {
	        child.dataModel = mlModel;
	      });
	    });
	
	    function updateDataVisualAndLayout(data, idx, isFrom) {
	      var itemModel = data.getItemModel(idx);
	      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	      data.setItemVisual(idx, {
	        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
	        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }
	
	    lineDraw.__keep = true;
	    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mlModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var fromData = new List(coordDimsInfos, mlModel);
	  var toData = new List(coordDimsInfos, mlModel); // No dimensions
	
	  var lineData = new List([], mlModel);
	  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  };
	  fromData.initData(zrUtil.map(optData, function (item) {
	    return item[0];
	  }), null, dimValueGetter);
	  toData.initData(zrUtil.map(optData, function (item) {
	    return item[1];
	  }), null, dimValueGetter);
	  lineData.initData(zrUtil.map(optData, function (item) {
	    return item[2];
	  }));
	  lineData.hasItemOption = true;
	  return {
	    from: fromData,
	    to: toData,
	    line: lineData
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	__webpack_require__(583);
	
	__webpack_require__(584);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markArea component is enabled
	  opt.markArea = opt.markArea || {};
	});

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(575);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markArea',
	  defaultOption: {
	    zlevel: 0,
	    // PENDING
	    z: 1,
	    tooltip: {
	      trigger: 'item'
	    },
	    // markArea should fixed on the coordinate system
	    animation: false,
	    label: {
	      show: true,
	      position: 'top'
	    },
	    itemStyle: {
	      // color and borderColor default to use color from series
	      // color: 'auto'
	      // borderColor: 'auto'
	      borderWidth: 0
	    },
	    emphasis: {
	      label: {
	        show: true,
	        position: 'top'
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var colorUtil = __webpack_require__(150);
	
	var List = __webpack_require__(255);
	
	var numberUtil = __webpack_require__(218);
	
	var graphic = __webpack_require__(180);
	
	var markerHelper = __webpack_require__(577);
	
	var MarkerView = __webpack_require__(578);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Better on polar
	var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	  var lt = markerHelper.dataTransform(seriesModel, item[0]);
	  var rb = markerHelper.dataTransform(seriesModel, item[1]);
	  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb
	
	  var ltCoord = lt.coord;
	  var rbCoord = rb.coord;
	  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	  rbCoord[0] = retrieve(rbCoord[0], Infinity);
	  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	  var result = zrUtil.mergeAll([{}, lt, rb]);
	  result.coord = [lt.coord, rb.coord];
	  result.x0 = lt.x;
	  result.y0 = lt.y;
	  result.x1 = rb.x;
	  result.y1 = rb.y;
	  return result;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markArea has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
	}
	
	function markAreaFilter(coordSys, item) {
	  var fromCoord = item.coord[0];
	  var toCoord = item.coord[1];
	
	  if (coordSys.type === 'cartesian2d') {
	    // In case
	    // {
	    //  markArea: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, {
	    coord: fromCoord,
	    x: item.x0,
	    y: item.y0
	  }) || markerHelper.dataFilter(coordSys, {
	    coord: toCoord,
	    x: item.x1,
	    y: item.y1
	  });
	} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
	    } else {
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      var pt = [x, y];
	      coordSys.clampData && coordSys.clampData(pt, pt);
	      point = coordSys.dataToPoint(pt, true);
	    }
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	
	      if (isInifinity(x)) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	      } else if (isInifinity(y)) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  return point;
	}
	
	var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	MarkerView.extend({
	  type: 'markArea',
	  // updateLayout: function (markAreaModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var maModel = seriesModel.markAreaModel;
	  //         if (maModel) {
	  //             var areaData = maModel.getData();
	  //             areaData.each(function (idx) {
	  //                 var points = zrUtil.map(dimPermutations, function (dim) {
	  //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	  //                 });
	  //                 // Layout
	  //                 areaData.setItemLayout(idx, points);
	  //                 var el = areaData.getItemGraphicEl(idx);
	  //                 el.setShape('points', points);
	  //             });
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markAreaModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var maModel = seriesModel.markAreaModel;
	
	      if (maModel) {
	        var areaData = maModel.getData();
	        areaData.each(function (idx) {
	          var points = zrUtil.map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          }); // Layout
	
	          areaData.setItemLayout(idx, points);
	          var el = areaData.getItemGraphicEl(idx);
	          el.setShape('points', points);
	        });
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, maModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var areaGroupMap = this.markerGroupMap;
	    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
	      group: new graphic.Group()
	    });
	    this.group.add(polygonGroup.group);
	    polygonGroup.__keep = true;
	    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	    maModel.setData(areaData); // Update visual and layout of line
	
	    areaData.each(function (idx) {
	      // Layout
	      areaData.setItemLayout(idx, zrUtil.map(dimPermutations, function (dim) {
	        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	      })); // Visual
	
	      areaData.setItemVisual(idx, {
	        color: seriesData.getVisual('color')
	      });
	    });
	    areaData.diff(polygonGroup.__data).add(function (idx) {
	      var polygon = new graphic.Polygon({
	        shape: {
	          points: areaData.getItemLayout(idx)
	        }
	      });
	      areaData.setItemGraphicEl(idx, polygon);
	      polygonGroup.group.add(polygon);
	    }).update(function (newIdx, oldIdx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
	
	      graphic.updateProps(polygon, {
	        shape: {
	          points: areaData.getItemLayout(newIdx)
	        }
	      }, maModel, newIdx);
	      polygonGroup.group.add(polygon);
	      areaData.setItemGraphicEl(newIdx, polygon);
	    }).remove(function (idx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(idx);
	
	      polygonGroup.group.remove(polygon);
	    }).execute();
	    areaData.eachItemGraphicEl(function (polygon, idx) {
	      var itemModel = areaData.getItemModel(idx);
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var color = areaData.getItemVisual(idx, 'color');
	      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle').getItemStyle(), {
	        fill: colorUtil.modifyAlpha(color, 0.4),
	        stroke: color
	      }));
	      polygon.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: maModel,
	        labelDataIndex: idx,
	        defaultText: areaData.getName(idx) || '',
	        isRectText: true,
	        autoColor: color
	      });
	      graphic.setHoverStyle(polygon, {});
	      polygon.dataModel = maModel;
	    });
	    polygonGroup.__data = areaData;
	    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	function createList(coordSys, seriesModel, maModel) {
	  var coordDimsInfos;
	  var areaData;
	  var dims = ['x0', 'y0', 'x1', 'y1'];
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var data = seriesModel.getData();
	      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	    areaData = new List(zrUtil.map(dims, function (dim, idx) {
	      return {
	        name: dim,
	        type: coordDimsInfos[idx % 2].type
	      };
	    }), maModel);
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	    areaData = new List(coordDimsInfos, maModel);
	  }
	
	  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	  } : function (item) {
	    return item.value;
	  };
	  areaData.initData(optData, null, dimValueGetter);
	  areaData.hasItemOption = true;
	  return areaData;
	}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var preprocessor = __webpack_require__(586);
	
	__webpack_require__(587);
	
	__webpack_require__(588);
	
	__webpack_require__(589);
	
	__webpack_require__(591);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  var timelineOpt = option && option.timeline;
	
	  if (!zrUtil.isArray(timelineOpt)) {
	    timelineOpt = timelineOpt ? [timelineOpt] : [];
	  }
	
	  zrUtil.each(timelineOpt, function (opt) {
	    if (!opt) {
	      return;
	    }
	
	    compatibleEC2(opt);
	  });
	}
	
	function compatibleEC2(opt) {
	  var type = opt.type;
	  var ec2Types = {
	    'number': 'value',
	    'time': 'time'
	  }; // Compatible with ec2
	
	  if (ec2Types[type]) {
	    opt.axisType = ec2Types[type];
	    delete opt.type;
	  }
	
	  transferItem(opt);
	
	  if (has(opt, 'controlPosition')) {
	    var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	    if (!has(controlStyle, 'position')) {
	      controlStyle.position = opt.controlPosition;
	    }
	
	    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	      controlStyle.show = false;
	      delete controlStyle.position;
	    }
	
	    delete opt.controlPosition;
	  }
	
	  zrUtil.each(opt.data || [], function (dataItem) {
	    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
	      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	        // In ec2, using name as value.
	        dataItem.value = dataItem.name;
	      }
	
	      transferItem(dataItem);
	    }
	  });
	}
	
	function transferItem(opt) {
	  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	  var label = opt.label || opt.label || {};
	  var labelNormal = label.normal || (label.normal = {});
	  var excludeLabelAttr = {
	    normal: 1,
	    emphasis: 1
	  };
	  zrUtil.each(label, function (value, name) {
	    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	      labelNormal[name] = value;
	    }
	  });
	
	  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	    label.emphasis = itemStyleEmphasis.label;
	    delete itemStyleEmphasis.label;
	  }
	}
	
	function has(obj, attr) {
	  return obj.hasOwnProperty(attr);
	}
	
	module.exports = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('timeline', function () {
	  // Only slider now.
	  return 'slider';
	});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'timelineChange',
	  event: 'timelineChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.currentIndex != null) {
	    timelineModel.setCurrentIndex(payload.currentIndex);
	
	    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
	      timelineModel.setPlayState(false);
	    }
	  } // Set normalized currentIndex to payload.
	
	
	  ecModel.resetOption('timeline');
	  return zrUtil.defaults({
	    currentIndex: timelineModel.option.currentIndex
	  }, payload);
	});
	echarts.registerAction({
	  type: 'timelinePlayChange',
	  event: 'timelinePlayChanged',
	  update: 'update'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.playState != null) {
	    timelineModel.setPlayState(payload.playState);
	  }
	});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var TimelineModel = __webpack_require__(590);
	
	var dataFormatMixin = __webpack_require__(234);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderTimelineModel = TimelineModel.extend({
	  type: 'timeline.slider',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 时间轴背景颜色
	    borderColor: '#ccc',
	    // 时间轴边框颜色
	    borderWidth: 0,
	    // 时间轴边框线宽，单位px，默认为0（无边框）
	    orient: 'horizontal',
	    // 'vertical'
	    inverse: false,
	    tooltip: {
	      // boolean or Object
	      trigger: 'item' // data item may also have tootip attr.
	
	    },
	    symbol: 'emptyCircle',
	    symbolSize: 10,
	    lineStyle: {
	      show: true,
	      width: 2,
	      color: '#304654'
	    },
	    label: {
	      // 文本标签
	      position: 'auto',
	      // auto left right top bottom
	      // When using number, label position is not
	      // restricted by viewRect.
	      // positive: right/bottom, negative: left/top
	      show: true,
	      interval: 'auto',
	      rotate: 0,
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#304654'
	    },
	    itemStyle: {
	      color: '#304654',
	      borderWidth: 1
	    },
	    checkpointStyle: {
	      symbol: 'circle',
	      symbolSize: 13,
	      color: '#c23531',
	      borderWidth: 5,
	      borderColor: 'rgba(194,53,49, 0.5)',
	      animation: true,
	      animationDuration: 300,
	      animationEasing: 'quinticInOut'
	    },
	    controlStyle: {
	      show: true,
	      showPlayBtn: true,
	      showPrevBtn: true,
	      showNextBtn: true,
	      itemSize: 22,
	      itemGap: 12,
	      position: 'left',
	      // 'left' 'right' 'top' 'bottom'
	      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	      // jshint ignore:line
	      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	      // jshint ignore:line
	      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
	      // jshint ignore:line
	      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
	      // jshint ignore:line
	      color: '#304654',
	      borderColor: '#304654',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#c23531'
	      },
	      itemStyle: {
	        color: '#c23531'
	      },
	      controlStyle: {
	        color: '#c23531',
	        borderColor: '#c23531',
	        borderWidth: 2
	      }
	    },
	    data: []
	  }
	});
	zrUtil.mixin(SliderTimelineModel, dataFormatMixin);
	var _default = SliderTimelineModel;
	module.exports = _default;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var ComponentModel = __webpack_require__(215);
	
	var List = __webpack_require__(255);
	
	var modelUtil = __webpack_require__(173);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TimelineModel = ComponentModel.extend({
	  type: 'timeline',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 4,
	    // 二级层叠
	    show: true,
	    axisType: 'time',
	    // 模式是时间类型，支持 value, category
	    realtime: true,
	    left: '20%',
	    top: null,
	    right: '20%',
	    bottom: 0,
	    width: null,
	    height: 40,
	    padding: 5,
	    controlPosition: 'left',
	    // 'left' 'right' 'top' 'bottom' 'none'
	    autoPlay: false,
	    rewind: false,
	    // 反向播放
	    loop: true,
	    playInterval: 2000,
	    // 播放时间间隔，单位ms
	    currentIndex: 0,
	    itemStyle: {},
	    label: {
	      color: '#000'
	    },
	    data: []
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {module:echarts/data/List}
	     */
	    this._data;
	    /**
	     * @private
	     * @type {Array.<string>}
	     */
	
	    this._names;
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._initData();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    TimelineModel.superApply(this, 'mergeOption', arguments);
	
	    this._initData();
	  },
	
	  /**
	   * @param {number} [currentIndex]
	   */
	  setCurrentIndex: function (currentIndex) {
	    if (currentIndex == null) {
	      currentIndex = this.option.currentIndex;
	    }
	
	    var count = this._data.count();
	
	    if (this.option.loop) {
	      currentIndex = (currentIndex % count + count) % count;
	    } else {
	      currentIndex >= count && (currentIndex = count - 1);
	      currentIndex < 0 && (currentIndex = 0);
	    }
	
	    this.option.currentIndex = currentIndex;
	  },
	
	  /**
	   * @return {number} currentIndex
	   */
	  getCurrentIndex: function () {
	    return this.option.currentIndex;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isIndexMax: function () {
	    return this.getCurrentIndex() >= this._data.count() - 1;
	  },
	
	  /**
	   * @param {boolean} state true: play, false: stop
	   */
	  setPlayState: function (state) {
	    this.option.autoPlay = !!state;
	  },
	
	  /**
	   * @return {boolean} true: play, false: stop
	   */
	  getPlayState: function () {
	    return !!this.option.autoPlay;
	  },
	
	  /**
	   * @private
	   */
	  _initData: function () {
	    var thisOption = this.option;
	    var dataArr = thisOption.data || [];
	    var axisType = thisOption.axisType;
	    var names = this._names = [];
	
	    if (axisType === 'category') {
	      var idxArr = [];
	      zrUtil.each(dataArr, function (item, index) {
	        var value = modelUtil.getDataItemValue(item);
	        var newItem;
	
	        if (zrUtil.isObject(item)) {
	          newItem = zrUtil.clone(item);
	          newItem.value = index;
	        } else {
	          newItem = index;
	        }
	
	        idxArr.push(newItem);
	
	        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
	          value = '';
	        }
	
	        names.push(value + '');
	      });
	      dataArr = idxArr;
	    }
	
	    var dimType = {
	      category: 'ordinal',
	      time: 'time'
	    }[axisType] || 'number';
	    var data = this._data = new List([{
	      name: 'value',
	      type: dimType
	    }], this);
	    data.initData(dataArr, names);
	  },
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @public
	   * @return {Array.<string>} categoreis
	   */
	  getCategories: function () {
	    if (this.get('axisType') === 'category') {
	      return this._names.slice();
	    }
	  }
	});
	var _default = TimelineModel;
	module.exports = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var BoundingRect = __webpack_require__(154);
	
	var matrix = __webpack_require__(145);
	
	var graphic = __webpack_require__(180);
	
	var layout = __webpack_require__(217);
	
	var TimelineView = __webpack_require__(592);
	
	var TimelineAxis = __webpack_require__(593);
	
	var _symbol = __webpack_require__(271);
	
	var createSymbol = _symbol.createSymbol;
	
	var axisHelper = __webpack_require__(261);
	
	var numberUtil = __webpack_require__(218);
	
	var _format = __webpack_require__(219);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var PI = Math.PI;
	
	var _default = TimelineView.extend({
	  type: 'timeline.slider',
	  init: function (ecModel, api) {
	    this.api = api;
	    /**
	     * @private
	     * @type {module:echarts/component/timeline/TimelineAxis}
	     */
	
	    this._axis;
	    /**
	     * @private
	     * @type {module:zrender/core/BoundingRect}
	     */
	
	    this._viewRect;
	    /**
	     * @type {number}
	     */
	
	    this._timer;
	    /**
	     * @type {module:zrender/Element}
	     */
	
	    this._currentPointer;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._labelGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (timelineModel, ecModel, api, payload) {
	    this.model = timelineModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    this.group.removeAll();
	
	    if (timelineModel.get('show', true)) {
	      var layoutInfo = this._layout(timelineModel, api);
	
	      var mainGroup = this._createGroup('mainGroup');
	
	      var labelGroup = this._createGroup('labelGroup');
	      /**
	       * @private
	       * @type {module:echarts/component/timeline/TimelineAxis}
	       */
	
	
	      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
	
	      timelineModel.formatTooltip = function (dataIndex) {
	        return encodeHTML(axis.scale.getLabel(dataIndex));
	      };
	
	      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
	      }, this);
	
	      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
	
	      this._position(layoutInfo, timelineModel);
	    }
	
	    this._doPlayStop();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearTimer();
	
	    this.group.removeAll();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearTimer();
	  },
	  _layout: function (timelineModel, api) {
	    var labelPosOpt = timelineModel.get('label.position');
	    var orient = timelineModel.get('orient');
	    var viewRect = getViewRect(timelineModel, api); // Auto label offset.
	
	    if (labelPosOpt == null || labelPosOpt === 'auto') {
	      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	    } else if (isNaN(labelPosOpt)) {
	      labelPosOpt = {
	        horizontal: {
	          top: '-',
	          bottom: '+'
	        },
	        vertical: {
	          left: '-',
	          right: '+'
	        }
	      }[orient][labelPosOpt];
	    }
	
	    var labelAlignMap = {
	      horizontal: 'center',
	      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
	    };
	    var labelBaselineMap = {
	      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
	      vertical: 'middle'
	    };
	    var rotationMap = {
	      horizontal: 0,
	      vertical: PI / 2
	    }; // Position
	
	    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	    var controlModel = timelineModel.getModel('controlStyle');
	    var showControl = controlModel.get('show', true);
	    var controlSize = showControl ? controlModel.get('itemSize') : 0;
	    var controlGap = showControl ? controlModel.get('itemGap') : 0;
	    var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	    var labelRotation = timelineModel.get('label.rotate') || 0;
	    labelRotation = labelRotation * PI / 180; // To radian.
	
	    var playPosition;
	    var prevBtnPosition;
	    var nextBtnPosition;
	    var axisExtent;
	    var controlPosition = controlModel.get('position', true);
	    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	    var xLeft = 0;
	    var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	    if (controlPosition === 'left' || controlPosition === 'bottom') {
	      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    } else {
	      // 'top' 'right'
	      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    }
	
	    axisExtent = [xLeft, xRight];
	
	    if (timelineModel.get('inverse')) {
	      axisExtent.reverse();
	    }
	
	    return {
	      viewRect: viewRect,
	      mainLength: mainLength,
	      orient: orient,
	      rotation: rotationMap[orient],
	      labelRotation: labelRotation,
	      labelPosOpt: labelPosOpt,
	      labelAlign: timelineModel.get('label.align') || labelAlignMap[orient],
	      labelBaseline: timelineModel.get('label.verticalAlign') || timelineModel.get('label.baseline') || labelBaselineMap[orient],
	      // Based on mainGroup.
	      playPosition: playPosition,
	      prevBtnPosition: prevBtnPosition,
	      nextBtnPosition: nextBtnPosition,
	      axisExtent: axisExtent,
	      controlSize: controlSize,
	      controlGap: controlGap
	    };
	  },
	  _position: function (layoutInfo, timelineModel) {
	    // Position is be called finally, because bounding rect is needed for
	    // adapt content to fill viewRect (auto adapt offset).
	    // Timeline may be not all in the viewRect when 'offset' is specified
	    // as a number, because it is more appropriate that label aligns at
	    // 'offset' but not the other edge defined by viewRect.
	    var mainGroup = this._mainGroup;
	    var labelGroup = this._labelGroup;
	    var viewRect = layoutInfo.viewRect;
	
	    if (layoutInfo.orient === 'vertical') {
	      // transform to horizontal, inverse rotate by left-top point.
	      var m = matrix.create();
	      var rotateOriginX = viewRect.x;
	      var rotateOriginY = viewRect.y + viewRect.height;
	      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
	      matrix.rotate(m, m, -PI / 2);
	      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
	      viewRect = viewRect.clone();
	      viewRect.applyTransform(m);
	    }
	
	    var viewBound = getBound(viewRect);
	    var mainBound = getBound(mainGroup.getBoundingRect());
	    var labelBound = getBound(labelGroup.getBoundingRect());
	    var mainPosition = mainGroup.position;
	    var labelsPosition = labelGroup.position;
	    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	    var labelPosOpt = layoutInfo.labelPosOpt;
	
	    if (isNaN(labelPosOpt)) {
	      // '+' or '-'
	      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	    } else {
	      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      labelsPosition[1] = mainPosition[1] + labelPosOpt;
	    }
	
	    mainGroup.attr('position', mainPosition);
	    labelGroup.attr('position', labelsPosition);
	    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	    setOrigin(mainGroup);
	    setOrigin(labelGroup);
	
	    function setOrigin(targetGroup) {
	      var pos = targetGroup.position;
	      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
	    }
	
	    function getBound(rect) {
	      // [[xmin, xmax], [ymin, ymax]]
	      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	    }
	
	    function toBound(fromPos, from, to, dimIdx, boundIdx) {
	      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	    }
	  },
	  _createAxis: function (layoutInfo, timelineModel) {
	    var data = timelineModel.getData();
	    var axisType = timelineModel.get('axisType');
	    var scale = axisHelper.createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
	
	    scale.getTicks = function () {
	      return data.mapArray(['value'], function (value) {
	        return value;
	      });
	    };
	
	    var dataExtent = data.getDataExtent('value');
	    scale.setExtent(dataExtent[0], dataExtent[1]);
	    scale.niceTicks();
	    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	    axis.model = timelineModel;
	    return axis;
	  },
	  _createGroup: function (name) {
	    var newGroup = this['_' + name] = new graphic.Group();
	    this.group.add(newGroup);
	    return newGroup;
	  },
	  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
	    var axisExtent = axis.getExtent();
	
	    if (!timelineModel.get('lineStyle.show')) {
	      return;
	    }
	
	    group.add(new graphic.Line({
	      shape: {
	        x1: axisExtent[0],
	        y1: 0,
	        x2: axisExtent[1],
	        y2: 0
	      },
	      style: zrUtil.extend({
	        lineCap: 'round'
	      }, timelineModel.getModel('lineStyle').getLineStyle()),
	      silent: true,
	      z2: 1
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
	
	    var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.
	
	    each(ticks, function (value) {
	      var tickCoord = axis.dataToCoord(value);
	      var itemModel = data.getItemModel(value);
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      var hoverStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var symbolOpt = {
	        position: [tickCoord, 0],
	        onclick: bind(this._changeTimeline, this, value)
	      };
	      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());
	
	      if (itemModel.get('tooltip')) {
	        el.dataIndex = value;
	        el.dataModel = timelineModel;
	      } else {
	        el.dataIndex = el.dataModel = null;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
	    var labelModel = axis.getLabelModel();
	
	    if (!labelModel.get('show')) {
	      return;
	    }
	
	    var data = timelineModel.getData();
	    var labels = axis.getViewLabels();
	    each(labels, function (labelItem) {
	      // The tickValue is dataIndex, see the costomized scale.
	      var dataIndex = labelItem.tickValue;
	      var itemModel = data.getItemModel(dataIndex);
	      var normalLabelModel = itemModel.getModel('label');
	      var hoverLabelModel = itemModel.getModel('emphasis.label');
	      var tickCoord = axis.dataToCoord(labelItem.tickValue);
	      var textEl = new graphic.Text({
	        position: [tickCoord, 0],
	        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	        onclick: bind(this._changeTimeline, this, dataIndex),
	        silent: false
	      });
	      graphic.setTextStyle(textEl.style, normalLabelModel, {
	        text: labelItem.formattedLabel,
	        textAlign: layoutInfo.labelAlign,
	        textVerticalAlign: layoutInfo.labelBaseline
	      });
	      group.add(textEl);
	      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderControl: function (layoutInfo, group, axis, timelineModel) {
	    var controlSize = layoutInfo.controlSize;
	    var rotation = layoutInfo.rotation;
	    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
	    var hoverStyle = timelineModel.getModel('emphasis.controlStyle').getItemStyle();
	    var rect = [0, -controlSize / 2, controlSize, controlSize];
	    var playState = timelineModel.getPlayState();
	    var inverse = timelineModel.get('inverse', true);
	    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);
	
	    function makeBtn(position, iconPath, onclick, willRotate) {
	      if (!position) {
	        return;
	      }
	
	      var opt = {
	        position: position,
	        origin: [controlSize / 2, 0],
	        rotation: willRotate ? -rotation : 0,
	        rectHover: true,
	        style: itemStyle,
	        onclick: onclick
	      };
	      var btn = makeIcon(timelineModel, iconPath, rect, opt);
	      group.add(btn);
	      graphic.setHoverStyle(btn, hoverStyle);
	    }
	  },
	  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var currentIndex = timelineModel.getCurrentIndex();
	    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	    var me = this;
	    var callback = {
	      onCreate: function (pointer) {
	        pointer.draggable = true;
	        pointer.drift = bind(me._handlePointerDrag, me);
	        pointer.ondragend = bind(me._handlePointerDragend, me);
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
	      },
	      onUpdate: function (pointer) {
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
	      }
	    }; // Reuse when exists, for animation and drag.
	
	    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	  },
	  _handlePlayClick: function (nextState) {
	    this._clearTimer();
	
	    this.api.dispatchAction({
	      type: 'timelinePlayChange',
	      playState: nextState,
	      from: this.uid
	    });
	  },
	  _handlePointerDrag: function (dx, dy, e) {
	    this._clearTimer();
	
	    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	  },
	  _handlePointerDragend: function (e) {
	    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	  },
	  _pointerChangeTimeline: function (mousePos, trigger) {
	    var toCoord = this._toAxisCoord(mousePos)[0];
	
	    var axis = this._axis;
	    var axisExtent = numberUtil.asc(axis.getExtent().slice());
	    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	    this._currentPointer.position[0] = toCoord;
	
	    this._currentPointer.dirty();
	
	    var targetDataIndex = this._findNearestTick(toCoord);
	
	    var timelineModel = this.model;
	
	    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	      this._changeTimeline(targetDataIndex);
	    }
	  },
	  _doPlayStop: function () {
	    this._clearTimer();
	
	    if (this.model.getPlayState()) {
	      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
	    }
	
	    function handleFrame() {
	      // Do not cache
	      var timelineModel = this.model;
	
	      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	    }
	  },
	  _toAxisCoord: function (vertex) {
	    var trans = this._mainGroup.getLocalTransform();
	
	    return graphic.applyTransform(vertex, trans, true);
	  },
	  _findNearestTick: function (axisCoord) {
	    var data = this.model.getData();
	    var dist = Infinity;
	    var targetDataIndex;
	    var axis = this._axis;
	    data.each(['value'], function (value, dataIndex) {
	      var coord = axis.dataToCoord(value);
	      var d = Math.abs(coord - axisCoord);
	
	      if (d < dist) {
	        dist = d;
	        targetDataIndex = dataIndex;
	      }
	    });
	    return targetDataIndex;
	  },
	  _clearTimer: function () {
	    if (this._timer) {
	      clearTimeout(this._timer);
	      this._timer = null;
	    }
	  },
	  _changeTimeline: function (nextIndex) {
	    var currentIndex = this.model.getCurrentIndex();
	
	    if (nextIndex === '+') {
	      nextIndex = currentIndex + 1;
	    } else if (nextIndex === '-') {
	      nextIndex = currentIndex - 1;
	    }
	
	    this.api.dispatchAction({
	      type: 'timelineChange',
	      currentIndex: nextIndex,
	      from: this.uid
	    });
	  }
	});
	
	function getViewRect(model, api) {
	  return layout.getLayoutRect(model.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  }, model.get('padding'));
	}
	
	function makeIcon(timelineModel, objPath, rect, opts) {
	  var icon = graphic.makePath(timelineModel.get(objPath).replace(/^path:\/\//, ''), zrUtil.clone(opts || {}), new BoundingRect(rect[0], rect[1], rect[2], rect[3]), 'center');
	  return icon;
	}
	/**
	 * Create symbol or update symbol
	 * opt: basic position and event handlers
	 */
	
	
	function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	  var color = itemStyleModel.get('color');
	
	  if (!symbol) {
	    var symbolType = hostModel.get('symbol');
	    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	    symbol.setStyle('strokeNoScale', true);
	    group.add(symbol);
	    callback && callback.onCreate(symbol);
	  } else {
	    symbol.setColor(color);
	    group.add(symbol); // Group may be new, also need to add.
	
	    callback && callback.onUpdate(symbol);
	  } // Style
	
	
	  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
	  symbol.setStyle(itemStyle); // Transform and events.
	
	  opt = zrUtil.merge({
	    rectHover: true,
	    z2: 100
	  }, opt, true);
	  var symbolSize = hostModel.get('symbolSize');
	  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	  symbolSize[0] /= 2;
	  symbolSize[1] /= 2;
	  opt.scale = symbolSize;
	  var symbolOffset = hostModel.get('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = opt.position = opt.position || [0, 0];
	    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = hostModel.get('symbolRotate');
	  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  symbol.attr(opt); // FIXME
	  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	  // getBoundingRect will return wrong result.
	  // (This is supposed to be resolved in zrender, but it is a little difficult to
	  // leverage performance and auto updateTransform)
	  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	  symbol.updateTransform();
	  return symbol;
	}
	
	function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
	  if (pointer.dragging) {
	    return;
	  }
	
	  var pointerModel = timelineModel.getModel('checkpointStyle');
	  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));
	
	  if (noAnimation || !pointerModel.get('animation', true)) {
	    pointer.attr({
	      position: [toCoord, 0]
	    });
	  } else {
	    pointer.stopAnimation(true);
	    pointer.animateTo({
	      position: [toCoord, 0]
	    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(237);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'timeline'
	});
	
	module.exports = _default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	var Axis = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var TimelineAxis = function (dim, scale, coordExtent, axisType) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis model
	   * @param {module:echarts/component/TimelineModel}
	   */
	
	  this.model = null;
	};
	
	TimelineAxis.prototype = {
	  constructor: TimelineAxis,
	
	  /**
	   * @override
	   */
	  getLabelModel: function () {
	    return this.model.getModel('label');
	  },
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.model.get('orient') === 'horizontal';
	  }
	};
	zrUtil.inherits(TimelineAxis, Axis);
	var _default = TimelineAxis;
	module.exports = _default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(595);
	
	__webpack_require__(596);
	
	__webpack_require__(597);
	
	__webpack_require__(598);
	
	__webpack_require__(599);
	
	__webpack_require__(600);
	
	__webpack_require__(605);

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var featureManager = __webpack_require__(539);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ToolboxModel = echarts.extendComponentModel({
	  type: 'toolbox',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  optionUpdated: function () {
	    ToolboxModel.superApply(this, 'optionUpdated', arguments);
	    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
	      var Feature = featureManager.get(featureName);
	      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
	    });
	  },
	  defaultOption: {
	    show: true,
	    z: 6,
	    zlevel: 0,
	    orient: 'horizontal',
	    left: 'right',
	    top: 'top',
	    // right
	    // bottom
	    backgroundColor: 'transparent',
	    borderColor: '#ccc',
	    borderRadius: 0,
	    borderWidth: 0,
	    padding: 5,
	    itemSize: 15,
	    itemGap: 8,
	    showTitle: true,
	    iconStyle: {
	      borderColor: '#666',
	      color: 'none'
	    },
	    emphasis: {
	      iconStyle: {
	        borderColor: '#3E98C5'
	      } // textStyle: {},
	      // feature
	
	    }
	  }
	});
	var _default = ToolboxModel;
	module.exports = _default;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var textContain = __webpack_require__(167);
	
	var featureManager = __webpack_require__(539);
	
	var graphic = __webpack_require__(180);
	
	var Model = __webpack_require__(174);
	
	var DataDiffer = __webpack_require__(256);
	
	var listComponentHelper = __webpack_require__(503);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'toolbox',
	  render: function (toolboxModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	
	    if (!toolboxModel.get('show')) {
	      return;
	    }
	
	    var itemSize = +toolboxModel.get('itemSize');
	    var featureOpts = toolboxModel.get('feature') || {};
	    var features = this._features || (this._features = {});
	    var featureNames = [];
	    zrUtil.each(featureOpts, function (opt, name) {
	      featureNames.push(name);
	    });
	    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.
	
	    this._featureNames = featureNames;
	
	    function processFeature(newIndex, oldIndex) {
	      var featureName = featureNames[newIndex];
	      var oldName = featureNames[oldIndex];
	      var featureOpt = featureOpts[featureName];
	      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	      var feature;
	
	      if (featureName && !oldName) {
	        // Create
	        if (isUserFeatureName(featureName)) {
	          feature = {
	            model: featureModel,
	            onclick: featureModel.option.onclick,
	            featureName: featureName
	          };
	        } else {
	          var Feature = featureManager.get(featureName);
	
	          if (!Feature) {
	            return;
	          }
	
	          feature = new Feature(featureModel, ecModel, api);
	        }
	
	        features[featureName] = feature;
	      } else {
	        feature = features[oldName]; // If feature does not exsit.
	
	        if (!feature) {
	          return;
	        }
	
	        feature.model = featureModel;
	        feature.ecModel = ecModel;
	        feature.api = api;
	      }
	
	      if (!featureName && oldName) {
	        feature.dispose && feature.dispose(ecModel, api);
	        return;
	      }
	
	      if (!featureModel.get('show') || feature.unusable) {
	        feature.remove && feature.remove(ecModel, api);
	        return;
	      }
	
	      createIconPaths(featureModel, feature, featureName);
	
	      featureModel.setIconStatus = function (iconName, status) {
	        var option = this.option;
	        var iconPaths = this.iconPaths;
	        option.iconStatus = option.iconStatus || {};
	        option.iconStatus[iconName] = status; // FIXME
	
	        iconPaths[iconName] && iconPaths[iconName].trigger(status);
	      };
	
	      if (feature.render) {
	        feature.render(featureModel, ecModel, api, payload);
	      }
	    }
	
	    function createIconPaths(featureModel, feature, featureName) {
	      var iconStyleModel = featureModel.getModel('iconStyle');
	      var iconStyleEmphasisModel = featureModel.getModel('emphasis.iconStyle'); // If one feature has mutiple icon. they are orginaized as
	      // {
	      //     icon: {
	      //         foo: '',
	      //         bar: ''
	      //     },
	      //     title: {
	      //         foo: '',
	      //         bar: ''
	      //     }
	      // }
	
	      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	      var titles = featureModel.get('title') || {};
	
	      if (typeof icons === 'string') {
	        var icon = icons;
	        var title = titles;
	        icons = {};
	        titles = {};
	        icons[featureName] = icon;
	        titles[featureName] = title;
	      }
	
	      var iconPaths = featureModel.iconPaths = {};
	      zrUtil.each(icons, function (iconStr, iconName) {
	        var path = graphic.createIcon(iconStr, {}, {
	          x: -itemSize / 2,
	          y: -itemSize / 2,
	          width: itemSize,
	          height: itemSize
	        });
	        path.setStyle(iconStyleModel.getItemStyle());
	        path.hoverStyle = iconStyleEmphasisModel.getItemStyle();
	        graphic.setHoverStyle(path);
	
	        if (toolboxModel.get('showTitle')) {
	          path.__title = titles[iconName];
	          path.on('mouseover', function () {
	            // Should not reuse above hoverStyle, which might be modified.
	            var hoverStyle = iconStyleEmphasisModel.getItemStyle();
	            path.setStyle({
	              text: titles[iconName],
	              textPosition: hoverStyle.textPosition || 'bottom',
	              textFill: hoverStyle.fill || hoverStyle.stroke || '#000',
	              textAlign: hoverStyle.textAlign || 'center'
	            });
	          }).on('mouseout', function () {
	            path.setStyle({
	              textFill: null
	            });
	          });
	        }
	
	        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
	        group.add(path);
	        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
	        iconPaths[iconName] = path;
	      });
	    }
	
	    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
	    // FIXME
	
	    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	    group.eachChild(function (icon) {
	      var titleText = icon.__title;
	      var hoverStyle = icon.hoverStyle; // May be background element
	
	      if (hoverStyle && titleText) {
	        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
	        var offsetX = icon.position[0] + group.position[0];
	        var offsetY = icon.position[1] + group.position[1] + itemSize;
	        var needPutOnTop = false;
	
	        if (offsetY + rect.height > api.getHeight()) {
	          hoverStyle.textPosition = 'top';
	          needPutOnTop = true;
	        }
	
	        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
	
	        if (offsetX + rect.width / 2 > api.getWidth()) {
	          hoverStyle.textPosition = ['100%', topOffset];
	          hoverStyle.textAlign = 'right';
	        } else if (offsetX - rect.width / 2 < 0) {
	          hoverStyle.textPosition = [0, topOffset];
	          hoverStyle.textAlign = 'left';
	        }
	      }
	    });
	  },
	  updateView: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	    });
	  },
	  // updateLayout: function (toolboxModel, ecModel, api, payload) {
	  //     zrUtil.each(this._features, function (feature) {
	  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	  //     });
	  // },
	  remove: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.remove && feature.remove(ecModel, api);
	    });
	    this.group.removeAll();
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.dispose && feature.dispose(ecModel, api);
	    });
	  }
	});
	
	function isUserFeatureName(featureName) {
	  return featureName.indexOf('my') === 0;
	}
	
	module.exports = _default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var env = __webpack_require__(133);
	
	var lang = __webpack_require__(243);
	
	var featureManager = __webpack_require__(539);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8Array */
	var saveAsImageLang = lang.toolbox.saveAsImage;
	
	function SaveAsImage(model) {
	  this.model = model;
	}
	
	SaveAsImage.defaultOption = {
	  show: true,
	  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	  title: saveAsImageLang.title,
	  type: 'png',
	  // Default use option.backgroundColor
	  // backgroundColor: '#fff',
	  name: '',
	  excludeComponents: ['toolbox'],
	  pixelRatio: 1,
	  lang: saveAsImageLang.lang.slice()
	};
	SaveAsImage.prototype.unusable = !env.canvasSupported;
	var proto = SaveAsImage.prototype;
	
	proto.onclick = function (ecModel, api) {
	  var model = this.model;
	  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	  var $a = document.createElement('a');
	  var type = model.get('type', true) || 'png';
	  $a.download = title + '.' + type;
	  $a.target = '_blank';
	  var url = api.getConnectedDataURL({
	    type: type,
	    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	    excludeComponents: model.get('excludeComponents'),
	    pixelRatio: model.get('pixelRatio')
	  });
	  $a.href = url; // Chrome and Firefox
	
	  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
	    var evt = new MouseEvent('click', {
	      view: window,
	      bubbles: true,
	      cancelable: false
	    });
	    $a.dispatchEvent(evt);
	  } // IE
	  else {
	      if (window.navigator.msSaveOrOpenBlob) {
	        var bstr = atob(url.split(',')[1]);
	        var n = bstr.length;
	        var u8arr = new Uint8Array(n);
	
	        while (n--) {
	          u8arr[n] = bstr.charCodeAt(n);
	        }
	
	        var blob = new Blob([u8arr]);
	        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
	      } else {
	        var lang = model.get('lang');
	        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	        var tab = window.open();
	        tab.document.write(html);
	      }
	    }
	};
	
	featureManager.register('saveAsImage', SaveAsImage);
	var _default = SaveAsImage;
	module.exports = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var lang = __webpack_require__(243);
	
	var featureManager = __webpack_require__(539);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var magicTypeLang = lang.toolbox.magicType;
	
	function MagicType(model) {
	  this.model = model;
	}
	
	MagicType.defaultOption = {
	  show: true,
	  type: [],
	  // Icon group
	  icon: {
	    /* eslint-disable */
	    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z',
	    // jshint ignore:line
	    tiled: 'M2.3,2.2h22.8V25H2.3V2.2z M35,2.2h22.8V25H35V2.2zM2.3,35h22.8v22.8H2.3V35z M35,35h22.8v22.8H35V35z'
	    /* eslint-enable */
	
	  },
	  // `line`, `bar`, `stack`, `tiled`
	  title: zrUtil.clone(magicTypeLang.title),
	  option: {},
	  seriesIndex: {}
	};
	var proto = MagicType.prototype;
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon');
	  var icons = {};
	  zrUtil.each(model.get('type'), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	var seriesOptGenreator = {
	  'line': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'line',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.line') || {}, true);
	    }
	  },
	  'bar': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'bar',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.bar') || {}, true);
	    }
	  },
	  'stack': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line' || seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        stack: '__ec_magicType_stack__'
	      }, model.get('option.stack') || {}, true);
	    }
	  },
	  'tiled': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line' || seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        stack: ''
	      }, model.get('option.tiled') || {}, true);
	    }
	  }
	};
	var radioTypes = [['line', 'bar'], ['stack', 'tiled']];
	
	proto.onclick = function (ecModel, api, type) {
	  var model = this.model;
	  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType
	
	  if (!seriesOptGenreator[type]) {
	    return;
	  }
	
	  var newOption = {
	    series: []
	  };
	
	  var generateNewSeriesTypes = function (seriesModel) {
	    var seriesType = seriesModel.subType;
	    var seriesId = seriesModel.id;
	    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	    if (newSeriesOpt) {
	      // PENDING If merge original option?
	      zrUtil.defaults(newSeriesOpt, seriesModel.option);
	      newOption.series.push(newSeriesOpt);
	    } // Modify boundaryGap
	
	
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (categoryAxis) {
	        var axisDim = categoryAxis.dim;
	        var axisType = axisDim + 'Axis';
	        var axisModel = ecModel.queryComponents({
	          mainType: axisType,
	          index: seriesModel.get(name + 'Index'),
	          id: seriesModel.get(name + 'Id')
	        })[0];
	        var axisIndex = axisModel.componentIndex;
	        newOption[axisType] = newOption[axisType] || [];
	
	        for (var i = 0; i <= axisIndex; i++) {
	          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	        }
	
	        newOption[axisType][axisIndex].boundaryGap = type === 'bar';
	      }
	    }
	  };
	
	  zrUtil.each(radioTypes, function (radio) {
	    if (zrUtil.indexOf(radio, type) >= 0) {
	      zrUtil.each(radio, function (item) {
	        model.setIconStatus(item, 'normal');
	      });
	    }
	  });
	  model.setIconStatus(type, 'emphasis');
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: seriesIndex == null ? null : {
	      seriesIndex: seriesIndex
	    }
	  }, generateNewSeriesTypes);
	  api.dispatchAction({
	    type: 'changeMagicType',
	    currentType: type,
	    newOption: newOption
	  });
	};
	
	echarts.registerAction({
	  type: 'changeMagicType',
	  event: 'magicTypeChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.mergeOption(payload.newOption);
	});
	featureManager.register('magicType', MagicType);
	var _default = MagicType;
	module.exports = _default;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var eventTool = __webpack_require__(139);
	
	var lang = __webpack_require__(243);
	
	var featureManager = __webpack_require__(539);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var dataViewLang = lang.toolbox.dataView;
	var BLOCK_SPLITER = new Array(60).join('-');
	var ITEM_SPLITER = '\t';
	/**
	 * Group series into two types
	 *  1. on category axis, like line, bar
	 *  2. others, like scatter, pie
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object}
	 * @inner
	 */
	
	function groupSeries(ecModel) {
	  var seriesGroupByCategoryAxis = {};
	  var otherSeries = [];
	  var meta = [];
	  ecModel.eachRawSeries(function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (baseAxis.type === 'category') {
	        var key = baseAxis.dim + '_' + baseAxis.index;
	
	        if (!seriesGroupByCategoryAxis[key]) {
	          seriesGroupByCategoryAxis[key] = {
	            categoryAxis: baseAxis,
	            valueAxis: coordSys.getOtherAxis(baseAxis),
	            series: []
	          };
	          meta.push({
	            axisDim: baseAxis.dim,
	            axisIndex: baseAxis.index
	          });
	        }
	
	        seriesGroupByCategoryAxis[key].series.push(seriesModel);
	      } else {
	        otherSeries.push(seriesModel);
	      }
	    } else {
	      otherSeries.push(seriesModel);
	    }
	  });
	  return {
	    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	    other: otherSeries,
	    meta: meta
	  };
	}
	/**
	 * Assemble content of series on cateogory axis
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleSeriesWithCategoryAxis(series) {
	  var tables = [];
	  zrUtil.each(series, function (group, key) {
	    var categoryAxis = group.categoryAxis;
	    var valueAxis = group.valueAxis;
	    var valueAxisDim = valueAxis.dim;
	    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
	      return series.name;
	    }));
	    var columns = [categoryAxis.model.getCategories()];
	    zrUtil.each(group.series, function (series) {
	      columns.push(series.getRawData().mapArray(valueAxisDim, function (val) {
	        return val;
	      }));
	    }); // Assemble table content
	
	    var lines = [headers.join(ITEM_SPLITER)];
	
	    for (var i = 0; i < columns[0].length; i++) {
	      var items = [];
	
	      for (var j = 0; j < columns.length; j++) {
	        items.push(columns[j][i]);
	      }
	
	      lines.push(items.join(ITEM_SPLITER));
	    }
	
	    tables.push(lines.join('\n'));
	  });
	  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * Assemble content of other series
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleOtherSeries(series) {
	  return zrUtil.map(series, function (series) {
	    var data = series.getRawData();
	    var lines = [series.name];
	    var vals = [];
	    data.each(data.dimensions, function () {
	      var argLen = arguments.length;
	      var dataIndex = arguments[argLen - 1];
	      var name = data.getName(dataIndex);
	
	      for (var i = 0; i < argLen - 1; i++) {
	        vals[i] = arguments[i];
	      }
	
	      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	    });
	    return lines.join('\n');
	  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * @param {module:echarts/model/Global}
	 * @return {Object}
	 * @inner
	 */
	
	
	function getContentFromModel(ecModel) {
	  var result = groupSeries(ecModel);
	  return {
	    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	      return str.replace(/[\n\t\s]/g, '');
	    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	    meta: result.meta
	  };
	}
	
	function trim(str) {
	  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	/**
	 * If a block is tsv format
	 */
	
	
	function isTSVFormat(block) {
	  // Simple method to find out if a block is tsv format
	  var firstLine = block.slice(0, block.indexOf('\n'));
	
	  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	    return true;
	  }
	}
	
	var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	/**
	 * @param {string} tsv
	 * @return {Object}
	 */
	
	function parseTSVContents(tsv) {
	  var tsvLines = tsv.split(/\n+/g);
	  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
	  var categories = [];
	  var series = zrUtil.map(headers, function (header) {
	    return {
	      name: header,
	      data: []
	    };
	  });
	
	  for (var i = 0; i < tsvLines.length; i++) {
	    var items = trim(tsvLines[i]).split(itemSplitRegex);
	    categories.push(items.shift());
	
	    for (var j = 0; j < items.length; j++) {
	      series[j] && (series[j].data[i] = items[j]);
	    }
	  }
	
	  return {
	    series: series,
	    categories: categories
	  };
	}
	/**
	 * @param {string} str
	 * @return {Array.<Object>}
	 * @inner
	 */
	
	
	function parseListContents(str) {
	  var lines = str.split(/\n+/g);
	  var seriesName = trim(lines.shift());
	  var data = [];
	
	  for (var i = 0; i < lines.length; i++) {
	    var items = trim(lines[i]).split(itemSplitRegex);
	    var name = '';
	    var value;
	    var hasName = false;
	
	    if (isNaN(items[0])) {
	      // First item is name
	      hasName = true;
	      name = items[0];
	      items = items.slice(1);
	      data[i] = {
	        name: name,
	        value: []
	      };
	      value = data[i].value;
	    } else {
	      value = data[i] = [];
	    }
	
	    for (var j = 0; j < items.length; j++) {
	      value.push(+items[j]);
	    }
	
	    if (value.length === 1) {
	      hasName ? data[i].value = value[0] : data[i] = value[0];
	    }
	  }
	
	  return {
	    name: seriesName,
	    data: data
	  };
	}
	/**
	 * @param {string} str
	 * @param {Array.<Object>} blockMetaList
	 * @return {Object}
	 * @inner
	 */
	
	
	function parseContents(str, blockMetaList) {
	  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	  var newOption = {
	    series: []
	  };
	  zrUtil.each(blocks, function (block, idx) {
	    if (isTSVFormat(block)) {
	      var result = parseTSVContents(block);
	      var blockMeta = blockMetaList[idx];
	      var axisKey = blockMeta.axisDim + 'Axis';
	
	      if (blockMeta) {
	        newOption[axisKey] = newOption[axisKey] || [];
	        newOption[axisKey][blockMeta.axisIndex] = {
	          data: result.categories
	        };
	        newOption.series = newOption.series.concat(result.series);
	      }
	    } else {
	      var result = parseListContents(block);
	      newOption.series.push(result);
	    }
	  });
	  return newOption;
	}
	/**
	 * @alias {module:echarts/component/toolbox/feature/DataView}
	 * @constructor
	 * @param {module:echarts/model/Model} model
	 */
	
	
	function DataView(model) {
	  this._dom = null;
	  this.model = model;
	}
	
	DataView.defaultOption = {
	  show: true,
	  readOnly: false,
	  optionToContent: null,
	  contentToOption: null,
	  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	  title: zrUtil.clone(dataViewLang.title),
	  lang: zrUtil.clone(dataViewLang.lang),
	  backgroundColor: '#fff',
	  textColor: '#000',
	  textareaColor: '#fff',
	  textareaBorderColor: '#333',
	  buttonColor: '#c23531',
	  buttonTextColor: '#fff'
	};
	
	DataView.prototype.onclick = function (ecModel, api) {
	  var container = api.getDom();
	  var model = this.model;
	
	  if (this._dom) {
	    container.removeChild(this._dom);
	  }
	
	  var root = document.createElement('div');
	  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
	  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	  var header = document.createElement('h4');
	  var lang = model.get('lang') || [];
	  header.innerHTML = lang[0] || model.get('title');
	  header.style.cssText = 'margin: 10px 20px;';
	  header.style.color = model.get('textColor');
	  var viewMain = document.createElement('div');
	  var textarea = document.createElement('textarea');
	  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
	  var optionToContent = model.get('optionToContent');
	  var contentToOption = model.get('contentToOption');
	  var result = getContentFromModel(ecModel);
	
	  if (typeof optionToContent === 'function') {
	    var htmlOrDom = optionToContent(api.getOption());
	
	    if (typeof htmlOrDom === 'string') {
	      viewMain.innerHTML = htmlOrDom;
	    } else if (zrUtil.isDom(htmlOrDom)) {
	      viewMain.appendChild(htmlOrDom);
	    }
	  } else {
	    // Use default textarea
	    viewMain.appendChild(textarea);
	    textarea.readOnly = model.get('readOnly');
	    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
	    textarea.style.color = model.get('textColor');
	    textarea.style.borderColor = model.get('textareaBorderColor');
	    textarea.style.backgroundColor = model.get('textareaColor');
	    textarea.value = result.value;
	  }
	
	  var blockMetaList = result.meta;
	  var buttonContainer = document.createElement('div');
	  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
	  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	  var closeButton = document.createElement('div');
	  var refreshButton = document.createElement('div');
	  buttonStyle += ';background-color:' + model.get('buttonColor');
	  buttonStyle += ';color:' + model.get('buttonTextColor');
	  var self = this;
	
	  function close() {
	    container.removeChild(root);
	    self._dom = null;
	  }
	
	  eventTool.addEventListener(closeButton, 'click', close);
	  eventTool.addEventListener(refreshButton, 'click', function () {
	    var newOption;
	
	    try {
	      if (typeof contentToOption === 'function') {
	        newOption = contentToOption(viewMain, api.getOption());
	      } else {
	        newOption = parseContents(textarea.value, blockMetaList);
	      }
	    } catch (e) {
	      close();
	      throw new Error('Data view format error ' + e);
	    }
	
	    if (newOption) {
	      api.dispatchAction({
	        type: 'changeDataView',
	        newOption: newOption
	      });
	    }
	
	    close();
	  });
	  closeButton.innerHTML = lang[1];
	  refreshButton.innerHTML = lang[2];
	  refreshButton.style.cssText = buttonStyle;
	  closeButton.style.cssText = buttonStyle;
	  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	  buttonContainer.appendChild(closeButton); // http://stackoverflow.com/questions/6637341/use-tab-to-indent-in-textarea
	
	  eventTool.addEventListener(textarea, 'keydown', function (e) {
	    if ((e.keyCode || e.which) === 9) {
	      // get caret position/selection
	      var val = this.value;
	      var start = this.selectionStart;
	      var end = this.selectionEnd; // set textarea value to: text before caret + tab + text after caret
	
	      this.value = val.substring(0, start) + ITEM_SPLITER + val.substring(end); // put caret at right position again
	
	      this.selectionStart = this.selectionEnd = start + 1; // prevent the focus lose
	
	      eventTool.stop(e);
	    }
	  });
	  root.appendChild(header);
	  root.appendChild(viewMain);
	  root.appendChild(buttonContainer);
	  viewMain.style.height = container.clientHeight - 80 + 'px';
	  container.appendChild(root);
	  this._dom = root;
	};
	
	DataView.prototype.remove = function (ecModel, api) {
	  this._dom && api.getDom().removeChild(this._dom);
	};
	
	DataView.prototype.dispose = function (ecModel, api) {
	  this.remove(ecModel, api);
	};
	/**
	 * @inner
	 */
	
	
	function tryMergeDataOption(newData, originalData) {
	  return zrUtil.map(newData, function (newVal, idx) {
	    var original = originalData && originalData[idx];
	
	    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
	      if (zrUtil.isObject(newVal) && !zrUtil.isArray(newVal)) {
	        newVal = newVal.value;
	      } // Original data has option
	
	
	      return zrUtil.defaults({
	        value: newVal
	      }, original);
	    } else {
	      return newVal;
	    }
	  });
	}
	
	featureManager.register('dataView', DataView);
	echarts.registerAction({
	  type: 'changeDataView',
	  event: 'dataViewChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var newSeriesOptList = [];
	  zrUtil.each(payload.newOption.series, function (seriesOpt) {
	    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	    if (!seriesModel) {
	      // New created series
	      // Geuss the series type
	      newSeriesOptList.push(zrUtil.extend({
	        // Default is scatter
	        type: 'scatter'
	      }, seriesOpt));
	    } else {
	      var originalData = seriesModel.get('data');
	      newSeriesOptList.push({
	        name: seriesOpt.name,
	        data: tryMergeDataOption(seriesOpt.data, originalData)
	      });
	    }
	  });
	  ecModel.mergeOption(zrUtil.defaults({
	    series: newSeriesOptList
	  }, payload.newOption));
	});
	var _default = DataView;
	module.exports = _default;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var zrUtil = __webpack_require__(134);
	
	var BrushController = __webpack_require__(418);
	
	var BrushTargetManager = __webpack_require__(534);
	
	var history = __webpack_require__(601);
	
	var sliderMove = __webpack_require__(412);
	
	var lang = __webpack_require__(243);
	
	var featureManager = __webpack_require__(539);
	
	__webpack_require__(602);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Use dataZoomSelect
	var dataZoomLang = lang.toolbox.dataZoom;
	var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
	
	var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';
	
	function DataZoom(model, ecModel, api) {
	  /**
	   * @private
	   * @type {module:echarts/component/helper/BrushController}
	   */
	  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._isZoomActive;
	}
	
	DataZoom.defaultOption = {
	  show: true,
	  // Icon group
	  icon: {
	    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	  },
	  // `zoom`, `back`
	  title: zrUtil.clone(dataZoomLang.title)
	};
	var proto = DataZoom.prototype;
	
	proto.render = function (featureModel, ecModel, api, payload) {
	  this.model = featureModel;
	  this.ecModel = ecModel;
	  this.api = api;
	  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	  updateBackBtnStatus(featureModel, ecModel);
	};
	
	proto.onclick = function (ecModel, api, type) {
	  handlers[type].call(this);
	};
	
	proto.remove = function (ecModel, api) {
	  this._brushController.unmount();
	};
	
	proto.dispose = function (ecModel, api) {
	  this._brushController.dispose();
	};
	/**
	 * @private
	 */
	
	
	var handlers = {
	  zoom: function () {
	    var nextActive = !this._isZoomActive;
	    this.api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'dataZoomSelect',
	      dataZoomSelectActive: nextActive
	    });
	  },
	  back: function () {
	    this._dispatchZoomAction(history.pop(this.ecModel));
	  }
	};
	/**
	 * @private
	 */
	
	proto._onBrush = function (areas, opt) {
	  if (!opt.isEnd || !areas.length) {
	    return;
	  }
	
	  var snapshot = {};
	  var ecModel = this.ecModel;
	
	  this._brushController.updateCovers([]); // remove cover
	
	
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
	    include: ['grid']
	  });
	  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    if (coordSys.type !== 'cartesian2d') {
	      return;
	    }
	
	    var brushType = area.brushType;
	
	    if (brushType === 'rect') {
	      setBatch('x', coordSys, coordRange[0]);
	      setBatch('y', coordSys, coordRange[1]);
	    } else {
	      setBatch({
	        lineX: 'x',
	        lineY: 'y'
	      }[brushType], coordSys, coordRange);
	    }
	  });
	  history.push(ecModel, snapshot);
	
	  this._dispatchZoomAction(snapshot);
	
	  function setBatch(dimName, coordSys, minMax) {
	    var axis = coordSys.getAxis(dimName);
	    var axisModel = axis.model;
	    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	    }
	
	    dataZoomModel && (snapshot[dataZoomModel.id] = {
	      dataZoomId: dataZoomModel.id,
	      startValue: minMax[0],
	      endValue: minMax[1]
	    });
	  }
	
	  function findDataZoom(dimName, axisModel, ecModel) {
	    var found;
	    ecModel.eachComponent({
	      mainType: 'dataZoom',
	      subType: 'select'
	    }, function (dzModel) {
	      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	      has && (found = dzModel);
	    });
	    return found;
	  }
	};
	/**
	 * @private
	 */
	
	
	proto._dispatchZoomAction = function (snapshot) {
	  var batch = []; // Convert from hash map to array.
	
	  each(snapshot, function (batchItem, dataZoomId) {
	    batch.push(zrUtil.clone(batchItem));
	  });
	  batch.length && this.api.dispatchAction({
	    type: 'dataZoom',
	    from: this.uid,
	    batch: batch
	  });
	};
	
	function retrieveAxisSetting(option) {
	  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
	
	  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
	    setting[name] = option[name];
	    setting[name] == null && (setting[name] = 'all');
	    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
	  });
	  return setting;
	}
	
	function updateBackBtnStatus(featureModel, ecModel) {
	  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
	}
	
	function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	  var zoomActive = view._isZoomActive;
	
	  if (payload && payload.type === 'takeGlobalCursor') {
	    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	  }
	
	  view._isZoomActive = zoomActive;
	  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
	    include: ['grid']
	  });
	
	  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
	    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	  })).enableBrush(zoomActive ? {
	    brushType: 'auto',
	    brushStyle: {
	      // FIXME user customized?
	      lineWidth: 0,
	      fill: 'rgba(0,0,0,0.2)'
	    }
	  } : false);
	}
	
	featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
	// FIXME consider the case of merge option, where axes options are not exists.
	
	echarts.registerPreprocessor(function (option) {
	  if (!option) {
	    return;
	  }
	
	  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
	
	  if (!zrUtil.isArray(dataZoomOpts)) {
	    option.dataZoom = dataZoomOpts = [dataZoomOpts];
	  }
	
	  var toolboxOpt = option.toolbox;
	
	  if (toolboxOpt) {
	    // Assume there is only one toolbox
	    if (zrUtil.isArray(toolboxOpt)) {
	      toolboxOpt = toolboxOpt[0];
	    }
	
	    if (toolboxOpt && toolboxOpt.feature) {
	      var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
	      // no axis info to be added. See `test/dataZoom-extreme.html`
	
	      addForAxis('xAxis', dataZoomOpt);
	      addForAxis('yAxis', dataZoomOpt);
	    }
	  }
	
	  function addForAxis(axisName, dataZoomOpt) {
	    if (!dataZoomOpt) {
	      return;
	    } // Try not to modify model, because it is not merged yet.
	
	
	    var axisIndicesName = axisName + 'Index';
	    var givenAxisIndices = dataZoomOpt[axisIndicesName];
	
	    if (givenAxisIndices != null && givenAxisIndices !== 'all' && !zrUtil.isArray(givenAxisIndices)) {
	      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
	    }
	
	    forEachComponent(axisName, function (axisOpt, axisIndex) {
	      if (givenAxisIndices != null && givenAxisIndices !== 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
	        return;
	      }
	
	      var newOpt = {
	        type: 'select',
	        $fromToolbox: true,
	        // Id for merge mapping.
	        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
	      }; // FIXME
	      // Only support one axis now.
	
	      newOpt[axisIndicesName] = axisIndex;
	      dataZoomOpts.push(newOpt);
	    });
	  }
	
	  function forEachComponent(mainType, cb) {
	    var opts = option[mainType];
	
	    if (!zrUtil.isArray(opts)) {
	      opts = opts ? [opts] : [];
	    }
	
	    each(opts, cb);
	  }
	});
	var _default = DataZoom;
	module.exports = _default;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var ATTR = '\0_ec_hist_store';
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
	 */
	
	function push(ecModel, newSnapshot) {
	  var store = giveStore(ecModel); // If previous dataZoom can not be found,
	  // complete an range with current range.
	
	  each(newSnapshot, function (batchItem, dataZoomId) {
	    var i = store.length - 1;
	
	    for (; i >= 0; i--) {
	      var snapshot = store[i];
	
	      if (snapshot[dataZoomId]) {
	        break;
	      }
	    }
	
	    if (i < 0) {
	      // No origin range set, create one by current range.
	      var dataZoomModel = ecModel.queryComponents({
	        mainType: 'dataZoom',
	        subType: 'select',
	        id: dataZoomId
	      })[0];
	
	      if (dataZoomModel) {
	        var percentRange = dataZoomModel.getPercentRange();
	        store[0][dataZoomId] = {
	          dataZoomId: dataZoomId,
	          start: percentRange[0],
	          end: percentRange[1]
	        };
	      }
	    }
	  });
	  store.push(newSnapshot);
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} snapshot
	 */
	
	
	function pop(ecModel) {
	  var store = giveStore(ecModel);
	  var head = store[store.length - 1];
	  store.length > 1 && store.pop(); // Find top for all dataZoom.
	
	  var snapshot = {};
	  each(head, function (batchItem, dataZoomId) {
	    for (var i = store.length - 1; i >= 0; i--) {
	      var batchItem = store[i][dataZoomId];
	
	      if (batchItem) {
	        snapshot[dataZoomId] = batchItem;
	        break;
	      }
	    }
	  });
	  return snapshot;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function clear(ecModel) {
	  ecModel[ATTR] = null;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {number} records. always >= 1.
	 */
	
	
	function count(ecModel) {
	  return giveStore(ecModel).length;
	}
	/**
	 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
	 * History length of each dataZoom may be different.
	 * this._history[0] is used to store origin range.
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(ecModel) {
	  var store = ecModel[ATTR];
	
	  if (!store) {
	    store = ecModel[ATTR] = [{}];
	  }
	
	  return store;
	}
	
	exports.push = push;
	exports.pop = pop;
	exports.clear = clear;
	exports.count = count;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(546);
	
	__webpack_require__(547);
	
	__webpack_require__(550);
	
	__webpack_require__(603);
	
	__webpack_require__(604);
	
	__webpack_require__(556);
	
	__webpack_require__(557);

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(547);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomView = __webpack_require__(550);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomView.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(129);
	
	var history = __webpack_require__(601);
	
	var lang = __webpack_require__(243);
	
	var featureManager = __webpack_require__(539);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var restoreLang = lang.toolbox.restore;
	
	function Restore(model) {
	  this.model = model;
	}
	
	Restore.defaultOption = {
	  show: true,
	
	  /* eslint-disable */
	  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	
	  /* eslint-enable */
	  title: restoreLang.title
	};
	var proto = Restore.prototype;
	
	proto.onclick = function (ecModel, api, type) {
	  history.clear(ecModel);
	  api.dispatchAction({
	    type: 'restore',
	    from: this.uid
	  });
	};
	
	featureManager.register('restore', Restore);
	echarts.registerAction({
	  type: 'restore',
	  event: 'restore',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.resetOption('recreate');
	});
	var _default = Restore;
	module.exports = _default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(607);
	
	var _zrender = __webpack_require__(131);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(609);
	
	registerPainter('vml', Painter);

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(133);
	
	var _vector = __webpack_require__(136);
	
	var applyTransform = _vector.applyTransform;
	
	var BoundingRect = __webpack_require__(154);
	
	var colorTool = __webpack_require__(150);
	
	var textContain = __webpack_require__(167);
	
	var textHelper = __webpack_require__(166);
	
	var RectText = __webpack_require__(165);
	
	var Displayable = __webpack_require__(164);
	
	var ZImage = __webpack_require__(163);
	
	var Text = __webpack_require__(194);
	
	var Path = __webpack_require__(182);
	
	var PathProxy = __webpack_require__(183);
	
	var Gradient = __webpack_require__(211);
	
	var vmlCore = __webpack_require__(608);
	
	// http://www.w3.org/TR/NOTE-VML
	// TODO Use proxy like svg instead of overwrite brush methods
	var CMD = PathProxy.CMD;
	var round = Math.round;
	var sqrt = Math.sqrt;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var mathMax = Math.max;
	
	if (!env.canvasSupported) {
	  var comma = ',';
	  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
	  var Z = 21600;
	  var Z2 = Z / 2;
	  var ZLEVEL_BASE = 100000;
	  var Z_BASE = 1000;
	
	  var initRootElStyle = function (el) {
	    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
	    el.coordsize = Z + ',' + Z;
	    el.coordorigin = '0,0';
	  };
	
	  var encodeHtmlAttribute = function (s) {
	    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	  };
	
	  var rgb2Str = function (r, g, b) {
	    return 'rgb(' + [r, g, b].join(',') + ')';
	  };
	
	  var append = function (parent, child) {
	    if (child && parent && child.parentNode !== parent) {
	      parent.appendChild(child);
	    }
	  };
	
	  var remove = function (parent, child) {
	    if (child && parent && child.parentNode === parent) {
	      parent.removeChild(child);
	    }
	  };
	
	  var getZIndex = function (zlevel, z, z2) {
	    // z 的取值范围为 [0, 1000]
	    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
	  };
	
	  var parsePercent = function (value, maxValue) {
	    if (typeof value === 'string') {
	      if (value.lastIndexOf('%') >= 0) {
	        return parseFloat(value) / 100 * maxValue;
	      }
	
	      return parseFloat(value);
	    }
	
	    return value;
	  };
	  /***************************************************
	   * PATH
	   **************************************************/
	
	
	  var setColorAndOpacity = function (el, color, opacity) {
	    var colorArr = colorTool.parse(color);
	    opacity = +opacity;
	
	    if (isNaN(opacity)) {
	      opacity = 1;
	    }
	
	    if (colorArr) {
	      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
	      el.opacity = opacity * colorArr[3];
	    }
	  };
	
	  var getColorAndAlpha = function (color) {
	    var colorArr = colorTool.parse(color);
	    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
	  };
	
	  var updateFillNode = function (el, style, zrEl) {
	    // TODO pattern
	    var fill = style.fill;
	
	    if (fill != null) {
	      // Modified from excanvas
	      if (fill instanceof Gradient) {
	        var gradientType;
	        var angle = 0;
	        var focus = [0, 0]; // additional offset
	
	        var shift = 0; // scale factor for offset
	
	        var expansion = 1;
	        var rect = zrEl.getBoundingRect();
	        var rectWidth = rect.width;
	        var rectHeight = rect.height;
	
	        if (fill.type === 'linear') {
	          gradientType = 'gradient';
	          var transform = zrEl.transform;
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	            applyTransform(p1, p1, transform);
	          }
	
	          var dx = p1[0] - p0[0];
	          var dy = p1[1] - p0[1];
	          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
	
	          if (angle < 0) {
	            angle += 360;
	          } // Very small angles produce an unexpected result because they are
	          // converted to a scientific notation string.
	
	
	          if (angle < 1e-6) {
	            angle = 0;
	          }
	        } else {
	          gradientType = 'gradientradial';
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var transform = zrEl.transform;
	          var scale = zrEl.scale;
	          var width = rectWidth;
	          var height = rectHeight;
	          focus = [// Percent in bounding rect
	          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	          }
	
	          width /= scale[0] * Z;
	          height /= scale[1] * Z;
	          var dimension = mathMax(width, height);
	          shift = 2 * 0 / dimension;
	          expansion = 2 * fill.r / dimension - shift;
	        } // We need to sort the color stops in ascending order by offset,
	        // otherwise IE won't interpret it correctly.
	
	
	        var stops = fill.colorStops.slice();
	        stops.sort(function (cs1, cs2) {
	          return cs1.offset - cs2.offset;
	        });
	        var length = stops.length; // Color and alpha list of first and last stop
	
	        var colorAndAlphaList = [];
	        var colors = [];
	
	        for (var i = 0; i < length; i++) {
	          var stop = stops[i];
	          var colorAndAlpha = getColorAndAlpha(stop.color);
	          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);
	
	          if (i === 0 || i === length - 1) {
	            colorAndAlphaList.push(colorAndAlpha);
	          }
	        }
	
	        if (length >= 2) {
	          var color1 = colorAndAlphaList[0][0];
	          var color2 = colorAndAlphaList[1][0];
	          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
	          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
	          el.type = gradientType;
	          el.method = 'none';
	          el.focus = '100%';
	          el.angle = angle;
	          el.color = color1;
	          el.color2 = color2;
	          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
	          // are reversed.
	
	          el.opacity = opacity2; // FIXME g_o_:opacity ?
	
	          el.opacity2 = opacity1;
	        }
	
	        if (gradientType === 'radial') {
	          el.focusposition = focus.join(',');
	        }
	      } else {
	        // FIXME Change from Gradient fill to color fill
	        setColorAndOpacity(el, fill, style.opacity);
	      }
	    }
	  };
	
	  var updateStrokeNode = function (el, style) {
	    // if (style.lineJoin != null) {
	    //     el.joinstyle = style.lineJoin;
	    // }
	    // if (style.miterLimit != null) {
	    //     el.miterlimit = style.miterLimit * Z;
	    // }
	    // if (style.lineCap != null) {
	    //     el.endcap = style.lineCap;
	    // }
	    if (style.lineDash != null) {
	      el.dashstyle = style.lineDash.join(' ');
	    }
	
	    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
	      setColorAndOpacity(el, style.stroke, style.opacity);
	    }
	  };
	
	  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
	    var isFill = type === 'fill';
	    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
	
	    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error
	
	      if (style[type] instanceof Gradient) {
	        remove(vmlEl, el);
	      }
	
	      if (!el) {
	        el = vmlCore.createNode(type);
	      }
	
	      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
	      append(vmlEl, el);
	    } else {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
	      remove(vmlEl, el);
	    }
	  };
	
	  var points = [[], [], []];
	
	  var pathDataToString = function (path, m) {
	    var M = CMD.M;
	    var C = CMD.C;
	    var L = CMD.L;
	    var A = CMD.A;
	    var Q = CMD.Q;
	    var str = [];
	    var nPoint;
	    var cmdStr;
	    var cmd;
	    var i;
	    var xi;
	    var yi;
	    var data = path.data;
	    var dataLength = path.len();
	
	    for (i = 0; i < dataLength;) {
	      cmd = data[i++];
	      cmdStr = '';
	      nPoint = 0;
	
	      switch (cmd) {
	        case M:
	          cmdStr = ' m ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case L:
	          cmdStr = ' l ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case Q:
	        case C:
	          cmdStr = ' c ';
	          nPoint = 3;
	          var x1 = data[i++];
	          var y1 = data[i++];
	          var x2 = data[i++];
	          var y2 = data[i++];
	          var x3;
	          var y3;
	
	          if (cmd === Q) {
	            // Convert quadratic to cubic using degree elevation
	            x3 = x2;
	            y3 = y2;
	            x2 = (x2 + 2 * x1) / 3;
	            y2 = (y2 + 2 * y1) / 3;
	            x1 = (xi + 2 * x1) / 3;
	            y1 = (yi + 2 * y1) / 3;
	          } else {
	            x3 = data[i++];
	            y3 = data[i++];
	          }
	
	          points[0][0] = x1;
	          points[0][1] = y1;
	          points[1][0] = x2;
	          points[1][1] = y2;
	          points[2][0] = x3;
	          points[2][1] = y3;
	          xi = x3;
	          yi = y3;
	          break;
	
	        case A:
	          var x = 0;
	          var y = 0;
	          var sx = 1;
	          var sy = 1;
	          var angle = 0;
	
	          if (m) {
	            // Extract SRT from matrix
	            x = m[4];
	            y = m[5];
	            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
	            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
	            angle = Math.atan2(-m[1] / sy, m[0] / sx);
	          }
	
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++] + angle;
	          var endAngle = data[i++] + startAngle + angle; // FIXME
	          // var psi = data[i++];
	
	          i++;
	          var clockwise = data[i++];
	          var x0 = cx + cos(startAngle) * rx;
	          var y0 = cy + sin(startAngle) * ry;
	          var x1 = cx + cos(endAngle) * rx;
	          var y1 = cy + sin(endAngle) * ry;
	          var type = clockwise ? ' wa ' : ' at ';
	
	          if (Math.abs(x0 - x1) < 1e-4) {
	            // IE won't render arches drawn counter clockwise if x0 == x1.
	            if (Math.abs(endAngle - startAngle) > 1e-2) {
	              // Offset x0 by 1/80 of a pixel. Use something
	              // that can be represented in binary
	              if (clockwise) {
	                x0 += 270 / Z;
	              }
	            } else {
	              // Avoid case draw full circle
	              if (Math.abs(y0 - cy) < 1e-4) {
	                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
	                  y1 -= 270 / Z;
	                } else {
	                  y1 += 270 / Z;
	                }
	              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
	                x1 += 270 / Z;
	              } else {
	                x1 -= 270 / Z;
	              }
	            }
	          }
	
	          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
	          xi = x1;
	          yi = y1;
	          break;
	
	        case CMD.R:
	          var p0 = points[0];
	          var p1 = points[1]; // x0, y0
	
	          p0[0] = data[i++];
	          p0[1] = data[i++]; // x1, y1
	
	          p1[0] = p0[0] + data[i++];
	          p1[1] = p0[1] + data[i++];
	
	          if (m) {
	            applyTransform(p0, p0, m);
	            applyTransform(p1, p1, m);
	          }
	
	          p0[0] = round(p0[0] * Z - Z2);
	          p1[0] = round(p1[0] * Z - Z2);
	          p0[1] = round(p0[1] * Z - Z2);
	          p1[1] = round(p1[1] * Z - Z2);
	          str.push( // x0, y0
	          ' m ', p0[0], comma, p0[1], // x1, y0
	          ' l ', p1[0], comma, p0[1], // x1, y1
	          ' l ', p1[0], comma, p1[1], // x0, y1
	          ' l ', p0[0], comma, p1[1]);
	          break;
	
	        case CMD.Z:
	          // FIXME Update xi, yi
	          str.push(' x ');
	      }
	
	      if (nPoint > 0) {
	        str.push(cmdStr);
	
	        for (var k = 0; k < nPoint; k++) {
	          var p = points[k];
	          m && applyTransform(p, p, m); // 不 round 会非常慢
	
	          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
	        }
	      }
	    }
	
	    return str.join('');
	  }; // Rewrite the original path method
	
	
	  Path.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      vmlEl = vmlCore.createNode('shape');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    updateFillAndStroke(vmlEl, 'fill', style, this);
	    updateFillAndStroke(vmlEl, 'stroke', style, this);
	    var m = this.transform;
	    var needTransform = m != null;
	    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];
	
	    if (strokeEl) {
	      var lineWidth = style.lineWidth; // Get the line scale.
	      // Determinant of this.m_ means how much the area is enlarged by the
	      // transformation. So its square root can be used as a scale factor
	      // for width.
	
	      if (needTransform && !style.strokeNoScale) {
	        var det = m[0] * m[3] - m[1] * m[2];
	        lineWidth *= sqrt(abs(det));
	      }
	
	      strokeEl.weight = lineWidth + 'px';
	    }
	
	    var path = this.path || (this.path = new PathProxy());
	
	    if (this.__dirtyPath) {
	      path.beginPath();
	      path.subPixelOptimize = false;
	      this.buildPath(path, this.shape);
	      path.toStatic();
	      this.__dirtyPath = false;
	    }
	
	    vmlEl.path = pathDataToString(path, this.transform);
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Path.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this.removeRectText(vmlRoot);
	  };
	
	  Path.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * IMAGE
	   **************************************************/
	
	
	  var isImage = function (img) {
	    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
	    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
	  }; // Rewrite the original path method
	
	
	  ZImage.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var image = style.image; // Image original width, height
	
	    var ow;
	    var oh;
	
	    if (isImage(image)) {
	      var src = image.src;
	
	      if (src === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      } else {
	        var imageRuntimeStyle = image.runtimeStyle;
	        var oldRuntimeWidth = imageRuntimeStyle.width;
	        var oldRuntimeHeight = imageRuntimeStyle.height;
	        imageRuntimeStyle.width = 'auto';
	        imageRuntimeStyle.height = 'auto'; // get the original size
	
	        ow = image.width;
	        oh = image.height; // and remove overides
	
	        imageRuntimeStyle.width = oldRuntimeWidth;
	        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
	
	        this._imageSrc = src;
	        this._imageWidth = ow;
	        this._imageHeight = oh;
	      }
	
	      image = src;
	    } else {
	      if (image === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      }
	    }
	
	    if (!image) {
	      return;
	    }
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var dw = style.width;
	    var dh = style.height;
	    var sw = style.sWidth;
	    var sh = style.sHeight;
	    var sx = style.sx || 0;
	    var sy = style.sy || 0;
	    var hasCrop = sw && sh;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
	      // vmlEl = vmlCore.createNode('group');
	      vmlEl = vmlCore.doc.createElement('div');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    var vmlElStyle = vmlEl.style;
	    var hasRotation = false;
	    var m;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    if (this.transform) {
	      m = this.transform;
	      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
	      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
	      hasRotation = m[1] || m[2];
	    }
	
	    if (hasRotation) {
	      // If filters are necessary (rotation exists), create them
	      // filters are bog-slow, so only create them if abbsolutely necessary
	      // The following check doesn't account for skews (which don't exist
	      // in the canvas spec (yet) anyway.
	      // From excanvas
	      var p0 = [x, y];
	      var p1 = [x + dw, y];
	      var p2 = [x, y + dh];
	      var p3 = [x + dw, y + dh];
	      applyTransform(p0, p0, m);
	      applyTransform(p1, p1, m);
	      applyTransform(p2, p2, m);
	      applyTransform(p3, p3, m);
	      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
	      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
	      var transformFilter = [];
	      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
	      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
	
	      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
	    } else {
	      if (m) {
	        x = x * scaleX + m[4];
	        y = y * scaleY + m[5];
	      }
	
	      vmlElStyle.filter = '';
	      vmlElStyle.left = round(x) + 'px';
	      vmlElStyle.top = round(y) + 'px';
	    }
	
	    var imageEl = this._imageEl;
	    var cropEl = this._cropEl;
	
	    if (!imageEl) {
	      imageEl = vmlCore.doc.createElement('div');
	      this._imageEl = imageEl;
	    }
	
	    var imageELStyle = imageEl.style;
	
	    if (hasCrop) {
	      // Needs know image original width and height
	      if (!(ow && oh)) {
	        var tmpImage = new Image();
	        var self = this;
	
	        tmpImage.onload = function () {
	          tmpImage.onload = null;
	          ow = tmpImage.width;
	          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
	
	          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src
	
	          self._imageWidth = ow;
	          self._imageHeight = oh;
	          self._imageSrc = image;
	        };
	
	        tmpImage.src = image;
	      } else {
	        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
	      }
	
	      if (!cropEl) {
	        cropEl = vmlCore.doc.createElement('div');
	        cropEl.style.overflow = 'hidden';
	        this._cropEl = cropEl;
	      }
	
	      var cropElStyle = cropEl.style;
	      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
	      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
	      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';
	
	      if (!cropEl.parentNode) {
	        vmlEl.appendChild(cropEl);
	      }
	
	      if (imageEl.parentNode !== cropEl) {
	        cropEl.appendChild(imageEl);
	      }
	    } else {
	      imageELStyle.width = round(scaleX * dw) + 'px';
	      imageELStyle.height = round(scaleY * dh) + 'px';
	      vmlEl.appendChild(imageEl);
	
	      if (cropEl && cropEl.parentNode) {
	        vmlEl.removeChild(cropEl);
	        this._cropEl = null;
	      }
	    }
	
	    var filterStr = '';
	    var alpha = style.opacity;
	
	    if (alpha < 1) {
	      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
	    }
	
	    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
	    imageELStyle.filter = filterStr;
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    }
	  };
	
	  ZImage.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this._vmlEl = null;
	    this._cropEl = null;
	    this._imageEl = null;
	    this.removeRectText(vmlRoot);
	  };
	
	  ZImage.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * TEXT
	   **************************************************/
	
	
	  var DEFAULT_STYLE_NORMAL = 'normal';
	  var fontStyleCache = {};
	  var fontStyleCacheCount = 0;
	  var MAX_FONT_CACHE_SIZE = 100;
	  var fontEl = document.createElement('div');
	
	  var getFontStyle = function (fontString) {
	    var fontStyle = fontStyleCache[fontString];
	
	    if (!fontStyle) {
	      // Clear cache
	      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
	        fontStyleCacheCount = 0;
	        fontStyleCache = {};
	      }
	
	      var style = fontEl.style;
	      var fontFamily;
	
	      try {
	        style.font = fontString;
	        fontFamily = style.fontFamily.split(',')[0];
	      } catch (e) {}
	
	      fontStyle = {
	        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
	        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
	        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
	        size: parseFloat(style.fontSize || 12) | 0,
	        family: fontFamily || 'Microsoft YaHei'
	      };
	      fontStyleCache[fontString] = fontStyle;
	      fontStyleCacheCount++;
	    }
	
	    return fontStyle;
	  };
	
	  var textMeasureEl; // Overwrite measure text method
	
	  textContain.$override('measureText', function (text, textFont) {
	    var doc = vmlCore.doc;
	
	    if (!textMeasureEl) {
	      textMeasureEl = doc.createElement('div');
	      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
	      vmlCore.doc.body.appendChild(textMeasureEl);
	    }
	
	    try {
	      textMeasureEl.style.font = textFont;
	    } catch (ex) {// Ignore failures to set to invalid font.
	    }
	
	    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.
	
	    textMeasureEl.appendChild(doc.createTextNode(text));
	    return {
	      width: textMeasureEl.offsetWidth
	    };
	  });
	  var tmpRect = new BoundingRect();
	
	  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!text) {
	      return;
	    } // Convert rich text to plain text. Rich text is not supported in
	    // IE8-, but tags in rich text template will be removed.
	
	
	    if (style.rich) {
	      var contentBlock = textContain.parseRichText(text, style);
	      text = [];
	
	      for (var i = 0; i < contentBlock.lines.length; i++) {
	        var tokens = contentBlock.lines[i].tokens;
	        var textLine = [];
	
	        for (var j = 0; j < tokens.length; j++) {
	          textLine.push(tokens[j].text);
	        }
	
	        text.push(textLine.join(''));
	      }
	
	      text = text.join('\n');
	    }
	
	    var x;
	    var y;
	    var align = style.textAlign;
	    var verticalAlign = style.textVerticalAlign;
	    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
	
	    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
	    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space
	
	    var m = this.transform; // Ignore transform for text in other element
	
	    if (m && !fromTextEl) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(m);
	      rect = tmpRect;
	    }
	
	    if (!fromTextEl) {
	      var textPosition = style.textPosition;
	      var distance = style.textDistance; // Text position represented by coord
	
	      if (textPosition instanceof Array) {
	        x = rect.x + parsePercent(textPosition[0], rect.width);
	        y = rect.y + parsePercent(textPosition[1], rect.height);
	        align = align || 'left';
	      } else {
	        var res = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
	        x = res.x;
	        y = res.y; // Default align and baseline when has textPosition
	
	        align = align || res.textAlign;
	        verticalAlign = verticalAlign || res.textVerticalAlign;
	      }
	    } else {
	      x = rect.x;
	      y = rect.y;
	    }
	
	    x = textContain.adjustTextX(x, textRect.width, align);
	    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'
	
	    y += textRect.height / 2; // var fontSize = fontStyle.size;
	    // 1.75 is an arbitrary number, as there is no info about the text baseline
	    // switch (baseline) {
	    // case 'hanging':
	    // case 'top':
	    //     y += fontSize / 1.75;
	    //     break;
	    //     case 'middle':
	    //         break;
	    //     default:
	    //     // case null:
	    //     // case 'alphabetic':
	    //     // case 'ideographic':
	    //     // case 'bottom':
	    //         y -= fontSize / 2.25;
	    //         break;
	    // }
	    // switch (align) {
	    //     case 'left':
	    //         break;
	    //     case 'center':
	    //         x -= textRect.width / 2;
	    //         break;
	    //     case 'right':
	    //         x -= textRect.width;
	    //         break;
	    // case 'end':
	    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
	    // break;
	    // case 'start':
	    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
	    // break;
	    // default:
	    //     align = 'left';
	    // }
	
	    var createNode = vmlCore.createNode;
	    var textVmlEl = this._textVmlEl;
	    var pathEl;
	    var textPathEl;
	    var skewEl;
	
	    if (!textVmlEl) {
	      textVmlEl = createNode('line');
	      pathEl = createNode('path');
	      textPathEl = createNode('textpath');
	      skewEl = createNode('skew'); // FIXME Why here is not cammel case
	      // Align 'center' seems wrong
	
	      textPathEl.style['v-text-align'] = 'left';
	      initRootElStyle(textVmlEl);
	      pathEl.textpathok = true;
	      textPathEl.on = true;
	      textVmlEl.from = '0 0';
	      textVmlEl.to = '1000 0.05';
	      append(textVmlEl, skewEl);
	      append(textVmlEl, pathEl);
	      append(textVmlEl, textPathEl);
	      this._textVmlEl = textVmlEl;
	    } else {
	      // 这里是在前面 appendChild 保证顺序的前提下
	      skewEl = textVmlEl.firstChild;
	      pathEl = skewEl.nextSibling;
	      textPathEl = pathEl.nextSibling;
	    }
	
	    var coords = [x, y];
	    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
	
	    if (m && fromTextEl) {
	      applyTransform(coords, coords, m);
	      skewEl.on = true;
	      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position
	
	      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin
	
	      skewEl.origin = '0 0';
	      textVmlElStyle.left = '0px';
	      textVmlElStyle.top = '0px';
	    } else {
	      skewEl.on = false;
	      textVmlElStyle.left = round(x) + 'px';
	      textVmlElStyle.top = round(y) + 'px';
	    }
	
	    textPathEl.string = encodeHtmlAttribute(text); // TODO
	
	    try {
	      textPathEl.style.font = font;
	    } // Error font format
	    catch (e) {}
	
	    updateFillAndStroke(textVmlEl, 'fill', {
	      fill: style.textFill,
	      opacity: style.opacity
	    }, this);
	    updateFillAndStroke(textVmlEl, 'stroke', {
	      stroke: style.textStroke,
	      opacity: style.opacity,
	      lineDash: style.lineDash
	    }, this);
	    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root
	
	    append(vmlRoot, textVmlEl);
	  };
	
	  var removeRectText = function (vmlRoot) {
	    remove(vmlRoot, this._textVmlEl);
	    this._textVmlEl = null;
	  };
	
	  var appendRectText = function (vmlRoot) {
	    append(vmlRoot, this._textVmlEl);
	  };
	
	  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText
	
	  for (var i = 0; i < list.length; i++) {
	    var proto = list[i].prototype;
	    proto.drawRectText = drawRectText;
	    proto.removeRectText = removeRectText;
	    proto.appendRectText = appendRectText;
	  }
	
	  Text.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, {
	        x: style.x || 0,
	        y: style.y || 0,
	        width: 0,
	        height: 0
	      }, this.getBoundingRect(), true);
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Text.prototype.onRemove = function (vmlRoot) {
	    this.removeRectText(vmlRoot);
	  };
	
	  Text.prototype.onAdd = function (vmlRoot) {
	    this.appendRectText(vmlRoot);
	  };
	}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(133);
	
	var urn = 'urn:schemas-microsoft-com:vml';
	var win = typeof window === 'undefined' ? null : window;
	var vmlInited = false;
	var doc = win && win.document;
	
	function createNode(tagName) {
	  return doCreateNode(tagName);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	var doCreateNode;
	
	if (doc && !env.canvasSupported) {
	  try {
	    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);
	
	    doCreateNode = function (tagName) {
	      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
	    };
	  } catch (e) {
	    doCreateNode = function (tagName) {
	      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
	    };
	  }
	} // From raphael
	
	
	function initVML() {
	  if (vmlInited || !doc) {
	    return;
	  }
	
	  vmlInited = true;
	  var styleSheets = doc.styleSheets;
	
	  if (styleSheets.length < 31) {
	    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
	  } else {
	    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
	  }
	}
	
	exports.doc = doc;
	exports.createNode = createNode;
	exports.initVML = initVML;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var zrLog = __webpack_require__(152);
	
	var vmlCore = __webpack_require__(608);
	
	var _util = __webpack_require__(134);
	
	var each = _util.each;
	
	/**
	 * VML Painter.
	 *
	 * @module zrender/vml/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	/**
	 * @alias module:zrender/vml/Painter
	 */
	
	
	function VMLPainter(root, storage) {
	  vmlCore.initVML();
	  this.root = root;
	  this.storage = storage;
	  var vmlViewport = document.createElement('div');
	  var vmlRoot = document.createElement('div');
	  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
	  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  root.appendChild(vmlViewport);
	  this._vmlRoot = vmlRoot;
	  this._vmlViewport = vmlViewport;
	  this.resize(); // Modify storage
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	
	    if (el) {
	      el.onRemove && el.onRemove(vmlRoot);
	    }
	  };
	
	  storage.addToStorage = function (el) {
	    // Displayable already has a vml node
	    el.onAdd && el.onAdd(vmlRoot);
	    oldAddToStorage.call(storage, el);
	  };
	
	  this._firstPaint = true;
	}
	
	VMLPainter.prototype = {
	  constructor: VMLPainter,
	  getType: function () {
	    return 'vml';
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._vmlViewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   */
	  refresh: function () {
	    var list = this.storage.getDisplayList(true, true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    var vmlRoot = this._vmlRoot;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	
	      if (el.invisible || el.ignore) {
	        if (!el.__alreadyNotVisible) {
	          el.onRemove(vmlRoot);
	        } // Set as already invisible
	
	
	        el.__alreadyNotVisible = true;
	      } else {
	        if (el.__alreadyNotVisible) {
	          el.onAdd(vmlRoot);
	        }
	
	        el.__alreadyNotVisible = false;
	
	        if (el.__dirty) {
	          el.beforeBrush && el.beforeBrush();
	          (el.brushVML || el.brush).call(el, vmlRoot);
	          el.afterBrush && el.afterBrush();
	        }
	      }
	
	      el.__dirty = false;
	    }
	
	    if (this._firstPaint) {
	      // Detached from document at first time
	      // to avoid page refreshing too many times
	      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
	      this._vmlViewport.appendChild(vmlRoot);
	
	      this._firstPaint = false;
	    }
	  },
	  resize: function (width, height) {
	    var width = width == null ? this._getWidth() : width;
	    var height = height == null ? this._getHeight() : height;
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var vmlViewportStyle = this._vmlViewport.style;
	      vmlViewportStyle.width = width + 'px';
	      vmlViewportStyle.height = height + 'px';
	    }
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._vmlRoot = this._vmlViewport = this.storage = null;
	  },
	  getWidth: function () {
	    return this._width;
	  },
	  getHeight: function () {
	    return this._height;
	  },
	  clear: function () {
	    if (this._vmlViewport) {
	      this.root.removeChild(this._vmlViewport);
	    }
	  },
	  _getWidth: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
	  },
	  _getHeight: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    zrLog('In IE8.0 VML mode painter not support method "' + method + '"');
	  };
	} // Unsupported methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  VMLPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = VMLPainter;
	module.exports = _default;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(611);
	
	var _zrender = __webpack_require__(131);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(613);
	
	registerPainter('svg', Painter);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(612);
	
	var createElement = _core.createElement;
	
	var PathProxy = __webpack_require__(183);
	
	var BoundingRect = __webpack_require__(154);
	
	var matrix = __webpack_require__(145);
	
	var textContain = __webpack_require__(167);
	
	var textHelper = __webpack_require__(166);
	
	var Text = __webpack_require__(194);
	
	// TODO
	// 1. shadow
	// 2. Image: sx, sy, sw, sh
	var CMD = PathProxy.CMD;
	var arrayJoin = Array.prototype.join;
	var NONE = 'none';
	var mathRound = Math.round;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	var PI2 = Math.PI * 2;
	var degree = 180 / PI;
	var EPSILON = 1e-4;
	
	function round4(val) {
	  return mathRound(val * 1e4) / 1e4;
	}
	
	function isAroundZero(val) {
	  return val < EPSILON && val > -EPSILON;
	}
	
	function pathHasFill(style, isText) {
	  var fill = isText ? style.textFill : style.fill;
	  return fill != null && fill !== NONE;
	}
	
	function pathHasStroke(style, isText) {
	  var stroke = isText ? style.textStroke : style.stroke;
	  return stroke != null && stroke !== NONE;
	}
	
	function setTransform(svgEl, m) {
	  if (m) {
	    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
	  }
	}
	
	function attr(el, key, val) {
	  if (!val || val.type !== 'linear' && val.type !== 'radial') {
	    // Don't set attribute for gradient, since it need new dom nodes
	    el.setAttribute(key, val);
	  }
	}
	
	function attrXLink(el, key, val) {
	  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
	}
	
	function bindStyle(svgEl, style, isText, el) {
	  if (pathHasFill(style, isText)) {
	    var fill = isText ? style.textFill : style.fill;
	    fill = fill === 'transparent' ? NONE : fill;
	    /**
	     * FIXME:
	     * This is a temporary fix for Chrome's clipping bug
	     * that happens when a clip-path is referring another one.
	     * This fix should be used before Chrome's bug is fixed.
	     * For an element that has clip-path, and fill is none,
	     * set it to be "rgba(0, 0, 0, 0.002)" will hide the element.
	     * Otherwise, it will show black fill color.
	     * 0.002 is used because this won't work for alpha values smaller
	     * than 0.002.
	     *
	     * See
	     * https://bugs.chromium.org/p/chromium/issues/detail?id=659790
	     * for more information.
	     */
	
	    if (svgEl.getAttribute('clip-path') !== 'none' && fill === NONE) {
	      fill = 'rgba(0, 0, 0, 0.002)';
	    }
	
	    attr(svgEl, 'fill', fill);
	    attr(svgEl, 'fill-opacity', style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
	  } else {
	    attr(svgEl, 'fill', NONE);
	  }
	
	  if (pathHasStroke(style, isText)) {
	    var stroke = isText ? style.textStroke : style.stroke;
	    stroke = stroke === 'transparent' ? NONE : stroke;
	    attr(svgEl, 'stroke', stroke);
	    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
	    var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
	    attr(svgEl, 'stroke-width', strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others
	
	    attr(svgEl, 'paint-order', isText ? 'stroke' : 'fill');
	    attr(svgEl, 'stroke-opacity', style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
	    var lineDash = style.lineDash;
	
	    if (lineDash) {
	      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
	      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
	    } else {
	      attr(svgEl, 'stroke-dasharray', '');
	    } // PENDING
	
	
	    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
	    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
	    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
	  } else {
	    attr(svgEl, 'stroke', NONE);
	  }
	}
	/***************************************************
	 * PATH
	 **************************************************/
	
	
	function pathDataToString(path) {
	  var str = [];
	  var data = path.data;
	  var dataLength = path.len();
	
	  for (var i = 0; i < dataLength;) {
	    var cmd = data[i++];
	    var cmdStr = '';
	    var nData = 0;
	
	    switch (cmd) {
	      case CMD.M:
	        cmdStr = 'M';
	        nData = 2;
	        break;
	
	      case CMD.L:
	        cmdStr = 'L';
	        nData = 2;
	        break;
	
	      case CMD.Q:
	        cmdStr = 'Q';
	        nData = 4;
	        break;
	
	      case CMD.C:
	        cmdStr = 'C';
	        nData = 6;
	        break;
	
	      case CMD.A:
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++];
	        var psi = data[i++];
	        var clockwise = data[i++];
	        var dThetaPositive = Math.abs(dTheta);
	        var isCircle = isAroundZero(dThetaPositive - PI2) && !isAroundZero(dThetaPositive);
	        var large = false;
	
	        if (dThetaPositive >= PI2) {
	          large = true;
	        } else if (isAroundZero(dThetaPositive)) {
	          large = false;
	        } else {
	          large = (dTheta > -PI && dTheta < 0 || dTheta > PI) === !!clockwise;
	        }
	
	        var x0 = round4(cx + rx * mathCos(theta));
	        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
	        // We need to shift the end point with a small value
	        // FIXME A better way to draw circle ?
	
	        if (isCircle) {
	          if (clockwise) {
	            dTheta = PI2 - 1e-4;
	          } else {
	            dTheta = -PI2 + 1e-4;
	          }
	
	          large = true;
	
	          if (i === 9) {
	            // Move to (x0, y0) only when CMD.A comes at the
	            // first position of a shape.
	            // For instance, when drawing a ring, CMD.A comes
	            // after CMD.M, so it's unnecessary to move to
	            // (x0, y0).
	            str.push('M', x0, y0);
	          }
	        }
	
	        var x = round4(cx + rx * mathCos(theta + dTheta));
	        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse
	
	        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
	        break;
	
	      case CMD.Z:
	        cmdStr = 'Z';
	        break;
	
	      case CMD.R:
	        var x = round4(data[i++]);
	        var y = round4(data[i++]);
	        var w = round4(data[i++]);
	        var h = round4(data[i++]);
	        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
	        break;
	    }
	
	    cmdStr && str.push(cmdStr);
	
	    for (var j = 0; j < nData; j++) {
	      // PENDING With scale
	      str.push(round4(data[i++]));
	    }
	  }
	
	  return str.join(' ');
	}
	
	var svgPath = {};
	
	svgPath.brush = function (el) {
	  var style = el.style;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('path');
	    el.__svgEl = svgEl;
	  }
	
	  if (!el.path) {
	    el.createPathProxy();
	  }
	
	  var path = el.path;
	
	  if (el.__dirtyPath) {
	    path.beginPath();
	    path.subPixelOptimize = false;
	    el.buildPath(path, el.shape);
	    el.__dirtyPath = false;
	    var pathStr = pathDataToString(path);
	
	    if (pathStr.indexOf('NaN') < 0) {
	      // Ignore illegal path, which may happen such in out-of-range
	      // data in Calendar series.
	      attr(svgEl, 'd', pathStr);
	    }
	  }
	
	  bindStyle(svgEl, style, false, el);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  }
	};
	/***************************************************
	 * IMAGE
	 **************************************************/
	
	
	var svgImage = {};
	
	svgImage.brush = function (el) {
	  var style = el.style;
	  var image = style.image;
	
	  if (image instanceof HTMLImageElement) {
	    var src = image.src;
	    image = src;
	  }
	
	  if (!image) {
	    return;
	  }
	
	  var x = style.x || 0;
	  var y = style.y || 0;
	  var dw = style.width;
	  var dh = style.height;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('image');
	    el.__svgEl = svgEl;
	  }
	
	  if (image !== el.__imageSrc) {
	    attrXLink(svgEl, 'href', image); // Caching image src
	
	    el.__imageSrc = image;
	  }
	
	  attr(svgEl, 'width', dw);
	  attr(svgEl, 'height', dh);
	  attr(svgEl, 'x', x);
	  attr(svgEl, 'y', y);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  }
	};
	/***************************************************
	 * TEXT
	 **************************************************/
	
	
	var svgText = {};
	var tmpRect = new BoundingRect();
	
	var svgTextDrawRectText = function (el, rect, textRect) {
	  var style = el.style;
	  el.__dirty && textHelper.normalizeTextStyle(style, true);
	  var text = style.text; // Convert to string
	
	  if (text == null) {
	    // Draw no text only when text is set to null, but not ''
	    return;
	  } else {
	    text += '';
	  }
	
	  var textSvgEl = el.__textSvgEl;
	
	  if (!textSvgEl) {
	    textSvgEl = createElement('text');
	    el.__textSvgEl = textSvgEl;
	  }
	
	  var x;
	  var y;
	  var textPosition = style.textPosition;
	  var distance = style.textDistance;
	  var align = style.textAlign || 'left';
	
	  if (typeof style.fontSize === 'number') {
	    style.fontSize += 'px';
	  }
	
	  var font = style.font || [style.fontStyle || '', style.fontWeight || '', style.fontSize || '', style.fontFamily || ''].join(' ') || textContain.DEFAULT_FONT;
	  var verticalAlign = getVerticalAlignForSvg(style.textVerticalAlign);
	  textRect = textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight);
	  var lineHeight = textRect.lineHeight; // Text position represented by coord
	
	  if (textPosition instanceof Array) {
	    x = rect.x + textPosition[0];
	    y = rect.y + textPosition[1];
	  } else {
	    var newPos = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
	    x = newPos.x;
	    y = newPos.y;
	    verticalAlign = getVerticalAlignForSvg(newPos.textVerticalAlign);
	    align = newPos.textAlign;
	  }
	
	  attr(textSvgEl, 'alignment-baseline', verticalAlign);
	
	  if (font) {
	    textSvgEl.style.font = font;
	  }
	
	  var textPadding = style.textPadding; // Make baseline top
	
	  attr(textSvgEl, 'x', x);
	  attr(textSvgEl, 'y', y);
	  bindStyle(textSvgEl, style, true, el);
	
	  if (el instanceof Text || el.style.transformText) {
	    // Transform text with element
	    setTransform(textSvgEl, el.transform);
	  } else {
	    if (el.transform) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(el.transform);
	      rect = tmpRect;
	    } else {
	      var pos = el.transformCoordToGlobal(rect.x, rect.y);
	      rect.x = pos[0];
	      rect.y = pos[1];
	      el.transform = matrix.identity(matrix.create());
	    } // Text rotation, but no element transform
	
	
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = textRect.width / 2 + x;
	      y = textRect.height / 2 + y;
	    } else if (origin) {
	      x = origin[0] + x;
	      y = origin[1] + y;
	    }
	
	    var rotate = -style.textRotation || 0;
	    var transform = matrix.create(); // Apply textRotate to element matrix
	
	    matrix.rotate(transform, transform, rotate);
	    var pos = [el.transform[4], el.transform[5]];
	    matrix.translate(transform, transform, pos);
	    setTransform(textSvgEl, transform);
	  }
	
	  var textLines = text.split('\n');
	  var nTextLines = textLines.length;
	  var textAnchor = align; // PENDING
	
	  if (textAnchor === 'left') {
	    textAnchor = 'start';
	    textPadding && (x += textPadding[3]);
	  } else if (textAnchor === 'right') {
	    textAnchor = 'end';
	    textPadding && (x -= textPadding[1]);
	  } else if (textAnchor === 'center') {
	    textAnchor = 'middle';
	    textPadding && (x += (textPadding[3] - textPadding[1]) / 2);
	  }
	
	  var dy = 0;
	
	  if (verticalAlign === 'after-edge') {
	    dy = -textRect.height + lineHeight;
	    textPadding && (dy -= textPadding[2]);
	  } else if (verticalAlign === 'middle') {
	    dy = (-textRect.height + lineHeight) / 2;
	    textPadding && (y += (textPadding[0] - textPadding[2]) / 2);
	  } else {
	    textPadding && (dy += textPadding[0]);
	  } // Font may affect position of each tspan elements
	
	
	  if (el.__text !== text || el.__textFont !== font) {
	    var tspanList = el.__tspanList || [];
	    el.__tspanList = tspanList;
	
	    for (var i = 0; i < nTextLines; i++) {
	      // Using cached tspan elements
	      var tspan = tspanList[i];
	
	      if (!tspan) {
	        tspan = tspanList[i] = createElement('tspan');
	        textSvgEl.appendChild(tspan);
	        attr(tspan, 'alignment-baseline', verticalAlign);
	        attr(tspan, 'text-anchor', textAnchor);
	      } else {
	        tspan.innerHTML = '';
	      }
	
	      attr(tspan, 'x', x);
	      attr(tspan, 'y', y + i * lineHeight + dy);
	      tspan.appendChild(document.createTextNode(textLines[i]));
	    } // Remove unsed tspan elements
	
	
	    for (; i < tspanList.length; i++) {
	      textSvgEl.removeChild(tspanList[i]);
	    }
	
	    tspanList.length = nTextLines;
	    el.__text = text;
	    el.__textFont = font;
	  } else if (el.__tspanList.length) {
	    // Update span x and y
	    var len = el.__tspanList.length;
	
	    for (var i = 0; i < len; ++i) {
	      var tspan = el.__tspanList[i];
	
	      if (tspan) {
	        attr(tspan, 'x', x);
	        attr(tspan, 'y', y + i * lineHeight + dy);
	      }
	    }
	  }
	};
	
	function getVerticalAlignForSvg(verticalAlign) {
	  if (verticalAlign === 'middle') {
	    return 'middle';
	  } else if (verticalAlign === 'bottom') {
	    return 'after-edge';
	  } else {
	    return 'hanging';
	  }
	}
	
	svgText.drawRectText = svgTextDrawRectText;
	
	svgText.brush = function (el) {
	  var style = el.style;
	
	  if (style.text != null) {
	    // 强制设置 textPosition
	    style.textPosition = [0, 0];
	    svgTextDrawRectText(el, {
	      x: style.x || 0,
	      y: style.y || 0,
	      width: 0,
	      height: 0
	    }, el.getBoundingRect());
	  }
	};
	
	exports.path = svgPath;
	exports.image = svgImage;
	exports.text = svgText;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	var svgURI = 'http://www.w3.org/2000/svg';
	
	function createElement(name) {
	  return document.createElementNS(svgURI, name);
	}
	
	exports.createElement = createElement;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(612);
	
	var createElement = _core.createElement;
	
	var util = __webpack_require__(134);
	
	var zrLog = __webpack_require__(152);
	
	var Path = __webpack_require__(182);
	
	var ZImage = __webpack_require__(163);
	
	var ZText = __webpack_require__(194);
	
	var arrayDiff = __webpack_require__(614);
	
	var GradientManager = __webpack_require__(615);
	
	var ClippathManager = __webpack_require__(617);
	
	var ShadowManager = __webpack_require__(618);
	
	var _graphic = __webpack_require__(611);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * SVG Painter
	 * @module zrender/svg/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function getSvgProxy(el) {
	  if (el instanceof Path) {
	    return svgPath;
	  } else if (el instanceof ZImage) {
	    return svgImage;
	  } else if (el instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	}
	
	function checkParentAvailable(parent, child) {
	  return child && parent && child.parentNode !== parent;
	}
	
	function insertAfter(parent, child, prevSibling) {
	  if (checkParentAvailable(parent, child) && prevSibling) {
	    var nextSibling = prevSibling.nextSibling;
	    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
	  }
	}
	
	function prepend(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    var firstChild = parent.firstChild;
	    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
	  }
	}
	
	function append(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    parent.appendChild(child);
	  }
	}
	
	function remove(parent, child) {
	  if (child && parent && child.parentNode === parent) {
	    parent.removeChild(child);
	  }
	}
	
	function getTextSvgElement(displayable) {
	  return displayable.__textSvgEl;
	}
	
	function getSvgElement(displayable) {
	  return displayable.__svgEl;
	}
	/**
	 * @alias module:zrender/svg/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var SVGPainter = function (root, storage, opts, zrId) {
	  this.root = root;
	  this.storage = storage;
	  this._opts = opts = util.extend({}, opts || {});
	  var svgRoot = createElement('svg');
	  svgRoot.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	  svgRoot.setAttribute('version', '1.1');
	  svgRoot.setAttribute('baseProfile', 'full');
	  svgRoot.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
	  this.gradientManager = new GradientManager(zrId, svgRoot);
	  this.clipPathManager = new ClippathManager(zrId, svgRoot);
	  this.shadowManager = new ShadowManager(zrId, svgRoot);
	  var viewport = document.createElement('div');
	  viewport.style.cssText = 'overflow:hidden;position:relative';
	  this._svgRoot = svgRoot;
	  this._viewport = viewport;
	  root.appendChild(viewport);
	  viewport.appendChild(svgRoot);
	  this.resize(opts.width, opts.height);
	  this._visibleList = [];
	};
	
	SVGPainter.prototype = {
	  constructor: SVGPainter,
	  getType: function () {
	    return 'svg';
	  },
	  getViewportRoot: function () {
	    return this._viewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	  refresh: function () {
	    var list = this.storage.getDisplayList(true);
	
	    this._paintList(list);
	  },
	  setBackgroundColor: function (backgroundColor) {
	    // TODO gradient
	    this._viewport.style.background = backgroundColor;
	  },
	  _paintList: function (list) {
	    this.gradientManager.markAllUnused();
	    this.clipPathManager.markAllUnused();
	    this.shadowManager.markAllUnused();
	    var svgRoot = this._svgRoot;
	    var visibleList = this._visibleList;
	    var listLen = list.length;
	    var newVisibleList = [];
	    var i;
	
	    for (i = 0; i < listLen; i++) {
	      var displayable = list[i];
	      var svgProxy = getSvgProxy(displayable);
	      var svgElement = getSvgElement(displayable) || getTextSvgElement(displayable);
	
	      if (!displayable.invisible) {
	        if (displayable.__dirty) {
	          svgProxy && svgProxy.brush(displayable); // Update clipPath
	
	          this.clipPathManager.update(displayable); // Update gradient and shadow
	
	          if (displayable.style) {
	            this.gradientManager.update(displayable.style.fill);
	            this.gradientManager.update(displayable.style.stroke);
	            this.shadowManager.update(svgElement, displayable);
	          }
	
	          displayable.__dirty = false;
	        }
	
	        newVisibleList.push(displayable);
	      }
	    }
	
	    var diff = arrayDiff(visibleList, newVisibleList);
	    var prevSvgElement; // First do remove, in case element moved to the head and do remove
	    // after add
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = visibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          remove(svgRoot, svgElement);
	          remove(svgRoot, textSvgElement);
	        }
	      }
	    }
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.added) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);
	
	          if (svgElement) {
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          } else if (prevSvgElement) {
	            insertAfter(svgRoot, textSvgElement, prevSvgElement);
	          } else {
	            prepend(svgRoot, textSvgElement);
	          } // Insert text
	
	
	          insertAfter(svgRoot, textSvgElement, svgElement);
	          prevSvgElement = textSvgElement || svgElement || prevSvgElement;
	          this.gradientManager.addWithoutUpdate(svgElement, displayable);
	          this.shadowManager.addWithoutUpdate(prevSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      } else if (!item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          prevSvgElement = svgElement = getTextSvgElement(displayable) || getSvgElement(displayable) || prevSvgElement;
	          this.gradientManager.markUsed(displayable);
	          this.gradientManager.addWithoutUpdate(svgElement, displayable);
	          this.shadowManager.markUsed(displayable);
	          this.shadowManager.addWithoutUpdate(svgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      }
	    }
	
	    this.gradientManager.removeUnused();
	    this.clipPathManager.removeUnused();
	    this.shadowManager.removeUnused();
	    this._visibleList = newVisibleList;
	  },
	  _getDefs: function (isForceCreating) {
	    var svgRoot = this._svgRoot;
	
	    var defs = this._svgRoot.getElementsByTagName('defs');
	
	    if (defs.length === 0) {
	      // Not exist
	      if (isForceCreating) {
	        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
	        svgRoot.firstChild // Insert in the front of svg
	        );
	
	        if (!defs.contains) {
	          // IE doesn't support contains method
	          defs.contains = function (el) {
	            var children = defs.children;
	
	            if (!children) {
	              return false;
	            }
	
	            for (var i = children.length - 1; i >= 0; --i) {
	              if (children[i] === el) {
	                return true;
	              }
	            }
	
	            return false;
	          };
	        }
	
	        return defs;
	      } else {
	        return null;
	      }
	    } else {
	      return defs[0];
	    }
	  },
	  resize: function (width, height) {
	    var viewport = this._viewport; // FIXME Why ?
	
	    viewport.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    viewport.style.display = '';
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var viewportStyle = viewport.style;
	      viewportStyle.width = width + 'px';
	      viewportStyle.height = height + 'px';
	      var svgRoot = this._svgRoot; // Set width by 'svgRoot.width = width' is invalid
	
	      svgRoot.setAttribute('width', width);
	      svgRoot.setAttribute('height', height);
	    }
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._svgRoot = this._viewport = this.storage = null;
	  },
	  clear: function () {
	    if (this._viewport) {
	      this.root.removeChild(this._viewport);
	    }
	  },
	  pathToDataUrl: function () {
	    this.refresh();
	    var html = this._svgRoot.outerHTML;
	    return 'data:image/svg+xml;charset=UTF-8,' + html;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    zrLog('In SVG mode painter not support method "' + method + '"');
	  };
	} // Unsuppoted methods
	
	
	util.each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  SVGPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = SVGPainter;
	module.exports = _default;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	// Myers' Diff Algorithm
	// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
	function Diff() {}
	
	Diff.prototype = {
	  diff: function (oldArr, newArr, equals) {
	    if (!equals) {
	      equals = function (a, b) {
	        return a === b;
	      };
	    }
	
	    this.equals = equals;
	    var self = this;
	    oldArr = oldArr.slice();
	    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
	
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{
	      newPos: -1,
	      components: []
	    }]; // Seed editLength = 0, i.e. the content starts with the same values
	
	    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
	
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      var indices = [];
	
	      for (var i = 0; i < newArr.length; i++) {
	        indices.push(i);
	      } // Identity per the equality and tokenizer
	
	
	      return [{
	        indices: indices,
	        count: newArr.length
	      }];
	    } // Main worker method. checks all permutations of a given edit length for acceptance.
	
	
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath;
	        var addPath = bestPath[diagonalPath - 1];
	        var removePath = bestPath[diagonalPath + 1];
	        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen;
	        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
	
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        } // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	
	
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
	
	        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	          return buildValues(self, basePath.components, newArr, oldArr);
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    while (editLength <= maxEditLength) {
	      var ret = execEditLength();
	
	      if (ret) {
	        return ret;
	      }
	    }
	  },
	  pushComponent: function (components, added, removed) {
	    var last = components[components.length - 1];
	
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = {
	        count: last.count + 1,
	        added: added,
	        removed: removed
	      };
	    } else {
	      components.push({
	        count: 1,
	        added: added,
	        removed: removed
	      });
	    }
	  },
	  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var newPos = basePath.newPos;
	    var oldPos = newPos - diagonalPath;
	    var commonCount = 0;
	
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({
	        count: commonCount
	      });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  tokenize: function (value) {
	    return value.slice();
	  },
	  join: function (value) {
	    return value.slice();
	  }
	};
	
	function buildValues(diff, components, newArr, oldArr) {
	  var componentPos = 0;
	  var componentLen = components.length;
	  var newPos = 0;
	  var oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	
	    if (!component.removed) {
	      var indices = [];
	
	      for (var i = newPos; i < newPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      newPos += component.count; // Common case
	
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      var indices = [];
	
	      for (var i = oldPos; i < oldPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      oldPos += component.count;
	    }
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return {
	    newPos: path.newPos,
	    components: path.components.slice(0)
	  };
	}
	
	var arrayDiff = new Diff();
	
	function _default(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	
	module.exports = _default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(616);
	
	var zrUtil = __webpack_require__(134);
	
	var zrLog = __webpack_require__(152);
	
	var colorTool = __webpack_require__(150);
	
	/**
	 * @file Manages SVG gradient elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG gradient elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function GradientManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
	}
	
	zrUtil.inherits(GradientManager, Definable);
	/**
	 * Create new gradient DOM for fill or stroke if not exist,
	 * but will not update gradient if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && displayable.style) {
	    var that = this;
	    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
	      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
	        var gradient = displayable.style[fillOrStroke];
	        var defs = that.getDefs(true); // Create dom in <defs> if not exists
	
	        var dom;
	
	        if (gradient._dom) {
	          // Gradient exists
	          dom = gradient._dom;
	
	          if (!defs.contains(gradient._dom)) {
	            // _dom is no longer in defs, recreate
	            that.addDom(dom);
	          }
	        } else {
	          // New dom
	          dom = that.add(gradient);
	        }
	
	        that.markUsed(displayable);
	        var id = dom.getAttribute('id');
	        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
	      }
	    });
	  }
	};
	/**
	 * Add a new gradient tag in <defs>
	 *
	 * @param   {Gradient} gradient zr gradient instance
	 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
	 *                            created DOM
	 */
	
	
	GradientManager.prototype.add = function (gradient) {
	  var dom;
	
	  if (gradient.type === 'linear') {
	    dom = this.createElement('linearGradient');
	  } else if (gradient.type === 'radial') {
	    dom = this.createElement('radialGradient');
	  } else {
	    zrLog('Illegal gradient type.');
	    return null;
	  } // Set dom id with gradient id, since each gradient instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	
	  gradient.id = gradient.id || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
	  this.updateDom(gradient, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update gradient.
	 *
	 * @param {Gradient} gradient zr gradient instance
	 */
	
	
	GradientManager.prototype.update = function (gradient) {
	  var that = this;
	  Definable.prototype.update.call(this, gradient, function () {
	    var type = gradient.type;
	    var tagName = gradient._dom.tagName;
	
	    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
	      // Gradient type is not changed, update gradient
	      that.updateDom(gradient, gradient._dom);
	    } else {
	      // Remove and re-create if type is changed
	      that.removeDom(gradient);
	      that.add(gradient);
	    }
	  });
	};
	/**
	 * Update gradient dom
	 *
	 * @param {Gradient} gradient zr gradient instance
	 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
	 *                            DOM to update
	 */
	
	
	GradientManager.prototype.updateDom = function (gradient, dom) {
	  if (gradient.type === 'linear') {
	    dom.setAttribute('x1', gradient.x);
	    dom.setAttribute('y1', gradient.y);
	    dom.setAttribute('x2', gradient.x2);
	    dom.setAttribute('y2', gradient.y2);
	  } else if (gradient.type === 'radial') {
	    dom.setAttribute('cx', gradient.x);
	    dom.setAttribute('cy', gradient.y);
	    dom.setAttribute('r', gradient.r);
	  } else {
	    zrLog('Illegal gradient type.');
	    return;
	  }
	
	  if (gradient.global) {
	    // x1, x2, y1, y2 in range of 0 to canvas width or height
	    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
	  } else {
	    // x1, x2, y1, y2 in range of 0 to 1
	    dom.setAttribute('gradientUnits', 'objectBoundingBox');
	  } // Remove color stops if exists
	
	
	  dom.innerHTML = ''; // Add color stops
	
	  var colors = gradient.colorStops;
	
	  for (var i = 0, len = colors.length; i < len; ++i) {
	    var stop = this.createElement('stop');
	    stop.setAttribute('offset', colors[i].offset * 100 + '%');
	    var color = colors[i].color;
	
	    if (color.indexOf('rgba' > -1)) {
	      // Fix Safari bug that stop-color not recognizing alpha #9014
	      var opacity = colorTool.parse(color)[3];
	      var hex = colorTool.toHex(color); // stop-color cannot be color, since:
	      // The opacity value used for the gradient calculation is the
	      // *product* of the value of stop-opacity and the opacity of the
	      // value of stop-color.
	      // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty
	
	      stop.setAttribute('stop-color', '#' + hex);
	      stop.setAttribute('stop-opacity', opacity);
	    } else {
	      stop.setAttribute('stop-color', colors[i].color);
	    }
	
	    dom.appendChild(stop);
	  } // Store dom element in gradient, to avoid creating multiple
	  // dom instances for the same gradient element
	
	
	  gradient._dom = dom;
	};
	/**
	 * Mark a single gradient to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	GradientManager.prototype.markUsed = function (displayable) {
	  if (displayable.style) {
	    var gradient = displayable.style.fill;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	
	    gradient = displayable.style.stroke;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	  }
	};
	
	var _default = GradientManager;
	module.exports = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(612);
	
	var createElement = _core.createElement;
	
	var zrUtil = __webpack_require__(134);
	
	var Path = __webpack_require__(182);
	
	var ZImage = __webpack_require__(163);
	
	var ZText = __webpack_require__(194);
	
	var _graphic = __webpack_require__(611);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * @file Manages elements that can be defined in <defs> in SVG,
	 *       e.g., gradients, clip path, etc.
	 * @author Zhang Wenli
	 */
	var MARK_UNUSED = '0';
	var MARK_USED = '1';
	/**
	 * Manages elements that can be defined in <defs> in SVG,
	 * e.g., gradients, clip path, etc.
	 *
	 * @class
	 * @param {number}          zrId      zrender instance id
	 * @param {SVGElement}      svgRoot   root of SVG document
	 * @param {string|string[]} tagNames  possible tag names
	 * @param {string}          markLabel label name to make if the element
	 *                                    is used
	 */
	
	function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
	  this._zrId = zrId;
	  this._svgRoot = svgRoot;
	  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
	  this._markLabel = markLabel;
	  this._domName = domName || '_dom';
	  this.nextId = 0;
	}
	
	Definable.prototype.createElement = createElement;
	/**
	 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
	 *
	 * @param {boolean} isForceCreating if need to create when not exists
	 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
	 * exist and isForceCreating is false
	 */
	
	Definable.prototype.getDefs = function (isForceCreating) {
	  var svgRoot = this._svgRoot;
	
	  var defs = this._svgRoot.getElementsByTagName('defs');
	
	  if (defs.length === 0) {
	    // Not exist
	    if (isForceCreating) {
	      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
	      svgRoot.firstChild // Insert in the front of svg
	      );
	
	      if (!defs.contains) {
	        // IE doesn't support contains method
	        defs.contains = function (el) {
	          var children = defs.children;
	
	          if (!children) {
	            return false;
	          }
	
	          for (var i = children.length - 1; i >= 0; --i) {
	            if (children[i] === el) {
	              return true;
	            }
	          }
	
	          return false;
	        };
	      }
	
	      return defs;
	    } else {
	      return null;
	    }
	  } else {
	    return defs[0];
	  }
	};
	/**
	 * Update DOM element if necessary.
	 *
	 * @param {Object|string} element style element. e.g., for gradient,
	 *                                it may be '#ccc' or {type: 'linear', ...}
	 * @param {Function|undefined} onUpdate update callback
	 */
	
	
	Definable.prototype.update = function (element, onUpdate) {
	  if (!element) {
	    return;
	  }
	
	  var defs = this.getDefs(false);
	
	  if (element[this._domName] && defs.contains(element[this._domName])) {
	    // Update DOM
	    if (typeof onUpdate === 'function') {
	      onUpdate(element);
	    }
	  } else {
	    // No previous dom, create new
	    var dom = this.add(element);
	
	    if (dom) {
	      element[this._domName] = dom;
	    }
	  }
	};
	/**
	 * Add gradient dom to defs
	 *
	 * @param {SVGElement} dom DOM to be added to <defs>
	 */
	
	
	Definable.prototype.addDom = function (dom) {
	  var defs = this.getDefs(true);
	  defs.appendChild(dom);
	};
	/**
	 * Remove DOM of a given element.
	 *
	 * @param {SVGElement} element element to remove dom
	 */
	
	
	Definable.prototype.removeDom = function (element) {
	  var defs = this.getDefs(false);
	
	  if (defs && element[this._domName]) {
	    defs.removeChild(element[this._domName]);
	    element[this._domName] = null;
	  }
	};
	/**
	 * Get DOMs of this element.
	 *
	 * @return {HTMLDomElement} doms of this defineable elements in <defs>
	 */
	
	
	Definable.prototype.getDoms = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // No dom when defs is not defined
	    return [];
	  }
	
	  var doms = [];
	  zrUtil.each(this._tagNames, function (tagName) {
	    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
	    // rather than real array.
	    // So `doms.concat(tags)` add tags as one object.
	
	    doms = doms.concat([].slice.call(tags));
	  });
	  return doms;
	};
	/**
	 * Mark DOMs to be unused before painting, and clear unused ones at the end
	 * of the painting.
	 */
	
	
	Definable.prototype.markAllUnused = function () {
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    dom[that._markLabel] = MARK_UNUSED;
	  });
	};
	/**
	 * Mark a single DOM to be used.
	 *
	 * @param {SVGElement} dom DOM to mark
	 */
	
	
	Definable.prototype.markUsed = function (dom) {
	  if (dom) {
	    dom[this._markLabel] = MARK_USED;
	  }
	};
	/**
	 * Remove unused DOMs defined in <defs>
	 */
	
	
	Definable.prototype.removeUnused = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // Nothing to remove
	    return;
	  }
	
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    if (dom[that._markLabel] !== MARK_USED) {
	      // Remove gradient
	      defs.removeChild(dom);
	    }
	  });
	};
	/**
	 * Get SVG proxy.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {Path|Image|Text} svg proxy of given element
	 */
	
	
	Definable.prototype.getSvgProxy = function (displayable) {
	  if (displayable instanceof Path) {
	    return svgPath;
	  } else if (displayable instanceof ZImage) {
	    return svgImage;
	  } else if (displayable instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	};
	/**
	 * Get text SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element of text
	 */
	
	
	Definable.prototype.getTextSvgElement = function (displayable) {
	  return displayable.__textSvgEl;
	};
	/**
	 * Get SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element
	 */
	
	
	Definable.prototype.getSvgElement = function (displayable) {
	  return displayable.__svgEl;
	};
	
	var _default = Definable;
	module.exports = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(616);
	
	var zrUtil = __webpack_require__(134);
	
	var matrix = __webpack_require__(145);
	
	/**
	 * @file Manages SVG clipPath elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG clipPath elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ClippathManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__');
	}
	
	zrUtil.inherits(ClippathManager, Definable);
	/**
	 * Update clipPath.
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	ClippathManager.prototype.update = function (displayable) {
	  var svgEl = this.getSvgElement(displayable);
	
	  if (svgEl) {
	    this.updateDom(svgEl, displayable.__clipPaths, false);
	  }
	
	  var textEl = this.getTextSvgElement(displayable);
	
	  if (textEl) {
	    // Make another clipPath for text, since it's transform
	    // matrix is not the same with svgElement
	    this.updateDom(textEl, displayable.__clipPaths, true);
	  }
	
	  this.markUsed(displayable);
	};
	/**
	 * Create an SVGElement of displayable and create a <clipPath> of its
	 * clipPath
	 *
	 * @param {Displayable} parentEl  parent element
	 * @param {ClipPath[]}  clipPaths clipPaths of parent element
	 * @param {boolean}     isText    if parent element is Text
	 */
	
	
	ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
	  if (clipPaths && clipPaths.length > 0) {
	    // Has clipPath, create <clipPath> with the first clipPath
	    var defs = this.getDefs(true);
	    var clipPath = clipPaths[0];
	    var clipPathEl;
	    var id;
	    var dom = isText ? '_textDom' : '_dom';
	
	    if (clipPath[dom]) {
	      // Use a dom that is already in <defs>
	      id = clipPath[dom].getAttribute('id');
	      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
	
	      if (!defs.contains(clipPathEl)) {
	        // This happens when set old clipPath that has
	        // been previously removed
	        defs.appendChild(clipPathEl);
	      }
	    } else {
	      // New <clipPath>
	      id = 'zr' + this._zrId + '-clip-' + this.nextId;
	      ++this.nextId;
	      clipPathEl = this.createElement('clipPath');
	      clipPathEl.setAttribute('id', id);
	      defs.appendChild(clipPathEl);
	      clipPath[dom] = clipPathEl;
	    } // Build path and add to <clipPath>
	
	
	    var svgProxy = this.getSvgProxy(clipPath);
	
	    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
	      /**
	       * If a clipPath has a parent with transform, the transform
	       * of parent should not be considered when setting transform
	       * of clipPath. So we need to transform back from parent's
	       * transform, which is done by multiplying parent's inverse
	       * transform.
	       */
	      // Store old transform
	      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
	
	      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
	      svgProxy.brush(clipPath); // Set back transform of clipPath
	
	      clipPath.transform = transform;
	    } else {
	      svgProxy.brush(clipPath);
	    }
	
	    var pathEl = this.getSvgElement(clipPath);
	    clipPathEl.innerHTML = '';
	    /**
	     * Use `cloneNode()` here to appendChild to multiple parents,
	     * which may happend when Text and other shapes are using the same
	     * clipPath. Since Text will create an extra clipPath DOM due to
	     * different transform rules.
	     */
	
	    clipPathEl.appendChild(pathEl.cloneNode());
	    parentEl.setAttribute('clip-path', 'url(#' + id + ')');
	
	    if (clipPaths.length > 1) {
	      // Make the other clipPaths recursively
	      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
	    }
	  } else {
	    // No clipPath
	    if (parentEl) {
	      parentEl.setAttribute('clip-path', 'none');
	    }
	  }
	};
	/**
	 * Mark a single clipPath to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ClippathManager.prototype.markUsed = function (displayable) {
	  var that = this;
	
	  if (displayable.__clipPaths && displayable.__clipPaths.length > 0) {
	    zrUtil.each(displayable.__clipPaths, function (clipPath) {
	      if (clipPath._dom) {
	        Definable.prototype.markUsed.call(that, clipPath._dom);
	      }
	
	      if (clipPath._textDom) {
	        Definable.prototype.markUsed.call(that, clipPath._textDom);
	      }
	    });
	  }
	};
	
	var _default = ClippathManager;
	module.exports = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(616);
	
	var zrUtil = __webpack_require__(134);
	
	/**
	 * @file Manages SVG shadow elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG shadow elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ShadowManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['filter'], '__filter_in_use__', '_shadowDom');
	}
	
	zrUtil.inherits(ShadowManager, Definable);
	/**
	 * Create new shadow DOM for fill or stroke if not exist,
	 * but will not update shadow if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	ShadowManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && hasShadow(displayable.style)) {
	    var style = displayable.style; // Create dom in <defs> if not exists
	
	    var dom;
	
	    if (style._shadowDom) {
	      // Gradient exists
	      dom = style._shadowDom;
	      var defs = this.getDefs(true);
	
	      if (!defs.contains(style._shadowDom)) {
	        // _shadowDom is no longer in defs, recreate
	        this.addDom(dom);
	      }
	    } else {
	      // New dom
	      dom = this.add(displayable);
	    }
	
	    this.markUsed(displayable);
	    var id = dom.getAttribute('id');
	    svgElement.style.filter = 'url(#' + id + ')';
	  }
	};
	/**
	 * Add a new shadow tag in <defs>
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @return {SVGFilterElement} created DOM
	 */
	
	
	ShadowManager.prototype.add = function (displayable) {
	  var dom = this.createElement('filter');
	  var style = displayable.style; // Set dom id with shadow id, since each shadow instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	  style._shadowDomId = style._shadowDomId || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + style._shadowDomId);
	  this.updateDom(displayable, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update shadow.
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	
	ShadowManager.prototype.update = function (svgElement, displayable) {
	  var style = displayable.style;
	
	  if (hasShadow(style)) {
	    var that = this;
	    Definable.prototype.update.call(this, displayable, function (style) {
	      that.updateDom(displayable, style._shadowDom);
	    });
	  } else {
	    // Remove shadow
	    this.remove(svgElement, style);
	  }
	};
	/**
	 * Remove DOM and clear parent filter
	 */
	
	
	ShadowManager.prototype.remove = function (svgElement, style) {
	  if (style._shadowDomId != null) {
	    this.removeDom(style);
	    svgElement.style.filter = '';
	  }
	};
	/**
	 * Update shadow dom
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @param {SVGFilterElement} dom DOM to update
	 */
	
	
	ShadowManager.prototype.updateDom = function (displayable, dom) {
	  var domChild = dom.getElementsByTagName('feDropShadow');
	
	  if (domChild.length === 0) {
	    domChild = this.createElement('feDropShadow');
	  } else {
	    domChild = domChild[0];
	  }
	
	  var style = displayable.style;
	  var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
	  var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet
	
	  var offsetX, offsetY, blur, color;
	
	  if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
	    offsetX = style.shadowOffsetX || 0;
	    offsetY = style.shadowOffsetY || 0;
	    blur = style.shadowBlur;
	    color = style.shadowColor;
	  } else if (style.textShadowBlur) {
	    offsetX = style.textShadowOffsetX || 0;
	    offsetY = style.textShadowOffsetY || 0;
	    blur = style.textShadowBlur;
	    color = style.textShadowColor;
	  } else {
	    // Remove shadow
	    this.removeDom(dom, style);
	    return;
	  }
	
	  domChild.setAttribute('dx', offsetX / scaleX);
	  domChild.setAttribute('dy', offsetY / scaleY);
	  domChild.setAttribute('flood-color', color); // Divide by two here so that it looks the same as in canvas
	  // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
	
	  var stdDx = blur / 2 / scaleX;
	  var stdDy = blur / 2 / scaleY;
	  var stdDeviation = stdDx + ' ' + stdDy;
	  domChild.setAttribute('stdDeviation', stdDeviation); // Fix filter clipping problem
	
	  dom.setAttribute('x', '-100%');
	  dom.setAttribute('y', '-100%');
	  dom.setAttribute('width', Math.ceil(blur / 2 * 200) + '%');
	  dom.setAttribute('height', Math.ceil(blur / 2 * 200) + '%');
	  dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
	  // dom instances for the same shadow element
	
	  style._shadowDom = dom;
	};
	/**
	 * Mark a single shadow to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ShadowManager.prototype.markUsed = function (displayable) {
	  var style = displayable.style;
	
	  if (style && style._shadowDom) {
	    Definable.prototype.markUsed.call(this, style._shadowDom);
	  }
	};
	
	function hasShadow(style) {
	  // TODO: textBoxShadowBlur is not supported yet
	  return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
	}
	
	var _default = ShadowManager;
	module.exports = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid resultado\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <formulario ng-if=\"vm.showFormulario\" encuesta=\"vm.encuesta\"></formulario>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 text-center\">\n      <div id=\"resultados\">\n        <h2 ng-show='!vm.general'>Resultados <b><i>individuales</i></b><br> por categoría</h2>\n        <h2 ng-show='vm.general'>Resultados <b><i>generales</i></b><br> por categoría</h2>\n      </div>\n    </div>\n  </div>\n  \n  <div class=\"row\">\n    <div class=\"col-md-12 chart\">\n      <div id=\"bar\" style=\"width: 100%; min-height:250px;\"></div>\n    </div>\n  </div>\n  \n  <div class=\"row\" ng-show=\"vm.resultIndiv\">\n    <div class=\"text-center switch-mode\">\n      <div class=\"btn-group\">\n        <button type=\"button\" class=\"btn btn-tipo-resultados\">\n          <img class=\"message-tail-info\" src=\"assets/images/message-tail-info-bottom-left.svg\">\n          <span ng-show='!vm.general' ng-click=\"vm.goToResulGen()\">Ver resultados <b><i>generales</i></b></span>\n          <span ng-show='vm.general && vm.resultIndiv !== null' ng-click=\"vm.goToResulInd()\">Ver resultados <b><i>individuales</i></b></span>\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 text-center bg-sabias-que\">\n      <div class=\"btn-group\">\n        <button type=\"button\" class=\"btn btn-sabias-que\" scroll-to=\"#sabias-que\">\n          <img class=\"icon-star\" src=\"assets/images/icon-star.svg\">\n          ¿Sabías que?\n          <img class=\"message-tail-danger\" src=\"assets/images/message-tail-danger-bottom-right.svg\">\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"container\">\n  <div class=\"row\" id=\"sabias-que\">\n    <div class=\"col-md-12 col-sm-12\">\n      <h3 class=\"text-center\">Información legal</h3>\n\n      <div class=\"well well-default\">\n        <b>\n          La ley 5777/16 Protección Integral a las Mujeres contra toda forma de violencia, cuenta con un apartado\n          legal en el artículo 6. inc L que reconoce el Acoso en Internet como forma de violencia.\n        </b>\n        <p>\n          “Violencia telemática: Es la acción por medio de la cual difunden o publican mensajes, fotografías, audios, videos u\n          otros que afecten la dignidad o intimidad de las mujeres a través de las actuales tecnologías de información y\n          comunicación, incluido el uso de estos medios para promover la cosificación, sumisión o explotación de la mujer”\n        </p>\n      </div>\n\n      <uib-accordion close-others=\"true\">\n        <div uib-accordion-group\n          id=\"vigilancia\"\n          heading=\"Vigilancia\"\n          is-open=\"vm.openAccordion.vigilancia\"\n          class=\"panel-danger\">\n          <div ng-include=\"'accordion-vigilancia.html'\"></div>\n        </div>\n        <div uib-accordion-group\n          id=\"discurso-de-odio\"\n          heading=\"Discurso de odio\"\n          is-open=\"vm.openAccordion.discurso_de_odio\"\n          class=\"panel-warning\">\n          <div ng-include=\"'accordion-discurso-de-odio.html'\"></div>\n        </div>\n        <div uib-accordion-group\n          id=\"acoso\"\n          heading=\"Acoso\"\n          is-open=\"vm.openAccordion.acoso\"\n          class=\"panel-success\">\n          <div ng-include=\"'accordion-acoso.html'\"></div>\n        </div>\n      </uib-accordion>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-md-12 col-sm-12\">\n      <h3 class=\"text-center\">Organizaciones e iniciativas de Sociedad Civil</h3>\n\n      <uib-accordion close-others=\"true\">\n        <div uib-accordion-group\n          id=\"plataformas\"\n          heading=\"Plataformas\"\n          is-open=\"vm.openAccordion.plataformas\"\n          class=\"panel-default\">\n          <div ng-include=\"'accordion-plataformas.html'\"></div>\n        </div>\n        <div uib-accordion-group\n          id=\"organizaciones\"\n          heading=\"Organizaciones\"\n          is-open=\"vm.openAccordion.organizaciones\"\n          class=\"panel-default\">\n          <div ng-include=\"'accordion-organizaciones.html'\"></div>\n        </div>\n        <div uib-accordion-group\n          id=\"iniciativas-estatales\"\n          heading=\"Iniciativas estatales\"\n          is-open=\"vm.openAccordion.iniciativas_estatales\"\n          class=\"panel-default\">\n          <div ng-include=\"'accordion-iniciativas-estatales.html'\"></div>\n        </div>\n      </uib-accordion>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = "<p><b>El monitoreo constante de las actividades de la persona, su vida diaria, o información, sea\n    pública o privada, pertinente a la persona o a la organización.</b></p>\n<p><u>Acceso y control, manejo no autorizado de cuentaso dispositivos:</u> Ataques no autorizados para ganar acceso a\n    las cuentas o dispositivos de otros. Esto puede implicar que información no autorizada se junte, y/o el bloqueo de\n    acceso a la cuenta a la persona dueña de la cuenta misma. </p>\n<p><u>Doxeo:</u> Investigar y difundir información identificable sobre una persona sin su consentimiento, muchas veces\n    con la intención de tener acceso o contacto con la persona con fines de acoso u otros fines nocivos. </p>\n<p><u>Uso de spyware:</u> Software para espiar y obtener información de otros dispositivos o acceso a cuentas sin el\n    consentimiento del usuario. </p>\n\n    \n<uib-accordion close-others=\"false\">\n    <div uib-accordion-group\n        heading=\"¿Alguna vez te pasó que trataste de entrar a tus cuentas y alguien (no sabemos quién) cambió las credenciales y perdiste el acceso a tu identidad digital?\"\n        ng-class=\"vm.getPreguntaClass(4, 'panel-danger')\">\n        <p>El derecho a la intimidad se encuentra expresamente en nuestra Constitución Nacional en su artículo 33, además de ser consagrado como un derecho humano por la Declaración Universal de los Derechos Humanos en su artículo 12 y por el Pacto Internacional de los derechos civiles y políticos en su artículo 17. El derecho a la vida privada es el derecho que tenés a decidir y controlar cuándo y quién accede a diferentes aspectos de tu vida particular. Es tu potestad de excluir a terceros el conocimiento de tu vida privada, es decir, sentimientos, comportamientos e información sensible y que no sea considerado interés público.</p>\n        <p>En caso que puedas identificar a la persona que realizó esta acción, puedes analizar presentar una acción penal remitiendote en el siguiente artículo considerado “De los delitos informáticos” que son: Artículo 146 b.-Acceso indebido a datos y Artículo 174 b.-Acceso indebido a sistemas, ambos se refieren a acceso indebidos de bienes tecnológicos e identidades (datos personales) sin tu consentimiento. Con pena privativa de libertad de hasta tres años o multa. </p>\n        <p>También se encuentra la instancia Civil para la indemnización por daños y perjuicios que se enmarcar en el artículo 1835 del Código Civil paraguayo. Esto se aplica a los casos que existieron daño causado en perjuicio a tu persona, a tus derechos o facultades o cosas de dominio o posesión.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada.</p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Alguna vez tu pareja te ha solicitado alguna contraseña tuya para tener acceso a tus dispositivos o cuentas?\"\n        ng-class=\"vm.getPreguntaClass(5, 'panel-danger')\">\n        <p>El derecho a la intimidad se encuentra expresamente en nuestra Constitución Nacional en su artículo 33, además de ser consagrado como un derecho humano por la Declaración Universal de los Derechos Humanos en su artículo 12 y por el Pacto Internacional de los derechos civiles y políticos en su artículo 17. El derecho a la vida privada es el derecho que tenés a decidir y controlar cuándo y quién accede a diferentes aspectos de tu vida particular. Es tu potestad de excluir a terceros el conocimiento de tu vida privada, es decir, sentimientos, comportamientos e información sensible y que no sea considerado interés público.</p>\n        <p>En el caso que te hayas sentido presionado/a por otra persona, mediante violencia ilegítima a adoptar un determinado comportamiento en Internet en contra de tu voluntad o a impedirte con violencia a realizar un acto en Internet que la ley no prohíbe. El Código penal paraguayo sanciona en su artículo 120 todo tipo de coacción y el artículo 121 de coacción grave, que ponga en peligro tu vida o integridad física. </p>\n        <p>Si alguna vez te amenazaron de un hecho punible que afecta a tu vida en Internet o integridad física u otra cosa de valor considerable, el Código Penal prevé en su artículo 122 de Amenaza, una sanción a este tipo de conducta con pena privativa de libertad de hasta un año o con multa.</p>\n        <p>Si tenés prueba que una persona escucha, graba, almacena o comparte con otras personas el acceso de tus comunicaciones en Internet e imágenes sin tu consentimiento en cualquier soporte digital o impreso. El artículo 144 sobre “Lesión del derecho a la comunicación y a la imagen” del Código Penal paraguayo sanciona esta conducta con el castigo es con pena privativa de libertad de hasta dos años o con multa. </p>\n        <p>Y si conocés a la persona que accedió a tus datos digitales o a tus sistemas informáticos sin tu consentimiento, el Código Penal tipifica estos hechos antijurídicos, denominados delitos informáticos que son artículo 146 b.- Acceso indebido a datos y artículo 174 b.-Acceso indebido a sistemas; ambos se refieren a acceso indebidos de bienes tecnológicos e identidades (datos personales) sin tu consentimiento. Estas conductas sancionan con pena privativa de libertad de hasta tres años o multa.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada.         </p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Alguna vez te han pedido una foto o prueba sobre lo que estás haciendo o donde estás? Por ejemplo: Tu pareja te pide una selfie para ver cómo andás o no te cree que estás dormidx en tu casa.\"\n        ng-class=\"vm.getPreguntaClass(6, 'panel-danger')\">\n        <p>El derecho a la intimidad se encuentra expresamente en nuestra Constitución Nacional en su artículo 33, además de ser consagrado como un derecho humano por la Declaración Universal de los Derechos Humanos en su artículo 12 y por el Pacto Internacional de los derechos civiles y políticos en su artículo 17. El derecho a la vida privada es el derecho que tenés a decidir y controlar cuándo y quién accede a diferentes aspectos de tu vida particular. Es tu potestad de excluir a terceros el conocimiento de tu vida privada, es decir, sentimientos, comportamientos e información sensible y que no sea considerado interés público.</p>\n        <p>En el caso que te hayas sentido presionado/a por otra persona, mediante violencia ilegítima a adoptar un determinado comportamiento en Internet en contra de tu voluntad o a impedirte con violencia a realizar un acto en Internet que la ley no prohíbe. El Código penal paraguayo sanciona en su artículo 120 todo tipo de coacción y el artículo 121 de coacción grave, que ponga en peligro tu vida o integridad física. </p>\n        <p>Si alguna vez te amenazaron de un hecho punible que afecta a tu vida en Internet o integridad física u otra cosa de valor considerable, el Código Penal prevé en su artículo 122 de Amenaza, una sanción a este tipo de conducta con pena privativa de libertad de hasta un año o con multa.</p>\n        <p>Para los caso que te hayas sentido forzado/a por otra persona a realizar un acto contra tu voluntad a través de amenazas o intimidación para evitar que tu información sea compartida por otros, el Código Penal sanciona este tipo de conducta en su artículo 185 denominado Extorsión. </p>\n        <p>El artículo 144 sobre “Lesión del derecho a la comunicación y a la imagen” del Código Penal paraguayo sanciona esta conducta siempre y cuando escuchara, grabara o almacenara o facilitara a terceros el acceso a la comunicación e imagen sin consentimiento. El castigo es con pena privativa de libertad de hasta dos años o con multa. </p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada.</p>\n    </div>\n</uib-accordion>"

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = "<p><b>Discurso que refleja modelos culturales que incitan violencia, ya sea a través de\n    comentarios, insultos, o agresiones verbales.</b></p>\n<p><u>Amenazas:</u> Discurso y contenido (verbal o escrito, en imágenes, etc) con un tono agresivo y/o amenazador.\n    Amenazas directas de violencia de cualquier índole.</p>\n<p><u>Robo de identidad:</u> es un medio para la extorsión o el ciberbullying </p>\n\n\n<uib-accordion close-others=\"false\">\n    <div uib-accordion-group\n        heading=\"¿Alguna vez te has abstenido de publicar algo en tus redes por miedo a que te amenacen, te intimiden o te hagan sentir simplemente mal por tu forma de pensar?\"\n        ng-class=\"vm.getPreguntaClass(3, 'panel-warning')\">\n        <p>El derecho a la libertad de expresión se encuentra en nuestra Constitución Nacional en su artículo 26, además de consagrado como derechos humanos en el artículo 19 de la Declaración de los Derechos Humanos y del Pacto Internacional de los Derechos Civiles y Políticos , por el cual tiene como fin la protección de la persona para expresar y articular sus opiniones e ideas sin temor a represalias, censura o sanción. La autocensura es una forma de limitar el ejercicio pleno del derecho a la libertad de expresión.</p>\n        <p>Si alguna vez te amenazaron de un hecho punible que afecta a tu vida en Internet o integridad física u otra cosa de valor considerable, el Código Penal prevé en su artículo 122 de Amenaza, una sanción a este tipo de conducta con pena privativa de libertad de hasta un año o con multa.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada.</p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Se llegó a divulgar información manipulada o falsa sobre tu persona en las redes, como fotos, mensajes de texto, etc?\"\n        ng-class=\"vm.getPreguntaClass(8, 'panel-warning')\">\n        <p>El artículo 144 sobre “Lesión del derecho a la comunicación y a la imagen” del Código Penal paraguayo sanciona esta conducta siempre y cuando escuchara, grabara o almacenara o facilitara a terceros el acceso a la comunicación e imagen sin consentimiento. El castigo es con pena privativa de libertad de hasta dos años o con multa. </p>\n        <p>También el Código Penal Paraguayo sanciona en su capítulo VIII de Hechos punibles contra el honor y la reputación, todo lo referente a Calumnias, difamación e injurias.</p>\n        <p>También se encuentra la instancia Civil para la indemnización por daños y perjuicios que se enmarcar en el artículo 1835 del Código Civil paraguayo. Esto se aplica a los casos que existieron daño causado en perjuicio a otra persona, en sus derechos o facultades o cosas de dominio o posesión.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada.</p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Algún compañerx de trabajo, jefe, profesor o pariente, te manda textos, vídeos o audios con mensajes 'subidos de tono'? Por ejemplo: 'Qué linda pollera andás hoy', 'Mirá cómo te queda esa blusa'. Comentarios de ese estilo.\"\n        ng-class=\"vm.getPreguntaClass(9, 'panel-warning')\">\n        <p>En casos que se incurran en tu lugar de trabajo, el artículo 133 del Código Penal paraguayo estipula la tipificación “Acoso sexual” que se aplica para los casos de hostigación a otra persona en situación de dependencia, abuso de autoridad o influencia que le confieren sus funciones. Se prevée pena privativa de libertad de hasta dos años.</p>\n        <p>Esta acción legal dependerá de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n</uib-accordion>"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<p><b>Actos repetidos y no solicitados contra una persona u organización que son percibidos como intrusivos o\n    amenazadores.</b></p>\n<p><u>Ciberbullying, cibercacoso, ciberagresión:</u> Es el uso de medios de comunicación digitales para acosar a una\n    persona o grupo de personas, mediante ataques personales, divulgación de información confidencial o falsa. Es decir,\n    todo aquello que se realice a través de los dispositivos electrónicos de comunicación con el fin intencionado de\n    dañar o agredir a una persona o a un grupo. </p>\n<p><u>Acoso sexual:</u> Envío y recepción de material sexual no solicitado</p>\n<p><u>Extorsión:</u> Forzar a una persona a actuar de acuerdo a la voluntad de otra persona, a través de amenazas e\n    intimidación. Puede ser económica o de otra índole.</p>\n<p><u>Mobbing o acoso laboral:</u> Esta persona o grupo de personas reciben una violencia psicológica injustificada a\n    través de actos negativos y hostiles dentro o fuera del trabajo por parte de grupos sociales externos, de sus\n    compañeros (\"acoso horizontal\", entre iguales), de sus subalternos (en sentido vertical ascendente) o de sus\n    superiores (en sentido vertical descendente, también llamado bossing, del inglés boss, jefe).</p>\n<p><u>Ataques coordinados:</u> Son aquellos ataques que se realizan de manera coordinada y por más de una persona hacia\n    otra, una publicación específica o una página en las redes. Los fines de estos ataques pueden ser varios: difusión\n    de datos personales para causar hostigamiento y acoso, o incluso lograr la eliminación de los perfiles de las\n    víctimas. Suelen crearse identidades falsas para así poder esparcir publicaciones y noticias falsas.</p>\n<p><u>Generación de información falsa (Creación de perfiles, manipulación de imágenes, videos u otra información):</u>\n    se suele utilizar para ciberacoso o ataques coordinados</p>\n<p><u>Diseminación de información privada:</u> es un medio que termina en ciberacoso, mobying, o ataques coordinados</p>\n\n\n<uib-accordion close-others=\"false\">\n    <div uib-accordion-group\n        heading=\"¿Alguna vez te han escrito, enviado audios, o vídeos con los que te sentiste atacadx o insegurx?\"\n        ng-class=\"vm.getPreguntaClass(1, 'panel-success')\">\n        <p>Si en los soportes de audio, fotografía o videos te encuentras expuesta sin tu consentimiento, debes conocer que:</p>\n        <p>La Cesión de imagen es un derecho a la personalidad y se encuentra expresamente protegido en nuestra Constitución Nacional en el artículo 33 sobre el Derecho a la Intimidad, que incluye la dignidad y de la imagen privada de las personas. </p>\n        <p>El Código Penal Paraguayo sanciona con pena de multa esta conducta, siempre y cuando no hubiera habido consentimiento por parte de la persona afectada, el mismo se encuentra en su artículo 143: Lesión de la intimidad de la persona.</p>\n        <p>En el caso tu misma hayas tomado la fotografía, audio u video, debes saber que toda obra que sea guardada en un soporte (memoria del teléfono, disco duro, CD etc) está protegida por derecho de autor. La ley N° 1.328/1998 de derecho de autor y derecho conexo, en su artículo 6, estipula que el autor es el titular originario de los derechos exclusivos sobre la obra, de orden moral y patrimonial. </p>\n        <p>El Código Penal Paraguayo sanciona esta conducta en su artículo 184 “De la violación del derecho de autor o inventor”, eso quiere decir que si un tercero divulga, promociona o reproduce públicamente una obra de un autor sin su consentimiento, esta conducta será sancionada con pena privativa de libertad de hasta tres años o con multa.</p>\n        <p>También en el mismo Código Penal se sanciona en su capítulo VIII de Hechos punibles contra el honor y la reputación, todo lo referente a Calumnias, difamación e injurias.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Tu pareja o alguien conocidx, compañerxs del trabajo o de la facultad compartieron cosas íntimas tuyas o de alguien más sin permiso? ¿o te pidieron algo a cambio para evitar que se publique tu información?\"\n        ng-class=\"vm.getPreguntaClass(2, 'panel-success')\">\n        <p>Si en los soportes de audio, fotografía o videos te encuentras expuesta sin tu consentimiento, debes conocer que:</p>\n        <p>La Cesión de imagen es un derecho a la personalidad y se encuentra descripto en nuestra Constitución Nacional en el artículo 33 sobre el Derecho a la Intimidad, que incluye la dignidad y de la imagen privada de las personas. </p>\n        <p>El Código Penal Paraguayo sanciona con pena de multa esta conducta, siempre y cuando no hubiera habido consentimiento por parte de la persona afectada, el mismo se encuentra en su artículo 143: Lesión de la intimidad de la persona.</p>\n        <p>En el caso tu mismo/a hayas tomado la fotografía, audio u video, debes saber que toda obra que sea guardada en un soporte (memoria del teléfono, disco duro, CD etc) está protegida por derecho de autor. La ley N° 1.328/1998 de derecho de autor y derecho conexo, en su artículo 6, estipula que el autor es el titular originario de los derechos exclusivos sobre la obra, de orden moral y patrimonial. En el caso de violación del derecho de autor, el Código Penal sanciona esta conducta en su artículo 184 “De la violación del derecho de autor o inventor”, eso quiere decir que si un tercero divulga, promociona o reproduce públicamente tu obra sin tu consentimiento, esta conducta será sancionada con pena privativa de libertad de hasta tres años o con multa.</p>\n        <p>Por otro lado se encuentran las acciones legales del capítulo VIII de Hechos punibles contra el honor y la reputación del código penal que se referente a calumnias, difamación e injurias.</p>\n        <p>Para los caso que te hayas sentido forzado/a por otra persona a realizar un acto contra tu voluntad a través de amenazas o intimidación para evitar que tu información sea compartida por otros, el Código Penal sanciona este tipo de conducta en su artículo 185 denominado Extorsión. </p>\n        <p>También se encuentra la opción de la instancia del fuero Civil para que realices una acción de indemnización por daños y perjuicios, esta demanda se encuentra enmarcado en el artículo 1835 del Código Civil paraguayo. Esto se aplica a los casos que existieron daño causado en perjuicio a tu persona, en tus derechos o facultades o a tus cosas de dominio o posesión.</p>\n        <p>Todas estas acciones dependerán de la instancia de la víctima, es decir de vos y no de la fiscalía o policía y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Alguna vez tu pareja te ha solicitado alguna contraseña tuya para tener acceso a tus dispositivos o cuentas?\"\n        ng-class=\"vm.getPreguntaClass(5, 'panel-success')\">\n        <p>El derecho a la intimidad se encuentra expresamente en nuestra Constitución Nacional en su artículo 33, además de ser consagrado como un derecho humano por la Declaración Universal de los Derechos Humanos en su artículo 12 y por el Pacto Internacional de los derechos civiles y políticos en su artículo 17. El derecho a la vida privada es el derecho que tenés a decidir y controlar cuándo y quién accede a diferentes aspectos de tu vida particular. Es tu potestad de excluir a terceros el conocimiento de tu vida privada, es decir, sentimientos, comportamientos e información sensible y que no sea considerado interés público.</p>\n        <p>En el caso que te hayas sentido presionado/a por otra persona, mediante violencia ilegítima a adoptar un determinado comportamiento en Internet en contra de tu voluntad o a impedirte con violencia a realizar un acto en Internet que la ley no prohíbe. El Código penal paraguayo sanciona en su artículo 120 todo tipo de coacción y el artículo 121 de coacción grave, que ponga en peligro tu vida o integridad física. </p>\n        <p>Si alguna vez te amenazaron de un hecho punible que afecta a tu vida en Internet o integridad física u otra cosa de valor considerable, el Código Penal prevé en su artículo 122 de Amenaza, una sanción a este tipo de conducta con pena privativa de libertad de hasta un año o con multa.</p>\n        <p>Si tenés prueba que una persona escucha, graba, almacena o comparte con otras personas el acceso de tus comunicaciones en Internet e imágenes sin tu consentimiento en cualquier soporte digital o impreso. El artículo 144 sobre “Lesión del derecho a la comunicación y a la imagen” del Código Penal paraguayo sanciona esta conducta con el castigo es con pena privativa de libertad de hasta dos años o con multa. </p>\n        <p>Y si conocés a la persona que accedió a tus datos digitales o a tus sistemas informáticos sin tu consentimiento, el Código Penal tipifica estos hechos antijurídicos, denominados delitos informáticos que son artículo 146 b.- Acceso indebido a datos y artículo 174 b.-Acceso indebido a sistemas; ambos se refieren a acceso indebidos de bienes tecnológicos e identidades (datos personales) sin tu consentimiento. Estas conductas sancionan con pena privativa de libertad de hasta tres años o multa.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Alguna vez te han pedido una foto o prueba sobre lo que estás haciendo o donde estás? Por ejemplo, te has ido a comprar algo a la despensa y tu pareja te pide que le envíes una selfie para 'ver lo bonitx que estás', o no te cree que te quedaste durmiendo en tu casa durante la noche.\"\n        ng-class=\"vm.getPreguntaClass(6, 'panel-success')\">\n        <p>El derecho a la intimidad se encuentra expresamente en nuestra Constitución Nacional en su artículo 33, además de ser consagrado como un derecho humano por la Declaración Universal de los Derechos Humanos en su artículo 12 y por el Pacto Internacional de los derechos civiles y políticos en su artículo 17. El derecho a la vida privada es el derecho que tenés a decidir y controlar cuándo y quién accede a diferentes aspectos de tu vida particular. Es tu potestad de excluir a terceros el conocimiento de tu vida privada, es decir, sentimientos, comportamientos e información sensible y que no sea considerado interés público.</p>\n        <p>En el caso que te hayas sentido presionado/a por otra persona, mediante violencia ilegítima a adoptar un determinado comportamiento en Internet en contra de tu voluntad o a impedirte con violencia a realizar un acto en Internet que la ley no prohíbe. El Código penal paraguayo sanciona en su artículo 120 todo tipo de coacción y el artículo 121 de coacción grave, que ponga en peligro tu vida o integridad física. </p>\n        <p>Si alguna vez te amenazaron de un hecho punible que afecta a tu vida en Internet o integridad física u otra cosa de valor considerable, el Código Penal prevé en su artículo 122 de Amenaza, una sanción a este tipo de conducta con pena privativa de libertad de hasta un año o con multa.</p>\n        <p>Para los caso que te hayas sentido forzado/a por otra persona a realizar un acto contra tu voluntad a través de amenazas o intimidación para evitar que tu información sea compartida por otros, el Código Penal sanciona este tipo de conducta en su artículo 185 denominado Extorsión. </p>\n        <p>El artículo 144 sobre “Lesión del derecho a la comunicación y a la imagen” del Código Penal paraguayo sanciona esta conducta siempre y cuando escuchara, grabara o almacenara o facilitara a terceros el acceso a la comunicación e imagen sin consentimiento. El castigo es con pena privativa de libertad de hasta dos años o con multa. </p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada.</p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Te has buscado en las redes y has encontrado a otra persona con tu misma identidad, tus mismas fotos, hasta una selfie con tu mascota o tu pareja?\"\n        ng-class=\"vm.getPreguntaClass(7, 'panel-success')\">\n        <p>La usurpación de identidad no se encuentra actualmente sancionado en el Código Penal paraguayo. Sin embargo se encuentra en su capítulo VIII de Hechos punibles contra el honor y la reputación, todo lo referente a calumnias, difamación e injurias.</p>\n        <p>También se encuentra la instancia Civil para la indemnización por daños y perjuicios que se enmarcar en el artículo 1835 del Código Civil paraguayo. Esto se aplica a los casos que existieron daño causado en perjuicio a otra persona, en sus derechos o facultades o cosas de dominio o posesión.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Se llegó a divulgar información manipulada o falsa sobre tu persona en las redes, como fotos, mensajes de texto, etc?\"\n        ng-class=\"vm.getPreguntaClass(8, 'panel-success')\">\n        <p>El artículo 144 sobre “Lesión del derecho a la comunicación y a la imagen” del Código Penal paraguayo sanciona esta conducta siempre y cuando escuchara, grabara o almacenara o facilitara a terceros el acceso a la comunicación e imagen sin consentimiento. El castigo es con pena privativa de libertad de hasta dos años o con multa. </p>\n        <p>También el Código Penal Paraguayo sanciona en su capítulo VIII de Hechos punibles contra el honor y la reputación, todo lo referente a Calumnias, difamación e injurias.</p>\n        <p>También se encuentra la instancia Civil para la indemnización por daños y perjuicios que se enmarcar en el artículo 1835 del Código Civil paraguayo. Esto se aplica a los casos que existieron daño causado en perjuicio a otra persona, en sus derechos o facultades o cosas de dominio o posesión.</p>\n        <p>Todas estas acciones legales dependerán de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n\n    <div uib-accordion-group\n        heading=\"¿Algún compañerx de trabajo, jefe, profesor o pariente, te manda textos, vídeos o audios con mensajes 'subidos de tono'? Por ejemplo: 'Qué linda pollera andás hoy', 'Mirá cómo te queda esa blusa'. Comentarios de ese estilo.\"\n        ng-class=\"vm.getPreguntaClass(9, 'panel-success')\">\n        <p>En casos que se incurran en tu lugar de trabajo, el artículo 133 del Código Penal paraguayo estipula la tipificación “Acoso sexual” que se aplica para los casos de hostigación a otra persona en situación de dependencia, abuso de autoridad o influencia que le confieren sus funciones. Se prevée pena privativa de libertad de hasta dos años.</p>\n        <p>Esta acción legal dependerá de la instancia de la víctima, es decir de vos y se deberán realizar bajo patrocinio obligatorio de un abogado o abogada. </p>\n    </div>\n</uib-accordion>"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = "<p>\n    <b>Acoso.online</b><br>\n    <a href=\"http://acoso.online/\">http://acoso.online/</a><br>\n    Repositorio de recomendaciones legales\n</p>\n<p>\n    <b>#ColegiosLibresDeAcoso</b><br>\n    <a href=\"https://www.instagram.com/colegioslibresdeacoso/\">https://www.instagram.com/colegioslibresdeacoso/</a><br>\n    Apoyo y acompañamiento legal\n</p>"

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = "<p>\n    <b>TEDIC</b><br>\n    Apoyo capacitación sobre derechos digitales<br>\n    <a href=\"https://www.tedic.org\">https://www.tedic.org</a><br>\n    hola@tedic.org | +595 976 572025\n</p>\n\n<p>\n    <b>Consultorio Jurídico Feminista</b><br>\n    Apoyo y asesoramiento jurídico<br>\n    <a href=\"https://www.facebook.com/CJFparaguay/\">https://www.facebook.com/CJFparaguay/</a><br>\n    consultoriojuridicofeminista@gmail.com\n</p>\n\n<p>\n    <b>Aireana - Rohendu</b><br>\n    Línea de apoyo y contención<br>\n    <a href=\"https://www.aireana.org.py/tomando-fuerza/ro-hendu/\">https://www.aireana.org.py/tomando-fuerza/ro-hendu/</a><br>\n    0981 110 108 - 0800 110 108\n</p>\n\n<p>\n    <b>Asociación Panambí - Casa Diversa</b><br>\n    Panambi Asesoramiento y acompañamiento.<br>\n    Casa diversa Asesoramiento albergue transitorio<br>\n    (021) 446 710 | info@panambi.org.py\n</p>\n\n<p>\n    <b>Católicas por el Derecho a Decidir</b><br>\n    Contención y apoyo jurídico<br>\n    cddparaguay@gmail.com | Dina Cabañas - +595 981 992138 | Lourdes Rocío Cabañas - +595 971 121843 | Marina León - +595 981 516385\n</p>\n\n<p>\n    <b>Red Feminista de Salud Mental de Paraguay</b><br>\n    No brinda asesoramiento como red, sin embargo sus integrantes ofrecen acompañamiento a nivel personal<br>\n    Montserrat Vera - +595 981 234302 | Silvia Navarro - +595 981 528141 | Paola Kolher - +595 994 764037\n</p>\n\n<p>\n    <b>It Gets Better Paraguay</b><br>\n    Contención psicológica online y personal - Asesoramiento legal con enfoque anti discriminación<br>\n    <a href=\"https://www.facebook.com/ItGetsBetterPy/\">https://www.facebook.com/ItGetsBetterPy/</a>\n</p>"

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<p>\n    <b>“SOS MUJER” línea 137</b><br>\n    Ministerio de la Mujer<br>\n    (021) 45 20 60 | atencion@mujer.gov.py\n</p>\n\n<p>\n    <b>147 Fono Ayuda</b><br>\n    Secretaría de la Niñez y Adolescencia<br>\n    Para denuncias de hechos punibles de criadazgo o trabajo infantil\n</p>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapa = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mapa = __webpack_require__(627);
	
	var _mapa2 = _interopRequireDefault(_mapa);
	
	var _leaflet = __webpack_require__(628);
	
	var L = _interopRequireWildcard(_leaflet);
	
	var _chart = __webpack_require__(629);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var angular = __webpack_require__(94);
	
	var uiRouter = __webpack_require__(104);
	
	var $ = __webpack_require__(111);
	
	var mapa = exports.mapa = function () {
	  /*@ngInject*/
	  mapa.$inject = ['municipios', 'localidadesList', '$window', '$http', 'appConfig'];
	  function mapa(municipios, localidadesList, $window, $http, appConfig) {
	    _classCallCheck(this, mapa);
	
	    this.municipios = municipios;
	    this.localidadesList = localidadesList;
	    this.$window = $window;
	    this.$http = $http;
	    this.appConfig = appConfig;
	
	    this.validation = {
	      genero: null,
	      localidad: null,
	      edad: null
	    };
	  }
	
	  _createClass(mapa, [{
	    key: '$onInit',
	    value: function $onInit() {
	      _chart2.default.defaults.global.defaultFontFamily = 'Lato';
	      _chart2.default.defaults.global.defaultFontSize = 12;
	      _chart2.default.defaults.global.defaultFontColor = '#777';
	
	      var layerDistritos;
	      var listaLocalidades = [];
	
	      var exteriorStyle = {
	        weight: 2,
	        color: '#00AC9B',
	        dashArray: '',
	        fillOpacity: 0.1
	      };
	
	      var map = L.map('map').setView([-23.442503, -58.4438324], 7);
	      L.tileLayer('https://api.mapbox.com/styles/v1/samsaurio/ck7urxj9606nr1isz39c1dxvz/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}', {
	        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery :copyright: <a href="https://www.mapbox.com/">Mapbox</a>',
	        maxZoom: 18,
	        id: 'mapbox/streets-v11',
	        tileSize: 512,
	        zoomOffset: -1,
	        accessToken: 'pk.eyJ1Ijoic2Ftc2F1cmlvIiwiYSI6ImNqbjR1bDd6MTB1MGMzbG52Z2d5azNzMjQifQ.1EFe_Fl5OZ3A2EUik4dJ2Q'
	      }).addTo(map);
	
	      function highlightFeature(e) {
	        var layer = e.target;
	
	        layer.setStyle({
	          weight: 4,
	          color: '#00AC9B',
	          dashArray: '',
	          fillOpacity: 0.7
	        });
	
	        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
	          layer.bringToFront();
	        }
	      }
	
	      function resetHighlight(e) {
	        layerDistritos.resetStyle(e.target);
	      }
	
	      function zoomToFeature(e) {
	        var layer = e.target;
	        map.fitBounds(e.target.getBounds());
	        layer.openPopup();
	      }
	
	      function onEachFeature(feature, layer) {
	        listaLocalidades.push(feature.properties.dist_desc_);
	        layer._leaflet_id = feature.properties.dist_desc_;
	
	        layer.on({
	          mouseover: highlightFeature,
	          mouseout: resetHighlight,
	          click: zoomToFeature
	        });
	      }
	
	      layerDistritos = L.geoJson(this.municipios, {
	        style: exteriorStyle,
	        onEachFeature: onEachFeature
	      }).addTo(map);
	
	      map.fitBounds(layerDistritos.getBounds());
	
	      this.createDropdown(map, this.localidadesList);
	
	      this.generateMarkers(map, listaLocalidades);
	    }
	  }, {
	    key: 'createDropdown',
	    value: function createDropdown(map, listaLocalidades) {
	      var departamentoAct;
	
	      var dropdown = L.control({
	        position: 'topright',
	        title: 'Ciudades'
	      });
	      dropdown.onAdd = function (map) {
	        var div = L.DomUtil.create('div', 'custom-select');
	        var dropDownContent = '<select id="distritos">';
	
	        for (var i = 0; i < listaLocalidades.length; i++) {
	
	          var ciudad = listaLocalidades[i].ciudad.toUpperCase();
	          ciudad.replace("'", "&#39;");
	
	          if (i == 0) {
	            dropDownContent += '<optgroup label=' + "'" + listaLocalidades[i].departamento + "'>";
	            departamentoAct = listaLocalidades[i].departamento;
	          }
	          if (listaLocalidades[i].departamento == departamentoAct) {
	
	            dropDownContent += '<option value=' + '"' + ciudad + '">' + listaLocalidades[i].ciudad + '</option>';
	          } else {
	            departamentoAct = listaLocalidades[i].departamento;
	            dropDownContent += '<optgroup label=' + "'" + listaLocalidades[i].departamento + "'>";
	            dropDownContent += '<option value=' + "'" + ciudad + "'>" + listaLocalidades[i].ciudad + '</option>';
	          }
	        }
	        dropDownContent += '</select>';
	        div.innerHTML = dropDownContent;
	        div.firstChild.onmousedown = div.firstChild.ondblclick = L.DomEvent.stopPropagation;
	        return div;
	      };
	      dropdown.addTo(map);
	
	      $('select').change(function () {
	        var distritoSelect = document.getElementById("distritos");
	        var distritoSelected = distritoSelect.options[distritoSelect.selectedIndex].value;
	        polySelect(map, distritoSelected);
	      });
	    }
	  }, {
	    key: 'generateMarkers',
	    value: function generateMarkers(map, listaLocalidades) {
	      var _this = this;
	
	      var markerStyle = L.icon({
	        iconUrl: 'assets/images/localizacion.svg',
	        iconSize: [38, 95],
	        iconAnchor: [22, 94],
	        popupAnchor: [-3, -76] });
	
	      this.$http.get('/api/encuestas').then(function (response) {
	        for (var i = 0; i < listaLocalidades.length; i++) {
	          var layer = map._layers[listaLocalidades[i]];
	          var bounds = layer.getBounds();
	          var center = bounds.getCenter();
	
	          _this.result = response.data;
	          var porcentajes = getPorcentajes(_this.result, listaLocalidades[i], "general", "masculino", [15, 32]);
	
	          if (!(isNaN(porcentajes[0][0]) && isNaN(porcentajes[1][0]) && isNaN(porcentajes[2][0]))) {
	
	            var ciudad = capitalizeWords(listaLocalidades[i].toLowerCase());
	            var marker = new L.Marker(center, {
	              icon: markerStyle,
	              title: listaLocalidades[i]
	            }).bindPopup('<div id = "burbuja"><p class= tituloBurbuja> Resultados generales para: <br>' + ciudad + '</p><canvas id="burbujaChart"></canvas></div>').on('popupopen', function (e) {
	              this.result = response.data;
	              var porcentajes = getPorcentajes(this.result, e.target.options.title, "general", "masculino", [15, 32]);
	              var burbujaChart = document.getElementById("burbujaChart").getContext('2d');
	              createBurbujaChart(burbujaChart, porcentajes);
	              anadirdiv(this.result, e.target.options.title);
	            }).on('popupclose', function (e) {
	              var elem = document.getElementById("sidebar");
	
	              while (elem.firstChild) {
	                elem.removeChild(elem.firstChild);
	              }
	              var elemBurbuja = document.getElementById("burbuja");
	
	              while (elemBurbuja.firstChild) {
	                elemBurbuja.removeChild(elemBurbuja.firstChild);
	              }
	            }).addTo(map);
	            console.log(marker);
	          }
	        }
	      });
	    }
	  }]);
	
	  return mapa;
	}();
	
	function anadirdiv(base, distrito) {
	  var porcentajeGeneroFemenino = getPorcentajes(base, distrito, "genero", "femenino", [15, 32]);
	
	  var porcentajeGeneroMasculino = getPorcentajes(base, distrito, "genero", "masculino", [15, 32]);
	  var porcentajeGeneroOtro = getPorcentajes(base, distrito, "genero", "otro", [15, 32]);
	  var porcentajesGenero = [[porcentajeGeneroFemenino[0], porcentajeGeneroMasculino[0], porcentajeGeneroOtro[0]], [porcentajeGeneroFemenino[1], porcentajeGeneroMasculino[1], porcentajeGeneroOtro[1]], [porcentajeGeneroFemenino[2], porcentajeGeneroMasculino[2], porcentajeGeneroOtro[2]]];
	
	  var porcentajeEdadPrimerRango = getPorcentajes(base, distrito, "edad", "masculino", [12, 33]);
	  var porcentajeEdadSegundoRango = getPorcentajes(base, distrito, "edad", "femenino", [34, 54]);
	  var porcentajeEdadTercerRango = getPorcentajes(base, distrito, "edad", "otro", [55, 75]);
	  var porcentajesEdad = [[porcentajeEdadPrimerRango[0], porcentajeEdadSegundoRango[0], porcentajeEdadTercerRango[0]], [porcentajeEdadPrimerRango[1], porcentajeEdadSegundoRango[1], porcentajeEdadTercerRango[1]], [porcentajeEdadPrimerRango[2], porcentajeEdadSegundoRango[2], porcentajeEdadTercerRango[2]]];
	
	  var div = document.createElement('sidebar');
	
	  div.className = 'sidebar-wrapper';
	
	  div.innerHTML = '  <div id="features" class="panel panel-default"><h3 class="panel-title">Resultados por género</h3>  <canvas id="genero"></canvas> <h3 class="panel-title">Resultados por edad</h3>  <canvas id="edad"></canvas> </div>';
	
	  document.getElementById('sidebar').appendChild(div);
	
	  var genero = document.getElementById('genero').getContext('2d');
	  createChart("genero", genero, porcentajesGenero);
	
	  var edad = document.getElementById('edad').getContext('2d');
	  createChart("edad", edad, porcentajesEdad);
	}
	
	function createChart(type, chartName, porcentajes) {
	
	  switch (type) {
	    case 'edad':
	      var listLabels = ['12-33 años', '34-54 años', '55-75 años'];
	      break;
	    case 'genero':
	      var listLabels = ['Femenino', 'Masculino', 'Otro'];
	      break;
	  }
	  var massPopChart = new _chart2.default(chartName, {
	    type: 'horizontalBar',
	    data: {
	      labels: listLabels,
	      datasets: [{
	        label: 'Vigilancia',
	        data: porcentajes[0],
	        backgroundColor: ['rgb(255, 68, 106)', 'rgb(255, 68, 106)', 'rgb(255, 68, 106)']
	      }, {
	        label: 'Acoso',
	        data: porcentajes[1],
	        backgroundColor: ['rgb(255, 246, 87)', 'rgb(255, 246, 87)', 'rgb(255, 246, 87)']
	      }, {
	        label: 'Discurso de odio',
	        data: porcentajes[2],
	        backgroundColor: ['rgb(0, 176, 158)', 'rgb(0, 176, 158)', 'rgb(0, 176, 158)']
	      }]
	    },
	    options: {
	      legend: {
	        display: true,
	        position: 'right',
	        labels: {
	          fontColor: '#000',
	          boxWidth: 20
	        }
	      },
	      events: [],
	      layout: {
	        padding: {
	          left: 25,
	          right: 25,
	          bottom: 25,
	          top: 25
	        }
	      },
	      scales: {
	        xAxes: [{
	          gridLines: {
	            drawOnChartArea: false
	          },
	          ticks: {
	            beginAtZero: true,
	            steps: 10,
	            max: 100
	          }
	        }],
	        yAxes: [{
	          gridLines: {
	            drawOnChartArea: false
	          }
	        }]
	      }
	    }
	  });
	}
	
	function createBurbujaChart(chartName, porcentajes) {
	  var massPopChart = new _chart2.default(chartName, {
	    type: 'horizontalBar',
	    data: {
	      labels: [''],
	      datasets: [{
	        label: 'Vigilancia',
	        data: porcentajes[0],
	        backgroundColor: ['rgb(255, 68, 106)']
	      }, {
	        label: 'Acoso',
	        data: porcentajes[1],
	        backgroundColor: ['rgb(255, 246, 87)']
	      }, {
	        label: 'Discurso de odio',
	        data: porcentajes[2],
	        backgroundColor: ['rgb(0, 176, 158)']
	      }]
	    },
	    options: {
	      legend: {
	        display: true,
	        position: 'top',
	        labels: {
	          boxWidth: 20,
	          fontColor: '#000'
	        }
	      },
	      events: [],
	      scales: {
	        xAxes: [{
	          gridLines: {
	            drawOnChartArea: false
	          },
	          ticks: {
	            beginAtZero: true,
	            steps: 10,
	            max: 100
	          }
	        }],
	        yAxes: [{
	          gridLines: {
	            drawOnChartArea: false
	          }
	        }]
	      }
	    }
	  });
	}
	
	function getPorcentajes(resultados, ciudad, tipo, entradagen, entradaedad) {
	
	  var sumaResPosAcoso = 0;
	  var sumaRespNegAcoso = 0;
	  var sumaResPosOdio = 0;
	  var sumaRespNegOdio = 0;
	  var sumaResPosVigilancia = 0;
	  var sumaRespNegVigilancia = 0;
	  var cantidadPersonas = 0;
	  for (var i = 0; i < resultados.length; i++) {
	
	    if (resultados[i].ciudad != null) {
	
	      if (resultados[i].ciudad.toLowerCase() == ciudad.toLowerCase()) {
	
	        if (tipo == "general" || tipo == "genero" && entradagen == resultados[i].genero || tipo == "edad" && entradaedad[0] <= resultados[i].edad && entradaedad[1] >= resultados[i].edad) {
	
	          cantidadPersonas++;
	          sumaResPosAcoso = sumaResPosAcoso + resultados[i].result.tRespSiCat1;
	          sumaRespNegAcoso = sumaRespNegAcoso + resultados[i].result.tRespCat1;
	          sumaResPosOdio = sumaResPosOdio + resultados[i].result.tRespSiCat2;
	          sumaRespNegOdio = sumaRespNegOdio + resultados[i].result.tRespCat2;
	
	          sumaResPosVigilancia = sumaResPosVigilancia + resultados[i].result.tRespSiCat3;
	          sumaRespNegVigilancia = sumaRespNegVigilancia + resultados[i].result.tRespCat3;
	        }
	      }
	    }
	  }
	
	  var porcentajeAcoso = getPorcTipologia(cantidadPersonas, sumaResPosAcoso, sumaRespNegAcoso);
	  var porcentajeOdio = getPorcTipologia(cantidadPersonas, sumaResPosOdio, sumaRespNegOdio);
	  var porcentajeVigilancia = getPorcTipologia(cantidadPersonas, sumaResPosVigilancia, sumaRespNegVigilancia);
	
	  if (tipo == "general") {
	    var porcentajes = [[porcentajeAcoso], [porcentajeVigilancia], [porcentajeOdio]];
	
	    return porcentajes;
	  } else {
	    var porcentajes = [porcentajeAcoso, porcentajeVigilancia, porcentajeOdio];
	    return porcentajes;
	  }
	}
	
	function getPorcTipologia(total, resPos, resNeg) {
	  var mediaPos = resPos / total;
	  var mediaNeg = resNeg / total;
	
	  var porcentaje = mediaPos / mediaNeg * 100;
	  return porcentaje;
	}
	
	function polySelect(map, distrito) {
	  map._layers[distrito].fire('click');
	  var layer = map._layers[distrito];
	  map.fitBounds(layer.getBounds());
	}
	
	function capitalizeWords(str) {
	  return str.split(" ").map(function (item) {
	    return item[0].toUpperCase() + item.substr(1, item.length);
	  }).join(" ");
	}
	
	exports.default = angular.module('dataCuentaApp.mapa', [uiRouter]).config(_mapa2.default).component('mapa', {
	  template: __webpack_require__(759),
	  controller: mapa,
	  controllerAs: 'mp'
	}).name;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mapa', {
	    url: '/mapa',
	    template: '<mapa></mapa>'
	  });
	}];

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.6.0, a JS library for interactive maps. http://leafletjs.com
	 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.L = {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "1.6.0";
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	var freeze = Object.freeze;
	Object.freeze = function (obj) { return obj; };
	
	// @function extend(dest: Object, src?: Object): Object
	// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	function extend(dest) {
		var i, j, len, src;
	
		for (j = 1, len = arguments.length; j < len; j++) {
			src = arguments[j];
			for (i in src) {
				dest[i] = src[i];
			}
		}
		return dest;
	}
	
	// @function create(proto: Object, properties?: Object): Object
	// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	var create = Object.create || (function () {
		function F() {}
		return function (proto) {
			F.prototype = proto;
			return new F();
		};
	})();
	
	// @function bind(fn: Function, …): Function
	// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	// Has a `L.bind()` shortcut.
	function bind(fn, obj) {
		var slice = Array.prototype.slice;
	
		if (fn.bind) {
			return fn.bind.apply(fn, slice.call(arguments, 1));
		}
	
		var args = slice.call(arguments, 2);
	
		return function () {
			return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
		};
	}
	
	// @property lastId: Number
	// Last unique ID used by [`stamp()`](#util-stamp)
	var lastId = 0;
	
	// @function stamp(obj: Object): Number
	// Returns the unique ID of an object, assigning it one if it doesn't have it.
	function stamp(obj) {
		/*eslint-disable */
		obj._leaflet_id = obj._leaflet_id || ++lastId;
		return obj._leaflet_id;
		/* eslint-enable */
	}
	
	// @function throttle(fn: Function, time: Number, context: Object): Function
	// Returns a function which executes function `fn` with the given scope `context`
	// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	// `fn` will be called no more than one time per given amount of `time`. The arguments
	// received by the bound function will be any arguments passed when binding the
	// function, followed by any arguments passed when invoking the bound function.
	// Has an `L.throttle` shortcut.
	function throttle(fn, time, context) {
		var lock, args, wrapperFn, later;
	
		later = function () {
			// reset lock and call if queued
			lock = false;
			if (args) {
				wrapperFn.apply(context, args);
				args = false;
			}
		};
	
		wrapperFn = function () {
			if (lock) {
				// called too soon, queue to call later
				args = arguments;
	
			} else {
				// call and lock until later
				fn.apply(context, arguments);
				setTimeout(later, time);
				lock = true;
			}
		};
	
		return wrapperFn;
	}
	
	// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	// Returns the number `num` modulo `range` in such a way so it lies within
	// `range[0]` and `range[1]`. The returned value will be always smaller than
	// `range[1]` unless `includeMax` is set to `true`.
	function wrapNum(x, range, includeMax) {
		var max = range[1],
		    min = range[0],
		    d = max - min;
		return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	}
	
	// @function falseFn(): Function
	// Returns a function which always returns `false`.
	function falseFn() { return false; }
	
	// @function formatNum(num: Number, digits?: Number): Number
	// Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
	function formatNum(num, digits) {
		var pow = Math.pow(10, (digits === undefined ? 6 : digits));
		return Math.round(num * pow) / pow;
	}
	
	// @function trim(str: String): String
	// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	function trim(str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	// @function splitWords(str: String): String[]
	// Trims and splits the string on whitespace and returns the array of parts.
	function splitWords(str) {
		return trim(str).split(/\s+/);
	}
	
	// @function setOptions(obj: Object, options: Object): Object
	// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	function setOptions(obj, options) {
		if (!obj.hasOwnProperty('options')) {
			obj.options = obj.options ? create(obj.options) : {};
		}
		for (var i in options) {
			obj.options[i] = options[i];
		}
		return obj.options;
	}
	
	// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	// be appended at the end. If `uppercase` is `true`, the parameter names will
	// be uppercased (e.g. `'?A=foo&B=bar'`)
	function getParamString(obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	}
	
	var templateRe = /\{ *([\w_-]+) *\}/g;
	
	// @function template(str: String, data: Object): String
	// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	// `('Hello foo, bar')`. You can also specify functions instead of strings for
	// data values — they will be evaluated passing `data` as an argument.
	function template(str, data) {
		return str.replace(templateRe, function (str, key) {
			var value = data[key];
	
			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);
	
			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	}
	
	// @function isArray(obj): Boolean
	// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	var isArray = Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	};
	
	// @function indexOf(array: Array, el: Object): Number
	// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	function indexOf(array, el) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === el) { return i; }
		}
		return -1;
	}
	
	// @property emptyImageUrl: String
	// Data URI string containing a base64-encoded empty GIF image.
	// Used as a hack to free memory from unused images on WebKit-powered
	// mobile devices (by setting image `src` to this string).
	var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	function getPrefixed(name) {
		return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	}
	
	var lastTime = 0;
	
	// fallback for IE 7-8
	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));
	
		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}
	
	var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
			getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	// `context` if given. When `immediate` is set, `fn` is called immediately if
	// the browser doesn't have native support for
	// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	function requestAnimFrame(fn, context, immediate) {
		if (immediate && requestFn === timeoutDefer) {
			fn.call(context);
		} else {
			return requestFn.call(window, bind(fn, context));
		}
	}
	
	// @function cancelAnimFrame(id: Number): undefined
	// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	function cancelAnimFrame(id) {
		if (id) {
			cancelFn.call(window, id);
		}
	}
	
	
	var Util = (Object.freeze || Object)({
		freeze: freeze,
		extend: extend,
		create: create,
		bind: bind,
		lastId: lastId,
		stamp: stamp,
		throttle: throttle,
		wrapNum: wrapNum,
		falseFn: falseFn,
		formatNum: formatNum,
		trim: trim,
		splitWords: splitWords,
		setOptions: setOptions,
		getParamString: getParamString,
		template: template,
		isArray: isArray,
		indexOf: indexOf,
		emptyImageUrl: emptyImageUrl,
		requestFn: requestFn,
		cancelFn: cancelFn,
		requestAnimFrame: requestAnimFrame,
		cancelAnimFrame: cancelAnimFrame
	});
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	function Class() {}
	
	Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype' && i !== '__super__') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			checkDeprecatedMixinEvents(props.includes);
			extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = extend(create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	Class.include = function (props) {
		extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	Class.mergeOptions = function (options) {
		extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	function checkDeprecatedMixinEvents(includes) {
		if (typeof L === 'undefined' || !L || !L.Mixin) { return; }
	
		includes = isArray(includes) ? includes : [includes];
	
		for (var i = 0; i < includes.length; i++) {
			if (includes[i] === L.Mixin.Events) {
				console.warn('Deprecated include of L.Mixin.Events: ' +
					'this property will be removed in future releases, ' +
					'please inherit from L.Evented instead.', new Error().stack);
			}
		}
	}
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	var Events = {
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object. This includes implicitly attached events.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = extend({}, data, {
				type: type,
				target: this,
				sourceTarget: data && data.sourceTarget || this
			});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, extend({
					layer: e.target,
					propagatedFrom: e.target
				}, e), true);
			}
		}
	};
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	Events.addEventListener = Events.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	Events.addOneTimeEventListener = Events.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	Events.fireEvent = Events.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	Events.hasEventListeners = Events.listens;
	
	var Evented = Class.extend(Events);
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 *
	 * Note that `Point` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function Point(x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	}
	
	var trunc = Math.trunc || function (v) {
		return v > 0 ? Math.floor(v) : Math.ceil(v);
	};
	
	Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(toPoint(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(toPoint(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method trunc(): Point
		// Returns a copy of the current point with truncated coordinates (rounded towards zero).
		trunc: function () {
			return this.clone()._trunc();
		},
	
		_trunc: function () {
			this.x = trunc(this.x);
			this.y = trunc(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = toPoint(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = toPoint(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = toPoint(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        formatNum(this.x) + ', ' +
			        formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	function toPoint(x, y, round) {
		if (x instanceof Point) {
			return x;
		}
		if (isArray(x)) {
			return new Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new Point(x.x, x.y);
		}
		return new Point(x, y, round);
	}
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 *
	 * Note that `Bounds` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function Bounds(a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	}
	
	Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = toPoint(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new Point(this.max.x, this.min.y);
		},
	
		// @method getTopLeft(): Point
		// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
		getTopLeft: function () {
			return this.min; // left, top
		},
	
		// @method getBottomRight(): Point
		// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
		getBottomRight: function () {
			return this.max; // right, bottom
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof Point) {
				obj = toPoint(obj);
			} else {
				obj = toBounds(obj);
			}
	
			if (obj instanceof Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = toBounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(corner1: Point, corner2: Point)
	// Creates a Bounds object from two corners coordinate pairs.
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the given array of points.
	function toBounds(a, b) {
		if (!a || a instanceof Bounds) {
			return a;
		}
		return new Bounds(a, b);
	}
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 *
	 * Note that `LatLngBounds` does not inherit from Leafet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	}
	
	LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new LatLng(sw2.lat, sw2.lng);
				this._northEast = new LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
		// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
		// Negative values will retract the bounds.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new LatLngBounds(
			        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
				obj = toLatLng(obj);
			} else {
				obj = toLatLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
		equals: function (bounds, maxMargin) {
			if (!bounds) { return false; }
	
			bounds = toLatLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
			       this._northEast.equals(bounds.getNorthEast(), maxMargin);
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	function toLatLngBounds(a, b) {
		if (a instanceof LatLngBounds) {
			return a;
		}
		return new LatLngBounds(a, b);
	}
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 *
	 * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	 * which means new classes can't inherit from it, and new methods
	 * can't be added to it with the `include` function.
	 */
	
	function LatLng(lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	}
	
	LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = toLatLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        formatNum(this.lat, precision) + ', ' +
			        formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
		distanceTo: function (other) {
			return Earth.distance(this, toLatLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return toLatLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	function toLatLng(a, b, c) {
		if (a instanceof LatLng) {
			return a;
		}
		if (isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new LatLng(a, b, c);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Base
	 * Object that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 *
	 * Note that the CRS instances do not inherit from Leafet's `Class` object,
	 * and can't be instantiated. Also, new classes can't inherit from them,
	 * and methods can't be added to them with the `include` function.
	 */
	
	var CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return new Bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return new LatLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
			    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
			return new LatLngBounds(newSw, newNe);
		}
	};
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	var Earth = extend({}, CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
			    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
			    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
			    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return this.R * c;
		}
	});
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	var earthRadius = 6378137;
	
	var SphericalMercator = {
	
		R: earthRadius,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = earthRadius * Math.PI;
			return new Bounds([-d, -d], [d, d]);
		})()
	};
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = L.transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	function Transformation(a, b, c, d) {
		if (isArray(a)) {
			// use array properties
			this._a = a[0];
			this._b = a[1];
			this._c = a[2];
			this._d = a[3];
			return;
		}
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	}
	
	Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	// factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	// @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	// Instantiates a Transformation object with the given coefficients.
	
	// @alternative
	// @factory L.transformation(coefficients: Array): Transformation
	// Expects an coefficients array of the form
	// `[a: Number, b: Number, c: Number, d: Number]`.
	
	function toTransformation(a, b, c, d) {
		return new Transformation(a, b, c, d);
	}
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	var EPSG3857 = extend({}, Earth, {
		code: 'EPSG:3857',
		projection: SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * SphericalMercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	var EPSG900913 = extend({}, EPSG3857, {
		code: 'EPSG:900913'
	});
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	
	// @function create(name: String): SVGElement
	// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	// corresponding to the class name passed. For example, using 'line' will return
	// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	function svgCreate(name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	}
	
	// @function pointsToPath(rings: Point[], closed: Boolean): String
	// Generates a SVG path string for multiple rings, with each ring turning
	// into "M..L..L.." instructions
	function pointsToPath(rings, closed) {
		var str = '',
		i, j, len, len2, points, p;
	
		for (i = 0, len = rings.length; i < len; i++) {
			points = rings[i];
	
			for (j = 0, len2 = points.length; j < len2; j++) {
				p = points[j];
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}
	
			// closes the ring for polygons; "x" is VML syntax
			str += closed ? (svg ? 'z' : 'x') : '';
		}
	
		// SVG complains about empty path strings
		return str || 'M0 0';
	}
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	var style$1 = document.documentElement.style;
	
	// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	var ie = 'ActiveXObject' in window;
	
	// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	var ielt9 = ie && !document.addEventListener;
	
	// @property edge: Boolean; `true` for the Edge web browser.
	var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	// @property webkit: Boolean;
	// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	var webkit = userAgentContains('webkit');
	
	// @property android: Boolean
	// `true` for any browser running on an Android platform.
	var android = userAgentContains('android');
	
	// @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
	var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	/* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	// @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
	var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
	
	// @property opera: Boolean; `true` for the Opera browser
	var opera = !!window.opera;
	
	// @property chrome: Boolean; `true` for the Chrome browser.
	var chrome = userAgentContains('chrome');
	
	// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	// @property safari: Boolean; `true` for the Safari browser.
	var safari = !chrome && userAgentContains('safari');
	
	var phantom = userAgentContains('phantom');
	
	// @property opera12: Boolean
	// `true` for the Opera browser supporting CSS transforms (version 12 or later).
	var opera12 = 'OTransition' in style$1;
	
	// @property win: Boolean; `true` when the browser is running in a Windows platform
	var win = navigator.platform.indexOf('Win') === 0;
	
	// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	var ie3d = ie && ('transition' in style$1);
	
	// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	var gecko3d = 'MozPerspective' in style$1;
	
	// @property any3d: Boolean
	// `true` for all browsers supporting CSS transforms.
	var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	// @property mobile: Boolean; `true` for all browsers running in a mobile device.
	var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	var mobileWebkit = mobile && webkit;
	
	// @property mobileWebkit3d: Boolean
	// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	var mobileWebkit3d = mobile && webkit3d;
	
	// @property msPointer: Boolean
	// `true` for browsers implementing the Microsoft touch events model (notably IE10).
	var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	// @property pointer: Boolean
	// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	var pointer = !webkit && !!(window.PointerEvent || msPointer);
	
	// @property touch: Boolean
	// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	// This does not necessarily mean that the browser is running in a computer with
	// a touchscreen, it only means that the browser is capable of understanding
	// touch events.
	var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));
	
	// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	var mobileOpera = mobile && opera;
	
	// @property mobileGecko: Boolean
	// `true` for gecko-based browsers running in a mobile device.
	var mobileGecko = mobile && gecko;
	
	// @property retina: Boolean
	// `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	// @property passiveEvents: Boolean
	// `true` for browsers that support passive events.
	var passiveEvents = (function () {
		var supportsPassiveOption = false;
		try {
			var opts = Object.defineProperty({}, 'passive', {
				get: function () {
					supportsPassiveOption = true;
				}
			});
			window.addEventListener('testPassiveEventSupport', falseFn, opts);
			window.removeEventListener('testPassiveEventSupport', falseFn, opts);
		} catch (e) {
			// Errors can safely be ignored since this is only a browser support test.
		}
		return supportsPassiveOption;
	});
	
	// @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	var canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	// @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	var vml = !svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	
	function userAgentContains(str) {
		return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	}
	
	
	var Browser = (Object.freeze || Object)({
		ie: ie,
		ielt9: ielt9,
		edge: edge,
		webkit: webkit,
		android: android,
		android23: android23,
		androidStock: androidStock,
		opera: opera,
		chrome: chrome,
		gecko: gecko,
		safari: safari,
		phantom: phantom,
		opera12: opera12,
		win: win,
		ie3d: ie3d,
		webkit3d: webkit3d,
		gecko3d: gecko3d,
		any3d: any3d,
		mobile: mobile,
		mobileWebkit: mobileWebkit,
		mobileWebkit3d: mobileWebkit3d,
		msPointer: msPointer,
		pointer: pointer,
		touch: touch,
		mobileOpera: mobileOpera,
		mobileGecko: mobileGecko,
		retina: retina,
		passiveEvents: passiveEvents,
		canvas: canvas,
		svg: svg,
		vml: vml
	});
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	
	var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
	var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
	var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
	var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
	var TAG_WHITE_LIST = ['INPUT', 'SELECT', 'OPTION'];
	
	var _pointers = {};
	var _pointerDocListener = false;
	
	// DomEvent.DoubleTap needs to know about this
	var _pointersCount = 0;
	
	// Provides a touch events wrapper for (ms)pointer events.
	// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	function addPointerListener(obj, type, handler, id) {
		if (type === 'touchstart') {
			_addPointerStart(obj, handler, id);
	
		} else if (type === 'touchmove') {
			_addPointerMove(obj, handler, id);
	
		} else if (type === 'touchend') {
			_addPointerEnd(obj, handler, id);
		}
	
		return this;
	}
	
	function removePointerListener(obj, type, id) {
		var handler = obj['_leaflet_' + type + id];
	
		if (type === 'touchstart') {
			obj.removeEventListener(POINTER_DOWN, handler, false);
	
		} else if (type === 'touchmove') {
			obj.removeEventListener(POINTER_MOVE, handler, false);
	
		} else if (type === 'touchend') {
			obj.removeEventListener(POINTER_UP, handler, false);
			obj.removeEventListener(POINTER_CANCEL, handler, false);
		}
	
		return this;
	}
	
	function _addPointerStart(obj, handler, id) {
		var onDown = bind(function (e) {
			if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				// In IE11, some touch events needs to fire for form controls, or
				// the controls will stop working. We keep a whitelist of tag names that
				// need these events. For other target tags, we prevent default on the event.
				if (TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
					preventDefault(e);
				} else {
					return;
				}
			}
	
			_handlePointer(e, handler);
		});
	
		obj['_leaflet_touchstart' + id] = onDown;
		obj.addEventListener(POINTER_DOWN, onDown, false);
	
		// need to keep track of what pointers and how many are active to provide e.touches emulation
		if (!_pointerDocListener) {
			// we listen documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(POINTER_DOWN, _globalPointerDown, true);
			document.documentElement.addEventListener(POINTER_MOVE, _globalPointerMove, true);
			document.documentElement.addEventListener(POINTER_UP, _globalPointerUp, true);
			document.documentElement.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
			_pointerDocListener = true;
		}
	}
	
	function _globalPointerDown(e) {
		_pointers[e.pointerId] = e;
		_pointersCount++;
	}
	
	function _globalPointerMove(e) {
		if (_pointers[e.pointerId]) {
			_pointers[e.pointerId] = e;
		}
	}
	
	function _globalPointerUp(e) {
		delete _pointers[e.pointerId];
		_pointersCount--;
	}
	
	function _handlePointer(e, handler) {
		e.touches = [];
		for (var i in _pointers) {
			e.touches.push(_pointers[i]);
		}
		e.changedTouches = [e];
	
		handler(e);
	}
	
	function _addPointerMove(obj, handler, id) {
		var onMove = function (e) {
			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchmove' + id] = onMove;
		obj.addEventListener(POINTER_MOVE, onMove, false);
	}
	
	function _addPointerEnd(obj, handler, id) {
		var onUp = function (e) {
			_handlePointer(e, handler);
		};
	
		obj['_leaflet_touchend' + id] = onUp;
		obj.addEventListener(POINTER_UP, onUp, false);
		obj.addEventListener(POINTER_CANCEL, onUp, false);
	}
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
	var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
	var _pre = '_leaflet_';
	
	// inspired by Zepto touch code by Thomas Fuchs
	function addDoubleTapListener(obj, handler, id) {
		var last, touch$$1,
		    doubleTap = false,
		    delay = 250;
	
		function onTouchStart(e) {
			var count;
	
			if (pointer) {
				if ((!edge) || e.pointerType === 'mouse') { return; }
				count = _pointersCount;
			} else {
				count = e.touches.length;
			}
	
			if (count > 1) { return; }
	
			var now = Date.now(),
			    delta = now - (last || now);
	
			touch$$1 = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}
	
		function onTouchEnd(e) {
			if (doubleTap && !touch$$1.cancelBubble) {
				if (pointer) {
					if ((!edge) || e.pointerType === 'mouse') { return; }
					// work around .type being readonly with MSPointer* events
					var newTouch = {},
					    prop, i;
	
					for (i in touch$$1) {
						prop = touch$$1[i];
						newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
					}
					touch$$1 = newTouch;
				}
				touch$$1.type = 'dblclick';
				touch$$1.button = 0;
				handler(touch$$1);
				last = null;
			}
		}
	
		obj[_pre + _touchstart + id] = onTouchStart;
		obj[_pre + _touchend + id] = onTouchEnd;
		obj[_pre + 'dblclick' + id] = handler;
	
		obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? {passive: false} : false);
		obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? {passive: false} : false);
	
		// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
		// the browser doesn't fire touchend/pointerup events but does fire
		// native dblclicks. See #4127.
		// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
		obj.addEventListener('dblclick', handler, false);
	
		return this;
	}
	
	function removeDoubleTapListener(obj, id) {
		var touchstart = obj[_pre + _touchstart + id],
		    touchend = obj[_pre + _touchend + id],
		    dblclick = obj[_pre + 'dblclick' + id];
	
		obj.removeEventListener(_touchstart, touchstart, passiveEvents ? {passive: false} : false);
		obj.removeEventListener(_touchend, touchend, passiveEvents ? {passive: false} : false);
		if (!edge) {
			obj.removeEventListener('dblclick', dblclick, false);
		}
	
		return this;
	}
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	
	// @property TRANSFORM: String
	// Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	var TRANSFORM = testProp(
		['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser
	
	// @property TRANSITION: String
	// Vendor-prefixed transition style name.
	var TRANSITION = testProp(
		['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	// @property TRANSITION_END: String
	// Vendor-prefixed transitionend event name.
	var TRANSITION_END =
		TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	// @function get(id: String|HTMLElement): HTMLElement
	// Returns an element given its DOM id, or returns the element itself
	// if it was passed directly.
	function get(id) {
		return typeof id === 'string' ? document.getElementById(id) : id;
	}
	
	// @function getStyle(el: HTMLElement, styleAttrib: String): String
	// Returns the value for a certain style attribute on an element,
	// including computed values or values set through CSS.
	function getStyle(el, style) {
		var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}
		return value === 'auto' ? null : value;
	}
	
	// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	function create$1(tagName, className, container) {
		var el = document.createElement(tagName);
		el.className = className || '';
	
		if (container) {
			container.appendChild(el);
		}
		return el;
	}
	
	// @function remove(el: HTMLElement)
	// Removes `el` from its parent element
	function remove(el) {
		var parent = el.parentNode;
		if (parent) {
			parent.removeChild(el);
		}
	}
	
	// @function empty(el: HTMLElement)
	// Removes all of `el`'s children elements from `el`
	function empty(el) {
		while (el.firstChild) {
			el.removeChild(el.firstChild);
		}
	}
	
	// @function toFront(el: HTMLElement)
	// Makes `el` the last child of its parent, so it renders in front of the other children.
	function toFront(el) {
		var parent = el.parentNode;
		if (parent && parent.lastChild !== el) {
			parent.appendChild(el);
		}
	}
	
	// @function toBack(el: HTMLElement)
	// Makes `el` the first child of its parent, so it renders behind the other children.
	function toBack(el) {
		var parent = el.parentNode;
		if (parent && parent.firstChild !== el) {
			parent.insertBefore(el, parent.firstChild);
		}
	}
	
	// @function hasClass(el: HTMLElement, name: String): Boolean
	// Returns `true` if the element's class attribute contains `name`.
	function hasClass(el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	}
	
	// @function addClass(el: HTMLElement, name: String)
	// Adds `name` to the element's class attribute.
	function addClass(el, name) {
		if (el.classList !== undefined) {
			var classes = splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!hasClass(el, name)) {
			var className = getClass(el);
			setClass(el, (className ? className + ' ' : '') + name);
		}
	}
	
	// @function removeClass(el: HTMLElement, name: String)
	// Removes `name` from the element's class attribute.
	function removeClass(el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	}
	
	// @function setClass(el: HTMLElement, name: String)
	// Sets the element's class.
	function setClass(el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	}
	
	// @function getClass(el: HTMLElement): String
	// Returns the element's class.
	function getClass(el) {
		// Check if the element is an SVGElementInstance and use the correspondingElement instead
		// (Required for linked SVG elements in IE11.)
		if (el.correspondingElement) {
			el = el.correspondingElement;
		}
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	}
	
	// @function setOpacity(el: HTMLElement, opacity: Number)
	// Set the opacity of an element (including old IE support).
	// `opacity` must be a number from `0` to `1`.
	function setOpacity(el, value) {
		if ('opacity' in el.style) {
			el.style.opacity = value;
		} else if ('filter' in el.style) {
			_setOpacityIE(el, value);
		}
	}
	
	function _setOpacityIE(el, value) {
		var filter = false,
		    filterName = 'DXImageTransform.Microsoft.Alpha';
	
		// filters collection throws an error if we try to retrieve a filter that doesn't exist
		try {
			filter = el.filters.item(filterName);
		} catch (e) {
			// don't set opacity to 1 if we haven't already set an opacity,
			// it isn't needed and breaks transparent pngs.
			if (value === 1) { return; }
		}
	
		value = Math.round(value * 100);
	
		if (filter) {
			filter.Enabled = (value !== 100);
			filter.Opacity = value;
		} else {
			el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
		}
	}
	
	// @function testProp(props: String[]): String|false
	// Goes through the array of style names and returns the first name
	// that is a valid style name for an element. If no such name is found,
	// it returns false. Useful for vendor-prefixed styles like `transform`.
	function testProp(props) {
		var style = document.documentElement.style;
	
		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	}
	
	// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	// and optionally scaled by `scale`. Does not have an effect if the
	// browser doesn't support 3D CSS transforms.
	function setTransform(el, offset, scale) {
		var pos = offset || new Point(0, 0);
	
		el.style[TRANSFORM] =
			(ie3d ?
				'translate(' + pos.x + 'px,' + pos.y + 'px)' :
				'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
			(scale ? ' scale(' + scale + ')' : '');
	}
	
	// @function setPosition(el: HTMLElement, position: Point)
	// Sets the position of `el` to coordinates specified by `position`,
	// using CSS translate or top/left positioning depending on the browser
	// (used by Leaflet internally to position its layers).
	function setPosition(el, point) {
	
		/*eslint-disable */
		el._leaflet_pos = point;
		/* eslint-enable */
	
		if (any3d) {
			setTransform(el, point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	}
	
	// @function getPosition(el: HTMLElement): Point
	// Returns the coordinates of an element previously positioned with setPosition.
	function getPosition(el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance
	
		return el._leaflet_pos || new Point(0, 0);
	}
	
	// @function disableTextSelection()
	// Prevents the user from generating `selectstart` DOM events, usually generated
	// when the user drags the mouse through a page with text. Used internally
	// by Leaflet to override the behaviour of any click-and-drag interaction on
	// the map. Affects drag interactions on the whole document.
	
	// @function enableTextSelection()
	// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	var disableTextSelection;
	var enableTextSelection;
	var _userSelect;
	if ('onselectstart' in document) {
		disableTextSelection = function () {
			on(window, 'selectstart', preventDefault);
		};
		enableTextSelection = function () {
			off(window, 'selectstart', preventDefault);
		};
	} else {
		var userSelectProperty = testProp(
			['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
		disableTextSelection = function () {
			if (userSelectProperty) {
				var style = document.documentElement.style;
				_userSelect = style[userSelectProperty];
				style[userSelectProperty] = 'none';
			}
		};
		enableTextSelection = function () {
			if (userSelectProperty) {
				document.documentElement.style[userSelectProperty] = _userSelect;
				_userSelect = undefined;
			}
		};
	}
	
	// @function disableImageDrag()
	// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	// for `dragstart` DOM events, usually generated when the user drags an image.
	function disableImageDrag() {
		on(window, 'dragstart', preventDefault);
	}
	
	// @function enableImageDrag()
	// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	function enableImageDrag() {
		off(window, 'dragstart', preventDefault);
	}
	
	var _outlineElement;
	var _outlineStyle;
	// @function preventOutline(el: HTMLElement)
	// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	// of the element `el` invisible. Used internally by Leaflet to prevent
	// focusable elements from displaying an outline when the user performs a
	// drag interaction on them.
	function preventOutline(element) {
		while (element.tabIndex === -1) {
			element = element.parentNode;
		}
		if (!element.style) { return; }
		restoreOutline();
		_outlineElement = element;
		_outlineStyle = element.style.outline;
		element.style.outline = 'none';
		on(window, 'keydown', restoreOutline);
	}
	
	// @function restoreOutline()
	// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	function restoreOutline() {
		if (!_outlineElement) { return; }
		_outlineElement.style.outline = _outlineStyle;
		_outlineElement = undefined;
		_outlineStyle = undefined;
		off(window, 'keydown', restoreOutline);
	}
	
	// @function getSizedParentNode(el: HTMLElement): HTMLElement
	// Finds the closest parent node which size (width and height) is not null.
	function getSizedParentNode(element) {
		do {
			element = element.parentNode;
		} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
		return element;
	}
	
	// @function getScale(el: HTMLElement): Object
	// Computes the CSS scale currently applied on the element.
	// Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	// and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	function getScale(element) {
		var rect = element.getBoundingClientRect(); // Read-only in old browsers.
	
		return {
			x: rect.width / element.offsetWidth || 1,
			y: rect.height / element.offsetHeight || 1,
			boundingClientRect: rect
		};
	}
	
	
	var DomUtil = (Object.freeze || Object)({
		TRANSFORM: TRANSFORM,
		TRANSITION: TRANSITION,
		TRANSITION_END: TRANSITION_END,
		get: get,
		getStyle: getStyle,
		create: create$1,
		remove: remove,
		empty: empty,
		toFront: toFront,
		toBack: toBack,
		hasClass: hasClass,
		addClass: addClass,
		removeClass: removeClass,
		setClass: setClass,
		getClass: getClass,
		setOpacity: setOpacity,
		testProp: testProp,
		setTransform: setTransform,
		setPosition: setPosition,
		getPosition: getPosition,
		disableTextSelection: disableTextSelection,
		enableTextSelection: enableTextSelection,
		disableImageDrag: disableImageDrag,
		enableImageDrag: enableImageDrag,
		preventOutline: preventOutline,
		restoreOutline: restoreOutline,
		getSizedParentNode: getSizedParentNode,
		getScale: getScale
	});
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Adds a listener function (`fn`) to a particular DOM event type of the
	// element `el`. You can optionally specify the context of the listener
	// (object the `this` keyword will point to). You can also pass several
	// space-separated types (e.g. `'click dblclick'`).
	
	// @alternative
	// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function on(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				addOne(obj, type, types[type], fn);
			}
		} else {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				addOne(obj, types[i], fn, context);
			}
		}
	
		return this;
	}
	
	var eventsKey = '_leaflet_events';
	
	// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Removes a previously added listener function.
	// Note that if you passed a custom context to on, you must pass the same
	// context to `off` in order to remove the listener.
	
	// @alternative
	// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	function off(obj, types, fn, context) {
	
		if (typeof types === 'object') {
			for (var type in types) {
				removeOne(obj, type, types[type], fn);
			}
		} else if (types) {
			types = splitWords(types);
	
			for (var i = 0, len = types.length; i < len; i++) {
				removeOne(obj, types[i], fn, context);
			}
		} else {
			for (var j in obj[eventsKey]) {
				removeOne(obj, j, obj[eventsKey][j]);
			}
			delete obj[eventsKey];
		}
	
		return this;
	}
	
	function addOne(obj, type, fn, context) {
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
		if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};
	
		var originalHandler = handler;
	
		if (pointer && type.indexOf('touch') === 0) {
			// Needs DomEvent.Pointer.js
			addPointerListener(obj, type, handler, id);
	
		} else if (touch && (type === 'dblclick') && addDoubleTapListener &&
		           !(pointer && chrome)) {
			// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
			// See #5180
			addDoubleTapListener(obj, handler, id);
	
		} else if ('addEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, passiveEvents ? {passive: false} : false);
	
			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				handler = function (e) {
					e = e || window.event;
					if (isExternalTarget(obj, e)) {
						originalHandler(e);
					}
				};
				obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
			} else {
				if (type === 'click' && android) {
					handler = function (e) {
						filterClick(e, originalHandler);
					};
				}
				obj.addEventListener(type, handler, false);
			}
	
		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}
	
		obj[eventsKey] = obj[eventsKey] || {};
		obj[eventsKey][id] = handler;
	}
	
	function removeOne(obj, type, fn, context) {
	
		var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
		    handler = obj[eventsKey] && obj[eventsKey][id];
	
		if (!handler) { return this; }
	
		if (pointer && type.indexOf('touch') === 0) {
			removePointerListener(obj, type, id);
	
		} else if (touch && (type === 'dblclick') && removeDoubleTapListener &&
		           !(pointer && chrome)) {
			removeDoubleTapListener(obj, id);
	
		} else if ('removeEventListener' in obj) {
	
			if (type === 'mousewheel') {
				obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, passiveEvents ? {passive: false} : false);
	
			} else {
				obj.removeEventListener(
					type === 'mouseenter' ? 'mouseover' :
					type === 'mouseleave' ? 'mouseout' : type, handler, false);
			}
	
		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}
	
		obj[eventsKey][id] = null;
	}
	
	// @function stopPropagation(ev: DOMEvent): this
	// Stop the given event from propagation to parent elements. Used inside the listener functions:
	// ```js
	// L.DomEvent.on(div, 'click', function (ev) {
	// 	L.DomEvent.stopPropagation(ev);
	// });
	// ```
	function stopPropagation(e) {
	
		if (e.stopPropagation) {
			e.stopPropagation();
		} else if (e.originalEvent) {  // In case of Leaflet event.
			e.originalEvent._stopped = true;
		} else {
			e.cancelBubble = true;
		}
		skipped(e);
	
		return this;
	}
	
	// @function disableScrollPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
	function disableScrollPropagation(el) {
		addOne(el, 'mousewheel', stopPropagation);
		return this;
	}
	
	// @function disableClickPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	// `'mousedown'` and `'touchstart'` events (plus browser variants).
	function disableClickPropagation(el) {
		on(el, 'mousedown touchstart dblclick', stopPropagation);
		addOne(el, 'click', fakeStop);
		return this;
	}
	
	// @function preventDefault(ev: DOMEvent): this
	// Prevents the default action of the DOM Event `ev` from happening (such as
	// following a link in the href of the a element, or doing a POST request
	// with page reload when a `<form>` is submitted).
	// Use it inside listener functions.
	function preventDefault(e) {
		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	}
	
	// @function stop(ev: DOMEvent): this
	// Does `stopPropagation` and `preventDefault` at the same time.
	function stop(e) {
		preventDefault(e);
		stopPropagation(e);
		return this;
	}
	
	// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	// Gets normalized mouse position from a DOM event relative to the
	// `container` (border excluded) or to the whole page if not specified.
	function getMousePosition(e, container) {
		if (!container) {
			return new Point(e.clientX, e.clientY);
		}
	
		var scale = getScale(container),
		    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
	
		return new Point(
			// offset.left/top values are in page scale (like clientX/Y),
			// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
			(e.clientX - offset.left) / scale.x - container.clientLeft,
			(e.clientY - offset.top) / scale.y - container.clientTop
		);
	}
	
	// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	// and Firefox scrolls device pixels, not CSS pixels
	var wheelPxFactor =
		(win && chrome) ? 2 * window.devicePixelRatio :
		gecko ? window.devicePixelRatio : 1;
	
	// @function getWheelDelta(ev: DOMEvent): Number
	// Gets normalized wheel delta from a mousewheel DOM event, in vertical
	// pixels scrolled (negative if scrolling down).
	// Events from pointing devices without precise scrolling are mapped to
	// a best guess of 60 pixels.
	function getWheelDelta(e) {
		return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
		       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
		       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
		       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
		       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
		       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
		       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
		       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
		       0;
	}
	
	var skipEvents = {};
	
	function fakeStop(e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
		skipEvents[e.type] = true;
	}
	
	function skipped(e) {
		var events = skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		skipEvents[e.type] = false;
		return events;
	}
	
	// check if element really left/entered the event target (for mouseenter/mouseleave)
	function isExternalTarget(el, e) {
	
		var related = e.relatedTarget;
	
		if (!related) { return true; }
	
		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	}
	
	var lastClick;
	
	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	function filterClick(e, handler) {
		var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
		    elapsed = lastClick && (timeStamp - lastClick);
	
		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			stop(e);
			return;
		}
		lastClick = timeStamp;
	
		handler(e);
	}
	
	
	
	
	var DomEvent = (Object.freeze || Object)({
		on: on,
		off: off,
		stopPropagation: stopPropagation,
		disableScrollPropagation: disableScrollPropagation,
		disableClickPropagation: disableClickPropagation,
		preventDefault: preventDefault,
		stop: stop,
		getMousePosition: getMousePosition,
		getWheelDelta: getWheelDelta,
		fakeStop: fakeStop,
		skipped: skipped,
		isExternalTarget: isExternalTarget,
		addListener: on,
		removeListener: off
	});
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	var PosAnimation = Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	var Map = Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = *
			// Minimum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the lowest of their `minZoom` options will be used instead.
			minZoom: undefined,
	
			// @option maxZoom: Number = *
			// Maximum zoom level of the map.
			// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
			// the highest of their `maxZoom` options will be used instead.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = setOptions(this, options);
	
			// Make sure to assign internal flags at the beginning,
			// to avoid inconsistent state in some edge cases.
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(toLatLng(options.center), options.zoom, {reset: true});
			}
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = extend({animate: options.animate}, options.zoom);
					options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options?: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
			var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			if (zoom === Infinity) {
				return {
					center: bounds.getCenter(),
					zoom: zoom
				};
			}
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point, options?: Pan options): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = toPoint(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = toLatLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true, options.noMoveStart);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = toLatLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			var oldZoom = this.options.minZoom;
			this.options.minZoom = zoom;
	
			if (this._loaded && oldZoom !== zoom) {
				this.fire('zoomlevelschange');
	
				if (this.getZoom() < this.options.minZoom) {
					return this.setZoom(zoom);
				}
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			var oldZoom = this.options.maxZoom;
			this.options.maxZoom = zoom;
	
			if (this._loaded && oldZoom !== zoom) {
				this.fire('zoomlevelschange');
	
				if (this.getZoom() > this.options.maxZoom) {
					return this.setZoom(zoom);
				}
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method panInside(latlng: LatLng, options?: options): this
		// Pans the map the minimum amount to make the `latlng` visible. Use
		// `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
		// the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
		// If `latlng` is already within the (optionally padded) display bounds,
		// the map will not be panned.
		panInside: function (latlng, options) {
			options = options || {};
	
			var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
			    center = this.getCenter(),
			    pixelCenter = this.project(center),
			    pixelPoint = this.project(latlng),
			    pixelBounds = this.getPixelBounds(),
			    halfPixelBounds = pixelBounds.getSize().divideBy(2),
			    paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]);
	
			if (!paddedBounds.contains(pixelPoint)) {
				this._enforcingBounds = true;
				var diff = pixelCenter.subtract(pixelPoint),
				    newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);
	
				if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
					newCenter.x = pixelCenter.x - diff.x;
					if (diff.x > 0) {
						newCenter.x += halfPixelBounds.x - paddingTL.x;
					} else {
						newCenter.x -= halfPixelBounds.x - paddingBR.x;
					}
				}
				if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
					newCenter.y = pixelCenter.y - diff.y;
					if (diff.y > 0) {
						newCenter.y += halfPixelBounds.y - paddingTL.y;
					} else {
						newCenter.y -= halfPixelBounds.y - paddingBR.y;
					}
				}
				this.panTo(this.unproject(newCenter), options);
				this._enforcingBounds = false;
			}
			return this;
		},
	
		// @method invalidateSize(options: Zoom/pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = bind(this._handleGeolocationResponse, this),
			    onError = bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy * 2),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO Appropriate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/* eslint-enable */
				this._containerId = undefined;
			}
	
			if (this._locationWatchId !== undefined) {
				this.stopLocate();
			}
	
			this._stop();
	
			remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
			if (this._resizeRequest) {
				cancelAnimFrame(this._resizeRequest);
				this._resizeRequest = null;
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			var i;
			for (i in this._layers) {
				this._layers[i].remove();
			}
			for (i in this._panes) {
				remove(this._panes[i]);
			}
	
			this._layers = [];
			this._panes = [];
			delete this._mapPane;
			delete this._renderer;
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a child of `container`, or
		// as a child of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = create$1('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = toLatLngBounds(bounds);
			padding = toPoint(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = any3d ? this.options.zoomSnap : 1,
			    scalex = size.x / boundsSize.x,
			    scaley = size.y / boundsSize.y,
			    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(toPoint(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = toPoint(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(toLatLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(toLatLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return toPoint(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return toPoint(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(toPoint(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			on(container, 'scroll', this._onScroll, this);
			this._containerId = stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && any3d;
	
			addClass(container, 'leaflet-container' +
				(touch ? ' leaflet-touch' : '') +
				(retina ? ' leaflet-retina' : '') +
				(ielt9 ? ' leaflet-oldie' : '') +
				(safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			setPosition(this._mapPane, new Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for `Tooltip`s.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				addClass(panes.markerPane, 'leaflet-zoom-hide');
				addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			setPosition(this._mapPane, new Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged, false)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged, noMoveStart) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			if (!noMoveStart) {
				this.fire('movestart');
			}
			return this;
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove$$1) {
			this._targets = {};
			this._targets[stamp(this._container)] = this;
	
			var onOff = remove$$1 ? off : on;
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
			// @event keydown: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
			// the `keydown` event is fired for keys that produce a character value and for keys
			// that do not produce a character value.
			// @event keyup: KeyboardEvent
			// Fired when the user releases a key from the keyboard while the map is focused.
			onOff(this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				onOff(window, 'resize', this._onResize, this);
			}
	
			if (any3d && this.options.transform3DLimit) {
				(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || skipped(e)) { return; }
	
			var type = e.type;
	
			if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') {
				// prevents outline when clicking on keyboard-focusable element
				preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
				var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
				data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return getPosition(this._mapPane) || new Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return toBounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = toBounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._trunc();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = TRANSFORM,
				    transform = this._proxy.style[prop];
	
				setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === this._proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', this._animMoveEnd, this);
	
			this._on('unload', this._destroyAnimProxy, this);
		},
	
		_destroyAnimProxy: function () {
			remove(this._proxy);
			this.off('load moveend', this._animMoveEnd, this);
			delete this._proxy;
		},
	
		_animMoveEnd: function () {
			var c = this.getCenter(),
			    z = this.getZoom();
			setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			requestAnimFrame(function () {
				this
				    ._moveStart(true, false)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (!this._mapPane) { return; }
	
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @section Other Events
			// @event zoomanim: ZoomAnimEvent
			// Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			if (this._mapPane) {
				removeClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	function createMap(id, options) {
		return new Map(id, options);
	}
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	var Control = Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			this._map.on('unload', this.remove, this);
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map.off('unload', this.remove, this);
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	var control = function (options) {
		return new Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            create$1('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = create$1('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			for (var i in this._controlCorners) {
				remove(this._controlCorners[i]);
			}
			remove(this._controlContainer);
			delete this._controlCorners;
			delete this._controlContainer;
		}
	});
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	var Layers = Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			setOptions(this, options);
	
			this._layerControlInputs = [];
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.on('add remove', this._onLayerChange, this);
			}
	
			return this._container;
		},
	
		addTo: function (map) {
			Control.prototype.addTo.call(this, map);
			// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
			return this._expandIfNotCollapsed();
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			addClass(this._container, 'leaflet-control-layers-expanded');
			this._section.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._section.clientHeight) {
				addClass(this._section, 'leaflet-control-layers-scrollbar');
				this._section.style.height = acceptableHeight + 'px';
			} else {
				removeClass(this._section, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = create$1('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			disableClickPropagation(container);
			disableScrollPropagation(container);
	
			var section = this._section = create$1('section', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!android) {
					on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = create$1('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (touch) {
				on(link, 'click', stop);
				on(link, 'click', this.expand, this);
			} else {
				on(link, 'focus', this.expand, this);
			}
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = create$1('div', className + '-base', section);
			this._separator = create$1('div', className + '-separator', section);
			this._overlaysList = create$1('div', className + '-overlays', section);
	
			container.appendChild(section);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			if (this._map) {
				layer.on('add remove', this._onLayerChange, this);
			}
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
	
			this._expandIfNotCollapsed();
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			empty(this._baseLayersList);
			empty(this._overlaysList);
	
			this._layerControlInputs = [];
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
			}
	
			this._layerControlInputs.push(input);
			input.layerId = stamp(obj.layer);
	
			on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._layerControlInputs,
			    input, layer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
	
				if (input.checked) {
					addedLayers.push(layer);
				} else if (!input.checked) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				if (this._map.hasLayer(removedLayers[i])) {
					this._map.removeLayer(removedLayers[i]);
				}
			}
			for (i = 0; i < addedLayers.length; i++) {
				if (!this._map.hasLayer(addedLayers[i])) {
					this._map.addLayer(addedLayers[i]);
				}
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._layerControlInputs,
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expandIfNotCollapsed: function () {
			if (this._map && !this.options.collapsed) {
				this.expand();
			}
			return this;
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	var layers = function (baseLayers, overlays, options) {
		return new Layers(baseLayers, overlays, options);
	};
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	var Zoom = Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '&#x2212;'
			// The text set on the 'zoom out' button.
			zoomOutText: '&#x2212;',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = create$1('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = create$1('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			disableClickPropagation(link);
			on(link, 'click', stop);
			on(link, 'click', fn, this);
			on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			removeClass(this._zoomInButton, className);
			removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	Map.mergeOptions({
		zoomControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.zoomControl) {
			// @section Controls
			// @property zoomControl: Control.Zoom
			// The default zoom control (only available if the
			// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
			this.zoomControl = new Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	var zoom = function (options) {
		return new Zoom(options);
	};
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	var Scale = Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = create$1('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = create$1('div', className, container);
			}
			if (options.imperial) {
				this._iScale = create$1('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	var scale = function (options) {
		return new Scale(options);
	};
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	var Attribution = Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = create$1('div', 'leaflet-control-attribution');
			disableClickPropagation(this._container);
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	Map.mergeOptions({
		attributionControl: true
	});
	
	Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	var attribution = function (options) {
		return new Attribution(options);
	};
	
	Control.Layers = Layers;
	Control.Zoom = Zoom;
	Control.Scale = Scale;
	Control.Attribution = Attribution;
	
	control.layers = layers;
	control.zoom = zoom;
	control.scale = scale;
	control.attribution = attribution;
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	var Handler = Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	// @section There is static function which can be called without instantiating L.Handler:
	// @function addTo(map: Map, name: String): this
	// Adds a new Handler to the given map with the given name.
	Handler.addTo = function (map, name) {
		map.addHandler(name, this);
		return this;
	};
	
	var Mixin = {Events: Events};
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	var START = touch ? 'touchstart mousedown' : 'mousedown';
	var END = {
		mousedown: 'mouseup',
		touchstart: 'touchend',
		pointerdown: 'touchend',
		MSPointerDown: 'touchend'
	};
	var MOVE = {
		mousedown: 'mousemove',
		touchstart: 'touchmove',
		pointerdown: 'touchmove',
		MSPointerDown: 'touchmove'
	};
	
	
	var Draggable = Evented.extend({
	
		options: {
			// @section
			// @aka Draggable options
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline$$1, options) {
			setOptions(this, options);
	
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline$$1;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			on(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (Draggable._dragging === this) {
				this.finishDrag();
			}
	
			off(this._dragStartTarget, START, this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				preventOutline(this._element);
			}
	
			disableImageDrag();
			disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e,
			    sizedParent = getSizedParentNode(this._element);
	
			this._startPoint = new Point(first.clientX, first.clientY);
	
			// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
			this._parentScale = getScale(sizedParent);
	
			on(document, MOVE[e.type], this._onMove, this);
			on(document, END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			// We assume that the parent container's position, border and scale do not change for the duration of the drag.
			// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
			// and we can use the cached value for the scale.
			offset.x /= this._parentScale.x;
			offset.y /= this._parentScale.y;
	
			preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = getPosition(this._element).subtract(offset);
	
				addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in MOVE) {
				off(document, MOVE[i], this._onMove, this);
				off(document, END[i], this._onUp, this);
			}
	
			enableImageDrag();
			enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			Draggable._dragging = false;
		}
	
	});
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.
	
	// @function simplify(points: Point[], tolerance: Number): Point[]
	// Dramatically reduces the number of points in a polyline while retaining
	// its shape and returns a new array of simplified points, using the
	// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	// Used for a huge performance boost when processing/displaying Leaflet polylines for
	// each zoom level and also reducing visual noise. tolerance affects the amount of
	// simplification (lesser value means higher quality but slower and with more points).
	// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	function simplify(points, tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}
	
		var sqTolerance = tolerance * tolerance;
	
		    // stage 1: vertex reduction
		    points = _reducePoints(points, sqTolerance);
	
		    // stage 2: Douglas-Peucker simplification
		    points = _simplifyDP(points, sqTolerance);
	
		return points;
	}
	
	// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	// Returns the distance between point `p` and segment `p1` to `p2`.
	function pointToSegmentDistance(p, p1, p2) {
		return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	}
	
	// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	// Returns the closest point from a point `p` on a segment `p1` to `p2`.
	function closestPointOnSegment(p, p1, p2) {
		return _sqClosestPointOnSegment(p, p1, p2);
	}
	
	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	function _simplifyDP(points, sqTolerance) {
	
		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);
	
		    markers[0] = markers[len - 1] = 1;
	
		_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
		var i,
		    newPoints = [];
	
		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}
	
		return newPoints;
	}
	
	function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
		var maxSqDist = 0,
		index, i, sqDist;
	
		for (i = first + 1; i <= last - 1; i++) {
			sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}
	
		if (maxSqDist > sqTolerance) {
			markers[index] = 1;
	
			_simplifyDPStep(points, markers, sqTolerance, first, index);
			_simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	}
	
	// reduce points that are too close to each other to a single point
	function _reducePoints(points, sqTolerance) {
		var reducedPoints = [points[0]];
	
		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (_sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	}
	
	var _lastCode;
	
	// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	// Clips the segment a to b by rectangular bounds with the
	// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	// (modifying the segment points directly!). Used by Leaflet to only show polyline
	// points that are on the screen or near, increasing performance.
	function clipSegment(a, b, bounds, useLastCode, round) {
		var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
		    codeB = _getBitCode(b, bounds),
	
		    codeOut, p, newCode;
	
		    // save 2nd code to avoid calculating it on the next segment
		    _lastCode = codeB;
	
		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			}
	
			// if a,b is outside the clip window (trivial reject)
			if (codeA & codeB) {
				return false;
			}
	
			// other cases
			codeOut = codeA || codeB;
			p = _getEdgeIntersection(a, b, codeOut, bounds, round);
			newCode = _getBitCode(p, bounds);
	
			if (codeOut === codeA) {
				a = p;
				codeA = newCode;
			} else {
				b = p;
				codeB = newCode;
			}
		}
	}
	
	function _getEdgeIntersection(a, b, code, bounds, round) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max,
		    x, y;
	
		if (code & 8) { // top
			x = a.x + dx * (max.y - a.y) / dy;
			y = max.y;
	
		} else if (code & 4) { // bottom
			x = a.x + dx * (min.y - a.y) / dy;
			y = min.y;
	
		} else if (code & 2) { // right
			x = max.x;
			y = a.y + dy * (max.x - a.x) / dx;
	
		} else if (code & 1) { // left
			x = min.x;
			y = a.y + dy * (min.x - a.x) / dx;
		}
	
		return new Point(x, y, round);
	}
	
	function _getBitCode(p, bounds) {
		var code = 0;
	
		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}
	
		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}
	
		return code;
	}
	
	// square distance (to avoid unnecessary Math.sqrt calls)
	function _sqDist(p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	}
	
	// return closest point on segment or distance to that point
	function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;
	
		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}
	
		dx = p.x - x;
		dy = p.y - y;
	
		return sqDist ? dx * dx + dy * dy : new Point(x, y);
	}
	
	
	// @function isFlat(latlngs: LatLng[]): Boolean
	// Returns true if `latlngs` is a flat array, false is nested.
	function isFlat(latlngs) {
		return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	}
	
	function _flat(latlngs) {
		console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
		return isFlat(latlngs);
	}
	
	
	var LineUtil = (Object.freeze || Object)({
		simplify: simplify,
		pointToSegmentDistance: pointToSegmentDistance,
		closestPointOnSegment: closestPointOnSegment,
		clipSegment: clipSegment,
		_getEdgeIntersection: _getEdgeIntersection,
		_getBitCode: _getBitCode,
		_sqClosestPointOnSegment: _sqClosestPointOnSegment,
		isFlat: isFlat,
		_flat: _flat
	});
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a separate method for it.
	 */
	function clipPolygon(points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = _getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = _getEdgeIntersection(b, a, edge, bounds, round);
						p._code = _getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = _getEdgeIntersection(b, a, edge, bounds, round);
					p._code = _getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	}
	
	
	var PolyUtil = (Object.freeze || Object)({
		clipPolygon: clipPolygon
	});
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:4326` and `Simple` CRS.
	 */
	
	var LonLat = {
		project: function (latlng) {
			return new Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new LatLng(point.y, point.x);
		},
	
		bounds: new Bounds([-180, -90], [180, 90])
	};
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
	 */
	
	var Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new LatLng(phi * d, point.x * d / r);
		}
	};
	
	/*
	 * @class Projection
	
	 * An object with methods for projecting geographical coordinates of the world onto
	 * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).
	
	 * @property bounds: Bounds
	 * The bounds (specified in CRS units) where the projection is valid
	
	 * @method project(latlng: LatLng): Point
	 * Projects geographical coordinates into a 2D point.
	 * Only accepts actual `L.LatLng` instances, not arrays.
	
	 * @method unproject(point: Point): LatLng
	 * The inverse of `project`. Projects a 2D point into a geographical location.
	 * Only accepts actual `L.Point` instances, not arrays.
	
	 * Note that the projection instances do not inherit from Leafet's `Class` object,
	 * and can't be instantiated. Also, new classes can't inherit from them,
	 * and methods can't be added to them with the `include` function.
	
	 */
	
	
	
	
	var index = (Object.freeze || Object)({
		LonLat: LonLat,
		Mercator: Mercator,
		SphericalMercator: SphericalMercator
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	var EPSG3395 = extend({}, Earth, {
		code: 'EPSG:3395',
		projection: Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * Mercator.R);
			return toTransformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	var EPSG4326 = extend({}, Earth, {
		code: 'EPSG:4326',
		projection: LonLat,
		transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	var Simple = extend({}, CRS, {
		projection: LonLat,
		transformation: toTransformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	CRS.Earth = Earth;
	CRS.EPSG3395 = EPSG3395;
	CRS.EPSG3857 = EPSG3857;
	CRS.EPSG900913 = EPSG900913;
	CRS.EPSG4326 = EPSG4326;
	CRS.Simple = Simple;
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	var Layer = Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
	
			// @option attribution: String = null
			// String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
			attribution: null,
	
			bubblingMouseEvents: true
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map|LayerGroup): this
		 * Adds the layer to the given map or layer group.
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			if (!layer._layerAdd) {
				throw new Error('The provided object is not a Layer.');
			}
	
			var id = stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	var LayerGroup = Layer.extend({
	
		initialize: function (layers, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		// @alternative
		// @method hasLayer(id: Number): Boolean
		// Returns `true` if the given internal ID is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			return this.eachLayer(this.removeLayer, this);
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			this.eachLayer(map.addLayer, map);
		},
	
		onRemove: function (map) {
			this.eachLayer(map.removeLayer, map);
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
			this.eachLayer(layers.push, layers);
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers?: Layer[], options?: Object)
	// Create a layer group, optionally given an initial set of layers and an `options` object.
	var layerGroup = function (layers, options) {
		return new LayerGroup(layers, options);
	};
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	var FeatureGroup = LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the back of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	var featureGroup = function (layers) {
		return new FeatureGroup(layers);
	};
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	var Icon = Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = [0, 0]
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option tooltipAnchor: Point = [0, 0]
		 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		options: {
			popupAnchor: [0, 0],
			tooltipAnchor: [0, 0]
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = toPoint(sizeOption),
			    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	function icon(options) {
		return new Icon(options);
	}
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	var IconDefault = Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
				IconDefault.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `Icon.Default` will try to auto-detect the location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right path.
			return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = create$1('div',  'leaflet-default-icon-path', document.body);
			var path = getStyle(el, 'background-image') ||
			           getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			if (path === null || path.indexOf('url') !== 0) {
				path = '';
			} else {
				path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
			}
	
			return path;
		}
	});
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	 */
	
	var MarkerDrag = Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				predrag: this._onPreDrag,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				predrag: this._onPreDrag,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_adjustPan: function (e) {
			var marker = this._marker,
			    map = marker._map,
			    speed = this._marker.options.autoPanSpeed,
			    padding = this._marker.options.autoPanPadding,
			    iconPos = getPosition(marker._icon),
			    bounds = map.getPixelBounds(),
			    origin = map.getPixelOrigin();
	
			var panBounds = toBounds(
				bounds.min._subtract(origin).add(padding),
				bounds.max._subtract(origin).subtract(padding)
			);
	
			if (!panBounds.contains(iconPos)) {
				// Compute incremental movement
				var movement = toPoint(
					(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
					(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
	
					(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
					(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
				).multiplyBy(speed);
	
				map.panBy(movement, {animate: false});
	
				this._draggable._newPos._add(movement);
				this._draggable._startPos._add(movement);
	
				setPosition(marker._icon, this._draggable._newPos);
				this._onDrag(e);
	
				this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
			}
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onPreDrag: function (e) {
			if (this._marker.options.autoPan) {
				cancelAnimFrame(this._panRequest);
				this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
			}
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			 cancelAnimFrame(this._panRequest);
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	var Marker = Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon instance to use for rendering the marker.
			// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
			// If not specified, a common instance of `L.Icon.Default` is used.
			icon: new IconDefault(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// @option pane: String = 'shadowPane'
			// `Map pane` where the markers shadow will be added.
			shadowPane: 'shadowPane',
	
			// @option bubblingMouseEvents: Boolean = false
			// When `true`, a mouse event on this marker will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: false,
	
			// @section Draggable marker options
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option autoPan: Boolean = false
			// Whether to pan the map when dragging this marker near its edge or not.
			autoPan: false,
	
			// @option autoPanPadding: Point = Point(50, 50)
			// Distance (in pixels to the left/right and to the top/bottom) of the
			// map edge to start panning the map.
			autoPanPadding: [50, 50],
	
			// @option autoPanSpeed: Number = 10
			// Number of pixels the map should pan by.
			autoPanSpeed: 10
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
			delete this.dragging;
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = toLatLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method getIcon: Icon
		// Returns the current icon used by the marker
		getIcon: function () {
			return this.options.icon;
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon && this._map) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
	
				if (icon.tagName === 'IMG') {
					icon.alt = options.alt || '';
				}
			}
	
			addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane(options.shadowPane).appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
	
			if (this._icon) {
				setPosition(this._icon, pos);
			}
	
			if (this._shadow) {
				setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			if (this._icon) {
				this._icon.style.zIndex = this._zIndex + offset;
			}
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			if (this._icon) {
				setOpacity(this._icon, opacity);
			}
	
			if (this._shadow) {
				setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor;
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor;
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	function marker(latlng, options) {
		return new Marker(latlng, options);
	}
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	var Path = Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option bubblingMouseEvents: Boolean = true
			// When `true`, a mouse event on this path will trigger the same event on the map
			// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
			bubblingMouseEvents: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
				if (this.options.stroke && style && style.hasOwnProperty('weight')) {
					this._updateBounds();
				}
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in child classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
		}
	});
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	var CircleMarker = Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = toLatLng(latlng);
			this.redraw();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	function circleMarker(latlng, options) {
		return new CircleMarker(latlng, options);
	}
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	var Circle = CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = extend({}, legacyOptions, {radius: options});
			}
			setOptions(this, options);
			this._latlng = toLatLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
				this._radiusY = p.y - top.y;
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	function circle(latlng, options, legacyOptions) {
		return new Circle(latlng, options, legacyOptions);
	}
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	
	var Polyline = Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		// @method closestLayerPoint(p: Point): Point
		// Returns the point closest to `p` on the Polyline.
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = _sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = toLatLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = isFlat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = toLatLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				this._rawPxBounds = pxBounds;
				this._updateBounds();
			}
		},
	
		_updateBounds: function () {
			var w = this._clickTolerance(),
			    p = new Point(w, w);
			this._pxBounds = new Bounds([
				this._rawPxBounds.min.subtract(p),
				this._rawPxBounds.max.add(p)
			]);
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p, closed) {
			var i, j, k, len, len2, part,
			    w = this._clickTolerance();
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// hit detection for polylines
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					if (!closed && (j === 0)) { continue; }
	
					if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
						return true;
					}
				}
			}
			return false;
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	function polyline(latlngs, options) {
		return new Polyline(latlngs, options);
	}
	
	// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	Polyline._flat = _flat;
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	var Polygon = Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			Polyline.prototype._setLatLngs.call(this, latlngs);
			if (isFlat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		},
	
		// Needed by the `Canvas` renderer for interactivity
		_containsPoint: function (p) {
			var inside = false,
			    part, p1, p2, i, j, k, len, len2;
	
			if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
			// ray casting algorithm for detecting if point is in polygon
			for (i = 0, len = this._parts.length; i < len; i++) {
				part = this._parts[i];
	
				for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
					p1 = part[j];
					p2 = part[k];
	
					if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
						inside = !inside;
					}
				}
			}
	
			// also check if it's on polygon stroke
			return inside || Polyline.prototype._containsPoint.call(this, p, true);
		}
	
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	function polygon(latlngs, options) {
		return new Polygon(latlngs, options);
	}
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	var GeoJSON = FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 *
		 * @option markersInheritOptions: Boolean = false
		 * Whether default Markers for "Point" type Features inherit from group options.
		 */
	
		initialize: function (geojson, options) {
			setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer? ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		// If `layer` is omitted, the style of all features in the current layer is reset.
		resetStyle: function (layer) {
			if (layer === undefined) {
				return this.eachLayer(this.resetStyle, this);
			}
			// reset any custom styles
			layer.options = extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (layer.setStyle) {
				if (typeof style === 'function') {
					style = style(layer.feature);
				}
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	
	// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	// Creates a `Layer` from a given GeoJSON feature. Can use a custom
	// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	// functions if provided as options.
	function geometryToLayer(geojson, options) {
	
		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry ? geometry.coordinates : null,
		    layers = [],
		    pointToLayer = options && options.pointToLayer,
		    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
		    latlng, latlngs, i, len;
	
		if (!coords && !geometry) {
			return null;
		}
	
		switch (geometry.type) {
		case 'Point':
			latlng = _coordsToLatLng(coords);
			return _pointToLayer(pointToLayer, geojson, latlng, options);
	
		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = _coordsToLatLng(coords[i]);
				layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
			}
			return new FeatureGroup(layers);
	
		case 'LineString':
		case 'MultiLineString':
			latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
			return new Polyline(latlngs, options);
	
		case 'Polygon':
		case 'MultiPolygon':
			latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
			return new Polygon(latlngs, options);
	
		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {
				var layer = geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, options);
	
				if (layer) {
					layers.push(layer);
				}
			}
			return new FeatureGroup(layers);
	
		default:
			throw new Error('Invalid GeoJSON object.');
		}
	}
	
	function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
		return pointToLayerFn ?
			pointToLayerFn(geojson, latlng) :
			new Marker(latlng, options && options.markersInheritOptions && options);
	}
	
	// @function coordsToLatLng(coords: Array): LatLng
	// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	function coordsToLatLng(coords) {
		return new LatLng(coords[1], coords[0], coords[2]);
	}
	
	// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
		var latlngs = [];
	
		for (var i = 0, len = coords.length, latlng; i < len; i++) {
			latlng = levelsDeep ?
				coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
				(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
			latlngs.push(latlng);
		}
	
		return latlngs;
	}
	
	// @function latLngToCoords(latlng: LatLng, precision?: Number): Array
	// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	function latLngToCoords(latlng, precision) {
		precision = typeof precision === 'number' ? precision : 6;
		return latlng.alt !== undefined ?
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	}
	
	// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
		var coords = [];
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			coords.push(levelsDeep ?
				latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
				latLngToCoords(latlngs[i], precision));
		}
	
		if (!levelsDeep && closed) {
			coords.push(coords[0]);
		}
	
		return coords;
	}
	
	function getFeature(layer, newGeometry) {
		return layer.feature ?
			extend({}, layer.feature, {geometry: newGeometry}) :
			asFeature(newGeometry);
	}
	
	// @function asFeature(geojson: Object): Object
	// Normalize GeoJSON geometries/features into GeoJSON features.
	function asFeature(geojson) {
		if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
			return geojson;
		}
	
		return {
			type: 'Feature',
			properties: {},
			geometry: geojson
		};
	}
	
	var PointToGeoJSON = {
		toGeoJSON: function (precision) {
			return getFeature(this, {
				type: 'Point',
				coordinates: latLngToCoords(this.getLatLng(), precision)
			});
		}
	};
	
	// @namespace Marker
	// @section Other methods
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	Circle.include(PointToGeoJSON);
	CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	Polyline.include({
		toGeoJSON: function (precision) {
			var multi = !isFlat(this._latlngs);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'LineString',
				coordinates: coords
			});
		}
	});
	
	// @namespace Polygon
	// @method toGeoJSON(precision?: Number): Object
	// `precision` is the number of decimal places for coordinates.
	// The default value is 6 places.
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	Polygon.include({
		toGeoJSON: function (precision) {
			var holes = !isFlat(this._latlngs),
			    multi = holes && !isFlat(this._latlngs[0]);
	
			var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
			if (!holes) {
				coords = [coords];
			}
	
			return getFeature(this, {
				type: (multi ? 'Multi' : '') + 'Polygon',
				coordinates: coords
			});
		}
	});
	
	
	// @namespace LayerGroup
	LayerGroup.include({
		toMultiPoint: function (precision) {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON(precision).geometry.coordinates);
			});
	
			return getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(precision?: Number): Object
		// `precision` is the number of decimal places for coordinates.
		// The default value is 6 places.
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
		toGeoJSON: function (precision) {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint(precision);
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON(precision);
					if (isGeometryCollection) {
						jsons.push(json.geometry);
					} else {
						var feature = asFeature(json);
						// Squash nested feature collections
						if (feature.type === 'FeatureCollection') {
							jsons.push.apply(jsons, feature.features);
						} else {
							jsons.push(feature);
						}
					}
				}
			});
	
			if (isGeometryCollection) {
				return getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	function geoJSON(geojson, options) {
		return new GeoJSON(geojson, options);
	}
	
	// Backward compatibility.
	var geoJson = geoJSON;
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	var ImageOverlay = Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean|String = false
			// Whether the crossOrigin attribute will be added to the image.
			// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
			// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
			crossOrigin: false,
	
			// @option errorOverlayUrl: String = ''
			// URL to the overlay image to show in place of the overlay that failed to load.
			errorOverlayUrl: '',
	
			// @option zIndex: Number = 1
			// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
			zIndex: 1,
	
			// @option className: String = ''
			// A custom class name to assign to the image. Empty by default.
			className: ''
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = toLatLngBounds(bounds);
	
			setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = toLatLngBounds(bounds);
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method setZIndex(value: Number): this
		// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
		setZIndex: function (value) {
			this.options.zIndex = value;
			this._updateZIndex();
			return this;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
		// used by this overlay.
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'IMG';
			var img = this._image = wasElementSupplied ? this._url : create$1('img');
	
			addClass(img, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
			if (this.options.className) { addClass(img, this.options.className); }
	
			img.onselectstart = falseFn;
			img.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the ImageOverlay layer has loaded its image
			img.onload = bind(this.fire, this, 'load');
			img.onerror = bind(this._overlayOnError, this, 'error');
	
			if (this.options.crossOrigin || this.options.crossOrigin === '') {
				img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
			}
	
			if (this.options.zIndex) {
				this._updateZIndex();
			}
	
			if (wasElementSupplied) {
				this._url = img.src;
				return;
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			setOpacity(this._image, this.options.opacity);
		},
	
		_updateZIndex: function () {
			if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._image.style.zIndex = this.options.zIndex;
			}
		},
	
		_overlayOnError: function () {
			// @event error: Event
			// Fired when the ImageOverlay layer fails to load its image
			this.fire('error');
	
			var errorUrl = this.options.errorOverlayUrl;
			if (errorUrl && this._url !== errorUrl) {
				this._url = errorUrl;
				this._image.src = errorUrl;
			}
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	var imageOverlay = function (url, bounds, options) {
		return new ImageOverlay(url, bounds, options);
	};
	
	/*
	 * @class VideoOverlay
	 * @aka L.VideoOverlay
	 * @inherits ImageOverlay
	 *
	 * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	 *
	 * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	 * HTML5 element.
	 *
	 * @example
	 *
	 * ```js
	 * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	 * 	videoBounds = [[ 32, -130], [ 13, -100]];
	 * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	 * ```
	 */
	
	var VideoOverlay = ImageOverlay.extend({
	
		// @section
		// @aka VideoOverlay options
		options: {
			// @option autoplay: Boolean = true
			// Whether the video starts playing automatically when loaded.
			autoplay: true,
	
			// @option loop: Boolean = true
			// Whether the video will loop back to the beginning when played.
			loop: true,
	
			// @option keepAspectRatio: Boolean = true
			// Whether the video will save aspect ratio after the projection.
			// Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
			keepAspectRatio: true
		},
	
		_initImage: function () {
			var wasElementSupplied = this._url.tagName === 'VIDEO';
			var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
			addClass(vid, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
			if (this.options.className) { addClass(vid, this.options.className); }
	
			vid.onselectstart = falseFn;
			vid.onmousemove = falseFn;
	
			// @event load: Event
			// Fired when the video has finished loading the first frame
			vid.onloadeddata = bind(this.fire, this, 'load');
	
			if (wasElementSupplied) {
				var sourceElements = vid.getElementsByTagName('source');
				var sources = [];
				for (var j = 0; j < sourceElements.length; j++) {
					sources.push(sourceElements[j].src);
				}
	
				this._url = (sourceElements.length > 0) ? sources : [vid.src];
				return;
			}
	
			if (!isArray(this._url)) { this._url = [this._url]; }
	
			if (!this.options.keepAspectRatio && vid.style.hasOwnProperty('objectFit')) { vid.style['objectFit'] = 'fill'; }
			vid.autoplay = !!this.options.autoplay;
			vid.loop = !!this.options.loop;
			for (var i = 0; i < this._url.length; i++) {
				var source = create$1('source');
				source.src = this._url[i];
				vid.appendChild(source);
			}
		}
	
		// @method getElement(): HTMLVideoElement
		// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
		// used by this overlay.
	});
	
	
	// @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	// Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	// geographical bounds it is tied to.
	
	function videoOverlay(video, bounds, options) {
		return new VideoOverlay(video, bounds, options);
	}
	
	/*
	 * @class SVGOverlay
	 * @aka L.SVGOverlay
	 * @inherits ImageOverlay
	 *
	 * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
	 *
	 * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
	 *
	 * @example
	 *
	 * ```js
	 * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	 * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	 * svgElement.setAttribute('viewBox', "0 0 200 200");
	 * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
	 * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
	 * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
	 * ```
	 */
	
	var SVGOverlay = ImageOverlay.extend({
		_initImage: function () {
			var el = this._image = this._url;
	
			addClass(el, 'leaflet-image-layer');
			if (this._zoomAnimated) { addClass(el, 'leaflet-zoom-animated'); }
			if (this.options.className) { addClass(el, this.options.className); }
	
			el.onselectstart = falseFn;
			el.onmousemove = falseFn;
		}
	
		// @method getElement(): SVGElement
		// Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
		// used by this overlay.
	});
	
	
	// @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
	// Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
	// A viewBox attribute is required on the SVG element to zoom in and out properly.
	
	function svgOverlay(el, bounds, options) {
		return new SVGOverlay(el, bounds, options);
	}
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	var DivOverlay = Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
			} else {
				remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = toLatLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
			}
			return this;
		},
	
		_prepareOpen: function (parent, layer, latlng) {
			if (!(layer instanceof Layer)) {
				latlng = layer;
				layer = parent;
			}
	
			if (layer instanceof FeatureGroup) {
				for (var id in parent._layers) {
					layer = parent._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				if (layer.getCenter) {
					latlng = layer.getCenter();
				} else if (layer.getLatLng) {
					latlng = layer.getLatLng();
				} else {
					throw new Error('Unable to get source layer LatLng.');
				}
			}
	
			// set overlay source to this layer
			this._source = layer;
	
			// update the overlay (content, layout, ect...)
			this.update();
	
			return latlng;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	var Popup = DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when another popup is opened.
			autoClose: true,
	
			// @option closeOnEscapeKey: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the ESC key for closing of the popup.
			closeOnEscapeKey: true,
	
			// @option closeOnClick: Boolean = *
			// Set it if you want to override the default behavior of the popup closing when user clicks
			// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof Path)) {
					this._source.on('preclick', stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof Path)) {
					this._source.off('preclick', stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = create$1('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
			this._contentNode = create$1('div', prefix + '-content', wrapper);
	
			disableClickPropagation(wrapper);
			disableScrollPropagation(this._contentNode);
			on(wrapper, 'contextmenu', stopPropagation);
	
			this._tipContainer = create$1('div', prefix + '-tip-container', container);
			this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				on(closeButton, 'click', this._onCloseButtonClick, this);
			}
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				addClass(container, scrolledClass);
			} else {
				removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan) { return; }
			if (this._map._panAnim) { this._map._panAnim.stop(); }
	
			var map = this._map,
			    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = toPoint(this.options.autoPanPadding),
			    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	var popup = function (options, source) {
		return new Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof Popup)) {
				popup = new Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof Popup) {
				setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (this._popup && this._map) {
				latlng = this._popup._prepareOpen(this, layer, latlng);
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		},
	
		_onKeyPress: function (e) {
			if (e.originalEvent.keyCode === 13) {
				this._openPopup(e);
			}
		}
	});
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offsetting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	var Tooltip = DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamically switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = DivOverlay.prototype.getEvents.call(this);
	
			if (touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = create$1('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = toPoint(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(toPoint(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(toPoint(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(toPoint(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(toPoint(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			removeClass(container, 'leaflet-tooltip-right');
			removeClass(container, 'leaflet-tooltip-left');
			removeClass(container, 'leaflet-tooltip-top');
			removeClass(container, 'leaflet-tooltip-bottom');
			addClass(container, 'leaflet-tooltip-' + direction);
			setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	var tooltip = function (options, source) {
		return new Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof Tooltip)) {
				tooltip = new Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// necessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof Tooltip) {
				setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = new Tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove$$1) {
			if (!remove$$1 && this._tooltipHandlersAdded) { return; }
			var onOff = remove$$1 ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove$$1;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (this._tooltip && this._map) {
				latlng = this._tooltip._prepareOpen(this, layer, latlng);
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	var DivIcon = Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String|HTMLElement = ''
			// Custom HTML code to put inside the div element, empty by default. Alternatively,
			// an instance of `HTMLElement`.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			if (options.html instanceof Element) {
				empty(div);
				div.appendChild(options.html);
			} else {
				div.innerHTML = options.html !== false ? options.html : '';
			}
	
			if (options.bgPos) {
				var bgPos = toPoint(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	function divIcon(options) {
		return new DivIcon(options);
	}
	
	Icon.Default = IconDefault;
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	var GridLayer = Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = (depends)
			// Load new tiles only when panning ends.
			// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
			// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
			// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
			updateWhenIdle: mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: undefined,
	
			// @option maxNativeZoom: Number = undefined
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: undefined,
	
			// @option minNativeZoom: Number = undefined
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = undefined;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overridden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof Point ? s : new Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (ielt9) { return; }
	
			setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) {
						willPrune = true;
					} else {
						this._onOpaqueTile(tile);
					}
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_onOpaqueTile: falseFn,
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
					this._onUpdateLevel(z);
				} else {
					remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					this._onRemoveLevel(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				falseFn(level.el.offsetWidth);
	
				this._onCreateLevel(level);
			}
	
			this._level = level;
	
			return level;
		},
	
		_onUpdateLevel: falseFn,
	
		_onRemoveLevel: falseFn,
	
		_onCreateLevel: falseFn,
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				remove(this._levels[z].el);
				this._onRemoveLevel(z);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = undefined;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_clampZoom: function (zoom) {
			var options = this.options;
	
			if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
				return options.minNativeZoom;
			}
	
			if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
				return options.maxNativeZoom;
			}
	
			return zoom;
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = this._clampZoom(Math.round(zoom));
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (any3d) {
				setTransform(level.el, translate, scale);
			} else {
				setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = this._clampZoom(map.getZoom());
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			// Sanity check: panic if the tile range contains Infinity somewhere.
			if (!(isFinite(tileRange.min.x) &&
			      isFinite(tileRange.min.y) &&
			      isFinite(tileRange.max.x) &&
			      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					var tile = this._tiles[this._tileCoordsToKey(coords)];
					if (tile) {
						tile.current = true;
					} else {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		_tileCoordsToNwSe: function (coords) {
			var map = this._map,
			    tileSize = this.getTileSize(),
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z);
			return [nw, se];
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
			var bp = this._tileCoordsToNwSe(coords),
			    bounds = new LatLngBounds(bp[0], bp[1]);
	
			if (!this.options.noWrap) {
				bounds = this._map.wrapLatLngBounds(bounds);
			}
			return bounds;
		},
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = falseFn;
			tile.onmousemove = falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (ielt9 && this.options.opacity < 1) {
				setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (android && !android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
			}
	
			setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				setOpacity(tile.el, 0);
				cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (ielt9 || !this._map._fadeAnimated) {
					requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new Point(
				this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	function gridLayer(options) {
		return new GridLayer(options);
	}
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	var TileLayer = GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// The minimum zoom level down to which this layer will be displayed (inclusive).
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// The maximum zoom level up to which this layer will be displayed (inclusive).
			maxZoom: 18,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean|String = false
			// Whether the crossOrigin attribute will be added to the tiles.
			// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
			// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		// If the URL does not change, the layer will not be redrawn unless
		// the noRedraw parameter is set to false.
		setUrl: function (url, noRedraw) {
			if (this._url === url && noRedraw === undefined) {
				noRedraw = true;
			}
	
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
			on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin || this.options.crossOrigin === '') {
				tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return template(this._url, extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (ielt9) {
				setTimeout(bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.getAttribute('src') !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			return zoom + zoomOffset;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = falseFn;
					tile.onerror = falseFn;
	
					if (!tile.complete) {
						tile.src = emptyImageUrl;
						remove(tile);
						delete this._tiles[i];
					}
				}
			}
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			// Cancels any pending http requests associated with the tile
			// unless we're on Android's stock browser,
			// see https://github.com/Leaflet/Leaflet/issues/137
			if (!androidStock) {
				tile.el.setAttribute('src', emptyImageUrl);
			}
	
			return GridLayer.prototype._removeTile.call(this, key);
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
				return;
			}
	
			return GridLayer.prototype._tileReady.call(this, coords, err, tile);
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	function tileLayer(url, options) {
		return new TileLayer(url, options);
	}
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	var TileLayerWMS = TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = setOptions(this, options);
	
			var realRetina = options.detectRetina && retina ? 2 : 1;
			var tileSize = this.getTileSize();
			wmsParams.width = tileSize.x * realRetina;
			wmsParams.height = tileSize.y * realRetina;
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToNwSe(coords),
			    crs = this._crs,
			    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
			    min = bounds.min,
			    max = bounds.max,
			    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
			    [min.y, min.x, max.y, max.x] :
			    [min.x, min.y, max.x, max.y]).join(','),
			    url = TileLayer.prototype.getTileUrl.call(this, coords);
			return url +
				getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	function tileLayerWMS(url, options) {
		return new TileLayerWMS(url, options);
	}
	
	TileLayer.WMS = TileLayerWMS;
	tileLayer.wms = tileLayerWMS;
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	var Renderer = Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1,
	
			// @option tolerance: Number = 0
			// How much to extend click tolerance round a path/object on the map
			tolerance : 0
		},
	
		initialize: function (options) {
			setOptions(this, options);
			stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			this.off('update', this._updatePaths, this);
			this._destroyContainer();
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (any3d) {
				setTransform(this._container, topLeftOffset, scale);
			} else {
				setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var Canvas = Renderer.extend({
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			on(container, 'mousemove', this._onMouseMove, this);
			on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
			on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_destroyContainer: function () {
			cancelAnimFrame(this._redrawRequest);
			delete this._ctx;
			remove(this._container);
			off(this._container);
			delete this._container;
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = retina ? 2 : 1;
	
			setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete layer._order;
	
			delete this._layers[stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (typeof layer.options.dashArray === 'string') {
				var parts = layer.options.dashArray.split(/[, ]+/),
				    dashArray = [],
				    dashValue,
				    i;
				for (i = 0; i < parts.length; i++) {
					dashValue = Number(parts[i]);
					// Ignore dash array containing invalid lengths
					if (isNaN(dashValue)) { return; }
					dashArray.push(dashValue);
				}
				layer.options._dashArray = dashArray;
			} else {
				layer.options._dashArray = layer.options.dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			if (layer._pxBounds) {
				var padding = (layer.options.weight || 0) + 1;
				this._redrawBounds = this._redrawBounds || new Bounds();
				this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
				this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
			}
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			ctx.beginPath();
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = Math.max(Math.round(layer._radius), 1),
			    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				if (ctx.setLineDash) {
					ctx.setLineDash(layer.options && layer.options._dashArray || []);
				}
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
				this._mouseHoverThrottled = false;
			}
		},
	
		_handleMouseHover: function (e, point) {
			if (this._mouseHoverThrottled) {
				return;
			}
	
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
	
			this._mouseHoverThrottled = true;
			setTimeout(L.bind(function () {
				this._mouseHoverThrottled = false;
			}, this), 32);
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
	
			if (!order) { return; }
	
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// single entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
	
			if (!order) { return; }
	
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// single entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	function canvas$1(options) {
		return canvas ? new Canvas(options) : null;
	}
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	
	var vmlCreate = (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	})();
	
	
	/*
	 * @class SVG
	 *
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	var vmlMixin = {
	
		_initContainer: function () {
			this._container = create$1('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = vmlCreate('shape');
	
			addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = vmlCreate('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = vmlCreate('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = vmlCreate('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._container);
		}
	};
	
	var create$2 = vml ? vmlCreate : svgCreate;
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	var SVG = Renderer.extend({
	
		getEvents: function () {
			var events = Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = create$2('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = create$2('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_destroyContainer: function () {
			remove(this._container);
			off(this._container);
			delete this._container;
			delete this._rootGroup;
			delete this._svgSize;
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = create$2('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			if (!this._rootGroup) { this._initContainer(); }
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = Math.max(Math.round(layer._radius), 1),
			    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			toBack(layer._path);
		}
	});
	
	if (vml) {
		SVG.include(vmlMixin);
	}
	
	// @namespace SVG
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	function svg$1(options) {
		return svg || vml ? new SVG(options) : null;
	}
	
	Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				renderer = this._renderer = this._createRenderer();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = this._createRenderer({pane: name});
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		},
	
		_createRenderer: function (options) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			return (this.options.preferCanvas && canvas$1(options)) || svg$1(options);
		}
	});
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Rectangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	var Rectangle = Polygon.extend({
		initialize: function (latLngBounds, options) {
			Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = toLatLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	function rectangle(latLngBounds, options) {
		return new Rectangle(latLngBounds, options);
	}
	
	SVG.create = create$2;
	SVG.pointsToPath = pointsToPath;
	
	GeoJSON.geometryToLayer = geometryToLayer;
	GeoJSON.coordsToLatLng = coordsToLatLng;
	GeoJSON.coordsToLatLngs = coordsToLatLngs;
	GeoJSON.latLngToCoords = latLngToCoords;
	GeoJSON.latLngsToCoords = latLngsToCoords;
	GeoJSON.getFeature = getFeature;
	GeoJSON.asFeature = asFeature;
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	var BoxZoom = Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
			this._resetStateTimeout = 0;
			map.on('unload', this._destroy, this);
		},
	
		addHooks: function () {
			on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_destroy: function () {
			remove(this._pane);
			delete this._pane;
		},
	
		_resetState: function () {
			this._resetStateTimeout = 0;
			this._moved = false;
		},
	
		_clearDeferredResetState: function () {
			if (this._resetStateTimeout !== 0) {
				clearTimeout(this._resetStateTimeout);
				this._resetStateTimeout = 0;
			}
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			// Clear the deferred resetState if it hasn't executed yet, otherwise it
			// will interrupt the interaction and orphan a box element in the container.
			this._clearDeferredResetState();
			this._resetState();
	
			disableTextSelection();
			disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			on(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = create$1('div', 'leaflet-zoom-box', this._container);
				addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				remove(this._box);
				removeClass(this._container, 'leaflet-crosshair');
			}
	
			enableTextSelection();
			enableImageDrag();
	
			off(document, {
				contextmenu: stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			this._clearDeferredResetState();
			this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
			var bounds = new LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	var DoubleClickZoom = Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	var Drag = Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-grab');
			removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			map._stop();
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = toLatLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = toBounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				this._prunePositions(time);
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_prunePositions: function (time) {
			while (this._positions.length > 1 && time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
				this._prunePositions(+new Date());
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	Map.addInitHook('addHandler', 'dragging', Drag);
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	var Keyboard = Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
				if (!map._panAnim || !map._panAnim._inProgress) {
					offset = this._panKeys[key];
					if (e.shiftKey) {
						offset = toPoint(offset).multiplyBy(3);
					}
	
					map.panBy(offset);
	
					if (map.options.maxBounds) {
						map.panInsideBounds(map.options.maxBounds);
					}
				}
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
				map.closePopup();
	
			} else {
				return;
			}
	
			stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	var ScrollWheelZoom = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(bind(this._performZoom, this), left);
	
			stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	var Tap = Handler.extend({
		addHooks: function () {
			on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (touch && !pointer) {
		Map.addInitHook('addHandler', 'tap', Tap);
	}
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: touch && !android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	var TouchZoom = Handler.extend({
		addHooks: function () {
			addClass(this._map._container, 'leaflet-touch-zoom');
			on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			removeClass(this._map._container, 'leaflet-touch-zoom');
			off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			on(document, 'touchmove', this._onTouchMove, this);
			on(document, 'touchend', this._onTouchEnd, this);
	
			preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true, false);
				this._moved = true;
			}
	
			cancelAnimFrame(this._animRequest);
	
			var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = requestAnimFrame(moveFn, this, true);
	
			preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			cancelAnimFrame(this._animRequest);
	
			off(document, 'touchmove', this._onTouchMove);
			off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	Map.BoxZoom = BoxZoom;
	Map.DoubleClickZoom = DoubleClickZoom;
	Map.Drag = Drag;
	Map.Keyboard = Keyboard;
	Map.ScrollWheelZoom = ScrollWheelZoom;
	Map.Tap = Tap;
	Map.TouchZoom = TouchZoom;
	
	Object.freeze = freeze;
	
	exports.version = version;
	exports.Control = Control;
	exports.control = control;
	exports.Browser = Browser;
	exports.Evented = Evented;
	exports.Mixin = Mixin;
	exports.Util = Util;
	exports.Class = Class;
	exports.Handler = Handler;
	exports.extend = extend;
	exports.bind = bind;
	exports.stamp = stamp;
	exports.setOptions = setOptions;
	exports.DomEvent = DomEvent;
	exports.DomUtil = DomUtil;
	exports.PosAnimation = PosAnimation;
	exports.Draggable = Draggable;
	exports.LineUtil = LineUtil;
	exports.PolyUtil = PolyUtil;
	exports.Point = Point;
	exports.point = toPoint;
	exports.Bounds = Bounds;
	exports.bounds = toBounds;
	exports.Transformation = Transformation;
	exports.transformation = toTransformation;
	exports.Projection = index;
	exports.LatLng = LatLng;
	exports.latLng = toLatLng;
	exports.LatLngBounds = LatLngBounds;
	exports.latLngBounds = toLatLngBounds;
	exports.CRS = CRS;
	exports.GeoJSON = GeoJSON;
	exports.geoJSON = geoJSON;
	exports.geoJson = geoJson;
	exports.Layer = Layer;
	exports.LayerGroup = LayerGroup;
	exports.layerGroup = layerGroup;
	exports.FeatureGroup = FeatureGroup;
	exports.featureGroup = featureGroup;
	exports.ImageOverlay = ImageOverlay;
	exports.imageOverlay = imageOverlay;
	exports.VideoOverlay = VideoOverlay;
	exports.videoOverlay = videoOverlay;
	exports.SVGOverlay = SVGOverlay;
	exports.svgOverlay = svgOverlay;
	exports.DivOverlay = DivOverlay;
	exports.Popup = Popup;
	exports.popup = popup;
	exports.Tooltip = Tooltip;
	exports.tooltip = tooltip;
	exports.Icon = Icon;
	exports.icon = icon;
	exports.DivIcon = DivIcon;
	exports.divIcon = divIcon;
	exports.Marker = Marker;
	exports.marker = marker;
	exports.TileLayer = TileLayer;
	exports.tileLayer = tileLayer;
	exports.GridLayer = GridLayer;
	exports.gridLayer = gridLayer;
	exports.SVG = SVG;
	exports.svg = svg$1;
	exports.Renderer = Renderer;
	exports.Canvas = Canvas;
	exports.canvas = canvas$1;
	exports.Path = Path;
	exports.CircleMarker = CircleMarker;
	exports.circleMarker = circleMarker;
	exports.Circle = Circle;
	exports.circle = circle;
	exports.Polyline = Polyline;
	exports.polyline = polyline;
	exports.Polygon = Polygon;
	exports.polygon = polygon;
	exports.Rectangle = Rectangle;
	exports.rectangle = rectangle;
	exports.Map = Map;
	exports.map = createMap;
	
	var oldL = window.L;
	exports.noConflict = function() {
		window.L = oldL;
		return this;
	}
	
	// Always export us to window global (see #2364)
	window.L = exports;
	
	})));
	//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.4
	 * https://www.chartjs.org
	 * (c) 2020 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(630); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	function isValidKey(key) {
		return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
	}
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = Object.create(source);
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge(Object.create(null), [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
			return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || Object.create(null);
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || Object.create(null);
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var widestLabelSize = 0;
		var highestLabelSize = 0;
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
			widestLabelSize = Math.max(width, widestLabelSize);
			highestLabelSize = Math.max(height, highestLabelSize);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(widestLabelSize);
		highest = heights.indexOf(highestLabelSize);
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(631)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123)(module)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 632,
		"./af.js": 632,
		"./ar": 633,
		"./ar-dz": 634,
		"./ar-dz.js": 634,
		"./ar-kw": 635,
		"./ar-kw.js": 635,
		"./ar-ly": 636,
		"./ar-ly.js": 636,
		"./ar-ma": 637,
		"./ar-ma.js": 637,
		"./ar-sa": 638,
		"./ar-sa.js": 638,
		"./ar-tn": 639,
		"./ar-tn.js": 639,
		"./ar.js": 633,
		"./az": 640,
		"./az.js": 640,
		"./be": 641,
		"./be.js": 641,
		"./bg": 642,
		"./bg.js": 642,
		"./bm": 643,
		"./bm.js": 643,
		"./bn": 644,
		"./bn.js": 644,
		"./bo": 645,
		"./bo.js": 645,
		"./br": 646,
		"./br.js": 646,
		"./bs": 647,
		"./bs.js": 647,
		"./ca": 648,
		"./ca.js": 648,
		"./cs": 649,
		"./cs.js": 649,
		"./cv": 650,
		"./cv.js": 650,
		"./cy": 651,
		"./cy.js": 651,
		"./da": 652,
		"./da.js": 652,
		"./de": 653,
		"./de-at": 654,
		"./de-at.js": 654,
		"./de-ch": 655,
		"./de-ch.js": 655,
		"./de.js": 653,
		"./dv": 656,
		"./dv.js": 656,
		"./el": 657,
		"./el.js": 657,
		"./en-SG": 658,
		"./en-SG.js": 658,
		"./en-au": 659,
		"./en-au.js": 659,
		"./en-ca": 660,
		"./en-ca.js": 660,
		"./en-gb": 661,
		"./en-gb.js": 661,
		"./en-ie": 662,
		"./en-ie.js": 662,
		"./en-il": 663,
		"./en-il.js": 663,
		"./en-nz": 664,
		"./en-nz.js": 664,
		"./eo": 665,
		"./eo.js": 665,
		"./es": 666,
		"./es-do": 667,
		"./es-do.js": 667,
		"./es-us": 668,
		"./es-us.js": 668,
		"./es.js": 666,
		"./et": 669,
		"./et.js": 669,
		"./eu": 670,
		"./eu.js": 670,
		"./fa": 671,
		"./fa.js": 671,
		"./fi": 672,
		"./fi.js": 672,
		"./fo": 673,
		"./fo.js": 673,
		"./fr": 674,
		"./fr-ca": 675,
		"./fr-ca.js": 675,
		"./fr-ch": 676,
		"./fr-ch.js": 676,
		"./fr.js": 674,
		"./fy": 677,
		"./fy.js": 677,
		"./ga": 678,
		"./ga.js": 678,
		"./gd": 679,
		"./gd.js": 679,
		"./gl": 680,
		"./gl.js": 680,
		"./gom-latn": 681,
		"./gom-latn.js": 681,
		"./gu": 682,
		"./gu.js": 682,
		"./he": 683,
		"./he.js": 683,
		"./hi": 684,
		"./hi.js": 684,
		"./hr": 685,
		"./hr.js": 685,
		"./hu": 686,
		"./hu.js": 686,
		"./hy-am": 687,
		"./hy-am.js": 687,
		"./id": 688,
		"./id.js": 688,
		"./is": 689,
		"./is.js": 689,
		"./it": 690,
		"./it-ch": 691,
		"./it-ch.js": 691,
		"./it.js": 690,
		"./ja": 692,
		"./ja.js": 692,
		"./jv": 693,
		"./jv.js": 693,
		"./ka": 694,
		"./ka.js": 694,
		"./kk": 695,
		"./kk.js": 695,
		"./km": 696,
		"./km.js": 696,
		"./kn": 697,
		"./kn.js": 697,
		"./ko": 698,
		"./ko.js": 698,
		"./ku": 699,
		"./ku.js": 699,
		"./ky": 700,
		"./ky.js": 700,
		"./lb": 701,
		"./lb.js": 701,
		"./lo": 702,
		"./lo.js": 702,
		"./lt": 703,
		"./lt.js": 703,
		"./lv": 704,
		"./lv.js": 704,
		"./me": 705,
		"./me.js": 705,
		"./mi": 706,
		"./mi.js": 706,
		"./mk": 707,
		"./mk.js": 707,
		"./ml": 708,
		"./ml.js": 708,
		"./mn": 709,
		"./mn.js": 709,
		"./mr": 710,
		"./mr.js": 710,
		"./ms": 711,
		"./ms-my": 712,
		"./ms-my.js": 712,
		"./ms.js": 711,
		"./mt": 713,
		"./mt.js": 713,
		"./my": 714,
		"./my.js": 714,
		"./nb": 715,
		"./nb.js": 715,
		"./ne": 716,
		"./ne.js": 716,
		"./nl": 717,
		"./nl-be": 718,
		"./nl-be.js": 718,
		"./nl.js": 717,
		"./nn": 719,
		"./nn.js": 719,
		"./pa-in": 720,
		"./pa-in.js": 720,
		"./pl": 721,
		"./pl.js": 721,
		"./pt": 722,
		"./pt-br": 723,
		"./pt-br.js": 723,
		"./pt.js": 722,
		"./ro": 724,
		"./ro.js": 724,
		"./ru": 725,
		"./ru.js": 725,
		"./sd": 726,
		"./sd.js": 726,
		"./se": 727,
		"./se.js": 727,
		"./si": 728,
		"./si.js": 728,
		"./sk": 729,
		"./sk.js": 729,
		"./sl": 730,
		"./sl.js": 730,
		"./sq": 731,
		"./sq.js": 731,
		"./sr": 732,
		"./sr-cyrl": 733,
		"./sr-cyrl.js": 733,
		"./sr.js": 732,
		"./ss": 734,
		"./ss.js": 734,
		"./sv": 735,
		"./sv.js": 735,
		"./sw": 736,
		"./sw.js": 736,
		"./ta": 737,
		"./ta.js": 737,
		"./te": 738,
		"./te.js": 738,
		"./tet": 739,
		"./tet.js": 739,
		"./tg": 740,
		"./tg.js": 740,
		"./th": 741,
		"./th.js": 741,
		"./tl-ph": 742,
		"./tl-ph.js": 742,
		"./tlh": 743,
		"./tlh.js": 743,
		"./tr": 744,
		"./tr.js": 744,
		"./tzl": 745,
		"./tzl.js": 745,
		"./tzm": 746,
		"./tzm-latn": 747,
		"./tzm-latn.js": 747,
		"./tzm.js": 746,
		"./ug-cn": 748,
		"./ug-cn.js": 748,
		"./uk": 749,
		"./uk.js": 749,
		"./ur": 750,
		"./ur.js": 750,
		"./uz": 751,
		"./uz-latn": 752,
		"./uz-latn.js": 752,
		"./uz.js": 751,
		"./vi": 753,
		"./vi.js": 753,
		"./x-pseudo": 754,
		"./x-pseudo.js": 754,
		"./yo": 755,
		"./yo.js": 755,
		"./zh-cn": 756,
		"./zh-cn.js": 756,
		"./zh-hk": 757,
		"./zh-hk.js": 757,
		"./zh-tw": 758,
		"./zh-tw.js": 758
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 631;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(630)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<head>\n  <link rel=\"stylesheet\" href=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.css\" />\n  <script src=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.js\"></script>\n\n\n</head>\n\n</head>\n<navbar></navbar>\n\n<body>\n  <div id=\"container\">\n        <div id=\"sidebar\">\n          \n        </div>\n        <div id=\"map\"></div>\n      </div>\n\n\n</body>\n<footer></footer>\n"

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('acosoEnLineaApp.constants', []).constant('appConfig', __webpack_require__(761)).constant('localidadesList', __webpack_require__(762)).constant('municipios', __webpack_require__(763)).name;

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  timeToShowForm: 30*60*60*100, // 30 minutos
	
	  preguntas: [
	    {
	      idPregunta: 1,
	      descripcion: '¿Alguna vez te han escrito, enviado audios o vídeos con los que te sentiste atacadx o insegurx?'
	    },
	    {
	      idPregunta: 2,
	      descripcion: '¿Tu pareja o alguien conocidx, compañerxs del trabajo o de la facultad compartieron cosas íntimas tuyas o de alguien más sin permiso?'
	    },
	    {
	      idPregunta: 3,
	      descripcion: '¿Alguna vez te has abstenido de publicar algo en tus redes por miedo a que te amenacen, te intimiden o te hagan sentir simplemente mal por tu forma de pensar?'
	    },
	    {
	      idPregunta: 4,
	      descripcion: '¿Alguna vez te pasó que trataste de entrar a tus cuentas y alguien (no sabemos quién) cambió las credenciales y perdiste el acceso a tu identidad digital?'
	    },
	    {
	      idPregunta: 5,
	      descripcion: '¿Alguna vez tu pareja te ha solicitado alguna contraseña tuya para tener acceso a tus dispositivos o cuentas?'
	    },
	    {
	      idPregunta: 6,
	      descripcion: '¿Alguna vez te han pedido una foto o prueba sobre lo que estás haciendo o donde estás? Por ejemplo: Tu pareja te pide una selfie para ver cómo andás o no te cree que estás dormidx en tu casa.'
	    },
	    {
	      idPregunta: 7,
	      descripcion: '¿Te has buscado en las redes y has encontrado a otra persona con tu misma identidad, tus mismas fotos, hasta una selfie con tu mascota o tu pareja?'
	    },
	    {
	      idPregunta: 8,
	      descripcion: '¿Se llegó a divulgar información manipulada o falsa sobre tu persona en las redes, como fotos, mensajes de texto, etc?'
	    },
	    {
	      idPregunta: 9,
	      descripcion: '¿Algún compañerx de trabajo, jefe, profesor o pariente, te manda textos, vídeos o audios con mensajes "subidos de tono"? Por ejemplo: "Qué linda pollera andás hoy", "Mirá cómo te queda esa blusa". Comentarios de ese estilo.'
	    }
	  ],
	
	  generos: [
	    {
	      value: 'femenino',
	      label: 'Femenino'
	    },
	    {
	      value: 'masculino',
	      label: 'Masculino'
	    },
	    {
	      value: 'otro',
	      label: 'Otro'
	    }
	  ],
	
	  edades: {
	    desde: 12,
	    hasta: 76
	  }
	};


/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = [
	  {
	    "departamento": "Alto Paraguay",
	    "ciudad": "Bahía Negra"
	  },
	  {
	    "departamento": "Alto Paraguay",
	    "ciudad": "Carmelo Peralta"
	  },
	  {
	    "departamento": "Alto Paraguay",
	    "ciudad": "Fuerte Olimpo"
	  },
	  {
	    "departamento": "Alto Paraguay",
	    "ciudad": "Puerto Casado"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Ciudad del Este"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Doctor Juan León Mallorquín"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Doctor Raúl Peña"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Domingo Martínez de Irala"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Hernandarias"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Iruña"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Itakyry"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Juan E. O'Leary"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Los Cedrales"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Mbaracayú"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Minga Guazú"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Minga Porá"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Naranjal"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Ñacunday"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Presidente Franco"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "San Alberto"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "San Cristóbal"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Santa Fe del Paraná"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Santa Rita"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Santa Rosa del Monday"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Tavapy"
	  },
	  {
	    "departamento": "Alto Paraná",
	    "ciudad": "Yguazú"
	  },
	  {
	    "departamento": "Amambay",
	    "ciudad": "Bella Vista"
	  },
	  {
	    "departamento": "Amambay",
	    "ciudad": "Capitán Bado"
	  },
	  {
	    "departamento": "Amambay",
	    "ciudad": "Karapaí"
	  },
	  {
	    "departamento": "Amambay",
	    "ciudad": "Pedro Juan Caballero"
	  },
	  {
	    "departamento": "Amambay",
	    "ciudad": "Zanja Pytã"
	  },
	  {
	    "departamento": "Boquerón",
	    "ciudad": "Filadelfia"
	  },
	  {
	    "departamento": "Boquerón",
	    "ciudad": "Loma Plata"
	  },
	  {
	    "departamento": "Boquerón",
	    "ciudad": "Mariscal José Félix Estigarribia"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "3 de Febrero"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Caaguazú"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Carayaó"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Coronel Oviedo"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Doctor Cecilio Báez"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Doctor J. Eulogio Estigarribia"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Doctor Juan Manuel Frutos"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "José Domingo Ocampos"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "La Pastora"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Mariscal Francisco Solano Lopez"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Nueva Londres"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Nueva Toledo"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "R.I. 3 Corrales"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Raúl Arsenio Oviedo"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Repatriación"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "San Joaquín"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "San José de los Arroyos"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Santa Rosa del Mbutuy"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Simón Bolivar"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Tembiaporá"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Vaquería"
	  },
	  {
	    "departamento": "Caaguazú",
	    "ciudad": "Yhú"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "3 de Mayo"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Abaí"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Buena Vista"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Caazapá"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Maciel"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Doctor Moisés S. Bertoni"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Yegros"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "General Higinio Morinigo"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "San Juan Nepomuceno"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Tavaí"
	  },
	  {
	    "departamento": "Caazapá",
	    "ciudad": "Yuty"
	  },
	  {
	   "departamento": "Canindeyú",
	   "ciudad": "Corpus Christi"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Villa Curuguaty"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Francisco Caballero Alvarez"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Itanará"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Katueté"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "La Paloma del Espíritu Santo"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Maracaná"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Nueva Esperanza"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Salto del Guairá"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Villa Ygatimí"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Yasy Cañy"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Yby Pytá"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Ypejhú"
	 },
	 {
	   "departamento": "Canindeyú",
	   "ciudad": "Ybyrarobaná"
	 },
	 {
	   "departamento": "Capital",
	   "ciudad": "Asunción"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Areguá"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Capiatá"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Fernando de la Mora"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Guarambaré"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Itá"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Itauguá"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "J. Augusto Saldivar"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Lambaré"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Limpio"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Luque"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Mariano Roque Alonso"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Nueva Italia"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Ñemby"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "San Antonio"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "San Lorenzo"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Villa Elisa"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Villeta"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Ypacaraí"
	 },
	 {
	   "departamento": "Central",
	   "ciudad": "Ypané"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Arroyito"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Azote'y"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Belén"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Concepción"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Horqueta"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Loreto"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Paso Barreto"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "San Alfredo"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "San Lázaro"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "San Carlos del Apa"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Sargento José Félix López"
	 },
	 {
	   "departamento": "Concepción",
	   "ciudad": "Yby Ya'u"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Altos"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Arroyos y Esteros"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Atyrá"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Caacupé"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Caraguatay"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Emboscada"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Eusebio Ayala"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Isla Pucú"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Itacurubí de la Cordillera"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Juan de Mena"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Loma Grande"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Mbocayaty del Yhaguy"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Nueva Colombia"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Piribebuy"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Primero De Marzo"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "San Bernardino"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "San José Obrero"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Santa Elena"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Tobatí"
	 },
	 {
	   "departamento": "Cordillera",
	   "ciudad": "Valenzuela"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Coronel Martínez"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Borja"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Doctor Bottrell"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Gral. Eugenio A. Garay"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Félix Pérez Cardozo"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Independencia"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Itapé"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Iturbe"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "José Fassardi"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Capitán Mauricio José Troche"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Mbocayaty"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Natalicio Talavera"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Ñumí"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Paso Yobai"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "San Salvador"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Tebicuary"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Villarrica"
	 },
	 {
	   "departamento": "Guairá",
	   "ciudad": "Yataity"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Alto Verá"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Bella Vista"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Cambyretá"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Capitán Meza"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Capitán Miranda"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Carlos Antonio López"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Carmen del Paraná"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Coronel Bogado"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Edelira"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Encarnación"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Fram"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "General Delgado"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "General Artigas"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Hohenau"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Itapúa Poty"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Jesús"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "José Leandro Oviedo"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "La Paz"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Mayor Julio Dionisio Otaño"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Natalio"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Nueva Alborada"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Obligado"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Pirapó"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "San Cosme y Damián"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "San Juan del Paraná"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "San Pedro del Paraná"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "San Rafael del Paraná"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Tomás Romero Pereira"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Trinidad"
	 },
	 {
	   "departamento": "Itapúa",
	   "ciudad": "Yatytay"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "Ayolas"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "San Ignacio"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "San Juan Bautista de las misiones"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "San Miguel"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "San Patricio"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "Santa María"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "Santa Rosa"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "Santiago"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "Villa Florida"
	 },
	 {
	   "departamento": "Misiones",
	   "ciudad": "Yabebyry"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Alberdi"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Cerrito"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Desmochados"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Gral. José Eduvigis Díaz"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Guazú-cuá"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Humaitá"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Isla Umbú"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Laureles"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Mayor José Dejesús Martínez"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Paso de Patria"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Pilar"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "San Juan Bautista de Ñeembucú"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Tacuaras"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Villa Franca"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Villa Oliva"
	 },
	 {
	   "departamento": "Ñeembucú",
	   "ciudad": "Villalbín"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Acahay"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Caapucú"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Carapeguá"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Escobar"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "General Bernardino Caballero"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "La Colmena"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "María Antonia"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Mbuyapey"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Paraguarí"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Pirayú"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Quiindy"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Quyquyhó"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Roque Gonzalez de Santa Cruz"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Sapucái"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Tebicuary-mí"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Yaguarón"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Ybycuí"
	 },
	 {
	   "departamento": "Paraguarí",
	   "ciudad": "Ybytymí"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "Benjamín Aceval"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "General José María Bruguez"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "José Falcón"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "Nanawa"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "Puerto Pinasco"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "Tte. 1° Manuel Irala Fernández"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "Teniente Esteban Martínez"
	 },
	 {
	   "departamento": "Presidente Hayes",
	   "ciudad": "Villa Hayes"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "25 de Diciembre"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Antequera"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Capiibary"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Choré"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "General Elizardo Aquino"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "General Francisco Isidoro Resquín"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Guajayvi"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Itacurubí del Rosario"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Liberación"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Lima"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Nueva Germania"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "San Estanislao"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "San Pablo"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "San Pedro del Ycuamandyyú"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "San Vicente Pancholo"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Santa Rosa del Aguaray"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Tacuatí"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Unión"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Villa del Rosario"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Yataity del Norte"
	 },
	 {
	   "departamento": "San Pedro",
	   "ciudad": "Yrybucua"
	 }
	];


/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = [{
	  "type": "FeatureCollection",
	  "features": [{
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.175846, -24.157831],
	            [-55.161325, -24.191926],
	            [-55.177824, -24.229017],
	            [-55.208658, -24.241852],
	            [-55.209532, -24.252207],
	            [-55.192451, -24.268784],
	            [-55.184395, -24.312591],
	            [-55.195278, -24.32512],
	            [-55.223375, -24.34058],
	            [-55.230193, -24.352034],
	            [-55.244879, -24.353588],
	            [-55.257607, -24.365008],
	            [-55.288388, -24.36366],
	            [-55.316531, -24.353547],
	            [-55.360012, -24.359492],
	            [-55.373024, -24.374238],
	            [-55.342097, -24.391424],
	            [-55.326016, -24.410683],
	            [-55.322082, -24.433312],
	            [-55.363972, -24.436407],
	            [-55.394941, -24.427646],
	            [-55.422858, -24.432721],
	            [-55.447143, -24.426769],
	            [-55.464874, -24.435384],
	            [-55.489375, -24.43978],
	            [-55.508001, -24.424528],
	            [-55.526808, -24.42087],
	            [-55.494082, -24.390931],
	            [-55.509314, -24.360833],
	            [-55.521774, -24.363034],
	            [-55.548877, -24.334342],
	            [-55.566208, -24.329924],
	            [-55.577658, -24.308111],
	            [-55.539749, -24.297819],
	            [-55.518113, -24.273571],
	            [-55.502032, -24.268736],
	            [-55.500562, -24.257809],
	            [-55.475663, -24.260316],
	            [-55.46539, -24.282123],
	            [-55.442863, -24.28393],
	            [-55.431841, -24.261085],
	            [-55.44328, -24.244569],
	            [-55.432065, -24.214995],
	            [-55.434712, -24.198172],
	            [-55.446891, -24.187612],
	            [-55.4238, -24.180695],
	            [-55.396772, -24.192122],
	            [-55.393115, -24.205735],
	            [-55.375537, -24.207658],
	            [-55.359683, -24.190231],
	            [-55.319694, -24.158608],
	            [-55.315047, -24.136227],
	            [-55.307545, -24.13134],
	            [-55.268066, -24.135222],
	            [-55.238958, -24.131779],
	            [-55.228132, -24.139197],
	            [-55.214436, -24.129643],
	            [-55.175846, -24.157831]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "YBY PYTÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.162519, -23.322706],
	            [-56.164556, -23.352693],
	            [-56.15573, -23.390808],
	            [-56.154287, -23.423068],
	            [-56.166538, -23.451861],
	            [-56.165695, -23.471384],
	            [-56.147186, -23.492972],
	            [-56.226352, -23.494395],
	            [-56.265397, -23.528361],
	            [-56.282016, -23.530416],
	            [-56.309839, -23.543973],
	            [-56.321518, -23.561159],
	            [-56.333753, -23.565809],
	            [-56.358484, -23.563533],
	            [-56.377349, -23.580225],
	            [-56.39737, -23.589224],
	            [-56.421067, -23.592425],
	            [-56.448349, -23.603409],
	            [-56.46151, -23.61461],
	            [-56.492886, -23.627736],
	            [-56.510979, -23.631116],
	            [-56.531221, -23.666498],
	            [-56.556021, -23.698633],
	            [-56.552555, -23.723792],
	            [-56.575903, -23.739067],
	            [-56.590174, -23.734539],
	            [-56.60907, -23.745541],
	            [-56.610633, -23.760358],
	            [-56.636293, -23.777649],
	            [-56.650258, -23.777794],
	            [-56.67962, -23.794961],
	            [-56.714672, -23.794122],
	            [-56.703603, -23.773575],
	            [-56.722858, -23.752014],
	            [-56.737998, -23.742448],
	            [-56.74868, -23.725769],
	            [-56.814168, -23.700381],
	            [-56.827053, -23.718289],
	            [-56.849939, -23.719816],
	            [-56.878602, -23.698976],
	            [-56.900946, -23.699084],
	            [-56.910449, -23.692645],
	            [-56.972184, -23.695064],
	            [-56.94624, -23.627715],
	            [-56.940008, -23.577294],
	            [-56.932975, -23.560066],
	            [-56.959314, -23.521915],
	            [-56.971677, -23.483441],
	            [-56.966998, -23.468224],
	            [-56.979582, -23.448158],
	            [-56.967555, -23.437644],
	            [-56.948807, -23.435403],
	            [-56.925053, -23.445124],
	            [-56.906258, -23.439452],
	            [-56.883314, -23.443147],
	            [-56.868424, -23.437473],
	            [-56.811787, -23.439036],
	            [-56.8043, -23.425255],
	            [-56.776877, -23.435472],
	            [-56.750304, -23.451018],
	            [-56.726586, -23.432975],
	            [-56.693488, -23.449982],
	            [-56.673815, -23.44175],
	            [-56.632783, -23.444628],
	            [-56.607626, -23.458558],
	            [-56.564763, -23.445305],
	            [-56.529031, -23.456801],
	            [-56.517521, -23.451021],
	            [-56.515073, -23.427951],
	            [-56.491376, -23.424027],
	            [-56.476748, -23.4093],
	            [-56.457163, -23.406073],
	            [-56.43626, -23.418945],
	            [-56.406107, -23.414353],
	            [-56.384891, -23.390494],
	            [-56.352985, -23.37959],
	            [-56.361874, -23.363977],
	            [-56.349741, -23.352712],
	            [-56.314223, -23.345397],
	            [-56.293294, -23.329823],
	            [-56.250228, -23.321923],
	            [-56.238682, -23.313947],
	            [-56.221815, -23.317796],
	            [-56.192149, -23.302885],
	            [-56.174569, -23.301681],
	            [-56.162519, -23.322706]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "TACUATÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.418195, -24.745574],
	            [-56.405697, -24.782902],
	            [-56.429472, -24.792398],
	            [-56.436885, -24.832664],
	            [-56.391188, -24.887284],
	            [-56.398987, -24.904168],
	            [-56.392175, -24.913352],
	            [-56.400981, -24.928929],
	            [-56.420049, -24.933647],
	            [-56.427745, -24.944428],
	            [-56.51948, -25.003886],
	            [-56.545367, -25.00315],
	            [-56.564484, -24.997337],
	            [-56.580853, -24.988209],
	            [-56.603446, -24.986135],
	            [-56.633632, -24.957785],
	            [-56.684737, -24.868785],
	            [-56.680974, -24.856678],
	            [-56.687431, -24.81002],
	            [-56.654655, -24.802509],
	            [-56.637784, -24.813914],
	            [-56.615011, -24.803457],
	            [-56.594692, -24.80111],
	            [-56.564483, -24.789161],
	            [-56.550679, -24.771389],
	            [-56.538868, -24.770441],
	            [-56.523623, -24.775424],
	            [-56.502607, -24.760219],
	            [-56.498112, -24.748978],
	            [-56.474817, -24.719728],
	            [-56.439204, -24.707113],
	            [-56.429037, -24.71053],
	            [-56.418195, -24.745574]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "UNIÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.134739, -27.112273],
	            [-56.146439, -27.121438],
	            [-56.147174, -27.136496],
	            [-56.169738, -27.1515],
	            [-56.167893, -27.20465],
	            [-56.181177, -27.227234],
	            [-56.181851, -27.239675],
	            [-56.168952, -27.266893],
	            [-56.168231, -27.297061],
	            [-56.124613, -27.306457],
	            [-56.098127, -27.308322],
	            [-56.175637, -27.340166],
	            [-56.197087, -27.375038],
	            [-56.20912, -27.385061],
	            [-56.269638, -27.399057],
	            [-56.292493, -27.411052],
	            [-56.309819, -27.389717],
	            [-56.272077, -27.310227],
	            [-56.266434, -27.292387],
	            [-56.284182, -27.268325],
	            [-56.302769, -27.26267],
	            [-56.305146, -27.246881],
	            [-56.291289, -27.202771],
	            [-56.277932, -27.17689],
	            [-56.294974, -27.164478],
	            [-56.330813, -27.177313],
	            [-56.355149, -27.169912],
	            [-56.371544, -27.176831],
	            [-56.39179, -27.172745],
	            [-56.417295, -27.178584],
	            [-56.441311, -27.173439],
	            [-56.471163, -27.19109],
	            [-56.476901, -27.165951],
	            [-56.462554, -27.150158],
	            [-56.459289, -27.125903],
	            [-56.47365, -27.100448],
	            [-56.482484, -27.063631],
	            [-56.469077, -27.05451],
	            [-56.437354, -27.050781],
	            [-56.429874, -27.055739],
	            [-56.392806, -27.054981],
	            [-56.313287, -27.064072],
	            [-56.301545, -27.063463],
	            [-56.285614, -27.080676],
	            [-56.245082, -27.061785],
	            [-56.186902, -27.039449],
	            [-56.173379, -27.063585],
	            [-56.169645, -27.080246],
	            [-56.14056, -27.098492],
	            [-56.134739, -27.112273]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "CORONEL BOGADO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.908362, -26.220952],
	            [-54.762849, -26.347881],
	            [-54.696461, -26.404361],
	            [-54.700296, -26.437831],
	            [-54.711622, -26.455819],
	            [-54.75219, -26.493033],
	            [-54.783176, -26.511683],
	            [-54.80343, -26.544182],
	            [-54.83349, -26.545409],
	            [-54.824528, -26.525561],
	            [-54.850656, -26.511855],
	            [-54.871656, -26.524477],
	            [-54.911591, -26.503496],
	            [-54.911623, -26.489051],
	            [-54.926084, -26.474843],
	            [-54.939318, -26.477404],
	            [-54.953734, -26.463369],
	            [-54.963299, -26.435946],
	            [-54.976547, -26.441057],
	            [-54.995901, -26.420895],
	            [-55.009913, -26.424932],
	            [-55.032113, -26.411122],
	            [-55.024941, -26.393422],
	            [-55.03936, -26.389839],
	            [-55.036971, -26.374421],
	            [-55.059126, -26.363404],
	            [-55.075179, -26.363513],
	            [-55.102743, -26.324683],
	            [-55.120147, -26.322791],
	            [-55.212023, -26.239977],
	            [-55.205627, -26.233615],
	            [-55.183572, -26.213433],
	            [-55.165802, -26.216281],
	            [-55.137617, -26.206572],
	            [-55.123493, -26.219495],
	            [-55.050071, -26.237717],
	            [-55.035622, -26.237939],
	            [-55.028005, -26.223637],
	            [-55.009819, -26.235901],
	            [-54.990062, -26.225255],
	            [-54.981786, -26.238651],
	            [-54.947425, -26.233791],
	            [-54.957733, -26.222682],
	            [-54.939366, -26.20852],
	            [-54.908362, -26.220952]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "CARLOS ANTONIO LÓPEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.254855, -24.766173],
	            [-56.277746, -24.809199],
	            [-56.197163, -24.940447],
	            [-56.24882, -24.925567],
	            [-56.262941, -24.927557],
	            [-56.278033, -24.941122],
	            [-56.298665, -24.939866],
	            [-56.32813, -24.917344],
	            [-56.353049, -24.920561],
	            [-56.369432, -24.912318],
	            [-56.392175, -24.913352],
	            [-56.398987, -24.904168],
	            [-56.391188, -24.887284],
	            [-56.436885, -24.832664],
	            [-56.429472, -24.792398],
	            [-56.405697, -24.782902],
	            [-56.418195, -24.745574],
	            [-56.317287, -24.738429],
	            [-56.302356, -24.735362],
	            [-56.275064, -24.745758],
	            [-56.254855, -24.766173]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "YATAITY DEL NORTE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.151384, -24.194697],
	            [-56.158022, -24.219139],
	            [-56.170484, -24.235816],
	            [-56.155609, -24.282739],
	            [-56.126647, -24.300913],
	            [-56.125143, -24.342606],
	            [-56.11616, -24.37041],
	            [-56.123032, -24.379706],
	            [-56.146344, -24.386994],
	            [-56.180493, -24.42622],
	            [-56.191355, -24.445808],
	            [-56.232134, -24.432514],
	            [-56.247123, -24.437512],
	            [-56.271444, -24.456208],
	            [-56.297862, -24.454699],
	            [-56.287275, -24.485911],
	            [-56.259449, -24.509874],
	            [-56.262062, -24.53142],
	            [-56.257301, -24.559862],
	            [-56.309038, -24.583888],
	            [-56.449813, -24.58601],
	            [-56.479171, -24.589137],
	            [-56.479833, -24.567934],
	            [-56.519532, -24.567994],
	            [-56.519679, -24.53185],
	            [-56.526194, -24.531722],
	            [-56.524735, -24.47153],
	            [-56.540039, -24.462218],
	            [-56.5397, -24.428109],
	            [-56.531514, -24.398975],
	            [-56.538021, -24.380056],
	            [-56.556044, -24.355462],
	            [-56.545546, -24.343532],
	            [-56.546522, -24.299135],
	            [-56.493878, -24.301153],
	            [-56.440975, -24.303412],
	            [-56.365826, -24.299197],
	            [-56.365836, -24.308323],
	            [-56.286941, -24.308136],
	            [-56.287015, -24.284275],
	            [-56.272407, -24.284215],
	            [-56.272567, -24.220945],
	            [-56.198135, -24.22078],
	            [-56.198547, -24.194775],
	            [-56.151384, -24.194697]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "GUAJAYVI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.98744, -24.531236],
	            [-55.976541, -24.543285],
	            [-55.945353, -24.562912],
	            [-55.940481, -24.57057],
	            [-55.944019, -24.619265],
	            [-55.935421, -24.623431],
	            [-55.913896, -24.660447],
	            [-55.88023, -24.672427],
	            [-55.859494, -24.697307],
	            [-55.853028, -24.721531],
	            [-55.844395, -24.731452],
	            [-55.839619, -24.761879],
	            [-55.821896, -24.77385],
	            [-55.783129, -24.781929],
	            [-55.759969, -24.782908],
	            [-55.750717, -24.776921],
	            [-55.701991, -24.78397],
	            [-55.708015, -24.790957],
	            [-55.712114, -24.8199],
	            [-55.729978, -24.825008],
	            [-55.776427, -24.822422],
	            [-55.781163, -24.837822],
	            [-55.797103, -24.836629],
	            [-55.826973, -24.845741],
	            [-55.846136, -24.861453],
	            [-55.868537, -24.857954],
	            [-55.884079, -24.847499],
	            [-55.938318, -24.846133],
	            [-55.972534, -24.833745],
	            [-55.990516, -24.838419],
	            [-55.988705, -24.863221],
	            [-56.024134, -24.888207],
	            [-56.024258, -24.906038],
	            [-56.050659, -24.906208],
	            [-56.088941, -24.932729],
	            [-56.102968, -24.922314],
	            [-56.11883, -24.918813],
	            [-56.128384, -24.935166],
	            [-56.151114, -24.937293],
	            [-56.161899, -24.928346],
	            [-56.176524, -24.894305],
	            [-56.167925, -24.892289],
	            [-56.141319, -24.866401],
	            [-56.126998, -24.86196],
	            [-56.131489, -24.825661],
	            [-56.102449, -24.776296],
	            [-56.125925, -24.738171],
	            [-56.124245, -24.726878],
	            [-56.136656, -24.713128],
	            [-56.141926, -24.669973],
	            [-56.149587, -24.654208],
	            [-56.172393, -24.626732],
	            [-56.151867, -24.623141],
	            [-56.132773, -24.606262],
	            [-56.083023, -24.588018],
	            [-56.038941, -24.580293],
	            [-56.0189, -24.558057],
	            [-55.98744, -24.531236]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "CAPIIBARY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.980663, -23.667947],
	            [-55.97552, -23.744603],
	            [-55.985046, -23.779069],
	            [-56.020672, -23.800269],
	            [-56.02729, -23.822219],
	            [-56.055578, -23.842359],
	            [-56.081813, -23.848902],
	            [-56.097725, -23.859026],
	            [-56.122868, -23.859706],
	            [-56.136837, -23.867407],
	            [-56.174422, -23.860184],
	            [-56.204314, -23.878369],
	            [-56.220009, -23.898],
	            [-56.243592, -23.904991],
	            [-56.260562, -23.897712],
	            [-56.286735, -23.919189],
	            [-56.301163, -23.914211],
	            [-56.33013, -23.920308],
	            [-56.369717, -23.915129],
	            [-56.389658, -23.903743],
	            [-56.423543, -23.891756],
	            [-56.446281, -23.890915],
	            [-56.45609, -23.873425],
	            [-56.469995, -23.868566],
	            [-56.483397, -23.876859],
	            [-56.514077, -23.867091],
	            [-56.534861, -23.872547],
	            [-56.555269, -23.887104],
	            [-56.564832, -23.886411],
	            [-56.588091, -23.861836],
	            [-56.577885, -23.834806],
	            [-56.593214, -23.785021],
	            [-56.472088, -23.651115],
	            [-56.338146, -23.650822],
	            [-56.114045, -23.605876],
	            [-56.09405, -23.602035],
	            [-56.069867, -23.607776],
	            [-56.047371, -23.587458],
	            [-56.021576, -23.599062],
	            [-56.000919, -23.623406],
	            [-55.980663, -23.667947]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "SANTA ROSA DEL AGUARAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.123032, -24.379706],
	            [-56.103686, -24.399671],
	            [-56.057731, -24.403086],
	            [-56.052429, -24.421554],
	            [-56.024048, -24.444144],
	            [-56.012788, -24.482667],
	            [-55.994696, -24.501697],
	            [-55.98744, -24.531236],
	            [-56.0189, -24.558057],
	            [-56.038941, -24.580293],
	            [-56.083023, -24.588018],
	            [-56.132773, -24.606262],
	            [-56.151867, -24.623141],
	            [-56.172393, -24.626732],
	            [-56.20397, -24.606213],
	            [-56.204196, -24.584102],
	            [-56.224784, -24.578822],
	            [-56.257301, -24.559862],
	            [-56.262062, -24.53142],
	            [-56.259449, -24.509874],
	            [-56.287275, -24.485911],
	            [-56.297862, -24.454699],
	            [-56.271444, -24.456208],
	            [-56.247123, -24.437512],
	            [-56.232134, -24.432514],
	            [-56.191355, -24.445808],
	            [-56.180493, -24.42622],
	            [-56.146344, -24.386994],
	            [-56.123032, -24.379706]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "YRYBUCUA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.464863, -24.078319],
	            [-56.452727, -24.093498],
	            [-56.428388, -24.110106],
	            [-56.414384, -24.10318],
	            [-56.39265, -24.120089],
	            [-56.368464, -24.119805],
	            [-56.329637, -24.140076],
	            [-56.316651, -24.133964],
	            [-56.287026, -24.152108],
	            [-56.27656, -24.147582],
	            [-56.260197, -24.157525],
	            [-56.245, -24.153739],
	            [-56.22343, -24.15878],
	            [-56.202666, -24.143846],
	            [-56.189059, -24.156885],
	            [-56.160641, -24.149331],
	            [-56.151384, -24.194697],
	            [-56.198547, -24.194775],
	            [-56.198135, -24.22078],
	            [-56.272567, -24.220945],
	            [-56.272407, -24.284215],
	            [-56.287015, -24.284275],
	            [-56.286941, -24.308136],
	            [-56.365836, -24.308323],
	            [-56.365826, -24.299197],
	            [-56.440975, -24.303412],
	            [-56.493878, -24.301153],
	            [-56.484376, -24.265736],
	            [-56.500288, -24.214001],
	            [-56.500451, -24.197324],
	            [-56.511664, -24.178583],
	            [-56.51831, -24.1535],
	            [-56.534672, -24.12804],
	            [-56.536099, -24.097702],
	            [-56.531031, -24.065429],
	            [-56.534471, -24.054137],
	            [-56.527217, -24.048718],
	            [-56.486246, -24.063242],
	            [-56.464863, -24.078319]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "LIBERACIÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.065115, -25.333867],
	            [-57.069728, -25.344201],
	            [-57.060722, -25.359527],
	            [-57.05945, -25.378636],
	            [-57.069642, -25.399854],
	            [-57.094805, -25.422755],
	            [-57.11425, -25.429153],
	            [-57.119071, -25.450818],
	            [-57.131784, -25.455691],
	            [-57.170696, -25.429062],
	            [-57.195022, -25.401783],
	            [-57.200046, -25.360514],
	            [-57.186237, -25.342237],
	            [-57.162801, -25.358429],
	            [-57.127737, -25.34471],
	            [-57.129629, -25.304682],
	            [-57.110894, -25.311381],
	            [-57.084703, -25.313544],
	            [-57.065115, -25.333867]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "CAACUPÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.219913, -25.329638],
	            [-57.247358, -25.317479],
	            [-57.263685, -25.286552],
	            [-57.299978, -25.231472],
	            [-57.266827, -25.213439],
	            [-57.249927, -25.208582],
	            [-57.214592, -25.20801],
	            [-57.19826, -25.19506],
	            [-57.169169, -25.144912],
	            [-57.151144, -25.129624],
	            [-57.156385, -25.180967],
	            [-57.17674, -25.211325],
	            [-57.186592, -25.250339],
	            [-57.197819, -25.263808],
	            [-57.178151, -25.26914],
	            [-57.200155, -25.31474],
	            [-57.219913, -25.329638]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "ALTOS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.269082, -24.924028],
	            [-57.257124, -24.954286],
	            [-57.236079, -24.956669],
	            [-57.199748, -24.971682],
	            [-57.160999, -24.973513],
	            [-57.120214, -25.00661],
	            [-57.103678, -25.010618],
	            [-57.066075, -25.003591],
	            [-57.050596, -25.012718],
	            [-57.039551, -25.00407],
	            [-57.018101, -25.020104],
	            [-57.009232, -25.013016],
	            [-56.95923, -25.023378],
	            [-56.929577, -25.021493],
	            [-56.910611, -25.029028],
	            [-56.950905, -25.10419],
	            [-56.971995, -25.075856],
	            [-57.017805, -25.069743],
	            [-57.026115, -25.059871],
	            [-57.042431, -25.0711],
	            [-57.026603, -25.097273],
	            [-57.033295, -25.119491],
	            [-57.106956, -25.145227],
	            [-57.131001, -25.141248],
	            [-57.151008, -25.129589],
	            [-57.169975, -25.11636],
	            [-57.194949, -25.086044],
	            [-57.225015, -25.090607],
	            [-57.258432, -25.085441],
	            [-57.278465, -25.093516],
	            [-57.294053, -25.090127],
	            [-57.302672, -25.07267],
	            [-57.316967, -25.079886],
	            [-57.385737, -25.066408],
	            [-57.367145, -25.042229],
	            [-57.332126, -25.005858],
	            [-57.311273, -24.963954],
	            [-57.304273, -24.9329],
	            [-57.28733, -24.919469],
	            [-57.269082, -24.924028]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "ARROYOS Y ESTEROS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.131001, -25.141248],
	            [-57.120731, -25.154212],
	            [-57.111367, -25.196605],
	            [-57.097746, -25.211854],
	            [-57.130636, -25.259891],
	            [-57.129629, -25.304682],
	            [-57.127737, -25.34471],
	            [-57.162801, -25.358429],
	            [-57.186237, -25.342237],
	            [-57.200046, -25.360514],
	            [-57.212768, -25.355857],
	            [-57.219913, -25.329638],
	            [-57.200155, -25.31474],
	            [-57.178151, -25.26914],
	            [-57.197819, -25.263808],
	            [-57.186592, -25.250339],
	            [-57.17674, -25.211325],
	            [-57.156385, -25.180967],
	            [-57.151144, -25.129624],
	            [-57.151008, -25.129589],
	            [-57.131001, -25.141248]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "ATYRÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.619033, -25.166777],
	            [-56.66345, -25.26199],
	            [-56.681537, -25.254945],
	            [-56.69558, -25.241993],
	            [-56.712253, -25.246217],
	            [-56.714671, -25.2276],
	            [-56.724055, -25.214366],
	            [-56.746866, -25.209471],
	            [-56.763643, -25.194932],
	            [-56.774754, -25.218971],
	            [-56.763308, -25.242831],
	            [-56.766357, -25.258608],
	            [-56.757427, -25.299846],
	            [-56.747107, -25.327157],
	            [-56.802284, -25.343549],
	            [-56.820418, -25.354766],
	            [-56.835826, -25.354698],
	            [-56.837913, -25.336995],
	            [-56.831412, -25.318833],
	            [-56.850788, -25.315168],
	            [-56.887586, -25.277589],
	            [-56.882632, -25.25958],
	            [-56.906197, -25.253367],
	            [-56.90326, -25.241194],
	            [-56.893683, -25.218333],
	            [-56.894341, -25.204543],
	            [-56.874201, -25.176305],
	            [-56.862969, -25.135901],
	            [-56.849557, -25.134542],
	            [-56.828545, -25.144327],
	            [-56.808816, -25.121432],
	            [-56.750842, -25.109113],
	            [-56.645493, -25.152],
	            [-56.619033, -25.166777]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "CARAGUATAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.385737, -25.066408],
	            [-57.316967, -25.079886],
	            [-57.302672, -25.07267],
	            [-57.294053, -25.090127],
	            [-57.278465, -25.093516],
	            [-57.272796, -25.117082],
	            [-57.320735, -25.184803],
	            [-57.324171, -25.201092],
	            [-57.353069, -25.207975],
	            [-57.373973, -25.206853],
	            [-57.402491, -25.182251],
	            [-57.398983, -25.170773],
	            [-57.427015, -25.149884],
	            [-57.437008, -25.129088],
	            [-57.474415, -25.114231],
	            [-57.478317, -25.103693],
	            [-57.456977, -25.104586],
	            [-57.440162, -25.096261],
	            [-57.399767, -25.061616],
	            [-57.385737, -25.066408]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "EMBOSCADA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.945256, -25.238892],
	            [-56.941108, -25.288226],
	            [-56.9461, -25.297064],
	            [-56.927592, -25.311072],
	            [-56.914775, -25.336378],
	            [-56.878003, -25.360796],
	            [-56.897122, -25.368594],
	            [-56.875183, -25.387608],
	            [-56.864062, -25.403776],
	            [-56.868863, -25.418948],
	            [-56.900499, -25.417857],
	            [-56.908254, -25.438027],
	            [-56.926296, -25.4562],
	            [-56.947143, -25.460725],
	            [-56.971998, -25.466238],
	            [-56.989993, -25.444183],
	            [-57.035365, -25.425128],
	            [-57.037167, -25.376095],
	            [-57.05945, -25.378636],
	            [-57.060722, -25.359527],
	            [-57.069728, -25.344201],
	            [-57.065115, -25.333867],
	            [-57.045162, -25.319231],
	            [-57.022988, -25.309782],
	            [-57.018776, -25.277499],
	            [-57.022849, -25.264358],
	            [-57.011921, -25.246623],
	            [-56.967236, -25.248946],
	            [-56.945256, -25.238892]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "EUSEBIO AYALA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.90326, -25.241194],
	            [-56.906197, -25.253367],
	            [-56.882632, -25.25958],
	            [-56.887586, -25.277589],
	            [-56.850788, -25.315168],
	            [-56.831412, -25.318833],
	            [-56.837913, -25.336995],
	            [-56.835826, -25.354698],
	            [-56.860264, -25.367381],
	            [-56.878003, -25.360796],
	            [-56.914775, -25.336378],
	            [-56.927592, -25.311072],
	            [-56.9461, -25.297064],
	            [-56.941108, -25.288226],
	            [-56.945256, -25.238892],
	            [-56.942515, -25.220557],
	            [-56.90326, -25.241194]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "ISLA PUCÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.860264, -25.367381],
	            [-56.833997, -25.374896],
	            [-56.831585, -25.403433],
	            [-56.833505, -25.439068],
	            [-56.80705, -25.437921],
	            [-56.793364, -25.443516],
	            [-56.773974, -25.4649],
	            [-56.805761, -25.482386],
	            [-56.807155, -25.49019],
	            [-56.833765, -25.496335],
	            [-56.851227, -25.507642],
	            [-56.927, -25.508377],
	            [-56.928506, -25.477141],
	            [-56.947143, -25.460725],
	            [-56.926296, -25.4562],
	            [-56.908254, -25.438027],
	            [-56.900499, -25.417857],
	            [-56.868863, -25.418948],
	            [-56.864062, -25.403776],
	            [-56.875183, -25.387608],
	            [-56.897122, -25.368594],
	            [-56.878003, -25.360796],
	            [-56.860264, -25.367381]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "ITACURUBÍ DE LA CORDILLERA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.684737, -24.868785],
	            [-56.633632, -24.957785],
	            [-56.603446, -24.986135],
	            [-56.580853, -24.988209],
	            [-56.564484, -24.997337],
	            [-56.564242, -25.011932],
	            [-56.56168, -25.166074],
	            [-56.619033, -25.166777],
	            [-56.645493, -25.152],
	            [-56.750842, -25.109113],
	            [-56.776604, -25.098609],
	            [-56.837437, -25.050275],
	            [-56.858994, -25.045958],
	            [-56.876037, -25.033036],
	            [-56.910611, -25.029028],
	            [-56.929577, -25.021493],
	            [-56.95923, -25.023378],
	            [-57.009232, -25.013016],
	            [-57.018101, -25.020104],
	            [-57.039551, -25.00407],
	            [-57.048962, -24.984312],
	            [-57.030568, -24.977489],
	            [-57.015346, -24.965914],
	            [-57.004552, -24.942307],
	            [-56.989293, -24.922646],
	            [-56.980249, -24.896666],
	            [-56.983023, -24.878519],
	            [-56.954112, -24.863688],
	            [-56.949319, -24.843279],
	            [-56.860323, -24.875747],
	            [-56.842861, -24.877233],
	            [-56.812222, -24.868367],
	            [-56.767447, -24.866964],
	            [-56.749103, -24.873426],
	            [-56.735332, -24.889018],
	            [-56.720094, -24.888079],
	            [-56.708214, -24.876302],
	            [-56.689171, -24.878729],
	            [-56.684737, -24.868785]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "JUAN DE MENA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.151008, -25.129589],
	            [-57.151144, -25.129624],
	            [-57.169169, -25.144912],
	            [-57.19826, -25.19506],
	            [-57.214592, -25.20801],
	            [-57.249927, -25.208582],
	            [-57.266827, -25.213439],
	            [-57.255491, -25.197592],
	            [-57.243847, -25.16678],
	            [-57.234251, -25.158198],
	            [-57.236292, -25.124325],
	            [-57.222455, -25.100536],
	            [-57.225015, -25.090607],
	            [-57.194949, -25.086044],
	            [-57.169975, -25.11636],
	            [-57.151008, -25.129589]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "LOMA GRANDE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.66345, -25.26199],
	            [-56.645915, -25.293723],
	            [-56.623161, -25.313496],
	            [-56.606851, -25.314133],
	            [-56.561362, -25.306111],
	            [-56.651069, -25.397533],
	            [-56.672973, -25.413865],
	            [-56.722019, -25.435117],
	            [-56.728181, -25.379726],
	            [-56.73445, -25.360994],
	            [-56.748466, -25.34604],
	            [-56.747107, -25.327157],
	            [-56.757427, -25.299846],
	            [-56.766357, -25.258608],
	            [-56.763308, -25.242831],
	            [-56.774754, -25.218971],
	            [-56.763643, -25.194932],
	            [-56.746866, -25.209471],
	            [-56.724055, -25.214366],
	            [-56.714671, -25.2276],
	            [-56.712253, -25.246217],
	            [-56.69558, -25.241993],
	            [-56.681537, -25.254945],
	            [-56.66345, -25.26199]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "MBOCAYATY DEL YHAGUY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.225015, -25.090607],
	            [-57.222455, -25.100536],
	            [-57.236292, -25.124325],
	            [-57.234251, -25.158198],
	            [-57.243847, -25.16678],
	            [-57.255491, -25.197592],
	            [-57.266827, -25.213439],
	            [-57.299978, -25.231472],
	            [-57.306974, -25.214991],
	            [-57.324171, -25.201092],
	            [-57.320735, -25.184803],
	            [-57.272796, -25.117082],
	            [-57.278465, -25.093516],
	            [-57.258432, -25.085441],
	            [-57.225015, -25.090607]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "NUEVA COLOMBIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.947143, -25.460725],
	            [-56.928506, -25.477141],
	            [-56.927, -25.508377],
	            [-56.965982, -25.529797],
	            [-56.980261, -25.547324],
	            [-56.970803, -25.570088],
	            [-56.99186, -25.571449],
	            [-57.020082, -25.590981],
	            [-57.034121, -25.59176],
	            [-57.063751, -25.578507],
	            [-57.081853, -25.583342],
	            [-57.110919, -25.546847],
	            [-57.129893, -25.527532],
	            [-57.126355, -25.522925],
	            [-57.137315, -25.480454],
	            [-57.131784, -25.455691],
	            [-57.119071, -25.450818],
	            [-57.11425, -25.429153],
	            [-57.094805, -25.422755],
	            [-57.069642, -25.399854],
	            [-57.05945, -25.378636],
	            [-57.037167, -25.376095],
	            [-57.035365, -25.425128],
	            [-56.989993, -25.444183],
	            [-56.971998, -25.466238],
	            [-56.947143, -25.460725]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "PIRIBEBUY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.950905, -25.10419],
	            [-56.934867, -25.124322],
	            [-56.90864, -25.134064],
	            [-56.928164, -25.163114],
	            [-56.947905, -25.211755],
	            [-56.958432, -25.196852],
	            [-56.975814, -25.190009],
	            [-56.963666, -25.172318],
	            [-56.981572, -25.157556],
	            [-56.985192, -25.132464],
	            [-57.026603, -25.097273],
	            [-57.042431, -25.0711],
	            [-57.026115, -25.059871],
	            [-57.017805, -25.069743],
	            [-56.971995, -25.075856],
	            [-56.950905, -25.10419]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "PRIMERO DE MARZO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.299978, -25.231472],
	            [-57.263685, -25.286552],
	            [-57.247358, -25.317479],
	            [-57.219913, -25.329638],
	            [-57.212768, -25.355857],
	            [-57.233732, -25.366863],
	            [-57.249129, -25.36001],
	            [-57.268985, -25.363683],
	            [-57.296262, -25.353491],
	            [-57.307335, -25.338426],
	            [-57.33426, -25.311098],
	            [-57.343299, -25.294015],
	            [-57.341868, -25.276037],
	            [-57.32854, -25.24872],
	            [-57.337494, -25.232155],
	            [-57.349818, -25.227507],
	            [-57.373973, -25.206853],
	            [-57.353069, -25.207975],
	            [-57.324171, -25.201092],
	            [-57.306974, -25.214991],
	            [-57.299978, -25.231472]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "SAN BERNARDINO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.722019, -25.435117],
	            [-56.773974, -25.4649],
	            [-56.793364, -25.443516],
	            [-56.80705, -25.437921],
	            [-56.833505, -25.439068],
	            [-56.831585, -25.403433],
	            [-56.833997, -25.374896],
	            [-56.860264, -25.367381],
	            [-56.835826, -25.354698],
	            [-56.820418, -25.354766],
	            [-56.802284, -25.343549],
	            [-56.747107, -25.327157],
	            [-56.748466, -25.34604],
	            [-56.73445, -25.360994],
	            [-56.728181, -25.379726],
	            [-56.722019, -25.435117]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "SANTA ELENA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.947905, -25.211755],
	            [-56.942515, -25.220557],
	            [-56.945256, -25.238892],
	            [-56.967236, -25.248946],
	            [-57.011921, -25.246623],
	            [-57.022849, -25.264358],
	            [-57.018776, -25.277499],
	            [-57.022988, -25.309782],
	            [-57.045162, -25.319231],
	            [-57.065115, -25.333867],
	            [-57.084703, -25.313544],
	            [-57.110894, -25.311381],
	            [-57.129629, -25.304682],
	            [-57.130636, -25.259891],
	            [-57.097746, -25.211854],
	            [-57.111367, -25.196605],
	            [-57.120731, -25.154212],
	            [-57.131001, -25.141248],
	            [-57.106956, -25.145227],
	            [-57.033295, -25.119491],
	            [-57.026603, -25.097273],
	            [-56.985192, -25.132464],
	            [-56.981572, -25.157556],
	            [-56.963666, -25.172318],
	            [-56.975814, -25.190009],
	            [-56.958432, -25.196852],
	            [-56.947905, -25.211755]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "TOBATÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.719684, -25.658716],
	            [-56.726762, -25.663172],
	            [-56.758342, -25.64924],
	            [-56.780875, -25.631974],
	            [-56.810808, -25.625527],
	            [-56.823447, -25.64317],
	            [-56.83725, -25.6493],
	            [-56.857589, -25.646702],
	            [-56.862565, -25.662256],
	            [-56.892445, -25.668163],
	            [-56.945308, -25.651621],
	            [-56.914166, -25.590966],
	            [-56.917328, -25.564044],
	            [-56.934632, -25.569024],
	            [-56.94635, -25.561904],
	            [-56.970803, -25.570088],
	            [-56.980261, -25.547324],
	            [-56.965982, -25.529797],
	            [-56.927, -25.508377],
	            [-56.851227, -25.507642],
	            [-56.853035, -25.535367],
	            [-56.834052, -25.533499],
	            [-56.83124, -25.544237],
	            [-56.802286, -25.582017],
	            [-56.719684, -25.658716]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "VALENZUELA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.750842, -25.109113],
	            [-56.808816, -25.121432],
	            [-56.828545, -25.144327],
	            [-56.849557, -25.134542],
	            [-56.862969, -25.135901],
	            [-56.874201, -25.176305],
	            [-56.894341, -25.204543],
	            [-56.893683, -25.218333],
	            [-56.90326, -25.241194],
	            [-56.942515, -25.220557],
	            [-56.947905, -25.211755],
	            [-56.928164, -25.163114],
	            [-56.90864, -25.134064],
	            [-56.934867, -25.124322],
	            [-56.950905, -25.10419],
	            [-56.910611, -25.029028],
	            [-56.876037, -25.033036],
	            [-56.858994, -25.045958],
	            [-56.837437, -25.050275],
	            [-56.776604, -25.098609],
	            [-56.750842, -25.109113]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CORDILLERA",
	        "dist_desc_": "SAN JOSÉ OBRERO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.456667, -25.731081],
	            [-56.426079, -25.75069],
	            [-56.398212, -25.758768],
	            [-56.35362, -25.776812],
	            [-56.335607, -25.79698],
	            [-56.313834, -25.779691],
	            [-56.279545, -25.80959],
	            [-56.276798, -25.844823],
	            [-56.289907, -25.874771],
	            [-56.339091, -25.878276],
	            [-56.353574, -25.8958],
	            [-56.363888, -25.893781],
	            [-56.389069, -25.898997],
	            [-56.429083, -25.919062],
	            [-56.454944, -25.897856],
	            [-56.454695, -25.885918],
	            [-56.489932, -25.879995],
	            [-56.49403, -25.888536],
	            [-56.488732, -25.914647],
	            [-56.520348, -25.914255],
	            [-56.536435, -25.895141],
	            [-56.50706, -25.868939],
	            [-56.513834, -25.84752],
	            [-56.495395, -25.817183],
	            [-56.50084, -25.796304],
	            [-56.49962, -25.773382],
	            [-56.477711, -25.754049],
	            [-56.478512, -25.722013],
	            [-56.456667, -25.731081]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "VILLARRICA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.536435, -25.895141],
	            [-56.520348, -25.914255],
	            [-56.488732, -25.914647],
	            [-56.482626, -25.925743],
	            [-56.486807, -25.94632],
	            [-56.464526, -25.969578],
	            [-56.486314, -26.017519],
	            [-56.505011, -26.036038],
	            [-56.543319, -26.034095],
	            [-56.570012, -26.03846],
	            [-56.571444, -26.098256],
	            [-56.615798, -26.176472],
	            [-56.629165, -26.194631],
	            [-56.632747, -26.187327],
	            [-56.673423, -26.166968],
	            [-56.703753, -26.147234],
	            [-56.711758, -26.130117],
	            [-56.70579, -26.108989],
	            [-56.721934, -26.091607],
	            [-56.701791, -26.04464],
	            [-56.705464, -26.0275],
	            [-56.720967, -25.998364],
	            [-56.726172, -25.979917],
	            [-56.73702, -25.972646],
	            [-56.747588, -25.951921],
	            [-56.697863, -25.964883],
	            [-56.676833, -25.96265],
	            [-56.666061, -25.970483],
	            [-56.641556, -25.968454],
	            [-56.607639, -25.978275],
	            [-56.607719, -25.940555],
	            [-56.578641, -25.950614],
	            [-56.570295, -25.940105],
	            [-56.572526, -25.919452],
	            [-56.536435, -25.895141]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "BORJA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.292163, -25.569038],
	            [-56.287292, -25.585336],
	            [-56.256065, -25.578322],
	            [-56.231182, -25.580266],
	            [-56.205938, -25.576799],
	            [-56.154692, -25.599507],
	            [-56.120886, -25.607682],
	            [-56.059975, -25.622427],
	            [-55.943138, -25.626837],
	            [-55.957751, -25.628321],
	            [-56.010383, -25.67583],
	            [-56.029605, -25.661656],
	            [-56.062358, -25.656629],
	            [-56.068363, -25.641462],
	            [-56.079848, -25.640135],
	            [-56.098325, -25.653406],
	            [-56.118748, -25.658276],
	            [-56.142035, -25.638003],
	            [-56.158874, -25.640015],
	            [-56.178953, -25.632337],
	            [-56.200575, -25.638236],
	            [-56.213856, -25.648092],
	            [-56.225132, -25.628485],
	            [-56.237711, -25.624136],
	            [-56.265233, -25.640926],
	            [-56.280866, -25.633558],
	            [-56.302515, -25.632514],
	            [-56.306189, -25.56874],
	            [-56.292163, -25.569038]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "CAPITÁN MAURICIO JOSÉ TROCHE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.584448, -25.662496],
	            [-56.571677, -25.735996],
	            [-56.559047, -25.749938],
	            [-56.536828, -25.762015],
	            [-56.52517, -25.774625],
	            [-56.556929, -25.801721],
	            [-56.577453, -25.799518],
	            [-56.585894, -25.807954],
	            [-56.618632, -25.805067],
	            [-56.622671, -25.779971],
	            [-56.64279, -25.770525],
	            [-56.655783, -25.751806],
	            [-56.65676, -25.717481],
	            [-56.662314, -25.706708],
	            [-56.648903, -25.686064],
	            [-56.625624, -25.676376],
	            [-56.609438, -25.678555],
	            [-56.584448, -25.662496]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "CORONEL MARTÍNEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.010065, -26.788324],
	            [-55.053897, -26.798339],
	            [-55.068199, -26.807883],
	            [-55.084487, -26.829966],
	            [-55.119354, -26.847457],
	            [-55.1396, -26.864142],
	            [-55.146681, -26.878925],
	            [-55.171043, -26.873767],
	            [-55.189743, -26.837794],
	            [-55.184571, -26.813431],
	            [-55.206123, -26.818719],
	            [-55.224, -26.793969],
	            [-55.210708, -26.780954],
	            [-55.196382, -26.783576],
	            [-55.180552, -26.771673],
	            [-55.194361, -26.759874],
	            [-55.190799, -26.737008],
	            [-55.207571, -26.724731],
	            [-55.213617, -26.705202],
	            [-55.238647, -26.714602],
	            [-55.249169, -26.704834],
	            [-55.220572, -26.689343],
	            [-55.222948, -26.671699],
	            [-55.241679, -26.650337],
	            [-55.236842, -26.623143],
	            [-55.209707, -26.603667],
	            [-55.18849, -26.604555],
	            [-55.157684, -26.599204],
	            [-55.138916, -26.614611],
	            [-55.118764, -26.615411],
	            [-55.110888, -26.627596],
	            [-55.109849, -26.671963],
	            [-55.096929, -26.701599],
	            [-55.05556, -26.71413],
	            [-55.037185, -26.742706],
	            [-55.018965, -26.741468],
	            [-54.999281, -26.770688],
	            [-55.010065, -26.788324]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "NATALIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.023823, -26.97842],
	            [-55.997271, -26.99884],
	            [-55.987018, -26.989745],
	            [-55.885537, -27.081464],
	            [-55.903694, -27.092549],
	            [-55.923001, -27.112599],
	            [-55.926239, -27.134262],
	            [-55.932225, -27.145562],
	            [-55.948289, -27.148859],
	            [-55.96101, -27.172632],
	            [-55.973999, -27.172694],
	            [-55.993186, -27.189335],
	            [-56.12883, -27.069365],
	            [-56.116024, -27.05183],
	            [-56.117491, -27.01366],
	            [-56.077882, -26.988765],
	            [-56.047847, -26.974603],
	            [-56.023823, -26.97842]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "FRAM"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.367068, -27.026986],
	            [-58.360949, -27.035023],
	            [-58.374123, -27.073871],
	            [-58.387952, -27.07085],
	            [-58.400158, -27.153292],
	            [-58.41731, -27.156237],
	            [-58.48299, -27.167049],
	            [-58.498697, -27.15849],
	            [-58.507806, -27.164873],
	            [-58.540708, -27.161752],
	            [-58.567273, -27.182015],
	            [-58.645827, -27.196756],
	            [-58.659632, -27.187018],
	            [-58.664337, -27.16555],
	            [-58.651705, -27.133666],
	            [-58.640855, -27.122069],
	            [-58.617717, -27.112715],
	            [-58.558522, -27.107795],
	            [-58.55721, -27.038096],
	            [-58.531056, -27.037528],
	            [-58.508983, -27.062489],
	            [-58.502949, -27.034635],
	            [-58.478723, -27.028855],
	            [-58.452276, -27.029462],
	            [-58.439558, -27.018513],
	            [-58.428914, -27.035113],
	            [-58.410561, -27.040374],
	            [-58.388225, -27.02354],
	            [-58.367068, -27.026986]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "HUMAITÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.105601, -27.019521],
	            [-58.146167, -27.041413],
	            [-58.203843, -27.060879],
	            [-58.255656, -27.055887],
	            [-58.307461, -27.050896],
	            [-58.322418, -27.029313],
	            [-58.367068, -27.026986],
	            [-58.388225, -27.02354],
	            [-58.410561, -27.040374],
	            [-58.428914, -27.035113],
	            [-58.439558, -27.018513],
	            [-58.452276, -27.029462],
	            [-58.478723, -27.028855],
	            [-58.502949, -27.034635],
	            [-58.517762, -27.012628],
	            [-58.501764, -26.996602],
	            [-58.470904, -26.998444],
	            [-58.469315, -26.983032],
	            [-58.500826, -26.929698],
	            [-58.49435, -26.9228],
	            [-58.463634, -26.930338],
	            [-58.397771, -26.896372],
	            [-58.385315, -26.892457],
	            [-58.255319, -26.908945],
	            [-58.239261, -26.896946],
	            [-58.22283, -26.899752],
	            [-58.217385, -26.912534],
	            [-58.197001, -26.924869],
	            [-58.188191, -26.938877],
	            [-58.176731, -26.981479],
	            [-58.157452, -26.981445],
	            [-58.151102, -27.002445],
	            [-58.105601, -27.019521]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "ISLA UMBÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.447622, -24.307897],
	            [-54.447858, -24.307814],
	            [-54.478352, -24.320633],
	            [-54.498803, -24.334191],
	            [-54.490005, -24.354397],
	            [-54.459086, -24.379668],
	            [-54.46433, -24.390279],
	            [-54.49758, -24.401217],
	            [-54.579236, -24.384045],
	            [-54.602587, -24.368068],
	            [-54.603027, -24.332665],
	            [-54.594873, -24.313296],
	            [-54.593997, -24.290972],
	            [-54.581753, -24.277613],
	            [-54.588979, -24.268115],
	            [-54.615599, -24.198306],
	            [-54.653665, -24.132093],
	            [-54.683915, -24.089513],
	            [-54.698781, -24.058164],
	            [-54.706105, -24.021181],
	            [-54.700788, -23.992191],
	            [-54.69093, -23.974471],
	            [-54.643093, -23.965104],
	            [-54.606441, -23.976371],
	            [-54.612294, -24.008076],
	            [-54.606048, -24.019601],
	            [-54.608105, -24.042657],
	            [-54.542864, -24.0931],
	            [-54.541234, -24.118723],
	            [-54.530147, -24.133402],
	            [-54.542937, -24.147094],
	            [-54.458165, -24.211783],
	            [-54.42686, -24.217072],
	            [-54.41281, -24.233663],
	            [-54.421572, -24.245396],
	            [-54.421087, -24.27725],
	            [-54.447622, -24.307897]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "LA PALOMA DEL ESPÍRITU SANTO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.712784, -24.466358],
	            [-54.696262, -24.49729],
	            [-54.672339, -24.495375],
	            [-54.648225, -24.499731],
	            [-54.625611, -24.513783],
	            [-54.612566, -24.513437],
	            [-54.6119, -24.513576],
	            [-54.590618, -24.525721],
	            [-54.568911, -24.5254],
	            [-54.553883, -24.536435],
	            [-54.544408, -24.531095],
	            [-54.528989, -24.500552],
	            [-54.514831, -24.51625],
	            [-54.478974, -24.529503],
	            [-54.471294, -24.519171],
	            [-54.451739, -24.52495],
	            [-54.4263, -24.520206],
	            [-54.403721, -24.526962],
	            [-54.388003, -24.514849],
	            [-54.337188, -24.529039],
	            [-54.317429, -24.579943],
	            [-54.316512, -24.612469],
	            [-54.330034, -24.687963],
	            [-54.345807, -24.70766],
	            [-54.388422, -24.6878],
	            [-54.401625, -24.690621],
	            [-54.414963, -24.679505],
	            [-54.425065, -24.698939],
	            [-54.442937, -24.698474],
	            [-54.443583, -24.718126],
	            [-54.472163, -24.7234],
	            [-54.476453, -24.706886],
	            [-54.499098, -24.719593],
	            [-54.504421, -24.698763],
	            [-54.525297, -24.703708],
	            [-54.536398, -24.691861],
	            [-54.559952, -24.689375],
	            [-54.610266, -24.696964],
	            [-54.615111, -24.707076],
	            [-54.657861, -24.699844],
	            [-54.648169, -24.686923],
	            [-54.654124, -24.668356],
	            [-54.68304, -24.671952],
	            [-54.687385, -24.688325],
	            [-54.72046, -24.67641],
	            [-54.737933, -24.651919],
	            [-54.751686, -24.660109],
	            [-54.778602, -24.651542],
	            [-54.785245, -24.665315],
	            [-54.810644, -24.673316],
	            [-54.871519, -24.633855],
	            [-54.898908, -24.629243],
	            [-54.903853, -24.598787],
	            [-54.911696, -24.576463],
	            [-54.943617, -24.564523],
	            [-54.955096, -24.567317],
	            [-54.97138, -24.567716],
	            [-54.989176, -24.550463],
	            [-55.016638, -24.549184],
	            [-55.018011, -24.527859],
	            [-55.027833, -24.506327],
	            [-55.014787, -24.485484],
	            [-54.963658, -24.454144],
	            [-54.958574, -24.447323],
	            [-54.712784, -24.466358]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "NUEVA ESPERANZA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.938791, -24.372457],
	            [-55.924184, -24.369996],
	            [-55.8976, -24.386528],
	            [-55.871485, -24.396627],
	            [-55.861381, -24.421495],
	            [-55.863683, -24.434938],
	            [-55.827921, -24.468732],
	            [-55.797316, -24.479787],
	            [-55.776825, -24.509175],
	            [-55.774658, -24.52585],
	            [-55.758221, -24.535527],
	            [-55.756564, -24.562266],
	            [-55.749205, -24.571361],
	            [-55.767042, -24.588372],
	            [-55.764637, -24.618531],
	            [-55.75262, -24.637621],
	            [-55.762171, -24.656149],
	            [-55.727095, -24.72135],
	            [-55.736106, -24.743189],
	            [-55.718269, -24.758095],
	            [-55.701991, -24.78397],
	            [-55.750717, -24.776921],
	            [-55.759969, -24.782908],
	            [-55.783129, -24.781929],
	            [-55.821896, -24.77385],
	            [-55.839619, -24.761879],
	            [-55.844395, -24.731452],
	            [-55.853028, -24.721531],
	            [-55.859494, -24.697307],
	            [-55.88023, -24.672427],
	            [-55.913896, -24.660447],
	            [-55.935421, -24.623431],
	            [-55.944019, -24.619265],
	            [-55.940481, -24.57057],
	            [-55.945353, -24.562912],
	            [-55.976541, -24.543285],
	            [-55.98744, -24.531236],
	            [-55.994696, -24.501697],
	            [-56.012788, -24.482667],
	            [-56.024048, -24.444144],
	            [-56.052429, -24.421554],
	            [-56.057731, -24.403086],
	            [-56.024464, -24.394777],
	            [-56.00945, -24.398716],
	            [-55.991671, -24.378726],
	            [-55.95659, -24.367014],
	            [-55.938791, -24.372457]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "YASY CAÑY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.921589, -24.347711],
	            [-54.933543, -24.363009],
	            [-54.954066, -24.374045],
	            [-54.957234, -24.405099],
	            [-54.95393, -24.419589],
	            [-54.961605, -24.432792],
	            [-54.958574, -24.447323],
	            [-54.963658, -24.454144],
	            [-55.014787, -24.485484],
	            [-55.027833, -24.506327],
	            [-55.018011, -24.527859],
	            [-55.016638, -24.549184],
	            [-55.031299, -24.54437],
	            [-55.054886, -24.551203],
	            [-55.102954, -24.543704],
	            [-55.112865, -24.536628],
	            [-55.113647, -24.505702],
	            [-55.134036, -24.479881],
	            [-55.154635, -24.479057],
	            [-55.1803, -24.465456],
	            [-55.210568, -24.468604],
	            [-55.238953, -24.475998],
	            [-55.252526, -24.467507],
	            [-55.272355, -24.49292],
	            [-55.304158, -24.493571],
	            [-55.310341, -24.511868],
	            [-55.322406, -24.478439],
	            [-55.333374, -24.460944],
	            [-55.322082, -24.433312],
	            [-55.326016, -24.410683],
	            [-55.342097, -24.391424],
	            [-55.373024, -24.374238],
	            [-55.360012, -24.359492],
	            [-55.316531, -24.353547],
	            [-55.288388, -24.36366],
	            [-55.257607, -24.365008],
	            [-55.244879, -24.353588],
	            [-55.230193, -24.352034],
	            [-55.223375, -24.34058],
	            [-55.195278, -24.32512],
	            [-55.184395, -24.312591],
	            [-55.192451, -24.268784],
	            [-55.209532, -24.252207],
	            [-55.208658, -24.241852],
	            [-55.177824, -24.229017],
	            [-55.161325, -24.191926],
	            [-55.175846, -24.157831],
	            [-55.17744, -24.143133],
	            [-55.160378, -24.137049],
	            [-55.144614, -24.112129],
	            [-55.127058, -24.120383],
	            [-55.120535, -24.136099],
	            [-55.084661, -24.14],
	            [-55.076625, -24.134979],
	            [-55.051543, -24.137316],
	            [-55.038671, -24.144622],
	            [-55.032483, -24.165358],
	            [-55.004534, -24.176542],
	            [-54.994632, -24.247257],
	            [-54.996289, -24.272978],
	            [-54.98287, -24.286578],
	            [-54.983614, -24.299751],
	            [-54.941163, -24.327556],
	            [-54.921589, -24.347711]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "YBYRAROBANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.690801, -25.100726],
	            [-57.736476, -25.097113],
	            [-57.760693, -25.102492],
	            [-57.766155, -25.086191],
	            [-57.784006, -25.066257],
	            [-57.815753, -25.064903],
	            [-57.815257, -24.946246],
	            [-57.914972, -24.946696],
	            [-57.915458, -24.839357],
	            [-57.955497, -24.840741],
	            [-57.955039, -24.852022],
	            [-58.032039, -24.85068],
	            [-58.114375, -24.825761],
	            [-58.113881, -24.746055],
	            [-58.121295, -24.703918],
	            [-58.17192, -24.70122],
	            [-58.259736, -24.702341],
	            [-58.322056, -24.701439],
	            [-58.479784, -24.689553],
	            [-58.487746, -24.651636],
	            [-58.511136, -24.450709],
	            [-58.531788, -24.272547],
	            [-58.717981, -24.114743],
	            [-58.712062, -23.808446],
	            [-58.700311, -23.802064],
	            [-58.683166, -23.822584],
	            [-58.66544, -23.82031],
	            [-58.635262, -23.829311],
	            [-58.617633, -23.828217],
	            [-58.576506, -23.840757],
	            [-58.556196, -23.830929],
	            [-58.532747, -23.84212],
	            [-58.49807, -23.864732],
	            [-58.48321, -23.865825],
	            [-58.472417, -23.877561],
	            [-58.450801, -23.883101],
	            [-58.44799, -23.894518],
	            [-58.428795, -23.888525],
	            [-58.415508, -23.892539],
	            [-58.395416, -23.880166],
	            [-58.381006, -23.85864],
	            [-58.359735, -23.857115],
	            [-58.335411, -23.866198],
	            [-58.321843, -23.858589],
	            [-58.280378, -23.858749],
	            [-58.242387, -23.837026],
	            [-58.226449, -23.849072],
	            [-58.190344, -23.847985],
	            [-58.178672, -23.870231],
	            [-58.152128, -23.881145],
	            [-58.15022, -23.901016],
	            [-58.132074, -23.891604],
	            [-58.096503, -23.896834],
	            [-58.062193, -23.888649],
	            [-58.047111, -23.873866],
	            [-58.030044, -23.879377],
	            [-57.967376, -23.857035],
	            [-57.948844, -23.845375],
	            [-57.918908, -23.85447],
	            [-57.906309, -23.845833],
	            [-57.865583, -23.854347],
	            [-57.84557, -23.836879],
	            [-57.829995, -23.833094],
	            [-57.823616, -23.821666],
	            [-57.784158, -23.817581],
	            [-57.796767, -24.219176],
	            [-57.795218, -24.24376],
	            [-57.706457, -24.252312],
	            [-57.685669, -24.261596],
	            [-57.6801, -24.274382],
	            [-57.655163, -24.271302],
	            [-57.637158, -24.285682],
	            [-57.603817, -24.292269],
	            [-57.587975, -24.304462],
	            [-57.563788, -24.301935],
	            [-57.562869, -24.32921],
	            [-57.544303, -24.373207],
	            [-57.494531, -24.700068],
	            [-57.416807, -24.868048],
	            [-57.417168, -24.97559],
	            [-57.47928, -24.975566],
	            [-57.480898, -25.009426],
	            [-57.518798, -25.03829],
	            [-57.550628, -25.051723],
	            [-57.550928, -25.060047],
	            [-57.590018, -25.068962],
	            [-57.690801, -25.100726]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "BENJAMÍN ACEVAL"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.85573, -22.397713],
	            [-57.864481, -22.403069],
	            [-57.862, -22.423963],
	            [-57.840531, -22.443855],
	            [-57.844475, -22.487727],
	            [-57.830876, -22.513493],
	            [-57.827744, -22.570731],
	            [-57.804785, -22.592152],
	            [-57.779917, -22.622618],
	            [-57.772888, -22.639449],
	            [-57.776803, -22.661268],
	            [-57.789976, -22.663873],
	            [-57.829701, -22.652846],
	            [-57.848425, -22.651732],
	            [-57.909428, -22.659125],
	            [-57.937445, -22.688967],
	            [-57.940248, -22.708272],
	            [-57.925789, -22.743273],
	            [-57.890147, -22.755891],
	            [-57.877433, -22.773711],
	            [-57.882556, -22.793939],
	            [-57.875318, -22.80298],
	            [-57.840264, -22.807997],
	            [-57.811439, -22.817369],
	            [-57.789507, -22.877517],
	            [-57.798432, -22.892743],
	            [-57.818284, -22.90415],
	            [-57.821375, -22.914974],
	            [-57.789877, -22.941428],
	            [-57.767394, -22.965291],
	            [-57.765863, -22.976363],
	            [-57.784939, -23.006277],
	            [-57.786599, -23.032143],
	            [-57.767183, -23.035906],
	            [-57.731485, -23.059845],
	            [-57.725078, -23.078884],
	            [-57.70176, -23.097241],
	            [-57.667017, -23.094004],
	            [-57.676761, -23.1154],
	            [-57.704197, -23.121804],
	            [-57.719898, -23.106912],
	            [-57.744794, -23.100777],
	            [-57.746125, -23.089394],
	            [-57.766928, -23.076683],
	            [-57.767876, -23.096221],
	            [-57.786884, -23.107148],
	            [-57.790405, -23.123347],
	            [-57.83076, -23.131665],
	            [-57.839002, -23.162946],
	            [-57.827875, -23.183735],
	            [-57.837173, -23.208884],
	            [-57.856996, -23.200357],
	            [-57.881562, -23.19633],
	            [-57.905297, -23.219173],
	            [-57.9315, -23.219664],
	            [-57.954297, -23.240929],
	            [-57.970785, -23.240643],
	            [-57.987952, -23.229569],
	            [-57.997516, -23.239257],
	            [-57.986056, -23.251403],
	            [-58.023003, -23.259215],
	            [-58.060443, -23.251306],
	            [-58.071693, -23.262176],
	            [-58.090489, -23.260797],
	            [-58.102504, -23.267934],
	            [-58.114804, -23.291683],
	            [-58.151088, -23.297936],
	            [-58.15448, -23.312254],
	            [-58.195112, -23.345225],
	            [-58.219982, -23.35941],
	            [-58.236044, -23.335506],
	            [-58.264016, -23.329081],
	            [-58.291375, -23.332722],
	            [-58.295443, -23.340996],
	            [-58.327354, -23.358789],
	            [-58.34068, -23.354179],
	            [-58.349214, -23.337195],
	            [-58.381154, -23.342362],
	            [-58.413703, -23.360397],
	            [-58.483768, -23.326472],
	            [-58.498446, -23.330353],
	            [-58.516738, -23.311292],
	            [-58.55307, -23.313511],
	            [-58.561349, -23.321787],
	            [-58.606013, -23.301025],
	            [-58.605561, -23.290855],
	            [-58.628783, -23.271554],
	            [-58.63156, -23.245669],
	            [-58.652885, -23.244427],
	            [-58.679533, -23.250434],
	            [-58.703081, -23.2619],
	            [-58.722345, -23.262032],
	            [-58.754896, -23.245455],
	            [-58.770773, -23.245264],
	            [-58.778376, -23.226426],
	            [-58.795179, -23.220933],
	            [-58.80758, -23.226185],
	            [-58.83466, -23.213253],
	            [-58.847581, -23.21441],
	            [-58.897964, -23.232291],
	            [-58.926921, -23.223884],
	            [-58.938551, -23.20788],
	            [-58.966364, -23.189774],
	            [-58.97637, -23.171238],
	            [-58.997821, -23.17618],
	            [-59.018176, -23.171364],
	            [-59.026977, -23.182973],
	            [-59.064637, -23.2013],
	            [-59.096653, -23.204566],
	            [-59.102767, -23.217472],
	            [-59.139808, -23.206743],
	            [-59.157962, -23.197048],
	            [-59.173485, -23.216258],
	            [-59.186542, -23.217517],
	            [-59.196426, -23.193838],
	            [-59.235589, -23.075203],
	            [-59.246939, -23.062425],
	            [-59.168664, -22.986474],
	            [-59.15637, -22.986809],
	            [-59.137518, -22.925649],
	            [-59.142901, -22.883794],
	            [-59.149494, -22.878035],
	            [-59.147497, -22.838067],
	            [-59.154832, -22.787531],
	            [-59.143386, -22.750232],
	            [-59.121189, -22.740231],
	            [-59.12266, -22.694843],
	            [-59.083941, -22.663238],
	            [-59.063904, -22.669205],
	            [-59.052692, -22.646782],
	            [-59.053787, -22.633602],
	            [-59.019271, -22.62812],
	            [-59.001127, -22.620245],
	            [-58.963786, -22.614435],
	            [-58.941243, -22.605237],
	            [-58.90549, -22.620673],
	            [-58.895668, -22.619978],
	            [-58.887053, -22.601147],
	            [-58.852064, -22.605185],
	            [-59.011047, -22.426495],
	            [-59.00383, -22.414422],
	            [-58.985812, -22.410956],
	            [-59.093743, -22.261814],
	            [-59.09552, -22.250192],
	            [-59.113629, -22.229344],
	            [-59.128575, -22.224641],
	            [-59.128159, -22.211538],
	            [-59.149384, -22.215721],
	            [-59.162257, -22.203324],
	            [-59.192965, -22.203379],
	            [-59.20287, -22.188339],
	            [-59.223061, -22.185362],
	            [-59.235273, -22.2],
	            [-59.285183, -22.190854],
	            [-59.241225, -22.132108],
	            [-59.201595, -22.147866],
	            [-59.018355, -22.150072],
	            [-58.985425, -22.159613],
	            [-58.962615, -22.150356],
	            [-58.856872, -22.151179],
	            [-58.845213, -22.156471],
	            [-58.752591, -22.157357],
	            [-58.737136, -22.152462],
	            [-58.459693, -22.156769],
	            [-58.452149, -22.163699],
	            [-58.396747, -22.178969],
	            [-58.26688, -22.179487],
	            [-58.241671, -22.189903],
	            [-58.245549, -22.240463],
	            [-58.202731, -22.282506],
	            [-58.185565, -22.349438],
	            [-57.85573, -22.397713]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "PUERTO PINASCO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.667017, -23.094004],
	            [-57.634178, -23.092942],
	            [-57.627693, -23.111368],
	            [-57.640887, -23.130492],
	            [-57.641181, -23.142112],
	            [-57.617982, -23.184036],
	            [-57.549047, -23.212022],
	            [-57.533063, -23.243891],
	            [-57.510067, -23.261699],
	            [-57.491586, -23.28276],
	            [-57.488802, -23.316407],
	            [-57.518329, -23.336076],
	            [-57.519999, -23.353219],
	            [-57.494602, -23.372686],
	            [-57.48782, -23.389018],
	            [-57.450781, -23.4468],
	            [-57.447033, -23.477583],
	            [-57.473517, -23.536198],
	            [-57.468284, -23.560286],
	            [-57.448108, -23.59987],
	            [-57.421153, -23.641253],
	            [-57.419096, -23.65374],
	            [-57.375754, -23.671087],
	            [-57.34319, -23.680226],
	            [-57.303242, -23.70765],
	            [-57.266484, -23.724657],
	            [-57.256661, -23.735966],
	            [-57.255742, -23.761376],
	            [-57.278042, -23.77159],
	            [-57.252724, -23.787087],
	            [-57.25148, -23.811903],
	            [-57.272685, -23.835046],
	            [-57.272881, -23.851539],
	            [-57.255301, -23.865982],
	            [-57.265197, -23.886024],
	            [-57.303044, -23.900664],
	            [-57.299219, -23.923999],
	            [-57.263052, -23.943976],
	            [-57.238152, -23.941788],
	            [-57.229763, -23.951756],
	            [-57.240829, -23.980716],
	            [-57.215403, -23.987555],
	            [-57.21133, -24.004546],
	            [-57.228504, -24.020382],
	            [-57.261963, -24.033534],
	            [-57.258296, -24.050593],
	            [-57.221674, -24.065833],
	            [-57.209106, -24.078374],
	            [-57.210619, -24.09775],
	            [-57.233107, -24.109672],
	            [-57.257588, -24.128726],
	            [-57.275877, -24.135491],
	            [-57.277024, -24.152374],
	            [-57.254348, -24.175924],
	            [-57.240561, -24.201047],
	            [-57.218837, -24.212017],
	            [-57.206265, -24.230844],
	            [-57.204586, -24.26132],
	            [-57.206462, -24.27594],
	            [-57.198583, -24.296633],
	            [-57.180308, -24.312634],
	            [-57.164042, -24.355937],
	            [-57.177552, -24.375919],
	            [-57.181411, -24.393309],
	            [-57.167715, -24.421707],
	            [-57.149308, -24.44898],
	            [-57.157995, -24.466646],
	            [-57.187103, -24.476981],
	            [-57.194061, -24.493401],
	            [-57.163638, -24.522844],
	            [-57.162167, -24.534117],
	            [-57.187958, -24.552788],
	            [-57.194797, -24.569149],
	            [-57.190109, -24.582187],
	            [-57.157441, -24.618256],
	            [-57.174728, -24.659764],
	            [-57.172417, -24.692456],
	            [-57.196238, -24.698261],
	            [-57.227118, -24.697197],
	            [-57.234583, -24.709879],
	            [-57.226572, -24.738273],
	            [-57.232066, -24.756792],
	            [-57.246369, -24.774159],
	            [-57.265434, -24.810102],
	            [-57.298504, -24.831286],
	            [-57.291723, -24.851466],
	            [-57.257468, -24.86014],
	            [-57.259757, -24.885631],
	            [-57.249341, -24.894825],
	            [-57.21967, -24.904729],
	            [-57.216592, -24.920651],
	            [-57.223572, -24.932765],
	            [-57.24383, -24.935],
	            [-57.269082, -24.924028],
	            [-57.28733, -24.919469],
	            [-57.304273, -24.9329],
	            [-57.311273, -24.963954],
	            [-57.332126, -25.005858],
	            [-57.367145, -25.042229],
	            [-57.385737, -25.066408],
	            [-57.399767, -25.061616],
	            [-57.440162, -25.096261],
	            [-57.456977, -25.104586],
	            [-57.478317, -25.103693],
	            [-57.496235, -25.096707],
	            [-57.515272, -25.100377],
	            [-57.533635, -25.120238],
	            [-57.539578, -25.142802],
	            [-57.536947, -25.166585],
	            [-57.54323, -25.180939],
	            [-57.559354, -25.197463],
	            [-57.575086, -25.224663],
	            [-57.593662, -25.241651],
	            [-57.622845, -25.252738],
	            [-57.665677, -25.277344],
	            [-57.67283, -25.287615],
	            [-57.673858, -25.315799],
	            [-57.663467, -25.353841],
	            [-57.681666, -25.342416],
	            [-57.698829, -25.317408],
	            [-57.705808, -25.296322],
	            [-57.689979, -25.284948],
	            [-57.705573, -25.270189],
	            [-57.703613, -25.258136],
	            [-57.679351, -25.247122],
	            [-57.671063, -25.229685],
	            [-57.652215, -25.211025],
	            [-57.646453, -25.19223],
	            [-57.666564, -25.188427],
	            [-57.680559, -25.169096],
	            [-57.7, -25.163308],
	            [-57.717873, -25.164895],
	            [-57.724241, -25.141943],
	            [-57.685548, -25.141943],
	            [-57.683835, -25.107786],
	            [-57.690801, -25.100726],
	            [-57.590018, -25.068962],
	            [-57.550928, -25.060047],
	            [-57.550628, -25.051723],
	            [-57.518798, -25.03829],
	            [-57.480898, -25.009426],
	            [-57.47928, -24.975566],
	            [-57.417168, -24.97559],
	            [-57.416807, -24.868048],
	            [-57.494531, -24.700068],
	            [-57.544303, -24.373207],
	            [-57.562869, -24.32921],
	            [-57.563788, -24.301935],
	            [-57.587975, -24.304462],
	            [-57.603817, -24.292269],
	            [-57.637158, -24.285682],
	            [-57.655163, -24.271302],
	            [-57.6801, -24.274382],
	            [-57.685669, -24.261596],
	            [-57.706457, -24.252312],
	            [-57.795218, -24.24376],
	            [-57.796767, -24.219176],
	            [-57.784158, -23.817581],
	            [-57.823616, -23.821666],
	            [-57.829995, -23.833094],
	            [-57.84557, -23.836879],
	            [-57.865583, -23.854347],
	            [-57.906309, -23.845833],
	            [-57.918908, -23.85447],
	            [-57.948844, -23.845375],
	            [-57.967376, -23.857035],
	            [-58.030044, -23.879377],
	            [-58.047111, -23.873866],
	            [-58.062193, -23.888649],
	            [-58.096503, -23.896834],
	            [-58.132074, -23.891604],
	            [-58.15022, -23.901016],
	            [-58.152128, -23.881145],
	            [-58.178672, -23.870231],
	            [-58.190344, -23.847985],
	            [-58.226449, -23.849072],
	            [-58.242387, -23.837026],
	            [-58.280378, -23.858749],
	            [-58.321843, -23.858589],
	            [-58.335411, -23.866198],
	            [-58.359735, -23.857115],
	            [-58.381006, -23.85864],
	            [-58.395416, -23.880166],
	            [-58.415508, -23.892539],
	            [-58.428795, -23.888525],
	            [-58.44799, -23.894518],
	            [-58.450801, -23.883101],
	            [-58.472417, -23.877561],
	            [-58.48321, -23.865825],
	            [-58.49807, -23.864732],
	            [-58.532747, -23.84212],
	            [-58.556196, -23.830929],
	            [-58.576506, -23.840757],
	            [-58.617633, -23.828217],
	            [-58.635262, -23.829311],
	            [-58.66544, -23.82031],
	            [-58.683166, -23.822584],
	            [-58.700311, -23.802064],
	            [-58.712062, -23.808446],
	            [-58.728679, -23.795782],
	            [-58.745968, -23.797219],
	            [-58.766423, -23.785912],
	            [-58.83283, -23.770495],
	            [-58.836085, -23.76249],
	            [-58.876161, -23.761945],
	            [-58.900644, -23.752149],
	            [-58.969889, -23.743017],
	            [-58.974011, -23.731998],
	            [-59.010762, -23.728586],
	            [-59.023775, -23.720743],
	            [-59.092331, -23.701562],
	            [-59.131977, -23.731879],
	            [-59.143186, -23.729509],
	            [-59.200613, -23.59419],
	            [-59.077755, -23.570071],
	            [-59.080985, -23.558866],
	            [-59.121469, -23.505123],
	            [-59.142093, -23.510835],
	            [-59.169859, -23.49972],
	            [-59.190558, -23.48591],
	            [-59.175383, -23.443132],
	            [-59.255353, -23.453874],
	            [-59.288182, -23.423372],
	            [-59.303716, -23.400598],
	            [-59.331309, -23.398813],
	            [-59.343109, -23.409688],
	            [-59.370274, -23.411153],
	            [-59.395309, -23.384682],
	            [-59.408154, -23.376875],
	            [-59.410086, -23.346973],
	            [-59.417212, -23.336495],
	            [-59.414323, -23.290684],
	            [-59.38713, -23.147936],
	            [-59.262477, -23.074327],
	            [-59.246939, -23.062425],
	            [-59.235589, -23.075203],
	            [-59.196426, -23.193838],
	            [-59.186542, -23.217517],
	            [-59.173485, -23.216258],
	            [-59.157962, -23.197048],
	            [-59.139808, -23.206743],
	            [-59.102767, -23.217472],
	            [-59.096653, -23.204566],
	            [-59.064637, -23.2013],
	            [-59.026977, -23.182973],
	            [-59.018176, -23.171364],
	            [-58.997821, -23.17618],
	            [-58.97637, -23.171238],
	            [-58.966364, -23.189774],
	            [-58.938551, -23.20788],
	            [-58.926921, -23.223884],
	            [-58.897964, -23.232291],
	            [-58.847581, -23.21441],
	            [-58.83466, -23.213253],
	            [-58.80758, -23.226185],
	            [-58.795179, -23.220933],
	            [-58.778376, -23.226426],
	            [-58.770773, -23.245264],
	            [-58.754896, -23.245455],
	            [-58.722345, -23.262032],
	            [-58.703081, -23.2619],
	            [-58.679533, -23.250434],
	            [-58.652885, -23.244427],
	            [-58.63156, -23.245669],
	            [-58.628783, -23.271554],
	            [-58.605561, -23.290855],
	            [-58.606013, -23.301025],
	            [-58.561349, -23.321787],
	            [-58.55307, -23.313511],
	            [-58.516738, -23.311292],
	            [-58.498446, -23.330353],
	            [-58.483768, -23.326472],
	            [-58.413703, -23.360397],
	            [-58.381154, -23.342362],
	            [-58.349214, -23.337195],
	            [-58.34068, -23.354179],
	            [-58.327354, -23.358789],
	            [-58.295443, -23.340996],
	            [-58.291375, -23.332722],
	            [-58.264016, -23.329081],
	            [-58.236044, -23.335506],
	            [-58.219982, -23.35941],
	            [-58.195112, -23.345225],
	            [-58.15448, -23.312254],
	            [-58.151088, -23.297936],
	            [-58.114804, -23.291683],
	            [-58.102504, -23.267934],
	            [-58.090489, -23.260797],
	            [-58.071693, -23.262176],
	            [-58.060443, -23.251306],
	            [-58.023003, -23.259215],
	            [-57.986056, -23.251403],
	            [-57.997516, -23.239257],
	            [-57.987952, -23.229569],
	            [-57.970785, -23.240643],
	            [-57.954297, -23.240929],
	            [-57.9315, -23.219664],
	            [-57.905297, -23.219173],
	            [-57.881562, -23.19633],
	            [-57.856996, -23.200357],
	            [-57.837173, -23.208884],
	            [-57.827875, -23.183735],
	            [-57.839002, -23.162946],
	            [-57.83076, -23.131665],
	            [-57.790405, -23.123347],
	            [-57.786884, -23.107148],
	            [-57.767876, -23.096221],
	            [-57.766928, -23.076683],
	            [-57.746125, -23.089394],
	            [-57.744794, -23.100777],
	            [-57.719898, -23.106912],
	            [-57.704197, -23.121804],
	            [-57.676761, -23.1154],
	            [-57.667017, -23.094004]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "VILLA HAYES"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.705573, -25.270189],
	            [-57.689979, -25.284948],
	            [-57.705808, -25.296322],
	            [-57.717865, -25.266663],
	            [-57.705573, -25.270189]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "NANAWA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.479784, -24.689553],
	            [-58.322056, -24.701439],
	            [-58.259736, -24.702341],
	            [-58.17192, -24.70122],
	            [-58.121295, -24.703918],
	            [-58.113881, -24.746055],
	            [-58.114375, -24.825761],
	            [-58.032039, -24.85068],
	            [-57.955039, -24.852022],
	            [-57.955497, -24.840741],
	            [-57.915458, -24.839357],
	            [-57.914972, -24.946696],
	            [-57.815257, -24.946246],
	            [-57.815753, -25.064903],
	            [-57.784006, -25.066257],
	            [-57.766155, -25.086191],
	            [-57.760693, -25.102492],
	            [-57.736476, -25.097113],
	            [-57.690801, -25.100726],
	            [-57.683835, -25.107786],
	            [-57.685548, -25.141943],
	            [-57.724241, -25.141943],
	            [-57.717873, -25.164895],
	            [-57.7, -25.163308],
	            [-57.680559, -25.169096],
	            [-57.666564, -25.188427],
	            [-57.646453, -25.19223],
	            [-57.652215, -25.211025],
	            [-57.671063, -25.229685],
	            [-57.679351, -25.247122],
	            [-57.703613, -25.258136],
	            [-57.705573, -25.270189],
	            [-57.717865, -25.266663],
	            [-57.72927, -25.258846],
	            [-57.745802, -25.227758],
	            [-57.758773, -25.215991],
	            [-57.75557, -25.196945],
	            [-57.760899, -25.172496],
	            [-57.78, -25.152513],
	            [-57.801114, -25.149631],
	            [-57.836778, -25.131503],
	            [-57.850683, -25.109449],
	            [-57.849699, -25.097679],
	            [-57.884307, -25.075663],
	            [-57.906967, -25.073321],
	            [-57.931611, -25.077967],
	            [-57.965526, -25.075293],
	            [-57.989059, -25.081736],
	            [-57.996256, -25.060138],
	            [-58.011015, -25.040569],
	            [-58.028794, -25.03578],
	            [-58.044863, -25.042986],
	            [-58.077264, -25.037773],
	            [-58.085455, -25.012474],
	            [-58.117032, -25.019022],
	            [-58.136795, -25.011644],
	            [-58.137801, -24.989457],
	            [-58.149539, -24.975699],
	            [-58.168434, -24.968482],
	            [-58.188709, -24.96904],
	            [-58.201924, -24.949868],
	            [-58.217104, -24.950445],
	            [-58.224421, -24.927566],
	            [-58.237999, -24.92693],
	            [-58.257385, -24.93838],
	            [-58.288694, -24.964045],
	            [-58.31353, -24.989016],
	            [-58.331224, -24.999514],
	            [-58.341241, -24.996574],
	            [-58.353027, -24.968417],
	            [-58.393116, -24.95157],
	            [-58.413132, -24.920568],
	            [-58.430161, -24.921499],
	            [-58.430397, -24.892872],
	            [-58.475914, -24.86033],
	            [-58.502007, -24.850966],
	            [-58.477474, -24.827326],
	            [-58.475293, -24.775615],
	            [-58.479784, -24.689553]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "JOSÉ FALCÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-59.241225, -22.132108],
	            [-59.285183, -22.190854],
	            [-59.235273, -22.2],
	            [-59.223061, -22.185362],
	            [-59.20287, -22.188339],
	            [-59.192965, -22.203379],
	            [-59.162257, -22.203324],
	            [-59.149384, -22.215721],
	            [-59.128159, -22.211538],
	            [-59.128575, -22.224641],
	            [-59.113629, -22.229344],
	            [-59.09552, -22.250192],
	            [-59.093743, -22.261814],
	            [-58.985812, -22.410956],
	            [-59.00383, -22.414422],
	            [-59.011047, -22.426495],
	            [-58.852064, -22.605185],
	            [-58.887053, -22.601147],
	            [-58.895668, -22.619978],
	            [-58.90549, -22.620673],
	            [-58.941243, -22.605237],
	            [-58.963786, -22.614435],
	            [-59.001127, -22.620245],
	            [-59.019271, -22.62812],
	            [-59.053787, -22.633602],
	            [-59.052692, -22.646782],
	            [-59.063904, -22.669205],
	            [-59.083941, -22.663238],
	            [-59.12266, -22.694843],
	            [-59.121189, -22.740231],
	            [-59.143386, -22.750232],
	            [-59.154832, -22.787531],
	            [-59.147497, -22.838067],
	            [-59.149494, -22.878035],
	            [-59.142901, -22.883794],
	            [-59.137518, -22.925649],
	            [-59.15637, -22.986809],
	            [-59.168664, -22.986474],
	            [-59.246939, -23.062425],
	            [-59.262477, -23.074327],
	            [-59.38713, -23.147936],
	            [-59.414323, -23.290684],
	            [-59.417212, -23.336495],
	            [-59.410086, -23.346973],
	            [-59.408154, -23.376875],
	            [-59.395309, -23.384682],
	            [-59.370274, -23.411153],
	            [-59.343109, -23.409688],
	            [-59.331309, -23.398813],
	            [-59.303716, -23.400598],
	            [-59.288182, -23.423372],
	            [-59.255353, -23.453874],
	            [-59.276675, -23.463334],
	            [-59.37634, -23.465264],
	            [-59.391967, -23.46158],
	            [-59.46183, -23.456174],
	            [-59.461848, -23.633046],
	            [-59.43357, -23.66498],
	            [-59.446487, -23.68326],
	            [-59.529735, -23.720006],
	            [-59.522547, -23.777909],
	            [-59.546173, -23.784869],
	            [-59.659176, -23.782186],
	            [-59.674821, -23.769255],
	            [-59.717809, -23.804814],
	            [-59.91924, -23.776126],
	            [-59.945556, -23.823629],
	            [-60.293887, -23.811698],
	            [-60.372474, -23.78616],
	            [-60.407038, -23.716952],
	            [-60.373436, -23.609856],
	            [-60.371358, -23.55208],
	            [-60.202723, -23.532855],
	            [-60.186348, -23.524553],
	            [-60.136866, -23.512571],
	            [-60.092734, -23.492821],
	            [-60.076769, -23.458487],
	            [-60.059304, -23.38407],
	            [-60.02788, -23.304451],
	            [-59.978988, -23.172979],
	            [-59.992281, -23.157465],
	            [-59.958426, -23.067302],
	            [-59.969417, -22.970089],
	            [-59.976196, -22.830056],
	            [-59.966371, -22.802297],
	            [-59.944878, -22.796893],
	            [-59.948822, -22.782389],
	            [-59.928165, -22.756081],
	            [-59.86902, -22.672305],
	            [-59.843758, -22.634372],
	            [-59.787933, -22.566777],
	            [-59.75177, -22.525404],
	            [-59.747184, -22.500433],
	            [-59.747181, -22.466983],
	            [-59.712167, -22.467009],
	            [-59.7118, -22.427977],
	            [-59.626237, -22.427976],
	            [-59.639763, -22.388631],
	            [-59.639343, -22.368923],
	            [-59.614392, -22.335895],
	            [-59.336595, -22.170403],
	            [-59.367744, -22.076224],
	            [-59.241225, -22.132108]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "TTE. 1° MANUEL IRALA FERNÁNDEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-59.143186, -23.729509],
	            [-59.121546, -23.781618],
	            [-59.122465, -23.803544],
	            [-59.100736, -23.905783],
	            [-59.083824, -23.935649],
	            [-59.08203, -23.956236],
	            [-59.080279, -24.062755],
	            [-59.152958, -24.062435],
	            [-59.159622, -24.110419],
	            [-59.18422, -24.119458],
	            [-59.191963, -24.134685],
	            [-59.18771, -24.177745],
	            [-59.256482, -24.180615],
	            [-59.261327, -24.178422],
	            [-59.342942, -24.176382],
	            [-59.342857, -24.221629],
	            [-59.335207, -24.232509],
	            [-59.30311, -24.254583],
	            [-59.298615, -24.273913],
	            [-59.303505, -24.284944],
	            [-59.26328, -24.302254],
	            [-59.245261, -24.315618],
	            [-59.213934, -24.366023],
	            [-59.260261, -24.427177],
	            [-59.283596, -24.480508],
	            [-59.315627, -24.49785],
	            [-59.351874, -24.481517],
	            [-59.358692, -24.454034],
	            [-59.365577, -24.4502],
	            [-59.373098, -24.422989],
	            [-59.400471, -24.411221],
	            [-59.420852, -24.409224],
	            [-59.427473, -24.394303],
	            [-59.440643, -24.390448],
	            [-59.457218, -24.372223],
	            [-59.459489, -24.35579],
	            [-59.471059, -24.335975],
	            [-59.531928, -24.299828],
	            [-59.773602, -24.158861],
	            [-59.885317, -24.098383],
	            [-59.998422, -24.031622],
	            [-60.037035, -24.015126],
	            [-60.067498, -24.009021],
	            [-60.096, -24.026425],
	            [-60.152964, -24.039343],
	            [-60.18965, -24.043313],
	            [-60.237361, -24.044188],
	            [-60.261442, -24.049313],
	            [-60.305856, -24.044558],
	            [-60.333538, -24.030493],
	            [-60.368769, -24.033639],
	            [-60.38447, -24.008113],
	            [-60.417036, -23.993728],
	            [-60.435728, -23.978842],
	            [-60.487907, -23.964752],
	            [-60.496139, -23.972915],
	            [-60.552522, -23.964609],
	            [-60.557811, -23.954473],
	            [-60.588338, -23.954591],
	            [-60.593329, -23.924818],
	            [-60.605273, -23.914595],
	            [-60.629738, -23.923377],
	            [-60.641693, -23.908162],
	            [-60.677451, -23.895692],
	            [-60.68874, -23.903315],
	            [-60.721356, -23.883682],
	            [-60.759891, -23.873604],
	            [-60.781131, -23.830757],
	            [-60.780909, -23.794414],
	            [-60.768308, -23.777527],
	            [-60.692926, -23.733395],
	            [-60.671569, -23.697829],
	            [-60.675205, -23.59219],
	            [-60.601665, -23.611015],
	            [-60.578945, -23.58208],
	            [-60.565409, -23.573936],
	            [-60.371358, -23.55208],
	            [-60.373436, -23.609856],
	            [-60.407038, -23.716952],
	            [-60.372474, -23.78616],
	            [-60.293887, -23.811698],
	            [-59.945556, -23.823629],
	            [-59.91924, -23.776126],
	            [-59.717809, -23.804814],
	            [-59.674821, -23.769255],
	            [-59.659176, -23.782186],
	            [-59.546173, -23.784869],
	            [-59.522547, -23.777909],
	            [-59.529735, -23.720006],
	            [-59.446487, -23.68326],
	            [-59.43357, -23.66498],
	            [-59.461848, -23.633046],
	            [-59.46183, -23.456174],
	            [-59.391967, -23.46158],
	            [-59.37634, -23.465264],
	            [-59.276675, -23.463334],
	            [-59.255353, -23.453874],
	            [-59.175383, -23.443132],
	            [-59.190558, -23.48591],
	            [-59.169859, -23.49972],
	            [-59.142093, -23.510835],
	            [-59.121469, -23.505123],
	            [-59.080985, -23.558866],
	            [-59.077755, -23.570071],
	            [-59.200613, -23.59419],
	            [-59.143186, -23.729509]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "TENIENTE ESTEBAN MARTÍNEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.712062, -23.808446],
	            [-58.717981, -24.114743],
	            [-58.531788, -24.272547],
	            [-58.511136, -24.450709],
	            [-58.487746, -24.651636],
	            [-58.479784, -24.689553],
	            [-58.475293, -24.775615],
	            [-58.477474, -24.827326],
	            [-58.502007, -24.850966],
	            [-58.520918, -24.849059],
	            [-58.568479, -24.822538],
	            [-58.58368, -24.821659],
	            [-58.610848, -24.831152],
	            [-58.64866, -24.824476],
	            [-58.673542, -24.831446],
	            [-58.689049, -24.810074],
	            [-58.700216, -24.814533],
	            [-58.726546, -24.774428],
	            [-58.73992, -24.780788],
	            [-58.76421, -24.774757],
	            [-58.808127, -24.772038],
	            [-58.83693, -24.744917],
	            [-58.855436, -24.732417],
	            [-58.886702, -24.718882],
	            [-58.903164, -24.704942],
	            [-58.941531, -24.681718],
	            [-58.966764, -24.672288],
	            [-58.972684, -24.662317],
	            [-58.995541, -24.664034],
	            [-59.023708, -24.660163],
	            [-59.057537, -24.630986],
	            [-59.100344, -24.616888],
	            [-59.110987, -24.623783],
	            [-59.130718, -24.616002],
	            [-59.135847, -24.605964],
	            [-59.154063, -24.598689],
	            [-59.157208, -24.58751],
	            [-59.173587, -24.581018],
	            [-59.186072, -24.56337],
	            [-59.241087, -24.54629],
	            [-59.257605, -24.51957],
	            [-59.296782, -24.513223],
	            [-59.315627, -24.49785],
	            [-59.283596, -24.480508],
	            [-59.260261, -24.427177],
	            [-59.213934, -24.366023],
	            [-59.245261, -24.315618],
	            [-59.26328, -24.302254],
	            [-59.303505, -24.284944],
	            [-59.298615, -24.273913],
	            [-59.30311, -24.254583],
	            [-59.335207, -24.232509],
	            [-59.342857, -24.221629],
	            [-59.342942, -24.176382],
	            [-59.261327, -24.178422],
	            [-59.256482, -24.180615],
	            [-59.18771, -24.177745],
	            [-59.191963, -24.134685],
	            [-59.18422, -24.119458],
	            [-59.159622, -24.110419],
	            [-59.152958, -24.062435],
	            [-59.080279, -24.062755],
	            [-59.08203, -23.956236],
	            [-59.083824, -23.935649],
	            [-59.100736, -23.905783],
	            [-59.122465, -23.803544],
	            [-59.121546, -23.781618],
	            [-59.143186, -23.729509],
	            [-59.131977, -23.731879],
	            [-59.092331, -23.701562],
	            [-59.023775, -23.720743],
	            [-59.010762, -23.728586],
	            [-58.974011, -23.731998],
	            [-58.969889, -23.743017],
	            [-58.900644, -23.752149],
	            [-58.876161, -23.761945],
	            [-58.836085, -23.76249],
	            [-58.83283, -23.770495],
	            [-58.766423, -23.785912],
	            [-58.745968, -23.797219],
	            [-58.728679, -23.795782],
	            [-58.712062, -23.808446]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PRESIDENTE HAYES",
	        "dist_desc_": "GENERAL JOSÉ MARÍA BRUGUEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-60.535834, -20.456691],
	            [-60.537717, -20.677446],
	            [-60.54178, -20.819171],
	            [-60.541836, -20.891984],
	            [-60.544415, -20.963788],
	            [-60.545691, -21.049968],
	            [-60.548584, -21.14489],
	            [-60.556401, -21.348593],
	            [-60.566876, -21.553906],
	            [-60.569343, -21.618064],
	            [-60.580217, -21.828382],
	            [-60.49315, -21.83566],
	            [-60.503483, -22.009059],
	            [-60.409478, -22.007795],
	            [-60.411432, -22.114677],
	            [-60.411613, -22.214723],
	            [-60.414827, -22.221657],
	            [-60.235643, -22.357273],
	            [-60.092925, -22.464336],
	            [-60.055265, -22.467076],
	            [-59.953142, -22.518525],
	            [-59.957886, -22.58949],
	            [-59.923047, -22.589398],
	            [-59.93292, -22.611542],
	            [-59.933295, -22.634872],
	            [-59.915582, -22.635369],
	            [-59.91616, -22.673429],
	            [-59.86902, -22.672305],
	            [-59.928165, -22.756081],
	            [-59.948822, -22.782389],
	            [-59.944878, -22.796893],
	            [-59.966371, -22.802297],
	            [-59.976196, -22.830056],
	            [-59.969417, -22.970089],
	            [-59.958426, -23.067302],
	            [-59.992281, -23.157465],
	            [-59.978988, -23.172979],
	            [-60.02788, -23.304451],
	            [-60.059304, -23.38407],
	            [-60.076769, -23.458487],
	            [-60.092734, -23.492821],
	            [-60.136866, -23.512571],
	            [-60.186348, -23.524553],
	            [-60.202723, -23.532855],
	            [-60.371358, -23.55208],
	            [-60.565409, -23.573936],
	            [-60.578945, -23.58208],
	            [-60.601665, -23.611015],
	            [-60.675205, -23.59219],
	            [-60.671569, -23.697829],
	            [-60.692926, -23.733395],
	            [-60.768308, -23.777527],
	            [-60.780909, -23.794414],
	            [-60.781131, -23.830757],
	            [-60.759891, -23.873604],
	            [-60.775114, -23.879427],
	            [-60.799866, -23.864548],
	            [-60.811228, -23.873276],
	            [-60.848386, -23.870578],
	            [-60.856027, -23.858034],
	            [-60.883634, -23.841079],
	            [-60.896561, -23.84071],
	            [-60.911226, -23.821247],
	            [-60.932827, -23.809883],
	            [-60.959407, -23.819746],
	            [-60.993094, -23.807381],
	            [-60.999945, -23.792744],
	            [-61.019894, -23.769719],
	            [-61.013902, -23.760643],
	            [-61.040386, -23.74058],
	            [-61.039806, -23.730185],
	            [-61.05922, -23.704146],
	            [-61.08252, -23.689578],
	            [-61.100602, -23.657282],
	            [-61.091101, -23.646299],
	            [-61.098829, -23.620664],
	            [-61.091776, -23.611313],
	            [-61.136462, -23.576803],
	            [-61.162371, -23.56758],
	            [-61.161187, -23.558962],
	            [-61.186173, -23.544438],
	            [-61.208164, -23.552946],
	            [-61.225139, -23.552653],
	            [-61.234478, -23.542338],
	            [-61.279344, -23.513448],
	            [-61.280473, -23.490127],
	            [-61.3057, -23.48747],
	            [-61.315073, -23.472648],
	            [-61.345384, -23.46831],
	            [-61.350963, -23.450968],
	            [-61.391442, -23.457443],
	            [-61.403812, -23.44569],
	            [-61.420871, -23.445975],
	            [-61.445582, -23.421124],
	            [-61.474744, -23.426602],
	            [-61.493466, -23.421497],
	            [-61.501131, -23.400386],
	            [-61.525091, -23.370273],
	            [-61.509982, -23.34789],
	            [-61.544321, -23.348192],
	            [-61.555968, -23.342091],
	            [-61.564364, -23.310829],
	            [-61.58351, -23.305923],
	            [-61.609682, -23.286921],
	            [-61.630652, -23.277498],
	            [-61.671055, -23.285139],
	            [-61.689774, -23.262017],
	            [-61.715793, -23.239605],
	            [-61.734829, -23.240436],
	            [-61.741525, -23.215036],
	            [-61.739493, -23.202973],
	            [-61.753211, -23.173329],
	            [-61.780101, -23.164378],
	            [-61.783452, -23.151941],
	            [-61.803842, -23.143742],
	            [-61.8166, -23.12538],
	            [-61.838389, -23.109344],
	            [-61.852891, -23.091634],
	            [-61.885846, -23.075743],
	            [-61.926715, -23.067755],
	            [-61.934066, -23.051857],
	            [-61.952726, -23.034455],
	            [-61.986647, -23.016117],
	            [-61.993336, -22.998998],
	            [-62.005889, -22.994781],
	            [-61.998164, -22.977895],
	            [-62.008772, -22.963065],
	            [-62.00128, -22.927834],
	            [-62.024901, -22.929825],
	            [-62.037521, -22.913779],
	            [-62.034412, -22.890082],
	            [-62.045861, -22.866149],
	            [-62.058156, -22.862086],
	            [-62.07754, -22.843721],
	            [-62.082763, -22.813544],
	            [-62.106702, -22.821303],
	            [-62.111355, -22.797361],
	            [-62.135419, -22.791276],
	            [-62.140887, -22.774354],
	            [-62.155198, -22.761461],
	            [-62.148782, -22.745242],
	            [-62.177024, -22.720118],
	            [-62.19134, -22.718741],
	            [-62.200251, -22.706812],
	            [-62.198072, -22.668504],
	            [-62.214032, -22.661833],
	            [-62.213847, -22.649763],
	            [-62.228222, -22.638471],
	            [-62.234443, -22.612879],
	            [-62.249596, -22.604845],
	            [-62.240489, -22.591844],
	            [-62.239978, -22.573466],
	            [-62.223574, -22.549243],
	            [-62.247315, -22.537951],
	            [-62.265901, -22.514095],
	            [-62.273807, -22.522851],
	            [-62.294505, -22.520357],
	            [-62.286889, -22.477569],
	            [-62.310406, -22.488043],
	            [-62.341313, -22.478616],
	            [-62.346247, -22.457203],
	            [-62.381479, -22.460251],
	            [-62.407495, -22.447781],
	            [-62.417756, -22.424544],
	            [-62.460234, -22.413497],
	            [-62.472781, -22.377612],
	            [-62.486408, -22.373393],
	            [-62.511556, -22.380104],
	            [-62.528438, -22.369005],
	            [-62.541317, -22.372856],
	            [-62.562356, -22.324405],
	            [-62.583565, -22.320496],
	            [-62.612456, -22.302563],
	            [-62.619604, -22.292288],
	            [-62.640238, -22.299752],
	            [-62.629382, -22.266187],
	            [-62.644617, -22.251467],
	            [-62.632525, -22.213475],
	            [-62.260919, -21.058628],
	            [-62.266342, -20.563156],
	            [-61.922536, -20.089211],
	            [-61.768661, -20.109639],
	            [-61.737006, -20.098228],
	            [-61.71859, -20.096644],
	            [-61.698262, -20.104244],
	            [-61.660203, -20.135611],
	            [-61.645544, -20.153219],
	            [-61.620052, -20.170064],
	            [-61.54988, -20.174715],
	            [-61.51439, -20.182631],
	            [-61.490832, -20.192296],
	            [-60.90463, -20.355282],
	            [-60.535834, -20.456691]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "BOQUERÓN",
	        "dist_desc_": "MARISCAL JOSÉ FÉLIX ESTIGARRIBIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.889477, -26.219833],
	            [-56.8813, -26.241163],
	            [-56.861324, -26.252197],
	            [-56.857444, -26.262329],
	            [-56.883574, -26.283242],
	            [-56.889395, -26.297552],
	            [-56.909009, -26.32063],
	            [-56.9265, -26.32283],
	            [-56.927558, -26.348074],
	            [-56.941758, -26.363567],
	            [-56.983908, -26.36476],
	            [-56.995709, -26.386667],
	            [-56.993027, -26.399275],
	            [-57.007329, -26.412427],
	            [-57.014772, -26.41757],
	            [-57.043084, -26.411985],
	            [-57.0582, -26.402009],
	            [-57.071329, -26.379031],
	            [-57.087854, -26.376148],
	            [-57.078647, -26.370958],
	            [-57.09993, -26.341725],
	            [-57.113696, -26.308893],
	            [-57.125248, -26.301777],
	            [-57.09927, -26.261562],
	            [-57.09777, -26.245499],
	            [-57.11114, -26.243481],
	            [-57.121889, -26.219349],
	            [-57.114218, -26.20182],
	            [-57.144634, -26.182424],
	            [-57.146668, -26.168205],
	            [-57.135449, -26.145191],
	            [-57.119791, -26.126999],
	            [-57.1072, -26.122442],
	            [-57.078685, -26.143468],
	            [-57.042394, -26.14439],
	            [-57.029565, -26.134727],
	            [-57.008109, -26.136039],
	            [-56.970178, -26.114505],
	            [-56.944006, -26.125816],
	            [-56.921536, -26.162592],
	            [-56.919318, -26.175626],
	            [-56.903011, -26.194424],
	            [-56.889477, -26.219833]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "QUYQUYHÓ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.196668, -25.854078],
	            [-57.204233, -25.870039],
	            [-57.202088, -25.889312],
	            [-57.189861, -25.898598],
	            [-57.163354, -25.903501],
	            [-57.183876, -25.948022],
	            [-57.201297, -25.943027],
	            [-57.229873, -25.918098],
	            [-57.256051, -25.911124],
	            [-57.285074, -25.909377],
	            [-57.297104, -25.918514],
	            [-57.322523, -25.918861],
	            [-57.350218, -25.910268],
	            [-57.411902, -25.934175],
	            [-57.446799, -25.932162],
	            [-57.417286, -25.891638],
	            [-57.415749, -25.879598],
	            [-57.400869, -25.857792],
	            [-57.374926, -25.847324],
	            [-57.356545, -25.828293],
	            [-57.335029, -25.825481],
	            [-57.325859, -25.812187],
	            [-57.292557, -25.8155],
	            [-57.268552, -25.807045],
	            [-57.229301, -25.811994],
	            [-57.210641, -25.83128],
	            [-57.205605, -25.851183],
	            [-57.196668, -25.854078]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "ROQUE GONZALEZ DE SANTA CRUZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.914166, -25.590966],
	            [-56.945308, -25.651621],
	            [-56.892445, -25.668163],
	            [-56.894242, -25.68658],
	            [-56.911644, -25.702837],
	            [-56.93234, -25.743502],
	            [-56.960198, -25.758619],
	            [-56.948216, -25.781972],
	            [-56.96717, -25.801207],
	            [-56.966778, -25.824022],
	            [-56.997716, -25.846587],
	            [-57.016504, -25.85241],
	            [-57.034709, -25.849697],
	            [-57.051392, -25.837033],
	            [-57.069424, -25.834791],
	            [-57.076929, -25.818406],
	            [-57.059484, -25.810382],
	            [-57.040514, -25.788568],
	            [-57.0216, -25.786084],
	            [-57.01619, -25.776377],
	            [-57.003931, -25.785196],
	            [-56.976067, -25.776586],
	            [-56.980505, -25.745159],
	            [-56.966026, -25.730456],
	            [-56.981869, -25.69432],
	            [-57.007451, -25.669248],
	            [-56.997303, -25.606736],
	            [-56.988011, -25.596563],
	            [-56.990237, -25.574532],
	            [-56.968339, -25.572428],
	            [-56.945204, -25.593401],
	            [-56.914166, -25.590966]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "SAPUCÁI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.666513, -25.849005],
	            [-56.627668, -25.886487],
	            [-56.626772, -25.900973],
	            [-56.609886, -25.916533],
	            [-56.607719, -25.940555],
	            [-56.607639, -25.978275],
	            [-56.641556, -25.968454],
	            [-56.666061, -25.970483],
	            [-56.676833, -25.96265],
	            [-56.697863, -25.964883],
	            [-56.747588, -25.951921],
	            [-56.747988, -25.941148],
	            [-56.73626, -25.936525],
	            [-56.733152, -25.914199],
	            [-56.741936, -25.897987],
	            [-56.732359, -25.876514],
	            [-56.716579, -25.860479],
	            [-56.700035, -25.863773],
	            [-56.666513, -25.849005]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "TEBICUARY-MÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.218054, -25.551105],
	            [-57.207339, -25.572725],
	            [-57.183951, -25.591445],
	            [-57.18091, -25.605066],
	            [-57.184478, -25.635322],
	            [-57.19611, -25.660366],
	            [-57.231571, -25.65686],
	            [-57.270265, -25.677206],
	            [-57.279977, -25.66735],
	            [-57.342892, -25.668696],
	            [-57.363956, -25.660089],
	            [-57.388147, -25.639093],
	            [-57.368674, -25.622828],
	            [-57.346437, -25.613039],
	            [-57.343971, -25.589115],
	            [-57.33078, -25.578783],
	            [-57.317095, -25.497762],
	            [-57.253918, -25.50929],
	            [-57.230752, -25.52678],
	            [-57.218054, -25.551105]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "YAGUARÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.896488, -25.914835],
	            [-56.852308, -25.929416],
	            [-56.836422, -25.944931],
	            [-56.802381, -25.948107],
	            [-56.785187, -25.919941],
	            [-56.769908, -25.922992],
	            [-56.747988, -25.941148],
	            [-56.747588, -25.951921],
	            [-56.73702, -25.972646],
	            [-56.748161, -26.028082],
	            [-56.753314, -26.037152],
	            [-56.80236, -26.064624],
	            [-56.805014, -26.082348],
	            [-56.791741, -26.096461],
	            [-56.793483, -26.117859],
	            [-56.830912, -26.121822],
	            [-56.839019, -26.140099],
	            [-56.850764, -26.149299],
	            [-56.848649, -26.164945],
	            [-56.865578, -26.194444],
	            [-56.889477, -26.219833],
	            [-56.903011, -26.194424],
	            [-56.919318, -26.175626],
	            [-56.921536, -26.162592],
	            [-56.944006, -26.125816],
	            [-56.970178, -26.114505],
	            [-57.008109, -26.136039],
	            [-57.029565, -26.134727],
	            [-57.042394, -26.14439],
	            [-57.078685, -26.143468],
	            [-57.1072, -26.122442],
	            [-57.13015, -26.114418],
	            [-57.141422, -26.091318],
	            [-57.134345, -26.079505],
	            [-57.137597, -26.056634],
	            [-57.131693, -26.03062],
	            [-57.115086, -26.020566],
	            [-57.105521, -25.984526],
	            [-57.107902, -25.971864],
	            [-57.091207, -25.956106],
	            [-57.060978, -25.954392],
	            [-57.025321, -25.946578],
	            [-57.016665, -25.932999],
	            [-56.994893, -25.922954],
	            [-56.928457, -25.917207],
	            [-56.916657, -25.906893],
	            [-56.896488, -25.914835]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "YBYCUÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.719684, -25.658716],
	            [-56.715617, -25.669915],
	            [-56.692916, -25.69975],
	            [-56.669835, -25.700155],
	            [-56.689541, -25.762165],
	            [-56.666513, -25.849005],
	            [-56.700035, -25.863773],
	            [-56.716579, -25.860479],
	            [-56.732359, -25.876514],
	            [-56.741936, -25.897987],
	            [-56.733152, -25.914199],
	            [-56.78765, -25.898812],
	            [-56.776441, -25.869925],
	            [-56.778077, -25.859827],
	            [-56.807362, -25.863779],
	            [-56.814975, -25.856199],
	            [-56.84508, -25.864673],
	            [-56.864713, -25.858593],
	            [-56.893082, -25.889973],
	            [-56.901329, -25.904169],
	            [-56.896488, -25.914835],
	            [-56.916657, -25.906893],
	            [-56.915865, -25.880949],
	            [-56.886939, -25.888759],
	            [-56.874464, -25.851725],
	            [-56.867457, -25.843885],
	            [-56.872746, -25.805495],
	            [-56.856758, -25.803985],
	            [-56.843558, -25.777802],
	            [-56.846262, -25.751134],
	            [-56.837513, -25.718296],
	            [-56.825166, -25.695796],
	            [-56.806296, -25.676791],
	            [-56.758342, -25.64924],
	            [-56.726762, -25.663172],
	            [-56.719684, -25.658716]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "YBYTYMÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.5979, -25.504587],
	            [-54.600317, -25.524524],
	            [-54.594021, -25.555206],
	            [-54.623034, -25.54071],
	            [-54.70346, -25.540769],
	            [-54.71189, -25.576089],
	            [-54.736248, -25.58319],
	            [-54.724217, -25.433579],
	            [-54.720106, -25.419591],
	            [-54.700033, -25.403258],
	            [-54.691741, -25.417659],
	            [-54.711711, -25.427029],
	            [-54.712585, -25.44036],
	            [-54.685617, -25.43207],
	            [-54.670611, -25.442644],
	            [-54.680605, -25.458777],
	            [-54.667899, -25.469484],
	            [-54.651592, -25.443283],
	            [-54.640916, -25.458348],
	            [-54.638788, -25.477981],
	            [-54.6302, -25.491752],
	            [-54.5979, -25.504587]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "CIUDAD DEL ESTE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.594021, -25.555206],
	            [-54.596702, -25.624994],
	            [-54.583424, -25.651029],
	            [-54.586032, -25.66706],
	            [-54.609589, -25.667448],
	            [-54.645153, -25.661235],
	            [-54.71189, -25.576089],
	            [-54.70346, -25.540769],
	            [-54.623034, -25.54071],
	            [-54.594021, -25.555206]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "PRESIDENTE FRANCO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.625082, -25.777775],
	            [-54.59533, -25.813318],
	            [-54.587293, -25.829439],
	            [-54.596325, -25.860942],
	            [-54.611925, -25.886723],
	            [-54.622518, -25.915543],
	            [-54.620804, -25.937811],
	            [-54.606567, -25.963826],
	            [-54.612571, -25.980387],
	            [-54.624111, -25.985364],
	            [-54.65871, -25.979525],
	            [-54.813148, -25.838412],
	            [-54.799343, -25.768136],
	            [-54.771582, -25.771839],
	            [-54.734802, -25.787517],
	            [-54.706368, -25.771452],
	            [-54.669852, -25.777542],
	            [-54.654606, -25.77004],
	            [-54.640799, -25.786943],
	            [-54.625082, -25.777775]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "DOMINGO MARTÍNEZ DE IRALA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.081703, -25.559745],
	            [-55.105411, -25.55632],
	            [-55.131268, -25.563155],
	            [-55.144117, -25.54944],
	            [-55.160507, -25.516799],
	            [-55.169214, -25.523047],
	            [-55.194807, -25.519495],
	            [-55.217517, -25.526523],
	            [-55.239583, -25.52791],
	            [-55.249829, -25.553888],
	            [-55.27252, -25.567335],
	            [-55.303745, -25.565068],
	            [-55.327309, -25.582695],
	            [-55.347002, -25.588659],
	            [-55.322328, -25.456391],
	            [-55.30889, -25.389438],
	            [-55.30686, -25.349476],
	            [-55.296601, -25.349466],
	            [-55.211044, -25.442786],
	            [-55.081703, -25.559745]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "DOCTOR JUAN LEÓN MALLORQUÍN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.967812, -25.137971],
	            [-54.941803, -25.181181],
	            [-54.903077, -25.163798],
	            [-54.87892, -25.138193],
	            [-54.873019, -25.164921],
	            [-54.864138, -25.173328],
	            [-54.875338, -25.213488],
	            [-54.870607, -25.224328],
	            [-54.874878, -25.253366],
	            [-54.826079, -25.280304],
	            [-54.73627, -25.278578],
	            [-54.72347, -25.282497],
	            [-54.701419, -25.246062],
	            [-54.691652, -25.258837],
	            [-54.676921, -25.26132],
	            [-54.652225, -25.250828],
	            [-54.636569, -25.257677],
	            [-54.629605, -25.280366],
	            [-54.615101, -25.286246],
	            [-54.578968, -25.291757],
	            [-54.554826, -25.289567],
	            [-54.54302, -25.304739],
	            [-54.541729, -25.328812],
	            [-54.531345, -25.342776],
	            [-54.584475, -25.397266],
	            [-54.606453, -25.444631],
	            [-54.619867, -25.456393],
	            [-54.615531, -25.472207],
	            [-54.596891, -25.491493],
	            [-54.5979, -25.504587],
	            [-54.6302, -25.491752],
	            [-54.638788, -25.477981],
	            [-54.640916, -25.458348],
	            [-54.651592, -25.443283],
	            [-54.667899, -25.469484],
	            [-54.680605, -25.458777],
	            [-54.670611, -25.442644],
	            [-54.685617, -25.43207],
	            [-54.712585, -25.44036],
	            [-54.711711, -25.427029],
	            [-54.691741, -25.417659],
	            [-54.700033, -25.403258],
	            [-54.720106, -25.419591],
	            [-54.752274, -25.405239],
	            [-54.76184, -25.419087],
	            [-54.788537, -25.420943],
	            [-54.806241, -25.411378],
	            [-54.810928, -25.400512],
	            [-54.839077, -25.39396],
	            [-54.844502, -25.368119],
	            [-54.86349, -25.364835],
	            [-54.91178, -25.368898],
	            [-54.896184, -25.360124],
	            [-54.907177, -25.349845],
	            [-54.935052, -25.354564],
	            [-54.950017, -25.345809],
	            [-54.938235, -25.334262],
	            [-54.956127, -25.319684],
	            [-54.974729, -25.283314],
	            [-54.980917, -25.26329],
	            [-55.017009, -25.244222],
	            [-55.026888, -25.222413],
	            [-55.01641, -25.196013],
	            [-55.026819, -25.18122],
	            [-54.981519, -25.140654],
	            [-54.967812, -25.137971]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "HERNANDARIAS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.016638, -24.549184],
	            [-54.989176, -24.550463],
	            [-54.97138, -24.567716],
	            [-54.955096, -24.567317],
	            [-54.966245, -24.602499],
	            [-54.977275, -24.607265],
	            [-54.987968, -24.625365],
	            [-54.990265, -24.647848],
	            [-55.029041, -24.848298],
	            [-55.047329, -24.940143],
	            [-55.055298, -24.943746],
	            [-55.059104, -24.977821],
	            [-55.068402, -24.990355],
	            [-55.055251, -25.010239],
	            [-55.024143, -25.012786],
	            [-55.00162, -25.022794],
	            [-54.975655, -25.051019],
	            [-54.979715, -25.065545],
	            [-54.949596, -25.059183],
	            [-54.967812, -25.137971],
	            [-54.981519, -25.140654],
	            [-55.026819, -25.18122],
	            [-55.056213, -25.160806],
	            [-55.106961, -25.131952],
	            [-55.147529, -25.097319],
	            [-55.159835, -25.096041],
	            [-55.176294, -25.058814],
	            [-55.193267, -25.04297],
	            [-55.210648, -25.049148],
	            [-55.232697, -25.042762],
	            [-55.229126, -25.029408],
	            [-55.275727, -25.038248],
	            [-55.277307, -25.023885],
	            [-55.294287, -25.023168],
	            [-55.312739, -25.001805],
	            [-55.308838, -24.982178],
	            [-55.3311, -24.970963],
	            [-55.33469, -24.949664],
	            [-55.331563, -24.924489],
	            [-55.344111, -24.914792],
	            [-55.326876, -24.900817],
	            [-55.329277, -24.877442],
	            [-55.340843, -24.868244],
	            [-55.348866, -24.842709],
	            [-55.336609, -24.831797],
	            [-55.335092, -24.80473],
	            [-55.321423, -24.767983],
	            [-55.322848, -24.751616],
	            [-55.303417, -24.725729],
	            [-55.303439, -24.704624],
	            [-55.314855, -24.697177],
	            [-55.315383, -24.677053],
	            [-55.292578, -24.646202],
	            [-55.301445, -24.633549],
	            [-55.292657, -24.612836],
	            [-55.30545, -24.592002],
	            [-55.30208, -24.567184],
	            [-55.269593, -24.523168],
	            [-55.24723, -24.514509],
	            [-55.237797, -24.519098],
	            [-55.21456, -24.515227],
	            [-55.160848, -24.518731],
	            [-55.138767, -24.496782],
	            [-55.154635, -24.479057],
	            [-55.134036, -24.479881],
	            [-55.113647, -24.505702],
	            [-55.112865, -24.536628],
	            [-55.102954, -24.543704],
	            [-55.054886, -24.551203],
	            [-55.031299, -24.54437],
	            [-55.016638, -24.549184]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "ITAKYRY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.30686, -25.349476],
	            [-55.30889, -25.389438],
	            [-55.322328, -25.456391],
	            [-55.347002, -25.588659],
	            [-55.373239, -25.619977],
	            [-55.390133, -25.629409],
	            [-55.400011, -25.622747],
	            [-55.39926, -25.604094],
	            [-55.408404, -25.598393],
	            [-55.426062, -25.557542],
	            [-55.378436, -25.361914],
	            [-55.355386, -25.357609],
	            [-55.32846, -25.33526],
	            [-55.30686, -25.349476]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "JUAN E. O'LEARY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.65871, -25.979525],
	            [-54.67612, -25.988624],
	            [-54.677528, -26.015109],
	            [-54.650192, -26.065334],
	            [-54.643179, -26.092294],
	            [-54.650714, -26.118779],
	            [-54.674339, -26.144902],
	            [-54.671004, -26.161157],
	            [-54.658353, -26.177156],
	            [-54.633339, -26.19162],
	            [-54.617422, -26.211252],
	            [-54.623316, -26.223348],
	            [-54.672423, -26.254019],
	            [-54.678613, -26.239576],
	            [-54.693862, -26.228169],
	            [-54.721954, -26.249752],
	            [-54.778498, -26.236395],
	            [-54.785802, -26.217834],
	            [-54.799772, -26.201016],
	            [-54.82739, -26.201213],
	            [-54.839885, -26.185601],
	            [-54.855418, -26.188875],
	            [-54.87467, -26.174255],
	            [-54.888942, -26.135902],
	            [-54.981832, -26.107086],
	            [-54.976183, -26.092686],
	            [-54.959013, -26.079171],
	            [-54.961826, -26.068659],
	            [-54.935248, -26.055239],
	            [-54.934531, -26.04335],
	            [-54.921135, -26.031693],
	            [-54.936559, -25.980394],
	            [-54.896697, -25.982322],
	            [-54.876814, -25.989956],
	            [-54.873086, -26.003389],
	            [-54.859746, -26.009305],
	            [-54.840586, -25.978066],
	            [-54.837824, -25.871702],
	            [-54.813148, -25.838412],
	            [-54.65871, -25.979525]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "ÑACUNDAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.219968, -25.265591],
	            [-55.191369, -25.29759],
	            [-55.159652, -25.320395],
	            [-55.123678, -25.327808],
	            [-55.099059, -25.325457],
	            [-55.058655, -25.31361],
	            [-55.042375, -25.319506],
	            [-55.031534, -25.358517],
	            [-55.021251, -25.378072],
	            [-55.000168, -25.387518],
	            [-54.965461, -25.375289],
	            [-54.960914, -25.361279],
	            [-54.943998, -25.366907],
	            [-54.935052, -25.354564],
	            [-54.907177, -25.349845],
	            [-54.896184, -25.360124],
	            [-54.91178, -25.368898],
	            [-54.950767, -25.572144],
	            [-54.972657, -25.583139],
	            [-55.024459, -25.585594],
	            [-55.034315, -25.5763],
	            [-55.081703, -25.559745],
	            [-55.211044, -25.442786],
	            [-55.296601, -25.349466],
	            [-55.30686, -25.349476],
	            [-55.32846, -25.33526],
	            [-55.307153, -25.277279],
	            [-55.289862, -25.251734],
	            [-55.248298, -25.252297],
	            [-55.219968, -25.265591]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "YGUAZÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.736248, -25.58319],
	            [-54.71189, -25.576089],
	            [-54.645153, -25.661235],
	            [-54.657981, -25.679384],
	            [-54.641591, -25.717663],
	            [-54.633161, -25.757166],
	            [-54.625082, -25.777775],
	            [-54.640799, -25.786943],
	            [-54.654606, -25.77004],
	            [-54.669852, -25.777542],
	            [-54.706368, -25.771452],
	            [-54.734802, -25.787517],
	            [-54.771582, -25.771839],
	            [-54.799343, -25.768136],
	            [-54.822244, -25.756955],
	            [-54.835591, -25.756824],
	            [-54.85271, -25.739874],
	            [-54.857139, -25.694569],
	            [-54.866084, -25.690846],
	            [-54.859066, -25.644128],
	            [-54.843959, -25.628526],
	            [-54.85489, -25.597887],
	            [-54.817874, -25.579245],
	            [-54.805831, -25.605645],
	            [-54.7552, -25.586393],
	            [-54.736248, -25.58319]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "LOS CEDRALES"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.720106, -25.419591],
	            [-54.724217, -25.433579],
	            [-54.736248, -25.58319],
	            [-54.7552, -25.586393],
	            [-54.805831, -25.605645],
	            [-54.817874, -25.579245],
	            [-54.85489, -25.597887],
	            [-54.843959, -25.628526],
	            [-54.859066, -25.644128],
	            [-54.879692, -25.639091],
	            [-54.88451, -25.652287],
	            [-54.886295, -25.622412],
	            [-54.903599, -25.604198],
	            [-54.921386, -25.617058],
	            [-54.93363, -25.617853],
	            [-54.95421, -25.602723],
	            [-54.945396, -25.577774],
	            [-54.950767, -25.572144],
	            [-54.91178, -25.368898],
	            [-54.86349, -25.364835],
	            [-54.844502, -25.368119],
	            [-54.839077, -25.39396],
	            [-54.810928, -25.400512],
	            [-54.806241, -25.411378],
	            [-54.788537, -25.420943],
	            [-54.76184, -25.419087],
	            [-54.752274, -25.405239],
	            [-54.720106, -25.419591]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "MINGA GUAZÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.217517, -25.526523],
	            [-55.218311, -25.592765],
	            [-55.226693, -25.596013],
	            [-55.231887, -25.629862],
	            [-55.237377, -25.636356],
	            [-55.244114, -25.672137],
	            [-55.269271, -25.696659],
	            [-55.269051, -25.710961],
	            [-55.27833, -25.736691],
	            [-55.276007, -25.748801],
	            [-55.286637, -25.780893],
	            [-55.295849, -25.818719],
	            [-55.320012, -25.84644],
	            [-55.321632, -25.866842],
	            [-55.290541, -25.874623],
	            [-55.273879, -25.897707],
	            [-55.288594, -25.912741],
	            [-55.301286, -25.911839],
	            [-55.341922, -25.919644],
	            [-55.39014, -25.903979],
	            [-55.405402, -25.921815],
	            [-55.409833, -25.942898],
	            [-55.392241, -25.952747],
	            [-55.389527, -25.966299],
	            [-55.365049, -25.975237],
	            [-55.357259, -25.993078],
	            [-55.378425, -26.000864],
	            [-55.376636, -26.017328],
	            [-55.391728, -26.035087],
	            [-55.40175, -26.026031],
	            [-55.411279, -25.998593],
	            [-55.432133, -26.006918],
	            [-55.501749, -25.986196],
	            [-55.55064, -25.996946],
	            [-55.528221, -25.942823],
	            [-55.515895, -25.90193],
	            [-55.526787, -25.888793],
	            [-55.512066, -25.870352],
	            [-55.528283, -25.850023],
	            [-55.521961, -25.80619],
	            [-55.511496, -25.782718],
	            [-55.497341, -25.775743],
	            [-55.480194, -25.733308],
	            [-55.466178, -25.709268],
	            [-55.477607, -25.68364],
	            [-55.46278, -25.677548],
	            [-55.452592, -25.654134],
	            [-55.427199, -25.659704],
	            [-55.419411, -25.637492],
	            [-55.400011, -25.622747],
	            [-55.390133, -25.629409],
	            [-55.373239, -25.619977],
	            [-55.347002, -25.588659],
	            [-55.327309, -25.582695],
	            [-55.303745, -25.565068],
	            [-55.27252, -25.567335],
	            [-55.249829, -25.553888],
	            [-55.239583, -25.52791],
	            [-55.217517, -25.526523]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "SAN CRISTÓBAL"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.998024, -25.716584],
	            [-54.996087, -25.729759],
	            [-55.011934, -25.762669],
	            [-55.005226, -25.775555],
	            [-55.010784, -25.818891],
	            [-55.025654, -25.8348],
	            [-55.028702, -25.863128],
	            [-55.062836, -25.904853],
	            [-55.072688, -25.916489],
	            [-55.097724, -25.907789],
	            [-55.158098, -25.892925],
	            [-55.168016, -25.871782],
	            [-55.193474, -25.868536],
	            [-55.220821, -25.840302],
	            [-55.246979, -25.829327],
	            [-55.258488, -25.833365],
	            [-55.277752, -25.815039],
	            [-55.273856, -25.798084],
	            [-55.286637, -25.780893],
	            [-55.276007, -25.748801],
	            [-55.27833, -25.736691],
	            [-55.269051, -25.710961],
	            [-55.269271, -25.696659],
	            [-55.244114, -25.672137],
	            [-55.161837, -25.668784],
	            [-55.140533, -25.654018],
	            [-55.073816, -25.674114],
	            [-55.06599, -25.682234],
	            [-55.014538, -25.68569],
	            [-55.022317, -25.703415],
	            [-54.998024, -25.716584]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "SANTA RITA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.550514, -25.63915],
	            [-56.516603, -25.674891],
	            [-56.49732, -25.689576],
	            [-56.478512, -25.722013],
	            [-56.477711, -25.754049],
	            [-56.49962, -25.773382],
	            [-56.52517, -25.774625],
	            [-56.536828, -25.762015],
	            [-56.559047, -25.749938],
	            [-56.571677, -25.735996],
	            [-56.584448, -25.662496],
	            [-56.550514, -25.63915]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "FÉLIX PÉREZ CARDOZO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.125128, -25.864965],
	            [-56.135321, -25.874424],
	            [-56.139649, -25.899168],
	            [-56.117294, -25.920288],
	            [-56.114745, -25.945889],
	            [-56.130843, -25.960546],
	            [-56.137707, -25.97554],
	            [-56.151859, -25.985179],
	            [-56.128906, -26.007595],
	            [-56.120771, -26.027396],
	            [-56.136796, -26.030134],
	            [-56.161596, -26.054514],
	            [-56.180444, -26.063412],
	            [-56.27254, -25.977978],
	            [-56.280961, -25.976187],
	            [-56.274312, -25.94237],
	            [-56.253337, -25.921947],
	            [-56.249205, -25.898742],
	            [-56.276702, -25.885794],
	            [-56.276798, -25.844823],
	            [-56.248204, -25.836149],
	            [-56.22521, -25.841672],
	            [-56.204515, -25.838259],
	            [-56.192228, -25.858661],
	            [-56.125128, -25.864965]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "GRAL. EUGENIO A. GARAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.118748, -25.658276],
	            [-56.100914, -25.683829],
	            [-56.097131, -25.71131],
	            [-56.073867, -25.746356],
	            [-56.063607, -25.753428],
	            [-56.060452, -25.770316],
	            [-56.038711, -25.767988],
	            [-56.029186, -25.79546],
	            [-56.032941, -25.805788],
	            [-56.034183, -25.862157],
	            [-56.088729, -25.866377],
	            [-56.125128, -25.864965],
	            [-56.192228, -25.858661],
	            [-56.204515, -25.838259],
	            [-56.22521, -25.841672],
	            [-56.248204, -25.836149],
	            [-56.276798, -25.844823],
	            [-56.279545, -25.80959],
	            [-56.313834, -25.779691],
	            [-56.285569, -25.765748],
	            [-56.280551, -25.751253],
	            [-56.296827, -25.727891],
	            [-56.29165, -25.707671],
	            [-56.25944, -25.710253],
	            [-56.24931, -25.704249],
	            [-56.244591, -25.65392],
	            [-56.237711, -25.624136],
	            [-56.225132, -25.628485],
	            [-56.213856, -25.648092],
	            [-56.200575, -25.638236],
	            [-56.178953, -25.632337],
	            [-56.158874, -25.640015],
	            [-56.142035, -25.638003],
	            [-56.118748, -25.658276]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "INDEPENDENCIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.536435, -25.895141],
	            [-56.572526, -25.919452],
	            [-56.570295, -25.940105],
	            [-56.578641, -25.950614],
	            [-56.607719, -25.940555],
	            [-56.609886, -25.916533],
	            [-56.626772, -25.900973],
	            [-56.627668, -25.886487],
	            [-56.619856, -25.86526],
	            [-56.633577, -25.822559],
	            [-56.618632, -25.805067],
	            [-56.585894, -25.807954],
	            [-56.577453, -25.799518],
	            [-56.556929, -25.801721],
	            [-56.52517, -25.774625],
	            [-56.49962, -25.773382],
	            [-56.50084, -25.796304],
	            [-56.495395, -25.817183],
	            [-56.513834, -25.84752],
	            [-56.50706, -25.868939],
	            [-56.536435, -25.895141]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "ITAPÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.274312, -25.94237],
	            [-56.280961, -25.976187],
	            [-56.301645, -25.983688],
	            [-56.323347, -26.002197],
	            [-56.335464, -26.002497],
	            [-56.352383, -26.026281],
	            [-56.37144, -26.017638],
	            [-56.392453, -26.016739],
	            [-56.410906, -26.023869],
	            [-56.402443, -26.137133],
	            [-56.410134, -26.139789],
	            [-56.437506, -26.119072],
	            [-56.48085, -26.116594],
	            [-56.532745, -26.121778],
	            [-56.546402, -26.128445],
	            [-56.538739, -26.14871],
	            [-56.561302, -26.188953],
	            [-56.586182, -26.185884],
	            [-56.603696, -26.173139],
	            [-56.615798, -26.176472],
	            [-56.571444, -26.098256],
	            [-56.570012, -26.03846],
	            [-56.543319, -26.034095],
	            [-56.505011, -26.036038],
	            [-56.486314, -26.017519],
	            [-56.451857, -26.026936],
	            [-56.439939, -26.039072],
	            [-56.414507, -26.022596],
	            [-56.38684, -25.999433],
	            [-56.365221, -25.993001],
	            [-56.349519, -25.971671],
	            [-56.317747, -25.962663],
	            [-56.316469, -25.951559],
	            [-56.299365, -25.942633],
	            [-56.274312, -25.94237]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "ITURBE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.009762, -25.877585],
	            [-56.02716, -25.892457],
	            [-56.048453, -25.89086],
	            [-56.099252, -26.019043],
	            [-56.120771, -26.027396],
	            [-56.128906, -26.007595],
	            [-56.151859, -25.985179],
	            [-56.137707, -25.97554],
	            [-56.130843, -25.960546],
	            [-56.114745, -25.945889],
	            [-56.117294, -25.920288],
	            [-56.139649, -25.899168],
	            [-56.135321, -25.874424],
	            [-56.125128, -25.864965],
	            [-56.088729, -25.866377],
	            [-56.034183, -25.862157],
	            [-56.030236, -25.870703],
	            [-56.009762, -25.877585]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "JOSÉ FASSARDI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.33895, -25.632473],
	            [-56.335654, -25.653966],
	            [-56.318614, -25.678904],
	            [-56.303887, -25.687187],
	            [-56.29165, -25.707671],
	            [-56.296827, -25.727891],
	            [-56.280551, -25.751253],
	            [-56.285569, -25.765748],
	            [-56.313834, -25.779691],
	            [-56.335607, -25.79698],
	            [-56.35362, -25.776812],
	            [-56.398212, -25.758768],
	            [-56.426079, -25.75069],
	            [-56.456667, -25.731081],
	            [-56.441352, -25.727133],
	            [-56.434447, -25.681278],
	            [-56.423523, -25.648939],
	            [-56.422928, -25.628521],
	            [-56.385044, -25.622612],
	            [-56.362366, -25.623408],
	            [-56.33895, -25.632473]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "MBOCAYATY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.237711, -25.624136],
	            [-56.244591, -25.65392],
	            [-56.24931, -25.704249],
	            [-56.25944, -25.710253],
	            [-56.29165, -25.707671],
	            [-56.303887, -25.687187],
	            [-56.318614, -25.678904],
	            [-56.335654, -25.653966],
	            [-56.33895, -25.632473],
	            [-56.325448, -25.624935],
	            [-56.302515, -25.632514],
	            [-56.280866, -25.633558],
	            [-56.265233, -25.640926],
	            [-56.237711, -25.624136]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "NATALICIO TALAVERA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.274312, -25.94237],
	            [-56.299365, -25.942633],
	            [-56.316469, -25.951559],
	            [-56.317747, -25.962663],
	            [-56.349519, -25.971671],
	            [-56.368896, -25.95387],
	            [-56.37167, -25.939737],
	            [-56.363888, -25.893781],
	            [-56.353574, -25.8958],
	            [-56.339091, -25.878276],
	            [-56.289907, -25.874771],
	            [-56.276798, -25.844823],
	            [-56.276702, -25.885794],
	            [-56.249205, -25.898742],
	            [-56.253337, -25.921947],
	            [-56.274312, -25.94237]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "ÑUMÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.363888, -25.893781],
	            [-56.37167, -25.939737],
	            [-56.368896, -25.95387],
	            [-56.349519, -25.971671],
	            [-56.365221, -25.993001],
	            [-56.38684, -25.999433],
	            [-56.414507, -26.022596],
	            [-56.439939, -26.039072],
	            [-56.451857, -26.026936],
	            [-56.486314, -26.017519],
	            [-56.464526, -25.969578],
	            [-56.486807, -25.94632],
	            [-56.482626, -25.925743],
	            [-56.488732, -25.914647],
	            [-56.49403, -25.888536],
	            [-56.489932, -25.879995],
	            [-56.454695, -25.885918],
	            [-56.454944, -25.897856],
	            [-56.429083, -25.919062],
	            [-56.389069, -25.898997],
	            [-56.363888, -25.893781]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "SAN SALVADOR"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.443962, -25.621711],
	            [-56.422928, -25.628521],
	            [-56.423523, -25.648939],
	            [-56.434447, -25.681278],
	            [-56.441352, -25.727133],
	            [-56.456667, -25.731081],
	            [-56.478512, -25.722013],
	            [-56.49732, -25.689576],
	            [-56.516603, -25.674891],
	            [-56.550514, -25.63915],
	            [-56.528384, -25.624785],
	            [-56.495153, -25.622927],
	            [-56.481575, -25.635729],
	            [-56.46769, -25.626744],
	            [-56.443962, -25.621711]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "YATAITY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.306189, -25.56874],
	            [-56.302515, -25.632514],
	            [-56.325448, -25.624935],
	            [-56.33895, -25.632473],
	            [-56.362366, -25.623408],
	            [-56.385044, -25.622612],
	            [-56.422928, -25.628521],
	            [-56.443962, -25.621711],
	            [-56.430005, -25.616172],
	            [-56.41695, -25.58112],
	            [-56.389795, -25.565875],
	            [-56.368971, -25.578189],
	            [-56.356234, -25.569623],
	            [-56.333285, -25.57385],
	            [-56.317261, -25.564827],
	            [-56.306189, -25.56874]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "DOCTOR BOTTRELL"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.633585, -25.65027],
	            [-55.643693, -25.676042],
	            [-55.662527, -25.699718],
	            [-55.674354, -25.738374],
	            [-55.689608, -25.742986],
	            [-55.703147, -25.721492],
	            [-55.73582, -25.710407],
	            [-55.765212, -25.726537],
	            [-55.755193, -25.771686],
	            [-55.778722, -25.776616],
	            [-55.789392, -25.78833],
	            [-55.813625, -25.784088],
	            [-55.823717, -25.797352],
	            [-55.848217, -25.802523],
	            [-55.867591, -25.819641],
	            [-55.887567, -25.855247],
	            [-55.912355, -25.876045],
	            [-55.93567, -25.854463],
	            [-55.983205, -25.854364],
	            [-55.997689, -25.872776],
	            [-56.009762, -25.877585],
	            [-56.030236, -25.870703],
	            [-56.034183, -25.862157],
	            [-56.032941, -25.805788],
	            [-56.029186, -25.79546],
	            [-56.038711, -25.767988],
	            [-56.060452, -25.770316],
	            [-56.063607, -25.753428],
	            [-56.073867, -25.746356],
	            [-56.097131, -25.71131],
	            [-56.100914, -25.683829],
	            [-56.118748, -25.658276],
	            [-56.098325, -25.653406],
	            [-56.079848, -25.640135],
	            [-56.068363, -25.641462],
	            [-56.062358, -25.656629],
	            [-56.029605, -25.661656],
	            [-56.010383, -25.67583],
	            [-55.957751, -25.628321],
	            [-55.943138, -25.626837],
	            [-55.933161, -25.627229],
	            [-55.860078, -25.656747],
	            [-55.861593, -25.678564],
	            [-55.837358, -25.685348],
	            [-55.786869, -25.692779],
	            [-55.766773, -25.681094],
	            [-55.746604, -25.691246],
	            [-55.720324, -25.675498],
	            [-55.693877, -25.678459],
	            [-55.666178, -25.645696],
	            [-55.633585, -25.65027]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "PASO YOBAI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.662314, -25.706708],
	            [-56.65676, -25.717481],
	            [-56.655783, -25.751806],
	            [-56.64279, -25.770525],
	            [-56.622671, -25.779971],
	            [-56.618632, -25.805067],
	            [-56.633577, -25.822559],
	            [-56.619856, -25.86526],
	            [-56.627668, -25.886487],
	            [-56.666513, -25.849005],
	            [-56.689541, -25.762165],
	            [-56.669835, -25.700155],
	            [-56.669062, -25.700086],
	            [-56.662314, -25.706708]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "GUAIRÁ",
	        "dist_desc_": "TEBICUARY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.370806, -25.34257],
	            [-56.386287, -25.39376],
	            [-56.363079, -25.414558],
	            [-56.339482, -25.407238],
	            [-56.308491, -25.404758],
	            [-56.278962, -25.42348],
	            [-56.268913, -25.425176],
	            [-56.239027, -25.404455],
	            [-56.230099, -25.417274],
	            [-56.182073, -25.40677],
	            [-56.150344, -25.424973],
	            [-56.168375, -25.440393],
	            [-56.183323, -25.441558],
	            [-56.191055, -25.460575],
	            [-56.23624, -25.478653],
	            [-56.250643, -25.51555],
	            [-56.242215, -25.523963],
	            [-56.246779, -25.543528],
	            [-56.259733, -25.543535],
	            [-56.267376, -25.557746],
	            [-56.292163, -25.569038],
	            [-56.306189, -25.56874],
	            [-56.317261, -25.564827],
	            [-56.333285, -25.57385],
	            [-56.356234, -25.569623],
	            [-56.368971, -25.578189],
	            [-56.389795, -25.565875],
	            [-56.41695, -25.58112],
	            [-56.430005, -25.616172],
	            [-56.443962, -25.621711],
	            [-56.46769, -25.626744],
	            [-56.481575, -25.635729],
	            [-56.495153, -25.622927],
	            [-56.528384, -25.624785],
	            [-56.550514, -25.63915],
	            [-56.584448, -25.662496],
	            [-56.609438, -25.678555],
	            [-56.625624, -25.676376],
	            [-56.648903, -25.686064],
	            [-56.662314, -25.706708],
	            [-56.669062, -25.700086],
	            [-56.677162, -25.692839],
	            [-56.654898, -25.640219],
	            [-56.64369, -25.635013],
	            [-56.622871, -25.59621],
	            [-56.591675, -25.589825],
	            [-56.559335, -25.544098],
	            [-56.520852, -25.522523],
	            [-56.519143, -25.472289],
	            [-56.512627, -25.4673],
	            [-56.507665, -25.401529],
	            [-56.501654, -25.386027],
	            [-56.513244, -25.368474],
	            [-56.484928, -25.378885],
	            [-56.475695, -25.282985],
	            [-56.437901, -25.230817],
	            [-56.437865, -25.242561],
	            [-56.39192, -25.291516],
	            [-56.386275, -25.311528],
	            [-56.389203, -25.327673],
	            [-56.370806, -25.34257]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "CORONEL OVIEDO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.966372, -25.209312],
	            [-55.981391, -25.247044],
	            [-55.98185, -25.295691],
	            [-55.953816, -25.310462],
	            [-55.927532, -25.309623],
	            [-55.919004, -25.334798],
	            [-55.897206, -25.361102],
	            [-55.891992, -25.376274],
	            [-55.893435, -25.401974],
	            [-55.874994, -25.45089],
	            [-55.874767, -25.465372],
	            [-55.847548, -25.491102],
	            [-55.828134, -25.492949],
	            [-55.830522, -25.501292],
	            [-55.859248, -25.507027],
	            [-55.902975, -25.511166],
	            [-55.933752, -25.506937],
	            [-55.981347, -25.519407],
	            [-55.995156, -25.508929],
	            [-56.012412, -25.517069],
	            [-56.133726, -25.590065],
	            [-56.120886, -25.607682],
	            [-56.154692, -25.599507],
	            [-56.205938, -25.576799],
	            [-56.231182, -25.580266],
	            [-56.256065, -25.578322],
	            [-56.287292, -25.585336],
	            [-56.292163, -25.569038],
	            [-56.267376, -25.557746],
	            [-56.259733, -25.543535],
	            [-56.246779, -25.543528],
	            [-56.242215, -25.523963],
	            [-56.250643, -25.51555],
	            [-56.23624, -25.478653],
	            [-56.191055, -25.460575],
	            [-56.183323, -25.441558],
	            [-56.168375, -25.440393],
	            [-56.150344, -25.424973],
	            [-56.182073, -25.40677],
	            [-56.137014, -25.394547],
	            [-56.120579, -25.393152],
	            [-56.093165, -25.382012],
	            [-56.096712, -25.345621],
	            [-56.088182, -25.318176],
	            [-56.100552, -25.284123],
	            [-56.119011, -25.26668],
	            [-56.145993, -25.267606],
	            [-56.143372, -25.259229],
	            [-56.120634, -25.254431],
	            [-56.119224, -25.231604],
	            [-56.080798, -25.227248],
	            [-56.061078, -25.216121],
	            [-56.059229, -25.193452],
	            [-56.016327, -25.193236],
	            [-55.994697, -25.188052],
	            [-55.976591, -25.206557],
	            [-55.966372, -25.209312]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "CAAGUAZÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.308038, -25.14076],
	            [-56.286047, -25.129824],
	            [-56.192786, -25.119543],
	            [-56.182363, -25.111322],
	            [-56.156324, -25.110932],
	            [-56.130938, -25.127569],
	            [-56.111317, -25.168035],
	            [-56.096022, -25.168772],
	            [-56.075435, -25.16096],
	            [-56.059229, -25.193452],
	            [-56.061078, -25.216121],
	            [-56.080798, -25.227248],
	            [-56.119224, -25.231604],
	            [-56.120634, -25.254431],
	            [-56.143372, -25.259229],
	            [-56.145993, -25.267606],
	            [-56.178907, -25.283159],
	            [-56.210866, -25.284272],
	            [-56.218952, -25.311475],
	            [-56.262689, -25.314026],
	            [-56.287849, -25.327903],
	            [-56.303026, -25.323417],
	            [-56.307653, -25.341118],
	            [-56.327853, -25.336906],
	            [-56.341995, -25.346765],
	            [-56.370806, -25.34257],
	            [-56.389203, -25.327673],
	            [-56.386275, -25.311528],
	            [-56.39192, -25.291516],
	            [-56.437865, -25.242561],
	            [-56.437901, -25.230817],
	            [-56.457644, -25.22428],
	            [-56.458665, -25.211053],
	            [-56.471792, -25.186509],
	            [-56.503466, -25.167223],
	            [-56.522349, -25.172182],
	            [-56.533894, -25.166864],
	            [-56.56168, -25.166074],
	            [-56.564242, -25.011932],
	            [-56.52174, -25.018325],
	            [-56.490413, -25.032452],
	            [-56.46683, -25.051877],
	            [-56.437315, -25.063716],
	            [-56.416027, -25.088098],
	            [-56.388133, -25.094068],
	            [-56.358865, -25.112159],
	            [-56.342811, -25.131567],
	            [-56.308038, -25.14076]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "CARAYAÓ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.150852, -25.052502],
	            [-56.144659, -25.085137],
	            [-56.130938, -25.127569],
	            [-56.156324, -25.110932],
	            [-56.182363, -25.111322],
	            [-56.192786, -25.119543],
	            [-56.286047, -25.129824],
	            [-56.308038, -25.14076],
	            [-56.302789, -25.102794],
	            [-56.318141, -25.095167],
	            [-56.303656, -25.067972],
	            [-56.267466, -25.051515],
	            [-56.259011, -25.035503],
	            [-56.195676, -25.063552],
	            [-56.156706, -25.057493],
	            [-56.150852, -25.052502]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "DOCTOR CECILIO BÁEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.176524, -24.894305],
	            [-56.161899, -24.928346],
	            [-56.151114, -24.937293],
	            [-56.128384, -24.935166],
	            [-56.11883, -24.918813],
	            [-56.102968, -24.922314],
	            [-56.103332, -24.942896],
	            [-56.093293, -24.953284],
	            [-56.119243, -24.968787],
	            [-56.133165, -24.988379],
	            [-56.156118, -24.992678],
	            [-56.184286, -24.98702],
	            [-56.198866, -25.000627],
	            [-56.209514, -24.999442],
	            [-56.255638, -25.017262],
	            [-56.275782, -24.999675],
	            [-56.334593, -24.98686],
	            [-56.347447, -24.995573],
	            [-56.359561, -24.987326],
	            [-56.382423, -24.98978],
	            [-56.395972, -24.975323],
	            [-56.413647, -24.96956],
	            [-56.427745, -24.944428],
	            [-56.420049, -24.933647],
	            [-56.400981, -24.928929],
	            [-56.392175, -24.913352],
	            [-56.369432, -24.912318],
	            [-56.353049, -24.920561],
	            [-56.32813, -24.917344],
	            [-56.298665, -24.939866],
	            [-56.278033, -24.941122],
	            [-56.262941, -24.927557],
	            [-56.24882, -24.925567],
	            [-56.197163, -24.940447],
	            [-56.277746, -24.809199],
	            [-56.254855, -24.766173],
	            [-56.222655, -24.800904],
	            [-56.215241, -24.838853],
	            [-56.200056, -24.855683],
	            [-56.176524, -24.894305]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "SANTA ROSA DEL MBUTUY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.940699, -25.214566],
	            [-55.900875, -25.233983],
	            [-55.884767, -25.238386],
	            [-55.864116, -25.252406],
	            [-55.847908, -25.251648],
	            [-55.827682, -25.262428],
	            [-55.803952, -25.260251],
	            [-55.776657, -25.276393],
	            [-55.736513, -25.281558],
	            [-55.7177, -25.275003],
	            [-55.703972, -25.275983],
	            [-55.716853, -25.307944],
	            [-55.716754, -25.327745],
	            [-55.72862, -25.335572],
	            [-55.732419, -25.389089],
	            [-55.715055, -25.400992],
	            [-55.69949, -25.441563],
	            [-55.677538, -25.459854],
	            [-55.675039, -25.479045],
	            [-55.663468, -25.503224],
	            [-55.681185, -25.516155],
	            [-55.709401, -25.512163],
	            [-55.737644, -25.482147],
	            [-55.771505, -25.479915],
	            [-55.786266, -25.498334],
	            [-55.828134, -25.492949],
	            [-55.847548, -25.491102],
	            [-55.874767, -25.465372],
	            [-55.874994, -25.45089],
	            [-55.893435, -25.401974],
	            [-55.891992, -25.376274],
	            [-55.897206, -25.361102],
	            [-55.919004, -25.334798],
	            [-55.927532, -25.309623],
	            [-55.953816, -25.310462],
	            [-55.98185, -25.295691],
	            [-55.981391, -25.247044],
	            [-55.966372, -25.209312],
	            [-55.966365, -25.209315],
	            [-55.940699, -25.214566]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "DOCTOR JUAN MANUEL FRUTOS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.663468, -25.503224],
	            [-55.640768, -25.505322],
	            [-55.62102, -25.515638],
	            [-55.604825, -25.544878],
	            [-55.584476, -25.536787],
	            [-55.560182, -25.537051],
	            [-55.538923, -25.554753],
	            [-55.514017, -25.562642],
	            [-55.53396, -25.579993],
	            [-55.546121, -25.619203],
	            [-55.56187, -25.637357],
	            [-55.573884, -25.634279],
	            [-55.590661, -25.656408],
	            [-55.614144, -25.648977],
	            [-55.633585, -25.65027],
	            [-55.666178, -25.645696],
	            [-55.693877, -25.678459],
	            [-55.720324, -25.675498],
	            [-55.746604, -25.691246],
	            [-55.766773, -25.681094],
	            [-55.786869, -25.692779],
	            [-55.837358, -25.685348],
	            [-55.861593, -25.678564],
	            [-55.860078, -25.656747],
	            [-55.933161, -25.627229],
	            [-55.943138, -25.626837],
	            [-56.059975, -25.622427],
	            [-56.120886, -25.607682],
	            [-56.133726, -25.590065],
	            [-56.012412, -25.517069],
	            [-55.995156, -25.508929],
	            [-55.981347, -25.519407],
	            [-55.933752, -25.506937],
	            [-55.902975, -25.511166],
	            [-55.859248, -25.507027],
	            [-55.830522, -25.501292],
	            [-55.828134, -25.492949],
	            [-55.786266, -25.498334],
	            [-55.771505, -25.479915],
	            [-55.737644, -25.482147],
	            [-55.709401, -25.512163],
	            [-55.681185, -25.516155],
	            [-55.663468, -25.503224]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "REPATRIACIÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.513244, -25.368474],
	            [-56.501654, -25.386027],
	            [-56.507665, -25.401529],
	            [-56.512627, -25.4673],
	            [-56.519143, -25.472289],
	            [-56.520852, -25.522523],
	            [-56.559335, -25.544098],
	            [-56.575371, -25.539239],
	            [-56.576703, -25.515805],
	            [-56.571494, -25.496246],
	            [-56.590425, -25.4834],
	            [-56.614883, -25.47491],
	            [-56.622559, -25.459965],
	            [-56.625426, -25.431794],
	            [-56.649135, -25.408681],
	            [-56.651069, -25.397533],
	            [-56.561362, -25.306111],
	            [-56.551812, -25.30513],
	            [-56.532648, -25.323136],
	            [-56.513244, -25.368474]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "NUEVA LONDRES"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.966365, -25.209315],
	            [-55.966372, -25.209312],
	            [-55.976591, -25.206557],
	            [-55.994697, -25.188052],
	            [-56.016327, -25.193236],
	            [-56.059229, -25.193452],
	            [-56.075435, -25.16096],
	            [-56.096022, -25.168772],
	            [-56.111317, -25.168035],
	            [-56.130938, -25.127569],
	            [-56.144659, -25.085137],
	            [-56.150852, -25.052502],
	            [-56.141954, -25.049132],
	            [-56.146249, -25.016745],
	            [-56.156118, -24.992678],
	            [-56.133165, -24.988379],
	            [-56.119243, -24.968787],
	            [-56.093293, -24.953284],
	            [-56.103332, -24.942896],
	            [-56.102968, -24.922314],
	            [-56.088941, -24.932729],
	            [-56.050659, -24.906208],
	            [-56.024258, -24.906038],
	            [-56.024134, -24.888207],
	            [-55.964057, -24.913259],
	            [-55.951041, -24.911064],
	            [-55.949566, -24.941756],
	            [-55.969151, -24.961127],
	            [-55.977082, -25.025048],
	            [-55.975732, -25.04244],
	            [-55.991806, -25.044238],
	            [-55.999149, -25.06605],
	            [-56.012857, -25.082961],
	            [-55.999094, -25.113219],
	            [-55.970071, -25.124095],
	            [-55.964279, -25.135379],
	            [-55.97456, -25.153659],
	            [-55.97498, -25.200342],
	            [-55.966365, -25.209315]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "SAN JOAQUÍN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.559335, -25.544098],
	            [-56.591675, -25.589825],
	            [-56.622871, -25.59621],
	            [-56.64369, -25.635013],
	            [-56.654898, -25.640219],
	            [-56.677162, -25.692839],
	            [-56.669062, -25.700086],
	            [-56.669835, -25.700155],
	            [-56.692916, -25.69975],
	            [-56.715617, -25.669915],
	            [-56.719684, -25.658716],
	            [-56.802286, -25.582017],
	            [-56.83124, -25.544237],
	            [-56.834052, -25.533499],
	            [-56.853035, -25.535367],
	            [-56.851227, -25.507642],
	            [-56.833765, -25.496335],
	            [-56.807155, -25.49019],
	            [-56.805761, -25.482386],
	            [-56.773974, -25.4649],
	            [-56.722019, -25.435117],
	            [-56.672973, -25.413865],
	            [-56.651069, -25.397533],
	            [-56.649135, -25.408681],
	            [-56.625426, -25.431794],
	            [-56.622559, -25.459965],
	            [-56.614883, -25.47491],
	            [-56.590425, -25.4834],
	            [-56.571494, -25.496246],
	            [-56.576703, -25.515805],
	            [-56.575371, -25.539239],
	            [-56.559335, -25.544098]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "SAN JOSÉ DE LOS ARROYOS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.592494, -24.60245],
	            [-55.562509, -24.655536],
	            [-55.56582, -24.670688],
	            [-55.552429, -24.686294],
	            [-55.537552, -24.690912],
	            [-55.528042, -24.709768],
	            [-55.484293, -24.736285],
	            [-55.472723, -24.736407],
	            [-55.456066, -24.749933],
	            [-55.425584, -24.753167],
	            [-55.413519, -24.77611],
	            [-55.375881, -24.815686],
	            [-55.400618, -24.829385],
	            [-55.417914, -24.822026],
	            [-55.445923, -24.821918],
	            [-55.486123, -24.834944],
	            [-55.707863, -24.912186],
	            [-55.74141, -24.895477],
	            [-55.757163, -24.901316],
	            [-55.767496, -24.915787],
	            [-55.790146, -24.924501],
	            [-55.79517, -24.940777],
	            [-55.830982, -24.971105],
	            [-55.852744, -24.959639],
	            [-55.875921, -24.999647],
	            [-55.853249, -25.018121],
	            [-55.829001, -25.01465],
	            [-55.804646, -25.02424],
	            [-55.794562, -25.040582],
	            [-55.775471, -25.053136],
	            [-55.758139, -25.057584],
	            [-55.729111, -25.082479],
	            [-55.709578, -25.09941],
	            [-55.704394, -25.128181],
	            [-55.714573, -25.128486],
	            [-55.686789, -25.169423],
	            [-55.688051, -25.176289],
	            [-55.704237, -25.179275],
	            [-55.741724, -25.177743],
	            [-55.76483, -25.171152],
	            [-55.793955, -25.155752],
	            [-55.827126, -25.180308],
	            [-55.837463, -25.16286],
	            [-55.85422, -25.161415],
	            [-55.877922, -25.150589],
	            [-55.889519, -25.136458],
	            [-55.940699, -25.214566],
	            [-55.966365, -25.209315],
	            [-55.97498, -25.200342],
	            [-55.97456, -25.153659],
	            [-55.964279, -25.135379],
	            [-55.970071, -25.124095],
	            [-55.999094, -25.113219],
	            [-56.012857, -25.082961],
	            [-55.999149, -25.06605],
	            [-55.991806, -25.044238],
	            [-55.975732, -25.04244],
	            [-55.977082, -25.025048],
	            [-55.969151, -24.961127],
	            [-55.949566, -24.941756],
	            [-55.951041, -24.911064],
	            [-55.964057, -24.913259],
	            [-56.024134, -24.888207],
	            [-55.988705, -24.863221],
	            [-55.990516, -24.838419],
	            [-55.972534, -24.833745],
	            [-55.938318, -24.846133],
	            [-55.884079, -24.847499],
	            [-55.868537, -24.857954],
	            [-55.846136, -24.861453],
	            [-55.826973, -24.845741],
	            [-55.797103, -24.836629],
	            [-55.781163, -24.837822],
	            [-55.776427, -24.822422],
	            [-55.729978, -24.825008],
	            [-55.712114, -24.8199],
	            [-55.708015, -24.790957],
	            [-55.701991, -24.78397],
	            [-55.718269, -24.758095],
	            [-55.736106, -24.743189],
	            [-55.727095, -24.72135],
	            [-55.712726, -24.707917],
	            [-55.702707, -24.688919],
	            [-55.670795, -24.672122],
	            [-55.668465, -24.653189],
	            [-55.638464, -24.644827],
	            [-55.612427, -24.646075],
	            [-55.6018, -24.634745],
	            [-55.592494, -24.60245]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "YHÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.557725, -25.267269],
	            [-55.545577, -25.274248],
	            [-55.513194, -25.31071],
	            [-55.507797, -25.345503],
	            [-55.481062, -25.355105],
	            [-55.477826, -25.412276],
	            [-55.476412, -25.523741],
	            [-55.495888, -25.561066],
	            [-55.514017, -25.562642],
	            [-55.538923, -25.554753],
	            [-55.560182, -25.537051],
	            [-55.584476, -25.536787],
	            [-55.604825, -25.544878],
	            [-55.62102, -25.515638],
	            [-55.640768, -25.505322],
	            [-55.663468, -25.503224],
	            [-55.675039, -25.479045],
	            [-55.677538, -25.459854],
	            [-55.69949, -25.441563],
	            [-55.715055, -25.400992],
	            [-55.732419, -25.389089],
	            [-55.72862, -25.335572],
	            [-55.716754, -25.327745],
	            [-55.716853, -25.307944],
	            [-55.703972, -25.275983],
	            [-55.665164, -25.26182],
	            [-55.644846, -25.270887],
	            [-55.626906, -25.271512],
	            [-55.602623, -25.263527],
	            [-55.58515, -25.26906],
	            [-55.557725, -25.267269]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "DOCTOR J. EULOGIO ESTIGARRIBIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.182073, -25.40677],
	            [-56.230099, -25.417274],
	            [-56.239027, -25.404455],
	            [-56.268913, -25.425176],
	            [-56.278962, -25.42348],
	            [-56.308491, -25.404758],
	            [-56.339482, -25.407238],
	            [-56.363079, -25.414558],
	            [-56.386287, -25.39376],
	            [-56.370806, -25.34257],
	            [-56.341995, -25.346765],
	            [-56.327853, -25.336906],
	            [-56.307653, -25.341118],
	            [-56.303026, -25.323417],
	            [-56.287849, -25.327903],
	            [-56.262689, -25.314026],
	            [-56.218952, -25.311475],
	            [-56.210866, -25.284272],
	            [-56.178907, -25.283159],
	            [-56.145993, -25.267606],
	            [-56.119011, -25.26668],
	            [-56.100552, -25.284123],
	            [-56.088182, -25.318176],
	            [-56.096712, -25.345621],
	            [-56.093165, -25.382012],
	            [-56.120579, -25.393152],
	            [-56.137014, -25.394547],
	            [-56.182073, -25.40677]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "R.I. 3 CORRALES"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.402366, -25.106807],
	            [-55.392452, -25.122285],
	            [-55.366968, -25.12493],
	            [-55.363075, -25.134097],
	            [-55.388691, -25.142119],
	            [-55.412968, -25.140638],
	            [-55.418148, -25.154697],
	            [-55.403844, -25.199962],
	            [-55.424101, -25.200288],
	            [-55.418211, -25.225008],
	            [-55.441192, -25.230638],
	            [-55.45367, -25.219371],
	            [-55.463912, -25.228834],
	            [-55.511065, -25.228502],
	            [-55.510804, -25.237546],
	            [-55.542382, -25.239612],
	            [-55.541818, -25.251375],
	            [-55.564704, -25.254208],
	            [-55.557725, -25.267269],
	            [-55.58515, -25.26906],
	            [-55.602623, -25.263527],
	            [-55.626906, -25.271512],
	            [-55.644846, -25.270887],
	            [-55.665164, -25.26182],
	            [-55.703972, -25.275983],
	            [-55.7177, -25.275003],
	            [-55.688051, -25.176289],
	            [-55.686789, -25.169423],
	            [-55.714573, -25.128486],
	            [-55.704394, -25.128181],
	            [-55.709578, -25.09941],
	            [-55.729111, -25.082479],
	            [-55.714891, -25.076056],
	            [-55.686369, -25.040925],
	            [-55.67946, -25.022358],
	            [-55.700167, -25.017125],
	            [-55.676851, -25.011667],
	            [-55.648726, -25.022999],
	            [-55.631199, -25.03999],
	            [-55.60709, -25.036077],
	            [-55.572749, -25.065042],
	            [-55.553831, -25.064159],
	            [-55.523404, -25.071214],
	            [-55.489112, -25.083523],
	            [-55.472955, -25.073697],
	            [-55.446607, -25.090014],
	            [-55.434485, -25.113142],
	            [-55.402366, -25.106807]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "RAÚL ARSENIO OVIEDO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.378436, -25.361914],
	            [-55.426062, -25.557542],
	            [-55.432483, -25.543784],
	            [-55.476412, -25.523741],
	            [-55.477826, -25.412276],
	            [-55.481062, -25.355105],
	            [-55.417028, -25.362798],
	            [-55.378436, -25.361914]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "JOSÉ DOMINGO OCAMPOS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.312739, -25.001805],
	            [-55.294287, -25.023168],
	            [-55.277307, -25.023885],
	            [-55.275727, -25.038248],
	            [-55.229126, -25.029408],
	            [-55.232697, -25.042762],
	            [-55.210648, -25.049148],
	            [-55.193267, -25.04297],
	            [-55.176294, -25.058814],
	            [-55.159835, -25.096041],
	            [-55.147529, -25.097319],
	            [-55.106961, -25.131952],
	            [-55.056213, -25.160806],
	            [-55.026819, -25.18122],
	            [-55.01641, -25.196013],
	            [-55.026888, -25.222413],
	            [-55.017009, -25.244222],
	            [-54.980917, -25.26329],
	            [-54.974729, -25.283314],
	            [-54.956127, -25.319684],
	            [-54.938235, -25.334262],
	            [-54.950017, -25.345809],
	            [-54.935052, -25.354564],
	            [-54.943998, -25.366907],
	            [-54.960914, -25.361279],
	            [-54.965461, -25.375289],
	            [-55.000168, -25.387518],
	            [-55.021251, -25.378072],
	            [-55.031534, -25.358517],
	            [-55.042375, -25.319506],
	            [-55.058655, -25.31361],
	            [-55.099059, -25.325457],
	            [-55.123678, -25.327808],
	            [-55.159652, -25.320395],
	            [-55.191369, -25.29759],
	            [-55.219968, -25.265591],
	            [-55.224168, -25.238349],
	            [-55.242094, -25.200438],
	            [-55.296841, -25.171167],
	            [-55.340186, -25.152131],
	            [-55.363075, -25.134097],
	            [-55.366968, -25.12493],
	            [-55.392452, -25.122285],
	            [-55.402366, -25.106807],
	            [-55.404069, -25.093414],
	            [-55.420659, -25.071352],
	            [-55.422312, -25.038546],
	            [-55.41055, -25.023848],
	            [-55.403666, -24.993568],
	            [-55.380003, -24.990766],
	            [-55.356896, -25.005297],
	            [-55.33585, -25.000012],
	            [-55.312739, -25.001805]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "MARISCAL FRANCISCO SOLANO LÓPEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.56168, -25.166074],
	            [-56.533894, -25.166864],
	            [-56.522349, -25.172182],
	            [-56.503466, -25.167223],
	            [-56.471792, -25.186509],
	            [-56.458665, -25.211053],
	            [-56.457644, -25.22428],
	            [-56.437901, -25.230817],
	            [-56.475695, -25.282985],
	            [-56.484928, -25.378885],
	            [-56.513244, -25.368474],
	            [-56.532648, -25.323136],
	            [-56.551812, -25.30513],
	            [-56.561362, -25.306111],
	            [-56.606851, -25.314133],
	            [-56.623161, -25.313496],
	            [-56.645915, -25.293723],
	            [-56.66345, -25.26199],
	            [-56.619033, -25.166777],
	            [-56.56168, -25.166074]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "LA PASTORA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.688051, -25.176289],
	            [-55.7177, -25.275003],
	            [-55.736513, -25.281558],
	            [-55.776657, -25.276393],
	            [-55.803952, -25.260251],
	            [-55.827682, -25.262428],
	            [-55.847908, -25.251648],
	            [-55.864116, -25.252406],
	            [-55.884767, -25.238386],
	            [-55.900875, -25.233983],
	            [-55.940699, -25.214566],
	            [-55.889519, -25.136458],
	            [-55.877922, -25.150589],
	            [-55.85422, -25.161415],
	            [-55.837463, -25.16286],
	            [-55.827126, -25.180308],
	            [-55.793955, -25.155752],
	            [-55.76483, -25.171152],
	            [-55.741724, -25.177743],
	            [-55.704237, -25.179275],
	            [-55.688051, -25.176289]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "3 DE FEBRERO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.156118, -24.992678],
	            [-56.146249, -25.016745],
	            [-56.141954, -25.049132],
	            [-56.150852, -25.052502],
	            [-56.156706, -25.057493],
	            [-56.195676, -25.063552],
	            [-56.259011, -25.035503],
	            [-56.267466, -25.051515],
	            [-56.303656, -25.067972],
	            [-56.318141, -25.095167],
	            [-56.302789, -25.102794],
	            [-56.308038, -25.14076],
	            [-56.342811, -25.131567],
	            [-56.358865, -25.112159],
	            [-56.388133, -25.094068],
	            [-56.416027, -25.088098],
	            [-56.437315, -25.063716],
	            [-56.46683, -25.051877],
	            [-56.490413, -25.032452],
	            [-56.52174, -25.018325],
	            [-56.564242, -25.011932],
	            [-56.564484, -24.997337],
	            [-56.545367, -25.00315],
	            [-56.51948, -25.003886],
	            [-56.427745, -24.944428],
	            [-56.413647, -24.96956],
	            [-56.395972, -24.975323],
	            [-56.382423, -24.98978],
	            [-56.359561, -24.987326],
	            [-56.347447, -24.995573],
	            [-56.334593, -24.98686],
	            [-56.275782, -24.999675],
	            [-56.255638, -25.017262],
	            [-56.209514, -24.999442],
	            [-56.198866, -25.000627],
	            [-56.184286, -24.98702],
	            [-56.156118, -24.992678]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "SIMÓN BOLIVAR"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.154635, -24.479057],
	            [-55.138767, -24.496782],
	            [-55.160848, -24.518731],
	            [-55.21456, -24.515227],
	            [-55.237797, -24.519098],
	            [-55.24723, -24.514509],
	            [-55.269593, -24.523168],
	            [-55.30208, -24.567184],
	            [-55.30545, -24.592002],
	            [-55.292657, -24.612836],
	            [-55.301445, -24.633549],
	            [-55.292578, -24.646202],
	            [-55.315383, -24.677053],
	            [-55.314855, -24.697177],
	            [-55.303439, -24.704624],
	            [-55.303417, -24.725729],
	            [-55.322848, -24.751616],
	            [-55.321423, -24.767983],
	            [-55.335092, -24.80473],
	            [-55.336609, -24.831797],
	            [-55.348866, -24.842709],
	            [-55.364012, -24.831314],
	            [-55.377267, -24.864319],
	            [-55.400576, -24.879478],
	            [-55.422299, -24.8751],
	            [-55.457276, -24.893636],
	            [-55.530079, -24.890899],
	            [-55.548747, -24.893222],
	            [-55.559482, -24.901976],
	            [-55.586, -24.901232],
	            [-55.600989, -24.917611],
	            [-55.630877, -24.92729],
	            [-55.657521, -24.951116],
	            [-55.665345, -24.974168],
	            [-55.682672, -24.987434],
	            [-55.708073, -24.993322],
	            [-55.700167, -25.017125],
	            [-55.67946, -25.022358],
	            [-55.686369, -25.040925],
	            [-55.714891, -25.076056],
	            [-55.729111, -25.082479],
	            [-55.758139, -25.057584],
	            [-55.775471, -25.053136],
	            [-55.794562, -25.040582],
	            [-55.804646, -25.02424],
	            [-55.829001, -25.01465],
	            [-55.853249, -25.018121],
	            [-55.875921, -24.999647],
	            [-55.852744, -24.959639],
	            [-55.830982, -24.971105],
	            [-55.79517, -24.940777],
	            [-55.790146, -24.924501],
	            [-55.767496, -24.915787],
	            [-55.757163, -24.901316],
	            [-55.74141, -24.895477],
	            [-55.707863, -24.912186],
	            [-55.486123, -24.834944],
	            [-55.445923, -24.821918],
	            [-55.417914, -24.822026],
	            [-55.400618, -24.829385],
	            [-55.375881, -24.815686],
	            [-55.413519, -24.77611],
	            [-55.425584, -24.753167],
	            [-55.456066, -24.749933],
	            [-55.472723, -24.736407],
	            [-55.484293, -24.736285],
	            [-55.528042, -24.709768],
	            [-55.537552, -24.690912],
	            [-55.552429, -24.686294],
	            [-55.56582, -24.670688],
	            [-55.562509, -24.655536],
	            [-55.592494, -24.60245],
	            [-55.577875, -24.601239],
	            [-55.56419, -24.581454],
	            [-55.551627, -24.550859],
	            [-55.552465, -24.51865],
	            [-55.543932, -24.513539],
	            [-55.513492, -24.515307],
	            [-55.493706, -24.533788],
	            [-55.491108, -24.568021],
	            [-55.460479, -24.541427],
	            [-55.437838, -24.551255],
	            [-55.400627, -24.536478],
	            [-55.392659, -24.544614],
	            [-55.369768, -24.539964],
	            [-55.345172, -24.509034],
	            [-55.32944, -24.506011],
	            [-55.310341, -24.511868],
	            [-55.304158, -24.493571],
	            [-55.272355, -24.49292],
	            [-55.252526, -24.467507],
	            [-55.238953, -24.475998],
	            [-55.210568, -24.468604],
	            [-55.1803, -24.465456],
	            [-55.154635, -24.479057]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "VAQUERÍA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.437354, -27.050781],
	            [-56.469077, -27.05451],
	            [-56.482484, -27.063631],
	            [-56.47365, -27.100448],
	            [-56.459289, -27.125903],
	            [-56.462554, -27.150158],
	            [-56.476901, -27.165951],
	            [-56.471163, -27.19109],
	            [-56.470697, -27.22351],
	            [-56.524386, -27.230671],
	            [-56.55115, -27.215443],
	            [-56.529839, -27.186331],
	            [-56.549817, -27.173285],
	            [-56.538227, -27.158618],
	            [-56.544475, -27.146012],
	            [-56.629554, -27.154275],
	            [-56.63892, -27.159107],
	            [-56.634802, -27.138759],
	            [-56.640758, -27.035484],
	            [-56.625861, -27.016422],
	            [-56.629229, -26.997258],
	            [-56.64405, -26.978312],
	            [-56.64703, -26.926496],
	            [-56.614185, -26.894671],
	            [-56.600574, -26.888159],
	            [-56.561993, -26.912292],
	            [-56.541127, -26.938283],
	            [-56.539702, -26.966099],
	            [-56.464733, -27.00678],
	            [-56.443315, -27.016309],
	            [-56.437354, -27.050781]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "GENERAL DELGADO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.564899, -27.125635],
	            [-55.562304, -27.159517],
	            [-55.57449, -27.16741],
	            [-55.588925, -27.16202],
	            [-55.611695, -27.167655],
	            [-55.620825, -27.142002],
	            [-55.674586, -27.092932],
	            [-55.668314, -27.076273],
	            [-55.691157, -27.064588],
	            [-55.701731, -27.048443],
	            [-55.70097, -27.029234],
	            [-55.727644, -27.007696],
	            [-55.767149, -27.009512],
	            [-55.786451, -26.992066],
	            [-55.811983, -27.018813],
	            [-55.822887, -27.011457],
	            [-55.800939, -26.988511],
	            [-55.791817, -26.968093],
	            [-55.875891, -26.891587],
	            [-55.888277, -26.880405],
	            [-55.858989, -26.860381],
	            [-55.814438, -26.899395],
	            [-55.675184, -27.028],
	            [-55.585731, -27.108799],
	            [-55.564899, -27.125635]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "HOHENAU"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.674586, -27.092932],
	            [-55.697026, -27.09282],
	            [-55.698074, -27.106664],
	            [-55.719528, -27.109714],
	            [-55.730422, -27.07416],
	            [-55.748579, -27.073302],
	            [-55.756669, -27.083936],
	            [-55.771039, -27.071072],
	            [-55.787242, -27.079658],
	            [-55.798188, -27.070011],
	            [-55.840658, -27.105986],
	            [-55.878446, -27.075518],
	            [-55.875308, -27.056666],
	            [-55.855078, -27.044988],
	            [-55.822887, -27.011457],
	            [-55.811983, -27.018813],
	            [-55.786451, -26.992066],
	            [-55.767149, -27.009512],
	            [-55.727644, -27.007696],
	            [-55.70097, -27.029234],
	            [-55.701731, -27.048443],
	            [-55.691157, -27.064588],
	            [-55.668314, -27.076273],
	            [-55.674586, -27.092932]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "JESÚS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.175596, -26.706033],
	            [-56.167062, -26.711752],
	            [-56.163762, -26.736312],
	            [-56.139415, -26.756819],
	            [-56.183421, -26.777775],
	            [-56.214879, -26.800656],
	            [-56.255431, -26.801237],
	            [-56.312131, -26.737669],
	            [-56.31363, -26.729115],
	            [-56.283807, -26.718411],
	            [-56.254838, -26.701921],
	            [-56.216052, -26.69764],
	            [-56.184914, -26.711174],
	            [-56.175596, -26.706033]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "JOSÉ LEANDRO OVIEDO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.531918, -27.101683],
	            [-55.555194, -27.106019],
	            [-55.564899, -27.125635],
	            [-55.585731, -27.108799],
	            [-55.675184, -27.028],
	            [-55.814438, -26.899395],
	            [-55.858989, -26.860381],
	            [-55.854169, -26.822983],
	            [-55.761764, -26.773016],
	            [-55.696101, -26.83186],
	            [-55.699111, -26.83916],
	            [-55.579605, -26.946871],
	            [-55.61354, -26.961238],
	            [-55.646013, -26.986974],
	            [-55.647965, -26.994747],
	            [-55.535433, -27.095821],
	            [-55.531918, -27.101683]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "OBLIGADO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.672423, -26.254019],
	            [-54.67489, -26.278456],
	            [-54.652065, -26.298251],
	            [-54.651953, -26.320846],
	            [-54.674555, -26.344069],
	            [-54.696503, -26.37757],
	            [-54.696461, -26.404361],
	            [-54.762849, -26.347881],
	            [-54.908362, -26.220952],
	            [-54.916272, -26.211473],
	            [-54.91648, -26.189696],
	            [-54.883816, -26.195519],
	            [-54.870696, -26.190632],
	            [-54.87467, -26.174255],
	            [-54.855418, -26.188875],
	            [-54.839885, -26.185601],
	            [-54.82739, -26.201213],
	            [-54.799772, -26.201016],
	            [-54.785802, -26.217834],
	            [-54.778498, -26.236395],
	            [-54.721954, -26.249752],
	            [-54.693862, -26.228169],
	            [-54.678613, -26.239576],
	            [-54.672423, -26.254019]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "MAYOR JULIO DIONISIO OTAÑO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.471163, -27.19109],
	            [-56.441311, -27.173439],
	            [-56.417295, -27.178584],
	            [-56.39179, -27.172745],
	            [-56.371544, -27.176831],
	            [-56.355149, -27.169912],
	            [-56.330813, -27.177313],
	            [-56.294974, -27.164478],
	            [-56.277932, -27.17689],
	            [-56.291289, -27.202771],
	            [-56.305146, -27.246881],
	            [-56.302769, -27.26267],
	            [-56.284182, -27.268325],
	            [-56.266434, -27.292387],
	            [-56.272077, -27.310227],
	            [-56.309819, -27.389717],
	            [-56.292493, -27.411052],
	            [-56.290565, -27.448739],
	            [-56.295779, -27.478909],
	            [-56.334238, -27.510631],
	            [-56.360184, -27.54718],
	            [-56.362173, -27.570264],
	            [-56.376957, -27.587815],
	            [-56.407793, -27.591834],
	            [-56.429092, -27.585845],
	            [-56.481682, -27.555813],
	            [-56.533076, -27.477187],
	            [-56.548836, -27.458439],
	            [-56.589339, -27.438195],
	            [-56.637025, -27.44164],
	            [-56.675857, -27.452208],
	            [-56.694095, -27.451879],
	            [-56.719086, -27.466246],
	            [-56.721561, -27.483211],
	            [-56.7316, -27.495036],
	            [-56.750519, -27.49775],
	            [-56.773917, -27.488804],
	            [-56.801759, -27.471413],
	            [-56.829381, -27.460666],
	            [-56.855809, -27.434096],
	            [-56.884837, -27.412556],
	            [-56.84859, -27.410185],
	            [-56.831488, -27.399382],
	            [-56.791617, -27.399867],
	            [-56.772511, -27.388335],
	            [-56.695045, -27.369136],
	            [-56.684276, -27.34657],
	            [-56.669655, -27.337722],
	            [-56.675038, -27.322605],
	            [-56.670036, -27.292481],
	            [-56.698123, -27.268968],
	            [-56.696968, -27.243528],
	            [-56.709545, -27.23603],
	            [-56.688419, -27.201018],
	            [-56.669645, -27.196623],
	            [-56.654828, -27.172053],
	            [-56.63892, -27.159107],
	            [-56.629554, -27.154275],
	            [-56.544475, -27.146012],
	            [-56.538227, -27.158618],
	            [-56.549817, -27.173285],
	            [-56.529839, -27.186331],
	            [-56.55115, -27.215443],
	            [-56.524386, -27.230671],
	            [-56.470697, -27.22351],
	            [-56.471163, -27.19109]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "SAN COSME Y DAMIÁN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.876135, -26.457655],
	            [-55.861723, -26.471309],
	            [-55.814848, -26.481762],
	            [-55.805336, -26.488273],
	            [-55.783429, -26.530218],
	            [-55.833573, -26.60867],
	            [-55.842765, -26.615217],
	            [-55.835991, -26.644508],
	            [-55.874699, -26.691897],
	            [-55.883422, -26.715737],
	            [-55.886579, -26.742424],
	            [-55.854169, -26.822983],
	            [-55.858989, -26.860381],
	            [-55.888277, -26.880405],
	            [-55.875891, -26.891587],
	            [-55.888119, -26.891639],
	            [-55.904001, -26.904488],
	            [-55.934721, -26.907277],
	            [-55.959733, -26.925831],
	            [-55.959289, -26.944299],
	            [-56.014605, -26.967487],
	            [-56.023823, -26.97842],
	            [-56.047847, -26.974603],
	            [-56.077882, -26.988765],
	            [-56.091408, -26.970291],
	            [-56.110719, -26.97302],
	            [-56.117997, -26.983299],
	            [-56.134475, -26.97214],
	            [-56.135904, -26.955828],
	            [-56.15574, -26.945589],
	            [-56.158599, -26.928759],
	            [-56.131313, -26.937844],
	            [-56.128586, -26.929809],
	            [-56.158691, -26.884933],
	            [-56.19664, -26.879261],
	            [-56.231859, -26.879568],
	            [-56.240098, -26.819857],
	            [-56.255431, -26.801237],
	            [-56.214879, -26.800656],
	            [-56.183421, -26.777775],
	            [-56.139415, -26.756819],
	            [-56.163762, -26.736312],
	            [-56.167062, -26.711752],
	            [-56.175596, -26.706033],
	            [-56.184779, -26.678919],
	            [-56.175564, -26.662529],
	            [-56.159533, -26.656305],
	            [-56.155789, -26.639919],
	            [-56.130645, -26.634806],
	            [-56.116496, -26.626097],
	            [-56.121747, -26.595897],
	            [-56.10615, -26.562982],
	            [-56.094861, -26.550894],
	            [-56.055874, -26.523506],
	            [-56.050702, -26.534125],
	            [-56.020374, -26.531216],
	            [-56.018722, -26.516326],
	            [-55.955553, -26.511295],
	            [-55.919502, -26.516751],
	            [-55.893158, -26.475005],
	            [-55.876135, -26.457655]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "SAN PEDRO DEL PARANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.299558, -26.103186],
	            [-55.311719, -26.108235],
	            [-55.311409, -26.139457],
	            [-55.296577, -26.148828],
	            [-55.303891, -26.162672],
	            [-55.28445, -26.201394],
	            [-55.263084, -26.217752],
	            [-55.259845, -26.235964],
	            [-55.230368, -26.244793],
	            [-55.212023, -26.239977],
	            [-55.120147, -26.322791],
	            [-55.102743, -26.324683],
	            [-55.075179, -26.363513],
	            [-55.059126, -26.363404],
	            [-55.036971, -26.374421],
	            [-55.03936, -26.389839],
	            [-55.024941, -26.393422],
	            [-55.032113, -26.411122],
	            [-55.009913, -26.424932],
	            [-54.995901, -26.420895],
	            [-54.976547, -26.441057],
	            [-54.963299, -26.435946],
	            [-54.953734, -26.463369],
	            [-54.939318, -26.477404],
	            [-54.926084, -26.474843],
	            [-54.911623, -26.489051],
	            [-54.911591, -26.503496],
	            [-54.871656, -26.524477],
	            [-54.850656, -26.511855],
	            [-54.824528, -26.525561],
	            [-54.83349, -26.545409],
	            [-54.80343, -26.544182],
	            [-54.807345, -26.56241],
	            [-54.787704, -26.582419],
	            [-54.783728, -26.610439],
	            [-54.788284, -26.633443],
	            [-54.812702, -26.669297],
	            [-54.833143, -26.673729],
	            [-54.84966, -26.659752],
	            [-54.876497, -26.656411],
	            [-54.913814, -26.6667],
	            [-54.943503, -26.684451],
	            [-54.948091, -26.701741],
	            [-54.98081, -26.697858],
	            [-54.990785, -26.681831],
	            [-55.028607, -26.660688],
	            [-55.025147, -26.640833],
	            [-55.037772, -26.633465],
	            [-55.047669, -26.611193],
	            [-55.029156, -26.596817],
	            [-55.046299, -26.588274],
	            [-55.060653, -26.598331],
	            [-55.087585, -26.56912],
	            [-55.095481, -26.558298],
	            [-55.096506, -26.529247],
	            [-55.083688, -26.514293],
	            [-55.091113, -26.500442],
	            [-55.129775, -26.498093],
	            [-55.145276, -26.458805],
	            [-55.143683, -26.446021],
	            [-55.173342, -26.443722],
	            [-55.185375, -26.426075],
	            [-55.202274, -26.413263],
	            [-55.223841, -26.412644],
	            [-55.24369, -26.397318],
	            [-55.268316, -26.398269],
	            [-55.290407, -26.365764],
	            [-55.354347, -26.377482],
	            [-55.365747, -26.364445],
	            [-55.384761, -26.360854],
	            [-55.44622, -26.359345],
	            [-55.452063, -26.324578],
	            [-55.391636, -26.310047],
	            [-55.375114, -26.297436],
	            [-55.360003, -26.269488],
	            [-55.357302, -26.230951],
	            [-55.367148, -26.210066],
	            [-55.354241, -26.201153],
	            [-55.343039, -26.148815],
	            [-55.347285, -26.11813],
	            [-55.334594, -26.104511],
	            [-55.317148, -26.097023],
	            [-55.299558, -26.103186]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "SAN RAFAEL DEL PARANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.674586, -27.092932],
	            [-55.620825, -27.142002],
	            [-55.626276, -27.153087],
	            [-55.653309, -27.162701],
	            [-55.672737, -27.17969],
	            [-55.69147, -27.188583],
	            [-55.716971, -27.216669],
	            [-55.840658, -27.105986],
	            [-55.798188, -27.070011],
	            [-55.787242, -27.079658],
	            [-55.771039, -27.071072],
	            [-55.756669, -27.083936],
	            [-55.748579, -27.073302],
	            [-55.730422, -27.07416],
	            [-55.719528, -27.109714],
	            [-55.698074, -27.106664],
	            [-55.697026, -27.09282],
	            [-55.674586, -27.092932]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "TRINIDAD"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.236842, -26.623143],
	            [-55.241679, -26.650337],
	            [-55.222948, -26.671699],
	            [-55.220572, -26.689343],
	            [-55.249169, -26.704834],
	            [-55.238647, -26.714602],
	            [-55.213617, -26.705202],
	            [-55.207571, -26.724731],
	            [-55.190799, -26.737008],
	            [-55.194361, -26.759874],
	            [-55.266341, -26.76222],
	            [-55.292466, -26.782392],
	            [-55.303063, -26.763026],
	            [-55.368666, -26.732542],
	            [-55.374505, -26.700117],
	            [-55.397101, -26.670155],
	            [-55.389591, -26.645207],
	            [-55.391003, -26.624962],
	            [-55.440037, -26.598874],
	            [-55.470177, -26.594498],
	            [-55.510665, -26.57203],
	            [-55.524872, -26.525501],
	            [-55.523546, -26.507094],
	            [-55.534913, -26.431117],
	            [-55.535174, -26.395029],
	            [-55.539685, -26.384378],
	            [-55.532806, -26.355603],
	            [-55.498236, -26.350111],
	            [-55.459668, -26.401016],
	            [-55.441731, -26.429231],
	            [-55.41121, -26.444534],
	            [-55.377156, -26.503207],
	            [-55.365181, -26.500303],
	            [-55.338245, -26.527998],
	            [-55.309417, -26.544679],
	            [-55.308426, -26.568187],
	            [-55.297693, -26.586974],
	            [-55.286243, -26.591179],
	            [-55.259408, -26.618475],
	            [-55.236842, -26.623143]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "EDELIRA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.452063, -26.324578],
	            [-55.44622, -26.359345],
	            [-55.384761, -26.360854],
	            [-55.365747, -26.364445],
	            [-55.354347, -26.377482],
	            [-55.290407, -26.365764],
	            [-55.268316, -26.398269],
	            [-55.24369, -26.397318],
	            [-55.223841, -26.412644],
	            [-55.202274, -26.413263],
	            [-55.185375, -26.426075],
	            [-55.173342, -26.443722],
	            [-55.143683, -26.446021],
	            [-55.145276, -26.458805],
	            [-55.129775, -26.498093],
	            [-55.091113, -26.500442],
	            [-55.083688, -26.514293],
	            [-55.096506, -26.529247],
	            [-55.095481, -26.558298],
	            [-55.087585, -26.56912],
	            [-55.124722, -26.584291],
	            [-55.156887, -26.576596],
	            [-55.178766, -26.581716],
	            [-55.20355, -26.580442],
	            [-55.21556, -26.594575],
	            [-55.209707, -26.603667],
	            [-55.236842, -26.623143],
	            [-55.259408, -26.618475],
	            [-55.286243, -26.591179],
	            [-55.297693, -26.586974],
	            [-55.308426, -26.568187],
	            [-55.309417, -26.544679],
	            [-55.338245, -26.527998],
	            [-55.365181, -26.500303],
	            [-55.377156, -26.503207],
	            [-55.41121, -26.444534],
	            [-55.441731, -26.429231],
	            [-55.459668, -26.401016],
	            [-55.498236, -26.350111],
	            [-55.513137, -26.313866],
	            [-55.507194, -26.307913],
	            [-55.482375, -26.310219],
	            [-55.452063, -26.324578]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "TOMÁS ROMERO PEREIRA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.63269, -26.392207],
	            [-55.655955, -26.488023],
	            [-55.641724, -26.521934],
	            [-55.612713, -26.570432],
	            [-55.643261, -26.587713],
	            [-55.588468, -26.680385],
	            [-55.751131, -26.766954],
	            [-55.761764, -26.773016],
	            [-55.854169, -26.822983],
	            [-55.886579, -26.742424],
	            [-55.883422, -26.715737],
	            [-55.874699, -26.691897],
	            [-55.835991, -26.644508],
	            [-55.842765, -26.615217],
	            [-55.833573, -26.60867],
	            [-55.783429, -26.530218],
	            [-55.805336, -26.488273],
	            [-55.814848, -26.481762],
	            [-55.861723, -26.471309],
	            [-55.876135, -26.457655],
	            [-55.86037, -26.44007],
	            [-55.851127, -26.439226],
	            [-55.835524, -26.435486],
	            [-55.818978, -26.414306],
	            [-55.823708, -26.40854],
	            [-55.803671, -26.387667],
	            [-55.766044, -26.39383],
	            [-55.736492, -26.379547],
	            [-55.717589, -26.36205],
	            [-55.684837, -26.361076],
	            [-55.651582, -26.372855],
	            [-55.63269, -26.392207]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "ALTO VERÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.948091, -26.701741],
	            [-54.943561, -26.737585],
	            [-54.949035, -26.770225],
	            [-54.959737, -26.785423],
	            [-54.974844, -26.79071],
	            [-55.010065, -26.788324],
	            [-54.999281, -26.770688],
	            [-55.018965, -26.741468],
	            [-55.037185, -26.742706],
	            [-55.05556, -26.71413],
	            [-55.096929, -26.701599],
	            [-55.109849, -26.671963],
	            [-55.110888, -26.627596],
	            [-55.118764, -26.615411],
	            [-55.138916, -26.614611],
	            [-55.157684, -26.599204],
	            [-55.18849, -26.604555],
	            [-55.209707, -26.603667],
	            [-55.21556, -26.594575],
	            [-55.20355, -26.580442],
	            [-55.178766, -26.581716],
	            [-55.156887, -26.576596],
	            [-55.124722, -26.584291],
	            [-55.087585, -26.56912],
	            [-55.060653, -26.598331],
	            [-55.046299, -26.588274],
	            [-55.029156, -26.596817],
	            [-55.047669, -26.611193],
	            [-55.037772, -26.633465],
	            [-55.025147, -26.640833],
	            [-55.028607, -26.660688],
	            [-54.990785, -26.681831],
	            [-54.98081, -26.697858],
	            [-54.948091, -26.701741]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "YATYTAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.911769, -27.344723],
	            [-55.959543, -27.348305],
	            [-55.985783, -27.342491],
	            [-56.024394, -27.3226],
	            [-56.046522, -27.306623],
	            [-56.046397, -27.291692],
	            [-56.032841, -27.275569],
	            [-56.019438, -27.225988],
	            [-56.020418, -27.21402],
	            [-56.011724, -27.228529],
	            [-55.985247, -27.255219],
	            [-55.965479, -27.260468],
	            [-55.930837, -27.293117],
	            [-55.916445, -27.291539],
	            [-55.901563, -27.300119],
	            [-55.918148, -27.312596],
	            [-55.911257, -27.323478],
	            [-55.911769, -27.344723]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "SAN JUAN DEL PARANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.480756, -26.7206],
	            [-55.389218, -26.802685],
	            [-55.406991, -26.818288],
	            [-55.390051, -26.83376],
	            [-55.37215, -26.817987],
	            [-55.34912, -26.838874],
	            [-55.367165, -26.854776],
	            [-55.271731, -26.940938],
	            [-55.304141, -26.962829],
	            [-55.375939, -26.965227],
	            [-55.41205, -26.9876],
	            [-55.426571, -26.968618],
	            [-55.447202, -26.962032],
	            [-55.46083, -26.950338],
	            [-55.476033, -26.950079],
	            [-55.48631, -26.973412],
	            [-55.509422, -26.983646],
	            [-55.751131, -26.766954],
	            [-55.588468, -26.680385],
	            [-55.548919, -26.659161],
	            [-55.480756, -26.7206]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "PIRAPÓ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.397101, -26.670155],
	            [-55.421573, -26.685239],
	            [-55.436634, -26.684575],
	            [-55.456461, -26.694808],
	            [-55.480756, -26.7206],
	            [-55.548919, -26.659161],
	            [-55.588468, -26.680385],
	            [-55.643261, -26.587713],
	            [-55.612713, -26.570432],
	            [-55.641724, -26.521934],
	            [-55.655955, -26.488023],
	            [-55.63269, -26.392207],
	            [-55.612579, -26.409338],
	            [-55.595002, -26.416836],
	            [-55.567476, -26.390021],
	            [-55.562965, -26.367225],
	            [-55.545852, -26.366186],
	            [-55.532806, -26.355603],
	            [-55.539685, -26.384378],
	            [-55.535174, -26.395029],
	            [-55.534913, -26.431117],
	            [-55.523546, -26.507094],
	            [-55.524872, -26.525501],
	            [-55.510665, -26.57203],
	            [-55.470177, -26.594498],
	            [-55.440037, -26.598874],
	            [-55.391003, -26.624962],
	            [-55.389591, -26.645207],
	            [-55.397101, -26.670155]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "ITAPÚA POTY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.253171, -26.565534],
	            [-57.239972, -26.571796],
	            [-57.206402, -26.562178],
	            [-57.179549, -26.53277],
	            [-57.108887, -26.506477],
	            [-57.119917, -26.515804],
	            [-57.109289, -26.561008],
	            [-57.085657, -26.595741],
	            [-57.085499, -26.657825],
	            [-57.071144, -26.681521],
	            [-57.06265, -26.705284],
	            [-57.001132, -26.710043],
	            [-57.00103, -26.710043],
	            [-57.044319, -26.752842],
	            [-57.046088, -26.760738],
	            [-57.103327, -26.799062],
	            [-57.115037, -26.796376],
	            [-57.137384, -26.805899],
	            [-57.174929, -26.79487],
	            [-57.198147, -26.81036],
	            [-57.23405, -26.814955],
	            [-57.254502, -26.808112],
	            [-57.270803, -26.781871],
	            [-57.301011, -26.819067],
	            [-57.3698, -26.90901],
	            [-57.417305, -27.026781],
	            [-57.430828, -27.057374],
	            [-57.583257, -26.863025],
	            [-57.640095, -26.790442],
	            [-57.698569, -26.569792],
	            [-57.743139, -26.40059],
	            [-57.726689, -26.398418],
	            [-57.70356, -26.408527],
	            [-57.708285, -26.424237],
	            [-57.663253, -26.434848],
	            [-57.663342, -26.450357],
	            [-57.674871, -26.468331],
	            [-57.663286, -26.478529],
	            [-57.64847, -26.477898],
	            [-57.643633, -26.490328],
	            [-57.620066, -26.491327],
	            [-57.608775, -26.517449],
	            [-57.597049, -26.532505],
	            [-57.575897, -26.533626],
	            [-57.563883, -26.52272],
	            [-57.54889, -26.535046],
	            [-57.522753, -26.540063],
	            [-57.508414, -26.561937],
	            [-57.495321, -26.567041],
	            [-57.471167, -26.560132],
	            [-57.429089, -26.596997],
	            [-57.399603, -26.610901],
	            [-57.383313, -26.606075],
	            [-57.34456, -26.604942],
	            [-57.332568, -26.609884],
	            [-57.321049, -26.600007],
	            [-57.273051, -26.585403],
	            [-57.267099, -26.570156],
	            [-57.253171, -26.565534]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SAN JUAN BAUTISTA DE LAS MISIONES"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.698123, -27.268968],
	            [-56.670036, -27.292481],
	            [-56.675038, -27.322605],
	            [-56.669655, -27.337722],
	            [-56.684276, -27.34657],
	            [-56.695045, -27.369136],
	            [-56.772511, -27.388335],
	            [-56.791617, -27.399867],
	            [-56.831488, -27.399382],
	            [-56.84859, -27.410185],
	            [-56.884837, -27.412556],
	            [-56.907013, -27.408389],
	            [-56.93884, -27.414947],
	            [-56.959538, -27.433414],
	            [-57.045857, -27.481722],
	            [-57.094835, -27.485129],
	            [-57.120738, -27.481407],
	            [-57.129941, -27.486017],
	            [-57.19082, -27.468809],
	            [-57.23335, -27.466991],
	            [-57.279121, -27.436469],
	            [-57.318363, -27.416538],
	            [-57.341979, -27.416305],
	            [-57.325792, -27.386776],
	            [-57.322882, -27.391666],
	            [-57.269739, -27.388674],
	            [-57.248755, -27.394798],
	            [-57.220907, -27.391879],
	            [-57.209148, -27.380097],
	            [-57.183373, -27.377949],
	            [-57.171999, -27.386075],
	            [-57.155657, -27.382975],
	            [-57.141065, -27.357721],
	            [-57.13079, -27.360069],
	            [-57.09817, -27.347723],
	            [-57.084909, -27.328185],
	            [-57.082797, -27.305986],
	            [-57.04767, -27.302103],
	            [-57.02548, -27.2929],
	            [-57.010638, -27.279021],
	            [-56.961817, -27.281404],
	            [-56.94506, -27.278699],
	            [-56.770737, -27.267489],
	            [-56.698123, -27.268968]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "AYOLAS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.915739, -26.842047],
	            [-56.907285, -26.859815],
	            [-56.91612, -26.868335],
	            [-56.929241, -26.907856],
	            [-56.937301, -26.919078],
	            [-56.916252, -26.93405],
	            [-56.925052, -26.954311],
	            [-56.951003, -26.98019],
	            [-56.988277, -27.002096],
	            [-56.976966, -27.025894],
	            [-56.977706, -27.048127],
	            [-56.956887, -27.072653],
	            [-56.950347, -27.112453],
	            [-56.951933, -27.128095],
	            [-56.966137, -27.174257],
	            [-57.038354, -27.159996],
	            [-57.080401, -27.135588],
	            [-57.123977, -27.114086],
	            [-57.132438, -27.124497],
	            [-57.184311, -27.113239],
	            [-57.182094, -27.108967],
	            [-57.428681, -27.060106],
	            [-57.430828, -27.057374],
	            [-57.417305, -27.026781],
	            [-57.3698, -26.90901],
	            [-57.301011, -26.819067],
	            [-57.270803, -26.781871],
	            [-57.254502, -26.808112],
	            [-57.23405, -26.814955],
	            [-57.198147, -26.81036],
	            [-57.174929, -26.79487],
	            [-57.137384, -26.805899],
	            [-57.115037, -26.796376],
	            [-57.103327, -26.799062],
	            [-57.046088, -26.760738],
	            [-57.044319, -26.752842],
	            [-57.00103, -26.710043],
	            [-56.981112, -26.739169],
	            [-56.997471, -26.782008],
	            [-56.999456, -26.796565],
	            [-56.988802, -26.818894],
	            [-56.96545, -26.834672],
	            [-56.923437, -26.848557],
	            [-56.915739, -26.842047]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SAN IGNACIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.848325, -26.541554],
	            [-56.820651, -26.543998],
	            [-56.813814, -26.566978],
	            [-56.821245, -26.587204],
	            [-56.814409, -26.60365],
	            [-56.814684, -26.624521],
	            [-56.802169, -26.639317],
	            [-56.806634, -26.648311],
	            [-56.828606, -26.659106],
	            [-56.8745, -26.669551],
	            [-56.903176, -26.662829],
	            [-56.935948, -26.663814],
	            [-56.987229, -26.679265],
	            [-56.98581, -26.688332],
	            [-57.001132, -26.710043],
	            [-57.06265, -26.705284],
	            [-57.071144, -26.681521],
	            [-57.085499, -26.657825],
	            [-57.085657, -26.595741],
	            [-57.109289, -26.561008],
	            [-57.119917, -26.515804],
	            [-57.108887, -26.506477],
	            [-57.05272, -26.502247],
	            [-57.036568, -26.50538],
	            [-57.031723, -26.488099],
	            [-57.007866, -26.473412],
	            [-57.008027, -26.458965],
	            [-56.996131, -26.419516],
	            [-56.971571, -26.448548],
	            [-56.955298, -26.449317],
	            [-56.961298, -26.472731],
	            [-56.949111, -26.485057],
	            [-56.925715, -26.464992],
	            [-56.912381, -26.460795],
	            [-56.896304, -26.49316],
	            [-56.880812, -26.504596],
	            [-56.879578, -26.523098],
	            [-56.848325, -26.541554]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SAN MIGUEL"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.77354, -26.959648],
	            [-56.785177, -26.973204],
	            [-56.797739, -27.00332],
	            [-56.794876, -27.027832],
	            [-56.813207, -27.017073],
	            [-56.827188, -27.016965],
	            [-56.843212, -27.036697],
	            [-56.8658, -27.049505],
	            [-56.89204, -27.051509],
	            [-56.89357, -27.040252],
	            [-56.857346, -27.003365],
	            [-56.849598, -26.985959],
	            [-56.834381, -26.969537],
	            [-56.842966, -26.954796],
	            [-56.833634, -26.942062],
	            [-56.799328, -26.946428],
	            [-56.77354, -26.959648]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SAN PATRICIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.766468, -26.635655],
	            [-56.785131, -26.715388],
	            [-56.807278, -26.748294],
	            [-56.826358, -26.790989],
	            [-56.837751, -26.826278],
	            [-56.856707, -26.834379],
	            [-56.889099, -26.841275],
	            [-56.915739, -26.842047],
	            [-56.923437, -26.848557],
	            [-56.96545, -26.834672],
	            [-56.988802, -26.818894],
	            [-56.999456, -26.796565],
	            [-56.997471, -26.782008],
	            [-56.981112, -26.739169],
	            [-57.00103, -26.710043],
	            [-57.001132, -26.710043],
	            [-56.98581, -26.688332],
	            [-56.987229, -26.679265],
	            [-56.935948, -26.663814],
	            [-56.903176, -26.662829],
	            [-56.8745, -26.669551],
	            [-56.828606, -26.659106],
	            [-56.806634, -26.648311],
	            [-56.802169, -26.639317],
	            [-56.814684, -26.624521],
	            [-56.814409, -26.60365],
	            [-56.79784, -26.62048],
	            [-56.777467, -26.619114],
	            [-56.766468, -26.635655]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SANTA MARÍA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.635073, -26.681476],
	            [-56.652459, -26.687253],
	            [-56.649056, -26.706291],
	            [-56.658796, -26.726241],
	            [-56.647044, -26.924488],
	            [-56.678038, -26.944037],
	            [-56.708264, -26.958891],
	            [-56.747757, -26.967116],
	            [-56.77354, -26.959648],
	            [-56.799328, -26.946428],
	            [-56.833634, -26.942062],
	            [-56.842966, -26.954796],
	            [-56.834381, -26.969537],
	            [-56.849598, -26.985959],
	            [-56.857346, -27.003365],
	            [-56.89357, -27.040252],
	            [-56.89204, -27.051509],
	            [-56.90564, -27.089285],
	            [-56.90176, -27.108333],
	            [-56.914846, -27.128597],
	            [-56.92135, -27.161152],
	            [-56.914376, -27.172497],
	            [-56.966137, -27.174257],
	            [-56.951933, -27.128095],
	            [-56.950347, -27.112453],
	            [-56.956887, -27.072653],
	            [-56.977706, -27.048127],
	            [-56.976966, -27.025894],
	            [-56.988277, -27.002096],
	            [-56.951003, -26.98019],
	            [-56.925052, -26.954311],
	            [-56.916252, -26.93405],
	            [-56.937301, -26.919078],
	            [-56.929241, -26.907856],
	            [-56.91612, -26.868335],
	            [-56.907285, -26.859815],
	            [-56.915739, -26.842047],
	            [-56.889099, -26.841275],
	            [-56.856707, -26.834379],
	            [-56.837751, -26.826278],
	            [-56.826358, -26.790989],
	            [-56.807278, -26.748294],
	            [-56.785131, -26.715388],
	            [-56.766468, -26.635655],
	            [-56.753325, -26.635502],
	            [-56.74061, -26.622067],
	            [-56.716518, -26.648052],
	            [-56.703661, -26.653583],
	            [-56.666235, -26.657003],
	            [-56.63568, -26.668611],
	            [-56.635073, -26.681476]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SANTA ROSA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.64703, -26.926496],
	            [-56.64405, -26.978312],
	            [-56.629229, -26.997258],
	            [-56.625861, -27.016422],
	            [-56.640758, -27.035484],
	            [-56.634802, -27.138759],
	            [-56.63892, -27.159107],
	            [-56.654828, -27.172053],
	            [-56.669645, -27.196623],
	            [-56.688419, -27.201018],
	            [-56.709545, -27.23603],
	            [-56.696968, -27.243528],
	            [-56.698123, -27.268968],
	            [-56.770737, -27.267489],
	            [-56.94506, -27.278699],
	            [-56.961817, -27.281404],
	            [-56.976095, -27.249009],
	            [-56.984003, -27.246798],
	            [-56.974368, -27.221211],
	            [-56.974247, -27.184515],
	            [-56.966137, -27.174257],
	            [-56.914376, -27.172497],
	            [-56.92135, -27.161152],
	            [-56.914846, -27.128597],
	            [-56.90176, -27.108333],
	            [-56.90564, -27.089285],
	            [-56.89204, -27.051509],
	            [-56.8658, -27.049505],
	            [-56.843212, -27.036697],
	            [-56.827188, -27.016965],
	            [-56.813207, -27.017073],
	            [-56.794876, -27.027832],
	            [-56.797739, -27.00332],
	            [-56.785177, -26.973204],
	            [-56.77354, -26.959648],
	            [-56.747757, -26.967116],
	            [-56.708264, -26.958891],
	            [-56.678038, -26.944037],
	            [-56.647044, -26.924488],
	            [-56.64703, -26.926496]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "SANTIAGO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.007329, -26.412427],
	            [-56.996131, -26.419516],
	            [-57.008027, -26.458965],
	            [-57.007866, -26.473412],
	            [-57.031723, -26.488099],
	            [-57.036568, -26.50538],
	            [-57.05272, -26.502247],
	            [-57.108887, -26.506477],
	            [-57.179549, -26.53277],
	            [-57.206402, -26.562178],
	            [-57.239972, -26.571796],
	            [-57.253171, -26.565534],
	            [-57.254154, -26.545458],
	            [-57.239178, -26.519711],
	            [-57.251243, -26.498464],
	            [-57.205569, -26.467771],
	            [-57.185131, -26.463185],
	            [-57.187956, -26.450884],
	            [-57.170586, -26.412256],
	            [-57.125973, -26.402645],
	            [-57.121616, -26.381965],
	            [-57.105213, -26.38535],
	            [-57.087854, -26.376148],
	            [-57.071329, -26.379031],
	            [-57.0582, -26.402009],
	            [-57.043084, -26.411985],
	            [-57.014772, -26.41757],
	            [-57.007329, -26.412427]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "VILLA FLORIDA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.966137, -27.174257],
	            [-56.974247, -27.184515],
	            [-56.974368, -27.221211],
	            [-56.984003, -27.246798],
	            [-56.976095, -27.249009],
	            [-56.961817, -27.281404],
	            [-57.010638, -27.279021],
	            [-57.02548, -27.2929],
	            [-57.04767, -27.302103],
	            [-57.082797, -27.305986],
	            [-57.084909, -27.328185],
	            [-57.09817, -27.347723],
	            [-57.13079, -27.360069],
	            [-57.141065, -27.357721],
	            [-57.155657, -27.382975],
	            [-57.171999, -27.386075],
	            [-57.183373, -27.377949],
	            [-57.209148, -27.380097],
	            [-57.220907, -27.391879],
	            [-57.248755, -27.394798],
	            [-57.269739, -27.388674],
	            [-57.322882, -27.391666],
	            [-57.325792, -27.386776],
	            [-57.249706, -27.239019],
	            [-57.218765, -27.179547],
	            [-57.184311, -27.113239],
	            [-57.132438, -27.124497],
	            [-57.123977, -27.114086],
	            [-57.080401, -27.135588],
	            [-57.038354, -27.159996],
	            [-56.966137, -27.174257]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "MISIONES",
	        "dist_desc_": "YABEBYRY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.129893, -25.527532],
	            [-57.110919, -25.546847],
	            [-57.081853, -25.583342],
	            [-57.09494, -25.634496],
	            [-57.075901, -25.651628],
	            [-57.074173, -25.666105],
	            [-57.089019, -25.688081],
	            [-57.10519, -25.702469],
	            [-57.084505, -25.710803],
	            [-57.066, -25.725144],
	            [-57.044672, -25.753064],
	            [-57.021806, -25.758041],
	            [-57.01619, -25.776377],
	            [-57.0216, -25.786084],
	            [-57.040514, -25.788568],
	            [-57.059484, -25.810382],
	            [-57.076929, -25.818406],
	            [-57.093813, -25.804901],
	            [-57.120826, -25.799689],
	            [-57.138691, -25.791172],
	            [-57.162024, -25.772838],
	            [-57.193824, -25.776181],
	            [-57.215849, -25.762248],
	            [-57.218764, -25.745669],
	            [-57.233407, -25.737592],
	            [-57.233034, -25.72076],
	            [-57.240332, -25.695441],
	            [-57.260596, -25.693704],
	            [-57.270265, -25.677206],
	            [-57.231571, -25.65686],
	            [-57.19611, -25.660366],
	            [-57.184478, -25.635322],
	            [-57.18091, -25.605066],
	            [-57.183951, -25.591445],
	            [-57.207339, -25.572725],
	            [-57.218054, -25.551105],
	            [-57.195895, -25.544042],
	            [-57.187494, -25.531031],
	            [-57.129893, -25.527532]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "PARAGUARÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.076929, -25.818406],
	            [-57.069424, -25.834791],
	            [-57.051392, -25.837033],
	            [-57.034709, -25.849697],
	            [-57.016504, -25.85241],
	            [-56.997716, -25.846587],
	            [-56.981811, -25.852239],
	            [-56.96425, -25.842729],
	            [-56.946981, -25.857241],
	            [-56.954027, -25.868762],
	            [-56.915865, -25.880949],
	            [-56.916657, -25.906893],
	            [-56.928457, -25.917207],
	            [-56.994893, -25.922954],
	            [-57.016665, -25.932999],
	            [-57.025321, -25.946578],
	            [-57.060978, -25.954392],
	            [-57.091207, -25.956106],
	            [-57.107902, -25.971864],
	            [-57.124195, -25.977807],
	            [-57.140931, -25.96087],
	            [-57.179782, -25.956421],
	            [-57.183876, -25.948022],
	            [-57.163354, -25.903501],
	            [-57.189861, -25.898598],
	            [-57.202088, -25.889312],
	            [-57.204233, -25.870039],
	            [-57.196668, -25.854078],
	            [-57.174525, -25.848004],
	            [-57.149504, -25.831606],
	            [-57.138691, -25.791172],
	            [-57.120826, -25.799689],
	            [-57.093813, -25.804901],
	            [-57.076929, -25.818406]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "ACAHAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.141422, -26.091318],
	            [-57.13015, -26.114418],
	            [-57.1072, -26.122442],
	            [-57.119791, -26.126999],
	            [-57.135449, -26.145191],
	            [-57.146668, -26.168205],
	            [-57.144634, -26.182424],
	            [-57.114218, -26.20182],
	            [-57.121889, -26.219349],
	            [-57.11114, -26.243481],
	            [-57.09777, -26.245499],
	            [-57.09927, -26.261562],
	            [-57.125248, -26.301777],
	            [-57.113696, -26.308893],
	            [-57.09993, -26.341725],
	            [-57.078647, -26.370958],
	            [-57.087854, -26.376148],
	            [-57.105213, -26.38535],
	            [-57.121616, -26.381965],
	            [-57.125973, -26.402645],
	            [-57.170586, -26.412256],
	            [-57.187956, -26.450884],
	            [-57.185131, -26.463185],
	            [-57.205569, -26.467771],
	            [-57.251243, -26.498464],
	            [-57.239178, -26.519711],
	            [-57.254154, -26.545458],
	            [-57.253171, -26.565534],
	            [-57.267099, -26.570156],
	            [-57.273051, -26.585403],
	            [-57.321049, -26.600007],
	            [-57.332568, -26.609884],
	            [-57.34456, -26.604942],
	            [-57.383313, -26.606075],
	            [-57.399603, -26.610901],
	            [-57.429089, -26.596997],
	            [-57.471167, -26.560132],
	            [-57.495321, -26.567041],
	            [-57.508414, -26.561937],
	            [-57.522753, -26.540063],
	            [-57.54889, -26.535046],
	            [-57.563883, -26.52272],
	            [-57.575897, -26.533626],
	            [-57.597049, -26.532505],
	            [-57.608775, -26.517449],
	            [-57.620066, -26.491327],
	            [-57.643633, -26.490328],
	            [-57.64847, -26.477898],
	            [-57.663286, -26.478529],
	            [-57.674871, -26.468331],
	            [-57.663342, -26.450357],
	            [-57.663253, -26.434848],
	            [-57.708285, -26.424237],
	            [-57.70356, -26.408527],
	            [-57.726689, -26.398418],
	            [-57.743139, -26.40059],
	            [-57.748991, -26.381935],
	            [-57.735852, -26.375533],
	            [-57.73429, -26.357441],
	            [-57.718938, -26.356921],
	            [-57.715073, -26.375906],
	            [-57.69897, -26.372309],
	            [-57.680778, -26.352158],
	            [-57.691623, -26.343221],
	            [-57.679545, -26.314145],
	            [-57.656972, -26.292759],
	            [-57.641842, -26.264731],
	            [-57.62032, -26.251566],
	            [-57.619689, -26.238104],
	            [-57.610527, -26.219735],
	            [-57.596607, -26.215748],
	            [-57.579656, -26.185393],
	            [-57.55174, -26.177528],
	            [-57.531195, -26.179282],
	            [-57.520244, -26.168071],
	            [-57.482368, -26.156885],
	            [-57.472422, -26.138434],
	            [-57.480641, -26.113197],
	            [-57.468136, -26.11337],
	            [-57.376347, -26.128672],
	            [-57.34658, -26.077368],
	            [-57.318823, -26.074087],
	            [-57.303202, -26.086798],
	            [-57.198335, -26.087919],
	            [-57.178413, -26.077471],
	            [-57.141422, -26.091318]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "CAAPUCÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.758342, -25.64924],
	            [-56.806296, -25.676791],
	            [-56.825166, -25.695796],
	            [-56.837513, -25.718296],
	            [-56.846262, -25.751134],
	            [-56.843558, -25.777802],
	            [-56.856758, -25.803985],
	            [-56.872746, -25.805495],
	            [-56.867457, -25.843885],
	            [-56.874464, -25.851725],
	            [-56.886939, -25.888759],
	            [-56.915865, -25.880949],
	            [-56.954027, -25.868762],
	            [-56.946981, -25.857241],
	            [-56.96425, -25.842729],
	            [-56.981811, -25.852239],
	            [-56.997716, -25.846587],
	            [-56.966778, -25.824022],
	            [-56.96717, -25.801207],
	            [-56.948216, -25.781972],
	            [-56.960198, -25.758619],
	            [-56.93234, -25.743502],
	            [-56.911644, -25.702837],
	            [-56.894242, -25.68658],
	            [-56.892445, -25.668163],
	            [-56.862565, -25.662256],
	            [-56.857589, -25.646702],
	            [-56.83725, -25.6493],
	            [-56.823447, -25.64317],
	            [-56.810808, -25.625527],
	            [-56.780875, -25.631974],
	            [-56.758342, -25.64924]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "GENERAL BERNARDINO CABALLERO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.397124, -25.6283],
	            [-57.388147, -25.639093],
	            [-57.363956, -25.660089],
	            [-57.342892, -25.668696],
	            [-57.279977, -25.66735],
	            [-57.270265, -25.677206],
	            [-57.260596, -25.693704],
	            [-57.240332, -25.695441],
	            [-57.233034, -25.72076],
	            [-57.233407, -25.737592],
	            [-57.218764, -25.745669],
	            [-57.215849, -25.762248],
	            [-57.193824, -25.776181],
	            [-57.162024, -25.772838],
	            [-57.138691, -25.791172],
	            [-57.149504, -25.831606],
	            [-57.174525, -25.848004],
	            [-57.196668, -25.854078],
	            [-57.205605, -25.851183],
	            [-57.210641, -25.83128],
	            [-57.229301, -25.811994],
	            [-57.268552, -25.807045],
	            [-57.292557, -25.8155],
	            [-57.325859, -25.812187],
	            [-57.335029, -25.825481],
	            [-57.356545, -25.828293],
	            [-57.374926, -25.847324],
	            [-57.400869, -25.857792],
	            [-57.415749, -25.879598],
	            [-57.423004, -25.854065],
	            [-57.442906, -25.844625],
	            [-57.456491, -25.817523],
	            [-57.453799, -25.808391],
	            [-57.468209, -25.756149],
	            [-57.449227, -25.723163],
	            [-57.432726, -25.70154],
	            [-57.41937, -25.693386],
	            [-57.416483, -25.674113],
	            [-57.421513, -25.647052],
	            [-57.406309, -25.62839],
	            [-57.397124, -25.6283]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "CARAPEGUÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.914166, -25.590966],
	            [-56.945204, -25.593401],
	            [-56.968339, -25.572428],
	            [-56.990237, -25.574532],
	            [-56.988011, -25.596563],
	            [-56.997303, -25.606736],
	            [-57.007451, -25.669248],
	            [-56.981869, -25.69432],
	            [-56.966026, -25.730456],
	            [-56.980505, -25.745159],
	            [-56.976067, -25.776586],
	            [-57.003931, -25.785196],
	            [-57.01619, -25.776377],
	            [-57.021806, -25.758041],
	            [-57.044672, -25.753064],
	            [-57.066, -25.725144],
	            [-57.084505, -25.710803],
	            [-57.10519, -25.702469],
	            [-57.089019, -25.688081],
	            [-57.074173, -25.666105],
	            [-57.075901, -25.651628],
	            [-57.09494, -25.634496],
	            [-57.081853, -25.583342],
	            [-57.063751, -25.578507],
	            [-57.034121, -25.59176],
	            [-57.020082, -25.590981],
	            [-56.99186, -25.571449],
	            [-56.970803, -25.570088],
	            [-56.94635, -25.561904],
	            [-56.934632, -25.569024],
	            [-56.917328, -25.564044],
	            [-56.914166, -25.590966]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "ESCOBAR"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.733152, -25.914199],
	            [-56.73626, -25.936525],
	            [-56.747988, -25.941148],
	            [-56.769908, -25.922992],
	            [-56.785187, -25.919941],
	            [-56.802381, -25.948107],
	            [-56.836422, -25.944931],
	            [-56.852308, -25.929416],
	            [-56.896488, -25.914835],
	            [-56.901329, -25.904169],
	            [-56.893082, -25.889973],
	            [-56.864713, -25.858593],
	            [-56.84508, -25.864673],
	            [-56.814975, -25.856199],
	            [-56.807362, -25.863779],
	            [-56.778077, -25.859827],
	            [-56.776441, -25.869925],
	            [-56.78765, -25.898812],
	            [-56.733152, -25.914199]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "LA COLMENA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.629165, -26.194631],
	            [-56.638871, -26.221206],
	            [-56.673942, -26.227274],
	            [-56.684218, -26.253538],
	            [-56.694399, -26.260439],
	            [-56.693793, -26.287431],
	            [-56.699077, -26.300785],
	            [-56.725113, -26.312683],
	            [-56.72243, -26.326858],
	            [-56.736365, -26.334299],
	            [-56.738884, -26.365066],
	            [-56.755367, -26.366029],
	            [-56.763958, -26.391534],
	            [-56.759429, -26.415425],
	            [-56.850044, -26.385063],
	            [-56.828217, -26.359747],
	            [-56.845559, -26.350692],
	            [-56.832621, -26.333287],
	            [-56.889395, -26.297552],
	            [-56.883574, -26.283242],
	            [-56.857444, -26.262329],
	            [-56.861324, -26.252197],
	            [-56.8813, -26.241163],
	            [-56.889477, -26.219833],
	            [-56.865578, -26.194444],
	            [-56.848649, -26.164945],
	            [-56.850764, -26.149299],
	            [-56.839019, -26.140099],
	            [-56.830912, -26.121822],
	            [-56.793483, -26.117859],
	            [-56.791741, -26.096461],
	            [-56.805014, -26.082348],
	            [-56.80236, -26.064624],
	            [-56.753314, -26.037152],
	            [-56.748161, -26.028082],
	            [-56.73702, -25.972646],
	            [-56.726172, -25.979917],
	            [-56.720967, -25.998364],
	            [-56.705464, -26.0275],
	            [-56.701791, -26.04464],
	            [-56.721934, -26.091607],
	            [-56.70579, -26.108989],
	            [-56.711758, -26.130117],
	            [-56.703753, -26.147234],
	            [-56.673423, -26.166968],
	            [-56.632747, -26.187327],
	            [-56.629165, -26.194631]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "MBUYAPEY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.131784, -25.455691],
	            [-57.137315, -25.480454],
	            [-57.126355, -25.522925],
	            [-57.129893, -25.527532],
	            [-57.187494, -25.531031],
	            [-57.195895, -25.544042],
	            [-57.218054, -25.551105],
	            [-57.230752, -25.52678],
	            [-57.253918, -25.50929],
	            [-57.317095, -25.497762],
	            [-57.312246, -25.461011],
	            [-57.299755, -25.448728],
	            [-57.247476, -25.433456],
	            [-57.22301, -25.418625],
	            [-57.21791, -25.40268],
	            [-57.195022, -25.401783],
	            [-57.170696, -25.429062],
	            [-57.131784, -25.455691]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "PIRAYÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.183876, -25.948022],
	            [-57.179782, -25.956421],
	            [-57.140931, -25.96087],
	            [-57.124195, -25.977807],
	            [-57.107902, -25.971864],
	            [-57.105521, -25.984526],
	            [-57.115086, -26.020566],
	            [-57.131693, -26.03062],
	            [-57.137597, -26.056634],
	            [-57.134345, -26.079505],
	            [-57.141422, -26.091318],
	            [-57.178413, -26.077471],
	            [-57.198335, -26.087919],
	            [-57.303202, -26.086798],
	            [-57.318823, -26.074087],
	            [-57.34658, -26.077368],
	            [-57.376347, -26.128672],
	            [-57.468136, -26.11337],
	            [-57.488729, -26.059954],
	            [-57.484906, -26.044499],
	            [-57.499619, -26.025117],
	            [-57.47605, -25.972293],
	            [-57.446799, -25.932162],
	            [-57.411902, -25.934175],
	            [-57.350218, -25.910268],
	            [-57.322523, -25.918861],
	            [-57.297104, -25.918514],
	            [-57.285074, -25.909377],
	            [-57.256051, -25.911124],
	            [-57.229873, -25.918098],
	            [-57.201297, -25.943027],
	            [-57.183876, -25.948022]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "QUIINDY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.743139, -26.40059],
	            [-57.698569, -26.569792],
	            [-57.640095, -26.790442],
	            [-57.583257, -26.863025],
	            [-57.642945, -26.852718],
	            [-57.772965, -26.777087],
	            [-57.791167, -26.755376],
	            [-57.80168, -26.756302],
	            [-57.874527, -26.746049],
	            [-57.895729, -26.734369],
	            [-57.924041, -26.694559],
	            [-57.944944, -26.679666],
	            [-57.967153, -26.683705],
	            [-58.001771, -26.678356],
	            [-58.027746, -26.686566],
	            [-58.036947, -26.678006],
	            [-58.054084, -26.681939],
	            [-58.065802, -26.670263],
	            [-58.086105, -26.665007],
	            [-58.105284, -26.647976],
	            [-58.12674, -26.639743],
	            [-58.152875, -26.638664],
	            [-58.171297, -26.603134],
	            [-58.141404, -26.569416],
	            [-58.139947, -26.546902],
	            [-58.101115, -26.538301],
	            [-58.086842, -26.544084],
	            [-58.078104, -26.534313],
	            [-58.042393, -26.519962],
	            [-58.027158, -26.522774],
	            [-58.00756, -26.504935],
	            [-57.980008, -26.492309],
	            [-57.983291, -26.481604],
	            [-57.970199, -26.465352],
	            [-57.941485, -26.455003],
	            [-57.918352, -26.460019],
	            [-57.90076, -26.431209],
	            [-57.882948, -26.444474],
	            [-57.851427, -26.438629],
	            [-57.837587, -26.427808],
	            [-57.823676, -26.434737],
	            [-57.805826, -26.429613],
	            [-57.795474, -26.403372],
	            [-57.782039, -26.388298],
	            [-57.748991, -26.381935],
	            [-57.743139, -26.40059]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "SAN JUAN BAUTISTA DE ÑEEMBUCÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.583257, -26.863025],
	            [-57.430828, -27.057374],
	            [-57.428681, -27.060106],
	            [-57.182094, -27.108967],
	            [-57.184311, -27.113239],
	            [-57.218765, -27.179547],
	            [-57.327969, -27.148349],
	            [-57.501853, -27.163521],
	            [-57.610891, -27.099167],
	            [-57.65347, -27.065323],
	            [-57.727807, -27.023058],
	            [-57.788765, -27.002259],
	            [-57.788084, -26.953086],
	            [-57.798971, -26.933696],
	            [-57.810651, -26.925748],
	            [-57.853944, -26.939897],
	            [-57.879003, -26.943882],
	            [-57.899584, -26.922532],
	            [-57.932042, -26.878314],
	            [-57.944176, -26.857302],
	            [-57.971279, -26.8441],
	            [-57.986543, -26.841643],
	            [-58.009935, -26.823327],
	            [-58.037758, -26.827581],
	            [-58.1133, -26.758395],
	            [-58.197844, -26.757494],
	            [-58.205547, -26.751615],
	            [-58.246119, -26.742258],
	            [-58.25522, -26.721844],
	            [-58.257059, -26.668477],
	            [-58.260589, -26.648852],
	            [-58.246196, -26.64179],
	            [-58.218686, -26.65414],
	            [-58.199153, -26.652758],
	            [-58.191373, -26.638361],
	            [-58.209049, -26.615337],
	            [-58.196172, -26.604783],
	            [-58.179792, -26.59648],
	            [-58.171297, -26.603134],
	            [-58.152875, -26.638664],
	            [-58.12674, -26.639743],
	            [-58.105284, -26.647976],
	            [-58.086105, -26.665007],
	            [-58.065802, -26.670263],
	            [-58.054084, -26.681939],
	            [-58.036947, -26.678006],
	            [-58.027746, -26.686566],
	            [-58.001771, -26.678356],
	            [-57.967153, -26.683705],
	            [-57.944944, -26.679666],
	            [-57.924041, -26.694559],
	            [-57.895729, -26.734369],
	            [-57.874527, -26.746049],
	            [-57.80168, -26.756302],
	            [-57.791167, -26.755376],
	            [-57.772965, -26.777087],
	            [-57.642945, -26.852718],
	            [-57.583257, -26.863025]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "TACUARAS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.619689, -26.238104],
	            [-57.62032, -26.251566],
	            [-57.641842, -26.264731],
	            [-57.656972, -26.292759],
	            [-57.679545, -26.314145],
	            [-57.691623, -26.343221],
	            [-57.680778, -26.352158],
	            [-57.69897, -26.372309],
	            [-57.715073, -26.375906],
	            [-57.718938, -26.356921],
	            [-57.73429, -26.357441],
	            [-57.735852, -26.375533],
	            [-57.748991, -26.381935],
	            [-57.782039, -26.388298],
	            [-57.795474, -26.403372],
	            [-57.805826, -26.429613],
	            [-57.823676, -26.434737],
	            [-57.837587, -26.427808],
	            [-57.851427, -26.438629],
	            [-57.882948, -26.444474],
	            [-57.90076, -26.431209],
	            [-57.918352, -26.460019],
	            [-57.941485, -26.455003],
	            [-57.970199, -26.465352],
	            [-57.983291, -26.481604],
	            [-57.980008, -26.492309],
	            [-58.00756, -26.504935],
	            [-58.027158, -26.522774],
	            [-58.042393, -26.519962],
	            [-58.078104, -26.534313],
	            [-58.086842, -26.544084],
	            [-58.101115, -26.538301],
	            [-58.139947, -26.546902],
	            [-58.141404, -26.569416],
	            [-58.171297, -26.603134],
	            [-58.179792, -26.59648],
	            [-58.196172, -26.604783],
	            [-58.192605, -26.593666],
	            [-58.202462, -26.557246],
	            [-58.223275, -26.539977],
	            [-58.224353, -26.527885],
	            [-58.207388, -26.50048],
	            [-58.230673, -26.474239],
	            [-58.222678, -26.463623],
	            [-58.18808, -26.463087],
	            [-58.183645, -26.44788],
	            [-58.20169, -26.435591],
	            [-58.221707, -26.40351],
	            [-58.216943, -26.385204],
	            [-58.206797, -26.375458],
	            [-58.166247, -26.355512],
	            [-58.159432, -26.345091],
	            [-58.154122, -26.317443],
	            [-58.165778, -26.29396],
	            [-58.167062, -26.276697],
	            [-58.158582, -26.26043],
	            [-58.134744, -26.252225],
	            [-58.106877, -26.236195],
	            [-58.105381, -26.222758],
	            [-58.088464, -26.223222],
	            [-58.072516, -26.238411],
	            [-58.025469, -26.25041],
	            [-58.018789, -26.219326],
	            [-58.027544, -26.202069],
	            [-58.000321, -26.176082],
	            [-57.974689, -26.188289],
	            [-57.958352, -26.164111],
	            [-57.940837, -26.176876],
	            [-57.917792, -26.164244],
	            [-57.898341, -26.144625],
	            [-57.814365, -26.18036],
	            [-57.813382, -26.190176],
	            [-57.718487, -26.238242],
	            [-57.69399, -26.194639],
	            [-57.65532, -26.213244],
	            [-57.644011, -26.232062],
	            [-57.619689, -26.238104]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "VILLA FRANCA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.31363, -26.729115],
	            [-56.312131, -26.737669],
	            [-56.255431, -26.801237],
	            [-56.240098, -26.819857],
	            [-56.231859, -26.879568],
	            [-56.19664, -26.879261],
	            [-56.158691, -26.884933],
	            [-56.128586, -26.929809],
	            [-56.131313, -26.937844],
	            [-56.158599, -26.928759],
	            [-56.15574, -26.945589],
	            [-56.135904, -26.955828],
	            [-56.134475, -26.97214],
	            [-56.117997, -26.983299],
	            [-56.110719, -26.97302],
	            [-56.091408, -26.970291],
	            [-56.077882, -26.988765],
	            [-56.117491, -27.01366],
	            [-56.116024, -27.05183],
	            [-56.12883, -27.069365],
	            [-56.134739, -27.112273],
	            [-56.14056, -27.098492],
	            [-56.169645, -27.080246],
	            [-56.173379, -27.063585],
	            [-56.186902, -27.039449],
	            [-56.245082, -27.061785],
	            [-56.285614, -27.080676],
	            [-56.301545, -27.063463],
	            [-56.313287, -27.064072],
	            [-56.392806, -27.054981],
	            [-56.429874, -27.055739],
	            [-56.437354, -27.050781],
	            [-56.443315, -27.016309],
	            [-56.464733, -27.00678],
	            [-56.539702, -26.966099],
	            [-56.541127, -26.938283],
	            [-56.561993, -26.912292],
	            [-56.600574, -26.888159],
	            [-56.614185, -26.894671],
	            [-56.64703, -26.926496],
	            [-56.647044, -26.924488],
	            [-56.658796, -26.726241],
	            [-56.623234, -26.747297],
	            [-56.60341, -26.74309],
	            [-56.573014, -26.758359],
	            [-56.538692, -26.758107],
	            [-56.52848, -26.778316],
	            [-56.508777, -26.780195],
	            [-56.501938, -26.791827],
	            [-56.477889, -26.786486],
	            [-56.461416, -26.773048],
	            [-56.431168, -26.774826],
	            [-56.383767, -26.741123],
	            [-56.370124, -26.738914],
	            [-56.353063, -26.7244],
	            [-56.31363, -26.729115]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "GENERAL ARTIGAS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.062836, -25.904853],
	            [-55.048594, -25.922174],
	            [-55.010951, -25.949049],
	            [-55.027282, -25.966455],
	            [-55.008442, -25.977926],
	            [-54.994399, -26.006796],
	            [-55.00713, -26.009689],
	            [-55.022056, -26.027768],
	            [-55.034078, -26.026508],
	            [-55.050271, -26.046932],
	            [-55.077821, -26.047342],
	            [-55.090452, -26.030513],
	            [-55.11978, -26.050656],
	            [-55.129551, -26.04723],
	            [-55.142754, -26.037449],
	            [-55.145105, -26.020184],
	            [-55.181676, -26.041989],
	            [-55.179125, -26.060918],
	            [-55.203941, -26.07239],
	            [-55.212472, -26.08735],
	            [-55.229899, -26.065733],
	            [-55.249222, -26.058675],
	            [-55.253528, -26.043205],
	            [-55.28759, -26.049178],
	            [-55.327943, -26.022099],
	            [-55.357259, -25.993078],
	            [-55.365049, -25.975237],
	            [-55.389527, -25.966299],
	            [-55.392241, -25.952747],
	            [-55.409833, -25.942898],
	            [-55.405402, -25.921815],
	            [-55.39014, -25.903979],
	            [-55.341922, -25.919644],
	            [-55.301286, -25.911839],
	            [-55.288594, -25.912741],
	            [-55.273879, -25.897707],
	            [-55.290541, -25.874623],
	            [-55.321632, -25.866842],
	            [-55.320012, -25.84644],
	            [-55.295849, -25.818719],
	            [-55.286637, -25.780893],
	            [-55.273856, -25.798084],
	            [-55.277752, -25.815039],
	            [-55.258488, -25.833365],
	            [-55.246979, -25.829327],
	            [-55.220821, -25.840302],
	            [-55.193474, -25.868536],
	            [-55.168016, -25.871782],
	            [-55.158098, -25.892925],
	            [-55.097724, -25.907789],
	            [-55.072688, -25.916489],
	            [-55.062836, -25.904853]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "NARANJAL"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.859066, -25.644128],
	            [-54.866084, -25.690846],
	            [-54.857139, -25.694569],
	            [-54.85271, -25.739874],
	            [-54.835591, -25.756824],
	            [-54.822244, -25.756955],
	            [-54.799343, -25.768136],
	            [-54.813148, -25.838412],
	            [-54.837824, -25.871702],
	            [-54.840586, -25.978066],
	            [-54.859746, -26.009305],
	            [-54.873086, -26.003389],
	            [-54.876814, -25.989956],
	            [-54.896697, -25.982322],
	            [-54.936559, -25.980394],
	            [-54.96944, -26.002402],
	            [-54.975978, -26.013184],
	            [-54.994399, -26.006796],
	            [-55.008442, -25.977926],
	            [-55.027282, -25.966455],
	            [-55.010951, -25.949049],
	            [-55.048594, -25.922174],
	            [-55.062836, -25.904853],
	            [-55.028702, -25.863128],
	            [-55.025654, -25.8348],
	            [-55.010784, -25.818891],
	            [-55.005226, -25.775555],
	            [-55.011934, -25.762669],
	            [-54.996087, -25.729759],
	            [-54.998024, -25.716584],
	            [-54.988519, -25.709011],
	            [-54.917059, -25.720778],
	            [-54.908234, -25.659462],
	            [-54.88451, -25.652287],
	            [-54.879692, -25.639091],
	            [-54.859066, -25.644128]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "SANTA ROSA DEL MONDAY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.657861, -24.699844],
	            [-54.681481, -24.693381],
	            [-54.698044, -24.702713],
	            [-54.700846, -24.713718],
	            [-54.723884, -24.733768],
	            [-54.735839, -24.770036],
	            [-54.72288, -24.782277],
	            [-54.688573, -24.780069],
	            [-54.66826, -24.789638],
	            [-54.682098, -24.856067],
	            [-54.703907, -24.871262],
	            [-54.719233, -24.870901],
	            [-54.738072, -24.854926],
	            [-54.790773, -24.852632],
	            [-54.794998, -24.861207],
	            [-54.837844, -24.885706],
	            [-54.840519, -24.896248],
	            [-54.864504, -24.909411],
	            [-54.866354, -24.921096],
	            [-54.899018, -24.943808],
	            [-54.966925, -24.881658],
	            [-54.979449, -24.882519],
	            [-54.986496, -24.867736],
	            [-55.004772, -24.863264],
	            [-55.029041, -24.848298],
	            [-54.990265, -24.647848],
	            [-54.987968, -24.625365],
	            [-54.977275, -24.607265],
	            [-54.966245, -24.602499],
	            [-54.955096, -24.567317],
	            [-54.943617, -24.564523],
	            [-54.911696, -24.576463],
	            [-54.903853, -24.598787],
	            [-54.898908, -24.629243],
	            [-54.871519, -24.633855],
	            [-54.810644, -24.673316],
	            [-54.785245, -24.665315],
	            [-54.778602, -24.651542],
	            [-54.751686, -24.660109],
	            [-54.737933, -24.651919],
	            [-54.72046, -24.67641],
	            [-54.687385, -24.688325],
	            [-54.68304, -24.671952],
	            [-54.654124, -24.668356],
	            [-54.648169, -24.686923],
	            [-54.657861, -24.699844]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "MINGA PORÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.423139, -24.887775],
	            [-54.439866, -24.966881],
	            [-54.456479, -25.084967],
	            [-54.481471, -25.067137],
	            [-54.486325, -25.094263],
	            [-54.521589, -25.085983],
	            [-54.534152, -25.073705],
	            [-54.544574, -25.078987],
	            [-54.56599, -25.074133],
	            [-54.604822, -25.078702],
	            [-54.617529, -25.090694],
	            [-54.641085, -25.075989],
	            [-54.653221, -25.077988],
	            [-54.671784, -25.09777],
	            [-54.693723, -25.087815],
	            [-54.706163, -25.091781],
	            [-54.723943, -25.112779],
	            [-54.776192, -25.13028],
	            [-54.866528, -25.212453],
	            [-54.863862, -25.226903],
	            [-54.874878, -25.253366],
	            [-54.870607, -25.224328],
	            [-54.875338, -25.213488],
	            [-54.864138, -25.173328],
	            [-54.873019, -25.164921],
	            [-54.87892, -25.138193],
	            [-54.903077, -25.163798],
	            [-54.941803, -25.181181],
	            [-54.967812, -25.137971],
	            [-54.949596, -25.059183],
	            [-54.9399, -25.05402],
	            [-54.891115, -25.003488],
	            [-54.876012, -24.998746],
	            [-54.851505, -25.002072],
	            [-54.842001, -24.978059],
	            [-54.815771, -24.95408],
	            [-54.790992, -24.939945],
	            [-54.774465, -24.955273],
	            [-54.76059, -24.944391],
	            [-54.738195, -24.888464],
	            [-54.724413, -24.874061],
	            [-54.707058, -24.878526],
	            [-54.676355, -24.877783],
	            [-54.661126, -24.858329],
	            [-54.637373, -24.864978],
	            [-54.633661, -24.881254],
	            [-54.617119, -24.887873],
	            [-54.585987, -24.867907],
	            [-54.561951, -24.867861],
	            [-54.509739, -24.888821],
	            [-54.423139, -24.887775]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "MBARACAYÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.345807, -24.70766],
	            [-54.372403, -24.739802],
	            [-54.398873, -24.805107],
	            [-54.403228, -24.841491],
	            [-54.423139, -24.887775],
	            [-54.509739, -24.888821],
	            [-54.561951, -24.867861],
	            [-54.585987, -24.867907],
	            [-54.617119, -24.887873],
	            [-54.633661, -24.881254],
	            [-54.637373, -24.864978],
	            [-54.661126, -24.858329],
	            [-54.676355, -24.877783],
	            [-54.707058, -24.878526],
	            [-54.724413, -24.874061],
	            [-54.738195, -24.888464],
	            [-54.76059, -24.944391],
	            [-54.774465, -24.955273],
	            [-54.790992, -24.939945],
	            [-54.815771, -24.95408],
	            [-54.842001, -24.978059],
	            [-54.851505, -25.002072],
	            [-54.876012, -24.998746],
	            [-54.891115, -25.003488],
	            [-54.9399, -25.05402],
	            [-54.949596, -25.059183],
	            [-54.979715, -25.065545],
	            [-54.975655, -25.051019],
	            [-55.00162, -25.022794],
	            [-55.024143, -25.012786],
	            [-55.055251, -25.010239],
	            [-55.068402, -24.990355],
	            [-55.059104, -24.977821],
	            [-55.055298, -24.943746],
	            [-55.047329, -24.940143],
	            [-55.029041, -24.848298],
	            [-55.004772, -24.863264],
	            [-54.986496, -24.867736],
	            [-54.979449, -24.882519],
	            [-54.966925, -24.881658],
	            [-54.899018, -24.943808],
	            [-54.866354, -24.921096],
	            [-54.864504, -24.909411],
	            [-54.840519, -24.896248],
	            [-54.837844, -24.885706],
	            [-54.794998, -24.861207],
	            [-54.790773, -24.852632],
	            [-54.738072, -24.854926],
	            [-54.719233, -24.870901],
	            [-54.703907, -24.871262],
	            [-54.682098, -24.856067],
	            [-54.66826, -24.789638],
	            [-54.688573, -24.780069],
	            [-54.72288, -24.782277],
	            [-54.735839, -24.770036],
	            [-54.723884, -24.733768],
	            [-54.700846, -24.713718],
	            [-54.698044, -24.702713],
	            [-54.681481, -24.693381],
	            [-54.657861, -24.699844],
	            [-54.615111, -24.707076],
	            [-54.610266, -24.696964],
	            [-54.559952, -24.689375],
	            [-54.536398, -24.691861],
	            [-54.525297, -24.703708],
	            [-54.504421, -24.698763],
	            [-54.499098, -24.719593],
	            [-54.476453, -24.706886],
	            [-54.472163, -24.7234],
	            [-54.443583, -24.718126],
	            [-54.442937, -24.698474],
	            [-54.425065, -24.698939],
	            [-54.414963, -24.679505],
	            [-54.401625, -24.690621],
	            [-54.388422, -24.6878],
	            [-54.345807, -24.70766]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "SAN ALBERTO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.936559, -25.980394],
	            [-54.921135, -26.031693],
	            [-54.934531, -26.04335],
	            [-54.935248, -26.055239],
	            [-54.961826, -26.068659],
	            [-54.959013, -26.079171],
	            [-54.976183, -26.092686],
	            [-54.981832, -26.107086],
	            [-54.888942, -26.135902],
	            [-54.87467, -26.174255],
	            [-54.870696, -26.190632],
	            [-54.883816, -26.195519],
	            [-54.91648, -26.189696],
	            [-54.916272, -26.211473],
	            [-54.908362, -26.220952],
	            [-54.939366, -26.20852],
	            [-54.957733, -26.222682],
	            [-54.947425, -26.233791],
	            [-54.981786, -26.238651],
	            [-54.990062, -26.225255],
	            [-55.009819, -26.235901],
	            [-55.028005, -26.223637],
	            [-55.035622, -26.237939],
	            [-55.050071, -26.237717],
	            [-55.123493, -26.219495],
	            [-55.137617, -26.206572],
	            [-55.165802, -26.216281],
	            [-55.183572, -26.213433],
	            [-55.205627, -26.233615],
	            [-55.1803, -26.185102],
	            [-55.160242, -26.13575],
	            [-55.159319, -26.114065],
	            [-55.146951, -26.091723],
	            [-55.151212, -26.068371],
	            [-55.129551, -26.04723],
	            [-55.11978, -26.050656],
	            [-55.090452, -26.030513],
	            [-55.077821, -26.047342],
	            [-55.050271, -26.046932],
	            [-55.034078, -26.026508],
	            [-55.022056, -26.027768],
	            [-55.00713, -26.009689],
	            [-54.994399, -26.006796],
	            [-54.975978, -26.013184],
	            [-54.96944, -26.002402],
	            [-54.936559, -25.980394]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "IRUÑA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.456479, -25.084967],
	            [-54.427024, -25.118643],
	            [-54.41753, -25.136632],
	            [-54.417017, -25.161004],
	            [-54.433116, -25.181514],
	            [-54.469491, -25.214302],
	            [-54.481741, -25.256266],
	            [-54.487286, -25.291636],
	            [-54.511641, -25.328358],
	            [-54.531345, -25.342776],
	            [-54.541729, -25.328812],
	            [-54.54302, -25.304739],
	            [-54.554826, -25.289567],
	            [-54.578968, -25.291757],
	            [-54.615101, -25.286246],
	            [-54.629605, -25.280366],
	            [-54.636569, -25.257677],
	            [-54.652225, -25.250828],
	            [-54.676921, -25.26132],
	            [-54.691652, -25.258837],
	            [-54.701419, -25.246062],
	            [-54.72347, -25.282497],
	            [-54.73627, -25.278578],
	            [-54.826079, -25.280304],
	            [-54.874878, -25.253366],
	            [-54.863862, -25.226903],
	            [-54.866528, -25.212453],
	            [-54.776192, -25.13028],
	            [-54.723943, -25.112779],
	            [-54.706163, -25.091781],
	            [-54.693723, -25.087815],
	            [-54.671784, -25.09777],
	            [-54.653221, -25.077988],
	            [-54.641085, -25.075989],
	            [-54.617529, -25.090694],
	            [-54.604822, -25.078702],
	            [-54.56599, -25.074133],
	            [-54.544574, -25.078987],
	            [-54.534152, -25.073705],
	            [-54.521589, -25.085983],
	            [-54.486325, -25.094263],
	            [-54.481471, -25.067137],
	            [-54.456479, -25.084967]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "SANTA FE DEL PARANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.081703, -25.559745],
	            [-55.034315, -25.5763],
	            [-55.024459, -25.585594],
	            [-54.972657, -25.583139],
	            [-54.950767, -25.572144],
	            [-54.945396, -25.577774],
	            [-54.95421, -25.602723],
	            [-54.93363, -25.617853],
	            [-54.921386, -25.617058],
	            [-54.903599, -25.604198],
	            [-54.886295, -25.622412],
	            [-54.88451, -25.652287],
	            [-54.908234, -25.659462],
	            [-54.917059, -25.720778],
	            [-54.988519, -25.709011],
	            [-54.998024, -25.716584],
	            [-55.022317, -25.703415],
	            [-55.014538, -25.68569],
	            [-55.06599, -25.682234],
	            [-55.073816, -25.674114],
	            [-55.140533, -25.654018],
	            [-55.161837, -25.668784],
	            [-55.244114, -25.672137],
	            [-55.237377, -25.636356],
	            [-55.231887, -25.629862],
	            [-55.226693, -25.596013],
	            [-55.218311, -25.592765],
	            [-55.217517, -25.526523],
	            [-55.194807, -25.519495],
	            [-55.169214, -25.523047],
	            [-55.160507, -25.516799],
	            [-55.144117, -25.54944],
	            [-55.131268, -25.563155],
	            [-55.105411, -25.55632],
	            [-55.081703, -25.559745]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "TAVAPY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.129551, -26.04723],
	            [-55.151212, -26.068371],
	            [-55.146951, -26.091723],
	            [-55.159319, -26.114065],
	            [-55.160242, -26.13575],
	            [-55.1803, -26.185102],
	            [-55.205627, -26.233615],
	            [-55.212023, -26.239977],
	            [-55.230368, -26.244793],
	            [-55.259845, -26.235964],
	            [-55.263084, -26.217752],
	            [-55.28445, -26.201394],
	            [-55.303891, -26.162672],
	            [-55.296577, -26.148828],
	            [-55.311409, -26.139457],
	            [-55.311719, -26.108235],
	            [-55.299558, -26.103186],
	            [-55.286861, -26.090758],
	            [-55.249651, -26.069093],
	            [-55.249222, -26.058675],
	            [-55.229899, -26.065733],
	            [-55.212472, -26.08735],
	            [-55.203941, -26.07239],
	            [-55.179125, -26.060918],
	            [-55.181676, -26.041989],
	            [-55.145105, -26.020184],
	            [-55.142754, -26.037449],
	            [-55.129551, -26.04723]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARANÁ",
	        "dist_desc_": "DOCTOR RAÚL PEÑA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.33426, -25.311098],
	            [-57.368049, -25.338273],
	            [-57.373082, -25.353265],
	            [-57.390103, -25.34755],
	            [-57.402525, -25.357885],
	            [-57.421747, -25.345426],
	            [-57.431766, -25.322911],
	            [-57.444332, -25.307941],
	            [-57.446159, -25.282172],
	            [-57.420647, -25.260722],
	            [-57.393723, -25.257207],
	            [-57.349818, -25.227507],
	            [-57.337494, -25.232155],
	            [-57.32854, -25.24872],
	            [-57.341868, -25.276037],
	            [-57.343299, -25.294015],
	            [-57.33426, -25.311098]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "AREGUÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.402525, -25.357885],
	            [-57.405787, -25.388754],
	            [-57.399156, -25.418292],
	            [-57.427113, -25.412394],
	            [-57.423662, -25.403567],
	            [-57.447271, -25.396183],
	            [-57.465184, -25.439108],
	            [-57.510766, -25.423578],
	            [-57.507406, -25.403112],
	            [-57.484566, -25.401887],
	            [-57.483177, -25.342099],
	            [-57.469994, -25.324433],
	            [-57.444332, -25.307941],
	            [-57.431766, -25.322911],
	            [-57.421747, -25.345426],
	            [-57.402525, -25.357885]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "CAPIATÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.535964, -25.295812],
	            [-57.517974, -25.31878],
	            [-57.540099, -25.332433],
	            [-57.551821, -25.356953],
	            [-57.570284, -25.355547],
	            [-57.584936, -25.339359],
	            [-57.560422, -25.320256],
	            [-57.541826, -25.291726],
	            [-57.535964, -25.295812]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "FERNANDO DE LA MORA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.428463, -25.459173],
	            [-57.423722, -25.477461],
	            [-57.434843, -25.507176],
	            [-57.448895, -25.527388],
	            [-57.485321, -25.507605],
	            [-57.478472, -25.497673],
	            [-57.475878, -25.479378],
	            [-57.462644, -25.456363],
	            [-57.428463, -25.459173]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "GUARAMBARÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.312246, -25.461011],
	            [-57.317095, -25.497762],
	            [-57.33078, -25.578783],
	            [-57.343971, -25.589115],
	            [-57.346437, -25.613039],
	            [-57.368674, -25.622828],
	            [-57.388147, -25.639093],
	            [-57.397124, -25.6283],
	            [-57.394847, -25.615618],
	            [-57.414358, -25.598478],
	            [-57.427085, -25.563228],
	            [-57.420451, -25.534996],
	            [-57.430652, -25.525583],
	            [-57.423722, -25.477461],
	            [-57.428463, -25.459173],
	            [-57.401445, -25.444545],
	            [-57.328837, -25.455907],
	            [-57.312246, -25.461011]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "ITÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.299755, -25.448728],
	            [-57.312246, -25.461011],
	            [-57.328837, -25.455907],
	            [-57.401445, -25.444545],
	            [-57.399156, -25.418292],
	            [-57.405787, -25.388754],
	            [-57.402525, -25.357885],
	            [-57.390103, -25.34755],
	            [-57.373082, -25.353265],
	            [-57.368049, -25.338273],
	            [-57.33426, -25.311098],
	            [-57.307335, -25.338426],
	            [-57.331391, -25.371976],
	            [-57.311299, -25.388758],
	            [-57.315888, -25.405342],
	            [-57.300079, -25.417648],
	            [-57.299755, -25.448728]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "ITAUGUÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.586135, -25.341443],
	            [-57.613791, -25.389412],
	            [-57.64208, -25.380387],
	            [-57.635274, -25.367609],
	            [-57.636421, -25.349102],
	            [-57.616029, -25.313682],
	            [-57.586135, -25.341443]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "LAMBARÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.402491, -25.182251],
	            [-57.41664, -25.197468],
	            [-57.435994, -25.192501],
	            [-57.448774, -25.212785],
	            [-57.473873, -25.220948],
	            [-57.500115, -25.203941],
	            [-57.505922, -25.183357],
	            [-57.501143, -25.161412],
	            [-57.516522, -25.153876],
	            [-57.529219, -25.160606],
	            [-57.529939, -25.174392],
	            [-57.54323, -25.180939],
	            [-57.536947, -25.166585],
	            [-57.539578, -25.142802],
	            [-57.533635, -25.120238],
	            [-57.515272, -25.100377],
	            [-57.496235, -25.096707],
	            [-57.478317, -25.103693],
	            [-57.474415, -25.114231],
	            [-57.437008, -25.129088],
	            [-57.427015, -25.149884],
	            [-57.398983, -25.170773],
	            [-57.402491, -25.182251]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "LIMPIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.373973, -25.206853],
	            [-57.349818, -25.227507],
	            [-57.393723, -25.257207],
	            [-57.420647, -25.260722],
	            [-57.446159, -25.282172],
	            [-57.444332, -25.307941],
	            [-57.469994, -25.324433],
	            [-57.493767, -25.312162],
	            [-57.535964, -25.295812],
	            [-57.541826, -25.291726],
	            [-57.542529, -25.272124],
	            [-57.52503, -25.242664],
	            [-57.512601, -25.216839],
	            [-57.500115, -25.203941],
	            [-57.473873, -25.220948],
	            [-57.448774, -25.212785],
	            [-57.435994, -25.192501],
	            [-57.41664, -25.197468],
	            [-57.402491, -25.182251],
	            [-57.373973, -25.206853]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "LUQUE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.500115, -25.203941],
	            [-57.512601, -25.216839],
	            [-57.52503, -25.242664],
	            [-57.575086, -25.224663],
	            [-57.559354, -25.197463],
	            [-57.54323, -25.180939],
	            [-57.529939, -25.174392],
	            [-57.529219, -25.160606],
	            [-57.516522, -25.153876],
	            [-57.501143, -25.161412],
	            [-57.505922, -25.183357],
	            [-57.500115, -25.203941]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "MARIANO ROQUE ALONSO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.414358, -25.598478],
	            [-57.394847, -25.615618],
	            [-57.397124, -25.6283],
	            [-57.406309, -25.62839],
	            [-57.421513, -25.647052],
	            [-57.416483, -25.674113],
	            [-57.41937, -25.693386],
	            [-57.432726, -25.70154],
	            [-57.449227, -25.723163],
	            [-57.468209, -25.756149],
	            [-57.453799, -25.808391],
	            [-57.456491, -25.817523],
	            [-57.442906, -25.844625],
	            [-57.423004, -25.854065],
	            [-57.415749, -25.879598],
	            [-57.417286, -25.891638],
	            [-57.446799, -25.932162],
	            [-57.47605, -25.972293],
	            [-57.499619, -26.025117],
	            [-57.497653, -25.977524],
	            [-57.518125, -25.987615],
	            [-57.522341, -25.95255],
	            [-57.521516, -25.840866],
	            [-57.527504, -25.816591],
	            [-57.523288, -25.754698],
	            [-57.516199, -25.693954],
	            [-57.508176, -25.592118],
	            [-57.497974, -25.563762],
	            [-57.472514, -25.573658],
	            [-57.444327, -25.591475],
	            [-57.414358, -25.598478]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "NUEVA ITALIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.507406, -25.403112],
	            [-57.510766, -25.423578],
	            [-57.534474, -25.443702],
	            [-57.538957, -25.419052],
	            [-57.571855, -25.384836],
	            [-57.566758, -25.360922],
	            [-57.526884, -25.372394],
	            [-57.523278, -25.385783],
	            [-57.507406, -25.403112]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "ÑEMBY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.52503, -25.242664],
	            [-57.542529, -25.272124],
	            [-57.541826, -25.291726],
	            [-57.560422, -25.320256],
	            [-57.584936, -25.339359],
	            [-57.586135, -25.341443],
	            [-57.616029, -25.313682],
	            [-57.636421, -25.349102],
	            [-57.635274, -25.367609],
	            [-57.64208, -25.380387],
	            [-57.663467, -25.353841],
	            [-57.673858, -25.315799],
	            [-57.67283, -25.287615],
	            [-57.665677, -25.277344],
	            [-57.622845, -25.252738],
	            [-57.593662, -25.241651],
	            [-57.575086, -25.224663],
	            [-57.52503, -25.242664]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ASUNCIÓN",
	        "dist_desc_": "ASUNCIÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.385735, -23.064081],
	            [-57.364896, -23.07921],
	            [-57.338601, -23.081345],
	            [-57.328849, -23.092778],
	            [-57.290144, -23.083126],
	            [-57.280017, -23.092447],
	            [-57.255534, -23.082725],
	            [-57.254291, -23.109059],
	            [-57.280811, -23.147217],
	            [-57.294573, -23.176383],
	            [-57.319673, -23.170184],
	            [-57.331155, -23.213472],
	            [-57.352092, -23.224298],
	            [-57.357477, -23.258729],
	            [-57.375202, -23.266881],
	            [-57.340993, -23.30179],
	            [-57.327013, -23.305875],
	            [-57.309353, -23.323368],
	            [-57.259998, -23.335272],
	            [-57.22518, -23.350542],
	            [-57.203259, -23.354884],
	            [-57.203639, -23.329146],
	            [-57.182641, -23.325818],
	            [-57.177298, -23.339871],
	            [-57.144293, -23.329804],
	            [-57.140822, -23.354675],
	            [-57.224652, -23.374702],
	            [-57.275784, -23.37411],
	            [-57.323577, -23.408392],
	            [-57.311647, -23.436884],
	            [-57.329887, -23.438757],
	            [-57.340557, -23.459221],
	            [-57.293183, -23.4679],
	            [-57.29579, -23.491251],
	            [-57.326463, -23.499997],
	            [-57.334742, -23.496753],
	            [-57.362047, -23.509491],
	            [-57.376524, -23.497768],
	            [-57.402792, -23.498416],
	            [-57.410662, -23.483956],
	            [-57.447033, -23.477583],
	            [-57.450781, -23.4468],
	            [-57.48782, -23.389018],
	            [-57.494602, -23.372686],
	            [-57.519999, -23.353219],
	            [-57.518329, -23.336076],
	            [-57.488802, -23.316407],
	            [-57.491586, -23.28276],
	            [-57.510067, -23.261699],
	            [-57.533063, -23.243891],
	            [-57.549047, -23.212022],
	            [-57.617982, -23.184036],
	            [-57.641181, -23.142112],
	            [-57.640887, -23.130492],
	            [-57.627693, -23.111368],
	            [-57.612974, -23.100088],
	            [-57.59091, -23.105648],
	            [-57.579477, -23.097962],
	            [-57.537367, -23.10292],
	            [-57.519436, -23.083262],
	            [-57.493861, -23.077294],
	            [-57.468933, -23.054229],
	            [-57.457719, -23.068132],
	            [-57.446375, -23.069144],
	            [-57.424439, -23.055316],
	            [-57.413012, -23.061631],
	            [-57.385735, -23.064081]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "CONCEPCIÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.146124, -23.475622],
	            [-57.200465, -23.48257],
	            [-57.222787, -23.474262],
	            [-57.237016, -23.479292],
	            [-57.26236, -23.478485],
	            [-57.285995, -23.496612],
	            [-57.29579, -23.491251],
	            [-57.293183, -23.4679],
	            [-57.340557, -23.459221],
	            [-57.329887, -23.438757],
	            [-57.311647, -23.436884],
	            [-57.323577, -23.408392],
	            [-57.275784, -23.37411],
	            [-57.224652, -23.374702],
	            [-57.140822, -23.354675],
	            [-57.138474, -23.393588],
	            [-57.144362, -23.40327],
	            [-57.147587, -23.441549],
	            [-57.15699, -23.458254],
	            [-57.146124, -23.475622]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "BELÉN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.98375, -22.242528],
	            [-57.005233, -22.330435],
	            [-57.021881, -22.352792],
	            [-57.051724, -22.38124],
	            [-57.121445, -22.377726],
	            [-57.113032, -22.403632],
	            [-57.102388, -22.486622],
	            [-57.131097, -22.489315],
	            [-57.121083, -22.510518],
	            [-57.120603, -22.530272],
	            [-57.106981, -22.556532],
	            [-57.109255, -22.576042],
	            [-57.125901, -22.571819],
	            [-57.148817, -22.574809],
	            [-57.159139, -22.568635],
	            [-57.181583, -22.605839],
	            [-57.208375, -22.605958],
	            [-57.228333, -22.612474],
	            [-57.236699, -22.604962],
	            [-57.259999, -22.615435],
	            [-57.277484, -22.615878],
	            [-57.290222, -22.617137],
	            [-57.304005, -22.604329],
	            [-57.352563, -22.647835],
	            [-57.348001, -22.674142],
	            [-57.366432, -22.694779],
	            [-57.381953, -22.699048],
	            [-57.387007, -22.710824],
	            [-57.424714, -22.750201],
	            [-57.357322, -22.549376],
	            [-57.502216, -22.382377],
	            [-57.514353, -22.381431],
	            [-57.512283, -22.316637],
	            [-57.499419, -22.284561],
	            [-57.510713, -22.263147],
	            [-57.537739, -22.255119],
	            [-57.555092, -22.202822],
	            [-57.563802, -22.188053],
	            [-57.556105, -22.178862],
	            [-57.54029, -22.181154],
	            [-57.521619, -22.168305],
	            [-57.506149, -22.184913],
	            [-57.489246, -22.191135],
	            [-57.472915, -22.186946],
	            [-57.444758, -22.188331],
	            [-57.43059, -22.19622],
	            [-57.383163, -22.208015],
	            [-57.381552, -22.226467],
	            [-57.342351, -22.229101],
	            [-57.321232, -22.245776],
	            [-57.310919, -22.228948],
	            [-57.29584, -22.218699],
	            [-57.24071, -22.249371],
	            [-57.220978, -22.239109],
	            [-57.206161, -22.209243],
	            [-57.181621, -22.230205],
	            [-57.151065, -22.231076],
	            [-57.127754, -22.224569],
	            [-57.101414, -22.248542],
	            [-57.084821, -22.250286],
	            [-57.019309, -22.231403],
	            [-57.01053, -22.235894],
	            [-56.996415, -22.222424],
	            [-56.98375, -22.242528]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "SAN CARLOS DEL APA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.556105, -22.178862],
	            [-57.563802, -22.188053],
	            [-57.555092, -22.202822],
	            [-57.537739, -22.255119],
	            [-57.510713, -22.263147],
	            [-57.499419, -22.284561],
	            [-57.512283, -22.316637],
	            [-57.514353, -22.381431],
	            [-57.529463, -22.392647],
	            [-57.557697, -22.400466],
	            [-57.575382, -22.400413],
	            [-57.613674, -22.371721],
	            [-57.642554, -22.364698],
	            [-57.673478, -22.36806],
	            [-57.702091, -22.383937],
	            [-57.721863, -22.377833],
	            [-57.745923, -22.390367],
	            [-57.762831, -22.414538],
	            [-57.806831, -22.394738],
	            [-57.825332, -22.413132],
	            [-57.843757, -22.412307],
	            [-57.845519, -22.399055],
	            [-57.827431, -22.395544],
	            [-57.821354, -22.373316],
	            [-57.86698, -22.34306],
	            [-57.877699, -22.329258],
	            [-57.877296, -22.311988],
	            [-57.884162, -22.279562],
	            [-57.894087, -22.265573],
	            [-57.927043, -22.27617],
	            [-57.951789, -22.277079],
	            [-57.960054, -22.236732],
	            [-57.971349, -22.225712],
	            [-57.972553, -22.194305],
	            [-57.963191, -22.171429],
	            [-57.956594, -22.13154],
	            [-57.96292, -22.120721],
	            [-57.990167, -22.104637],
	            [-57.993034, -22.086919],
	            [-57.970704, -22.090363],
	            [-57.959918, -22.079347],
	            [-57.939075, -22.085133],
	            [-57.929884, -22.118858],
	            [-57.88612, -22.130136],
	            [-57.863715, -22.131015],
	            [-57.828071, -22.12025],
	            [-57.819527, -22.138108],
	            [-57.799313, -22.149943],
	            [-57.779775, -22.12515],
	            [-57.748986, -22.138786],
	            [-57.734209, -22.12093],
	            [-57.689858, -22.08828],
	            [-57.675008, -22.102512],
	            [-57.638924, -22.106203],
	            [-57.609898, -22.096164],
	            [-57.612209, -22.121126],
	            [-57.584165, -22.141835],
	            [-57.587975, -22.16564],
	            [-57.580226, -22.175271],
	            [-57.556105, -22.178862]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "SAN LÁZARO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.294387, -22.687641],
	            [-56.20878, -22.874392],
	            [-56.132473, -23.040365],
	            [-56.12905, -23.075018],
	            [-56.151362, -23.09974],
	            [-56.139751, -23.111248],
	            [-56.144168, -23.123154],
	            [-56.163978, -23.124294],
	            [-56.178838, -23.118217],
	            [-56.188172, -23.12919],
	            [-56.183326, -23.161046],
	            [-56.203973, -23.163658],
	            [-56.203066, -23.173662],
	            [-56.21759, -23.185992],
	            [-56.204974, -23.207105],
	            [-56.202929, -23.227301],
	            [-56.223724, -23.230937],
	            [-56.262449, -23.24637],
	            [-56.27346, -23.27146],
	            [-56.286595, -23.273099],
	            [-56.29235, -23.257754],
	            [-56.33003, -23.27243],
	            [-56.367515, -23.256318],
	            [-56.382674, -23.258058],
	            [-56.427333, -23.24055],
	            [-56.449406, -23.244206],
	            [-56.473906, -23.254118],
	            [-56.495807, -23.255348],
	            [-56.513259, -23.123623],
	            [-56.547022, -23.11619],
	            [-56.558866, -23.055489],
	            [-56.564692, -23.036391],
	            [-56.594045, -23.018786],
	            [-56.617587, -23.018854],
	            [-56.644147, -23.00719],
	            [-56.671859, -23.005846],
	            [-56.693818, -22.993669],
	            [-56.679403, -22.976234],
	            [-56.683841, -22.956829],
	            [-56.715704, -22.944564],
	            [-56.708895, -22.935691],
	            [-56.71967, -22.919438],
	            [-56.713041, -22.897017],
	            [-56.708694, -22.905949],
	            [-56.667314, -22.893474],
	            [-56.66528, -22.88403],
	            [-56.625794, -22.892862],
	            [-56.61488, -22.909133],
	            [-56.596767, -22.913451],
	            [-56.568775, -22.901485],
	            [-56.538011, -22.876611],
	            [-56.543662, -22.861049],
	            [-56.521924, -22.841396],
	            [-56.526012, -22.809764],
	            [-56.508678, -22.802377],
	            [-56.509667, -22.787253],
	            [-56.494067, -22.776301],
	            [-56.455246, -22.768328],
	            [-56.442059, -22.772239],
	            [-56.417486, -22.759744],
	            [-56.413066, -22.744556],
	            [-56.391341, -22.739502],
	            [-56.39249, -22.722465],
	            [-56.38442, -22.713256],
	            [-56.36413, -22.720169],
	            [-56.35782, -22.710184],
	            [-56.328049, -22.687636],
	            [-56.30828, -22.692805],
	            [-56.294387, -22.687641]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "YBY YAU"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.286595, -23.273099],
	            [-56.285994, -23.287519],
	            [-56.298978, -23.295757],
	            [-56.290891, -23.320068],
	            [-56.311854, -23.327085],
	            [-56.314223, -23.345397],
	            [-56.349741, -23.352712],
	            [-56.361874, -23.363977],
	            [-56.352985, -23.37959],
	            [-56.384891, -23.390494],
	            [-56.406107, -23.414353],
	            [-56.43626, -23.418945],
	            [-56.457163, -23.406073],
	            [-56.476748, -23.4093],
	            [-56.491376, -23.424027],
	            [-56.515073, -23.427951],
	            [-56.517521, -23.451021],
	            [-56.529031, -23.456801],
	            [-56.564763, -23.445305],
	            [-56.607626, -23.458558],
	            [-56.632783, -23.444628],
	            [-56.673815, -23.44175],
	            [-56.693488, -23.449982],
	            [-56.726586, -23.432975],
	            [-56.713095, -23.424877],
	            [-56.706745, -23.401394],
	            [-56.698361, -23.384929],
	            [-56.666777, -23.376356],
	            [-56.658494, -23.381721],
	            [-56.634005, -23.377597],
	            [-56.622323, -23.352114],
	            [-56.575217, -23.311249],
	            [-56.565439, -23.269717],
	            [-56.59024, -23.235712],
	            [-56.593877, -23.209065],
	            [-56.601395, -23.193055],
	            [-56.595127, -23.180749],
	            [-56.576701, -23.165724],
	            [-56.563878, -23.136182],
	            [-56.547022, -23.11619],
	            [-56.513259, -23.123623],
	            [-56.495807, -23.255348],
	            [-56.473906, -23.254118],
	            [-56.449406, -23.244206],
	            [-56.427333, -23.24055],
	            [-56.382674, -23.258058],
	            [-56.367515, -23.256318],
	            [-56.33003, -23.27243],
	            [-56.29235, -23.257754],
	            [-56.286595, -23.273099]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "AZOTE'Y"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.826067, -22.295926],
	            [-56.609426, -22.365286],
	            [-56.64365, -22.382773],
	            [-56.648658, -22.42215],
	            [-56.699045, -22.440523],
	            [-56.716417, -22.458229],
	            [-56.722629, -22.509426],
	            [-56.734788, -22.524551],
	            [-56.738518, -22.543249],
	            [-56.726167, -22.577304],
	            [-56.726906, -22.593223],
	            [-56.718255, -22.609541],
	            [-56.722316, -22.654157],
	            [-56.694325, -22.682097],
	            [-56.694564, -22.68871],
	            [-56.696381, -22.688202],
	            [-57.019995, -22.749295],
	            [-57.216401, -22.786026],
	            [-57.213231, -22.776956],
	            [-57.222802, -22.756044],
	            [-57.248035, -22.735374],
	            [-57.272349, -22.681529],
	            [-57.255386, -22.681788],
	            [-57.243041, -22.632293],
	            [-57.277484, -22.615878],
	            [-57.259999, -22.615435],
	            [-57.236699, -22.604962],
	            [-57.228333, -22.612474],
	            [-57.208375, -22.605958],
	            [-57.181583, -22.605839],
	            [-57.159139, -22.568635],
	            [-57.148817, -22.574809],
	            [-57.125901, -22.571819],
	            [-57.109255, -22.576042],
	            [-57.106981, -22.556532],
	            [-57.120603, -22.530272],
	            [-57.121083, -22.510518],
	            [-57.131097, -22.489315],
	            [-57.102388, -22.486622],
	            [-57.113032, -22.403632],
	            [-57.121445, -22.377726],
	            [-57.051724, -22.38124],
	            [-57.021881, -22.352792],
	            [-57.005233, -22.330435],
	            [-56.98375, -22.242528],
	            [-56.957757, -22.238287],
	            [-56.947506, -22.255852],
	            [-56.914936, -22.256713],
	            [-56.883334, -22.247482],
	            [-56.876113, -22.262157],
	            [-56.879748, -22.277919],
	            [-56.844373, -22.300825],
	            [-56.826067, -22.295926]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "SARGENTO JOSÉ FÉLIX LÓPEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.514353, -22.381431],
	            [-57.502216, -22.382377],
	            [-57.357322, -22.549376],
	            [-57.424714, -22.750201],
	            [-57.387007, -22.710824],
	            [-57.381953, -22.699048],
	            [-57.366432, -22.694779],
	            [-57.348001, -22.674142],
	            [-57.352563, -22.647835],
	            [-57.304005, -22.604329],
	            [-57.290222, -22.617137],
	            [-57.277484, -22.615878],
	            [-57.243041, -22.632293],
	            [-57.255386, -22.681788],
	            [-57.272349, -22.681529],
	            [-57.248035, -22.735374],
	            [-57.222802, -22.756044],
	            [-57.213231, -22.776956],
	            [-57.216401, -22.786026],
	            [-57.210722, -22.829698],
	            [-57.202275, -22.847117],
	            [-57.200102, -22.87506],
	            [-57.204005, -22.89422],
	            [-57.200619, -22.919044],
	            [-57.257697, -22.9708],
	            [-57.269668, -22.964362],
	            [-57.289083, -22.969436],
	            [-57.309671, -22.966583],
	            [-57.312754, -22.983546],
	            [-57.345522, -23.005226],
	            [-57.357579, -23.029377],
	            [-57.36477, -23.031989],
	            [-57.374046, -23.059023],
	            [-57.385735, -23.064081],
	            [-57.413012, -23.061631],
	            [-57.424439, -23.055316],
	            [-57.446375, -23.069144],
	            [-57.457719, -23.068132],
	            [-57.468933, -23.054229],
	            [-57.493861, -23.077294],
	            [-57.519436, -23.083262],
	            [-57.537367, -23.10292],
	            [-57.579477, -23.097962],
	            [-57.59091, -23.105648],
	            [-57.612974, -23.100088],
	            [-57.627693, -23.111368],
	            [-57.634178, -23.092942],
	            [-57.667017, -23.094004],
	            [-57.70176, -23.097241],
	            [-57.725078, -23.078884],
	            [-57.731485, -23.059845],
	            [-57.767183, -23.035906],
	            [-57.786599, -23.032143],
	            [-57.784939, -23.006277],
	            [-57.765863, -22.976363],
	            [-57.767394, -22.965291],
	            [-57.789877, -22.941428],
	            [-57.821375, -22.914974],
	            [-57.818284, -22.90415],
	            [-57.798432, -22.892743],
	            [-57.789507, -22.877517],
	            [-57.811439, -22.817369],
	            [-57.840264, -22.807997],
	            [-57.875318, -22.80298],
	            [-57.882556, -22.793939],
	            [-57.877433, -22.773711],
	            [-57.890147, -22.755891],
	            [-57.925789, -22.743273],
	            [-57.940248, -22.708272],
	            [-57.937445, -22.688967],
	            [-57.909428, -22.659125],
	            [-57.848425, -22.651732],
	            [-57.829701, -22.652846],
	            [-57.789976, -22.663873],
	            [-57.776803, -22.661268],
	            [-57.772888, -22.639449],
	            [-57.779917, -22.622618],
	            [-57.804785, -22.592152],
	            [-57.827744, -22.570731],
	            [-57.830876, -22.513493],
	            [-57.844475, -22.487727],
	            [-57.840531, -22.443855],
	            [-57.862, -22.423963],
	            [-57.864481, -22.403069],
	            [-57.85573, -22.397713],
	            [-57.845519, -22.399055],
	            [-57.843757, -22.412307],
	            [-57.825332, -22.413132],
	            [-57.806831, -22.394738],
	            [-57.762831, -22.414538],
	            [-57.745923, -22.390367],
	            [-57.721863, -22.377833],
	            [-57.702091, -22.383937],
	            [-57.673478, -22.36806],
	            [-57.642554, -22.364698],
	            [-57.613674, -22.371721],
	            [-57.575382, -22.400413],
	            [-57.557697, -22.400466],
	            [-57.529463, -22.392647],
	            [-57.514353, -22.381431]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "SAN ALFREDO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.713041, -22.897017],
	            [-56.71967, -22.919438],
	            [-56.708895, -22.935691],
	            [-56.715704, -22.944564],
	            [-56.683841, -22.956829],
	            [-56.679403, -22.976234],
	            [-56.693818, -22.993669],
	            [-56.708876, -22.995162],
	            [-56.725377, -23.009107],
	            [-56.747314, -23.017754],
	            [-56.763191, -23.014187],
	            [-56.793578, -23.035041],
	            [-56.787466, -23.05205],
	            [-56.804394, -23.055785],
	            [-56.826412, -23.080009],
	            [-56.837121, -23.073298],
	            [-56.859051, -23.082451],
	            [-56.894186, -23.067118],
	            [-56.893358, -23.079823],
	            [-56.906347, -23.09302],
	            [-56.945306, -23.08613],
	            [-56.976425, -23.09236],
	            [-57.001856, -23.085989],
	            [-57.004279, -23.076593],
	            [-57.036076, -23.07067],
	            [-57.044354, -23.075579],
	            [-57.066178, -23.055798],
	            [-57.084286, -23.064782],
	            [-57.12152, -23.058083],
	            [-57.134253, -23.078728],
	            [-57.153299, -23.092539],
	            [-57.177893, -23.098206],
	            [-57.195463, -23.083878],
	            [-57.225138, -23.099582],
	            [-57.239461, -23.1148],
	            [-57.254291, -23.109059],
	            [-57.255534, -23.082725],
	            [-57.280017, -23.092447],
	            [-57.290144, -23.083126],
	            [-57.328849, -23.092778],
	            [-57.338601, -23.081345],
	            [-57.364896, -23.07921],
	            [-57.385735, -23.064081],
	            [-57.374046, -23.059023],
	            [-57.36477, -23.031989],
	            [-57.357579, -23.029377],
	            [-57.345522, -23.005226],
	            [-57.312754, -22.983546],
	            [-57.309671, -22.966583],
	            [-57.289083, -22.969436],
	            [-57.269668, -22.964362],
	            [-57.257697, -22.9708],
	            [-57.200619, -22.919044],
	            [-57.204005, -22.89422],
	            [-57.200102, -22.87506],
	            [-57.202275, -22.847117],
	            [-57.210722, -22.829698],
	            [-57.216401, -22.786026],
	            [-57.019995, -22.749295],
	            [-56.696381, -22.688202],
	            [-56.694564, -22.68871],
	            [-56.696299, -22.708651],
	            [-56.672317, -22.711783],
	            [-56.666954, -22.742396],
	            [-56.669689, -22.765853],
	            [-56.662268, -22.772017],
	            [-56.66093, -22.794178],
	            [-56.649583, -22.800865],
	            [-56.653458, -22.815906],
	            [-56.686957, -22.841142],
	            [-56.714482, -22.849658],
	            [-56.704913, -22.868155],
	            [-56.713041, -22.897017]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "PASO BARRETO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.979582, -23.448158],
	            [-56.966998, -23.468224],
	            [-56.971677, -23.483441],
	            [-56.959314, -23.521915],
	            [-56.932975, -23.560066],
	            [-56.940008, -23.577294],
	            [-56.94624, -23.627715],
	            [-56.972184, -23.695064],
	            [-56.910449, -23.692645],
	            [-56.900946, -23.699084],
	            [-56.878602, -23.698976],
	            [-56.849939, -23.719816],
	            [-56.827053, -23.718289],
	            [-56.814168, -23.700381],
	            [-56.74868, -23.725769],
	            [-56.737998, -23.742448],
	            [-56.722858, -23.752014],
	            [-56.703603, -23.773575],
	            [-56.714672, -23.794122],
	            [-56.737528, -23.820199],
	            [-56.746344, -23.845554],
	            [-56.743453, -23.885495],
	            [-56.727832, -23.915677],
	            [-56.705818, -23.935995],
	            [-56.705161, -23.952771],
	            [-56.733056, -23.983871],
	            [-56.735004, -23.997626],
	            [-56.754197, -24.015221],
	            [-56.774288, -24.024817],
	            [-56.789809, -24.061162],
	            [-56.818263, -24.07233],
	            [-56.839284, -24.090923],
	            [-56.859365, -24.085254],
	            [-56.869619, -24.073228],
	            [-56.891684, -24.0876],
	            [-56.904325, -24.074131],
	            [-56.923023, -24.08787],
	            [-56.943437, -24.090386],
	            [-56.960987, -24.085001],
	            [-56.974026, -24.096286],
	            [-56.984064, -24.089455],
	            [-57.011514, -24.105377],
	            [-57.03823, -24.107692],
	            [-57.043497, -24.120208],
	            [-57.062976, -24.119001],
	            [-57.075416, -24.133101],
	            [-57.089784, -24.132353],
	            [-57.103272, -24.134566],
	            [-57.141948, -24.1577],
	            [-57.151931, -24.152397],
	            [-57.146136, -24.129443],
	            [-57.16171, -24.096435],
	            [-57.135861, -24.091142],
	            [-57.129341, -24.036632],
	            [-57.133174, -24.011669],
	            [-57.104085, -24.004687],
	            [-57.086649, -23.995708],
	            [-57.07662, -23.981838],
	            [-57.087258, -23.967648],
	            [-57.088834, -23.947311],
	            [-57.103593, -23.908621],
	            [-57.150455, -23.905233],
	            [-57.17398, -23.911228],
	            [-57.192478, -23.931378],
	            [-57.229763, -23.951756],
	            [-57.238152, -23.941788],
	            [-57.263052, -23.943976],
	            [-57.299219, -23.923999],
	            [-57.303044, -23.900664],
	            [-57.265197, -23.886024],
	            [-57.255301, -23.865982],
	            [-57.272881, -23.851539],
	            [-57.272685, -23.835046],
	            [-57.25148, -23.811903],
	            [-57.252724, -23.787087],
	            [-57.278042, -23.77159],
	            [-57.255742, -23.761376],
	            [-57.256661, -23.735966],
	            [-57.266484, -23.724657],
	            [-57.303242, -23.70765],
	            [-57.34319, -23.680226],
	            [-57.375754, -23.671087],
	            [-57.419096, -23.65374],
	            [-57.421153, -23.641253],
	            [-57.448108, -23.59987],
	            [-57.468284, -23.560286],
	            [-57.473517, -23.536198],
	            [-57.447033, -23.477583],
	            [-57.410662, -23.483956],
	            [-57.402792, -23.498416],
	            [-57.376524, -23.497768],
	            [-57.362047, -23.509491],
	            [-57.334742, -23.496753],
	            [-57.326463, -23.499997],
	            [-57.29579, -23.491251],
	            [-57.285995, -23.496612],
	            [-57.26236, -23.478485],
	            [-57.237016, -23.479292],
	            [-57.222787, -23.474262],
	            [-57.200465, -23.48257],
	            [-57.146124, -23.475622],
	            [-57.135394, -23.46857],
	            [-57.059101, -23.45751],
	            [-57.032925, -23.442126],
	            [-57.005781, -23.45173],
	            [-56.979582, -23.448158]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "SAN PEDRO DEL YCUAMANDYYÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.089784, -24.132353],
	            [-57.08186, -24.187982],
	            [-57.089094, -24.196215],
	            [-57.09925, -24.203308],
	            [-57.08326, -24.224723],
	            [-57.077692, -24.243426],
	            [-57.103675, -24.242284],
	            [-57.108529, -24.251135],
	            [-57.134941, -24.26013],
	            [-57.179011, -24.266654],
	            [-57.204586, -24.26132],
	            [-57.206265, -24.230844],
	            [-57.218837, -24.212017],
	            [-57.240561, -24.201047],
	            [-57.254348, -24.175924],
	            [-57.277024, -24.152374],
	            [-57.275877, -24.135491],
	            [-57.257588, -24.128726],
	            [-57.233107, -24.109672],
	            [-57.210619, -24.09775],
	            [-57.209106, -24.078374],
	            [-57.221674, -24.065833],
	            [-57.258296, -24.050593],
	            [-57.261963, -24.033534],
	            [-57.228504, -24.020382],
	            [-57.21133, -24.004546],
	            [-57.215403, -23.987555],
	            [-57.240829, -23.980716],
	            [-57.229763, -23.951756],
	            [-57.192478, -23.931378],
	            [-57.17398, -23.911228],
	            [-57.150455, -23.905233],
	            [-57.103593, -23.908621],
	            [-57.088834, -23.947311],
	            [-57.087258, -23.967648],
	            [-57.07662, -23.981838],
	            [-57.086649, -23.995708],
	            [-57.104085, -24.004687],
	            [-57.133174, -24.011669],
	            [-57.129341, -24.036632],
	            [-57.135861, -24.091142],
	            [-57.16171, -24.096435],
	            [-57.146136, -24.129443],
	            [-57.151931, -24.152397],
	            [-57.141948, -24.1577],
	            [-57.103272, -24.134566],
	            [-57.089784, -24.132353]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "ANTEQUERA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.534471, -24.054137],
	            [-56.531031, -24.065429],
	            [-56.536099, -24.097702],
	            [-56.534672, -24.12804],
	            [-56.51831, -24.1535],
	            [-56.511664, -24.178583],
	            [-56.500451, -24.197324],
	            [-56.500288, -24.214001],
	            [-56.484376, -24.265736],
	            [-56.493878, -24.301153],
	            [-56.546522, -24.299135],
	            [-56.545546, -24.343532],
	            [-56.556044, -24.355462],
	            [-56.5794, -24.346221],
	            [-56.601091, -24.355732],
	            [-56.607209, -24.347755],
	            [-56.602086, -24.31567],
	            [-56.613168, -24.299969],
	            [-56.627677, -24.294614],
	            [-56.651277, -24.296905],
	            [-56.68577, -24.273877],
	            [-56.688934, -24.26757],
	            [-56.72333, -24.259182],
	            [-56.750866, -24.223777],
	            [-56.811618, -24.194675],
	            [-56.806096, -24.165845],
	            [-56.798111, -24.15244],
	            [-56.797205, -24.130219],
	            [-56.769101, -24.125427],
	            [-56.780758, -24.112112],
	            [-56.769552, -24.098516],
	            [-56.766356, -24.075947],
	            [-56.744233, -24.073779],
	            [-56.73621, -24.079668],
	            [-56.720211, -24.068288],
	            [-56.702746, -24.064865],
	            [-56.682092, -24.071422],
	            [-56.654587, -24.062645],
	            [-56.61874, -24.05593],
	            [-56.591207, -24.05822],
	            [-56.58702, -24.047947],
	            [-56.550011, -24.036552],
	            [-56.534471, -24.054137]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "CHORÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.601091, -24.355732],
	            [-56.607753, -24.376852],
	            [-56.605925, -24.424104],
	            [-56.611154, -24.437158],
	            [-56.628748, -24.452676],
	            [-56.653485, -24.464909],
	            [-56.693502, -24.455381],
	            [-56.725178, -24.453862],
	            [-56.757795, -24.45787],
	            [-56.776926, -24.472432],
	            [-56.800054, -24.481427],
	            [-56.807907, -24.500272],
	            [-56.833319, -24.500415],
	            [-56.841171, -24.49242],
	            [-56.867155, -24.49756],
	            [-56.916696, -24.48471],
	            [-56.913697, -24.520688],
	            [-56.982458, -24.535926],
	            [-56.997211, -24.525427],
	            [-56.997639, -24.481455],
	            [-56.989787, -24.449475],
	            [-57.007918, -24.41778],
	            [-56.97965, -24.404217],
	            [-56.96209, -24.379947],
	            [-56.945386, -24.396651],
	            [-56.907838, -24.360388],
	            [-56.884139, -24.341542],
	            [-56.853703, -24.311252],
	            [-56.850303, -24.302786],
	            [-56.819768, -24.276691],
	            [-56.819757, -24.226506],
	            [-56.811618, -24.194675],
	            [-56.750866, -24.223777],
	            [-56.72333, -24.259182],
	            [-56.688934, -24.26757],
	            [-56.68577, -24.273877],
	            [-56.651277, -24.296905],
	            [-56.627677, -24.294614],
	            [-56.613168, -24.299969],
	            [-56.602086, -24.31567],
	            [-56.607209, -24.347755],
	            [-56.601091, -24.355732]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "GENERAL ELIZARDO AQUINO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.704115, -24.643025],
	            [-56.727621, -24.670219],
	            [-56.742969, -24.651413],
	            [-56.753991, -24.670903],
	            [-56.767985, -24.671777],
	            [-56.78092, -24.643728],
	            [-56.809212, -24.643518],
	            [-56.83131, -24.648172],
	            [-56.861314, -24.640233],
	            [-56.872572, -24.656109],
	            [-56.889719, -24.663497],
	            [-56.873974, -24.678898],
	            [-56.853927, -24.678462],
	            [-56.860582, -24.698604],
	            [-56.894275, -24.681329],
	            [-56.907124, -24.690324],
	            [-56.904983, -24.7056],
	            [-56.890849, -24.728014],
	            [-56.901557, -24.736438],
	            [-56.963375, -24.728157],
	            [-57.004635, -24.719734],
	            [-57.033474, -24.714594],
	            [-57.024479, -24.684613],
	            [-57.0152, -24.672906],
	            [-57.025193, -24.658201],
	            [-56.968229, -24.557122],
	            [-56.982458, -24.535926],
	            [-56.913697, -24.520688],
	            [-56.916696, -24.48471],
	            [-56.867155, -24.49756],
	            [-56.841171, -24.49242],
	            [-56.833319, -24.500415],
	            [-56.807907, -24.500272],
	            [-56.800054, -24.481427],
	            [-56.776926, -24.472432],
	            [-56.757795, -24.45787],
	            [-56.725178, -24.453862],
	            [-56.693502, -24.455381],
	            [-56.653485, -24.464909],
	            [-56.628748, -24.452676],
	            [-56.611154, -24.437158],
	            [-56.63338, -24.499778],
	            [-56.640023, -24.511851],
	            [-56.579515, -24.533328],
	            [-56.602789, -24.561489],
	            [-56.619724, -24.567309],
	            [-56.629521, -24.586977],
	            [-56.673851, -24.602119],
	            [-56.704115, -24.643025]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "ITACURUBÍ DEL ROSARIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.369717, -23.915129],
	            [-56.370375, -23.947518],
	            [-56.429338, -24.019386],
	            [-56.448687, -24.046314],
	            [-56.458105, -24.073718],
	            [-56.464863, -24.078319],
	            [-56.486246, -24.063242],
	            [-56.527217, -24.048718],
	            [-56.534471, -24.054137],
	            [-56.550011, -24.036552],
	            [-56.58702, -24.047947],
	            [-56.591207, -24.05822],
	            [-56.61874, -24.05593],
	            [-56.654587, -24.062645],
	            [-56.682092, -24.071422],
	            [-56.702746, -24.064865],
	            [-56.720211, -24.068288],
	            [-56.73621, -24.079668],
	            [-56.744233, -24.073779],
	            [-56.766356, -24.075947],
	            [-56.776273, -24.067989],
	            [-56.796562, -24.077155],
	            [-56.818263, -24.07233],
	            [-56.789809, -24.061162],
	            [-56.774288, -24.024817],
	            [-56.754197, -24.015221],
	            [-56.735004, -23.997626],
	            [-56.733056, -23.983871],
	            [-56.705161, -23.952771],
	            [-56.705818, -23.935995],
	            [-56.687107, -23.919551],
	            [-56.661914, -23.906139],
	            [-56.635419, -23.901318],
	            [-56.616382, -23.906502],
	            [-56.587128, -23.889181],
	            [-56.564832, -23.886411],
	            [-56.555269, -23.887104],
	            [-56.534861, -23.872547],
	            [-56.514077, -23.867091],
	            [-56.483397, -23.876859],
	            [-56.469995, -23.868566],
	            [-56.45609, -23.873425],
	            [-56.446281, -23.890915],
	            [-56.423543, -23.891756],
	            [-56.389658, -23.903743],
	            [-56.369717, -23.915129]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "LIMA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.114045, -23.605876],
	            [-56.338146, -23.650822],
	            [-56.472088, -23.651115],
	            [-56.593214, -23.785021],
	            [-56.577885, -23.834806],
	            [-56.588091, -23.861836],
	            [-56.564832, -23.886411],
	            [-56.587128, -23.889181],
	            [-56.616382, -23.906502],
	            [-56.635419, -23.901318],
	            [-56.661914, -23.906139],
	            [-56.687107, -23.919551],
	            [-56.705818, -23.935995],
	            [-56.727832, -23.915677],
	            [-56.743453, -23.885495],
	            [-56.746344, -23.845554],
	            [-56.737528, -23.820199],
	            [-56.714672, -23.794122],
	            [-56.67962, -23.794961],
	            [-56.650258, -23.777794],
	            [-56.636293, -23.777649],
	            [-56.610633, -23.760358],
	            [-56.60907, -23.745541],
	            [-56.590174, -23.734539],
	            [-56.575903, -23.739067],
	            [-56.552555, -23.723792],
	            [-56.556021, -23.698633],
	            [-56.531221, -23.666498],
	            [-56.510979, -23.631116],
	            [-56.492886, -23.627736],
	            [-56.46151, -23.61461],
	            [-56.448349, -23.603409],
	            [-56.421067, -23.592425],
	            [-56.39737, -23.589224],
	            [-56.377349, -23.580225],
	            [-56.358484, -23.563533],
	            [-56.333753, -23.565809],
	            [-56.321518, -23.561159],
	            [-56.309839, -23.543973],
	            [-56.282016, -23.530416],
	            [-56.265397, -23.528361],
	            [-56.226352, -23.494395],
	            [-56.147186, -23.492972],
	            [-56.135212, -23.513132],
	            [-56.143783, -23.533633],
	            [-56.135744, -23.565286],
	            [-56.110924, -23.592839],
	            [-56.114045, -23.605876]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "NUEVA GERMANIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.556044, -24.355462],
	            [-56.538021, -24.380056],
	            [-56.531514, -24.398975],
	            [-56.5397, -24.428109],
	            [-56.540039, -24.462218],
	            [-56.524735, -24.47153],
	            [-56.526194, -24.531722],
	            [-56.519679, -24.53185],
	            [-56.519532, -24.567994],
	            [-56.479833, -24.567934],
	            [-56.479171, -24.589137],
	            [-56.449813, -24.58601],
	            [-56.309038, -24.583888],
	            [-56.257301, -24.559862],
	            [-56.224784, -24.578822],
	            [-56.204196, -24.584102],
	            [-56.20397, -24.606213],
	            [-56.172393, -24.626732],
	            [-56.149587, -24.654208],
	            [-56.141926, -24.669973],
	            [-56.136656, -24.713128],
	            [-56.124245, -24.726878],
	            [-56.125925, -24.738171],
	            [-56.102449, -24.776296],
	            [-56.131489, -24.825661],
	            [-56.126998, -24.86196],
	            [-56.141319, -24.866401],
	            [-56.167925, -24.892289],
	            [-56.176524, -24.894305],
	            [-56.200056, -24.855683],
	            [-56.215241, -24.838853],
	            [-56.222655, -24.800904],
	            [-56.254855, -24.766173],
	            [-56.275064, -24.745758],
	            [-56.302356, -24.735362],
	            [-56.317287, -24.738429],
	            [-56.418195, -24.745574],
	            [-56.429037, -24.71053],
	            [-56.439204, -24.707113],
	            [-56.474817, -24.719728],
	            [-56.498112, -24.748978],
	            [-56.502607, -24.760219],
	            [-56.523623, -24.775424],
	            [-56.538868, -24.770441],
	            [-56.552849, -24.744365],
	            [-56.568268, -24.705683],
	            [-56.562544, -24.678307],
	            [-56.539387, -24.646881],
	            [-56.553135, -24.632157],
	            [-56.573363, -24.632804],
	            [-56.629563, -24.653275],
	            [-56.668654, -24.660227],
	            [-56.685778, -24.675031],
	            [-56.710401, -24.664757],
	            [-56.704115, -24.643025],
	            [-56.673851, -24.602119],
	            [-56.629521, -24.586977],
	            [-56.619724, -24.567309],
	            [-56.602789, -24.561489],
	            [-56.579515, -24.533328],
	            [-56.640023, -24.511851],
	            [-56.63338, -24.499778],
	            [-56.611154, -24.437158],
	            [-56.605925, -24.424104],
	            [-56.607753, -24.376852],
	            [-56.601091, -24.355732],
	            [-56.5794, -24.346221],
	            [-56.556044, -24.355462]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "SAN ESTANISLAO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.017797, -20.501686],
	            [-58.01648, -20.52725],
	            [-57.995245, -20.56349],
	            [-58.007966, -20.591163],
	            [-58.012243, -20.614403],
	            [-57.999489, -20.629304],
	            [-57.970133, -20.644661],
	            [-57.988757, -20.688125],
	            [-57.979325, -20.706239],
	            [-57.951782, -20.701327],
	            [-57.93182, -20.665085],
	            [-57.914102, -20.670873],
	            [-57.904663, -20.689125],
	            [-57.870004, -20.725962],
	            [-57.870406, -20.750213],
	            [-57.926033, -20.743952],
	            [-57.947466, -20.760235],
	            [-57.961751, -20.795012],
	            [-57.948271, -20.800993],
	            [-57.909283, -20.788793],
	            [-57.89309, -20.791098],
	            [-57.860549, -20.822408],
	            [-57.854663, -20.835083],
	            [-57.860027, -20.852785],
	            [-57.871323, -20.853687],
	            [-57.927032, -20.89303],
	            [-57.922905, -20.904391],
	            [-57.898742, -20.902524],
	            [-57.880341, -20.917394],
	            [-57.872598, -20.942581],
	            [-57.858079, -20.949866],
	            [-57.842379, -20.94646],
	            [-57.829594, -20.934016],
	            [-57.818771, -20.948818],
	            [-57.824884, -20.967252],
	            [-57.817327, -20.9791],
	            [-57.839583, -21.004155],
	            [-57.844858, -21.015998],
	            [-57.867549, -21.040833],
	            [-57.867589, -21.062963],
	            [-57.84793, -21.093964],
	            [-57.8902, -21.095712],
	            [-57.933242, -21.086437],
	            [-57.958251, -21.064438],
	            [-57.992264, -21.060663],
	            [-58.029467, -21.081705],
	            [-58.05364, -21.076303],
	            [-58.071456, -21.077895],
	            [-58.095846, -21.058689],
	            [-58.162638, -21.061723],
	            [-58.181801, -21.050153],
	            [-58.250135, -21.051108],
	            [-58.273831, -21.069223],
	            [-58.282885, -21.084091],
	            [-58.304509, -21.088124],
	            [-58.306044, -21.074852],
	            [-58.327329, -21.072752],
	            [-58.342882, -21.087756],
	            [-58.365232, -21.08648],
	            [-58.395275, -21.094862],
	            [-58.400095, -21.110545],
	            [-58.45725, -21.085205],
	            [-58.488875, -21.08405],
	            [-58.514889, -21.110145],
	            [-58.543726, -21.130444],
	            [-58.575247, -21.102156],
	            [-58.60715, -21.090389],
	            [-58.668705, -21.099609],
	            [-58.683409, -21.105845],
	            [-58.722284, -21.107244],
	            [-58.732217, -21.098731],
	            [-58.746341, -21.118027],
	            [-58.749867, -21.136161],
	            [-58.773908, -21.129691],
	            [-58.785145, -21.14029],
	            [-58.840926, -21.161126],
	            [-58.857097, -21.152625],
	            [-58.893141, -21.17997],
	            [-58.903008, -21.181478],
	            [-58.909042, -21.200918],
	            [-58.918907, -21.203291],
	            [-58.927098, -21.222576],
	            [-58.942191, -21.215301],
	            [-58.941417, -21.202464],
	            [-58.958011, -21.20132],
	            [-58.974298, -21.217154],
	            [-58.99455, -21.20335],
	            [-59.017145, -21.205828],
	            [-59.059567, -21.229461],
	            [-59.07993, -21.223366],
	            [-59.088932, -21.204272],
	            [-59.100682, -21.1981],
	            [-59.145212, -21.21326],
	            [-59.186464, -21.202517],
	            [-59.207845, -21.210373],
	            [-59.23932, -21.213558],
	            [-59.257972, -21.230688],
	            [-59.2732, -21.227525],
	            [-59.329275, -21.23514],
	            [-59.359002, -21.24484],
	            [-59.395038, -21.266848],
	            [-59.424329, -21.271126],
	            [-59.445631, -21.279108],
	            [-59.458644, -21.299326],
	            [-59.497302, -21.197883],
	            [-59.714117, -21.200965],
	            [-59.76635, -21.200573],
	            [-59.75087, -21.182933],
	            [-59.755849, -21.096831],
	            [-59.768323, -21.037456],
	            [-59.785691, -21.022105],
	            [-59.814891, -20.976694],
	            [-59.817786, -20.936654],
	            [-59.839607, -20.903143],
	            [-59.83831, -20.8807],
	            [-59.863118, -20.820841],
	            [-59.886896, -20.791957],
	            [-59.886381, -20.711153],
	            [-59.879513, -20.630417],
	            [-59.759325, -20.397361],
	            [-59.759282, -20.281663],
	            [-59.578477, -20.281219],
	            [-59.580264, -20.138252],
	            [-59.439085, -20.136918],
	            [-59.28514, -20.136834],
	            [-59.278849, -20.130463],
	            [-59.032319, -20.13244],
	            [-58.89834, -20.132585],
	            [-58.803087, -20.134299],
	            [-58.468038, -20.285636],
	            [-58.46407, -20.41442],
	            [-58.464676, -20.467303],
	            [-58.511416, -20.481214],
	            [-58.48526, -20.522925],
	            [-58.456596, -20.49493],
	            [-58.408251, -20.485654],
	            [-58.385209, -20.476407],
	            [-58.377995, -20.458144],
	            [-58.364667, -20.448933],
	            [-58.332627, -20.451867],
	            [-58.319745, -20.435186],
	            [-58.28015, -20.421533],
	            [-58.263462, -20.386075],
	            [-58.253969, -20.391019],
	            [-58.259613, -20.414555],
	            [-58.241838, -20.425704],
	            [-58.229828, -20.422814],
	            [-58.19214, -20.438185],
	            [-58.178805, -20.447424],
	            [-58.167581, -20.434214],
	            [-58.142766, -20.442699],
	            [-58.127445, -20.435858],
	            [-58.080161, -20.47437],
	            [-58.08605, -20.48827],
	            [-58.078011, -20.514823],
	            [-58.057612, -20.51532],
	            [-58.060702, -20.490236],
	            [-58.051375, -20.47571],
	            [-58.036347, -20.475191],
	            [-58.017797, -20.501686]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARAGUAY",
	        "dist_desc_": "FUERTE OLIMPO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.84793, -21.093964],
	            [-57.846296, -21.098401],
	            [-57.864222, -21.137799],
	            [-57.84826, -21.197477],
	            [-57.856582, -21.232997],
	            [-57.92087, -21.278237],
	            [-57.977002, -21.299952],
	            [-58.037701, -21.306574],
	            [-58.080803, -21.374623],
	            [-58.117433, -21.350517],
	            [-58.139638, -21.354894],
	            [-58.149805, -21.363984],
	            [-58.176211, -21.356729],
	            [-58.190855, -21.369939],
	            [-58.249007, -21.381015],
	            [-58.260938, -21.367575],
	            [-58.273599, -21.341862],
	            [-58.308136, -21.350212],
	            [-58.318586, -21.347205],
	            [-58.350814, -21.352701],
	            [-58.377341, -21.348026],
	            [-58.389024, -21.338662],
	            [-58.457284, -21.353022],
	            [-58.468628, -21.347147],
	            [-58.494432, -21.364954],
	            [-58.494879, -21.385191],
	            [-58.518245, -21.38501],
	            [-58.561317, -21.39504],
	            [-58.577906, -21.388982],
	            [-58.583678, -21.400747],
	            [-58.599784, -21.404998],
	            [-58.638442, -21.399884],
	            [-58.656693, -21.424839],
	            [-58.681469, -21.432393],
	            [-58.70121, -21.445851],
	            [-58.699583, -21.465956],
	            [-58.714492, -21.468606],
	            [-58.72602, -21.481506],
	            [-58.752276, -21.490483],
	            [-58.76476, -21.508073],
	            [-58.758101, -21.529707],
	            [-58.756763, -21.574003],
	            [-58.720178, -21.575226],
	            [-58.720316, -21.690031],
	            [-58.708733, -21.692442],
	            [-58.708875, -21.807812],
	            [-58.683801, -21.808069],
	            [-58.668688, -21.876193],
	            [-58.685874, -21.880587],
	            [-58.675656, -21.948661],
	            [-58.659237, -21.945152],
	            [-58.563144, -21.807016],
	            [-58.53523, -21.80796],
	            [-58.384705, -21.80818],
	            [-58.384894, -21.951137],
	            [-58.334228, -21.949784],
	            [-58.236575, -22.033363],
	            [-58.176484, -22.020541],
	            [-58.157444, -22.043259],
	            [-58.104763, -22.043623],
	            [-58.096951, -22.027904],
	            [-58.063702, -22.029555],
	            [-58.009501, -22.043386],
	            [-57.983976, -22.065347],
	            [-57.993034, -22.086919],
	            [-57.990167, -22.104637],
	            [-57.96292, -22.120721],
	            [-57.956594, -22.13154],
	            [-57.963191, -22.171429],
	            [-57.972553, -22.194305],
	            [-57.971349, -22.225712],
	            [-57.960054, -22.236732],
	            [-57.951789, -22.277079],
	            [-57.927043, -22.27617],
	            [-57.894087, -22.265573],
	            [-57.884162, -22.279562],
	            [-57.877296, -22.311988],
	            [-57.877699, -22.329258],
	            [-57.86698, -22.34306],
	            [-57.821354, -22.373316],
	            [-57.827431, -22.395544],
	            [-57.845519, -22.399055],
	            [-57.85573, -22.397713],
	            [-58.185565, -22.349438],
	            [-58.202731, -22.282506],
	            [-58.245549, -22.240463],
	            [-58.241671, -22.189903],
	            [-58.26688, -22.179487],
	            [-58.396747, -22.178969],
	            [-58.452149, -22.163699],
	            [-58.459693, -22.156769],
	            [-58.737136, -22.152462],
	            [-58.752591, -22.157357],
	            [-58.845213, -22.156471],
	            [-58.856872, -22.151179],
	            [-58.962615, -22.150356],
	            [-58.985425, -22.159613],
	            [-59.018355, -22.150072],
	            [-59.201595, -22.147866],
	            [-59.241225, -22.132108],
	            [-59.367744, -22.076224],
	            [-59.412897, -22.05682],
	            [-59.740028, -22.055499],
	            [-59.860806, -22.054194],
	            [-59.953068, -22.054504],
	            [-59.951841, -21.98222],
	            [-59.947422, -21.926573],
	            [-59.932733, -21.834242],
	            [-59.926285, -21.776837],
	            [-59.904947, -21.646972],
	            [-59.887532, -21.554004],
	            [-59.872402, -21.447163],
	            [-59.845566, -21.432452],
	            [-59.769895, -21.383322],
	            [-59.715013, -21.345861],
	            [-59.76635, -21.200573],
	            [-59.714117, -21.200965],
	            [-59.497302, -21.197883],
	            [-59.458644, -21.299326],
	            [-59.445631, -21.279108],
	            [-59.424329, -21.271126],
	            [-59.395038, -21.266848],
	            [-59.359002, -21.24484],
	            [-59.329275, -21.23514],
	            [-59.2732, -21.227525],
	            [-59.257972, -21.230688],
	            [-59.23932, -21.213558],
	            [-59.207845, -21.210373],
	            [-59.186464, -21.202517],
	            [-59.145212, -21.21326],
	            [-59.100682, -21.1981],
	            [-59.088932, -21.204272],
	            [-59.07993, -21.223366],
	            [-59.059567, -21.229461],
	            [-59.017145, -21.205828],
	            [-58.99455, -21.20335],
	            [-58.974298, -21.217154],
	            [-58.958011, -21.20132],
	            [-58.941417, -21.202464],
	            [-58.942191, -21.215301],
	            [-58.927098, -21.222576],
	            [-58.918907, -21.203291],
	            [-58.909042, -21.200918],
	            [-58.903008, -21.181478],
	            [-58.893141, -21.17997],
	            [-58.857097, -21.152625],
	            [-58.840926, -21.161126],
	            [-58.785145, -21.14029],
	            [-58.773908, -21.129691],
	            [-58.749867, -21.136161],
	            [-58.746341, -21.118027],
	            [-58.732217, -21.098731],
	            [-58.722284, -21.107244],
	            [-58.683409, -21.105845],
	            [-58.668705, -21.099609],
	            [-58.60715, -21.090389],
	            [-58.575247, -21.102156],
	            [-58.543726, -21.130444],
	            [-58.514889, -21.110145],
	            [-58.488875, -21.08405],
	            [-58.45725, -21.085205],
	            [-58.400095, -21.110545],
	            [-58.395275, -21.094862],
	            [-58.365232, -21.08648],
	            [-58.342882, -21.087756],
	            [-58.327329, -21.072752],
	            [-58.306044, -21.074852],
	            [-58.304509, -21.088124],
	            [-58.282885, -21.084091],
	            [-58.273831, -21.069223],
	            [-58.250135, -21.051108],
	            [-58.181801, -21.050153],
	            [-58.162638, -21.061723],
	            [-58.095846, -21.058689],
	            [-58.071456, -21.077895],
	            [-58.05364, -21.076303],
	            [-58.029467, -21.081705],
	            [-57.992264, -21.060663],
	            [-57.958251, -21.064438],
	            [-57.933242, -21.086437],
	            [-57.8902, -21.095712],
	            [-57.84793, -21.093964]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARAGUAY",
	        "dist_desc_": "PUERTO CASADO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.017797, -20.501686],
	            [-58.036347, -20.475191],
	            [-58.051375, -20.47571],
	            [-58.060702, -20.490236],
	            [-58.057612, -20.51532],
	            [-58.078011, -20.514823],
	            [-58.08605, -20.48827],
	            [-58.080161, -20.47437],
	            [-58.127445, -20.435858],
	            [-58.142766, -20.442699],
	            [-58.167581, -20.434214],
	            [-58.178805, -20.447424],
	            [-58.19214, -20.438185],
	            [-58.229828, -20.422814],
	            [-58.241838, -20.425704],
	            [-58.259613, -20.414555],
	            [-58.253969, -20.391019],
	            [-58.263462, -20.386075],
	            [-58.28015, -20.421533],
	            [-58.319745, -20.435186],
	            [-58.332627, -20.451867],
	            [-58.364667, -20.448933],
	            [-58.377995, -20.458144],
	            [-58.385209, -20.476407],
	            [-58.408251, -20.485654],
	            [-58.456596, -20.49493],
	            [-58.48526, -20.522925],
	            [-58.511416, -20.481214],
	            [-58.464676, -20.467303],
	            [-58.46407, -20.41442],
	            [-58.468038, -20.285636],
	            [-58.803087, -20.134299],
	            [-58.89834, -20.132585],
	            [-59.032319, -20.13244],
	            [-59.278849, -20.130463],
	            [-59.28514, -20.136834],
	            [-59.439085, -20.136918],
	            [-59.580264, -20.138252],
	            [-59.578477, -20.281219],
	            [-59.759282, -20.281663],
	            [-59.759325, -20.397361],
	            [-59.879513, -20.630417],
	            [-59.9273, -20.632887],
	            [-60.111019, -20.58095],
	            [-60.535834, -20.456691],
	            [-60.90463, -20.355282],
	            [-61.490832, -20.192296],
	            [-61.51439, -20.182631],
	            [-61.54988, -20.174715],
	            [-61.620052, -20.170064],
	            [-61.645544, -20.153219],
	            [-61.660203, -20.135611],
	            [-61.698262, -20.104244],
	            [-61.71859, -20.096644],
	            [-61.737006, -20.098228],
	            [-61.768661, -20.109639],
	            [-61.922536, -20.089211],
	            [-61.735211, -19.634406],
	            [-60.604325, -19.456639],
	            [-60.124039, -19.332723],
	            [-59.977778, -19.294686],
	            [-59.068928, -19.287647],
	            [-58.266901, -19.757015],
	            [-58.235967, -19.774997],
	            [-58.164069, -19.827083],
	            [-58.179379, -19.845808],
	            [-58.202076, -19.863508],
	            [-58.206051, -19.883391],
	            [-58.196587, -19.925901],
	            [-58.213174, -19.954717],
	            [-58.186537, -19.970363],
	            [-58.177427, -20.001428],
	            [-58.175893, -20.029958],
	            [-58.158098, -20.042822],
	            [-58.168289, -20.050645],
	            [-58.165339, -20.06645],
	            [-58.143971, -20.102744],
	            [-58.138544, -20.122988],
	            [-58.1514, -20.152522],
	            [-58.169035, -20.166578],
	            [-58.159045, -20.181847],
	            [-58.126777, -20.185952],
	            [-58.122928, -20.199562],
	            [-58.154622, -20.215632],
	            [-58.16512, -20.229932],
	            [-58.161301, -20.260309],
	            [-58.141276, -20.271842],
	            [-58.128193, -20.254811],
	            [-58.100802, -20.251193],
	            [-58.089776, -20.27024],
	            [-58.101566, -20.32798],
	            [-58.088897, -20.362619],
	            [-58.073418, -20.387793],
	            [-58.02172, -20.402377],
	            [-58.000726, -20.431956],
	            [-57.998009, -20.454624],
	            [-58.012992, -20.478508],
	            [-58.017797, -20.501686]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARAGUAY",
	        "dist_desc_": "BAHÍA NEGRA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.522341, -25.95255],
	            [-57.518125, -25.987615],
	            [-57.497653, -25.977524],
	            [-57.499619, -26.025117],
	            [-57.484906, -26.044499],
	            [-57.488729, -26.059954],
	            [-57.468136, -26.11337],
	            [-57.480641, -26.113197],
	            [-57.472422, -26.138434],
	            [-57.482368, -26.156885],
	            [-57.520244, -26.168071],
	            [-57.531195, -26.179282],
	            [-57.55174, -26.177528],
	            [-57.579656, -26.185393],
	            [-57.596607, -26.215748],
	            [-57.610527, -26.219735],
	            [-57.619689, -26.238104],
	            [-57.644011, -26.232062],
	            [-57.65532, -26.213244],
	            [-57.69399, -26.194639],
	            [-57.718487, -26.238242],
	            [-57.813382, -26.190176],
	            [-57.814365, -26.18036],
	            [-57.898341, -26.144625],
	            [-57.917792, -26.164244],
	            [-57.940837, -26.176876],
	            [-57.958352, -26.164111],
	            [-57.974689, -26.188289],
	            [-58.000321, -26.176082],
	            [-58.022942, -26.159287],
	            [-58.035254, -26.162517],
	            [-58.094209, -26.125613],
	            [-58.089509, -26.115076],
	            [-58.064138, -26.107652],
	            [-58.050035, -26.111725],
	            [-58.017052, -26.103863],
	            [-57.947926, -26.065879],
	            [-57.923533, -26.035515],
	            [-57.888785, -26.017303],
	            [-57.860397, -26.009329],
	            [-57.852375, -25.991235],
	            [-57.893095, -25.962323],
	            [-57.887641, -25.940176],
	            [-57.871751, -25.928411],
	            [-57.84951, -25.923037],
	            [-57.84037, -25.910654],
	            [-57.84502, -25.89635],
	            [-57.861075, -25.886231],
	            [-57.8646, -25.86716],
	            [-57.854749, -25.85437],
	            [-57.816215, -25.845927],
	            [-57.808329, -25.839976],
	            [-57.789693, -25.83384],
	            [-57.791435, -25.809386],
	            [-57.751574, -25.797269],
	            [-57.727558, -25.844566],
	            [-57.712155, -25.850379],
	            [-57.689625, -25.849549],
	            [-57.687826, -25.858457],
	            [-57.657292, -25.865031],
	            [-57.637735, -25.858457],
	            [-57.630568, -25.874267],
	            [-57.603685, -25.882995],
	            [-57.60363, -25.898778],
	            [-57.586606, -25.894925],
	            [-57.576725, -25.912167],
	            [-57.557591, -25.924531],
	            [-57.54179, -25.948243],
	            [-57.522341, -25.95255]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "VILLA OLIVA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.571855, -25.384836],
	            [-57.572362, -25.392606],
	            [-57.597797, -25.40176],
	            [-57.613791, -25.389412],
	            [-57.586135, -25.341443],
	            [-57.584936, -25.339359],
	            [-57.570284, -25.355547],
	            [-57.566758, -25.360922],
	            [-57.571855, -25.384836]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "VILLA ELISA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.423722, -25.477461],
	            [-57.430652, -25.525583],
	            [-57.420451, -25.534996],
	            [-57.427085, -25.563228],
	            [-57.414358, -25.598478],
	            [-57.444327, -25.591475],
	            [-57.472514, -25.573658],
	            [-57.497974, -25.563762],
	            [-57.508176, -25.592118],
	            [-57.516199, -25.693954],
	            [-57.523288, -25.754698],
	            [-57.527504, -25.816591],
	            [-57.521516, -25.840866],
	            [-57.522341, -25.95255],
	            [-57.54179, -25.948243],
	            [-57.557591, -25.924531],
	            [-57.576725, -25.912167],
	            [-57.586606, -25.894925],
	            [-57.60363, -25.898778],
	            [-57.603685, -25.882995],
	            [-57.630568, -25.874267],
	            [-57.637735, -25.858457],
	            [-57.657292, -25.865031],
	            [-57.687826, -25.858457],
	            [-57.689625, -25.849549],
	            [-57.712155, -25.850379],
	            [-57.727558, -25.844566],
	            [-57.751574, -25.797269],
	            [-57.791435, -25.809386],
	            [-57.789693, -25.83384],
	            [-57.808329, -25.839976],
	            [-57.796167, -25.814743],
	            [-57.818054, -25.783379],
	            [-57.826122, -25.756845],
	            [-57.808966, -25.7523],
	            [-57.779394, -25.760272],
	            [-57.733799, -25.724738],
	            [-57.731071, -25.707884],
	            [-57.759689, -25.708533],
	            [-57.76711, -25.696606],
	            [-57.750398, -25.66149],
	            [-57.729942, -25.645629],
	            [-57.716088, -25.647057],
	            [-57.692063, -25.660587],
	            [-57.670662, -25.652989],
	            [-57.677128, -25.603606],
	            [-57.657242, -25.597132],
	            [-57.629633, -25.61706],
	            [-57.608597, -25.605266],
	            [-57.603037, -25.567137],
	            [-57.576943, -25.565093],
	            [-57.569965, -25.541064],
	            [-57.579162, -25.507522],
	            [-57.567442, -25.482093],
	            [-57.527801, -25.482779],
	            [-57.512643, -25.488819],
	            [-57.488436, -25.489668],
	            [-57.478472, -25.497673],
	            [-57.485321, -25.507605],
	            [-57.448895, -25.527388],
	            [-57.434843, -25.507176],
	            [-57.423722, -25.477461]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "VILLETA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.212768, -25.355857],
	            [-57.200046, -25.360514],
	            [-57.195022, -25.401783],
	            [-57.21791, -25.40268],
	            [-57.22301, -25.418625],
	            [-57.247476, -25.433456],
	            [-57.299755, -25.448728],
	            [-57.300079, -25.417648],
	            [-57.315888, -25.405342],
	            [-57.311299, -25.388758],
	            [-57.331391, -25.371976],
	            [-57.307335, -25.338426],
	            [-57.296262, -25.353491],
	            [-57.268985, -25.363683],
	            [-57.249129, -25.36001],
	            [-57.233732, -25.366863],
	            [-57.212768, -25.355857]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "YPACARAÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.465184, -25.439108],
	            [-57.462644, -25.456363],
	            [-57.475878, -25.479378],
	            [-57.478472, -25.497673],
	            [-57.488436, -25.489668],
	            [-57.512643, -25.488819],
	            [-57.527801, -25.482779],
	            [-57.567442, -25.482093],
	            [-57.560908, -25.471707],
	            [-57.559407, -25.44375],
	            [-57.544613, -25.455432],
	            [-57.534474, -25.443702],
	            [-57.510766, -25.423578],
	            [-57.465184, -25.439108]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "YPANÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.399156, -25.418292],
	            [-57.401445, -25.444545],
	            [-57.428463, -25.459173],
	            [-57.462644, -25.456363],
	            [-57.465184, -25.439108],
	            [-57.447271, -25.396183],
	            [-57.423662, -25.403567],
	            [-57.427113, -25.412394],
	            [-57.399156, -25.418292]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "J. AUGUSTO SALDIVAR"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.009561, -27.018194],
	            [-58.011342, -27.035812],
	            [-58.040313, -27.030094],
	            [-58.083213, -27.026425],
	            [-58.105601, -27.019521],
	            [-58.151102, -27.002445],
	            [-58.157452, -26.981445],
	            [-58.176731, -26.981479],
	            [-58.188191, -26.938877],
	            [-58.197001, -26.924869],
	            [-58.217385, -26.912534],
	            [-58.22283, -26.899752],
	            [-58.239261, -26.896946],
	            [-58.255319, -26.908945],
	            [-58.385315, -26.892457],
	            [-58.379207, -26.870719],
	            [-58.366563, -26.863139],
	            [-58.344344, -26.870705],
	            [-58.319801, -26.864357],
	            [-58.32191, -26.847697],
	            [-58.354452, -26.828462],
	            [-58.357661, -26.816158],
	            [-58.346754, -26.80486],
	            [-58.30638, -26.807981],
	            [-58.281103, -26.792719],
	            [-58.262626, -26.791241],
	            [-58.231969, -26.810166],
	            [-58.231847, -26.821529],
	            [-58.212986, -26.834524],
	            [-58.196646, -26.856715],
	            [-58.150764, -26.935858],
	            [-58.068285, -26.989042],
	            [-58.060155, -26.987696],
	            [-58.009561, -27.018194]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "PILAR"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.011342, -27.035812],
	            [-57.987119, -27.054777],
	            [-58.001939, -27.132182],
	            [-58.030706, -27.133068],
	            [-58.064378, -27.126587],
	            [-58.109592, -27.137877],
	            [-58.125526, -27.150805],
	            [-58.161869, -27.150612],
	            [-58.158843, -27.134971],
	            [-58.202099, -27.143016],
	            [-58.22402, -27.132581],
	            [-58.282411, -27.129864],
	            [-58.255656, -27.055887],
	            [-58.203843, -27.060879],
	            [-58.146167, -27.041413],
	            [-58.105601, -27.019521],
	            [-58.083213, -27.026425],
	            [-58.040313, -27.030094],
	            [-58.011342, -27.035812]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "DESMOCHADOS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.610891, -27.099167],
	            [-57.627753, -27.097526],
	            [-57.894506, -27.05811],
	            [-57.918368, -27.048364],
	            [-57.972466, -27.034233],
	            [-58.009561, -27.018194],
	            [-58.060155, -26.987696],
	            [-58.068285, -26.989042],
	            [-58.150764, -26.935858],
	            [-58.196646, -26.856715],
	            [-58.212986, -26.834524],
	            [-58.231847, -26.821529],
	            [-58.231969, -26.810166],
	            [-58.262626, -26.791241],
	            [-58.281103, -26.792719],
	            [-58.293121, -26.774175],
	            [-58.294182, -26.759911],
	            [-58.281409, -26.75577],
	            [-58.254377, -26.759152],
	            [-58.246119, -26.742258],
	            [-58.205547, -26.751615],
	            [-58.197844, -26.757494],
	            [-58.1133, -26.758395],
	            [-58.037758, -26.827581],
	            [-58.009935, -26.823327],
	            [-57.986543, -26.841643],
	            [-57.971279, -26.8441],
	            [-57.944176, -26.857302],
	            [-57.932042, -26.878314],
	            [-57.899584, -26.922532],
	            [-57.879003, -26.943882],
	            [-57.853944, -26.939897],
	            [-57.810651, -26.925748],
	            [-57.798971, -26.933696],
	            [-57.788084, -26.953086],
	            [-57.788765, -27.002259],
	            [-57.727807, -27.023058],
	            [-57.65347, -27.065323],
	            [-57.610891, -27.099167]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "GUAZÚ-CUÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.001939, -27.132182],
	            [-58.010584, -27.164573],
	            [-58.01101, -27.202519],
	            [-58.017551, -27.2395],
	            [-57.995984, -27.266778],
	            [-58.025843, -27.258094],
	            [-58.073729, -27.261327],
	            [-58.092911, -27.273429],
	            [-58.1722, -27.277113],
	            [-58.225959, -27.266857],
	            [-58.249105, -27.256239],
	            [-58.266092, -27.256066],
	            [-58.276301, -27.265032],
	            [-58.281147, -27.18518],
	            [-58.285652, -27.171102],
	            [-58.282411, -27.129864],
	            [-58.22402, -27.132581],
	            [-58.202099, -27.143016],
	            [-58.158843, -27.134971],
	            [-58.161869, -27.150612],
	            [-58.125526, -27.150805],
	            [-58.109592, -27.137877],
	            [-58.064378, -27.126587],
	            [-58.030706, -27.133068],
	            [-58.001939, -27.132182]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "MAYOR JOSÉ DEJESÚS MARTÍNEZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.655748, -22.605428],
	            [-55.713496, -22.652766],
	            [-55.735198, -22.629942],
	            [-55.74203, -22.646182],
	            [-55.767949, -22.653537],
	            [-55.774816, -22.668461],
	            [-55.787688, -22.676846],
	            [-55.799163, -22.696525],
	            [-55.807065, -22.7269],
	            [-55.828835, -22.73016],
	            [-55.843801, -22.739738],
	            [-55.857736, -22.762671],
	            [-55.854307, -22.773904],
	            [-55.814271, -22.783614],
	            [-55.815244, -22.800137],
	            [-55.793548, -22.810782],
	            [-55.767544, -22.811599],
	            [-55.748374, -22.832923],
	            [-55.752178, -22.852128],
	            [-55.764974, -22.871308],
	            [-55.768669, -22.88876],
	            [-55.759323, -22.899666],
	            [-55.719885, -22.908827],
	            [-55.688412, -22.92257],
	            [-55.661185, -22.964045],
	            [-55.673023, -22.988261],
	            [-55.676108, -23.006139],
	            [-55.699566, -23.018558],
	            [-55.719052, -23.038699],
	            [-55.759494, -23.050628],
	            [-55.762562, -23.060092],
	            [-55.797459, -23.084127],
	            [-55.824688, -23.123997],
	            [-55.824764, -23.147425],
	            [-55.851559, -23.15936],
	            [-55.869904, -23.186606],
	            [-55.905348, -23.228347],
	            [-55.934464, -23.248649],
	            [-55.955678, -23.242918],
	            [-55.983586, -23.25373],
	            [-55.989549, -23.268556],
	            [-56.027267, -23.277745],
	            [-56.033606, -23.288843],
	            [-56.0666, -23.313129],
	            [-56.090216, -23.320659],
	            [-56.106598, -23.334907],
	            [-56.136607, -23.312903],
	            [-56.162519, -23.322706],
	            [-56.174569, -23.301681],
	            [-56.192149, -23.302885],
	            [-56.221815, -23.317796],
	            [-56.238682, -23.313947],
	            [-56.250228, -23.321923],
	            [-56.293294, -23.329823],
	            [-56.314223, -23.345397],
	            [-56.311854, -23.327085],
	            [-56.290891, -23.320068],
	            [-56.298978, -23.295757],
	            [-56.285994, -23.287519],
	            [-56.286595, -23.273099],
	            [-56.27346, -23.27146],
	            [-56.262449, -23.24637],
	            [-56.223724, -23.230937],
	            [-56.202929, -23.227301],
	            [-56.204974, -23.207105],
	            [-56.21759, -23.185992],
	            [-56.203066, -23.173662],
	            [-56.203973, -23.163658],
	            [-56.183326, -23.161046],
	            [-56.188172, -23.12919],
	            [-56.178838, -23.118217],
	            [-56.163978, -23.124294],
	            [-56.144168, -23.123154],
	            [-56.139751, -23.111248],
	            [-56.151362, -23.09974],
	            [-56.12905, -23.075018],
	            [-56.132473, -23.040365],
	            [-56.20878, -22.874392],
	            [-56.294387, -22.687641],
	            [-56.281537, -22.667837],
	            [-56.269788, -22.668547],
	            [-56.263436, -22.641386],
	            [-56.249838, -22.623103],
	            [-56.225342, -22.575788],
	            [-56.202635, -22.579687],
	            [-56.193952, -22.555584],
	            [-56.198505, -22.548023],
	            [-56.160511, -22.511899],
	            [-56.144458, -22.514674],
	            [-56.107423, -22.488719],
	            [-56.081032, -22.481543],
	            [-56.071647, -22.465406],
	            [-56.093143, -22.402298],
	            [-56.086331, -22.350758],
	            [-56.098956, -22.31941],
	            [-56.133661, -22.294622],
	            [-56.1395, -22.285731],
	            [-56.123606, -22.271591],
	            [-56.068608, -22.286122],
	            [-56.059845, -22.276198],
	            [-56.006564, -22.292561],
	            [-55.980954, -22.278604],
	            [-55.969265, -22.292021],
	            [-55.929037, -22.278505],
	            [-55.888937, -22.282788],
	            [-55.851187, -22.281823],
	            [-55.843135, -22.287096],
	            [-55.8324, -22.325656],
	            [-55.821007, -22.345148],
	            [-55.800853, -22.355343],
	            [-55.803711, -22.372303],
	            [-55.779819, -22.384371],
	            [-55.748685, -22.383451],
	            [-55.737219, -22.41122],
	            [-55.733909, -22.441544],
	            [-55.751078, -22.474732],
	            [-55.747266, -22.505485],
	            [-55.723604, -22.551771],
	            [-55.698421, -22.563258],
	            [-55.694779, -22.57754],
	            [-55.655748, -22.605428]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "AMAMBAY",
	        "dist_desc_": "PEDRO JUAN CABALLERO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.1395, -22.285731],
	            [-56.133661, -22.294622],
	            [-56.098956, -22.31941],
	            [-56.086331, -22.350758],
	            [-56.093143, -22.402298],
	            [-56.071647, -22.465406],
	            [-56.081032, -22.481543],
	            [-56.107423, -22.488719],
	            [-56.144458, -22.514674],
	            [-56.160511, -22.511899],
	            [-56.198505, -22.548023],
	            [-56.193952, -22.555584],
	            [-56.202635, -22.579687],
	            [-56.225342, -22.575788],
	            [-56.249838, -22.623103],
	            [-56.263436, -22.641386],
	            [-56.269788, -22.668547],
	            [-56.281537, -22.667837],
	            [-56.294387, -22.687641],
	            [-56.30828, -22.692805],
	            [-56.328049, -22.687636],
	            [-56.35782, -22.710184],
	            [-56.36413, -22.720169],
	            [-56.38442, -22.713256],
	            [-56.39249, -22.722465],
	            [-56.391341, -22.739502],
	            [-56.413066, -22.744556],
	            [-56.417486, -22.759744],
	            [-56.442059, -22.772239],
	            [-56.455246, -22.768328],
	            [-56.494067, -22.776301],
	            [-56.509667, -22.787253],
	            [-56.508678, -22.802377],
	            [-56.526012, -22.809764],
	            [-56.521924, -22.841396],
	            [-56.543662, -22.861049],
	            [-56.538011, -22.876611],
	            [-56.568775, -22.901485],
	            [-56.596767, -22.913451],
	            [-56.61488, -22.909133],
	            [-56.625794, -22.892862],
	            [-56.66528, -22.88403],
	            [-56.667314, -22.893474],
	            [-56.708694, -22.905949],
	            [-56.713041, -22.897017],
	            [-56.704913, -22.868155],
	            [-56.714482, -22.849658],
	            [-56.686957, -22.841142],
	            [-56.653458, -22.815906],
	            [-56.649583, -22.800865],
	            [-56.66093, -22.794178],
	            [-56.662268, -22.772017],
	            [-56.669689, -22.765853],
	            [-56.666954, -22.742396],
	            [-56.672317, -22.711783],
	            [-56.696299, -22.708651],
	            [-56.694564, -22.68871],
	            [-56.694325, -22.682097],
	            [-56.722316, -22.654157],
	            [-56.718255, -22.609541],
	            [-56.726906, -22.593223],
	            [-56.726167, -22.577304],
	            [-56.738518, -22.543249],
	            [-56.734788, -22.524551],
	            [-56.722629, -22.509426],
	            [-56.716417, -22.458229],
	            [-56.699045, -22.440523],
	            [-56.648658, -22.42215],
	            [-56.64365, -22.382773],
	            [-56.609426, -22.365286],
	            [-56.826067, -22.295926],
	            [-56.802827, -22.283502],
	            [-56.804151, -22.25197],
	            [-56.784854, -22.257371],
	            [-56.76238, -22.249597],
	            [-56.748534, -22.236368],
	            [-56.726844, -22.259994],
	            [-56.709286, -22.247514],
	            [-56.701217, -22.226644],
	            [-56.683163, -22.234921],
	            [-56.673206, -22.249108],
	            [-56.637922, -22.257787],
	            [-56.64338, -22.245549],
	            [-56.605994, -22.23165],
	            [-56.58219, -22.205287],
	            [-56.570459, -22.207479],
	            [-56.556378, -22.195304],
	            [-56.556725, -22.168925],
	            [-56.533024, -22.158646],
	            [-56.522988, -22.137545],
	            [-56.518973, -22.10847],
	            [-56.497126, -22.094211],
	            [-56.479817, -22.093841],
	            [-56.47156, -22.080222],
	            [-56.432378, -22.085859],
	            [-56.402658, -22.079741],
	            [-56.390008, -22.086082],
	            [-56.3925, -22.100948],
	            [-56.37828, -22.11534],
	            [-56.367814, -22.136868],
	            [-56.373845, -22.149937],
	            [-56.363578, -22.170539],
	            [-56.34963, -22.173588],
	            [-56.317905, -22.214634],
	            [-56.29931, -22.217803],
	            [-56.284928, -22.23172],
	            [-56.262683, -22.239471],
	            [-56.238337, -22.236459],
	            [-56.234522, -22.255814],
	            [-56.210235, -22.277799],
	            [-56.193848, -22.271246],
	            [-56.174656, -22.285549],
	            [-56.150816, -22.281781],
	            [-56.1395, -22.285731]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "AMAMBAY",
	        "dist_desc_": "BELLA VISTA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.636647, -23.018262],
	            [-55.613918, -23.041077],
	            [-55.610969, -23.077018],
	            [-55.617027, -23.08173],
	            [-55.599783, -23.104176],
	            [-55.595833, -23.119457],
	            [-55.596811, -23.152603],
	            [-55.573477, -23.143295],
	            [-55.541903, -23.15612],
	            [-55.543098, -23.180811],
	            [-55.523292, -23.197788],
	            [-55.54032, -23.220929],
	            [-55.537306, -23.251264],
	            [-55.522676, -23.259717],
	            [-55.553183, -23.279475],
	            [-55.549275, -23.303647],
	            [-55.556013, -23.316298],
	            [-55.534643, -23.333314],
	            [-55.520707, -23.352235],
	            [-55.519498, -23.365119],
	            [-55.504478, -23.378475],
	            [-55.515641, -23.409535],
	            [-55.544794, -23.449316],
	            [-55.540578, -23.455517],
	            [-55.551784, -23.489397],
	            [-55.543421, -23.523665],
	            [-55.544369, -23.539317],
	            [-55.571773, -23.579081],
	            [-55.586656, -23.637399],
	            [-55.600351, -23.652925],
	            [-55.630333, -23.656923],
	            [-55.641461, -23.668499],
	            [-55.662524, -23.675578],
	            [-55.707476, -23.660665],
	            [-55.753374, -23.691553],
	            [-55.769927, -23.736119],
	            [-55.800041, -23.751397],
	            [-55.839276, -23.763523],
	            [-55.857309, -23.784195],
	            [-55.859315, -23.799012],
	            [-55.886037, -23.807051],
	            [-55.899763, -23.821139],
	            [-55.917527, -23.817657],
	            [-55.930942, -23.830927],
	            [-55.951692, -23.812831],
	            [-55.991649, -23.82771],
	            [-56.027214, -23.822321],
	            [-56.02729, -23.822219],
	            [-56.020672, -23.800269],
	            [-55.985046, -23.779069],
	            [-55.97552, -23.744603],
	            [-55.980663, -23.667947],
	            [-55.953791, -23.65475],
	            [-55.952101, -23.642751],
	            [-55.93194, -23.621285],
	            [-55.92952, -23.599941],
	            [-55.932788, -23.575685],
	            [-55.930221, -23.547909],
	            [-55.921335, -23.539403],
	            [-55.903889, -23.499117],
	            [-55.916926, -23.475576],
	            [-55.895537, -23.41858],
	            [-55.89919, -23.392179],
	            [-56.030524, -23.38142],
	            [-56.038695, -23.391636],
	            [-56.054136, -23.381894],
	            [-56.069079, -23.347449],
	            [-56.0666, -23.313129],
	            [-56.033606, -23.288843],
	            [-56.027267, -23.277745],
	            [-55.989549, -23.268556],
	            [-55.983586, -23.25373],
	            [-55.955678, -23.242918],
	            [-55.934464, -23.248649],
	            [-55.905348, -23.228347],
	            [-55.869904, -23.186606],
	            [-55.851559, -23.15936],
	            [-55.824764, -23.147425],
	            [-55.824688, -23.123997],
	            [-55.797459, -23.084127],
	            [-55.762562, -23.060092],
	            [-55.759494, -23.050628],
	            [-55.719052, -23.038699],
	            [-55.699566, -23.018558],
	            [-55.676108, -23.006139],
	            [-55.662847, -23.002062],
	            [-55.636647, -23.018262]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "AMAMBAY",
	        "dist_desc_": "CAPITÁN BADO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.636647, -23.018262],
	            [-55.662847, -23.002062],
	            [-55.676108, -23.006139],
	            [-55.673023, -22.988261],
	            [-55.661185, -22.964045],
	            [-55.688412, -22.92257],
	            [-55.719885, -22.908827],
	            [-55.759323, -22.899666],
	            [-55.768669, -22.88876],
	            [-55.764974, -22.871308],
	            [-55.752178, -22.852128],
	            [-55.748374, -22.832923],
	            [-55.767544, -22.811599],
	            [-55.793548, -22.810782],
	            [-55.815244, -22.800137],
	            [-55.814271, -22.783614],
	            [-55.854307, -22.773904],
	            [-55.857736, -22.762671],
	            [-55.843801, -22.739738],
	            [-55.828835, -22.73016],
	            [-55.807065, -22.7269],
	            [-55.799163, -22.696525],
	            [-55.787688, -22.676846],
	            [-55.774816, -22.668461],
	            [-55.767949, -22.653537],
	            [-55.74203, -22.646182],
	            [-55.735198, -22.629942],
	            [-55.713496, -22.652766],
	            [-55.655748, -22.605428],
	            [-55.625163, -22.628248],
	            [-55.622873, -22.650469],
	            [-55.614424, -22.655087],
	            [-55.617308, -22.677623],
	            [-55.61342, -22.717043],
	            [-55.620181, -22.753352],
	            [-55.63657, -22.778869],
	            [-55.650426, -22.791042],
	            [-55.65338, -22.816641],
	            [-55.660875, -22.827413],
	            [-55.665857, -22.852473],
	            [-55.661224, -22.882224],
	            [-55.650979, -22.887307],
	            [-55.645516, -22.924494],
	            [-55.651648, -22.931081],
	            [-55.638408, -22.950596],
	            [-55.636836, -22.964769],
	            [-55.621977, -22.984552],
	            [-55.633931, -22.991824],
	            [-55.636647, -23.018262]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "AMAMBAY",
	        "dist_desc_": "ZANJA PYTÃ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.0666, -23.313129],
	            [-56.069079, -23.347449],
	            [-56.054136, -23.381894],
	            [-56.038695, -23.391636],
	            [-56.030524, -23.38142],
	            [-55.89919, -23.392179],
	            [-55.895537, -23.41858],
	            [-55.916926, -23.475576],
	            [-55.903889, -23.499117],
	            [-55.921335, -23.539403],
	            [-55.930221, -23.547909],
	            [-55.932788, -23.575685],
	            [-55.92952, -23.599941],
	            [-55.93194, -23.621285],
	            [-55.952101, -23.642751],
	            [-55.953791, -23.65475],
	            [-55.980663, -23.667947],
	            [-56.000919, -23.623406],
	            [-56.021576, -23.599062],
	            [-56.047371, -23.587458],
	            [-56.069867, -23.607776],
	            [-56.09405, -23.602035],
	            [-56.114045, -23.605876],
	            [-56.110924, -23.592839],
	            [-56.135744, -23.565286],
	            [-56.143783, -23.533633],
	            [-56.135212, -23.513132],
	            [-56.147186, -23.492972],
	            [-56.165695, -23.471384],
	            [-56.166538, -23.451861],
	            [-56.154287, -23.423068],
	            [-56.15573, -23.390808],
	            [-56.164556, -23.352693],
	            [-56.162519, -23.322706],
	            [-56.136607, -23.312903],
	            [-56.106598, -23.334907],
	            [-56.090216, -23.320659],
	            [-56.0666, -23.313129]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "AMAMBAY",
	        "dist_desc_": "KARAPAÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.309458, -24.439749],
	            [-54.322073, -24.411449],
	            [-54.340951, -24.396511],
	            [-54.339665, -24.383397],
	            [-54.377209, -24.390649],
	            [-54.375194, -24.381066],
	            [-54.39264, -24.366014],
	            [-54.412638, -24.37657],
	            [-54.41822, -24.364543],
	            [-54.412957, -24.342413],
	            [-54.430938, -24.327871],
	            [-54.445345, -24.324269],
	            [-54.447445, -24.307959],
	            [-54.447622, -24.307897],
	            [-54.421087, -24.27725],
	            [-54.421572, -24.245396],
	            [-54.41281, -24.233663],
	            [-54.42686, -24.217072],
	            [-54.458165, -24.211783],
	            [-54.542937, -24.147094],
	            [-54.530147, -24.133402],
	            [-54.541234, -24.118723],
	            [-54.542864, -24.0931],
	            [-54.608105, -24.042657],
	            [-54.606048, -24.019601],
	            [-54.612294, -24.008076],
	            [-54.606441, -23.976371],
	            [-54.643093, -23.965104],
	            [-54.69093, -23.974471],
	            [-54.715328, -23.964369],
	            [-54.719125, -23.936571],
	            [-54.738671, -23.866629],
	            [-54.705236, -23.864651],
	            [-54.698701, -23.842004],
	            [-54.668717, -23.817248],
	            [-54.652679, -23.821618],
	            [-54.646452, -23.833809],
	            [-54.616615, -23.835086],
	            [-54.609754, -23.851449],
	            [-54.581539, -23.845868],
	            [-54.564449, -23.854265],
	            [-54.568596, -23.874523],
	            [-54.543744, -23.868393],
	            [-54.523234, -23.873628],
	            [-54.51492, -23.885223],
	            [-54.492972, -23.885177],
	            [-54.486755, -23.894093],
	            [-54.439934, -23.904416],
	            [-54.426197, -23.915697],
	            [-54.426776, -23.931134],
	            [-54.414785, -23.95814],
	            [-54.394113, -23.965234],
	            [-54.383597, -23.986776],
	            [-54.351636, -24.007797],
	            [-54.315988, -24.004069],
	            [-54.287655, -24.032434],
	            [-54.292486, -24.052294],
	            [-54.280185, -24.067297],
	            [-54.319159, -24.106709],
	            [-54.33523, -24.1144],
	            [-54.346117, -24.152534],
	            [-54.327904, -24.197497],
	            [-54.330428, -24.229978],
	            [-54.315428, -24.258266],
	            [-54.291094, -24.277135],
	            [-54.273946, -24.304053],
	            [-54.259745, -24.346291],
	            [-54.259648, -24.365662],
	            [-54.283898, -24.411747],
	            [-54.309458, -24.439749]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "SALTO DEL GUAIRÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.82326, -23.889803],
	            [-54.820723, -24.045085],
	            [-54.818272, -24.061086],
	            [-54.815856, -24.17864],
	            [-54.820884, -24.188724],
	            [-54.81999, -24.259339],
	            [-54.824359, -24.260102],
	            [-54.822493, -24.318451],
	            [-54.845916, -24.303055],
	            [-54.872774, -24.333451],
	            [-54.879522, -24.347945],
	            [-54.893184, -24.354703],
	            [-54.912043, -24.341612],
	            [-54.921589, -24.347711],
	            [-54.941163, -24.327556],
	            [-54.983614, -24.299751],
	            [-54.98287, -24.286578],
	            [-54.996289, -24.272978],
	            [-54.994632, -24.247257],
	            [-55.004534, -24.176542],
	            [-55.032483, -24.165358],
	            [-55.038671, -24.144622],
	            [-55.051543, -24.137316],
	            [-55.076625, -24.134979],
	            [-55.084661, -24.14],
	            [-55.120535, -24.136099],
	            [-55.127058, -24.120383],
	            [-55.144614, -24.112129],
	            [-55.160378, -24.137049],
	            [-55.17744, -24.143133],
	            [-55.175846, -24.157831],
	            [-55.214436, -24.129643],
	            [-55.228132, -24.139197],
	            [-55.238958, -24.131779],
	            [-55.268066, -24.135222],
	            [-55.307545, -24.13134],
	            [-55.315047, -24.136227],
	            [-55.314604, -24.113792],
	            [-55.324553, -24.087666],
	            [-55.299419, -24.085633],
	            [-55.221515, -24.060111],
	            [-55.231217, -24.052751],
	            [-55.23807, -24.022793],
	            [-55.228737, -24.013829],
	            [-55.206878, -24.003624],
	            [-55.19842, -23.986693],
	            [-55.178746, -23.993818],
	            [-55.128834, -23.983765],
	            [-55.107055, -23.965292],
	            [-55.090453, -23.982641],
	            [-55.062445, -23.993344],
	            [-55.033386, -23.973959],
	            [-55.020205, -23.972684],
	            [-54.998684, -23.957639],
	            [-54.976526, -23.957757],
	            [-54.966773, -23.966209],
	            [-54.925358, -23.960353],
	            [-54.930422, -23.944391],
	            [-54.926968, -23.92486],
	            [-54.908764, -23.91143],
	            [-54.860207, -23.905276],
	            [-54.836371, -23.884021],
	            [-54.82326, -23.889803]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "CORPUS CHRISTI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.844013, -24.066661],
	            [-55.823974, -24.083541],
	            [-55.809844, -24.083223],
	            [-55.765327, -24.100731],
	            [-55.744213, -24.103265],
	            [-55.741071, -24.113799],
	            [-55.723134, -24.118938],
	            [-55.717579, -24.140817],
	            [-55.705469, -24.163057],
	            [-55.685817, -24.18419],
	            [-55.687557, -24.209253],
	            [-55.67833, -24.219331],
	            [-55.67743, -24.239028],
	            [-55.652096, -24.239042],
	            [-55.628604, -24.245174],
	            [-55.622946, -24.266007],
	            [-55.60703, -24.269456],
	            [-55.598261, -24.291966],
	            [-55.577658, -24.308111],
	            [-55.566208, -24.329924],
	            [-55.548877, -24.334342],
	            [-55.521774, -24.363034],
	            [-55.509314, -24.360833],
	            [-55.494082, -24.390931],
	            [-55.526808, -24.42087],
	            [-55.508001, -24.424528],
	            [-55.489375, -24.43978],
	            [-55.464874, -24.435384],
	            [-55.447143, -24.426769],
	            [-55.422858, -24.432721],
	            [-55.394941, -24.427646],
	            [-55.363972, -24.436407],
	            [-55.322082, -24.433312],
	            [-55.333374, -24.460944],
	            [-55.322406, -24.478439],
	            [-55.310341, -24.511868],
	            [-55.32944, -24.506011],
	            [-55.345172, -24.509034],
	            [-55.369768, -24.539964],
	            [-55.392659, -24.544614],
	            [-55.400627, -24.536478],
	            [-55.437838, -24.551255],
	            [-55.460479, -24.541427],
	            [-55.491108, -24.568021],
	            [-55.493706, -24.533788],
	            [-55.513492, -24.515307],
	            [-55.543932, -24.513539],
	            [-55.552465, -24.51865],
	            [-55.551627, -24.550859],
	            [-55.56419, -24.581454],
	            [-55.577875, -24.601239],
	            [-55.592494, -24.60245],
	            [-55.6018, -24.634745],
	            [-55.612427, -24.646075],
	            [-55.638464, -24.644827],
	            [-55.668465, -24.653189],
	            [-55.670795, -24.672122],
	            [-55.702707, -24.688919],
	            [-55.712726, -24.707917],
	            [-55.727095, -24.72135],
	            [-55.762171, -24.656149],
	            [-55.75262, -24.637621],
	            [-55.764637, -24.618531],
	            [-55.767042, -24.588372],
	            [-55.749205, -24.571361],
	            [-55.756564, -24.562266],
	            [-55.758221, -24.535527],
	            [-55.774658, -24.52585],
	            [-55.776825, -24.509175],
	            [-55.797316, -24.479787],
	            [-55.827921, -24.468732],
	            [-55.863683, -24.434938],
	            [-55.861381, -24.421495],
	            [-55.871485, -24.396627],
	            [-55.8976, -24.386528],
	            [-55.924184, -24.369996],
	            [-55.938791, -24.372457],
	            [-55.922346, -24.352549],
	            [-55.913695, -24.334024],
	            [-55.882226, -24.288628],
	            [-55.860115, -24.274854],
	            [-55.857529, -24.29006],
	            [-55.833878, -24.299203],
	            [-55.801719, -24.298041],
	            [-55.805633, -24.286608],
	            [-55.775785, -24.282713],
	            [-55.793868, -24.239769],
	            [-55.804074, -24.195476],
	            [-55.835332, -24.203947],
	            [-55.830325, -24.172585],
	            [-55.836826, -24.160732],
	            [-55.829909, -24.135655],
	            [-55.835908, -24.10989],
	            [-55.848579, -24.092421],
	            [-55.845777, -24.067284],
	            [-55.844013, -24.066661]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "VILLA CURUGUATY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.4141, -23.964813],
	            [-55.394334, -23.973515],
	            [-55.387616, -23.967492],
	            [-55.349329, -23.993549],
	            [-55.336099, -23.992949],
	            [-55.317725, -23.962891],
	            [-55.304178, -23.965023],
	            [-55.277802, -23.984555],
	            [-55.235377, -24.006624],
	            [-55.228737, -24.013829],
	            [-55.23807, -24.022793],
	            [-55.231217, -24.052751],
	            [-55.221515, -24.060111],
	            [-55.299419, -24.085633],
	            [-55.324553, -24.087666],
	            [-55.314604, -24.113792],
	            [-55.315047, -24.136227],
	            [-55.319694, -24.158608],
	            [-55.359683, -24.190231],
	            [-55.375537, -24.207658],
	            [-55.393115, -24.205735],
	            [-55.396772, -24.192122],
	            [-55.4238, -24.180695],
	            [-55.446891, -24.187612],
	            [-55.434712, -24.198172],
	            [-55.432065, -24.214995],
	            [-55.44328, -24.244569],
	            [-55.431841, -24.261085],
	            [-55.442863, -24.28393],
	            [-55.46539, -24.282123],
	            [-55.475663, -24.260316],
	            [-55.500562, -24.257809],
	            [-55.502032, -24.268736],
	            [-55.518113, -24.273571],
	            [-55.539749, -24.297819],
	            [-55.577658, -24.308111],
	            [-55.598261, -24.291966],
	            [-55.60703, -24.269456],
	            [-55.622946, -24.266007],
	            [-55.628604, -24.245174],
	            [-55.652096, -24.239042],
	            [-55.67743, -24.239028],
	            [-55.67833, -24.219331],
	            [-55.687557, -24.209253],
	            [-55.685817, -24.18419],
	            [-55.705469, -24.163057],
	            [-55.717579, -24.140817],
	            [-55.723134, -24.118938],
	            [-55.741071, -24.113799],
	            [-55.744213, -24.103265],
	            [-55.765327, -24.100731],
	            [-55.809844, -24.083223],
	            [-55.823974, -24.083541],
	            [-55.844013, -24.066661],
	            [-55.823698, -24.044287],
	            [-55.801582, -24.036895],
	            [-55.794636, -24.02561],
	            [-55.779108, -24.024648],
	            [-55.770342, -24.034295],
	            [-55.755119, -24.025204],
	            [-55.725149, -24.025838],
	            [-55.707131, -24.009387],
	            [-55.702849, -23.99352],
	            [-55.682172, -23.980976],
	            [-55.675476, -23.968221],
	            [-55.676667, -23.946503],
	            [-55.646683, -23.930267],
	            [-55.637661, -23.931903],
	            [-55.618037, -23.916348],
	            [-55.603412, -23.919251],
	            [-55.578017, -23.883912],
	            [-55.544864, -23.882811],
	            [-55.535781, -23.87323],
	            [-55.50695, -23.884823],
	            [-55.502869, -23.894658],
	            [-55.471609, -23.918999],
	            [-55.427431, -23.971693],
	            [-55.4141, -23.964813]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "VILLA YGATIMÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.453793, -23.81914],
	            [-55.511727, -23.797116],
	            [-55.528162, -23.802422],
	            [-55.540629, -23.796765],
	            [-55.598367, -23.820116],
	            [-55.62489, -23.837401],
	            [-55.640565, -23.852797],
	            [-55.688163, -23.868251],
	            [-55.707479, -23.902014],
	            [-55.727751, -23.903221],
	            [-56.0257, -23.828573],
	            [-56.027214, -23.822321],
	            [-55.991649, -23.82771],
	            [-55.951692, -23.812831],
	            [-55.930942, -23.830927],
	            [-55.917527, -23.817657],
	            [-55.899763, -23.821139],
	            [-55.886037, -23.807051],
	            [-55.859315, -23.799012],
	            [-55.857309, -23.784195],
	            [-55.839276, -23.763523],
	            [-55.800041, -23.751397],
	            [-55.769927, -23.736119],
	            [-55.753374, -23.691553],
	            [-55.707476, -23.660665],
	            [-55.662524, -23.675578],
	            [-55.641461, -23.668499],
	            [-55.630333, -23.656923],
	            [-55.600351, -23.652925],
	            [-55.586656, -23.637399],
	            [-55.571773, -23.579081],
	            [-55.544369, -23.539317],
	            [-55.543421, -23.523665],
	            [-55.536226, -23.554944],
	            [-55.52659, -23.567341],
	            [-55.538274, -23.591854],
	            [-55.530508, -23.627821],
	            [-55.510424, -23.632556],
	            [-55.474763, -23.650422],
	            [-55.475337, -23.673729],
	            [-55.462246, -23.683898],
	            [-55.466584, -23.703439],
	            [-55.442129, -23.727941],
	            [-55.448677, -23.742265],
	            [-55.443276, -23.765659],
	            [-55.433864, -23.77103],
	            [-55.430187, -23.790131],
	            [-55.453793, -23.81914]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "ITANARÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.453793, -23.81914],
	            [-55.441561, -23.829217],
	            [-55.435679, -23.872306],
	            [-55.439481, -23.904891],
	            [-55.44638, -23.916834],
	            [-55.42789, -23.926306],
	            [-55.4141, -23.964813],
	            [-55.427431, -23.971693],
	            [-55.471609, -23.918999],
	            [-55.502869, -23.894658],
	            [-55.50695, -23.884823],
	            [-55.535781, -23.87323],
	            [-55.544864, -23.882811],
	            [-55.578017, -23.883912],
	            [-55.603412, -23.919251],
	            [-55.618037, -23.916348],
	            [-55.637661, -23.931903],
	            [-55.646683, -23.930267],
	            [-55.676667, -23.946503],
	            [-55.675476, -23.968221],
	            [-55.682172, -23.980976],
	            [-55.702849, -23.99352],
	            [-55.707131, -24.009387],
	            [-55.725149, -24.025838],
	            [-55.755119, -24.025204],
	            [-55.770342, -24.034295],
	            [-55.779108, -24.024648],
	            [-55.794636, -24.02561],
	            [-55.801582, -24.036895],
	            [-55.823698, -24.044287],
	            [-55.844013, -24.066661],
	            [-55.845777, -24.067284],
	            [-55.86868, -24.068876],
	            [-55.887589, -24.05121],
	            [-55.922912, -24.061552],
	            [-55.960326, -24.049306],
	            [-55.977107, -24.028614],
	            [-56.004341, -23.91669],
	            [-56.0257, -23.828573],
	            [-55.727751, -23.903221],
	            [-55.707479, -23.902014],
	            [-55.688163, -23.868251],
	            [-55.640565, -23.852797],
	            [-55.62489, -23.837401],
	            [-55.598367, -23.820116],
	            [-55.540629, -23.796765],
	            [-55.528162, -23.802422],
	            [-55.511727, -23.797116],
	            [-55.453793, -23.81914]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "YPEJHÚ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.738671, -23.866629],
	            [-54.719125, -23.936571],
	            [-54.715328, -23.964369],
	            [-54.69093, -23.974471],
	            [-54.700788, -23.992191],
	            [-54.706105, -24.021181],
	            [-54.698781, -24.058164],
	            [-54.683915, -24.089513],
	            [-54.653665, -24.132093],
	            [-54.615599, -24.198306],
	            [-54.588979, -24.268115],
	            [-54.581753, -24.277613],
	            [-54.593997, -24.290972],
	            [-54.594873, -24.313296],
	            [-54.603027, -24.332665],
	            [-54.602587, -24.368068],
	            [-54.579236, -24.384045],
	            [-54.603881, -24.418864],
	            [-54.620971, -24.425588],
	            [-54.637158, -24.441454],
	            [-54.603578, -24.472279],
	            [-54.611941, -24.513567],
	            [-54.612566, -24.513437],
	            [-54.625611, -24.513783],
	            [-54.648225, -24.499731],
	            [-54.672339, -24.495375],
	            [-54.696262, -24.49729],
	            [-54.712784, -24.466358],
	            [-54.70344, -24.410185],
	            [-54.692385, -24.382323],
	            [-54.662716, -24.367799],
	            [-54.677271, -24.289994],
	            [-54.677462, -24.274179],
	            [-54.687948, -24.245369],
	            [-54.712973, -24.213678],
	            [-54.717242, -24.190794],
	            [-54.741953, -24.199162],
	            [-54.770834, -24.193938],
	            [-54.751882, -24.179374],
	            [-54.763493, -24.16201],
	            [-54.781976, -24.154767],
	            [-54.797462, -24.168225],
	            [-54.785067, -24.180669],
	            [-54.804868, -24.190072],
	            [-54.815856, -24.17864],
	            [-54.818272, -24.061086],
	            [-54.820723, -24.045085],
	            [-54.82326, -23.889803],
	            [-54.792895, -23.868137],
	            [-54.764121, -23.866273],
	            [-54.759219, -23.856778],
	            [-54.738671, -23.866629]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "FRANCISCO CABALLERO ALVAREZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.712784, -24.466358],
	            [-54.958574, -24.447323],
	            [-54.961605, -24.432792],
	            [-54.95393, -24.419589],
	            [-54.957234, -24.405099],
	            [-54.954066, -24.374045],
	            [-54.933543, -24.363009],
	            [-54.921589, -24.347711],
	            [-54.912043, -24.341612],
	            [-54.893184, -24.354703],
	            [-54.879522, -24.347945],
	            [-54.872774, -24.333451],
	            [-54.845916, -24.303055],
	            [-54.822493, -24.318451],
	            [-54.824359, -24.260102],
	            [-54.81999, -24.259339],
	            [-54.820884, -24.188724],
	            [-54.815856, -24.17864],
	            [-54.804868, -24.190072],
	            [-54.785067, -24.180669],
	            [-54.797462, -24.168225],
	            [-54.781976, -24.154767],
	            [-54.763493, -24.16201],
	            [-54.751882, -24.179374],
	            [-54.770834, -24.193938],
	            [-54.741953, -24.199162],
	            [-54.717242, -24.190794],
	            [-54.712973, -24.213678],
	            [-54.687948, -24.245369],
	            [-54.677462, -24.274179],
	            [-54.677271, -24.289994],
	            [-54.662716, -24.367799],
	            [-54.692385, -24.382323],
	            [-54.70344, -24.410185],
	            [-54.712784, -24.466358]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "KATUETÉ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.000321, -26.176082],
	            [-58.027544, -26.202069],
	            [-58.018789, -26.219326],
	            [-58.025469, -26.25041],
	            [-58.072516, -26.238411],
	            [-58.088464, -26.223222],
	            [-58.105381, -26.222758],
	            [-58.121177, -26.208122],
	            [-58.142941, -26.197944],
	            [-58.143359, -26.178431],
	            [-58.120511, -26.186224],
	            [-58.115063, -26.148155],
	            [-58.094209, -26.125613],
	            [-58.035254, -26.162517],
	            [-58.022942, -26.159287],
	            [-58.000321, -26.176082]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "ALBERDI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.840658, -27.105986],
	            [-55.716971, -27.216669],
	            [-55.745813, -27.242581],
	            [-55.68832, -27.293815],
	            [-55.717075, -27.319519],
	            [-55.7967, -27.2487],
	            [-55.803112, -27.268111],
	            [-55.818366, -27.267267],
	            [-55.82219, -27.226416],
	            [-55.926239, -27.134262],
	            [-55.923001, -27.112599],
	            [-55.903694, -27.092549],
	            [-55.885537, -27.081464],
	            [-55.878446, -27.075518],
	            [-55.840658, -27.105986]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "CAPITÁN MIRANDA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.611695, -27.167655],
	            [-55.620033, -27.18235],
	            [-55.620231, -27.2048],
	            [-55.580036, -27.236588],
	            [-55.577538, -27.265363],
	            [-55.601213, -27.286144],
	            [-55.590751, -27.326275],
	            [-55.628783, -27.357149],
	            [-55.662177, -27.370152],
	            [-55.717075, -27.319519],
	            [-55.68832, -27.293815],
	            [-55.745813, -27.242581],
	            [-55.716971, -27.216669],
	            [-55.69147, -27.188583],
	            [-55.672737, -27.17969],
	            [-55.653309, -27.162701],
	            [-55.626276, -27.153087],
	            [-55.620825, -27.142002],
	            [-55.611695, -27.167655]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "NUEVA ALBORADA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.993186, -27.189335],
	            [-56.020418, -27.21402],
	            [-56.019438, -27.225988],
	            [-56.032841, -27.275569],
	            [-56.046397, -27.291692],
	            [-56.046522, -27.306623],
	            [-56.098127, -27.308322],
	            [-56.124613, -27.306457],
	            [-56.168231, -27.297061],
	            [-56.168952, -27.266893],
	            [-56.181851, -27.239675],
	            [-56.181177, -27.227234],
	            [-56.167893, -27.20465],
	            [-56.169738, -27.1515],
	            [-56.147174, -27.136496],
	            [-56.146439, -27.121438],
	            [-56.134739, -27.112273],
	            [-56.12883, -27.069365],
	            [-55.993186, -27.189335]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "CARMEN DEL PARANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.766356, -24.075947],
	            [-56.769552, -24.098516],
	            [-56.780758, -24.112112],
	            [-56.769101, -24.125427],
	            [-56.797205, -24.130219],
	            [-56.798111, -24.15244],
	            [-56.806096, -24.165845],
	            [-56.811618, -24.194675],
	            [-56.849061, -24.200776],
	            [-56.9441, -24.197053],
	            [-56.949734, -24.187484],
	            [-56.986365, -24.176337],
	            [-56.999125, -24.167662],
	            [-57.036353, -24.178399],
	            [-57.048744, -24.188076],
	            [-57.089094, -24.196215],
	            [-57.08186, -24.187982],
	            [-57.089784, -24.132353],
	            [-57.075416, -24.133101],
	            [-57.062976, -24.119001],
	            [-57.043497, -24.120208],
	            [-57.03823, -24.107692],
	            [-57.011514, -24.105377],
	            [-56.984064, -24.089455],
	            [-56.974026, -24.096286],
	            [-56.960987, -24.085001],
	            [-56.943437, -24.090386],
	            [-56.923023, -24.08787],
	            [-56.904325, -24.074131],
	            [-56.891684, -24.0876],
	            [-56.869619, -24.073228],
	            [-56.859365, -24.085254],
	            [-56.839284, -24.090923],
	            [-56.818263, -24.07233],
	            [-56.796562, -24.077155],
	            [-56.776273, -24.067989],
	            [-56.766356, -24.075947]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "SAN PABLO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.538868, -24.770441],
	            [-56.550679, -24.771389],
	            [-56.564483, -24.789161],
	            [-56.594692, -24.80111],
	            [-56.615011, -24.803457],
	            [-56.637784, -24.813914],
	            [-56.654655, -24.802509],
	            [-56.687431, -24.81002],
	            [-56.680974, -24.856678],
	            [-56.684737, -24.868785],
	            [-56.689171, -24.878729],
	            [-56.708214, -24.876302],
	            [-56.720094, -24.888079],
	            [-56.735332, -24.889018],
	            [-56.749103, -24.873426],
	            [-56.767447, -24.866964],
	            [-56.812222, -24.868367],
	            [-56.842861, -24.877233],
	            [-56.860323, -24.875747],
	            [-56.949319, -24.843279],
	            [-56.954112, -24.863688],
	            [-56.983023, -24.878519],
	            [-56.980249, -24.896666],
	            [-56.989293, -24.922646],
	            [-57.004552, -24.942307],
	            [-57.015346, -24.965914],
	            [-57.030568, -24.977489],
	            [-57.053443, -24.921408],
	            [-57.054076, -24.90801],
	            [-57.037692, -24.882633],
	            [-57.055711, -24.865224],
	            [-57.048331, -24.848501],
	            [-57.059916, -24.840513],
	            [-57.041338, -24.819165],
	            [-57.050303, -24.795039],
	            [-57.027052, -24.782844],
	            [-57.010843, -24.785379],
	            [-57.001263, -24.756031],
	            [-57.004635, -24.719734],
	            [-56.963375, -24.728157],
	            [-56.901557, -24.736438],
	            [-56.890849, -24.728014],
	            [-56.904983, -24.7056],
	            [-56.907124, -24.690324],
	            [-56.894275, -24.681329],
	            [-56.860582, -24.698604],
	            [-56.853927, -24.678462],
	            [-56.873974, -24.678898],
	            [-56.889719, -24.663497],
	            [-56.872572, -24.656109],
	            [-56.861314, -24.640233],
	            [-56.83131, -24.648172],
	            [-56.809212, -24.643518],
	            [-56.78092, -24.643728],
	            [-56.767985, -24.671777],
	            [-56.753991, -24.670903],
	            [-56.742969, -24.651413],
	            [-56.727621, -24.670219],
	            [-56.704115, -24.643025],
	            [-56.710401, -24.664757],
	            [-56.685778, -24.675031],
	            [-56.668654, -24.660227],
	            [-56.629563, -24.653275],
	            [-56.573363, -24.632804],
	            [-56.553135, -24.632157],
	            [-56.539387, -24.646881],
	            [-56.562544, -24.678307],
	            [-56.568268, -24.705683],
	            [-56.552849, -24.744365],
	            [-56.538868, -24.770441]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "25 DE DICIEMBRE"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.811618, -24.194675],
	            [-56.819757, -24.226506],
	            [-56.819768, -24.276691],
	            [-56.850303, -24.302786],
	            [-56.853703, -24.311252],
	            [-56.884139, -24.341542],
	            [-56.907838, -24.360388],
	            [-56.945386, -24.396651],
	            [-56.96209, -24.379947],
	            [-56.97965, -24.404217],
	            [-57.007918, -24.41778],
	            [-56.989787, -24.449475],
	            [-56.997639, -24.481455],
	            [-56.997211, -24.525427],
	            [-56.982458, -24.535926],
	            [-56.968229, -24.557122],
	            [-57.025193, -24.658201],
	            [-57.0152, -24.672906],
	            [-57.024479, -24.684613],
	            [-57.033474, -24.714594],
	            [-57.004635, -24.719734],
	            [-57.001263, -24.756031],
	            [-57.010843, -24.785379],
	            [-57.027052, -24.782844],
	            [-57.050303, -24.795039],
	            [-57.041338, -24.819165],
	            [-57.059916, -24.840513],
	            [-57.048331, -24.848501],
	            [-57.055711, -24.865224],
	            [-57.037692, -24.882633],
	            [-57.054076, -24.90801],
	            [-57.053443, -24.921408],
	            [-57.030568, -24.977489],
	            [-57.048962, -24.984312],
	            [-57.039551, -25.00407],
	            [-57.050596, -25.012718],
	            [-57.066075, -25.003591],
	            [-57.103678, -25.010618],
	            [-57.120214, -25.00661],
	            [-57.160999, -24.973513],
	            [-57.199748, -24.971682],
	            [-57.236079, -24.956669],
	            [-57.257124, -24.954286],
	            [-57.269082, -24.924028],
	            [-57.24383, -24.935],
	            [-57.223572, -24.932765],
	            [-57.216592, -24.920651],
	            [-57.21967, -24.904729],
	            [-57.249341, -24.894825],
	            [-57.259757, -24.885631],
	            [-57.257468, -24.86014],
	            [-57.291723, -24.851466],
	            [-57.298504, -24.831286],
	            [-57.265434, -24.810102],
	            [-57.246369, -24.774159],
	            [-57.232066, -24.756792],
	            [-57.226572, -24.738273],
	            [-57.234583, -24.709879],
	            [-57.227118, -24.697197],
	            [-57.196238, -24.698261],
	            [-57.172417, -24.692456],
	            [-57.174728, -24.659764],
	            [-57.157441, -24.618256],
	            [-57.190109, -24.582187],
	            [-57.194797, -24.569149],
	            [-57.187958, -24.552788],
	            [-57.162167, -24.534117],
	            [-57.163638, -24.522844],
	            [-57.194061, -24.493401],
	            [-57.187103, -24.476981],
	            [-57.157995, -24.466646],
	            [-57.149308, -24.44898],
	            [-57.167715, -24.421707],
	            [-57.181411, -24.393309],
	            [-57.177552, -24.375919],
	            [-57.164042, -24.355937],
	            [-57.180308, -24.312634],
	            [-57.198583, -24.296633],
	            [-57.206462, -24.27594],
	            [-57.204586, -24.26132],
	            [-57.179011, -24.266654],
	            [-57.134941, -24.26013],
	            [-57.108529, -24.251135],
	            [-57.103675, -24.242284],
	            [-57.077692, -24.243426],
	            [-57.08326, -24.224723],
	            [-57.09925, -24.203308],
	            [-57.089094, -24.196215],
	            [-57.048744, -24.188076],
	            [-57.036353, -24.178399],
	            [-56.999125, -24.167662],
	            [-56.986365, -24.176337],
	            [-56.949734, -24.187484],
	            [-56.9441, -24.197053],
	            [-56.849061, -24.200776],
	            [-56.811618, -24.194675]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "VILLA DEL ROSARIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.02729, -23.822219],
	            [-56.027214, -23.822321],
	            [-56.0257, -23.828573],
	            [-56.004341, -23.91669],
	            [-56.014811, -23.924913],
	            [-56.048626, -23.924919],
	            [-56.052487, -23.948239],
	            [-56.072426, -23.946685],
	            [-56.073823, -23.959228],
	            [-56.187307, -23.948024],
	            [-56.200347, -23.980981],
	            [-56.203994, -24.00058],
	            [-56.224387, -24.020584],
	            [-56.231259, -24.016141],
	            [-56.250519, -24.034491],
	            [-56.229111, -24.063194],
	            [-56.229147, -24.093259],
	            [-56.189737, -24.098081],
	            [-56.18662, -24.129195],
	            [-56.202666, -24.143846],
	            [-56.22343, -24.15878],
	            [-56.245, -24.153739],
	            [-56.260197, -24.157525],
	            [-56.27656, -24.147582],
	            [-56.287026, -24.152108],
	            [-56.316651, -24.133964],
	            [-56.329637, -24.140076],
	            [-56.368464, -24.119805],
	            [-56.39265, -24.120089],
	            [-56.414384, -24.10318],
	            [-56.428388, -24.110106],
	            [-56.452727, -24.093498],
	            [-56.464863, -24.078319],
	            [-56.458105, -24.073718],
	            [-56.448687, -24.046314],
	            [-56.429338, -24.019386],
	            [-56.370375, -23.947518],
	            [-56.369717, -23.915129],
	            [-56.33013, -23.920308],
	            [-56.301163, -23.914211],
	            [-56.286735, -23.919189],
	            [-56.260562, -23.897712],
	            [-56.243592, -23.904991],
	            [-56.220009, -23.898],
	            [-56.204314, -23.878369],
	            [-56.174422, -23.860184],
	            [-56.136837, -23.867407],
	            [-56.122868, -23.859706],
	            [-56.097725, -23.859026],
	            [-56.081813, -23.848902],
	            [-56.055578, -23.842359],
	            [-56.02729, -23.822219]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "GENERAL FRANCISCO ISIDORO RESQUÍN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.219968, -25.265591],
	            [-55.248298, -25.252297],
	            [-55.289862, -25.251734],
	            [-55.307153, -25.277279],
	            [-55.32846, -25.33526],
	            [-55.355386, -25.357609],
	            [-55.378436, -25.361914],
	            [-55.417028, -25.362798],
	            [-55.481062, -25.355105],
	            [-55.507797, -25.345503],
	            [-55.513194, -25.31071],
	            [-55.545577, -25.274248],
	            [-55.557725, -25.267269],
	            [-55.564704, -25.254208],
	            [-55.541818, -25.251375],
	            [-55.542382, -25.239612],
	            [-55.510804, -25.237546],
	            [-55.511065, -25.228502],
	            [-55.463912, -25.228834],
	            [-55.45367, -25.219371],
	            [-55.441192, -25.230638],
	            [-55.418211, -25.225008],
	            [-55.424101, -25.200288],
	            [-55.403844, -25.199962],
	            [-55.418148, -25.154697],
	            [-55.412968, -25.140638],
	            [-55.388691, -25.142119],
	            [-55.363075, -25.134097],
	            [-55.340186, -25.152131],
	            [-55.296841, -25.171167],
	            [-55.242094, -25.200438],
	            [-55.224168, -25.238349],
	            [-55.219968, -25.265591]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "TEMBIAPORÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.348866, -24.842709],
	            [-55.340843, -24.868244],
	            [-55.329277, -24.877442],
	            [-55.326876, -24.900817],
	            [-55.344111, -24.914792],
	            [-55.331563, -24.924489],
	            [-55.33469, -24.949664],
	            [-55.3311, -24.970963],
	            [-55.308838, -24.982178],
	            [-55.312739, -25.001805],
	            [-55.33585, -25.000012],
	            [-55.356896, -25.005297],
	            [-55.380003, -24.990766],
	            [-55.403666, -24.993568],
	            [-55.41055, -25.023848],
	            [-55.422312, -25.038546],
	            [-55.420659, -25.071352],
	            [-55.404069, -25.093414],
	            [-55.402366, -25.106807],
	            [-55.434485, -25.113142],
	            [-55.446607, -25.090014],
	            [-55.472955, -25.073697],
	            [-55.489112, -25.083523],
	            [-55.523404, -25.071214],
	            [-55.553831, -25.064159],
	            [-55.572749, -25.065042],
	            [-55.60709, -25.036077],
	            [-55.631199, -25.03999],
	            [-55.648726, -25.022999],
	            [-55.676851, -25.011667],
	            [-55.700167, -25.017125],
	            [-55.708073, -24.993322],
	            [-55.682672, -24.987434],
	            [-55.665345, -24.974168],
	            [-55.657521, -24.951116],
	            [-55.630877, -24.92729],
	            [-55.600989, -24.917611],
	            [-55.586, -24.901232],
	            [-55.559482, -24.901976],
	            [-55.548747, -24.893222],
	            [-55.530079, -24.890899],
	            [-55.457276, -24.893636],
	            [-55.422299, -24.8751],
	            [-55.400576, -24.879478],
	            [-55.377267, -24.864319],
	            [-55.364012, -24.831314],
	            [-55.348866, -24.842709]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAGUAZÚ",
	        "dist_desc_": "NUEVA TOLEDO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.180444, -26.063412],
	            [-56.179505, -26.071068],
	            [-56.202596, -26.095771],
	            [-56.212011, -26.122662],
	            [-56.223916, -26.129832],
	            [-56.198658, -26.155747],
	            [-56.164737, -26.1504],
	            [-56.140913, -26.141375],
	            [-56.127988, -26.126051],
	            [-56.104643, -26.130335],
	            [-56.113968, -26.162168],
	            [-56.118708, -26.181451],
	            [-56.129093, -26.181293],
	            [-56.148491, -26.201363],
	            [-56.15202, -26.213682],
	            [-56.145387, -26.249749],
	            [-56.167135, -26.266581],
	            [-56.183231, -26.262727],
	            [-56.213712, -26.279502],
	            [-56.218989, -26.296221],
	            [-56.246794, -26.303412],
	            [-56.260238, -26.368075],
	            [-56.275264, -26.378],
	            [-56.306767, -26.372697],
	            [-56.330928, -26.386441],
	            [-56.357216, -26.388721],
	            [-56.369488, -26.406595],
	            [-56.366203, -26.387544],
	            [-56.376161, -26.376609],
	            [-56.389548, -26.3572],
	            [-56.388572, -26.336235],
	            [-56.397334, -26.318515],
	            [-56.38275, -26.31719],
	            [-56.368098, -26.274188],
	            [-56.372398, -26.247656],
	            [-56.389328, -26.235915],
	            [-56.40079, -26.208356],
	            [-56.40231, -26.177733],
	            [-56.396427, -26.166543],
	            [-56.410134, -26.139789],
	            [-56.402443, -26.137133],
	            [-56.410906, -26.023869],
	            [-56.392453, -26.016739],
	            [-56.37144, -26.017638],
	            [-56.352383, -26.026281],
	            [-56.335464, -26.002497],
	            [-56.323347, -26.002197],
	            [-56.301645, -25.983688],
	            [-56.280961, -25.976187],
	            [-56.27254, -25.977978],
	            [-56.180444, -26.063412]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "CAAZAPÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.476412, -25.523741],
	            [-55.432483, -25.543784],
	            [-55.426062, -25.557542],
	            [-55.408404, -25.598393],
	            [-55.39926, -25.604094],
	            [-55.400011, -25.622747],
	            [-55.419411, -25.637492],
	            [-55.427199, -25.659704],
	            [-55.452592, -25.654134],
	            [-55.46278, -25.677548],
	            [-55.477607, -25.68364],
	            [-55.466178, -25.709268],
	            [-55.480194, -25.733308],
	            [-55.497341, -25.775743],
	            [-55.511496, -25.782718],
	            [-55.521961, -25.80619],
	            [-55.528283, -25.850023],
	            [-55.512066, -25.870352],
	            [-55.526787, -25.888793],
	            [-55.515895, -25.90193],
	            [-55.528221, -25.942823],
	            [-55.55064, -25.996946],
	            [-55.576381, -26.014491],
	            [-55.599051, -26.016482],
	            [-55.647214, -26.056155],
	            [-55.649988, -26.092339],
	            [-55.671505, -26.143801],
	            [-55.706748, -26.151186],
	            [-55.711541, -26.17896],
	            [-55.719781, -26.181281],
	            [-55.75648, -26.133586],
	            [-55.763874, -26.113141],
	            [-55.786827, -26.112163],
	            [-55.798881, -26.121107],
	            [-55.814448, -26.092024],
	            [-55.841676, -26.076464],
	            [-55.858792, -26.08998],
	            [-55.872729, -26.092031],
	            [-55.895175, -26.111896],
	            [-55.907119, -26.10996],
	            [-55.926982, -26.091366],
	            [-55.968379, -26.07054],
	            [-55.994792, -26.082021],
	            [-55.982042, -26.055148],
	            [-55.994164, -26.014396],
	            [-55.991104, -26.002658],
	            [-55.999427, -25.984514],
	            [-55.999178, -25.948351],
	            [-55.991184, -25.934484],
	            [-56.00921, -25.922469],
	            [-56.02716, -25.892457],
	            [-56.009762, -25.877585],
	            [-55.997689, -25.872776],
	            [-55.983205, -25.854364],
	            [-55.93567, -25.854463],
	            [-55.912355, -25.876045],
	            [-55.887567, -25.855247],
	            [-55.867591, -25.819641],
	            [-55.848217, -25.802523],
	            [-55.823717, -25.797352],
	            [-55.813625, -25.784088],
	            [-55.789392, -25.78833],
	            [-55.778722, -25.776616],
	            [-55.755193, -25.771686],
	            [-55.765212, -25.726537],
	            [-55.73582, -25.710407],
	            [-55.703147, -25.721492],
	            [-55.689608, -25.742986],
	            [-55.674354, -25.738374],
	            [-55.662527, -25.699718],
	            [-55.643693, -25.676042],
	            [-55.633585, -25.65027],
	            [-55.614144, -25.648977],
	            [-55.590661, -25.656408],
	            [-55.573884, -25.634279],
	            [-55.56187, -25.637357],
	            [-55.546121, -25.619203],
	            [-55.53396, -25.579993],
	            [-55.514017, -25.562642],
	            [-55.495888, -25.561066],
	            [-55.476412, -25.523741]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "ABAÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.08594, -26.28996],
	            [-56.09798, -26.285733],
	            [-56.103594, -26.271019],
	            [-56.129242, -26.247147],
	            [-56.145387, -26.249749],
	            [-56.15202, -26.213682],
	            [-56.148491, -26.201363],
	            [-56.129093, -26.181293],
	            [-56.118708, -26.181451],
	            [-56.113968, -26.162168],
	            [-56.035557, -26.155752],
	            [-56.021741, -26.162129],
	            [-56.026579, -26.177743],
	            [-56.055047, -26.199556],
	            [-56.05916, -26.210689],
	            [-56.015073, -26.230866],
	            [-56.027606, -26.247727],
	            [-56.040685, -26.285471],
	            [-56.049793, -26.281779],
	            [-56.08594, -26.28996]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "BUENA VISTA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.397334, -26.318515],
	            [-56.388572, -26.336235],
	            [-56.389548, -26.3572],
	            [-56.376161, -26.376609],
	            [-56.400539, -26.376564],
	            [-56.4208, -26.365655],
	            [-56.422631, -26.388908],
	            [-56.434169, -26.39252],
	            [-56.441563, -26.413562],
	            [-56.546014, -26.479377],
	            [-56.576863, -26.478297],
	            [-56.79594, -26.492734],
	            [-56.805035, -26.489874],
	            [-56.787159, -26.462082],
	            [-56.791365, -26.434187],
	            [-56.781246, -26.434359],
	            [-56.759429, -26.415425],
	            [-56.763958, -26.391534],
	            [-56.755367, -26.366029],
	            [-56.738884, -26.365066],
	            [-56.736365, -26.334299],
	            [-56.72243, -26.326858],
	            [-56.725113, -26.312683],
	            [-56.699077, -26.300785],
	            [-56.693793, -26.287431],
	            [-56.647517, -26.283029],
	            [-56.639385, -26.287727],
	            [-56.590885, -26.296129],
	            [-56.549209, -26.280785],
	            [-56.535779, -26.28393],
	            [-56.512015, -26.264216],
	            [-56.460852, -26.274317],
	            [-56.398325, -26.312839],
	            [-56.397334, -26.318515]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "DOCTOR MOISÉS S. BERTONI"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.02716, -25.892457],
	            [-56.00921, -25.922469],
	            [-55.991184, -25.934484],
	            [-55.999178, -25.948351],
	            [-55.999427, -25.984514],
	            [-55.991104, -26.002658],
	            [-55.994164, -26.014396],
	            [-55.982042, -26.055148],
	            [-55.994792, -26.082021],
	            [-56.016369, -26.089317],
	            [-56.033084, -26.083186],
	            [-56.087031, -26.109726],
	            [-56.104643, -26.130335],
	            [-56.127988, -26.126051],
	            [-56.140913, -26.141375],
	            [-56.164737, -26.1504],
	            [-56.198658, -26.155747],
	            [-56.223916, -26.129832],
	            [-56.212011, -26.122662],
	            [-56.202596, -26.095771],
	            [-56.179505, -26.071068],
	            [-56.180444, -26.063412],
	            [-56.161596, -26.054514],
	            [-56.136796, -26.030134],
	            [-56.120771, -26.027396],
	            [-56.099252, -26.019043],
	            [-56.048453, -25.89086],
	            [-56.02716, -25.892457]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "GENERAL HIGINIO MORINIGO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.410134, -26.139789],
	            [-56.396427, -26.166543],
	            [-56.40231, -26.177733],
	            [-56.40079, -26.208356],
	            [-56.389328, -26.235915],
	            [-56.372398, -26.247656],
	            [-56.368098, -26.274188],
	            [-56.38275, -26.31719],
	            [-56.397334, -26.318515],
	            [-56.398325, -26.312839],
	            [-56.460852, -26.274317],
	            [-56.512015, -26.264216],
	            [-56.535779, -26.28393],
	            [-56.549209, -26.280785],
	            [-56.590885, -26.296129],
	            [-56.639385, -26.287727],
	            [-56.647517, -26.283029],
	            [-56.693793, -26.287431],
	            [-56.694399, -26.260439],
	            [-56.684218, -26.253538],
	            [-56.673942, -26.227274],
	            [-56.638871, -26.221206],
	            [-56.629165, -26.194631],
	            [-56.615798, -26.176472],
	            [-56.603696, -26.173139],
	            [-56.586182, -26.185884],
	            [-56.561302, -26.188953],
	            [-56.538739, -26.14871],
	            [-56.546402, -26.128445],
	            [-56.532745, -26.121778],
	            [-56.48085, -26.116594],
	            [-56.437506, -26.119072],
	            [-56.410134, -26.139789]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "MACIEL"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.711541, -26.17896],
	            [-55.697986, -26.206103],
	            [-55.722551, -26.222542],
	            [-55.723049, -26.26037],
	            [-55.740481, -26.298435],
	            [-55.761511, -26.304516],
	            [-55.764804, -26.318858],
	            [-55.755231, -26.334898],
	            [-55.758967, -26.346342],
	            [-55.788029, -26.346485],
	            [-55.802138, -26.357404],
	            [-55.803671, -26.387667],
	            [-55.823708, -26.40854],
	            [-55.818978, -26.414306],
	            [-55.835524, -26.435486],
	            [-55.851127, -26.439226],
	            [-55.849836, -26.416783],
	            [-55.871097, -26.394537],
	            [-55.881498, -26.363772],
	            [-55.894049, -26.358154],
	            [-55.918938, -26.366045],
	            [-55.936871, -26.36511],
	            [-55.951607, -26.375646],
	            [-55.964852, -26.375404],
	            [-55.96845, -26.347017],
	            [-55.986011, -26.343019],
	            [-56.015689, -26.358261],
	            [-56.025956, -26.349645],
	            [-56.05309, -26.358637],
	            [-56.104082, -26.337487],
	            [-56.071086, -26.295124],
	            [-56.08594, -26.28996],
	            [-56.049793, -26.281779],
	            [-56.040685, -26.285471],
	            [-56.027606, -26.247727],
	            [-56.015073, -26.230866],
	            [-56.05916, -26.210689],
	            [-56.055047, -26.199556],
	            [-56.026579, -26.177743],
	            [-56.021741, -26.162129],
	            [-56.035557, -26.155752],
	            [-56.113968, -26.162168],
	            [-56.104643, -26.130335],
	            [-56.087031, -26.109726],
	            [-56.033084, -26.083186],
	            [-56.016369, -26.089317],
	            [-55.994792, -26.082021],
	            [-55.968379, -26.07054],
	            [-55.926982, -26.091366],
	            [-55.907119, -26.10996],
	            [-55.895175, -26.111896],
	            [-55.872729, -26.092031],
	            [-55.858792, -26.08998],
	            [-55.841676, -26.076464],
	            [-55.814448, -26.092024],
	            [-55.798881, -26.121107],
	            [-55.786827, -26.112163],
	            [-55.763874, -26.113141],
	            [-55.75648, -26.133586],
	            [-55.719781, -26.181281],
	            [-55.711541, -26.17896]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "SAN JUAN NEPOMUCENO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.357259, -25.993078],
	            [-55.327943, -26.022099],
	            [-55.28759, -26.049178],
	            [-55.253528, -26.043205],
	            [-55.249222, -26.058675],
	            [-55.249651, -26.069093],
	            [-55.286861, -26.090758],
	            [-55.299558, -26.103186],
	            [-55.317148, -26.097023],
	            [-55.334594, -26.104511],
	            [-55.347285, -26.11813],
	            [-55.343039, -26.148815],
	            [-55.354241, -26.201153],
	            [-55.367148, -26.210066],
	            [-55.357302, -26.230951],
	            [-55.360003, -26.269488],
	            [-55.375114, -26.297436],
	            [-55.391636, -26.310047],
	            [-55.452063, -26.324578],
	            [-55.482375, -26.310219],
	            [-55.507194, -26.307913],
	            [-55.513137, -26.313866],
	            [-55.498236, -26.350111],
	            [-55.532806, -26.355603],
	            [-55.545852, -26.366186],
	            [-55.562965, -26.367225],
	            [-55.567476, -26.390021],
	            [-55.595002, -26.416836],
	            [-55.612579, -26.409338],
	            [-55.63269, -26.392207],
	            [-55.651582, -26.372855],
	            [-55.684837, -26.361076],
	            [-55.717589, -26.36205],
	            [-55.736492, -26.379547],
	            [-55.766044, -26.39383],
	            [-55.803671, -26.387667],
	            [-55.802138, -26.357404],
	            [-55.788029, -26.346485],
	            [-55.758967, -26.346342],
	            [-55.755231, -26.334898],
	            [-55.764804, -26.318858],
	            [-55.761511, -26.304516],
	            [-55.740481, -26.298435],
	            [-55.723049, -26.26037],
	            [-55.722551, -26.222542],
	            [-55.697986, -26.206103],
	            [-55.711541, -26.17896],
	            [-55.706748, -26.151186],
	            [-55.671505, -26.143801],
	            [-55.649988, -26.092339],
	            [-55.647214, -26.056155],
	            [-55.599051, -26.016482],
	            [-55.576381, -26.014491],
	            [-55.55064, -25.996946],
	            [-55.501749, -25.986196],
	            [-55.432133, -26.006918],
	            [-55.411279, -25.998593],
	            [-55.40175, -26.026031],
	            [-55.391728, -26.035087],
	            [-55.376636, -26.017328],
	            [-55.378425, -26.000864],
	            [-55.357259, -25.993078]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "TAVAÍ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.376161, -26.376609],
	            [-56.366203, -26.387544],
	            [-56.369488, -26.406595],
	            [-56.351916, -26.431243],
	            [-56.346112, -26.459309],
	            [-56.338038, -26.46521],
	            [-56.340281, -26.486268],
	            [-56.33006, -26.491469],
	            [-56.330163, -26.521246],
	            [-56.340568, -26.543475],
	            [-56.339346, -26.563752],
	            [-56.330937, -26.595554],
	            [-56.340105, -26.612293],
	            [-56.366111, -26.618834],
	            [-56.4148, -26.594038],
	            [-56.459064, -26.609232],
	            [-56.482715, -26.623366],
	            [-56.503311, -26.620353],
	            [-56.536199, -26.626844],
	            [-56.582504, -26.665603],
	            [-56.600576, -26.667023],
	            [-56.608461, -26.680904],
	            [-56.624924, -26.674588],
	            [-56.635073, -26.681476],
	            [-56.63568, -26.668611],
	            [-56.666235, -26.657003],
	            [-56.703661, -26.653583],
	            [-56.716518, -26.648052],
	            [-56.74061, -26.622067],
	            [-56.753325, -26.635502],
	            [-56.766468, -26.635655],
	            [-56.777467, -26.619114],
	            [-56.79784, -26.62048],
	            [-56.814409, -26.60365],
	            [-56.821245, -26.587204],
	            [-56.813814, -26.566978],
	            [-56.820651, -26.543998],
	            [-56.848325, -26.541554],
	            [-56.846848, -26.529396],
	            [-56.811707, -26.487158],
	            [-56.805035, -26.489874],
	            [-56.79594, -26.492734],
	            [-56.576863, -26.478297],
	            [-56.546014, -26.479377],
	            [-56.441563, -26.413562],
	            [-56.434169, -26.39252],
	            [-56.422631, -26.388908],
	            [-56.4208, -26.365655],
	            [-56.400539, -26.376564],
	            [-56.376161, -26.376609]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "YEGROS"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.275264, -26.378],
	            [-56.24998, -26.391672],
	            [-56.230832, -26.4096],
	            [-56.216591, -26.413752],
	            [-56.210641, -26.427787],
	            [-56.184984, -26.437517],
	            [-56.144752, -26.472265],
	            [-56.1358, -26.493834],
	            [-56.108004, -26.520889],
	            [-56.094861, -26.550894],
	            [-56.10615, -26.562982],
	            [-56.121747, -26.595897],
	            [-56.116496, -26.626097],
	            [-56.130645, -26.634806],
	            [-56.155789, -26.639919],
	            [-56.159533, -26.656305],
	            [-56.175564, -26.662529],
	            [-56.184779, -26.678919],
	            [-56.175596, -26.706033],
	            [-56.184914, -26.711174],
	            [-56.216052, -26.69764],
	            [-56.254838, -26.701921],
	            [-56.283807, -26.718411],
	            [-56.31363, -26.729115],
	            [-56.353063, -26.7244],
	            [-56.370124, -26.738914],
	            [-56.383767, -26.741123],
	            [-56.431168, -26.774826],
	            [-56.461416, -26.773048],
	            [-56.477889, -26.786486],
	            [-56.501938, -26.791827],
	            [-56.508777, -26.780195],
	            [-56.52848, -26.778316],
	            [-56.538692, -26.758107],
	            [-56.573014, -26.758359],
	            [-56.60341, -26.74309],
	            [-56.623234, -26.747297],
	            [-56.658796, -26.726241],
	            [-56.649056, -26.706291],
	            [-56.652459, -26.687253],
	            [-56.635073, -26.681476],
	            [-56.624924, -26.674588],
	            [-56.608461, -26.680904],
	            [-56.600576, -26.667023],
	            [-56.582504, -26.665603],
	            [-56.536199, -26.626844],
	            [-56.503311, -26.620353],
	            [-56.482715, -26.623366],
	            [-56.459064, -26.609232],
	            [-56.4148, -26.594038],
	            [-56.366111, -26.618834],
	            [-56.340105, -26.612293],
	            [-56.330937, -26.595554],
	            [-56.339346, -26.563752],
	            [-56.340568, -26.543475],
	            [-56.330163, -26.521246],
	            [-56.33006, -26.491469],
	            [-56.340281, -26.486268],
	            [-56.338038, -26.46521],
	            [-56.346112, -26.459309],
	            [-56.351916, -26.431243],
	            [-56.369488, -26.406595],
	            [-56.357216, -26.388721],
	            [-56.330928, -26.386441],
	            [-56.306767, -26.372697],
	            [-56.275264, -26.378]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "YUTY"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.08594, -26.28996],
	            [-56.071086, -26.295124],
	            [-56.104082, -26.337487],
	            [-56.05309, -26.358637],
	            [-56.025956, -26.349645],
	            [-56.015689, -26.358261],
	            [-55.986011, -26.343019],
	            [-55.96845, -26.347017],
	            [-55.964852, -26.375404],
	            [-55.951607, -26.375646],
	            [-55.936871, -26.36511],
	            [-55.918938, -26.366045],
	            [-55.894049, -26.358154],
	            [-55.881498, -26.363772],
	            [-55.871097, -26.394537],
	            [-55.849836, -26.416783],
	            [-55.851127, -26.439226],
	            [-55.86037, -26.44007],
	            [-55.876135, -26.457655],
	            [-55.893158, -26.475005],
	            [-55.919502, -26.516751],
	            [-55.955553, -26.511295],
	            [-56.018722, -26.516326],
	            [-56.020374, -26.531216],
	            [-56.050702, -26.534125],
	            [-56.055874, -26.523506],
	            [-56.094861, -26.550894],
	            [-56.108004, -26.520889],
	            [-56.1358, -26.493834],
	            [-56.144752, -26.472265],
	            [-56.184984, -26.437517],
	            [-56.210641, -26.427787],
	            [-56.216591, -26.413752],
	            [-56.230832, -26.4096],
	            [-56.24998, -26.391672],
	            [-56.275264, -26.378],
	            [-56.260238, -26.368075],
	            [-56.246794, -26.303412],
	            [-56.218989, -26.296221],
	            [-56.213712, -26.279502],
	            [-56.183231, -26.262727],
	            [-56.167135, -26.266581],
	            [-56.145387, -26.249749],
	            [-56.129242, -26.247147],
	            [-56.103594, -26.271019],
	            [-56.09798, -26.285733],
	            [-56.08594, -26.28996]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CAAZAPÁ",
	        "dist_desc_": "3 DE MAYO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.41205, -26.9876],
	            [-55.436531, -27.010671],
	            [-55.450662, -27.035836],
	            [-55.456543, -27.058332],
	            [-55.449116, -27.097082],
	            [-55.45863, -27.107152],
	            [-55.484358, -27.109309],
	            [-55.531918, -27.101683],
	            [-55.535433, -27.095821],
	            [-55.647965, -26.994747],
	            [-55.646013, -26.986974],
	            [-55.61354, -26.961238],
	            [-55.579605, -26.946871],
	            [-55.699111, -26.83916],
	            [-55.696101, -26.83186],
	            [-55.761764, -26.773016],
	            [-55.751131, -26.766954],
	            [-55.509422, -26.983646],
	            [-55.48631, -26.973412],
	            [-55.476033, -26.950079],
	            [-55.46083, -26.950338],
	            [-55.447202, -26.962032],
	            [-55.426571, -26.968618],
	            [-55.41205, -26.9876]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "BELLA VISTA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.717075, -27.319519],
	            [-55.662177, -27.370152],
	            [-55.688417, -27.382702],
	            [-55.714021, -27.412398],
	            [-55.731537, -27.443191],
	            [-55.785553, -27.441238],
	            [-55.816379, -27.426313],
	            [-55.80991, -27.411387],
	            [-55.789292, -27.390857],
	            [-55.822345, -27.360422],
	            [-55.842151, -27.35741],
	            [-55.853848, -27.340455],
	            [-55.848637, -27.324407],
	            [-55.832057, -27.331337],
	            [-55.812566, -27.323306],
	            [-55.806586, -27.306068],
	            [-55.825993, -27.302251],
	            [-55.818366, -27.267267],
	            [-55.803112, -27.268111],
	            [-55.7967, -27.2487],
	            [-55.717075, -27.319519]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "CAMBYRETÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.194361, -26.759874],
	            [-55.180552, -26.771673],
	            [-55.196382, -26.783576],
	            [-55.210708, -26.780954],
	            [-55.224, -26.793969],
	            [-55.206123, -26.818719],
	            [-55.184571, -26.813431],
	            [-55.189743, -26.837794],
	            [-55.171043, -26.873767],
	            [-55.146681, -26.878925],
	            [-55.147295, -26.903247],
	            [-55.131043, -26.935209],
	            [-55.139813, -26.952346],
	            [-55.194673, -26.968631],
	            [-55.213636, -26.965613],
	            [-55.238891, -26.941691],
	            [-55.271731, -26.940938],
	            [-55.367165, -26.854776],
	            [-55.34912, -26.838874],
	            [-55.37215, -26.817987],
	            [-55.390051, -26.83376],
	            [-55.406991, -26.818288],
	            [-55.389218, -26.802685],
	            [-55.480756, -26.7206],
	            [-55.456461, -26.694808],
	            [-55.436634, -26.684575],
	            [-55.421573, -26.685239],
	            [-55.397101, -26.670155],
	            [-55.374505, -26.700117],
	            [-55.368666, -26.732542],
	            [-55.303063, -26.763026],
	            [-55.292466, -26.782392],
	            [-55.266341, -26.76222],
	            [-55.194361, -26.759874]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "CAPITÁN MEZA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.534474, -25.443702],
	            [-57.544613, -25.455432],
	            [-57.559407, -25.44375],
	            [-57.597797, -25.40176],
	            [-57.572362, -25.392606],
	            [-57.571855, -25.384836],
	            [-57.538957, -25.419052],
	            [-57.534474, -25.443702]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "SAN ANTONIO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.784935, -27.212132],
	            [-57.700041, -27.244614],
	            [-57.625647, -27.262778],
	            [-57.419766, -27.281365],
	            [-57.420726, -27.247338],
	            [-57.249706, -27.239019],
	            [-57.325792, -27.386776],
	            [-57.341979, -27.416305],
	            [-57.365868, -27.422851],
	            [-57.415151, -27.427632],
	            [-57.450632, -27.439745],
	            [-57.495671, -27.443754],
	            [-57.51981, -27.433736],
	            [-57.566051, -27.407914],
	            [-57.610046, -27.391381],
	            [-57.634044, -27.377812],
	            [-57.675874, -27.343639],
	            [-57.711974, -27.334592],
	            [-57.756933, -27.332175],
	            [-57.816636, -27.332154],
	            [-57.826027, -27.328105],
	            [-57.853621, -27.287162],
	            [-57.87235, -27.276978],
	            [-57.875252, -27.269875],
	            [-57.863325, -27.247697],
	            [-57.847519, -27.246664],
	            [-57.812567, -27.209314],
	            [-57.784935, -27.212132]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "CERRITO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.255656, -27.055887],
	            [-58.282411, -27.129864],
	            [-58.285652, -27.171102],
	            [-58.281147, -27.18518],
	            [-58.276301, -27.265032],
	            [-58.290445, -27.278815],
	            [-58.317592, -27.274581],
	            [-58.355939, -27.283093],
	            [-58.402031, -27.286044],
	            [-58.431368, -27.285078],
	            [-58.413698, -27.223172],
	            [-58.41772, -27.207819],
	            [-58.429626, -27.197346],
	            [-58.41731, -27.156237],
	            [-58.400158, -27.153292],
	            [-58.387952, -27.07085],
	            [-58.374123, -27.073871],
	            [-58.360949, -27.035023],
	            [-58.367068, -27.026986],
	            [-58.322418, -27.029313],
	            [-58.307461, -27.050896],
	            [-58.255656, -27.055887]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "GRAL. JOSÉ EDUVIGIS DÍAZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.610891, -27.099167],
	            [-57.501853, -27.163521],
	            [-57.327969, -27.148349],
	            [-57.218765, -27.179547],
	            [-57.249706, -27.239019],
	            [-57.420726, -27.247338],
	            [-57.419766, -27.281365],
	            [-57.625647, -27.262778],
	            [-57.700041, -27.244614],
	            [-57.784935, -27.212132],
	            [-57.781868, -27.194812],
	            [-57.830418, -27.105243],
	            [-57.987119, -27.054777],
	            [-58.011342, -27.035812],
	            [-58.009561, -27.018194],
	            [-57.972466, -27.034233],
	            [-57.918368, -27.048364],
	            [-57.894506, -27.05811],
	            [-57.627753, -27.097526],
	            [-57.610891, -27.099167]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "LAURELES"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-58.431368, -27.285078],
	            [-58.477331, -27.273806],
	            [-58.504831, -27.279473],
	            [-58.537336, -27.295882],
	            [-58.610192, -27.306219],
	            [-58.606699, -27.279939],
	            [-58.593692, -27.260688],
	            [-58.596251, -27.226077],
	            [-58.616509, -27.209189],
	            [-58.645827, -27.196756],
	            [-58.567273, -27.182015],
	            [-58.540708, -27.161752],
	            [-58.507806, -27.164873],
	            [-58.498697, -27.15849],
	            [-58.48299, -27.167049],
	            [-58.41731, -27.156237],
	            [-58.429626, -27.197346],
	            [-58.41772, -27.207819],
	            [-58.413698, -27.223172],
	            [-58.431368, -27.285078]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "PASO DE PATRIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.784935, -27.212132],
	            [-57.812567, -27.209314],
	            [-57.847519, -27.246664],
	            [-57.863325, -27.247697],
	            [-57.875252, -27.269875],
	            [-57.87235, -27.276978],
	            [-57.891457, -27.278834],
	            [-57.89722, -27.292985],
	            [-57.913387, -27.297925],
	            [-57.953317, -27.286833],
	            [-57.995984, -27.266778],
	            [-58.017551, -27.2395],
	            [-58.01101, -27.202519],
	            [-58.010584, -27.164573],
	            [-58.001939, -27.132182],
	            [-57.987119, -27.054777],
	            [-57.830418, -27.105243],
	            [-57.781868, -27.194812],
	            [-57.784935, -27.212132]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ÑEEMBUCÚ",
	        "dist_desc_": "VILLALBÍN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-59.879513, -20.630417],
	            [-59.886381, -20.711153],
	            [-59.886896, -20.791957],
	            [-59.863118, -20.820841],
	            [-59.83831, -20.8807],
	            [-59.839607, -20.903143],
	            [-59.817786, -20.936654],
	            [-59.814891, -20.976694],
	            [-59.785691, -21.022105],
	            [-59.768323, -21.037456],
	            [-59.755849, -21.096831],
	            [-59.75087, -21.182933],
	            [-59.76635, -21.200573],
	            [-59.715013, -21.345861],
	            [-59.769895, -21.383322],
	            [-59.845566, -21.432452],
	            [-59.872402, -21.447163],
	            [-59.887532, -21.554004],
	            [-59.904947, -21.646972],
	            [-59.926285, -21.776837],
	            [-59.932733, -21.834242],
	            [-59.947422, -21.926573],
	            [-59.951841, -21.98222],
	            [-59.953068, -22.054504],
	            [-59.860806, -22.054194],
	            [-59.740028, -22.055499],
	            [-59.738584, -22.178351],
	            [-59.739024, -22.349135],
	            [-59.83867, -22.347806],
	            [-59.969289, -22.349068],
	            [-59.991241, -22.35116],
	            [-59.991474, -22.467149],
	            [-59.953439, -22.466968],
	            [-59.953142, -22.518525],
	            [-60.055265, -22.467076],
	            [-60.092925, -22.464336],
	            [-60.235643, -22.357273],
	            [-60.414827, -22.221657],
	            [-60.411613, -22.214723],
	            [-60.411432, -22.114677],
	            [-60.409478, -22.007795],
	            [-60.503483, -22.009059],
	            [-60.49315, -21.83566],
	            [-60.580217, -21.828382],
	            [-60.569343, -21.618064],
	            [-60.566876, -21.553906],
	            [-60.556401, -21.348593],
	            [-60.548584, -21.14489],
	            [-60.545691, -21.049968],
	            [-60.544415, -20.963788],
	            [-60.541836, -20.891984],
	            [-60.54178, -20.819171],
	            [-60.537717, -20.677446],
	            [-60.535834, -20.456691],
	            [-60.111019, -20.58095],
	            [-59.9273, -20.632887],
	            [-59.879513, -20.630417]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "BOQUERÓN",
	        "dist_desc_": "FILADELFIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-59.86902, -22.672305],
	            [-59.91616, -22.673429],
	            [-59.915582, -22.635369],
	            [-59.933295, -22.634872],
	            [-59.93292, -22.611542],
	            [-59.923047, -22.589398],
	            [-59.957886, -22.58949],
	            [-59.953142, -22.518525],
	            [-59.953439, -22.466968],
	            [-59.991474, -22.467149],
	            [-59.991241, -22.35116],
	            [-59.969289, -22.349068],
	            [-59.83867, -22.347806],
	            [-59.739024, -22.349135],
	            [-59.738584, -22.178351],
	            [-59.740028, -22.055499],
	            [-59.412897, -22.05682],
	            [-59.367744, -22.076224],
	            [-59.336595, -22.170403],
	            [-59.614392, -22.335895],
	            [-59.639343, -22.368923],
	            [-59.639763, -22.388631],
	            [-59.626237, -22.427976],
	            [-59.7118, -22.427977],
	            [-59.712167, -22.467009],
	            [-59.747181, -22.466983],
	            [-59.747184, -22.500433],
	            [-59.75177, -22.525404],
	            [-59.787933, -22.566777],
	            [-59.843758, -22.634372],
	            [-59.86902, -22.672305]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "BOQUERÓN",
	        "dist_desc_": "LOMA PLATA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.92087, -21.278237],
	            [-57.919655, -21.285886],
	            [-57.897859, -21.305497],
	            [-57.855339, -21.316245],
	            [-57.854277, -21.335203],
	            [-57.863489, -21.353899],
	            [-57.881116, -21.369607],
	            [-57.89541, -21.392358],
	            [-57.906962, -21.401278],
	            [-57.9099, -21.421359],
	            [-57.927269, -21.452257],
	            [-57.926536, -21.469507],
	            [-57.937318, -21.4888],
	            [-57.961949, -21.511051],
	            [-57.968614, -21.530405],
	            [-57.959566, -21.561961],
	            [-57.923754, -21.578863],
	            [-57.914616, -21.595386],
	            [-57.941622, -21.619563],
	            [-57.942746, -21.632193],
	            [-57.923853, -21.664491],
	            [-57.884753, -21.683734],
	            [-57.898526, -21.70629],
	            [-57.945115, -21.738184],
	            [-57.939994, -21.758796],
	            [-57.909607, -21.770589],
	            [-57.913589, -21.790056],
	            [-57.933349, -21.827103],
	            [-57.96568, -21.851695],
	            [-57.921584, -21.872856],
	            [-57.919885, -21.890777],
	            [-57.935816, -21.889175],
	            [-57.949239, -21.901959],
	            [-57.936943, -21.917278],
	            [-57.937811, -21.930511],
	            [-57.964326, -21.981204],
	            [-57.964557, -21.999886],
	            [-57.976682, -22.016565],
	            [-58.005149, -22.031421],
	            [-58.009501, -22.043386],
	            [-58.063702, -22.029555],
	            [-58.096951, -22.027904],
	            [-58.104763, -22.043623],
	            [-58.157444, -22.043259],
	            [-58.176484, -22.020541],
	            [-58.236575, -22.033363],
	            [-58.334228, -21.949784],
	            [-58.384894, -21.951137],
	            [-58.384705, -21.80818],
	            [-58.53523, -21.80796],
	            [-58.563144, -21.807016],
	            [-58.659237, -21.945152],
	            [-58.675656, -21.948661],
	            [-58.685874, -21.880587],
	            [-58.668688, -21.876193],
	            [-58.683801, -21.808069],
	            [-58.708875, -21.807812],
	            [-58.708733, -21.692442],
	            [-58.720316, -21.690031],
	            [-58.720178, -21.575226],
	            [-58.756763, -21.574003],
	            [-58.758101, -21.529707],
	            [-58.76476, -21.508073],
	            [-58.752276, -21.490483],
	            [-58.72602, -21.481506],
	            [-58.714492, -21.468606],
	            [-58.699583, -21.465956],
	            [-58.70121, -21.445851],
	            [-58.681469, -21.432393],
	            [-58.656693, -21.424839],
	            [-58.638442, -21.399884],
	            [-58.599784, -21.404998],
	            [-58.583678, -21.400747],
	            [-58.577906, -21.388982],
	            [-58.561317, -21.39504],
	            [-58.518245, -21.38501],
	            [-58.494879, -21.385191],
	            [-58.494432, -21.364954],
	            [-58.468628, -21.347147],
	            [-58.457284, -21.353022],
	            [-58.389024, -21.338662],
	            [-58.377341, -21.348026],
	            [-58.350814, -21.352701],
	            [-58.318586, -21.347205],
	            [-58.308136, -21.350212],
	            [-58.273599, -21.341862],
	            [-58.260938, -21.367575],
	            [-58.249007, -21.381015],
	            [-58.190855, -21.369939],
	            [-58.176211, -21.356729],
	            [-58.149805, -21.363984],
	            [-58.139638, -21.354894],
	            [-58.117433, -21.350517],
	            [-58.080803, -21.374623],
	            [-58.037701, -21.306574],
	            [-57.977002, -21.299952],
	            [-57.92087, -21.278237]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ALTO PARAGUAY",
	        "dist_desc_": "CARMELO PERALTA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.906347, -23.09302],
	            [-56.90081, -23.1157],
	            [-57.14352, -23.255227],
	            [-57.178065, -23.239618],
	            [-57.214028, -23.294973],
	            [-57.20778, -23.310097],
	            [-57.187629, -23.308403],
	            [-57.182641, -23.325818],
	            [-57.203639, -23.329146],
	            [-57.203259, -23.354884],
	            [-57.22518, -23.350542],
	            [-57.259998, -23.335272],
	            [-57.309353, -23.323368],
	            [-57.327013, -23.305875],
	            [-57.340993, -23.30179],
	            [-57.375202, -23.266881],
	            [-57.357477, -23.258729],
	            [-57.352092, -23.224298],
	            [-57.331155, -23.213472],
	            [-57.319673, -23.170184],
	            [-57.294573, -23.176383],
	            [-57.280811, -23.147217],
	            [-57.254291, -23.109059],
	            [-57.239461, -23.1148],
	            [-57.225138, -23.099582],
	            [-57.195463, -23.083878],
	            [-57.177893, -23.098206],
	            [-57.153299, -23.092539],
	            [-57.134253, -23.078728],
	            [-57.12152, -23.058083],
	            [-57.084286, -23.064782],
	            [-57.066178, -23.055798],
	            [-57.044354, -23.075579],
	            [-57.036076, -23.07067],
	            [-57.004279, -23.076593],
	            [-57.001856, -23.085989],
	            [-56.976425, -23.09236],
	            [-56.945306, -23.08613],
	            [-56.906347, -23.09302]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "LORETO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.859051, -23.082451],
	            [-56.853049, -23.110674],
	            [-56.842858, -23.119625],
	            [-56.827946, -23.152802],
	            [-56.829043, -23.170269],
	            [-56.802999, -23.218146],
	            [-56.77454, -23.204947],
	            [-56.769093, -23.242032],
	            [-56.754562, -23.228389],
	            [-56.737353, -23.261486],
	            [-56.746775, -23.306924],
	            [-56.743858, -23.364108],
	            [-56.734367, -23.379782],
	            [-56.706745, -23.401394],
	            [-56.713095, -23.424877],
	            [-56.726586, -23.432975],
	            [-56.750304, -23.451018],
	            [-56.776877, -23.435472],
	            [-56.8043, -23.425255],
	            [-56.811787, -23.439036],
	            [-56.868424, -23.437473],
	            [-56.883314, -23.443147],
	            [-56.906258, -23.439452],
	            [-56.925053, -23.445124],
	            [-56.948807, -23.435403],
	            [-56.967555, -23.437644],
	            [-56.979582, -23.448158],
	            [-57.005781, -23.45173],
	            [-57.032925, -23.442126],
	            [-57.059101, -23.45751],
	            [-57.135394, -23.46857],
	            [-57.146124, -23.475622],
	            [-57.15699, -23.458254],
	            [-57.147587, -23.441549],
	            [-57.144362, -23.40327],
	            [-57.138474, -23.393588],
	            [-57.140822, -23.354675],
	            [-57.144293, -23.329804],
	            [-57.177298, -23.339871],
	            [-57.182641, -23.325818],
	            [-57.187629, -23.308403],
	            [-57.20778, -23.310097],
	            [-57.214028, -23.294973],
	            [-57.178065, -23.239618],
	            [-57.14352, -23.255227],
	            [-56.90081, -23.1157],
	            [-56.906347, -23.09302],
	            [-56.893358, -23.079823],
	            [-56.894186, -23.067118],
	            [-56.859051, -23.082451]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "HORQUETA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.693818, -22.993669],
	            [-56.671859, -23.005846],
	            [-56.644147, -23.00719],
	            [-56.617587, -23.018854],
	            [-56.594045, -23.018786],
	            [-56.564692, -23.036391],
	            [-56.558866, -23.055489],
	            [-56.547022, -23.11619],
	            [-56.563878, -23.136182],
	            [-56.576701, -23.165724],
	            [-56.595127, -23.180749],
	            [-56.601395, -23.193055],
	            [-56.593877, -23.209065],
	            [-56.59024, -23.235712],
	            [-56.565439, -23.269717],
	            [-56.575217, -23.311249],
	            [-56.622323, -23.352114],
	            [-56.634005, -23.377597],
	            [-56.658494, -23.381721],
	            [-56.666777, -23.376356],
	            [-56.698361, -23.384929],
	            [-56.706745, -23.401394],
	            [-56.734367, -23.379782],
	            [-56.743858, -23.364108],
	            [-56.746775, -23.306924],
	            [-56.737353, -23.261486],
	            [-56.754562, -23.228389],
	            [-56.769093, -23.242032],
	            [-56.77454, -23.204947],
	            [-56.802999, -23.218146],
	            [-56.829043, -23.170269],
	            [-56.827946, -23.152802],
	            [-56.842858, -23.119625],
	            [-56.853049, -23.110674],
	            [-56.859051, -23.082451],
	            [-56.837121, -23.073298],
	            [-56.826412, -23.080009],
	            [-56.804394, -23.055785],
	            [-56.787466, -23.05205],
	            [-56.793578, -23.035041],
	            [-56.763191, -23.014187],
	            [-56.747314, -23.017754],
	            [-56.725377, -23.009107],
	            [-56.708876, -22.995162],
	            [-56.693818, -22.993669]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CONCEPCIÓN",
	        "dist_desc_": "ARROYITO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-56.759429, -26.415425],
	            [-56.781246, -26.434359],
	            [-56.791365, -26.434187],
	            [-56.787159, -26.462082],
	            [-56.805035, -26.489874],
	            [-56.811707, -26.487158],
	            [-56.846848, -26.529396],
	            [-56.848325, -26.541554],
	            [-56.879578, -26.523098],
	            [-56.880812, -26.504596],
	            [-56.896304, -26.49316],
	            [-56.912381, -26.460795],
	            [-56.925715, -26.464992],
	            [-56.949111, -26.485057],
	            [-56.961298, -26.472731],
	            [-56.955298, -26.449317],
	            [-56.971571, -26.448548],
	            [-56.996131, -26.419516],
	            [-57.007329, -26.412427],
	            [-56.993027, -26.399275],
	            [-56.995709, -26.386667],
	            [-56.983908, -26.36476],
	            [-56.941758, -26.363567],
	            [-56.927558, -26.348074],
	            [-56.9265, -26.32283],
	            [-56.909009, -26.32063],
	            [-56.889395, -26.297552],
	            [-56.832621, -26.333287],
	            [-56.845559, -26.350692],
	            [-56.828217, -26.359747],
	            [-56.850044, -26.385063],
	            [-56.759429, -26.415425]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "PARAGUARÍ",
	        "dist_desc_": "MARÍA ANTONIA"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.977107, -24.028614],
	            [-55.960326, -24.049306],
	            [-55.922912, -24.061552],
	            [-55.887589, -24.05121],
	            [-55.86868, -24.068876],
	            [-55.845777, -24.067284],
	            [-55.848579, -24.092421],
	            [-55.835908, -24.10989],
	            [-55.829909, -24.135655],
	            [-55.836826, -24.160732],
	            [-55.830325, -24.172585],
	            [-55.835332, -24.203947],
	            [-55.804074, -24.195476],
	            [-55.793868, -24.239769],
	            [-55.775785, -24.282713],
	            [-55.805633, -24.286608],
	            [-55.801719, -24.298041],
	            [-55.833878, -24.299203],
	            [-55.857529, -24.29006],
	            [-55.860115, -24.274854],
	            [-55.882226, -24.288628],
	            [-55.913695, -24.334024],
	            [-55.922346, -24.352549],
	            [-55.938791, -24.372457],
	            [-55.95659, -24.367014],
	            [-55.991671, -24.378726],
	            [-56.00945, -24.398716],
	            [-56.024464, -24.394777],
	            [-56.057731, -24.403086],
	            [-56.103686, -24.399671],
	            [-56.123032, -24.379706],
	            [-56.11616, -24.37041],
	            [-56.125143, -24.342606],
	            [-56.126647, -24.300913],
	            [-56.155609, -24.282739],
	            [-56.170484, -24.235816],
	            [-56.158022, -24.219139],
	            [-56.151384, -24.194697],
	            [-56.160641, -24.149331],
	            [-56.149615, -24.121171],
	            [-56.129663, -24.109064],
	            [-56.115013, -24.111105],
	            [-56.103796, -24.08979],
	            [-56.080617, -24.067524],
	            [-56.01599, -24.024658],
	            [-55.977107, -24.028614]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "MARACANÁ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.977107, -24.028614],
	            [-56.01599, -24.024658],
	            [-56.080617, -24.067524],
	            [-56.103796, -24.08979],
	            [-56.115013, -24.111105],
	            [-56.129663, -24.109064],
	            [-56.149615, -24.121171],
	            [-56.160641, -24.149331],
	            [-56.189059, -24.156885],
	            [-56.202666, -24.143846],
	            [-56.18662, -24.129195],
	            [-56.189737, -24.098081],
	            [-56.229147, -24.093259],
	            [-56.229111, -24.063194],
	            [-56.250519, -24.034491],
	            [-56.231259, -24.016141],
	            [-56.224387, -24.020584],
	            [-56.203994, -24.00058],
	            [-56.200347, -23.980981],
	            [-56.187307, -23.948024],
	            [-56.073823, -23.959228],
	            [-56.072426, -23.946685],
	            [-56.052487, -23.948239],
	            [-56.048626, -23.924919],
	            [-56.014811, -23.924913],
	            [-56.004341, -23.91669],
	            [-55.977107, -24.028614]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "SAN PEDRO",
	        "dist_desc_": "SAN VICENTE PANCHOLO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-57.469994, -25.324433],
	            [-57.483177, -25.342099],
	            [-57.484566, -25.401887],
	            [-57.507406, -25.403112],
	            [-57.523278, -25.385783],
	            [-57.526884, -25.372394],
	            [-57.566758, -25.360922],
	            [-57.570284, -25.355547],
	            [-57.551821, -25.356953],
	            [-57.540099, -25.332433],
	            [-57.517974, -25.31878],
	            [-57.535964, -25.295812],
	            [-57.493767, -25.312162],
	            [-57.469994, -25.324433]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CENTRAL",
	        "dist_desc_": "SAN LORENZO"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.875891, -26.891587],
	            [-55.791817, -26.968093],
	            [-55.800939, -26.988511],
	            [-55.822887, -27.011457],
	            [-55.855078, -27.044988],
	            [-55.875308, -27.056666],
	            [-55.878446, -27.075518],
	            [-55.885537, -27.081464],
	            [-55.987018, -26.989745],
	            [-55.997271, -26.99884],
	            [-56.023823, -26.97842],
	            [-56.014605, -26.967487],
	            [-55.959289, -26.944299],
	            [-55.959733, -26.925831],
	            [-55.934721, -26.907277],
	            [-55.904001, -26.904488],
	            [-55.888119, -26.891639],
	            [-55.875891, -26.891587]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "LA PAZ"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-55.818366, -27.267267],
	            [-55.825993, -27.302251],
	            [-55.806586, -27.306068],
	            [-55.812566, -27.323306],
	            [-55.832057, -27.331337],
	            [-55.848637, -27.324407],
	            [-55.853848, -27.340455],
	            [-55.842151, -27.35741],
	            [-55.822345, -27.360422],
	            [-55.789292, -27.390857],
	            [-55.80991, -27.411387],
	            [-55.816379, -27.426313],
	            [-55.826569, -27.425046],
	            [-55.863622, -27.391933],
	            [-55.864364, -27.374631],
	            [-55.879461, -27.347271],
	            [-55.88864, -27.341237],
	            [-55.911769, -27.344723],
	            [-55.911257, -27.323478],
	            [-55.918148, -27.312596],
	            [-55.901563, -27.300119],
	            [-55.916445, -27.291539],
	            [-55.930837, -27.293117],
	            [-55.965479, -27.260468],
	            [-55.985247, -27.255219],
	            [-56.011724, -27.228529],
	            [-56.020418, -27.21402],
	            [-55.993186, -27.189335],
	            [-55.973999, -27.172694],
	            [-55.96101, -27.172632],
	            [-55.948289, -27.148859],
	            [-55.932225, -27.145562],
	            [-55.926239, -27.134262],
	            [-55.82219, -27.226416],
	            [-55.818366, -27.267267]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "ITAPÚA",
	        "dist_desc_": "ENCARNACIÓN"
	      }
	    },
	    {
	      "type": "Feature",
	      "geometry": {
	        "type": "Polygon",
	        "coordinates": [
	          [
	            [-54.611941, -24.513567],
	            [-54.603578, -24.472279],
	            [-54.637158, -24.441454],
	            [-54.620971, -24.425588],
	            [-54.603881, -24.418864],
	            [-54.579236, -24.384045],
	            [-54.49758, -24.401217],
	            [-54.46433, -24.390279],
	            [-54.459086, -24.379668],
	            [-54.490005, -24.354397],
	            [-54.498803, -24.334191],
	            [-54.478352, -24.320633],
	            [-54.447858, -24.307814],
	            [-54.447445, -24.307959],
	            [-54.445345, -24.324269],
	            [-54.430938, -24.327871],
	            [-54.412957, -24.342413],
	            [-54.41822, -24.364543],
	            [-54.412638, -24.37657],
	            [-54.39264, -24.366014],
	            [-54.375194, -24.381066],
	            [-54.377209, -24.390649],
	            [-54.339665, -24.383397],
	            [-54.340951, -24.396511],
	            [-54.322073, -24.411449],
	            [-54.309458, -24.439749],
	            [-54.321035, -24.452039],
	            [-54.328446, -24.487829],
	            [-54.335034, -24.499178],
	            [-54.337188, -24.529039],
	            [-54.388003, -24.514849],
	            [-54.403721, -24.526962],
	            [-54.4263, -24.520206],
	            [-54.451739, -24.52495],
	            [-54.471294, -24.519171],
	            [-54.478974, -24.529503],
	            [-54.514831, -24.51625],
	            [-54.528989, -24.500552],
	            [-54.544408, -24.531095],
	            [-54.553883, -24.536435],
	            [-54.568911, -24.5254],
	            [-54.590618, -24.525721],
	            [-54.6119, -24.513576],
	            [-54.611941, -24.513567]
	          ]
	        ]
	      },
	      "properties": {
	        "dpto_desc": "CANINDEYÚ",
	        "dist_desc_": "PUERTO ADELA"
	      }
	    }
	  ]
	}];


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(765);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('acosoEnLineaApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(94);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(767);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(770)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(768)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:300,300i,700,900&display=swap);", ""]);
	exports.i(__webpack_require__(769), "");
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.row{margin-left:-15px;margin-right:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm{padding-left:0;padding-right:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#00ac9b;border-color:#009384}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#00796d;border-color:#001311}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#00796d;border-color:#00554d}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#00554d;border-color:#001311}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#00ac9b;border-color:#009384}.btn-success .badge{color:#00ac9b;background-color:#fff}.btn-info{color:#fff;background-color:#007cb4;border-color:#006a9b}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#005981;border-color:#00131b}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#005981;border-color:#00405d}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#00405d;border-color:#00131b}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#007cb4;border-color:#006a9b}.btn-info .badge{color:#007cb4;background-color:#fff}.btn-warning{color:#fff;background-color:#ffe153;border-color:#ffdd39}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ffd820;border-color:#b99900}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ffd820;border-color:#fbcf00}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#fbcf00;border-color:#b99900}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#ffe153;border-color:#ffdd39}.btn-warning .badge{color:#ffe153;background-color:#fff}.btn-danger{color:#fff;background-color:#ed3f5f;border-color:#eb284c}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#e4153b;border-color:#860d23}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#e4153b;border-color:#c31233}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#c31233;border-color:#860d23}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#ed3f5f;border-color:#eb284c}.btn-danger .badge{color:#ed3f5f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{left:auto;right:0}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important;float:left}.navbar-right{float:right!important;float:right;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#080808;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857143;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#00ac9b}.label-success[href]:focus,.label-success[href]:hover{background-color:#00796d}.label-info{background-color:#007cb4}.label-info[href]:focus,.label-info[href]:hover{background-color:#005981}.label-warning{background-color:#ffe153}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ffd820}.label-danger{background-color:#ed3f5f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#e4153b}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-left:auto;margin-right:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#00ac9b}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#007cb4}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#ffe153}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#ed3f5f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}body{font-family:Lato,sans-serif;font-weight:300;padding-top:60px}.btn-group-vertical>.btn-group,.btn-toolbar,.clearfix,.container,.container-fluid,.dl-horizontal dd,.form-horizontal .form-group,.modal-footer,.modal-header,.nav,.navbar,.navbar-collapse,.navbar-header,.pager,.panel-body,.row{clear:both}.md,.xxs{display:none}.btn,a{cursor:pointer}@media screen and (min-width:420px){.md{display:block}}@media screen and (max-width:420px){.xxs{display:block}}formulario label{text-align:center;display:block}formulario h3.text-danger,formulario h3.text-success{text-transform:uppercase;font-weight:700;margin-top:5px}formulario .edad{top:65%}formulario .edad,formulario .genero{position:absolute;text-align:center;font-size:18px;width:55%}formulario .genero{top:45%}formulario .localidades{position:absolute;top:25%;text-align:center;font-size:18px;width:55%}formulario .form{margin-left:42%;margin-right:50%;width:100%}formulario .has-success .control-label,formulario .has-success .form-control,formulario .text-success{color:#00ac9b!important;font-size:1.6em}formulario .has-success .form-control{border-color:#00ac9b!important}formulario .has-danger .control-label,formulario .text-danger{color:#ed3f5f!important}formulario .btn-group .btn{border-radius:10px;font-weight:700;padding:5px 15px;box-shadow:0 4px 12px -5px #000;cursor:pointer}formulario .btn-group .btn-ver-estadisticas{background-color:#ffe153;border:1px solid #ffe153;color:#fff;font-size:1.6em;margin:5px 0;outline:none}formulario .btn-group .btn-ver-estadisticas img.message-tail-warning{position:absolute;left:3px;bottom:-10px;height:10px}formulario .fin-encuesta{margin:40px 0 290px}formulario .fin-encuesta h2{margin:0;color:#555}formulario .fin-encuesta .like-heart{width:90px;margin-bottom:10px}@media screen and (max-width:500px){formulario h2,formulario h3{font-size:20px}}formulario .fade{transition:all 1.5s ease-in;opacity:1}formulario .fade.ng-hide{opacity:0}formulario .ng-hide{opacity:0;transition:none 0}formulario .ui-select-choices-group-label,formulario .ui-select-choices-row-inner,formulario .ui-select-match-text{text-align:center}formulario .ui-select-choices-group-label{font-size:1.1em;font-weight:700}formulario .ui-select-highlight{background-color:#ff0;color:#000}#map{height:775px;margin:auto}#sidebar{float:right;height:100%;max-width:100%;width:500px}.tituloBurbuja{text-align:center;font-family:Lato,sans-serif;font-size:15px;margin:0}.sidebar-wrapper{height:100%;position:relative;width:100%}@media (max-width:767px){#sidebar{display:none}}.panel{margin-bottom:0;border-width:0;box-shadow:none;-webkit-box-shadow:none}.panel-title{padding:10px;text-align:center;background:#1abc9c;color:#fff;font-size:30px}.content{padding:20px}.portada{padding:0!important}.portada #bloque-2{background-color:#00ac9b;color:#fff;padding:0}.portada #bloque-2 .bg-1-top-right{background:url(\"/assets/images/bg-1-top-right.svg\") no-repeat 100% 0}.portada #bloque-2 .bg-1-bottom-left{background:url(\"/assets/images/bg-1-bottom-left.svg\") no-repeat 0 100%;padding:9vh 30px}.portada #bloque-2 h1{margin:0}.portada #bloque-2 h2{display:block;text-align:center}.portada #bloque-2 h2 span{display:block;font-weight:300;font-size:6vw}.portada #bloque-2 h2 b{display:block;text-transform:uppercase;font-size:7vw}.portada #bloque-2 img{display:block;margin:auto}.portada #bloque-2 img.icon-line-main{display:block;height:4vw}.portada #bloque-2 .separator{margin:70px 0 0}.portada #bloque-2 .separator img.icon-down-chevron{cursor:pointer;height:40px}.portada #bloque-3{background-color:#fff;color:#333}.portada #bloque-3 .separator{margin:45px auto}.portada #bloque-3 .separator img.icon-down-chevron{cursor:pointer;height:40px}.portada #bloque-3 p.text{padding-top:10px;text-align:center;line-height:1.1em;font-size:1.3em}.portada #bloque-3 .circle{background-color:#00ac9b;height:200px;width:200px;border-radius:50%;margin:auto;padding-top:40px}.portada #bloque-3 .circle p{font-size:18px;color:#fff;text-align:center;margin:auto;line-height:1.1em}.portada #bloque-4{background-color:#00ac9b;color:#fff;padding:0}.portada #bloque-4 .bg-2{background:url(\"/assets/images/bg-2-a.svg\") no-repeat;background-position:60% bottom;background-size:260px;padding:60px 30px;padding-bottom:55px}.portada #bloque-4 .circle{background-color:#fff;height:200px;width:200px;border-radius:50%;margin:auto;padding-top:40px}.portada #bloque-4 .circle p{font-size:18px;color:#333;text-align:center;margin:auto;line-height:1.1em}.portada #bloque-4 p.text{color:#fff;text-align:center;margin:auto;line-height:1.1em;padding-top:40px}.portada #bloque-5-btn{background-color:#fff;padding:20px}.portada #bloque-5-btn .btn-group .btn{border-radius:10px;font-weight:700;padding:5px 15px;box-shadow:0 4px 12px -5px #000;cursor:pointer}.portada #bloque-5-btn .btn-group .btn-encuesta{background-color:#ed3f5f;border:1px solid #ed3f5f;color:#fff;margin-top:20px;margin-bottom:10px}.portada #bloque-5-btn .btn-group .btn-encuesta img.message-tail-danger{position:absolute;right:3px;bottom:-10px;height:10px}.portada #bloque-5-btn .btn-estadisticas{background-color:#fff;margin-top:5px}.portada #bloque-5-btn .btn-estadisticas .logo-bars-colors{height:15px;margin-top:-2px;margin-right:5px}.portada #bloque-5-btn .btn-encuesta-container,.portada #bloque-5-btn .btn-politica-de-privacidad-container{margin-top:30px}.portada .separator{text-align:center;margin:25px auto}.portada img.icon-logo{width:120px;padding-bottom:10px}.portada img.icon-logo-text{width:220px}.portada img.icon-dove{width:40px}.portada .jumbotron{margin:0;border-radius:0;border:none;padding:30px}@media screen and (min-width:768px){.portada #bloque-3 p{font-size:1.5em}.portada #bloque-3 .separator{margin:30px 0 0}}@media screen and (min-width:992px){.portada #bloque-2 h2 span{font-size:4vw}.portada #bloque-2 h2 b{font-size:5vw}.portada #bloque-2 img.icon-line-main{height:3vw}.portada #bloque-3 p.text{margin-top:30px;font-size:1.5em}.portada #bloque-3 .circle{height:240px;width:240px;padding-top:45px}.portada #bloque-3 .circle p{font-size:1.5em}.portada #bloque-4 p.text{padding-top:0;font-size:2em}.portada #bloque-4 .bg-2{background-position:80% bottom;background-size:220px}.portada #bloque-5-btn{padding:70px}.portada #bloque-5-btn .btn-group .btn-encuesta{font-size:2em}.portada #bloque-5-btn .btn-estadisticas{font-size:1.2em}.portada img.icon-logo{width:200px}}.pregunta-container{transition:background-color 1s linear;margin-top:-60px;padding-top:60px}.pregunta-container .bg-preguntas{padding:15px}.pregunta-container.success{background-color:#00ac9b}.pregunta-container.info{background-color:#007cb4}.pregunta-container.warning{background-color:#ffe153}.pregunta-container.danger{background-color:#ed3f5f}.pregunta-container .pregunta-id{width:70%;margin:auto;margin-top:15px}.pregunta-container .pregunta-id h2{max-width:20vw;display:block;color:#fff;font-size:110px;font-weight:700;text-align:center}.pregunta-container .bg-preg-text{background:url(\"/assets/images/bg-preg-text.svg\") no-repeat;background-size:260px auto;background-position:50% 50%;padding:17px;width:290px;height:264px;margin:auto}.pregunta-container.par .bg-preguntas{background:url(\"/assets/images/bg-preguntas-a.svg\") no-repeat;background-size:230% auto;background-position:50% -80px}.pregunta-container.par .pregunta-id h2{margin:0 44vw 0 0}.pregunta-container.impar .bg-preguntas{background:url(\"/assets/images/bg-preguntas-b.svg\") no-repeat;background-size:230% auto;background-position:50% -80px}.pregunta-container.impar .pregunta-id h2{margin:0 0 0 44vw}.pregunta-container .pregunta-text p{color:#555;text-align:center;line-height:1.1em;display:block;padding:38px;font-size:1.3em}.pregunta-container.pregunta-1 .pregunta-text p{font-size:1.6em}.pregunta-container.pregunta-4 .pregunta-text p{font-size:1.29em}.pregunta-container.pregunta-5 .pregunta-text p{font-size:1.5em}.pregunta-container.pregunta-6 .pregunta-text p{font-size:1.2em}.pregunta-container.pregunta-8 .pregunta-text p{font-size:1.4em}.pregunta-container.pregunta-9 .pregunta-text p{font-size:1.1em}.pregunta-container .pregunta-btn-group{padding-top:30px;padding-bottom:30px;width:245px;margin:auto}.pregunta-container .pregunta-btn-group .btn-group .btn{border-radius:10px!important;font-weight:700;padding:5px 15px;box-shadow:0 4px 12px -5px #000;cursor:pointer;outline:none}.pregunta-container .pregunta-btn-group .btn-group .btn .icon{height:30px;width:30px;display:none}.pregunta-container .pregunta-btn-group .btn-group .btn .text{color:#555;font-size:1.1em;display:initial}.pregunta-container .pregunta-btn-group .btn-group .btn.shake .icon{display:block}.pregunta-container .pregunta-btn-group .btn-group .btn-si{background-color:#fff;border:1px solid #fff;color:#555;margin-left:15px;margin-bottom:10px;width:60px}.pregunta-container .pregunta-btn-group .btn-group .btn-si img.message-tail-bottom-right{position:absolute;right:3px;bottom:-10px;height:10px}.pregunta-container .pregunta-btn-group .btn-group .btn-si.shake{animation:temblar .82s cubic-bezier(.36,.07,.19,.97) both;animation-iteration-count:2}.pregunta-container .pregunta-btn-group .btn-group .btn-si .icon{position:absolute;top:-14px;right:-10px}.pregunta-container .pregunta-btn-group .btn-group .btn-no{background-color:#fff;border:1px solid #fff;color:#555;margin-bottom:10px;width:60px}.pregunta-container .pregunta-btn-group .btn-group .btn-no img.message-tail-bottom-left{position:absolute;left:3px;bottom:-10px;height:10px}.pregunta-container .pregunta-btn-group .btn-group .btn-no.shake{animation-name:negar;animation-duration:.8s;transform-origin:50% 50%;animation-iteration-count:1;animation-timing-function:linear;transform:translateZ(0)}.pregunta-container .pregunta-btn-group .btn-group .btn-no .icon{position:absolute;top:-14px;left:-10px}.pregunta-container .pregunta-btn-group .btn-group .btn-nose{background-color:#fff;border:1px solid #fff;color:#555;margin-top:15px;margin-bottom:10px;width:160px}.pregunta-container .pregunta-btn-group .btn-group .btn-nose.shake{animation-name:dudar;animation-duration:1s;transform-origin:50% 50%;animation-iteration-count:1;animation-timing-function:ease-out;transform:translateZ(0)}.pregunta-container .pregunta-btn-group .btn-group .btn-nose .icon{position:absolute;top:-21px;left:65px}@media screen and (min-width:768px){.pregunta-container.impar .bg-preguntas,.pregunta-container.par .bg-preguntas{background-position:50% -120px}}@media screen and (min-width:992px){.pregunta-container.impar .bg-preguntas,.pregunta-container.par .bg-preguntas{background:url(\"/assets/images/bg-preguntas-c.svg\") no-repeat;background-size:160% auto;background-position:40% 40%}.pregunta-container.impar .pregunta-id h2,.pregunta-container.par .pregunta-id h2{margin:0!important}.pregunta-container .content{padding:80px 0}.pregunta-container .pregunta-text{width:340px;height:330px;font-size:16px;margin:auto}.pregunta-container .pregunta-text p{padding:54px 30px}.pregunta-container .pregunta-text .bg-preg-text{background-size:320px auto;background-position:50% 50%;padding:30px;width:340px;height:330px}.pregunta-container .pregunta-id{padding-top:60px}.pregunta-container .pregunta-btn-group{padding-top:80px}}@keyframes temblar{0%{transform:translate(2px,1px) rotate(0deg)}10%{transform:translate(-1px,-2px) rotate(-1deg)}20%{transform:translate(-3px) rotate(1deg)}30%{transform:translateY(2px) rotate(0deg)}40%{transform:translate(1px,-1px) rotate(1deg)}50%{transform:translate(-1px,2px) rotate(-1deg)}60%{transform:translate(-3px,1px) rotate(0deg)}70%{transform:translate(2px,1px) rotate(-1deg)}80%{transform:translate(-1px,-1px) rotate(1deg)}90%{transform:translate(2px,2px) rotate(0deg)}to{transform:translate(1px,-2px) rotate(-1deg)}}@keyframes negar{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@keyframes dudar{10%{transform:rotate(0deg)}35%{transform:rotate(-4deg)}85%{transform:rotate(-5deg)}to{transform:rotate(0deg)}}resultado #resultados{margin-top:40px;display:inline-block;min-height:72px}resultado #resultados h2{font-size:20px;font-weight:700}resultado .chart{min-height:250px}resultado .switch-mode{margin-bottom:20px;min-height:34px}resultado .btn-group .btn{border-radius:10px;font-weight:700;padding:5px 15px;box-shadow:0 4px 12px -5px #000;cursor:pointer}resultado .btn-group .btn-sabias-que{background-color:#ed3f5f;border:1px solid #ed3f5f;color:#fff;font-size:2em;margin:30px 0;outline:none}resultado .btn-group .btn-sabias-que img.icon-star{position:absolute;top:-23px;left:75px;width:40px}resultado .btn-group .btn-sabias-que img.message-tail-danger{position:absolute;right:3px;bottom:-10px;height:10px}resultado .btn-group .btn-tipo-resultados{background-color:#007cb4;border:1px solid #007cb4;color:#fff;font-size:1.5em;margin:30px 0;outline:none}resultado .btn-group .btn-tipo-resultados img.message-tail-info{position:absolute;left:3px;bottom:-10px;height:10px}resultado .bg-sabias-que{background:url(\"/assets/images/bg-3.svg\") no-repeat;background-size:100% auto;background-position:50% 20px;margin:-30px -15px 0;padding:50px 15px 0;height:190px}resultado h4.panel-title{text-align:center}@media screen and (max-width:500px){resultado .bg-sabias-que{margin:-20px 0 0;padding:10px 15px 0;height:100px}}@media screen and (min-width:500px){resultado .bg-sabias-que{background-size:100% auto;background-position:50% 20px;margin:0 0 -130px;padding:50px 16px 0 15px;height:320px}}.thing-form{margin:20px 0}#banner{border-bottom:none;margin-top:-20px}#banner h1{font-size:60px;line-height:1;letter-spacing:-1px}.hero-unit{position:relative;padding:30px 15px;color:#f5f5f5;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.1);background:#4393b9}.navbar-text{margin-left:15px}.footer{text-align:right;padding:20px 10px;margin-top:0;background:#fff;color:#555;display:flex;justify-content:space-around;align-items:center}.footer p{margin:15px;text-align:center}.footer .logo-equalrightstrust{height:15px}.footer .logo-gitlab{height:20px}.footer .logo-cc{height:23px}.footer .logo-datacuenta{height:25px;top:-2px;position:relative}.footer .logo-tedic{height:29px}.footer .logo-europa{height:28px}@media screen and (min-width:992px){.footer .logo-europa{height:60px}.footer .logo-equalrightstrust{height:39px}.footer .logo-tedic{height:60px}.footer .logo-datacuenta{height:50px}.footer .logo-gitlab{height:37px}.footer .logo-cc{height:35px}}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#007cb4}.modal-success .modal-header{background:#00ac9b}.modal-warning .modal-header{background:#ffe153}.modal-danger .modal-header{background:#ed3f5f}.navbar{margin-bottom:0}.navbar-static-top{z-index:2000}.navbar-top{background:#fff;box-shadow:0 -3px 11px #000;border:none;width:100%}.navbar-top .navbtn-danger{background:#ed3f5f}.navbar-top .navbtn-danger>a:hover{background:#ef5672}.navbar-top .navbtn-danger>a:active,.navbar-top .navbtn-danger>a:focus{background:#eb284c}.navbar-top .navbtn-warning{background:#ffe153}.navbar-top .navbtn-warning>a:hover{background:#ffe56d}.navbar-top .navbtn-warning>a:active,.navbar-top .navbtn-warning>a:focus{background:#ffdd39}.navbar-top .navbtn-info{background:#007cb4}.navbar-top .navbtn-info>a:hover{background:#008ece}.navbar-top .navbtn-info>a:active,.navbar-top .navbtn-info>a:focus{background:#006a9b}.navbar-top .navbtn-primary{background:#337ab7}.navbar-top .navbtn-primary>a:hover{background:#3c87c8}.navbar-top .navbtn-primary>a:active,.navbar-top .navbtn-primary>a:focus{background:#2e6da4}@media screen and (max-width:768px){.navbar-top .navbar-header{float:left!important}}.navbar-top .navbar-header .navbar-brand{padding:10px;height:auto;background:transparent}.navbar-top .navbar-header .navbar-brand img.icon{display:inline;margin-right:10px;height:15px}.navbar-top .navbar-header .navbar-brand img.icon-logo-isotipo{height:40px}.navbar-top .navbar-header .navbar-brand img.icon-logo-text{height:20px}.navbar-top .navbar-nav{float:right;margin:0 -15px 0 0}@media screen and (max-width:768px){.navbar-top .navbar-nav li{float:left}}.navbar-top .navbar-nav li a{height:60px;padding:10px}.navbar-top .navbar-nav li a span{color:#fff;font-size:40px}.navbar-top .navbar-nav img.icon-bars{display:inline;margin-right:10px;height:18px}.navbar-top .navbar-nav img.icon-localizacion,.navbar-top .navbar-nav img.icon-tedic{width:auto;height:40px}.navbar-top .navbar-header,.navbar-top .navbar-nav{clear:unset}.fixed-top{position:fixed;top:0}", ""]);
	
	// exports


/***/ }),
/* 768 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(768)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.19.8 - 2017-04-18T05:43:43.881Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container.select2.direction-up .ui-select-match,.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:4px;border-top-left-radius:0;border-top-right-radius:0}.ui-select-container.select2.direction-up .ui-select-dropdown,.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search,.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match,.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden,.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden input{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control.single>.selectize-input>input{width:100%}.selectize-control.multi>.selectize-input>input{margin:0!important}.selectize-control>.selectize-dropdown{width:100%}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.ui-select-container[theme=selectize] input.ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0;width:0}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.ui-select-bootstrap .ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices,.ui-select-bootstrap>.ui-select-no-choice{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:none;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close{pointer-events:none}.ui-select-multiple:hover .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple:hover .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>span{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-bootstrap .ui-select-choices-row>span:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>span{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>span,.ui-select-bootstrap .ui-select-choices-row.disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-bootstrap .ui-select-match-text{width:100%;padding-right:1em}.ui-select-bootstrap .ui-select-match-text span{display:inline-block;width:100%;overflow:hidden}.ui-select-bootstrap .ui-select-toggle>a.btn{position:absolute;height:10px;right:10px;margin-top:-2px}.ui-select-refreshing.glyphicon{position:absolute;right:0;padding:8px 27px}@keyframes ui-select-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.ui-select-spin{animation:ui-select-spin 2s infinite linear}.ui-select-refreshing.ng-animate{-webkit-animation:none 0s}", ""]);
	
	// exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.f5e82f7e9b1d4e6a2296.js